// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%231e1e1e%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23dae1e7%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%2834, 41, 47, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%237367f0%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%2328c76f%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23ea5455%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23ea5455%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2898, 98, 98, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23626262%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27M2 5L8 11L14 5%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27rgb%2846, 41.2, 96%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27M2 5L8 11L14 5%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgb%28171, 163.8, 246%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%2322292f%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("./assets/img/pages/vuesax-login-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("./assets/img/logo/vuesax-logo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("./assets/fonts/feather.eot?t=1501834582692", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("./assets/fonts/feather.woff?t=1501834582692", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("./assets/fonts/feather.ttf?t=1501834582692", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("./assets/fonts/feather.svg?t=1501834582692", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___, { hash: "#feather" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * prism.js tomorrow night eighties for JavaScript, CoffeeScript, CSS and HTML
 * Based on https://github.com/chriskempson/tomorrow-theme
 * @author Rose Pritchard
 */
code[class*=language-],
pre[class*=language-] {
  color: #ccc;
  background: none;
  font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
  font-size: 1em;
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  word-wrap: normal;
  line-height: 1.5;
  tab-size: 4;
  hyphens: none;
}

/* Code blocks */
pre[class*=language-] {
  padding: 1em;
  margin: 0.5em 0;
  overflow: auto;
}

:not(pre) > code[class*=language-],
pre[class*=language-] {
  background: #2d2d2d;
}

/* Inline code */
:not(pre) > code[class*=language-] {
  padding: 0.1em;
  border-radius: 0.3em;
  white-space: normal;
}

.token.comment,
.token.block-comment,
.token.prolog,
.token.doctype,
.token.cdata {
  color: #999;
}

.token.punctuation {
  color: #ccc;
}

.token.tag,
.token.attr-name,
.token.namespace,
.token.deleted {
  color: #e2777a;
}

.token.function-name {
  color: #6196cc;
}

.token.boolean,
.token.number,
.token.function {
  color: #f08d49;
}

.token.property,
.token.class-name,
.token.constant,
.token.symbol {
  color: #f8c555;
}

.token.selector,
.token.important,
.token.atrule,
.token.keyword,
.token.builtin {
  color: #cc99cd;
}

.token.string,
.token.char,
.token.attr-value,
.token.regex,
.token.variable {
  color: #7ec699;
}

.token.operator,
.token.entity,
.token.url {
  color: #67cdcc;
}

.token.important,
.token.bold {
  font-weight: bold;
}

.token.italic {
  font-style: italic;
}

.token.entity {
  cursor: help;
}

.token.inserted {
  color: green;
}

/*!
 * Bootstrap v4.3.1 (https://getbootstrap.com/)
 * Copyright 2011-2020 The Bootstrap Authors
 * Copyright 2011-2020 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */
/*!
 * Bootstrap  v5.3.3 (https://getbootstrap.com/)
 * Copyright 2011-2024 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --bs-blue: #00cfe8;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #ea5455;
  --bs-orange: #ff9f43;
  --bs-yellow: #ffc107;
  --bs-green: #28c76f;
  --bs-teal: #20c997;
  --bs-cyan: #7367f0;
  --bs-black: #22292f;
  --bs-white: #fff;
  --bs-gray: #b8c2cc;
  --bs-gray-dark: #1e1e1e;
  --bs-gray-100: #babfc7;
  --bs-gray-200: #ededed;
  --bs-gray-300: #dae1e7;
  --bs-gray-400: #636363;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #b8c2cc;
  --bs-gray-700: #4e5154;
  --bs-gray-800: #1e1e1e;
  --bs-gray-900: #2a2e30;
  --bs-primary: #7367f0;
  --bs-secondary: #b8c2cc;
  --bs-success: #28c76f;
  --bs-info: #00cfe8;
  --bs-warning: #ff9f43;
  --bs-danger: #ea5455;
  --bs-light: #babfc7;
  --bs-dark: #2a2e30;
  --bs-primary-rgb: 115, 103, 240;
  --bs-secondary-rgb: 184, 194, 204;
  --bs-success-rgb: 40, 199, 111;
  --bs-info-rgb: 0, 207, 232;
  --bs-warning-rgb: 255, 159, 67;
  --bs-danger-rgb: 234, 84, 85;
  --bs-light-rgb: 186, 191, 199;
  --bs-dark-rgb: 42, 46, 48;
  --bs-primary-text-emphasis: rgb(46, 41.2, 96);
  --bs-secondary-text-emphasis: rgb(73.6, 77.6, 81.6);
  --bs-success-text-emphasis: rgb(16, 79.6, 44.4);
  --bs-info-text-emphasis: rgb(0, 82.8, 92.8);
  --bs-warning-text-emphasis: rgb(102, 63.6, 26.8);
  --bs-danger-text-emphasis: rgb(93.6, 33.6, 34);
  --bs-light-text-emphasis: #4e5154;
  --bs-dark-text-emphasis: #4e5154;
  --bs-primary-bg-subtle: rgb(227, 224.6, 252);
  --bs-secondary-bg-subtle: rgb(240.8, 242.8, 244.8);
  --bs-success-bg-subtle: rgb(212, 243.8, 226.2);
  --bs-info-bg-subtle: rgb(204, 245.4, 250.4);
  --bs-warning-bg-subtle: rgb(255, 235.8, 217.4);
  --bs-danger-bg-subtle: rgb(250.8, 220.8, 221);
  --bs-light-bg-subtle: rgb(220.5, 223, 227);
  --bs-dark-bg-subtle: #636363;
  --bs-primary-border-subtle: rgb(199, 194.2, 249);
  --bs-secondary-border-subtle: rgb(226.6, 230.6, 234.6);
  --bs-success-border-subtle: rgb(169, 232.6, 197.4);
  --bs-info-border-subtle: rgb(153, 235.8, 245.8);
  --bs-warning-border-subtle: rgb(255, 216.6, 179.8);
  --bs-danger-border-subtle: rgb(246.6, 186.6, 187);
  --bs-light-border-subtle: #ededed;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 34, 41, 47;
  --bs-font-sans-serif: "Montserrat", Helvetica, Arial, serif;
  --bs-font-monospace: "Montserrat", Helvetica, Arial, serif;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.45;
  --bs-body-color: #626262;
  --bs-body-color-rgb: 98, 98, 98;
  --bs-body-bg: #f8f8f8;
  --bs-body-bg-rgb: 248, 248, 248;
  --bs-emphasis-color: #22292f;
  --bs-emphasis-color-rgb: 34, 41, 47;
  --bs-secondary-color: rgba(98, 98, 98, 0.75);
  --bs-secondary-color-rgb: 98, 98, 98;
  --bs-secondary-bg: #ededed;
  --bs-secondary-bg-rgb: 237, 237, 237;
  --bs-tertiary-color: rgba(98, 98, 98, 0.5);
  --bs-tertiary-color-rgb: 98, 98, 98;
  --bs-tertiary-bg: #babfc7;
  --bs-tertiary-bg-rgb: 186, 191, 199;
  --bs-heading-color: #2c2c2c;
  --bs-link-color: #7367f0;
  --bs-link-color-rgb: 115, 103, 240;
  --bs-link-decoration: underline;
  --bs-link-hover-color: rgb(93.622754491, 79.7904191617, 237.7095808383);
  --bs-link-hover-color-rgb: 94, 80, 238;
  --bs-link-hover-decoration: none;
  --bs-code-color: #d63384;
  --bs-highlight-color: #626262;
  --bs-highlight-bg: rgb(255, 242.6, 205.4);
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #ededed;
  --bs-border-color-translucent: rgba(34, 41, 47, 0.175);
  --bs-border-radius: 0.5rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.6rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0.5rem 1rem rgba(34, 41, 47, 0.15);
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(34, 41, 47, 0.075);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(34, 41, 47, 0.175);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(34, 41, 47, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(115, 103, 240, 0.25);
  --bs-form-valid-color: #28c76f;
  --bs-form-valid-border-color: #28c76f;
  --bs-form-invalid-color: #ea5455;
  --bs-form-invalid-border-color: #ea5455;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #dae1e7;
  --bs-body-color-rgb: 218, 225, 231;
  --bs-body-bg: #2a2e30;
  --bs-body-bg-rgb: 42, 46, 48;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(218, 225, 231, 0.75);
  --bs-secondary-color-rgb: 218, 225, 231;
  --bs-secondary-bg: #1e1e1e;
  --bs-secondary-bg-rgb: 30, 30, 30;
  --bs-tertiary-color: rgba(218, 225, 231, 0.5);
  --bs-tertiary-color-rgb: 218, 225, 231;
  --bs-tertiary-bg: #242627;
  --bs-tertiary-bg-rgb: 36, 38, 39;
  --bs-primary-text-emphasis: rgb(171, 163.8, 246);
  --bs-secondary-text-emphasis: rgb(212.4, 218.4, 224.4);
  --bs-success-text-emphasis: rgb(126, 221.4, 168.6);
  --bs-info-text-emphasis: rgb(102, 226.2, 241.2);
  --bs-warning-text-emphasis: rgb(255, 197.4, 142.2);
  --bs-danger-text-emphasis: rgb(242.4, 152.4, 153);
  --bs-light-text-emphasis: #babfc7;
  --bs-dark-text-emphasis: #dae1e7;
  --bs-primary-bg-subtle: rgb(23, 20.6, 48);
  --bs-secondary-bg-subtle: rgb(36.8, 38.8, 40.8);
  --bs-success-bg-subtle: rgb(8, 39.8, 22.2);
  --bs-info-bg-subtle: rgb(0, 41.4, 46.4);
  --bs-warning-bg-subtle: rgb(51, 31.8, 13.4);
  --bs-danger-bg-subtle: rgb(46.8, 16.8, 17);
  --bs-light-bg-subtle: #1e1e1e;
  --bs-dark-bg-subtle: rgb(32, 35.5, 38.5);
  --bs-primary-border-subtle: rgb(69, 61.8, 144);
  --bs-secondary-border-subtle: rgb(110.4, 116.4, 122.4);
  --bs-success-border-subtle: rgb(24, 119.4, 66.6);
  --bs-info-border-subtle: rgb(0, 124.2, 139.2);
  --bs-warning-border-subtle: rgb(153, 95.4, 40.2);
  --bs-danger-border-subtle: rgb(140.4, 50.4, 51);
  --bs-light-border-subtle: #4e5154;
  --bs-dark-border-subtle: #1e1e1e;
  --bs-heading-color: inherit;
  --bs-link-color: rgb(171, 163.8, 246);
  --bs-link-hover-color: rgb(187.8, 182.04, 247.8);
  --bs-link-color-rgb: 171, 164, 246;
  --bs-link-hover-color-rgb: 188, 182, 248;
  --bs-code-color: rgb(230.4, 132.6, 181.2);
  --bs-highlight-color: #dae1e7;
  --bs-highlight-bg: rgb(102, 77.2, 2.8);
  --bs-border-color: #4e5154;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: rgb(126, 221.4, 168.6);
  --bs-form-valid-border-color: rgb(126, 221.4, 168.6);
  --bs-form-invalid-color: rgb(242.4, 152.4, 153);
  --bs-form-invalid-border-color: rgb(242.4, 152.4, 153);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(34, 41, 47, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-family: inherit;
  font-weight: 500;
  line-height: 1.2;
  color: var(--bs-heading-color);
}

h1, .h1 {
  font-size: calc(1.325rem + 0.9vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2rem;
  }
}

h2, .h2 {
  font-size: calc(1.299rem + 0.588vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 1.74rem;
  }
}

h3, .h3 {
  font-size: calc(1.276rem + 0.312vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.51rem;
  }
}

h4, .h4 {
  font-size: calc(1.257rem + 0.084vw);
}
@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.32rem;
  }
}

h5, .h5 {
  font-size: 1.14rem;
}

h6, .h6 {
  font-size: 1rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: smaller;
}

mark, .mark {
  padding: 0.1875em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: underline;
}
a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
  text-decoration: none;
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 90%;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 90%;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 90%;
  color: var(--bs-body-bg);
  background-color: #eee;
  border-radius: 0.25rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-secondary-color);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: smaller;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: smaller;
  color: #b8c2cc;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: smaller;
  color: var(--bs-secondary-color);
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 28px;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}

.row {
  --bs-gutter-x: 28px;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-25,
.gx-25 {
  --bs-gutter-x: 0.25rem;
}

.g-25,
.gy-25 {
  --bs-gutter-y: 0.25rem;
}

.g-50,
.gx-50 {
  --bs-gutter-x: 0.5rem;
}

.g-50,
.gy-50 {
  --bs-gutter-y: 0.5rem;
}

.g-75,
.gx-75 {
  --bs-gutter-x: 0.75rem;
}

.g-75,
.gy-75 {
  --bs-gutter-y: 0.75rem;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 1rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 1rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 1.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 1.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 3rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 3rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 3.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 3.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 4rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 4rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-25,
  .gx-sm-25 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-25,
  .gy-sm-25 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-50,
  .gx-sm-50 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-50,
  .gy-sm-50 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-75,
  .gx-sm-75 {
    --bs-gutter-x: 0.75rem;
  }
  .g-sm-75,
  .gy-sm-75 {
    --bs-gutter-y: 0.75rem;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 3rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 3.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 3.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 4rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 4rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-25,
  .gx-md-25 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-25,
  .gy-md-25 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-50,
  .gx-md-50 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-50,
  .gy-md-50 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-75,
  .gx-md-75 {
    --bs-gutter-x: 0.75rem;
  }
  .g-md-75,
  .gy-md-75 {
    --bs-gutter-y: 0.75rem;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 1rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 1rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 3rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 3rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 3.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 3.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 4rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 4rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-25,
  .gx-lg-25 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-25,
  .gy-lg-25 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-50,
  .gx-lg-50 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-50,
  .gy-lg-50 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-75,
  .gx-lg-75 {
    --bs-gutter-x: 0.75rem;
  }
  .g-lg-75,
  .gy-lg-75 {
    --bs-gutter-y: 0.75rem;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 3rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 3.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 3.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 4rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 4rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-25,
  .gx-xl-25 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-25,
  .gy-xl-25 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-50,
  .gx-xl-50 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-50,
  .gy-xl-50 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-75,
  .gx-xl-75 {
    --bs-gutter-x: 0.75rem;
  }
  .g-xl-75,
  .gy-xl-75 {
    --bs-gutter-y: 0.75rem;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 3rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 3.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 3.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 4rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 4rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-25,
  .gx-xxl-25 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-25,
  .gy-xxl-25 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-50,
  .gx-xxl-50 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-50,
  .gy-xxl-50 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-75,
  .gx-xxl-75 {
    --bs-gutter-x: 0.75rem;
  }
  .g-xxl-75,
  .gy-xxl-75 {
    --bs-gutter-y: 0.75rem;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 3rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 3rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 3.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 3.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 4rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 4rem;
  }
}
.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--bs-emphasis-color);
  --bs-table-bg: var(--bs-body-bg);
  --bs-table-border-color: #f8f8f8;
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-emphasis-color);
  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);
  --bs-table-active-color: var(--bs-emphasis-color);
  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);
  --bs-table-hover-color: var(--bs-emphasis-color);
  --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: var(--bs-border-width);
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: var(--bs-border-width) 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 var(--bs-border-width);
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color: #22292f;
  --bs-table-bg: rgb(227, 224.6, 252);
  --bs-table-border-color: rgb(188.4, 187.88, 211);
  --bs-table-striped-bg: rgb(217.35, 215.42, 241.75);
  --bs-table-striped-color: #22292f;
  --bs-table-active-bg: rgb(207.7, 206.24, 231.5);
  --bs-table-active-color: #22292f;
  --bs-table-hover-bg: rgb(212.525, 210.83, 236.625);
  --bs-table-hover-color: #22292f;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #22292f;
  --bs-table-bg: rgb(240.8, 242.8, 244.8);
  --bs-table-border-color: rgb(199.44, 202.44, 205.24);
  --bs-table-striped-bg: rgb(230.46, 232.71, 234.91);
  --bs-table-striped-color: #22292f;
  --bs-table-active-bg: rgb(220.12, 222.62, 225.02);
  --bs-table-active-color: #22292f;
  --bs-table-hover-bg: rgb(225.29, 227.665, 229.965);
  --bs-table-hover-color: #22292f;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #22292f;
  --bs-table-bg: rgb(212, 243.8, 226.2);
  --bs-table-border-color: rgb(176.4, 203.24, 190.36);
  --bs-table-striped-bg: rgb(203.1, 233.66, 217.24);
  --bs-table-striped-color: #22292f;
  --bs-table-active-bg: rgb(194.2, 223.52, 208.28);
  --bs-table-active-color: #22292f;
  --bs-table-hover-bg: rgb(198.65, 228.59, 212.76);
  --bs-table-hover-color: #22292f;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #22292f;
  --bs-table-bg: rgb(204, 245.4, 250.4);
  --bs-table-border-color: rgb(170, 204.52, 209.72);
  --bs-table-striped-bg: rgb(195.5, 235.18, 240.23);
  --bs-table-striped-color: #22292f;
  --bs-table-active-bg: rgb(187, 224.96, 230.06);
  --bs-table-active-color: #22292f;
  --bs-table-hover-bg: rgb(191.25, 230.07, 235.145);
  --bs-table-hover-color: #22292f;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #22292f;
  --bs-table-bg: rgb(255, 235.8, 217.4);
  --bs-table-border-color: rgb(210.8, 196.84, 183.32);
  --bs-table-striped-bg: rgb(243.95, 226.06, 208.88);
  --bs-table-striped-color: #22292f;
  --bs-table-active-bg: rgb(232.9, 216.32, 200.36);
  --bs-table-active-color: #22292f;
  --bs-table-hover-bg: rgb(238.425, 221.19, 204.62);
  --bs-table-hover-color: #22292f;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #22292f;
  --bs-table-bg: rgb(250.8, 220.8, 221);
  --bs-table-border-color: rgb(207.44, 184.84, 186.2);
  --bs-table-striped-bg: rgb(239.96, 211.81, 212.3);
  --bs-table-striped-color: #22292f;
  --bs-table-active-bg: rgb(229.12, 202.82, 203.6);
  --bs-table-active-color: #22292f;
  --bs-table-hover-bg: rgb(234.54, 207.315, 207.95);
  --bs-table-hover-color: #22292f;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #22292f;
  --bs-table-bg: #babfc7;
  --bs-table-border-color: rgb(155.6, 161, 168.6);
  --bs-table-striped-bg: rgb(178.4, 183.5, 191.4);
  --bs-table-striped-color: #22292f;
  --bs-table-active-bg: rgb(170.8, 176, 183.8);
  --bs-table-active-color: #22292f;
  --bs-table-hover-bg: rgb(174.6, 179.75, 187.6);
  --bs-table-hover-color: #22292f;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #2a2e30;
  --bs-table-border-color: rgb(84.6, 87.8, 89.4);
  --bs-table-striped-bg: rgb(52.65, 56.45, 58.35);
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(63.3, 66.9, 68.7);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(57.975, 61.675, 63.525);
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.7rem + 1px);
  padding-bottom: calc(0.7rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.25;
}

.col-form-label-lg {
  padding-top: calc(1rem + 1px);
  padding-bottom: calc(1rem + 1px);
  font-size: 1.25rem;
}

.col-form-label-sm {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 0.7rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: smaller;
  color: var(--bs-secondary-color);
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.7rem 0.7rem;
  font-size: 0.96rem;
  font-weight: 400;
  line-height: 1.25;
  color: #4e5154;
  appearance: none;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: #4e5154;
  background-color: var(--bs-body-bg);
  border-color: #7367f0;
  outline: 0;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.25em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: rgba(0, 0, 0, 0.5);
  opacity: 1;
}
.form-control:disabled {
  background-color: #f5f5f1;
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.7rem 0.7rem;
  margin: -0.7rem -0.7rem;
  margin-inline-end: 0.7rem;
  color: #4e5154;
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--bs-secondary-bg);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.7rem 0;
  margin-bottom: 0;
  line-height: 1.25;
  color: #adb5bd;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.25em + 1rem + calc(1px * 2));
  padding: 0.5rem 1.5rem;
  font-size: 0.7rem;
  border-radius: 4px;
}
.form-control-sm::file-selector-button {
  padding: 0.5rem 1.5rem;
  margin: -0.5rem -1.5rem;
  margin-inline-end: 1.5rem;
}

.form-control-lg {
  min-height: calc(1.25em + 2rem + calc(1px * 2));
  padding: 1rem 2.5rem;
  font-size: 1.25rem;
  border-radius: 6px;
}
.form-control-lg::file-selector-button {
  padding: 1rem 2.5rem;
  margin: -1rem -2.5rem;
  margin-inline-end: 2.5rem;
}

textarea.form-control {
  min-height: calc(1.25em + 1.4rem + 1px);
}
textarea.form-control-sm {
  min-height: calc(1.25em + 1rem + calc(1px * 2));
}
textarea.form-control-lg {
  min-height: calc(1.25em + 2rem + calc(1px * 2));
}

.form-control-color {
  width: 3rem;
  height: calc(1.25em + 1.4rem + 1px);
  padding: 0.7rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: 5px;
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: 5px;
}
.form-control-color.form-control-sm {
  height: calc(1.25em + 1rem + calc(1px * 2));
}
.form-control-color.form-control-lg {
  height: calc(1.25em + 2rem + calc(1px * 2));
}

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  padding: 0.7rem 2.1rem 0.7rem 0.7rem;
  font-size: 0.96rem;
  font-weight: 400;
  line-height: 1.25;
  color: #4e5154;
  appearance: none;
  background-color: var(--bs-body-bg);
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.7rem center;
  background-size: 16px 12px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: #7367f0;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(115, 103, 240, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.7rem;
  background-image: none;
}
.form-select:disabled {
  background-color: #f5f5f1;
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #4e5154;
}

.form-select-sm {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1.5rem;
  font-size: 0.7rem;
  border-radius: 4px;
}

.form-select-lg {
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 2.5rem;
  font-size: 1.25rem;
  border-radius: 6px;
}

[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.form-check {
  display: block;
  min-height: 1.45rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg: var(--bs-body-bg);
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.225em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--bs-border-width) solid var(--bs-border-color);
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: #7367f0;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(115, 103, 240, 0.25);
}
.form-check-input:checked {
  background-color: #7367f0;
  border-color: #7367f0;
}
.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #7367f0;
  border-color: #7367f0;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #f8f8f8, 0 3px 10px 0 rgba(0, 0, 0, 0.15);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #f8f8f8, 0 3px 10px 0 rgba(0, 0, 0, 0.15);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #7367f0;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: rgb(213, 209.4, 250.5);
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #7367f0;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: rgb(213, 209.4, 250.5);
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--bs-secondary-color);
}
.form-range:disabled::-moz-range-thumb {
  background-color: var(--bs-secondary-color);
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + calc(1px * 2));
  min-height: calc(3.5rem + calc(1px * 2));
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  padding: 1rem 0.7rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: 1px solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.7rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:focus ~ label::after,
.form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.form-floating > .form-control-plaintext ~ label::after,
.form-floating > .form-select ~ label::after {
  position: absolute;
  inset: 1rem 0.35rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--bs-body-bg);
  border-radius: 5px;
}
.form-floating > .form-control:-webkit-autofill ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: 1px 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #b8c2cc;
}
.form-floating > :disabled ~ label::after,
.form-floating > .form-control:disabled ~ label::after {
  background-color: #f5f5f1;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.7rem 0.7rem;
  font-size: 0.96rem;
  font-weight: 400;
  line-height: 1.25;
  color: #4e5154;
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-tertiary-bg);
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 1rem 2.5rem;
  font-size: 1.25rem;
  border-radius: 6px;
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.5rem 1.5rem;
  font-size: 0.7rem;
  border-radius: 4px;
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 2.8rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(1px * -1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: smaller;
  color: var(--bs-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.4rem 0.775rem;
  margin-top: 0.1rem;
  font-size: 0.857rem;
  color: #fff;
  background-color: var(--bs-success);
  border-radius: 0.428rem;
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--bs-form-valid-border-color);
  padding-right: calc(1.25em + 1.4rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: right calc(0.3125em + 0.35rem) center;
  background-size: calc(0.625em + 0.7rem) calc(0.625em + 0.7rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.25em + 1.4rem);
  background-position: top calc(0.3125em + 0.35rem) right calc(0.3125em + 0.35rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  padding-right: 3.85rem;
  background-position: right 0.7rem center, center right 2.1rem;
  background-size: 16px 12px, calc(0.625em + 0.7rem) calc(0.625em + 0.7rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.25em + 1.4rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--bs-form-valid-color);
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--bs-form-valid-color);
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: smaller;
  color: var(--bs-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.4rem 0.775rem;
  margin-top: 0.1rem;
  font-size: 0.857rem;
  color: #fff;
  background-color: var(--bs-danger);
  border-radius: 0.428rem;
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
  padding-right: calc(1.25em + 1.4rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-position: right calc(0.3125em + 0.35rem) center;
  background-size: calc(0.625em + 0.7rem) calc(0.625em + 0.7rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.25em + 1.4rem);
  background-position: top calc(0.3125em + 0.35rem) right calc(0.3125em + 0.35rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  padding-right: 3.85rem;
  background-position: right 0.7rem center, center right 2.1rem;
  background-size: 16px 12px, calc(0.625em + 0.7rem) calc(0.625em + 0.7rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.25em + 1.4rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--bs-form-invalid-color);
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--bs-form-invalid-color);
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 2rem;
  --bs-btn-padding-y: 0.9rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 1rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: 0;
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: 0.4285rem;
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(34, 41, 47, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked:focus-visible + .btn {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #7367f0;
  --bs-btn-border-color: #7367f0;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(97.75, 87.55, 204);
  --bs-btn-hover-border-color: rgb(92, 82.4, 192);
  --bs-btn-focus-shadow-rgb: 136, 126, 242;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(92, 82.4, 192);
  --bs-btn-active-border-color: rgb(86.25, 77.25, 180);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #7367f0;
  --bs-btn-disabled-border-color: #7367f0;
}

.btn-secondary {
  --bs-btn-color: #22292f;
  --bs-btn-bg: #b8c2cc;
  --bs-btn-border-color: #b8c2cc;
  --bs-btn-hover-color: #22292f;
  --bs-btn-hover-bg: rgb(194.65, 203.15, 211.65);
  --bs-btn-hover-border-color: rgb(191.1, 200.1, 209.1);
  --bs-btn-focus-shadow-rgb: 162, 171, 180;
  --bs-btn-active-color: #22292f;
  --bs-btn-active-bg: rgb(198.2, 206.2, 214.2);
  --bs-btn-active-border-color: rgb(191.1, 200.1, 209.1);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #22292f;
  --bs-btn-disabled-bg: #b8c2cc;
  --bs-btn-disabled-border-color: #b8c2cc;
}

.btn-success {
  --bs-btn-color: #22292f;
  --bs-btn-bg: #28c76f;
  --bs-btn-border-color: #28c76f;
  --bs-btn-hover-color: #22292f;
  --bs-btn-hover-bg: rgb(72.25, 207.4, 132.6);
  --bs-btn-hover-border-color: rgb(61.5, 204.6, 125.4);
  --bs-btn-focus-shadow-rgb: 39, 175, 101;
  --bs-btn-active-color: #22292f;
  --bs-btn-active-bg: rgb(83, 210.2, 139.8);
  --bs-btn-active-border-color: rgb(61.5, 204.6, 125.4);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #22292f;
  --bs-btn-disabled-bg: #28c76f;
  --bs-btn-disabled-border-color: #28c76f;
}

.btn-info {
  --bs-btn-color: #22292f;
  --bs-btn-bg: #00cfe8;
  --bs-btn-border-color: #00cfe8;
  --bs-btn-hover-color: #22292f;
  --bs-btn-hover-bg: rgb(38.25, 214.2, 235.45);
  --bs-btn-hover-border-color: rgb(25.5, 211.8, 234.3);
  --bs-btn-focus-shadow-rgb: 5, 182, 204;
  --bs-btn-active-color: #22292f;
  --bs-btn-active-bg: rgb(51, 216.6, 236.6);
  --bs-btn-active-border-color: rgb(25.5, 211.8, 234.3);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #22292f;
  --bs-btn-disabled-bg: #00cfe8;
  --bs-btn-disabled-border-color: #00cfe8;
}

.btn-warning {
  --bs-btn-color: #22292f;
  --bs-btn-bg: #ff9f43;
  --bs-btn-border-color: #ff9f43;
  --bs-btn-hover-color: #22292f;
  --bs-btn-hover-bg: rgb(255, 173.4, 95.2);
  --bs-btn-hover-border-color: rgb(255, 168.6, 85.8);
  --bs-btn-focus-shadow-rgb: 222, 141, 64;
  --bs-btn-active-color: #22292f;
  --bs-btn-active-bg: rgb(255, 178.2, 104.6);
  --bs-btn-active-border-color: rgb(255, 168.6, 85.8);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #22292f;
  --bs-btn-disabled-bg: #ff9f43;
  --bs-btn-disabled-border-color: #ff9f43;
}

.btn-danger {
  --bs-btn-color: #22292f;
  --bs-btn-bg: #ea5455;
  --bs-btn-border-color: #ea5455;
  --bs-btn-hover-color: #22292f;
  --bs-btn-hover-bg: rgb(237.15, 109.65, 110.5);
  --bs-btn-hover-border-color: rgb(236.1, 101.1, 102);
  --bs-btn-focus-shadow-rgb: 204, 78, 79;
  --bs-btn-active-color: #22292f;
  --bs-btn-active-bg: rgb(238.2, 118.2, 119);
  --bs-btn-active-border-color: rgb(236.1, 101.1, 102);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #22292f;
  --bs-btn-disabled-bg: #ea5455;
  --bs-btn-disabled-border-color: #ea5455;
}

.btn-light {
  --bs-btn-color: #22292f;
  --bs-btn-bg: #babfc7;
  --bs-btn-border-color: #babfc7;
  --bs-btn-hover-color: #22292f;
  --bs-btn-hover-bg: rgb(158.1, 162.35, 169.15);
  --bs-btn-hover-border-color: rgb(148.8, 152.8, 159.2);
  --bs-btn-focus-shadow-rgb: 163, 169, 176;
  --bs-btn-active-color: #22292f;
  --bs-btn-active-bg: rgb(148.8, 152.8, 159.2);
  --bs-btn-active-border-color: rgb(139.5, 143.25, 149.25);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #22292f;
  --bs-btn-disabled-bg: #babfc7;
  --bs-btn-disabled-border-color: #babfc7;
}

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #2a2e30;
  --bs-btn-border-color: #2a2e30;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(73.95, 77.35, 79.05);
  --bs-btn-hover-border-color: rgb(63.3, 66.9, 68.7);
  --bs-btn-focus-shadow-rgb: 74, 77, 79;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(84.6, 87.8, 89.4);
  --bs-btn-active-border-color: rgb(63.3, 66.9, 68.7);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #2a2e30;
  --bs-btn-disabled-border-color: #2a2e30;
}

.btn-outline-primary {
  --bs-btn-color: #7367f0;
  --bs-btn-border-color: #7367f0;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #7367f0;
  --bs-btn-hover-border-color: #7367f0;
  --bs-btn-focus-shadow-rgb: 115, 103, 240;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #7367f0;
  --bs-btn-active-border-color: #7367f0;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #7367f0;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #7367f0;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #b8c2cc;
  --bs-btn-border-color: #b8c2cc;
  --bs-btn-hover-color: #22292f;
  --bs-btn-hover-bg: #b8c2cc;
  --bs-btn-hover-border-color: #b8c2cc;
  --bs-btn-focus-shadow-rgb: 184, 194, 204;
  --bs-btn-active-color: #22292f;
  --bs-btn-active-bg: #b8c2cc;
  --bs-btn-active-border-color: #b8c2cc;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #b8c2cc;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #b8c2cc;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #28c76f;
  --bs-btn-border-color: #28c76f;
  --bs-btn-hover-color: #22292f;
  --bs-btn-hover-bg: #28c76f;
  --bs-btn-hover-border-color: #28c76f;
  --bs-btn-focus-shadow-rgb: 40, 199, 111;
  --bs-btn-active-color: #22292f;
  --bs-btn-active-bg: #28c76f;
  --bs-btn-active-border-color: #28c76f;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #28c76f;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #28c76f;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #00cfe8;
  --bs-btn-border-color: #00cfe8;
  --bs-btn-hover-color: #22292f;
  --bs-btn-hover-bg: #00cfe8;
  --bs-btn-hover-border-color: #00cfe8;
  --bs-btn-focus-shadow-rgb: 0, 207, 232;
  --bs-btn-active-color: #22292f;
  --bs-btn-active-bg: #00cfe8;
  --bs-btn-active-border-color: #00cfe8;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #00cfe8;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #00cfe8;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #ff9f43;
  --bs-btn-border-color: #ff9f43;
  --bs-btn-hover-color: #22292f;
  --bs-btn-hover-bg: #ff9f43;
  --bs-btn-hover-border-color: #ff9f43;
  --bs-btn-focus-shadow-rgb: 255, 159, 67;
  --bs-btn-active-color: #22292f;
  --bs-btn-active-bg: #ff9f43;
  --bs-btn-active-border-color: #ff9f43;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #ff9f43;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ff9f43;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #ea5455;
  --bs-btn-border-color: #ea5455;
  --bs-btn-hover-color: #22292f;
  --bs-btn-hover-bg: #ea5455;
  --bs-btn-hover-border-color: #ea5455;
  --bs-btn-focus-shadow-rgb: 234, 84, 85;
  --bs-btn-active-color: #22292f;
  --bs-btn-active-bg: #ea5455;
  --bs-btn-active-border-color: #ea5455;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #ea5455;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ea5455;
  --bs-gradient: none;
}

.btn-outline-light {
  --bs-btn-color: #babfc7;
  --bs-btn-border-color: #babfc7;
  --bs-btn-hover-color: #22292f;
  --bs-btn-hover-bg: #babfc7;
  --bs-btn-hover-border-color: #babfc7;
  --bs-btn-focus-shadow-rgb: 186, 191, 199;
  --bs-btn-active-color: #22292f;
  --bs-btn-active-bg: #babfc7;
  --bs-btn-active-border-color: #babfc7;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #babfc7;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #babfc7;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #2a2e30;
  --bs-btn-border-color: #2a2e30;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #2a2e30;
  --bs-btn-hover-border-color: #2a2e30;
  --bs-btn-focus-shadow-rgb: 42, 46, 48;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #2a2e30;
  --bs-btn-active-border-color: #2a2e30;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #2a2e30;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #2a2e30;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #b8c2cc;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 136, 126, 242;
  text-decoration: underline;
}
.btn-link:hover, .btn-link:focus-visible {
  text-decoration: none;
}
.btn-link:focus-visible {
  color: var(--bs-btn-color);
}
.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 1rem;
  --bs-btn-padding-x: 2.5rem;
  --bs-btn-font-size: 1.25rem;
  --bs-btn-border-radius: var(--bs-border-radius-lg);
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1.5rem;
  --bs-btn-font-size: 0.7rem;
  --bs-btn-border-radius: var(--bs-border-radius-sm);
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.5rem;
  --bs-dropdown-font-size: 0.9375rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: var(--bs-body-bg);
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: 5px;
  --bs-dropdown-border-width: var(--bs-border-width);
  --bs-dropdown-inner-border-radius: calc(5px - var(--bs-border-width));
  --bs-dropdown-divider-bg: rgba(0, 0, 0, 0.08);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: var(--bs-box-shadow);
  --bs-dropdown-link-color: var(--bs-body-color);
  --bs-dropdown-link-hover-color: var(--bs-body-color);
  --bs-dropdown-link-hover-bg: #f8f8f8;
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #7367f0;
  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);
  --bs-dropdown-item-padding-x: 1rem;
  --bs-dropdown-item-padding-y: 0.25rem;
  --bs-dropdown-header-color: #b8c2cc;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 1rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #dae1e7;
  --bs-dropdown-bg: #1e1e1e;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #dae1e7;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: rgba(0, 0, 0, 0.08);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #7367f0;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: 0.4285rem;
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(0 * -1);
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 1.5rem;
  padding-left: 1.5rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 1.125rem;
  padding-left: 1.125rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 1.875rem;
  padding-left: 1.875rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(0 * -1);
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 0.5rem;
  --bs-nav-link-padding-y: 0.357rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(115, 103, 240, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: var(--bs-border-color);
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);
  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: var(--bs-border-radius);
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #7367f0;
}
.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}
.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}
.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 700;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);
  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);
  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-padding-y: -0.368rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 2rem;
  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 2rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);
  --bs-navbar-toggler-border-radius: 0.4285rem;
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.357rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.357rem;
  padding-bottom: 0.357rem;
  color: var(--bs-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

[data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

.card {
  --bs-card-spacer-y: 1.5rem;
  --bs-card-spacer-x: 1.5rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: var(--bs-border-width);
  --bs-card-border-color: var(--bs-border-color-translucent);
  --bs-card-border-radius: var(--bs-border-radius);
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-card-cap-padding-y: 0.75rem;
  --bs-card-cap-padding-x: 1.5rem;
  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: var(--bs-body-bg);
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 14px;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: var(--bs-body-color);
  --bs-accordion-bg: var(--bs-body-bg);
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: var(--bs-border-radius);
  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(115, 103, 240, 0.25);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: var(--bs-primary-text-emphasis);
  --bs-accordion-active-bg: var(--bs-primary-bg-subtle);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.accordion-item:first-of-type > .accordion-header .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:last-of-type > .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush > .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush > .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush > .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush > .accordion-item > .accordion-header .accordion-button, .accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {
  border-radius: 0;
}
.accordion-flush > .accordion-item > .accordion-collapse {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: var(--bs-secondary-color);
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, ">>") /* rtl: var(--bs-breadcrumb-divider, ">>") */;
}
.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.911rem;
  --bs-pagination-padding-y: 0.65rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-color: var(--bs-link-color);
  --bs-pagination-bg: var(--bs-body-bg);
  --bs-pagination-border-width: var(--bs-border-width);
  --bs-pagination-border-color: var(--bs-border-color);
  --bs-pagination-border-radius: var(--bs-border-radius);
  --bs-pagination-hover-color: var(--bs-link-hover-color);
  --bs-pagination-hover-bg: var(--bs-tertiary-bg);
  --bs-pagination-hover-border-color: var(--bs-border-color);
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: var(--bs-secondary-bg);
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(115, 103, 240, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #7367f0;
  --bs-pagination-active-border-color: #7367f0;
  --bs-pagination-disabled-color: var(--bs-secondary-color);
  --bs-pagination-disabled-bg: var(--bs-secondary-bg);
  --bs-pagination-disabled-border-color: var(--bs-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  text-decoration: none;
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: calc(var(--bs-border-width) * -1);
}
.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}
.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1rem;
  --bs-pagination-padding-y: 0.5rem;
  --bs-pagination-font-size: calc(1.325rem + 0.9vw);
  --bs-pagination-border-radius: var(--bs-border-radius-lg);
}
@media (min-width: 1200px) {
  .pagination-lg {
    --bs-pagination-font-size: 2rem;
  }
}

.pagination-sm {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.5rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-border-radius: var(--bs-border-radius-sm);
}

.badge {
  --bs-badge-padding-x: 0.4em;
  --bs-badge-padding-y: 0.4em;
  --bs-badge-font-size: 80%;
  --bs-badge-font-weight: 700;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: 0.25rem;
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 0.71rem;
  --bs-alert-padding-y: 0.71rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: var(--bs-border-radius);
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 2.13rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 0.8875rem 0.71rem;
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 0.357rem;
  }
}
.progress,
.progress-stacked {
  --bs-progress-height: 0.357rem;
  --bs-progress-font-size: 0.75rem;
  --bs-progress-bg: var(--bs-secondary-bg);
  --bs-progress-border-radius: 1.28rem;
  --bs-progress-box-shadow: var(--bs-box-shadow-inset);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #7367f0;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: var(--bs-body-bg);
  --bs-list-group-border-color: var(--bs-border-color);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-bg);
  --bs-list-group-disabled-color: var(--bs-secondary-color);
  --bs-list-group-disabled-bg: var(--bs-body-bg);
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #7367f0;
  --bs-list-group-active-border-color: #7367f0;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.list-group-item-action:active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  text-decoration: none;
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}

.btn-close {
  --bs-btn-close-color: #22292f;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(115, 103, 240, 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.5rem;
  opacity: var(--bs-btn-close-opacity);
}
.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  filter: var(--bs-btn-close-white-filter);
}

[data-bs-theme=dark] .btn-close {
  filter: var(--bs-btn-close-white-filter);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 28px;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-border-width: var(--bs-border-width);
  --bs-toast-border-color: var(--bs-border-color-translucent);
  --bs-toast-border-radius: var(--bs-border-radius);
  --bs-toast-box-shadow: var(--bs-box-shadow);
  --bs-toast-header-color: var(--bs-secondary-color);
  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-header-border-color: var(--bs-border-color-translucent);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: ;
  --bs-modal-bg: var(--bs-body-bg);
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: var(--bs-border-width);
  --bs-modal-border-radius: var(--bs-border-radius-lg);
  --bs-modal-box-shadow: var(--bs-box-shadow-sm);
  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: var(--bs-border-width);
  --bs-modal-title-line-height: 1.45;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: var(--bs-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #22292f;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: var(--bs-box-shadow);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1032;
  --bs-tooltip-max-width: 220px;
  --bs-tooltip-padding-x: 0.775rem;
  --bs-tooltip-padding-y: 0.4rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size: 0.857rem;
  --bs-tooltip-color: var(--bs-body-bg);
  --bs-tooltip-bg: #323232;
  --bs-tooltip-border-radius: 0.428rem;
  --bs-tooltip-opacity: 1;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.45;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.857rem;
  --bs-popover-bg: var(--bs-body-bg);
  --bs-popover-border-width: var(--bs-border-width);
  --bs-popover-border-color: var(--bs-border-color-translucent);
  --bs-popover-border-radius: 0.428rem;
  --bs-popover-inner-border-radius: calc(0.428rem - var(--bs-border-width));
  --bs-popover-box-shadow: var(--bs-box-shadow);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: #2c2c2c;
  --bs-popover-header-bg: #7367f0;
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: var(--bs-body-color);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.45;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e")*/;
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e")*/;
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #22292f;
}
.carousel-dark .carousel-caption {
  color: #22292f;
}

[data-bs-theme=dark] .carousel .carousel-control-prev-icon,
[data-bs-theme=dark] .carousel .carousel-control-next-icon, [data-bs-theme=dark].carousel .carousel-control-prev-icon,
[data-bs-theme=dark].carousel .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target], [data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {
  background-color: #22292f;
}
[data-bs-theme=dark] .carousel .carousel-caption, [data-bs-theme=dark].carousel .carousel-caption {
  color: #22292f;
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-body-bg);
  --bs-offcanvas-border-width: var(--bs-border-width);
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.45;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #22292f;
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-offcanvas-padding-y)) calc(-0.5 * var(--bs-offcanvas-padding-x)) calc(-0.5 * var(--bs-offcanvas-padding-y)) auto;
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, #22292f 55%, rgba(0, 0, 0, 0.8) 75%, #22292f 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #22292f !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #22292f !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #22292f !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #22292f !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #22292f !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #22292f !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(92, 82, 192, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(92, 82, 192, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(198, 206, 214, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(198, 206, 214, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(83, 210, 140, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(83, 210, 140, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(51, 217, 237, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(51, 217, 237, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(255, 178, 105, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 178, 105, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(238, 118, 119, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(238, 118, 119, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(200, 204, 210, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(200, 204, 210, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(34, 37, 38, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(34, 37, 38, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-25 {
  margin: 0.25rem !important;
}

.m-50 {
  margin: 0.5rem !important;
}

.m-75 {
  margin: 0.75rem !important;
}

.m-1 {
  margin: 1rem !important;
}

.m-2 {
  margin: 1.5rem !important;
}

.m-3 {
  margin: 3rem !important;
}

.m-4 {
  margin: 3.5rem !important;
}

.m-5 {
  margin: 4rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-25 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-50 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-75 {
  margin-right: 0.75rem !important;
  margin-left: 0.75rem !important;
}

.mx-1 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-2 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-3 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-4 {
  margin-right: 3.5rem !important;
  margin-left: 3.5rem !important;
}

.mx-5 {
  margin-right: 4rem !important;
  margin-left: 4rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-25 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-50 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-75 {
  margin-top: 0.75rem !important;
  margin-bottom: 0.75rem !important;
}

.my-1 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-2 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-3 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-4 {
  margin-top: 3.5rem !important;
  margin-bottom: 3.5rem !important;
}

.my-5 {
  margin-top: 4rem !important;
  margin-bottom: 4rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-25 {
  margin-top: 0.25rem !important;
}

.mt-50 {
  margin-top: 0.5rem !important;
}

.mt-75 {
  margin-top: 0.75rem !important;
}

.mt-1 {
  margin-top: 1rem !important;
}

.mt-2 {
  margin-top: 1.5rem !important;
}

.mt-3 {
  margin-top: 3rem !important;
}

.mt-4 {
  margin-top: 3.5rem !important;
}

.mt-5 {
  margin-top: 4rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-25 {
  margin-right: 0.25rem !important;
}

.me-50 {
  margin-right: 0.5rem !important;
}

.me-75 {
  margin-right: 0.75rem !important;
}

.me-1 {
  margin-right: 1rem !important;
}

.me-2 {
  margin-right: 1.5rem !important;
}

.me-3 {
  margin-right: 3rem !important;
}

.me-4 {
  margin-right: 3.5rem !important;
}

.me-5 {
  margin-right: 4rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-25 {
  margin-bottom: 0.25rem !important;
}

.mb-50 {
  margin-bottom: 0.5rem !important;
}

.mb-75 {
  margin-bottom: 0.75rem !important;
}

.mb-1 {
  margin-bottom: 1rem !important;
}

.mb-2 {
  margin-bottom: 1.5rem !important;
}

.mb-3 {
  margin-bottom: 3rem !important;
}

.mb-4 {
  margin-bottom: 3.5rem !important;
}

.mb-5 {
  margin-bottom: 4rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-25 {
  margin-left: 0.25rem !important;
}

.ms-50 {
  margin-left: 0.5rem !important;
}

.ms-75 {
  margin-left: 0.75rem !important;
}

.ms-1 {
  margin-left: 1rem !important;
}

.ms-2 {
  margin-left: 1.5rem !important;
}

.ms-3 {
  margin-left: 3rem !important;
}

.ms-4 {
  margin-left: 3.5rem !important;
}

.ms-5 {
  margin-left: 4rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-25 {
  padding: 0.25rem !important;
}

.p-50 {
  padding: 0.5rem !important;
}

.p-75 {
  padding: 0.75rem !important;
}

.p-1 {
  padding: 1rem !important;
}

.p-2 {
  padding: 1.5rem !important;
}

.p-3 {
  padding: 3rem !important;
}

.p-4 {
  padding: 3.5rem !important;
}

.p-5 {
  padding: 4rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-25 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-50 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-75 {
  padding-right: 0.75rem !important;
  padding-left: 0.75rem !important;
}

.px-1 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-2 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-3 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.px-4 {
  padding-right: 3.5rem !important;
  padding-left: 3.5rem !important;
}

.px-5 {
  padding-right: 4rem !important;
  padding-left: 4rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-25 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-50 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-75 {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}

.py-1 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-2 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-3 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.py-4 {
  padding-top: 3.5rem !important;
  padding-bottom: 3.5rem !important;
}

.py-5 {
  padding-top: 4rem !important;
  padding-bottom: 4rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-25 {
  padding-top: 0.25rem !important;
}

.pt-50 {
  padding-top: 0.5rem !important;
}

.pt-75 {
  padding-top: 0.75rem !important;
}

.pt-1 {
  padding-top: 1rem !important;
}

.pt-2 {
  padding-top: 1.5rem !important;
}

.pt-3 {
  padding-top: 3rem !important;
}

.pt-4 {
  padding-top: 3.5rem !important;
}

.pt-5 {
  padding-top: 4rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-25 {
  padding-right: 0.25rem !important;
}

.pe-50 {
  padding-right: 0.5rem !important;
}

.pe-75 {
  padding-right: 0.75rem !important;
}

.pe-1 {
  padding-right: 1rem !important;
}

.pe-2 {
  padding-right: 1.5rem !important;
}

.pe-3 {
  padding-right: 3rem !important;
}

.pe-4 {
  padding-right: 3.5rem !important;
}

.pe-5 {
  padding-right: 4rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-25 {
  padding-bottom: 0.25rem !important;
}

.pb-50 {
  padding-bottom: 0.5rem !important;
}

.pb-75 {
  padding-bottom: 0.75rem !important;
}

.pb-1 {
  padding-bottom: 1rem !important;
}

.pb-2 {
  padding-bottom: 1.5rem !important;
}

.pb-3 {
  padding-bottom: 3rem !important;
}

.pb-4 {
  padding-bottom: 3.5rem !important;
}

.pb-5 {
  padding-bottom: 4rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-25 {
  padding-left: 0.25rem !important;
}

.ps-50 {
  padding-left: 0.5rem !important;
}

.ps-75 {
  padding-left: 0.75rem !important;
}

.ps-1 {
  padding-left: 1rem !important;
}

.ps-2 {
  padding-left: 1.5rem !important;
}

.ps-3 {
  padding-left: 3rem !important;
}

.ps-4 {
  padding-left: 3.5rem !important;
}

.ps-5 {
  padding-left: 4rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-25 {
  gap: 0.25rem !important;
}

.gap-50 {
  gap: 0.5rem !important;
}

.gap-75 {
  gap: 0.75rem !important;
}

.gap-1 {
  gap: 1rem !important;
}

.gap-2 {
  gap: 1.5rem !important;
}

.gap-3 {
  gap: 3rem !important;
}

.gap-4 {
  gap: 3.5rem !important;
}

.gap-5 {
  gap: 4rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-25 {
  row-gap: 0.25rem !important;
}

.row-gap-50 {
  row-gap: 0.5rem !important;
}

.row-gap-75 {
  row-gap: 0.75rem !important;
}

.row-gap-1 {
  row-gap: 1rem !important;
}

.row-gap-2 {
  row-gap: 1.5rem !important;
}

.row-gap-3 {
  row-gap: 3rem !important;
}

.row-gap-4 {
  row-gap: 3.5rem !important;
}

.row-gap-5 {
  row-gap: 4rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-25 {
  column-gap: 0.25rem !important;
}

.column-gap-50 {
  column-gap: 0.5rem !important;
}

.column-gap-75 {
  column-gap: 0.75rem !important;
}

.column-gap-1 {
  column-gap: 1rem !important;
}

.column-gap-2 {
  column-gap: 1.5rem !important;
}

.column-gap-3 {
  column-gap: 3rem !important;
}

.column-gap-4 {
  column-gap: 3.5rem !important;
}

.column-gap-5 {
  column-gap: 4rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.325rem + 0.9vw) !important;
}

.fs-2 {
  font-size: calc(1.299rem + 0.588vw) !important;
}

.fs-3 {
  font-size: calc(1.276rem + 0.312vw) !important;
}

.fs-4 {
  font-size: calc(1.257rem + 0.084vw) !important;
}

.fs-5 {
  font-size: 1.14rem !important;
}

.fs-6 {
  font-size: 1rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1 !important;
}

.lh-base {
  line-height: 1.45 !important;
}

.lh-lg {
  line-height: 1.25 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(34, 41, 47, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-25 {
    margin: 0.25rem !important;
  }
  .m-sm-50 {
    margin: 0.5rem !important;
  }
  .m-sm-75 {
    margin: 0.75rem !important;
  }
  .m-sm-1 {
    margin: 1rem !important;
  }
  .m-sm-2 {
    margin: 1.5rem !important;
  }
  .m-sm-3 {
    margin: 3rem !important;
  }
  .m-sm-4 {
    margin: 3.5rem !important;
  }
  .m-sm-5 {
    margin: 4rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-25 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-50 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-75 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-sm-1 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-2 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-4 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-25 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-50 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-75 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-sm-1 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-2 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-3 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-4 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }
  .my-sm-5 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-25 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-50 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-75 {
    margin-top: 0.75rem !important;
  }
  .mt-sm-1 {
    margin-top: 1rem !important;
  }
  .mt-sm-2 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 3rem !important;
  }
  .mt-sm-4 {
    margin-top: 3.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 4rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-25 {
    margin-right: 0.25rem !important;
  }
  .me-sm-50 {
    margin-right: 0.5rem !important;
  }
  .me-sm-75 {
    margin-right: 0.75rem !important;
  }
  .me-sm-1 {
    margin-right: 1rem !important;
  }
  .me-sm-2 {
    margin-right: 1.5rem !important;
  }
  .me-sm-3 {
    margin-right: 3rem !important;
  }
  .me-sm-4 {
    margin-right: 3.5rem !important;
  }
  .me-sm-5 {
    margin-right: 4rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-25 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-50 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-75 {
    margin-bottom: 0.75rem !important;
  }
  .mb-sm-1 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 3.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 4rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-25 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-50 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-75 {
    margin-left: 0.75rem !important;
  }
  .ms-sm-1 {
    margin-left: 1rem !important;
  }
  .ms-sm-2 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 3rem !important;
  }
  .ms-sm-4 {
    margin-left: 3.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 4rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-25 {
    padding: 0.25rem !important;
  }
  .p-sm-50 {
    padding: 0.5rem !important;
  }
  .p-sm-75 {
    padding: 0.75rem !important;
  }
  .p-sm-1 {
    padding: 1rem !important;
  }
  .p-sm-2 {
    padding: 1.5rem !important;
  }
  .p-sm-3 {
    padding: 3rem !important;
  }
  .p-sm-4 {
    padding: 3.5rem !important;
  }
  .p-sm-5 {
    padding: 4rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-25 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-50 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-75 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-sm-1 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-2 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-3 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-sm-4 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }
  .px-sm-5 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-25 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-50 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-75 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-sm-1 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-2 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-3 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-sm-4 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }
  .py-sm-5 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-25 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-50 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-75 {
    padding-top: 0.75rem !important;
  }
  .pt-sm-1 {
    padding-top: 1rem !important;
  }
  .pt-sm-2 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 3rem !important;
  }
  .pt-sm-4 {
    padding-top: 3.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 4rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-25 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-50 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-75 {
    padding-right: 0.75rem !important;
  }
  .pe-sm-1 {
    padding-right: 1rem !important;
  }
  .pe-sm-2 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 3rem !important;
  }
  .pe-sm-4 {
    padding-right: 3.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 4rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-25 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-50 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-75 {
    padding-bottom: 0.75rem !important;
  }
  .pb-sm-1 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 3rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 3.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 4rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-25 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-50 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-75 {
    padding-left: 0.75rem !important;
  }
  .ps-sm-1 {
    padding-left: 1rem !important;
  }
  .ps-sm-2 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 3rem !important;
  }
  .ps-sm-4 {
    padding-left: 3.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 4rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-25 {
    gap: 0.25rem !important;
  }
  .gap-sm-50 {
    gap: 0.5rem !important;
  }
  .gap-sm-75 {
    gap: 0.75rem !important;
  }
  .gap-sm-1 {
    gap: 1rem !important;
  }
  .gap-sm-2 {
    gap: 1.5rem !important;
  }
  .gap-sm-3 {
    gap: 3rem !important;
  }
  .gap-sm-4 {
    gap: 3.5rem !important;
  }
  .gap-sm-5 {
    gap: 4rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-25 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-50 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-75 {
    row-gap: 0.75rem !important;
  }
  .row-gap-sm-1 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 3rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 3.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 4rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-25 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-50 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-75 {
    column-gap: 0.75rem !important;
  }
  .column-gap-sm-1 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 3rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 3.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 4rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-25 {
    margin: 0.25rem !important;
  }
  .m-md-50 {
    margin: 0.5rem !important;
  }
  .m-md-75 {
    margin: 0.75rem !important;
  }
  .m-md-1 {
    margin: 1rem !important;
  }
  .m-md-2 {
    margin: 1.5rem !important;
  }
  .m-md-3 {
    margin: 3rem !important;
  }
  .m-md-4 {
    margin: 3.5rem !important;
  }
  .m-md-5 {
    margin: 4rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-25 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-50 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-75 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-md-1 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-2 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-3 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-4 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }
  .mx-md-5 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-25 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-50 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-75 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-md-1 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-2 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-3 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-4 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }
  .my-md-5 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-25 {
    margin-top: 0.25rem !important;
  }
  .mt-md-50 {
    margin-top: 0.5rem !important;
  }
  .mt-md-75 {
    margin-top: 0.75rem !important;
  }
  .mt-md-1 {
    margin-top: 1rem !important;
  }
  .mt-md-2 {
    margin-top: 1.5rem !important;
  }
  .mt-md-3 {
    margin-top: 3rem !important;
  }
  .mt-md-4 {
    margin-top: 3.5rem !important;
  }
  .mt-md-5 {
    margin-top: 4rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-25 {
    margin-right: 0.25rem !important;
  }
  .me-md-50 {
    margin-right: 0.5rem !important;
  }
  .me-md-75 {
    margin-right: 0.75rem !important;
  }
  .me-md-1 {
    margin-right: 1rem !important;
  }
  .me-md-2 {
    margin-right: 1.5rem !important;
  }
  .me-md-3 {
    margin-right: 3rem !important;
  }
  .me-md-4 {
    margin-right: 3.5rem !important;
  }
  .me-md-5 {
    margin-right: 4rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-25 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-50 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-75 {
    margin-bottom: 0.75rem !important;
  }
  .mb-md-1 {
    margin-bottom: 1rem !important;
  }
  .mb-md-2 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 3rem !important;
  }
  .mb-md-4 {
    margin-bottom: 3.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 4rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-25 {
    margin-left: 0.25rem !important;
  }
  .ms-md-50 {
    margin-left: 0.5rem !important;
  }
  .ms-md-75 {
    margin-left: 0.75rem !important;
  }
  .ms-md-1 {
    margin-left: 1rem !important;
  }
  .ms-md-2 {
    margin-left: 1.5rem !important;
  }
  .ms-md-3 {
    margin-left: 3rem !important;
  }
  .ms-md-4 {
    margin-left: 3.5rem !important;
  }
  .ms-md-5 {
    margin-left: 4rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-25 {
    padding: 0.25rem !important;
  }
  .p-md-50 {
    padding: 0.5rem !important;
  }
  .p-md-75 {
    padding: 0.75rem !important;
  }
  .p-md-1 {
    padding: 1rem !important;
  }
  .p-md-2 {
    padding: 1.5rem !important;
  }
  .p-md-3 {
    padding: 3rem !important;
  }
  .p-md-4 {
    padding: 3.5rem !important;
  }
  .p-md-5 {
    padding: 4rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-25 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-50 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-75 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-md-1 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-2 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-3 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-md-4 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }
  .px-md-5 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-25 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-50 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-75 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-md-1 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-2 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-3 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-md-4 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }
  .py-md-5 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-25 {
    padding-top: 0.25rem !important;
  }
  .pt-md-50 {
    padding-top: 0.5rem !important;
  }
  .pt-md-75 {
    padding-top: 0.75rem !important;
  }
  .pt-md-1 {
    padding-top: 1rem !important;
  }
  .pt-md-2 {
    padding-top: 1.5rem !important;
  }
  .pt-md-3 {
    padding-top: 3rem !important;
  }
  .pt-md-4 {
    padding-top: 3.5rem !important;
  }
  .pt-md-5 {
    padding-top: 4rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-25 {
    padding-right: 0.25rem !important;
  }
  .pe-md-50 {
    padding-right: 0.5rem !important;
  }
  .pe-md-75 {
    padding-right: 0.75rem !important;
  }
  .pe-md-1 {
    padding-right: 1rem !important;
  }
  .pe-md-2 {
    padding-right: 1.5rem !important;
  }
  .pe-md-3 {
    padding-right: 3rem !important;
  }
  .pe-md-4 {
    padding-right: 3.5rem !important;
  }
  .pe-md-5 {
    padding-right: 4rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-25 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-50 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-75 {
    padding-bottom: 0.75rem !important;
  }
  .pb-md-1 {
    padding-bottom: 1rem !important;
  }
  .pb-md-2 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 3rem !important;
  }
  .pb-md-4 {
    padding-bottom: 3.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 4rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-25 {
    padding-left: 0.25rem !important;
  }
  .ps-md-50 {
    padding-left: 0.5rem !important;
  }
  .ps-md-75 {
    padding-left: 0.75rem !important;
  }
  .ps-md-1 {
    padding-left: 1rem !important;
  }
  .ps-md-2 {
    padding-left: 1.5rem !important;
  }
  .ps-md-3 {
    padding-left: 3rem !important;
  }
  .ps-md-4 {
    padding-left: 3.5rem !important;
  }
  .ps-md-5 {
    padding-left: 4rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-25 {
    gap: 0.25rem !important;
  }
  .gap-md-50 {
    gap: 0.5rem !important;
  }
  .gap-md-75 {
    gap: 0.75rem !important;
  }
  .gap-md-1 {
    gap: 1rem !important;
  }
  .gap-md-2 {
    gap: 1.5rem !important;
  }
  .gap-md-3 {
    gap: 3rem !important;
  }
  .gap-md-4 {
    gap: 3.5rem !important;
  }
  .gap-md-5 {
    gap: 4rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-25 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-50 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-75 {
    row-gap: 0.75rem !important;
  }
  .row-gap-md-1 {
    row-gap: 1rem !important;
  }
  .row-gap-md-2 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 3rem !important;
  }
  .row-gap-md-4 {
    row-gap: 3.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 4rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-25 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-50 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-75 {
    column-gap: 0.75rem !important;
  }
  .column-gap-md-1 {
    column-gap: 1rem !important;
  }
  .column-gap-md-2 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 3rem !important;
  }
  .column-gap-md-4 {
    column-gap: 3.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 4rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-25 {
    margin: 0.25rem !important;
  }
  .m-lg-50 {
    margin: 0.5rem !important;
  }
  .m-lg-75 {
    margin: 0.75rem !important;
  }
  .m-lg-1 {
    margin: 1rem !important;
  }
  .m-lg-2 {
    margin: 1.5rem !important;
  }
  .m-lg-3 {
    margin: 3rem !important;
  }
  .m-lg-4 {
    margin: 3.5rem !important;
  }
  .m-lg-5 {
    margin: 4rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-25 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-50 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-75 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-lg-1 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-2 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-4 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-25 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-50 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-75 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-lg-1 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-2 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-3 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-4 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }
  .my-lg-5 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-25 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-50 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-75 {
    margin-top: 0.75rem !important;
  }
  .mt-lg-1 {
    margin-top: 1rem !important;
  }
  .mt-lg-2 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 3rem !important;
  }
  .mt-lg-4 {
    margin-top: 3.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 4rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-25 {
    margin-right: 0.25rem !important;
  }
  .me-lg-50 {
    margin-right: 0.5rem !important;
  }
  .me-lg-75 {
    margin-right: 0.75rem !important;
  }
  .me-lg-1 {
    margin-right: 1rem !important;
  }
  .me-lg-2 {
    margin-right: 1.5rem !important;
  }
  .me-lg-3 {
    margin-right: 3rem !important;
  }
  .me-lg-4 {
    margin-right: 3.5rem !important;
  }
  .me-lg-5 {
    margin-right: 4rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-25 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-50 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-75 {
    margin-bottom: 0.75rem !important;
  }
  .mb-lg-1 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 3.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 4rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-25 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-50 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-75 {
    margin-left: 0.75rem !important;
  }
  .ms-lg-1 {
    margin-left: 1rem !important;
  }
  .ms-lg-2 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 3rem !important;
  }
  .ms-lg-4 {
    margin-left: 3.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 4rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-25 {
    padding: 0.25rem !important;
  }
  .p-lg-50 {
    padding: 0.5rem !important;
  }
  .p-lg-75 {
    padding: 0.75rem !important;
  }
  .p-lg-1 {
    padding: 1rem !important;
  }
  .p-lg-2 {
    padding: 1.5rem !important;
  }
  .p-lg-3 {
    padding: 3rem !important;
  }
  .p-lg-4 {
    padding: 3.5rem !important;
  }
  .p-lg-5 {
    padding: 4rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-25 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-50 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-75 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-lg-1 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-2 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-3 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-lg-4 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }
  .px-lg-5 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-25 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-50 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-75 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-lg-1 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-2 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-3 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-lg-4 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }
  .py-lg-5 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-25 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-50 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-75 {
    padding-top: 0.75rem !important;
  }
  .pt-lg-1 {
    padding-top: 1rem !important;
  }
  .pt-lg-2 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 3rem !important;
  }
  .pt-lg-4 {
    padding-top: 3.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 4rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-25 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-50 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-75 {
    padding-right: 0.75rem !important;
  }
  .pe-lg-1 {
    padding-right: 1rem !important;
  }
  .pe-lg-2 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 3rem !important;
  }
  .pe-lg-4 {
    padding-right: 3.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 4rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-25 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-50 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-75 {
    padding-bottom: 0.75rem !important;
  }
  .pb-lg-1 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 3rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 3.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 4rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-25 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-50 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-75 {
    padding-left: 0.75rem !important;
  }
  .ps-lg-1 {
    padding-left: 1rem !important;
  }
  .ps-lg-2 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 3rem !important;
  }
  .ps-lg-4 {
    padding-left: 3.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 4rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-25 {
    gap: 0.25rem !important;
  }
  .gap-lg-50 {
    gap: 0.5rem !important;
  }
  .gap-lg-75 {
    gap: 0.75rem !important;
  }
  .gap-lg-1 {
    gap: 1rem !important;
  }
  .gap-lg-2 {
    gap: 1.5rem !important;
  }
  .gap-lg-3 {
    gap: 3rem !important;
  }
  .gap-lg-4 {
    gap: 3.5rem !important;
  }
  .gap-lg-5 {
    gap: 4rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-25 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-50 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-75 {
    row-gap: 0.75rem !important;
  }
  .row-gap-lg-1 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 3rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 3.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 4rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-25 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-50 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-75 {
    column-gap: 0.75rem !important;
  }
  .column-gap-lg-1 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 3rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 3.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 4rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-25 {
    margin: 0.25rem !important;
  }
  .m-xl-50 {
    margin: 0.5rem !important;
  }
  .m-xl-75 {
    margin: 0.75rem !important;
  }
  .m-xl-1 {
    margin: 1rem !important;
  }
  .m-xl-2 {
    margin: 1.5rem !important;
  }
  .m-xl-3 {
    margin: 3rem !important;
  }
  .m-xl-4 {
    margin: 3.5rem !important;
  }
  .m-xl-5 {
    margin: 4rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-25 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-50 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-75 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-xl-1 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-2 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-4 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-25 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-50 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-75 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-xl-1 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-2 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-3 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-4 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }
  .my-xl-5 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-25 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-50 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-75 {
    margin-top: 0.75rem !important;
  }
  .mt-xl-1 {
    margin-top: 1rem !important;
  }
  .mt-xl-2 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 3rem !important;
  }
  .mt-xl-4 {
    margin-top: 3.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 4rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-25 {
    margin-right: 0.25rem !important;
  }
  .me-xl-50 {
    margin-right: 0.5rem !important;
  }
  .me-xl-75 {
    margin-right: 0.75rem !important;
  }
  .me-xl-1 {
    margin-right: 1rem !important;
  }
  .me-xl-2 {
    margin-right: 1.5rem !important;
  }
  .me-xl-3 {
    margin-right: 3rem !important;
  }
  .me-xl-4 {
    margin-right: 3.5rem !important;
  }
  .me-xl-5 {
    margin-right: 4rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-25 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-50 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-75 {
    margin-bottom: 0.75rem !important;
  }
  .mb-xl-1 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 3.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 4rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-25 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-50 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-75 {
    margin-left: 0.75rem !important;
  }
  .ms-xl-1 {
    margin-left: 1rem !important;
  }
  .ms-xl-2 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 3rem !important;
  }
  .ms-xl-4 {
    margin-left: 3.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 4rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-25 {
    padding: 0.25rem !important;
  }
  .p-xl-50 {
    padding: 0.5rem !important;
  }
  .p-xl-75 {
    padding: 0.75rem !important;
  }
  .p-xl-1 {
    padding: 1rem !important;
  }
  .p-xl-2 {
    padding: 1.5rem !important;
  }
  .p-xl-3 {
    padding: 3rem !important;
  }
  .p-xl-4 {
    padding: 3.5rem !important;
  }
  .p-xl-5 {
    padding: 4rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-25 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-50 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-75 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-xl-1 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-2 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-3 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-xl-4 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }
  .px-xl-5 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-25 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-50 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-75 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-xl-1 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-2 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-3 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-xl-4 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }
  .py-xl-5 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-25 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-50 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-75 {
    padding-top: 0.75rem !important;
  }
  .pt-xl-1 {
    padding-top: 1rem !important;
  }
  .pt-xl-2 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 3rem !important;
  }
  .pt-xl-4 {
    padding-top: 3.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 4rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-25 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-50 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-75 {
    padding-right: 0.75rem !important;
  }
  .pe-xl-1 {
    padding-right: 1rem !important;
  }
  .pe-xl-2 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 3rem !important;
  }
  .pe-xl-4 {
    padding-right: 3.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 4rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-25 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-50 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-75 {
    padding-bottom: 0.75rem !important;
  }
  .pb-xl-1 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 3rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 3.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 4rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-25 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-50 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-75 {
    padding-left: 0.75rem !important;
  }
  .ps-xl-1 {
    padding-left: 1rem !important;
  }
  .ps-xl-2 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 3rem !important;
  }
  .ps-xl-4 {
    padding-left: 3.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 4rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-25 {
    gap: 0.25rem !important;
  }
  .gap-xl-50 {
    gap: 0.5rem !important;
  }
  .gap-xl-75 {
    gap: 0.75rem !important;
  }
  .gap-xl-1 {
    gap: 1rem !important;
  }
  .gap-xl-2 {
    gap: 1.5rem !important;
  }
  .gap-xl-3 {
    gap: 3rem !important;
  }
  .gap-xl-4 {
    gap: 3.5rem !important;
  }
  .gap-xl-5 {
    gap: 4rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-25 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-50 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-75 {
    row-gap: 0.75rem !important;
  }
  .row-gap-xl-1 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 3rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 3.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 4rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-25 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-50 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-75 {
    column-gap: 0.75rem !important;
  }
  .column-gap-xl-1 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 3rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 3.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 4rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-25 {
    margin: 0.25rem !important;
  }
  .m-xxl-50 {
    margin: 0.5rem !important;
  }
  .m-xxl-75 {
    margin: 0.75rem !important;
  }
  .m-xxl-1 {
    margin: 1rem !important;
  }
  .m-xxl-2 {
    margin: 1.5rem !important;
  }
  .m-xxl-3 {
    margin: 3rem !important;
  }
  .m-xxl-4 {
    margin: 3.5rem !important;
  }
  .m-xxl-5 {
    margin: 4rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-25 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-50 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-75 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-xxl-1 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-2 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-4 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-25 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-50 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-75 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-xxl-1 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-2 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-4 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-25 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-50 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-75 {
    margin-top: 0.75rem !important;
  }
  .mt-xxl-1 {
    margin-top: 1rem !important;
  }
  .mt-xxl-2 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 3rem !important;
  }
  .mt-xxl-4 {
    margin-top: 3.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 4rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-25 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-50 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-75 {
    margin-right: 0.75rem !important;
  }
  .me-xxl-1 {
    margin-right: 1rem !important;
  }
  .me-xxl-2 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 3rem !important;
  }
  .me-xxl-4 {
    margin-right: 3.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 4rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-25 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-50 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-75 {
    margin-bottom: 0.75rem !important;
  }
  .mb-xxl-1 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 3.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 4rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-25 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-50 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-75 {
    margin-left: 0.75rem !important;
  }
  .ms-xxl-1 {
    margin-left: 1rem !important;
  }
  .ms-xxl-2 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 3rem !important;
  }
  .ms-xxl-4 {
    margin-left: 3.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 4rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-25 {
    padding: 0.25rem !important;
  }
  .p-xxl-50 {
    padding: 0.5rem !important;
  }
  .p-xxl-75 {
    padding: 0.75rem !important;
  }
  .p-xxl-1 {
    padding: 1rem !important;
  }
  .p-xxl-2 {
    padding: 1.5rem !important;
  }
  .p-xxl-3 {
    padding: 3rem !important;
  }
  .p-xxl-4 {
    padding: 3.5rem !important;
  }
  .p-xxl-5 {
    padding: 4rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-25 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-50 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-75 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-xxl-1 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-2 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-xxl-4 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-25 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-50 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-75 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-xxl-1 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-2 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-xxl-4 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-25 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-50 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-75 {
    padding-top: 0.75rem !important;
  }
  .pt-xxl-1 {
    padding-top: 1rem !important;
  }
  .pt-xxl-2 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 3rem !important;
  }
  .pt-xxl-4 {
    padding-top: 3.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 4rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-25 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-50 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-75 {
    padding-right: 0.75rem !important;
  }
  .pe-xxl-1 {
    padding-right: 1rem !important;
  }
  .pe-xxl-2 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 3rem !important;
  }
  .pe-xxl-4 {
    padding-right: 3.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 4rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-25 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-50 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-75 {
    padding-bottom: 0.75rem !important;
  }
  .pb-xxl-1 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 3rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 3.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 4rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-25 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-50 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-75 {
    padding-left: 0.75rem !important;
  }
  .ps-xxl-1 {
    padding-left: 1rem !important;
  }
  .ps-xxl-2 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 3rem !important;
  }
  .ps-xxl-4 {
    padding-left: 3.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 4rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-25 {
    gap: 0.25rem !important;
  }
  .gap-xxl-50 {
    gap: 0.5rem !important;
  }
  .gap-xxl-75 {
    gap: 0.75rem !important;
  }
  .gap-xxl-1 {
    gap: 1rem !important;
  }
  .gap-xxl-2 {
    gap: 1.5rem !important;
  }
  .gap-xxl-3 {
    gap: 3rem !important;
  }
  .gap-xxl-4 {
    gap: 3.5rem !important;
  }
  .gap-xxl-5 {
    gap: 4rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-25 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-50 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-75 {
    row-gap: 0.75rem !important;
  }
  .row-gap-xxl-1 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 3rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 3.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 4rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-25 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-50 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-75 {
    column-gap: 0.75rem !important;
  }
  .column-gap-xxl-1 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 3rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 3.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 4rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2rem !important;
  }
  .fs-2 {
    font-size: 1.74rem !important;
  }
  .fs-3 {
    font-size: 1.51rem !important;
  }
  .fs-4 {
    font-size: 1.32rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
/*========================================================
        DARK LAYOUT
=========================================================*/
html {
  font-size: 14px;
  height: 100%;
  letter-spacing: 0.01rem;
}
html body {
  height: 100%;
  background-color: #f8f8f8;
  direction: ltr;
  /*
      * Blank page
      */
}
html body .content {
  padding: 0;
  position: relative;
  transition: 300ms ease all;
  backface-visibility: hidden;
  min-height: calc(100% - 4rem);
  margin-left: 260px;
}
html body .content.app-content {
  overflow: hidden;
}
html body .content.app-content.show-overlay .content-overlay {
  z-index: 10;
  opacity: 1;
}
html body .content.app-content.show-overlay .content-overlay ~ .header-navbar-shadow {
  background: linear-gradient(180deg, rgba(44, 48, 60, 0.9) 44%, rgba(44, 48, 60, 0.43) 73%, rgba(44, 48, 60, 0));
}
html body .content.app-content .content-overlay {
  position: fixed;
  opacity: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  cursor: pointer;
  transition: all 0.7s;
  z-index: -1;
}
html body .content.app-content .content-overlay.show {
  z-index: 12;
}
html body .content.app-content .content-area-wrapper {
  height: calc(100% - 5rem);
  margin: calc(5rem + 2.7rem) 2.2rem 0;
  display: flex;
  position: relative;
}
html body .content.app-content .content-area-wrapper .content-wrapper {
  margin-top: 0;
  height: calc(100vh - 13rem);
}
html body .content .content-wrapper {
  padding: calc(2.2rem - 0.4rem) 2.2rem 0;
  margin-top: 6rem;
  min-height: calc(100vh - 9.75rem);
}
html body .content .content-wrapper .content-header-title {
  font-weight: 500;
  color: #636363;
  margin-right: 1rem;
}
html body .content .content-wrapper .content-header-right .dropdown-toggle::after {
  display: none;
}
html body .content .content-wrapper .content-header-right .btn-icon {
  padding: 0.8rem;
}
html body .vertical-layout.navbar-hidden .app-content .header-navbar-shadow {
  display: none;
}
html body .vertical-layout.navbar-hidden .app-content .content-wrapper {
  padding: 2.2rem;
  margin-top: 0;
  min-height: calc(100vh - 4rem);
}
html body .vertical-layout.navbar-hidden .app-content .content-area-wrapper {
  padding: 0;
  margin-top: 2.5rem;
}
html body .vertical-layout.navbar-static .app-content .header-navbar-shadow {
  display: none;
}
html body .vertical-layout.navbar-static .app-content .navbar-container {
  padding-left: 2.2rem;
  padding-right: 1.2rem;
}
html body .vertical-layout.navbar-static .app-content .content-wrapper {
  padding: 2.2rem;
  margin-top: 0;
  padding-top: 1rem;
}
html body .vertical-layout.navbar-static .app-content .content-area-wrapper {
  margin-top: 1rem;
}
html body .vertical-layout.menu-collapsed .header-navbar.fixed-top {
  left: 60px;
  width: auto;
}
html body .vertical-layout.navbar-sticky .app-content .header-navbar-shadow {
  display: none;
}
html body .vertical-layout.navbar-sticky .app-content .navbar-container {
  padding-left: 2.2rem;
  padding-right: 1rem;
}
html body .vertical-layout.navbar-sticky .app-content .content-wrapper {
  padding: 2.2rem;
  margin-top: 4.65rem;
}
html body .vertical-layout.navbar-static .navbar-container,
html body .vertical-layout.navbar-sticky .navbar-container {
  padding-left: 2.2rem;
  padding-right: 1rem;
}
html body .vertical-layout.fixed-footer .app-content,
html body .horizontal-layout.fixed-footer .app-content {
  margin-bottom: 3rem;
}
html body .vertical-layout.fixed-footer .footer,
html body .horizontal-layout.fixed-footer .footer {
  position: fixed;
  z-index: 1030;
  right: 0;
  left: 0;
  bottom: 0;
  background: #fff;
  box-shadow: 0 -1px 4px 0 rgba(0, 0, 0, 0.15);
}
html body .vertical-layout .menu-swipe-area {
  width: 30px;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1032;
  height: 100vh;
}
html body p {
  line-height: 1.5rem;
}
html body .bg-full-screen-image {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) no-repeat center center;
  background-size: cover;
}
html body .blank-page .content {
  margin-left: 0;
}
html body .blank-page .content.app-content {
  overflow: overlay;
  overflow-x: hidden;
}
html body .blank-page .content-wrapper {
  padding: 0 !important;
  margin-top: 0;
}
html body .blank-page .content-wrapper .flexbox-container {
  display: flex;
  align-items: center;
  height: 100vh;
  justify-content: center;
  overflow: hidden;
}
html body[data-col="1-column"] .content,
html body[data-col="1-column"] .footer {
  margin-left: 0px !important;
}
html .pace .pace-progress {
  background: #7367f0;
}

.app-content.center-layout {
  overflow: hidden;
}

/*
* Col 3 layout for detached and general type
*/
@media (min-width: 992px) {
  body .content-right {
    width: calc(100% - 260px);
    float: right;
  }
  body .content-left {
    width: calc(100% - 260px);
    float: left;
  }
  body .content-detached {
    width: 100%;
  }
  body .content-detached.content-right {
    float: right;
    margin-left: -260px;
  }
  body .content-detached.content-right .content-body {
    margin-left: calc(260px + 2.2rem);
  }
  body .content-detached.content-left {
    float: left;
    margin-right: -260px;
  }
  body .content-detached.content-left .content-body {
    margin-right: calc(260px + 2.2rem);
  }
  .sidebar-right.sidebar-sticky {
    float: right !important;
    margin-left: -260px;
    width: 260px !important;
    margin-top: 6rem;
  }
  [data-col=content-left-sidebar] .sticky-wrapper {
    float: left;
  }
}
.truncate {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

html body .content .content-wrapper {
  padding: calc(2.2rem - 0.4rem) calc(2.2rem - 1rem) 0;
}

body.navbar-static .app-content .header-navbar .navbar-container, body.navbar-sticky .app-content .header-navbar .navbar-container {
  padding-left: 1rem;
  padding-right: 0.5rem;
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  html.full-screen {
    width: 100%;
  }
  html.full-screen .content.app-content {
    height: 100%;
    overflow: scroll;
    overflow-x: hidden;
  }
}
.vertical-layout .main-menu .navigation .menu-content li a svg:first-child {
  margin-right: 1.38rem !important;
}
.vertical-layout .main-menu .navigation .menu-content li a .menu-toggle-icon {
  right: 9px;
}
.vertical-layout.menu-collapsed .main-menu.collapsed {
  width: 80px;
  transition: 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.vertical-layout.menu-collapsed .main-menu.collapsed .badge,
.vertical-layout.menu-collapsed .main-menu.collapsed svg.menu-toggle-icon,
.vertical-layout.menu-collapsed .main-menu.collapsed .brand-text,
.vertical-layout.menu-collapsed .main-menu.collapsed .navigation-header,
.vertical-layout.menu-collapsed .main-menu.collapsed ul.menu-content {
  display: none;
}
.vertical-layout.menu-collapsed .app-content {
  margin-left: 80px;
}
.vertical-layout.menu-collapsed .app-content .header-navbar {
  width: calc(100% - 4.4rem - 80px);
}
.vertical-layout.menu-collapsed .footer {
  margin-left: 80px;
}

@media (max-width: 1200px) {
  .vertical-layout .app-content {
    margin-left: 0;
  }
  .vertical-layout .app-content .header-navbar.floating-nav {
    width: calc(100% - 4.4rem) !important;
  }
  .vertical-layout .footer {
    margin-left: 0;
  }
  .vertical-layout .main-menu:not(.hide-sidebar) ~ .sidenav-overlay {
    display: block;
  }
}
@media (max-width: 576px) {
  .vertical-layout .app-content .header-navbar.floating-nav {
    width: calc(100% - 2.4rem) !important;
  }
}
/*=========================================================================================
    File Name: sidebar.scss
    Description: content sidebar specific scss.
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy React admin Template
    Version: 1.0
    Author: PIXINVENT
    Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
.sidebar {
  position: relative;
  width: 100%;
}
@media (min-width: 992px) {
  .sidebar {
    vertical-align: top;
  }
}

.sidebar-fixed {
  position: fixed;
  height: 100%;
  overflow: scroll;
}

.sidenav-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 120vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 997;
  display: none;
}

.drag-target {
  height: 100%;
  width: 40px;
  position: fixed;
  top: 0;
  left: -10px;
  z-index: 1036;
}

@media (min-width: 992px) {
  .sidebar-left {
    float: left;
  }
  .sidebar-right {
    float: right;
  }
}
footer.footer {
  padding: 1rem 2.2rem;
}
footer.footer a {
  margin: 0 0.3rem;
}
footer.footer span svg {
  margin-left: 0.5rem;
}
footer.footer .scroll-top {
  padding: 0.81rem 0.83rem;
}
footer.navbar-shadow {
  box-shadow: 0px -1px 4px 0px rgba(0, 0, 0, 0.15);
}
footer.navbar-border {
  border-top: 1px solid #e4e7ed;
}

.fixed-footer.footer-light {
  background: #fff;
  box-shadow: 0px -1px 4px 0px rgba(0, 0, 0, 0.15);
}
.fixed-footer.footer-dark {
  background: #b8c2cc;
  color: #fff;
}

.scroll-top {
  position: fixed;
  bottom: 5%;
  right: 30px;
  z-index: 99;
}

@media (min-width: 992px) {
  .footer {
    margin-left: 260px;
  }
}
/*=========================================================================================
    File Name: navigations.scss
    Description: Common mixin for menus, contain dark and light version scss.
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy React  admin Template
    Version: 1.0
    Author: PIXINVENT
    Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
.main-menu {
  z-index: 1031;
  position: absolute;
  display: table-cell;
  height: 100%;
  overflow: hidden;
  width: 260px;
  transition: width 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.main-menu.menu-light {
  color: #626262;
  background: #fff;
}
.main-menu.menu-light .main-menu-header {
  padding: 20px;
}
.main-menu.menu-light .main-menu-header .menu-search {
  background: rgb(229.5, 229.5, 229.5);
  padding: 0.5rem 1rem;
  color: rgb(72.5, 72.5, 72.5);
}
.main-menu.menu-light .main-menu-header .menu-search:focus {
  border-color: rgb(216.75, 216.75, 216.75);
}
.main-menu.menu-light .navigation {
  background: #fff;
}
.main-menu.menu-light .navigation .navigation-header {
  color: rgb(152.825, 152.825, 152.825);
  margin: calc(2.2rem - 0.2rem) 0 0.8rem 2.2rem;
  padding: 0;
  line-height: 1.5;
  letter-spacing: 0.01rem;
}
.main-menu.menu-light .navigation .navigation-header span {
  font-weight: 500;
}
.main-menu.menu-light .navigation li .menu-text {
  width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.main-menu.menu-light .navigation li .menu-text:last-child {
  width: 180px;
}
.main-menu.menu-light .navigation li.has-sub ul.menu-content {
  padding: 7px;
  margin: -7px -7px 0 -7px;
  transition: height 0.25s ease;
}
.main-menu.menu-light .navigation li a {
  color: rgb(85.505, 85.505, 85.505);
  padding: 10px 15px;
  line-height: 1.45;
  transition: padding 0.35s ease 0s !important;
}
.main-menu.menu-light .navigation li a span.menu-sub-title {
  color: rgb(174.5, 174.5, 174.5);
}
.main-menu.menu-light .navigation li a .badge {
  box-shadow: 0 0 7px 3px rgba(0, 0, 0, 0.1);
}
.main-menu.menu-light .navigation li.hover > a {
  padding-left: 25px;
  transition: padding 0.35s ease 0s !important;
}
.main-menu.menu-light .navigation > li {
  padding: 0 15px;
}
.main-menu.menu-light .navigation > li > a .label {
  margin-top: 4px;
  margin-right: 5px;
}
.main-menu.menu-light .navigation > li > a i {
  position: relative;
  top: 1px;
}
.main-menu.menu-light .navigation > li.open > a, .main-menu.menu-light .navigation > li.sidebar-group-active > a,
.main-menu.menu-light .navigation > li ul.menu-content .sidebar-group-active > a,
.main-menu.menu-light .navigation > li ul.menu-content .open > a {
  color: rgb(72.5, 72.5, 72.5);
  background: rgb(244.8, 244.8, 244.8);
  transition: transform 0.25s ease 0s;
  border-radius: 6px;
  margin-bottom: 7px;
}
.main-menu.menu-light .navigation > li.open.open > a svg.menu-toggle-icon, .main-menu.menu-light .navigation > li.sidebar-group-active.open > a svg.menu-toggle-icon,
.main-menu.menu-light .navigation > li ul.menu-content .sidebar-group-active.open > a svg.menu-toggle-icon,
.main-menu.menu-light .navigation > li ul.menu-content .open.open > a svg.menu-toggle-icon {
  transform: rotate(90deg);
}
.main-menu.menu-light .navigation > li:not(.open) > ul {
  display: none;
}
.main-menu.menu-light .navigation > li.active > a {
  color: #fff;
  font-weight: 400;
  border-radius: 4px;
}
.main-menu.menu-light .navigation > li .active {
  background: rgb(239.7, 239.7, 239.7);
}
.main-menu.menu-light .navigation > li .active > a {
  color: #7367f0;
  margin-bottom: 0;
}
.main-menu.menu-light .navigation > li .active .hover > a {
  background: rgb(244.8, 244.8, 244.8);
}
.main-menu.menu-light .navigation > li ul {
  padding: 0;
  margin: 0;
}
.main-menu.menu-light .navigation > li ul li {
  color: #626262;
  background: transparent;
}
.main-menu.menu-light .navigation > li ul li > a {
  padding: 10px 15px 10px 20px;
}
.main-menu.menu-light .navigation > li ul .has-sub:not(.open) > ul {
  display: none;
}
.main-menu.menu-light .navigation > li ul .open > a,
.main-menu.menu-light .navigation > li ul .sidebar-group-active > a {
  color: #626262;
}
.main-menu.menu-light .navigation > li ul .open > ul,
.main-menu.menu-light .navigation > li ul .sidebar-group-active > ul {
  display: block;
}
.main-menu.menu-light .navigation > li ul .open > ul .open > ul,
.main-menu.menu-light .navigation > li ul .sidebar-group-active > ul .open > ul {
  display: block;
}
.main-menu.menu-light .navigation > li ul .hover > a, .main-menu.menu-light .navigation > li ul:hover > a {
  color: rgb(108.2, 108.2, 108.2);
}
.main-menu.menu-light .navigation > li ul .active {
  background: linear-gradient(118deg, #7367f0, rgba(115, 103, 240, 0.7));
  box-shadow: 0 0 10px 1px rgba(115, 103, 240, 0.7);
  border-radius: 4px;
}
.main-menu.menu-light .navigation > li ul .active > a {
  color: #fff;
}
.main-menu.menu-light .navigation > li > ul {
  background: #fff;
}
.main-menu.menu-light ul.menu-popout {
  background: #fff;
}
.main-menu.menu-light ul.menu-popout li a {
  color: #626262;
}
.main-menu.menu-light ul.menu-popout li a span.menu-sub-title {
  color: rgb(174.5, 174.5, 174.5);
}
.main-menu.menu-light ul.menu-popout li.hover > a, .main-menu.menu-light ul.menu-popout li:hover > a, .main-menu.menu-light ul.menu-popout li.open > a {
  background: rgb(239.7, 239.7, 239.7);
}
.main-menu.menu-light ul.menu-popout .has-sub:not(.open) > ul {
  display: none;
}
.main-menu.menu-light ul.menu-popout .open > a {
  color: #626262;
}
.main-menu.menu-light ul.menu-popout .open > ul {
  display: block;
}
.main-menu.menu-light ul.menu-popout .open > ul .open {
  background: rgb(232.05, 232.05, 232.05);
}
.main-menu.menu-light ul.menu-popout .open > ul .open > ul {
  display: block;
  background: rgb(232.05, 232.05, 232.05);
}
.main-menu.menu-light ul.menu-popout .hover > a, .main-menu.menu-light ul.menu-popout:hover > a {
  color: rgb(108.2, 108.2, 108.2);
  background-color: rgb(244.8, 244.8, 244.8);
}
.main-menu.menu-light ul.menu-popout .active {
  background: rgba(0, 0, 0, 0.06);
}
.main-menu.menu-light ul.menu-popout .active > a {
  color: rgb(123.5, 123.5, 123.5);
  background-color: rgb(244.8, 244.8, 244.8);
}
.main-menu.menu-light ul.menu-popout .active .hover > a,
.main-menu.menu-light ul.menu-popout .active :hover > a {
  background-color: transparent;
}
.main-menu.menu-dark {
  color: #dcdcdc;
  background: #10163a;
}
.main-menu.menu-dark .main-menu-header {
  padding: 20px;
}
.main-menu.menu-dark .main-menu-header .menu-search {
  background: rgb(4.972972973, 6.8378378378, 18.027027027);
  padding: 0.5rem 1rem;
  color: rgb(194.5, 194.5, 194.5);
}
.main-menu.menu-dark .main-menu-header .menu-search:focus {
  border-color: black;
}
.main-menu.menu-dark .navigation {
  background: #10163a;
}
.main-menu.menu-dark .navigation .navigation-header {
  color: white;
  margin: calc(2.2rem - 0.2rem) 0 0.8rem 2.2rem;
  padding: 0;
  line-height: 1.5;
  letter-spacing: 0.01rem;
}
.main-menu.menu-dark .navigation .navigation-header span {
  font-weight: 500;
}
.main-menu.menu-dark .navigation li .menu-text {
  width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.main-menu.menu-dark .navigation li .menu-text:last-child {
  width: 180px;
}
.main-menu.menu-dark .navigation li.has-sub ul.menu-content {
  padding: 7px;
  margin: -7px -7px 0 -7px;
  transition: height 0.25s ease;
}
.main-menu.menu-dark .navigation li a {
  color: rgb(207.505, 207.505, 207.505);
  padding: 10px 15px;
  line-height: 1.45;
  transition: padding 0.35s ease 0s !important;
}
.main-menu.menu-dark .navigation li a span.menu-sub-title {
  color: white;
}
.main-menu.menu-dark .navigation li a .badge {
  box-shadow: 0 0 7px 3px rgba(0, 0, 0, 0.1);
}
.main-menu.menu-dark .navigation li.hover > a {
  padding-left: 25px;
  transition: padding 0.35s ease 0s !important;
}
.main-menu.menu-dark .navigation > li {
  padding: 0 15px;
}
.main-menu.menu-dark .navigation > li > a .label {
  margin-top: 4px;
  margin-right: 5px;
}
.main-menu.menu-dark .navigation > li > a i {
  position: relative;
  top: 1px;
}
.main-menu.menu-dark .navigation > li.open > a, .main-menu.menu-dark .navigation > li.sidebar-group-active > a,
.main-menu.menu-dark .navigation > li ul.menu-content .sidebar-group-active > a,
.main-menu.menu-dark .navigation > li ul.menu-content .open > a {
  color: rgb(194.5, 194.5, 194.5);
  background: rgb(11.5891891892, 15.9351351351, 42.0108108108);
  transition: transform 0.25s ease 0s;
  border-radius: 6px;
  margin-bottom: 7px;
}
.main-menu.menu-dark .navigation > li.open.open > a svg.menu-toggle-icon, .main-menu.menu-dark .navigation > li.sidebar-group-active.open > a svg.menu-toggle-icon,
.main-menu.menu-dark .navigation > li ul.menu-content .sidebar-group-active.open > a svg.menu-toggle-icon,
.main-menu.menu-dark .navigation > li ul.menu-content .open.open > a svg.menu-toggle-icon {
  transform: rotate(90deg);
}
.main-menu.menu-dark .navigation > li:not(.open) > ul {
  display: none;
}
.main-menu.menu-dark .navigation > li.active > a {
  color: #fff;
  font-weight: 400;
  border-radius: 4px;
}
.main-menu.menu-dark .navigation > li .active {
  background: rgb(9.3837837838, 12.9027027027, 34.0162162162);
}
.main-menu.menu-dark .navigation > li .active > a {
  color: #7367f0;
  margin-bottom: 0;
}
.main-menu.menu-dark .navigation > li .active .hover > a {
  background: rgb(11.5891891892, 15.9351351351, 42.0108108108);
}
.main-menu.menu-dark .navigation > li ul {
  padding: 0;
  margin: 0;
}
.main-menu.menu-dark .navigation > li ul li {
  color: #dcdcdc;
  background: transparent;
}
.main-menu.menu-dark .navigation > li ul li > a {
  padding: 10px 15px 10px 20px;
}
.main-menu.menu-dark .navigation > li ul .has-sub:not(.open) > ul {
  display: none;
}
.main-menu.menu-dark .navigation > li ul .open > a,
.main-menu.menu-dark .navigation > li ul .sidebar-group-active > a {
  color: #dcdcdc;
}
.main-menu.menu-dark .navigation > li ul .open > ul,
.main-menu.menu-dark .navigation > li ul .sidebar-group-active > ul {
  display: block;
}
.main-menu.menu-dark .navigation > li ul .open > ul .open > ul,
.main-menu.menu-dark .navigation > li ul .sidebar-group-active > ul .open > ul {
  display: block;
}
.main-menu.menu-dark .navigation > li ul .hover > a, .main-menu.menu-dark .navigation > li ul:hover > a {
  color: rgb(230.2, 230.2, 230.2);
}
.main-menu.menu-dark .navigation > li ul .active {
  background: linear-gradient(118deg, #7367f0, rgba(115, 103, 240, 0.7));
  box-shadow: 0 0 10px 1px rgba(115, 103, 240, 0.7);
  border-radius: 4px;
}
.main-menu.menu-dark .navigation > li ul .active > a {
  color: #fff;
}
.main-menu.menu-dark .navigation > li > ul {
  background: #10163a;
}
.main-menu.menu-dark ul.menu-popout {
  background: #10163a;
}
.main-menu.menu-dark ul.menu-popout li a {
  color: #dcdcdc;
}
.main-menu.menu-dark ul.menu-popout li a span.menu-sub-title {
  color: white;
}
.main-menu.menu-dark ul.menu-popout li.hover > a, .main-menu.menu-dark ul.menu-popout li:hover > a, .main-menu.menu-dark ul.menu-popout li.open > a {
  background: rgb(9.3837837838, 12.9027027027, 34.0162162162);
}
.main-menu.menu-dark ul.menu-popout .has-sub:not(.open) > ul {
  display: none;
}
.main-menu.menu-dark ul.menu-popout .open > a {
  color: #dcdcdc;
}
.main-menu.menu-dark ul.menu-popout .open > ul {
  display: block;
}
.main-menu.menu-dark ul.menu-popout .open > ul .open {
  background: rgb(6.0756756757, 8.3540540541, 22.0243243243);
}
.main-menu.menu-dark ul.menu-popout .open > ul .open > ul {
  display: block;
  background: rgb(6.0756756757, 8.3540540541, 22.0243243243);
}
.main-menu.menu-dark ul.menu-popout .hover > a, .main-menu.menu-dark ul.menu-popout:hover > a {
  color: rgb(230.2, 230.2, 230.2);
  background-color: rgb(11.5891891892, 15.9351351351, 42.0108108108);
}
.main-menu.menu-dark ul.menu-popout .active {
  background: rgba(0, 0, 0, 0.06);
}
.main-menu.menu-dark ul.menu-popout .active > a {
  color: rgb(245.5, 245.5, 245.5);
  background-color: rgb(11.5891891892, 15.9351351351, 42.0108108108);
}
.main-menu.menu-dark ul.menu-popout .active .hover > a,
.main-menu.menu-dark ul.menu-popout .active :hover > a {
  background-color: transparent;
}
.main-menu.menu-fixed {
  position: fixed;
  /* fallback if needed */
}
.main-menu.menu-fixed .main-menu-footer {
  position: fixed;
}
.main-menu.menu-static {
  height: auto;
  padding-bottom: calc(100% - 35rem);
}
.main-menu.menu-static .main-menu-content {
  height: unset !important;
}
.main-menu.menu-shadow {
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.05);
}
.main-menu.menu-border {
  border-right: 1px solid #e4e7ed;
}
.main-menu .shadow-bottom {
  position: absolute;
  z-index: 2;
  height: 60px;
  width: 100%;
  pointer-events: none;
  margin-top: -1.3rem;
  margin-left: -1rem;
  filter: blur(5px);
  background: linear-gradient(#fff 41%, hsla(0, 0%, 100%, 0.11) 95%, hsla(0, 0%, 100%, 0));
}
.main-menu.menu-native-scroll .main-menu-content {
  overflow-y: scroll;
}
.main-menu .navbar-header {
  height: 100%;
  width: 260px;
  height: 5rem;
  position: relative;
  padding: 0.35rem 1rem 0.3rem 1.64rem;
  transition: 300ms ease all;
}
.main-menu .navbar-header .navbar-brand {
  display: flex;
  align-items: center;
  margin-top: 1.35rem;
}
.main-menu .navbar-header .navbar-brand .brand-logo {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) no-repeat;
  background-position: -65px -54px;
  height: 24px;
  width: 35px;
}
.main-menu .navbar-header .navbar-brand .brand-text {
  color: #7367f0;
  padding-left: 1rem;
  font-weight: 600;
  letter-spacing: 0.01rem;
  font-size: 1.57rem;
  animation: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) 0s normal forwards 1 fadein;
}
.main-menu .navbar-header .modern-nav-toggle {
  animation: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) 0s normal forwards 1 fadein;
}
.main-menu .main-menu-content {
  height: calc(100% - 6rem) !important;
  position: relative;
  transition: all 0.25s ease;
}
.main-menu .main-menu-content .ps__rail-y:hover, .main-menu .main-menu-content.ps--active-y .ps__rail-y {
  background-color: transparent !important;
}
.main-menu ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.main-menu ul.navigation-main {
  overflow-x: hidden;
}
.main-menu ul.navigation-main > li:first-child {
  margin-top: 0.5rem;
}
.main-menu ul.navigation-main .nav-item svg:first-child {
  margin-right: 1rem;
  position: relative;
  top: -1px;
}
.main-menu ul.navigation-main .nav-item svg.menu-toggle-icon {
  position: absolute;
  right: 22px;
  top: 15px;
  transition: all 0.25s ease;
}
.main-menu a {
  outline: none;
}
.main-menu a:hover, .main-menu a:focus {
  text-decoration: none;
}
.main-menu.hide-sidebar {
  transform: translateX(-100%);
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.main-menu:not(.hide-sidebar) {
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.navigation {
  font-size: 1.1rem;
  font-family: "Montserrat", Helvetica, Arial, serif;
  font-weight: 400;
  overflow-y: hidden;
  padding-bottom: 20px;
}
.navigation .navigation-header {
  font-family: "Montserrat", Helvetica, Arial, serif;
  font-weight: 500;
  line-height: 1.2;
  padding: 12px 22px;
  font-size: 0.9rem;
  text-transform: uppercase;
}
.navigation li {
  position: relative;
  white-space: nowrap;
}
.navigation li a {
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
}
.navigation li.disabled {
  pointer-events: none;
  cursor: not-allowed;
}
.navigation .nav-item.active a {
  background: linear-gradient(118deg, #7367f0, rgba(115, 103, 240, 0.7));
  box-shadow: 0 0 10px 1px rgba(115, 103, 240, 0.7) !important;
}
.navigation .nav-item .menu-content li.active {
  background: linear-gradient(118deg, #7367f0, rgba(115, 103, 240, 0.7));
  box-shadow: 0 0 10px 1px rgba(115, 103, 240, 0.7) !important;
}

.menu-popout li.disabled a {
  cursor: not-allowed;
}

.dropdown-notification .nav-link-label {
  position: relative;
}
.dropdown-notification .notification-text {
  margin-bottom: 0.25rem;
  font-size: smaller;
  color: #626262;
}
.dropdown-notification .notification-title {
  color: rgba(255, 255, 255, 0.75);
}
.dropdown-notification .notification-tag {
  position: relative;
  top: -4px;
}
.dropdown-notification .dropdown-menu.dropdown-menu-right {
  right: -2px;
  padding: 0;
}
.dropdown-notification .dropdown-menu.dropdown-menu-right::before {
  background: #7367f0;
  border-color: #7367f0;
}
.dropdown-notification .dropdown-menu-header {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  background: #7367f0;
  color: #fff;
  text-align: center;
}
.dropdown-notification .dropdown-menu-header .dropdown-header h3, .dropdown-notification .dropdown-menu-header .dropdown-header .h3 {
  margin-bottom: 0.25rem;
}

.horizontal-layout.theme-primary .navbar-container .brand-logo,
.horizontal-layout.theme-primary .navbar-header .brand-logo,
.vertical-layout.theme-primary .navbar-container .brand-logo,
.vertical-layout.theme-primary .navbar-header .brand-logo {
  background-position: -65px -54px !important;
}
.horizontal-layout.theme-success .navbar-container .brand-logo,
.horizontal-layout.theme-success .navbar-header .brand-logo,
.vertical-layout.theme-success .navbar-container .brand-logo,
.vertical-layout.theme-success .navbar-header .brand-logo {
  background-position: -120px -10px !important;
}
.horizontal-layout.theme-danger .navbar-container .brand-logo,
.horizontal-layout.theme-danger .navbar-header .brand-logo,
.vertical-layout.theme-danger .navbar-container .brand-logo,
.vertical-layout.theme-danger .navbar-header .brand-logo {
  background-position: -10px -10px !important;
}
.horizontal-layout.theme-info .navbar-container .brand-logo,
.horizontal-layout.theme-info .navbar-header .brand-logo,
.vertical-layout.theme-info .navbar-container .brand-logo,
.vertical-layout.theme-info .navbar-header .brand-logo {
  background-position: -10px -54px !important;
}
.horizontal-layout.theme-warning .navbar-container .brand-logo,
.horizontal-layout.theme-warning .navbar-header .brand-logo,
.vertical-layout.theme-warning .navbar-container .brand-logo,
.vertical-layout.theme-warning .navbar-header .brand-logo {
  background-position: -120px -54px !important;
}
.horizontal-layout.theme-dark .navbar-container .brand-logo,
.horizontal-layout.theme-dark .navbar-header .brand-logo,
.vertical-layout.theme-dark .navbar-container .brand-logo,
.vertical-layout.theme-dark .navbar-header .brand-logo {
  background-position: -65px -10px !important;
}

.main-menu-header .user-content {
  padding: 20px;
}
.main-menu-header .user-content .media {
  overflow: inherit;
}
.main-menu-header .user-content .media-body {
  vertical-align: bottom;
  opacity: 1;
  width: 150px;
  white-space: nowrap;
  transition: all 0.3s ease 0.15s;
}

.main-menu-footer {
  position: relative;
  overflow: hidden;
  bottom: 0;
  display: block;
  z-index: 1000;
  color: white;
  background-color: rgb(154.3196721311, 168.5, 182.6803278689);
}
.main-menu-footer.footer-open {
  max-height: 500px;
  transition: max-height 0.2s ease-in-out;
}
.main-menu-footer a {
  color: white;
}
.main-menu-footer a:hover, .main-menu-footer a:focus {
  color: #fff;
}
.main-menu-footer .header {
  height: 19px;
  border-bottom: 1px solid rgb(169.1598360656, 181.25, 193.3401639344);
}
.main-menu-footer .toggle {
  transform: rotate(0deg);
}
.main-menu-footer .content {
  padding: 0;
}
.main-menu-footer .content .actions > a {
  display: block;
  float: left;
  width: 33.3333333333%;
  padding: 1rem 0;
  color: white;
  text-align: center;
  border-top: 1px solid rgb(169.1598360656, 181.25, 193.3401639344);
  border-left: 1px solid rgb(169.1598360656, 181.25, 193.3401639344);
}
.main-menu-footer .content .actions > a > span {
  font-size: 1.35rem;
}
.main-menu-footer .content .actions > a:hover, .main-menu-footer .content .actions > a:focus {
  color: #fff;
}

body .main-menu-footer .content {
  margin-left: 0;
}

body.menu-collapsed .menu-static {
  padding-bottom: calc(100% - 14rem);
}

@media (max-width: 575.98px) {
  .menu-hide .main-menu,
  .menu-open .main-menu {
    transition: transform 0.25s, top 0.35s, height 0.35s;
  }
  .main-menu {
    backface-visibility: hidden;
    perspective: 1000;
  }
  .main-menu:not(.hide-sidebar) {
    transform: translate3d(0);
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  }
  .menu-open .main-menu {
    transform: translate3d(0, 0, 0);
  }
}
@media (min-width: 768px) {
  .drag-target {
    z-index: 0;
  }
}
body .vertical-layout.fixed-footer .main-menu.menu-fixed {
  height: 100%;
}

@media (max-width: 768px) {
  body .main-menu.menu-static {
    padding-bottom: 100%;
  }
}
/*=========================================================================================
	File Name: horizontal-menu.scss
	Description: A classic horizontal menu for easy navingation & support all devices.
	It support light & dark version, filpped layout, right side icons, borders menu for
	item seperation.
	----------------------------------------------------------------------------------------
	Item Name: Vuexy  - Vuejs, HTML & Laravel admin Dashboard TemplateTheme
	Author: PIXINVENT
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
/*========================================================
        DARK LAYOUT
=========================================================*/
.horizontal-layout.navbar-floating .app-content {
  padding-top: 9.75rem;
}
.horizontal-layout .content {
  margin-left: 0;
}
.horizontal-layout .content .content-wrapper {
  margin-top: 0 !important;
  min-height: calc(100vh - 13.75rem);
}
.horizontal-layout footer {
  position: static;
  margin-left: 0;
}
.horizontal-layout .header-navbar.fixed-top {
  left: 0;
}
.horizontal-layout .header-navbar .brand-logo {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) no-repeat;
  background-position: -65px -54px;
  height: 24px;
  width: 35px;
}
.horizontal-layout .header-navbar .navbar-nav.float-right .nav-item:not(:last-child) a.nav-link {
  margin-right: 4px;
}
.horizontal-layout .header-navbar .navbar-nav.float-right .nav-item:not(:last-child) .dropdown-notification .nav-link {
  margin-right: 10px;
}
.horizontal-layout ul#main-menu-navigation > li {
  line-height: 1;
}
.horizontal-layout ul#main-menu-navigation > li.active .nav-link {
  background: linear-gradient(118deg, #7367f0, rgba(115, 103, 240, 0.7));
  box-shadow: 0px 0px 6px 1px rgba(115, 103, 240, 0.6);
  color: #fff !important;
  border-radius: 4px;
}
.horizontal-layout ul#main-menu-navigation > li.active .nav-link .dropdown-menu .active {
  background-color: #f8f8f8;
}
.horizontal-layout ul#main-menu-navigation > li.nav-item:not(:last-child) .nav-link.dropdown {
  margin-right: 4px;
}
.horizontal-layout ul#main-menu-navigation > li .single-item {
  padding-left: 11px !important;
  padding-right: 11px !important;
}
.horizontal-layout ul#main-menu-navigation > li .single-item .nav-link {
  color: #626262;
  padding: 0.75rem 1.25rem !important;
}
.horizontal-layout ul#main-menu-navigation > li .dropdown:not(.sub-menu) {
  padding-top: 0.965rem;
  padding-bottom: 0.965rem;
}
.horizontal-layout ul#main-menu-navigation > li .dropdown:not(.sub-menu).nav-link {
  padding: 0.75rem 1.25rem;
}
.horizontal-layout ul#main-menu-navigation > li .item-content {
  color: #626262;
}
.horizontal-layout ul#main-menu-navigation > li .item-content span {
  vertical-align: middle;
}
.horizontal-layout ul#main-menu-navigation > li .dropdown-text span:not(.menu-icon) {
  vertical-align: bottom;
}
.horizontal-layout ul#main-menu-navigation > li .has-sub-arrow {
  position: absolute;
  right: 1rem;
  top: 15px;
}
.horizontal-layout ul#main-menu-navigation > li .dropdown-menu {
  margin-left: 0;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  animation-name: slideIn;
}
.horizontal-layout ul#main-menu-navigation > li .dropdown-menu li:focus {
  outline: none;
}
.horizontal-layout ul#main-menu-navigation > li .dropdown-menu .dropdown-item {
  transition: padding 0.35s ease 0s !important;
  line-height: 1;
}
.horizontal-layout ul#main-menu-navigation > li .dropdown-menu .dropdown-item:focus {
  outline: 0;
}
.horizontal-layout ul#main-menu-navigation > li .dropdown-menu .dropdown-item.hover {
  padding-left: 25px !important;
  transition: padding 0.35s ease 0s !important;
  background-color: transparent;
  color: #626262;
}
.horizontal-layout ul#main-menu-navigation > li .dropdown-menu .dropdown-item.has-sub:focus {
  outline: 0;
}
.horizontal-layout ul#main-menu-navigation > li .dropdown-menu .dropdown-item.has-sub.hover {
  padding-left: 10px !important;
  background-color: #f8f8f8;
}
.horizontal-layout ul#main-menu-navigation > li .dropdown-menu .dropdown-item.active {
  background: #f8f8f8;
}
.horizontal-layout ul#main-menu-navigation > li .dropdown-menu .dropdown-item.active span,
.horizontal-layout ul#main-menu-navigation > li .dropdown-menu .dropdown-item.active svg {
  color: #7367f0 !important;
  font-weight: 500;
}
.horizontal-layout ul#main-menu-navigation > li .dropdown-menu .open.active > a {
  color: #626262;
  font-weight: normal;
}
.horizontal-layout ul#main-menu-navigation > li .dropdown-menu .dropdown-item {
  font-size: 1rem;
  display: flex;
  align-items: center;
}
.horizontal-layout ul#main-menu-navigation > li .dropdown-menu .dropdown-item:not(.has-sub) {
  padding: 0.95rem 1.428rem;
}
.horizontal-layout ul#main-menu-navigation > li .dropdown-menu .dropdown-item:hover span,
.horizontal-layout ul#main-menu-navigation > li .dropdown-menu .dropdown-item:hover svg {
  color: #626262;
}
.horizontal-layout ul#main-menu-navigation > li .dropdown-menu .dropdown-item.has-sub {
  padding: 0;
}
.horizontal-layout ul#main-menu-navigation > li .dropdown-menu .dropdown-item.has-sub .dropdown {
  padding: 0.95rem 1.4rem;
}
.horizontal-layout ul#main-menu-navigation > li .dropdown-menu::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
.horizontal-layout ul#main-menu-navigation > li .dropdown-menu::-webkit-scrollbar-thumb {
  background: #dae1e7;
  border-radius: 20px;
}
.horizontal-layout ul#main-menu-navigation > li .dropdown-menu::-webkit-scrollbar-track {
  background: #f8f8f8;
  border-radius: 30px;
}
.horizontal-layout ul#main-menu-navigation > li > .dropdown a {
  display: flex;
  margin-right: 0.5rem;
  align-items: center;
}
.horizontal-layout ul#main-menu-navigation > li.hover .nav-link {
  background: #f8f8f8;
  border-radius: 4px;
}
.horizontal-layout ul#main-menu-navigation > li .nav-item-wrapper {
  padding: 11px 0;
}
.horizontal-layout ul#main-menu-navigation > li .dropdown.has-active-child {
  background-color: #f8f8f8;
}
.horizontal-layout ul#main-menu-navigation > li .dropdown-menu[x-placement=left-start], .horizontal-layout ul#main-menu-navigation > li .dropdown-menu[x-placement=left-start] .dropdown-menu {
  left: -100%;
  right: 100%;
}
.horizontal-layout.navbar-floating:not(.blank-page) .app-content {
  padding-top: 9.75rem;
}
.horizontal-layout.navbar-floating .horizontal-menu-wrapper {
  background: linear-gradient(to bottom, rgba(248, 248, 248, 0.95) 44%, rgba(248, 248, 248, 0.46) 73%, rgba(255, 255, 255, 0) 100%);
  background-repeat: repeat-x;
}
.horizontal-layout.navbar-floating .horizontal-menu-wrapper .navbar-horizontal.floating-nav {
  margin: 1.3rem 2.2rem 0;
}
.horizontal-layout.dark-layout .header-navbar {
  background: inherit !important;
}
.horizontal-layout.dark-layout .horizontal-menu-wrapper {
  background: linear-gradient(to bottom, rgba(37, 43, 71, 0.76) 44%, rgba(56, 53, 53, 0.46) 73%, rgba(255, 255, 255, 0) 100%);
}
.horizontal-layout.dark-layout .horizontal-menu-wrapper .header-navbar {
  background: #10163a !important;
}
.horizontal-layout.dark-layout .horizontal-menu-wrapper .header-navbar.navbar-horizontal ul#main-menu-navigation > li:hover:not(.active) > a {
  background: #262c49;
}
.horizontal-layout.navbar-sticky .app-content {
  padding-top: 8.5rem;
}
.horizontal-layout.navbar-sticky .header-navbar {
  background-color: #f8f8f8;
  box-shadow: none;
}
.horizontal-layout.navbar-sticky .horizontal-menu-wrapper .navbar-horizontal.header-navbar.fixed-top {
  left: 0;
  top: 62px;
  background-color: #fff;
}
.horizontal-layout.navbar-static .app-content {
  padding-top: 2.5rem;
}
.horizontal-layout.navbar-static .header-navbar:not(.scrolling) {
  background-color: #f8f8f8;
  box-shadow: none;
}
.horizontal-layout.navbar-static .header-navbar:not(.scrolling) .navbar-wrapper {
  width: 100%;
}
.horizontal-layout.navbar-static .horizontal-menu-wrapper {
  position: relative;
}
.horizontal-layout.navbar-static .horizontal-menu-wrapper .navbar-horizontal.header-navbar {
  background: #fff;
}
.horizontal-layout.navbar-static .horizontal-menu-wrapper .navbar-horizontal.header-navbar.navbar-static-top {
  position: static;
  background: #fff;
  left: 0;
}
.horizontal-layout .horizontal-menu-wrapper {
  position: fixed;
  top: 62px;
  z-index: 990;
  width: 100%;
  height: 99px;
}
.horizontal-layout .horizontal-menu-wrapper .header-navbar .navbar-container {
  padding-left: 1rem;
  padding-right: 1rem;
  width: 100%;
}
.horizontal-layout .horizontal-menu-wrapper .header-navbar .navbar-header {
  display: none;
}
.horizontal-layout .header-navbar {
  background: #fff;
  z-index: 999 !important;
  line-height: 1;
}
.horizontal-layout .header-navbar.navbar-horizontal.floating-nav {
  width: calc(100vw - (100vw - 100%) - 2.2rem * 2);
  background: #fff;
}
.horizontal-layout .header-navbar .navbar-container {
  padding-left: 2.2rem;
  padding-right: calc(2.2rem - 1rem);
  border-radius: 0.5rem;
}
.horizontal-layout .header-navbar.navbar-fixed {
  position: fixed;
  width: 100%;
}
.horizontal-layout .header-navbar.navbar-brand-center .navbar-header {
  position: absolute;
  left: 50%;
  margin-left: -65px;
  padding: 0;
  z-index: 1000;
}
.horizontal-layout .header-navbar.navbar-brand-center .navbar-header .navbar-brand {
  display: flex;
  align-items: center;
  margin-right: 0;
}
.horizontal-layout .header-navbar.navbar-brand-center .navbar-header .navbar-brand .brand-text {
  color: #fff;
  padding-left: 1rem;
  letter-spacing: 0.01rem;
  font-size: 1.57rem;
}
.horizontal-layout .header-navbar.navbar-horizontal .nav-link.dropdown-toggle::after {
  left: 0.4rem;
}
.horizontal-layout .header-navbar.navbar-horizontal .dropdown-menu::before {
  display: none;
}
.horizontal-layout .header-navbar.navbar-horizontal .dropdown-menu {
  min-width: 215px;
  border: none;
  min-height: 52px;
}
.horizontal-layout .header-navbar.navbar-horizontal .dropdown-menu .disabled {
  pointer-events: none !important;
}
.horizontal-layout .header-navbar.navbar-horizontal .dropdown-menu .disabled a {
  color: #b8c2cc;
}
.horizontal-layout .header-navbar.navbar-horizontal .dropdown-menu .dropdown-toggle::after {
  left: auto;
  position: absolute;
  top: 50%;
  margin-top: -7px;
  right: 1rem;
  content: "\\e844" !important;
}
.horizontal-layout .header-navbar.navbar-horizontal .dropdown-menu .dropdown-submenu {
  position: relative;
}
.horizontal-layout .header-navbar.navbar-horizontal .dropdown-menu .dropdown-submenu.openLeft .dropdown-menu {
  left: auto;
  right: 100%;
}
.horizontal-layout .header-navbar.navbar-horizontal .dropdown-menu .dropdown-submenu.show {
  background: #f8f8f8;
}
.horizontal-layout .header-navbar.navbar-horizontal .dropdown-menu .dropdown-submenu > .dropdown-menu {
  position: absolute;
  top: 0 !important;
  left: 100% !important;
}
.horizontal-layout .header-navbar.navbar-horizontal .dropdown-menu .dropdown-submenu > .dropdown-menu i {
  font-size: 0.75rem !important;
}
.horizontal-layout.menu-collapsed #main-menu-navigation .nav-item > a span {
  display: none;
}
.horizontal-layout .navigation-header {
  font-family: inherit;
  color: #929292;
  padding: 8px 20px;
  font-size: 1rem;
  text-transform: uppercase;
}
.horizontal-layout .navbar-dark .nav-item.active > a {
  border-bottom: 2px solid #7367f0;
  background-color: #313c50;
}
.horizontal-layout .content.app-content .content-area-wrapper {
  margin-top: 2.2rem;
}
.horizontal-layout .content.app-content .content-area-wrapper .content-wrapper {
  height: calc(100vh - 16rem);
  height: calc(var(--vh, 1vh) * 100 - 16rem);
}
.horizontal-layout.chat-application .sidebar-content, .horizontal-layout.email-application .content-area-wrapper .sidebar .email-app-sidebar, .horizontal-layout.todo-application .content-area-wrapper .sidebar .todo-sidebar {
  height: calc(100vh - 16rem);
  height: calc(var(--vh, 1vh) * 100 - 16rem);
}
.horizontal-layout.todo-application .content-area-wrapper .content-right .todo-task-list {
  height: calc(100vh - 19.5rem);
  height: calc(var(--vh, 1vh) * 100 - 19.5rem);
}
.horizontal-layout.email-application .app-content .content-area-wrapper .email-user-list {
  height: calc(100vh - 23.3rem);
  height: calc(var(--vh, 1vh) * 100 - 23.3rem);
}
.horizontal-layout.chat-application .user-profile-sidebar {
  height: calc(100vh - 16.1rem);
  height: calc(var(--vh, 1vh) * 100 - 16.1rem);
  bottom: 4.1rem;
}
.horizontal-layout.chat-application .chat-profile-sidebar {
  height: calc(100vh - 16rem);
  height: calc(var(--vh, 1vh) * 100 - 16rem);
}
.horizontal-layout.chat-application .chat-app-window .user-chats {
  height: calc(100vh - 26.5rem);
  height: calc(var(--vh, 1vh) * 100 - 26.5rem);
}

@media (max-width: 991.98px) {
  body.horizontal-layout.horizontal-menu .horizontal-menu-wrapper .header-navbar {
    display: none;
  }
  body.horizontal-layout .header-navbar {
    background: #fff;
  }
  body.horizontal-layout .content .content-wrapper {
    margin-top: 5rem;
  }
}
@media (max-width: 1230px) and (min-width: 1200px) {
  .horizontal-layout .horizontal-menu-wrapper #main-menu-navigation .nav-item .nav-link a {
    margin-right: 0;
  }
}
@keyframes slideIn {
  100% {
    transform: translateY(0);
    opacity: 1;
  }
  0% {
    transform: translateY(1rem);
    opacity: 0;
  }
}
.display-inline {
  display: inline !important;
}

.display-block {
  display: block !important;
}

.display-inline-block {
  display: inline-block !important;
}

.display-hidden {
  display: none !important;
}

.display-table-cell {
  display: table-cell !important;
}

.position-top-0 {
  top: 0;
}

.position-right-0 {
  right: 0;
}

.position-bottom-0 {
  bottom: 0;
}

.position-left-0 {
  left: 0;
}

.zindex-1 {
  z-index: 1 !important;
}

.zindex-2 {
  z-index: 2 !important;
}

.zindex-3 {
  z-index: 3 !important;
}

.zindex-4 {
  z-index: 4 !important;
}

.zindex-0 {
  z-index: 0 !important;
}

.zindex-minus-1 {
  z-index: -1 !important;
}

.zindex-minus-2 {
  z-index: -2 !important;
}

.zindex-minus-3 {
  z-index: -3 !important;
}

.zindex-minus-4 {
  z-index: -4 !important;
}

.no-edge-top {
  top: 0 !important;
}

.no-edge-bottom {
  bottom: 0 !important;
}

.no-edge-left {
  left: 0 !important;
}

.no-edge-right {
  right: 0 !important;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-move {
  cursor: move;
}

.cursor-default {
  cursor: default;
}

.cursor-progress {
  cursor: progress;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.overflow-hidden {
  overflow: hidden;
}

.overflow-visible {
  overflow: visible;
}

.overflow-auto {
  overflow: auto;
}

.overflow-scroll {
  overflow: scroll;
}

.overflow-x-scroll {
  overflow: scroll;
}

.overflow-y-scroll {
  overflow: scroll;
}

.bullets-inside {
  list-style: inside;
}

.list-style-circle {
  list-style: circle;
}

.list-style-square {
  list-style: square;
}

.list-style-icons {
  padding-left: 10px;
  margin-left: 0;
  list-style: none;
}
.list-style-icons > li svg {
  width: 1em;
  margin: 0 6px 0 0;
}

.border {
  border: 1px solid;
}

.border-top {
  border-top: 1px solid;
}

.border-bottom {
  border-bottom: 1px solid;
}

.border-left {
  border-left: 1px solid;
}

.border-right {
  border-right: 1px solid;
}

.border-2 {
  border-width: 2px !important;
}

.border-top-2 {
  border-top-width: 2px !important;
}

.border-bottom-2 {
  border-bottom-width: 2px !important;
}

.border-left-2 {
  border-left-width: 2px !important;
}

.border-right-2 {
  border-right-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-top-3 {
  border-top-width: 3px !important;
}

.border-bottom-3 {
  border-bottom-width: 3px !important;
}

.border-left-3 {
  border-left-width: 3px !important;
}

.border-right-3 {
  border-right-width: 3px !important;
}

.no-border-top-radius {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.no-border-bottom-radius {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.no-border-top-left-radius {
  border-top-left-radius: 0 !important;
}

.no-border-top-right-radius {
  border-top-right-radius: 0 !important;
}

.no-border-bottom-left-radius {
  border-bottom-left-radius: 0 !important;
}

.no-border-bottom-right-radius {
  border-bottom-right-radius: 0 !important;
}

.box-shadow-0 {
  box-shadow: none !important;
}

.box-shadow-1 {
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
}

.box-shadow-2 {
  box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.box-shadow-3 {
  box-shadow: 0 12px 15px 0 rgba(0, 0, 0, 0.24), 0 17px 50px 0 rgba(0, 0, 0, 0.19);
}

.box-shadow-4 {
  box-shadow: 0 16px 28px 0 rgba(0, 0, 0, 0.22), 0 25px 55px 0 rgba(0, 0, 0, 0.21);
}

.box-shadow-5 {
  box-shadow: 0 27px 24px 0 rgba(0, 0, 0, 0.2), 0 40px 77px 0 rgba(0, 0, 0, 0.22);
}

.box-shadow-6 {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.08);
}

.fit {
  max-width: 100% !important;
}

.half-width {
  width: 50% !important;
}

.full-width {
  width: 100% !important;
}

.full-height {
  height: 100% !important;
}

.width-50 {
  width: 50px !important;
}

.width-100 {
  width: 100px !important;
}

.width-150 {
  width: 150px !important;
}

.width-200 {
  width: 200px !important;
}

.width-250 {
  width: 250px !important;
}

.width-300 {
  width: 300px !important;
}

.width-350 {
  width: 350px !important;
}

.width-400 {
  width: 400px !important;
}

.width-450 {
  width: 450px !important;
}

.width-500 {
  width: 500px !important;
}

.width-550 {
  width: 550px !important;
}

.width-600 {
  width: 600px !important;
}

.width-650 {
  width: 650px !important;
}

.width-700 {
  width: 700px !important;
}

.width-750 {
  width: 750px !important;
}

.width-800 {
  width: 800px !important;
}

.width-5-per {
  width: 5% !important;
}

.width-10-per {
  width: 10% !important;
}

.width-15-per {
  width: 15% !important;
}

.width-20-per {
  width: 20% !important;
}

.width-25-per {
  width: 25% !important;
}

.width-30-per {
  width: 30% !important;
}

.width-35-per {
  width: 35% !important;
}

.width-40-per {
  width: 40% !important;
}

.width-45-per {
  width: 45% !important;
}

.width-50-per {
  width: 50% !important;
}

.width-55-per {
  width: 55% !important;
}

.width-60-per {
  width: 60% !important;
}

.width-65-per {
  width: 65% !important;
}

.width-70-per {
  width: 70% !important;
}

.width-75-per {
  width: 75% !important;
}

.width-80-per {
  width: 80% !important;
}

.width-90-per {
  width: 90% !important;
}

.width-95-per {
  width: 95% !important;
}

.height-50 {
  height: 50px !important;
}

.height-75 {
  height: 75px !important;
}

.height-100 {
  height: 100px !important;
}

.height-150 {
  height: 150px !important;
}

.height-200 {
  height: 200px !important;
}

.height-250 {
  height: 250px !important;
}

.height-300 {
  height: 300px !important;
}

.height-350 {
  height: 350px !important;
}

.height-400 {
  height: 400px !important;
}

.height-450 {
  height: 450px !important;
}

.height-500 {
  height: 500px !important;
}

.height-550 {
  height: 550px !important;
}

.height-600 {
  height: 600px !important;
}

.height-650 {
  height: 650px !important;
}

.height-700 {
  height: 700px !important;
}

.height-750 {
  height: 750px !important;
}

.height-800 {
  height: 800px !important;
}

.height-5-per {
  height: 5% !important;
}

.height-10-per {
  height: 10% !important;
}

.height-15-per {
  height: 15% !important;
}

.height-20-per {
  height: 20% !important;
}

.height-25-per {
  height: 25% !important;
}

.height-30-per {
  height: 30% !important;
}

.height-35-per {
  height: 35% !important;
}

.height-40-per {
  height: 40% !important;
}

.height-45-per {
  height: 45% !important;
}

.height-50-per {
  height: 50% !important;
}

.height-55-per {
  height: 55% !important;
}

.height-60-per {
  height: 60% !important;
}

.height-65-per {
  height: 65% !important;
}

.height-70-per {
  height: 70% !important;
}

.height-75-per {
  height: 75% !important;
}

.height-80-per {
  height: 80% !important;
}

.full-height-vh {
  height: 100vh;
}

.line-height-1 {
  line-height: 1 !important;
}

.line-height-2 {
  line-height: 2 !important;
}

.rotate-45 {
  transform: rotate(45deg);
}

.rotate-45-inverse {
  transform: rotate(-45deg);
}

.rotate-90 {
  transform: rotate(45deg);
}

.rotate-90-inverse {
  transform: rotate(-45deg);
}

.rotate-180 {
  transform: rotate(45deg);
}

.rotate-180-inverse {
  transform: rotate(-45deg);
}

.pull-up {
  transition: all 0.25s ease;
}
.pull-up:hover {
  transform: translateY(-4px) scale(1.02);
  box-shadow: 0px 14px 24px rgba(62, 57, 107, 0.2);
  z-index: 30;
}

.spinner {
  display: inline-block;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.spinner-reverse {
  display: inline-block;
  animation: spin-reverse 1s linear infinite;
}

@keyframes spin-reverse {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
.bg-cover {
  background-size: cover !important;
}

.background-repeat {
  background-repeat: repeat !important;
}

.background-no-repeat {
  background-repeat: no-repeat !important;
}

.img-xl {
  width: 64px !important;
  height: 64px !important;
}

.img-lg {
  width: 44px !important;
  height: 44px !important;
}

.img-sm {
  width: 36px !important;
  height: 36px !important;
}

.img-xs {
  width: 32px !important;
  height: 32px !important;
}

.bullet {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
}
.bullet.bullet-xs {
  width: 0.5rem;
  height: 0.5rem;
}
.bullet.bullet-sm {
  width: 0.714rem;
  height: 0.714rem;
}
.bullet.bullet-lg {
  width: 1.25rem;
  height: 1.25rem;
}

.color-radio {
  position: relative;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.color-radio .radio-content {
  height: 20px;
  width: 20px;
  display: block;
  border-radius: 50%;
}

.match-height .card {
  height: calc(100% - 2.2rem);
}

.avatar {
  white-space: nowrap;
  background-color: #c3c3c3;
  border-radius: 50%;
  position: relative;
  cursor: pointer;
  color: #fff;
  display: inline-flex;
  font-size: 0.75rem;
  text-align: center;
  vertical-align: middle;
  margin: 5px;
}
.avatar .avatar-content {
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.avatar .avatar-content .avatar-icon svg {
  width: 1.2rem;
  height: 1.2rem;
}
.avatar:not(.avatar-stats) svg {
  height: 12px;
  width: 12px;
}
.avatar [class*=avatar-status-] {
  border-radius: 50%;
  width: 11px;
  height: 11px;
  position: absolute;
  right: 0;
  bottom: 0;
  border: 1px solid #fff;
}
.avatar [class*=avatar-status-].avatar-status-lg {
  width: 17px;
  height: 17px;
  border-width: 2px;
}
.avatar .avatar-status-online {
  background-color: #28c76f;
}
.avatar .avatar-status-busy {
  background-color: #ea5455;
}
.avatar .avatar-status-away {
  background-color: #ff9f43;
}
.avatar .avatar-status-offline {
  background-color: #b8c2cc;
}
.avatar img {
  border-radius: 50%;
}
.avatar.avatar-xl {
  font-size: 1.5rem;
}
.avatar.avatar-xl img {
  width: 70px;
  height: 70px;
}
.avatar.avatar-xl .avatar-content {
  height: 70px;
  width: 70px;
}
.avatar.avatar-xl .avatar-content .avatar-icon svg {
  width: 3rem;
  height: 3rem;
}
.avatar.avatar-lg {
  font-size: 1.2rem;
}
.avatar.avatar-lg img {
  width: 50px;
  height: 50px;
}
.avatar.avatar-lg .avatar-content {
  width: 50px;
  height: 50px;
}
.avatar.avatar-lg .avatar-content .avatar-icon svg {
  width: 2rem;
  height: 2rem;
}
.avatar.avatar-sm .avatar-content {
  width: 24px;
  height: 24px;
}
.avatar.avatar-sm .avatar-content .avatar-icon svg {
  width: 1rem;
  height: 1rem;
}
.avatar.avatar-sm img {
  width: 24px;
  height: 24px;
}

/*=========================================================================================
	File Name: search.scss
	Description: Search  functionality.
	----------------------------------------------------------------------------------------
	Item Name: Vuexy React admin Template
	Version: 1.0
	Author: PIXINVENT
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
.navbar-container a.nav-link-search {
  float: left;
}
.navbar-container .search-input {
  float: left;
  width: 0;
}
.navbar-container .search-input input {
  width: 0;
  border: "2px solid black";
  transition: all 0.2s ease-out;
  line-height: 16px;
  padding: 1.75rem 3.6rem;
}
.navbar-container .search-input input:focus {
  outline: 0 !important;
  outline-offset: 0 !important;
}
.navbar-container .search-input.open {
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 1;
  border-radius: 0.5rem;
}
.navbar-container .search-input.open .search-input-close,
.navbar-container .search-input.open .search-input-icon {
  display: block;
}
.navbar-container .search-input.open input {
  width: 100%;
  outline: none;
  transition: all 0.3s ease-out;
}
.navbar-container .search-input .search-input-icon {
  z-index: 2;
  display: none;
  position: absolute;
  left: 1.5rem;
  top: 1.75rem;
  cursor: pointer;
}
.navbar-container .search-input .search-input-close {
  z-index: 1;
  display: none;
  position: absolute;
  right: 2rem;
  top: 20px;
  cursor: pointer;
}
.navbar-container .search-input .search-header {
  padding: 1.2rem 1.5rem;
  padding-bottom: 0.5rem;
}
.navbar-container .search-input .other-results {
  overflow: hidden;
}
.navbar-container .search-input .other-results .permanent-result {
  width: 100%;
  cursor: pointer;
  padding: 0.5rem;
  padding-left: 1rem;
}
.navbar-container .search-input .other-results .permanent-result:hover {
  background-color: #f1f1f1;
}
.navbar-container .bookmark-input {
  position: absolute;
  top: 102%;
  width: 25%;
  display: none;
}
.navbar-container .bookmark-input.show {
  display: block;
}
.navbar-container .bookmark-input .bookmark-input-icon {
  position: absolute;
  z-index: 1;
  top: 0.75rem;
  left: 1rem;
}
.navbar-container .bookmark-input input {
  padding: 0.7rem 0.7rem 0.7rem 2.5rem;
  width: 100%;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-bottom-left-radius: 5px !important;
  border-bottom-right-radius: 5px !important;
}
.navbar-container .bookmark-input input:focus {
  border: 1px solid #7367f0;
}
.navbar-container .bookmark-icon {
  cursor: pointer;
}
.navbar-container .dropdown.bookmark-dropdown {
  padding: 1.4rem 0.5rem 1.35rem;
}
.navbar-container .dropdown.bookmark-dropdown .dropdown-toggle:after {
  display: none;
}

/* .navbar-light, .navbar-semi-dark{
	.search-input{
		.input{
			color: \$gray-600;
		}
		&.open{
			.input{
				color: \$gray-600;
				// border-bottom: 1px solid \$gray-600;

			}
		}
	}
} */
.navbar-dark .search-input .input,
.navbar-semi-light .search-input .input {
  color: #f5f7fa;
  border-radius: 0.5rem;
  border: "2px solid black";
}
.navbar-dark .search-input.open .input,
.navbar-semi-light .search-input.open .input {
  color: #f5f7fa;
  border: 1px solid #f5f7fa;
}

@media (max-width: 575.98px) {
  #navbar-mobile .search-input.open .input {
    color: #b8c2cc;
  }
}
@media (max-width: 1300px) {
  .navbar-container .bookmark-input {
    width: 35%;
  }
}
.apexcharts-canvas .apexcharts-tooltip {
  color: #626262 !important;
}
.apexcharts-canvas .apexcharts-tooltip.dark {
  color: #fff !important;
}
.apexcharts-canvas .apexcharts-toolbar .apexcharts-menu .apexcharts-menu-item {
  color: #626262;
}

.apexcharts-xaxistooltip {
  color: #626262 !important;
}

#client-retention-chart .apexcharts-canvas .apexcharts-legend {
  left: -14px !important;
}

.btn-social, .btn-social-icon {
  position: relative;
  padding-left: 4.95rem;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.btn-social > :first-child, .btn-social-icon > :first-child {
  position: absolute;
  left: 0;
  top: 2px;
  bottom: 0;
  width: 2.95rem;
  line-height: 2.7rem;
  font-size: 1rem;
  text-align: center;
  border-right: 1px solid rgba(0, 0, 0, 0.2);
}

.btn-social-icon {
  height: 2.95rem;
  width: 2.95rem;
  padding: 0;
}
.btn-social-icon > :first-child {
  border: none;
  text-align: center;
  width: 100% !important;
}

.btn-adn {
  background-color: #d87a68;
  --bs-btn-color: #d87a68;
  --bs-btn-bg: #d87a68;
  --bs-btn-border-color: #fff;
  --bs-btn-hover-color: #22292f;
  --bs-btn-hover-bg: #d87a68;
  --bs-btn-hover-border-color: white;
  --bs-btn-focus-shadow-rgb: 249, 235, 232;
  --bs-btn-active-color: #22292f;
  --bs-btn-active-bg: rgb(223.8, 148.6, 134.2);
  --bs-btn-active-border-color: white;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #22292f;
  --bs-btn-disabled-bg: #d87a68;
  --bs-btn-disabled-border-color: #fff;
}

.btn-bitbucket {
  background-color: #205081;
  --bs-btn-color: #205081;
  --bs-btn-bg: #205081;
  --bs-btn-border-color: #fff;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #205081;
  --bs-btn-hover-border-color: white;
  --bs-btn-focus-shadow-rgb: 222, 229, 236;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(76.6, 115, 154.2);
  --bs-btn-active-border-color: white;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #205081;
  --bs-btn-disabled-border-color: #fff;
}

.btn-dropbox {
  background-color: #1087dd;
  --bs-btn-color: #1087dd;
  --bs-btn-bg: #1087dd;
  --bs-btn-border-color: #fff;
  --bs-btn-hover-color: #22292f;
  --bs-btn-hover-bg: #1087dd;
  --bs-btn-hover-border-color: white;
  --bs-btn-focus-shadow-rgb: 219, 237, 250;
  --bs-btn-active-color: #22292f;
  --bs-btn-active-bg: rgb(63.8, 159, 227.8);
  --bs-btn-active-border-color: white;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #22292f;
  --bs-btn-disabled-bg: #1087dd;
  --bs-btn-disabled-border-color: #fff;
}

.btn-facebook {
  background-color: #3b5998;
  --bs-btn-color: #3b5998;
  --bs-btn-bg: #3b5998;
  --bs-btn-border-color: #fff;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #3b5998;
  --bs-btn-hover-border-color: white;
  --bs-btn-focus-shadow-rgb: 226, 230, 240;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(98.2, 122.2, 172.6);
  --bs-btn-active-border-color: white;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #3b5998;
  --bs-btn-disabled-border-color: #fff;
}

.btn-flickr {
  background-color: #ff0084;
  --bs-btn-color: #ff0084;
  --bs-btn-bg: #ff0084;
  --bs-btn-border-color: #fff;
  --bs-btn-hover-color: #22292f;
  --bs-btn-hover-bg: #ff0084;
  --bs-btn-hover-border-color: white;
  --bs-btn-focus-shadow-rgb: 255, 217, 237;
  --bs-btn-active-color: #22292f;
  --bs-btn-active-bg: rgb(255, 51, 156.6);
  --bs-btn-active-border-color: white;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #22292f;
  --bs-btn-disabled-bg: #ff0084;
  --bs-btn-disabled-border-color: #fff;
}

.btn-foursquare {
  background-color: #f94877;
  --bs-btn-color: #f94877;
  --bs-btn-bg: #f94877;
  --bs-btn-border-color: #fff;
  --bs-btn-hover-color: #22292f;
  --bs-btn-hover-bg: #f94877;
  --bs-btn-hover-border-color: white;
  --bs-btn-focus-shadow-rgb: 254, 228, 235;
  --bs-btn-active-color: #22292f;
  --bs-btn-active-bg: rgb(250.2, 108.6, 146.2);
  --bs-btn-active-border-color: white;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #22292f;
  --bs-btn-disabled-bg: #f94877;
  --bs-btn-disabled-border-color: #fff;
}

.btn-github {
  background-color: #444444;
  --bs-btn-color: #444444;
  --bs-btn-bg: #444444;
  --bs-btn-border-color: #fff;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #444444;
  --bs-btn-hover-border-color: white;
  --bs-btn-focus-shadow-rgb: 227, 227, 227;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(105.4, 105.4, 105.4);
  --bs-btn-active-border-color: white;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #444444;
  --bs-btn-disabled-border-color: #fff;
}

.btn-google {
  background-color: #dd4b39;
  --bs-btn-color: #dd4b39;
  --bs-btn-bg: #dd4b39;
  --bs-btn-border-color: #fff;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #dd4b39;
  --bs-btn-hover-border-color: white;
  --bs-btn-focus-shadow-rgb: 250, 228, 225;
  --bs-btn-active-color: #22292f;
  --bs-btn-active-bg: rgb(227.8, 111, 96.6);
  --bs-btn-active-border-color: white;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #dd4b39;
  --bs-btn-disabled-border-color: #fff;
}

.btn-instagram {
  background-color: #3f729b;
  --bs-btn-color: #3f729b;
  --bs-btn-bg: #3f729b;
  --bs-btn-border-color: #fff;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #3f729b;
  --bs-btn-hover-border-color: white;
  --bs-btn-focus-shadow-rgb: 226, 234, 240;
  --bs-btn-active-color: #22292f;
  --bs-btn-active-bg: rgb(101.4, 142.2, 175);
  --bs-btn-active-border-color: white;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #3f729b;
  --bs-btn-disabled-border-color: #fff;
}

.btn-linkedin {
  background-color: #007bb6;
  --bs-btn-color: #007bb6;
  --bs-btn-bg: #007bb6;
  --bs-btn-border-color: #fff;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #007bb6;
  --bs-btn-hover-border-color: white;
  --bs-btn-focus-shadow-rgb: 217, 235, 244;
  --bs-btn-active-color: #22292f;
  --bs-btn-active-bg: rgb(51, 149.4, 196.6);
  --bs-btn-active-border-color: white;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #007bb6;
  --bs-btn-disabled-border-color: #fff;
}

.btn-microsoft {
  background-color: #2672ec;
  --bs-btn-color: #2672ec;
  --bs-btn-bg: #2672ec;
  --bs-btn-border-color: #fff;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #2672ec;
  --bs-btn-hover-border-color: white;
  --bs-btn-focus-shadow-rgb: 222, 234, 252;
  --bs-btn-active-color: #22292f;
  --bs-btn-active-bg: rgb(81.4, 142.2, 239.8);
  --bs-btn-active-border-color: white;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #2672ec;
  --bs-btn-disabled-border-color: #fff;
}

.btn-odnoklassniki {
  background-color: #f4731c;
  --bs-btn-color: #f4731c;
  --bs-btn-bg: #f4731c;
  --bs-btn-border-color: #fff;
  --bs-btn-hover-color: #22292f;
  --bs-btn-hover-bg: #f4731c;
  --bs-btn-hover-border-color: white;
  --bs-btn-focus-shadow-rgb: 253, 234, 221;
  --bs-btn-active-color: #22292f;
  --bs-btn-active-bg: rgb(246.2, 143, 73.4);
  --bs-btn-active-border-color: white;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #22292f;
  --bs-btn-disabled-bg: #f4731c;
  --bs-btn-disabled-border-color: #fff;
}

.btn-openid {
  background-color: #f7931e;
  --bs-btn-color: #f7931e;
  --bs-btn-bg: #f7931e;
  --bs-btn-border-color: #fff;
  --bs-btn-hover-color: #22292f;
  --bs-btn-hover-bg: #f7931e;
  --bs-btn-hover-border-color: white;
  --bs-btn-focus-shadow-rgb: 254, 239, 221;
  --bs-btn-active-color: #22292f;
  --bs-btn-active-bg: rgb(248.6, 168.6, 75);
  --bs-btn-active-border-color: white;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #22292f;
  --bs-btn-disabled-bg: #f7931e;
  --bs-btn-disabled-border-color: #fff;
}

.btn-pinterest {
  background-color: #cb2027;
  --bs-btn-color: #cb2027;
  --bs-btn-bg: #cb2027;
  --bs-btn-border-color: #fff;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #cb2027;
  --bs-btn-hover-border-color: white;
  --bs-btn-focus-shadow-rgb: 247, 222, 223;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(213.4, 76.6, 82.2);
  --bs-btn-active-border-color: white;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #cb2027;
  --bs-btn-disabled-border-color: #fff;
}

.btn-reddit {
  background-color: #eff7ff;
  --bs-btn-color: #000;
  --bs-btn-bg: #eff7ff;
  --bs-btn-border-color: #000;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #000;
  --bs-btn-hover-border-color: rgb(25.5, 25.5, 25.5);
  --bs-btn-focus-shadow-rgb: 0, 0, 0;
  --bs-btn-active-color: #22292f;
  --bs-btn-active-bg: rgb(242.2, 248.6, 255);
  --bs-btn-active-border-color: rgb(25.5, 25.5, 25.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #22292f;
  --bs-btn-disabled-bg: #eff7ff;
  --bs-btn-disabled-border-color: #000;
}

.btn-soundcloud {
  background-color: #ff5500;
  --bs-btn-color: #ff5500;
  --bs-btn-bg: #ff5500;
  --bs-btn-border-color: #fff;
  --bs-btn-hover-color: #22292f;
  --bs-btn-hover-bg: #ff5500;
  --bs-btn-hover-border-color: white;
  --bs-btn-focus-shadow-rgb: 255, 230, 217;
  --bs-btn-active-color: #22292f;
  --bs-btn-active-bg: #ff7733;
  --bs-btn-active-border-color: white;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #22292f;
  --bs-btn-disabled-bg: #ff5500;
  --bs-btn-disabled-border-color: #fff;
}

.btn-tumblr {
  background-color: #2c4762;
  --bs-btn-color: #2c4762;
  --bs-btn-bg: #2c4762;
  --bs-btn-border-color: #fff;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #2c4762;
  --bs-btn-hover-border-color: white;
  --bs-btn-focus-shadow-rgb: 223, 227, 231;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(86.2, 107.8, 129.4);
  --bs-btn-active-border-color: white;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #2c4762;
  --bs-btn-disabled-border-color: #fff;
}

.btn-twitter {
  background-color: #55acee;
  --bs-btn-color: #55acee;
  --bs-btn-bg: #55acee;
  --bs-btn-border-color: #fff;
  --bs-btn-hover-color: #22292f;
  --bs-btn-hover-bg: #55acee;
  --bs-btn-hover-border-color: white;
  --bs-btn-focus-shadow-rgb: 230, 243, 252;
  --bs-btn-active-color: #22292f;
  --bs-btn-active-bg: rgb(119, 188.6, 241.4);
  --bs-btn-active-border-color: white;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #22292f;
  --bs-btn-disabled-bg: #55acee;
  --bs-btn-disabled-border-color: #fff;
}

.btn-vimeo {
  background-color: #1ab7ea;
  --bs-btn-color: #1ab7ea;
  --bs-btn-bg: #1ab7ea;
  --bs-btn-border-color: #fff;
  --bs-btn-hover-color: #22292f;
  --bs-btn-hover-bg: #1ab7ea;
  --bs-btn-hover-border-color: white;
  --bs-btn-focus-shadow-rgb: 221, 244, 252;
  --bs-btn-active-color: #22292f;
  --bs-btn-active-bg: rgb(71.8, 197.4, 238.2);
  --bs-btn-active-border-color: white;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #22292f;
  --bs-btn-disabled-bg: #1ab7ea;
  --bs-btn-disabled-border-color: #fff;
}

.btn-vk {
  background-color: #587ea3;
  --bs-btn-color: #587ea3;
  --bs-btn-bg: #587ea3;
  --bs-btn-border-color: #fff;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #587ea3;
  --bs-btn-hover-border-color: white;
  --bs-btn-focus-shadow-rgb: 230, 236, 241;
  --bs-btn-active-color: #22292f;
  --bs-btn-active-bg: rgb(121.4, 151.8, 181.4);
  --bs-btn-active-border-color: white;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #587ea3;
  --bs-btn-disabled-border-color: #fff;
}

.btn-yahoo {
  background-color: #720e9e;
  --bs-btn-color: #720e9e;
  --bs-btn-bg: #720e9e;
  --bs-btn-border-color: #fff;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #720e9e;
  --bs-btn-hover-border-color: white;
  --bs-btn-focus-shadow-rgb: 234, 219, 240;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(142.2, 62.2, 177.4);
  --bs-btn-active-border-color: white;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #720e9e;
  --bs-btn-disabled-border-color: #fff;
}

.btn-outline-adn {
  border: 1px solid #d87a68 !important;
  color: #d87a68;
}

.btn-outline-bitbucket {
  border: 1px solid #205081 !important;
  color: #205081;
}

.btn-outline-dropbox {
  border: 1px solid #1087dd !important;
  color: #1087dd;
}

.btn-outline-facebook {
  border: 1px solid #3b5998 !important;
  color: #3b5998;
}

.btn-outline-flickr {
  border: 1px solid #ff0084 !important;
  color: #ff0084;
}

.btn-outline-foursquare {
  border: 1px solid #f94877 !important;
  color: #f94877;
}

.btn-outline-github {
  border: 1px solid #444444 !important;
  color: #444444;
}

.btn-outline-google {
  border: 1px solid #dd4b39 !important;
  color: #dd4b39;
}

.btn-outline-instagram {
  border: 1px solid #3f729b !important;
  color: #3f729b;
}

.btn-outline-linkedin {
  border: 1px solid #007bb6 !important;
  color: #007bb6;
}

.btn-outline-microsoft {
  border: 1px solid #2672ec !important;
  color: #2672ec;
}

.btn-outline-odnoklassniki {
  border: 1px solid #f4731c !important;
  color: #f4731c;
}

.btn-outline-openid {
  border: 1px solid #f7931e !important;
  color: #f7931e;
}

.btn-outline-pinterest {
  border: 1px solid #cb2027 !important;
  color: #cb2027;
}

.btn-outline-reddit {
  border: 1px solid #ff4500 !important;
  color: #ff4500;
}

.btn-outline-soundcloud {
  border: 1px solid #ff5500 !important;
  color: #ff5500;
}

.btn-outline-tumblr {
  border: 1px solid #2c4762 !important;
  color: #2c4762;
}

.btn-outline-twitter {
  border: 1px solid #55acee !important;
  color: #55acee;
}

.btn-outline-vimeo {
  border: 1px solid #1ab7ea !important;
  color: #1ab7ea;
}

.btn-outline-vk {
  border: 1px solid #587ea3 !important;
  color: #587ea3;
}

.btn-outline-yahoo {
  border: 1px solid #720e9e !important;
  color: #720e9e;
}

.btn-outline-adn:hover {
  color: rgb(173.2526315789, 65.4, 44.7473684211);
  border: 1px solid rgb(173.2526315789, 65.4, 44.7473684211) !important;
}

.btn-outline-bitbucket:hover {
  color: rgb(11.7267080745, 29.3167701863, 47.2732919255);
  border: 1px solid rgb(11.7267080745, 29.3167701863, 47.2732919255) !important;
}

.btn-outline-dropbox:hover {
  color: rgb(9.1139240506, 76.8987341772, 125.8860759494);
  border: 1px solid rgb(9.1139240506, 76.8987341772, 125.8860759494) !important;
}

.btn-outline-facebook:hover {
  color: rgb(30.4786729858, 45.9763033175, 78.5213270142);
  border: 1px solid rgb(30.4786729858, 45.9763033175, 78.5213270142) !important;
}

.btn-outline-flickr:hover {
  color: rgb(153, 0, 79.2);
  border: 1px solid rgb(153, 0, 79.2) !important;
}

.btn-outline-foursquare:hover {
  color: rgb(212.0476190476, 6.9523809524, 61.4126984127);
  border: 1px solid rgb(212.0476190476, 6.9523809524, 61.4126984127) !important;
}

.btn-outline-github:hover {
  color: #111111;
  border: 1px solid #111111 !important;
}

.btn-outline-google:hover {
  color: rgb(150.2068965517, 39.4482758621, 25.7931034483);
  border: 1px solid rgb(150.2068965517, 39.4482758621, 25.7931034483) !important;
}

.btn-outline-instagram:hover {
  color: rgb(33.5229357798, 60.6605504587, 82.4770642202);
  border: 1px solid rgb(33.5229357798, 60.6605504587, 82.4770642202) !important;
}

.btn-outline-linkedin:hover {
  color: rgb(0, 54.0659340659, 80);
  border: 1px solid rgb(0, 54.0659340659, 80) !important;
}

.btn-outline-microsoft:hover {
  color: rgb(13.8474576271, 69.2372881356, 158.1525423729);
  border: 1px solid rgb(13.8474576271, 69.2372881356, 158.1525423729) !important;
}

.btn-outline-odnoklassniki:hover {
  color: rgb(162.1428571429, 70, 7.8571428571);
  border: 1px solid rgb(162.1428571429, 70, 7.8571428571) !important;
}

.btn-outline-openid:hover {
  color: rgb(168.991416309, 93.8841201717, 6.008583691);
  border: 1px solid rgb(168.991416309, 93.8841201717, 6.008583691) !important;
}

.btn-outline-pinterest:hover {
  color: rgb(114.8893617021, 18.1106382979, 22.0723404255);
  border: 1px solid rgb(114.8893617021, 18.1106382979, 22.0723404255) !important;
}

.btn-outline-reddit:hover {
  color: rgb(153, 41.4, 0);
  border: 1px solid rgb(153, 41.4, 0) !important;
}

.btn-outline-soundcloud:hover {
  color: #993300;
  border: 1px solid #993300 !important;
}

.btn-outline-tumblr:hover {
  color: rgb(12.3943661972, 20, 27.6056338028);
  border: 1px solid rgb(12.3943661972, 20, 27.6056338028) !important;
}

.btn-outline-twitter:hover {
  color: rgb(20.0909090909, 122.9090909091, 200.9090909091);
  border: 1px solid rgb(20.0909090909, 122.9090909091, 200.9090909091) !important;
}

.btn-outline-vimeo:hover {
  color: rgb(13.272, 112.496, 144.728);
  border: 1px solid rgb(13.272, 112.496, 144.728) !important;
}

.btn-outline-vk:hover {
  color: rgb(52.2390438247, 74.796812749, 96.7609561753);
  border: 1px solid rgb(52.2390438247, 74.796812749, 96.7609561753) !important;
}

.btn-outline-yahoo:hover {
  color: rgb(46.3953488372, 5.6976744186, 64.3023255814);
  border: 1px solid rgb(46.3953488372, 5.6976744186, 64.3023255814) !important;
}

.bg-adn {
  background-color: #d87a68;
}

.bg-bitbucket {
  background-color: #205081;
}

.bg-dropbox {
  background-color: #1087dd;
}

.bg-facebook {
  background-color: #3b5998;
}

.bg-flickr {
  background-color: #ff0084;
}

.bg-foursquare {
  background-color: #f94877;
}

.bg-github {
  background-color: #444444;
}

.bg-google {
  background-color: #dd4b39;
}

.bg-instagram {
  background-color: #3f729b;
}

.bg-linkedin {
  background-color: #007bb6;
}

.bg-microsoft {
  background-color: #2672ec;
}

.bg-odnoklassniki {
  background-color: #f4731c;
}

.bg-openid {
  background-color: #f7931e;
}

.bg-pinterest {
  background-color: #cb2027;
}

.bg-reddit {
  background-color: #ff4500;
}

.bg-soundcloud {
  background-color: #ff5500;
}

.bg-tumblr {
  background-color: #2c4762;
}

.bg-twitter {
  background-color: #55acee;
}

.bg-vimeo {
  background-color: #1ab7ea;
}

.bg-vk {
  background-color: #587ea3;
}

.bg-yahoo {
  background-color: #720e9e;
}

/*=========================================================================================
    File Name: demo.scss
    Description: CSS used for demo purpose only. Remove this css from your project.
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy React admin Template
    Version: 1.0
    Author: PIXINVENT
    Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
.fonticon-container > .fonticon-wrap {
  float: left;
  width: 60px;
  height: 60px;
  line-height: 1rem;
  text-align: center;
  border-radius: 0.1875rem;
  margin-right: 0;
  margin-bottom: 1.5rem;
  cursor: pointer;
}
.fonticon-container > .fonticon-wrap > svg {
  transition: all 0.2s ease-in-out;
}
.fonticon-container > .fonticon-wrap > svg:hover {
  stroke: #7367f0;
  transform: scale(1.3);
}
.fonticon-container > .fonticon-wrap.youtube {
  width: 100px;
}
.fonticon-container:hover svg {
  color: #7367f0;
  transform: scale(1.3);
}
.fonticon-container > .fonticon-classname,
.fonticon-container > .fonticon-unit {
  display: block;
  font-size: 1.5rem;
  line-height: 1.2;
}
.fonticon-container > .fonticon-unit {
  font-size: 1rem;
  font-style: italic;
}

.scroll-example {
  padding: 0.5rem;
  position: relative;
  border: 2px solid rgb(222.5, 222.5, 222.5);
  overflow: auto;
}
.scroll-example .horz-scroll-content {
  width: 1200px;
}

.browser {
  background: #e0e0e0;
  border: 4px solid #e0e0e0;
  width: 100%;
  height: 12rem;
  padding-top: 20px;
  margin: 0 0 10px;
  box-sizing: border-box;
}

.browser iframe {
  border: 0;
  background: #fff;
  height: 100%;
  width: 100%;
}

.loader-wrapper {
  height: 8em;
}

.maintenance-icon {
  font-size: 4rem;
}

.animationIcon {
  right: 30px;
  bottom: 10px;
}

/*=========================================================================================
	File Name: customizer.scss
	Description: CSS used for demo purpose only. Remove this css from your project.
	----------------------------------------------------------------------------------------
	Item Name: Vuexy React admin Template
	Version: 1.0
	Author: PIXINVENT
	Author URL: http://www.themeforest.net/user/pixinvent
  ==========================================================================================*/
.customizer {
  width: 400px;
  right: -400px;
  padding: 0;
  background-color: #fff;
  z-index: 1051;
  position: fixed;
  top: 0;
  bottom: 0;
  height: 100vh;
  transition: right 0.4s cubic-bezier(0.05, 0.74, 0.2, 0.99);
  backface-visibility: hidden;
  border-left: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11), 0 5px 15px 0 rgba(0, 0, 0, 0.08);
}
.customizer .open-icon {
  animation: Spin 2s infinite linear;
  position: relative;
  top: -2px;
}
.customizer.open {
  right: 0;
}
.customizer .customizer-content {
  position: relative;
  height: calc(100% - 7rem);
}
.customizer .customizer-content .bg-default {
  background-color: #fff;
}
.customizer .customizer-close {
  position: absolute;
  right: 30px;
  top: 20px;
  padding: 7px;
  width: auto;
  z-index: 10;
  color: #626262;
}
.customizer .customizer-close i {
  font-size: 1.71rem;
}
.customizer .customizer-toggle {
  background: #7367f0;
  color: #fff;
  display: block;
  box-shadow: -3px 0px 8px rgba(0, 0, 0, 0.1);
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  position: absolute;
  top: 50%;
  width: 38px;
  height: 38px;
  left: -39px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}
.customizer .color-box {
  height: 35px;
  width: 35px;
  margin: 0.5rem;
  border-radius: 0.5rem;
  cursor: pointer;
}
.customizer .color-box.selected {
  box-shadow: 0 0 0 3px rgba(52, 144, 220, 0.5);
  transition: all 0.2s ease-in-out;
}
.customizer .color-box.disabled {
  pointer-events: none;
  cursor: not-allowed;
}

body.dark-layout .hide-scroll-top-switch .custom-switch .custom-control-label:before,
body.dark-layout .collapse-sidebar .custom-switch .custom-control-label:before {
  background-color: #10163a;
}

.buy-now {
  position: fixed;
  bottom: 5%;
  right: 79px;
  z-index: 1031;
}
.buy-now .btn {
  box-shadow: 0 1px 20px 1px #EA5455 !important;
}
.buy-now .btn:hover {
  box-shadow: none !important;
}

@keyframes Spin {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(359deg);
  }
}
.chip {
  background-color: #f0f0f0;
  font-size: 0.8rem;
  border-radius: 1.428rem;
  display: inline-flex;
  padding: 0 10px;
  margin-bottom: 5px;
  vertical-align: middle;
  justify-content: center;
}
.chip .chip-body {
  color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: space-between;
  min-height: 1.857rem;
  min-width: 1.857rem;
}
.chip .chip-body .avatar {
  background-color: #c3c3c3;
  display: flex;
  width: 24px;
  height: 24px;
  margin: 2px 0;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  color: #fff;
  transform: translate(-8px);
}
.chip .chip-body .avatar .avatar-content {
  font-size: 0.8rem;
}
.chip .chip-body .avatar img {
  border-radius: 50%;
  height: 24px;
  width: 24px;
}
.chip .chip-body .chip-text {
  vertical-align: middle;
  align-self: center;
}
.chip .chip-body .chip-closable {
  min-height: 1.428rem;
  min-width: 1.428rem;
  margin: 0 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.15);
  color: #fff;
  transform: translate(10px);
  cursor: pointer;
}
.chip .chip-body .chip-closable svg {
  height: 12px;
  width: 12px;
}

.divider {
  display: block;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  margin: 1rem 0;
}
.divider .divider-text {
  position: relative;
  display: inline-block;
  font-size: 0.9375rem;
  padding: 0 1rem;
  background-color: #fff;
}
.divider .divider-text svg {
  height: 1rem;
  width: 1rem;
}
.divider .divider-text:before, .divider .divider-text:after {
  content: "";
  position: absolute;
  top: 50%;
  width: 9999px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.divider .divider-text:before {
  right: 100%;
}
.divider .divider-text:after {
  left: 100%;
}
.divider.divider-left .divider-text {
  float: left;
  padding-left: 0;
}
.divider.divider-left .divider-text:before {
  display: none;
}
.divider.divider-left-center .divider-text {
  left: -25%;
}
.divider.divider-right .divider-text {
  float: right;
  padding-right: 0;
}
.divider.divider-right .divider-text:after {
  display: none;
}
.divider.divider-right-center .divider-text {
  right: -25%;
}
.divider.divider-dotted .divider-text:before, .divider.divider-dotted .divider-text:after {
  border-style: dotted;
  border-width: 1px;
  border-top-width: 0;
  border-color: black;
}
.divider.divider-dashed .divider-text:before, .divider.divider-dashed .divider-text:after {
  border-style: dashed;
  border-width: 1px;
  border-top-width: 0;
  border-color: black;
}

/***** Vuexy Wizard *****/
.vx-wizard {
  box-shadow: none !important;
  display: table;
  width: 100%;
}
.vx-wizard.nav.nav-tabs .step-wrapper.nav-item {
  display: table-cell;
  width: auto;
}
.vx-wizard.nav.nav-tabs .step-wrapper.nav-item .step.nav-link {
  transform: translateY(0) !important;
  text-align: center !important;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.vx-wizard.nav.nav-tabs .step-wrapper.nav-item .step.nav-link .step-text {
  border-radius: 50%;
  font-size: 1.5rem;
  z-index: 2;
  height: 50px;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  background: #fff;
}
.vx-wizard.nav.nav-tabs .step-wrapper.nav-item .step.nav-link.active .step-text {
  background-color: #2a2e30;
  color: #fff;
}
.vx-wizard.nav.nav-tabs .step-wrapper.nav-item .step.nav-link.active:after {
  background: #2a2e30 !important;
  box-shadow: none !important;
  height: 3px;
  top: 50% !important;
  z-index: -1;
  width: 50%;
}
.vx-wizard.nav.nav-tabs .step-wrapper.nav-item .step.nav-link.done .step-text {
  border-color: #2a2e30 !important;
}
.vx-wizard.nav.nav-tabs .step-wrapper.nav-item .step.nav-link.done:before, .vx-wizard.nav.nav-tabs .step-wrapper.nav-item .step.nav-link.done:after {
  background: #2a2e30 !important;
  box-shadow: none !important;
  height: 3px;
  top: 50% !important;
  z-index: -1;
  width: 50%;
  content: "";
  position: absolute;
  top: 50%;
  width: 45.5%;
}
.vx-wizard.nav.nav-tabs .step-wrapper.nav-item .step.nav-link.done:before {
  left: 0;
}
.vx-wizard.nav.nav-tabs .step-wrapper.nav-item .step.nav-link.done:after {
  right: 0;
}
.vx-wizard.nav.nav-tabs .step-wrapper.nav-item .step.nav-link:not(.active) .step-text {
  border: 3px solid #b8c2cc;
  color: #b8c2cc;
}

.vx-autocomplete-container {
  position: relative;
  border: "2px solid black";
}
.vx-autocomplete-container .vx-autocomplete-search {
  height: 100%;
  width: 100%;
  background-color: "#XXXXXX";
}
.vx-autocomplete-container .vx-autocomplete-search:focus {
  box-shadow: none;
}
.vx-autocomplete-container .suggestions-list {
  z-index: 998;
  list-style: none;
  padding-left: 0;
  border-radius: 0.5rem;
  max-height: 450px;
  height: auto;
  width: 100%;
  position: absolute;
  margin-top: 0.5rem;
  background-color: #fff;
  box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11), 0 5px 15px 0 rgba(0, 0, 0, 0.08);
}
.vx-autocomplete-container .suggestions-list .suggestion-item {
  padding: 0.85rem 1rem;
  color: #626262;
}
.vx-autocomplete-container .suggestions-list .suggestion-item a {
  color: #626262;
}
.vx-autocomplete-container .suggestions-list .suggestion-item.active, .vx-autocomplete-container .suggestions-list .suggestion-item:hover:not(.suggestion-title):not(.no-result) {
  background-color: #f8f8f8;
  color: #626262;
}
.vx-autocomplete-container .suggestions-list .suggestion-item:hover:not(.suggestion-title):not(.no-result) {
  cursor: pointer;
}

.loading {
  position: absolute;
  left: calc(50% - 35px);
  top: 50%;
  width: 55px;
  height: 55px;
  border-radius: 50%;
  box-sizing: border-box;
  border: 3px solid transparent;
}
.loading.component-loader {
  margin-top: -60px;
}
.loading .effect-1,
.loading .effect-2 {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid transparent;
  border-left: 3px solid rgb(121, 97, 249);
  border-radius: 50%;
  box-sizing: border-box;
}
.loading .effect-1 {
  animation: rotate 1s ease infinite;
}
.loading .effect-2 {
  animation: rotateOpacity 1s ease infinite 0.1s;
}
.loading .effect-3 {
  width: 100%;
  height: 100%;
  border: 3px solid transparent;
  border-left: 3px solid rgb(121, 97, 249);
  animation: rotateOpacity 1s ease infinite 0.2s;
  border-radius: 50%;
  box-sizing: border-box;
}
.loading .loading .effects {
  transition: all 0.3s ease;
}

.fallback-logo {
  position: absolute;
  left: calc(50% - 45px);
  top: 40%;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(1turn);
  }
}
@keyframes rotateOpacity {
  0% {
    transform: rotate(0deg);
    opacity: 0.1;
  }
  100% {
    transform: rotate(1turn);
    opacity: 1;
  }
}
.chat-widget .chat-app-window .user-chats {
  padding: 10px 20px;
  position: relative;
  text-align: center;
  height: 415px;
}
.chat-widget .chat-app-window .user-chats .chats {
  padding: 0;
}
.chat-widget .chat-app-window .user-chats .chats .chat-body {
  display: block;
  margin: 10px 30px 0 0;
  overflow: hidden;
}
.chat-widget .chat-app-window .user-chats .chats .chat-body .chat-content {
  text-align: left;
  display: block;
  float: right;
  padding: 0.75rem 1rem;
  margin: 0 20px 10px 0;
  clear: both;
  color: #fff;
  background: linear-gradient(118deg, #7367f0, rgba(115, 103, 240, 0.7));
  border-radius: 0.5rem;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.08);
}
.chat-widget .chat-app-window .user-chats .chats .chat-body .chat-content p {
  margin: 0;
}
.chat-widget .chat-app-window .user-chats .chats .chat-avatar {
  float: right;
}
.chat-widget .chat-app-window .user-chats .chats .chat-left .chat-avatar {
  float: left;
}
.chat-widget .chat-app-window .user-chats .chats .chat-left .chat-body {
  margin: 0;
}
.chat-widget .chat-app-window .user-chats .chats .chat-left .chat-content {
  text-align: left;
  float: left;
  margin: 10px 10px 10px 20px;
  color: #626262;
  background: none;
  background-color: white;
  border: 1px solid #dae1e7;
}

@media screen and (min-width: 0px) {
  head {
    font-family: "xs 0px";
  }
  body:after {
    content: "xs - min-width: 0px";
  }
}
@media screen and (min-width: 544px) {
  head {
    font-family: "sm 544px";
  }
  body:after {
    content: "sm - min-width: 544px";
  }
}
@media screen and (min-width: 768px) {
  head {
    font-family: "md 768px";
  }
  body:after {
    content: "md - min-width: 768px";
  }
}
@media screen and (min-width: 992px) {
  head {
    font-family: "lg 992px";
  }
  body:after {
    content: "lg - min-width: 992px";
  }
}
@media screen and (min-width: 1200px) {
  head {
    font-family: "xl 1200px";
  }
  body:after {
    content: "xl - min-width: 1200px";
  }
}
head {
  clear: both;
}
head title {
  font-family: "xs 0px, sm 544px, md 768px, lg 992px, xl 1200px";
}

body:after {
  display: none;
}

*[data-usn-if] {
  display: none;
}

.group-area {
  margin-bottom: 3rem;
}

.block {
  display: block;
  width: 100%;
}

/* Input with icon */
.form-control-position {
  position: absolute;
  top: 1px;
  right: 0;
  z-index: 2;
  display: block;
  width: 2.5rem;
  height: 2.5rem;
  line-height: 2.5rem;
  text-align: center;
}

/*---------------------------------
Input Icon
---------------------------------*/
.position-relative .form-control {
  padding-right: calc(1.25em + 1.4rem + 1px);
}
.position-relative .form-control.form-control-lg {
  padding-left: 2.5rem;
}
.position-relative .form-control.form-control-lg ~ .form-control-position {
  top: 9px;
}
.position-relative .form-control.form-control-sm ~ .form-control-position {
  top: -3px;
}

/* Input Icon left */
.has-icon-left .form-control {
  padding-right: 2rem;
  padding-left: 3rem;
}
.has-icon-left .form-control-position {
  right: auto;
  left: inherit;
}
.has-icon-left .form-control-position svg {
  position: relative;
  left: 5px;
  color: rgba(34, 41, 47, 0.4);
}

input[type=color] {
  height: calc(1.25em + 1.4rem + 1px);
}

input[type=date].form-control,
input[type=time].form-control,
input[type=datetime-local].form-control,
input[type=month].form-control {
  line-height: 1.45;
}

.font-size-large {
  font-size: 2rem;
}

.font-size-base {
  font-size: 1rem;
}

.font-size-small {
  font-size: 1rem;
}

.font-size-xsmall {
  font-size: 0.75rem;
}

.input-group-xs .form-control,
.input-group-xs .input-group-addon,
.input-group-xs .input-group-btn > button {
  padding: 0.175rem 0.5rem;
  font-size: 0.725rem;
  line-height: 1.677777;
  border-bottom-left-radius: 0.175rem;
  border-top-left-radius: 0.175rem;
}
.input-group-xs .input-group-btn > button {
  border-radius: 0.175rem;
}

.input-group-addon {
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
}

.floating-label-form-group-with-focus label,
.floating-label-form-group-with-value label {
  color: #7367f0 !important;
  text-transform: uppercase;
  font-weight: 400;
}

table.dataTable {
  border: 2px solid #f8f8f8;
}
table.dataTable th, table.dataTable td {
  border-bottom: 1px solid #f8f8f8;
  border-top: 0;
}
table.dataTable thead th, table.dataTable thead td, table.dataTable tfoot th, table.dataTable tfoot td {
  font-size: 0.85rem;
  border: 0;
}
table.dataTable thead tr {
  background-color: #f8f8f8;
}
table.dataTable thead .sorting, table.dataTable thead .sorting_asc, table.dataTable thead .sorting_desc {
  padding-right: inherit;
}
table.dataTable thead .sorting:before, table.dataTable thead .sorting_asc:before, table.dataTable thead .sorting_desc:before {
  font-family: "feather";
  content: "\\e845";
  padding-right: 0.3rem;
  font-size: 0.7rem;
  left: 0;
  top: 0.9rem;
}
table.dataTable thead .sorting:after, table.dataTable thead .sorting_asc:after, table.dataTable thead .sorting_desc:after {
  font-family: "feather";
  content: "\\e842";
  font-size: 0.7rem;
  left: 0;
  top: 1.3rem;
}
table.dataTable.table-striped tbody tr:nth-of-type(even) {
  background-color: #f8f8f8;
}
table.dataTable.table-striped tbody tr:nth-of-type(odd) {
  background-color: #fff;
}
table.dataTable.complex-headers {
  border: 1px solid #dae1e7;
}
table.dataTable.complex-headers thead th, table.dataTable.complex-headers thead td, table.dataTable.complex-headers tfoot th, table.dataTable.complex-headers tfoot td {
  border-bottom: 1px solid #dae1e7;
  border-right: 1px solid #dae1e7;
}
table.dataTable tbody tr.selected {
  background-color: rgba(115, 103, 240, 0.05) !important;
  color: #7367f0 !important;
  box-shadow: 0 0 1px 0 #7367f0 !important;
  border-radius: 5px;
}
table.dataTable tbody tr.selected td, table.dataTable tbody tr.selected th {
  border-bottom: 0;
}

div.dataTables_wrapper div.dataTables_filter label, div.dataTables_wrapper div.dataTables_length label {
  margin-top: 1rem;
}
div.dataTables_wrapper div.dataTables_filter select, div.dataTables_wrapper div.dataTables_length select {
  background-position: calc(100% - 3px) 5px, calc(100% - 20px) 13px, 100% 0;
  padding: 0 0.8rem;
}
div.dataTables_wrapper div.dataTables_paginate ul.pagination {
  margin-top: 1rem;
  padding-bottom: 7px;
}
div.dataTables_wrapper div.dataTables_paginate ul.pagination li a {
  font-size: 0.8rem;
}

tr.group {
  background-color: #ededed;
}

@media only screen and (max-width: 768px) {
  div.dataTables_wrapper div.dataTables_paginate ul.pagination {
    justify-content: center;
  }
}
/*========================================================
        DARK LAYOUT
=========================================================*/
body.dark-layout {
  background-color: #262c49;
  /********* UI ELEMENTS *********/
  /********* COMPONENTS *********/
  /********** FORMS **********/
  /********** TABLE **********/
  /********** PAGES **********/
  /********** CHARTS **********/
  /********** APPLICATIONS **********/
  /********** EXTENSIONS **********/
  /********** CUSTOMIZER **********/
  /********** HORIZONTAL Layout **********/
}
body.dark-layout h1, body.dark-layout .h1,
body.dark-layout h2,
body.dark-layout .h2,
body.dark-layout h3,
body.dark-layout .h3,
body.dark-layout h4,
body.dark-layout .h4,
body.dark-layout h5,
body.dark-layout .h5,
body.dark-layout h6,
body.dark-layout .h6 {
  color: #ebeefd;
}
body.dark-layout [class*=border-]:not(.bullet):not(.spinner-border) {
  border-color: #414561 !important;
}
body.dark-layout a:hover {
  color: #7367f0;
}
body.dark-layout p,
body.dark-layout small,
body.dark-layout .small,
body.dark-layout span,
body.dark-layout label {
  color: #c2c6dc;
}
body.dark-layout hr {
  border-color: #414561;
}
body.dark-layout pre {
  background-color: #262c49;
  border: 0;
}
body.dark-layout pre code {
  background-color: inherit;
  text-shadow: none;
}
body.dark-layout pre code .operator,
body.dark-layout pre code .url {
  background-color: #262c49;
}
body.dark-layout code {
  background-color: #262c49;
  color: #b8c2cc;
}
body.dark-layout kbd {
  background-color: #262c49;
}
body.dark-layout .component-code pre::-webkit-scrollbar-thumb {
  background: #c2c6dc;
}
body.dark-layout .component-code pre::-webkit-scrollbar-track {
  background: #343661;
}
body.dark-layout .text-dark {
  color: #b8c2cc !important;
}
body.dark-layout .header-navbar-shadow {
  background: linear-gradient(180deg, rgba(44, 48, 60, 0.9) 44%, rgba(44, 48, 60, 0.43) 73%, rgba(17, 30, 70, 0));
}
body.dark-layout .header-navbar {
  background-color: #10163a;
}
body.dark-layout .header-navbar .navbar-container .nav .nav-item .nav-link,
body.dark-layout .header-navbar .navbar-container .navbar-nav .nav-item .nav-link {
  color: #c2c6dc;
  background-color: transparent;
}
body.dark-layout .header-navbar .navbar-container .nav .nav-item .nav-link svg,
body.dark-layout .header-navbar .navbar-container .navbar-nav .nav-item .nav-link svg {
  stroke: #c2c6dc;
}
body.dark-layout .header-navbar .navbar-container .nav .nav-item.nav-search .search-input.open,
body.dark-layout .header-navbar .navbar-container .navbar-nav .nav-item.nav-search .search-input.open {
  background-color: #10163a;
}
body.dark-layout .header-navbar .navbar-container .nav .nav-item.nav-search .search-input.open .input,
body.dark-layout .header-navbar .navbar-container .navbar-nav .nav-item.nav-search .search-input.open .input {
  border-color: #414561;
}
body.dark-layout .header-navbar .navbar-container .nav .nav-item.nav-search .search-input.open .input,
body.dark-layout .header-navbar .navbar-container .nav .nav-item.nav-search .search-input.open .input::placeholder,
body.dark-layout .header-navbar .navbar-container .nav .nav-item.nav-search .search-input.open .search-input-close,
body.dark-layout .header-navbar .navbar-container .navbar-nav .nav-item.nav-search .search-input.open .input,
body.dark-layout .header-navbar .navbar-container .navbar-nav .nav-item.nav-search .search-input.open .input::placeholder,
body.dark-layout .header-navbar .navbar-container .navbar-nav .nav-item.nav-search .search-input.open .search-input-close {
  color: #c2c6dc;
}
body.dark-layout .header-navbar .navbar-container .nav .nav-item .bookmark-input .form-control,
body.dark-layout .header-navbar .navbar-container .navbar-nav .nav-item .bookmark-input .form-control {
  background-color: #10163a;
}
body.dark-layout .header-navbar .navbar-container .nav .nav-item .search-list,
body.dark-layout .header-navbar .navbar-container .navbar-nav .nav-item .search-list {
  background-color: #262c49;
}
body.dark-layout .header-navbar .navbar-container .nav .nav-item .search-list .current_item,
body.dark-layout .header-navbar .navbar-container .navbar-nav .nav-item .search-list .current_item {
  background-color: #10163a;
}
body.dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-menu.dropdown-menu-media,
body.dark-layout .header-navbar .navbar-container .navbar-nav .dropdown-notification .dropdown-menu.dropdown-menu-media {
  overflow: hidden;
}
body.dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-menu.dropdown-menu-media:before,
body.dark-layout .header-navbar .navbar-container .navbar-nav .dropdown-notification .dropdown-menu.dropdown-menu-media:before {
  display: none;
}
body.dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-menu.dropdown-menu-media .media,
body.dark-layout .header-navbar .navbar-container .navbar-nav .dropdown-notification .dropdown-menu.dropdown-menu-media .media {
  border-color: #414561;
}
body.dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-menu.dropdown-menu-media .media .media-body .notification-text,
body.dark-layout .header-navbar .navbar-container .navbar-nav .dropdown-notification .dropdown-menu.dropdown-menu-media .media .media-body .notification-text {
  color: #c2c6dc;
}
body.dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-menu.dropdown-menu-media .media .media-meta,
body.dark-layout .header-navbar .navbar-container .navbar-nav .dropdown-notification .dropdown-menu.dropdown-menu-media .media .media-meta {
  color: #c2c6dc;
}
body.dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-menu.dropdown-menu-media .media:hover,
body.dark-layout .header-navbar .navbar-container .navbar-nav .dropdown-notification .dropdown-menu.dropdown-menu-media .media:hover {
  background-color: #10163a;
}
body.dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-menu.dropdown-menu-media .dropdown-menu-footer,
body.dark-layout .header-navbar .navbar-container .navbar-nav .dropdown-notification .dropdown-menu.dropdown-menu-media .dropdown-menu-footer {
  background-color: #10163a;
}
body.dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-menu.dropdown-menu-media .dropdown-menu-footer .dropdown-item,
body.dark-layout .header-navbar .navbar-container .navbar-nav .dropdown-notification .dropdown-menu.dropdown-menu-media .dropdown-menu-footer .dropdown-item {
  color: #fff;
  border-color: #414561;
}
body.dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-menu.dropdown-menu-media .dropdown-menu-footer .dropdown-item:hover,
body.dark-layout .header-navbar .navbar-container .navbar-nav .dropdown-notification .dropdown-menu.dropdown-menu-media .dropdown-menu-footer .dropdown-item:hover {
  background-color: #10163a;
}
body.dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-cart.empty-cart:before,
body.dark-layout .header-navbar .navbar-container .navbar-nav .dropdown-notification .dropdown-cart.empty-cart:before {
  background-color: #262c49;
}
body.dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-cart li,
body.dark-layout .header-navbar .navbar-container .navbar-nav .dropdown-notification .dropdown-cart li {
  color: #fff;
}
body.dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-cart .dropdown-header span,
body.dark-layout .header-navbar .navbar-container .navbar-nav .dropdown-notification .dropdown-cart .dropdown-header span {
  color: #fff;
}
body.dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-cart .media-list .media,
body.dark-layout .header-navbar .navbar-container .navbar-nav .dropdown-notification .dropdown-cart .media-list .media {
  background-color: #fff;
}
body.dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-cart .media-list .media .media-body,
body.dark-layout .header-navbar .navbar-container .navbar-nav .dropdown-notification .dropdown-cart .media-list .media .media-body {
  background-color: #262c49;
  padding-left: 1rem !important;
}
body.dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-cart .media-list .media:hover,
body.dark-layout .header-navbar .navbar-container .navbar-nav .dropdown-notification .dropdown-cart .media-list .media:hover {
  background-color: #fff !important;
}
body.dark-layout .header-navbar.navbar-static-top {
  background-color: transparent;
}
body.dark-layout .header-navbar[class*=bg-] .navbar-nav .nav-item .nav-link {
  background-color: inherit;
}
body.dark-layout .header-navbar[class*=bg-] .navbar-nav .nav-item .nav-link svg {
  stroke: #fff;
}
body.dark-layout .header-navbar.bg-dark {
  background-color: #adb5bd !important;
}
body.dark-layout .main-menu {
  background-color: #10163a;
}
body.dark-layout .main-menu .shadow-bottom {
  background: linear-gradient(180deg, #0f1642 44%, rgba(15, 22, 66, 0.51) 73%, rgba(44, 48, 60, 0));
}
body.dark-layout .main-menu:not(.expanded) .navigation .sidebar-group-active a {
  background-color: #262c49;
}
body.dark-layout .main-menu.theme-dark .navbar-header .brand-text {
  color: #adb5bd !important;
}
body.dark-layout .main-menu.theme-dark .navigation .nav-item.active a {
  background: linear-gradient(118deg, #adb5bd, rgba(173, 181, 189, 0.7));
  box-shadow: 0 0 10px 1px rgba(173, 181, 189, 0.7);
}
body.dark-layout .main-menu.theme-dark .navigation .nav-item .menu-content li.active {
  background: linear-gradient(118deg, #adb5bd, rgba(173, 181, 189, 0.7));
  box-shadow: 0 0 10px 1px rgba(173, 181, 189, 0.7);
}
body.dark-layout .main-menu-content .navigation-main {
  background-color: #10163a;
}
body.dark-layout .main-menu-content .navigation-main .nav-item .menu-text {
  color: #c2c6dc;
}
body.dark-layout .main-menu-content .navigation-main .nav-item svg {
  stroke: #c2c6dc;
}
body.dark-layout .main-menu-content .navigation-main .nav-item.open a {
  background-color: #262c49;
}
body.dark-layout .main-menu-content .navigation-main .nav-item a:after {
  color: #c2c6dc;
}
body.dark-layout .main-menu-content .navigation-main .nav-item .menu-content {
  background-color: #10163a;
}
body.dark-layout .main-menu-content .navigation-main .nav-item .menu-content .active .menu-item {
  color: #fff;
}
body.dark-layout .main-menu-content .navigation-main .nav-item .menu-content li:not(.active) a {
  background-color: #10163a;
  color: #c2c6dc;
}
body.dark-layout .main-menu-content .navigation-main .active .menu-text,
body.dark-layout .main-menu-content .navigation-main .active svg,
body.dark-layout .main-menu-content .navigation-main .active span {
  color: #fff;
  stroke: #fff;
}
body.dark-layout .main-menu-content .navigation-main .sidebar-group-active a {
  background: #10163a;
  border-radius: 4px;
}
body.dark-layout .main-menu-content .navigation-main .sidebar-group-active .menu-content {
  background-color: #10163a;
}
body.dark-layout .main-menu-content .navigation-main .sidebar-group-active .menu-content .active {
  z-index: 1;
}
body.dark-layout .main-menu-content .navigation-main .sidebar-group-active .menu-content .active a {
  background-color: transparent;
}
body.dark-layout.menu-collapsed .main-menu:not(.expanded) .navigation-main li.active a {
  background: #262c49 !important;
}
body.dark-layout .bd-example .row,
body.dark-layout .bd-example .d-flex {
  background-color: #262c49;
}
body.dark-layout .bd-example .row .col,
body.dark-layout .bd-example .row [class*=col-],
body.dark-layout .bd-example .row .bd-highlight,
body.dark-layout .bd-example .d-flex .col,
body.dark-layout .bd-example .d-flex [class*=col-],
body.dark-layout .bd-example .d-flex .bd-highlight {
  background-color: #262c49;
  border-color: #808080;
}
body.dark-layout .bd-example .height-example-wrapper {
  background-color: #343661 !important;
}
body.dark-layout .bd-example .width-example,
body.dark-layout .bd-example .height-example {
  background-color: #262c49 !important;
}
body.dark-layout .bd-example-row-flex-cols .row {
  background-color: #262c49;
}
body.dark-layout .colors-container span {
  color: #fff;
}
body.dark-layout .alert .alert-heading,
body.dark-layout .alert p {
  color: inherit;
}
body.dark-layout .alert.alert-dark {
  color: #b8c2cc !important;
}
body.dark-layout .alert.alert-dark .alert-heading,
body.dark-layout .alert.alert-dark p {
  color: #b8c2cc;
}
body.dark-layout .content-header-left .breadcrumbs-top .content-header-title {
  color: #ebeefd;
}
body.dark-layout .content-header-left .breadcrumbs-top .breadcrumb-wrapper .breadcrumb .breadcrumb-item {
  color: #c2c6dc;
}
body.dark-layout .content-header-left .breadcrumbs-top .breadcrumb-wrapper .breadcrumb .breadcrumb-item:before {
  color: #c2c6dc;
}
body.dark-layout .content-header-left .breadcrumbs-top .breadcrumb-wrapper .breadcrumb .breadcrumb-item:not(.active) a:hover {
  color: #7367f0;
}
body.dark-layout #breadcrumb-slash .breadcrumb .breadcrumb-item,
body.dark-layout #breadcrumb-alignment .breadcrumb .breadcrumb-item {
  color: #c2c6dc;
}
body.dark-layout #breadcrumb-slash .breadcrumb .breadcrumb-item:before,
body.dark-layout #breadcrumb-alignment .breadcrumb .breadcrumb-item:before {
  color: #c2c6dc;
}
body.dark-layout #breadcrumb-slash .breadcrumb .breadcrumb-item:not(.active) a:hover,
body.dark-layout #breadcrumb-alignment .breadcrumb .breadcrumb-item:not(.active) a:hover {
  color: #7367f0;
}
body.dark-layout #component-breadcrumbs .breadcrumb .breadcrumb-item:not(.active) a {
  color: #c2c6dc;
}
body.dark-layout #component-breadcrumbs .breadcrumb .breadcrumb-item:before {
  color: #c2c6dc;
}
body.dark-layout #component-breadcrumbs .breadcrumb .breadcrumb-item.active span {
  color: #7367f0;
}
body.dark-layout .collapse-bordered .collapse-header {
  border-color: rgba(255, 255, 255, 0.04);
}
body.dark-layout .collapse-bordered.accordion-shadow {
  box-shadow: 0 0 8px 0 rgba(255, 255, 255, 0.1);
}
body.dark-layout .collapse-bordered .card {
  border-color: #414561;
}
body.dark-layout .accordion .collapse-border-item {
  border-color: rgba(255, 255, 255, 0.04);
}
body.dark-layout .collapse-margin {
  box-shadow: 0 2px 15px 0 rgba(255, 255, 255, 0.1);
}
body.dark-layout .accordion[data-toggle-hover=true] .card,
body.dark-layout .collapse[data-toggle-hover=true] .card {
  border-color: rgba(255, 255, 255, 0.04);
}
body.dark-layout .collapse-icon .card-header a {
  color: #c2c6dc;
}
body.dark-layout .btn span {
  color: #fff;
}
body.dark-layout .btn.btn-white span {
  color: #22292f;
}
body.dark-layout .btn.btn-icon i {
  color: #fff;
}
body.dark-layout .btn.btn-dark, body.dark-layout .btn.btn-outline-dark, body.dark-layout .btn.btn-flat-dark {
  color: #b8c2cc;
}
body.dark-layout .btn.btn-dark {
  background-color: #4e5154 !important;
}
body.dark-layout .btn.btn-outline-dark {
  border-color: #4e5154;
  color: #b8c2cc;
}
body.dark-layout .btn.btn-flat-dark:active, body.dark-layout .btn.btn-flat-dark:focus {
  background: #4e5154;
}
body.dark-layout .btn.btn-white {
  color: #626262;
}
body.dark-layout .dropdown-toggle {
  color: #fff;
}
body.dark-layout .dropdown-toggle:hover i, body.dark-layout .dropdown-toggle:hover:after {
  color: #fff;
}
body.dark-layout .dropdown-menu {
  background-color: #262c49;
}
body.dark-layout .dropdown-menu:before,
body.dark-layout .dropdown-menu .dropdown-item:hover,
body.dark-layout .dropdown-menu .dropdown-item:focus {
  background: #262c49;
}
body.dark-layout .dropdown-menu .dropdown-item {
  color: #c2c6dc;
}
body.dark-layout .dropdown-menu .form-control {
  background-color: #10163a;
}
body.dark-layout .dropdown-menu .dropdown-divider {
  border-color: #414561;
}
body.dark-layout .btn-white ~ .dropdown-menu .dropdown-item:not(.acitve):hover {
  color: #7367f0 !important;
}
body.dark-layout .btn-dark ~ .dropdown-menu .dropdown-item:hover,
body.dark-layout .btn-outline-dark ~ .dropdown-menu .dropdown-item:hover,
body.dark-layout .btn-flat-dark ~ .dropdown-menu .dropdown-item:hover {
  color: #c2c6dc;
}
body.dark-layout .dropup.dropdown-icon-wrapper .dropdown-menu .dropdown-item i {
  color: #c2c6dc;
}
body.dark-layout .modal .modal-header,
body.dark-layout .modal .modal-header[class*=bg-] {
  background-color: #10163a !important;
}
body.dark-layout .modal .modal-header .close,
body.dark-layout .modal .modal-header[class*=bg-] .close {
  background-color: #262c49;
  text-shadow: none;
}
body.dark-layout .modal .modal-header .close span,
body.dark-layout .modal .modal-header[class*=bg-] .close span {
  color: #fff;
}
body.dark-layout .modal .modal-content,
body.dark-layout .modal .modal-body,
body.dark-layout .modal .modal-footer {
  background-color: #262c49;
  color: #c2c6dc;
}
body.dark-layout .modal .modal-content .form-control,
body.dark-layout .modal .modal-content .picker__input,
body.dark-layout .modal .modal-content .custom-file-label,
body.dark-layout .modal .modal-content .custom-file-label:after,
body.dark-layout .modal .modal-body .form-control,
body.dark-layout .modal .modal-body .picker__input,
body.dark-layout .modal .modal-body .custom-file-label,
body.dark-layout .modal .modal-body .custom-file-label:after,
body.dark-layout .modal .modal-footer .form-control,
body.dark-layout .modal .modal-footer .picker__input,
body.dark-layout .modal .modal-footer .custom-file-label,
body.dark-layout .modal .modal-footer .custom-file-label:after {
  background-color: #10163a !important;
}
body.dark-layout .pagination:not([class*=pagination-]) .page-item.active {
  background-color: #262c49;
}
body.dark-layout .pagination:not([class*=pagination-]) .page-item.active .page-link {
  background-color: #7367f0;
}
body.dark-layout .pagination:not([class*=pagination-]) .page-item.active .page-link:hover {
  color: #fff;
}
body.dark-layout .pagination:not([class*=pagination-]) .page-item .page-link {
  background-color: #262c49;
  color: #fff;
}
body.dark-layout .pagination:not([class*=pagination-]) .page-item .page-link:hover {
  color: #7367f0;
}
body.dark-layout .pagination:not([class*=pagination-]) .page-item.prev-item .page-link:hover, body.dark-layout .pagination:not([class*=pagination-]) .page-item.next-item .page-link:hover {
  color: #fff;
}
body.dark-layout .pagination[class*=pagination-] .page-item:not(.active):not(:hover) .page-link {
  background-color: #262c49;
  color: #fff;
}
body.dark-layout .pagination[class*=pagination-] .page-item:not(.active) .page-link:hover {
  background-color: #262c49;
}
body.dark-layout .pagination[class*=pagination-] .page-item.active {
  background-color: #262c49;
}
body.dark-layout .nav .nav-item .nav-link {
  color: #c2c6dc;
}
body.dark-layout .nav .nav-item .nav-link.active, body.dark-layout .nav .nav-item .nav-link:hover {
  color: #7367f0;
}
body.dark-layout .nav.wrap-border {
  border-color: #414561;
}
body.dark-layout #navbar-component .basic-navbar .navbar {
  background-color: #262c49;
}
body.dark-layout #navbar-component .navbar .nav .nav-item a,
body.dark-layout #navbar-component .navbar .navbar-nav .nav-item a {
  color: #fff !important;
}
body.dark-layout #navbar-component .navbar .nav .nav-item .nav-link,
body.dark-layout #navbar-component .navbar .navbar-nav .nav-item .nav-link {
  background-color: inherit;
}
body.dark-layout #navbar-component .navbar .nav .nav-item .nav-link span,
body.dark-layout #navbar-component .navbar .navbar-nav .nav-item .nav-link span {
  color: #fff;
}
body.dark-layout #navbar-component .navbar .nav .nav-item .nav-link .badge,
body.dark-layout #navbar-component .navbar .nav .nav-item .nav-link svg,
body.dark-layout #navbar-component .navbar .navbar-nav .nav-item .nav-link .badge,
body.dark-layout #navbar-component .navbar .navbar-nav .nav-item .nav-link svg {
  color: #fff !important;
  stroke: #fff !important;
}
body.dark-layout .nav-tabs .nav-item .nav-link,
body.dark-layout .nav-tabs.nav-justified .nav-item .nav-link,
body.dark-layout .nav:not(.nav-pills) .nav-item .nav-link {
  background-color: #10163a;
}
body.dark-layout .nav-tabs .nav-item .nav-link.active,
body.dark-layout .nav-tabs.nav-justified .nav-item .nav-link.active,
body.dark-layout .nav:not(.nav-pills) .nav-item .nav-link.active {
  background-color: #10163a;
}
body.dark-layout .nav-tabs .nav-item .nav-link.disabled,
body.dark-layout .nav-tabs.nav-justified .nav-item .nav-link.disabled,
body.dark-layout .nav:not(.nav-pills) .nav-item .nav-link.disabled {
  opacity: 0.5;
}
body.dark-layout .nav-tabs ~ .tab-content .tab-pane,
body.dark-layout .nav-tabs.nav-justified ~ .tab-content .tab-pane,
body.dark-layout .nav:not(.nav-pills) ~ .tab-content .tab-pane {
  background-color: #10163a;
}
body.dark-layout .nav-vertical .nav.nav-tabs.nav-left ~ .tab-content .tab-pane, body.dark-layout .nav-vertical .nav.nav-tabs.nav-right ~ .tab-content .tab-pane {
  background-color: #10163a;
}
body.dark-layout .nav-pills .nav-item .nav-link.active {
  color: #fff;
}
body.dark-layout .nav-pills.nav-active-bordered-pill .nav-item .nav-link.active {
  background-color: transparent !important;
}
body.dark-layout .nav-justified.nav.nav-tabs .nav-item .nav-link.active {
  background-color: transparent;
}
body.dark-layout .card {
  background-color: #10163a;
}
body.dark-layout .card.border {
  border-color: #414561 !important;
}
body.dark-layout .card .card-title {
  color: #fff;
}
body.dark-layout .card .card-header,
body.dark-layout .card .card-footer {
  color: #c2c6dc;
  background-color: #10163a !important;
}
body.dark-layout .card .card-body,
body.dark-layout .card .card-footer {
  color: #c2c6dc;
  border-color: #414561;
}
body.dark-layout .card.overlay-img-card .card-img-overlay span,
body.dark-layout .card.overlay-img-card .card-img-overlay p {
  color: #fff;
}
body.dark-layout .media-bordered .media {
  border-color: #414561;
}
body.dark-layout .activity-timeline {
  border-color: #414561;
}
body.dark-layout #dashboard-analytics .bg-analytics {
  background: linear-gradient(118deg, #7367f0, rgba(115, 103, 240, 0.7));
}
body.dark-layout #dashboard-analytics .bg-analytics p {
  color: #fff;
}
body.dark-layout #dashboard-analytics .bg-analytics .card-body {
  background-color: transparent;
}
body.dark-layout .chat-widget.chat-application .chat-app-window .user-chats .chats .chat-body .chat-content p {
  color: #fff;
}
body.dark-layout .chat-widget.chat-application .chat-app-window .user-chats .chats .chat-left .chat-content {
  background-color: #171e49;
  border: 1px solid #414561;
}
body.dark-layout .chat-widget.chat-application .chat-app-window .user-chats .chats .chat-left .chat-content p {
  color: #c2c6dc;
}
body.dark-layout .chat-widget.chat-application .chat-app-window .chat-footer {
  border-top: 1px solid #414561;
}
body.dark-layout .chat-widget.chat-application .chat-app-window .chat-footer .card-body {
  padding-top: 1.5rem !important;
}
body.dark-layout .badge {
  color: #fff;
}
body.dark-layout .badge span {
  color: #fff;
}
body.dark-layout .badge:hover i {
  color: #fff;
}
body.dark-layout .popover[x-placement=top] .arrow:after {
  border-top-color: #262c49;
}
body.dark-layout .popover[x-placement=bottom] .arrow:after {
  border-bottom-color: #7367f0;
}
body.dark-layout .popover[x-placement=left] .arrow:after {
  border-left-color: #262c49;
}
body.dark-layout .popover[x-placement=right] .arrow:after {
  border-right-color: #262c49;
}
body.dark-layout .popover .popover-body {
  background-color: #262c49;
  color: #c2c6dc;
}
body.dark-layout .toast {
  background-color: #262c49;
  box-shadow: -5px 5px 5px 0px rgba(0, 0, 0, 0.3);
}
body.dark-layout .toast .toast-header {
  background-color: #262c49;
  color: #c2c6dc;
  border-color: #414561;
}
body.dark-layout .toast .toast-header .close {
  text-shadow: none;
  opacity: 1;
}
body.dark-layout .toast .toast-body {
  background-color: #262c49;
  color: #c2c6dc;
}
body.dark-layout .progress {
  background-color: #262c49;
}
body.dark-layout .avatar {
  background-color: #262c49;
}
body.dark-layout .avatar .avatar-content {
  color: #fff;
}
body.dark-layout .chip {
  background-color: #262c49;
}
body.dark-layout .chip .avatar {
  background-color: #10163a;
}
body.dark-layout .chip .chip-body .chip-text,
body.dark-layout .chip .chip-body span {
  color: #fff;
}
body.dark-layout .divider .divider-text {
  background-color: transparent;
  color: #c2c6dc;
}
body.dark-layout .divider .divider-text::before, body.dark-layout .divider .divider-text::after {
  border-color: #414561;
}
body.dark-layout .divider.divider-dark .divider-text::before, body.dark-layout .divider.divider-dark .divider-text::after {
  border-color: #4e5154 !important;
}
body.dark-layout .vx-wizard.nav.nav-tabs .step-wrapper.nav-item .step.nav-link:not(.active) .step-text {
  background-color: #262c49;
}
body.dark-layout .vx-wizard.nav.nav-tabs .step-wrapper.nav-item .step.nav-link:not(.active) .step-text svg {
  color: #c2c6dc;
}
body.dark-layout .list-group .list-group-item:not([class*=list-group-item-]), body.dark-layout .list-group .list-group-item.list-group-item-action {
  background-color: #10163a;
  border-color: #414561;
  color: #c2c6dc;
}
body.dark-layout .list-group .list-group-item:not([class*=list-group-item-]):hover, body.dark-layout .list-group .list-group-item.list-group-item-action:hover {
  background-color: #262c49;
}
body.dark-layout .list-group .list-group-item.active {
  background-color: #7367f0;
  color: #fff;
}
body.dark-layout .list-group .list-group-item.active p,
body.dark-layout .list-group .list-group-item.active small,
body.dark-layout .list-group .list-group-item.active .small {
  color: #fff;
}
body.dark-layout .list-group .list-group-item.disabled {
  background-color: #262c49;
}
body.dark-layout input.form-control,
body.dark-layout .custom-file-label,
body.dark-layout textarea.form-control {
  background-color: #262c49;
  color: #c2c6dc;
}
body.dark-layout input.form-control:not(:focus),
body.dark-layout .custom-file-label:not(:focus),
body.dark-layout textarea.form-control:not(:focus) {
  border: 0;
}
body.dark-layout input.form-control::placeholder,
body.dark-layout .custom-file-label::placeholder,
body.dark-layout textarea.form-control::placeholder {
  color: #c2c6dc;
}
body.dark-layout input.form-control ~ .form-control-position svg,
body.dark-layout .custom-file-label ~ .form-control-position svg,
body.dark-layout textarea.form-control ~ .form-control-position svg {
  color: #c2c6dc;
}
body.dark-layout input.form-control:focus ~ .form-control-position i,
body.dark-layout .custom-file-label:focus ~ .form-control-position i,
body.dark-layout textarea.form-control:focus ~ .form-control-position i {
  color: #7367f0;
}
body.dark-layout input.form-control:disabled, body.dark-layout input.form-control[readonly],
body.dark-layout .custom-file-label:disabled,
body.dark-layout .custom-file-label[readonly],
body.dark-layout textarea.form-control:disabled,
body.dark-layout textarea.form-control[readonly] {
  opacity: 0.5;
}
body.dark-layout .char-textarea.active {
  color: #c2c6dc !important;
}
body.dark-layout .char-textarea.max-limit {
  color: #ea5455 !important;
}
body.dark-layout .custom-file-label:after {
  background-color: #262c49;
  border-left: 1px solid #414561;
  color: #c2c6dc;
}
body.dark-layout .has-icon-left.input-divider-left .form-control-position i {
  border-right-color: #414561;
}
body.dark-layout .has-icon-left.input-divider-right .form-control-position i {
  border-left-color: #414561;
}
body.dark-layout select.form-control,
body.dark-layout .custom-select {
  background-color: #262c49;
  color: #c2c6dc;
  border: 0;
}
body.dark-layout select.form-control option:checked,
body.dark-layout .custom-select option:checked {
  background-color: #10163a;
}
body.dark-layout .custom-control.custom-radio input[disabled] ~ label:before, body.dark-layout .custom-control.custom-radio input[disabled] ~ label:after, body.dark-layout .custom-control.custom-checkbox input[disabled] ~ label:before, body.dark-layout .custom-control.custom-checkbox input[disabled] ~ label:after {
  opacity: 0.5;
}
body.dark-layout .select__control,
body.dark-layout .React__control {
  background-color: #262c49;
  border-color: #414561;
}
body.dark-layout .select__control .select__value-container .select__single-value,
body.dark-layout .select__control .select__value-container .React__single-value,
body.dark-layout .select__control .React__value-container .select__single-value,
body.dark-layout .select__control .React__value-container .React__single-value,
body.dark-layout .React__control .select__value-container .select__single-value,
body.dark-layout .React__control .select__value-container .React__single-value,
body.dark-layout .React__control .React__value-container .select__single-value,
body.dark-layout .React__control .React__value-container .React__single-value {
  color: #c2c6dc;
}
body.dark-layout .select__control .select__value-container .select__multi-value,
body.dark-layout .select__control .React__value-container .select__multi-value,
body.dark-layout .React__control .select__value-container .select__multi-value,
body.dark-layout .React__control .React__value-container .select__multi-value {
  background-color: #10163a;
}
body.dark-layout .select__control .select__value-container .select__multi-value .select__multi-value__label,
body.dark-layout .select__control .React__value-container .select__multi-value .select__multi-value__label,
body.dark-layout .React__control .select__value-container .select__multi-value .select__multi-value__label,
body.dark-layout .React__control .React__value-container .select__multi-value .select__multi-value__label {
  color: #c2c6dc;
}
body.dark-layout .select__control ~ .select__menu,
body.dark-layout .select__control ~ .React__menu,
body.dark-layout .React__control ~ .select__menu,
body.dark-layout .React__control ~ .React__menu {
  background-color: #262c49;
}
body.dark-layout .select__control ~ .select__menu .select__menu-list.select__option--is-selected, body.dark-layout .select__control ~ .select__menu .select__menu-list.React__option--is-selected,
body.dark-layout .select__control ~ .select__menu .React__menu-list.select__option--is-selected,
body.dark-layout .select__control ~ .select__menu .React__menu-list.React__option--is-selected,
body.dark-layout .select__control ~ .React__menu .select__menu-list.select__option--is-selected,
body.dark-layout .select__control ~ .React__menu .select__menu-list.React__option--is-selected,
body.dark-layout .select__control ~ .React__menu .React__menu-list.select__option--is-selected,
body.dark-layout .select__control ~ .React__menu .React__menu-list.React__option--is-selected,
body.dark-layout .React__control ~ .select__menu .select__menu-list.select__option--is-selected,
body.dark-layout .React__control ~ .select__menu .select__menu-list.React__option--is-selected,
body.dark-layout .React__control ~ .select__menu .React__menu-list.select__option--is-selected,
body.dark-layout .React__control ~ .select__menu .React__menu-list.React__option--is-selected,
body.dark-layout .React__control ~ .React__menu .select__menu-list.select__option--is-selected,
body.dark-layout .React__control ~ .React__menu .select__menu-list.React__option--is-selected,
body.dark-layout .React__control ~ .React__menu .React__menu-list.select__option--is-selected,
body.dark-layout .React__control ~ .React__menu .React__menu-list.React__option--is-selected {
  background-color: #10163a;
}
body.dark-layout .select__control.select__control--is-focused .select__loading-indicator,
body.dark-layout .React__control.select__control--is-focused .select__loading-indicator {
  color: #c2c6dc;
}
body.dark-layout .select__control.select__control--is-focused .select__loading-indicator span,
body.dark-layout .React__control.select__control--is-focused .select__loading-indicator span {
  background-color: #c2c6dc;
}
body.dark-layout .react-numeric-input {
  background-color: #262c49 !important;
}
body.dark-layout .react-numeric-input input {
  background-color: #262c49 !important;
  color: #c2c6dc !important;
}
body.dark-layout .react-toggle-wrapper .react-toggle:not(.react-toggle--checked):not([class*=switch-]) .react-toggle-track {
  background-color: #262c49;
}
body.dark-layout .react-toggle-wrapper .react-toggle .react-toggle-track .react-toggle-track-x svg,
body.dark-layout .react-toggle-wrapper .react-toggle .react-toggle-track .react-toggle-track-check svg {
  stroke: #fff;
  fill: #fff;
}
body.dark-layout .custom-switch .custom-control-input[disabled] ~ .custom-control-label {
  opacity: 0.5;
}
body.dark-layout .custom-switch .custom-control-input:not(:disabled):active ~ .custom-control-label::before {
  background-color: #7367f0;
}
body.dark-layout .custom-switch .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #7367f0;
}
body.dark-layout .custom-switch .custom-control-label:before {
  background-color: #262c49;
}
body.dark-layout .input-group .input-group-prepend .input-group-text,
body.dark-layout .input-group .input-group-append .input-group-text {
  background-color: #10163a;
  border: 1px solid #414561;
}
body.dark-layout .input-group .input-group-prepend ~ .form-control {
  border-left: 1px solid #414561;
}
body.dark-layout .input-group .form-control ~ .input-group-append {
  border-left: 1px solid #414561;
}
body.dark-layout .form-label-group > input:not(:focus):not(:placeholder-shown) ~ label, body.dark-layout .form-label-group > textarea:not(:focus):not(:placeholder-shown) ~ label {
  color: #c2c6dc !important;
}
body.dark-layout .form-control.flatpickr-input {
  background-color: #262c49;
}
body.dark-layout .form-control.flatpickr-input ~ input {
  background-color: #262c49;
}
body.dark-layout .flatpickr-calendar:not(.inline):after, body.dark-layout .flatpickr-calendar:not(.inline):before {
  border-bottom-color: #7367f0;
}
body.dark-layout .flatpickr-calendar .flatpickr-innerContainer {
  background: #262c49;
  border-color: #262c49;
}
body.dark-layout .flatpickr-calendar .flatpickr-months .flatpickr-prev-month,
body.dark-layout .flatpickr-calendar .flatpickr-months .flatpickr-next-month {
  fill: #fff;
  color: #fff;
}
body.dark-layout .flatpickr-calendar .flatpickr-months .flatpickr-month select:hover {
  background: #fff;
}
body.dark-layout .flatpickr-calendar .flatpickr-months .numInputWrapper .numInput {
  color: #fff;
}
body.dark-layout .flatpickr-calendar .flatpickr-days {
  border-color: #262c49;
}
body.dark-layout .flatpickr-calendar .flatpickr-days .flatpickr-day:hover, body.dark-layout .flatpickr-calendar .flatpickr-days .flatpickr-day:focus {
  background-color: #10163a;
  border-color: #10163a;
}
body.dark-layout .flatpickr-calendar .flatpickr-days .flatpickr-day.prevMonthDay, body.dark-layout .flatpickr-calendar .flatpickr-days .flatpickr-day.nextMonthDay, body.dark-layout .flatpickr-calendar .flatpickr-days .flatpickr-day.flatpickr-disabled {
  color: #636363;
}
body.dark-layout .flatpickr-calendar .flatpickr-weekdays,
body.dark-layout .flatpickr-calendar .flatpickr-weekday {
  color: #fff;
}
body.dark-layout .table:not(.table-inverse) {
  background-color: #212744;
}
body.dark-layout .table:not(.table-inverse) .thead tr:not([class*=table-]) th,
body.dark-layout .table:not(.table-inverse) .thead tr:not([class*=table-]) td,
body.dark-layout .table:not(.table-inverse) tbody tr:not([class*=table-]) th,
body.dark-layout .table:not(.table-inverse) tbody tr:not([class*=table-]) td {
  border-color: #414561;
  color: #c2c6dc;
}
body.dark-layout .table:not(.table-inverse) .thead tr:not([class*=table-]) th code,
body.dark-layout .table:not(.table-inverse) .thead tr:not([class*=table-]) td code,
body.dark-layout .table:not(.table-inverse) tbody tr:not([class*=table-]) th code,
body.dark-layout .table:not(.table-inverse) tbody tr:not([class*=table-]) td code {
  background-color: #10163a;
}
body.dark-layout .table:not(.table-inverse) thead tr th {
  border: 0;
  background-color: #212744;
  color: #c2c6dc;
}
body.dark-layout .table:not(.table-inverse) tbody tr[class*=table-] td,
body.dark-layout .table:not(.table-inverse) tbody tr[class*=table-] th {
  background-color: unset;
  color: #22292f;
  border-color: #414561;
}
body.dark-layout .table:not(.table-inverse) tbody tr.table-dark td,
body.dark-layout .table:not(.table-inverse) tbody tr.table-dark th {
  color: #fff;
}
body.dark-layout .table:not(.table-inverse) tbody tr.table-active td,
body.dark-layout .table:not(.table-inverse) tbody tr.table-active th {
  color: #c2c6dc;
}
body.dark-layout .table:not(.table-inverse) tbody tr th {
  background-color: #262c49;
}
body.dark-layout .table:not(.table-inverse) tbody tr td {
  background-color: #262c49;
  color: #c2c6dc;
}
body.dark-layout .table:not(.table-inverse).table-bordered {
  border: 1px solid #414561;
}
body.dark-layout .table:not(.table-inverse).table-bordered thead tr th,
body.dark-layout .table:not(.table-inverse).table-bordered thead tr td,
body.dark-layout .table:not(.table-inverse).table-bordered tbody tr th,
body.dark-layout .table:not(.table-inverse).table-bordered tbody tr td {
  border: 1px solid #414561;
}
body.dark-layout .table:not(.table-inverse).table-hover tbody tr:hover {
  background-color: #10163a;
}
body.dark-layout .table:not(.table-inverse).table-hover tbody tr th,
body.dark-layout .table:not(.table-inverse).table-hover tbody tr td {
  background-color: unset;
}
body.dark-layout .table:not(.table-inverse).table-striped tbody tr:nth-of-type(odd) {
  background-color: #10163a;
}
body.dark-layout .table:not(.table-inverse).table-striped tbody tr td,
body.dark-layout .table:not(.table-inverse).table-striped tbody tr th {
  background-color: unset;
}
body.dark-layout .table:not(.table-inverse).table-mx-0 {
  background-color: #10163a;
}
body.dark-layout .table:not(.table-inverse).table-mx-0 thead tr th,
body.dark-layout .table:not(.table-inverse).table-mx-0 thead tr td,
body.dark-layout .table:not(.table-inverse).table-mx-0 tbody tr th,
body.dark-layout .table:not(.table-inverse).table-mx-0 tbody tr td {
  background-color: #10163a;
}
body.dark-layout .ReactTable .rt-table .rt-thead {
  border-color: #414561;
}
body.dark-layout .ReactTable .rt-table .rt-thead .rt-th {
  background-color: #262c49;
  border-color: #414561;
}
body.dark-layout .ReactTable .rt-table .rt-thead .rt-th input,
body.dark-layout .ReactTable .rt-table .rt-thead .rt-th select {
  background-color: #10163a;
  color: #c2c6dc;
}
body.dark-layout .ReactTable .rt-table .rt-tbody .rt-tr .rt-td {
  background-color: #262c49;
  border-color: #414561;
}
body.dark-layout .ReactTable .rt-table .rt-tbody .rt-tr .rt-td div:not(.rt-expander) {
  background-color: #262c49 !important;
}
body.dark-layout .ReactTable .rt-table .rt-tbody .rt-tr .rt-td.rt-expandable {
  background-color: #262c49 !important;
}
body.dark-layout .ReactTable .rt-table .rt-tbody .rt-tr .rt-td.rt-expandable .rt-expander:after {
  border-top-color: #c2c6dc;
}
body.dark-layout .ReactTable .rt-table .rt-tbody .rt-tr-group {
  border-color: #414561;
}
body.dark-layout .ReactTable .pagination-bottom .-pageJump input {
  background-color: #262c49;
  color: #c2c6dc;
}
body.dark-layout .ReactTable .pagination-bottom .select-wrap select {
  background-color: #262c49;
  color: #c2c6dc;
}
body.dark-layout .ReactTable.nested-table .rt-tbody .rt-tr-group .rt-td:first-child {
  background-color: #262c49 !important;
}
body.dark-layout .ag-grid-table {
  background-color: #10163a;
}
body.dark-layout .ag-grid-table .ag-dropdown {
  border-color: #414561;
}
body.dark-layout .ag-grid-table .ag-dropdown div {
  color: #c2c6dc;
}
body.dark-layout .ag-grid-table .ag-pinned-left-header {
  border-color: #414561;
}
body.dark-layout .ag-grid-table .ag-root-wrapper .ag-root-wrapper-body .ag-header {
  background-color: #10163a;
  border-color: #414561;
}
body.dark-layout .ag-grid-table .ag-root-wrapper .ag-root-wrapper-body .ag-header .ag-header-cell {
  border-color: #414561;
  background-color: #10163a;
}
body.dark-layout .ag-grid-table .ag-root-wrapper .ag-root-wrapper-body .ag-header .ag-header-cell-label,
body.dark-layout .ag-grid-table .ag-root-wrapper .ag-root-wrapper-body .ag-header .ag-floating-filter-input {
  color: #c2c6dc;
}
body.dark-layout .ag-grid-table .ag-root-wrapper .ag-root-wrapper-body .ag-header .ag-floating-filter-input {
  border-color: #414561;
}
body.dark-layout .ag-grid-table .ag-root-wrapper .ag-root-wrapper-body .ag-body-viewport .ag-cell {
  color: #c2c6dc;
  border-color: #414561;
}
body.dark-layout .ag-grid-table .ag-root-wrapper .ag-root-wrapper-body .ag-body-viewport .ag-row {
  border-color: #414561;
}
body.dark-layout .ag-grid-table .ag-row-hover,
body.dark-layout .ag-grid-table .ag-header-cell:hover,
body.dark-layout .ag-grid-table .ag-row-selected {
  background-color: #262c49 !important;
}
body.dark-layout .ag-grid-table .ag-icon {
  color: #c2c6dc;
}
body.dark-layout .ag-grid-table .ag-icon.ag-icon-checkbox-checked {
  color: #7367f0;
}
body.dark-layout .ag-grid-table .ag-paging-panel {
  border-color: #414561;
}
body.dark-layout .ag-grid-table .ag-paging-panel .ag-paging-button.ag-disabled {
  background-color: #373f6d;
}
body.dark-layout .ag-grid-table .ag-paging-panel .ag-paging-button.ag-disabled span {
  color: #fff !important;
}
body.dark-layout .ag-grid-table .ag-paging-panel span[ref=lbTotal] {
  background-color: #373f6d;
  color: #c2c6dc !important;
}
body.dark-layout .ag-grid-table .ag-menu {
  background-color: #262c49;
}
body.dark-layout .ag-grid-table .ag-menu .ag-filter-select {
  border-color: #414561;
  color: #c2c6dc;
}
body.dark-layout .ag-grid-table .ag-menu .ag-filter-select option {
  color: #c2c6dc;
  background-color: #262c49;
}
body.dark-layout .ag-grid-table .ag-menu .ag-input-wrapper .ag-filter-filter {
  color: #c2c6dc;
  border-color: #414561;
}
body.dark-layout .ag-grid-table .ag-menu .ag-input-wrapper .ag-filter-filter::placeholder {
  color: #c2c6dc;
}
body.dark-layout .ag-grid-table ::-webkit-scrollbar-thumb {
  background: #7367f0;
}
body.dark-layout .ag-grid-table ::-webkit-scrollbar-track {
  background: #262c49;
}
body.dark-layout .sweet-alert {
  background-color: #10163a !important;
}
body.dark-layout .sweet-alert h2, body.dark-layout .sweet-alert .h2, body.dark-layout .sweet-alert p {
  color: #c2c6dc !important;
}
body.dark-layout .bg-authentication {
  background-color: #eff2f7;
}
body.dark-layout .bg-authentication .auth-title {
  color: #c2c6dc;
}
body.dark-layout .bg-authentication .form-group.row,
body.dark-layout .bg-authentication .card-footer {
  background-color: #10163a;
}
body.dark-layout .bg-authentication .form-group.row .btn-facebook span,
body.dark-layout .bg-authentication .form-group.row .btn-twitter span,
body.dark-layout .bg-authentication .card-footer .btn-facebook span,
body.dark-layout .bg-authentication .card-footer .btn-twitter span {
  color: #fff;
}
body.dark-layout .bg-authentication .form-group .vx-checkbox-con span {
  color: #c2c6dc;
}
body.dark-layout .getting-started .clockCard p {
  color: #c2c6dc !important;
}
body.dark-layout .auth-card h1, body.dark-layout .auth-card .h1 {
  color: #2c2c2c;
}
body.dark-layout .auth-card p {
  color: #fff;
}
body.dark-layout #user-profile .profile-header img {
  border-color: #fff !important;
}
body.dark-layout #user-profile .profile-header .profile-header-nav {
  background-color: #10163a;
}
body.dark-layout #user-profile .profile-header .navbar svg {
  color: #c2c6dc;
}
body.dark-layout #user-profile .btn-load.loading {
  background-color: rgba(255, 255, 255, 0.75) !important;
}
body.dark-layout .account-settings-tab .nav-link {
  background: transparent !important;
}
body.dark-layout #search-website .search-bar .form-control {
  background-color: #10163a;
}
body.dark-layout #search-website .search-menu .search-filter {
  background-color: #10163a;
  color: #c2c6dc;
}
body.dark-layout #search-website .search-result-info .dropdown-toggle {
  color: #c2c6dc;
}
body.dark-layout #search-website .search-pagination .pagination .page-item {
  background-color: #10163a;
}
body.dark-layout #search-website .search-pagination .pagination .page-item.active .page-link {
  background-color: #7367f0;
}
body.dark-layout #search-website .search-pagination .pagination .page-item .page-link {
  background-color: #10163a;
}
body.dark-layout .faq .accordion .collapse-margin {
  background-color: #10163a;
}
body.dark-layout .faq-bg .card-body .card-text,
body.dark-layout .knowledge-base-bg .card-body .card-text {
  color: #fff;
}
body.dark-layout .search-content .card .card-body .text-dark {
  color: #c2c6dc !important;
}
body.dark-layout .knowledge-base-category .list-group .list-group-item,
body.dark-layout .knowledge-base-question .list-group .list-group-item {
  color: #7367f0;
}
body.dark-layout .invoice-items-table .table-borderless,
body.dark-layout .invoice-total-table .table-borderless {
  border: 0;
}
body.dark-layout .invoice-header .input-group .form-control {
  background-color: #10163a;
}
body.dark-layout .apexcharts-canvas .apexcharts-gridlines-horizontal .apexcharts-gridline {
  stroke: #414561;
}
body.dark-layout .apexcharts-canvas .apexcharts-tooltip.light,
body.dark-layout .apexcharts-canvas .apexcharts-yaxistooltip,
body.dark-layout .apexcharts-canvas .apexcharts-xaxistooltip,
body.dark-layout .apexcharts-canvas .apexcharts-tooltip {
  background-color: #212744;
  border-color: #262c49;
}
body.dark-layout .apexcharts-canvas .apexcharts-tooltip.light .apexcharts-tooltip-title,
body.dark-layout .apexcharts-canvas .apexcharts-tooltip.light .apexcharts-tooltip-text,
body.dark-layout .apexcharts-canvas .apexcharts-yaxistooltip .apexcharts-tooltip-title,
body.dark-layout .apexcharts-canvas .apexcharts-yaxistooltip .apexcharts-tooltip-text,
body.dark-layout .apexcharts-canvas .apexcharts-xaxistooltip .apexcharts-tooltip-title,
body.dark-layout .apexcharts-canvas .apexcharts-xaxistooltip .apexcharts-tooltip-text,
body.dark-layout .apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-title,
body.dark-layout .apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-text {
  background-color: #212744;
  color: #c2c6dc;
}
body.dark-layout .apexcharts-canvas .apexcharts-tooltip.dark .apexcharts-tooltip-text .apexcharts-tooltip-text-label,
body.dark-layout .apexcharts-canvas .apexcharts-tooltip.dark .apexcharts-tooltip-text .apexcharts-tooltip-text-value {
  color: #fff;
}
body.dark-layout .apexcharts-canvas .apexcharts-xaxistooltip-bottom:before {
  border-bottom-color: transparent;
}
body.dark-layout .apexcharts-canvas .apexcharts-xaxistooltip-bottom:after {
  border-bottom-color: #262c49;
}
body.dark-layout .apexcharts-canvas .apexcharts-yaxistooltip-left:before {
  border-left-color: transparent;
}
body.dark-layout .apexcharts-canvas .apexcharts-yaxistooltip-left:after {
  border-left-color: #262c49;
}
body.dark-layout .apexcharts-canvas text {
  fill: #fff !important;
}
body.dark-layout .apexcharts-canvas .apexcharts-legend-series .apexcharts-legend-text {
  color: #c2c6dc !important;
}
body.dark-layout .apexcharts-canvas .apexcharts-radialbar-track path {
  stroke: #262c49;
}
body.dark-layout .apexcharts-canvas .apexcharts-inner polygon {
  stroke: #212744 !important;
  fill: #262c49 !important;
}
body.dark-layout .apexcharts-canvas .apexcharts-inner rect {
  fill: #10163a;
}
body.dark-layout .apexcharts-canvas .apexcharts-pie-series path {
  stroke: #262c49;
}
body.dark-layout .apexcharts-canvas .apexcharts-menu {
  background-color: #262c49;
  border: 0;
}
body.dark-layout .apexcharts-canvas .apexcharts-toolbar .apexcharts-zoom-in-icon:hover svg,
body.dark-layout .apexcharts-canvas .apexcharts-toolbar .apexcharts-zoom-out-icon:hover svg,
body.dark-layout .apexcharts-canvas .apexcharts-toolbar .apexcharts-zoom-icon:hover svg,
body.dark-layout .apexcharts-canvas .apexcharts-toolbar .apexcharts-menu-icon:hover svg,
body.dark-layout .apexcharts-canvas .apexcharts-toolbar .apexcharts-reset-zoom-icon:hover svg {
  fill: #c2c6dc;
}
body.dark-layout .apexcharts-canvas .apexcharts-toolbar .apexcharts-menu-item {
  color: #c2c6dc;
}
body.dark-layout .apexcharts-canvas .apexcharts-toolbar .apexcharts-menu-item:hover {
  background-color: #10163a;
}
body.dark-layout .recharts-wrapper line {
  stroke: #c2c6dc;
}
body.dark-layout .recharts-wrapper text {
  fill: #fff;
}
body.dark-layout .recharts-wrapper .recharts-default-tooltip {
  background-color: #10163a !important;
  border-color: #414561 !important;
  color: #c2c6dc;
}
body.dark-layout .recharts-wrapper .recharts-rectangle.recharts-tooltip-cursor {
  fill: #262c49 !important;
}
body.dark-layout .recharts-wrapper .recharts-pie-sector .recharts-sector {
  stroke: #414561;
}
body.dark-layout .recharts-wrapper .recharts-radial-bar-background .recharts-radial-bar-background-sector {
  fill: #262c49;
}
body.dark-layout .dropdown-divider {
  border-color: #414561;
}
body.dark-layout .email-application .email-app-sidebar {
  background-color: #10163a;
  border-color: #414561;
}
body.dark-layout .email-application .app-fixed-search {
  background-color: #10163a;
  border-color: #414561;
}
body.dark-layout .email-application .app-fixed-search svg {
  color: #c2c6dc;
}
body.dark-layout .email-application .app-fixed-search .form-control {
  color: #c2c6dc;
}
body.dark-layout .email-application .app-fixed-search .form-control::placeholder {
  color: #c2c6dc;
}
body.dark-layout .email-application .app-fixed-search .form-control:focus ~ .form-control-position svg {
  color: #7367f0;
}
body.dark-layout .email-application .app-fixed-search .form-control-position svg {
  color: #c2c6dc;
}
body.dark-layout .email-application .email-app-list-wrapper {
  border-color: #414561;
}
body.dark-layout .email-application .email-app-list-wrapper .app-action {
  border-color: #414561;
}
body.dark-layout .email-application .email-app-menu .sidebar-menu-list .list-group-messages .list-group-item,
body.dark-layout .email-application .email-app-menu .sidebar-menu-list .list-group-labels .list-group-item {
  background: #10163a;
}
body.dark-layout .email-application .email-app-menu .sidebar-menu-list .list-group-messages .list-group-item.active, body.dark-layout .email-application .email-app-menu .sidebar-menu-list .list-group-messages .list-group-item.active:hover,
body.dark-layout .email-application .email-app-menu .sidebar-menu-list .list-group-labels .list-group-item.active,
body.dark-layout .email-application .email-app-menu .sidebar-menu-list .list-group-labels .list-group-item.active:hover {
  color: #7367f0;
}
body.dark-layout .email-application .email-app-menu .sidebar-menu-list .list-group-messages .list-group-item:hover,
body.dark-layout .email-application .email-app-menu .sidebar-menu-list .list-group-labels .list-group-item:hover {
  color: #c2c6dc;
}
body.dark-layout .email-application .content-right {
  border-color: #414561;
}
body.dark-layout .email-application .content-right .email-app-list .app-action .action-right .list-inline-item svg {
  color: #c2c6dc;
}
body.dark-layout .email-application .content-right .email-app-list .email-user-list .media {
  border-color: #414561;
}
body.dark-layout .email-application .content-right .email-app-list .email-user-list .media:hover {
  box-shadow: 0 0 0 0 #1e1e1e;
}
body.dark-layout .email-application .content-right .email-app-list .email-user-list .mail-read,
body.dark-layout .email-application .content-right .email-app-list .email-user-list .media {
  background-color: #262c49;
}
body.dark-layout .email-application .content-right .email-app-list .email-user-list .mail-read .user-details p,
body.dark-layout .email-application .content-right .email-app-list .email-user-list .mail-read .user-details .list-group-item-text,
body.dark-layout .email-application .content-right .email-app-list .email-user-list .mail-read .mail-message p,
body.dark-layout .email-application .content-right .email-app-list .email-user-list .mail-read .mail-message .list-group-item-text,
body.dark-layout .email-application .content-right .email-app-list .email-user-list .media .user-details p,
body.dark-layout .email-application .content-right .email-app-list .email-user-list .media .user-details .list-group-item-text,
body.dark-layout .email-application .content-right .email-app-list .email-user-list .media .mail-message p,
body.dark-layout .email-application .content-right .email-app-list .email-user-list .media .mail-message .list-group-item-text {
  color: #c2c6dc;
}
body.dark-layout .email-application .content-right .email-app-list .email-user-list .mail-read .user-details .mail-meta .mail-date,
body.dark-layout .email-application .content-right .email-app-list .email-user-list .mail-read .mail-message .mail-meta .mail-date,
body.dark-layout .email-application .content-right .email-app-list .email-user-list .media .user-details .mail-meta .mail-date,
body.dark-layout .email-application .content-right .email-app-list .email-user-list .media .mail-message .mail-meta .mail-date {
  color: #c2c6dc;
}
body.dark-layout .email-application .content-right .email-app-list .email-user-list .mail-unread {
  background-color: #10163a;
}
body.dark-layout .email-application .email-app-details {
  border-color: #414561;
}
body.dark-layout .email-application .email-app-details.show {
  background-color: #212744;
}
body.dark-layout .email-application .email-app-details .email-detail-header {
  border-color: #414561;
  background-color: #10163a;
}
body.dark-layout .email-application .email-app-details .email-detail-header .email-header-right .list-inline-item .dropdown-toggle {
  color: #c2c6dc;
}
body.dark-layout .email-application .email-app-details .email-detail-header svg {
  color: #c2c6dc;
}
body.dark-layout .email-application .email-app-details .mail-message-wrapper,
body.dark-layout .email-application .email-app-details .email-detail-head {
  border-color: #414561 !important;
}
body.dark-layout .chat-application .chat-profile-sidebar {
  background-color: #262c49;
}
body.dark-layout .chat-application .sidebar-content {
  background-color: #10163a;
  border-color: #414561;
}
body.dark-layout .chat-application .sidebar-content .chat-fixed-search {
  border-color: #414561;
}
body.dark-layout .chat-application .sidebar-content .chat-fixed-search .form-control {
  background-color: #10163a;
}
body.dark-layout .chat-application .sidebar-content .chat-fixed-search .form-control:not(:focus) {
  border: 1px solid #414561;
}
body.dark-layout .chat-application .sidebar-content .chat-fixed-search svg {
  color: #c2c6dc;
}
body.dark-layout .chat-application .sidebar-content .chat-user-list .chat-users-list-wrapper li {
  border-color: #414561;
}
body.dark-layout .chat-application .sidebar-content .chat-user-list .chat-users-list-wrapper li:not(.active):hover {
  background: #10163a;
}
body.dark-layout .chat-application .sidebar-content .chat-user-list .chat-users-list-wrapper li.active .contact-info p {
  color: #fff;
}
body.dark-layout .chat-application .content-right {
  border-color: #414561;
}
body.dark-layout .chat-application .content-right .avatar {
  border: 2px solid #fff;
}
body.dark-layout .chat-application .content-right .chat-app-window .start-chat-area {
  background-color: #171e49;
}
body.dark-layout .chat-application .content-right .chat-app-window .start-chat-area .start-chat-icon,
body.dark-layout .chat-application .content-right .chat-app-window .start-chat-area .start-chat-text {
  background: #262c49;
}
body.dark-layout .chat-application .content-right .chat-app-window .active-chat .chat_navbar .chat_header {
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.5);
}
body.dark-layout .chat-application .content-right .chat-app-window .active-chat .chat_navbar .chat_header svg {
  color: #c2c6dc;
}
body.dark-layout .chat-application .content-right .chat-app-window .active-chat .user-chats {
  background-color: #171e49;
}
body.dark-layout .chat-application .content-right .chat-app-window .active-chat .user-chats .chat-left .chat-content {
  color: #c2c6dc;
  background-color: #10163a;
  border: 1px solid #c2c6dc;
}
body.dark-layout .chat-application .content-right .chat-app-window .active-chat .user-chats .chat-left .chat-content p {
  color: #c2c6dc;
}
body.dark-layout .chat-application .content-right .chat-app-window .active-chat .user-chats .chat-content p {
  color: #fff;
}
body.dark-layout .chat-application .content-right .chat-app-window .active-chat .user-chats .chat-content {
  background-color: #262c49;
}
body.dark-layout .chat-application .content-right .chat-app-window .active-chat .chat-app-form {
  background-color: #10163a;
}
body.dark-layout .chat-application .content-right .chat-app-window .active-chat .chat-app-form .form-control {
  background-color: #10163a;
  border: 1px solid #414561;
}
body.dark-layout .chat-application .chat-profile-sidebar {
  border: 1px solid !important;
}
body.dark-layout .chat-application .user-profile-sidebar,
body.dark-layout .chat-application .chat-profile-sidebar {
  background-color: #10163a;
  border-color: #414561 !important;
}
body.dark-layout .chat-application .user-profile-sidebar .user-profile-header,
body.dark-layout .chat-application .user-profile-sidebar .chat-profile-header,
body.dark-layout .chat-application .chat-profile-sidebar .user-profile-header,
body.dark-layout .chat-application .chat-profile-sidebar .chat-profile-header {
  border-color: #414561;
}
body.dark-layout .chat-application .user-profile-sidebar .user-profile-header .avatar,
body.dark-layout .chat-application .user-profile-sidebar .chat-profile-header .avatar,
body.dark-layout .chat-application .chat-profile-sidebar .user-profile-header .avatar,
body.dark-layout .chat-application .chat-profile-sidebar .chat-profile-header .avatar {
  border: 2px solid #fff;
}
body.dark-layout .chat-application .user-profile-sidebar .user-profile-header .close-icon,
body.dark-layout .chat-application .user-profile-sidebar .chat-profile-header .close-icon,
body.dark-layout .chat-application .chat-profile-sidebar .user-profile-header .close-icon,
body.dark-layout .chat-application .chat-profile-sidebar .chat-profile-header .close-icon {
  color: #c2c6dc;
}
body.dark-layout .todo-application {
  border-color: #414561;
}
body.dark-layout .todo-application .todo-sidebar {
  background-color: #10163a;
  border-color: #414561;
}
body.dark-layout .todo-application .todo-sidebar .list-group .list-group-item:hover {
  color: #c2c6dc;
}
body.dark-layout .todo-application .todo-sidebar .list-group .list-group-item:hover svg {
  color: #c2c6dc;
}
body.dark-layout .todo-application .todo-app-area .todo-app-list-wrapper {
  border-color: #414561;
}
body.dark-layout .todo-application .todo-app-area .app-fixed-search {
  background-color: #10163a;
  border-color: #414561 !important;
}
body.dark-layout .todo-application .todo-app-area .app-fixed-search svg {
  color: #c2c6dc;
}
body.dark-layout .todo-application .todo-app-area .app-fixed-search .form-control-position svg {
  color: #c2c6dc;
}
body.dark-layout .todo-application .todo-app-area .todo-task-list .todo-item {
  border-color: #414561;
}
body.dark-layout .todo-application .todo-app-area .todo-task-list .todo-item:hover {
  box-shadow: none;
}
body.dark-layout .todo-application .todo-app-area .todo-task-list .todo-item .chip {
  background-color: #10163a;
}
body.dark-layout .todo-application .todo-app-area .todo-task-list .todo-item .todo-item-action .todo-item-favorite svg,
body.dark-layout .todo-application .todo-app-area .todo-task-list .todo-item .todo-item-action .todo-item-delete svg,
body.dark-layout .todo-application .todo-app-area .todo-task-list .todo-item .todo-item-action .todo-item-info svg {
  color: #c2c6dc;
}
body.dark-layout .todo-application .task-sidebar {
  background-color: #10163a;
}
body.dark-layout .todo-application .task-header {
  background-color: #10163a;
}
body.dark-layout .todo-application .task-header .close-icon {
  color: #c2c6dc;
}
body.dark-layout .todo-application .task-body svg {
  color: #c2c6dc;
}
body.dark-layout .ecommerce-application .sidebar-shop .filter-heading {
  color: #c2c6dc;
}
body.dark-layout .ecommerce-application .sidebar-shop .price-slider .range-slider {
  background-color: #262c49;
}
body.dark-layout .ecommerce-application .sidebar-shop .ratings-list li, body.dark-layout .ecommerce-application .sidebar-shop .ratings-list ~ .stars-received {
  color: #c2c6dc;
}
body.dark-layout .ecommerce-application .ecommerce-header-items .result-toggler .search-results {
  color: #c2c6dc;
}
body.dark-layout .ecommerce-application .ecommerce-header-items .result-toggler .shop-sidebar-toggler svg {
  color: #c2c6dc;
}
body.dark-layout .ecommerce-application .ecommerce-header-items .view-options .React-Select .select__control {
  background-color: #10163a;
}
body.dark-layout .ecommerce-application .ecommerce-header-items .view-options .React-Select .select__control .select__single-value {
  color: #c2c6dc;
}
body.dark-layout .ecommerce-application .ecommerce-header-items .view-options .select__menu .select__option {
  color: #c2c6dc;
}
body.dark-layout .ecommerce-application .ecommerce-header-items .view-options .select__menu .select__option:hover {
  color: #fff;
}
body.dark-layout .ecommerce-application .ecommerce-header-items .view-options .select__menu .select__option.select__option--is-selected {
  background-color: #7367f0;
}
body.dark-layout .ecommerce-application .ecommerce-header-items .view-options .view-btn-option .view-btn {
  background-color: #10163a !important;
}
body.dark-layout .ecommerce-application .ecommerce-header-items .view-options .view-btn-option .view-btn:not(.active) svg {
  color: #c2c6dc;
}
body.dark-layout .ecommerce-application .search-product {
  background-color: #10163a;
}
body.dark-layout .ecommerce-application .search-product ~ .form-control-position svg {
  color: #c2c6dc;
}
body.dark-layout .ecommerce-application .grid-view .ecommerce-card .card-body,
body.dark-layout .ecommerce-application .list-view .ecommerce-card .card-body {
  border-color: #414561;
}
body.dark-layout .ecommerce-application .grid-view .ecommerce-card .item-img,
body.dark-layout .ecommerce-application .list-view .ecommerce-card .item-img {
  background-color: #fff;
}
body.dark-layout .ecommerce-application .grid-view .ecommerce-card .item-name,
body.dark-layout .ecommerce-application .list-view .ecommerce-card .item-name {
  color: #fff;
}
body.dark-layout .ecommerce-application .grid-view .ecommerce-card .item-options .wishlist span,
body.dark-layout .ecommerce-application .list-view .ecommerce-card .item-options .wishlist span {
  color: #2c2c2c;
}
body.dark-layout .ecommerce-application .grid-view .ecommerce-card .item-options .cart span,
body.dark-layout .ecommerce-application .list-view .ecommerce-card .item-options .cart span {
  color: #fff;
}
body.dark-layout .ecommerce-application .pagination .page-item {
  background-color: #10163a;
}
body.dark-layout .ecommerce-application .pagination .page-item.active {
  background-color: #10163a;
}
body.dark-layout .ecommerce-application .pagination .page-item.active .page-link {
  background-color: #7367f0;
}
body.dark-layout .ecommerce-application .pagination .page-item .page-link {
  background-color: #10163a;
}
body.dark-layout .ecommerce-application .wishlist-items .ecommerce-card .move-cart .move-to-cart {
  color: #fff;
}
body.dark-layout .ecommerce-application .product-checkout .checkout-options .detail-total {
  color: #c2c6dc;
}
body.dark-layout .ecommerce-application .product-checkout.list-view {
  background: #262c49;
}
body.dark-layout .app-ecommerce-details .item-features {
  background-color: #171e49;
}
body.dark-layout .app-ecommerce-details .swiper-slide {
  background-color: #262c49;
}
body.dark-layout .app-ecommerce-details .swiper-button-next,
body.dark-layout .app-ecommerce-details .swiper-button-prev {
  color: #7367f0;
}
body.dark-layout .app-calendar .rbc-calendar .rbc-month-view,
body.dark-layout .app-calendar .rbc-calendar .rbc-month-row,
body.dark-layout .app-calendar .rbc-calendar .rbc-day-bg,
body.dark-layout .app-calendar .rbc-calendar .rbc-header,
body.dark-layout .app-calendar .rbc-calendar .rbc-time-view,
body.dark-layout .app-calendar .rbc-calendar .rbc-time-content,
body.dark-layout .app-calendar .rbc-calendar .rbc-time-header-content,
body.dark-layout .app-calendar .rbc-calendar .rbc-events-container,
body.dark-layout .app-calendar .rbc-calendar .rbc-timeslot-group,
body.dark-layout .app-calendar .rbc-calendar .rbc-time-slot {
  border-color: #414561 !important;
}
body.dark-layout .app-calendar .rbc-calendar .rbc-date-cell.rbc-off-range {
  color: #c2c6dc;
}
body.dark-layout .app-calendar .rbc-calendar .rbc-today {
  background-color: transparent;
}
body.dark-layout .app-calendar .add-event-sidebar,
body.dark-layout .app-calendar .add-event-sidebar .header {
  background-color: #10163a;
}
body.dark-layout .app-calendar .add-event-sidebar svg,
body.dark-layout .app-calendar .add-event-sidebar .header svg {
  color: #c2c6dc;
}
body.dark-layout .app-user-list .ag-grid-table .ag-header .ag-header-cell {
  background-color: transparent;
}
body.dark-layout .rc-slider .rc-slider-rail {
  background-color: #262c49 !important;
}
body.dark-layout .rc-slider.rc-slider-disabled {
  background-color: #262c49;
  opacity: 0.7;
}
body.dark-layout .dropzone {
  background-color: #262c49;
}
body.dark-layout .dropzone ~ .thumb-container .dz-thumb {
  border-color: #414561 !important;
}
body.dark-layout .rdw-editor-wrapper .rdw-editor-toolbar {
  background-color: #262c49;
  border-color: #414561;
}
body.dark-layout .rdw-editor-wrapper .rdw-editor-toolbar .rdw-dropdown-wrapper {
  background-color: #10163a;
  border-color: #414561;
}
body.dark-layout .rdw-editor-wrapper .rdw-editor-toolbar .rdw-dropdown-wrapper:hover {
  background-color: #10163a;
  box-shadow: none;
}
body.dark-layout .rdw-editor-wrapper .rdw-editor-toolbar .rdw-dropdown-wrapper .rdw-dropdown-carettoopen {
  border-top-color: #c2c6dc;
}
body.dark-layout .rdw-editor-wrapper .rdw-editor-toolbar .rdw-dropdown-wrapper .rdw-dropdown-carettoclose {
  border-bottom-color: #c2c6dc;
}
body.dark-layout .rdw-editor-wrapper .rdw-editor-toolbar .rdw-dropdown-wrapper .rdw-dropdown-optionwrapper {
  border-color: #414561;
  background-color: #10163a;
}
body.dark-layout .rdw-editor-wrapper .rdw-editor-toolbar .rdw-dropdown-wrapper .rdw-dropdown-optionwrapper .rdw-dropdownoption-active,
body.dark-layout .rdw-editor-wrapper .rdw-editor-toolbar .rdw-dropdown-wrapper .rdw-dropdown-optionwrapper .rdw-dropdownoption-highlighted {
  background-color: #262c49;
}
body.dark-layout .vx-pagination li {
  background-color: #262c49;
}
body.dark-layout .vx-pagination li a {
  color: #c2c6dc;
}
body.dark-layout .react-contexify {
  background-color: #262c49;
  box-shadow: none;
}
body.dark-layout .react-contexify .react-contexify__item {
  border-color: #414561;
}
body.dark-layout .react-contexify .react-contexify__item .react-contexify__item__content {
  color: #c2c6dc;
}
body.dark-layout .swiper-container .swiper-slide.swiper-slide-active span,
body.dark-layout .swiper-container .swiper-slide.swiper-slide-active svg {
  color: #fff;
}
body.dark-layout .swiper-container.centered-style-1 .swiper-slide {
  background-color: #171e49;
}
body.dark-layout .swiper-container.centered-style-2 .swiper-slide:not(.swiper-slide-active) {
  background-color: #171e49;
}
body.dark-layout .swiper-container.swiper-parallax .swiper-slide,
body.dark-layout .swiper-container.swiper-parallax .swiper-slide p {
  color: #22292f;
}
body.dark-layout .vx-autocomplete-container .suggestions-list {
  background-color: #262c49;
}
body.dark-layout .vx-autocomplete-container .suggestions-list .suggestion-item.active, body.dark-layout .vx-autocomplete-container .suggestions-list .suggestion-item.active:hover {
  background-color: #10163a;
}
body.dark-layout .vx-autocomplete-container .suggestions-list .suggestion-item:hover {
  background-color: #10163a !important;
}
body.dark-layout .vx-autocomplete-container .suggestions-list .suggestion-item svg:not([class*=text-]) {
  stroke: #c2c6dc;
}
body.dark-layout .customizer {
  background-color: #262c49;
}
body.dark-layout .customizer .close-icon svg {
  color: #c2c6dc;
}
body.dark-layout .customizer .bg-default {
  background-color: #10163a;
  border-color: #10163a !important;
}
body.dark-layout .vertical-layout.fixed-footer .footer {
  background-color: #10163a;
}
body.dark-layout .horizontal-layout .horizontal-menu-wrapper {
  background: linear-gradient(to bottom, rgba(37, 43, 71, 0.76) 44%, rgba(56, 53, 53, 0.46) 73%, rgba(255, 255, 255, 0) 100%);
}
body.dark-layout .horizontal-layout .header-navbar {
  background-color: #10163a !important;
}
body.dark-layout .horizontal-layout .header-navbar #main-menu-navigation .dropdown-item .item-content {
  color: #c2c6dc !important;
}
body.dark-layout .horizontal-layout .header-navbar #main-menu-navigation .dropdown-item.active {
  background-color: #10163a !important;
}
body.dark-layout .horizontal-layout .header-navbar #main-menu-navigation .dropdown-item:not(.active):hover span {
  color: #c2c6dc;
}
body.dark-layout .horizontal-layout .header-navbar #main-menu-navigation .dropdown-item.has-sub.hover, body.dark-layout .horizontal-layout .header-navbar #main-menu-navigation .dropdown-item.has-sub.hover .dropdown {
  background-color: transparent !important;
}
body.dark-layout .horizontal-layout .header-navbar #main-menu-navigation .nav-item.hover:not(.active) .dropdown,
body.dark-layout .horizontal-layout .header-navbar #main-menu-navigation .nav-item.hover:not(.active) a.nav-link {
  background-color: #262c49 !important;
}
body.dark-layout .horizontal-layout .header-navbar #main-menu-navigation .nav-item.active .menu-icon svg {
  stroke: #fff;
}
body.dark-layout .horizontal-layout .header-navbar #main-menu-navigation .nav-item.active .dropdown-menu li.active,
body.dark-layout .horizontal-layout .header-navbar #main-menu-navigation .nav-item.active .dropdown-menu li.active:hover {
  background: #10163a !important;
}
body.dark-layout .horizontal-layout .header-navbar #main-menu-navigation .nav-item.active .dropdown-menu .dropdown-item:hover {
  background: #10163a !important;
}
body.dark-layout .horizontal-layout .header-navbar #main-menu-navigation .dropdown-menu::-webkit-scrollbar-thumb {
  background: #10163a !important;
}
body.dark-layout .horizontal-layout .header-navbar #main-menu-navigation .dropdown-menu::-webkit-scrollbar-track {
  background: #262c49 !important;
}
body.dark-layout .horizontal-layout.fixed-footer .footer {
  background: #10163a;
}

/*========================================================
        DARK LAYOUT
=========================================================*/
body.semi-dark-layout {
  /************ Main Menu **************/
}
body.semi-dark-layout .main-menu {
  background-color: #10163a;
}
body.semi-dark-layout .main-menu .shadow-bottom {
  background: linear-gradient(180deg, #0f1642 44%, rgba(15, 22, 66, 0.51) 73%, rgba(44, 48, 60, 0));
}
body.semi-dark-layout .main-menu:not(.expanded) .navigation .sidebar-group-active a {
  background-color: #262c49;
}
body.semi-dark-layout .main-menu.theme-dark .navbar-header .brand-text {
  color: #adb5bd !important;
}
body.semi-dark-layout .main-menu.theme-dark .navbar-header .modern-nav-toggle svg {
  color: #adb5bd !important;
}
body.semi-dark-layout .main-menu.theme-dark .navigation .nav-item.active a {
  background: linear-gradient(118deg, #adb5bd, rgba(173, 181, 189, 0.7));
  box-shadow: 0 0 10px 1px rgba(173, 181, 189, 0.7);
}
body.semi-dark-layout .main-menu.theme-dark .navigation .nav-item .menu-content li.active {
  background: linear-gradient(118deg, #adb5bd, rgba(173, 181, 189, 0.7));
  box-shadow: 0 0 10px 1px rgba(173, 181, 189, 0.7);
}
body.semi-dark-layout .main-menu-content .navigation-main {
  background-color: #10163a;
}
body.semi-dark-layout .main-menu-content .navigation-main .nav-item svg {
  color: #c2c6dc;
}
body.semi-dark-layout .main-menu-content .navigation-main .nav-item.open a {
  background-color: #262c49;
}
body.semi-dark-layout .main-menu-content .navigation-main .nav-item a:after,
body.semi-dark-layout .main-menu-content .navigation-main .nav-item a {
  color: #c2c6dc;
}
body.semi-dark-layout .main-menu-content .navigation-main .nav-item .menu-content {
  background-color: #10163a;
}
body.semi-dark-layout .main-menu-content .navigation-main .nav-item .menu-content .active .menu-item {
  color: #fff;
}
body.semi-dark-layout .main-menu-content .navigation-main .nav-item .menu-content li:not(.active) a {
  background-color: #10163a;
}
body.semi-dark-layout .main-menu-content .navigation-main .nav-item .menu-content li.hover a,
body.semi-dark-layout .main-menu-content .navigation-main .nav-item .menu-content li.hover svg {
  color: #c2c6dc;
}
body.semi-dark-layout .main-menu-content .navigation-main .active .menu-title,
body.semi-dark-layout .main-menu-content .navigation-main .active svg {
  color: #fff;
}
body.semi-dark-layout .main-menu-content .navigation-main .sidebar-group-active a {
  background: #10163a;
  border-radius: 4px;
}
body.semi-dark-layout .main-menu-content .navigation-main .sidebar-group-active .menu-content {
  background-color: #10163a;
}
body.semi-dark-layout .main-menu-content .navigation-main .sidebar-group-active .menu-content .active {
  z-index: 1;
}
body.semi-dark-layout .main-menu-content .navigation-main .sidebar-group-active .menu-content .active a {
  background-color: transparent;
}
body.semi-dark-layout.menu-collapsed .main-menu:not(.expanded) .navigation-main li.active a {
  background: #262c49 !important;
}

/*========================================================
        DARK LAYOUT
=========================================================*/
a:focus {
  outline: none;
}

.component-code pre {
  max-height: 300px;
  overflow-y: scroll;
}
.component-code pre::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
.component-code pre::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 20px;
}
.component-code pre::-webkit-scrollbar-track {
  background: #f8f8f8;
}

.font-small-1 {
  font-size: 0.7rem !important;
}

.font-small-2 {
  font-size: 0.8rem !important;
}

.font-small-3 {
  font-size: 0.9rem !important;
}

.font-medium-1 {
  font-size: 1.1rem !important;
}

.font-medium-2 {
  font-size: 1.2rem !important;
}

.font-medium-3 {
  font-size: 1.3rem !important;
}

.font-medium-4 {
  font-size: 1.4rem !important;
}

.font-medium-5 {
  font-size: 1.5rem !important;
}

.font-large-1 {
  font-size: 2rem !important;
}

.font-large-2 {
  font-size: 3rem !important;
}

.font-large-3 {
  font-size: 4rem !important;
}

.font-large-4 {
  font-size: 5rem !important;
}

.font-large-5 {
  font-size: 6rem !important;
}

.text-bold-300 {
  font-weight: 300;
}

.text-bold-400 {
  font-weight: 400;
}

.text-bold-500 {
  font-weight: 500;
}

.text-bold-600 {
  font-weight: 600;
}

.text-bold-700 {
  font-weight: 700;
}

.text-italic {
  font-style: italic;
}

.text-highlight {
  padding: 4px 6px;
}

ol li, ul li, dl li {
  line-height: 1.2;
}

code {
  padding: 0.1rem 0.4rem;
  font-size: 90%;
  color: #d63384;
  background-color: #eee;
  border-radius: 0.25rem;
}

pre {
  border-radius: 0.5rem;
}
pre code {
  background-color: transparent !important;
}

.bd-example-row .row + .row {
  margin-top: 1rem;
}
.bd-example-row .row > .col,
.bd-example-row .row > [class^=col-] {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  background-color: rgba(86, 61, 124, 0.15);
  border: 1px solid rgba(86, 61, 124, 0.2);
}
.bd-example-row .flex-items-top,
.bd-example-row .flex-items-middle,
.bd-example-row .flex-items-bottom {
  min-height: 6rem;
  background-color: rgba(255, 0, 0, 0.1);
}

.bd-example-row-flex-cols .row {
  min-height: 10rem;
  background-color: rgba(255, 0, 0, 0.1);
}

.bd-highlight {
  background-color: rgba(86, 61, 124, 0.15);
  border: 1px solid rgba(86, 61, 124, 0.15);
}

.example-container {
  width: 800px;
  --bs-gutter-x: 28px;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

.example-row {
  --bs-gutter-x: 28px;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}

.example-content-main {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}
@media (min-width: 576px) {
  .example-content-main {
    flex: 0 0 auto;
    width: 50%;
  }
}
@media (min-width: 992px) {
  .example-content-main {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
}

.example-content-secondary {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}
@media (min-width: 576px) {
  .example-content-secondary {
    flex: 0 0 auto;
    width: 50%;
  }
}
@media (min-width: 992px) {
  .example-content-secondary {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
}

.table-white-space th,
.table-white-space td {
  white-space: nowrap;
}

.table thead th {
  vertical-align: top;
}
.table th,
.table td {
  padding: 1rem;
  vertical-align: middle;
}
.table th {
  font-size: 0.85rem;
}

.table-inverse {
  color: #fff;
  background-color: #00cfe8;
}

.table-hover-animation {
  background-color: #f8f8f8;
}
.table-hover-animation thead th {
  border-top: 2px solid #f8f8f8;
  border-bottom: 0;
  background-color: #fff;
}
.table-hover-animation th,
.table-hover-animation td {
  border: 0;
}
.table-hover-animation tbody tr {
  transition: all 0.25s ease;
  background-color: #fff;
}
.table-hover-animation tbody tr:hover {
  transform: translateY(-4px);
}

.form-control::placeholder {
  font-size: 0.85rem;
  color: rgba(34, 41, 47, 0.4);
  transition: all 0.2s ease;
}
.form-control:focus::placeholder {
  transform: translate(5px);
  transition: all 0.2s ease;
}
.form-control:focus ~ .form-control-position svg {
  stroke: #7367f0;
}

/* Form specific Scss */
label {
  color: rgb(69.5, 69.5, 69.5);
  font-size: 0.85rem;
  margin-bottom: 0;
  padding-left: 0.2rem;
}

textarea.form-control {
  line-height: 1.6rem;
  font-size: 1rem;
}

.form-group {
  margin-bottom: 1.5rem;
}
.form-group .valid-tooltip,
.form-group .invalid-tooltip {
  top: auto;
}

.form-control {
  border: 1px solid rgb(217.4, 217.4, 217.4);
  color: #5f5f5f;
}

.form-section {
  color: #b8c2cc;
  line-height: 3rem;
  margin-bottom: 20px;
  border-bottom: 1px solid #b8c2cc;
}

/* .form-body{
    overflow: hidden;
} */
.form-actions {
  border-top: 1px solid rgb(222.5, 222.5, 222.5);
  padding: 20px 0;
  margin-top: 20px;
}
.form-actions.filled {
  background-color: #f8f8f8;
}
.form-actions.center {
  text-align: center;
}
.form-actions.right {
  text-align: right;
}
.form-actions.top {
  border-top: 0;
  border-bottom: 1px solid rgb(222.5, 222.5, 222.5);
  margin-top: 0;
  margin-bottom: 20px;
}
@media (max-width: 575.98px) {
  .form-actions .buttons-group {
    float: left !important;
    margin-bottom: 10px;
  }
}

@media (min-width: 576px) {
  .form-horizontal .form-group .label-control {
    text-align: right;
  }
}

.form-control.form-control-lg {
  padding: 1rem;
}
.form-control.form-control-lg::placeholder {
  font-size: 1.25rem;
}

.form-control.form-control-sm {
  padding: 0.6rem;
}
.form-control.form-control-sm::placeholder {
  font-size: 0.7rem;
}

.custom-file-label {
  padding: 0.7rem 0.5rem;
}
.custom-file-label::after {
  padding: 0.7rem 0.5rem;
  height: auto;
}

select.form-control:not([multiple=multiple]) {
  background-position: calc(100% - 12px) 13px, calc(100% - 20px) 13px, 100% 0;
  background-size: 12px 12px, 10px 10px;
  background-repeat: no-repeat;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding-right: 1.5rem;
}

.custom-select {
  padding: 0.7rem 1.7rem 0.6rem 0.7rem;
  -moz-appearance: none;
  -webkit-appearance: none;
}

.input-group-addon {
  background-color: #eceff1;
  border-color: #babfc7;
}

.custom-control-label::before {
  width: 1.1rem;
  height: 1.1rem;
  top: 0.1rem;
}

.custom-control-label::after {
  width: 1.1rem;
  height: 1.1rem;
  top: 0.1rem;
}

.custom-control-input:not(:disabled):active ~ .custom-control-label::before {
  background-color: #7367f0;
  border-color: #7367f0;
}

/* Floating label Group */
.form-label-group {
  position: relative;
  margin-bottom: 1.5rem;
}
.form-label-group .form-control-lg ~ label {
  font-size: 1.25rem;
  padding: 1rem;
}
.form-label-group .form-control-sm ~ label {
  font-size: 0.7rem;
}
.form-label-group > label {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  transition: all 0.25s ease-in-out;
  padding: 0.6rem;
  color: rgba(34, 41, 47, 0.4);
  font-size: 0.85rem;
  opacity: 0;
  z-index: -1;
}
.form-label-group > input,
.form-label-group textarea {
  padding: 0.6rem;
}
.form-label-group > input:focus:not(:placeholder-shown) ~ label, .form-label-group > input:not(:active):not(:placeholder-shown) ~ label,
.form-label-group textarea:focus:not(:placeholder-shown) ~ label,
.form-label-group textarea:not(:active):not(:placeholder-shown) ~ label {
  color: #7367f0 !important;
  transition: all 0.25s ease-in-out;
  opacity: 1;
}
.form-label-group > input:not(:focus):not(:placeholder-shown) ~ label,
.form-label-group textarea:not(:focus):not(:placeholder-shown) ~ label {
  color: rgba(34, 41, 47, 0.4) !important;
}
.form-label-group > input:not(:placeholder-shown) ~ label,
.form-label-group textarea:not(:placeholder-shown) ~ label {
  padding: 0.25rem 0;
  font-size: 0.7rem;
  top: -20px;
  left: 3px;
  z-index: 1;
}
.form-label-group.has-icon-left > label {
  left: 36px;
}

/* Vuexy Custom Checkbox */
.vx-checkbox-con {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0.25rem 0;
}
.vx-checkbox-con input {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 200;
  cursor: pointer;
  top: 0;
}
.vx-checkbox-con input:checked ~ .vx-checkbox {
  transform: rotate(0deg);
  border-color: #7367f0;
}
.vx-checkbox-con input:checked ~ .vx-checkbox .vx-checkbox--check {
  transform: translate(0);
  background-color: #7367f0;
}
.vx-checkbox-con input:checked ~ .vx-checkbox .vx-checkbox--check .vx-icon {
  transform: translate(0);
  line-height: 1.2;
  opacity: 1;
}
.vx-checkbox-con input:checked ~ .vx-checkbox.vx-checkbox-sm .vx-checkbox--check .vx-icon {
  font-size: 0.75rem;
}
.vx-checkbox-con input:checked ~ .vx-checkbox.vx-checkbox-lg .vx-checkbox--check .vx-icon {
  font-size: 1.2rem;
}
.vx-checkbox-con input:active:checked + .vx-checkbox .vx-checkbox--check {
  transform: translate(3px);
  background-color: #7367f0;
}
.vx-checkbox-con input:active:checked + .vx-checkbox .vx-checkbox--check .vx-icon {
  opacity: 1;
  transform: translate(6px);
}
.vx-checkbox-con input:disabled {
  cursor: default;
  pointer-events: none;
}
.vx-checkbox-con input:disabled + .vx-checkbox {
  cursor: default;
  opacity: 0.5;
}
.vx-checkbox-con .vx-checkbox {
  cursor: pointer;
  position: relative;
  width: 20px;
  height: 20px;
  border-width: 2px;
  border-style: solid;
  border-color: #b8c2cc;
  border-radius: 2px;
  transform: rotate(-90deg);
  transition: all 0.2s ease;
  overflow: hidden;
  margin-right: 0.5rem;
}
.vx-checkbox-con .vx-checkbox.vx-checkbox-sm {
  width: 15px;
  height: 15px;
}
.vx-checkbox-con .vx-checkbox.vx-checkbox-lg {
  width: 24px;
  height: 24px;
}
.vx-checkbox-con .vx-checkbox .vx-checkbox--check {
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  left: 0;
  transform: translate(100%);
  transform-origin: right;
  transition: all 0.2s ease;
  z-index: 10;
}
.vx-checkbox-con .vx-checkbox .vx-checkbox--check .vx-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}

/* Vuexy Custom Radio */
.vx-radio-con {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0.25rem 0;
}
.vx-radio-con input {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 200;
  cursor: pointer;
}
.vx-radio-con input:checked ~ .vx-radio {
  transform: rotate(0deg);
  outline: 0;
}
.vx-radio-con input:checked ~ .vx-radio .vx-radio--circle {
  background: #7367f0;
  box-shadow: 0 3px 12px 0 rgba(115, 103, 240, 0.4);
  opacity: 1;
  transform: scale(1);
}
.vx-radio-con input:checked ~ .vx-radio .vx-radio--border {
  opacity: 0;
  transform: scale(0.3);
}
.vx-radio-con input:disabled {
  cursor: default;
  pointer-events: none;
}
.vx-radio-con input:disabled + .vx-radio {
  cursor: default;
  opacity: 0.5;
}
.vx-radio-con input:active ~ .vx-radio {
  transform: scale(1.1);
}
.vx-radio-con .vx-radio {
  cursor: pointer;
  position: relative;
  width: 18px;
  height: 18px;
  transition: all 0.2s ease;
  margin-right: 0.5rem;
}
.vx-radio-con .vx-radio.vx-radio-sm {
  width: 13px;
  height: 13px;
}
.vx-radio-con .vx-radio.vx-radio-lg {
  width: 22px;
  height: 22px;
}
.vx-radio-con .vx-radio .vx-radio--border,
.vx-radio-con .vx-radio .vx-radio--circle {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  transition: all 0.25s ease;
  top: 0;
  border-radius: 50%;
}
.vx-radio-con .vx-radio .vx-radio--border {
  background: transparent;
  border: 2px solid #b8c2cc;
}
.vx-radio-con .vx-radio .vx-radio--circle {
  opacity: 0;
  transform: scale(0.1);
}

/* Switches */
.custom-switch {
  padding-left: 0;
  /*For Switch label*/
  /*For Switch Handle Animation*/
}
.custom-switch .custom-control-label {
  height: 1.571rem;
  width: 3.1rem;
  padding: 0;
  /* For bg color of switch*/
  /*For Switch handle*/
  /*For Switch text*/
}
.custom-switch .custom-control-label::before {
  border: none;
  background-color: #e2e2e2;
  height: 1.571rem;
  left: -0.2857rem;
  box-shadow: none !important;
  transition: all 0.25s ease;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  top: 0;
  left: 0;
}
.custom-switch .custom-control-label:after {
  position: absolute;
  top: 2px;
  left: 2px;
  box-shadow: none;
  background-color: #fff;
  transition: all 0.25s ease;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.custom-switch .custom-control-label .switch-text-left,
.custom-switch .custom-control-label .switch-text-right,
.custom-switch .custom-control-label .switch-icon-left,
.custom-switch .custom-control-label .switch-icon-right {
  position: absolute;
  top: 5px;
  font-size: 0.7rem;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.custom-switch .custom-control-label .switch-text-left,
.custom-switch .custom-control-label .switch-icon-left {
  left: 7px;
  color: #fff;
}
.custom-switch .custom-control-label .switch-text-right,
.custom-switch .custom-control-label .switch-icon-right {
  right: 7px;
}
.custom-switch .custom-control-label:focus {
  outline: 0;
}
.custom-switch .switch-label {
  padding-left: 1rem;
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::before {
  box-shadow: none;
  background-color: #7367f0;
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  transform: translateX(1.4rem);
}
.custom-switch .custom-control-input:not(:checked) ~ .custom-control-label .switch-text-left {
  opacity: 0;
}
.custom-switch .custom-control-input:not(:checked) ~ .custom-control-label .switch-text-right {
  opacity: 1;
}
.custom-switch .custom-control-input:checked ~ .custom-control-label .switch-text-right {
  opacity: 0;
}
.custom-switch .custom-control-input:checked ~ .custom-control-label .switch-text-left {
  opacity: 1;
}
.custom-switch .custom-control-input:not(:disabled):active ~ .custom-control-label::before {
  background-color: #e2e2e2;
}
.custom-switch.switch-md .custom-control-label {
  width: 4rem;
  height: 1.571rem;
}
.custom-switch.switch-md .custom-control-label::before {
  width: 4rem;
  border: none;
  background-color: #e2e2e2;
  height: 1.571rem;
  left: -0.2857rem;
  box-shadow: none !important;
  transition: all 0.25s ease;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.custom-switch.switch-md .custom-control-label:after {
  box-shadow: none;
  background-color: #fff;
  transition: all 0.25s ease;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: absolute;
  top: 2px;
  left: -2px;
}
.custom-switch.switch-md .custom-control-label .switch-text-right,
.custom-switch.switch-md .custom-control-label .switch-icon-right {
  right: 9px;
}
.custom-switch.switch-md .custom-control-label .switch-text-left,
.custom-switch.switch-md .custom-control-label .switch-icon-left {
  left: 5px;
}
.custom-switch.switch-md .custom-control-input:checked ~ .custom-control-label::after {
  transform: translateX(2.3rem);
}
.custom-switch.switch-lg .custom-control-label {
  width: 5.5rem;
  height: 1.571rem;
}
.custom-switch.switch-lg .custom-control-label::before {
  width: 5.5rem;
  border: none;
  background-color: #e2e2e2;
  height: 1.571rem;
  left: -0.2857rem;
  box-shadow: none !important;
  transition: all 0.25s ease;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.custom-switch.switch-lg .custom-control-label:after {
  position: absolute;
  top: 2px;
  left: -2px;
  box-shadow: none;
  background-color: #fff;
  transition: all 0.25s ease;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.custom-switch.switch-lg .custom-control-label .switch-text-right,
.custom-switch.switch-lg .custom-control-label .switch-icon-right {
  right: 10px;
}
.custom-switch.switch-lg .custom-control-input:checked ~ .custom-control-label::after {
  transform: translateX(3.8rem);
}

/* Textarea with Counter */
.counter-value {
  background-color: #7367f0;
  color: #fff;
  padding: 1px 6px;
  font-size: 0.6rem;
  border-radius: 0 0 5px 5px;
  margin-right: 1rem;
}

/* Input box with icon divider */
.form-group.input-divider-left .form-control-position svg {
  padding: 0.2rem 0.5rem;
  border-right: 1px solid rgb(217.4, 217.4, 217.4);
  height: 25px;
  width: 30px;
}
.form-group.input-divider-right .form-control-position svg {
  padding: 0.2rem 0.5rem;
  border-left: 1px solid rgb(217.4, 217.4, 217.4);
  height: 25px;
  width: 30px;
}

/* input-groups-lg and input-groups-sm  */
.input-group-lg .form-control,
.input-group-sm .form-control {
  padding: 0.7rem;
}

/***** React Numeric Input *****/
/* Number Type Input Box Scss for - Remove arrow on hover */
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
}

.picker__input.form-control {
  background-color: #fff;
}

.input-group .form-control {
  height: auto;
}
.input-group .input-group-prepend .dropdown-toggle::after,
.input-group .input-group-append .dropdown-toggle::after {
  left: 0;
}
.input-group .input-group-prepend .vx-checkbox-con,
.input-group .input-group-prepend .vx-checkbox,
.input-group .input-group-prepend .vx-radio-con,
.input-group .input-group-prepend .vx-radio,
.input-group .input-group-append .vx-checkbox-con,
.input-group .input-group-append .vx-checkbox,
.input-group .input-group-append .vx-radio-con,
.input-group .input-group-append .vx-radio {
  margin: 0;
}
.input-group.input-group-lg .form-control::placeholder {
  font-size: 1.25rem;
}
.input-group.input-group-lg .input-group-prepend .btn,
.input-group.input-group-lg .input-group-append .btn {
  line-height: 1.3;
  font-size: 1.3rem;
}
.input-group.input-group-sm .form-control::placeholder {
  font-size: 0.7rem;
}

.input-group .input-group-append .react-ripples .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group .input-group-prepend .react-ripples .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.btn:disabled {
  cursor: default;
}
.btn.btn-white {
  color: #626262;
}
.btn.btn-white:hover, .btn.btn-white:focus, .btn.btn-white:active {
  color: #626262 !important;
}
.btn[class*=bg-gradient-] {
  color: #fff;
}
.btn[class*=bg-gradient-]:hover {
  box-shadow: 0 8px 25px -8px #aaa;
}
.btn.btn-secondary {
  color: #fff;
}
.btn.btn-secondary:hover {
  box-shadow: 0 8px 25px -8px #b8c2cc;
}
.btn.btn-dark:hover {
  box-shadow: 0 8px 25px -8px #2a2e30;
}
.btn.btn-light:hover {
  box-shadow: 0 8px 25px -8px #babfc7;
}
.btn.btn-outline-secondary, .btn.btn-outline-dark, .btn.btn-outline-light {
  border: 1px solid;
}
.btn.btn-flat-secondary:hover {
  background-color: rgba(184, 194, 204, 0.1);
}
.btn.btn-flat-secondary:active, .btn.btn-flat-secondary:focus {
  background: #b8c2cc;
}
.btn.btn-flat-dark:hover {
  background-color: rgba(42, 46, 48, 0.1);
}
.btn.btn-flat-dark:active, .btn.btn-flat-dark:focus {
  background: #2a2e30;
  color: #fff;
}
.btn.btn-flat-light:hover {
  background-color: rgba(186, 191, 199, 0.1);
}
.btn.btn-flat-light:active, .btn.btn-flat-light:focus {
  background: #babfc7;
}
.btn[class*=btn-outline-] {
  padding-top: calc(0.9rem - 1px);
  padding-bottom: calc(0.9rem - 1px);
}
.btn[class*=btn-outline-].btn-lg, .btn-group-lg > .btn[class*=btn-outline-] {
  padding-top: calc(1rem - 1px);
  padding-bottom: calc(1rem - 1px);
}
.btn[class*=btn-outline-].btn-sm, .btn-group-sm > .btn[class*=btn-outline-] {
  padding-top: calc(0.5rem - 1px);
  padding-bottom: calc(0.5rem - 1px);
}
.btn.btn-relief-secondary {
  background-color: #b8c2cc;
  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.2);
  color: #fff;
}
.btn.btn-relief-secondary:hover {
  color: #fff;
}
.btn.btn-relief-secondary:active, .btn.btn-relief-secondary:focus {
  outline: none;
  transform: translateY(3px);
}
.btn.btn-relief-light {
  background-color: #babfc7;
  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.2);
  color: #fff;
}
.btn.btn-relief-light:hover {
  color: #fff;
}
.btn.btn-relief-light:active, .btn.btn-relief-light:focus {
  outline: none;
  transform: translateY(3px);
}
.btn.btn-relief-dark {
  background-color: #2a2e30;
  box-shadow: inset 0 -3px 0 0 rgba(255, 255, 255, 0.1);
  color: #fff;
}
.btn.btn-relief-dark:hover {
  color: #fff;
}
.btn.btn-relief-dark:active, .btn.btn-relief-dark:focus {
  outline: none;
  transform: translateY(3px);
}
.btn.btn-icon {
  padding: 0.715rem 0.736rem;
}
.btn.btn-sm.btn-icon, .btn-group-sm > .btn.btn-icon {
  padding: 0.5rem;
}
.btn.btn-lg.btn-icon, .btn-group-lg > .btn.btn-icon {
  padding: 1rem;
}
.btn.btn-square {
  border-radius: 0;
}
.btn.btn-round {
  border-radius: 2rem;
}
.btn:focus, .btn.focus, .btn:active, .btn.active {
  outline: none;
  box-shadow: none !important;
}
.btn.btn-icon svg {
  height: 1.1rem;
  width: 1.1rem;
}

.btn-group .react-ripples:not(:last-child) .btn {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.btn-group .react-ripples:not(:first-child) .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.btn-group-vertical .react-ripples:not(:last-child) .btn {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
.btn-group-vertical .react-ripples:not(:first-child) .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

button,
html [type=button],
[type=reset],
[type=submit] {
  cursor: pointer;
}

.waves-button-input {
  padding: unset;
}

.collapse-icon .card-header {
  position: relative;
}
.collapse-icon .card-header:after {
  position: absolute;
  top: 48%;
  right: 20px;
  margin-top: -8px;
  font-family: "feather";
  content: "\\e845";
  transition: all 300ms linear 0s;
  font-size: 0.9rem;
}
.collapse-icon .card-header:before {
  position: absolute;
  top: 48%;
  right: 20px;
  margin-top: -8px;
  font-family: "feather";
  content: "\\e842";
  transition: all 300ms linear 0s;
  font-size: 0.9rem;
}
.collapse-icon.left a {
  padding-left: 28px;
}
.collapse-icon.left a:before, .collapse-icon.left a:after {
  left: 20px;
  right: auto;
}
.collapse-icon.accordion-icon-rotate .collapse.show:before {
  transform: rotate(180deg);
}
.collapse-icon.accordion-icon-rotate .collapse:not(.show):after {
  transform: rotate(-180deg);
}

.dropdown.show .btn-outline-warning.dropdown-toggle,
.dropdown.show .btn-outline-light.dropdown-toggle {
  color: #fff;
}
.dropdown .btn:not(.btn-sm):not(.btn-lg),
.dropdown .btn:not(.btn-sm):not(.btn-lg).dropdown-toggle {
  padding: 0.85rem 1.5rem;
}
.dropdown .btn:not(.btn-sm):not(.btn-lg).btn-round,
.dropdown .btn:not(.btn-sm):not(.btn-lg).dropdown-toggle.btn-round {
  border-radius: 2rem;
}
.dropdown .btn.dropdown-toggle.dropdown-toggle-split {
  padding: 0.85rem 1rem;
  border-left-color: rgba(255, 255, 255, 0.2) !important;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.dropdown [class*=btn-outline-].dropdown-toggle.dropdown-toggle-split {
  border-left: 0 !important;
}
.dropdown [class*=btn-outline-].dropdown-toggle.dropdown-toggle-split:active {
  color: #fff;
}
.dropdown .dropdown-menu {
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  transform: scale(1, 0);
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.1);
  min-width: 8rem;
}
.dropdown .dropdown-menu::before {
  content: "";
  position: absolute;
  top: -1px;
  left: 1.2rem;
  width: 0.75rem;
  height: 0.75rem;
  display: block;
  background: #fff;
  transform: rotate(45deg) translate(-7px);
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  border-left: 1px solid rgba(0, 0, 0, 0.1);
  z-index: 10;
  box-sizing: border-box;
}
.dropdown .dropdown-menu.dropdown-menu-right::before {
  right: 0.6rem;
  left: auto;
}
.dropdown .dropdown-menu .dropdown-header {
  padding: 0.714rem 1.428rem;
  margin-top: 0.714rem;
}
.dropdown .dropdown-menu .dropdown-item {
  padding: 0.5rem 1rem;
  color: #626262;
  width: auto;
  cursor: pointer;
}
.dropdown .dropdown-menu .dropdown-item:hover {
  background-color: #f8f8f8;
  color: #7367f0;
}
.dropdown .dropdown-menu .dropdown-item:hover svg,
.dropdown .dropdown-menu .dropdown-item:hover span {
  color: #7367f0;
}
.dropdown .dropdown-menu .dropdown-item.active {
  color: #fff;
}
.dropdown .dropdown-menu .dropdown-item:active {
  background-color: transparent;
  color: var(--bs-body-color);
}
.dropdown .dropdown-menu .dropdown-item.disabled {
  color: #b8c2cc;
}
.dropdown.no-arrow .dropdown-toggle:after {
  display: none;
}

.dropdown,
.dropup,
.dropright,
.dropleft {
  position: relative;
}
.dropdown .dropdown-menu .dropdown-item,
.dropup .dropdown-menu .dropdown-item,
.dropright .dropdown-menu .dropdown-item,
.dropleft .dropdown-menu .dropdown-item {
  padding: 0.714rem 1.428rem;
}
.dropdown .dropdown-toggle:after, .dropdown .dropdown-toggle:before,
.dropup .dropdown-toggle:after,
.dropup .dropdown-toggle:before,
.dropright .dropdown-toggle:after,
.dropright .dropdown-toggle:before,
.dropleft .dropdown-toggle:after,
.dropleft .dropdown-toggle:before {
  display: none;
}

.show > .dropdown-menu {
  transform: scale(1, 1);
  opacity: 1;
  display: block;
}

.dropdown-toggle::after {
  display: none;
}
.dropdown-toggle svg {
  position: relative;
  left: 10px;
}
.dropdown-toggle.dropdown-toggle-split {
  border-left: 1px solid rgba(255, 255, 255, 0.2);
}
.dropdown-toggle.dropdown-toggle-split svg {
  left: 0;
}
.dropdown-toggle.nav-hide-arrow::after {
  display: none;
}
.dropdown-toggle:focus {
  outline: 0;
}

.navbar-horizontal .dropdown-submenu .dropdown-toggle::after {
  top: -9px !important;
  margin-top: 1.25rem;
  right: 1px;
}

/* .dropdown-menu-right {
  left: auto !important; // Input group with dropdown issue for dropdown-menu-right
  right: 0;
} */
.btn-secondary ~ .dropdown-menu .dropdown-item.active, .btn-secondary ~ .dropdown-menu .dropdown-item:hover {
  background-color: #cccccc;
}

.dropup {
  position: relative;
}
.dropup .btn,
.dropup .btn.dropdown-toggle {
  padding: 0.85rem 1.5rem;
}
.dropup .btn.dropdown-toggle.dropdown-toggle-split {
  padding: 0.85rem 1rem;
  border-color: rgba(255, 255, 255, 0.2) !important;
}
.dropup .dropdown-toggle::after {
  content: "\\e845" !important;
  vertical-align: 0.05rem;
}
.dropup .dropdown-menu::before {
  content: "";
  position: absolute;
  bottom: -0.714rem;
  left: 1.214rem;
  width: 0.714rem;
  height: 0.714rem;
  display: block;
  background: #fff;
  transform: rotate(45deg) translate(-7px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  border-right: 1px solid rgba(0, 0, 0, 0.1);
  z-index: 10;
  box-sizing: border-box;
}
.dropup .dropdown-menu.dropdown-menu-right::before {
  left: auto;
  right: 0.714rem;
}
.dropup .dropdown-submenu .dropdown-menu {
  bottom: auto;
  top: 0;
}

.dropleft .btn,
.dropleft .btn.dropdown-toggle {
  padding: 0.85rem 1.5rem;
}
.dropleft .btn.dropdown-toggle.dropdown-toggle-split {
  padding: 0.85rem 1rem;
}
.dropleft .dropdown-toggle svg {
  left: -10px;
}
.dropleft .dropdown-menu::before {
  content: "";
  position: absolute;
  top: 1.285rem;
  right: 0;
  width: 0.714rem;
  height: 0.714rem;
  display: block;
  background: #fff;
  transform: rotate(130deg) translate(-8px);
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  border-left: 1px solid rgba(0, 0, 0, 0.1);
  z-index: 10;
  box-sizing: border-box;
}

.dropright .btn,
.dropright .btn.dropdown-toggle {
  padding: 0.85rem 1.5rem;
}
.dropright .btn.dropdown-toggle.dropdown-toggle-split {
  padding: 0.85rem 1rem;
}
.dropright .dropdown-toggle::after {
  border: none !important;
  font-family: "feather";
  content: "\\e844" !important;
}
.dropright .dropdown-menu::before {
  content: "";
  position: absolute;
  top: 1.285rem;
  left: -0.9rem;
  width: 0.714rem;
  height: 0.714rem;
  display: block;
  background: #fff;
  transform: rotate(140deg) translate(-9px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  border-right: 1px solid rgba(0, 0, 0, 0.1);
  z-index: 10;
  box-sizing: border-box;
}

.dropdown.dropdown-icon .dropdown-toggle:after,
.dropup.dropdown-icon .dropdown-toggle:after {
  display: none;
}
.dropdown.dropdown-icon .dropdown-toggle svg,
.dropup.dropdown-icon .dropdown-toggle svg {
  left: 0;
}
.dropdown.dropdown-icon .dropdown-menu,
.dropup.dropdown-icon .dropdown-menu {
  min-width: auto;
}
.dropdown.dropdown-icon .dropdown-menu .dropdown-item,
.dropup.dropdown-icon .dropdown-menu .dropdown-item {
  padding: 0.5rem 1.1rem;
  cursor: pointer;
}
.dropdown.dropdown-icon .dropdown-menu .dropdown-item:hover,
.dropup.dropdown-icon .dropdown-menu .dropdown-item:hover {
  color: #fff;
}

.btn.btn-white ~ .dropdown-menu .dropdown-item:not(.acitve):hover {
  color: #626262 !important;
}
.btn.btn-white ~ .dropdown-menu .dropdown-item.active {
  color: #626262;
}

/* ===============================================================================================
    File Name: navbar.scss
    Description: Contain header navigation bar, vertical main navigation bar and
    horiznotal main navigation bar related SCSS.
    ----------------------------------------------------------------------------------------------
    Item Name: Vuexy React admin Template
    Version: 1.0
    Author: PIXINVENT
    Author URL: http://www.themeforest.net/user/pixinvent
================================================================================================*/
.navbar-dark .hamburger-inner,
.navbar-dark .hamburger-inner::before,
.navbar-dark .hamburger-inner::after {
  background-color: #fff;
}

.header-navbar-shadow {
  display: block;
  background: linear-gradient(180deg, hsla(0, 0%, 97.3%, 0.95) 44%, hsla(0, 0%, 97.3%, 0.46) 73%, hsla(0, 0%, 100%, 0));
  padding-top: 2.2rem;
  background-repeat: repeat;
  width: 100%;
  height: 102px;
  position: fixed;
  top: 0;
  z-index: 11;
}

.header-navbar {
  padding: 0px;
  min-height: 4.5rem;
  font-family: "Montserrat", Helvetica, Arial, serif;
  transition: 300ms ease all;
  background: linear-gradient(180deg, hsla(0, 0%, 97.3%, 0.95) 44%, hsla(0, 0%, 97.3%, 0.46) 73%, hsla(0, 0%, 100%, 0));
  z-index: 1000;
  /* For sm screen*/
}
.header-navbar.fixed-top {
  left: 260px;
}
.header-navbar[class*=bg-] .navbar-nav .nav-item a {
  color: #fff !important;
}
.header-navbar[class*=bg-] .navbar-nav .nav-item a.dropdown-item span,
.header-navbar[class*=bg-] .navbar-nav .nav-item a.dropdown-item svg {
  color: #626262 !important;
}
.header-navbar[class*=bg-] .navbar-nav .nav-item a.dropdown-item:hover span,
.header-navbar[class*=bg-] .navbar-nav .nav-item a.dropdown-item:hover svg {
  color: #fff !important;
}
.header-navbar[class*=bg-] .navbar-nav .nav-item svg,
.header-navbar[class*=bg-] .navbar-nav .nav-item span {
  color: #fff !important;
}
.header-navbar.floating-nav {
  margin: 1.3rem 2.2rem 0;
  border-radius: 0.5rem;
  position: fixed;
  width: calc(100% - 2.2rem * 2 - 260px);
  z-index: 11;
  right: 0;
}
.header-navbar.navbar-static-top {
  background: transparent;
  box-shadow: none !important;
}
.header-navbar .navbar-wrapper {
  width: 100%;
}
.header-navbar.navbar-border {
  border-bottom: 1px solid #e4e7ed;
}
.header-navbar.navbar-dark.navbar-border {
  border-bottom: 1px solid #8596b5;
}
.header-navbar.navbar-shadow {
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
}
.header-navbar .nav-link.dropdown-toggle::after {
  display: none;
}
.header-navbar .navbar-container ul.nav li.dropdown-language {
  padding-right: 0;
}
.header-navbar .navbar-container ul.nav li.dropdown-language .country-flag {
  width: 1.5rem !important;
}
.header-navbar .navbar-container ul.nav li.dropdown-language .selected-language {
  font-size: 0.97rem;
  letter-spacing: -0.25px;
  font-weight: 500;
}
.header-navbar .navbar-container {
  padding-left: 1rem;
  transition: 300ms ease all;
  background: inherit;
  margin-left: 0;
}
.header-navbar .navbar-container ul.navbar-nav li {
  line-height: 0.5;
}
.header-navbar .navbar-container ul.navbar-nav li > .nav-link {
  padding: 1.4rem 0.5rem 1.35rem;
}
.header-navbar .navbar-container ul.navbar-nav li > .nav-link svg:hover {
  color: #7367f0;
}
.header-navbar .navbar-container ul.navbar-nav li.dropdown-notification .dropdown-menu:focus {
  outline: none;
}
.header-navbar .navbar-container ul.navbar-nav.navbar-nav-user li:not(:last-child) > .nav-link {
  margin-right: 0.5rem;
}
.header-navbar .navbar-container .bookmark-input {
  z-index: 1;
}
.header-navbar .navbar-container ul.nav li.dropdown .dropdown-menu {
  top: 48px;
  margin-top: -4px;
}
.header-navbar .navbar-container ul.nav li .badge {
  padding: 0.42em 0.6em 0.25rem;
}
.header-navbar .navbar-container ul.nav li .badge.badge-up {
  position: absolute;
  top: 12px;
  right: -7px;
}
.header-navbar .navbar-container ul.nav li.dropdown-language > a.nav-link {
  padding: 1.75rem 0.5rem;
}
.header-navbar .navbar-container ul.nav li.dropdown-language .dropdown-menu {
  min-width: 12rem;
}
.header-navbar .navbar-container ul.nav li > .nav-link {
  color: #626262;
  padding: 1.4rem 0.5rem 1.35rem;
}
.header-navbar .navbar-container ul.nav li > .nav-link i.flag-icon {
  margin-right: 0.5rem;
}
.header-navbar .navbar-container ul.nav li.dropdown-user .dropdown-menu-right {
  right: 26px;
  left: -12px !important;
  padding: 0.5rem;
}
.header-navbar .navbar-container ul.nav li.dropdown-user .dropdown-menu-right .dropdown-item {
  padding: 10px;
}
.header-navbar .navbar-container ul.nav li.dropdown-user .dropdown-menu-right .dropdown-item:hover, .header-navbar .navbar-container ul.nav li.dropdown-user .dropdown-menu-right .dropdown-item:active {
  background: #7367f0;
}
.header-navbar .navbar-container ul.nav li.dropdown-user .dropdown-menu-right .dropdown-item:hover span,
.header-navbar .navbar-container ul.nav li.dropdown-user .dropdown-menu-right .dropdown-item:hover svg, .header-navbar .navbar-container ul.nav li.dropdown-user .dropdown-menu-right .dropdown-item:active span,
.header-navbar .navbar-container ul.nav li.dropdown-user .dropdown-menu-right .dropdown-item:active svg {
  color: #fff;
}
.header-navbar .navbar-container ul.nav li a.dropdown-user-link {
  padding: 0.7rem 1rem;
  display: flex;
  align-items: center;
}
.header-navbar .navbar-container ul.nav li a.dropdown-user-link .user-name {
  display: inline-block;
  margin-bottom: 0.435rem;
  margin-left: 0.2rem;
  line-height: 1;
}
.header-navbar .navbar-container ul.nav li a.dropdown-user-link .user-status {
  font-size: smaller;
}
.header-navbar .navbar-container ul.nav li a.dropdown-user-link img {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.08);
}
.header-navbar .navbar-container ul.nav li a.menu-toggle {
  padding: 1.34rem 0.22rem 1.35rem 0;
}
.header-navbar .navbar-container ul.nav li a.menu-toggle i {
  font-size: 1.75rem;
}
.header-navbar .navbar-container ul.nav li a.nav-link-label {
  padding: 1.6rem 0.2rem 1.35rem 0.8rem;
}
.header-navbar .navbar-container ul.nav li a.dropdown-user-link .user-nav {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  float: left;
  margin-right: 0.8rem;
}
.header-navbar .navbar-container ul.nav li div.input-group {
  padding: 0.7rem 1rem;
}
.header-navbar .navbar-container ul.nav li i.ficon {
  font-size: 1.5rem;
  color: #626262;
}
.header-navbar .navbar-container ul.nav li i.ficon:hover {
  color: #7367f0;
}
.header-navbar .navbar-container ul.nav li .media-list {
  max-height: 24rem;
  line-height: 1;
}
.header-navbar .navbar-container ul.nav li .scrollable-container {
  position: relative;
}
.header-navbar .navbar-container .dropdown-menu-media {
  width: 26rem;
  left: 10px !important;
}
.header-navbar .navbar-container .dropdown-menu-media .media-list {
  cursor: pointer;
}
.header-navbar .navbar-container .dropdown-menu-media .media-list .media {
  padding: 1rem;
  border: none;
  border-bottom: 1px solid #dae1e7;
}
.header-navbar .navbar-container .dropdown-menu-media .media-list .media:hover {
  background: #f8f8f8;
}
.header-navbar .navbar-container .dropdown-menu-media .media-list .media .media-meta {
  color: #626262;
}
.header-navbar .navbar-container .dropdown-menu-media .media-list a:last-of-type .media {
  border-bottom: none;
}
.header-navbar .navbar-container .dropdown-menu-media .dropdown-menu-header {
  border-bottom: 1px solid #dae1e7;
  padding: 1.25rem;
}
.header-navbar .navbar-container .dropdown-menu-media .dropdown-menu-header .dropdown-header {
  padding: 0;
}
.header-navbar .navbar-container .dropdown-menu-media .dropdown-menu-footer a {
  padding: 0.3rem;
  border-top: 1px solid #dae1e7;
}
.header-navbar .navbar-container .dropdown-menu-media.dropdown-cart {
  left: 5px !important;
}
.header-navbar .navbar-container .dropdown-menu-media.dropdown-cart.empty-cart:before {
  background: #fff;
  border-color: rgba(0, 0, 0, 0.1);
}
.header-navbar .navbar-container .dropdown-menu-media.dropdown-cart .media-left {
  width: 100px;
}
.header-navbar.navbar-without-menu .navbar-container {
  margin-left: 0;
}
.header-navbar .nav-item + .nav-item {
  margin-left: 0rem;
}
@media (max-width: 575.98px) {
  .header-navbar .navbar-header {
    width: 100% !important;
    padding: 0.5rem 1rem;
    position: relative;
  }
  .header-navbar .navbar-header .menu-toggle {
    top: 2px;
    position: relative;
  }
  .header-navbar .navbar-header .open-navbar-container i {
    font-size: 1.8rem;
  }
  .header-navbar .navbar-header .navbar-brand {
    position: absolute;
    left: 50%;
    top: 0;
    transform: translate(-50%, 0);
  }
  .header-navbar.navbar-with-menu .navbar-container {
    width: 100%;
    display: table;
    margin: 0;
    height: auto;
  }
}

/* Modern menu For md screen*/
@media (max-width: 767.98px) {
  [data-menu=vertical-menu-modern] .header-navbar .navbar-header {
    width: 100% !important;
    padding: 0.5rem 1rem;
    position: relative;
  }
  [data-menu=vertical-menu-modern] .header-navbar .navbar-header .menu-toggle {
    top: 2px;
    position: relative;
  }
  [data-menu=vertical-menu-modern] .header-navbar .navbar-header .open-navbar-container i {
    font-size: 1.8rem;
  }
  [data-menu=vertical-menu-modern] .header-navbar .navbar-header .navbar-brand {
    position: absolute;
    left: 50%;
    top: 0;
    transform: translate(-50%, 0);
  }
  [data-menu=vertical-menu-modern] .header-navbar.navbar-with-menu .navbar-container {
    width: 100%;
    display: table;
    margin: 0;
    height: auto;
  }
  [data-menu=vertical-menu-modern] .navbar-dark .navbar-header .navbar-nav .nav-link,
  [data-menu=vertical-menu-modern] .navbar-semi-dark .navbar-header .navbar-nav .nav-link {
    color: #fff;
  }
  [data-menu=vertical-menu-modern] .navbar-dark .navbar-container .navbar-nav .nav-link,
  [data-menu=vertical-menu-modern] .navbar-semi-dark .navbar-container .navbar-nav .nav-link {
    color: #b8c2cc;
  }
}
.navbar-light {
  background: #fff;
}
.navbar-light.navbar-horizontal {
  background: #fff;
}
.navbar-light .navbar-nav li {
  line-height: 1;
}
.navbar-light .navbar-nav .active.nav-link {
  background-color: rgba(0, 0, 0, 0.03);
}
.navbar-light .navbar-nav .disabled.nav-link {
  color: var(--bs-secondary-color);
}

.navbar-dark {
  background: #b8c2cc;
}
.navbar-dark .navbar-brand {
  color: #fff !important;
}
.navbar-dark.navbar-horizontal {
  background: #b8c2cc;
}
.navbar-dark .nav-search .form-control,
.navbar-dark .nav-search .btn-secondary {
  color: #fff;
  background: #b8c2cc;
}
.navbar-dark .navbar-nav li {
  line-height: 1;
}
.navbar-dark .navbar-nav .active.nav-link {
  background-color: rgba(255, 255, 255, 0.05);
}
.navbar-dark .navbar-nav .disabled.nav-link {
  color: #dae1e7;
}

.navbar-semi-dark {
  background: #fff;
}
.navbar-semi-dark .navbar-header {
  background: #b8c2cc;
}
.navbar-semi-dark .navbar-header .brand-text {
  color: #fff;
}
.navbar-semi-dark .navbar-nav li {
  line-height: 1;
}
.navbar-semi-dark .navbar-nav .nav-link {
  color: #b8c2cc;
}
.navbar-semi-dark .navbar-nav .active.nav-link {
  background-color: rgba(0, 0, 0, 0.03);
}
.navbar-semi-dark .navbar-nav .disabled.nav-link {
  color: var(--bs-secondary-color);
}

.navbar-semi-light {
  background: #b8c2cc;
}
.navbar-semi-light .navbar-header {
  background: #fff;
}
.navbar-semi-light .navbar-header .brand-text {
  color: #b8c2cc;
}
.navbar-semi-light .navbar-nav li {
  line-height: 1;
}
.navbar-semi-light .navbar-nav .nav-link {
  color: #fff;
}
.navbar-semi-light .navbar-nav .active.nav-link {
  background-color: rgba(0, 0, 0, 0.03);
}
.navbar-semi-light .navbar-nav .disabled.nav-link {
  color: var(--bs-secondary-color);
}

@-moz-document url-prefix() {
  ul li a .children-in {
    position: relative;
    right: 3px;
    top: -14px;
  }
}
.navbar-menu-icon span {
  display: block;
  position: absolute;
  height: 2px;
  width: 100%;
  background: #b8c2cc;
  border-radius: 9px;
  opacity: 1;
  left: 0;
  transform: rotate(0deg);
  transition: 0.25s ease-in-out;
}

.navbar-menu-icon span:nth-child(1) {
  top: 0px;
}

.navbar-menu-icon span:nth-child(2) {
  top: 10px;
}

.navbar-menu-icon span:nth-child(3) {
  top: 20px;
}

.navbar-menu-icon.show span:nth-child(1) {
  top: 10px;
  transform: rotate(135deg);
}

.navbar-menu-icon.show span:nth-child(2) {
  opacity: 0;
  left: -60px;
}

.navbar-menu-icon.show span:nth-child(3) {
  top: 10px;
  transform: rotate(-135deg);
}

@media (max-width: 575.98px) {
  .header-navbar .navbar-nav .show {
    position: static;
  }
  .header-navbar .navbar-nav .open-navbar-container {
    padding-top: 0.625rem;
  }
  .header-navbar .navbar-container .show .dropdown-menu {
    right: 0;
    left: 0 !important;
    float: none;
    width: auto;
    margin-top: 0;
    overflow: hidden;
  }
  .header-navbar .navbar-container ul.nav li.nav-item i {
    margin-right: 0.2rem;
  }
  .header-navbar .navbar-container ul.nav li a.dropdown-user-link {
    padding: 0.8rem 0.6rem;
  }
  .header-navbar .navbar-container ul.nav li .dropdown-toggle::after {
    margin-right: 0;
    margin-left: -2px;
  }
  .navbar-dark .hamburger-inner,
  .navbar-dark .hamburger-inner::before,
  .navbar-dark .hamburger-inner::after,
  .navbar-semi-dark .hamburger-inner,
  .navbar-semi-dark .hamburger-inner::before,
  .navbar-semi-dark .hamburger-inner::after {
    background-color: #fff;
  }
  .navbar-dark .navbar-header .navbar-nav .nav-link,
  .navbar-semi-dark .navbar-header .navbar-nav .nav-link {
    color: #fff;
  }
  .navbar-dark .navbar-container .navbar-nav .nav-link,
  .navbar-semi-dark .navbar-container .navbar-nav .nav-link {
    color: #b8c2cc;
  }
  .header-navbar .navbar-container .dropdown-notification .dropdown-menu,
  .header-navbar .navbar-container .dropdown-language .dropdown-menu {
    right: 0 !important;
    left: 31px !important;
  }
}
.headroom {
  will-change: transform;
  transition: transform 200ms linear;
}

.headroom--pinned-top {
  transform: translateY(0%);
}

.headroom--unpinned-top {
  transform: translateY(-100%);
}

.headroom--pinned-bottom {
  transform: translateY(0%);
}

.headroom--unpinned-bottom {
  transform: translateY(100%);
}

.header-navbar .navbar-container ul.nav li .selected-language {
  display: none;
}

body[data-col="1-column"] .header-navbar.floating-nav {
  width: calc(100% - 2.2rem * 2);
}

@media (min-width: 1200px) and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  body:not([data-col="1-columns"]) .header-navbar.floating-nav {
    width: calc(100% - 60px - 260px);
  }
}
@media (max-width: 991.98px) {
  .header-navbar .navbar-container ul.nav li.dropdown-language > a.nav-link {
    padding: 1.75rem 0.5rem;
  }
  .header-navbar .navbar-container ul.nav li a.dropdown-user-link {
    padding: 0.7rem 1.23rem;
  }
  .header-navbar .navbar-container ul.nav li .dropdown-toggle::after {
    margin-right: 0;
    margin-left: -2px;
  }
}
@media (max-width: 767px) {
  #navbar-mobile.navbar-collapse .navbar-nav {
    margin: 0;
    flex-flow: row wrap;
  }
  #navbar-mobile.navbar-collapse .navbar-nav .dropdown-menu {
    position: absolute;
  }
  #navbar-mobile.navbar-collapse .navbar-nav .nav-item {
    float: left;
  }
}
@media (max-width: 767.98px) {
  #navbar-mobile.navbar-collapse .navbar-nav {
    margin: 0;
    flex-flow: row wrap;
  }
  #navbar-mobile.navbar-collapse .navbar-nav .dropdown-menu {
    position: absolute;
  }
  #navbar-mobile.navbar-collapse .navbar-nav .nav-item {
    float: left;
  }
}
/* ----------- iPhone 5, 5S  iPhone 6----------- */
/* Landscape */
@media only screen and (min-device-width: 26.78em) and (max-device-width: 47.64em) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
  .header-navbar .navbar-container .show .dropdown-menu {
    max-height: 180px;
  }
}
/* ----------- iPhone 6+ ----------- */
/* Landscape */
@media only screen and (min-device-width: 29.57em) and (max-device-width: 52.57em) and (-webkit-min-device-pixel-ratio: 3) and (orientation: landscape) {
  .header-navbar .navbar-container .show .dropdown-menu {
    max-height: 280px;
  }
}
/*----------------------------- For Navbar Component -------------------------*/
#navbar-component .navbar {
  position: relative;
  width: auto;
  z-index: auto;
}
#navbar-component .navbar.floating-nav {
  border-radius: 0.5rem;
}
#navbar-component .navbar.header-navbar.navbar-dark .navbar-nav .nav-link {
  color: #fff;
}
#navbar-component .navbar .navbar-nav .dropdown-language.show,
#navbar-component .navbar .navbar-nav .dropdown-notification.show,
#navbar-component .navbar .navbar-nav .dropdown-user.show {
  position: relative;
}
#navbar-component .navbar .navbar-nav .dropdown-language .dropdown-menu.show,
#navbar-component .navbar .navbar-nav .dropdown-notification .dropdown-menu.show,
#navbar-component .navbar .navbar-nav .dropdown-user .dropdown-menu.show {
  position: absolute;
  right: 0;
}
#navbar-component .navbar.navbar-dark .navbar-toggler, #navbar-component .navbar.navbar-light .navbar-toggler {
  font-size: 1.2rem;
}
#navbar-component .navbar.navbar-dark .navbar-toggler:focus, #navbar-component .navbar.navbar-light .navbar-toggler:focus {
  outline: 0;
}
#navbar-component #navbar-collapsed .navbar {
  border-radius: 0;
}

@media (min-width: 992px) {
  #navbar-component .navbar .navbar-container {
    background: inherit;
  }
  #navbar-component .nav .dropdown-language {
    float: right;
  }
}
@media (max-width: 992px) {
  #navbar-component .navbar .navbar-container {
    background: inherit;
  }
  #navbar-component .navbar .navbar-container .navbar-nav {
    flex-direction: row;
  }
}
@media (max-width: 1200px) {
  .header-navbar.fixed-top {
    left: 0;
  }
}
@media (max-width: 768px) {
  #navbar-component .navbar .navbar-nav .dropdown-notification.show {
    position: static;
  }
}
.header-navbar.floating-nav {
  width: calc(100% - 2.4rem) !important;
  margin-left: 1.2rem;
  margin-right: 1.2rem;
}

.content.app-content .content-area-wrapper {
  margin-left: 1.2rem !important;
  margin-right: 1.2rem !important;
}

@media (max-width: 992px) {
  .navbar-container #navbar-mobile .nav-back {
    margin-top: 5px;
  }
}
.card-group,
.card-deck {
  margin-bottom: 0.75rem;
}

.card {
  margin-bottom: 2.2rem;
  border: none;
  border-radius: 0.5rem;
  box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-in-out;
}
.card .card {
  box-shadow: none !important;
}
.card .card-subtitle {
  margin-top: 0.5rem;
}
.card .card-title {
  font-weight: 500;
  letter-spacing: 0.05rem;
  font-size: 1.32rem;
  margin-bottom: 0.5rem;
  color: #2c2c2c;
}
.card .card-bordered {
  border: var(--bs-border-width) solid var(--bs-border-color-translucent);
}
.card .card-img-overlay {
  border-radius: var(--bs-border-radius);
}
.card.card-fullscreen {
  display: block;
  z-index: 9999;
  position: fixed;
  width: 100% !important;
  height: 100% !important;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  overflow: auto;
}
.card .card-body[class*=border-bottom-] {
  border-bottom-width: 2px !important;
}
.card .card-img-overlay.bg-overlay {
  background: rgba(0, 0, 0, 0.45);
}
.card .card-img-overlay .text-muted {
  color: #1e1e1e !important;
}
.card.card-minimal {
  border: none;
  box-shadow: none;
}
.card .card-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  border-bottom: none;
  padding: 1.5rem 1.5rem 0;
  background-color: transparent;
}
.card .card-header .card-title {
  margin-bottom: 0;
}
.card .card-header .nav-tabs {
  margin-bottom: 0;
}
.card .card-footer {
  border-top: 1px solid #dae1e7;
}
.card.card-action .card-header {
  padding-bottom: 1.5rem;
}
.card.card-action .card-header svg {
  cursor: pointer;
}
.card.card-action.card-collapsed .card-header .collapse-icon {
  transform: rotate(180deg);
  transition: all 0.5s ease;
}
.card.card-action.closing .collapse-icon {
  transform: rotate(180deg);
  transition: all 0.5s ease;
}
.card.card-action.opening .collapse-icon {
  transform: rotate(0deg);
  transition: all 0.5s ease;
}
.card.card-action.card-shown .card-header .collapse-icon {
  transform: rotate(0deg);
  transition: all 0.5s ease;
}
.card.card-action.card-reload .reload-spinner {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 1;
}
.card.card-action.card-reload.refreshing .card-body {
  opacity: 0.5;
}

.card-columns .card {
  margin-bottom: 2.2rem;
}

.text-white .card-text {
  color: white;
}
.text-white .card-img-overlay .text-muted {
  color: #fff !important;
}
.text-white code {
  background-color: white;
}

.card-head-inverse {
  color: #fff;
}

.card-transparent {
  background-color: transparent;
}

.overlay-img-card .card-img-overlay,
.overlay-img-card img {
  max-height: 34.64rem;
}

.activity-timeline .timeline-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.activity-timeline.timeline-left {
  border-left: 2px solid #dae1e7;
  padding-left: 40px;
  margin-left: 1.5rem;
}
.activity-timeline.timeline-left li {
  position: relative;
  margin-bottom: 20px;
}
.activity-timeline.timeline-left li p {
  margin-bottom: 0;
}
.activity-timeline.timeline-left li .timeline-icon {
  position: absolute;
  top: 0;
  left: -4.3rem;
  padding: 0.7rem;
  border-radius: 50%;
  color: #fff;
}
.activity-timeline.timeline-right {
  border-right: 2px solid #dae1e7;
  padding-right: 40px;
  margin-right: 1.5rem;
}
.activity-timeline.timeline-right li {
  position: relative;
  margin-bottom: 20px;
  text-align: right;
}
.activity-timeline.timeline-right li p {
  margin-bottom: 0;
}
.activity-timeline.timeline-right li .timeline-icon {
  position: absolute;
  top: 0;
  right: -4.3rem;
  padding: 0.6rem 0.7rem;
  border-radius: 50%;
  color: #fff;
}

.breadcrumb {
  font-size: 1rem;
  font-family: "Montserrat", Helvetica, Arial, serif;
  background-color: transparent;
  padding: 0.5rem 0 0.5rem 0 !important;
  border-radius: 0;
}
.breadcrumb > li + li::before {
  padding-right: 0.6rem;
  padding-left: 0.6rem;
}
.breadcrumb .breadcrumb-item + .breadcrumb-item {
  padding-left: 0;
}
.breadcrumb .breadcrumb-item + .breadcrumb-item:before {
  content: "\\e847";
  font-family: "feather";
  color: #626262;
}
.breadcrumb .breadcrumb-item.active {
  color: #626262;
}

/* Custom scss for page headers style */
.breadcrumbs-right .breadcrumb {
  float: right;
}

.breadcrumbs-top .breadcrumb {
  margin: 0;
  padding: 0;
}

.vx-breadcrumbs .breadcrumb {
  border-left: 1px solid rgb(213.6803278689, 219.5, 225.3196721311) !important;
}

/* Component Specific */
#component-breadcrumbs .breadcrumb {
  border: none;
}
#component-breadcrumbs .breadcrumb .breadcrumb-item + .breadcrumb-item:before {
  padding: 0 1rem;
}
#component-breadcrumbs .breadcrumb-slash .breadcrumb-item + .breadcrumb-item:before {
  content: "/";
}
#component-breadcrumbs .breadcrumb-dots .breadcrumb-item + .breadcrumb-item:before {
  content: ".";
  position: relative;
  top: -4px;
}
#component-breadcrumbs .breadcrumb-dashes .breadcrumb-item + .breadcrumb-item:before {
  content: "-";
}
#component-breadcrumbs .breadcrumb-pipes .breadcrumb-item + .breadcrumb-item:before {
  content: "|";
}
#component-breadcrumbs .breadcrumb-chevron .breadcrumb-item + .breadcrumb-item:before {
  content: "\\e844";
  font-family: "feather";
  position: relative;
  top: 1px;
}

#breadcrumb-alignment .breadcrumb-wrapper {
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
  padding: 1px;
  border-radius: 10px;
  display: flex;
  margin-bottom: 1rem;
}
#breadcrumb-alignment .breadcrumb-wrapper .breadcrumb {
  margin: 1rem;
}

.badge {
  color: #fff;
  font-weight: 400;
}
.badge[class*=badge-] [class*=icon-] {
  line-height: 1;
}
.badge[class*=badge-] a {
  color: #fff;
}
.badge[class*=badge-] span {
  vertical-align: middle;
}
.badge[class*=badge-] svg ~ span {
  margin-left: 0.5rem;
}
.badge.badge-square {
  border-radius: 0;
}
.badge.badge-up {
  position: absolute;
  top: -1rem;
  right: -1rem;
}
.badge.badge-up.badge-sm {
  top: -0.5rem;
  right: -0.5rem;
}

.badge-xl {
  font-size: 1.8rem;
}

.badge-lg {
  font-size: 1.2rem;
}

.badge-md {
  font-size: 1rem;
}

.badge-sm {
  font-size: 0.7rem;
}

.badge-icon svg {
  font-size: 100%;
  margin-right: 5px;
}

.dropup .badge {
  cursor: pointer;
}

.nav {
  border-radius: 0.25rem;
}
.nav.wrap-border {
  border: 1px solid #ddd;
}
.nav.wrap-border li.nav-header {
  margin: 0 0.5rem;
}
.nav.wrap-border li.nav-item,
.nav.wrap-border div {
  padding: 2px 0.714rem;
}
.nav.square-border {
  border-radius: 0;
}
.nav.square-border .nav-item .nav-link.active {
  border-radius: 0;
}
.nav .modern-nav-toggle {
  padding: 1.571rem 0;
  cursor: pointer;
}
.nav .modern-nav-toggle .toggle-icon {
  margin-right: 0.425rem;
}
.nav.nav-pills {
  margin-bottom: 1rem;
}
.nav.nav-pills .nav-item .nav-link {
  border-radius: 0.357rem;
  padding: 0.2rem 1rem;
  padding-top: 0.3rem;
  font-size: 0.98rem;
  margin-right: 0.5rem;
  color: #000;
}
.nav.nav-pills .nav-item .nav-link.active {
  color: #fff;
}
.nav.nav-pills .nav-item .nav-link.disabled {
  color: #b8c2cc;
}
.nav.nav-pills .nav-item .nav-link.dropdown-toggle::after {
  top: 1px;
  left: 1px;
}
.nav.nav-pills .nav-item.dropdown.show .nav-link {
  color: #fff;
}
.nav.nav-pills .nav-item.dropdown.show .dropdown-item.active:hover {
  color: #7367f0;
}
.nav.nav-pills.nav-justified {
  width: 100%;
}
.nav.nav-pills.nav-justified .nav-item {
  float: none;
}
.nav.nav-pills.nav-justified .nav-link {
  text-align: center;
  margin-bottom: 5px;
}
.nav.nav-pills.nav-justified > .dropdown .dropdown-menu {
  top: auto;
  left: auto;
}
@media (min-width: 576px) {
  .nav.nav-pills.nav-justified .nav-item {
    display: block;
    width: 1%;
  }
  .nav.nav-pills.nav-justified .nav-link {
    margin-bottom: 0;
  }
}
.nav.nav-pills.nav-justified .nav-link {
  margin-right: 0;
  border-radius: 0.5rem;
}
@media (min-width: 576px) {
  .nav.nav-pills.nav-justified .nav-link.active,
  .nav.nav-pills.nav-justified .nav-link.active:hover,
  .nav.nav-pills.nav-justified .nav-link.active:focus {
    border-bottom-color: transparent;
  }
}
.nav.nav-pills.nav-justified .nav-link {
  display: block;
}
.nav.nav-pills.nav-justified .nav-link.active {
  border: none;
}
.nav.nav-pills.nav-justified .nav-link.active:hover, .nav.nav-pills.nav-justified .nav-link.active:focus {
  border: none;
}
.nav.nav-pills.nav-active-bordered-pill .nav-item a.nav-link.active {
  border: 1px solid #7367f0;
  border-radius: 0.25rem;
  color: #7367f0;
  background-color: #fff;
}
.nav.nav-tabs {
  box-shadow: -1px 11px 17px -10px rgba(0, 0, 0, 0.04);
  border: none;
  margin-bottom: 1rem;
  position: relative;
  border-radius: 0;
}
.nav.nav-tabs .nav-item {
  position: relative;
}
.nav.nav-tabs .nav-item .nav-link {
  color: #000;
  font-size: 0.95rem;
  border: none;
  min-width: auto;
  font-weight: 450;
  padding: 0.61rem 0.635rem;
  border-radius: 0;
}
.nav.nav-tabs .nav-item .nav-link.active {
  border: none;
  position: relative;
  color: #7367f0;
  transition: all 0.2s ease;
  background-color: #fff;
  transform: translateY(-2px);
}
.nav.nav-tabs .nav-item .nav-link.active:after {
  content: attr(data-before);
  height: 2px;
  width: 100%;
  left: 0;
  position: absolute;
  bottom: 0;
  top: 100%;
  background: linear-gradient(30deg, #7367f0, rgba(115, 103, 240, 0.5)) !important;
  box-shadow: 0 0 8px 0 rgba(115, 103, 240, 0.5) !important;
  transform: translateY(0px);
  transition: all 0.2s linear;
}
.nav.nav-tabs .nav-item .nav-link.dropdown-toggle::after {
  top: 1px;
  left: 1px;
}
.nav.nav-tabs .nav-item .nav-link.disabled {
  color: #b8c2cc;
}
.nav.nav-tabs.nav-justified {
  width: 100%;
}
.nav.nav-tabs.nav-justified .nav-item {
  float: none;
}
.nav.nav-tabs.nav-justified .nav-link {
  text-align: center;
  margin-bottom: 5px;
}
.nav.nav-tabs.nav-justified > .dropdown .dropdown-menu {
  top: auto;
  left: auto;
}
@media (min-width: 576px) {
  .nav.nav-tabs.nav-justified .nav-item {
    display: block;
    width: 1%;
  }
  .nav.nav-tabs.nav-justified .nav-link {
    margin-bottom: 0;
  }
}
.nav.nav-tabs.nav-justified .nav-link {
  margin-right: 0;
  border-radius: 0.5rem;
}
@media (min-width: 576px) {
  .nav.nav-tabs.nav-justified .nav-link.active,
  .nav.nav-tabs.nav-justified .nav-link.active:hover,
  .nav.nav-tabs.nav-justified .nav-link.active:focus {
    border-bottom-color: transparent;
  }
}
.nav.nav-tabs.nav-justified .nav-item a.nav-link {
  display: block;
  border-radius: 0;
}
.nav.nav-tabs.nav-justified .nav-item a.nav-link.active {
  border: none;
  background-color: #fff;
}
.nav.nav-tabs.nav-justified .nav-item a.nav-link:hover {
  border-color: transparent;
}

.nav-vertical {
  overflow: hidden;
}
.nav-vertical .nav.nav-tabs .nav-item .nav-link {
  border: none;
  margin-bottom: 0;
}
.nav-vertical .nav.nav-tabs .nav-item .nav-link.active {
  border: none;
  border-radius: 0;
}
.nav-vertical .nav.nav-tabs .nav-item .nav-link.active:after {
  transform: rotate(90deg);
  left: -1rem;
  bottom: 100%;
  top: 1rem;
  width: 2.14rem;
}
.nav-vertical .nav.nav-tabs .nav-item .nav-link:hover {
  border-right: none;
}
.nav-vertical .nav.nav-tabs.nav-left {
  float: left;
  display: table;
  margin-right: 1rem;
}
.nav-vertical .nav.nav-tabs.nav-left ~ .tab-content .tab-pane {
  display: none;
  background-color: #fff;
  overflow-y: auto;
  padding-left: 1rem;
}
.nav-vertical .nav.nav-tabs.nav-left ~ .tab-content .tab-pane.active {
  display: block;
}
.nav-vertical .nav.nav-tabs.nav-right {
  float: right;
  display: table;
  margin-left: 1rem;
}
.nav-vertical .nav.nav-tabs.nav-right .nav-item .nav-link.active:after {
  left: 2.6rem;
}
.nav-vertical .nav.nav-tabs.nav-right ~ .tab-content .tab-pane {
  display: none;
  background-color: #fff;
  overflow-y: auto;
  padding-right: 1rem;
}
.nav-vertical .nav.nav-tabs.nav-right ~ .tab-content .tab-pane.active {
  display: block;
}

.alert {
  font-weight: 500;
  border: none;
}
.alert .close:focus {
  outline: 0;
}
.alert p {
  font-weight: 500;
  padding: 2px 0;
  margin-bottom: 0;
  vertical-align: middle;
}
.alert span {
  vertical-align: middle;
}
.alert svg {
  margin-right: 1rem;
  vertical-align: middle;
}
.alert .alert-heading {
  font-weight: 700;
  font-size: 0.9rem;
  padding: 0;
  padding-bottom: 8px;
  margin-bottom: 0.5rem;
}
.alert.alert-dismissible .close {
  opacity: 1;
  top: -2px;
}
.alert.alert-dark .alert-heading {
  box-shadow: rgba(42, 46, 48, 0.4) 0px 6px 15px -7px;
}
.alert.alert-light .alert-heading {
  box-shadow: rgba(186, 191, 199, 0.4) 0px 6px 15px -7px;
}

.media-list .media {
  padding: 1.25rem;
  width: 100%;
  margin-top: 0;
}
.media-list .media .media-left {
  padding-right: 1rem;
}
.media-list .media .media-right {
  padding-left: 1rem;
}
.media-list a.media {
  color: #b8c2cc !important;
}

.media-bordered .media {
  border-top: 1px solid #e4e7ed;
}
.media-bordered .media:first-child {
  border-top: 0;
}

/*=========================================================================================
  File Name: progress.scss
  Description: Extended bootstrap progress bar scss.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy React admin Template
  Version: 1.0
  Author: PIXINVENT
  Author URL: http://www.themeforest.net/user/pixinvent
  ----------------------------------------------------------------------------------------

  Modifiers:       \`progress-lg\`
                   \`progress-md\`
                   \`progress-sm\`
                   \`progress-xs\`

==========================================================================================*/
.progress {
  margin-bottom: 3rem;
}
.progress:last-child {
  margin-bottom: 1rem;
}
.progress.progress-xl {
  height: 1.14rem;
}
.progress.progress-lg {
  height: 0.857rem;
}
.progress.progress-md {
  height: 0.57rem;
}
.progress.progress-sm {
  height: 0.143rem;
}
.progress .progress-bar {
  border-radius: 1.28rem;
}
.progress .progress-bar.progress-bar-animated {
  animation: progressBarAnimated 1s linear infinite;
}
.progress .progress-bar-striped {
  background-size: 1rem 1rem;
}

[dir=rtl] .progress .progress-bar.progress-bar-animated {
  animation: progressBarAnimatedRTL 1s linear infinite !important;
}

@keyframes progressBarAnimated {
  0% {
    background-position: 1rem 0;
  }
  100% {
    background-position: 0 0;
  }
}
/* rtl:ignore */
@keyframes progressBarAnimatedRTL {
  0% {
    background-position: 1rem 0;
  }
  100% {
    background-position: 0 100%;
  }
}
/* ===============================================================================================
	File Name: list-group.scss
	Description: Contain list item, list group related extended SCSS.
	----------------------------------------------------------------------------------------------
	Item Name: Vuexy React admin Template
	Version: 1.0
	Author: PIXINVENT
	Author URL: http://www.themeforest.net/user/pixinvent
================================================================================================*/
ul.list-inline li {
  display: inline-block;
}
ul.list-inline.list-inline-pipe > li + li:before {
  content: " | ";
  padding-right: 2px;
}

.list-group .list-group-item {
  line-height: 1.5;
}
.list-group .list-group-item.active:hover {
  background-color: #7367f0;
}
.list-group .list-group-item.active:focus {
  color: #626262;
  outline: 0;
}
.list-group .list-group-item.active:focus:hover {
  color: #fff;
}
.list-group .list-group-item:hover {
  background-color: #f8f8f8;
}
.list-group .list-group-item:not(.active):focus:active {
  color: inherit;
}
.list-group .list-group-item-action:active {
  background-color: #7367f0;
  color: #fff;
}
.list-group .list-group-item-action:focus {
  background-color: #f8f8f8;
  outline: 0;
}

.list-group-item.gu-mirror {
  border-radius: 0;
}

.users-list li + li {
  margin-left: -0.785rem;
}
.users-list li img {
  border: 2px solid #fff;
  box-shadow: 0px 2px 10px 0px rgba(184, 194, 204, 0.3);
}
.users-list li .badge {
  color: #22292f;
}

.toast-bs-container {
  z-index: 1040;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.toast-bs-container .toast-position {
  position: relative;
  top: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap-reverse;
}
.toast-bs-container .toast-position .toast.show {
  opacity: 1;
  z-index: 1030;
}

.toast-placement {
  position: static;
  top: 0;
}
.toast-placement .toast {
  position: fixed;
  top: 0;
  z-index: 1030;
}

.toast {
  display: none;
  margin-top: 0.75rem;
}
.toast .toast-header .close:focus, .toast .toast-header .close:active {
  outline: none;
}

.toast.show.toast-wrapper {
  position: static;
}

.toast.toast-translucent {
  opacity: 1;
  display: block;
}

.toast-header img {
  width: 35px;
  height: 24px;
}

_:-ms-lang(x),
.toast-bs-container {
  position: fixed !important;
  left: 74% !important;
}

.vx-collapse .collapse-title {
  font-weight: 400;
  font-size: 1.2rem;
}
.vx-collapse .opening .collapse-icon,
.vx-collapse .collapse-shown .collapse-icon {
  transition: all 0.25s ease-in-out;
  transform: rotate(180deg);
}
.vx-collapse .collapse-icon {
  transition: all 0.25s ease-in-out;
  transform: rotate(0deg);
}
.vx-collapse .card {
  cursor: pointer;
}

.collapse-title {
  color: inherit;
  cursor: pointer;
}
.collapse-title:hover {
  color: inherit;
}

.collapse-bordered .card:first-child {
  border-top: 0;
}
.collapse-bordered .card:last-child {
  border-bottom: 0;
}
.collapse-bordered .card {
  margin-bottom: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
  border-radius: 0;
}
.collapse-bordered .card .card-header {
  padding: 1rem;
}
.collapse-bordered .card .card-body {
  padding: 1rem;
  line-height: 1.5;
}

.collapse-border-item.card {
  border: 1px solid rgba(0, 0, 0, 0.1);
  margin-bottom: 0;
  border-radius: 0;
}
.collapse-border-item.card:first-child {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.collapse-border-item.card:not(:last-child) {
  border-bottom: 0;
}
.collapse-border-item.card:last-child {
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
}
.collapse-border-item.card .card-header {
  padding: 1rem;
}
.collapse-border-item.card .card-body {
  padding: 1rem;
  line-height: 1.5;
}

.accordion-shadow {
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.1);
  padding: 0.15rem 0.75rem;
  border-radius: 0.5rem;
}
.accordion-shadow .card.open {
  border-radius: 0.571rem;
  margin: 10px 0;
  border: 0;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1) !important;
}
.accordion-shadow .card:first-child {
  border-top-left-radius: 0.571rem;
  border-top-right-radius: 0.571rem;
}
.accordion-shadow .card:last-child {
  border-bottom-left-radius: 0.571rem;
  border-bottom-right-radius: 0.571rem;
}

.collapse-border {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 0.5rem;
}
.collapse-border + .collapse.show {
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.collapse-margin {
  margin-top: 0.71rem;
  margin-bottom: 0.71rem !important;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.05);
  border-bottom: 0 solid transparent !important;
  border-radius: 5px !important;
}
.collapse-margin .card {
  margin-bottom: 0;
  border-radius: 5px !important;
}
.collapse-margin .card .card-header {
  padding: 1rem;
  border-radius: 5px;
}
.collapse-margin .card .card-body {
  padding: 1rem;
  line-height: 1.5rem;
}

.pagination .page-item {
  border-radius: 5rem;
}
.pagination .page-item.prev-item .page-link, .pagination .page-item.next-item .page-link, .pagination .page-item.first .page-link, .pagination .page-item.last .page-link, .pagination .page-item.prev .page-link, .pagination .page-item.next .page-link {
  color: #7367f0;
}
.pagination .page-item.prev-item.disabled .page-link, .pagination .page-item.next-item.disabled .page-link, .pagination .page-item.first.disabled .page-link, .pagination .page-item.last.disabled .page-link, .pagination .page-item.prev.disabled .page-link, .pagination .page-item.next.disabled .page-link {
  color: #b8c2cc;
}
.pagination .page-item.prev-item {
  margin-right: 0.3571rem;
}
.pagination .page-item.prev-item .page-link {
  background-color: #f0f0f0;
  padding: 0.572rem 0.7rem;
  border-radius: 50%;
}
.pagination .page-item.prev-item .page-link svg {
  width: 1.2rem;
  height: 1.2rem;
}
.pagination .page-item.prev-item .page-link:hover {
  background: #7367f0;
  color: #fff;
}
.pagination .page-item.prev-item ~ .page-item:nth-child(2).active .page-link {
  border-radius: 0.5rem !important;
}
.pagination .page-item.prev-item ~ .page-item:nth-child(2) .page-link {
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
}
.pagination .page-item.prev-item ~ .page-item:nth-last-child(-n+2).active .page-link {
  border-radius: 0.5rem !important;
}
.pagination .page-item.prev-item ~ .page-item:nth-last-child(-n+2) .page-link {
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}
.pagination .page-item.next-item {
  margin-left: 0.3571rem;
}
.pagination .page-item.next-item .page-link {
  background-color: #f0f0f0;
  padding: 0.572rem 0.7rem;
  border-radius: 50%;
}
.pagination .page-item.next-item .page-link svg {
  width: 1.2rem;
  height: 1.2rem;
}
.pagination .page-item.next-item .page-link:hover {
  background: #7367f0;
  color: #fff;
}
.pagination .page-item .page-link {
  border: none;
  margin: 0;
  color: rgba(0, 0, 0, 0.6);
  background-color: #f0f0f0;
  margin-left: 0;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.4rem;
}
.pagination .page-item .page-link svg {
  height: 1.2rem;
  width: 1.2rem;
  position: relative;
  top: -1px;
}
.pagination .page-item .page-link:focus {
  box-shadow: none;
}
.pagination .page-item .page-link:hover {
  color: #7367f0;
}
.pagination .page-item.active {
  background-color: #f0f0f0;
  border-radius: 0;
}
.pagination .page-item.active .page-link {
  z-index: 3;
  border-radius: 0.5rem;
  background-color: #7367f0;
  color: #fff;
  transform: scale(1.05);
}
.pagination .page-item:first-child:not(.prev-item).active {
  border-top-left-radius: 1.428rem;
  border-bottom-left-radius: 1.428rem;
}
.pagination .page-item:first-child:not(.prev-item).active .page-link {
  border-radius: 5rem;
}
.pagination .page-item:first-child:not(.prev-item) .page-link {
  border-top-left-radius: 1.428rem;
  border-bottom-left-radius: 1.428rem;
}
.pagination .page-item:last-child:not(.next-item).active {
  border-top-right-radius: 1.428rem;
  border-bottom-right-radius: 1.428rem;
}
.pagination .page-item:last-child:not(.next-item).active .page-link {
  border-radius: 5rem;
}
.pagination .page-item:last-child:not(.next-item) .page-link {
  border-top-right-radius: 1.428rem;
  border-bottom-right-radius: 1.428rem;
}
.pagination.pagination-lg .page-item .page-link {
  font-size: 1.5rem;
  transform: scale(1);
}

.spinner-border-lg,
.spinner-grow-lg {
  height: 3rem;
  width: 3rem;
}

.modal .modal-header {
  background-color: #f8f8f8;
  border-radius: 0.42rem;
  padding: 0.8rem;
  border-bottom: none;
}
.modal .modal-header .close {
  padding: 0.2rem 0.62rem;
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.1);
  border-radius: 0.357rem;
  background: #fff;
  opacity: 1;
  transition: all 0.23s ease 0.1s;
  position: relative;
  transform: translate(8px, -2px);
}
.modal .modal-header .close span {
  font-weight: 400;
  font-size: 2rem;
  color: #7367f0;
}
.modal .modal-header .close:hover, .modal .modal-header .close:focus, .modal .modal-header .close:active {
  opacity: 1;
  outline: none;
  transform: translate(5px, 3px);
  box-shadow: none;
}
.modal .modal-header[class*=bg-] {
  color: #fff;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
.modal .modal-header[class*=bg-] .modal-title {
  color: #fff;
}
.modal .modal-header.bg-primary .close span {
  color: #7367f0;
}
.modal .modal-header.bg-success .close span {
  color: #28c76f;
}
.modal .modal-header.bg-info .close span {
  color: #00cfe8;
}
.modal .modal-header.bg-danger .close span {
  color: #ea5455;
}
.modal .modal-header.bg-warning .close span {
  color: #ff9f43;
}
.modal .modal-header.bg-dark .close span {
  color: #2a2e30;
}
.modal .modal-content {
  border: none;
  overflow: visible;
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.1);
}
.modal.modal-centered .modal-dialog {
  display: flex;
  align-items: center;
}
.modal .modal-footer {
  border-color: rgba(0, 0, 0, 0.05);
}

.modal-sm {
  max-width: 400px;
}

.modal-xs {
  max-width: 300px;
}

.modal-xl {
  max-width: 94%;
  margin-left: 3%;
  margin-right: 3%;
}

@media (max-width: 576px) {
  .modal {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .modal .modal-xs,
  .modal .modal-sm {
    max-width: unset;
  }
}
.demo-modal-form .btn-outline-success:focus {
  box-shadow: 0 0 0 0.2rem rgba(40, 199, 111, 0.5) !important;
}

.popover {
  z-index: 1060;
}
.popover .popover-header {
  color: #fff;
  border: none;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
}
.popover.bs-popover-bottom .arrow:after, .popover.bs-popover-auto[data-popper-placement^=bottom] .arrow:after {
  border-bottom-color: #7367f0;
}

.icon-bg-circle {
  color: #fff;
  padding: 0.5rem;
  border-radius: 50%;
}

.icon-left {
  margin-right: 0.5rem;
}

.icon-right {
  margin-right: 0.5rem;
}

.icon-spin {
  display: inline-block;
  animation: spin 1s infinite linear;
}

.blockOverlay {
  z-index: 1050 !important;
}

.blockElement, .blockPage {
  z-index: 1051 !important;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.hidden {
  display: none;
  visibility: hidden;
}

a:hover {
  cursor: pointer;
}

.round {
  border-radius: 1.5rem;
}

.square {
  border-radius: 0;
}

.icon-line-height {
  line-height: 1.5rem !important;
}

.table-middle td {
  vertical-align: middle;
}

.spinner {
  display: inline-block;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.bg-gradient-white {
  color: #fff;
  background-image: linear-gradient(30deg, #ffffff, rgba(255, 255, 255, 0.5));
}
.bg-gradient-white:hover, .bg-gradient-white:active {
  color: #fff;
}

.gradient-light-white {
  background: linear-gradient(30deg, #ffffff 0%, 100%);
  color: #fff;
}
.gradient-light-white:hover, .gradient-light-white:active {
  color: #fff;
}

.bg-gradient-black {
  color: #fff;
  background-image: linear-gradient(30deg, #000000, rgba(0, 0, 0, 0.5));
}
.bg-gradient-black:hover, .bg-gradient-black:active {
  color: #fff;
}

.gradient-light-black {
  background: linear-gradient(30deg, #000000 0%, 100%);
  color: #fff;
}
.gradient-light-black:hover, .gradient-light-black:active {
  color: #fff;
}

.bg-gradient-dark {
  background: #640064;
  color: #fff;
  background-image: linear-gradient(30deg, #2a2e30, rgba(42, 46, 48, 0.5));
}
.bg-gradient-dark:hover, .bg-gradient-dark:active {
  color: #fff;
}

.gradient-light-dark {
  background: linear-gradient(30deg, #2a2e30 0%, 100%);
  color: #fff;
}
.gradient-light-dark:hover, .gradient-light-dark:active {
  color: #fff;
}

.bg-gradient-light {
  background: #640064;
  color: #fff;
  background-image: linear-gradient(30deg, #babfc7, rgba(186, 191, 199, 0.5));
}
.bg-gradient-light:hover, .bg-gradient-light:active {
  color: #fff;
}

.gradient-light-light {
  background: linear-gradient(30deg, #babfc7 0%, 100%);
  color: #fff;
}
.gradient-light-light:hover, .gradient-light-light:active {
  color: #fff;
}

.bg-gradient-primary {
  background: #640064;
  color: #fff;
  background-image: linear-gradient(30deg, #7367f0, rgba(115, 103, 240, 0.5));
}
.bg-gradient-primary:hover, .bg-gradient-primary:active {
  color: #fff;
}

.gradient-light-primary {
  background: linear-gradient(30deg, #7367f0 0%, rgb(205.887538787, 158.985231015, 251.997768985) 100%);
  color: #fff;
}
.gradient-light-primary:hover, .gradient-light-primary:active {
  color: #fff;
}

.bg-gradient-secondary {
  background: #640064;
  color: #fff;
  background-image: linear-gradient(30deg, #b8c2cc, rgba(184, 194, 204, 0.5));
}
.bg-gradient-secondary:hover, .bg-gradient-secondary:active {
  color: #fff;
}

.gradient-light-secondary {
  background: linear-gradient(30deg, #b8c2cc 0%, rgb(220.3498655492, 221.623471291, 235.6331344508) 100%);
  color: #fff;
}
.gradient-light-secondary:hover, .gradient-light-secondary:active {
  color: #fff;
}

.bg-gradient-success {
  background: #0064fa;
  color: #fff;
  background-image: linear-gradient(30deg, #28c76f, rgba(40, 199, 111, 0.5));
}
.bg-gradient-success:hover, .bg-gradient-success:active {
  color: #fff;
}

.gradient-light-success {
  background: linear-gradient(30deg, #28c76f 0%, rgb(73.8812290858, 233.1017709142, 211.3216024566) 100%);
  color: #fff;
}
.gradient-light-success:hover, .gradient-light-success:active {
  color: #fff;
}

.bg-gradient-info {
  background: #640064;
  color: #fff;
  background-image: linear-gradient(30deg, #00cfe8, rgba(0, 207, 232, 0.5));
}
.bg-gradient-info:hover, .bg-gradient-info:active {
  color: #fff;
}

.gradient-light-info {
  background: linear-gradient(30deg, #00cfe8 0%, rgb(44.983, 144.8617744253, 255) 100%);
  color: #fff;
}
.gradient-light-info:hover, .gradient-light-info:active {
  color: #fff;
}

.bg-gradient-warning {
  background: #fafafa;
  color: #fff;
  background-image: linear-gradient(30deg, #ff9f43, rgba(255, 159, 67, 0.5));
}
.bg-gradient-warning:hover, .bg-gradient-warning:active {
  color: #fff;
}

.gradient-light-warning {
  background: linear-gradient(30deg, #ff9f43 0%, rgb(255, 243.7218067376, 134.983) 100%);
  color: #fff;
}
.gradient-light-warning:hover, .gradient-light-warning:active {
  color: #fff;
}

.bg-gradient-danger {
  background: #640064;
  color: #fff;
  background-image: linear-gradient(30deg, #ea5455, rgba(234, 84, 85, 0.5));
}
.bg-gradient-danger:hover, .bg-gradient-danger:active {
  color: #fff;
}

.gradient-light-danger {
  background: linear-gradient(30deg, #ea5455 0%, rgb(248.814652125, 182.9433326175, 137.168347875) 100%);
  color: #fff;
}
.gradient-light-danger:hover, .gradient-light-danger:active {
  color: #fff;
}

.white {
  color: #ffffff !important;
}

.bg-white {
  background-color: #ffffff !important;
}
.bg-white .card-header,
.bg-white .card-footer {
  background-color: transparent;
}

.alert-white {
  background: rgba(255, 255, 255, 0.2) !important;
  color: #ffffff !important;
}
.alert-white .alert-heading {
  box-shadow: rgba(255, 255, 255, 0.4) 0px 6px 15px -7px;
}
.alert-white .alert-link {
  color: rgb(242.25, 242.25, 242.25) !important;
}

.bg-rgba-white {
  background: rgba(255, 255, 255, 0.15) !important;
}

.border-white {
  border: 1px solid #ffffff !important;
}

.border-top-white {
  border-top: 1px solid #ffffff;
}

.border-bottom-white {
  border-bottom: 1px solid #ffffff;
}

.border-left-white {
  border-left: 1px solid #ffffff;
}

.border-right-white {
  border-right: 1px solid #ffffff;
}

.badge.badge-light-white {
  color: #ffffff !important;
  font-weight: 500;
  text-transform: uppercase;
}

.bg-white.badge-glow,
.border-white.badge-glow,
.badge-white.badge-glow {
  box-shadow: 0px 0px 10px #ffffff;
}

.overlay-white {
  background: #ffffff; /* The Fallback */
  background: rgba(255, 255, 255, 0.6);
}

.btn-white {
  border-color: !important;
  background-color: #ffffff !important;
  color: #fff;
}
.btn-white:hover {
  border-color: !important;
  color: #fff !important;
  box-shadow: 0 8px 25px -8px white;
}
.btn-white:focus, .btn-white:active {
  color: #fff !important;
}

.btn-flat-white {
  background-color: transparent;
  color: #ffffff;
}
.btn-flat-white:hover {
  color: #ffffff;
  background-color: rgba(255, 255, 255, 0.1);
}
.btn-flat-white:active, .btn-flat-white:focus {
  background-color: #ffffff;
  color: #fff !important;
}

.btn-relief-white {
  background-color: #ffffff;
  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.2);
  color: #fff;
}
.btn-relief-white:hover {
  color: #fff;
}
.btn-relief-white:active, .btn-relief-white:focus {
  outline: none;
  transform: translateY(3px);
}

.btn-outline-white {
  border: 1px solid #ffffff;
  background-color: transparent;
  color: #ffffff;
}
.btn-outline-white:hover {
  background-color: rgba(255, 255, 255, 0.08);
  color: #ffffff;
}
.btn-outline-white:active {
  color: #fff !important;
}

.btn-white ~ .dropdown-menu .dropdown-item.active,
.btn-outline-white ~ .dropdown-menu .dropdown-item.active,
.btn-flat-white ~ .dropdown-menu .dropdown-item.active {
  background-color: #ffffff;
  color: #fff;
}
.btn-white ~ .dropdown-menu .dropdown-item.active:hover,
.btn-outline-white ~ .dropdown-menu .dropdown-item.active:hover,
.btn-flat-white ~ .dropdown-menu .dropdown-item.active:hover {
  color: #fff;
}
.btn-white ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,
.btn-outline-white ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,
.btn-flat-white ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover {
  color: #ffffff;
}

.bullet.bullet-white {
  background-color: #ffffff;
}
.bullet.bullet-white.bullet-bordered {
  background-color: transparent;
  border: 2px solid #ffffff;
}

.pagination-white li.active a,
.pagination-white li.active .page-link,
.pagination-white .page-item.active a,
.pagination-white .page-item.active .page-link {
  background: #ffffff !important;
  color: #fff;
}
.pagination-white li.active a:hover,
.pagination-white li.active .page-link:hover,
.pagination-white .page-item.active a:hover,
.pagination-white .page-item.active .page-link:hover {
  color: #fff !important;
}
.pagination-white li a:hover,
.pagination-white li .page-link:hover,
.pagination-white .page-item a:hover,
.pagination-white .page-item .page-link:hover {
  color: #ffffff !important;
}
.pagination-white li.prev-item .page-link:hover, .pagination-white li.next-item .page-link:hover,
.pagination-white .page-item.prev-item .page-link:hover,
.pagination-white .page-item.next-item .page-link:hover {
  background: #ffffff;
  color: #fff;
}

.nav-pill-white .nav-item .nav-link.active {
  color: #fff;
  background-color: #ffffff;
}

.chip-white {
  background-color: #ffffff !important;
}
.chip-white .chip-body {
  color: #fff !important;
}

.divider.divider-white .divider-text:before, .divider.divider-white .divider-text:after {
  border-color: #ffffff !important;
}

input[type=checkbox].bg-white + .custom-control-label:before, input[type=radio].bg-white + .custom-control-label:before {
  background-color: #ffffff !important;
}

input:focus ~ .bg-white {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #ffffff !important;
}

.vx-checkbox-white input:checked ~ .vx-checkbox {
  border-color: #ffffff !important;
}
.vx-checkbox-white input:checked ~ .vx-checkbox .vx-checkbox--check {
  background-color: #ffffff !important;
}
.vx-checkbox-white input:active:checked + .vx-checkbox .vx-checkbox--check {
  background-color: #ffffff !important;
}

.vertical-layout .main-menu.theme-white .navbar-header .navbar-nav .brand-text {
  color: #ffffff;
}
.vertical-layout .main-menu.theme-white .navigation .nav-item.active a {
  background: linear-gradient(118deg, white, rgba(255, 255, 255, 0.7));
  box-shadow: 0 0 10px 1px rgba(255, 255, 255, 0.7) !important;
}
.vertical-layout .main-menu.theme-white .navigation .nav-item .menu-content li.active {
  background: linear-gradient(118deg, white, rgba(255, 255, 255, 0.7));
  box-shadow: 0 0 10px 1px rgba(255, 255, 255, 0.7) !important;
}

.horizontal-layout.theme-white .header-navbar .brand-text {
  color: #ffffff !important;
}
.horizontal-layout.theme-white .navbar-horizontal #main-menu-navigation .nav-item.active .nav-link {
  background: linear-gradient(118deg, white, rgba(255, 255, 255, 0.7));
  box-shadow: 0 0 10px 1px rgba(255, 255, 255, 0.7) !important;
}

.custom-switch-white .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #ffffff !important;
  color: #fff;
  transition: all 0.2s ease-out;
}

.color-radio.color-radio-white {
  border: 1px solid transparent;
}
.color-radio.color-radio-white.selected {
  border-color: #ffffff;
}
.color-radio.color-radio-white .radio-content {
  background-color: #ffffff;
}

.vx-radio-white input:checked ~ .vx-radio .vx-radio--circle {
  background: white !important;
  box-shadow: 0 3px 12px 0 rgba(255, 255, 255, 0.4) !important;
}

.black {
  color: #000000 !important;
}

.bg-black {
  background-color: #000000 !important;
}
.bg-black .card-header,
.bg-black .card-footer {
  background-color: transparent;
}

.alert-black {
  background: rgba(0, 0, 0, 0.2) !important;
  color: #000000 !important;
}
.alert-black .alert-heading {
  box-shadow: rgba(0, 0, 0, 0.4) 0px 6px 15px -7px;
}
.alert-black .alert-link {
  color: black !important;
}

.bg-rgba-black {
  background: rgba(0, 0, 0, 0.15) !important;
}

.border-black {
  border: 1px solid #000000 !important;
}

.border-top-black {
  border-top: 1px solid #000000;
}

.border-bottom-black {
  border-bottom: 1px solid #000000;
}

.border-left-black {
  border-left: 1px solid #000000;
}

.border-right-black {
  border-right: 1px solid #000000;
}

.badge.badge-light-black {
  color: #000000 !important;
  font-weight: 500;
  text-transform: uppercase;
}

.bg-black.badge-glow,
.border-black.badge-glow,
.badge-black.badge-glow {
  box-shadow: 0px 0px 10px #000000;
}

.overlay-black {
  background: #000000; /* The Fallback */
  background: rgba(0, 0, 0, 0.6);
}

.btn-black {
  border-color: !important;
  background-color: #000000 !important;
  color: #fff;
}
.btn-black:hover {
  border-color: !important;
  color: #fff !important;
  box-shadow: 0 8px 25px -8px black;
}
.btn-black:focus, .btn-black:active {
  color: #fff !important;
}

.btn-flat-black {
  background-color: transparent;
  color: #000000;
}
.btn-flat-black:hover {
  color: #000000;
  background-color: rgba(0, 0, 0, 0.1);
}
.btn-flat-black:active, .btn-flat-black:focus {
  background-color: #000000;
  color: #fff !important;
}

.btn-relief-black {
  background-color: #000000;
  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.2);
  color: #fff;
}
.btn-relief-black:hover {
  color: #fff;
}
.btn-relief-black:active, .btn-relief-black:focus {
  outline: none;
  transform: translateY(3px);
}

.btn-outline-black {
  border: 1px solid #000000;
  background-color: transparent;
  color: #000000;
}
.btn-outline-black:hover {
  background-color: rgba(0, 0, 0, 0.08);
  color: #000000;
}
.btn-outline-black:active {
  color: #fff !important;
}

.btn-black ~ .dropdown-menu .dropdown-item.active,
.btn-outline-black ~ .dropdown-menu .dropdown-item.active,
.btn-flat-black ~ .dropdown-menu .dropdown-item.active {
  background-color: #000000;
  color: #fff;
}
.btn-black ~ .dropdown-menu .dropdown-item.active:hover,
.btn-outline-black ~ .dropdown-menu .dropdown-item.active:hover,
.btn-flat-black ~ .dropdown-menu .dropdown-item.active:hover {
  color: #fff;
}
.btn-black ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,
.btn-outline-black ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,
.btn-flat-black ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover {
  color: #000000;
}

.bullet.bullet-black {
  background-color: #000000;
}
.bullet.bullet-black.bullet-bordered {
  background-color: transparent;
  border: 2px solid #000000;
}

.pagination-black li.active a,
.pagination-black li.active .page-link,
.pagination-black .page-item.active a,
.pagination-black .page-item.active .page-link {
  background: #000000 !important;
  color: #fff;
}
.pagination-black li.active a:hover,
.pagination-black li.active .page-link:hover,
.pagination-black .page-item.active a:hover,
.pagination-black .page-item.active .page-link:hover {
  color: #fff !important;
}
.pagination-black li a:hover,
.pagination-black li .page-link:hover,
.pagination-black .page-item a:hover,
.pagination-black .page-item .page-link:hover {
  color: #000000 !important;
}
.pagination-black li.prev-item .page-link:hover, .pagination-black li.next-item .page-link:hover,
.pagination-black .page-item.prev-item .page-link:hover,
.pagination-black .page-item.next-item .page-link:hover {
  background: #000000;
  color: #fff;
}

.nav-pill-black .nav-item .nav-link.active {
  color: #fff;
  background-color: #000000;
}

.chip-black {
  background-color: #000000 !important;
}
.chip-black .chip-body {
  color: #fff !important;
}

.divider.divider-black .divider-text:before, .divider.divider-black .divider-text:after {
  border-color: #000000 !important;
}

input[type=checkbox].bg-black + .custom-control-label:before, input[type=radio].bg-black + .custom-control-label:before {
  background-color: #000000 !important;
}

input:focus ~ .bg-black {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #000000 !important;
}

.vx-checkbox-black input:checked ~ .vx-checkbox {
  border-color: #000000 !important;
}
.vx-checkbox-black input:checked ~ .vx-checkbox .vx-checkbox--check {
  background-color: #000000 !important;
}
.vx-checkbox-black input:active:checked + .vx-checkbox .vx-checkbox--check {
  background-color: #000000 !important;
}

.vertical-layout .main-menu.theme-black .navbar-header .navbar-nav .brand-text {
  color: #000000;
}
.vertical-layout .main-menu.theme-black .navigation .nav-item.active a {
  background: linear-gradient(118deg, black, rgba(0, 0, 0, 0.7));
  box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.7) !important;
}
.vertical-layout .main-menu.theme-black .navigation .nav-item .menu-content li.active {
  background: linear-gradient(118deg, black, rgba(0, 0, 0, 0.7));
  box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.7) !important;
}

.horizontal-layout.theme-black .header-navbar .brand-text {
  color: #000000 !important;
}
.horizontal-layout.theme-black .navbar-horizontal #main-menu-navigation .nav-item.active .nav-link {
  background: linear-gradient(118deg, black, rgba(0, 0, 0, 0.7));
  box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.7) !important;
}

.custom-switch-black .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #000000 !important;
  color: #fff;
  transition: all 0.2s ease-out;
}

.color-radio.color-radio-black {
  border: 1px solid transparent;
}
.color-radio.color-radio-black.selected {
  border-color: #000000;
}
.color-radio.color-radio-black .radio-content {
  background-color: #000000;
}

.vx-radio-black input:checked ~ .vx-radio .vx-radio--circle {
  background: black !important;
  box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.4) !important;
}

.dark {
  color: #2a2e30 !important;
}

.bg-dark {
  background-color: #2a2e30 !important;
}
.bg-dark .card-header,
.bg-dark .card-footer {
  background-color: transparent;
}

.alert-dark {
  background: rgba(42, 46, 48, 0.2) !important;
  color: #2a2e30 !important;
}
.alert-dark .alert-heading {
  box-shadow: rgba(42, 46, 48, 0.4) 0px 6px 15px -7px;
}
.alert-dark .alert-link {
  color: rgb(30.1, 32.9666666667, 34.4) !important;
}

.bg-rgba-dark {
  background: rgba(42, 46, 48, 0.15) !important;
}

.border-dark {
  border: 1px solid #2a2e30 !important;
}

.border-top-dark {
  border-top: 1px solid #2a2e30;
}

.border-bottom-dark {
  border-bottom: 1px solid #2a2e30;
}

.border-left-dark {
  border-left: 1px solid #2a2e30;
}

.border-right-dark {
  border-right: 1px solid #2a2e30;
}

.badge.badge-light-dark {
  color: #2a2e30 !important;
  font-weight: 500;
  text-transform: uppercase;
}

.bg-dark.badge-glow,
.border-dark.badge-glow,
.badge-dark.badge-glow {
  box-shadow: 0px 0px 10px #2a2e30;
}

.overlay-dark {
  background: #2a2e30; /* The Fallback */
  background: rgba(42, 46, 48, 0.6);
}

.btn-dark {
  border-color: !important;
  background-color: #2a2e30 !important;
  color: #fff;
}
.btn-dark:hover {
  border-color: !important;
  color: #fff !important;
  box-shadow: 0 8px 25px -8px #2a2e30;
}
.btn-dark:focus, .btn-dark:active {
  color: #fff !important;
}

.btn-flat-dark {
  background-color: transparent;
  color: #2a2e30;
}
.btn-flat-dark:hover {
  color: #2a2e30;
  background-color: rgba(42, 46, 48, 0.1);
}
.btn-flat-dark:active, .btn-flat-dark:focus {
  background-color: #2a2e30;
  color: #fff !important;
}

.btn-relief-dark {
  background-color: #2a2e30;
  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.2);
  color: #fff;
}
.btn-relief-dark:hover {
  color: #fff;
}
.btn-relief-dark:active, .btn-relief-dark:focus {
  outline: none;
  transform: translateY(3px);
}

.btn-outline-dark {
  border: 1px solid #2a2e30;
  background-color: transparent;
  color: #2a2e30;
}
.btn-outline-dark:hover {
  background-color: rgba(42, 46, 48, 0.08);
  color: #2a2e30;
}
.btn-outline-dark:active {
  color: #fff !important;
}

.btn-dark ~ .dropdown-menu .dropdown-item.active,
.btn-outline-dark ~ .dropdown-menu .dropdown-item.active,
.btn-flat-dark ~ .dropdown-menu .dropdown-item.active {
  background-color: #2a2e30;
  color: #fff;
}
.btn-dark ~ .dropdown-menu .dropdown-item.active:hover,
.btn-outline-dark ~ .dropdown-menu .dropdown-item.active:hover,
.btn-flat-dark ~ .dropdown-menu .dropdown-item.active:hover {
  color: #fff;
}
.btn-dark ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,
.btn-outline-dark ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,
.btn-flat-dark ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover {
  color: #2a2e30;
}

.bullet.bullet-dark {
  background-color: #2a2e30;
}
.bullet.bullet-dark.bullet-bordered {
  background-color: transparent;
  border: 2px solid #2a2e30;
}

.pagination-dark li.active a,
.pagination-dark li.active .page-link,
.pagination-dark .page-item.active a,
.pagination-dark .page-item.active .page-link {
  background: #2a2e30 !important;
  color: #fff;
}
.pagination-dark li.active a:hover,
.pagination-dark li.active .page-link:hover,
.pagination-dark .page-item.active a:hover,
.pagination-dark .page-item.active .page-link:hover {
  color: #fff !important;
}
.pagination-dark li a:hover,
.pagination-dark li .page-link:hover,
.pagination-dark .page-item a:hover,
.pagination-dark .page-item .page-link:hover {
  color: #2a2e30 !important;
}
.pagination-dark li.prev-item .page-link:hover, .pagination-dark li.next-item .page-link:hover,
.pagination-dark .page-item.prev-item .page-link:hover,
.pagination-dark .page-item.next-item .page-link:hover {
  background: #2a2e30;
  color: #fff;
}

.nav-pill-dark .nav-item .nav-link.active {
  color: #fff;
  background-color: #2a2e30;
}

.chip-dark {
  background-color: #2a2e30 !important;
}
.chip-dark .chip-body {
  color: #fff !important;
}

.divider.divider-dark .divider-text:before, .divider.divider-dark .divider-text:after {
  border-color: #2a2e30 !important;
}

input[type=checkbox].bg-dark + .custom-control-label:before, input[type=radio].bg-dark + .custom-control-label:before {
  background-color: #2a2e30 !important;
}

input:focus ~ .bg-dark {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #2a2e30 !important;
}

.vx-checkbox-dark input:checked ~ .vx-checkbox {
  border-color: #2a2e30 !important;
}
.vx-checkbox-dark input:checked ~ .vx-checkbox .vx-checkbox--check {
  background-color: #2a2e30 !important;
}
.vx-checkbox-dark input:active:checked + .vx-checkbox .vx-checkbox--check {
  background-color: #2a2e30 !important;
}

.vertical-layout .main-menu.theme-dark .navbar-header .navbar-nav .brand-text {
  color: #2a2e30;
}
.vertical-layout .main-menu.theme-dark .navigation .nav-item.active a {
  background: linear-gradient(118deg, #2a2e30, rgba(42, 46, 48, 0.7));
  box-shadow: 0 0 10px 1px rgba(42, 46, 48, 0.7) !important;
}
.vertical-layout .main-menu.theme-dark .navigation .nav-item .menu-content li.active {
  background: linear-gradient(118deg, #2a2e30, rgba(42, 46, 48, 0.7));
  box-shadow: 0 0 10px 1px rgba(42, 46, 48, 0.7) !important;
}

.horizontal-layout.theme-dark .header-navbar .brand-text {
  color: #2a2e30 !important;
}
.horizontal-layout.theme-dark .navbar-horizontal #main-menu-navigation .nav-item.active .nav-link {
  background: linear-gradient(118deg, #2a2e30, rgba(42, 46, 48, 0.7));
  box-shadow: 0 0 10px 1px rgba(42, 46, 48, 0.7) !important;
}

.custom-switch-dark .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #2a2e30 !important;
  color: #fff;
  transition: all 0.2s ease-out;
}

.color-radio.color-radio-dark {
  border: 1px solid transparent;
}
.color-radio.color-radio-dark.selected {
  border-color: #2a2e30;
}
.color-radio.color-radio-dark .radio-content {
  background-color: #2a2e30;
}

.vx-radio-dark input:checked ~ .vx-radio .vx-radio--circle {
  background: #2a2e30 !important;
  box-shadow: 0 3px 12px 0 rgba(42, 46, 48, 0.4) !important;
}

.dark.gradient-bg {
  color: #640064 !important;
}

.bg-dark.bg-gradient-bg {
  background-color: #640064 !important;
}

.btn-dark.btn-gradient-bg {
  border-color: !important;
  background-color: #640064 !important;
}
.btn-dark.btn-gradient-bg:hover {
  border-color: !important;
  background-color: !important;
}
.btn-dark.btn-gradient-bg:focus, .btn-dark.btn-gradient-bg:active {
  border-color: !important;
  background-color: !important;
}

.btn-outline-dark.btn-outline-gradient-bg {
  border-color: #640064 !important;
  color: #640064 !important;
}
.btn-outline-dark.btn-outline-gradient-bg:hover {
  background-color: #640064 !important;
}

input:focus ~ .bg-dark {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #640064 !important;
}

.border-dark.border-gradient-bg {
  border: 1px solid #640064 !important;
}

.border-top-dark.border-top-gradient-bg {
  border-top: 1px solid #640064 !important;
}

.border-bottom-dark.border-bottom-gradient-bg {
  border-bottom: 1px solid #640064 !important;
}

.border-left-dark.border-left-gradient-bg {
  border-left: 1px solid #640064 !important;
}

.border-right-dark.border-right-gradient-bg {
  border-right: 1px solid #640064 !important;
}

.overlay-dark.overlay-gradient-bg {
  background: #640064; /* The Fallback */
  background: rgba(100, 0, 100, 0.6);
}

.light {
  color: #babfc7 !important;
}

.bg-light {
  background-color: #babfc7 !important;
}
.bg-light .card-header,
.bg-light .card-footer {
  background-color: transparent;
}

.alert-light {
  background: rgba(186, 191, 199, 0.2) !important;
  color: #babfc7 !important;
}
.alert-light .alert-heading {
  box-shadow: rgba(186, 191, 199, 0.4) 0px 6px 15px -7px;
}
.alert-light .alert-link {
  color: rgb(171.924, 177.944, 187.576) !important;
}

.bg-rgba-light {
  background: rgba(186, 191, 199, 0.15) !important;
}

.border-light {
  border: 1px solid #babfc7 !important;
}

.border-top-light {
  border-top: 1px solid #babfc7;
}

.border-bottom-light {
  border-bottom: 1px solid #babfc7;
}

.border-left-light {
  border-left: 1px solid #babfc7;
}

.border-right-light {
  border-right: 1px solid #babfc7;
}

.badge.badge-light-light {
  color: #babfc7 !important;
  font-weight: 500;
  text-transform: uppercase;
}

.bg-light.badge-glow,
.border-light.badge-glow,
.badge-light.badge-glow {
  box-shadow: 0px 0px 10px #babfc7;
}

.overlay-light {
  background: #babfc7; /* The Fallback */
  background: rgba(186, 191, 199, 0.6);
}

.btn-light {
  border-color: !important;
  background-color: #babfc7 !important;
  color: #fff;
}
.btn-light:hover {
  border-color: !important;
  color: #fff !important;
  box-shadow: 0 8px 25px -8px #babfc7;
}
.btn-light:focus, .btn-light:active {
  color: #fff !important;
}

.btn-flat-light {
  background-color: transparent;
  color: #babfc7;
}
.btn-flat-light:hover {
  color: #babfc7;
  background-color: rgba(186, 191, 199, 0.1);
}
.btn-flat-light:active, .btn-flat-light:focus {
  background-color: #babfc7;
  color: #fff !important;
}

.btn-relief-light {
  background-color: #babfc7;
  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.2);
  color: #fff;
}
.btn-relief-light:hover {
  color: #fff;
}
.btn-relief-light:active, .btn-relief-light:focus {
  outline: none;
  transform: translateY(3px);
}

.btn-outline-light {
  border: 1px solid #babfc7;
  background-color: transparent;
  color: #babfc7;
}
.btn-outline-light:hover {
  background-color: rgba(186, 191, 199, 0.08);
  color: #babfc7;
}
.btn-outline-light:active {
  color: #fff !important;
}

.btn-light ~ .dropdown-menu .dropdown-item.active,
.btn-outline-light ~ .dropdown-menu .dropdown-item.active,
.btn-flat-light ~ .dropdown-menu .dropdown-item.active {
  background-color: #babfc7;
  color: #fff;
}
.btn-light ~ .dropdown-menu .dropdown-item.active:hover,
.btn-outline-light ~ .dropdown-menu .dropdown-item.active:hover,
.btn-flat-light ~ .dropdown-menu .dropdown-item.active:hover {
  color: #fff;
}
.btn-light ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,
.btn-outline-light ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,
.btn-flat-light ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover {
  color: #babfc7;
}

.bullet.bullet-light {
  background-color: #babfc7;
}
.bullet.bullet-light.bullet-bordered {
  background-color: transparent;
  border: 2px solid #babfc7;
}

.pagination-light li.active a,
.pagination-light li.active .page-link,
.pagination-light .page-item.active a,
.pagination-light .page-item.active .page-link {
  background: #babfc7 !important;
  color: #fff;
}
.pagination-light li.active a:hover,
.pagination-light li.active .page-link:hover,
.pagination-light .page-item.active a:hover,
.pagination-light .page-item.active .page-link:hover {
  color: #fff !important;
}
.pagination-light li a:hover,
.pagination-light li .page-link:hover,
.pagination-light .page-item a:hover,
.pagination-light .page-item .page-link:hover {
  color: #babfc7 !important;
}
.pagination-light li.prev-item .page-link:hover, .pagination-light li.next-item .page-link:hover,
.pagination-light .page-item.prev-item .page-link:hover,
.pagination-light .page-item.next-item .page-link:hover {
  background: #babfc7;
  color: #fff;
}

.nav-pill-light .nav-item .nav-link.active {
  color: #fff;
  background-color: #babfc7;
}

.chip-light {
  background-color: #babfc7 !important;
}
.chip-light .chip-body {
  color: #fff !important;
}

.divider.divider-light .divider-text:before, .divider.divider-light .divider-text:after {
  border-color: #babfc7 !important;
}

input[type=checkbox].bg-light + .custom-control-label:before, input[type=radio].bg-light + .custom-control-label:before {
  background-color: #babfc7 !important;
}

input:focus ~ .bg-light {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #babfc7 !important;
}

.vx-checkbox-light input:checked ~ .vx-checkbox {
  border-color: #babfc7 !important;
}
.vx-checkbox-light input:checked ~ .vx-checkbox .vx-checkbox--check {
  background-color: #babfc7 !important;
}
.vx-checkbox-light input:active:checked + .vx-checkbox .vx-checkbox--check {
  background-color: #babfc7 !important;
}

.vertical-layout .main-menu.theme-light .navbar-header .navbar-nav .brand-text {
  color: #babfc7;
}
.vertical-layout .main-menu.theme-light .navigation .nav-item.active a {
  background: linear-gradient(118deg, #babfc7, rgba(186, 191, 199, 0.7));
  box-shadow: 0 0 10px 1px rgba(186, 191, 199, 0.7) !important;
}
.vertical-layout .main-menu.theme-light .navigation .nav-item .menu-content li.active {
  background: linear-gradient(118deg, #babfc7, rgba(186, 191, 199, 0.7));
  box-shadow: 0 0 10px 1px rgba(186, 191, 199, 0.7) !important;
}

.horizontal-layout.theme-light .header-navbar .brand-text {
  color: #babfc7 !important;
}
.horizontal-layout.theme-light .navbar-horizontal #main-menu-navigation .nav-item.active .nav-link {
  background: linear-gradient(118deg, #babfc7, rgba(186, 191, 199, 0.7));
  box-shadow: 0 0 10px 1px rgba(186, 191, 199, 0.7) !important;
}

.custom-switch-light .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #babfc7 !important;
  color: #fff;
  transition: all 0.2s ease-out;
}

.color-radio.color-radio-light {
  border: 1px solid transparent;
}
.color-radio.color-radio-light.selected {
  border-color: #babfc7;
}
.color-radio.color-radio-light .radio-content {
  background-color: #babfc7;
}

.vx-radio-light input:checked ~ .vx-radio .vx-radio--circle {
  background: #babfc7 !important;
  box-shadow: 0 3px 12px 0 rgba(186, 191, 199, 0.4) !important;
}

.light.gradient-bg {
  color: #640064 !important;
}

.bg-light.bg-gradient-bg {
  background-color: #640064 !important;
}

.btn-light.btn-gradient-bg {
  border-color: !important;
  background-color: #640064 !important;
}
.btn-light.btn-gradient-bg:hover {
  border-color: !important;
  background-color: !important;
}
.btn-light.btn-gradient-bg:focus, .btn-light.btn-gradient-bg:active {
  border-color: !important;
  background-color: !important;
}

.btn-outline-light.btn-outline-gradient-bg {
  border-color: #640064 !important;
  color: #640064 !important;
}
.btn-outline-light.btn-outline-gradient-bg:hover {
  background-color: #640064 !important;
}

input:focus ~ .bg-light {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #640064 !important;
}

.border-light.border-gradient-bg {
  border: 1px solid #640064 !important;
}

.border-top-light.border-top-gradient-bg {
  border-top: 1px solid #640064 !important;
}

.border-bottom-light.border-bottom-gradient-bg {
  border-bottom: 1px solid #640064 !important;
}

.border-left-light.border-left-gradient-bg {
  border-left: 1px solid #640064 !important;
}

.border-right-light.border-right-gradient-bg {
  border-right: 1px solid #640064 !important;
}

.overlay-light.overlay-gradient-bg {
  background: #640064; /* The Fallback */
  background: rgba(100, 0, 100, 0.6);
}

.primary.gradient-light {
  color: rgb(205.887538787, 158.985231015, 251.997768985) !important;
}

.bg-primary.bg-gradient-light {
  background-color: rgb(205.887538787, 158.985231015, 251.997768985) !important;
}

.btn-primary.btn-gradient-light {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: rgb(205.887538787, 158.985231015, 251.997768985) !important;
}
.btn-primary.btn-gradient-light:hover {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
}
.btn-primary.btn-gradient-light:focus, .btn-primary.btn-gradient-light:active {
  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;
}

.btn-outline-primary.btn-outline-gradient-light {
  border-color: rgb(205.887538787, 158.985231015, 251.997768985) !important;
  color: rgb(205.887538787, 158.985231015, 251.997768985) !important;
}
.btn-outline-primary.btn-outline-gradient-light:hover {
  background-color: rgb(205.887538787, 158.985231015, 251.997768985) !important;
}

input:focus ~ .bg-primary {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(205.887538787, 158.985231015, 251.997768985) !important;
}

.border-primary.border-gradient-light {
  border: 1px solid rgb(205.887538787, 158.985231015, 251.997768985) !important;
}

.border-top-primary.border-top-gradient-light {
  border-top: 1px solid rgb(205.887538787, 158.985231015, 251.997768985) !important;
}

.border-bottom-primary.border-bottom-gradient-light {
  border-bottom: 1px solid rgb(205.887538787, 158.985231015, 251.997768985) !important;
}

.border-left-primary.border-left-gradient-light {
  border-left: 1px solid rgb(205.887538787, 158.985231015, 251.997768985) !important;
}

.border-right-primary.border-right-gradient-light {
  border-right: 1px solid rgb(205.887538787, 158.985231015, 251.997768985) !important;
}

.overlay-primary.overlay-gradient-light {
  background: rgb(205.887538787, 158.985231015, 251.997768985); /* The Fallback */
  background: rgba(205.887538787, 158.985231015, 251.997768985, 0.6);
}

.primary.light-badge {
  color: rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;
}

.bg-primary.bg-light-badge {
  background-color: rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;
}

.btn-primary.btn-light-badge {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;
}
.btn-primary.btn-light-badge:hover {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
}
.btn-primary.btn-light-badge:focus, .btn-primary.btn-light-badge:active {
  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;
}

.btn-outline-primary.btn-outline-light-badge {
  border-color: rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;
  color: rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;
}
.btn-outline-primary.btn-outline-light-badge:hover {
  background-color: rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;
}

input:focus ~ .bg-primary {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;
}

.border-primary.border-light-badge {
  border: 1px solid rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;
}

.border-top-primary.border-top-light-badge {
  border-top: 1px solid rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;
}

.border-bottom-primary.border-bottom-light-badge {
  border-bottom: 1px solid rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;
}

.border-left-primary.border-left-light-badge {
  border-left: 1px solid rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;
}

.border-right-primary.border-right-light-badge {
  border-right: 1px solid rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;
}

.overlay-primary.overlay-light-badge {
  background: rgb(221.8862275449, 219.0479041916, 251.4520958084); /* The Fallback */
  background: rgba(221.8862275449, 219.0479041916, 251.4520958084, 0.6);
}

.primary.lighten-5 {
  color: rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;
}

.bg-primary.bg-lighten-5 {
  background-color: rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;
}

.btn-primary.btn-lighten-5 {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;
}
.btn-primary.btn-lighten-5:hover {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
}
.btn-primary.btn-lighten-5:focus, .btn-primary.btn-lighten-5:active {
  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;
}

.btn-outline-primary.btn-outline-lighten-5 {
  border-color: rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;
  color: rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;
}
.btn-outline-primary.btn-outline-lighten-5:hover {
  background-color: rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;
}

input:focus ~ .bg-primary {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;
}

.border-primary.border-lighten-5 {
  border: 1px solid rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;
}

.border-top-primary.border-top-lighten-5 {
  border-top: 1px solid rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;
}

.border-bottom-primary.border-bottom-lighten-5 {
  border-bottom: 1px solid rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;
}

.border-left-primary.border-left-lighten-5 {
  border-left: 1px solid rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;
}

.border-right-primary.border-right-lighten-5 {
  border-right: 1px solid rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;
}

.overlay-primary.overlay-lighten-5 {
  background: rgb(221.8862275449, 219.0479041916, 251.4520958084); /* The Fallback */
  background: rgba(221.8862275449, 219.0479041916, 251.4520958084, 0.6);
}

.primary.lighten-4 {
  color: rgb(200.5089820359, 195.8383233533, 249.1616766467) !important;
}

.bg-primary.bg-lighten-4 {
  background-color: rgb(200.5089820359, 195.8383233533, 249.1616766467) !important;
}

.btn-primary.btn-lighten-4 {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: rgb(200.5089820359, 195.8383233533, 249.1616766467) !important;
}
.btn-primary.btn-lighten-4:hover {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
}
.btn-primary.btn-lighten-4:focus, .btn-primary.btn-lighten-4:active {
  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;
}

.btn-outline-primary.btn-outline-lighten-4 {
  border-color: rgb(200.5089820359, 195.8383233533, 249.1616766467) !important;
  color: rgb(200.5089820359, 195.8383233533, 249.1616766467) !important;
}
.btn-outline-primary.btn-outline-lighten-4:hover {
  background-color: rgb(200.5089820359, 195.8383233533, 249.1616766467) !important;
}

input:focus ~ .bg-primary {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(200.5089820359, 195.8383233533, 249.1616766467) !important;
}

.border-primary.border-lighten-4 {
  border: 1px solid rgb(200.5089820359, 195.8383233533, 249.1616766467) !important;
}

.border-top-primary.border-top-lighten-4 {
  border-top: 1px solid rgb(200.5089820359, 195.8383233533, 249.1616766467) !important;
}

.border-bottom-primary.border-bottom-lighten-4 {
  border-bottom: 1px solid rgb(200.5089820359, 195.8383233533, 249.1616766467) !important;
}

.border-left-primary.border-left-lighten-4 {
  border-left: 1px solid rgb(200.5089820359, 195.8383233533, 249.1616766467) !important;
}

.border-right-primary.border-right-lighten-4 {
  border-right: 1px solid rgb(200.5089820359, 195.8383233533, 249.1616766467) !important;
}

.overlay-primary.overlay-lighten-4 {
  background: rgb(200.5089820359, 195.8383233533, 249.1616766467); /* The Fallback */
  background: rgba(200.5089820359, 195.8383233533, 249.1616766467, 0.6);
}

.primary.lighten-3 {
  color: rgb(179.1317365269, 172.628742515, 246.871257485) !important;
}

.bg-primary.bg-lighten-3 {
  background-color: rgb(179.1317365269, 172.628742515, 246.871257485) !important;
}

.btn-primary.btn-lighten-3 {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: rgb(179.1317365269, 172.628742515, 246.871257485) !important;
}
.btn-primary.btn-lighten-3:hover {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
}
.btn-primary.btn-lighten-3:focus, .btn-primary.btn-lighten-3:active {
  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;
}

.btn-outline-primary.btn-outline-lighten-3 {
  border-color: rgb(179.1317365269, 172.628742515, 246.871257485) !important;
  color: rgb(179.1317365269, 172.628742515, 246.871257485) !important;
}
.btn-outline-primary.btn-outline-lighten-3:hover {
  background-color: rgb(179.1317365269, 172.628742515, 246.871257485) !important;
}

input:focus ~ .bg-primary {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(179.1317365269, 172.628742515, 246.871257485) !important;
}

.border-primary.border-lighten-3 {
  border: 1px solid rgb(179.1317365269, 172.628742515, 246.871257485) !important;
}

.border-top-primary.border-top-lighten-3 {
  border-top: 1px solid rgb(179.1317365269, 172.628742515, 246.871257485) !important;
}

.border-bottom-primary.border-bottom-lighten-3 {
  border-bottom: 1px solid rgb(179.1317365269, 172.628742515, 246.871257485) !important;
}

.border-left-primary.border-left-lighten-3 {
  border-left: 1px solid rgb(179.1317365269, 172.628742515, 246.871257485) !important;
}

.border-right-primary.border-right-lighten-3 {
  border-right: 1px solid rgb(179.1317365269, 172.628742515, 246.871257485) !important;
}

.overlay-primary.overlay-lighten-3 {
  background: rgb(179.1317365269, 172.628742515, 246.871257485); /* The Fallback */
  background: rgba(179.1317365269, 172.628742515, 246.871257485, 0.6);
}

.primary.lighten-2 {
  color: rgb(157.754491018, 149.4191616766, 244.5808383234) !important;
}

.bg-primary.bg-lighten-2 {
  background-color: rgb(157.754491018, 149.4191616766, 244.5808383234) !important;
}

.btn-primary.btn-lighten-2 {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: rgb(157.754491018, 149.4191616766, 244.5808383234) !important;
}
.btn-primary.btn-lighten-2:hover {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
}
.btn-primary.btn-lighten-2:focus, .btn-primary.btn-lighten-2:active {
  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;
}

.btn-outline-primary.btn-outline-lighten-2 {
  border-color: rgb(157.754491018, 149.4191616766, 244.5808383234) !important;
  color: rgb(157.754491018, 149.4191616766, 244.5808383234) !important;
}
.btn-outline-primary.btn-outline-lighten-2:hover {
  background-color: rgb(157.754491018, 149.4191616766, 244.5808383234) !important;
}

input:focus ~ .bg-primary {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(157.754491018, 149.4191616766, 244.5808383234) !important;
}

.border-primary.border-lighten-2 {
  border: 1px solid rgb(157.754491018, 149.4191616766, 244.5808383234) !important;
}

.border-top-primary.border-top-lighten-2 {
  border-top: 1px solid rgb(157.754491018, 149.4191616766, 244.5808383234) !important;
}

.border-bottom-primary.border-bottom-lighten-2 {
  border-bottom: 1px solid rgb(157.754491018, 149.4191616766, 244.5808383234) !important;
}

.border-left-primary.border-left-lighten-2 {
  border-left: 1px solid rgb(157.754491018, 149.4191616766, 244.5808383234) !important;
}

.border-right-primary.border-right-lighten-2 {
  border-right: 1px solid rgb(157.754491018, 149.4191616766, 244.5808383234) !important;
}

.overlay-primary.overlay-lighten-2 {
  background: rgb(157.754491018, 149.4191616766, 244.5808383234); /* The Fallback */
  background: rgba(157.754491018, 149.4191616766, 244.5808383234, 0.6);
}

.primary.lighten-1 {
  color: rgb(136.377245509, 126.2095808383, 242.2904191617) !important;
}

.bg-primary.bg-lighten-1 {
  background-color: rgb(136.377245509, 126.2095808383, 242.2904191617) !important;
}

.btn-primary.btn-lighten-1 {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: rgb(136.377245509, 126.2095808383, 242.2904191617) !important;
}
.btn-primary.btn-lighten-1:hover {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
}
.btn-primary.btn-lighten-1:focus, .btn-primary.btn-lighten-1:active {
  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;
}

.btn-outline-primary.btn-outline-lighten-1 {
  border-color: rgb(136.377245509, 126.2095808383, 242.2904191617) !important;
  color: rgb(136.377245509, 126.2095808383, 242.2904191617) !important;
}
.btn-outline-primary.btn-outline-lighten-1:hover {
  background-color: rgb(136.377245509, 126.2095808383, 242.2904191617) !important;
}

input:focus ~ .bg-primary {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(136.377245509, 126.2095808383, 242.2904191617) !important;
}

.border-primary.border-lighten-1 {
  border: 1px solid rgb(136.377245509, 126.2095808383, 242.2904191617) !important;
}

.border-top-primary.border-top-lighten-1 {
  border-top: 1px solid rgb(136.377245509, 126.2095808383, 242.2904191617) !important;
}

.border-bottom-primary.border-bottom-lighten-1 {
  border-bottom: 1px solid rgb(136.377245509, 126.2095808383, 242.2904191617) !important;
}

.border-left-primary.border-left-lighten-1 {
  border-left: 1px solid rgb(136.377245509, 126.2095808383, 242.2904191617) !important;
}

.border-right-primary.border-right-lighten-1 {
  border-right: 1px solid rgb(136.377245509, 126.2095808383, 242.2904191617) !important;
}

.overlay-primary.overlay-lighten-1 {
  background: rgb(136.377245509, 126.2095808383, 242.2904191617); /* The Fallback */
  background: rgba(136.377245509, 126.2095808383, 242.2904191617, 0.6);
}

.primary {
  color: #7367f0 !important;
}

.bg-primary {
  background-color: #7367f0 !important;
}
.bg-primary .card-header,
.bg-primary .card-footer {
  background-color: transparent;
}

.alert-primary {
  background: rgba(115, 103, 240, 0.2) !important;
  color: #7367f0 !important;
}
.alert-primary .alert-heading {
  box-shadow: rgba(115, 103, 240, 0.4) 0px 6px 15px -7px;
}
.alert-primary .alert-link {
  color: rgb(93.622754491, 79.7904191617, 237.7095808383) !important;
}

.bg-rgba-primary {
  background: rgba(115, 103, 240, 0.15) !important;
}

.border-primary {
  border: 1px solid #7367f0 !important;
}

.border-top-primary {
  border-top: 1px solid #7367f0;
}

.border-bottom-primary {
  border-bottom: 1px solid #7367f0;
}

.border-left-primary {
  border-left: 1px solid #7367f0;
}

.border-right-primary {
  border-right: 1px solid #7367f0;
}

.badge.badge-light-primary {
  background-color: rgb(221.8862275449, 219.0479041916, 251.4520958084);
  color: #7367f0 !important;
  font-weight: 500;
  text-transform: uppercase;
}

.bg-primary.badge-glow,
.border-primary.badge-glow,
.badge-primary.badge-glow {
  box-shadow: 0px 0px 10px #7367f0;
}

.overlay-primary {
  background: #7367f0; /* The Fallback */
  background: rgba(115, 103, 240, 0.6);
}

.btn-primary {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: #7367f0 !important;
  color: #fff;
}
.btn-primary:hover {
  border-color: rgb(93.622754491, 79.7904191617, 237.7095808383) !important;
  color: #fff !important;
  box-shadow: 0 8px 25px -8px #7367f0;
}
.btn-primary:focus, .btn-primary:active {
  color: #fff !important;
}

.btn-flat-primary {
  background-color: transparent;
  color: #7367f0;
}
.btn-flat-primary:hover {
  color: #7367f0;
  background-color: rgba(115, 103, 240, 0.1);
}
.btn-flat-primary:active, .btn-flat-primary:focus {
  background-color: #7367f0;
  color: #fff !important;
}

.btn-relief-primary {
  background-color: #7367f0;
  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.2);
  color: #fff;
}
.btn-relief-primary:hover {
  color: #fff;
}
.btn-relief-primary:active, .btn-relief-primary:focus {
  outline: none;
  transform: translateY(3px);
}

.btn-outline-primary {
  border: 1px solid #7367f0;
  background-color: transparent;
  color: #7367f0;
}
.btn-outline-primary:hover {
  background-color: rgba(115, 103, 240, 0.08);
  color: #7367f0;
}
.btn-outline-primary:active {
  color: #fff !important;
}

.btn-primary ~ .dropdown-menu .dropdown-item.active,
.btn-outline-primary ~ .dropdown-menu .dropdown-item.active,
.btn-flat-primary ~ .dropdown-menu .dropdown-item.active {
  background-color: #7367f0;
  color: #fff;
}
.btn-primary ~ .dropdown-menu .dropdown-item.active:hover,
.btn-outline-primary ~ .dropdown-menu .dropdown-item.active:hover,
.btn-flat-primary ~ .dropdown-menu .dropdown-item.active:hover {
  color: #fff;
}
.btn-primary ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,
.btn-outline-primary ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,
.btn-flat-primary ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover {
  color: #7367f0;
}

.bullet.bullet-primary {
  background-color: #7367f0;
}
.bullet.bullet-primary.bullet-bordered {
  background-color: transparent;
  border: 2px solid #7367f0;
}

.pagination-primary li.active a,
.pagination-primary li.active .page-link,
.pagination-primary .page-item.active a,
.pagination-primary .page-item.active .page-link {
  background: #7367f0 !important;
  color: #fff;
}
.pagination-primary li.active a:hover,
.pagination-primary li.active .page-link:hover,
.pagination-primary .page-item.active a:hover,
.pagination-primary .page-item.active .page-link:hover {
  color: #fff !important;
}
.pagination-primary li a:hover,
.pagination-primary li .page-link:hover,
.pagination-primary .page-item a:hover,
.pagination-primary .page-item .page-link:hover {
  color: #7367f0 !important;
}
.pagination-primary li.prev-item .page-link:hover, .pagination-primary li.next-item .page-link:hover,
.pagination-primary .page-item.prev-item .page-link:hover,
.pagination-primary .page-item.next-item .page-link:hover {
  background: #7367f0;
  color: #fff;
}

.nav-pill-primary .nav-item .nav-link.active {
  color: #fff;
  background-color: #7367f0;
}

.chip-primary {
  background-color: #7367f0 !important;
}
.chip-primary .chip-body {
  color: #fff !important;
}

.divider.divider-primary .divider-text:before, .divider.divider-primary .divider-text:after {
  border-color: #7367f0 !important;
}

input[type=checkbox].bg-primary + .custom-control-label:before, input[type=radio].bg-primary + .custom-control-label:before {
  background-color: #7367f0 !important;
}

input:focus ~ .bg-primary {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #7367f0 !important;
}

.vx-checkbox-primary input:checked ~ .vx-checkbox {
  border-color: #7367f0 !important;
}
.vx-checkbox-primary input:checked ~ .vx-checkbox .vx-checkbox--check {
  background-color: #7367f0 !important;
}
.vx-checkbox-primary input:active:checked + .vx-checkbox .vx-checkbox--check {
  background-color: #7367f0 !important;
}

.vertical-layout .main-menu.theme-primary .navbar-header .navbar-nav .brand-text {
  color: #7367f0;
}
.vertical-layout .main-menu.theme-primary .navigation .nav-item.active a {
  background: linear-gradient(118deg, #7367f0, rgba(115, 103, 240, 0.7));
  box-shadow: 0 0 10px 1px rgba(115, 103, 240, 0.7) !important;
}
.vertical-layout .main-menu.theme-primary .navigation .nav-item .menu-content li.active {
  background: linear-gradient(118deg, #7367f0, rgba(115, 103, 240, 0.7));
  box-shadow: 0 0 10px 1px rgba(115, 103, 240, 0.7) !important;
}

.horizontal-layout.theme-primary .header-navbar .brand-text {
  color: #7367f0 !important;
}
.horizontal-layout.theme-primary .navbar-horizontal #main-menu-navigation .nav-item.active .nav-link {
  background: linear-gradient(118deg, #7367f0, rgba(115, 103, 240, 0.7));
  box-shadow: 0 0 10px 1px rgba(115, 103, 240, 0.7) !important;
}

.custom-switch-primary .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #7367f0 !important;
  color: #fff;
  transition: all 0.2s ease-out;
}

.color-radio.color-radio-primary {
  border: 1px solid transparent;
}
.color-radio.color-radio-primary.selected {
  border-color: #7367f0;
}
.color-radio.color-radio-primary .radio-content {
  background-color: #7367f0;
}

.vx-radio-primary input:checked ~ .vx-radio .vx-radio--circle {
  background: #7367f0 !important;
  box-shadow: 0 3px 12px 0 rgba(115, 103, 240, 0.4) !important;
}

.primary.darken-1 {
  color: rgb(93.622754491, 79.7904191617, 237.7095808383) !important;
}

.bg-primary.bg-darken-1 {
  background-color: rgb(93.622754491, 79.7904191617, 237.7095808383) !important;
}

.btn-primary.btn-darken-1 {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: rgb(93.622754491, 79.7904191617, 237.7095808383) !important;
}
.btn-primary.btn-darken-1:hover {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
}
.btn-primary.btn-darken-1:focus, .btn-primary.btn-darken-1:active {
  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;
}

.btn-outline-primary.btn-outline-darken-1 {
  border-color: rgb(93.622754491, 79.7904191617, 237.7095808383) !important;
  color: rgb(93.622754491, 79.7904191617, 237.7095808383) !important;
}
.btn-outline-primary.btn-outline-darken-1:hover {
  background-color: rgb(93.622754491, 79.7904191617, 237.7095808383) !important;
}

input:focus ~ .bg-primary {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(93.622754491, 79.7904191617, 237.7095808383) !important;
}

.border-primary.border-darken-1 {
  border: 1px solid rgb(93.622754491, 79.7904191617, 237.7095808383) !important;
}

.border-top-primary.border-top-darken-1 {
  border-top: 1px solid rgb(93.622754491, 79.7904191617, 237.7095808383) !important;
}

.border-bottom-primary.border-bottom-darken-1 {
  border-bottom: 1px solid rgb(93.622754491, 79.7904191617, 237.7095808383) !important;
}

.border-left-primary.border-left-darken-1 {
  border-left: 1px solid rgb(93.622754491, 79.7904191617, 237.7095808383) !important;
}

.border-right-primary.border-right-darken-1 {
  border-right: 1px solid rgb(93.622754491, 79.7904191617, 237.7095808383) !important;
}

.overlay-primary.overlay-darken-1 {
  background: rgb(93.622754491, 79.7904191617, 237.7095808383); /* The Fallback */
  background: rgba(93.622754491, 79.7904191617, 237.7095808383, 0.6);
}

.primary.darken-2 {
  color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
}

.bg-primary.bg-darken-2 {
  background-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
}

.btn-primary.btn-darken-2 {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
}
.btn-primary.btn-darken-2:hover {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
}
.btn-primary.btn-darken-2:focus, .btn-primary.btn-darken-2:active {
  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;
}

.btn-outline-primary.btn-outline-darken-2 {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
}
.btn-outline-primary.btn-outline-darken-2:hover {
  background-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
}

input:focus ~ .bg-primary {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
}

.border-primary.border-darken-2 {
  border: 1px solid rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
}

.border-top-primary.border-top-darken-2 {
  border-top: 1px solid rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
}

.border-bottom-primary.border-bottom-darken-2 {
  border-bottom: 1px solid rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
}

.border-left-primary.border-left-darken-2 {
  border-left: 1px solid rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
}

.border-right-primary.border-right-darken-2 {
  border-right: 1px solid rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
}

.overlay-primary.overlay-darken-2 {
  background: rgb(72.245508982, 56.5808383234, 235.4191616766); /* The Fallback */
  background: rgba(72.245508982, 56.5808383234, 235.4191616766, 0.6);
}

.primary.darken-3 {
  color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
}

.bg-primary.bg-darken-3 {
  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
}

.btn-primary.btn-darken-3 {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
}
.btn-primary.btn-darken-3:hover {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
}
.btn-primary.btn-darken-3:focus, .btn-primary.btn-darken-3:active {
  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;
}

.btn-outline-primary.btn-outline-darken-3 {
  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
  color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
}
.btn-outline-primary.btn-outline-darken-3:hover {
  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
}

input:focus ~ .bg-primary {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(50.8682634731, 33.371257485, 233.128742515) !important;
}

.border-primary.border-darken-3 {
  border: 1px solid rgb(50.8682634731, 33.371257485, 233.128742515) !important;
}

.border-top-primary.border-top-darken-3 {
  border-top: 1px solid rgb(50.8682634731, 33.371257485, 233.128742515) !important;
}

.border-bottom-primary.border-bottom-darken-3 {
  border-bottom: 1px solid rgb(50.8682634731, 33.371257485, 233.128742515) !important;
}

.border-left-primary.border-left-darken-3 {
  border-left: 1px solid rgb(50.8682634731, 33.371257485, 233.128742515) !important;
}

.border-right-primary.border-right-darken-3 {
  border-right: 1px solid rgb(50.8682634731, 33.371257485, 233.128742515) !important;
}

.overlay-primary.overlay-darken-3 {
  background: rgb(50.8682634731, 33.371257485, 233.128742515); /* The Fallback */
  background: rgba(50.8682634731, 33.371257485, 233.128742515, 0.6);
}

.primary.darken-4 {
  color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;
}

.bg-primary.bg-darken-4 {
  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;
}

.btn-primary.btn-darken-4 {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;
}
.btn-primary.btn-darken-4:hover {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
}
.btn-primary.btn-darken-4:focus, .btn-primary.btn-darken-4:active {
  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;
}

.btn-outline-primary.btn-outline-darken-4 {
  border-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;
  color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;
}
.btn-outline-primary.btn-outline-darken-4:hover {
  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;
}

input:focus ~ .bg-primary {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;
}

.border-primary.border-darken-4 {
  border: 1px solid rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;
}

.border-top-primary.border-top-darken-4 {
  border-top: 1px solid rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;
}

.border-bottom-primary.border-bottom-darken-4 {
  border-bottom: 1px solid rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;
}

.border-left-primary.border-left-darken-4 {
  border-left: 1px solid rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;
}

.border-right-primary.border-right-darken-4 {
  border-right: 1px solid rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;
}

.overlay-primary.overlay-darken-4 {
  background: rgb(38.9640718563, 21.6467065868, 219.3532934132); /* The Fallback */
  background: rgba(38.9640718563, 21.6467065868, 219.3532934132, 0.6);
}

.primary.accent-1 {
  color: #bdfdff !important;
}

.bg-primary.bg-accent-1 {
  background-color: #bdfdff !important;
}

.btn-primary.btn-accent-1 {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: #bdfdff !important;
}
.btn-primary.btn-accent-1:hover {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
}
.btn-primary.btn-accent-1:focus, .btn-primary.btn-accent-1:active {
  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;
}

.btn-outline-primary.btn-outline-accent-1 {
  border-color: #bdfdff !important;
  color: #bdfdff !important;
}
.btn-outline-primary.btn-outline-accent-1:hover {
  background-color: #bdfdff !important;
}

input:focus ~ .bg-primary {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #bdfdff !important;
}

.border-primary.border-accent-1 {
  border: 1px solid #bdfdff !important;
}

.border-top-primary.border-top-accent-1 {
  border-top: 1px solid #bdfdff !important;
}

.border-bottom-primary.border-bottom-accent-1 {
  border-bottom: 1px solid #bdfdff !important;
}

.border-left-primary.border-left-accent-1 {
  border-left: 1px solid #bdfdff !important;
}

.border-right-primary.border-right-accent-1 {
  border-right: 1px solid #bdfdff !important;
}

.overlay-primary.overlay-accent-1 {
  background: #bdfdff; /* The Fallback */
  background: rgba(189, 253, 255, 0.6);
}

.primary.accent-2 {
  color: #8afbff !important;
}

.bg-primary.bg-accent-2 {
  background-color: #8afbff !important;
}

.btn-primary.btn-accent-2 {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: #8afbff !important;
}
.btn-primary.btn-accent-2:hover {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
}
.btn-primary.btn-accent-2:focus, .btn-primary.btn-accent-2:active {
  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;
}

.btn-outline-primary.btn-outline-accent-2 {
  border-color: #8afbff !important;
  color: #8afbff !important;
}
.btn-outline-primary.btn-outline-accent-2:hover {
  background-color: #8afbff !important;
}

input:focus ~ .bg-primary {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #8afbff !important;
}

.border-primary.border-accent-2 {
  border: 1px solid #8afbff !important;
}

.border-top-primary.border-top-accent-2 {
  border-top: 1px solid #8afbff !important;
}

.border-bottom-primary.border-bottom-accent-2 {
  border-bottom: 1px solid #8afbff !important;
}

.border-left-primary.border-left-accent-2 {
  border-left: 1px solid #8afbff !important;
}

.border-right-primary.border-right-accent-2 {
  border-right: 1px solid #8afbff !important;
}

.overlay-primary.overlay-accent-2 {
  background: #8afbff; /* The Fallback */
  background: rgba(138, 251, 255, 0.6);
}

.primary.accent-3 {
  color: #57faff !important;
}

.bg-primary.bg-accent-3 {
  background-color: #57faff !important;
}

.btn-primary.btn-accent-3 {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: #57faff !important;
}
.btn-primary.btn-accent-3:hover {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
}
.btn-primary.btn-accent-3:focus, .btn-primary.btn-accent-3:active {
  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;
}

.btn-outline-primary.btn-outline-accent-3 {
  border-color: #57faff !important;
  color: #57faff !important;
}
.btn-outline-primary.btn-outline-accent-3:hover {
  background-color: #57faff !important;
}

input:focus ~ .bg-primary {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #57faff !important;
}

.border-primary.border-accent-3 {
  border: 1px solid #57faff !important;
}

.border-top-primary.border-top-accent-3 {
  border-top: 1px solid #57faff !important;
}

.border-bottom-primary.border-bottom-accent-3 {
  border-bottom: 1px solid #57faff !important;
}

.border-left-primary.border-left-accent-3 {
  border-left: 1px solid #57faff !important;
}

.border-right-primary.border-right-accent-3 {
  border-right: 1px solid #57faff !important;
}

.overlay-primary.overlay-accent-3 {
  background: #57faff; /* The Fallback */
  background: rgba(87, 250, 255, 0.6);
}

.primary.accent-4 {
  color: #3df9ff !important;
}

.bg-primary.bg-accent-4 {
  background-color: #3df9ff !important;
}

.btn-primary.btn-accent-4 {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: #3df9ff !important;
}
.btn-primary.btn-accent-4:hover {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
}
.btn-primary.btn-accent-4:focus, .btn-primary.btn-accent-4:active {
  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;
}

.btn-outline-primary.btn-outline-accent-4 {
  border-color: #3df9ff !important;
  color: #3df9ff !important;
}
.btn-outline-primary.btn-outline-accent-4:hover {
  background-color: #3df9ff !important;
}

input:focus ~ .bg-primary {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #3df9ff !important;
}

.border-primary.border-accent-4 {
  border: 1px solid #3df9ff !important;
}

.border-top-primary.border-top-accent-4 {
  border-top: 1px solid #3df9ff !important;
}

.border-bottom-primary.border-bottom-accent-4 {
  border-bottom: 1px solid #3df9ff !important;
}

.border-left-primary.border-left-accent-4 {
  border-left: 1px solid #3df9ff !important;
}

.border-right-primary.border-right-accent-4 {
  border-right: 1px solid #3df9ff !important;
}

.overlay-primary.overlay-accent-4 {
  background: #3df9ff; /* The Fallback */
  background: rgba(61, 249, 255, 0.6);
}

.primary.gradient-bg {
  color: #640064 !important;
}

.bg-primary.bg-gradient-bg {
  background-color: #640064 !important;
}

.btn-primary.btn-gradient-bg {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: #640064 !important;
}
.btn-primary.btn-gradient-bg:hover {
  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;
  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
}
.btn-primary.btn-gradient-bg:focus, .btn-primary.btn-gradient-bg:active {
  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;
  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;
}

.btn-outline-primary.btn-outline-gradient-bg {
  border-color: #640064 !important;
  color: #640064 !important;
}
.btn-outline-primary.btn-outline-gradient-bg:hover {
  background-color: #640064 !important;
}

input:focus ~ .bg-primary {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #640064 !important;
}

.border-primary.border-gradient-bg {
  border: 1px solid #640064 !important;
}

.border-top-primary.border-top-gradient-bg {
  border-top: 1px solid #640064 !important;
}

.border-bottom-primary.border-bottom-gradient-bg {
  border-bottom: 1px solid #640064 !important;
}

.border-left-primary.border-left-gradient-bg {
  border-left: 1px solid #640064 !important;
}

.border-right-primary.border-right-gradient-bg {
  border-right: 1px solid #640064 !important;
}

.overlay-primary.overlay-gradient-bg {
  background: #640064; /* The Fallback */
  background: rgba(100, 0, 100, 0.6);
}

.secondary.gradient-light {
  color: rgb(220.3498655492, 221.623471291, 235.6331344508) !important;
}

.bg-secondary.bg-gradient-light {
  background-color: rgb(220.3498655492, 221.623471291, 235.6331344508) !important;
}

.btn-secondary.btn-gradient-light {
  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;
  background-color: rgb(220.3498655492, 221.623471291, 235.6331344508) !important;
}
.btn-secondary.btn-gradient-light:hover {
  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;
  background-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;
}
.btn-secondary.btn-gradient-light:focus, .btn-secondary.btn-gradient-light:active {
  border-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;
  background-color: rgb(124.6393442623, 143, 161.3606557377) !important;
}

.btn-outline-secondary.btn-outline-gradient-light {
  border-color: rgb(220.3498655492, 221.623471291, 235.6331344508) !important;
  color: rgb(220.3498655492, 221.623471291, 235.6331344508) !important;
}
.btn-outline-secondary.btn-outline-gradient-light:hover {
  background-color: rgb(220.3498655492, 221.623471291, 235.6331344508) !important;
}

input:focus ~ .bg-secondary {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(220.3498655492, 221.623471291, 235.6331344508) !important;
}

.border-secondary.border-gradient-light {
  border: 1px solid rgb(220.3498655492, 221.623471291, 235.6331344508) !important;
}

.border-top-secondary.border-top-gradient-light {
  border-top: 1px solid rgb(220.3498655492, 221.623471291, 235.6331344508) !important;
}

.border-bottom-secondary.border-bottom-gradient-light {
  border-bottom: 1px solid rgb(220.3498655492, 221.623471291, 235.6331344508) !important;
}

.border-left-secondary.border-left-gradient-light {
  border-left: 1px solid rgb(220.3498655492, 221.623471291, 235.6331344508) !important;
}

.border-right-secondary.border-right-gradient-light {
  border-right: 1px solid rgb(220.3498655492, 221.623471291, 235.6331344508) !important;
}

.overlay-secondary.overlay-gradient-light {
  background: rgb(220.3498655492, 221.623471291, 235.6331344508); /* The Fallback */
  background: rgba(220.3498655492, 221.623471291, 235.6331344508, 0.6);
}

.secondary.light-badge {
  color: white !important;
}

.bg-secondary.bg-light-badge {
  background-color: white !important;
}

.btn-secondary.btn-light-badge {
  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;
  background-color: white !important;
}
.btn-secondary.btn-light-badge:hover {
  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;
  background-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;
}
.btn-secondary.btn-light-badge:focus, .btn-secondary.btn-light-badge:active {
  border-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;
  background-color: rgb(124.6393442623, 143, 161.3606557377) !important;
}

.btn-outline-secondary.btn-outline-light-badge {
  border-color: white !important;
  color: white !important;
}
.btn-outline-secondary.btn-outline-light-badge:hover {
  background-color: white !important;
}

input:focus ~ .bg-secondary {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem white !important;
}

.border-secondary.border-light-badge {
  border: 1px solid white !important;
}

.border-top-secondary.border-top-light-badge {
  border-top: 1px solid white !important;
}

.border-bottom-secondary.border-bottom-light-badge {
  border-bottom: 1px solid white !important;
}

.border-left-secondary.border-left-light-badge {
  border-left: 1px solid white !important;
}

.border-right-secondary.border-right-light-badge {
  border-right: 1px solid white !important;
}

.overlay-secondary.overlay-light-badge {
  background: white; /* The Fallback */
  background: rgba(255, 255, 255, 0.6);
}

.secondary.lighten-5 {
  color: white !important;
}

.bg-secondary.bg-lighten-5 {
  background-color: white !important;
}

.btn-secondary.btn-lighten-5 {
  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;
  background-color: white !important;
}
.btn-secondary.btn-lighten-5:hover {
  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;
  background-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;
}
.btn-secondary.btn-lighten-5:focus, .btn-secondary.btn-lighten-5:active {
  border-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;
  background-color: rgb(124.6393442623, 143, 161.3606557377) !important;
}

.btn-outline-secondary.btn-outline-lighten-5 {
  border-color: white !important;
  color: white !important;
}
.btn-outline-secondary.btn-outline-lighten-5:hover {
  background-color: white !important;
}

input:focus ~ .bg-secondary {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem white !important;
}

.border-secondary.border-lighten-5 {
  border: 1px solid white !important;
}

.border-top-secondary.border-top-lighten-5 {
  border-top: 1px solid white !important;
}

.border-bottom-secondary.border-bottom-lighten-5 {
  border-bottom: 1px solid white !important;
}

.border-left-secondary.border-left-lighten-5 {
  border-left: 1px solid white !important;
}

.border-right-secondary.border-right-lighten-5 {
  border-right: 1px solid white !important;
}

.overlay-secondary.overlay-lighten-5 {
  background: white; /* The Fallback */
  background: rgba(255, 255, 255, 0.6);
}

.secondary.lighten-4 {
  color: rgb(243.3606557377, 245, 246.6393442623) !important;
}

.bg-secondary.bg-lighten-4 {
  background-color: rgb(243.3606557377, 245, 246.6393442623) !important;
}

.btn-secondary.btn-lighten-4 {
  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;
  background-color: rgb(243.3606557377, 245, 246.6393442623) !important;
}
.btn-secondary.btn-lighten-4:hover {
  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;
  background-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;
}
.btn-secondary.btn-lighten-4:focus, .btn-secondary.btn-lighten-4:active {
  border-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;
  background-color: rgb(124.6393442623, 143, 161.3606557377) !important;
}

.btn-outline-secondary.btn-outline-lighten-4 {
  border-color: rgb(243.3606557377, 245, 246.6393442623) !important;
  color: rgb(243.3606557377, 245, 246.6393442623) !important;
}
.btn-outline-secondary.btn-outline-lighten-4:hover {
  background-color: rgb(243.3606557377, 245, 246.6393442623) !important;
}

input:focus ~ .bg-secondary {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(243.3606557377, 245, 246.6393442623) !important;
}

.border-secondary.border-lighten-4 {
  border: 1px solid rgb(243.3606557377, 245, 246.6393442623) !important;
}

.border-top-secondary.border-top-lighten-4 {
  border-top: 1px solid rgb(243.3606557377, 245, 246.6393442623) !important;
}

.border-bottom-secondary.border-bottom-lighten-4 {
  border-bottom: 1px solid rgb(243.3606557377, 245, 246.6393442623) !important;
}

.border-left-secondary.border-left-lighten-4 {
  border-left: 1px solid rgb(243.3606557377, 245, 246.6393442623) !important;
}

.border-right-secondary.border-right-lighten-4 {
  border-right: 1px solid rgb(243.3606557377, 245, 246.6393442623) !important;
}

.overlay-secondary.overlay-lighten-4 {
  background: rgb(243.3606557377, 245, 246.6393442623); /* The Fallback */
  background: rgba(243.3606557377, 245, 246.6393442623, 0.6);
}

.secondary.lighten-3 {
  color: rgb(228.5204918033, 232.25, 235.9795081967) !important;
}

.bg-secondary.bg-lighten-3 {
  background-color: rgb(228.5204918033, 232.25, 235.9795081967) !important;
}

.btn-secondary.btn-lighten-3 {
  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;
  background-color: rgb(228.5204918033, 232.25, 235.9795081967) !important;
}
.btn-secondary.btn-lighten-3:hover {
  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;
  background-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;
}
.btn-secondary.btn-lighten-3:focus, .btn-secondary.btn-lighten-3:active {
  border-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;
  background-color: rgb(124.6393442623, 143, 161.3606557377) !important;
}

.btn-outline-secondary.btn-outline-lighten-3 {
  border-color: rgb(228.5204918033, 232.25, 235.9795081967) !important;
  color: rgb(228.5204918033, 232.25, 235.9795081967) !important;
}
.btn-outline-secondary.btn-outline-lighten-3:hover {
  background-color: rgb(228.5204918033, 232.25, 235.9795081967) !important;
}

input:focus ~ .bg-secondary {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(228.5204918033, 232.25, 235.9795081967) !important;
}

.border-secondary.border-lighten-3 {
  border: 1px solid rgb(228.5204918033, 232.25, 235.9795081967) !important;
}

.border-top-secondary.border-top-lighten-3 {
  border-top: 1px solid rgb(228.5204918033, 232.25, 235.9795081967) !important;
}

.border-bottom-secondary.border-bottom-lighten-3 {
  border-bottom: 1px solid rgb(228.5204918033, 232.25, 235.9795081967) !important;
}

.border-left-secondary.border-left-lighten-3 {
  border-left: 1px solid rgb(228.5204918033, 232.25, 235.9795081967) !important;
}

.border-right-secondary.border-right-lighten-3 {
  border-right: 1px solid rgb(228.5204918033, 232.25, 235.9795081967) !important;
}

.overlay-secondary.overlay-lighten-3 {
  background: rgb(228.5204918033, 232.25, 235.9795081967); /* The Fallback */
  background: rgba(228.5204918033, 232.25, 235.9795081967, 0.6);
}

.secondary.lighten-2 {
  color: rgb(213.6803278689, 219.5, 225.3196721311) !important;
}

.bg-secondary.bg-lighten-2 {
  background-color: rgb(213.6803278689, 219.5, 225.3196721311) !important;
}

.btn-secondary.btn-lighten-2 {
  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;
  background-color: rgb(213.6803278689, 219.5, 225.3196721311) !important;
}
.btn-secondary.btn-lighten-2:hover {
  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;
  background-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;
}
.btn-secondary.btn-lighten-2:focus, .btn-secondary.btn-lighten-2:active {
  border-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;
  background-color: rgb(124.6393442623, 143, 161.3606557377) !important;
}

.btn-outline-secondary.btn-outline-lighten-2 {
  border-color: rgb(213.6803278689, 219.5, 225.3196721311) !important;
  color: rgb(213.6803278689, 219.5, 225.3196721311) !important;
}
.btn-outline-secondary.btn-outline-lighten-2:hover {
  background-color: rgb(213.6803278689, 219.5, 225.3196721311) !important;
}

input:focus ~ .bg-secondary {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(213.6803278689, 219.5, 225.3196721311) !important;
}

.border-secondary.border-lighten-2 {
  border: 1px solid rgb(213.6803278689, 219.5, 225.3196721311) !important;
}

.border-top-secondary.border-top-lighten-2 {
  border-top: 1px solid rgb(213.6803278689, 219.5, 225.3196721311) !important;
}

.border-bottom-secondary.border-bottom-lighten-2 {
  border-bottom: 1px solid rgb(213.6803278689, 219.5, 225.3196721311) !important;
}

.border-left-secondary.border-left-lighten-2 {
  border-left: 1px solid rgb(213.6803278689, 219.5, 225.3196721311) !important;
}

.border-right-secondary.border-right-lighten-2 {
  border-right: 1px solid rgb(213.6803278689, 219.5, 225.3196721311) !important;
}

.overlay-secondary.overlay-lighten-2 {
  background: rgb(213.6803278689, 219.5, 225.3196721311); /* The Fallback */
  background: rgba(213.6803278689, 219.5, 225.3196721311, 0.6);
}

.secondary.lighten-1 {
  color: rgb(198.8401639344, 206.75, 214.6598360656) !important;
}

.bg-secondary.bg-lighten-1 {
  background-color: rgb(198.8401639344, 206.75, 214.6598360656) !important;
}

.btn-secondary.btn-lighten-1 {
  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;
  background-color: rgb(198.8401639344, 206.75, 214.6598360656) !important;
}
.btn-secondary.btn-lighten-1:hover {
  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;
  background-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;
}
.btn-secondary.btn-lighten-1:focus, .btn-secondary.btn-lighten-1:active {
  border-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;
  background-color: rgb(124.6393442623, 143, 161.3606557377) !important;
}

.btn-outline-secondary.btn-outline-lighten-1 {
  border-color: rgb(198.8401639344, 206.75, 214.6598360656) !important;
  color: rgb(198.8401639344, 206.75, 214.6598360656) !important;
}
.btn-outline-secondary.btn-outline-lighten-1:hover {
  background-color: rgb(198.8401639344, 206.75, 214.6598360656) !important;
}

input:focus ~ .bg-secondary {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(198.8401639344, 206.75, 214.6598360656) !important;
}

.border-secondary.border-lighten-1 {
  border: 1px solid rgb(198.8401639344, 206.75, 214.6598360656) !important;
}

.border-top-secondary.border-top-lighten-1 {
  border-top: 1px solid rgb(198.8401639344, 206.75, 214.6598360656) !important;
}

.border-bottom-secondary.border-bottom-lighten-1 {
  border-bottom: 1px solid rgb(198.8401639344, 206.75, 214.6598360656) !important;
}

.border-left-secondary.border-left-lighten-1 {
  border-left: 1px solid rgb(198.8401639344, 206.75, 214.6598360656) !important;
}

.border-right-secondary.border-right-lighten-1 {
  border-right: 1px solid rgb(198.8401639344, 206.75, 214.6598360656) !important;
}

.overlay-secondary.overlay-lighten-1 {
  background: rgb(198.8401639344, 206.75, 214.6598360656); /* The Fallback */
  background: rgba(198.8401639344, 206.75, 214.6598360656, 0.6);
}

.secondary {
  color: #b8c2cc !important;
}

.bg-secondary {
  background-color: #b8c2cc !important;
}
.bg-secondary .card-header,
.bg-secondary .card-footer {
  background-color: transparent;
}

.alert-secondary {
  background: rgba(184, 194, 204, 0.2) !important;
  color: #b8c2cc !important;
}
.alert-secondary .alert-heading {
  box-shadow: rgba(184, 194, 204, 0.4) 0px 6px 15px -7px;
}
.alert-secondary .alert-link {
  color: rgb(169.1598360656, 181.25, 193.3401639344) !important;
}

.bg-rgba-secondary {
  background: rgba(184, 194, 204, 0.15) !important;
}

.border-secondary {
  border: 1px solid #b8c2cc !important;
}

.border-top-secondary {
  border-top: 1px solid #b8c2cc;
}

.border-bottom-secondary {
  border-bottom: 1px solid #b8c2cc;
}

.border-left-secondary {
  border-left: 1px solid #b8c2cc;
}

.border-right-secondary {
  border-right: 1px solid #b8c2cc;
}

.badge.badge-light-secondary {
  background-color: white;
  color: #b8c2cc !important;
  font-weight: 500;
  text-transform: uppercase;
}

.bg-secondary.badge-glow,
.border-secondary.badge-glow,
.badge-secondary.badge-glow {
  box-shadow: 0px 0px 10px #b8c2cc;
}

.overlay-secondary {
  background: #b8c2cc; /* The Fallback */
  background: rgba(184, 194, 204, 0.6);
}

.btn-secondary {
  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;
  background-color: #b8c2cc !important;
  color: #fff;
}
.btn-secondary:hover {
  border-color: rgb(169.1598360656, 181.25, 193.3401639344) !important;
  color: #fff !important;
  box-shadow: 0 8px 25px -8px #b8c2cc;
}
.btn-secondary:focus, .btn-secondary:active {
  color: #fff !important;
}

.btn-flat-secondary {
  background-color: transparent;
  color: #b8c2cc;
}
.btn-flat-secondary:hover {
  color: #b8c2cc;
  background-color: rgba(184, 194, 204, 0.1);
}
.btn-flat-secondary:active, .btn-flat-secondary:focus {
  background-color: #b8c2cc;
  color: #fff !important;
}

.btn-relief-secondary {
  background-color: #b8c2cc;
  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.2);
  color: #fff;
}
.btn-relief-secondary:hover {
  color: #fff;
}
.btn-relief-secondary:active, .btn-relief-secondary:focus {
  outline: none;
  transform: translateY(3px);
}

.btn-outline-secondary {
  border: 1px solid #b8c2cc;
  background-color: transparent;
  color: #b8c2cc;
}
.btn-outline-secondary:hover {
  background-color: rgba(184, 194, 204, 0.08);
  color: #b8c2cc;
}
.btn-outline-secondary:active {
  color: #fff !important;
}

.btn-secondary ~ .dropdown-menu .dropdown-item.active,
.btn-outline-secondary ~ .dropdown-menu .dropdown-item.active,
.btn-flat-secondary ~ .dropdown-menu .dropdown-item.active {
  background-color: #b8c2cc;
  color: #fff;
}
.btn-secondary ~ .dropdown-menu .dropdown-item.active:hover,
.btn-outline-secondary ~ .dropdown-menu .dropdown-item.active:hover,
.btn-flat-secondary ~ .dropdown-menu .dropdown-item.active:hover {
  color: #fff;
}
.btn-secondary ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,
.btn-outline-secondary ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,
.btn-flat-secondary ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover {
  color: #b8c2cc;
}

.bullet.bullet-secondary {
  background-color: #b8c2cc;
}
.bullet.bullet-secondary.bullet-bordered {
  background-color: transparent;
  border: 2px solid #b8c2cc;
}

.pagination-secondary li.active a,
.pagination-secondary li.active .page-link,
.pagination-secondary .page-item.active a,
.pagination-secondary .page-item.active .page-link {
  background: #b8c2cc !important;
  color: #fff;
}
.pagination-secondary li.active a:hover,
.pagination-secondary li.active .page-link:hover,
.pagination-secondary .page-item.active a:hover,
.pagination-secondary .page-item.active .page-link:hover {
  color: #fff !important;
}
.pagination-secondary li a:hover,
.pagination-secondary li .page-link:hover,
.pagination-secondary .page-item a:hover,
.pagination-secondary .page-item .page-link:hover {
  color: #b8c2cc !important;
}
.pagination-secondary li.prev-item .page-link:hover, .pagination-secondary li.next-item .page-link:hover,
.pagination-secondary .page-item.prev-item .page-link:hover,
.pagination-secondary .page-item.next-item .page-link:hover {
  background: #b8c2cc;
  color: #fff;
}

.nav-pill-secondary .nav-item .nav-link.active {
  color: #fff;
  background-color: #b8c2cc;
}

.chip-secondary {
  background-color: #b8c2cc !important;
}
.chip-secondary .chip-body {
  color: #fff !important;
}

.divider.divider-secondary .divider-text:before, .divider.divider-secondary .divider-text:after {
  border-color: #b8c2cc !important;
}

input[type=checkbox].bg-secondary + .custom-control-label:before, input[type=radio].bg-secondary + .custom-control-label:before {
  background-color: #b8c2cc !important;
}

input:focus ~ .bg-secondary {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #b8c2cc !important;
}

.vx-checkbox-secondary input:checked ~ .vx-checkbox {
  border-color: #b8c2cc !important;
}
.vx-checkbox-secondary input:checked ~ .vx-checkbox .vx-checkbox--check {
  background-color: #b8c2cc !important;
}
.vx-checkbox-secondary input:active:checked + .vx-checkbox .vx-checkbox--check {
  background-color: #b8c2cc !important;
}

.vertical-layout .main-menu.theme-secondary .navbar-header .navbar-nav .brand-text {
  color: #b8c2cc;
}
.vertical-layout .main-menu.theme-secondary .navigation .nav-item.active a {
  background: linear-gradient(118deg, #b8c2cc, rgba(184, 194, 204, 0.7));
  box-shadow: 0 0 10px 1px rgba(184, 194, 204, 0.7) !important;
}
.vertical-layout .main-menu.theme-secondary .navigation .nav-item .menu-content li.active {
  background: linear-gradient(118deg, #b8c2cc, rgba(184, 194, 204, 0.7));
  box-shadow: 0 0 10px 1px rgba(184, 194, 204, 0.7) !important;
}

.horizontal-layout.theme-secondary .header-navbar .brand-text {
  color: #b8c2cc !important;
}
.horizontal-layout.theme-secondary .navbar-horizontal #main-menu-navigation .nav-item.active .nav-link {
  background: linear-gradient(118deg, #b8c2cc, rgba(184, 194, 204, 0.7));
  box-shadow: 0 0 10px 1px rgba(184, 194, 204, 0.7) !important;
}

.custom-switch-secondary .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #b8c2cc !important;
  color: #fff;
  transition: all 0.2s ease-out;
}

.color-radio.color-radio-secondary {
  border: 1px solid transparent;
}
.color-radio.color-radio-secondary.selected {
  border-color: #b8c2cc;
}
.color-radio.color-radio-secondary .radio-content {
  background-color: #b8c2cc;
}

.vx-radio-secondary input:checked ~ .vx-radio .vx-radio--circle {
  background: #b8c2cc !important;
  box-shadow: 0 3px 12px 0 rgba(184, 194, 204, 0.4) !important;
}

.secondary.darken-1 {
  color: rgb(169.1598360656, 181.25, 193.3401639344) !important;
}

.bg-secondary.bg-darken-1 {
  background-color: rgb(169.1598360656, 181.25, 193.3401639344) !important;
}

.btn-secondary.btn-darken-1 {
  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;
  background-color: rgb(169.1598360656, 181.25, 193.3401639344) !important;
}
.btn-secondary.btn-darken-1:hover {
  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;
  background-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;
}
.btn-secondary.btn-darken-1:focus, .btn-secondary.btn-darken-1:active {
  border-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;
  background-color: rgb(124.6393442623, 143, 161.3606557377) !important;
}

.btn-outline-secondary.btn-outline-darken-1 {
  border-color: rgb(169.1598360656, 181.25, 193.3401639344) !important;
  color: rgb(169.1598360656, 181.25, 193.3401639344) !important;
}
.btn-outline-secondary.btn-outline-darken-1:hover {
  background-color: rgb(169.1598360656, 181.25, 193.3401639344) !important;
}

input:focus ~ .bg-secondary {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(169.1598360656, 181.25, 193.3401639344) !important;
}

.border-secondary.border-darken-1 {
  border: 1px solid rgb(169.1598360656, 181.25, 193.3401639344) !important;
}

.border-top-secondary.border-top-darken-1 {
  border-top: 1px solid rgb(169.1598360656, 181.25, 193.3401639344) !important;
}

.border-bottom-secondary.border-bottom-darken-1 {
  border-bottom: 1px solid rgb(169.1598360656, 181.25, 193.3401639344) !important;
}

.border-left-secondary.border-left-darken-1 {
  border-left: 1px solid rgb(169.1598360656, 181.25, 193.3401639344) !important;
}

.border-right-secondary.border-right-darken-1 {
  border-right: 1px solid rgb(169.1598360656, 181.25, 193.3401639344) !important;
}

.overlay-secondary.overlay-darken-1 {
  background: rgb(169.1598360656, 181.25, 193.3401639344); /* The Fallback */
  background: rgba(169.1598360656, 181.25, 193.3401639344, 0.6);
}

.secondary.darken-2 {
  color: rgb(154.3196721311, 168.5, 182.6803278689) !important;
}

.bg-secondary.bg-darken-2 {
  background-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;
}

.btn-secondary.btn-darken-2 {
  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;
  background-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;
}
.btn-secondary.btn-darken-2:hover {
  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;
  background-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;
}
.btn-secondary.btn-darken-2:focus, .btn-secondary.btn-darken-2:active {
  border-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;
  background-color: rgb(124.6393442623, 143, 161.3606557377) !important;
}

.btn-outline-secondary.btn-outline-darken-2 {
  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;
  color: rgb(154.3196721311, 168.5, 182.6803278689) !important;
}
.btn-outline-secondary.btn-outline-darken-2:hover {
  background-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;
}

input:focus ~ .bg-secondary {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(154.3196721311, 168.5, 182.6803278689) !important;
}

.border-secondary.border-darken-2 {
  border: 1px solid rgb(154.3196721311, 168.5, 182.6803278689) !important;
}

.border-top-secondary.border-top-darken-2 {
  border-top: 1px solid rgb(154.3196721311, 168.5, 182.6803278689) !important;
}

.border-bottom-secondary.border-bottom-darken-2 {
  border-bottom: 1px solid rgb(154.3196721311, 168.5, 182.6803278689) !important;
}

.border-left-secondary.border-left-darken-2 {
  border-left: 1px solid rgb(154.3196721311, 168.5, 182.6803278689) !important;
}

.border-right-secondary.border-right-darken-2 {
  border-right: 1px solid rgb(154.3196721311, 168.5, 182.6803278689) !important;
}

.overlay-secondary.overlay-darken-2 {
  background: rgb(154.3196721311, 168.5, 182.6803278689); /* The Fallback */
  background: rgba(154.3196721311, 168.5, 182.6803278689, 0.6);
}

.secondary.darken-3 {
  color: rgb(139.4795081967, 155.75, 172.0204918033) !important;
}

.bg-secondary.bg-darken-3 {
  background-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;
}

.btn-secondary.btn-darken-3 {
  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;
  background-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;
}
.btn-secondary.btn-darken-3:hover {
  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;
  background-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;
}
.btn-secondary.btn-darken-3:focus, .btn-secondary.btn-darken-3:active {
  border-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;
  background-color: rgb(124.6393442623, 143, 161.3606557377) !important;
}

.btn-outline-secondary.btn-outline-darken-3 {
  border-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;
  color: rgb(139.4795081967, 155.75, 172.0204918033) !important;
}
.btn-outline-secondary.btn-outline-darken-3:hover {
  background-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;
}

input:focus ~ .bg-secondary {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(139.4795081967, 155.75, 172.0204918033) !important;
}

.border-secondary.border-darken-3 {
  border: 1px solid rgb(139.4795081967, 155.75, 172.0204918033) !important;
}

.border-top-secondary.border-top-darken-3 {
  border-top: 1px solid rgb(139.4795081967, 155.75, 172.0204918033) !important;
}

.border-bottom-secondary.border-bottom-darken-3 {
  border-bottom: 1px solid rgb(139.4795081967, 155.75, 172.0204918033) !important;
}

.border-left-secondary.border-left-darken-3 {
  border-left: 1px solid rgb(139.4795081967, 155.75, 172.0204918033) !important;
}

.border-right-secondary.border-right-darken-3 {
  border-right: 1px solid rgb(139.4795081967, 155.75, 172.0204918033) !important;
}

.overlay-secondary.overlay-darken-3 {
  background: rgb(139.4795081967, 155.75, 172.0204918033); /* The Fallback */
  background: rgba(139.4795081967, 155.75, 172.0204918033, 0.6);
}

.secondary.darken-4 {
  color: rgb(124.6393442623, 143, 161.3606557377) !important;
}

.bg-secondary.bg-darken-4 {
  background-color: rgb(124.6393442623, 143, 161.3606557377) !important;
}

.btn-secondary.btn-darken-4 {
  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;
  background-color: rgb(124.6393442623, 143, 161.3606557377) !important;
}
.btn-secondary.btn-darken-4:hover {
  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;
  background-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;
}
.btn-secondary.btn-darken-4:focus, .btn-secondary.btn-darken-4:active {
  border-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;
  background-color: rgb(124.6393442623, 143, 161.3606557377) !important;
}

.btn-outline-secondary.btn-outline-darken-4 {
  border-color: rgb(124.6393442623, 143, 161.3606557377) !important;
  color: rgb(124.6393442623, 143, 161.3606557377) !important;
}
.btn-outline-secondary.btn-outline-darken-4:hover {
  background-color: rgb(124.6393442623, 143, 161.3606557377) !important;
}

input:focus ~ .bg-secondary {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(124.6393442623, 143, 161.3606557377) !important;
}

.border-secondary.border-darken-4 {
  border: 1px solid rgb(124.6393442623, 143, 161.3606557377) !important;
}

.border-top-secondary.border-top-darken-4 {
  border-top: 1px solid rgb(124.6393442623, 143, 161.3606557377) !important;
}

.border-bottom-secondary.border-bottom-darken-4 {
  border-bottom: 1px solid rgb(124.6393442623, 143, 161.3606557377) !important;
}

.border-left-secondary.border-left-darken-4 {
  border-left: 1px solid rgb(124.6393442623, 143, 161.3606557377) !important;
}

.border-right-secondary.border-right-darken-4 {
  border-right: 1px solid rgb(124.6393442623, 143, 161.3606557377) !important;
}

.overlay-secondary.overlay-darken-4 {
  background: rgb(124.6393442623, 143, 161.3606557377); /* The Fallback */
  background: rgba(124.6393442623, 143, 161.3606557377, 0.6);
}

.secondary.gradient-bg {
  color: #640064 !important;
}

.bg-secondary.bg-gradient-bg {
  background-color: #640064 !important;
}

.btn-secondary.btn-gradient-bg {
  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;
  background-color: #640064 !important;
}
.btn-secondary.btn-gradient-bg:hover {
  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;
  background-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;
}
.btn-secondary.btn-gradient-bg:focus, .btn-secondary.btn-gradient-bg:active {
  border-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;
  background-color: rgb(124.6393442623, 143, 161.3606557377) !important;
}

.btn-outline-secondary.btn-outline-gradient-bg {
  border-color: #640064 !important;
  color: #640064 !important;
}
.btn-outline-secondary.btn-outline-gradient-bg:hover {
  background-color: #640064 !important;
}

input:focus ~ .bg-secondary {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #640064 !important;
}

.border-secondary.border-gradient-bg {
  border: 1px solid #640064 !important;
}

.border-top-secondary.border-top-gradient-bg {
  border-top: 1px solid #640064 !important;
}

.border-bottom-secondary.border-bottom-gradient-bg {
  border-bottom: 1px solid #640064 !important;
}

.border-left-secondary.border-left-gradient-bg {
  border-left: 1px solid #640064 !important;
}

.border-right-secondary.border-right-gradient-bg {
  border-right: 1px solid #640064 !important;
}

.overlay-secondary.overlay-gradient-bg {
  background: #640064; /* The Fallback */
  background: rgba(100, 0, 100, 0.6);
}

.success.gradient-light {
  color: rgb(73.8812290858, 233.1017709142, 211.3216024566) !important;
}

.bg-success.bg-gradient-light {
  background-color: rgb(73.8812290858, 233.1017709142, 211.3216024566) !important;
}

.btn-success.btn-gradient-light {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: rgb(73.8812290858, 233.1017709142, 211.3216024566) !important;
}
.btn-success.btn-gradient-light:hover {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
}
.btn-success.btn-gradient-light:focus, .btn-success.btn-gradient-light:active {
  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;
}

.btn-outline-success.btn-outline-gradient-light {
  border-color: rgb(73.8812290858, 233.1017709142, 211.3216024566) !important;
  color: rgb(73.8812290858, 233.1017709142, 211.3216024566) !important;
}
.btn-outline-success.btn-outline-gradient-light:hover {
  background-color: rgb(73.8812290858, 233.1017709142, 211.3216024566) !important;
}

input:focus ~ .bg-success {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(73.8812290858, 233.1017709142, 211.3216024566) !important;
}

.border-success.border-gradient-light {
  border: 1px solid rgb(73.8812290858, 233.1017709142, 211.3216024566) !important;
}

.border-top-success.border-top-gradient-light {
  border-top: 1px solid rgb(73.8812290858, 233.1017709142, 211.3216024566) !important;
}

.border-bottom-success.border-bottom-gradient-light {
  border-bottom: 1px solid rgb(73.8812290858, 233.1017709142, 211.3216024566) !important;
}

.border-left-success.border-left-gradient-light {
  border-left: 1px solid rgb(73.8812290858, 233.1017709142, 211.3216024566) !important;
}

.border-right-success.border-right-gradient-light {
  border-right: 1px solid rgb(73.8812290858, 233.1017709142, 211.3216024566) !important;
}

.overlay-success.overlay-gradient-light {
  background: rgb(73.8812290858, 233.1017709142, 211.3216024566); /* The Fallback */
  background: rgba(73.8812290858, 233.1017709142, 211.3216024566, 0.6);
}

.success.light-badge {
  color: rgb(199.2133891213, 243.7866108787, 219.1171548117) !important;
}

.bg-success.bg-light-badge {
  background-color: rgb(199.2133891213, 243.7866108787, 219.1171548117) !important;
}

.btn-success.btn-light-badge {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: rgb(199.2133891213, 243.7866108787, 219.1171548117) !important;
}
.btn-success.btn-light-badge:hover {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
}
.btn-success.btn-light-badge:focus, .btn-success.btn-light-badge:active {
  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;
}

.btn-outline-success.btn-outline-light-badge {
  border-color: rgb(199.2133891213, 243.7866108787, 219.1171548117) !important;
  color: rgb(199.2133891213, 243.7866108787, 219.1171548117) !important;
}
.btn-outline-success.btn-outline-light-badge:hover {
  background-color: rgb(199.2133891213, 243.7866108787, 219.1171548117) !important;
}

input:focus ~ .bg-success {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(199.2133891213, 243.7866108787, 219.1171548117) !important;
}

.border-success.border-light-badge {
  border: 1px solid rgb(199.2133891213, 243.7866108787, 219.1171548117) !important;
}

.border-top-success.border-top-light-badge {
  border-top: 1px solid rgb(199.2133891213, 243.7866108787, 219.1171548117) !important;
}

.border-bottom-success.border-bottom-light-badge {
  border-bottom: 1px solid rgb(199.2133891213, 243.7866108787, 219.1171548117) !important;
}

.border-left-success.border-left-light-badge {
  border-left: 1px solid rgb(199.2133891213, 243.7866108787, 219.1171548117) !important;
}

.border-right-success.border-right-light-badge {
  border-right: 1px solid rgb(199.2133891213, 243.7866108787, 219.1171548117) !important;
}

.overlay-success.overlay-light-badge {
  background: rgb(199.2133891213, 243.7866108787, 219.1171548117); /* The Fallback */
  background: rgba(199.2133891213, 243.7866108787, 219.1171548117, 0.6);
}

.success.lighten-5 {
  color: rgb(135.5167364017, 230.9832635983, 178.1464435146) !important;
}

.bg-success.bg-lighten-5 {
  background-color: rgb(135.5167364017, 230.9832635983, 178.1464435146) !important;
}

.btn-success.btn-lighten-5 {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: rgb(135.5167364017, 230.9832635983, 178.1464435146) !important;
}
.btn-success.btn-lighten-5:hover {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
}
.btn-success.btn-lighten-5:focus, .btn-success.btn-lighten-5:active {
  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;
}

.btn-outline-success.btn-outline-lighten-5 {
  border-color: rgb(135.5167364017, 230.9832635983, 178.1464435146) !important;
  color: rgb(135.5167364017, 230.9832635983, 178.1464435146) !important;
}
.btn-outline-success.btn-outline-lighten-5:hover {
  background-color: rgb(135.5167364017, 230.9832635983, 178.1464435146) !important;
}

input:focus ~ .bg-success {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(135.5167364017, 230.9832635983, 178.1464435146) !important;
}

.border-success.border-lighten-5 {
  border: 1px solid rgb(135.5167364017, 230.9832635983, 178.1464435146) !important;
}

.border-top-success.border-top-lighten-5 {
  border-top: 1px solid rgb(135.5167364017, 230.9832635983, 178.1464435146) !important;
}

.border-bottom-success.border-bottom-lighten-5 {
  border-bottom: 1px solid rgb(135.5167364017, 230.9832635983, 178.1464435146) !important;
}

.border-left-success.border-left-lighten-5 {
  border-left: 1px solid rgb(135.5167364017, 230.9832635983, 178.1464435146) !important;
}

.border-right-success.border-right-lighten-5 {
  border-right: 1px solid rgb(135.5167364017, 230.9832635983, 178.1464435146) !important;
}

.overlay-success.overlay-lighten-5 {
  background: rgb(135.5167364017, 230.9832635983, 178.1464435146); /* The Fallback */
  background: rgba(135.5167364017, 230.9832635983, 178.1464435146, 0.6);
}

.success.lighten-4 {
  color: rgb(114.2845188285, 226.7154811715, 164.489539749) !important;
}

.bg-success.bg-lighten-4 {
  background-color: rgb(114.2845188285, 226.7154811715, 164.489539749) !important;
}

.btn-success.btn-lighten-4 {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: rgb(114.2845188285, 226.7154811715, 164.489539749) !important;
}
.btn-success.btn-lighten-4:hover {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
}
.btn-success.btn-lighten-4:focus, .btn-success.btn-lighten-4:active {
  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;
}

.btn-outline-success.btn-outline-lighten-4 {
  border-color: rgb(114.2845188285, 226.7154811715, 164.489539749) !important;
  color: rgb(114.2845188285, 226.7154811715, 164.489539749) !important;
}
.btn-outline-success.btn-outline-lighten-4:hover {
  background-color: rgb(114.2845188285, 226.7154811715, 164.489539749) !important;
}

input:focus ~ .bg-success {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(114.2845188285, 226.7154811715, 164.489539749) !important;
}

.border-success.border-lighten-4 {
  border: 1px solid rgb(114.2845188285, 226.7154811715, 164.489539749) !important;
}

.border-top-success.border-top-lighten-4 {
  border-top: 1px solid rgb(114.2845188285, 226.7154811715, 164.489539749) !important;
}

.border-bottom-success.border-bottom-lighten-4 {
  border-bottom: 1px solid rgb(114.2845188285, 226.7154811715, 164.489539749) !important;
}

.border-left-success.border-left-lighten-4 {
  border-left: 1px solid rgb(114.2845188285, 226.7154811715, 164.489539749) !important;
}

.border-right-success.border-right-lighten-4 {
  border-right: 1px solid rgb(114.2845188285, 226.7154811715, 164.489539749) !important;
}

.overlay-success.overlay-lighten-4 {
  background: rgb(114.2845188285, 226.7154811715, 164.489539749); /* The Fallback */
  background: rgba(114.2845188285, 226.7154811715, 164.489539749, 0.6);
}

.success.lighten-3 {
  color: rgb(93.0523012552, 222.4476987448, 150.8326359833) !important;
}

.bg-success.bg-lighten-3 {
  background-color: rgb(93.0523012552, 222.4476987448, 150.8326359833) !important;
}

.btn-success.btn-lighten-3 {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: rgb(93.0523012552, 222.4476987448, 150.8326359833) !important;
}
.btn-success.btn-lighten-3:hover {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
}
.btn-success.btn-lighten-3:focus, .btn-success.btn-lighten-3:active {
  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;
}

.btn-outline-success.btn-outline-lighten-3 {
  border-color: rgb(93.0523012552, 222.4476987448, 150.8326359833) !important;
  color: rgb(93.0523012552, 222.4476987448, 150.8326359833) !important;
}
.btn-outline-success.btn-outline-lighten-3:hover {
  background-color: rgb(93.0523012552, 222.4476987448, 150.8326359833) !important;
}

input:focus ~ .bg-success {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(93.0523012552, 222.4476987448, 150.8326359833) !important;
}

.border-success.border-lighten-3 {
  border: 1px solid rgb(93.0523012552, 222.4476987448, 150.8326359833) !important;
}

.border-top-success.border-top-lighten-3 {
  border-top: 1px solid rgb(93.0523012552, 222.4476987448, 150.8326359833) !important;
}

.border-bottom-success.border-bottom-lighten-3 {
  border-bottom: 1px solid rgb(93.0523012552, 222.4476987448, 150.8326359833) !important;
}

.border-left-success.border-left-lighten-3 {
  border-left: 1px solid rgb(93.0523012552, 222.4476987448, 150.8326359833) !important;
}

.border-right-success.border-right-lighten-3 {
  border-right: 1px solid rgb(93.0523012552, 222.4476987448, 150.8326359833) !important;
}

.overlay-success.overlay-lighten-3 {
  background: rgb(93.0523012552, 222.4476987448, 150.8326359833); /* The Fallback */
  background: rgba(93.0523012552, 222.4476987448, 150.8326359833, 0.6);
}

.success.lighten-2 {
  color: rgb(71.820083682, 218.179916318, 137.1757322176) !important;
}

.bg-success.bg-lighten-2 {
  background-color: rgb(71.820083682, 218.179916318, 137.1757322176) !important;
}

.btn-success.btn-lighten-2 {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: rgb(71.820083682, 218.179916318, 137.1757322176) !important;
}
.btn-success.btn-lighten-2:hover {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
}
.btn-success.btn-lighten-2:focus, .btn-success.btn-lighten-2:active {
  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;
}

.btn-outline-success.btn-outline-lighten-2 {
  border-color: rgb(71.820083682, 218.179916318, 137.1757322176) !important;
  color: rgb(71.820083682, 218.179916318, 137.1757322176) !important;
}
.btn-outline-success.btn-outline-lighten-2:hover {
  background-color: rgb(71.820083682, 218.179916318, 137.1757322176) !important;
}

input:focus ~ .bg-success {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(71.820083682, 218.179916318, 137.1757322176) !important;
}

.border-success.border-lighten-2 {
  border: 1px solid rgb(71.820083682, 218.179916318, 137.1757322176) !important;
}

.border-top-success.border-top-lighten-2 {
  border-top: 1px solid rgb(71.820083682, 218.179916318, 137.1757322176) !important;
}

.border-bottom-success.border-bottom-lighten-2 {
  border-bottom: 1px solid rgb(71.820083682, 218.179916318, 137.1757322176) !important;
}

.border-left-success.border-left-lighten-2 {
  border-left: 1px solid rgb(71.820083682, 218.179916318, 137.1757322176) !important;
}

.border-right-success.border-right-lighten-2 {
  border-right: 1px solid rgb(71.820083682, 218.179916318, 137.1757322176) !important;
}

.overlay-success.overlay-lighten-2 {
  background: rgb(71.820083682, 218.179916318, 137.1757322176); /* The Fallback */
  background: rgba(71.820083682, 218.179916318, 137.1757322176, 0.6);
}

.success.lighten-1 {
  color: rgb(50.5878661088, 213.9121338912, 123.5188284519) !important;
}

.bg-success.bg-lighten-1 {
  background-color: rgb(50.5878661088, 213.9121338912, 123.5188284519) !important;
}

.btn-success.btn-lighten-1 {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: rgb(50.5878661088, 213.9121338912, 123.5188284519) !important;
}
.btn-success.btn-lighten-1:hover {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
}
.btn-success.btn-lighten-1:focus, .btn-success.btn-lighten-1:active {
  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;
}

.btn-outline-success.btn-outline-lighten-1 {
  border-color: rgb(50.5878661088, 213.9121338912, 123.5188284519) !important;
  color: rgb(50.5878661088, 213.9121338912, 123.5188284519) !important;
}
.btn-outline-success.btn-outline-lighten-1:hover {
  background-color: rgb(50.5878661088, 213.9121338912, 123.5188284519) !important;
}

input:focus ~ .bg-success {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(50.5878661088, 213.9121338912, 123.5188284519) !important;
}

.border-success.border-lighten-1 {
  border: 1px solid rgb(50.5878661088, 213.9121338912, 123.5188284519) !important;
}

.border-top-success.border-top-lighten-1 {
  border-top: 1px solid rgb(50.5878661088, 213.9121338912, 123.5188284519) !important;
}

.border-bottom-success.border-bottom-lighten-1 {
  border-bottom: 1px solid rgb(50.5878661088, 213.9121338912, 123.5188284519) !important;
}

.border-left-success.border-left-lighten-1 {
  border-left: 1px solid rgb(50.5878661088, 213.9121338912, 123.5188284519) !important;
}

.border-right-success.border-right-lighten-1 {
  border-right: 1px solid rgb(50.5878661088, 213.9121338912, 123.5188284519) !important;
}

.overlay-success.overlay-lighten-1 {
  background: rgb(50.5878661088, 213.9121338912, 123.5188284519); /* The Fallback */
  background: rgba(50.5878661088, 213.9121338912, 123.5188284519, 0.6);
}

.success {
  color: #28c76f !important;
}

.bg-success {
  background-color: #28c76f !important;
}
.bg-success .card-header,
.bg-success .card-footer {
  background-color: transparent;
}

.alert-success {
  background: rgba(40, 199, 111, 0.2) !important;
  color: #28c76f !important;
}
.alert-success .alert-heading {
  box-shadow: rgba(40, 199, 111, 0.4) 0px 6px 15px -7px;
}
.alert-success .alert-link {
  color: rgb(35.7322175732, 177.7677824268, 99.1569037657) !important;
}

.bg-rgba-success {
  background: rgba(40, 199, 111, 0.15) !important;
}

.border-success {
  border: 1px solid #28c76f !important;
}

.border-top-success {
  border-top: 1px solid #28c76f;
}

.border-bottom-success {
  border-bottom: 1px solid #28c76f;
}

.border-left-success {
  border-left: 1px solid #28c76f;
}

.border-right-success {
  border-right: 1px solid #28c76f;
}

.badge.badge-light-success {
  background-color: rgb(199.2133891213, 243.7866108787, 219.1171548117);
  color: #28c76f !important;
  font-weight: 500;
  text-transform: uppercase;
}

.bg-success.badge-glow,
.border-success.badge-glow,
.badge-success.badge-glow {
  box-shadow: 0px 0px 10px #28c76f;
}

.overlay-success {
  background: #28c76f; /* The Fallback */
  background: rgba(40, 199, 111, 0.6);
}

.btn-success {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: #28c76f !important;
  color: #fff;
}
.btn-success:hover {
  border-color: rgb(35.7322175732, 177.7677824268, 99.1569037657) !important;
  color: #fff !important;
  box-shadow: 0 8px 25px -8px #28c76f;
}
.btn-success:focus, .btn-success:active {
  color: #fff !important;
}

.btn-flat-success {
  background-color: transparent;
  color: #28c76f;
}
.btn-flat-success:hover {
  color: #28c76f;
  background-color: rgba(40, 199, 111, 0.1);
}
.btn-flat-success:active, .btn-flat-success:focus {
  background-color: #28c76f;
  color: #fff !important;
}

.btn-relief-success {
  background-color: #28c76f;
  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.2);
  color: #fff;
}
.btn-relief-success:hover {
  color: #fff;
}
.btn-relief-success:active, .btn-relief-success:focus {
  outline: none;
  transform: translateY(3px);
}

.btn-outline-success {
  border: 1px solid #28c76f;
  background-color: transparent;
  color: #28c76f;
}
.btn-outline-success:hover {
  background-color: rgba(40, 199, 111, 0.08);
  color: #28c76f;
}
.btn-outline-success:active {
  color: #fff !important;
}

.btn-success ~ .dropdown-menu .dropdown-item.active,
.btn-outline-success ~ .dropdown-menu .dropdown-item.active,
.btn-flat-success ~ .dropdown-menu .dropdown-item.active {
  background-color: #28c76f;
  color: #fff;
}
.btn-success ~ .dropdown-menu .dropdown-item.active:hover,
.btn-outline-success ~ .dropdown-menu .dropdown-item.active:hover,
.btn-flat-success ~ .dropdown-menu .dropdown-item.active:hover {
  color: #fff;
}
.btn-success ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,
.btn-outline-success ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,
.btn-flat-success ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover {
  color: #28c76f;
}

.bullet.bullet-success {
  background-color: #28c76f;
}
.bullet.bullet-success.bullet-bordered {
  background-color: transparent;
  border: 2px solid #28c76f;
}

.pagination-success li.active a,
.pagination-success li.active .page-link,
.pagination-success .page-item.active a,
.pagination-success .page-item.active .page-link {
  background: #28c76f !important;
  color: #fff;
}
.pagination-success li.active a:hover,
.pagination-success li.active .page-link:hover,
.pagination-success .page-item.active a:hover,
.pagination-success .page-item.active .page-link:hover {
  color: #fff !important;
}
.pagination-success li a:hover,
.pagination-success li .page-link:hover,
.pagination-success .page-item a:hover,
.pagination-success .page-item .page-link:hover {
  color: #28c76f !important;
}
.pagination-success li.prev-item .page-link:hover, .pagination-success li.next-item .page-link:hover,
.pagination-success .page-item.prev-item .page-link:hover,
.pagination-success .page-item.next-item .page-link:hover {
  background: #28c76f;
  color: #fff;
}

.nav-pill-success .nav-item .nav-link.active {
  color: #fff;
  background-color: #28c76f;
}

.chip-success {
  background-color: #28c76f !important;
}
.chip-success .chip-body {
  color: #fff !important;
}

.divider.divider-success .divider-text:before, .divider.divider-success .divider-text:after {
  border-color: #28c76f !important;
}

input[type=checkbox].bg-success + .custom-control-label:before, input[type=radio].bg-success + .custom-control-label:before {
  background-color: #28c76f !important;
}

input:focus ~ .bg-success {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #28c76f !important;
}

.vx-checkbox-success input:checked ~ .vx-checkbox {
  border-color: #28c76f !important;
}
.vx-checkbox-success input:checked ~ .vx-checkbox .vx-checkbox--check {
  background-color: #28c76f !important;
}
.vx-checkbox-success input:active:checked + .vx-checkbox .vx-checkbox--check {
  background-color: #28c76f !important;
}

.vertical-layout .main-menu.theme-success .navbar-header .navbar-nav .brand-text {
  color: #28c76f;
}
.vertical-layout .main-menu.theme-success .navigation .nav-item.active a {
  background: linear-gradient(118deg, #28c76f, rgba(40, 199, 111, 0.7));
  box-shadow: 0 0 10px 1px rgba(40, 199, 111, 0.7) !important;
}
.vertical-layout .main-menu.theme-success .navigation .nav-item .menu-content li.active {
  background: linear-gradient(118deg, #28c76f, rgba(40, 199, 111, 0.7));
  box-shadow: 0 0 10px 1px rgba(40, 199, 111, 0.7) !important;
}

.horizontal-layout.theme-success .header-navbar .brand-text {
  color: #28c76f !important;
}
.horizontal-layout.theme-success .navbar-horizontal #main-menu-navigation .nav-item.active .nav-link {
  background: linear-gradient(118deg, #28c76f, rgba(40, 199, 111, 0.7));
  box-shadow: 0 0 10px 1px rgba(40, 199, 111, 0.7) !important;
}

.custom-switch-success .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #28c76f !important;
  color: #fff;
  transition: all 0.2s ease-out;
}

.color-radio.color-radio-success {
  border: 1px solid transparent;
}
.color-radio.color-radio-success.selected {
  border-color: #28c76f;
}
.color-radio.color-radio-success .radio-content {
  background-color: #28c76f;
}

.vx-radio-success input:checked ~ .vx-radio .vx-radio--circle {
  background: #28c76f !important;
  box-shadow: 0 3px 12px 0 rgba(40, 199, 111, 0.4) !important;
}

.success.darken-1 {
  color: rgb(35.7322175732, 177.7677824268, 99.1569037657) !important;
}

.bg-success.bg-darken-1 {
  background-color: rgb(35.7322175732, 177.7677824268, 99.1569037657) !important;
}

.btn-success.btn-darken-1 {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: rgb(35.7322175732, 177.7677824268, 99.1569037657) !important;
}
.btn-success.btn-darken-1:hover {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
}
.btn-success.btn-darken-1:focus, .btn-success.btn-darken-1:active {
  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;
}

.btn-outline-success.btn-outline-darken-1 {
  border-color: rgb(35.7322175732, 177.7677824268, 99.1569037657) !important;
  color: rgb(35.7322175732, 177.7677824268, 99.1569037657) !important;
}
.btn-outline-success.btn-outline-darken-1:hover {
  background-color: rgb(35.7322175732, 177.7677824268, 99.1569037657) !important;
}

input:focus ~ .bg-success {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(35.7322175732, 177.7677824268, 99.1569037657) !important;
}

.border-success.border-darken-1 {
  border: 1px solid rgb(35.7322175732, 177.7677824268, 99.1569037657) !important;
}

.border-top-success.border-top-darken-1 {
  border-top: 1px solid rgb(35.7322175732, 177.7677824268, 99.1569037657) !important;
}

.border-bottom-success.border-bottom-darken-1 {
  border-bottom: 1px solid rgb(35.7322175732, 177.7677824268, 99.1569037657) !important;
}

.border-left-success.border-left-darken-1 {
  border-left: 1px solid rgb(35.7322175732, 177.7677824268, 99.1569037657) !important;
}

.border-right-success.border-right-darken-1 {
  border-right: 1px solid rgb(35.7322175732, 177.7677824268, 99.1569037657) !important;
}

.overlay-success.overlay-darken-1 {
  background: rgb(35.7322175732, 177.7677824268, 99.1569037657); /* The Fallback */
  background: rgba(35.7322175732, 177.7677824268, 99.1569037657, 0.6);
}

.success.darken-2 {
  color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
}

.bg-success.bg-darken-2 {
  background-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
}

.btn-success.btn-darken-2 {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
}
.btn-success.btn-darken-2:hover {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
}
.btn-success.btn-darken-2:focus, .btn-success.btn-darken-2:active {
  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;
}

.btn-outline-success.btn-outline-darken-2 {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
}
.btn-outline-success.btn-outline-darken-2:hover {
  background-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
}

input:focus ~ .bg-success {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
}

.border-success.border-darken-2 {
  border: 1px solid rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
}

.border-top-success.border-top-darken-2 {
  border-top: 1px solid rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
}

.border-bottom-success.border-bottom-darken-2 {
  border-bottom: 1px solid rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
}

.border-left-success.border-left-darken-2 {
  border-left: 1px solid rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
}

.border-right-success.border-right-darken-2 {
  border-right: 1px solid rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
}

.overlay-success.overlay-darken-2 {
  background: rgb(31.4644351464, 156.5355648536, 87.3138075314); /* The Fallback */
  background: rgba(31.4644351464, 156.5355648536, 87.3138075314, 0.6);
}

.success.darken-3 {
  color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
}

.bg-success.bg-darken-3 {
  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
}

.btn-success.btn-darken-3 {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
}
.btn-success.btn-darken-3:hover {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
}
.btn-success.btn-darken-3:focus, .btn-success.btn-darken-3:active {
  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;
}

.btn-outline-success.btn-outline-darken-3 {
  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
  color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
}
.btn-outline-success.btn-outline-darken-3:hover {
  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
}

input:focus ~ .bg-success {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
}

.border-success.border-darken-3 {
  border: 1px solid rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
}

.border-top-success.border-top-darken-3 {
  border-top: 1px solid rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
}

.border-bottom-success.border-bottom-darken-3 {
  border-bottom: 1px solid rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
}

.border-left-success.border-left-darken-3 {
  border-left: 1px solid rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
}

.border-right-success.border-right-darken-3 {
  border-right: 1px solid rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
}

.overlay-success.overlay-darken-3 {
  background: rgb(27.1966527197, 135.3033472803, 75.4707112971); /* The Fallback */
  background: rgba(27.1966527197, 135.3033472803, 75.4707112971, 0.6);
}

.success.darken-4 {
  color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;
}

.bg-success.bg-darken-4 {
  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;
}

.btn-success.btn-darken-4 {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;
}
.btn-success.btn-darken-4:hover {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
}
.btn-success.btn-darken-4:focus, .btn-success.btn-darken-4:active {
  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;
}

.btn-outline-success.btn-outline-darken-4 {
  border-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;
  color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;
}
.btn-outline-success.btn-outline-darken-4:hover {
  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;
}

input:focus ~ .bg-success {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;
}

.border-success.border-darken-4 {
  border: 1px solid rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;
}

.border-top-success.border-top-darken-4 {
  border-top: 1px solid rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;
}

.border-bottom-success.border-bottom-darken-4 {
  border-bottom: 1px solid rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;
}

.border-left-success.border-left-darken-4 {
  border-left: 1px solid rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;
}

.border-right-success.border-right-darken-4 {
  border-right: 1px solid rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;
}

.overlay-success.overlay-darken-4 {
  background: rgb(22.9288702929, 114.0711297071, 63.6276150628); /* The Fallback */
  background: rgba(22.9288702929, 114.0711297071, 63.6276150628, 0.6);
}

.success.accent-1 {
  color: #e1fff1 !important;
}

.bg-success.bg-accent-1 {
  background-color: #e1fff1 !important;
}

.btn-success.btn-accent-1 {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: #e1fff1 !important;
}
.btn-success.btn-accent-1:hover {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
}
.btn-success.btn-accent-1:focus, .btn-success.btn-accent-1:active {
  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;
}

.btn-outline-success.btn-outline-accent-1 {
  border-color: #e1fff1 !important;
  color: #e1fff1 !important;
}
.btn-outline-success.btn-outline-accent-1:hover {
  background-color: #e1fff1 !important;
}

input:focus ~ .bg-success {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #e1fff1 !important;
}

.border-success.border-accent-1 {
  border: 1px solid #e1fff1 !important;
}

.border-top-success.border-top-accent-1 {
  border-top: 1px solid #e1fff1 !important;
}

.border-bottom-success.border-bottom-accent-1 {
  border-bottom: 1px solid #e1fff1 !important;
}

.border-left-success.border-left-accent-1 {
  border-left: 1px solid #e1fff1 !important;
}

.border-right-success.border-right-accent-1 {
  border-right: 1px solid #e1fff1 !important;
}

.overlay-success.overlay-accent-1 {
  background: #e1fff1; /* The Fallback */
  background: rgba(225, 255, 241, 0.6);
}

.success.accent-2 {
  color: #aeffd9 !important;
}

.bg-success.bg-accent-2 {
  background-color: #aeffd9 !important;
}

.btn-success.btn-accent-2 {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: #aeffd9 !important;
}
.btn-success.btn-accent-2:hover {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
}
.btn-success.btn-accent-2:focus, .btn-success.btn-accent-2:active {
  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;
}

.btn-outline-success.btn-outline-accent-2 {
  border-color: #aeffd9 !important;
  color: #aeffd9 !important;
}
.btn-outline-success.btn-outline-accent-2:hover {
  background-color: #aeffd9 !important;
}

input:focus ~ .bg-success {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #aeffd9 !important;
}

.border-success.border-accent-2 {
  border: 1px solid #aeffd9 !important;
}

.border-top-success.border-top-accent-2 {
  border-top: 1px solid #aeffd9 !important;
}

.border-bottom-success.border-bottom-accent-2 {
  border-bottom: 1px solid #aeffd9 !important;
}

.border-left-success.border-left-accent-2 {
  border-left: 1px solid #aeffd9 !important;
}

.border-right-success.border-right-accent-2 {
  border-right: 1px solid #aeffd9 !important;
}

.overlay-success.overlay-accent-2 {
  background: #aeffd9; /* The Fallback */
  background: rgba(174, 255, 217, 0.6);
}

.success.accent-3 {
  color: #7bffc1 !important;
}

.bg-success.bg-accent-3 {
  background-color: #7bffc1 !important;
}

.btn-success.btn-accent-3 {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: #7bffc1 !important;
}
.btn-success.btn-accent-3:hover {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
}
.btn-success.btn-accent-3:focus, .btn-success.btn-accent-3:active {
  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;
}

.btn-outline-success.btn-outline-accent-3 {
  border-color: #7bffc1 !important;
  color: #7bffc1 !important;
}
.btn-outline-success.btn-outline-accent-3:hover {
  background-color: #7bffc1 !important;
}

input:focus ~ .bg-success {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #7bffc1 !important;
}

.border-success.border-accent-3 {
  border: 1px solid #7bffc1 !important;
}

.border-top-success.border-top-accent-3 {
  border-top: 1px solid #7bffc1 !important;
}

.border-bottom-success.border-bottom-accent-3 {
  border-bottom: 1px solid #7bffc1 !important;
}

.border-left-success.border-left-accent-3 {
  border-left: 1px solid #7bffc1 !important;
}

.border-right-success.border-right-accent-3 {
  border-right: 1px solid #7bffc1 !important;
}

.overlay-success.overlay-accent-3 {
  background: #7bffc1; /* The Fallback */
  background: rgba(123, 255, 193, 0.6);
}

.success.accent-4 {
  color: #62ffb5 !important;
}

.bg-success.bg-accent-4 {
  background-color: #62ffb5 !important;
}

.btn-success.btn-accent-4 {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: #62ffb5 !important;
}
.btn-success.btn-accent-4:hover {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
}
.btn-success.btn-accent-4:focus, .btn-success.btn-accent-4:active {
  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;
}

.btn-outline-success.btn-outline-accent-4 {
  border-color: #62ffb5 !important;
  color: #62ffb5 !important;
}
.btn-outline-success.btn-outline-accent-4:hover {
  background-color: #62ffb5 !important;
}

input:focus ~ .bg-success {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #62ffb5 !important;
}

.border-success.border-accent-4 {
  border: 1px solid #62ffb5 !important;
}

.border-top-success.border-top-accent-4 {
  border-top: 1px solid #62ffb5 !important;
}

.border-bottom-success.border-bottom-accent-4 {
  border-bottom: 1px solid #62ffb5 !important;
}

.border-left-success.border-left-accent-4 {
  border-left: 1px solid #62ffb5 !important;
}

.border-right-success.border-right-accent-4 {
  border-right: 1px solid #62ffb5 !important;
}

.overlay-success.overlay-accent-4 {
  background: #62ffb5; /* The Fallback */
  background: rgba(98, 255, 181, 0.6);
}

.success.gradient-bg {
  color: #0064fa !important;
}

.bg-success.bg-gradient-bg {
  background-color: #0064fa !important;
}

.btn-success.btn-gradient-bg {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: #0064fa !important;
}
.btn-success.btn-gradient-bg:hover {
  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;
  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
}
.btn-success.btn-gradient-bg:focus, .btn-success.btn-gradient-bg:active {
  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;
  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;
}

.btn-outline-success.btn-outline-gradient-bg {
  border-color: #0064fa !important;
  color: #0064fa !important;
}
.btn-outline-success.btn-outline-gradient-bg:hover {
  background-color: #0064fa !important;
}

input:focus ~ .bg-success {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #0064fa !important;
}

.border-success.border-gradient-bg {
  border: 1px solid #0064fa !important;
}

.border-top-success.border-top-gradient-bg {
  border-top: 1px solid #0064fa !important;
}

.border-bottom-success.border-bottom-gradient-bg {
  border-bottom: 1px solid #0064fa !important;
}

.border-left-success.border-left-gradient-bg {
  border-left: 1px solid #0064fa !important;
}

.border-right-success.border-right-gradient-bg {
  border-right: 1px solid #0064fa !important;
}

.overlay-success.overlay-gradient-bg {
  background: #0064fa; /* The Fallback */
  background: rgba(0, 100, 250, 0.6);
}

.info.gradient-light {
  color: rgb(44.983, 144.8617744253, 255) !important;
}

.bg-info.bg-gradient-light {
  background-color: rgb(44.983, 144.8617744253, 255) !important;
}

.btn-info.btn-gradient-light {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: rgb(44.983, 144.8617744253, 255) !important;
}
.btn-info.btn-gradient-light:hover {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: rgb(0, 138.7435344828, 155.5) !important;
}
.btn-info.btn-gradient-light:focus, .btn-info.btn-gradient-light:active {
  border-color: rgb(0, 138.7435344828, 155.5) !important;
  background-color: rgb(0, 115.9913793103, 130) !important;
}

.btn-outline-info.btn-outline-gradient-light {
  border-color: rgb(44.983, 144.8617744253, 255) !important;
  color: rgb(44.983, 144.8617744253, 255) !important;
}
.btn-outline-info.btn-outline-gradient-light:hover {
  background-color: rgb(44.983, 144.8617744253, 255) !important;
}

input:focus ~ .bg-info {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(44.983, 144.8617744253, 255) !important;
}

.border-info.border-gradient-light {
  border: 1px solid rgb(44.983, 144.8617744253, 255) !important;
}

.border-top-info.border-top-gradient-light {
  border-top: 1px solid rgb(44.983, 144.8617744253, 255) !important;
}

.border-bottom-info.border-bottom-gradient-light {
  border-bottom: 1px solid rgb(44.983, 144.8617744253, 255) !important;
}

.border-left-info.border-left-gradient-light {
  border-left: 1px solid rgb(44.983, 144.8617744253, 255) !important;
}

.border-right-info.border-right-gradient-light {
  border-right: 1px solid rgb(44.983, 144.8617744253, 255) !important;
}

.overlay-info.overlay-gradient-light {
  background: rgb(44.983, 144.8617744253, 255); /* The Fallback */
  background: rgba(44.983, 144.8617744253, 255, 0.6);
}

.info.light-badge {
  color: rgb(181, 247.025862069, 255) !important;
}

.bg-info.bg-light-badge {
  background-color: rgb(181, 247.025862069, 255) !important;
}

.btn-info.btn-light-badge {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: rgb(181, 247.025862069, 255) !important;
}
.btn-info.btn-light-badge:hover {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: rgb(0, 138.7435344828, 155.5) !important;
}
.btn-info.btn-light-badge:focus, .btn-info.btn-light-badge:active {
  border-color: rgb(0, 138.7435344828, 155.5) !important;
  background-color: rgb(0, 115.9913793103, 130) !important;
}

.btn-outline-info.btn-outline-light-badge {
  border-color: rgb(181, 247.025862069, 255) !important;
  color: rgb(181, 247.025862069, 255) !important;
}
.btn-outline-info.btn-outline-light-badge:hover {
  background-color: rgb(181, 247.025862069, 255) !important;
}

input:focus ~ .bg-info {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(181, 247.025862069, 255) !important;
}

.border-info.border-light-badge {
  border: 1px solid rgb(181, 247.025862069, 255) !important;
}

.border-top-info.border-top-light-badge {
  border-top: 1px solid rgb(181, 247.025862069, 255) !important;
}

.border-bottom-info.border-bottom-light-badge {
  border-bottom: 1px solid rgb(181, 247.025862069, 255) !important;
}

.border-left-info.border-left-light-badge {
  border-left: 1px solid rgb(181, 247.025862069, 255) !important;
}

.border-right-info.border-right-light-badge {
  border-right: 1px solid rgb(181, 247.025862069, 255) !important;
}

.overlay-info.overlay-light-badge {
  background: rgb(181, 247.025862069, 255); /* The Fallback */
  background: rgba(181, 247.025862069, 255, 0.6);
}

.info.lighten-5 {
  color: rgb(104.5, 238.7823275862, 255) !important;
}

.bg-info.bg-lighten-5 {
  background-color: rgb(104.5, 238.7823275862, 255) !important;
}

.btn-info.btn-lighten-5 {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: rgb(104.5, 238.7823275862, 255) !important;
}
.btn-info.btn-lighten-5:hover {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: rgb(0, 138.7435344828, 155.5) !important;
}
.btn-info.btn-lighten-5:focus, .btn-info.btn-lighten-5:active {
  border-color: rgb(0, 138.7435344828, 155.5) !important;
  background-color: rgb(0, 115.9913793103, 130) !important;
}

.btn-outline-info.btn-outline-lighten-5 {
  border-color: rgb(104.5, 238.7823275862, 255) !important;
  color: rgb(104.5, 238.7823275862, 255) !important;
}
.btn-outline-info.btn-outline-lighten-5:hover {
  background-color: rgb(104.5, 238.7823275862, 255) !important;
}

input:focus ~ .bg-info {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(104.5, 238.7823275862, 255) !important;
}

.border-info.border-lighten-5 {
  border: 1px solid rgb(104.5, 238.7823275862, 255) !important;
}

.border-top-info.border-top-lighten-5 {
  border-top: 1px solid rgb(104.5, 238.7823275862, 255) !important;
}

.border-bottom-info.border-bottom-lighten-5 {
  border-bottom: 1px solid rgb(104.5, 238.7823275862, 255) !important;
}

.border-left-info.border-left-lighten-5 {
  border-left: 1px solid rgb(104.5, 238.7823275862, 255) !important;
}

.border-right-info.border-right-lighten-5 {
  border-right: 1px solid rgb(104.5, 238.7823275862, 255) !important;
}

.overlay-info.overlay-lighten-5 {
  background: rgb(104.5, 238.7823275862, 255); /* The Fallback */
  background: rgba(104.5, 238.7823275862, 255, 0.6);
}

.info.lighten-4 {
  color: rgb(79, 236.0344827586, 255) !important;
}

.bg-info.bg-lighten-4 {
  background-color: rgb(79, 236.0344827586, 255) !important;
}

.btn-info.btn-lighten-4 {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: rgb(79, 236.0344827586, 255) !important;
}
.btn-info.btn-lighten-4:hover {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: rgb(0, 138.7435344828, 155.5) !important;
}
.btn-info.btn-lighten-4:focus, .btn-info.btn-lighten-4:active {
  border-color: rgb(0, 138.7435344828, 155.5) !important;
  background-color: rgb(0, 115.9913793103, 130) !important;
}

.btn-outline-info.btn-outline-lighten-4 {
  border-color: rgb(79, 236.0344827586, 255) !important;
  color: rgb(79, 236.0344827586, 255) !important;
}
.btn-outline-info.btn-outline-lighten-4:hover {
  background-color: rgb(79, 236.0344827586, 255) !important;
}

input:focus ~ .bg-info {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(79, 236.0344827586, 255) !important;
}

.border-info.border-lighten-4 {
  border: 1px solid rgb(79, 236.0344827586, 255) !important;
}

.border-top-info.border-top-lighten-4 {
  border-top: 1px solid rgb(79, 236.0344827586, 255) !important;
}

.border-bottom-info.border-bottom-lighten-4 {
  border-bottom: 1px solid rgb(79, 236.0344827586, 255) !important;
}

.border-left-info.border-left-lighten-4 {
  border-left: 1px solid rgb(79, 236.0344827586, 255) !important;
}

.border-right-info.border-right-lighten-4 {
  border-right: 1px solid rgb(79, 236.0344827586, 255) !important;
}

.overlay-info.overlay-lighten-4 {
  background: rgb(79, 236.0344827586, 255); /* The Fallback */
  background: rgba(79, 236.0344827586, 255, 0.6);
}

.info.lighten-3 {
  color: rgb(53.5, 233.286637931, 255) !important;
}

.bg-info.bg-lighten-3 {
  background-color: rgb(53.5, 233.286637931, 255) !important;
}

.btn-info.btn-lighten-3 {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: rgb(53.5, 233.286637931, 255) !important;
}
.btn-info.btn-lighten-3:hover {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: rgb(0, 138.7435344828, 155.5) !important;
}
.btn-info.btn-lighten-3:focus, .btn-info.btn-lighten-3:active {
  border-color: rgb(0, 138.7435344828, 155.5) !important;
  background-color: rgb(0, 115.9913793103, 130) !important;
}

.btn-outline-info.btn-outline-lighten-3 {
  border-color: rgb(53.5, 233.286637931, 255) !important;
  color: rgb(53.5, 233.286637931, 255) !important;
}
.btn-outline-info.btn-outline-lighten-3:hover {
  background-color: rgb(53.5, 233.286637931, 255) !important;
}

input:focus ~ .bg-info {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(53.5, 233.286637931, 255) !important;
}

.border-info.border-lighten-3 {
  border: 1px solid rgb(53.5, 233.286637931, 255) !important;
}

.border-top-info.border-top-lighten-3 {
  border-top: 1px solid rgb(53.5, 233.286637931, 255) !important;
}

.border-bottom-info.border-bottom-lighten-3 {
  border-bottom: 1px solid rgb(53.5, 233.286637931, 255) !important;
}

.border-left-info.border-left-lighten-3 {
  border-left: 1px solid rgb(53.5, 233.286637931, 255) !important;
}

.border-right-info.border-right-lighten-3 {
  border-right: 1px solid rgb(53.5, 233.286637931, 255) !important;
}

.overlay-info.overlay-lighten-3 {
  background: rgb(53.5, 233.286637931, 255); /* The Fallback */
  background: rgba(53.5, 233.286637931, 255, 0.6);
}

.info.lighten-2 {
  color: rgb(28, 230.5387931034, 255) !important;
}

.bg-info.bg-lighten-2 {
  background-color: rgb(28, 230.5387931034, 255) !important;
}

.btn-info.btn-lighten-2 {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: rgb(28, 230.5387931034, 255) !important;
}
.btn-info.btn-lighten-2:hover {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: rgb(0, 138.7435344828, 155.5) !important;
}
.btn-info.btn-lighten-2:focus, .btn-info.btn-lighten-2:active {
  border-color: rgb(0, 138.7435344828, 155.5) !important;
  background-color: rgb(0, 115.9913793103, 130) !important;
}

.btn-outline-info.btn-outline-lighten-2 {
  border-color: rgb(28, 230.5387931034, 255) !important;
  color: rgb(28, 230.5387931034, 255) !important;
}
.btn-outline-info.btn-outline-lighten-2:hover {
  background-color: rgb(28, 230.5387931034, 255) !important;
}

input:focus ~ .bg-info {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(28, 230.5387931034, 255) !important;
}

.border-info.border-lighten-2 {
  border: 1px solid rgb(28, 230.5387931034, 255) !important;
}

.border-top-info.border-top-lighten-2 {
  border-top: 1px solid rgb(28, 230.5387931034, 255) !important;
}

.border-bottom-info.border-bottom-lighten-2 {
  border-bottom: 1px solid rgb(28, 230.5387931034, 255) !important;
}

.border-left-info.border-left-lighten-2 {
  border-left: 1px solid rgb(28, 230.5387931034, 255) !important;
}

.border-right-info.border-right-lighten-2 {
  border-right: 1px solid rgb(28, 230.5387931034, 255) !important;
}

.overlay-info.overlay-lighten-2 {
  background: rgb(28, 230.5387931034, 255); /* The Fallback */
  background: rgba(28, 230.5387931034, 255, 0.6);
}

.info.lighten-1 {
  color: rgb(2.5, 227.7909482759, 255) !important;
}

.bg-info.bg-lighten-1 {
  background-color: rgb(2.5, 227.7909482759, 255) !important;
}

.btn-info.btn-lighten-1 {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: rgb(2.5, 227.7909482759, 255) !important;
}
.btn-info.btn-lighten-1:hover {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: rgb(0, 138.7435344828, 155.5) !important;
}
.btn-info.btn-lighten-1:focus, .btn-info.btn-lighten-1:active {
  border-color: rgb(0, 138.7435344828, 155.5) !important;
  background-color: rgb(0, 115.9913793103, 130) !important;
}

.btn-outline-info.btn-outline-lighten-1 {
  border-color: rgb(2.5, 227.7909482759, 255) !important;
  color: rgb(2.5, 227.7909482759, 255) !important;
}
.btn-outline-info.btn-outline-lighten-1:hover {
  background-color: rgb(2.5, 227.7909482759, 255) !important;
}

input:focus ~ .bg-info {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(2.5, 227.7909482759, 255) !important;
}

.border-info.border-lighten-1 {
  border: 1px solid rgb(2.5, 227.7909482759, 255) !important;
}

.border-top-info.border-top-lighten-1 {
  border-top: 1px solid rgb(2.5, 227.7909482759, 255) !important;
}

.border-bottom-info.border-bottom-lighten-1 {
  border-bottom: 1px solid rgb(2.5, 227.7909482759, 255) !important;
}

.border-left-info.border-left-lighten-1 {
  border-left: 1px solid rgb(2.5, 227.7909482759, 255) !important;
}

.border-right-info.border-right-lighten-1 {
  border-right: 1px solid rgb(2.5, 227.7909482759, 255) !important;
}

.overlay-info.overlay-lighten-1 {
  background: rgb(2.5, 227.7909482759, 255); /* The Fallback */
  background: rgba(2.5, 227.7909482759, 255, 0.6);
}

.info {
  color: #00cfe8 !important;
}

.bg-info {
  background-color: #00cfe8 !important;
}
.bg-info .card-header,
.bg-info .card-footer {
  background-color: transparent;
}

.alert-info {
  background: rgba(0, 207, 232, 0.2) !important;
  color: #00cfe8 !important;
}
.alert-info .alert-heading {
  box-shadow: rgba(0, 207, 232, 0.4) 0px 6px 15px -7px;
}
.alert-info .alert-link {
  color: rgb(0, 184.2478448276, 206.5) !important;
}

.bg-rgba-info {
  background: rgba(0, 207, 232, 0.15) !important;
}

.border-info {
  border: 1px solid #00cfe8 !important;
}

.border-top-info {
  border-top: 1px solid #00cfe8;
}

.border-bottom-info {
  border-bottom: 1px solid #00cfe8;
}

.border-left-info {
  border-left: 1px solid #00cfe8;
}

.border-right-info {
  border-right: 1px solid #00cfe8;
}

.badge.badge-light-info {
  background-color: rgb(181, 247.025862069, 255);
  color: #00cfe8 !important;
  font-weight: 500;
  text-transform: uppercase;
}

.bg-info.badge-glow,
.border-info.badge-glow,
.badge-info.badge-glow {
  box-shadow: 0px 0px 10px #00cfe8;
}

.overlay-info {
  background: #00cfe8; /* The Fallback */
  background: rgba(0, 207, 232, 0.6);
}

.btn-info {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: #00cfe8 !important;
  color: #fff;
}
.btn-info:hover {
  border-color: rgb(0, 184.2478448276, 206.5) !important;
  color: #fff !important;
  box-shadow: 0 8px 25px -8px #00cfe8;
}
.btn-info:focus, .btn-info:active {
  color: #fff !important;
}

.btn-flat-info {
  background-color: transparent;
  color: #00cfe8;
}
.btn-flat-info:hover {
  color: #00cfe8;
  background-color: rgba(0, 207, 232, 0.1);
}
.btn-flat-info:active, .btn-flat-info:focus {
  background-color: #00cfe8;
  color: #fff !important;
}

.btn-relief-info {
  background-color: #00cfe8;
  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.2);
  color: #fff;
}
.btn-relief-info:hover {
  color: #fff;
}
.btn-relief-info:active, .btn-relief-info:focus {
  outline: none;
  transform: translateY(3px);
}

.btn-outline-info {
  border: 1px solid #00cfe8;
  background-color: transparent;
  color: #00cfe8;
}
.btn-outline-info:hover {
  background-color: rgba(0, 207, 232, 0.08);
  color: #00cfe8;
}
.btn-outline-info:active {
  color: #fff !important;
}

.btn-info ~ .dropdown-menu .dropdown-item.active,
.btn-outline-info ~ .dropdown-menu .dropdown-item.active,
.btn-flat-info ~ .dropdown-menu .dropdown-item.active {
  background-color: #00cfe8;
  color: #fff;
}
.btn-info ~ .dropdown-menu .dropdown-item.active:hover,
.btn-outline-info ~ .dropdown-menu .dropdown-item.active:hover,
.btn-flat-info ~ .dropdown-menu .dropdown-item.active:hover {
  color: #fff;
}
.btn-info ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,
.btn-outline-info ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,
.btn-flat-info ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover {
  color: #00cfe8;
}

.bullet.bullet-info {
  background-color: #00cfe8;
}
.bullet.bullet-info.bullet-bordered {
  background-color: transparent;
  border: 2px solid #00cfe8;
}

.pagination-info li.active a,
.pagination-info li.active .page-link,
.pagination-info .page-item.active a,
.pagination-info .page-item.active .page-link {
  background: #00cfe8 !important;
  color: #fff;
}
.pagination-info li.active a:hover,
.pagination-info li.active .page-link:hover,
.pagination-info .page-item.active a:hover,
.pagination-info .page-item.active .page-link:hover {
  color: #fff !important;
}
.pagination-info li a:hover,
.pagination-info li .page-link:hover,
.pagination-info .page-item a:hover,
.pagination-info .page-item .page-link:hover {
  color: #00cfe8 !important;
}
.pagination-info li.prev-item .page-link:hover, .pagination-info li.next-item .page-link:hover,
.pagination-info .page-item.prev-item .page-link:hover,
.pagination-info .page-item.next-item .page-link:hover {
  background: #00cfe8;
  color: #fff;
}

.nav-pill-info .nav-item .nav-link.active {
  color: #fff;
  background-color: #00cfe8;
}

.chip-info {
  background-color: #00cfe8 !important;
}
.chip-info .chip-body {
  color: #fff !important;
}

.divider.divider-info .divider-text:before, .divider.divider-info .divider-text:after {
  border-color: #00cfe8 !important;
}

input[type=checkbox].bg-info + .custom-control-label:before, input[type=radio].bg-info + .custom-control-label:before {
  background-color: #00cfe8 !important;
}

input:focus ~ .bg-info {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #00cfe8 !important;
}

.vx-checkbox-info input:checked ~ .vx-checkbox {
  border-color: #00cfe8 !important;
}
.vx-checkbox-info input:checked ~ .vx-checkbox .vx-checkbox--check {
  background-color: #00cfe8 !important;
}
.vx-checkbox-info input:active:checked + .vx-checkbox .vx-checkbox--check {
  background-color: #00cfe8 !important;
}

.vertical-layout .main-menu.theme-info .navbar-header .navbar-nav .brand-text {
  color: #00cfe8;
}
.vertical-layout .main-menu.theme-info .navigation .nav-item.active a {
  background: linear-gradient(118deg, #00cfe8, rgba(0, 207, 232, 0.7));
  box-shadow: 0 0 10px 1px rgba(0, 207, 232, 0.7) !important;
}
.vertical-layout .main-menu.theme-info .navigation .nav-item .menu-content li.active {
  background: linear-gradient(118deg, #00cfe8, rgba(0, 207, 232, 0.7));
  box-shadow: 0 0 10px 1px rgba(0, 207, 232, 0.7) !important;
}

.horizontal-layout.theme-info .header-navbar .brand-text {
  color: #00cfe8 !important;
}
.horizontal-layout.theme-info .navbar-horizontal #main-menu-navigation .nav-item.active .nav-link {
  background: linear-gradient(118deg, #00cfe8, rgba(0, 207, 232, 0.7));
  box-shadow: 0 0 10px 1px rgba(0, 207, 232, 0.7) !important;
}

.custom-switch-info .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #00cfe8 !important;
  color: #fff;
  transition: all 0.2s ease-out;
}

.color-radio.color-radio-info {
  border: 1px solid transparent;
}
.color-radio.color-radio-info.selected {
  border-color: #00cfe8;
}
.color-radio.color-radio-info .radio-content {
  background-color: #00cfe8;
}

.vx-radio-info input:checked ~ .vx-radio .vx-radio--circle {
  background: #00cfe8 !important;
  box-shadow: 0 3px 12px 0 rgba(0, 207, 232, 0.4) !important;
}

.info.darken-1 {
  color: rgb(0, 184.2478448276, 206.5) !important;
}

.bg-info.bg-darken-1 {
  background-color: rgb(0, 184.2478448276, 206.5) !important;
}

.btn-info.btn-darken-1 {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: rgb(0, 184.2478448276, 206.5) !important;
}
.btn-info.btn-darken-1:hover {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: rgb(0, 138.7435344828, 155.5) !important;
}
.btn-info.btn-darken-1:focus, .btn-info.btn-darken-1:active {
  border-color: rgb(0, 138.7435344828, 155.5) !important;
  background-color: rgb(0, 115.9913793103, 130) !important;
}

.btn-outline-info.btn-outline-darken-1 {
  border-color: rgb(0, 184.2478448276, 206.5) !important;
  color: rgb(0, 184.2478448276, 206.5) !important;
}
.btn-outline-info.btn-outline-darken-1:hover {
  background-color: rgb(0, 184.2478448276, 206.5) !important;
}

input:focus ~ .bg-info {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(0, 184.2478448276, 206.5) !important;
}

.border-info.border-darken-1 {
  border: 1px solid rgb(0, 184.2478448276, 206.5) !important;
}

.border-top-info.border-top-darken-1 {
  border-top: 1px solid rgb(0, 184.2478448276, 206.5) !important;
}

.border-bottom-info.border-bottom-darken-1 {
  border-bottom: 1px solid rgb(0, 184.2478448276, 206.5) !important;
}

.border-left-info.border-left-darken-1 {
  border-left: 1px solid rgb(0, 184.2478448276, 206.5) !important;
}

.border-right-info.border-right-darken-1 {
  border-right: 1px solid rgb(0, 184.2478448276, 206.5) !important;
}

.overlay-info.overlay-darken-1 {
  background: rgb(0, 184.2478448276, 206.5); /* The Fallback */
  background: rgba(0, 184.2478448276, 206.5, 0.6);
}

.info.darken-2 {
  color: rgb(0, 161.4956896552, 181) !important;
}

.bg-info.bg-darken-2 {
  background-color: rgb(0, 161.4956896552, 181) !important;
}

.btn-info.btn-darken-2 {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: rgb(0, 161.4956896552, 181) !important;
}
.btn-info.btn-darken-2:hover {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: rgb(0, 138.7435344828, 155.5) !important;
}
.btn-info.btn-darken-2:focus, .btn-info.btn-darken-2:active {
  border-color: rgb(0, 138.7435344828, 155.5) !important;
  background-color: rgb(0, 115.9913793103, 130) !important;
}

.btn-outline-info.btn-outline-darken-2 {
  border-color: rgb(0, 161.4956896552, 181) !important;
  color: rgb(0, 161.4956896552, 181) !important;
}
.btn-outline-info.btn-outline-darken-2:hover {
  background-color: rgb(0, 161.4956896552, 181) !important;
}

input:focus ~ .bg-info {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(0, 161.4956896552, 181) !important;
}

.border-info.border-darken-2 {
  border: 1px solid rgb(0, 161.4956896552, 181) !important;
}

.border-top-info.border-top-darken-2 {
  border-top: 1px solid rgb(0, 161.4956896552, 181) !important;
}

.border-bottom-info.border-bottom-darken-2 {
  border-bottom: 1px solid rgb(0, 161.4956896552, 181) !important;
}

.border-left-info.border-left-darken-2 {
  border-left: 1px solid rgb(0, 161.4956896552, 181) !important;
}

.border-right-info.border-right-darken-2 {
  border-right: 1px solid rgb(0, 161.4956896552, 181) !important;
}

.overlay-info.overlay-darken-2 {
  background: rgb(0, 161.4956896552, 181); /* The Fallback */
  background: rgba(0, 161.4956896552, 181, 0.6);
}

.info.darken-3 {
  color: rgb(0, 138.7435344828, 155.5) !important;
}

.bg-info.bg-darken-3 {
  background-color: rgb(0, 138.7435344828, 155.5) !important;
}

.btn-info.btn-darken-3 {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: rgb(0, 138.7435344828, 155.5) !important;
}
.btn-info.btn-darken-3:hover {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: rgb(0, 138.7435344828, 155.5) !important;
}
.btn-info.btn-darken-3:focus, .btn-info.btn-darken-3:active {
  border-color: rgb(0, 138.7435344828, 155.5) !important;
  background-color: rgb(0, 115.9913793103, 130) !important;
}

.btn-outline-info.btn-outline-darken-3 {
  border-color: rgb(0, 138.7435344828, 155.5) !important;
  color: rgb(0, 138.7435344828, 155.5) !important;
}
.btn-outline-info.btn-outline-darken-3:hover {
  background-color: rgb(0, 138.7435344828, 155.5) !important;
}

input:focus ~ .bg-info {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(0, 138.7435344828, 155.5) !important;
}

.border-info.border-darken-3 {
  border: 1px solid rgb(0, 138.7435344828, 155.5) !important;
}

.border-top-info.border-top-darken-3 {
  border-top: 1px solid rgb(0, 138.7435344828, 155.5) !important;
}

.border-bottom-info.border-bottom-darken-3 {
  border-bottom: 1px solid rgb(0, 138.7435344828, 155.5) !important;
}

.border-left-info.border-left-darken-3 {
  border-left: 1px solid rgb(0, 138.7435344828, 155.5) !important;
}

.border-right-info.border-right-darken-3 {
  border-right: 1px solid rgb(0, 138.7435344828, 155.5) !important;
}

.overlay-info.overlay-darken-3 {
  background: rgb(0, 138.7435344828, 155.5); /* The Fallback */
  background: rgba(0, 138.7435344828, 155.5, 0.6);
}

.info.darken-4 {
  color: rgb(0, 115.9913793103, 130) !important;
}

.bg-info.bg-darken-4 {
  background-color: rgb(0, 115.9913793103, 130) !important;
}

.btn-info.btn-darken-4 {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: rgb(0, 115.9913793103, 130) !important;
}
.btn-info.btn-darken-4:hover {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: rgb(0, 138.7435344828, 155.5) !important;
}
.btn-info.btn-darken-4:focus, .btn-info.btn-darken-4:active {
  border-color: rgb(0, 138.7435344828, 155.5) !important;
  background-color: rgb(0, 115.9913793103, 130) !important;
}

.btn-outline-info.btn-outline-darken-4 {
  border-color: rgb(0, 115.9913793103, 130) !important;
  color: rgb(0, 115.9913793103, 130) !important;
}
.btn-outline-info.btn-outline-darken-4:hover {
  background-color: rgb(0, 115.9913793103, 130) !important;
}

input:focus ~ .bg-info {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(0, 115.9913793103, 130) !important;
}

.border-info.border-darken-4 {
  border: 1px solid rgb(0, 115.9913793103, 130) !important;
}

.border-top-info.border-top-darken-4 {
  border-top: 1px solid rgb(0, 115.9913793103, 130) !important;
}

.border-bottom-info.border-bottom-darken-4 {
  border-bottom: 1px solid rgb(0, 115.9913793103, 130) !important;
}

.border-left-info.border-left-darken-4 {
  border-left: 1px solid rgb(0, 115.9913793103, 130) !important;
}

.border-right-info.border-right-darken-4 {
  border-right: 1px solid rgb(0, 115.9913793103, 130) !important;
}

.overlay-info.overlay-darken-4 {
  background: rgb(0, 115.9913793103, 130); /* The Fallback */
  background: rgba(0, 115.9913793103, 130, 0.6);
}

.info.accent-1 {
  color: #feffff !important;
}

.bg-info.bg-accent-1 {
  background-color: #feffff !important;
}

.btn-info.btn-accent-1 {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: #feffff !important;
}
.btn-info.btn-accent-1:hover {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: rgb(0, 138.7435344828, 155.5) !important;
}
.btn-info.btn-accent-1:focus, .btn-info.btn-accent-1:active {
  border-color: rgb(0, 138.7435344828, 155.5) !important;
  background-color: rgb(0, 115.9913793103, 130) !important;
}

.btn-outline-info.btn-outline-accent-1 {
  border-color: #feffff !important;
  color: #feffff !important;
}
.btn-outline-info.btn-outline-accent-1:hover {
  background-color: #feffff !important;
}

input:focus ~ .bg-info {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #feffff !important;
}

.border-info.border-accent-1 {
  border: 1px solid #feffff !important;
}

.border-top-info.border-top-accent-1 {
  border-top: 1px solid #feffff !important;
}

.border-bottom-info.border-bottom-accent-1 {
  border-bottom: 1px solid #feffff !important;
}

.border-left-info.border-left-accent-1 {
  border-left: 1px solid #feffff !important;
}

.border-right-info.border-right-accent-1 {
  border-right: 1px solid #feffff !important;
}

.overlay-info.overlay-accent-1 {
  background: #feffff; /* The Fallback */
  background: rgba(254, 255, 255, 0.6);
}

.info.accent-2 {
  color: #cbf5ff !important;
}

.bg-info.bg-accent-2 {
  background-color: #cbf5ff !important;
}

.btn-info.btn-accent-2 {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: #cbf5ff !important;
}
.btn-info.btn-accent-2:hover {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: rgb(0, 138.7435344828, 155.5) !important;
}
.btn-info.btn-accent-2:focus, .btn-info.btn-accent-2:active {
  border-color: rgb(0, 138.7435344828, 155.5) !important;
  background-color: rgb(0, 115.9913793103, 130) !important;
}

.btn-outline-info.btn-outline-accent-2 {
  border-color: #cbf5ff !important;
  color: #cbf5ff !important;
}
.btn-outline-info.btn-outline-accent-2:hover {
  background-color: #cbf5ff !important;
}

input:focus ~ .bg-info {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #cbf5ff !important;
}

.border-info.border-accent-2 {
  border: 1px solid #cbf5ff !important;
}

.border-top-info.border-top-accent-2 {
  border-top: 1px solid #cbf5ff !important;
}

.border-bottom-info.border-bottom-accent-2 {
  border-bottom: 1px solid #cbf5ff !important;
}

.border-left-info.border-left-accent-2 {
  border-left: 1px solid #cbf5ff !important;
}

.border-right-info.border-right-accent-2 {
  border-right: 1px solid #cbf5ff !important;
}

.overlay-info.overlay-accent-2 {
  background: #cbf5ff; /* The Fallback */
  background: rgba(203, 245, 255, 0.6);
}

.info.accent-3 {
  color: #98ecff !important;
}

.bg-info.bg-accent-3 {
  background-color: #98ecff !important;
}

.btn-info.btn-accent-3 {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: #98ecff !important;
}
.btn-info.btn-accent-3:hover {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: rgb(0, 138.7435344828, 155.5) !important;
}
.btn-info.btn-accent-3:focus, .btn-info.btn-accent-3:active {
  border-color: rgb(0, 138.7435344828, 155.5) !important;
  background-color: rgb(0, 115.9913793103, 130) !important;
}

.btn-outline-info.btn-outline-accent-3 {
  border-color: #98ecff !important;
  color: #98ecff !important;
}
.btn-outline-info.btn-outline-accent-3:hover {
  background-color: #98ecff !important;
}

input:focus ~ .bg-info {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #98ecff !important;
}

.border-info.border-accent-3 {
  border: 1px solid #98ecff !important;
}

.border-top-info.border-top-accent-3 {
  border-top: 1px solid #98ecff !important;
}

.border-bottom-info.border-bottom-accent-3 {
  border-bottom: 1px solid #98ecff !important;
}

.border-left-info.border-left-accent-3 {
  border-left: 1px solid #98ecff !important;
}

.border-right-info.border-right-accent-3 {
  border-right: 1px solid #98ecff !important;
}

.overlay-info.overlay-accent-3 {
  background: #98ecff; /* The Fallback */
  background: rgba(152, 236, 255, 0.6);
}

.info.accent-4 {
  color: #7fe7ff !important;
}

.bg-info.bg-accent-4 {
  background-color: #7fe7ff !important;
}

.btn-info.btn-accent-4 {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: #7fe7ff !important;
}
.btn-info.btn-accent-4:hover {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: rgb(0, 138.7435344828, 155.5) !important;
}
.btn-info.btn-accent-4:focus, .btn-info.btn-accent-4:active {
  border-color: rgb(0, 138.7435344828, 155.5) !important;
  background-color: rgb(0, 115.9913793103, 130) !important;
}

.btn-outline-info.btn-outline-accent-4 {
  border-color: #7fe7ff !important;
  color: #7fe7ff !important;
}
.btn-outline-info.btn-outline-accent-4:hover {
  background-color: #7fe7ff !important;
}

input:focus ~ .bg-info {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #7fe7ff !important;
}

.border-info.border-accent-4 {
  border: 1px solid #7fe7ff !important;
}

.border-top-info.border-top-accent-4 {
  border-top: 1px solid #7fe7ff !important;
}

.border-bottom-info.border-bottom-accent-4 {
  border-bottom: 1px solid #7fe7ff !important;
}

.border-left-info.border-left-accent-4 {
  border-left: 1px solid #7fe7ff !important;
}

.border-right-info.border-right-accent-4 {
  border-right: 1px solid #7fe7ff !important;
}

.overlay-info.overlay-accent-4 {
  background: #7fe7ff; /* The Fallback */
  background: rgba(127, 231, 255, 0.6);
}

.info.gradient-bg {
  color: #640064 !important;
}

.bg-info.bg-gradient-bg {
  background-color: #640064 !important;
}

.btn-info.btn-gradient-bg {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: #640064 !important;
}
.btn-info.btn-gradient-bg:hover {
  border-color: rgb(0, 161.4956896552, 181) !important;
  background-color: rgb(0, 138.7435344828, 155.5) !important;
}
.btn-info.btn-gradient-bg:focus, .btn-info.btn-gradient-bg:active {
  border-color: rgb(0, 138.7435344828, 155.5) !important;
  background-color: rgb(0, 115.9913793103, 130) !important;
}

.btn-outline-info.btn-outline-gradient-bg {
  border-color: #640064 !important;
  color: #640064 !important;
}
.btn-outline-info.btn-outline-gradient-bg:hover {
  background-color: #640064 !important;
}

input:focus ~ .bg-info {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #640064 !important;
}

.border-info.border-gradient-bg {
  border: 1px solid #640064 !important;
}

.border-top-info.border-top-gradient-bg {
  border-top: 1px solid #640064 !important;
}

.border-bottom-info.border-bottom-gradient-bg {
  border-bottom: 1px solid #640064 !important;
}

.border-left-info.border-left-gradient-bg {
  border-left: 1px solid #640064 !important;
}

.border-right-info.border-right-gradient-bg {
  border-right: 1px solid #640064 !important;
}

.overlay-info.overlay-gradient-bg {
  background: #640064; /* The Fallback */
  background: rgba(100, 0, 100, 0.6);
}

.warning.gradient-light {
  color: rgb(255, 243.7218067376, 134.983) !important;
}

.bg-warning.bg-gradient-light {
  background-color: rgb(255, 243.7218067376, 134.983) !important;
}

.btn-warning.btn-gradient-light {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: rgb(255, 243.7218067376, 134.983) !important;
}
.btn-warning.btn-gradient-light:hover {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: rgb(245.5, 120.1382978723, 0) !important;
}
.btn-warning.btn-gradient-light:focus, .btn-warning.btn-gradient-light:active {
  border-color: rgb(245.5, 120.1382978723, 0) !important;
  background-color: rgb(220, 107.6595744681, 0) !important;
}

.btn-outline-warning.btn-outline-gradient-light {
  border-color: rgb(255, 243.7218067376, 134.983) !important;
  color: rgb(255, 243.7218067376, 134.983) !important;
}
.btn-outline-warning.btn-outline-gradient-light:hover {
  background-color: rgb(255, 243.7218067376, 134.983) !important;
}

input:focus ~ .bg-warning {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(255, 243.7218067376, 134.983) !important;
}

.border-warning.border-gradient-light {
  border: 1px solid rgb(255, 243.7218067376, 134.983) !important;
}

.border-top-warning.border-top-gradient-light {
  border-top: 1px solid rgb(255, 243.7218067376, 134.983) !important;
}

.border-bottom-warning.border-bottom-gradient-light {
  border-bottom: 1px solid rgb(255, 243.7218067376, 134.983) !important;
}

.border-left-warning.border-left-gradient-light {
  border-left: 1px solid rgb(255, 243.7218067376, 134.983) !important;
}

.border-right-warning.border-right-gradient-light {
  border-right: 1px solid rgb(255, 243.7218067376, 134.983) !important;
}

.overlay-warning.overlay-gradient-light {
  background: rgb(255, 243.7218067376, 134.983); /* The Fallback */
  background: rgba(255, 243.7218067376, 134.983, 0.6);
}

.warning.light-badge {
  color: rgb(255, 224.1063829787, 194.5) !important;
}

.bg-warning.bg-light-badge {
  background-color: rgb(255, 224.1063829787, 194.5) !important;
}

.btn-warning.btn-light-badge {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: rgb(255, 224.1063829787, 194.5) !important;
}
.btn-warning.btn-light-badge:hover {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: rgb(245.5, 120.1382978723, 0) !important;
}
.btn-warning.btn-light-badge:focus, .btn-warning.btn-light-badge:active {
  border-color: rgb(245.5, 120.1382978723, 0) !important;
  background-color: rgb(220, 107.6595744681, 0) !important;
}

.btn-outline-warning.btn-outline-light-badge {
  border-color: rgb(255, 224.1063829787, 194.5) !important;
  color: rgb(255, 224.1063829787, 194.5) !important;
}
.btn-outline-warning.btn-outline-light-badge:hover {
  background-color: rgb(255, 224.1063829787, 194.5) !important;
}

input:focus ~ .bg-warning {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(255, 224.1063829787, 194.5) !important;
}

.border-warning.border-light-badge {
  border: 1px solid rgb(255, 224.1063829787, 194.5) !important;
}

.border-top-warning.border-top-light-badge {
  border-top: 1px solid rgb(255, 224.1063829787, 194.5) !important;
}

.border-bottom-warning.border-bottom-light-badge {
  border-bottom: 1px solid rgb(255, 224.1063829787, 194.5) !important;
}

.border-left-warning.border-left-light-badge {
  border-left: 1px solid rgb(255, 224.1063829787, 194.5) !important;
}

.border-right-warning.border-right-light-badge {
  border-right: 1px solid rgb(255, 224.1063829787, 194.5) !important;
}

.overlay-warning.overlay-light-badge {
  background: rgb(255, 224.1063829787, 194.5); /* The Fallback */
  background: rgba(255, 224.1063829787, 194.5, 0.6);
}

.warning.lighten-5 {
  color: rgb(255, 224.1063829787, 194.5) !important;
}

.bg-warning.bg-lighten-5 {
  background-color: rgb(255, 224.1063829787, 194.5) !important;
}

.btn-warning.btn-lighten-5 {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: rgb(255, 224.1063829787, 194.5) !important;
}
.btn-warning.btn-lighten-5:hover {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: rgb(245.5, 120.1382978723, 0) !important;
}
.btn-warning.btn-lighten-5:focus, .btn-warning.btn-lighten-5:active {
  border-color: rgb(245.5, 120.1382978723, 0) !important;
  background-color: rgb(220, 107.6595744681, 0) !important;
}

.btn-outline-warning.btn-outline-lighten-5 {
  border-color: rgb(255, 224.1063829787, 194.5) !important;
  color: rgb(255, 224.1063829787, 194.5) !important;
}
.btn-outline-warning.btn-outline-lighten-5:hover {
  background-color: rgb(255, 224.1063829787, 194.5) !important;
}

input:focus ~ .bg-warning {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(255, 224.1063829787, 194.5) !important;
}

.border-warning.border-lighten-5 {
  border: 1px solid rgb(255, 224.1063829787, 194.5) !important;
}

.border-top-warning.border-top-lighten-5 {
  border-top: 1px solid rgb(255, 224.1063829787, 194.5) !important;
}

.border-bottom-warning.border-bottom-lighten-5 {
  border-bottom: 1px solid rgb(255, 224.1063829787, 194.5) !important;
}

.border-left-warning.border-left-lighten-5 {
  border-left: 1px solid rgb(255, 224.1063829787, 194.5) !important;
}

.border-right-warning.border-right-lighten-5 {
  border-right: 1px solid rgb(255, 224.1063829787, 194.5) !important;
}

.overlay-warning.overlay-lighten-5 {
  background: rgb(255, 224.1063829787, 194.5); /* The Fallback */
  background: rgba(255, 224.1063829787, 194.5, 0.6);
}

.warning.lighten-4 {
  color: rgb(255, 211.085106383, 169) !important;
}

.bg-warning.bg-lighten-4 {
  background-color: rgb(255, 211.085106383, 169) !important;
}

.btn-warning.btn-lighten-4 {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: rgb(255, 211.085106383, 169) !important;
}
.btn-warning.btn-lighten-4:hover {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: rgb(245.5, 120.1382978723, 0) !important;
}
.btn-warning.btn-lighten-4:focus, .btn-warning.btn-lighten-4:active {
  border-color: rgb(245.5, 120.1382978723, 0) !important;
  background-color: rgb(220, 107.6595744681, 0) !important;
}

.btn-outline-warning.btn-outline-lighten-4 {
  border-color: rgb(255, 211.085106383, 169) !important;
  color: rgb(255, 211.085106383, 169) !important;
}
.btn-outline-warning.btn-outline-lighten-4:hover {
  background-color: rgb(255, 211.085106383, 169) !important;
}

input:focus ~ .bg-warning {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(255, 211.085106383, 169) !important;
}

.border-warning.border-lighten-4 {
  border: 1px solid rgb(255, 211.085106383, 169) !important;
}

.border-top-warning.border-top-lighten-4 {
  border-top: 1px solid rgb(255, 211.085106383, 169) !important;
}

.border-bottom-warning.border-bottom-lighten-4 {
  border-bottom: 1px solid rgb(255, 211.085106383, 169) !important;
}

.border-left-warning.border-left-lighten-4 {
  border-left: 1px solid rgb(255, 211.085106383, 169) !important;
}

.border-right-warning.border-right-lighten-4 {
  border-right: 1px solid rgb(255, 211.085106383, 169) !important;
}

.overlay-warning.overlay-lighten-4 {
  background: rgb(255, 211.085106383, 169); /* The Fallback */
  background: rgba(255, 211.085106383, 169, 0.6);
}

.warning.lighten-3 {
  color: rgb(255, 198.0638297872, 143.5) !important;
}

.bg-warning.bg-lighten-3 {
  background-color: rgb(255, 198.0638297872, 143.5) !important;
}

.btn-warning.btn-lighten-3 {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: rgb(255, 198.0638297872, 143.5) !important;
}
.btn-warning.btn-lighten-3:hover {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: rgb(245.5, 120.1382978723, 0) !important;
}
.btn-warning.btn-lighten-3:focus, .btn-warning.btn-lighten-3:active {
  border-color: rgb(245.5, 120.1382978723, 0) !important;
  background-color: rgb(220, 107.6595744681, 0) !important;
}

.btn-outline-warning.btn-outline-lighten-3 {
  border-color: rgb(255, 198.0638297872, 143.5) !important;
  color: rgb(255, 198.0638297872, 143.5) !important;
}
.btn-outline-warning.btn-outline-lighten-3:hover {
  background-color: rgb(255, 198.0638297872, 143.5) !important;
}

input:focus ~ .bg-warning {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(255, 198.0638297872, 143.5) !important;
}

.border-warning.border-lighten-3 {
  border: 1px solid rgb(255, 198.0638297872, 143.5) !important;
}

.border-top-warning.border-top-lighten-3 {
  border-top: 1px solid rgb(255, 198.0638297872, 143.5) !important;
}

.border-bottom-warning.border-bottom-lighten-3 {
  border-bottom: 1px solid rgb(255, 198.0638297872, 143.5) !important;
}

.border-left-warning.border-left-lighten-3 {
  border-left: 1px solid rgb(255, 198.0638297872, 143.5) !important;
}

.border-right-warning.border-right-lighten-3 {
  border-right: 1px solid rgb(255, 198.0638297872, 143.5) !important;
}

.overlay-warning.overlay-lighten-3 {
  background: rgb(255, 198.0638297872, 143.5); /* The Fallback */
  background: rgba(255, 198.0638297872, 143.5, 0.6);
}

.warning.lighten-2 {
  color: rgb(255, 185.0425531915, 118) !important;
}

.bg-warning.bg-lighten-2 {
  background-color: rgb(255, 185.0425531915, 118) !important;
}

.btn-warning.btn-lighten-2 {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: rgb(255, 185.0425531915, 118) !important;
}
.btn-warning.btn-lighten-2:hover {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: rgb(245.5, 120.1382978723, 0) !important;
}
.btn-warning.btn-lighten-2:focus, .btn-warning.btn-lighten-2:active {
  border-color: rgb(245.5, 120.1382978723, 0) !important;
  background-color: rgb(220, 107.6595744681, 0) !important;
}

.btn-outline-warning.btn-outline-lighten-2 {
  border-color: rgb(255, 185.0425531915, 118) !important;
  color: rgb(255, 185.0425531915, 118) !important;
}
.btn-outline-warning.btn-outline-lighten-2:hover {
  background-color: rgb(255, 185.0425531915, 118) !important;
}

input:focus ~ .bg-warning {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(255, 185.0425531915, 118) !important;
}

.border-warning.border-lighten-2 {
  border: 1px solid rgb(255, 185.0425531915, 118) !important;
}

.border-top-warning.border-top-lighten-2 {
  border-top: 1px solid rgb(255, 185.0425531915, 118) !important;
}

.border-bottom-warning.border-bottom-lighten-2 {
  border-bottom: 1px solid rgb(255, 185.0425531915, 118) !important;
}

.border-left-warning.border-left-lighten-2 {
  border-left: 1px solid rgb(255, 185.0425531915, 118) !important;
}

.border-right-warning.border-right-lighten-2 {
  border-right: 1px solid rgb(255, 185.0425531915, 118) !important;
}

.overlay-warning.overlay-lighten-2 {
  background: rgb(255, 185.0425531915, 118); /* The Fallback */
  background: rgba(255, 185.0425531915, 118, 0.6);
}

.warning.lighten-1 {
  color: rgb(255, 172.0212765957, 92.5) !important;
}

.bg-warning.bg-lighten-1 {
  background-color: rgb(255, 172.0212765957, 92.5) !important;
}

.btn-warning.btn-lighten-1 {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: rgb(255, 172.0212765957, 92.5) !important;
}
.btn-warning.btn-lighten-1:hover {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: rgb(245.5, 120.1382978723, 0) !important;
}
.btn-warning.btn-lighten-1:focus, .btn-warning.btn-lighten-1:active {
  border-color: rgb(245.5, 120.1382978723, 0) !important;
  background-color: rgb(220, 107.6595744681, 0) !important;
}

.btn-outline-warning.btn-outline-lighten-1 {
  border-color: rgb(255, 172.0212765957, 92.5) !important;
  color: rgb(255, 172.0212765957, 92.5) !important;
}
.btn-outline-warning.btn-outline-lighten-1:hover {
  background-color: rgb(255, 172.0212765957, 92.5) !important;
}

input:focus ~ .bg-warning {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(255, 172.0212765957, 92.5) !important;
}

.border-warning.border-lighten-1 {
  border: 1px solid rgb(255, 172.0212765957, 92.5) !important;
}

.border-top-warning.border-top-lighten-1 {
  border-top: 1px solid rgb(255, 172.0212765957, 92.5) !important;
}

.border-bottom-warning.border-bottom-lighten-1 {
  border-bottom: 1px solid rgb(255, 172.0212765957, 92.5) !important;
}

.border-left-warning.border-left-lighten-1 {
  border-left: 1px solid rgb(255, 172.0212765957, 92.5) !important;
}

.border-right-warning.border-right-lighten-1 {
  border-right: 1px solid rgb(255, 172.0212765957, 92.5) !important;
}

.overlay-warning.overlay-lighten-1 {
  background: rgb(255, 172.0212765957, 92.5); /* The Fallback */
  background: rgba(255, 172.0212765957, 92.5, 0.6);
}

.warning {
  color: #ff9f43 !important;
}

.bg-warning {
  background-color: #ff9f43 !important;
}
.bg-warning .card-header,
.bg-warning .card-footer {
  background-color: transparent;
}

.alert-warning {
  background: rgba(255, 159, 67, 0.2) !important;
  color: #ff9f43 !important;
}
.alert-warning .alert-heading {
  box-shadow: rgba(255, 159, 67, 0.4) 0px 6px 15px -7px;
}
.alert-warning .alert-link {
  color: rgb(255, 145.9787234043, 41.5) !important;
}

.bg-rgba-warning {
  background: rgba(255, 159, 67, 0.15) !important;
}

.border-warning {
  border: 1px solid #ff9f43 !important;
}

.border-top-warning {
  border-top: 1px solid #ff9f43;
}

.border-bottom-warning {
  border-bottom: 1px solid #ff9f43;
}

.border-left-warning {
  border-left: 1px solid #ff9f43;
}

.border-right-warning {
  border-right: 1px solid #ff9f43;
}

.badge.badge-light-warning {
  background-color: rgb(255, 224.1063829787, 194.5);
  color: #ff9f43 !important;
  font-weight: 500;
  text-transform: uppercase;
}

.bg-warning.badge-glow,
.border-warning.badge-glow,
.badge-warning.badge-glow {
  box-shadow: 0px 0px 10px #ff9f43;
}

.overlay-warning {
  background: #ff9f43; /* The Fallback */
  background: rgba(255, 159, 67, 0.6);
}

.btn-warning {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: #ff9f43 !important;
  color: #fff;
}
.btn-warning:hover {
  border-color: rgb(255, 145.9787234043, 41.5) !important;
  color: #fff !important;
  box-shadow: 0 8px 25px -8px #ff9f43;
}
.btn-warning:focus, .btn-warning:active {
  color: #fff !important;
}

.btn-flat-warning {
  background-color: transparent;
  color: #ff9f43;
}
.btn-flat-warning:hover {
  color: #ff9f43;
  background-color: rgba(255, 159, 67, 0.1);
}
.btn-flat-warning:active, .btn-flat-warning:focus {
  background-color: #ff9f43;
  color: #fff !important;
}

.btn-relief-warning {
  background-color: #ff9f43;
  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.2);
  color: #fff;
}
.btn-relief-warning:hover {
  color: #fff;
}
.btn-relief-warning:active, .btn-relief-warning:focus {
  outline: none;
  transform: translateY(3px);
}

.btn-outline-warning {
  border: 1px solid #ff9f43;
  background-color: transparent;
  color: #ff9f43;
}
.btn-outline-warning:hover {
  background-color: rgba(255, 159, 67, 0.08);
  color: #ff9f43;
}
.btn-outline-warning:active {
  color: #fff !important;
}

.btn-warning ~ .dropdown-menu .dropdown-item.active,
.btn-outline-warning ~ .dropdown-menu .dropdown-item.active,
.btn-flat-warning ~ .dropdown-menu .dropdown-item.active {
  background-color: #ff9f43;
  color: #fff;
}
.btn-warning ~ .dropdown-menu .dropdown-item.active:hover,
.btn-outline-warning ~ .dropdown-menu .dropdown-item.active:hover,
.btn-flat-warning ~ .dropdown-menu .dropdown-item.active:hover {
  color: #fff;
}
.btn-warning ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,
.btn-outline-warning ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,
.btn-flat-warning ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover {
  color: #ff9f43;
}

.bullet.bullet-warning {
  background-color: #ff9f43;
}
.bullet.bullet-warning.bullet-bordered {
  background-color: transparent;
  border: 2px solid #ff9f43;
}

.pagination-warning li.active a,
.pagination-warning li.active .page-link,
.pagination-warning .page-item.active a,
.pagination-warning .page-item.active .page-link {
  background: #ff9f43 !important;
  color: #fff;
}
.pagination-warning li.active a:hover,
.pagination-warning li.active .page-link:hover,
.pagination-warning .page-item.active a:hover,
.pagination-warning .page-item.active .page-link:hover {
  color: #fff !important;
}
.pagination-warning li a:hover,
.pagination-warning li .page-link:hover,
.pagination-warning .page-item a:hover,
.pagination-warning .page-item .page-link:hover {
  color: #ff9f43 !important;
}
.pagination-warning li.prev-item .page-link:hover, .pagination-warning li.next-item .page-link:hover,
.pagination-warning .page-item.prev-item .page-link:hover,
.pagination-warning .page-item.next-item .page-link:hover {
  background: #ff9f43;
  color: #fff;
}

.nav-pill-warning .nav-item .nav-link.active {
  color: #fff;
  background-color: #ff9f43;
}

.chip-warning {
  background-color: #ff9f43 !important;
}
.chip-warning .chip-body {
  color: #fff !important;
}

.divider.divider-warning .divider-text:before, .divider.divider-warning .divider-text:after {
  border-color: #ff9f43 !important;
}

input[type=checkbox].bg-warning + .custom-control-label:before, input[type=radio].bg-warning + .custom-control-label:before {
  background-color: #ff9f43 !important;
}

input:focus ~ .bg-warning {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #ff9f43 !important;
}

.vx-checkbox-warning input:checked ~ .vx-checkbox {
  border-color: #ff9f43 !important;
}
.vx-checkbox-warning input:checked ~ .vx-checkbox .vx-checkbox--check {
  background-color: #ff9f43 !important;
}
.vx-checkbox-warning input:active:checked + .vx-checkbox .vx-checkbox--check {
  background-color: #ff9f43 !important;
}

.vertical-layout .main-menu.theme-warning .navbar-header .navbar-nav .brand-text {
  color: #ff9f43;
}
.vertical-layout .main-menu.theme-warning .navigation .nav-item.active a {
  background: linear-gradient(118deg, #ff9f43, rgba(255, 159, 67, 0.7));
  box-shadow: 0 0 10px 1px rgba(255, 159, 67, 0.7) !important;
}
.vertical-layout .main-menu.theme-warning .navigation .nav-item .menu-content li.active {
  background: linear-gradient(118deg, #ff9f43, rgba(255, 159, 67, 0.7));
  box-shadow: 0 0 10px 1px rgba(255, 159, 67, 0.7) !important;
}

.horizontal-layout.theme-warning .header-navbar .brand-text {
  color: #ff9f43 !important;
}
.horizontal-layout.theme-warning .navbar-horizontal #main-menu-navigation .nav-item.active .nav-link {
  background: linear-gradient(118deg, #ff9f43, rgba(255, 159, 67, 0.7));
  box-shadow: 0 0 10px 1px rgba(255, 159, 67, 0.7) !important;
}

.custom-switch-warning .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #ff9f43 !important;
  color: #fff;
  transition: all 0.2s ease-out;
}

.color-radio.color-radio-warning {
  border: 1px solid transparent;
}
.color-radio.color-radio-warning.selected {
  border-color: #ff9f43;
}
.color-radio.color-radio-warning .radio-content {
  background-color: #ff9f43;
}

.vx-radio-warning input:checked ~ .vx-radio .vx-radio--circle {
  background: #ff9f43 !important;
  box-shadow: 0 3px 12px 0 rgba(255, 159, 67, 0.4) !important;
}

.warning.darken-1 {
  color: rgb(255, 145.9787234043, 41.5) !important;
}

.bg-warning.bg-darken-1 {
  background-color: rgb(255, 145.9787234043, 41.5) !important;
}

.btn-warning.btn-darken-1 {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: rgb(255, 145.9787234043, 41.5) !important;
}
.btn-warning.btn-darken-1:hover {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: rgb(245.5, 120.1382978723, 0) !important;
}
.btn-warning.btn-darken-1:focus, .btn-warning.btn-darken-1:active {
  border-color: rgb(245.5, 120.1382978723, 0) !important;
  background-color: rgb(220, 107.6595744681, 0) !important;
}

.btn-outline-warning.btn-outline-darken-1 {
  border-color: rgb(255, 145.9787234043, 41.5) !important;
  color: rgb(255, 145.9787234043, 41.5) !important;
}
.btn-outline-warning.btn-outline-darken-1:hover {
  background-color: rgb(255, 145.9787234043, 41.5) !important;
}

input:focus ~ .bg-warning {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(255, 145.9787234043, 41.5) !important;
}

.border-warning.border-darken-1 {
  border: 1px solid rgb(255, 145.9787234043, 41.5) !important;
}

.border-top-warning.border-top-darken-1 {
  border-top: 1px solid rgb(255, 145.9787234043, 41.5) !important;
}

.border-bottom-warning.border-bottom-darken-1 {
  border-bottom: 1px solid rgb(255, 145.9787234043, 41.5) !important;
}

.border-left-warning.border-left-darken-1 {
  border-left: 1px solid rgb(255, 145.9787234043, 41.5) !important;
}

.border-right-warning.border-right-darken-1 {
  border-right: 1px solid rgb(255, 145.9787234043, 41.5) !important;
}

.overlay-warning.overlay-darken-1 {
  background: rgb(255, 145.9787234043, 41.5); /* The Fallback */
  background: rgba(255, 145.9787234043, 41.5, 0.6);
}

.warning.darken-2 {
  color: rgb(255, 132.9574468085, 16) !important;
}

.bg-warning.bg-darken-2 {
  background-color: rgb(255, 132.9574468085, 16) !important;
}

.btn-warning.btn-darken-2 {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: rgb(255, 132.9574468085, 16) !important;
}
.btn-warning.btn-darken-2:hover {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: rgb(245.5, 120.1382978723, 0) !important;
}
.btn-warning.btn-darken-2:focus, .btn-warning.btn-darken-2:active {
  border-color: rgb(245.5, 120.1382978723, 0) !important;
  background-color: rgb(220, 107.6595744681, 0) !important;
}

.btn-outline-warning.btn-outline-darken-2 {
  border-color: rgb(255, 132.9574468085, 16) !important;
  color: rgb(255, 132.9574468085, 16) !important;
}
.btn-outline-warning.btn-outline-darken-2:hover {
  background-color: rgb(255, 132.9574468085, 16) !important;
}

input:focus ~ .bg-warning {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(255, 132.9574468085, 16) !important;
}

.border-warning.border-darken-2 {
  border: 1px solid rgb(255, 132.9574468085, 16) !important;
}

.border-top-warning.border-top-darken-2 {
  border-top: 1px solid rgb(255, 132.9574468085, 16) !important;
}

.border-bottom-warning.border-bottom-darken-2 {
  border-bottom: 1px solid rgb(255, 132.9574468085, 16) !important;
}

.border-left-warning.border-left-darken-2 {
  border-left: 1px solid rgb(255, 132.9574468085, 16) !important;
}

.border-right-warning.border-right-darken-2 {
  border-right: 1px solid rgb(255, 132.9574468085, 16) !important;
}

.overlay-warning.overlay-darken-2 {
  background: rgb(255, 132.9574468085, 16); /* The Fallback */
  background: rgba(255, 132.9574468085, 16, 0.6);
}

.warning.darken-3 {
  color: rgb(245.5, 120.1382978723, 0) !important;
}

.bg-warning.bg-darken-3 {
  background-color: rgb(245.5, 120.1382978723, 0) !important;
}

.btn-warning.btn-darken-3 {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: rgb(245.5, 120.1382978723, 0) !important;
}
.btn-warning.btn-darken-3:hover {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: rgb(245.5, 120.1382978723, 0) !important;
}
.btn-warning.btn-darken-3:focus, .btn-warning.btn-darken-3:active {
  border-color: rgb(245.5, 120.1382978723, 0) !important;
  background-color: rgb(220, 107.6595744681, 0) !important;
}

.btn-outline-warning.btn-outline-darken-3 {
  border-color: rgb(245.5, 120.1382978723, 0) !important;
  color: rgb(245.5, 120.1382978723, 0) !important;
}
.btn-outline-warning.btn-outline-darken-3:hover {
  background-color: rgb(245.5, 120.1382978723, 0) !important;
}

input:focus ~ .bg-warning {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(245.5, 120.1382978723, 0) !important;
}

.border-warning.border-darken-3 {
  border: 1px solid rgb(245.5, 120.1382978723, 0) !important;
}

.border-top-warning.border-top-darken-3 {
  border-top: 1px solid rgb(245.5, 120.1382978723, 0) !important;
}

.border-bottom-warning.border-bottom-darken-3 {
  border-bottom: 1px solid rgb(245.5, 120.1382978723, 0) !important;
}

.border-left-warning.border-left-darken-3 {
  border-left: 1px solid rgb(245.5, 120.1382978723, 0) !important;
}

.border-right-warning.border-right-darken-3 {
  border-right: 1px solid rgb(245.5, 120.1382978723, 0) !important;
}

.overlay-warning.overlay-darken-3 {
  background: rgb(245.5, 120.1382978723, 0); /* The Fallback */
  background: rgba(245.5, 120.1382978723, 0, 0.6);
}

.warning.darken-4 {
  color: rgb(220, 107.6595744681, 0) !important;
}

.bg-warning.bg-darken-4 {
  background-color: rgb(220, 107.6595744681, 0) !important;
}

.btn-warning.btn-darken-4 {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: rgb(220, 107.6595744681, 0) !important;
}
.btn-warning.btn-darken-4:hover {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: rgb(245.5, 120.1382978723, 0) !important;
}
.btn-warning.btn-darken-4:focus, .btn-warning.btn-darken-4:active {
  border-color: rgb(245.5, 120.1382978723, 0) !important;
  background-color: rgb(220, 107.6595744681, 0) !important;
}

.btn-outline-warning.btn-outline-darken-4 {
  border-color: rgb(220, 107.6595744681, 0) !important;
  color: rgb(220, 107.6595744681, 0) !important;
}
.btn-outline-warning.btn-outline-darken-4:hover {
  background-color: rgb(220, 107.6595744681, 0) !important;
}

input:focus ~ .bg-warning {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(220, 107.6595744681, 0) !important;
}

.border-warning.border-darken-4 {
  border: 1px solid rgb(220, 107.6595744681, 0) !important;
}

.border-top-warning.border-top-darken-4 {
  border-top: 1px solid rgb(220, 107.6595744681, 0) !important;
}

.border-bottom-warning.border-bottom-darken-4 {
  border-bottom: 1px solid rgb(220, 107.6595744681, 0) !important;
}

.border-left-warning.border-left-darken-4 {
  border-left: 1px solid rgb(220, 107.6595744681, 0) !important;
}

.border-right-warning.border-right-darken-4 {
  border-right: 1px solid rgb(220, 107.6595744681, 0) !important;
}

.overlay-warning.overlay-darken-4 {
  background: rgb(220, 107.6595744681, 0); /* The Fallback */
  background: rgba(220, 107.6595744681, 0, 0.6);
}

.warning.accent-1 {
  color: #fff5ef !important;
}

.bg-warning.bg-accent-1 {
  background-color: #fff5ef !important;
}

.btn-warning.btn-accent-1 {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: #fff5ef !important;
}
.btn-warning.btn-accent-1:hover {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: rgb(245.5, 120.1382978723, 0) !important;
}
.btn-warning.btn-accent-1:focus, .btn-warning.btn-accent-1:active {
  border-color: rgb(245.5, 120.1382978723, 0) !important;
  background-color: rgb(220, 107.6595744681, 0) !important;
}

.btn-outline-warning.btn-outline-accent-1 {
  border-color: #fff5ef !important;
  color: #fff5ef !important;
}
.btn-outline-warning.btn-outline-accent-1:hover {
  background-color: #fff5ef !important;
}

input:focus ~ .bg-warning {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #fff5ef !important;
}

.border-warning.border-accent-1 {
  border: 1px solid #fff5ef !important;
}

.border-top-warning.border-top-accent-1 {
  border-top: 1px solid #fff5ef !important;
}

.border-bottom-warning.border-bottom-accent-1 {
  border-bottom: 1px solid #fff5ef !important;
}

.border-left-warning.border-left-accent-1 {
  border-left: 1px solid #fff5ef !important;
}

.border-right-warning.border-right-accent-1 {
  border-right: 1px solid #fff5ef !important;
}

.overlay-warning.overlay-accent-1 {
  background: #fff5ef; /* The Fallback */
  background: rgba(255, 245, 239, 0.6);
}

.warning.accent-2 {
  color: #ffe5d8 !important;
}

.bg-warning.bg-accent-2 {
  background-color: #ffe5d8 !important;
}

.btn-warning.btn-accent-2 {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: #ffe5d8 !important;
}
.btn-warning.btn-accent-2:hover {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: rgb(245.5, 120.1382978723, 0) !important;
}
.btn-warning.btn-accent-2:focus, .btn-warning.btn-accent-2:active {
  border-color: rgb(245.5, 120.1382978723, 0) !important;
  background-color: rgb(220, 107.6595744681, 0) !important;
}

.btn-outline-warning.btn-outline-accent-2 {
  border-color: #ffe5d8 !important;
  color: #ffe5d8 !important;
}
.btn-outline-warning.btn-outline-accent-2:hover {
  background-color: #ffe5d8 !important;
}

input:focus ~ .bg-warning {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #ffe5d8 !important;
}

.border-warning.border-accent-2 {
  border: 1px solid #ffe5d8 !important;
}

.border-top-warning.border-top-accent-2 {
  border-top: 1px solid #ffe5d8 !important;
}

.border-bottom-warning.border-bottom-accent-2 {
  border-bottom: 1px solid #ffe5d8 !important;
}

.border-left-warning.border-left-accent-2 {
  border-left: 1px solid #ffe5d8 !important;
}

.border-right-warning.border-right-accent-2 {
  border-right: 1px solid #ffe5d8 !important;
}

.overlay-warning.overlay-accent-2 {
  background: #ffe5d8; /* The Fallback */
  background: rgba(255, 229, 216, 0.6);
}

.warning.accent-3 {
  color: #fff6f3 !important;
}

.bg-warning.bg-accent-3 {
  background-color: #fff6f3 !important;
}

.btn-warning.btn-accent-3 {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: #fff6f3 !important;
}
.btn-warning.btn-accent-3:hover {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: rgb(245.5, 120.1382978723, 0) !important;
}
.btn-warning.btn-accent-3:focus, .btn-warning.btn-accent-3:active {
  border-color: rgb(245.5, 120.1382978723, 0) !important;
  background-color: rgb(220, 107.6595744681, 0) !important;
}

.btn-outline-warning.btn-outline-accent-3 {
  border-color: #fff6f3 !important;
  color: #fff6f3 !important;
}
.btn-outline-warning.btn-outline-accent-3:hover {
  background-color: #fff6f3 !important;
}

input:focus ~ .bg-warning {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #fff6f3 !important;
}

.border-warning.border-accent-3 {
  border: 1px solid #fff6f3 !important;
}

.border-top-warning.border-top-accent-3 {
  border-top: 1px solid #fff6f3 !important;
}

.border-bottom-warning.border-bottom-accent-3 {
  border-bottom: 1px solid #fff6f3 !important;
}

.border-left-warning.border-left-accent-3 {
  border-left: 1px solid #fff6f3 !important;
}

.border-right-warning.border-right-accent-3 {
  border-right: 1px solid #fff6f3 !important;
}

.overlay-warning.overlay-accent-3 {
  background: #fff6f3; /* The Fallback */
  background: rgba(255, 246, 243, 0.6);
}

.warning.accent-4 {
  color: #ffe3da !important;
}

.bg-warning.bg-accent-4 {
  background-color: #ffe3da !important;
}

.btn-warning.btn-accent-4 {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: #ffe3da !important;
}
.btn-warning.btn-accent-4:hover {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: rgb(245.5, 120.1382978723, 0) !important;
}
.btn-warning.btn-accent-4:focus, .btn-warning.btn-accent-4:active {
  border-color: rgb(245.5, 120.1382978723, 0) !important;
  background-color: rgb(220, 107.6595744681, 0) !important;
}

.btn-outline-warning.btn-outline-accent-4 {
  border-color: #ffe3da !important;
  color: #ffe3da !important;
}
.btn-outline-warning.btn-outline-accent-4:hover {
  background-color: #ffe3da !important;
}

input:focus ~ .bg-warning {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #ffe3da !important;
}

.border-warning.border-accent-4 {
  border: 1px solid #ffe3da !important;
}

.border-top-warning.border-top-accent-4 {
  border-top: 1px solid #ffe3da !important;
}

.border-bottom-warning.border-bottom-accent-4 {
  border-bottom: 1px solid #ffe3da !important;
}

.border-left-warning.border-left-accent-4 {
  border-left: 1px solid #ffe3da !important;
}

.border-right-warning.border-right-accent-4 {
  border-right: 1px solid #ffe3da !important;
}

.overlay-warning.overlay-accent-4 {
  background: #ffe3da; /* The Fallback */
  background: rgba(255, 227, 218, 0.6);
}

.warning.gradient-bg {
  color: #fafafa !important;
}

.bg-warning.bg-gradient-bg {
  background-color: #fafafa !important;
}

.btn-warning.btn-gradient-bg {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: #fafafa !important;
}
.btn-warning.btn-gradient-bg:hover {
  border-color: rgb(255, 132.9574468085, 16) !important;
  background-color: rgb(245.5, 120.1382978723, 0) !important;
}
.btn-warning.btn-gradient-bg:focus, .btn-warning.btn-gradient-bg:active {
  border-color: rgb(245.5, 120.1382978723, 0) !important;
  background-color: rgb(220, 107.6595744681, 0) !important;
}

.btn-outline-warning.btn-outline-gradient-bg {
  border-color: #fafafa !important;
  color: #fafafa !important;
}
.btn-outline-warning.btn-outline-gradient-bg:hover {
  background-color: #fafafa !important;
}

input:focus ~ .bg-warning {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #fafafa !important;
}

.border-warning.border-gradient-bg {
  border: 1px solid #fafafa !important;
}

.border-top-warning.border-top-gradient-bg {
  border-top: 1px solid #fafafa !important;
}

.border-bottom-warning.border-bottom-gradient-bg {
  border-bottom: 1px solid #fafafa !important;
}

.border-left-warning.border-left-gradient-bg {
  border-left: 1px solid #fafafa !important;
}

.border-right-warning.border-right-gradient-bg {
  border-right: 1px solid #fafafa !important;
}

.overlay-warning.overlay-gradient-bg {
  background: #fafafa; /* The Fallback */
  background: rgba(250, 250, 250, 0.6);
}

.danger.gradient-light {
  color: rgb(248.814652125, 182.9433326175, 137.168347875) !important;
}

.bg-danger.bg-gradient-light {
  background-color: rgb(248.814652125, 182.9433326175, 137.168347875) !important;
}

.btn-danger.btn-gradient-light {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: rgb(248.814652125, 182.9433326175, 137.168347875) !important;
}
.btn-danger.btn-gradient-light:hover {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
}
.btn-danger.btn-gradient-light:focus, .btn-danger.btn-gradient-light:active {
  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
  background-color: rgb(192.375, 23.625, 24.75) !important;
}

.btn-outline-danger.btn-outline-gradient-light {
  border-color: rgb(248.814652125, 182.9433326175, 137.168347875) !important;
  color: rgb(248.814652125, 182.9433326175, 137.168347875) !important;
}
.btn-outline-danger.btn-outline-gradient-light:hover {
  background-color: rgb(248.814652125, 182.9433326175, 137.168347875) !important;
}

input:focus ~ .bg-danger {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(248.814652125, 182.9433326175, 137.168347875) !important;
}

.border-danger.border-gradient-light {
  border: 1px solid rgb(248.814652125, 182.9433326175, 137.168347875) !important;
}

.border-top-danger.border-top-gradient-light {
  border-top: 1px solid rgb(248.814652125, 182.9433326175, 137.168347875) !important;
}

.border-bottom-danger.border-bottom-gradient-light {
  border-bottom: 1px solid rgb(248.814652125, 182.9433326175, 137.168347875) !important;
}

.border-left-danger.border-left-gradient-light {
  border-left: 1px solid rgb(248.814652125, 182.9433326175, 137.168347875) !important;
}

.border-right-danger.border-right-gradient-light {
  border-right: 1px solid rgb(248.814652125, 182.9433326175, 137.168347875) !important;
}

.overlay-danger.overlay-gradient-light {
  background: rgb(248.814652125, 182.9433326175, 137.168347875); /* The Fallback */
  background: rgba(248.814652125, 182.9433326175, 137.168347875, 0.6);
}

.danger.light-badge {
  color: rgb(250.734375, 220.265625, 220.46875) !important;
}

.bg-danger.bg-light-badge {
  background-color: rgb(250.734375, 220.265625, 220.46875) !important;
}

.btn-danger.btn-light-badge {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: rgb(250.734375, 220.265625, 220.46875) !important;
}
.btn-danger.btn-light-badge:hover {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
}
.btn-danger.btn-light-badge:focus, .btn-danger.btn-light-badge:active {
  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
  background-color: rgb(192.375, 23.625, 24.75) !important;
}

.btn-outline-danger.btn-outline-light-badge {
  border-color: rgb(250.734375, 220.265625, 220.46875) !important;
  color: rgb(250.734375, 220.265625, 220.46875) !important;
}
.btn-outline-danger.btn-outline-light-badge:hover {
  background-color: rgb(250.734375, 220.265625, 220.46875) !important;
}

input:focus ~ .bg-danger {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(250.734375, 220.265625, 220.46875) !important;
}

.border-danger.border-light-badge {
  border: 1px solid rgb(250.734375, 220.265625, 220.46875) !important;
}

.border-top-danger.border-top-light-badge {
  border-top: 1px solid rgb(250.734375, 220.265625, 220.46875) !important;
}

.border-bottom-danger.border-bottom-light-badge {
  border-bottom: 1px solid rgb(250.734375, 220.265625, 220.46875) !important;
}

.border-left-danger.border-left-light-badge {
  border-left: 1px solid rgb(250.734375, 220.265625, 220.46875) !important;
}

.border-right-danger.border-right-light-badge {
  border-right: 1px solid rgb(250.734375, 220.265625, 220.46875) !important;
}

.overlay-danger.overlay-light-badge {
  background: rgb(250.734375, 220.265625, 220.46875); /* The Fallback */
  background: rgba(250.734375, 220.265625, 220.46875, 0.6);
}

.danger.lighten-5 {
  color: rgb(247.9453125, 197.5546875, 197.890625) !important;
}

.bg-danger.bg-lighten-5 {
  background-color: rgb(247.9453125, 197.5546875, 197.890625) !important;
}

.btn-danger.btn-lighten-5 {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: rgb(247.9453125, 197.5546875, 197.890625) !important;
}
.btn-danger.btn-lighten-5:hover {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
}
.btn-danger.btn-lighten-5:focus, .btn-danger.btn-lighten-5:active {
  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
  background-color: rgb(192.375, 23.625, 24.75) !important;
}

.btn-outline-danger.btn-outline-lighten-5 {
  border-color: rgb(247.9453125, 197.5546875, 197.890625) !important;
  color: rgb(247.9453125, 197.5546875, 197.890625) !important;
}
.btn-outline-danger.btn-outline-lighten-5:hover {
  background-color: rgb(247.9453125, 197.5546875, 197.890625) !important;
}

input:focus ~ .bg-danger {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(247.9453125, 197.5546875, 197.890625) !important;
}

.border-danger.border-lighten-5 {
  border: 1px solid rgb(247.9453125, 197.5546875, 197.890625) !important;
}

.border-top-danger.border-top-lighten-5 {
  border-top: 1px solid rgb(247.9453125, 197.5546875, 197.890625) !important;
}

.border-bottom-danger.border-bottom-lighten-5 {
  border-bottom: 1px solid rgb(247.9453125, 197.5546875, 197.890625) !important;
}

.border-left-danger.border-left-lighten-5 {
  border-left: 1px solid rgb(247.9453125, 197.5546875, 197.890625) !important;
}

.border-right-danger.border-right-lighten-5 {
  border-right: 1px solid rgb(247.9453125, 197.5546875, 197.890625) !important;
}

.overlay-danger.overlay-lighten-5 {
  background: rgb(247.9453125, 197.5546875, 197.890625); /* The Fallback */
  background: rgba(247.9453125, 197.5546875, 197.890625, 0.6);
}

.danger.lighten-4 {
  color: rgb(245.15625, 174.84375, 175.3125) !important;
}

.bg-danger.bg-lighten-4 {
  background-color: rgb(245.15625, 174.84375, 175.3125) !important;
}

.btn-danger.btn-lighten-4 {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: rgb(245.15625, 174.84375, 175.3125) !important;
}
.btn-danger.btn-lighten-4:hover {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
}
.btn-danger.btn-lighten-4:focus, .btn-danger.btn-lighten-4:active {
  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
  background-color: rgb(192.375, 23.625, 24.75) !important;
}

.btn-outline-danger.btn-outline-lighten-4 {
  border-color: rgb(245.15625, 174.84375, 175.3125) !important;
  color: rgb(245.15625, 174.84375, 175.3125) !important;
}
.btn-outline-danger.btn-outline-lighten-4:hover {
  background-color: rgb(245.15625, 174.84375, 175.3125) !important;
}

input:focus ~ .bg-danger {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(245.15625, 174.84375, 175.3125) !important;
}

.border-danger.border-lighten-4 {
  border: 1px solid rgb(245.15625, 174.84375, 175.3125) !important;
}

.border-top-danger.border-top-lighten-4 {
  border-top: 1px solid rgb(245.15625, 174.84375, 175.3125) !important;
}

.border-bottom-danger.border-bottom-lighten-4 {
  border-bottom: 1px solid rgb(245.15625, 174.84375, 175.3125) !important;
}

.border-left-danger.border-left-lighten-4 {
  border-left: 1px solid rgb(245.15625, 174.84375, 175.3125) !important;
}

.border-right-danger.border-right-lighten-4 {
  border-right: 1px solid rgb(245.15625, 174.84375, 175.3125) !important;
}

.overlay-danger.overlay-lighten-4 {
  background: rgb(245.15625, 174.84375, 175.3125); /* The Fallback */
  background: rgba(245.15625, 174.84375, 175.3125, 0.6);
}

.danger.lighten-3 {
  color: rgb(242.3671875, 152.1328125, 152.734375) !important;
}

.bg-danger.bg-lighten-3 {
  background-color: rgb(242.3671875, 152.1328125, 152.734375) !important;
}

.btn-danger.btn-lighten-3 {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: rgb(242.3671875, 152.1328125, 152.734375) !important;
}
.btn-danger.btn-lighten-3:hover {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
}
.btn-danger.btn-lighten-3:focus, .btn-danger.btn-lighten-3:active {
  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
  background-color: rgb(192.375, 23.625, 24.75) !important;
}

.btn-outline-danger.btn-outline-lighten-3 {
  border-color: rgb(242.3671875, 152.1328125, 152.734375) !important;
  color: rgb(242.3671875, 152.1328125, 152.734375) !important;
}
.btn-outline-danger.btn-outline-lighten-3:hover {
  background-color: rgb(242.3671875, 152.1328125, 152.734375) !important;
}

input:focus ~ .bg-danger {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(242.3671875, 152.1328125, 152.734375) !important;
}

.border-danger.border-lighten-3 {
  border: 1px solid rgb(242.3671875, 152.1328125, 152.734375) !important;
}

.border-top-danger.border-top-lighten-3 {
  border-top: 1px solid rgb(242.3671875, 152.1328125, 152.734375) !important;
}

.border-bottom-danger.border-bottom-lighten-3 {
  border-bottom: 1px solid rgb(242.3671875, 152.1328125, 152.734375) !important;
}

.border-left-danger.border-left-lighten-3 {
  border-left: 1px solid rgb(242.3671875, 152.1328125, 152.734375) !important;
}

.border-right-danger.border-right-lighten-3 {
  border-right: 1px solid rgb(242.3671875, 152.1328125, 152.734375) !important;
}

.overlay-danger.overlay-lighten-3 {
  background: rgb(242.3671875, 152.1328125, 152.734375); /* The Fallback */
  background: rgba(242.3671875, 152.1328125, 152.734375, 0.6);
}

.danger.lighten-2 {
  color: rgb(239.578125, 129.421875, 130.15625) !important;
}

.bg-danger.bg-lighten-2 {
  background-color: rgb(239.578125, 129.421875, 130.15625) !important;
}

.btn-danger.btn-lighten-2 {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: rgb(239.578125, 129.421875, 130.15625) !important;
}
.btn-danger.btn-lighten-2:hover {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
}
.btn-danger.btn-lighten-2:focus, .btn-danger.btn-lighten-2:active {
  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
  background-color: rgb(192.375, 23.625, 24.75) !important;
}

.btn-outline-danger.btn-outline-lighten-2 {
  border-color: rgb(239.578125, 129.421875, 130.15625) !important;
  color: rgb(239.578125, 129.421875, 130.15625) !important;
}
.btn-outline-danger.btn-outline-lighten-2:hover {
  background-color: rgb(239.578125, 129.421875, 130.15625) !important;
}

input:focus ~ .bg-danger {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(239.578125, 129.421875, 130.15625) !important;
}

.border-danger.border-lighten-2 {
  border: 1px solid rgb(239.578125, 129.421875, 130.15625) !important;
}

.border-top-danger.border-top-lighten-2 {
  border-top: 1px solid rgb(239.578125, 129.421875, 130.15625) !important;
}

.border-bottom-danger.border-bottom-lighten-2 {
  border-bottom: 1px solid rgb(239.578125, 129.421875, 130.15625) !important;
}

.border-left-danger.border-left-lighten-2 {
  border-left: 1px solid rgb(239.578125, 129.421875, 130.15625) !important;
}

.border-right-danger.border-right-lighten-2 {
  border-right: 1px solid rgb(239.578125, 129.421875, 130.15625) !important;
}

.overlay-danger.overlay-lighten-2 {
  background: rgb(239.578125, 129.421875, 130.15625); /* The Fallback */
  background: rgba(239.578125, 129.421875, 130.15625, 0.6);
}

.danger.lighten-1 {
  color: rgb(236.7890625, 106.7109375, 107.578125) !important;
}

.bg-danger.bg-lighten-1 {
  background-color: rgb(236.7890625, 106.7109375, 107.578125) !important;
}

.btn-danger.btn-lighten-1 {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: rgb(236.7890625, 106.7109375, 107.578125) !important;
}
.btn-danger.btn-lighten-1:hover {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
}
.btn-danger.btn-lighten-1:focus, .btn-danger.btn-lighten-1:active {
  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
  background-color: rgb(192.375, 23.625, 24.75) !important;
}

.btn-outline-danger.btn-outline-lighten-1 {
  border-color: rgb(236.7890625, 106.7109375, 107.578125) !important;
  color: rgb(236.7890625, 106.7109375, 107.578125) !important;
}
.btn-outline-danger.btn-outline-lighten-1:hover {
  background-color: rgb(236.7890625, 106.7109375, 107.578125) !important;
}

input:focus ~ .bg-danger {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(236.7890625, 106.7109375, 107.578125) !important;
}

.border-danger.border-lighten-1 {
  border: 1px solid rgb(236.7890625, 106.7109375, 107.578125) !important;
}

.border-top-danger.border-top-lighten-1 {
  border-top: 1px solid rgb(236.7890625, 106.7109375, 107.578125) !important;
}

.border-bottom-danger.border-bottom-lighten-1 {
  border-bottom: 1px solid rgb(236.7890625, 106.7109375, 107.578125) !important;
}

.border-left-danger.border-left-lighten-1 {
  border-left: 1px solid rgb(236.7890625, 106.7109375, 107.578125) !important;
}

.border-right-danger.border-right-lighten-1 {
  border-right: 1px solid rgb(236.7890625, 106.7109375, 107.578125) !important;
}

.overlay-danger.overlay-lighten-1 {
  background: rgb(236.7890625, 106.7109375, 107.578125); /* The Fallback */
  background: rgba(236.7890625, 106.7109375, 107.578125, 0.6);
}

.danger {
  color: #ea5455 !important;
}

.bg-danger {
  background-color: #ea5455 !important;
}
.bg-danger .card-header,
.bg-danger .card-footer {
  background-color: transparent;
}

.alert-danger {
  background: rgba(234, 84, 85, 0.2) !important;
  color: #ea5455 !important;
}
.alert-danger .alert-heading {
  box-shadow: rgba(234, 84, 85, 0.4) 0px 6px 15px -7px;
}
.alert-danger .alert-link {
  color: rgb(231.2109375, 61.2890625, 62.421875) !important;
}

.bg-rgba-danger {
  background: rgba(234, 84, 85, 0.15) !important;
}

.border-danger {
  border: 1px solid #ea5455 !important;
}

.border-top-danger {
  border-top: 1px solid #ea5455;
}

.border-bottom-danger {
  border-bottom: 1px solid #ea5455;
}

.border-left-danger {
  border-left: 1px solid #ea5455;
}

.border-right-danger {
  border-right: 1px solid #ea5455;
}

.badge.badge-light-danger {
  background-color: rgb(250.734375, 220.265625, 220.46875);
  color: #ea5455 !important;
  font-weight: 500;
  text-transform: uppercase;
}

.bg-danger.badge-glow,
.border-danger.badge-glow,
.badge-danger.badge-glow {
  box-shadow: 0px 0px 10px #ea5455;
}

.overlay-danger {
  background: #ea5455; /* The Fallback */
  background: rgba(234, 84, 85, 0.6);
}

.btn-danger {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: #ea5455 !important;
  color: #fff;
}
.btn-danger:hover {
  border-color: rgb(231.2109375, 61.2890625, 62.421875) !important;
  color: #fff !important;
  box-shadow: 0 8px 25px -8px #ea5455;
}
.btn-danger:focus, .btn-danger:active {
  color: #fff !important;
}

.btn-flat-danger {
  background-color: transparent;
  color: #ea5455;
}
.btn-flat-danger:hover {
  color: #ea5455;
  background-color: rgba(234, 84, 85, 0.1);
}
.btn-flat-danger:active, .btn-flat-danger:focus {
  background-color: #ea5455;
  color: #fff !important;
}

.btn-relief-danger {
  background-color: #ea5455;
  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.2);
  color: #fff;
}
.btn-relief-danger:hover {
  color: #fff;
}
.btn-relief-danger:active, .btn-relief-danger:focus {
  outline: none;
  transform: translateY(3px);
}

.btn-outline-danger {
  border: 1px solid #ea5455;
  background-color: transparent;
  color: #ea5455;
}
.btn-outline-danger:hover {
  background-color: rgba(234, 84, 85, 0.08);
  color: #ea5455;
}
.btn-outline-danger:active {
  color: #fff !important;
}

.btn-danger ~ .dropdown-menu .dropdown-item.active,
.btn-outline-danger ~ .dropdown-menu .dropdown-item.active,
.btn-flat-danger ~ .dropdown-menu .dropdown-item.active {
  background-color: #ea5455;
  color: #fff;
}
.btn-danger ~ .dropdown-menu .dropdown-item.active:hover,
.btn-outline-danger ~ .dropdown-menu .dropdown-item.active:hover,
.btn-flat-danger ~ .dropdown-menu .dropdown-item.active:hover {
  color: #fff;
}
.btn-danger ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,
.btn-outline-danger ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,
.btn-flat-danger ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover {
  color: #ea5455;
}

.bullet.bullet-danger {
  background-color: #ea5455;
}
.bullet.bullet-danger.bullet-bordered {
  background-color: transparent;
  border: 2px solid #ea5455;
}

.pagination-danger li.active a,
.pagination-danger li.active .page-link,
.pagination-danger .page-item.active a,
.pagination-danger .page-item.active .page-link {
  background: #ea5455 !important;
  color: #fff;
}
.pagination-danger li.active a:hover,
.pagination-danger li.active .page-link:hover,
.pagination-danger .page-item.active a:hover,
.pagination-danger .page-item.active .page-link:hover {
  color: #fff !important;
}
.pagination-danger li a:hover,
.pagination-danger li .page-link:hover,
.pagination-danger .page-item a:hover,
.pagination-danger .page-item .page-link:hover {
  color: #ea5455 !important;
}
.pagination-danger li.prev-item .page-link:hover, .pagination-danger li.next-item .page-link:hover,
.pagination-danger .page-item.prev-item .page-link:hover,
.pagination-danger .page-item.next-item .page-link:hover {
  background: #ea5455;
  color: #fff;
}

.nav-pill-danger .nav-item .nav-link.active {
  color: #fff;
  background-color: #ea5455;
}

.chip-danger {
  background-color: #ea5455 !important;
}
.chip-danger .chip-body {
  color: #fff !important;
}

.divider.divider-danger .divider-text:before, .divider.divider-danger .divider-text:after {
  border-color: #ea5455 !important;
}

input[type=checkbox].bg-danger + .custom-control-label:before, input[type=radio].bg-danger + .custom-control-label:before {
  background-color: #ea5455 !important;
}

input:focus ~ .bg-danger {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #ea5455 !important;
}

.vx-checkbox-danger input:checked ~ .vx-checkbox {
  border-color: #ea5455 !important;
}
.vx-checkbox-danger input:checked ~ .vx-checkbox .vx-checkbox--check {
  background-color: #ea5455 !important;
}
.vx-checkbox-danger input:active:checked + .vx-checkbox .vx-checkbox--check {
  background-color: #ea5455 !important;
}

.vertical-layout .main-menu.theme-danger .navbar-header .navbar-nav .brand-text {
  color: #ea5455;
}
.vertical-layout .main-menu.theme-danger .navigation .nav-item.active a {
  background: linear-gradient(118deg, #ea5455, rgba(234, 84, 85, 0.7));
  box-shadow: 0 0 10px 1px rgba(234, 84, 85, 0.7) !important;
}
.vertical-layout .main-menu.theme-danger .navigation .nav-item .menu-content li.active {
  background: linear-gradient(118deg, #ea5455, rgba(234, 84, 85, 0.7));
  box-shadow: 0 0 10px 1px rgba(234, 84, 85, 0.7) !important;
}

.horizontal-layout.theme-danger .header-navbar .brand-text {
  color: #ea5455 !important;
}
.horizontal-layout.theme-danger .navbar-horizontal #main-menu-navigation .nav-item.active .nav-link {
  background: linear-gradient(118deg, #ea5455, rgba(234, 84, 85, 0.7));
  box-shadow: 0 0 10px 1px rgba(234, 84, 85, 0.7) !important;
}

.custom-switch-danger .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #ea5455 !important;
  color: #fff;
  transition: all 0.2s ease-out;
}

.color-radio.color-radio-danger {
  border: 1px solid transparent;
}
.color-radio.color-radio-danger.selected {
  border-color: #ea5455;
}
.color-radio.color-radio-danger .radio-content {
  background-color: #ea5455;
}

.vx-radio-danger input:checked ~ .vx-radio .vx-radio--circle {
  background: #ea5455 !important;
  box-shadow: 0 3px 12px 0 rgba(234, 84, 85, 0.4) !important;
}

.danger.darken-1 {
  color: rgb(231.2109375, 61.2890625, 62.421875) !important;
}

.bg-danger.bg-darken-1 {
  background-color: rgb(231.2109375, 61.2890625, 62.421875) !important;
}

.btn-danger.btn-darken-1 {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: rgb(231.2109375, 61.2890625, 62.421875) !important;
}
.btn-danger.btn-darken-1:hover {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
}
.btn-danger.btn-darken-1:focus, .btn-danger.btn-darken-1:active {
  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
  background-color: rgb(192.375, 23.625, 24.75) !important;
}

.btn-outline-danger.btn-outline-darken-1 {
  border-color: rgb(231.2109375, 61.2890625, 62.421875) !important;
  color: rgb(231.2109375, 61.2890625, 62.421875) !important;
}
.btn-outline-danger.btn-outline-darken-1:hover {
  background-color: rgb(231.2109375, 61.2890625, 62.421875) !important;
}

input:focus ~ .bg-danger {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(231.2109375, 61.2890625, 62.421875) !important;
}

.border-danger.border-darken-1 {
  border: 1px solid rgb(231.2109375, 61.2890625, 62.421875) !important;
}

.border-top-danger.border-top-darken-1 {
  border-top: 1px solid rgb(231.2109375, 61.2890625, 62.421875) !important;
}

.border-bottom-danger.border-bottom-darken-1 {
  border-bottom: 1px solid rgb(231.2109375, 61.2890625, 62.421875) !important;
}

.border-left-danger.border-left-darken-1 {
  border-left: 1px solid rgb(231.2109375, 61.2890625, 62.421875) !important;
}

.border-right-danger.border-right-darken-1 {
  border-right: 1px solid rgb(231.2109375, 61.2890625, 62.421875) !important;
}

.overlay-danger.overlay-darken-1 {
  background: rgb(231.2109375, 61.2890625, 62.421875); /* The Fallback */
  background: rgba(231.2109375, 61.2890625, 62.421875, 0.6);
}

.danger.darken-2 {
  color: rgb(228.421875, 38.578125, 39.84375) !important;
}

.bg-danger.bg-darken-2 {
  background-color: rgb(228.421875, 38.578125, 39.84375) !important;
}

.btn-danger.btn-darken-2 {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: rgb(228.421875, 38.578125, 39.84375) !important;
}
.btn-danger.btn-darken-2:hover {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
}
.btn-danger.btn-darken-2:focus, .btn-danger.btn-darken-2:active {
  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
  background-color: rgb(192.375, 23.625, 24.75) !important;
}

.btn-outline-danger.btn-outline-darken-2 {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  color: rgb(228.421875, 38.578125, 39.84375) !important;
}
.btn-outline-danger.btn-outline-darken-2:hover {
  background-color: rgb(228.421875, 38.578125, 39.84375) !important;
}

input:focus ~ .bg-danger {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(228.421875, 38.578125, 39.84375) !important;
}

.border-danger.border-darken-2 {
  border: 1px solid rgb(228.421875, 38.578125, 39.84375) !important;
}

.border-top-danger.border-top-darken-2 {
  border-top: 1px solid rgb(228.421875, 38.578125, 39.84375) !important;
}

.border-bottom-danger.border-bottom-darken-2 {
  border-bottom: 1px solid rgb(228.421875, 38.578125, 39.84375) !important;
}

.border-left-danger.border-left-darken-2 {
  border-left: 1px solid rgb(228.421875, 38.578125, 39.84375) !important;
}

.border-right-danger.border-right-darken-2 {
  border-right: 1px solid rgb(228.421875, 38.578125, 39.84375) !important;
}

.overlay-danger.overlay-darken-2 {
  background: rgb(228.421875, 38.578125, 39.84375); /* The Fallback */
  background: rgba(228.421875, 38.578125, 39.84375, 0.6);
}

.danger.darken-3 {
  color: rgb(215.0859375, 26.4140625, 27.671875) !important;
}

.bg-danger.bg-darken-3 {
  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
}

.btn-danger.btn-darken-3 {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
}
.btn-danger.btn-darken-3:hover {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
}
.btn-danger.btn-darken-3:focus, .btn-danger.btn-darken-3:active {
  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
  background-color: rgb(192.375, 23.625, 24.75) !important;
}

.btn-outline-danger.btn-outline-darken-3 {
  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
  color: rgb(215.0859375, 26.4140625, 27.671875) !important;
}
.btn-outline-danger.btn-outline-darken-3:hover {
  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
}

input:focus ~ .bg-danger {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(215.0859375, 26.4140625, 27.671875) !important;
}

.border-danger.border-darken-3 {
  border: 1px solid rgb(215.0859375, 26.4140625, 27.671875) !important;
}

.border-top-danger.border-top-darken-3 {
  border-top: 1px solid rgb(215.0859375, 26.4140625, 27.671875) !important;
}

.border-bottom-danger.border-bottom-darken-3 {
  border-bottom: 1px solid rgb(215.0859375, 26.4140625, 27.671875) !important;
}

.border-left-danger.border-left-darken-3 {
  border-left: 1px solid rgb(215.0859375, 26.4140625, 27.671875) !important;
}

.border-right-danger.border-right-darken-3 {
  border-right: 1px solid rgb(215.0859375, 26.4140625, 27.671875) !important;
}

.overlay-danger.overlay-darken-3 {
  background: rgb(215.0859375, 26.4140625, 27.671875); /* The Fallback */
  background: rgba(215.0859375, 26.4140625, 27.671875, 0.6);
}

.danger.darken-4 {
  color: rgb(192.375, 23.625, 24.75) !important;
}

.bg-danger.bg-darken-4 {
  background-color: rgb(192.375, 23.625, 24.75) !important;
}

.btn-danger.btn-darken-4 {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: rgb(192.375, 23.625, 24.75) !important;
}
.btn-danger.btn-darken-4:hover {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
}
.btn-danger.btn-darken-4:focus, .btn-danger.btn-darken-4:active {
  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
  background-color: rgb(192.375, 23.625, 24.75) !important;
}

.btn-outline-danger.btn-outline-darken-4 {
  border-color: rgb(192.375, 23.625, 24.75) !important;
  color: rgb(192.375, 23.625, 24.75) !important;
}
.btn-outline-danger.btn-outline-darken-4:hover {
  background-color: rgb(192.375, 23.625, 24.75) !important;
}

input:focus ~ .bg-danger {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(192.375, 23.625, 24.75) !important;
}

.border-danger.border-darken-4 {
  border: 1px solid rgb(192.375, 23.625, 24.75) !important;
}

.border-top-danger.border-top-darken-4 {
  border-top: 1px solid rgb(192.375, 23.625, 24.75) !important;
}

.border-bottom-danger.border-bottom-darken-4 {
  border-bottom: 1px solid rgb(192.375, 23.625, 24.75) !important;
}

.border-left-danger.border-left-darken-4 {
  border-left: 1px solid rgb(192.375, 23.625, 24.75) !important;
}

.border-right-danger.border-right-darken-4 {
  border-right: 1px solid rgb(192.375, 23.625, 24.75) !important;
}

.overlay-danger.overlay-darken-4 {
  background: rgb(192.375, 23.625, 24.75); /* The Fallback */
  background: rgba(192.375, 23.625, 24.75, 0.6);
}

.danger.accent-1 {
  color: #ffeef1 !important;
}

.bg-danger.bg-accent-1 {
  background-color: #ffeef1 !important;
}

.btn-danger.btn-accent-1 {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: #ffeef1 !important;
}
.btn-danger.btn-accent-1:hover {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
}
.btn-danger.btn-accent-1:focus, .btn-danger.btn-accent-1:active {
  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
  background-color: rgb(192.375, 23.625, 24.75) !important;
}

.btn-outline-danger.btn-outline-accent-1 {
  border-color: #ffeef1 !important;
  color: #ffeef1 !important;
}
.btn-outline-danger.btn-outline-accent-1:hover {
  background-color: #ffeef1 !important;
}

input:focus ~ .bg-danger {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #ffeef1 !important;
}

.border-danger.border-accent-1 {
  border: 1px solid #ffeef1 !important;
}

.border-top-danger.border-top-accent-1 {
  border-top: 1px solid #ffeef1 !important;
}

.border-bottom-danger.border-bottom-accent-1 {
  border-bottom: 1px solid #ffeef1 !important;
}

.border-left-danger.border-left-accent-1 {
  border-left: 1px solid #ffeef1 !important;
}

.border-right-danger.border-right-accent-1 {
  border-right: 1px solid #ffeef1 !important;
}

.overlay-danger.overlay-accent-1 {
  background: #ffeef1; /* The Fallback */
  background: rgba(255, 238, 241, 0.6);
}

.danger.accent-2 {
  color: #ffd6db !important;
}

.bg-danger.bg-accent-2 {
  background-color: #ffd6db !important;
}

.btn-danger.btn-accent-2 {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: #ffd6db !important;
}
.btn-danger.btn-accent-2:hover {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
}
.btn-danger.btn-accent-2:focus, .btn-danger.btn-accent-2:active {
  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
  background-color: rgb(192.375, 23.625, 24.75) !important;
}

.btn-outline-danger.btn-outline-accent-2 {
  border-color: #ffd6db !important;
  color: #ffd6db !important;
}
.btn-outline-danger.btn-outline-accent-2:hover {
  background-color: #ffd6db !important;
}

input:focus ~ .bg-danger {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #ffd6db !important;
}

.border-danger.border-accent-2 {
  border: 1px solid #ffd6db !important;
}

.border-top-danger.border-top-accent-2 {
  border-top: 1px solid #ffd6db !important;
}

.border-bottom-danger.border-bottom-accent-2 {
  border-bottom: 1px solid #ffd6db !important;
}

.border-left-danger.border-left-accent-2 {
  border-left: 1px solid #ffd6db !important;
}

.border-right-danger.border-right-accent-2 {
  border-right: 1px solid #ffd6db !important;
}

.overlay-danger.overlay-accent-2 {
  background: #ffd6db; /* The Fallback */
  background: rgba(255, 214, 219, 0.6);
}

.danger.accent-3 {
  color: #ffecee !important;
}

.bg-danger.bg-accent-3 {
  background-color: #ffecee !important;
}

.btn-danger.btn-accent-3 {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: #ffecee !important;
}
.btn-danger.btn-accent-3:hover {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
}
.btn-danger.btn-accent-3:focus, .btn-danger.btn-accent-3:active {
  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
  background-color: rgb(192.375, 23.625, 24.75) !important;
}

.btn-outline-danger.btn-outline-accent-3 {
  border-color: #ffecee !important;
  color: #ffecee !important;
}
.btn-outline-danger.btn-outline-accent-3:hover {
  background-color: #ffecee !important;
}

input:focus ~ .bg-danger {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #ffecee !important;
}

.border-danger.border-accent-3 {
  border: 1px solid #ffecee !important;
}

.border-top-danger.border-top-accent-3 {
  border-top: 1px solid #ffecee !important;
}

.border-bottom-danger.border-bottom-accent-3 {
  border-bottom: 1px solid #ffecee !important;
}

.border-left-danger.border-left-accent-3 {
  border-left: 1px solid #ffecee !important;
}

.border-right-danger.border-right-accent-3 {
  border-right: 1px solid #ffecee !important;
}

.overlay-danger.overlay-accent-3 {
  background: #ffecee; /* The Fallback */
  background: rgba(255, 236, 238, 0.6);
}

.danger.accent-4 {
  color: #ffd3d7 !important;
}

.bg-danger.bg-accent-4 {
  background-color: #ffd3d7 !important;
}

.btn-danger.btn-accent-4 {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: #ffd3d7 !important;
}
.btn-danger.btn-accent-4:hover {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
}
.btn-danger.btn-accent-4:focus, .btn-danger.btn-accent-4:active {
  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
  background-color: rgb(192.375, 23.625, 24.75) !important;
}

.btn-outline-danger.btn-outline-accent-4 {
  border-color: #ffd3d7 !important;
  color: #ffd3d7 !important;
}
.btn-outline-danger.btn-outline-accent-4:hover {
  background-color: #ffd3d7 !important;
}

input:focus ~ .bg-danger {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #ffd3d7 !important;
}

.border-danger.border-accent-4 {
  border: 1px solid #ffd3d7 !important;
}

.border-top-danger.border-top-accent-4 {
  border-top: 1px solid #ffd3d7 !important;
}

.border-bottom-danger.border-bottom-accent-4 {
  border-bottom: 1px solid #ffd3d7 !important;
}

.border-left-danger.border-left-accent-4 {
  border-left: 1px solid #ffd3d7 !important;
}

.border-right-danger.border-right-accent-4 {
  border-right: 1px solid #ffd3d7 !important;
}

.overlay-danger.overlay-accent-4 {
  background: #ffd3d7; /* The Fallback */
  background: rgba(255, 211, 215, 0.6);
}

.danger.gradient-bg {
  color: #640064 !important;
}

.bg-danger.bg-gradient-bg {
  background-color: #640064 !important;
}

.btn-danger.btn-gradient-bg {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: #640064 !important;
}
.btn-danger.btn-gradient-bg:hover {
  border-color: rgb(228.421875, 38.578125, 39.84375) !important;
  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
}
.btn-danger.btn-gradient-bg:focus, .btn-danger.btn-gradient-bg:active {
  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;
  background-color: rgb(192.375, 23.625, 24.75) !important;
}

.btn-outline-danger.btn-outline-gradient-bg {
  border-color: #640064 !important;
  color: #640064 !important;
}
.btn-outline-danger.btn-outline-gradient-bg:hover {
  background-color: #640064 !important;
}

input:focus ~ .bg-danger {
  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #640064 !important;
}

.border-danger.border-gradient-bg {
  border: 1px solid #640064 !important;
}

.border-top-danger.border-top-gradient-bg {
  border-top: 1px solid #640064 !important;
}

.border-bottom-danger.border-bottom-gradient-bg {
  border-bottom: 1px solid #640064 !important;
}

.border-left-danger.border-left-gradient-bg {
  border-left: 1px solid #640064 !important;
}

.border-right-danger.border-right-gradient-bg {
  border-right: 1px solid #640064 !important;
}

.overlay-danger.overlay-gradient-bg {
  background: #640064; /* The Fallback */
  background: rgba(100, 0, 100, 0.6);
}

@font-face {
  font-family: "feather";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_21___}); /* IE9*/
  src: url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("svg"); /* iOS 4.1- */
}
.feather {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "feather" !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-alert-octagon:before {
  content: "\\e81b";
}

.icon-alert-circle:before {
  content: "\\e81c";
}

.icon-activity:before {
  content: "\\e81d";
}

.icon-alert-triangle:before {
  content: "\\e81e";
}

.icon-align-center:before {
  content: "\\e81f";
}

.icon-airplay:before {
  content: "\\e820";
}

.icon-align-justify:before {
  content: "\\e821";
}

.icon-align-left:before {
  content: "\\e822";
}

.icon-align-right:before {
  content: "\\e823";
}

.icon-arrow-down-left:before {
  content: "\\e824";
}

.icon-arrow-down-right:before {
  content: "\\e825";
}

.icon-anchor:before {
  content: "\\e826";
}

.icon-aperture:before {
  content: "\\e827";
}

.icon-arrow-left:before {
  content: "\\e828";
}

.icon-arrow-right:before {
  content: "\\e829";
}

.icon-arrow-down:before {
  content: "\\e82a";
}

.icon-arrow-up-left:before {
  content: "\\e82b";
}

.icon-arrow-up-right:before {
  content: "\\e82c";
}

.icon-arrow-up:before {
  content: "\\e82d";
}

.icon-award:before {
  content: "\\e82e";
}

.icon-bar-chart:before {
  content: "\\e82f";
}

.icon-at-sign:before {
  content: "\\e830";
}

.icon-bar-chart-2:before {
  content: "\\e831";
}

.icon-battery-charging:before {
  content: "\\e832";
}

.icon-bell-off:before {
  content: "\\e833";
}

.icon-battery:before {
  content: "\\e834";
}

.icon-bluetooth:before {
  content: "\\e835";
}

.icon-bell:before {
  content: "\\e836";
}

.icon-book:before {
  content: "\\e837";
}

.icon-briefcase:before {
  content: "\\e838";
}

.icon-camera-off:before {
  content: "\\e839";
}

.icon-calendar:before {
  content: "\\e83a";
}

.icon-bookmark:before {
  content: "\\e83b";
}

.icon-box:before {
  content: "\\e83c";
}

.icon-camera:before {
  content: "\\e83d";
}

.icon-check-circle:before {
  content: "\\e83e";
}

.icon-check:before {
  content: "\\e83f";
}

.icon-check-square:before {
  content: "\\e840";
}

.icon-cast:before {
  content: "\\e841";
}

.icon-chevron-down:before {
  content: "\\e842";
}

.icon-chevron-left:before {
  content: "\\e843";
}

.icon-chevron-right:before {
  content: "\\e844";
}

.icon-chevron-up:before {
  content: "\\e845";
}

.icon-chevrons-down:before {
  content: "\\e846";
}

.icon-chevrons-right:before {
  content: "\\e847";
}

.icon-chevrons-up:before {
  content: "\\e848";
}

.icon-chevrons-left:before {
  content: "\\e849";
}

.icon-circle:before {
  content: "\\e84a";
}

.icon-clipboard:before {
  content: "\\e84b";
}

.icon-chrome:before {
  content: "\\e84c";
}

.icon-clock:before {
  content: "\\e84d";
}

.icon-cloud-lightning:before {
  content: "\\e84e";
}

.icon-cloud-drizzle:before {
  content: "\\e84f";
}

.icon-cloud-rain:before {
  content: "\\e850";
}

.icon-cloud-off:before {
  content: "\\e851";
}

.icon-codepen:before {
  content: "\\e852";
}

.icon-cloud-snow:before {
  content: "\\e853";
}

.icon-compass:before {
  content: "\\e854";
}

.icon-copy:before {
  content: "\\e855";
}

.icon-corner-down-right:before {
  content: "\\e856";
}

.icon-corner-down-left:before {
  content: "\\e857";
}

.icon-corner-left-down:before {
  content: "\\e858";
}

.icon-corner-left-up:before {
  content: "\\e859";
}

.icon-corner-up-left:before {
  content: "\\e85a";
}

.icon-corner-up-right:before {
  content: "\\e85b";
}

.icon-corner-right-down:before {
  content: "\\e85c";
}

.icon-corner-right-up:before {
  content: "\\e85d";
}

.icon-cpu:before {
  content: "\\e85e";
}

.icon-credit-card:before {
  content: "\\e85f";
}

.icon-crosshair:before {
  content: "\\e860";
}

.icon-disc:before {
  content: "\\e861";
}

.icon-delete:before {
  content: "\\e862";
}

.icon-download-cloud:before {
  content: "\\e863";
}

.icon-download:before {
  content: "\\e864";
}

.icon-droplet:before {
  content: "\\e865";
}

.icon-edit-2:before {
  content: "\\e866";
}

.icon-edit:before {
  content: "\\e867";
}

.icon-edit-1:before {
  content: "\\e868";
}

.icon-external-link:before {
  content: "\\e869";
}

.icon-eye:before {
  content: "\\e86a";
}

.icon-feather:before {
  content: "\\e86b";
}

.icon-facebook:before {
  content: "\\e86c";
}

.icon-file-minus:before {
  content: "\\e86d";
}

.icon-eye-off:before {
  content: "\\e86e";
}

.icon-fast-forward:before {
  content: "\\e86f";
}

.icon-file-text:before {
  content: "\\e870";
}

.icon-film:before {
  content: "\\e871";
}

.icon-file:before {
  content: "\\e872";
}

.icon-file-plus:before {
  content: "\\e873";
}

.icon-folder:before {
  content: "\\e874";
}

.icon-filter:before {
  content: "\\e875";
}

.icon-flag:before {
  content: "\\e876";
}

.icon-globe:before {
  content: "\\e877";
}

.icon-grid:before {
  content: "\\e878";
}

.icon-heart:before {
  content: "\\e879";
}

.icon-home:before {
  content: "\\e87a";
}

.icon-github:before {
  content: "\\e87b";
}

.icon-image:before {
  content: "\\e87c";
}

.icon-inbox:before {
  content: "\\e87d";
}

.icon-layers:before {
  content: "\\e87e";
}

.icon-info:before {
  content: "\\e87f";
}

.icon-instagram:before {
  content: "\\e880";
}

.icon-layout:before {
  content: "\\e881";
}

.icon-link-2:before {
  content: "\\e882";
}

.icon-life-buoy:before {
  content: "\\e883";
}

.icon-link:before {
  content: "\\e884";
}

.icon-log-in:before {
  content: "\\e885";
}

.icon-list:before {
  content: "\\e886";
}

.icon-lock:before {
  content: "\\e887";
}

.icon-log-out:before {
  content: "\\e888";
}

.icon-loader:before {
  content: "\\e889";
}

.icon-mail:before {
  content: "\\e88a";
}

.icon-maximize-2:before {
  content: "\\e88b";
}

.icon-map:before {
  content: "\\e88c";
}

.icon-map-pin:before {
  content: "\\e88e";
}

.icon-menu:before {
  content: "\\e88f";
}

.icon-message-circle:before {
  content: "\\e890";
}

.icon-message-square:before {
  content: "\\e891";
}

.icon-minimize-2:before {
  content: "\\e892";
}

.icon-mic-off:before {
  content: "\\e893";
}

.icon-minus-circle:before {
  content: "\\e894";
}

.icon-mic:before {
  content: "\\e895";
}

.icon-minus-square:before {
  content: "\\e896";
}

.icon-minus:before {
  content: "\\e897";
}

.icon-moon:before {
  content: "\\e898";
}

.icon-monitor:before {
  content: "\\e899";
}

.icon-more-vertical:before {
  content: "\\e89a";
}

.icon-more-horizontal:before {
  content: "\\e89b";
}

.icon-move:before {
  content: "\\e89c";
}

.icon-music:before {
  content: "\\e89d";
}

.icon-navigation-2:before {
  content: "\\e89e";
}

.icon-navigation:before {
  content: "\\e89f";
}

.icon-octagon:before {
  content: "\\e8a0";
}

.icon-package:before {
  content: "\\e8a1";
}

.icon-pause-circle:before {
  content: "\\e8a2";
}

.icon-pause:before {
  content: "\\e8a3";
}

.icon-percent:before {
  content: "\\e8a4";
}

.icon-phone-call:before {
  content: "\\e8a5";
}

.icon-phone-forwarded:before {
  content: "\\e8a6";
}

.icon-phone-missed:before {
  content: "\\e8a7";
}

.icon-phone-off:before {
  content: "\\e8a8";
}

.icon-phone-incoming:before {
  content: "\\e8a9";
}

.icon-phone:before {
  content: "\\e8aa";
}

.icon-phone-outgoing:before {
  content: "\\e8ab";
}

.icon-pie-chart:before {
  content: "\\e8ac";
}

.icon-play-circle:before {
  content: "\\e8ad";
}

.icon-play:before {
  content: "\\e8ae";
}

.icon-plus-square:before {
  content: "\\e8af";
}

.icon-plus-circle:before {
  content: "\\e8b0";
}

.icon-plus:before {
  content: "\\e8b1";
}

.icon-pocket:before {
  content: "\\e8b2";
}

.icon-printer:before {
  content: "\\e8b3";
}

.icon-power:before {
  content: "\\e8b4";
}

.icon-radio:before {
  content: "\\e8b5";
}

.icon-repeat:before {
  content: "\\e8b6";
}

.icon-refresh-ccw:before {
  content: "\\e8b7";
}

.icon-rewind:before {
  content: "\\e8b8";
}

.icon-rotate-ccw:before {
  content: "\\e8b9";
}

.icon-refresh-cw:before {
  content: "\\e8ba";
}

.icon-rotate-cw:before {
  content: "\\e8bb";
}

.icon-save:before {
  content: "\\e8bc";
}

.icon-search:before {
  content: "\\e8bd";
}

.icon-server:before {
  content: "\\e8be";
}

.icon-scissors:before {
  content: "\\e8bf";
}

.icon-share-2:before {
  content: "\\e8c0";
}

.icon-share:before {
  content: "\\e8c1";
}

.icon-shield:before {
  content: "\\e8c2";
}

.icon-settings:before {
  content: "\\e8c3";
}

.icon-skip-back:before {
  content: "\\e8c4";
}

.icon-shuffle:before {
  content: "\\e8c5";
}

.icon-sidebar:before {
  content: "\\e8c6";
}

.icon-skip-forward:before {
  content: "\\e8c7";
}

.icon-slack:before {
  content: "\\e8c8";
}

.icon-slash:before {
  content: "\\e8c9";
}

.icon-smartphone:before {
  content: "\\e8ca";
}

.icon-square:before {
  content: "\\e8cb";
}

.icon-speaker:before {
  content: "\\e8cc";
}

.icon-star:before {
  content: "\\e8cd";
}

.icon-stop-circle:before {
  content: "\\e8ce";
}

.icon-sun:before {
  content: "\\e8cf";
}

.icon-sunrise:before {
  content: "\\e8d0";
}

.icon-tablet:before {
  content: "\\e8d1";
}

.icon-tag:before {
  content: "\\e8d2";
}

.icon-sunset:before {
  content: "\\e8d3";
}

.icon-target:before {
  content: "\\e8d4";
}

.icon-thermometer:before {
  content: "\\e8d5";
}

.icon-thumbs-up:before {
  content: "\\e8d6";
}

.icon-thumbs-down:before {
  content: "\\e8d7";
}

.icon-toggle-left:before {
  content: "\\e8d8";
}

.icon-toggle-right:before {
  content: "\\e8d9";
}

.icon-trash-2:before {
  content: "\\e8da";
}

.icon-trash:before {
  content: "\\e8db";
}

.icon-trending-up:before {
  content: "\\e8dc";
}

.icon-trending-down:before {
  content: "\\e8dd";
}

.icon-triangle:before {
  content: "\\e8de";
}

.icon-type:before {
  content: "\\e8df";
}

.icon-twitter:before {
  content: "\\e8e0";
}

.icon-upload:before {
  content: "\\e8e1";
}

.icon-umbrella:before {
  content: "\\e8e2";
}

.icon-upload-cloud:before {
  content: "\\e8e3";
}

.icon-unlock:before {
  content: "\\e8e4";
}

.icon-user-check:before {
  content: "\\e8e5";
}

.icon-user-minus:before {
  content: "\\e8e6";
}

.icon-user-plus:before {
  content: "\\e8e7";
}

.icon-user-x:before {
  content: "\\e8e8";
}

.icon-user:before {
  content: "\\e8e9";
}

.icon-users:before {
  content: "\\e8ea";
}

.icon-video-off:before {
  content: "\\e8eb";
}

.icon-video:before {
  content: "\\e8ec";
}

.icon-voicemail:before {
  content: "\\e8ed";
}

.icon-volume-x:before {
  content: "\\e8ee";
}

.icon-volume-2:before {
  content: "\\e8ef";
}

.icon-volume-1:before {
  content: "\\e8f0";
}

.icon-volume:before {
  content: "\\e8f1";
}

.icon-watch:before {
  content: "\\e8f2";
}

.icon-wifi:before {
  content: "\\e8f3";
}

.icon-x-square:before {
  content: "\\e8f4";
}

.icon-wind:before {
  content: "\\e8f5";
}

.icon-x:before {
  content: "\\e8f6";
}

.icon-x-circle:before {
  content: "\\e8f7";
}

.icon-zap:before {
  content: "\\e8f8";
}

.icon-zoom-in:before {
  content: "\\e8f9";
}

.icon-zoom-out:before {
  content: "\\e8fa";
}

.icon-command:before {
  content: "\\e8fb";
}

.icon-cloud:before {
  content: "\\e8fc";
}

.icon-hash:before {
  content: "\\e8fd";
}

.icon-headphones:before {
  content: "\\e8fe";
}

.icon-underline:before {
  content: "\\e8ff";
}

.icon-italic:before {
  content: "\\e900";
}

.icon-bold:before {
  content: "\\e901";
}

.icon-crop:before {
  content: "\\e902";
}

.icon-help-circle:before {
  content: "\\e903";
}

.icon-paperclip:before {
  content: "\\e904";
}

.icon-shopping-cart:before {
  content: "\\e905";
}

.icon-tv:before {
  content: "\\e906";
}

.icon-wifi-off:before {
  content: "\\e907";
}

.icon-minimize:before {
  content: "\\e88d";
}

.icon-maximize:before {
  content: "\\e908";
}

.icon-gitlab:before {
  content: "\\e909";
}

.icon-sliders:before {
  content: "\\e90a";
}

.icon-star-on:before {
  content: "\\e90b";
}

.icon-heart-on:before {
  content: "\\e90c";
}

.icon-archive:before {
  content: "\\e90d";
}

.icon-arrow-down-circle:before {
  content: "\\e90e";
}

.icon-arrow-up-circle:before {
  content: "\\e90f";
}

.icon-arrow-left-circle:before {
  content: "\\e910";
}

.icon-arrow-right-circle:before {
  content: "\\e911";
}

.icon-bar-chart-line-:before {
  content: "\\e912";
}

.icon-bar-chart-line:before {
  content: "\\e913";
}

.icon-book-open:before {
  content: "\\e914";
}

.icon-code:before {
  content: "\\e915";
}

.icon-database:before {
  content: "\\e916";
}

.icon-dollar-sign:before {
  content: "\\e917";
}

.icon-folder-plus:before {
  content: "\\e918";
}

.icon-gift:before {
  content: "\\e919";
}

.icon-folder-minus:before {
  content: "\\e91a";
}

.icon-git-commit:before {
  content: "\\e91b";
}

.icon-git-branch:before {
  content: "\\e91c";
}

.icon-git-pull-request:before {
  content: "\\e91d";
}

.icon-git-merge:before {
  content: "\\e91e";
}

.icon-linkedin:before {
  content: "\\e91f";
}

.icon-hard-drive:before {
  content: "\\e920";
}

.icon-more-vertical-:before {
  content: "\\e921";
}

.icon-more-horizontal-:before {
  content: "\\e922";
}

.icon-rss:before {
  content: "\\e923";
}

.icon-send:before {
  content: "\\e924";
}

.icon-shield-off:before {
  content: "\\e925";
}

.icon-shopping-bag:before {
  content: "\\e926";
}

.icon-terminal:before {
  content: "\\e927";
}

.icon-truck:before {
  content: "\\e928";
}

.icon-zap-off:before {
  content: "\\e929";
}

.icon-youtube:before {
  content: "\\e92a";
}

/*========================================================
        DARK LAYOUT
=========================================================*/
html[dir=rtl] .sales-card .img-left {
  left: 0;
  right: auto;
}
html[dir=rtl] .sales-card .img-right {
  right: 0;
}
html[dir=rtl] .breadcrum-right .dropdown-toggle svg {
  right: 0;
}
html[dir=rtl] .breadcrumb-wrapper .breadcrumb .breadcrumb-item:before {
  transform: rotate(180deg);
}
html[dir=rtl] .dropup-form .dropdown-menu {
  min-width: 16rem;
}
html[dir=rtl] .main-menu ul.navigation-main .nav-item:not(.open) svg.menu-toggle-icon {
  transform: rotate(180deg);
}
html[dir=rtl] .main-menu ul.navigation-main .nav-item.open svg.menu-toggle-icon {
  transform: rotate(90deg) !important;
}
html[dir=rtl] .ag-rtl {
  direction: rtl;
}
html[dir=rtl] .ag-rtl .ag-header-select-all {
  margin-right: 0 !important;
  margin-left: 24px !important;
}
html[dir=rtl] .ag-rtl .ag-cell-value {
  margin-left: 0 !important;
  margin-right: 24px !important;
}
html[dir=rtl] .component-code pre {
  text-align: left;
}
html[dir=rtl] .recharts-layer {
  direction: ltr;
}
html[dir=rtl] .react-contexify {
  z-index: 1031;
}
html[dir=rtl] .email-application .content-right .app-fixed-search .sidebar-toggle {
  margin-left: 0;
}
html[dir=rtl] .email-application .content-right .email-detail-header .dropdown .dropdown-menu, html[dir=rtl] .email-application .content-right .app-action .dropdown .dropdown-menu {
  transform: translate3d(0px, 22px, 0px) !important;
}
html[dir=rtl] .carousel .carousel-control-prev .carousel-control-prev-icon,
html[dir=rtl] .carousel .carousel-control-prev .carousel-control-next-icon,
html[dir=rtl] .carousel .carousel-control-next .carousel-control-prev-icon,
html[dir=rtl] .carousel .carousel-control-next .carousel-control-next-icon {
  transform: rotate(180deg);
}
html[dir=rtl] .pagination .prev-item a svg,
html[dir=rtl] .pagination .previous a svg,
html[dir=rtl] .pagination .next-item a svg,
html[dir=rtl] .pagination .next a svg,
html[dir=rtl] .vx-pagination .prev-item a svg,
html[dir=rtl] .vx-pagination .previous a svg,
html[dir=rtl] .vx-pagination .next-item a svg,
html[dir=rtl] .vx-pagination .next a svg {
  transform: rotate(180deg);
}
html[dir=rtl] .pagination li:first-child a span svg,
html[dir=rtl] .pagination li:last-child a span svg,
html[dir=rtl] .vx-pagination li:first-child a span svg,
html[dir=rtl] .vx-pagination li:last-child a span svg {
  transform: rotate(180deg);
}
html[dir=rtl] .swiper-container .swiper-button-next:after,
html[dir=rtl] .swiper-container .swiper-button-prev:after {
  transform: rotate(180deg);
}
html[dir=rtl] .swiper-container-cube.swiper-container-rtl .swiper-slide {
  transform-origin: 100% 0 !important;
}
html[dir=rtl] .rc-slider-tooltip {
  right: 50%;
  width: 30px;
}
html[dir=rtl] .rc-slider-vertical .rc-slider-dot {
  right: -1px;
}
html[dir=rtl] .horizontal-layout .horizontal-menu-wrapper #main-menu-navigation .nav-item .has-sub svg.has-sub-arrow {
  transform: rotate(180deg);
}
html[dir=rtl] .horizontal-layout .horizontal-menu-wrapper #main-menu-navigation .dropdown-menu {
  right: 0 !important;
  left: auto !important;
  top: 100% !important;
}
html[dir=rtl] .horizontal-layout .horizontal-menu-wrapper #main-menu-navigation .dropdown-menu .dropdown-menu {
  left: auto !important;
  right: 100% !important;
  top: 0 !important;
}
html[dir=rtl] .main-menu .navigation > li ul li > a {
  display: flex;
  align-items: center;
}
html[dir=rtl] .header-navbar .navbar-container ul.nav li.dropdown .dropdown-menu {
  margin-top: 0;
}
html[dir=rtl] .header-navbar .navbar-container ul.nav li.dropdown .dropdown-menu::before {
  top: 1px;
}
html[dir=rtl] .header-navbar .dropdown .dropdown-menu.dropdown-menu-right::before,
html[dir=rtl] .header-navbar .dropup .dropdown-menu.dropdown-menu-right::before {
  right: auto;
  left: 0.5rem;
}
html[dir=rtl] .dropdown .dropdown-menu,
html[dir=rtl] .dropup .dropdown-menu {
  right: auto !important;
  top: 0 !important;
  left: auto !important;
}
html[dir=rtl] .dropdown .dropdown-menu.dropdown-menu-right,
html[dir=rtl] .dropup .dropdown-menu.dropdown-menu-right {
  left: auto !important;
  right: 0 !important;
}
html[dir=rtl] .dropdown .dropdown-menu.dropdown-menu-right::before,
html[dir=rtl] .dropup .dropdown-menu.dropdown-menu-right::before {
  right: 0.6rem;
  left: auto;
}
html[dir=rtl] .input-group .dropdown-menu.show {
  top: 0 !important;
  right: auto !important;
  left: 0px !important;
}
html[dir=rtl] .context-menu-list {
  z-index: 1031 !important;
}
html[dir=rtl] code[class*=language-],
html[dir=rtl] pre[class*=language-] {
  direction: ltr;
}
@media print {
  html[dir=rtl] code[class*=language-],
  html[dir=rtl] pre[class*=language-] {
    text-shadow: none;
  }
}
html[dir=rtl] .app-calendar .calendar-navigation .btn svg {
  transform: rotate(180deg);
}
html[dir=rtl] .bs-tooltip-left .arrow::before,
html[dir=rtl] .bs-tooltip-auto[x-placement^=left] .arrow::before {
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #323232;
}
html[dir=rtl] .bs-tooltip-left .arrow,
html[dir=rtl] .bs-tooltip-auto[x-placement^=left] .arrow {
  right: 0;
  left: auto;
}
html[dir=rtl] .bs-tooltip-right .arrow::before,
html[dir=rtl] .bs-tooltip-auto[x-placement^=right] .arrow::before {
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #323232;
}
html[dir=rtl] .bs-tooltip-right .arrow,
html[dir=rtl] .bs-tooltip-auto[x-placement^=right] .arrow {
  left: 0;
  right: auto;
}
html[dir=rtl] .popover {
  right: auto !important;
}
html[dir=rtl] body .ps__rail-y {
  right: auto !important;
  left: 1px !important;
}

@media (max-width: 1200px) {
  html[dir=rtl] .vertical-layout.menu-collapsed .app-content {
    margin-right: 0;
  }
}
@media (max-width: 575.98px) {
  html[dir=rtl] .vertical-layout .navbar-container .header-navbar ul.nav .nav-item.dropdown .dropdown-menu {
    left: 12px !important;
  }
  html[dir=rtl] .vertical-layout .navbar-container .header-navbar ul.nav .nav-item.dropdown .dropdown-menu.dropdown-menu-media {
    left: 15px !important;
    right: -15px !important;
  }
  html[dir=rtl] .vertical-layout .navbar-container .header-navbar ul.nav .nav-item.dropdown.dropdown-notification .dropdown-menu {
    transform: translate3d(-12px, 62px, 0px) !important;
  }
  html[dir=rtl] .vertical-layout .navbar-container .header-navbar ul.nav .nav-item.dropdown.dropdown-notification .dropdown-menu.dropdown-cart {
    transform: translate3d(-12px, 59px, 0px) !important;
  }
  html[dir=rtl] .vertical-layout .navbar-container .header-navbar ul.nav .nav-item.dropdown.dropdown-user .dropdown-menu {
    transform: translate3d(20px, 60px, 0px) !important;
  }
  html[dir=rtl] .vertical-layout .navbar-container .header-navbar ul.nav .nav-item.dropdown.dropdown-language .dropdown-menu {
    right: 28px !important;
  }
}
@media (min-width: 769px) {
  html[dir=rtl] .header-navbar .dropdown.dropdown-notification .dropdown-menu {
    transform: translate3d(324px, 62px, 0px) !important;
  }
  html[dir=rtl] .header-navbar .dropdown.dropdown-notification .dropdown-menu.dropdowncart {
    transform: translate3d(335px, 62px, 0px) !important;
  }
  html[dir=rtl] .header-navbar .dropdown.dropdown-user .dropdown-menu {
    transform: translate3d(20px, 60px, 0px) !important;
  }
  html[dir=rtl] .header-navbar .dropdown.dropdown-language .dropdown-menu {
    transform: translate3d(114px, 64px, 0px) !important;
  }
}
@media (max-width: 768px) {
  html[dir=rtl] .app-content .header-navbar .dropdown.dropdown-notification .dropdown-menu {
    transform: translate3d(26px, 59px, 0px) !important;
  }
  html[dir=rtl] .app-content .header-navbar .dropdown.dropdown-notification .dropdown-menu.dropdown-cart {
    transform: translate3d(26px, 59px, 0px) !important;
  }
  html[dir=rtl] .app-content .header-navbar .dropdown.dropdown-user .dropdown-menu {
    left: 0 !important;
    right: 28px !important;
  }
  html[dir=rtl] .app-content .header-navbar .dropdown.dropdown-language .dropdown-menu {
    transform: translate3d(26px, 64px, 0px) !important;
  }
}
* {
  font-family: "Montserrat", sans-serif;
}

.uploadFormGroup {
  display: flex;
  flex-direction: column;
}

.uploadFormGroup .uploadButton {
  align-self: center;
  align-items: center;
}

.image-crop-modal {
  min-width: 80%;
  min-height: 70%;
}

.image-crop-modal-body {
  text-align: center;
}

.ag-root.ag-layout-normal {
  /* height: 100%; */
  height: -moz-fit-content;
  height: fit-content;
}

.ag-grid-table {
  height: 750px !important;
}

.ag-paging-description span {
  display: initial !important;
}

.ag-paging-page-summary-panel .ag-paging-number {
  display: none;
}

.breadcrumb-item {
  color: #7367f0;
  text-decoration: none;
  cursor: pointer;
}

.delete-modal {
  min-width: -moz-fit-content;
  min-width: fit-content;
}

.textarea-auto textarea {
  min-height: 200px;
}`, "",{"version":3,"sources":["webpack://./src/index.scss","webpack://./node_modules/prismjs/themes/prism-tomorrow.css","webpack://./src/assets/scss/bootstrap.scss","webpack://./node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/mixins/_color-mode.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./src/assets/scss/core/variables/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss","webpack://./src/assets/scss/core/variables/_components-variables.scss","webpack://./src/assets/scss/core/layouts/_content.scss","webpack://./src/assets/scss/core/layouts/_sidebar.scss","webpack://./src/assets/scss/core/layouts/_footer.scss","webpack://./src/assets/scss/core/menu/_navigation.scss","webpack://./src/assets/scss/core/mixins/main-menu-mixin.scss","webpack://./src/assets/scss/core/menu/horizontal-menu.scss","webpack://./src/assets/scss/components/helper.scss","webpack://./src/assets/scss/components/avatar.scss","webpack://./src/assets/scss/components/search.scss","webpack://./src/assets/scss/components/chart.scss","webpack://./src/assets/scss/components/bootstrap-social.scss","webpack://./src/assets/scss/components/demo.scss","webpack://./src/assets/scss/components/customizer.scss","webpack://./src/assets/scss/components/chips.scss","webpack://./src/assets/scss/components/divider.scss","webpack://./src/assets/scss/components/wizard.scss","webpack://./src/assets/scss/components/autocomplete.scss","webpack://./src/assets/scss/components/app-loader.scss","webpack://./src/assets/scss/components/chat-widget.scss","webpack://./src/assets/scss/plugins/ui/_breakpoints.scss","webpack://./src/assets/scss/plugins/forms/tags/_basic-input.scss","webpack://./src/assets/scss/plugins/tables/_datatables.scss","webpack://./src/assets/scss/themes/dark-layout.scss","webpack://./src/assets/scss/themes/semi-dark-layout.scss","webpack://./src/assets/scss/bootstrap-extended/_reboot.scss","webpack://./src/assets/scss/bootstrap-extended/_type.scss","webpack://./src/assets/scss/bootstrap-extended/mixins/_type.scss","webpack://./src/assets/scss/bootstrap-extended/_code.scss","webpack://./src/assets/scss/bootstrap-extended/_grid.scss","webpack://./src/assets/scss/bootstrap-extended/_tables.scss","webpack://./src/assets/scss/bootstrap-extended/_forms.scss","webpack://./src/assets/scss/bootstrap-extended/_buttons.scss","webpack://./src/assets/scss/bootstrap-extended/_animation.scss","webpack://./src/assets/scss/bootstrap-extended/_dropdown.scss","webpack://./src/assets/scss/bootstrap-extended/_navbar.scss","webpack://./src/assets/scss/bootstrap-extended/_card.scss","webpack://./src/assets/scss/bootstrap-extended/_breadcrumb.scss","webpack://./src/assets/scss/bootstrap-extended/_badge.scss","webpack://./src/assets/scss/bootstrap-extended/_nav.scss","webpack://./src/assets/scss/bootstrap-extended/mixins/_navs.scss","webpack://./src/assets/scss/bootstrap-extended/_alert.scss","webpack://./src/assets/scss/core/mixins/alert.scss","webpack://./src/assets/scss/bootstrap-extended/_media.scss","webpack://./src/assets/scss/bootstrap-extended/_progress.scss","webpack://./src/assets/scss/bootstrap-extended/_list-group.scss","webpack://./src/assets/scss/bootstrap-extended/_toast.scss","webpack://./src/assets/scss/bootstrap-extended/_collapse.scss","webpack://./src/assets/scss/bootstrap-extended/_pagination.scss","webpack://./src/assets/scss/bootstrap-extended/_spinners.scss","webpack://./src/assets/scss/bootstrap-extended/_modal.scss","webpack://./src/assets/scss/bootstrap-extended/_popover.scss","webpack://./src/assets/scss/bootstrap-extended/_utilities.scss","webpack://./src/assets/scss/core/colors/palette-gradient.scss","webpack://./src/assets/scss/core/colors/_palette.scss","webpack://./src/assets/scss/core/mixins/hex2rgb.scss","webpack://./src/assets/scss/core/colors/palette-variables.scss","webpack://./src/assets/scss/iconfont.scss","webpack://./src/assets/scss/custom-rtl.scss","webpack://./src/assets/scss/app.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;;EAAA;AAMA;;EAEC,WAAA;EACA,gBAAA;EACA,sEAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EAIA,WAAA;EAKA,aAAA;ADDD;;ACKA,gBAAA;AACA;EACC,YAAA;EACA,eAAA;EACA,cAAA;ADFD;;ACKA;;EAEC,mBAAA;ADFD;;ACKA,gBAAA;AACA;EACC,cAAA;EACA,oBAAA;EACA,mBAAA;ADFD;;ACKA;;;;;EAKC,WAAA;ADFD;;ACKA;EACC,WAAA;ADFD;;ACKA;;;;EAIC,cAAA;ADFD;;ACKA;EACC,cAAA;ADFD;;ACKA;;;EAGC,cAAA;ADFD;;ACKA;;;;EAIC,cAAA;ADFD;;ACKA;;;;;EAKC,cAAA;ADFD;;ACKA;;;;;EAKC,cAAA;ADFD;;ACKA;;;EAGC,cAAA;ADFD;;ACKA;;EAEC,iBAAA;ADFD;;ACIA;EACC,kBAAA;ADDD;;ACIA;EACC,YAAA;ADDD;;ACIA;EACC,YAAA;ADDD;;AEvHA;;;;;EAAA;ACCE;;;;EAAA;ACDF;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAIA,+BAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,0BAAA;EAAA,8BAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,yBAAA;EAIA,6CAAA;EAAA,mDAAA;EAAA,+CAAA;EAAA,2CAAA;EAAA,gDAAA;EAAA,8CAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,4CAAA;EAAA,kDAAA;EAAA,8CAAA;EAAA,2CAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,0CAAA;EAAA,4BAAA;EAIA,gDAAA;EAAA,sDAAA;EAAA,kDAAA;EAAA,+CAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,0BAAA;EAMA,2DAAA;EACA,0DAAA;EACA,yFAAA;EAOA,gDAAA;EC2OI,yBALI;EDpOR,0BAAA;EACA,2BAAA;EAKA,wBAAA;EACA,+BAAA;EACA,qBAAA;EACA,+BAAA;EAEA,4BAAA;EACA,mCAAA;EAEA,4CAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EAEA,0CAAA;EACA,mCAAA;EACA,yBAAA;EACA,mCAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,kCAAA;EACA,+BAAA;EAEA,uEAAA;EACA,sCAAA;EAGE,gCAAA;EAGF,wBAAA;EACA,6BAAA;EACA,yCAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,sDAAA;EAEA,0BAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,qDAAA;EACA,8DAAA;EACA,uDAAA;EACA,8DAAA;EAIA,8BAAA;EACA,6BAAA;EACA,gDAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AJ6HF;;AM7OI;EFsHA,kBAAA;EAGA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,sCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,yBAAA;EACA,gCAAA;EAGE,gDAAA;EAAA,sDAAA;EAAA,kDAAA;EAAA,+CAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,yCAAA;EAAA,+CAAA;EAAA,0CAAA;EAAA,uCAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,6BAAA;EAAA,wCAAA;EAIA,8CAAA;EAAA,sDAAA;EAAA,gDAAA;EAAA,6CAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,2BAAA;EAEA,qCAAA;EACA,gDAAA;EACA,kCAAA;EACA,wCAAA;EAEA,yCAAA;EACA,6BAAA;EACA,sCAAA;EAEA,0BAAA;EACA,wDAAA;EAEA,6CAAA;EACA,oDAAA;EACA,+CAAA;EACA,sDAAA;AJ6HJ;;AOrSA;;;EAGE,sBAAA;APwSF;;AOzRI;EANJ;IAOM,uBAAA;EP6RJ;AACF;;AOhRA;EACE,SAAA;EACA,uCAAA;EF6OI,mCALI;EEtOR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,gDAAA;APmRF;;AO1QA;EACE,cAAA;EACA,cCmnB4B;EDlnB5B,SAAA;EACA,wCAAA;EACA,aCynB4B;AR5W9B;;AOnQA;EACE,aAAA;EACA,qBE+CuB;EF9CvB,oBE+CqB;EF7CrB,gBE8CqB;EF7CrB,gBCwjB4B;EDvjB5B,8BAAA;APqQF;;AOlQA;EFuMQ,iCAAA;AL+DR;AK3NI;EE3CJ;IF8MQ,eAAA;EL4DN;AACF;;AOtQA;EFkMQ,mCAAA;ALwER;AKpOI;EEtCJ;IFyMQ,kBAAA;ELqEN;AACF;;AO1QA;EF6LQ,mCAAA;ALiFR;AK7OI;EEjCJ;IFoMQ,kBAAA;EL8EN;AACF;;AO9QA;EFwLQ,mCAAA;AL0FR;AKtPI;EE5BJ;IF+LQ,kBAAA;ELuFN;AACF;;AOlRA;EF+KM,kBALI;AL4GV;;AOjRA;EF0KM,eALI;ALgHV;;AO1QA;EACE,aAAA;EACA,mBCwV0B;AR3E5B;;AOnQA;EACE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,8BAAA;APsQF;;AOhQA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;APmQF;;AO7PA;;EAEE,kBAAA;APgQF;;AO7PA;;;EAGE,aAAA;EACA,mBAAA;APgQF;;AO7PA;;;;EAIE,gBAAA;APgQF;;AO7PA;EACE,gBC6b4B;AR7L9B;;AO3PA;EACE,qBAAA;EACA,cAAA;AP8PF;;AOxPA;EACE,gBAAA;AP2PF;;AOnPA;;EAEE,mBCsa4B;ARhL9B;;AO9OA;EF6EM,kBALI;AL0KV;;AO3OA;EACE,iBCqf4B;EDpf5B,gCAAA;EACA,wCAAA;AP8OF;;AOrOA;;EAEE,kBAAA;EFwDI,iBALI;EEjDR,cAAA;EACA,wBAAA;APwOF;;AOrOA;EAAM,eAAA;APyON;;AOxOA;EAAM,WAAA;AP4ON;;AOvOA;EACE,gEAAA;EACA,0BCgNwC;AR0B1C;AOxOE;EACE,mDAAA;EACA,qBEhKoB;AT0YxB;;AOhOE;EAEE,cAAA;EACA,qBAAA;APkOJ;;AO3NA;;;;EAIE,qCCgV4B;EHlUxB,cALI;ALsNV;;AOvNA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFEI,cALI;AL8NV;AOtNE;EFHI,kBALI;EEUN,cAAA;EACA,kBAAA;APwNJ;;AOpNA;EFVM,cALI;EEiBR,2BAAA;EACA,qBAAA;APuNF;AOpNE;EACE,cAAA;APsNJ;;AOlNA;EACE,2BAAA;EFtBI,cALI;EE6BR,wBCy5CkC;EDx5ClC,sBE9CO;ECvPL,sBAAA;AV2fJ;AOnNE;EACE,UAAA;EF7BE,cALI;ALwPV;;AO3MA;EACE,gBAAA;AP8MF;;AOxMA;;EAEE,sBAAA;AP2MF;;AOnMA;EACE,oBAAA;EACA,yBAAA;APsMF;;AOnMA;EACE,mBC4X4B;ED3X5B,sBC2X4B;ED1X5B,gCC4Z4B;ED3Z5B,gBAAA;APsMF;;AO/LA;EAEE,mBAAA;EACA,gCAAA;APiMF;;AO9LA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;APiMF;;AOzLA;EACE,qBAAA;AP4LF;;AOtLA;EAEE,gBAAA;APwLF;;AOhLA;EACE,UAAA;APmLF;;AO9KA;;;;;EAKE,SAAA;EACA,oBAAA;EF5HI,kBALI;EEmIR,oBAAA;APiLF;;AO7KA;;EAEE,oBAAA;APgLF;;AO3KA;EACE,eAAA;AP8KF;;AO3KA;EAGE,iBAAA;AP4KF;AOzKE;EACE,UAAA;AP2KJ;;AOpKA;EACE,wBAAA;APuKF;;AO/JA;;;;EAIE,0BAAA;APkKF;AO/JI;;;;EACE,eAAA;APoKN;;AO7JA;EACE,UAAA;EACA,kBAAA;APgKF;;AO3JA;EACE,gBAAA;AP8JF;;AOpJA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;APuJF;;AO/IA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBCmN4B;EHpatB,iCAAA;EEoNN,oBAAA;APiJF;AKjgBI;EEyWJ;IFtMQ,iBAAA;ELkWN;AACF;AOpJE;EACE,WAAA;APsJJ;;AO/IA;;;;;;;EAOE,UAAA;APkJF;;AO/IA;EACE,YAAA;APkJF;;AOzIA;EACE,6BAAA;EACA,oBAAA;AP4IF;;AOpIA;;;;;;;CAAA;AAWA;EACE,wBAAA;APoIF;;AO/HA;EACE,UAAA;APkIF;;AO3HA;EACE,aAAA;EACA,0BAAA;AP8HF;;AOzHA;EACE,qBAAA;AP4HF;;AOvHA;EACE,SAAA;AP0HF;;AOnHA;EACE,kBAAA;EACA,eAAA;APsHF;;AO9GA;EACE,wBAAA;APiHF;;AOzGA;EACE,wBAAA;AP4GF;;AWjrBA;ENmQM,kBALI;EM5PR,gBHwoB4B;AR4C9B;;AW/qBE;ENgQM,iCAAA;EM5PJ,gBHynBkB;EGxnBlB,gBHwmB0B;ARwE9B;AKjlBI;EMpGF;INuQM,eAAA;ELkbN;AACF;;AW1rBE;ENgQM,iCAAA;EM5PJ,gBHynBkB;EGxnBlB,gBHwmB0B;ARmF9B;AK5lBI;EMpGF;INuQM,iBAAA;EL6bN;AACF;;AWrsBE;ENgQM,iCAAA;EM5PJ,gBHynBkB;EGxnBlB,gBHwmB0B;AR8F9B;AKvmBI;EMpGF;INuQM,eAAA;ELwcN;AACF;;AWhtBE;ENgQM,iCAAA;EM5PJ,gBHynBkB;EGxnBlB,gBHwmB0B;ARyG9B;AKlnBI;EMpGF;INuQM,iBAAA;ELmdN;AACF;;AW3tBE;ENgQM,iCAAA;EM5PJ,gBHynBkB;EGxnBlB,gBHwmB0B;ARoH9B;AK7nBI;EMpGF;INuQM,eAAA;EL8dN;AACF;;AWtuBE;ENgQM,iCAAA;EM5PJ,gBHynBkB;EGxnBlB,gBHwmB0B;AR+H9B;AKxoBI;EMpGF;INuQM,iBAAA;ELyeN;AACF;;AWztBA;ECvDE,eAAA;EACA,gBAAA;AZoxBF;;AWztBA;EC5DE,eAAA;EACA,gBAAA;AZyxBF;;AW3tBA;EACE,qBAAA;AX8tBF;AW5tBE;EACE,oBHsoB0B;ARwF9B;;AWptBA;EN8MM,kBALI;EMvMR,yBAAA;AXutBF;;AWntBA;EACE,mBF9CO;EJqPH,kBALI;ALqhBV;AWptBE;EACE,gBAAA;AXstBJ;;AWltBA;EACE,iBAAA;EACA,mBFxDO;EJqPH,kBALI;EMtLR,cFjFS;ATsyBX;AWntBE;EACE,aAAA;AXqtBJ;;AarzBA;ECIE,eAAA;EAGA,YAAA;AdmzBF;;AapzBA;EACE,gBL+jDkC;EK9jDlC,mCL+jDkC;EK9jDlC,2DAAA;EHGE,sCAAA;EIRF,eAAA;EAGA,YAAA;Ad4zBF;;Aa9yBA;EAEE,qBAAA;AbgzBF;;Aa7yBA;EACE,qBAAA;EACA,cAAA;AbgzBF;;Aa7yBA;ERyPM,kBALI;EQlPR,gCLkjDkC;ARlwBpC;;Ael1BE;;;;;;;ECHA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;AhB+1BF;;AiBzyBI;EF5CE;IACE,gBPkee;ERuXrB;AACF;AiB/yBI;EF5CE;IACE,gBPkee;ER4XrB;AACF;AiBpzBI;EF5CE;IACE,gBPkee;ERiYrB;AACF;AiBzzBI;EF5CE;IACE,iBPkee;ERsYrB;AACF;AiB9zBI;EF5CE;IACE,iBPkee;ER2YrB;AACF;AkB93BA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;AlBo4BJ;;AkB/3BE;ECNA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AnBw4BF;AkBt4BI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AnBk4BF;;AmBn1BM;EACE,SAAA;AnBs1BR;;AmBn1BM;EApCJ,cAAA;EACA,WAAA;AnB23BF;;AmB72BE;EACE,cAAA;EACA,WAAA;AnBg3BJ;;AmBl3BE;EACE,cAAA;EACA,UAAA;AnBq3BJ;;AmBv3BE;EACE,cAAA;EACA,mBAAA;AnB03BJ;;AmB53BE;EACE,cAAA;EACA,UAAA;AnB+3BJ;;AmBj4BE;EACE,cAAA;EACA,UAAA;AnBo4BJ;;AmBt4BE;EACE,cAAA;EACA,mBAAA;AnBy4BJ;;AmB12BM;EAhDJ,cAAA;EACA,WAAA;AnB85BF;;AmBz2BU;EAhEN,cAAA;EACA,kBAAA;AnB66BJ;;AmB92BU;EAhEN,cAAA;EACA,mBAAA;AnBk7BJ;;AmBn3BU;EAhEN,cAAA;EACA,UAAA;AnBu7BJ;;AmBx3BU;EAhEN,cAAA;EACA,mBAAA;AnB47BJ;;AmB73BU;EAhEN,cAAA;EACA,mBAAA;AnBi8BJ;;AmBl4BU;EAhEN,cAAA;EACA,UAAA;AnBs8BJ;;AmBv4BU;EAhEN,cAAA;EACA,mBAAA;AnB28BJ;;AmB54BU;EAhEN,cAAA;EACA,mBAAA;AnBg9BJ;;AmBj5BU;EAhEN,cAAA;EACA,UAAA;AnBq9BJ;;AmBt5BU;EAhEN,cAAA;EACA,mBAAA;AnB09BJ;;AmB35BU;EAhEN,cAAA;EACA,mBAAA;AnB+9BJ;;AmBh6BU;EAhEN,cAAA;EACA,WAAA;AnBo+BJ;;AmB75BY;EAxDV,wBAAA;AnBy9BF;;AmBj6BY;EAxDV,yBAAA;AnB69BF;;AmBr6BY;EAxDV,gBAAA;AnBi+BF;;AmBz6BY;EAxDV,yBAAA;AnBq+BF;;AmB76BY;EAxDV,yBAAA;AnBy+BF;;AmBj7BY;EAxDV,gBAAA;AnB6+BF;;AmBr7BY;EAxDV,yBAAA;AnBi/BF;;AmBz7BY;EAxDV,yBAAA;AnBq/BF;;AmB77BY;EAxDV,gBAAA;AnBy/BF;;AmBj8BY;EAxDV,yBAAA;AnB6/BF;;AmBr8BY;EAxDV,yBAAA;AnBigCF;;AmB97BQ;;EAEE,gBAAA;AnBi8BV;;AmB97BQ;;EAEE,gBAAA;AnBi8BV;;AmBx8BQ;;EAEE,sBAAA;AnB28BV;;AmBx8BQ;;EAEE,sBAAA;AnB28BV;;AmBl9BQ;;EAEE,qBAAA;AnBq9BV;;AmBl9BQ;;EAEE,qBAAA;AnBq9BV;;AmB59BQ;;EAEE,sBAAA;AnB+9BV;;AmB59BQ;;EAEE,sBAAA;AnB+9BV;;AmBt+BQ;;EAEE,mBAAA;AnBy+BV;;AmBt+BQ;;EAEE,mBAAA;AnBy+BV;;AmBh/BQ;;EAEE,qBAAA;AnBm/BV;;AmBh/BQ;;EAEE,qBAAA;AnBm/BV;;AmB1/BQ;;EAEE,mBAAA;AnB6/BV;;AmB1/BQ;;EAEE,mBAAA;AnB6/BV;;AmBpgCQ;;EAEE,qBAAA;AnBugCV;;AmBpgCQ;;EAEE,qBAAA;AnBugCV;;AmB9gCQ;;EAEE,mBAAA;AnBihCV;;AmB9gCQ;;EAEE,mBAAA;AnBihCV;;AiB3kCI;EEUE;IACE,SAAA;EnBqkCN;EmBlkCI;IApCJ,cAAA;IACA,WAAA;EnBymCA;EmB3lCA;IACE,cAAA;IACA,WAAA;EnB6lCF;EmB/lCA;IACE,cAAA;IACA,UAAA;EnBimCF;EmBnmCA;IACE,cAAA;IACA,mBAAA;EnBqmCF;EmBvmCA;IACE,cAAA;IACA,UAAA;EnBymCF;EmB3mCA;IACE,cAAA;IACA,UAAA;EnB6mCF;EmB/mCA;IACE,cAAA;IACA,mBAAA;EnBinCF;EmBllCI;IAhDJ,cAAA;IACA,WAAA;EnBqoCA;EmBhlCQ;IAhEN,cAAA;IACA,kBAAA;EnBmpCF;EmBplCQ;IAhEN,cAAA;IACA,mBAAA;EnBupCF;EmBxlCQ;IAhEN,cAAA;IACA,UAAA;EnB2pCF;EmB5lCQ;IAhEN,cAAA;IACA,mBAAA;EnB+pCF;EmBhmCQ;IAhEN,cAAA;IACA,mBAAA;EnBmqCF;EmBpmCQ;IAhEN,cAAA;IACA,UAAA;EnBuqCF;EmBxmCQ;IAhEN,cAAA;IACA,mBAAA;EnB2qCF;EmB5mCQ;IAhEN,cAAA;IACA,mBAAA;EnB+qCF;EmBhnCQ;IAhEN,cAAA;IACA,UAAA;EnBmrCF;EmBpnCQ;IAhEN,cAAA;IACA,mBAAA;EnBurCF;EmBxnCQ;IAhEN,cAAA;IACA,mBAAA;EnB2rCF;EmB5nCQ;IAhEN,cAAA;IACA,WAAA;EnB+rCF;EmBxnCU;IAxDV,cAAA;EnBmrCA;EmB3nCU;IAxDV,wBAAA;EnBsrCA;EmB9nCU;IAxDV,yBAAA;EnByrCA;EmBjoCU;IAxDV,gBAAA;EnB4rCA;EmBpoCU;IAxDV,yBAAA;EnB+rCA;EmBvoCU;IAxDV,yBAAA;EnBksCA;EmB1oCU;IAxDV,gBAAA;EnBqsCA;EmB7oCU;IAxDV,yBAAA;EnBwsCA;EmBhpCU;IAxDV,yBAAA;EnB2sCA;EmBnpCU;IAxDV,gBAAA;EnB8sCA;EmBtpCU;IAxDV,yBAAA;EnBitCA;EmBzpCU;IAxDV,yBAAA;EnBotCA;EmBjpCM;;IAEE,gBAAA;EnBmpCR;EmBhpCM;;IAEE,gBAAA;EnBkpCR;EmBzpCM;;IAEE,sBAAA;EnB2pCR;EmBxpCM;;IAEE,sBAAA;EnB0pCR;EmBjqCM;;IAEE,qBAAA;EnBmqCR;EmBhqCM;;IAEE,qBAAA;EnBkqCR;EmBzqCM;;IAEE,sBAAA;EnB2qCR;EmBxqCM;;IAEE,sBAAA;EnB0qCR;EmBjrCM;;IAEE,mBAAA;EnBmrCR;EmBhrCM;;IAEE,mBAAA;EnBkrCR;EmBzrCM;;IAEE,qBAAA;EnB2rCR;EmBxrCM;;IAEE,qBAAA;EnB0rCR;EmBjsCM;;IAEE,mBAAA;EnBmsCR;EmBhsCM;;IAEE,mBAAA;EnBksCR;EmBzsCM;;IAEE,qBAAA;EnB2sCR;EmBxsCM;;IAEE,qBAAA;EnB0sCR;EmBjtCM;;IAEE,mBAAA;EnBmtCR;EmBhtCM;;IAEE,mBAAA;EnBktCR;AACF;AiB7wCI;EEUE;IACE,SAAA;EnBswCN;EmBnwCI;IApCJ,cAAA;IACA,WAAA;EnB0yCA;EmB5xCA;IACE,cAAA;IACA,WAAA;EnB8xCF;EmBhyCA;IACE,cAAA;IACA,UAAA;EnBkyCF;EmBpyCA;IACE,cAAA;IACA,mBAAA;EnBsyCF;EmBxyCA;IACE,cAAA;IACA,UAAA;EnB0yCF;EmB5yCA;IACE,cAAA;IACA,UAAA;EnB8yCF;EmBhzCA;IACE,cAAA;IACA,mBAAA;EnBkzCF;EmBnxCI;IAhDJ,cAAA;IACA,WAAA;EnBs0CA;EmBjxCQ;IAhEN,cAAA;IACA,kBAAA;EnBo1CF;EmBrxCQ;IAhEN,cAAA;IACA,mBAAA;EnBw1CF;EmBzxCQ;IAhEN,cAAA;IACA,UAAA;EnB41CF;EmB7xCQ;IAhEN,cAAA;IACA,mBAAA;EnBg2CF;EmBjyCQ;IAhEN,cAAA;IACA,mBAAA;EnBo2CF;EmBryCQ;IAhEN,cAAA;IACA,UAAA;EnBw2CF;EmBzyCQ;IAhEN,cAAA;IACA,mBAAA;EnB42CF;EmB7yCQ;IAhEN,cAAA;IACA,mBAAA;EnBg3CF;EmBjzCQ;IAhEN,cAAA;IACA,UAAA;EnBo3CF;EmBrzCQ;IAhEN,cAAA;IACA,mBAAA;EnBw3CF;EmBzzCQ;IAhEN,cAAA;IACA,mBAAA;EnB43CF;EmB7zCQ;IAhEN,cAAA;IACA,WAAA;EnBg4CF;EmBzzCU;IAxDV,cAAA;EnBo3CA;EmB5zCU;IAxDV,wBAAA;EnBu3CA;EmB/zCU;IAxDV,yBAAA;EnB03CA;EmBl0CU;IAxDV,gBAAA;EnB63CA;EmBr0CU;IAxDV,yBAAA;EnBg4CA;EmBx0CU;IAxDV,yBAAA;EnBm4CA;EmB30CU;IAxDV,gBAAA;EnBs4CA;EmB90CU;IAxDV,yBAAA;EnBy4CA;EmBj1CU;IAxDV,yBAAA;EnB44CA;EmBp1CU;IAxDV,gBAAA;EnB+4CA;EmBv1CU;IAxDV,yBAAA;EnBk5CA;EmB11CU;IAxDV,yBAAA;EnBq5CA;EmBl1CM;;IAEE,gBAAA;EnBo1CR;EmBj1CM;;IAEE,gBAAA;EnBm1CR;EmB11CM;;IAEE,sBAAA;EnB41CR;EmBz1CM;;IAEE,sBAAA;EnB21CR;EmBl2CM;;IAEE,qBAAA;EnBo2CR;EmBj2CM;;IAEE,qBAAA;EnBm2CR;EmB12CM;;IAEE,sBAAA;EnB42CR;EmBz2CM;;IAEE,sBAAA;EnB22CR;EmBl3CM;;IAEE,mBAAA;EnBo3CR;EmBj3CM;;IAEE,mBAAA;EnBm3CR;EmB13CM;;IAEE,qBAAA;EnB43CR;EmBz3CM;;IAEE,qBAAA;EnB23CR;EmBl4CM;;IAEE,mBAAA;EnBo4CR;EmBj4CM;;IAEE,mBAAA;EnBm4CR;EmB14CM;;IAEE,qBAAA;EnB44CR;EmBz4CM;;IAEE,qBAAA;EnB24CR;EmBl5CM;;IAEE,mBAAA;EnBo5CR;EmBj5CM;;IAEE,mBAAA;EnBm5CR;AACF;AiB98CI;EEUE;IACE,SAAA;EnBu8CN;EmBp8CI;IApCJ,cAAA;IACA,WAAA;EnB2+CA;EmB79CA;IACE,cAAA;IACA,WAAA;EnB+9CF;EmBj+CA;IACE,cAAA;IACA,UAAA;EnBm+CF;EmBr+CA;IACE,cAAA;IACA,mBAAA;EnBu+CF;EmBz+CA;IACE,cAAA;IACA,UAAA;EnB2+CF;EmB7+CA;IACE,cAAA;IACA,UAAA;EnB++CF;EmBj/CA;IACE,cAAA;IACA,mBAAA;EnBm/CF;EmBp9CI;IAhDJ,cAAA;IACA,WAAA;EnBugDA;EmBl9CQ;IAhEN,cAAA;IACA,kBAAA;EnBqhDF;EmBt9CQ;IAhEN,cAAA;IACA,mBAAA;EnByhDF;EmB19CQ;IAhEN,cAAA;IACA,UAAA;EnB6hDF;EmB99CQ;IAhEN,cAAA;IACA,mBAAA;EnBiiDF;EmBl+CQ;IAhEN,cAAA;IACA,mBAAA;EnBqiDF;EmBt+CQ;IAhEN,cAAA;IACA,UAAA;EnByiDF;EmB1+CQ;IAhEN,cAAA;IACA,mBAAA;EnB6iDF;EmB9+CQ;IAhEN,cAAA;IACA,mBAAA;EnBijDF;EmBl/CQ;IAhEN,cAAA;IACA,UAAA;EnBqjDF;EmBt/CQ;IAhEN,cAAA;IACA,mBAAA;EnByjDF;EmB1/CQ;IAhEN,cAAA;IACA,mBAAA;EnB6jDF;EmB9/CQ;IAhEN,cAAA;IACA,WAAA;EnBikDF;EmB1/CU;IAxDV,cAAA;EnBqjDA;EmB7/CU;IAxDV,wBAAA;EnBwjDA;EmBhgDU;IAxDV,yBAAA;EnB2jDA;EmBngDU;IAxDV,gBAAA;EnB8jDA;EmBtgDU;IAxDV,yBAAA;EnBikDA;EmBzgDU;IAxDV,yBAAA;EnBokDA;EmB5gDU;IAxDV,gBAAA;EnBukDA;EmB/gDU;IAxDV,yBAAA;EnB0kDA;EmBlhDU;IAxDV,yBAAA;EnB6kDA;EmBrhDU;IAxDV,gBAAA;EnBglDA;EmBxhDU;IAxDV,yBAAA;EnBmlDA;EmB3hDU;IAxDV,yBAAA;EnBslDA;EmBnhDM;;IAEE,gBAAA;EnBqhDR;EmBlhDM;;IAEE,gBAAA;EnBohDR;EmB3hDM;;IAEE,sBAAA;EnB6hDR;EmB1hDM;;IAEE,sBAAA;EnB4hDR;EmBniDM;;IAEE,qBAAA;EnBqiDR;EmBliDM;;IAEE,qBAAA;EnBoiDR;EmB3iDM;;IAEE,sBAAA;EnB6iDR;EmB1iDM;;IAEE,sBAAA;EnB4iDR;EmBnjDM;;IAEE,mBAAA;EnBqjDR;EmBljDM;;IAEE,mBAAA;EnBojDR;EmB3jDM;;IAEE,qBAAA;EnB6jDR;EmB1jDM;;IAEE,qBAAA;EnB4jDR;EmBnkDM;;IAEE,mBAAA;EnBqkDR;EmBlkDM;;IAEE,mBAAA;EnBokDR;EmB3kDM;;IAEE,qBAAA;EnB6kDR;EmB1kDM;;IAEE,qBAAA;EnB4kDR;EmBnlDM;;IAEE,mBAAA;EnBqlDR;EmBllDM;;IAEE,mBAAA;EnBolDR;AACF;AiB/oDI;EEUE;IACE,SAAA;EnBwoDN;EmBroDI;IApCJ,cAAA;IACA,WAAA;EnB4qDA;EmB9pDA;IACE,cAAA;IACA,WAAA;EnBgqDF;EmBlqDA;IACE,cAAA;IACA,UAAA;EnBoqDF;EmBtqDA;IACE,cAAA;IACA,mBAAA;EnBwqDF;EmB1qDA;IACE,cAAA;IACA,UAAA;EnB4qDF;EmB9qDA;IACE,cAAA;IACA,UAAA;EnBgrDF;EmBlrDA;IACE,cAAA;IACA,mBAAA;EnBorDF;EmBrpDI;IAhDJ,cAAA;IACA,WAAA;EnBwsDA;EmBnpDQ;IAhEN,cAAA;IACA,kBAAA;EnBstDF;EmBvpDQ;IAhEN,cAAA;IACA,mBAAA;EnB0tDF;EmB3pDQ;IAhEN,cAAA;IACA,UAAA;EnB8tDF;EmB/pDQ;IAhEN,cAAA;IACA,mBAAA;EnBkuDF;EmBnqDQ;IAhEN,cAAA;IACA,mBAAA;EnBsuDF;EmBvqDQ;IAhEN,cAAA;IACA,UAAA;EnB0uDF;EmB3qDQ;IAhEN,cAAA;IACA,mBAAA;EnB8uDF;EmB/qDQ;IAhEN,cAAA;IACA,mBAAA;EnBkvDF;EmBnrDQ;IAhEN,cAAA;IACA,UAAA;EnBsvDF;EmBvrDQ;IAhEN,cAAA;IACA,mBAAA;EnB0vDF;EmB3rDQ;IAhEN,cAAA;IACA,mBAAA;EnB8vDF;EmB/rDQ;IAhEN,cAAA;IACA,WAAA;EnBkwDF;EmB3rDU;IAxDV,cAAA;EnBsvDA;EmB9rDU;IAxDV,wBAAA;EnByvDA;EmBjsDU;IAxDV,yBAAA;EnB4vDA;EmBpsDU;IAxDV,gBAAA;EnB+vDA;EmBvsDU;IAxDV,yBAAA;EnBkwDA;EmB1sDU;IAxDV,yBAAA;EnBqwDA;EmB7sDU;IAxDV,gBAAA;EnBwwDA;EmBhtDU;IAxDV,yBAAA;EnB2wDA;EmBntDU;IAxDV,yBAAA;EnB8wDA;EmBttDU;IAxDV,gBAAA;EnBixDA;EmBztDU;IAxDV,yBAAA;EnBoxDA;EmB5tDU;IAxDV,yBAAA;EnBuxDA;EmBptDM;;IAEE,gBAAA;EnBstDR;EmBntDM;;IAEE,gBAAA;EnBqtDR;EmB5tDM;;IAEE,sBAAA;EnB8tDR;EmB3tDM;;IAEE,sBAAA;EnB6tDR;EmBpuDM;;IAEE,qBAAA;EnBsuDR;EmBnuDM;;IAEE,qBAAA;EnBquDR;EmB5uDM;;IAEE,sBAAA;EnB8uDR;EmB3uDM;;IAEE,sBAAA;EnB6uDR;EmBpvDM;;IAEE,mBAAA;EnBsvDR;EmBnvDM;;IAEE,mBAAA;EnBqvDR;EmB5vDM;;IAEE,qBAAA;EnB8vDR;EmB3vDM;;IAEE,qBAAA;EnB6vDR;EmBpwDM;;IAEE,mBAAA;EnBswDR;EmBnwDM;;IAEE,mBAAA;EnBqwDR;EmB5wDM;;IAEE,qBAAA;EnB8wDR;EmB3wDM;;IAEE,qBAAA;EnB6wDR;EmBpxDM;;IAEE,mBAAA;EnBsxDR;EmBnxDM;;IAEE,mBAAA;EnBqxDR;AACF;AiBh1DI;EEUE;IACE,SAAA;EnBy0DN;EmBt0DI;IApCJ,cAAA;IACA,WAAA;EnB62DA;EmB/1DA;IACE,cAAA;IACA,WAAA;EnBi2DF;EmBn2DA;IACE,cAAA;IACA,UAAA;EnBq2DF;EmBv2DA;IACE,cAAA;IACA,mBAAA;EnBy2DF;EmB32DA;IACE,cAAA;IACA,UAAA;EnB62DF;EmB/2DA;IACE,cAAA;IACA,UAAA;EnBi3DF;EmBn3DA;IACE,cAAA;IACA,mBAAA;EnBq3DF;EmBt1DI;IAhDJ,cAAA;IACA,WAAA;EnBy4DA;EmBp1DQ;IAhEN,cAAA;IACA,kBAAA;EnBu5DF;EmBx1DQ;IAhEN,cAAA;IACA,mBAAA;EnB25DF;EmB51DQ;IAhEN,cAAA;IACA,UAAA;EnB+5DF;EmBh2DQ;IAhEN,cAAA;IACA,mBAAA;EnBm6DF;EmBp2DQ;IAhEN,cAAA;IACA,mBAAA;EnBu6DF;EmBx2DQ;IAhEN,cAAA;IACA,UAAA;EnB26DF;EmB52DQ;IAhEN,cAAA;IACA,mBAAA;EnB+6DF;EmBh3DQ;IAhEN,cAAA;IACA,mBAAA;EnBm7DF;EmBp3DQ;IAhEN,cAAA;IACA,UAAA;EnBu7DF;EmBx3DQ;IAhEN,cAAA;IACA,mBAAA;EnB27DF;EmB53DQ;IAhEN,cAAA;IACA,mBAAA;EnB+7DF;EmBh4DQ;IAhEN,cAAA;IACA,WAAA;EnBm8DF;EmB53DU;IAxDV,cAAA;EnBu7DA;EmB/3DU;IAxDV,wBAAA;EnB07DA;EmBl4DU;IAxDV,yBAAA;EnB67DA;EmBr4DU;IAxDV,gBAAA;EnBg8DA;EmBx4DU;IAxDV,yBAAA;EnBm8DA;EmB34DU;IAxDV,yBAAA;EnBs8DA;EmB94DU;IAxDV,gBAAA;EnBy8DA;EmBj5DU;IAxDV,yBAAA;EnB48DA;EmBp5DU;IAxDV,yBAAA;EnB+8DA;EmBv5DU;IAxDV,gBAAA;EnBk9DA;EmB15DU;IAxDV,yBAAA;EnBq9DA;EmB75DU;IAxDV,yBAAA;EnBw9DA;EmBr5DM;;IAEE,gBAAA;EnBu5DR;EmBp5DM;;IAEE,gBAAA;EnBs5DR;EmB75DM;;IAEE,sBAAA;EnB+5DR;EmB55DM;;IAEE,sBAAA;EnB85DR;EmBr6DM;;IAEE,qBAAA;EnBu6DR;EmBp6DM;;IAEE,qBAAA;EnBs6DR;EmB76DM;;IAEE,sBAAA;EnB+6DR;EmB56DM;;IAEE,sBAAA;EnB86DR;EmBr7DM;;IAEE,mBAAA;EnBu7DR;EmBp7DM;;IAEE,mBAAA;EnBs7DR;EmB77DM;;IAEE,qBAAA;EnB+7DR;EmB57DM;;IAEE,qBAAA;EnB87DR;EmBr8DM;;IAEE,mBAAA;EnBu8DR;EmBp8DM;;IAEE,mBAAA;EnBs8DR;EmB78DM;;IAEE,qBAAA;EnB+8DR;EmB58DM;;IAEE,qBAAA;EnB88DR;EmBr9DM;;IAEE,mBAAA;EnBu9DR;EmBp9DM;;IAEE,mBAAA;EnBs9DR;AACF;AoB5kEA;EAEE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,0CAAA;EACA,gCAAA;EACA,gCAAA;EACA,iCAAA;EACA,kDAAA;EACA,+DAAA;EACA,iDAAA;EACA,6DAAA;EACA,gDAAA;EACA,8DAAA;EAEA,WAAA;EACA,mBXmBO;EWlBP,mBZusB4B;EYtsB5B,0CAAA;ApB2kEF;AoBpkEE;EACE,sBAAA;EAEA,qFAAA;EACA,oCAAA;EACA,2CZ+sB0B;EY9sB1B,2GAAA;ApBqkEJ;AoBlkEE;EACE,uBAAA;ApBokEJ;AoBjkEE;EACE,sBAAA;ApBmkEJ;;AoB/jEA;EACE,+DAAA;ApBkkEF;;AoB3jEA;EACE,iBAAA;ApB8jEF;;AoBpjEE;EACE,wBAAA;ApBujEJ;;AoBxiEE;EACE,sCAAA;ApB2iEJ;AoBxiEI;EACE,sCAAA;ApB0iEN;;AoBniEE;EACE,sBAAA;ApBsiEJ;AoBniEE;EACE,mBAAA;ApBqiEJ;;AoB3hEE;EACE,oDAAA;EACA,8CAAA;ApB8hEJ;;AoBxhEE;EACE,oDAAA;EACA,8CAAA;ApB2hEJ;;AoBnhEA;EACE,oDAAA;EACA,8CAAA;ApBshEF;;AoB9gEE;EACE,mDAAA;EACA,6CAAA;ApBihEJ;;AqB7pEE;EAOE,yBAAA;EACA,mCAAA;EACA,gDAAA;EACA,kDAAA;EACA,iCAAA;EACA,+CAAA;EACA,gCAAA;EACA,kDAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ArBypEJ;;AqB3qEE;EAOE,yBAAA;EACA,uCAAA;EACA,oDAAA;EACA,kDAAA;EACA,iCAAA;EACA,iDAAA;EACA,gCAAA;EACA,kDAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ArBuqEJ;;AqBzrEE;EAOE,yBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,iCAAA;EACA,gDAAA;EACA,gCAAA;EACA,gDAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ArBqrEJ;;AqBvsEE;EAOE,yBAAA;EACA,qCAAA;EACA,iDAAA;EACA,iDAAA;EACA,iCAAA;EACA,8CAAA;EACA,gCAAA;EACA,iDAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ArBmsEJ;;AqBrtEE;EAOE,yBAAA;EACA,qCAAA;EACA,mDAAA;EACA,kDAAA;EACA,iCAAA;EACA,gDAAA;EACA,gCAAA;EACA,iDAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ArBitEJ;;AqBnuEE;EAOE,yBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,iCAAA;EACA,gDAAA;EACA,gCAAA;EACA,iDAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ArB+tEJ;;AqBjvEE;EAOE,yBAAA;EACA,sBAAA;EACA,+CAAA;EACA,+CAAA;EACA,iCAAA;EACA,4CAAA;EACA,gCAAA;EACA,8CAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ArB6uEJ;;AqB/vEE;EAOE,sBAAA;EACA,sBAAA;EACA,8CAAA;EACA,+CAAA;EACA,8BAAA;EACA,2CAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ArB2vEJ;;AoB1mEI;EACE,gBAAA;EACA,iCAAA;ApB6mEN;;AiBxsEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EpBmnEJ;AACF;AiB/sEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EpBynEJ;AACF;AiBrtEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EpB+nEJ;AACF;AiB3tEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EpBqoEJ;AACF;AiBjuEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EpB2oEJ;AACF;AsB/yEA;EACE,qBdu2BsC;AR08CxC;;AsBxyEA;EACE,+BAAA;EACA,kCAAA;EACA,gBAAA;EjB8QI,kBALI;EiBrQR,iBbgFe;ATytEjB;;AsBryEA;EACE,6BAAA;EACA,gCAAA;EjBoQI,kBALI;AL0iEV;;AsBryEA;EACE,+BAAA;EACA,kCAAA;EjB8PI,iBALI;ALgjEV;;AuBt0EA;EACE,mBf+1BsC;EHrkBlC,kBALI;EkBjRR,gCf+1BsC;ARw+CxC;;AwB50EA;EACE,cAAA;EACA,WAAA;EACA,sBAAA;EnBwRI,kBALI;EmBhRR,gBhBkmB4B;EgBjmB5B,iBf0Fe;EezFf,cfQS;EePT,gBAAA;EACA,mChBq3BsC;EgBp3BtC,4BAAA;EACA,oCAAA;EdGE,kBAAA;EeHE,wEDMJ;AxB00EF;AyB50EM;EDhBN;ICiBQ,gBAAA;EzB+0EN;AACF;AwB70EE;EACE,gBAAA;AxB+0EJ;AwB70EI;EACE,eAAA;AxB+0EN;AwB10EE;EACE,cfdO;EeeP,mChBg2BoC;EgB/1BpC,qBfPG;EeQH,UAAA;EAKE,4Cf8ImB;AT0rEzB;AwBp0EE;EAME,eAAA;EAMA,cAAA;EAKA,SAAA;AxBwzEJ;AwBnzEE;EACE,cAAA;EACA,UAAA;AxBqzEJ;AwBjzEE;EACE,yBf+GsB;Ee7GtB,UAAA;AxBkzEJ;AwB1yEE;EAEE,yBfsFgB;EenFhB,UAAA;AxByyEJ;AwBryEE;EACE,sBAAA;EACA,uBAAA;EACA,yBfkEc;EejEd,cf9EO;EiBhBT,uClBqiCgC;EgBr8B9B,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BfDW;EeEX,gBAAA;ECzFE,qID0FF;AxBuyEJ;AyB73EM;ED0EJ;ICzEM,gBAAA;EzBg4EN;AACF;AwBzyEE;EACE,wChB47B8B;AR+2ClC;;AwBlyEA;EACE,cAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBfvBe;EewBf,cf3GS;Ee4GT,6BAAA;EACA,yBAAA;EACA,mBAAA;AxBqyEF;AwBnyEE;EACE,UAAA;AxBqyEJ;AwBlyEE;EAEE,gBAAA;EACA,eAAA;AxBmyEJ;;AwBxxEA;EACE,+ChB4wBsC;EgB3wBtC,sBAAA;EnByII,iBALI;EKvQN,kBAAA;AVg6EJ;AwBzxEE;EACE,sBAAA;EACA,uBAAA;EACA,yBfWiB;ATgxErB;;AwBvxEA;EACE,+ChBgwBsC;EgB/vBtC,oBAAA;EnB4HI,kBALI;EKvQN,kBAAA;AV46EJ;AwBxxEE;EACE,oBAAA;EACA,qBAAA;EACA,yBfCiB;ATyxErB;;AwBlxEE;EACE,uCfUW;AT2wEf;AwBlxEE;EACE,+ChB0uBoC;AR0iDxC;AwBjxEE;EACE,+ChBuuBoC;AR4iDxC;;AwB9wEA;EACE,WhBquBsC;EgBpuBtC,mCfLa;EeMb,efjCgB;ATkzElB;AwB/wEE;EACE,eAAA;AxBixEJ;AwB9wEE;EACE,oBAAA;EdvLA,kBAAA;AVw8EJ;AwB7wEE;EACE,oBAAA;Ed5LA,kBAAA;AV48EJ;AwB5wEE;EAAoB,2ChB8sBkB;ARikDxC;AwB9wEE;EAAoB,2ChB8sBkB;ARmkDxC;;A2Bh+EA;EACE,gEAAA;EAEA,cAAA;EACA,WAAA;EACA,oCAAA;EtBqRI,kBALI;EsB7QR,gBnB+lB4B;EmB9lB5B,iBlBuFe;EkBtFf,clBKS;EkBJT,gBAAA;EACA,mCnBk3BsC;EmBj3BtC,mFAAA;EACA,4BAAA;EACA,wCnB+9BkC;EmB99BlC,0BnB+9BkC;EmB99BlC,oCAAA;EjBHE,kBAAA;EeHE,wEESJ;A3Bg+EF;AyBr+EM;EEfN;IFgBQ,gBAAA;EzBw+EN;AACF;A2Bn+EE;EACE,qBlBCG;EkBAH,UAAA;EAKE,mDnBi+B4B;ARggDlC;A2B79EE;EAEE,qBlB2Hc;EkB1Hd,sBAAA;A3B89EJ;A2B39EE;EAEE,yBlB+HgB;AT61EpB;A2Bv9EE;EACE,kBAAA;EACA,0BAAA;A3By9EJ;;A2Br9EA;EACE,mBlB6GmB;EkB5GnB,sBlB4GmB;EkB3GnB,oBlB4GmB;EJuHf,iBALI;EKvQN,kBAAA;AVmgFJ;;A2Br9EA;EACE,iBlBuFuB;EkBtFvB,oBlBsFuB;EkBrFvB,oBlBuGmB;EJoHf,kBALI;EKvQN,kBAAA;AV2gFJ;;A2Bn9EI;EACE,gEAAA;A3Bs9EN;;A4B9hFA;EACE,cAAA;EACA,mBpBq6BwC;EoBp6BxC,mBpBq6BwC;EoBp6BxC,uBpBq6BwC;AR4nD1C;A4B/hFE;EACE,WAAA;EACA,mBAAA;A5BiiFJ;;A4B7hFA;EACE,oBpB25BwC;EoB15BxC,eAAA;EACA,iBAAA;A5BgiFF;A4B9hFE;EACE,YAAA;EACA,oBAAA;EACA,cAAA;A5BgiFJ;;A4B5hFA;EACE,qCAAA;EAEA,cAAA;EACA,UpB04BwC;EoBz4BxC,WpBy4BwC;EoBx4BxC,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,2DpB24BwC;EoB14BxC,iCAAA;UAAA,yBAAA;A5B8hFF;A4B3hFE;ElB3BE,qBAAA;AVyjFJ;A4B1hFE;EAEE,kBpBm4BsC;ARwpD1C;A4BxhFE;EACE,uBpB03BsC;ARgqD1C;A4BvhFE;EACE,qBnB/BG;EmBgCH,UAAA;EACA,mDpB8foB;AR2hExB;A4BthFE;EACE,yBnBrCG;EmBsCH,qBnBtCG;AT8jFP;A4BthFI;EAII,iEAAA;A5BqhFR;A4BjhFI;EAII,iEAAA;A5BghFR;A4B3gFE;EACE,yBnB1DG;EmB2DH,qBnB3DG;EmBgED,iEAAA;A5BygFN;A4BrgFE;EACE,oBAAA;EACA,YAAA;EACA,YpBk2BuC;ARqqD3C;A4BhgFI;EACE,eAAA;EACA,YpBy1BqC;ARyqD3C;;A4Bp/EA;EACE,mBpBo1BgC;ARmqDlC;A4Br/EE;EACE,4DAAA;EAEA,UpB80B8B;EoB70B9B,mBAAA;EACA,0CAAA;EACA,gCAAA;ElBjHA,kBAAA;EeHE,iDGsHF;A5Bs/EJ;AyBxmFM;EG0GJ;IHzGM,gBAAA;EzB2mFN;AACF;A4Bz/EI;EACE,4DAAA;A5B2/EN;A4Bx/EI;EACE,iCpB60B4B;EoBx0B1B,4DAAA;A5Bs/ER;A4Bj/EE;EACE,oBpBwzB8B;EoBvzB9B,eAAA;A5Bm/EJ;A4Bj/EI;EACE,oBAAA;EACA,cAAA;A5Bm/EN;;A4B9+EA;EACE,qBAAA;EACA,kBpBsyBgC;AR2sDlC;;A4B9+EA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;A5Bi/EF;A4B7+EI;EACE,oBAAA;EACA,YAAA;EACA,apBspBwB;ARy1D9B;;A4Bx+EI;EACE,4DAAA;A5B2+EN;;A6B9pFA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;A7BiqFF;A6B/pFE;EACE,UAAA;A7BiqFJ;A6B7pFI;EAA0B,+DrB8gCa;ARkpD3C;A6B/pFI;EAA0B,+DrB6gCa;ARqpD3C;A6B/pFE;EACE,SAAA;A7BiqFJ;A6B9pFE;EACE,WrB+/BuC;EqB9/BvC,YrB8/BuC;EqB7/BvC,oBAAA;EACA,gBAAA;EH1BF,yBjByBK;EoBGH,SrB6/BuC;EE1gCvC,mBAAA;EeHE,oHImBF;EJnBE,4GImBF;A7B+pFJ;AyB9qFM;EIMJ;IJLM,wBAAA;IAAA,gBAAA;EzBirFN;AACF;A6BlqFI;EHjCF,wClB8hCyC;ARwqD3C;A6BhqFE;EACE,WrBw+B8B;EqBv+B9B,crBw+B8B;EqBv+B9B,kBAAA;EACA,erBu+B8B;EqBt+B9B,wCrBu+B8B;EqBt+B9B,yBAAA;EnB7BA,mBAAA;AVgsFJ;A6B9pFE;EACE,WrBo+BuC;EqBn+BvC,YrBm+BuC;EqBl+BvC,gBAAA;EHpDF,yBjByBK;EoB6BH,SrBm+BuC;EE1gCvC,mBAAA;EeHE,iHI6CF;EJ7CE,4GI6CF;A7B+pFJ;AyBxsFM;EIiCJ;IJhCM,qBAAA;IAAA,gBAAA;EzB2sFN;AACF;A6BlqFI;EH3DF,wClB8hCyC;ARksD3C;A6BhqFE;EACE,WrB88B8B;EqB78B9B,crB88B8B;EqB78B9B,kBAAA;EACA,erB68B8B;EqB58B9B,wCrB68B8B;EqB58B9B,yBAAA;EnBvDA,mBAAA;AV0tFJ;A6B9pFE;EACE,oBAAA;A7BgqFJ;A6B9pFI;EACE,2CrBg9BqC;ARgtD3C;A6B7pFI;EACE,2CrB48BqC;ARmtD3C;;A8BtvFA;EACE,kBAAA;A9ByvFF;A8BvvFE;;;EAGE,oCtBwiCoC;EsBviCpC,wCtBuiCoC;EsBtiCpC,iBtBuiCoC;ARktDxC;A8BtvFE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,6BAAA;EACA,qBAAA;ELRE,gEKSF;A9BwvFJ;AyB7vFM;EKTJ;ILUM,gBAAA;EzBgwFN;AACF;A8B1vFE;;EAEE,oBAAA;A9B4vFJ;A8B1vFI;;EACE,kBAAA;A9B6vFN;A8B1vFI;;;EAEE,qBtB4gCkC;EsB3gClC,wBtB4gCkC;ARivDxC;A8B1vFI;;EACE,qBtBugCkC;EsBtgClC,wBtBugCkC;ARsvDxC;A8BzvFE;EACE,qBtBigCoC;EsBhgCpC,wBtBigCoC;AR0vDxC;A8BpvFI;;;;EACE,2CAAA;EACA,8DtB2/BkC;AR8vDxC;A8BvvFM;;;;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,atBm/BgC;EsBl/BhC,WAAA;EACA,mCtBg0BgC;EEh3BpC,kBAAA;AV6yFJ;A8BtvFI;EACE,2CAAA;EACA,8DtB0+BkC;AR8wDxC;A8BnvFI;EACE,mBAAA;A9BqvFN;A8BjvFE;;EAEE,crBrEO;ATwzFX;A8BjvFI;;EACE,yBrBkFc;ATkqFpB;;A+B30FA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A/B80FF;A+B50FE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A/B80FJ;A+B10FE;;;EAGE,UAAA;A/B40FJ;A+Bt0FE;EACE,kBAAA;EACA,UAAA;A/Bw0FJ;A+Bt0FI;EACE,UAAA;A/Bw0FN;;A+B7zFA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;E1B8OI,kBALI;E0BvOR,gBvByjB4B;EuBxjB5B,iBtBiDe;EsBhDf,ctBjCS;EsBkCT,kBAAA;EACA,mBAAA;EACA,uCvB06BsC;EuBz6BtC,oCAAA;ErBtCE,kBAAA;AVu2FJ;;A+BvzFA;;;;EAIE,oBAAA;E1BwNI,kBALI;EKvQN,kBAAA;AVg3FJ;;A+BvzFA;;;;EAIE,sBAAA;E1B+MI,iBALI;EKvQN,kBAAA;AVy3FJ;;A+BvzFA;;EAEE,qBAAA;A/B0zFF;;A+B7yFI;;;;ErBjEA,0BAAA;EACA,6BAAA;AVq3FJ;A+B5yFI;;;;ErB1EA,0BAAA;EACA,6BAAA;AV43FJ;A+BtyFE;EACE,2BAAA;ErB1EA,yBAAA;EACA,4BAAA;AVm3FJ;A+BtyFE;;ErB9EE,yBAAA;EACA,4BAAA;AVw3FJ;;AgCh5FE;EACE,aAAA;EACA,WAAA;EACA,mBxBu0BoC;EHrkBlC,kBALI;E2B1PN,iCxBkjCqB;ARg2DzB;;AgC/4FE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,wBAAA;EACA,kBAAA;E3BqPE,mBALI;E2B7ON,WxBqiCqB;EwBpiCrB,mCxBoiCqB;EE/jCrB,uBAAA;AV66FJ;;AgC74FI;;;;EAEE,cAAA;AhCk5FN;;AgCj8FI;EAqDE,+CxBuhCmB;EwBphCjB,oCxB81BgC;EwB71BhC,yDAAA;EACA,4BAAA;EACA,0DAAA;EACA,8DAAA;AhC84FR;AgC34FM;EACE,+CxB4gCiB;EwBvgCf,2DxBugCe;ARk4DzB;;AgC98FI;EA+EI,oCxBu0BgC;EwBt0BhC,gFAAA;AhCm4FR;;AgCn9FI;EAuFE,+CxBq/BmB;AR24DzB;AgC73FQ;EAEE,iEAAA;EACA,sBxBq5B8B;EwBp5B9B,6DAAA;EACA,yEAAA;AhC83FV;AgC13FM;EACE,+CxBw+BiB;EwBn+Bf,2DxBm+Be;ARq5DzB;;AgCj+FI;EAkHI,yCAAA;AhCm3FR;;AgCr+FI;EAyHE,+CxBm9BmB;AR65DzB;AgC92FM;EACE,4CxBg9BiB;ARg6DzB;AgC72FM;EACE,2DxB48BiB;ARm6DzB;AgC52FM;EACE,iCxBw8BiB;ARs6DzB;;AgCz2FI;EACE,kBAAA;AhC42FN;;AgCt/FI;;;;;EAoJM,UAAA;AhC02FV;;AgC1+FE;EACE,aAAA;EACA,WAAA;EACA,mBxBu0BoC;EHrkBlC,kBALI;E2B1PN,mCxBkjCqB;AR07DzB;;AgCz+FE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,wBAAA;EACA,kBAAA;E3BqPE,mBALI;E2B7ON,WxBqiCqB;EwBpiCrB,kCxBoiCqB;EE/jCrB,uBAAA;AVugGJ;;AgCv+FI;;;;EAEE,cAAA;AhC4+FN;;AgC3hGI;EAqDE,iDxBuhCmB;EwBphCjB,oCxB81BgC;EwB71BhC,0DAAA;EACA,4BAAA;EACA,0DAAA;EACA,8DAAA;AhCw+FR;AgCr+FM;EACE,iDxB4gCiB;EwBvgCf,0DxBugCe;AR49DzB;;AgCxiGI;EA+EI,oCxBu0BgC;EwBt0BhC,gFAAA;AhC69FR;;AgC7iGI;EAuFE,iDxBq/BmB;ARq+DzB;AgCv9FQ;EAEE,kEAAA;EACA,sBxBq5B8B;EwBp5B9B,6DAAA;EACA,yEAAA;AhCw9FV;AgCp9FM;EACE,iDxBw+BiB;EwBn+Bf,0DxBm+Be;AR++DzB;;AgC3jGI;EAkHI,yCAAA;AhC68FR;;AgC/jGI;EAyHE,iDxBm9BmB;ARu/DzB;AgCx8FM;EACE,8CxBg9BiB;AR0/DzB;AgCv8FM;EACE,0DxB48BiB;AR6/DzB;AgCt8FM;EACE,mCxBw8BiB;ARggEzB;;AgCn8FI;EACE,kBAAA;AhCs8FN;;AgChlGI;;;;;EAsJM,UAAA;AhCk8FV;;AiC1lGA;EAEE,wBAAA;EACA,0BAAA;EACA,sBAAA;E5BuRI,wBALI;E4BhRR,yBAAA;EACA,uBAAA;EACA,oCAAA;EACA,wBAAA;EACA,wBAAA;EACA,kCAAA;EACA,iCAAA;EACA,wCAAA;EACA,+FAAA;EACA,+BAAA;EACA,iFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E5BsQI,kCALI;E4B/PR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mEAAA;EvBjBE,0CAAA;EgBfF,kCOkCqB;ERtBjB,qIQwBJ;AjCwlGF;AyB5mGM;EQhBN;IRiBQ,gBAAA;EzB+mGN;AACF;AiC3lGE;EACE,gCAAA;EAEA,wCAAA;EACA,8CAAA;AjC4lGJ;AiCzlGE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;AjC0lGJ;AiCvlGE;EACE,gCAAA;EPrDF,wCOsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;AjCqlGN;AiCjlGE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;AjC+kGN;AiC3kGE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;AjCukGJ;AiCpkGI;EAKI,0CAAA;AjCkkGR;AiC7jGE;EAKI,0CAAA;AjC2jGN;AiCvjGE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;AjCsjGJ;;AiC1iGE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EACA,+CAAA;EACA,wCAAA;EACA,2BAAA;EACA,sCAAA;EACA,oDAAA;EACA,+DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AlC6pGF;;AiC3jGE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,8CAAA;EACA,qDAAA;EACA,wCAAA;EACA,8BAAA;EACA,4CAAA;EACA,sDAAA;EACA,+DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AlC8qGF;;AiC5kGE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,2CAAA;EACA,oDAAA;EACA,uCAAA;EACA,8BAAA;EACA,yCAAA;EACA,qDAAA;EACA,+DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AlC+rGF;;AiC7lGE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,4CAAA;EACA,oDAAA;EACA,sCAAA;EACA,8BAAA;EACA,yCAAA;EACA,qDAAA;EACA,+DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AlCgtGF;;AiC9mGE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,wCAAA;EACA,kDAAA;EACA,uCAAA;EACA,8BAAA;EACA,0CAAA;EACA,mDAAA;EACA,+DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AlCiuGF;;AiC/nGE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,6CAAA;EACA,mDAAA;EACA,sCAAA;EACA,8BAAA;EACA,0CAAA;EACA,oDAAA;EACA,+DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AlCkvGF;;AiChpGE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,6CAAA;EACA,qDAAA;EACA,wCAAA;EACA,8BAAA;EACA,4CAAA;EACA,wDAAA;EACA,+DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AlCmwGF;;AiCjqGE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,kDAAA;EACA,qCAAA;EACA,2BAAA;EACA,yCAAA;EACA,mDAAA;EACA,+DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AlCoxGF;;AiCxpGE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,+DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AlC4wGF;;AiCzqGE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,+DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AlC6xGF;;AiC1rGE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,+DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AlC8yGF;;AiC3sGE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,+DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AlC+zGF;;AiC5tGE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,+DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AlCg1GF;;AiC7uGE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,+DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AlCi2GF;;AiC9vGE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,+DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AlCk3GF;;AiC/wGE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,+DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AlCm4GF;;AiCpxGA;EACE,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,+BAAA;EACA,wCAAA;EAEA,0BzB8QwC;ARwgG1C;AiCjxGE;EAEE,qBxBrGoB;ATu3GxB;AiC/wGE;EACE,0BAAA;AjCixGJ;AiC9wGE;EACE,gCAAA;AjCgxGJ;;AiCrwGA;ECjJE,wBAAA;EACA,0BAAA;E7B8NI,2BALI;E6BvNR,kDAAA;AlC05GF;;AiCxwGA;ECrJE,0BAAA;EACA,0BAAA;E7B8NI,0BALI;E6BvNR,kDAAA;AlCi6GF;;AmCp+GA;EVgBM,gCUfJ;AnCu+GF;AyBp9GM;EUpBN;IVqBQ,gBAAA;EzBu9GN;AACF;AmC1+GE;EACE,UAAA;AnC4+GJ;;AmCt+GE;EACE,aAAA;AnCy+GJ;;AmCr+GA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;AnCw+GF;AyBt+GM;EULN;IVMQ,gBAAA;EzBy+GN;AACF;AmC3+GE;EACE,QAAA;EACA,YAAA;EVNE,4BUOF;AnC6+GJ;AyBh/GM;EUAJ;IVCM,gBAAA;EzBm/GN;AACF;;AoCxgHA;;;;;;EAME,kBAAA;ApC2gHF;;AoCxgHA;EACE,mBAAA;ApC2gHF;AqCn/GI;EACE,qBAAA;EACA,oB7B6hBwB;E6B5hBxB,uB7B2hBwB;E6B1hBxB,WAAA;EArCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;ArC2hHF;AqCj+GI;EACE,cAAA;ArCm+GN;;AoCjhHA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,4BAAA;E/BuQI,kCALI;E+BhQR,yCAAA;EACA,mCAAA;EACA,8DAAA;EACA,gCAAA;EACA,kDAAA;EACA,qEAAA;EACA,6CAAA;EACA,sCAAA;EACA,8CAAA;EACA,8CAAA;EACA,oDAAA;EACA,oCAAA;EACA,qCAAA;EACA,qCAAA;EACA,2DAAA;EACA,kCAAA;EACA,qCAAA;EACA,mCAAA;EACA,oCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E/B0OI,uCALI;E+BnOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E1BzCE,+CAAA;AV2jHJ;AoC9gHE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;ApCghHJ;;AoCx/GI;EACE,oBAAA;ApC2/GN;AoCz/GM;EACE,WAAA;EACA,OAAA;ApC2/GR;;AoCv/GI;EACE,kBAAA;ApC0/GN;AoCx/GM;EACE,QAAA;EACA,UAAA;ApC0/GR;;AiBpiHI;EmB4BA;IACE,oBAAA;EpC4gHJ;EoC1gHI;IACE,WAAA;IACA,OAAA;EpC4gHN;EoCxgHE;IACE,kBAAA;EpC0gHJ;EoCxgHI;IACE,QAAA;IACA,UAAA;EpC0gHN;AACF;AiBrjHI;EmB4BA;IACE,oBAAA;EpC4hHJ;EoC1hHI;IACE,WAAA;IACA,OAAA;EpC4hHN;EoCxhHE;IACE,kBAAA;EpC0hHJ;EoCxhHI;IACE,QAAA;IACA,UAAA;EpC0hHN;AACF;AiBrkHI;EmB4BA;IACE,oBAAA;EpC4iHJ;EoC1iHI;IACE,WAAA;IACA,OAAA;EpC4iHN;EoCxiHE;IACE,kBAAA;EpC0iHJ;EoCxiHI;IACE,QAAA;IACA,UAAA;EpC0iHN;AACF;AiBrlHI;EmB4BA;IACE,oBAAA;EpC4jHJ;EoC1jHI;IACE,WAAA;IACA,OAAA;EpC4jHN;EoCxjHE;IACE,kBAAA;EpC0jHJ;EoCxjHI;IACE,QAAA;IACA,UAAA;EpC0jHN;AACF;AiBrmHI;EmB4BA;IACE,oBAAA;EpC4kHJ;EoC1kHI;IACE,WAAA;IACA,OAAA;EpC4kHN;EoCxkHE;IACE,kBAAA;EpC0kHJ;EoCxkHI;IACE,QAAA;IACA,UAAA;EpC0kHN;AACF;AoCjkHE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;ApCmkHJ;AqCvpHI;EACE,qBAAA;EACA,oB7B6hBwB;E6B5hBxB,uB7B2hBwB;E6B1hBxB,WAAA;EA9BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;ArCwrHF;AqCroHI;EACE,cAAA;ArCuoHN;;AoCvkHE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;ApC0kHJ;AqC5qHI;EACE,qBAAA;EACA,oB7B6hBwB;E6B5hBxB,uB7B2hBwB;E6B1hBxB,WAAA;EAvBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;ArCssHF;AqC1pHI;EACE,cAAA;ArC4pHN;AoCllHI;EACE,iBAAA;ApColHN;;AoC9kHE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;ApCilHJ;AqCpsHI;EACE,qBAAA;EACA,oB7B6hBwB;E6B5hBxB,uB7B2hBwB;E6B1hBxB,WAAA;ArCssHN;AqC3rHM;EACE,aAAA;ArC6rHR;AqC1rHM;EACE,qBAAA;EACA,qB7B0gBsB;E6BzgBtB,uB7BwgBsB;E6BvgBtB,WAAA;EAnCN,mCAAA;EACA,yBAAA;EACA,sCAAA;ArCguHF;AqC1rHI;EACE,cAAA;ArC4rHN;AoCjmHI;EACE,iBAAA;ApCmmHN;;AoC5lHA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;ApC+lHF;;AoCzlHA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gB5Byb4B;E4Bxb5B,oCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;E1BtKE,uDAAA;AVmwHJ;AoC1lHE;EAEE,0CAAA;EV1LF,kDU4LuB;ApC0lHzB;AoCvlHE;EAEE,2CAAA;EACA,qBAAA;EVlMF,mDUmMuB;ApCwlHzB;AoCrlHE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;ApCslHJ;;AoChlHA;EACE,cAAA;ApCmlHF;;AoC/kHA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E/BmEI,eALI;E+B5DR,sCAAA;EACA,mBAAA;ApCklHF;;AoC9kHA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;ApCilHF;;AoC7kHA;EAEE,4BAAA;EACA,yBAAA;EACA,8DAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,6CAAA;EACA,sDAAA;EACA,qCAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;ApC+kHF;;AsCr0HA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AtCw0HF;AsCt0HE;;EACE,kBAAA;EACA,cAAA;AtCy0HJ;AsCp0HE;;;;;;;;;;;;EAME,UAAA;AtC40HJ;;AsCv0HA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AtC00HF;AsCx0HE;EACE,WAAA;AtC00HJ;;AsCt0HA;E5BhBI,wBAAA;AV01HJ;AsCt0HE;;EAEE,yBAAA;AtCw0HJ;AsCp0HE;;;E5BVE,0BAAA;EACA,6BAAA;AVm1HJ;AsCh0HE;;;E5BNE,yBAAA;EACA,4BAAA;AV20HJ;;AsCnzHA;EACE,qBAAA;EACA,oBAAA;AtCszHF;AsCpzHE;EAGE,cAAA;AtCozHJ;AsCjzHE;EACE,eAAA;AtCmzHJ;;AsC/yHA;EACE,uBAAA;EACA,sBAAA;AtCkzHF;;AsC/yHA;EACE,uBAAA;EACA,sBAAA;AtCkzHF;;AsC9xHA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AtCiyHF;AsC/xHE;;EAEE,WAAA;AtCiyHJ;AsC9xHE;;EAEE,wBAAA;AtCgyHJ;AsC5xHE;;E5B1FE,6BAAA;EACA,4BAAA;AV03HJ;AsC5xHE;;E5B7GE,yBAAA;EACA,0BAAA;AV64HJ;;AuCr6HA;EAEE,+BAAA;EACA,iCAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,uDAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AvCo6HF;;AuCj6HA;EACE,cAAA;EACA,kEAAA;ElCsQI,uCALI;EkC/PR,2CAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;EdfI,uGcgBJ;AvCo6HF;AyBh7HM;EcGN;IdFQ,gBAAA;EzBm7HN;AACF;AuCv6HE;EAEE,qCAAA;AvCw6HJ;AuCp6HE;EACE,UAAA;EACA,mD/BkhBoB;ARo5GxB;AuCl6HE;EAEE,wCAAA;EACA,oBAAA;EACA,eAAA;AvCm6HJ;;AuC35HA;EAEE,kDAAA;EACA,kDAAA;EACA,oDAAA;EACA,2GAAA;EACA,yDAAA;EACA,+CAAA;EACA,uGAAA;EAGA,oFAAA;AvC25HF;AuCz5HE;EACE,yDAAA;EACA,yDAAA;E7B7CA,wDAAA;EACA,yDAAA;AVy8HJ;AuC15HI;EAGE,kBAAA;EACA,wDAAA;AvC05HN;AuCt5HE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;AvCw5HJ;AuCr5HE;EAEE,sDAAA;E7BjEA,yBAAA;EACA,0BAAA;AVw9HJ;;AuC74HA;EAEE,qDAAA;EACA,sCAAA;EACA,sCAAA;AvC+4HF;AuC54HE;E7B5FE,gDAAA;AV2+HJ;AuC34HE;;EAEE,4CAAA;EbjHF,oDakHuB;AvC64HzB;;AuCp4HA;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EAGA,gCAAA;AvCo4HF;AuCl4HE;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;AvCo4HJ;AuCl4HI;EAEE,iCAAA;AvCm4HN;AuC/3HE;;EAEE,gB/B0d0B;E+Bzd1B,gDAAA;EACA,iCAAA;AvCi4HJ;;AuCv3HE;;EAEE,cAAA;EACA,kBAAA;AvC03HJ;;AuCr3HE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;AvCw3HJ;;AuCl3HE;;EACE,WAAA;AvCs3HJ;;AuC52HE;EACE,aAAA;AvC+2HJ;AuC72HE;EACE,cAAA;AvC+2HJ;;AwC5iIA;EAEE,wBAAA;EACA,6BAAA;EACA,2DAAA;EACA,gEAAA;EACA,mEAAA;EACA,+DAAA;EACA,sCAAA;EACA,kCAAA;EACA,iCAAA;EACA,8DAAA;EACA,oEAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,mCAAA;EACA,qEAAA;EACA,0EAAA;EACA,4CAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;AxC4iIF;AwCtiIE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AxC8iIJ;AwC1hIA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;EnC4NI,2CALI;EmCrNR,mCAAA;EACA,qBAAA;EACA,mBAAA;AxC4hIF;AwC1hIE;EAEE,yCAAA;AxC2hIJ;;AwCjhIA;EAEE,0BAAA;EACA,iCAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AxCghIF;AwC7gII;EAEE,oCAAA;AxC8gIN;AwC1gIE;EACE,gBAAA;AxC4gIJ;;AwCngIA;EACE,qB/B+GmB;E+B9GnB,wB/B8GmB;E+B7GnB,6BAAA;AxCsgIF;AwCpgIE;;;EAGE,oCAAA;AxCsgIJ;;AwCz/HA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AxC0/HF;;AwCt/HA;EACE,8EAAA;EnCyII,6CALI;EmClIR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;E9BxIE,qDAAA;EeHE,+Ce6IJ;AxCy/HF;AyBloIM;EeiIN;IfhIQ,gBAAA;EzBqoIN;AACF;AwC5/HE;EACE,qBAAA;AxC8/HJ;AwC3/HE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;AxC6/HJ;;AwCv/HA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;AxC0/HF;;AwCv/HA;EACE,yCAAA;EACA,gBAAA;AxC0/HF;;AiBpnII;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ExCi/HN;EwC/+HM;IACE,mBAAA;ExCi/HR;EwC/+HQ;IACE,kBAAA;ExCi/HV;EwC9+HQ;IACE,kDAAA;IACA,iDAAA;ExCg/HV;EwC5+HM;IACE,iBAAA;ExC8+HR;EwC3+HM;IACE,wBAAA;IACA,gBAAA;ExC6+HR;EwC1+HM;IACE,aAAA;ExC4+HR;EwCz+HM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ExCy+HR;EwCt+HQ;IACE,aAAA;ExCw+HV;EwCr+HQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ExCu+HV;AACF;AiBpqII;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ExCgiIN;EwC9hIM;IACE,mBAAA;ExCgiIR;EwC9hIQ;IACE,kBAAA;ExCgiIV;EwC7hIQ;IACE,kDAAA;IACA,iDAAA;ExC+hIV;EwC3hIM;IACE,iBAAA;ExC6hIR;EwC1hIM;IACE,wBAAA;IACA,gBAAA;ExC4hIR;EwCzhIM;IACE,aAAA;ExC2hIR;EwCxhIM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ExCwhIR;EwCrhIQ;IACE,aAAA;ExCuhIV;EwCphIQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ExCshIV;AACF;AiBntII;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ExC+kIN;EwC7kIM;IACE,mBAAA;ExC+kIR;EwC7kIQ;IACE,kBAAA;ExC+kIV;EwC5kIQ;IACE,kDAAA;IACA,iDAAA;ExC8kIV;EwC1kIM;IACE,iBAAA;ExC4kIR;EwCzkIM;IACE,wBAAA;IACA,gBAAA;ExC2kIR;EwCxkIM;IACE,aAAA;ExC0kIR;EwCvkIM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ExCukIR;EwCpkIQ;IACE,aAAA;ExCskIV;EwCnkIQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ExCqkIV;AACF;AiBlwII;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ExC8nIN;EwC5nIM;IACE,mBAAA;ExC8nIR;EwC5nIQ;IACE,kBAAA;ExC8nIV;EwC3nIQ;IACE,kDAAA;IACA,iDAAA;ExC6nIV;EwCznIM;IACE,iBAAA;ExC2nIR;EwCxnIM;IACE,wBAAA;IACA,gBAAA;ExC0nIR;EwCvnIM;IACE,aAAA;ExCynIR;EwCtnIM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ExCsnIR;EwCnnIQ;IACE,aAAA;ExCqnIV;EwClnIQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ExConIV;AACF;AiBjzII;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ExC6qIN;EwC3qIM;IACE,mBAAA;ExC6qIR;EwC3qIQ;IACE,kBAAA;ExC6qIV;EwC1qIQ;IACE,kDAAA;IACA,iDAAA;ExC4qIV;EwCxqIM;IACE,iBAAA;ExC0qIR;EwCvqIM;IACE,wBAAA;IACA,gBAAA;ExCyqIR;EwCtqIM;IACE,aAAA;ExCwqIR;EwCrqIM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ExCqqIR;EwClqIQ;IACE,aAAA;ExCoqIV;EwCjqIQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ExCmqIV;AACF;AwC1tII;EAEI,iBAAA;EACA,2BAAA;AxC2tIR;AwCztIQ;EACE,mBAAA;AxC2tIV;AwCztIU;EACE,kBAAA;AxC2tIZ;AwCxtIU;EACE,kDAAA;EACA,iDAAA;AxC0tIZ;AwCttIQ;EACE,iBAAA;AxCwtIV;AwCrtIQ;EACE,wBAAA;EACA,gBAAA;AxCutIV;AwCptIQ;EACE,aAAA;AxCstIV;AwCntIQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;Ef9NJ,gBegOI;AxCmtIV;AwChtIU;EACE,aAAA;AxCktIZ;AwC/sIU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AxCitIZ;;AwChsIA;;EAGE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,qEAAA;AxCksIF;;AwC5rII;EACE,qEAAA;AxC+rIN;;AyCx9IA;EAEE,0BAAA;EACA,0BAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,8CAAA;EACA,0DAAA;EACA,gDAAA;EACA,sBAAA;EACA,uFAAA;EACA,gCAAA;EACA,+BAAA;EACA,sDAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,mCAAA;EACA,4BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;E/BjBE,2CAAA;AV0+IJ;AyCr9IE;EACE,eAAA;EACA,cAAA;AzCu9IJ;AyCp9IE;EACE,mBAAA;EACA,sBAAA;AzCs9IJ;AyCp9II;EACE,mBAAA;E/BtBF,0DAAA;EACA,2DAAA;AV6+IJ;AyCp9II;EACE,sBAAA;E/BbF,8DAAA;EACA,6DAAA;AVo+IJ;AyCj9IE;;EAEE,aAAA;AzCm9IJ;;AyC/8IA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;AzCg9IF;;AyC78IA;EACE,4CAAA;EACA,iCAAA;AzCg9IF;;AyC78IA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;AzCg9IF;;AyC78IA;EACE,gBAAA;AzCg9IF;;AyCx8IE;EACE,oCAAA;AzC28IJ;;AyCn8IA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;AzCs8IF;AyCp8IE;E/B7FE,wFAAA;AVoiJJ;;AyCl8IA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;AzCq8IF;AyCn8IE;E/BxGE,wFAAA;AV8iJJ;;AyC57IA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;AzC+7IF;AyC77IE;EACE,mCAAA;EACA,sCAAA;AzC+7IJ;;AyC37IA;EACE,uDAAA;EACA,sDAAA;AzC87IF;;AyC17IA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;E/B1IE,iDAAA;AVwkJJ;;AyC17IA;;;EAGE,WAAA;AzC67IF;;AyC17IA;;E/B3II,0DAAA;EACA,2DAAA;AV0kJJ;;AyC37IA;;E/BlII,8DAAA;EACA,6DAAA;AVkkJJ;;AyCp7IE;EACE,0CAAA;AzCu7IJ;AiBljJI;EwBuHJ;IAQI,aAAA;IACA,mBAAA;EzCu7IF;EyCp7IE;IAEE,SAAA;IACA,gBAAA;EzCq7IJ;EyCn7II;IACE,cAAA;IACA,cAAA;EzCq7IN;EyCh7IM;I/B3KJ,0BAAA;IACA,6BAAA;EV8lJF;EyCj7IQ;;IAGE,0BAAA;EzCk7IV;EyCh7IQ;;IAGE,6BAAA;EzCi7IV;EyC76IM;I/B5KJ,yBAAA;IACA,4BAAA;EV4lJF;EyC96IQ;;IAGE,yBAAA;EzC+6IV;EyC76IQ;;IAGE,4BAAA;EzC86IV;AACF;;A0CnpJA;EAEE,0CAAA;EACA,oCAAA;EACA,8KAAA;EACA,mDAAA;EACA,mDAAA;EACA,qDAAA;EACA,4FAAA;EACA,qCAAA;EACA,kCAAA;EACA,8CAAA;EACA,6CAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,wEAAA;EACA,4EAAA;EACA,sCAAA;EACA,mCAAA;EACA,4DAAA;EACA,qDAAA;A1CqpJF;;A0CjpJA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;ErC4PI,eALI;EqCrPR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;EhCrBE,gBAAA;EgCuBF,qBAAA;EjB1BI,0CiB2BJ;A1CopJF;AyB3qJM;EiBUN;IjBTQ,gBAAA;EzB8qJN;AACF;A0CvpJE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;A1CypJJ;A0CvpJI;EACE,qDAAA;EACA,iDAAA;A1CypJN;A0CppJE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EjBjDE,mDiBkDF;A1CspJJ;AyBpsJM;EiBqCJ;IjBpCM,gBAAA;EzBusJN;AACF;A0CxpJE;EACE,UAAA;A1C0pJJ;A0CvpJE;EACE,UAAA;EACA,UAAA;EACA,oDAAA;A1CypJJ;;A0CrpJA;EACE,gBAAA;A1CwpJF;;A0CrpJA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;A1CwpJF;A0CtpJE;EhC7DE,yDAAA;EACA,0DAAA;AVstJJ;A0CvpJI;EhChEA,+DAAA;EACA,gEAAA;AV0tJJ;A0CtpJE;EACE,aAAA;A1CwpJJ;A0CppJE;EhC5DE,6DAAA;EACA,4DAAA;AVmtJJ;A0CppJM;EhChEF,mEAAA;EACA,kEAAA;AVutJJ;A0CnpJI;EhCrEA,6DAAA;EACA,4DAAA;AV2tJJ;;A0CjpJA;EACE,8EAAA;A1CopJF;;A0C3oJE;EACE,eAAA;EACA,cAAA;EhC9GA,gBAAA;AV6vJJ;A0C5oJI;EAAgB,aAAA;A1C+oJpB;A0C9oJI;EAAe,gBAAA;A1CipJnB;A0C7oJM;EhCtHF,gBAAA;AVswJJ;A0CzoJI;EhC7HA,gBAAA;AVywJJ;;A0CpoJI;EACE,iEAAA;EACA,wEAAA;A1CuoJN;;A2CjyJA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,wDAAA;EACA,sCAAA;EACA,4DAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;EtC+QI,yCALI;EsCxQR,gBAAA;EACA,yCAAA;EjCAE,iDAAA;AViyJJ;;A2C3xJE;EACE,iDAAA;A3C8xJJ;A2C5xJI;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,yFAAA;A3C8xJN;A2C1xJE;EACE,6CAAA;A3C4xJJ;;A4Cj0JA;EAEE,mCAAA;EACA,kCAAA;EvC4RI,+BALI;EuCrRR,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,uDAAA;EACA,+CAAA;EACA,0DAAA;EACA,uDAAA;EACA,gDAAA;EACA,yEAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,yDAAA;EACA,mDAAA;EACA,6DAAA;EAGA,aAAA;EhCpBA,eAAA;EACA,gBAAA;AZs1JF;;A4C/zJA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;EvCgQI,yCALI;EuCzPR,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;EnBpBI,qImBqBJ;A5Ck0JF;AyBn1JM;EmBQN;InBPQ,gBAAA;EzBs1JN;AACF;A4Cr0JE;EACE,UAAA;EACA,uCAAA;EAEA,+CAAA;EACA,qDAAA;A5Cs0JJ;A4Cn0JE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UpC2uCgC;EoC1uChC,iDAAA;A5Cq0JJ;A4Cl0JE;EAEE,UAAA;EACA,wCAAA;ElBtDF,gDkBuDuB;EACrB,sDAAA;A5Cm0JJ;A4Ch0JE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;A5Ci0JJ;;A4C5zJE;EACE,8CpC8sCgC;ARinHpC;A4C1zJM;ElC9BF,0DAAA;EACA,6DAAA;AV21JJ;A4CxzJM;ElClDF,2DAAA;EACA,8DAAA;AV62JJ;;A4C3yJA;EClGE,+BAAA;EACA,iCAAA;ExC8RM,iDAAA;EwC5RN,yDAAA;A7Ci5JF;AKjxJI;EuCjCJ;IvCoMQ,+BAAA;ELknJN;AACF;;A4CnzJA;ECtGE,kCAAA;EACA,iCAAA;ExC0RI,+BALI;EwCnRR,yDAAA;A7C65JF;;A8C/5JA;EAEE,2BAAA;EACA,2BAAA;EzCuRI,yBALI;EyChRR,2BAAA;EACA,sBAAA;EACA,iCAAA;EAGA,qBAAA;EACA,4DAAA;EzC+QI,oCALI;EyCxQR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EpCJE,4CAAA;AVo6JJ;A8C35JE;EACE,aAAA;A9C65JJ;;A8Cx5JA;EACE,kBAAA;EACA,SAAA;A9C25JF;;A+C37JA;EAEE,0BAAA;EACA,6BAAA;EACA,6BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,4EAAA;EACA,iDAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;ErCHE,4CAAA;AV+7JJ;;A+Cv7JA;EAEE,cAAA;A/Cy7JF;;A+Cr7JA;EACE,gBvC6kB4B;EuC5kB5B,iCAAA;A/Cw7JF;;A+Ch7JA;EACE,sBvCs+C8B;AR68GhC;A+Ch7JE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,0BAAA;A/Ck7JJ;;A+C16JE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A/C66JJ;;A+Cj7JE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A/Co7JJ;;A+Cx7JE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A/C27JJ;;A+C/7JE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A/Ck8JJ;;A+Ct8JE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A/Cy8JJ;;A+C78JE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A/Cg9JJ;;A+Cp9JE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A/Cu9JJ;;A+C39JE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A/C89JJ;;AgD1hKE;EACE;IAAK,+BvCwPS;ETsyJhB;AACF;AgD1hKA;;EAGE,8BAAA;E3CkRI,gCALI;E2C3QR,wCAAA;EACA,oCAAA;EACA,oDAAA;EACA,6BAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;E3CsQI,uCALI;E2C/PR,uCAAA;EtCRE,+CAAA;AVkiKJ;;AgDrhKA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EvBxBI,6CuByBJ;AhDwhKF;AyB7iKM;EuBYN;IvBXQ,gBAAA;EzBgjKN;AACF;;AgD1hKA;EtBAE,qMAAA;EsBEA,oEAAA;AhD6hKF;;AgD1hKA;EACE,iBAAA;AhD6hKF;;AgD1hKA;EACE,WAAA;AhD6hKF;;AgDzhKE;EACE,kDAAA;AhD4hKJ;AgDzhKM;EAJJ;IAKM,eAAA;EhD4hKN;AACF;;AiDxlKA;EAEE,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,oCAAA;EACA,sCAAA;EACA,uDAAA;EACA,4DAAA;EACA,sDAAA;EACA,yDAAA;EACA,wDAAA;EACA,yDAAA;EACA,8CAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EvCXE,iDAAA;AVkmKJ;;AiDnlKA;EACE,qBAAA;EACA,sBAAA;AjDslKF;AiDplKE;EAEE,oCAAA;EACA,0BAAA;AjDqlKJ;;AiD5kKA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;AjD+kKF;AiD5kKE;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;AjD6kKJ;AiD1kKE;EACE,+CAAA;EACA,uDAAA;AjD4kKJ;;AiDpkKA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;AjDukKF;AiDrkKE;EvCvDE,+BAAA;EACA,gCAAA;AV+nKJ;AiDrkKE;EvC7CE,mCAAA;EACA,kCAAA;AVqnKJ;AiDrkKE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;AjDskKJ;AiDlkKE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;AjDokKJ;AiDhkKE;EACE,mBAAA;AjDkkKJ;AiDhkKI;EACE,wDAAA;EACA,mDAAA;AjDkkKN;;AiDrjKI;EACE,mBAAA;AjDwjKN;AiDrjKQ;EvCvDJ,6DAAA;EAZA,0BAAA;AV4nKJ;AiDpjKQ;EvCxEJ,2DAAA;EAYA,4BAAA;AVonKJ;AiDnjKQ;EACE,aAAA;AjDqjKV;AiDljKQ;EACE,mDAAA;EACA,oBAAA;AjDojKV;AiDljKU;EACE,yDAAA;EACA,oDAAA;AjDojKZ;;AiB1oKI;EgC8DA;IACE,mBAAA;EjDglKJ;EiD7kKM;IvCvDJ,6DAAA;IAZA,0BAAA;EVopKF;EiD5kKM;IvCxEJ,2DAAA;IAYA,4BAAA;EV4oKF;EiD3kKM;IACE,aAAA;EjD6kKR;EiD1kKM;IACE,mDAAA;IACA,oBAAA;EjD4kKR;EiD1kKQ;IACE,yDAAA;IACA,oDAAA;EjD4kKV;AACF;AiBnqKI;EgC8DA;IACE,mBAAA;EjDwmKJ;EiDrmKM;IvCvDJ,6DAAA;IAZA,0BAAA;EV4qKF;EiDpmKM;IvCxEJ,2DAAA;IAYA,4BAAA;EVoqKF;EiDnmKM;IACE,aAAA;EjDqmKR;EiDlmKM;IACE,mDAAA;IACA,oBAAA;EjDomKR;EiDlmKQ;IACE,yDAAA;IACA,oDAAA;EjDomKV;AACF;AiB3rKI;EgC8DA;IACE,mBAAA;EjDgoKJ;EiD7nKM;IvCvDJ,6DAAA;IAZA,0BAAA;EVosKF;EiD5nKM;IvCxEJ,2DAAA;IAYA,4BAAA;EV4rKF;EiD3nKM;IACE,aAAA;EjD6nKR;EiD1nKM;IACE,mDAAA;IACA,oBAAA;EjD4nKR;EiD1nKQ;IACE,yDAAA;IACA,oDAAA;EjD4nKV;AACF;AiBntKI;EgC8DA;IACE,mBAAA;EjDwpKJ;EiDrpKM;IvCvDJ,6DAAA;IAZA,0BAAA;EV4tKF;EiDppKM;IvCxEJ,2DAAA;IAYA,4BAAA;EVotKF;EiDnpKM;IACE,aAAA;EjDqpKR;EiDlpKM;IACE,mDAAA;IACA,oBAAA;EjDopKR;EiDlpKQ;IACE,yDAAA;IACA,oDAAA;EjDopKV;AACF;AiB3uKI;EgC8DA;IACE,mBAAA;EjDgrKJ;EiD7qKM;IvCvDJ,6DAAA;IAZA,0BAAA;EVovKF;EiD5qKM;IvCxEJ,2DAAA;IAYA,4BAAA;EV4uKF;EiD3qKM;IACE,aAAA;EjD6qKR;EiD1qKM;IACE,mDAAA;IACA,oBAAA;EjD4qKR;EiD1qKQ;IACE,yDAAA;IACA,oDAAA;EjD4qKV;AACF;AiD/pKA;EvChJI,gBAAA;AVkzKJ;AiD/pKE;EACE,mDAAA;AjDiqKJ;AiD/pKI;EACE,sBAAA;AjDiqKN;;AiDppKE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AjDupKJ;;AiDjqKE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;AjDoqKJ;;AiD9qKE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AjDirKJ;;AiD3rKE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;AjD8rKJ;;AiDxsKE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AjD2sKJ;;AiDrtKE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;AjDwtKJ;;AiDluKE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;AjDquKJ;;AiD/uKE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;AjDkvKJ;;AkD96KA;EAEE,6BAAA;EACA,2DAAA;EACA,2BAAA;EACA,kCAAA;EACA,oEAAA;EACA,+BAAA;EACA,qCAAA;EACA,uEAAA;EAGA,uBAAA;EACA,U1CqpD2B;E0CppD3B,W1CopD2B;E0CnpD3B,sBAAA;EACA,gCAAA;EACA,wEAAA;EACA,SAAA;ExCJE,qBAAA;EwCMF,oCAAA;AlD86KF;AkD36KE;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;AlD66KJ;AkD16KE;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;AlD46KJ;AkDz6KE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6CAAA;AlD06KJ;;AkDl6KA;EAHE,wCAAA;AlDy6KF;;AkDh6KI;EATF,wCAAA;AlD66KF;;AmD99KA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,wBAAA;EACA,2BAAA;E9CyRI,8BALI;E8ClRR,kBAAA;EACA,gDAAA;EACA,+CAAA;EACA,2DAAA;EACA,iDAAA;EACA,2CAAA;EACA,kDAAA;EACA,uDAAA;EACA,kEAAA;EAGA,gCAAA;EACA,eAAA;E9C2QI,oCALI;E8CpQR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;EzCRE,4CAAA;AVu+KJ;AmD59KE;EACE,UAAA;AnD89KJ;AmD39KE;EACE,aAAA;AnD69KJ;;AmDz9KA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AnD29KF;AmDz9KE;EACE,sCAAA;AnD29KJ;;AmDv9KA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;EzChCE,0FAAA;EACA,2FAAA;AV2/KJ;AmDz9KE;EACE,oDAAA;EACA,sCAAA;AnD29KJ;;AmDv9KA;EACE,kCAAA;EACA,qBAAA;AnD09KF;;AoDxhLA;EAEE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gCAAA;EACA,2DAAA;EACA,+CAAA;EACA,oDAAA;EACA,8CAAA;EACA,2FAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EACA,sDAAA;EACA,sDAAA;EACA,kCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,sDAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;ApDshLF;;AoD/gLA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;ApDihLF;AoD9gLE;E3B5CI,mC2B6CF;EACA,8B5Ck8CgC;AR8kIpC;AyB1jLM;E2BwCJ;I3BvCM,gBAAA;EzB6jLN;AACF;AoDnhLE;EACE,e5Cg8CgC;ARqlIpC;AoDjhLE;EACE,sB5C67CgC;ARslIpC;;AoD/gLA;EACE,+CAAA;ApDkhLF;AoDhhLE;EACE,gBAAA;EACA,gBAAA;ApDkhLJ;AoD/gLE;EACE,gBAAA;ApDihLJ;;AoD7gLA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;ApDghLF;;AoD5gLA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E1CrFE,4CAAA;E0CyFF,UAAA;ApD4gLF;;AoDxgLA;EAEE,0BAAA;EACA,yBAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;ApD8gL9D;AqD1nLE;EAAS,UAAA;ArD6nLX;AqD5nLE;EAAS,mCD2GiF;ApDohL5F;;AoD/gLA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uCAAA;EACA,4FAAA;E1CrGE,2DAAA;EACA,4DAAA;AVwnLJ;AoDjhLE;EACE,kGAAA;EACA,sJAAA;ApDmhLJ;;AoD9gLA;EACE,gBAAA;EACA,8CAAA;ApDihLF;;AoD5gLA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;ApD6gLF;;AoDzgLA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;E1CzHE,+DAAA;EACA,8DAAA;AVsoLJ;AoDxgLE;EACE,8CAAA;ApD0gLJ;;AiBrnLI;EmCiHF;IACE,0BAAA;IACA,2CAAA;EpDwgLF;EoDpgLA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;EpDsgLF;EoDngLA;IACE,uBAAA;EpDqgLF;AACF;AiBpoLI;EmCmIF;;IAEE,uBAAA;EpDogLF;AACF;AiB1oLI;EmC0IF;IACE,wBAAA;EpDmgLF;AACF;AoD1/KI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;ApD4/KN;AoD1/KM;EACE,YAAA;EACA,SAAA;E1CzMJ,gBAAA;AVssLJ;AoDz/KM;;E1C7MF,gBAAA;AV0sLJ;AoDx/KM;EACE,gBAAA;ApD0/KR;;AiBppLI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EpDghLJ;EoD9gLI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;EV0tLF;EoD7gLI;;I1C7MF,gBAAA;EV8tLF;EoD5gLI;IACE,gBAAA;EpD8gLN;AACF;AiBzqLI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EpDoiLJ;EoDliLI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;EV8uLF;EoDjiLI;;I1C7MF,gBAAA;EVkvLF;EoDhiLI;IACE,gBAAA;EpDkiLN;AACF;AiB7rLI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EpDwjLJ;EoDtjLI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;EVkwLF;EoDrjLI;;I1C7MF,gBAAA;EVswLF;EoDpjLI;IACE,gBAAA;EpDsjLN;AACF;AiBjtLI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EpD4kLJ;EoD1kLI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;EVsxLF;EoDzkLI;;I1C7MF,gBAAA;EV0xLF;EoDxkLI;IACE,gBAAA;EpD0kLN;AACF;AiBruLI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EpDgmLJ;EoD9lLI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;EV0yLF;EoD7lLI;;I1C7MF,gBAAA;EV8yLF;EoD5lLI;IACE,gBAAA;EpD8lLN;AACF;AsDp0LA;EAEE,yBAAA;EACA,6BAAA;EACA,gCAAA;EACA,8BAAA;EACA,qBAAA;EjDwRI,gCALI;EiDjRR,qCAAA;EACA,wBAAA;EACA,oCAAA;EACA,uBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,gCAAA;EClBA,sC/C+lB4B;E+C7lB5B,kBAAA;EACA,gB/CwmB4B;E+CvmB5B,iB9CsHiB;E8CrHjB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;ElDgRI,sCALI;EiDhQR,qBAAA;EACA,UAAA;AtD40LF;AsD10LE;EAAS,kCAAA;AtD60LX;AsD30LE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AtD60LJ;AsD30LI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AtD60LN;;AsDx0LA;EACE,iDAAA;AtD20LF;AsDz0LE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;AtD20LJ;;AsDv0LA,qBAAA;AACA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;AtD00LF;AsDx0LE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;AtD00LJ;;AsDt0LA,mBAAA;AAEA;EACE,8CAAA;AtDw0LF;AsDt0LE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;AtDw0LJ;;AsDp0LA,qBAAA;AACA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;AtDu0LF;AsDr0LE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;AtDu0LJ;;AsDn0LA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E5CjGE,8CAAA;AVu5LJ;;AwD16LA;EAEE,yBAAA;EACA,6BAAA;EnD4RI,gCALI;EmDrRR,kCAAA;EACA,iDAAA;EACA,6DAAA;EACA,oCAAA;EACA,yEAAA;EACA,6CAAA;EACA,mCAAA;EACA,qCAAA;EnDmRI,mCALI;EmD5QR,kCAAA;EACA,+BAAA;EACA,iCAAA;EACA,iCAAA;EACA,6CAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,sC/C+lB4B;E+C7lB5B,kBAAA;EACA,gB/CwmB4B;E+CvmB5B,iB9CsHiB;E8CrHjB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;ElDgRI,sCALI;EmD1PR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;E9ChBE,8CAAA;AVq8LJ;AwDj7LE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AxDm7LJ;AwDj7LI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AxDk7LN;;AwD56LE;EACE,oFAAA;AxD+6LJ;AwD76LI;EAEE,wFAAA;AxD86LN;AwD36LI;EACE,SAAA;EACA,gDAAA;AxD66LN;AwD16LI;EACE,sCAAA;EACA,sCAAA;AxD46LN;;AwDv6LA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;AxDy6LJ;AwDv6LI;EAEE,kIAAA;AxDw6LN;AwDr6LI;EACE,OAAA;EACA,kDAAA;AxDu6LN;AwDp6LI;EACE,oCAAA;EACA,wCAAA;AxDs6LN;;AwDj6LA,mBAAA;AAGE;EACE,iFAAA;AxDk6LJ;AwDh6LI;EAEE,wFAAA;AxDi6LN;AwD95LI;EACE,MAAA;EACA,mDAAA;AxDg6LN;AwD75LI;EACE,mCAAA;EACA,yCAAA;AxD+5LN;AwD15LE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;AxD45LJ;;AwDx5LA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;AxD05LJ;AwDx5LI;EAEE,kIAAA;AxDy5LN;AwDt5LI;EACE,QAAA;EACA,iDAAA;AxDw5LN;AwDr5LI;EACE,qCAAA;EACA,uCAAA;AxDu5LN;;AwDl5LA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;EnD2GI,6CALI;EmDpGR,qCAAA;EACA,6CAAA;EACA,kFAAA;E9C5JE,6DAAA;EACA,8DAAA;AViiMJ;AwDn4LE;EACE,aAAA;AxDq4LJ;;AwDj4LA;EACE,0EAAA;EACA,mCAAA;AxDo4LF;;AyDzjMA;EACE,kBAAA;AzD4jMF;;AyDzjMA;EACE,mBAAA;AzD4jMF;;AyDzjMA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AzD4jMF;A0DllME;EACE,cAAA;EACA,WAAA;EACA,WAAA;A1DolMJ;;AyD7jMA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EhClBI,sCgCmBJ;AzDgkMF;AyB/kMM;EgCQN;IhCPQ,gBAAA;EzBklMN;AACF;;AyDlkMA;;;EAGE,cAAA;AzDqkMF;;AyDlkMA;;EAEE,2BAAA;AzDqkMF;;AyDlkMA;;EAEE,4BAAA;AzDqkMF;;AyD5jME;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AzD+jMJ;AyD5jME;;;EAGE,UAAA;EACA,UAAA;AzD8jMJ;AyD3jME;;EAEE,UAAA;EACA,UAAA;EhC5DE,2BgC6DF;AzD6jMJ;AyBtnMM;EgCqDJ;;IhCpDM,gBAAA;EzB0nMN;AACF;;AyD1jMA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UjDkhDmC;EiDjhDnC,UAAA;EACA,WhDtFM;EgDuFN,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YjD6gDmC;EiBnmD/B,8BgCuFJ;AzD4jMF;AyB/oMM;EgCkEN;;IhCjEQ,gBAAA;EzBmpMN;AACF;AyD/jME;;;EAEE,WhDhGI;EgDiGJ,qBAAA;EACA,UAAA;EACA,YjDqgDiC;AR6jJrC;;AyD/jMA;EACE,OAAA;AzDkkMF;;AyD/jMA;EACE,QAAA;AzDkkMF;;AyD7jMA;;EAEE,qBAAA;EACA,WjDsgDmC;EiDrgDnC,YjDqgDmC;EiDpgDnC,4BAAA;EACA,wBAAA;EACA,0BAAA;AzDgkMF;;AyD7jMA;EACE,2TAAA;AzDgkMF;;AyD9jMA;EACE,0TAAA;AzDikMF;;AyDzjMA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBjDs9CmC;EiDr9CnC,mBAAA;EACA,gBjDo9CmC;ARumJrC;AyDzjME;EACE,uBAAA;EACA,cAAA;EACA,WjDo9CiC;EiDn9CjC,WjDo9CiC;EiDn9CjC,UAAA;EACA,iBjDo9CiC;EiDn9CjC,gBjDm9CiC;EiDl9CjC,mBAAA;EACA,eAAA;EACA,sBhD9JI;EgD+JJ,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YjD28CiC;EiB3mD/B,6BgCiKF;AzD0jMJ;AyBvtMM;EgC4IJ;IhC3IM,gBAAA;EzB0tMN;AACF;AyD5jME;EACE,UjDw8CiC;ARsnJrC;;AyDrjMA;EACE,kBAAA;EACA,UAAA;EACA,ejDk8CmC;EiDj8CnC,SAAA;EACA,oBjD+7CmC;EiD97CnC,uBjD87CmC;EiD77CnC,WhDzLM;EgD0LN,kBAAA;AzDwjMF;;AyDljME;;EAEE,gCjDm8CiC;ARknJrC;AyDljME;EACE,yBhD3LI;AT+uMR;AyDjjME;EACE,chD/LI;ATkvMR;;AyD7jME;;;EAEE,gCjDm8CiC;AR8nJrC;AyD9jME;EACE,yBhD3LI;AT2vMR;AyD7jME;EACE,chD/LI;AT8vMR;;A2DjxMA;;EAEE,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;A3DmxMF;;A2D/wMA;EACE;IAAK,0CAAA;E3DmxML;AACF;A2DhxMA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;A3D+wMF;;A2D5wMA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;A3D8wMF;;A2DrwMA;EACE;IACE,mBAAA;E3DwwMF;E2DtwMA;IACE,UAAA;IACA,eAAA;E3DwwMF;AACF;A2DpwMA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;A3DmwMF;;A2DhwMA;EACE,wBAAA;EACA,yBAAA;A3DmwMF;;A2D/vME;EACE;;IAEE,kCAAA;E3DkwMJ;AACF;A4Dl1MA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,0CAAA;EACA,oCAAA;EACA,mDAAA;EACA,+DAAA;EACA,kDAAA;EACA,qDAAA;EACA,sCAAA;A5Dm1MF;;AiBtxMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E5Do0MJ;AACF;AyB/1MM;EmCYJ;InCXM,gBAAA;EzBk2MN;AACF;AiB5yMI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E5D20MN;E4Dx0MI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E5D00MN;E4Dv0MI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E5Dy0MN;E4Dt0MI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E5Dw0MN;E4Dr0MI;IAEE,eAAA;E5Ds0MN;E4Dn0MI;IAGE,mBAAA;E5Dm0MN;AACF;AiBh2MI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E5Dk0MN;E4Dh0MM;IACE,aAAA;E5Dk0MR;E4D/zMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E5Dg0MR;AACF;;AiBp2MI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E5Dk5MJ;AACF;AyB76MM;EmCYJ;InCXM,gBAAA;EzBg7MN;AACF;AiB13MI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E5Dy5MN;E4Dt5MI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E5Dw5MN;E4Dr5MI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E5Du5MN;E4Dp5MI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E5Ds5MN;E4Dn5MI;IAEE,eAAA;E5Do5MN;E4Dj5MI;IAGE,mBAAA;E5Di5MN;AACF;AiB96MI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E5Dg5MN;E4D94MM;IACE,aAAA;E5Dg5MR;E4D74MM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E5D84MR;AACF;;AiBl7MI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E5Dg+MJ;AACF;AyB3/MM;EmCYJ;InCXM,gBAAA;EzB8/MN;AACF;AiBx8MI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E5Du+MN;E4Dp+MI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E5Ds+MN;E4Dn+MI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E5Dq+MN;E4Dl+MI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E5Do+MN;E4Dj+MI;IAEE,eAAA;E5Dk+MN;E4D/9MI;IAGE,mBAAA;E5D+9MN;AACF;AiB5/MI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E5D89MN;E4D59MM;IACE,aAAA;E5D89MR;E4D39MM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E5D49MR;AACF;;AiBhgNI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E5D8iNJ;AACF;AyBzkNM;EmCYJ;InCXM,gBAAA;EzB4kNN;AACF;AiBthNI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E5DqjNN;E4DljNI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E5DojNN;E4DjjNI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E5DmjNN;E4DhjNI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E5DkjNN;E4D/iNI;IAEE,eAAA;E5DgjNN;E4D7iNI;IAGE,mBAAA;E5D6iNN;AACF;AiB1kNI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E5D4iNN;E4D1iNM;IACE,aAAA;E5D4iNR;E4DziNM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E5D0iNR;AACF;;AiB9kNI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E5D4nNJ;AACF;AyBvpNM;EmCYJ;InCXM,gBAAA;EzB0pNN;AACF;AiBpmNI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E5DmoNN;E4DhoNI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E5DkoNN;E4D/nNI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E5DioNN;E4D9nNI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E5DgoNN;E4D7nNI;IAEE,eAAA;E5D8nNN;E4D3nNI;IAGE,mBAAA;E5D2nNN;AACF;AiBxpNI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E5D0nNN;E4DxnNM;IACE,aAAA;E5D0nNR;E4DvnNM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E5DwnNR;AACF;;A4DxsNE;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EnC5BA,0CmC8BA;A5DysNN;AyBnuNM;EmCYJ;InCXM,gBAAA;EzBsuNN;AACF;A4D5sNM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;A5D8sNR;A4D3sNM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;A5D6sNR;A4D1sNM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;A5D4sNR;A4DzsNM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;A5D2sNR;A4DxsNM;EAEE,eAAA;A5DysNR;A4DtsNM;EAGE,mBAAA;A5DssNR;;A4D3qNA;EPpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a7C0mCkC;E6CzmClC,YAAA;EACA,aAAA;EACA,yB5CeM;AToxNR;AqDhyNE;EAAS,UAAA;ArDmyNX;AqDlyNE;EAAS,Y7Cm+CyB;ARk0KpC;;A4DvrNA;EACE,aAAA;EACA,mBAAA;EACA,oEAAA;A5D0rNF;A4DxrNE;EACE,4FAAA;EACA,6IAAA;A5D0rNJ;;A4DtrNA;EACE,gBAAA;EACA,kDAAA;A5DyrNF;;A4DtrNA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;A5DyrNF;;A6Dt0NA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YrDgzCkC;ARyhLpC;A6Dv0NE;EACE,qBAAA;EACA,WAAA;A7Dy0NJ;;A6Dp0NA;EACE,iBAAA;A7Du0NF;;A6Dp0NA;EACE,iBAAA;A7Du0NF;;A6Dp0NA;EACE,iBAAA;A7Du0NF;;A6Dl0NE;EACE,mDAAA;A7Dq0NJ;;A6Dj0NA;EACE;IACE,YrDmxCgC;ERijLlC;AACF;A6Dj0NA;EACE,qFAAA;EACA,oBAAA;EACA,8CAAA;A7Dm0NF;;A6Dh0NA;EACE;IACE,uBAAA;E7Dm0NF;AACF;A0Dl3NE;EACE,cAAA;EACA,WAAA;EACA,WAAA;A1Do3NJ;;A8Dv3NE;EACE,sBAAA;EACA,iFAAA;A9D03NJ;;A8D53NE;EACE,yBAAA;EACA,mFAAA;A9D+3NJ;;A8Dj4NE;EACE,yBAAA;EACA,iFAAA;A9Do4NJ;;A8Dt4NE;EACE,yBAAA;EACA,8EAAA;A9Dy4NJ;;A8D34NE;EACE,yBAAA;EACA,iFAAA;A9D84NJ;;A8Dh5NE;EACE,yBAAA;EACA,gFAAA;A9Dm5NJ;;A8Dr5NE;EACE,yBAAA;EACA,+EAAA;A9Dw5NJ;;A8D15NE;EACE,sBAAA;EACA,8EAAA;A9D65NJ;;A+D/5NE;EACE,wEAAA;EACA,kGAAA;A/Dk6NJ;A+D/5NM;EAGE,8DAAA;EACA,wFAAA;A/D+5NR;;A+Dx6NE;EACE,0EAAA;EACA,oGAAA;A/D26NJ;A+Dx6NM;EAGE,gEAAA;EACA,0FAAA;A/Dw6NR;;A+Dj7NE;EACE,wEAAA;EACA,kGAAA;A/Do7NJ;A+Dj7NM;EAGE,+DAAA;EACA,yFAAA;A/Di7NR;;A+D17NE;EACE,qEAAA;EACA,+FAAA;A/D67NJ;A+D17NM;EAGE,+DAAA;EACA,yFAAA;A/D07NR;;A+Dn8NE;EACE,wEAAA;EACA,kGAAA;A/Ds8NJ;A+Dn8NM;EAGE,gEAAA;EACA,0FAAA;A/Dm8NR;;A+D58NE;EACE,uEAAA;EACA,iGAAA;A/D+8NJ;A+D58NM;EAGE,gEAAA;EACA,0FAAA;A/D48NR;;A+Dr9NE;EACE,sEAAA;EACA,gGAAA;A/Dw9NJ;A+Dr9NM;EAGE,gEAAA;EACA,0FAAA;A/Dq9NR;;A+D99NE;EACE,qEAAA;EACA,+FAAA;A/Di+NJ;A+D99NM;EAGE,6DAAA;EACA,uFAAA;A/D89NR;;A+Dv9NA;EACE,+EAAA;EACA,yGAAA;A/D09NF;A+Dv9NI;EAEE,kFAAA;EACA,4GAAA;A/Dw9NN;;AgEl/NA;EACE,UAAA;EAEA,kJAAA;AhEo/NF;;AiEv/NA;EACE,oBAAA;EACA,azD6c4B;EyD5c5B,mBAAA;EACA,kFAAA;EACA,6BzD2c4B;EyD1c5B,2BAAA;AjE0/NF;AiEx/NE;EACE,cAAA;EACA,UzDuc0B;EyDtc1B,WzDsc0B;EyDrc1B,kBAAA;ExCIE,sCwCHF;AjE0/NJ;AyBn/NM;EwCZJ;IxCaM,gBAAA;EzBs/NN;AACF;;AiEx/NI;EACE,mEAAA;AjE2/NN;;AkE9gOA;EACE,kBAAA;EACA,WAAA;AlEihOF;AkE/gOE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;AlEihOJ;AkE9gOE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AlEghOJ;;AkE3gOE;EACE,uBAAA;AlE8gOJ;;AkE/gOE;EACE,sBAAA;AlEkhOJ;;AkEnhOE;EACE,yBAAA;AlEshOJ;;AkEvhOE;EACE,iCAAA;AlE0hOJ;;AmE/iOA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a3DumCkC;AR28LpC;;AmE/iOA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a3D+lCkC;ARm9LpC;;AmE1iOI;EACE,gBAAA;EACA,MAAA;EACA,a3DmlC8B;AR09LpC;;AmE1iOI;EACE,gBAAA;EACA,SAAA;EACA,a3D6kC8B;ARg+LpC;;AiB9gOI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a3DmlC8B;ERu+LlC;EmEvjOE;IACE,gBAAA;IACA,SAAA;IACA,a3D6kC8B;ER4+LlC;AACF;AiB3hOI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a3DmlC8B;ERm/LlC;EmEnkOE;IACE,gBAAA;IACA,SAAA;IACA,a3D6kC8B;ERw/LlC;AACF;AiBviOI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a3DmlC8B;ER+/LlC;EmE/kOE;IACE,gBAAA;IACA,SAAA;IACA,a3D6kC8B;ERogMlC;AACF;AiBnjOI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a3DmlC8B;ER2gMlC;EmE3lOE;IACE,gBAAA;IACA,SAAA;IACA,a3D6kC8B;ERghMlC;AACF;AiB/jOI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a3DmlC8B;ERuhMlC;EmEvmOE;IACE,gBAAA;IACA,SAAA;IACA,a3D6kC8B;ER4hMlC;AACF;AoEzoOA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;ApE2oOF;;AoExoOA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;ApE2oOF;;AqEnpOA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AtEopOF;AsEjpOE;;EACE,6BAAA;AtEopOJ;;AuElqOE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U/DgcsC;E+D/btC,WAAA;AvEqqOJ;;AwE7qOA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;AzEirOF;;A0EvrOA;EACE,qBAAA;EACA,mBAAA;EACA,6BlEisB4B;EkEhsB5B,eAAA;EACA,8BAAA;EACA,alE2rB4B;AR+/M9B;;A2E9nOQ;EAOI,mCAAA;A3E2nOZ;;A2EloOQ;EAOI,8BAAA;A3E+nOZ;;A2EtoOQ;EAOI,iCAAA;A3EmoOZ;;A2E1oOQ;EAOI,iCAAA;A3EuoOZ;;A2E9oOQ;EAOI,sCAAA;A3E2oOZ;;A2ElpOQ;EAOI,mCAAA;A3E+oOZ;;A2EtpOQ;EAOI,sBAAA;A3EmpOZ;;A2E1pOQ;EAOI,uBAAA;A3EupOZ;;A2E9pOQ;EAOI,sBAAA;A3E2pOZ;;A2ElqOQ;EAOI,8BAAA;A3E+pOZ;;A2EtqOQ;EAOI,4BAAA;A3EmqOZ;;A2E1qOQ;EAOI,2BAAA;A3EuqOZ;;A2E9qOQ;EAOI,iCAAA;A3E2qOZ;;A2ElrOQ;EAOI,2BAAA;A3E+qOZ;;A2EtrOQ;EAOI,qBAAA;A3EmrOZ;;A2E1rOQ;EAOI,wBAAA;A3EurOZ;;A2E9rOQ;EAOI,uBAAA;A3E2rOZ;;A2ElsOQ;EAOI,wBAAA;A3E+rOZ;;A2EtsOQ;EAOI,qBAAA;A3EmsOZ;;A2E1sOQ;EAOI,yBAAA;A3EusOZ;;A2E9sOQ;EAOI,2BAAA;A3E2sOZ;;A2EltOQ;EAOI,4BAAA;A3E+sOZ;;A2EttOQ;EAOI,2BAAA;A3EmtOZ;;A2E1tOQ;EAOI,2BAAA;A3EutOZ;;A2E9tOQ;EAOI,6BAAA;A3E2tOZ;;A2EluOQ;EAOI,8BAAA;A3E+tOZ;;A2EtuOQ;EAOI,6BAAA;A3EmuOZ;;A2E1uOQ;EAOI,2BAAA;A3EuuOZ;;A2E9uOQ;EAOI,6BAAA;A3E2uOZ;;A2ElvOQ;EAOI,8BAAA;A3E+uOZ;;A2EtvOQ;EAOI,6BAAA;A3EmvOZ;;A2E1vOQ;EAOI,0BAAA;A3EuvOZ;;A2E9vOQ;EAOI,gCAAA;A3E2vOZ;;A2ElwOQ;EAOI,yBAAA;A3E+vOZ;;A2EtwOQ;EAOI,wBAAA;A3EmwOZ;;A2E1wOQ;EAOI,+BAAA;A3EuwOZ;;A2E9wOQ;EAOI,yBAAA;A3E2wOZ;;A2ElxOQ;EAOI,6BAAA;A3E+wOZ;;A2EtxOQ;EAOI,8BAAA;A3EmxOZ;;A2E1xOQ;EAOI,wBAAA;A3EuxOZ;;A2E9xOQ;EAOI,+BAAA;A3E2xOZ;;A2ElyOQ;EAOI,wBAAA;A3E+xOZ;;A2EtyOQ;EAOI,2CAAA;A3EmyOZ;;A2E1yOQ;EAOI,8CAAA;A3EuyOZ;;A2E9yOQ;EAOI,8CAAA;A3E2yOZ;;A2ElzOQ;EAOI,2BAAA;A3E+yOZ;;A2Eh0OQ;EACE,gFAAA;A3Em0OV;;A2Ep0OQ;EACE,kFAAA;A3Eu0OV;;A2Ex0OQ;EACE,gFAAA;A3E20OV;;A2E50OQ;EACE,6EAAA;A3E+0OV;;A2Eh1OQ;EACE,gFAAA;A3Em1OV;;A2Ep1OQ;EACE,+EAAA;A3Eu1OV;;A2Ex1OQ;EACE,8EAAA;A3E21OV;;A2E51OQ;EACE,6EAAA;A3E+1OV;;A2Et1OQ;EAOI,2BAAA;A3Em1OZ;;A2E11OQ;EAOI,6BAAA;A3Eu1OZ;;A2E91OQ;EAOI,6BAAA;A3E21OZ;;A2El2OQ;EAOI,0BAAA;A3E+1OZ;;A2Et2OQ;EAOI,2BAAA;A3Em2OZ;;A2E12OQ;EAOI,iBAAA;A3Eu2OZ;;A2E92OQ;EAOI,mBAAA;A3E22OZ;;A2El3OQ;EAOI,oBAAA;A3E+2OZ;;A2Et3OQ;EAOI,oBAAA;A3Em3OZ;;A2E13OQ;EAOI,sBAAA;A3Eu3OZ;;A2E93OQ;EAOI,uBAAA;A3E23OZ;;A2El4OQ;EAOI,kBAAA;A3E+3OZ;;A2Et4OQ;EAOI,oBAAA;A3Em4OZ;;A2E14OQ;EAOI,qBAAA;A3Eu4OZ;;A2E94OQ;EAOI,mBAAA;A3E24OZ;;A2El5OQ;EAOI,qBAAA;A3E+4OZ;;A2Et5OQ;EAOI,sBAAA;A3Em5OZ;;A2E15OQ;EAOI,2CAAA;A3Eu5OZ;;A2E95OQ;EAOI,sCAAA;A3E25OZ;;A2El6OQ;EAOI,sCAAA;A3E+5OZ;;A2Et6OQ;EAOI,uFAAA;A3Em6OZ;;A2E16OQ;EAOI,oBAAA;A3Eu6OZ;;A2E96OQ;EAOI,2FAAA;A3E26OZ;;A2El7OQ;EAOI,wBAAA;A3E+6OZ;;A2Et7OQ;EAOI,6FAAA;A3Em7OZ;;A2E17OQ;EAOI,0BAAA;A3Eu7OZ;;A2E97OQ;EAOI,8FAAA;A3E27OZ;;A2El8OQ;EAOI,2BAAA;A3E+7OZ;;A2Et8OQ;EAOI,4FAAA;A3Em8OZ;;A2E18OQ;EAOI,yBAAA;A3Eu8OZ;;A2E98OQ;EAIQ,sBAAA;EAGJ,8EAAA;A3E48OZ;;A2En9OQ;EAIQ,sBAAA;EAGJ,gFAAA;A3Ei9OZ;;A2Ex9OQ;EAIQ,sBAAA;EAGJ,8EAAA;A3Es9OZ;;A2E79OQ;EAIQ,sBAAA;EAGJ,2EAAA;A3E29OZ;;A2El+OQ;EAIQ,sBAAA;EAGJ,8EAAA;A3Eg+OZ;;A2Ev+OQ;EAIQ,sBAAA;EAGJ,6EAAA;A3Eq+OZ;;A2E5+OQ;EAIQ,sBAAA;EAGJ,4EAAA;A3E0+OZ;;A2Ej/OQ;EAIQ,sBAAA;EAGJ,2EAAA;A3E++OZ;;A2Et/OQ;EAIQ,sBAAA;EAGJ,4EAAA;A3Eo/OZ;;A2E3/OQ;EAIQ,sBAAA;EAGJ,4EAAA;A3Ey/OZ;;A2EhgPQ;EAOI,wDAAA;A3E6/OZ;;A2EpgPQ;EAOI,0DAAA;A3EigPZ;;A2ExgPQ;EAOI,wDAAA;A3EqgPZ;;A2E5gPQ;EAOI,qDAAA;A3EygPZ;;A2EhhPQ;EAOI,wDAAA;A3E6gPZ;;A2EphPQ;EAOI,uDAAA;A3EihPZ;;A2ExhPQ;EAOI,sDAAA;A3EqhPZ;;A2E5hPQ;EAOI,qDAAA;A3EyhPZ;;A2EhiPQ;EAOI,4BAAA;A3E6hPZ;;A2EpiPQ;EAOI,4BAAA;A3EiiPZ;;A2ExiPQ;EAOI,4BAAA;A3EqiPZ;;A2E5iPQ;EAOI,4BAAA;A3EyiPZ;;A2EhjPQ;EAOI,4BAAA;A3E6iPZ;;A2E9jPQ;EACE,wBAAA;A3EikPV;;A2ElkPQ;EACE,yBAAA;A3EqkPV;;A2EtkPQ;EACE,wBAAA;A3EykPV;;A2E1kPQ;EACE,yBAAA;A3E6kPV;;A2E9kPQ;EACE,sBAAA;A3EilPV;;A2ExkPQ;EAOI,qBAAA;A3EqkPZ;;A2E5kPQ;EAOI,qBAAA;A3EykPZ;;A2EhlPQ;EAOI,qBAAA;A3E6kPZ;;A2EplPQ;EAOI,sBAAA;A3EilPZ;;A2ExlPQ;EAOI,sBAAA;A3EqlPZ;;A2E5lPQ;EAOI,0BAAA;A3EylPZ;;A2EhmPQ;EAOI,uBAAA;A3E6lPZ;;A2EpmPQ;EAOI,2BAAA;A3EimPZ;;A2ExmPQ;EAOI,sBAAA;A3EqmPZ;;A2E5mPQ;EAOI,sBAAA;A3EymPZ;;A2EhnPQ;EAOI,sBAAA;A3E6mPZ;;A2EpnPQ;EAOI,uBAAA;A3EinPZ;;A2ExnPQ;EAOI,uBAAA;A3EqnPZ;;A2E5nPQ;EAOI,2BAAA;A3EynPZ;;A2EhoPQ;EAOI,wBAAA;A3E6nPZ;;A2EpoPQ;EAOI,4BAAA;A3EioPZ;;A2ExoPQ;EAOI,yBAAA;A3EqoPZ;;A2E5oPQ;EAOI,8BAAA;A3EyoPZ;;A2EhpPQ;EAOI,iCAAA;A3E6oPZ;;A2EppPQ;EAOI,sCAAA;A3EipPZ;;A2ExpPQ;EAOI,yCAAA;A3EqpPZ;;A2E5pPQ;EAOI,uBAAA;A3EypPZ;;A2EhqPQ;EAOI,uBAAA;A3E6pPZ;;A2EpqPQ;EAOI,yBAAA;A3EiqPZ;;A2ExqPQ;EAOI,yBAAA;A3EqqPZ;;A2E5qPQ;EAOI,0BAAA;A3EyqPZ;;A2EhrPQ;EAOI,4BAAA;A3E6qPZ;;A2EprPQ;EAOI,kCAAA;A3EirPZ;;A2ExrPQ;EAOI,sCAAA;A3EqrPZ;;A2E5rPQ;EAOI,oCAAA;A3EyrPZ;;A2EhsPQ;EAOI,kCAAA;A3E6rPZ;;A2EpsPQ;EAOI,yCAAA;A3EisPZ;;A2ExsPQ;EAOI,wCAAA;A3EqsPZ;;A2E5sPQ;EAOI,wCAAA;A3EysPZ;;A2EhtPQ;EAOI,kCAAA;A3E6sPZ;;A2EptPQ;EAOI,gCAAA;A3EitPZ;;A2ExtPQ;EAOI,8BAAA;A3EqtPZ;;A2E5tPQ;EAOI,gCAAA;A3EytPZ;;A2EhuPQ;EAOI,+BAAA;A3E6tPZ;;A2EpuPQ;EAOI,oCAAA;A3EiuPZ;;A2ExuPQ;EAOI,kCAAA;A3EquPZ;;A2E5uPQ;EAOI,gCAAA;A3EyuPZ;;A2EhvPQ;EAOI,uCAAA;A3E6uPZ;;A2EpvPQ;EAOI,sCAAA;A3EivPZ;;A2ExvPQ;EAOI,iCAAA;A3EqvPZ;;A2E5vPQ;EAOI,2BAAA;A3EyvPZ;;A2EhwPQ;EAOI,iCAAA;A3E6vPZ;;A2EpwPQ;EAOI,+BAAA;A3EiwPZ;;A2ExwPQ;EAOI,6BAAA;A3EqwPZ;;A2E5wPQ;EAOI,+BAAA;A3EywPZ;;A2EhxPQ;EAOI,8BAAA;A3E6wPZ;;A2EpxPQ;EAOI,oBAAA;A3EixPZ;;A2ExxPQ;EAOI,mBAAA;A3EqxPZ;;A2E5xPQ;EAOI,mBAAA;A3EyxPZ;;A2EhyPQ;EAOI,mBAAA;A3E6xPZ;;A2EpyPQ;EAOI,mBAAA;A3EiyPZ;;A2ExyPQ;EAOI,mBAAA;A3EqyPZ;;A2E5yPQ;EAOI,mBAAA;A3EyyPZ;;A2EhzPQ;EAOI,mBAAA;A3E6yPZ;;A2EpzPQ;EAOI,oBAAA;A3EizPZ;;A2ExzPQ;EAOI,0BAAA;A3EqzPZ;;A2E5zPQ;EAOI,yBAAA;A3EyzPZ;;A2Eh0PQ;EAOI,0BAAA;A3E6zPZ;;A2Ep0PQ;EAOI,uBAAA;A3Ei0PZ;;A2Ex0PQ;EAOI,yBAAA;A3Eq0PZ;;A2E50PQ;EAOI,uBAAA;A3Ey0PZ;;A2Eh1PQ;EAOI,yBAAA;A3E60PZ;;A2Ep1PQ;EAOI,uBAAA;A3Ei1PZ;;A2Ex1PQ;EAOI,uBAAA;A3Eq1PZ;;A2E51PQ;EAOI,0BAAA;EAAA,yBAAA;A3E01PZ;;A2Ej2PQ;EAOI,gCAAA;EAAA,+BAAA;A3E+1PZ;;A2Et2PQ;EAOI,+BAAA;EAAA,8BAAA;A3Eo2PZ;;A2E32PQ;EAOI,gCAAA;EAAA,+BAAA;A3Ey2PZ;;A2Eh3PQ;EAOI,6BAAA;EAAA,4BAAA;A3E82PZ;;A2Er3PQ;EAOI,+BAAA;EAAA,8BAAA;A3Em3PZ;;A2E13PQ;EAOI,6BAAA;EAAA,4BAAA;A3Ew3PZ;;A2E/3PQ;EAOI,+BAAA;EAAA,8BAAA;A3E63PZ;;A2Ep4PQ;EAOI,6BAAA;EAAA,4BAAA;A3Ek4PZ;;A2Ez4PQ;EAOI,6BAAA;EAAA,4BAAA;A3Eu4PZ;;A2E94PQ;EAOI,wBAAA;EAAA,2BAAA;A3E44PZ;;A2En5PQ;EAOI,8BAAA;EAAA,iCAAA;A3Ei5PZ;;A2Ex5PQ;EAOI,6BAAA;EAAA,gCAAA;A3Es5PZ;;A2E75PQ;EAOI,8BAAA;EAAA,iCAAA;A3E25PZ;;A2El6PQ;EAOI,2BAAA;EAAA,8BAAA;A3Eg6PZ;;A2Ev6PQ;EAOI,6BAAA;EAAA,gCAAA;A3Eq6PZ;;A2E56PQ;EAOI,2BAAA;EAAA,8BAAA;A3E06PZ;;A2Ej7PQ;EAOI,6BAAA;EAAA,gCAAA;A3E+6PZ;;A2Et7PQ;EAOI,2BAAA;EAAA,8BAAA;A3Eo7PZ;;A2E37PQ;EAOI,2BAAA;EAAA,8BAAA;A3Ey7PZ;;A2Eh8PQ;EAOI,wBAAA;A3E67PZ;;A2Ep8PQ;EAOI,8BAAA;A3Ei8PZ;;A2Ex8PQ;EAOI,6BAAA;A3Eq8PZ;;A2E58PQ;EAOI,8BAAA;A3Ey8PZ;;A2Eh9PQ;EAOI,2BAAA;A3E68PZ;;A2Ep9PQ;EAOI,6BAAA;A3Ei9PZ;;A2Ex9PQ;EAOI,2BAAA;A3Eq9PZ;;A2E59PQ;EAOI,6BAAA;A3Ey9PZ;;A2Eh+PQ;EAOI,2BAAA;A3E69PZ;;A2Ep+PQ;EAOI,2BAAA;A3Ei+PZ;;A2Ex+PQ;EAOI,0BAAA;A3Eq+PZ;;A2E5+PQ;EAOI,gCAAA;A3Ey+PZ;;A2Eh/PQ;EAOI,+BAAA;A3E6+PZ;;A2Ep/PQ;EAOI,gCAAA;A3Ei/PZ;;A2Ex/PQ;EAOI,6BAAA;A3Eq/PZ;;A2E5/PQ;EAOI,+BAAA;A3Ey/PZ;;A2EhgQQ;EAOI,6BAAA;A3E6/PZ;;A2EpgQQ;EAOI,+BAAA;A3EigQZ;;A2ExgQQ;EAOI,6BAAA;A3EqgQZ;;A2E5gQQ;EAOI,6BAAA;A3EygQZ;;A2EhhQQ;EAOI,2BAAA;A3E6gQZ;;A2EphQQ;EAOI,iCAAA;A3EihQZ;;A2ExhQQ;EAOI,gCAAA;A3EqhQZ;;A2E5hQQ;EAOI,iCAAA;A3EyhQZ;;A2EhiQQ;EAOI,8BAAA;A3E6hQZ;;A2EpiQQ;EAOI,gCAAA;A3EiiQZ;;A2ExiQQ;EAOI,8BAAA;A3EqiQZ;;A2E5iQQ;EAOI,gCAAA;A3EyiQZ;;A2EhjQQ;EAOI,8BAAA;A3E6iQZ;;A2EpjQQ;EAOI,8BAAA;A3EijQZ;;A2ExjQQ;EAOI,yBAAA;A3EqjQZ;;A2E5jQQ;EAOI,+BAAA;A3EyjQZ;;A2EhkQQ;EAOI,8BAAA;A3E6jQZ;;A2EpkQQ;EAOI,+BAAA;A3EikQZ;;A2ExkQQ;EAOI,4BAAA;A3EqkQZ;;A2E5kQQ;EAOI,8BAAA;A3EykQZ;;A2EhlQQ;EAOI,4BAAA;A3E6kQZ;;A2EplQQ;EAOI,8BAAA;A3EilQZ;;A2ExlQQ;EAOI,4BAAA;A3EqlQZ;;A2E5lQQ;EAOI,4BAAA;A3EylQZ;;A2EhmQQ;EAOI,qBAAA;A3E6lQZ;;A2EpmQQ;EAOI,2BAAA;A3EimQZ;;A2ExmQQ;EAOI,0BAAA;A3EqmQZ;;A2E5mQQ;EAOI,2BAAA;A3EymQZ;;A2EhnQQ;EAOI,wBAAA;A3E6mQZ;;A2EpnQQ;EAOI,0BAAA;A3EinQZ;;A2ExnQQ;EAOI,wBAAA;A3EqnQZ;;A2E5nQQ;EAOI,0BAAA;A3EynQZ;;A2EhoQQ;EAOI,wBAAA;A3E6nQZ;;A2EpoQQ;EAOI,2BAAA;EAAA,0BAAA;A3EkoQZ;;A2EzoQQ;EAOI,iCAAA;EAAA,gCAAA;A3EuoQZ;;A2E9oQQ;EAOI,gCAAA;EAAA,+BAAA;A3E4oQZ;;A2EnpQQ;EAOI,iCAAA;EAAA,gCAAA;A3EipQZ;;A2ExpQQ;EAOI,8BAAA;EAAA,6BAAA;A3EspQZ;;A2E7pQQ;EAOI,gCAAA;EAAA,+BAAA;A3E2pQZ;;A2ElqQQ;EAOI,8BAAA;EAAA,6BAAA;A3EgqQZ;;A2EvqQQ;EAOI,gCAAA;EAAA,+BAAA;A3EqqQZ;;A2E5qQQ;EAOI,8BAAA;EAAA,6BAAA;A3E0qQZ;;A2EjrQQ;EAOI,yBAAA;EAAA,4BAAA;A3E+qQZ;;A2EtrQQ;EAOI,+BAAA;EAAA,kCAAA;A3EorQZ;;A2E3rQQ;EAOI,8BAAA;EAAA,iCAAA;A3EyrQZ;;A2EhsQQ;EAOI,+BAAA;EAAA,kCAAA;A3E8rQZ;;A2ErsQQ;EAOI,4BAAA;EAAA,+BAAA;A3EmsQZ;;A2E1sQQ;EAOI,8BAAA;EAAA,iCAAA;A3EwsQZ;;A2E/sQQ;EAOI,4BAAA;EAAA,+BAAA;A3E6sQZ;;A2EptQQ;EAOI,8BAAA;EAAA,iCAAA;A3EktQZ;;A2EztQQ;EAOI,4BAAA;EAAA,+BAAA;A3EutQZ;;A2E9tQQ;EAOI,yBAAA;A3E2tQZ;;A2EluQQ;EAOI,+BAAA;A3E+tQZ;;A2EtuQQ;EAOI,8BAAA;A3EmuQZ;;A2E1uQQ;EAOI,+BAAA;A3EuuQZ;;A2E9uQQ;EAOI,4BAAA;A3E2uQZ;;A2ElvQQ;EAOI,8BAAA;A3E+uQZ;;A2EtvQQ;EAOI,4BAAA;A3EmvQZ;;A2E1vQQ;EAOI,8BAAA;A3EuvQZ;;A2E9vQQ;EAOI,4BAAA;A3E2vQZ;;A2ElwQQ;EAOI,2BAAA;A3E+vQZ;;A2EtwQQ;EAOI,iCAAA;A3EmwQZ;;A2E1wQQ;EAOI,gCAAA;A3EuwQZ;;A2E9wQQ;EAOI,iCAAA;A3E2wQZ;;A2ElxQQ;EAOI,8BAAA;A3E+wQZ;;A2EtxQQ;EAOI,gCAAA;A3EmxQZ;;A2E1xQQ;EAOI,8BAAA;A3EuxQZ;;A2E9xQQ;EAOI,gCAAA;A3E2xQZ;;A2ElyQQ;EAOI,8BAAA;A3E+xQZ;;A2EtyQQ;EAOI,4BAAA;A3EmyQZ;;A2E1yQQ;EAOI,kCAAA;A3EuyQZ;;A2E9yQQ;EAOI,iCAAA;A3E2yQZ;;A2ElzQQ;EAOI,kCAAA;A3E+yQZ;;A2EtzQQ;EAOI,+BAAA;A3EmzQZ;;A2E1zQQ;EAOI,iCAAA;A3EuzQZ;;A2E9zQQ;EAOI,+BAAA;A3E2zQZ;;A2El0QQ;EAOI,iCAAA;A3E+zQZ;;A2Et0QQ;EAOI,+BAAA;A3Em0QZ;;A2E10QQ;EAOI,0BAAA;A3Eu0QZ;;A2E90QQ;EAOI,gCAAA;A3E20QZ;;A2El1QQ;EAOI,+BAAA;A3E+0QZ;;A2Et1QQ;EAOI,gCAAA;A3Em1QZ;;A2E11QQ;EAOI,6BAAA;A3Eu1QZ;;A2E91QQ;EAOI,+BAAA;A3E21QZ;;A2El2QQ;EAOI,6BAAA;A3E+1QZ;;A2Et2QQ;EAOI,+BAAA;A3Em2QZ;;A2E12QQ;EAOI,6BAAA;A3Eu2QZ;;A2E92QQ;EAOI,iBAAA;A3E22QZ;;A2El3QQ;EAOI,uBAAA;A3E+2QZ;;A2Et3QQ;EAOI,sBAAA;A3Em3QZ;;A2E13QQ;EAOI,uBAAA;A3Eu3QZ;;A2E93QQ;EAOI,oBAAA;A3E23QZ;;A2El4QQ;EAOI,sBAAA;A3E+3QZ;;A2Et4QQ;EAOI,oBAAA;A3Em4QZ;;A2E14QQ;EAOI,sBAAA;A3Eu4QZ;;A2E94QQ;EAOI,oBAAA;A3E24QZ;;A2El5QQ;EAOI,qBAAA;A3E+4QZ;;A2Et5QQ;EAOI,2BAAA;A3Em5QZ;;A2E15QQ;EAOI,0BAAA;A3Eu5QZ;;A2E95QQ;EAOI,2BAAA;A3E25QZ;;A2El6QQ;EAOI,wBAAA;A3E+5QZ;;A2Et6QQ;EAOI,0BAAA;A3Em6QZ;;A2E16QQ;EAOI,wBAAA;A3Eu6QZ;;A2E96QQ;EAOI,0BAAA;A3E26QZ;;A2El7QQ;EAOI,wBAAA;A3E+6QZ;;A2Et7QQ;EAOI,wBAAA;A3Em7QZ;;A2E17QQ;EAOI,8BAAA;A3Eu7QZ;;A2E97QQ;EAOI,6BAAA;A3E27QZ;;A2El8QQ;EAOI,8BAAA;A3E+7QZ;;A2Et8QQ;EAOI,2BAAA;A3Em8QZ;;A2E18QQ;EAOI,6BAAA;A3Eu8QZ;;A2E98QQ;EAOI,2BAAA;A3E28QZ;;A2El9QQ;EAOI,6BAAA;A3E+8QZ;;A2Et9QQ;EAOI,2BAAA;A3Em9QZ;;A2E19QQ;EAOI,gDAAA;A3Eu9QZ;;A2E99QQ;EAOI,4CAAA;A3E29QZ;;A2El+QQ;EAOI,8CAAA;A3E+9QZ;;A2Et+QQ;EAOI,8CAAA;A3Em+QZ;;A2E1+QQ;EAOI,8CAAA;A3Eu+QZ;;A2E9+QQ;EAOI,6BAAA;A3E2+QZ;;A2El/QQ;EAOI,0BAAA;A3E++QZ;;A2Et/QQ;EAOI,6BAAA;A3Em/QZ;;A2E1/QQ;EAOI,6BAAA;A3Eu/QZ;;A2E9/QQ;EAOI,+BAAA;A3E2/QZ;;A2ElgRQ;EAOI,2BAAA;A3E+/QZ;;A2EtgRQ;EAOI,2BAAA;A3EmgRZ;;A2E1gRQ;EAOI,2BAAA;A3EugRZ;;A2E9gRQ;EAOI,2BAAA;A3E2gRZ;;A2ElhRQ;EAOI,2BAAA;A3E+gRZ;;A2EthRQ;EAOI,8BAAA;A3EmhRZ;;A2E1hRQ;EAOI,yBAAA;A3EuhRZ;;A2E9hRQ;EAOI,yBAAA;A3E2hRZ;;A2EliRQ;EAOI,4BAAA;A3E+hRZ;;A2EtiRQ;EAOI,4BAAA;A3EmiRZ;;A2E1iRQ;EAOI,2BAAA;A3EuiRZ;;A2E9iRQ;EAOI,4BAAA;A3E2iRZ;;A2EljRQ;EAOI,6BAAA;A3E+iRZ;;A2EtjRQ;EAOI,gCAAA;A3EmjRZ;;A2E1jRQ;EAOI,qCAAA;A3EujRZ;;A2E9jRQ;EAOI,wCAAA;A3E2jRZ;;A2ElkRQ;EAOI,oCAAA;A3E+jRZ;;A2EtkRQ;EAOI,oCAAA;A3EmkRZ;;A2E1kRQ;EAOI,qCAAA;A3EukRZ;;A2E9kRQ;EAOI,8BAAA;A3E2kRZ;;A2EllRQ;EAOI,8BAAA;A3E+kRZ;;A2EpmRQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;A3EqlRZ;;A2ElkRQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,qEAAA;A3E2lRZ;;A2ElmRQ;EAIQ,oBAAA;EAGJ,uEAAA;A3EgmRZ;;A2EvmRQ;EAIQ,oBAAA;EAGJ,qEAAA;A3EqmRZ;;A2E5mRQ;EAIQ,oBAAA;EAGJ,kEAAA;A3E0mRZ;;A2EjnRQ;EAIQ,oBAAA;EAGJ,qEAAA;A3E+mRZ;;A2EtnRQ;EAIQ,oBAAA;EAGJ,oEAAA;A3EonRZ;;A2E3nRQ;EAIQ,oBAAA;EAGJ,mEAAA;A3EynRZ;;A2EhoRQ;EAIQ,oBAAA;EAGJ,kEAAA;A3E8nRZ;;A2EroRQ;EAIQ,oBAAA;EAGJ,mEAAA;A3EmoRZ;;A2E1oRQ;EAIQ,oBAAA;EAGJ,mEAAA;A3EwoRZ;;A2E/oRQ;EAIQ,oBAAA;EAGJ,wEAAA;A3E6oRZ;;A2EppRQ;EAIQ,oBAAA;EAGJ,2CAAA;A3EkpRZ;;A2EzpRQ;EAIQ,oBAAA;EAGJ,uCAAA;A3EupRZ;;A2E9pRQ;EAIQ,oBAAA;EAGJ,0CAAA;A3E4pRZ;;A2EnqRQ;EAIQ,oBAAA;EAGJ,2CAAA;A3EiqRZ;;A2ExqRQ;EAIQ,oBAAA;EAGJ,0CAAA;A3EsqRZ;;A2E7qRQ;EAIQ,oBAAA;EAGJ,0CAAA;A3E2qRZ;;A2ElrRQ;EAIQ,oBAAA;EAGJ,yBAAA;A3EgrRZ;;A2EjsRQ;EACE,uBAAA;A3EosRV;;A2ErsRQ;EACE,sBAAA;A3EwsRV;;A2EzsRQ;EACE,uBAAA;A3E4sRV;;A2E7sRQ;EACE,oBAAA;A3EgtRV;;A2EvsRQ;EAOI,iDAAA;A3EosRZ;;A2E3sRQ;EAOI,mDAAA;A3EwsRZ;;A2E/sRQ;EAOI,iDAAA;A3E4sRZ;;A2EntRQ;EAOI,8CAAA;A3EgtRZ;;A2EvtRQ;EAOI,iDAAA;A3EotRZ;;A2E3tRQ;EAOI,gDAAA;A3EwtRZ;;A2E/tRQ;EAOI,+CAAA;A3E4tRZ;;A2EnuRQ;EAOI,8CAAA;A3EguRZ;;A2EjvRQ;EACE,sBAAA;A3EovRV;;A2EhvRU;EACE,sBAAA;A3EmvRZ;;A2EzvRQ;EACE,uBAAA;A3E4vRV;;A2ExvRU;EACE,uBAAA;A3E2vRZ;;A2EjwRQ;EACE,sBAAA;A3EowRV;;A2EhwRU;EACE,sBAAA;A3EmwRZ;;A2EzwRQ;EACE,uBAAA;A3E4wRV;;A2ExwRU;EACE,uBAAA;A3E2wRZ;;A2EjxRQ;EACE,oBAAA;A3EoxRV;;A2EhxRU;EACE,oBAAA;A3EmxRZ;;A2E/wRQ;EAOI,yCAAA;A3E4wRZ;;A2EvwRU;EAOI,yCAAA;A3EowRd;;A2EvxRQ;EAOI,wCAAA;A3EoxRZ;;A2E/wRU;EAOI,wCAAA;A3E4wRd;;A2E/xRQ;EAOI,yCAAA;A3E4xRZ;;A2EvxRU;EAOI,yCAAA;A3EoxRd;;A2EvyRQ;EAIQ,8BAAA;EAGJ,+FAAA;A3EqyRZ;;A2E5yRQ;EAIQ,8BAAA;EAGJ,iGAAA;A3E0yRZ;;A2EjzRQ;EAIQ,8BAAA;EAGJ,+FAAA;A3E+yRZ;;A2EtzRQ;EAIQ,8BAAA;EAGJ,4FAAA;A3EozRZ;;A2E3zRQ;EAIQ,8BAAA;EAGJ,+FAAA;A3EyzRZ;;A2Eh0RQ;EAIQ,8BAAA;EAGJ,8FAAA;A3E8zRZ;;A2Er0RQ;EAIQ,8BAAA;EAGJ,6FAAA;A3Em0RZ;;A2E10RQ;EAIQ,8BAAA;EAGJ,4FAAA;A3Ew0RZ;;A2E/0RQ;EAIQ,8BAAA;EAGJ,qGAAA;A3E60RZ;;A2E91RQ;EACE,8BAAA;A3Ei2RV;;A2E71RU;EACE,8BAAA;A3Eg2RZ;;A2Et2RQ;EACE,gCAAA;A3Ey2RV;;A2Er2RU;EACE,gCAAA;A3Ew2RZ;;A2E92RQ;EACE,iCAAA;A3Ei3RV;;A2E72RU;EACE,iCAAA;A3Eg3RZ;;A2Et3RQ;EACE,gCAAA;A3Ey3RV;;A2Er3RU;EACE,gCAAA;A3Ew3RZ;;A2E93RQ;EACE,iCAAA;A3Ei4RV;;A2E73RU;EACE,iCAAA;A3Eg4RZ;;A2Et4RQ;EACE,8BAAA;A3Ey4RV;;A2Er4RU;EACE,8BAAA;A3Ew4RZ;;A2Ep4RQ;EAIQ,kBAAA;EAGJ,8EAAA;A3Ek4RZ;;A2Ez4RQ;EAIQ,kBAAA;EAGJ,gFAAA;A3Eu4RZ;;A2E94RQ;EAIQ,kBAAA;EAGJ,8EAAA;A3E44RZ;;A2En5RQ;EAIQ,kBAAA;EAGJ,2EAAA;A3Ei5RZ;;A2Ex5RQ;EAIQ,kBAAA;EAGJ,8EAAA;A3Es5RZ;;A2E75RQ;EAIQ,kBAAA;EAGJ,6EAAA;A3E25RZ;;A2El6RQ;EAIQ,kBAAA;EAGJ,4EAAA;A3Eg6RZ;;A2Ev6RQ;EAIQ,kBAAA;EAGJ,2EAAA;A3Eq6RZ;;A2E56RQ;EAIQ,kBAAA;EAGJ,4EAAA;A3E06RZ;;A2Ej7RQ;EAIQ,kBAAA;EAGJ,4EAAA;A3E+6RZ;;A2Et7RQ;EAIQ,kBAAA;EAGJ,8EAAA;A3Eo7RZ;;A2E37RQ;EAIQ,kBAAA;EAGJ,wCAAA;A3Ey7RZ;;A2Eh8RQ;EAIQ,kBAAA;EAGJ,mFAAA;A3E87RZ;;A2Er8RQ;EAIQ,kBAAA;EAGJ,kFAAA;A3Em8RZ;;A2Ep9RQ;EACE,oBAAA;A3Eu9RV;;A2Ex9RQ;EACE,qBAAA;A3E29RV;;A2E59RQ;EACE,oBAAA;A3E+9RV;;A2Eh+RQ;EACE,qBAAA;A3Em+RV;;A2Ep+RQ;EACE,kBAAA;A3Eu+RV;;A2E99RQ;EAOI,wDAAA;A3E29RZ;;A2El+RQ;EAOI,0DAAA;A3E+9RZ;;A2Et+RQ;EAOI,wDAAA;A3Em+RZ;;A2E1+RQ;EAOI,qDAAA;A3Eu+RZ;;A2E9+RQ;EAOI,wDAAA;A3E2+RZ;;A2El/RQ;EAOI,uDAAA;A3E++RZ;;A2Et/RQ;EAOI,sDAAA;A3Em/RZ;;A2E1/RQ;EAOI,qDAAA;A3Eu/RZ;;A2E9/RQ;EAOI,+CAAA;A3E2/RZ;;A2ElgSQ;EAOI,mCAAA;UAAA,2BAAA;A3E+/RZ;;A2EtgSQ;EAOI,oCAAA;UAAA,4BAAA;A3EmgSZ;;A2E1gSQ;EAOI,oCAAA;UAAA,4BAAA;A3EugSZ;;A2E9gSQ;EAOI,+BAAA;A3E2gSZ;;A2ElhSQ;EAOI,+BAAA;A3E+gSZ;;A2EthSQ;EAOI,iDAAA;A3EmhSZ;;A2E1hSQ;EAOI,2BAAA;A3EuhSZ;;A2E9hSQ;EAOI,oDAAA;A3E2hSZ;;A2EliSQ;EAOI,iDAAA;A3E+hSZ;;A2EtiSQ;EAOI,oDAAA;A3EmiSZ;;A2E1iSQ;EAOI,oDAAA;A3EuiSZ;;A2E9iSQ;EAOI,qDAAA;A3E2iSZ;;A2EljSQ;EAOI,6BAAA;A3E+iSZ;;A2EtjSQ;EAOI,sDAAA;A3EmjSZ;;A2E1jSQ;EAOI,0DAAA;EAAA,2DAAA;A3EwjSZ;;A2E/jSQ;EAOI,oCAAA;EAAA,qCAAA;A3E6jSZ;;A2EpkSQ;EAOI,6DAAA;EAAA,8DAAA;A3EkkSZ;;A2EzkSQ;EAOI,0DAAA;EAAA,2DAAA;A3EukSZ;;A2E9kSQ;EAOI,6DAAA;EAAA,8DAAA;A3E4kSZ;;A2EnlSQ;EAOI,6DAAA;EAAA,8DAAA;A3EilSZ;;A2ExlSQ;EAOI,8DAAA;EAAA,+DAAA;A3EslSZ;;A2E7lSQ;EAOI,sCAAA;EAAA,uCAAA;A3E2lSZ;;A2ElmSQ;EAOI,+DAAA;EAAA,gEAAA;A3EgmSZ;;A2EvmSQ;EAOI,2DAAA;EAAA,8DAAA;A3EqmSZ;;A2E5mSQ;EAOI,qCAAA;EAAA,wCAAA;A3E0mSZ;;A2EjnSQ;EAOI,8DAAA;EAAA,iEAAA;A3E+mSZ;;A2EtnSQ;EAOI,2DAAA;EAAA,8DAAA;A3EonSZ;;A2E3nSQ;EAOI,8DAAA;EAAA,iEAAA;A3EynSZ;;A2EhoSQ;EAOI,8DAAA;EAAA,iEAAA;A3E8nSZ;;A2EroSQ;EAOI,+DAAA;EAAA,kEAAA;A3EmoSZ;;A2E1oSQ;EAOI,uCAAA;EAAA,0CAAA;A3EwoSZ;;A2E/oSQ;EAOI,gEAAA;EAAA,mEAAA;A3E6oSZ;;A2EppSQ;EAOI,8DAAA;EAAA,6DAAA;A3EkpSZ;;A2EzpSQ;EAOI,wCAAA;EAAA,uCAAA;A3EupSZ;;A2E9pSQ;EAOI,iEAAA;EAAA,gEAAA;A3E4pSZ;;A2EnqSQ;EAOI,8DAAA;EAAA,6DAAA;A3EiqSZ;;A2ExqSQ;EAOI,iEAAA;EAAA,gEAAA;A3EsqSZ;;A2E7qSQ;EAOI,iEAAA;EAAA,gEAAA;A3E2qSZ;;A2ElrSQ;EAOI,kEAAA;EAAA,iEAAA;A3EgrSZ;;A2EvrSQ;EAOI,0CAAA;EAAA,yCAAA;A3EqrSZ;;A2E5rSQ;EAOI,mEAAA;EAAA,kEAAA;A3E0rSZ;;A2EjsSQ;EAOI,6DAAA;EAAA,0DAAA;A3E+rSZ;;A2EtsSQ;EAOI,uCAAA;EAAA,oCAAA;A3EosSZ;;A2E3sSQ;EAOI,gEAAA;EAAA,6DAAA;A3EysSZ;;A2EhtSQ;EAOI,6DAAA;EAAA,0DAAA;A3E8sSZ;;A2ErtSQ;EAOI,gEAAA;EAAA,6DAAA;A3EmtSZ;;A2E1tSQ;EAOI,gEAAA;EAAA,6DAAA;A3EwtSZ;;A2E/tSQ;EAOI,iEAAA;EAAA,8DAAA;A3E6tSZ;;A2EpuSQ;EAOI,yCAAA;EAAA,sCAAA;A3EkuSZ;;A2EzuSQ;EAOI,kEAAA;EAAA,+DAAA;A3EuuSZ;;A2E9uSQ;EAOI,8BAAA;A3E2uSZ;;A2ElvSQ;EAOI,6BAAA;A3E+uSZ;;A2EtvSQ;EAOI,sBAAA;A3EmvSZ;;A2E1vSQ;EAOI,qBAAA;A3EuvSZ;;A2E9vSQ;EAOI,qBAAA;A3E2vSZ;;A2ElwSQ;EAOI,qBAAA;A3E+vSZ;;A2EtwSQ;EAOI,qBAAA;A3EmwSZ;;AiB7wSI;E0DGI;IAOI,sBAAA;E3EwwSV;E2E/wSM;IAOI,uBAAA;E3E2wSV;E2ElxSM;IAOI,sBAAA;E3E8wSV;E2ErxSM;IAOI,8BAAA;E3EixSV;E2ExxSM;IAOI,4BAAA;E3EoxSV;E2E3xSM;IAOI,2BAAA;E3EuxSV;E2E9xSM;IAOI,iCAAA;E3E0xSV;E2EjySM;IAOI,2BAAA;E3E6xSV;E2EpySM;IAOI,0BAAA;E3EgySV;E2EvySM;IAOI,gCAAA;E3EmySV;E2E1ySM;IAOI,yBAAA;E3EsySV;E2E7ySM;IAOI,wBAAA;E3EyySV;E2EhzSM;IAOI,+BAAA;E3E4ySV;E2EnzSM;IAOI,yBAAA;E3E+ySV;E2EtzSM;IAOI,6BAAA;E3EkzSV;E2EzzSM;IAOI,8BAAA;E3EqzSV;E2E5zSM;IAOI,wBAAA;E3EwzSV;E2E/zSM;IAOI,+BAAA;E3E2zSV;E2El0SM;IAOI,wBAAA;E3E8zSV;E2Er0SM;IAOI,yBAAA;E3Ei0SV;E2Ex0SM;IAOI,8BAAA;E3Eo0SV;E2E30SM;IAOI,iCAAA;E3Eu0SV;E2E90SM;IAOI,sCAAA;E3E00SV;E2Ej1SM;IAOI,yCAAA;E3E60SV;E2Ep1SM;IAOI,uBAAA;E3Eg1SV;E2Ev1SM;IAOI,uBAAA;E3Em1SV;E2E11SM;IAOI,yBAAA;E3Es1SV;E2E71SM;IAOI,yBAAA;E3Ey1SV;E2Eh2SM;IAOI,0BAAA;E3E41SV;E2En2SM;IAOI,4BAAA;E3E+1SV;E2Et2SM;IAOI,kCAAA;E3Ek2SV;E2Ez2SM;IAOI,sCAAA;E3Eq2SV;E2E52SM;IAOI,oCAAA;E3Ew2SV;E2E/2SM;IAOI,kCAAA;E3E22SV;E2El3SM;IAOI,yCAAA;E3E82SV;E2Er3SM;IAOI,wCAAA;E3Ei3SV;E2Ex3SM;IAOI,wCAAA;E3Eo3SV;E2E33SM;IAOI,kCAAA;E3Eu3SV;E2E93SM;IAOI,gCAAA;E3E03SV;E2Ej4SM;IAOI,8BAAA;E3E63SV;E2Ep4SM;IAOI,gCAAA;E3Eg4SV;E2Ev4SM;IAOI,+BAAA;E3Em4SV;E2E14SM;IAOI,oCAAA;E3Es4SV;E2E74SM;IAOI,kCAAA;E3Ey4SV;E2Eh5SM;IAOI,gCAAA;E3E44SV;E2En5SM;IAOI,uCAAA;E3E+4SV;E2Et5SM;IAOI,sCAAA;E3Ek5SV;E2Ez5SM;IAOI,iCAAA;E3Eq5SV;E2E55SM;IAOI,2BAAA;E3Ew5SV;E2E/5SM;IAOI,iCAAA;E3E25SV;E2El6SM;IAOI,+BAAA;E3E85SV;E2Er6SM;IAOI,6BAAA;E3Ei6SV;E2Ex6SM;IAOI,+BAAA;E3Eo6SV;E2E36SM;IAOI,8BAAA;E3Eu6SV;E2E96SM;IAOI,oBAAA;E3E06SV;E2Ej7SM;IAOI,mBAAA;E3E66SV;E2Ep7SM;IAOI,mBAAA;E3Eg7SV;E2Ev7SM;IAOI,mBAAA;E3Em7SV;E2E17SM;IAOI,mBAAA;E3Es7SV;E2E77SM;IAOI,mBAAA;E3Ey7SV;E2Eh8SM;IAOI,mBAAA;E3E47SV;E2En8SM;IAOI,mBAAA;E3E+7SV;E2Et8SM;IAOI,oBAAA;E3Ek8SV;E2Ez8SM;IAOI,0BAAA;E3Eq8SV;E2E58SM;IAOI,yBAAA;E3Ew8SV;E2E/8SM;IAOI,0BAAA;E3E28SV;E2El9SM;IAOI,uBAAA;E3E88SV;E2Er9SM;IAOI,yBAAA;E3Ei9SV;E2Ex9SM;IAOI,uBAAA;E3Eo9SV;E2E39SM;IAOI,yBAAA;E3Eu9SV;E2E99SM;IAOI,uBAAA;E3E09SV;E2Ej+SM;IAOI,uBAAA;E3E69SV;E2Ep+SM;IAOI,0BAAA;IAAA,yBAAA;E3Ei+SV;E2Ex+SM;IAOI,gCAAA;IAAA,+BAAA;E3Eq+SV;E2E5+SM;IAOI,+BAAA;IAAA,8BAAA;E3Ey+SV;E2Eh/SM;IAOI,gCAAA;IAAA,+BAAA;E3E6+SV;E2Ep/SM;IAOI,6BAAA;IAAA,4BAAA;E3Ei/SV;E2Ex/SM;IAOI,+BAAA;IAAA,8BAAA;E3Eq/SV;E2E5/SM;IAOI,6BAAA;IAAA,4BAAA;E3Ey/SV;E2EhgTM;IAOI,+BAAA;IAAA,8BAAA;E3E6/SV;E2EpgTM;IAOI,6BAAA;IAAA,4BAAA;E3EigTV;E2ExgTM;IAOI,6BAAA;IAAA,4BAAA;E3EqgTV;E2E5gTM;IAOI,wBAAA;IAAA,2BAAA;E3EygTV;E2EhhTM;IAOI,8BAAA;IAAA,iCAAA;E3E6gTV;E2EphTM;IAOI,6BAAA;IAAA,gCAAA;E3EihTV;E2ExhTM;IAOI,8BAAA;IAAA,iCAAA;E3EqhTV;E2E5hTM;IAOI,2BAAA;IAAA,8BAAA;E3EyhTV;E2EhiTM;IAOI,6BAAA;IAAA,gCAAA;E3E6hTV;E2EpiTM;IAOI,2BAAA;IAAA,8BAAA;E3EiiTV;E2ExiTM;IAOI,6BAAA;IAAA,gCAAA;E3EqiTV;E2E5iTM;IAOI,2BAAA;IAAA,8BAAA;E3EyiTV;E2EhjTM;IAOI,2BAAA;IAAA,8BAAA;E3E6iTV;E2EpjTM;IAOI,wBAAA;E3EgjTV;E2EvjTM;IAOI,8BAAA;E3EmjTV;E2E1jTM;IAOI,6BAAA;E3EsjTV;E2E7jTM;IAOI,8BAAA;E3EyjTV;E2EhkTM;IAOI,2BAAA;E3E4jTV;E2EnkTM;IAOI,6BAAA;E3E+jTV;E2EtkTM;IAOI,2BAAA;E3EkkTV;E2EzkTM;IAOI,6BAAA;E3EqkTV;E2E5kTM;IAOI,2BAAA;E3EwkTV;E2E/kTM;IAOI,2BAAA;E3E2kTV;E2EllTM;IAOI,0BAAA;E3E8kTV;E2ErlTM;IAOI,gCAAA;E3EilTV;E2ExlTM;IAOI,+BAAA;E3EolTV;E2E3lTM;IAOI,gCAAA;E3EulTV;E2E9lTM;IAOI,6BAAA;E3E0lTV;E2EjmTM;IAOI,+BAAA;E3E6lTV;E2EpmTM;IAOI,6BAAA;E3EgmTV;E2EvmTM;IAOI,+BAAA;E3EmmTV;E2E1mTM;IAOI,6BAAA;E3EsmTV;E2E7mTM;IAOI,6BAAA;E3EymTV;E2EhnTM;IAOI,2BAAA;E3E4mTV;E2EnnTM;IAOI,iCAAA;E3E+mTV;E2EtnTM;IAOI,gCAAA;E3EknTV;E2EznTM;IAOI,iCAAA;E3EqnTV;E2E5nTM;IAOI,8BAAA;E3EwnTV;E2E/nTM;IAOI,gCAAA;E3E2nTV;E2EloTM;IAOI,8BAAA;E3E8nTV;E2EroTM;IAOI,gCAAA;E3EioTV;E2ExoTM;IAOI,8BAAA;E3EooTV;E2E3oTM;IAOI,8BAAA;E3EuoTV;E2E9oTM;IAOI,yBAAA;E3E0oTV;E2EjpTM;IAOI,+BAAA;E3E6oTV;E2EppTM;IAOI,8BAAA;E3EgpTV;E2EvpTM;IAOI,+BAAA;E3EmpTV;E2E1pTM;IAOI,4BAAA;E3EspTV;E2E7pTM;IAOI,8BAAA;E3EypTV;E2EhqTM;IAOI,4BAAA;E3E4pTV;E2EnqTM;IAOI,8BAAA;E3E+pTV;E2EtqTM;IAOI,4BAAA;E3EkqTV;E2EzqTM;IAOI,4BAAA;E3EqqTV;E2E5qTM;IAOI,qBAAA;E3EwqTV;E2E/qTM;IAOI,2BAAA;E3E2qTV;E2ElrTM;IAOI,0BAAA;E3E8qTV;E2ErrTM;IAOI,2BAAA;E3EirTV;E2ExrTM;IAOI,wBAAA;E3EorTV;E2E3rTM;IAOI,0BAAA;E3EurTV;E2E9rTM;IAOI,wBAAA;E3E0rTV;E2EjsTM;IAOI,0BAAA;E3E6rTV;E2EpsTM;IAOI,wBAAA;E3EgsTV;E2EvsTM;IAOI,2BAAA;IAAA,0BAAA;E3EosTV;E2E3sTM;IAOI,iCAAA;IAAA,gCAAA;E3EwsTV;E2E/sTM;IAOI,gCAAA;IAAA,+BAAA;E3E4sTV;E2EntTM;IAOI,iCAAA;IAAA,gCAAA;E3EgtTV;E2EvtTM;IAOI,8BAAA;IAAA,6BAAA;E3EotTV;E2E3tTM;IAOI,gCAAA;IAAA,+BAAA;E3EwtTV;E2E/tTM;IAOI,8BAAA;IAAA,6BAAA;E3E4tTV;E2EnuTM;IAOI,gCAAA;IAAA,+BAAA;E3EguTV;E2EvuTM;IAOI,8BAAA;IAAA,6BAAA;E3EouTV;E2E3uTM;IAOI,yBAAA;IAAA,4BAAA;E3EwuTV;E2E/uTM;IAOI,+BAAA;IAAA,kCAAA;E3E4uTV;E2EnvTM;IAOI,8BAAA;IAAA,iCAAA;E3EgvTV;E2EvvTM;IAOI,+BAAA;IAAA,kCAAA;E3EovTV;E2E3vTM;IAOI,4BAAA;IAAA,+BAAA;E3EwvTV;E2E/vTM;IAOI,8BAAA;IAAA,iCAAA;E3E4vTV;E2EnwTM;IAOI,4BAAA;IAAA,+BAAA;E3EgwTV;E2EvwTM;IAOI,8BAAA;IAAA,iCAAA;E3EowTV;E2E3wTM;IAOI,4BAAA;IAAA,+BAAA;E3EwwTV;E2E/wTM;IAOI,yBAAA;E3E2wTV;E2ElxTM;IAOI,+BAAA;E3E8wTV;E2ErxTM;IAOI,8BAAA;E3EixTV;E2ExxTM;IAOI,+BAAA;E3EoxTV;E2E3xTM;IAOI,4BAAA;E3EuxTV;E2E9xTM;IAOI,8BAAA;E3E0xTV;E2EjyTM;IAOI,4BAAA;E3E6xTV;E2EpyTM;IAOI,8BAAA;E3EgyTV;E2EvyTM;IAOI,4BAAA;E3EmyTV;E2E1yTM;IAOI,2BAAA;E3EsyTV;E2E7yTM;IAOI,iCAAA;E3EyyTV;E2EhzTM;IAOI,gCAAA;E3E4yTV;E2EnzTM;IAOI,iCAAA;E3E+yTV;E2EtzTM;IAOI,8BAAA;E3EkzTV;E2EzzTM;IAOI,gCAAA;E3EqzTV;E2E5zTM;IAOI,8BAAA;E3EwzTV;E2E/zTM;IAOI,gCAAA;E3E2zTV;E2El0TM;IAOI,8BAAA;E3E8zTV;E2Er0TM;IAOI,4BAAA;E3Ei0TV;E2Ex0TM;IAOI,kCAAA;E3Eo0TV;E2E30TM;IAOI,iCAAA;E3Eu0TV;E2E90TM;IAOI,kCAAA;E3E00TV;E2Ej1TM;IAOI,+BAAA;E3E60TV;E2Ep1TM;IAOI,iCAAA;E3Eg1TV;E2Ev1TM;IAOI,+BAAA;E3Em1TV;E2E11TM;IAOI,iCAAA;E3Es1TV;E2E71TM;IAOI,+BAAA;E3Ey1TV;E2Eh2TM;IAOI,0BAAA;E3E41TV;E2En2TM;IAOI,gCAAA;E3E+1TV;E2Et2TM;IAOI,+BAAA;E3Ek2TV;E2Ez2TM;IAOI,gCAAA;E3Eq2TV;E2E52TM;IAOI,6BAAA;E3Ew2TV;E2E/2TM;IAOI,+BAAA;E3E22TV;E2El3TM;IAOI,6BAAA;E3E82TV;E2Er3TM;IAOI,+BAAA;E3Ei3TV;E2Ex3TM;IAOI,6BAAA;E3Eo3TV;E2E33TM;IAOI,iBAAA;E3Eu3TV;E2E93TM;IAOI,uBAAA;E3E03TV;E2Ej4TM;IAOI,sBAAA;E3E63TV;E2Ep4TM;IAOI,uBAAA;E3Eg4TV;E2Ev4TM;IAOI,oBAAA;E3Em4TV;E2E14TM;IAOI,sBAAA;E3Es4TV;E2E74TM;IAOI,oBAAA;E3Ey4TV;E2Eh5TM;IAOI,sBAAA;E3E44TV;E2En5TM;IAOI,oBAAA;E3E+4TV;E2Et5TM;IAOI,qBAAA;E3Ek5TV;E2Ez5TM;IAOI,2BAAA;E3Eq5TV;E2E55TM;IAOI,0BAAA;E3Ew5TV;E2E/5TM;IAOI,2BAAA;E3E25TV;E2El6TM;IAOI,wBAAA;E3E85TV;E2Er6TM;IAOI,0BAAA;E3Ei6TV;E2Ex6TM;IAOI,wBAAA;E3Eo6TV;E2E36TM;IAOI,0BAAA;E3Eu6TV;E2E96TM;IAOI,wBAAA;E3E06TV;E2Ej7TM;IAOI,wBAAA;E3E66TV;E2Ep7TM;IAOI,8BAAA;E3Eg7TV;E2Ev7TM;IAOI,6BAAA;E3Em7TV;E2E17TM;IAOI,8BAAA;E3Es7TV;E2E77TM;IAOI,2BAAA;E3Ey7TV;E2Eh8TM;IAOI,6BAAA;E3E47TV;E2En8TM;IAOI,2BAAA;E3E+7TV;E2Et8TM;IAOI,6BAAA;E3Ek8TV;E2Ez8TM;IAOI,2BAAA;E3Eq8TV;E2E58TM;IAOI,2BAAA;E3Ew8TV;E2E/8TM;IAOI,4BAAA;E3E28TV;E2El9TM;IAOI,6BAAA;E3E88TV;AACF;AiBz9TI;E0DGI;IAOI,sBAAA;E3Em9TV;E2E19TM;IAOI,uBAAA;E3Es9TV;E2E79TM;IAOI,sBAAA;E3Ey9TV;E2Eh+TM;IAOI,8BAAA;E3E49TV;E2En+TM;IAOI,4BAAA;E3E+9TV;E2Et+TM;IAOI,2BAAA;E3Ek+TV;E2Ez+TM;IAOI,iCAAA;E3Eq+TV;E2E5+TM;IAOI,2BAAA;E3Ew+TV;E2E/+TM;IAOI,0BAAA;E3E2+TV;E2El/TM;IAOI,gCAAA;E3E8+TV;E2Er/TM;IAOI,yBAAA;E3Ei/TV;E2Ex/TM;IAOI,wBAAA;E3Eo/TV;E2E3/TM;IAOI,+BAAA;E3Eu/TV;E2E9/TM;IAOI,yBAAA;E3E0/TV;E2EjgUM;IAOI,6BAAA;E3E6/TV;E2EpgUM;IAOI,8BAAA;E3EggUV;E2EvgUM;IAOI,wBAAA;E3EmgUV;E2E1gUM;IAOI,+BAAA;E3EsgUV;E2E7gUM;IAOI,wBAAA;E3EygUV;E2EhhUM;IAOI,yBAAA;E3E4gUV;E2EnhUM;IAOI,8BAAA;E3E+gUV;E2EthUM;IAOI,iCAAA;E3EkhUV;E2EzhUM;IAOI,sCAAA;E3EqhUV;E2E5hUM;IAOI,yCAAA;E3EwhUV;E2E/hUM;IAOI,uBAAA;E3E2hUV;E2EliUM;IAOI,uBAAA;E3E8hUV;E2EriUM;IAOI,yBAAA;E3EiiUV;E2ExiUM;IAOI,yBAAA;E3EoiUV;E2E3iUM;IAOI,0BAAA;E3EuiUV;E2E9iUM;IAOI,4BAAA;E3E0iUV;E2EjjUM;IAOI,kCAAA;E3E6iUV;E2EpjUM;IAOI,sCAAA;E3EgjUV;E2EvjUM;IAOI,oCAAA;E3EmjUV;E2E1jUM;IAOI,kCAAA;E3EsjUV;E2E7jUM;IAOI,yCAAA;E3EyjUV;E2EhkUM;IAOI,wCAAA;E3E4jUV;E2EnkUM;IAOI,wCAAA;E3E+jUV;E2EtkUM;IAOI,kCAAA;E3EkkUV;E2EzkUM;IAOI,gCAAA;E3EqkUV;E2E5kUM;IAOI,8BAAA;E3EwkUV;E2E/kUM;IAOI,gCAAA;E3E2kUV;E2EllUM;IAOI,+BAAA;E3E8kUV;E2ErlUM;IAOI,oCAAA;E3EilUV;E2ExlUM;IAOI,kCAAA;E3EolUV;E2E3lUM;IAOI,gCAAA;E3EulUV;E2E9lUM;IAOI,uCAAA;E3E0lUV;E2EjmUM;IAOI,sCAAA;E3E6lUV;E2EpmUM;IAOI,iCAAA;E3EgmUV;E2EvmUM;IAOI,2BAAA;E3EmmUV;E2E1mUM;IAOI,iCAAA;E3EsmUV;E2E7mUM;IAOI,+BAAA;E3EymUV;E2EhnUM;IAOI,6BAAA;E3E4mUV;E2EnnUM;IAOI,+BAAA;E3E+mUV;E2EtnUM;IAOI,8BAAA;E3EknUV;E2EznUM;IAOI,oBAAA;E3EqnUV;E2E5nUM;IAOI,mBAAA;E3EwnUV;E2E/nUM;IAOI,mBAAA;E3E2nUV;E2EloUM;IAOI,mBAAA;E3E8nUV;E2EroUM;IAOI,mBAAA;E3EioUV;E2ExoUM;IAOI,mBAAA;E3EooUV;E2E3oUM;IAOI,mBAAA;E3EuoUV;E2E9oUM;IAOI,mBAAA;E3E0oUV;E2EjpUM;IAOI,oBAAA;E3E6oUV;E2EppUM;IAOI,0BAAA;E3EgpUV;E2EvpUM;IAOI,yBAAA;E3EmpUV;E2E1pUM;IAOI,0BAAA;E3EspUV;E2E7pUM;IAOI,uBAAA;E3EypUV;E2EhqUM;IAOI,yBAAA;E3E4pUV;E2EnqUM;IAOI,uBAAA;E3E+pUV;E2EtqUM;IAOI,yBAAA;E3EkqUV;E2EzqUM;IAOI,uBAAA;E3EqqUV;E2E5qUM;IAOI,uBAAA;E3EwqUV;E2E/qUM;IAOI,0BAAA;IAAA,yBAAA;E3E4qUV;E2EnrUM;IAOI,gCAAA;IAAA,+BAAA;E3EgrUV;E2EvrUM;IAOI,+BAAA;IAAA,8BAAA;E3EorUV;E2E3rUM;IAOI,gCAAA;IAAA,+BAAA;E3EwrUV;E2E/rUM;IAOI,6BAAA;IAAA,4BAAA;E3E4rUV;E2EnsUM;IAOI,+BAAA;IAAA,8BAAA;E3EgsUV;E2EvsUM;IAOI,6BAAA;IAAA,4BAAA;E3EosUV;E2E3sUM;IAOI,+BAAA;IAAA,8BAAA;E3EwsUV;E2E/sUM;IAOI,6BAAA;IAAA,4BAAA;E3E4sUV;E2EntUM;IAOI,6BAAA;IAAA,4BAAA;E3EgtUV;E2EvtUM;IAOI,wBAAA;IAAA,2BAAA;E3EotUV;E2E3tUM;IAOI,8BAAA;IAAA,iCAAA;E3EwtUV;E2E/tUM;IAOI,6BAAA;IAAA,gCAAA;E3E4tUV;E2EnuUM;IAOI,8BAAA;IAAA,iCAAA;E3EguUV;E2EvuUM;IAOI,2BAAA;IAAA,8BAAA;E3EouUV;E2E3uUM;IAOI,6BAAA;IAAA,gCAAA;E3EwuUV;E2E/uUM;IAOI,2BAAA;IAAA,8BAAA;E3E4uUV;E2EnvUM;IAOI,6BAAA;IAAA,gCAAA;E3EgvUV;E2EvvUM;IAOI,2BAAA;IAAA,8BAAA;E3EovUV;E2E3vUM;IAOI,2BAAA;IAAA,8BAAA;E3EwvUV;E2E/vUM;IAOI,wBAAA;E3E2vUV;E2ElwUM;IAOI,8BAAA;E3E8vUV;E2ErwUM;IAOI,6BAAA;E3EiwUV;E2ExwUM;IAOI,8BAAA;E3EowUV;E2E3wUM;IAOI,2BAAA;E3EuwUV;E2E9wUM;IAOI,6BAAA;E3E0wUV;E2EjxUM;IAOI,2BAAA;E3E6wUV;E2EpxUM;IAOI,6BAAA;E3EgxUV;E2EvxUM;IAOI,2BAAA;E3EmxUV;E2E1xUM;IAOI,2BAAA;E3EsxUV;E2E7xUM;IAOI,0BAAA;E3EyxUV;E2EhyUM;IAOI,gCAAA;E3E4xUV;E2EnyUM;IAOI,+BAAA;E3E+xUV;E2EtyUM;IAOI,gCAAA;E3EkyUV;E2EzyUM;IAOI,6BAAA;E3EqyUV;E2E5yUM;IAOI,+BAAA;E3EwyUV;E2E/yUM;IAOI,6BAAA;E3E2yUV;E2ElzUM;IAOI,+BAAA;E3E8yUV;E2ErzUM;IAOI,6BAAA;E3EizUV;E2ExzUM;IAOI,6BAAA;E3EozUV;E2E3zUM;IAOI,2BAAA;E3EuzUV;E2E9zUM;IAOI,iCAAA;E3E0zUV;E2Ej0UM;IAOI,gCAAA;E3E6zUV;E2Ep0UM;IAOI,iCAAA;E3Eg0UV;E2Ev0UM;IAOI,8BAAA;E3Em0UV;E2E10UM;IAOI,gCAAA;E3Es0UV;E2E70UM;IAOI,8BAAA;E3Ey0UV;E2Eh1UM;IAOI,gCAAA;E3E40UV;E2En1UM;IAOI,8BAAA;E3E+0UV;E2Et1UM;IAOI,8BAAA;E3Ek1UV;E2Ez1UM;IAOI,yBAAA;E3Eq1UV;E2E51UM;IAOI,+BAAA;E3Ew1UV;E2E/1UM;IAOI,8BAAA;E3E21UV;E2El2UM;IAOI,+BAAA;E3E81UV;E2Er2UM;IAOI,4BAAA;E3Ei2UV;E2Ex2UM;IAOI,8BAAA;E3Eo2UV;E2E32UM;IAOI,4BAAA;E3Eu2UV;E2E92UM;IAOI,8BAAA;E3E02UV;E2Ej3UM;IAOI,4BAAA;E3E62UV;E2Ep3UM;IAOI,4BAAA;E3Eg3UV;E2Ev3UM;IAOI,qBAAA;E3Em3UV;E2E13UM;IAOI,2BAAA;E3Es3UV;E2E73UM;IAOI,0BAAA;E3Ey3UV;E2Eh4UM;IAOI,2BAAA;E3E43UV;E2En4UM;IAOI,wBAAA;E3E+3UV;E2Et4UM;IAOI,0BAAA;E3Ek4UV;E2Ez4UM;IAOI,wBAAA;E3Eq4UV;E2E54UM;IAOI,0BAAA;E3Ew4UV;E2E/4UM;IAOI,wBAAA;E3E24UV;E2El5UM;IAOI,2BAAA;IAAA,0BAAA;E3E+4UV;E2Et5UM;IAOI,iCAAA;IAAA,gCAAA;E3Em5UV;E2E15UM;IAOI,gCAAA;IAAA,+BAAA;E3Eu5UV;E2E95UM;IAOI,iCAAA;IAAA,gCAAA;E3E25UV;E2El6UM;IAOI,8BAAA;IAAA,6BAAA;E3E+5UV;E2Et6UM;IAOI,gCAAA;IAAA,+BAAA;E3Em6UV;E2E16UM;IAOI,8BAAA;IAAA,6BAAA;E3Eu6UV;E2E96UM;IAOI,gCAAA;IAAA,+BAAA;E3E26UV;E2El7UM;IAOI,8BAAA;IAAA,6BAAA;E3E+6UV;E2Et7UM;IAOI,yBAAA;IAAA,4BAAA;E3Em7UV;E2E17UM;IAOI,+BAAA;IAAA,kCAAA;E3Eu7UV;E2E97UM;IAOI,8BAAA;IAAA,iCAAA;E3E27UV;E2El8UM;IAOI,+BAAA;IAAA,kCAAA;E3E+7UV;E2Et8UM;IAOI,4BAAA;IAAA,+BAAA;E3Em8UV;E2E18UM;IAOI,8BAAA;IAAA,iCAAA;E3Eu8UV;E2E98UM;IAOI,4BAAA;IAAA,+BAAA;E3E28UV;E2El9UM;IAOI,8BAAA;IAAA,iCAAA;E3E+8UV;E2Et9UM;IAOI,4BAAA;IAAA,+BAAA;E3Em9UV;E2E19UM;IAOI,yBAAA;E3Es9UV;E2E79UM;IAOI,+BAAA;E3Ey9UV;E2Eh+UM;IAOI,8BAAA;E3E49UV;E2En+UM;IAOI,+BAAA;E3E+9UV;E2Et+UM;IAOI,4BAAA;E3Ek+UV;E2Ez+UM;IAOI,8BAAA;E3Eq+UV;E2E5+UM;IAOI,4BAAA;E3Ew+UV;E2E/+UM;IAOI,8BAAA;E3E2+UV;E2El/UM;IAOI,4BAAA;E3E8+UV;E2Er/UM;IAOI,2BAAA;E3Ei/UV;E2Ex/UM;IAOI,iCAAA;E3Eo/UV;E2E3/UM;IAOI,gCAAA;E3Eu/UV;E2E9/UM;IAOI,iCAAA;E3E0/UV;E2EjgVM;IAOI,8BAAA;E3E6/UV;E2EpgVM;IAOI,gCAAA;E3EggVV;E2EvgVM;IAOI,8BAAA;E3EmgVV;E2E1gVM;IAOI,gCAAA;E3EsgVV;E2E7gVM;IAOI,8BAAA;E3EygVV;E2EhhVM;IAOI,4BAAA;E3E4gVV;E2EnhVM;IAOI,kCAAA;E3E+gVV;E2EthVM;IAOI,iCAAA;E3EkhVV;E2EzhVM;IAOI,kCAAA;E3EqhVV;E2E5hVM;IAOI,+BAAA;E3EwhVV;E2E/hVM;IAOI,iCAAA;E3E2hVV;E2EliVM;IAOI,+BAAA;E3E8hVV;E2EriVM;IAOI,iCAAA;E3EiiVV;E2ExiVM;IAOI,+BAAA;E3EoiVV;E2E3iVM;IAOI,0BAAA;E3EuiVV;E2E9iVM;IAOI,gCAAA;E3E0iVV;E2EjjVM;IAOI,+BAAA;E3E6iVV;E2EpjVM;IAOI,gCAAA;E3EgjVV;E2EvjVM;IAOI,6BAAA;E3EmjVV;E2E1jVM;IAOI,+BAAA;E3EsjVV;E2E7jVM;IAOI,6BAAA;E3EyjVV;E2EhkVM;IAOI,+BAAA;E3E4jVV;E2EnkVM;IAOI,6BAAA;E3E+jVV;E2EtkVM;IAOI,iBAAA;E3EkkVV;E2EzkVM;IAOI,uBAAA;E3EqkVV;E2E5kVM;IAOI,sBAAA;E3EwkVV;E2E/kVM;IAOI,uBAAA;E3E2kVV;E2EllVM;IAOI,oBAAA;E3E8kVV;E2ErlVM;IAOI,sBAAA;E3EilVV;E2ExlVM;IAOI,oBAAA;E3EolVV;E2E3lVM;IAOI,sBAAA;E3EulVV;E2E9lVM;IAOI,oBAAA;E3E0lVV;E2EjmVM;IAOI,qBAAA;E3E6lVV;E2EpmVM;IAOI,2BAAA;E3EgmVV;E2EvmVM;IAOI,0BAAA;E3EmmVV;E2E1mVM;IAOI,2BAAA;E3EsmVV;E2E7mVM;IAOI,wBAAA;E3EymVV;E2EhnVM;IAOI,0BAAA;E3E4mVV;E2EnnVM;IAOI,wBAAA;E3E+mVV;E2EtnVM;IAOI,0BAAA;E3EknVV;E2EznVM;IAOI,wBAAA;E3EqnVV;E2E5nVM;IAOI,wBAAA;E3EwnVV;E2E/nVM;IAOI,8BAAA;E3E2nVV;E2EloVM;IAOI,6BAAA;E3E8nVV;E2EroVM;IAOI,8BAAA;E3EioVV;E2ExoVM;IAOI,2BAAA;E3EooVV;E2E3oVM;IAOI,6BAAA;E3EuoVV;E2E9oVM;IAOI,2BAAA;E3E0oVV;E2EjpVM;IAOI,6BAAA;E3E6oVV;E2EppVM;IAOI,2BAAA;E3EgpVV;E2EvpVM;IAOI,2BAAA;E3EmpVV;E2E1pVM;IAOI,4BAAA;E3EspVV;E2E7pVM;IAOI,6BAAA;E3EypVV;AACF;AiBpqVI;E0DGI;IAOI,sBAAA;E3E8pVV;E2ErqVM;IAOI,uBAAA;E3EiqVV;E2ExqVM;IAOI,sBAAA;E3EoqVV;E2E3qVM;IAOI,8BAAA;E3EuqVV;E2E9qVM;IAOI,4BAAA;E3E0qVV;E2EjrVM;IAOI,2BAAA;E3E6qVV;E2EprVM;IAOI,iCAAA;E3EgrVV;E2EvrVM;IAOI,2BAAA;E3EmrVV;E2E1rVM;IAOI,0BAAA;E3EsrVV;E2E7rVM;IAOI,gCAAA;E3EyrVV;E2EhsVM;IAOI,yBAAA;E3E4rVV;E2EnsVM;IAOI,wBAAA;E3E+rVV;E2EtsVM;IAOI,+BAAA;E3EksVV;E2EzsVM;IAOI,yBAAA;E3EqsVV;E2E5sVM;IAOI,6BAAA;E3EwsVV;E2E/sVM;IAOI,8BAAA;E3E2sVV;E2EltVM;IAOI,wBAAA;E3E8sVV;E2ErtVM;IAOI,+BAAA;E3EitVV;E2ExtVM;IAOI,wBAAA;E3EotVV;E2E3tVM;IAOI,yBAAA;E3EutVV;E2E9tVM;IAOI,8BAAA;E3E0tVV;E2EjuVM;IAOI,iCAAA;E3E6tVV;E2EpuVM;IAOI,sCAAA;E3EguVV;E2EvuVM;IAOI,yCAAA;E3EmuVV;E2E1uVM;IAOI,uBAAA;E3EsuVV;E2E7uVM;IAOI,uBAAA;E3EyuVV;E2EhvVM;IAOI,yBAAA;E3E4uVV;E2EnvVM;IAOI,yBAAA;E3E+uVV;E2EtvVM;IAOI,0BAAA;E3EkvVV;E2EzvVM;IAOI,4BAAA;E3EqvVV;E2E5vVM;IAOI,kCAAA;E3EwvVV;E2E/vVM;IAOI,sCAAA;E3E2vVV;E2ElwVM;IAOI,oCAAA;E3E8vVV;E2ErwVM;IAOI,kCAAA;E3EiwVV;E2ExwVM;IAOI,yCAAA;E3EowVV;E2E3wVM;IAOI,wCAAA;E3EuwVV;E2E9wVM;IAOI,wCAAA;E3E0wVV;E2EjxVM;IAOI,kCAAA;E3E6wVV;E2EpxVM;IAOI,gCAAA;E3EgxVV;E2EvxVM;IAOI,8BAAA;E3EmxVV;E2E1xVM;IAOI,gCAAA;E3EsxVV;E2E7xVM;IAOI,+BAAA;E3EyxVV;E2EhyVM;IAOI,oCAAA;E3E4xVV;E2EnyVM;IAOI,kCAAA;E3E+xVV;E2EtyVM;IAOI,gCAAA;E3EkyVV;E2EzyVM;IAOI,uCAAA;E3EqyVV;E2E5yVM;IAOI,sCAAA;E3EwyVV;E2E/yVM;IAOI,iCAAA;E3E2yVV;E2ElzVM;IAOI,2BAAA;E3E8yVV;E2ErzVM;IAOI,iCAAA;E3EizVV;E2ExzVM;IAOI,+BAAA;E3EozVV;E2E3zVM;IAOI,6BAAA;E3EuzVV;E2E9zVM;IAOI,+BAAA;E3E0zVV;E2Ej0VM;IAOI,8BAAA;E3E6zVV;E2Ep0VM;IAOI,oBAAA;E3Eg0VV;E2Ev0VM;IAOI,mBAAA;E3Em0VV;E2E10VM;IAOI,mBAAA;E3Es0VV;E2E70VM;IAOI,mBAAA;E3Ey0VV;E2Eh1VM;IAOI,mBAAA;E3E40VV;E2En1VM;IAOI,mBAAA;E3E+0VV;E2Et1VM;IAOI,mBAAA;E3Ek1VV;E2Ez1VM;IAOI,mBAAA;E3Eq1VV;E2E51VM;IAOI,oBAAA;E3Ew1VV;E2E/1VM;IAOI,0BAAA;E3E21VV;E2El2VM;IAOI,yBAAA;E3E81VV;E2Er2VM;IAOI,0BAAA;E3Ei2VV;E2Ex2VM;IAOI,uBAAA;E3Eo2VV;E2E32VM;IAOI,yBAAA;E3Eu2VV;E2E92VM;IAOI,uBAAA;E3E02VV;E2Ej3VM;IAOI,yBAAA;E3E62VV;E2Ep3VM;IAOI,uBAAA;E3Eg3VV;E2Ev3VM;IAOI,uBAAA;E3Em3VV;E2E13VM;IAOI,0BAAA;IAAA,yBAAA;E3Eu3VV;E2E93VM;IAOI,gCAAA;IAAA,+BAAA;E3E23VV;E2El4VM;IAOI,+BAAA;IAAA,8BAAA;E3E+3VV;E2Et4VM;IAOI,gCAAA;IAAA,+BAAA;E3Em4VV;E2E14VM;IAOI,6BAAA;IAAA,4BAAA;E3Eu4VV;E2E94VM;IAOI,+BAAA;IAAA,8BAAA;E3E24VV;E2El5VM;IAOI,6BAAA;IAAA,4BAAA;E3E+4VV;E2Et5VM;IAOI,+BAAA;IAAA,8BAAA;E3Em5VV;E2E15VM;IAOI,6BAAA;IAAA,4BAAA;E3Eu5VV;E2E95VM;IAOI,6BAAA;IAAA,4BAAA;E3E25VV;E2El6VM;IAOI,wBAAA;IAAA,2BAAA;E3E+5VV;E2Et6VM;IAOI,8BAAA;IAAA,iCAAA;E3Em6VV;E2E16VM;IAOI,6BAAA;IAAA,gCAAA;E3Eu6VV;E2E96VM;IAOI,8BAAA;IAAA,iCAAA;E3E26VV;E2El7VM;IAOI,2BAAA;IAAA,8BAAA;E3E+6VV;E2Et7VM;IAOI,6BAAA;IAAA,gCAAA;E3Em7VV;E2E17VM;IAOI,2BAAA;IAAA,8BAAA;E3Eu7VV;E2E97VM;IAOI,6BAAA;IAAA,gCAAA;E3E27VV;E2El8VM;IAOI,2BAAA;IAAA,8BAAA;E3E+7VV;E2Et8VM;IAOI,2BAAA;IAAA,8BAAA;E3Em8VV;E2E18VM;IAOI,wBAAA;E3Es8VV;E2E78VM;IAOI,8BAAA;E3Ey8VV;E2Eh9VM;IAOI,6BAAA;E3E48VV;E2En9VM;IAOI,8BAAA;E3E+8VV;E2Et9VM;IAOI,2BAAA;E3Ek9VV;E2Ez9VM;IAOI,6BAAA;E3Eq9VV;E2E59VM;IAOI,2BAAA;E3Ew9VV;E2E/9VM;IAOI,6BAAA;E3E29VV;E2El+VM;IAOI,2BAAA;E3E89VV;E2Er+VM;IAOI,2BAAA;E3Ei+VV;E2Ex+VM;IAOI,0BAAA;E3Eo+VV;E2E3+VM;IAOI,gCAAA;E3Eu+VV;E2E9+VM;IAOI,+BAAA;E3E0+VV;E2Ej/VM;IAOI,gCAAA;E3E6+VV;E2Ep/VM;IAOI,6BAAA;E3Eg/VV;E2Ev/VM;IAOI,+BAAA;E3Em/VV;E2E1/VM;IAOI,6BAAA;E3Es/VV;E2E7/VM;IAOI,+BAAA;E3Ey/VV;E2EhgWM;IAOI,6BAAA;E3E4/VV;E2EngWM;IAOI,6BAAA;E3E+/VV;E2EtgWM;IAOI,2BAAA;E3EkgWV;E2EzgWM;IAOI,iCAAA;E3EqgWV;E2E5gWM;IAOI,gCAAA;E3EwgWV;E2E/gWM;IAOI,iCAAA;E3E2gWV;E2ElhWM;IAOI,8BAAA;E3E8gWV;E2ErhWM;IAOI,gCAAA;E3EihWV;E2ExhWM;IAOI,8BAAA;E3EohWV;E2E3hWM;IAOI,gCAAA;E3EuhWV;E2E9hWM;IAOI,8BAAA;E3E0hWV;E2EjiWM;IAOI,8BAAA;E3E6hWV;E2EpiWM;IAOI,yBAAA;E3EgiWV;E2EviWM;IAOI,+BAAA;E3EmiWV;E2E1iWM;IAOI,8BAAA;E3EsiWV;E2E7iWM;IAOI,+BAAA;E3EyiWV;E2EhjWM;IAOI,4BAAA;E3E4iWV;E2EnjWM;IAOI,8BAAA;E3E+iWV;E2EtjWM;IAOI,4BAAA;E3EkjWV;E2EzjWM;IAOI,8BAAA;E3EqjWV;E2E5jWM;IAOI,4BAAA;E3EwjWV;E2E/jWM;IAOI,4BAAA;E3E2jWV;E2ElkWM;IAOI,qBAAA;E3E8jWV;E2ErkWM;IAOI,2BAAA;E3EikWV;E2ExkWM;IAOI,0BAAA;E3EokWV;E2E3kWM;IAOI,2BAAA;E3EukWV;E2E9kWM;IAOI,wBAAA;E3E0kWV;E2EjlWM;IAOI,0BAAA;E3E6kWV;E2EplWM;IAOI,wBAAA;E3EglWV;E2EvlWM;IAOI,0BAAA;E3EmlWV;E2E1lWM;IAOI,wBAAA;E3EslWV;E2E7lWM;IAOI,2BAAA;IAAA,0BAAA;E3E0lWV;E2EjmWM;IAOI,iCAAA;IAAA,gCAAA;E3E8lWV;E2ErmWM;IAOI,gCAAA;IAAA,+BAAA;E3EkmWV;E2EzmWM;IAOI,iCAAA;IAAA,gCAAA;E3EsmWV;E2E7mWM;IAOI,8BAAA;IAAA,6BAAA;E3E0mWV;E2EjnWM;IAOI,gCAAA;IAAA,+BAAA;E3E8mWV;E2ErnWM;IAOI,8BAAA;IAAA,6BAAA;E3EknWV;E2EznWM;IAOI,gCAAA;IAAA,+BAAA;E3EsnWV;E2E7nWM;IAOI,8BAAA;IAAA,6BAAA;E3E0nWV;E2EjoWM;IAOI,yBAAA;IAAA,4BAAA;E3E8nWV;E2EroWM;IAOI,+BAAA;IAAA,kCAAA;E3EkoWV;E2EzoWM;IAOI,8BAAA;IAAA,iCAAA;E3EsoWV;E2E7oWM;IAOI,+BAAA;IAAA,kCAAA;E3E0oWV;E2EjpWM;IAOI,4BAAA;IAAA,+BAAA;E3E8oWV;E2ErpWM;IAOI,8BAAA;IAAA,iCAAA;E3EkpWV;E2EzpWM;IAOI,4BAAA;IAAA,+BAAA;E3EspWV;E2E7pWM;IAOI,8BAAA;IAAA,iCAAA;E3E0pWV;E2EjqWM;IAOI,4BAAA;IAAA,+BAAA;E3E8pWV;E2ErqWM;IAOI,yBAAA;E3EiqWV;E2ExqWM;IAOI,+BAAA;E3EoqWV;E2E3qWM;IAOI,8BAAA;E3EuqWV;E2E9qWM;IAOI,+BAAA;E3E0qWV;E2EjrWM;IAOI,4BAAA;E3E6qWV;E2EprWM;IAOI,8BAAA;E3EgrWV;E2EvrWM;IAOI,4BAAA;E3EmrWV;E2E1rWM;IAOI,8BAAA;E3EsrWV;E2E7rWM;IAOI,4BAAA;E3EyrWV;E2EhsWM;IAOI,2BAAA;E3E4rWV;E2EnsWM;IAOI,iCAAA;E3E+rWV;E2EtsWM;IAOI,gCAAA;E3EksWV;E2EzsWM;IAOI,iCAAA;E3EqsWV;E2E5sWM;IAOI,8BAAA;E3EwsWV;E2E/sWM;IAOI,gCAAA;E3E2sWV;E2EltWM;IAOI,8BAAA;E3E8sWV;E2ErtWM;IAOI,gCAAA;E3EitWV;E2ExtWM;IAOI,8BAAA;E3EotWV;E2E3tWM;IAOI,4BAAA;E3EutWV;E2E9tWM;IAOI,kCAAA;E3E0tWV;E2EjuWM;IAOI,iCAAA;E3E6tWV;E2EpuWM;IAOI,kCAAA;E3EguWV;E2EvuWM;IAOI,+BAAA;E3EmuWV;E2E1uWM;IAOI,iCAAA;E3EsuWV;E2E7uWM;IAOI,+BAAA;E3EyuWV;E2EhvWM;IAOI,iCAAA;E3E4uWV;E2EnvWM;IAOI,+BAAA;E3E+uWV;E2EtvWM;IAOI,0BAAA;E3EkvWV;E2EzvWM;IAOI,gCAAA;E3EqvWV;E2E5vWM;IAOI,+BAAA;E3EwvWV;E2E/vWM;IAOI,gCAAA;E3E2vWV;E2ElwWM;IAOI,6BAAA;E3E8vWV;E2ErwWM;IAOI,+BAAA;E3EiwWV;E2ExwWM;IAOI,6BAAA;E3EowWV;E2E3wWM;IAOI,+BAAA;E3EuwWV;E2E9wWM;IAOI,6BAAA;E3E0wWV;E2EjxWM;IAOI,iBAAA;E3E6wWV;E2EpxWM;IAOI,uBAAA;E3EgxWV;E2EvxWM;IAOI,sBAAA;E3EmxWV;E2E1xWM;IAOI,uBAAA;E3EsxWV;E2E7xWM;IAOI,oBAAA;E3EyxWV;E2EhyWM;IAOI,sBAAA;E3E4xWV;E2EnyWM;IAOI,oBAAA;E3E+xWV;E2EtyWM;IAOI,sBAAA;E3EkyWV;E2EzyWM;IAOI,oBAAA;E3EqyWV;E2E5yWM;IAOI,qBAAA;E3EwyWV;E2E/yWM;IAOI,2BAAA;E3E2yWV;E2ElzWM;IAOI,0BAAA;E3E8yWV;E2ErzWM;IAOI,2BAAA;E3EizWV;E2ExzWM;IAOI,wBAAA;E3EozWV;E2E3zWM;IAOI,0BAAA;E3EuzWV;E2E9zWM;IAOI,wBAAA;E3E0zWV;E2Ej0WM;IAOI,0BAAA;E3E6zWV;E2Ep0WM;IAOI,wBAAA;E3Eg0WV;E2Ev0WM;IAOI,wBAAA;E3Em0WV;E2E10WM;IAOI,8BAAA;E3Es0WV;E2E70WM;IAOI,6BAAA;E3Ey0WV;E2Eh1WM;IAOI,8BAAA;E3E40WV;E2En1WM;IAOI,2BAAA;E3E+0WV;E2Et1WM;IAOI,6BAAA;E3Ek1WV;E2Ez1WM;IAOI,2BAAA;E3Eq1WV;E2E51WM;IAOI,6BAAA;E3Ew1WV;E2E/1WM;IAOI,2BAAA;E3E21WV;E2El2WM;IAOI,2BAAA;E3E81WV;E2Er2WM;IAOI,4BAAA;E3Ei2WV;E2Ex2WM;IAOI,6BAAA;E3Eo2WV;AACF;AiB/2WI;E0DGI;IAOI,sBAAA;E3Ey2WV;E2Eh3WM;IAOI,uBAAA;E3E42WV;E2En3WM;IAOI,sBAAA;E3E+2WV;E2Et3WM;IAOI,8BAAA;E3Ek3WV;E2Ez3WM;IAOI,4BAAA;E3Eq3WV;E2E53WM;IAOI,2BAAA;E3Ew3WV;E2E/3WM;IAOI,iCAAA;E3E23WV;E2El4WM;IAOI,2BAAA;E3E83WV;E2Er4WM;IAOI,0BAAA;E3Ei4WV;E2Ex4WM;IAOI,gCAAA;E3Eo4WV;E2E34WM;IAOI,yBAAA;E3Eu4WV;E2E94WM;IAOI,wBAAA;E3E04WV;E2Ej5WM;IAOI,+BAAA;E3E64WV;E2Ep5WM;IAOI,yBAAA;E3Eg5WV;E2Ev5WM;IAOI,6BAAA;E3Em5WV;E2E15WM;IAOI,8BAAA;E3Es5WV;E2E75WM;IAOI,wBAAA;E3Ey5WV;E2Eh6WM;IAOI,+BAAA;E3E45WV;E2En6WM;IAOI,wBAAA;E3E+5WV;E2Et6WM;IAOI,yBAAA;E3Ek6WV;E2Ez6WM;IAOI,8BAAA;E3Eq6WV;E2E56WM;IAOI,iCAAA;E3Ew6WV;E2E/6WM;IAOI,sCAAA;E3E26WV;E2El7WM;IAOI,yCAAA;E3E86WV;E2Er7WM;IAOI,uBAAA;E3Ei7WV;E2Ex7WM;IAOI,uBAAA;E3Eo7WV;E2E37WM;IAOI,yBAAA;E3Eu7WV;E2E97WM;IAOI,yBAAA;E3E07WV;E2Ej8WM;IAOI,0BAAA;E3E67WV;E2Ep8WM;IAOI,4BAAA;E3Eg8WV;E2Ev8WM;IAOI,kCAAA;E3Em8WV;E2E18WM;IAOI,sCAAA;E3Es8WV;E2E78WM;IAOI,oCAAA;E3Ey8WV;E2Eh9WM;IAOI,kCAAA;E3E48WV;E2En9WM;IAOI,yCAAA;E3E+8WV;E2Et9WM;IAOI,wCAAA;E3Ek9WV;E2Ez9WM;IAOI,wCAAA;E3Eq9WV;E2E59WM;IAOI,kCAAA;E3Ew9WV;E2E/9WM;IAOI,gCAAA;E3E29WV;E2El+WM;IAOI,8BAAA;E3E89WV;E2Er+WM;IAOI,gCAAA;E3Ei+WV;E2Ex+WM;IAOI,+BAAA;E3Eo+WV;E2E3+WM;IAOI,oCAAA;E3Eu+WV;E2E9+WM;IAOI,kCAAA;E3E0+WV;E2Ej/WM;IAOI,gCAAA;E3E6+WV;E2Ep/WM;IAOI,uCAAA;E3Eg/WV;E2Ev/WM;IAOI,sCAAA;E3Em/WV;E2E1/WM;IAOI,iCAAA;E3Es/WV;E2E7/WM;IAOI,2BAAA;E3Ey/WV;E2EhgXM;IAOI,iCAAA;E3E4/WV;E2EngXM;IAOI,+BAAA;E3E+/WV;E2EtgXM;IAOI,6BAAA;E3EkgXV;E2EzgXM;IAOI,+BAAA;E3EqgXV;E2E5gXM;IAOI,8BAAA;E3EwgXV;E2E/gXM;IAOI,oBAAA;E3E2gXV;E2ElhXM;IAOI,mBAAA;E3E8gXV;E2ErhXM;IAOI,mBAAA;E3EihXV;E2ExhXM;IAOI,mBAAA;E3EohXV;E2E3hXM;IAOI,mBAAA;E3EuhXV;E2E9hXM;IAOI,mBAAA;E3E0hXV;E2EjiXM;IAOI,mBAAA;E3E6hXV;E2EpiXM;IAOI,mBAAA;E3EgiXV;E2EviXM;IAOI,oBAAA;E3EmiXV;E2E1iXM;IAOI,0BAAA;E3EsiXV;E2E7iXM;IAOI,yBAAA;E3EyiXV;E2EhjXM;IAOI,0BAAA;E3E4iXV;E2EnjXM;IAOI,uBAAA;E3E+iXV;E2EtjXM;IAOI,yBAAA;E3EkjXV;E2EzjXM;IAOI,uBAAA;E3EqjXV;E2E5jXM;IAOI,yBAAA;E3EwjXV;E2E/jXM;IAOI,uBAAA;E3E2jXV;E2ElkXM;IAOI,uBAAA;E3E8jXV;E2ErkXM;IAOI,0BAAA;IAAA,yBAAA;E3EkkXV;E2EzkXM;IAOI,gCAAA;IAAA,+BAAA;E3EskXV;E2E7kXM;IAOI,+BAAA;IAAA,8BAAA;E3E0kXV;E2EjlXM;IAOI,gCAAA;IAAA,+BAAA;E3E8kXV;E2ErlXM;IAOI,6BAAA;IAAA,4BAAA;E3EklXV;E2EzlXM;IAOI,+BAAA;IAAA,8BAAA;E3EslXV;E2E7lXM;IAOI,6BAAA;IAAA,4BAAA;E3E0lXV;E2EjmXM;IAOI,+BAAA;IAAA,8BAAA;E3E8lXV;E2ErmXM;IAOI,6BAAA;IAAA,4BAAA;E3EkmXV;E2EzmXM;IAOI,6BAAA;IAAA,4BAAA;E3EsmXV;E2E7mXM;IAOI,wBAAA;IAAA,2BAAA;E3E0mXV;E2EjnXM;IAOI,8BAAA;IAAA,iCAAA;E3E8mXV;E2ErnXM;IAOI,6BAAA;IAAA,gCAAA;E3EknXV;E2EznXM;IAOI,8BAAA;IAAA,iCAAA;E3EsnXV;E2E7nXM;IAOI,2BAAA;IAAA,8BAAA;E3E0nXV;E2EjoXM;IAOI,6BAAA;IAAA,gCAAA;E3E8nXV;E2EroXM;IAOI,2BAAA;IAAA,8BAAA;E3EkoXV;E2EzoXM;IAOI,6BAAA;IAAA,gCAAA;E3EsoXV;E2E7oXM;IAOI,2BAAA;IAAA,8BAAA;E3E0oXV;E2EjpXM;IAOI,2BAAA;IAAA,8BAAA;E3E8oXV;E2ErpXM;IAOI,wBAAA;E3EipXV;E2ExpXM;IAOI,8BAAA;E3EopXV;E2E3pXM;IAOI,6BAAA;E3EupXV;E2E9pXM;IAOI,8BAAA;E3E0pXV;E2EjqXM;IAOI,2BAAA;E3E6pXV;E2EpqXM;IAOI,6BAAA;E3EgqXV;E2EvqXM;IAOI,2BAAA;E3EmqXV;E2E1qXM;IAOI,6BAAA;E3EsqXV;E2E7qXM;IAOI,2BAAA;E3EyqXV;E2EhrXM;IAOI,2BAAA;E3E4qXV;E2EnrXM;IAOI,0BAAA;E3E+qXV;E2EtrXM;IAOI,gCAAA;E3EkrXV;E2EzrXM;IAOI,+BAAA;E3EqrXV;E2E5rXM;IAOI,gCAAA;E3EwrXV;E2E/rXM;IAOI,6BAAA;E3E2rXV;E2ElsXM;IAOI,+BAAA;E3E8rXV;E2ErsXM;IAOI,6BAAA;E3EisXV;E2ExsXM;IAOI,+BAAA;E3EosXV;E2E3sXM;IAOI,6BAAA;E3EusXV;E2E9sXM;IAOI,6BAAA;E3E0sXV;E2EjtXM;IAOI,2BAAA;E3E6sXV;E2EptXM;IAOI,iCAAA;E3EgtXV;E2EvtXM;IAOI,gCAAA;E3EmtXV;E2E1tXM;IAOI,iCAAA;E3EstXV;E2E7tXM;IAOI,8BAAA;E3EytXV;E2EhuXM;IAOI,gCAAA;E3E4tXV;E2EnuXM;IAOI,8BAAA;E3E+tXV;E2EtuXM;IAOI,gCAAA;E3EkuXV;E2EzuXM;IAOI,8BAAA;E3EquXV;E2E5uXM;IAOI,8BAAA;E3EwuXV;E2E/uXM;IAOI,yBAAA;E3E2uXV;E2ElvXM;IAOI,+BAAA;E3E8uXV;E2ErvXM;IAOI,8BAAA;E3EivXV;E2ExvXM;IAOI,+BAAA;E3EovXV;E2E3vXM;IAOI,4BAAA;E3EuvXV;E2E9vXM;IAOI,8BAAA;E3E0vXV;E2EjwXM;IAOI,4BAAA;E3E6vXV;E2EpwXM;IAOI,8BAAA;E3EgwXV;E2EvwXM;IAOI,4BAAA;E3EmwXV;E2E1wXM;IAOI,4BAAA;E3EswXV;E2E7wXM;IAOI,qBAAA;E3EywXV;E2EhxXM;IAOI,2BAAA;E3E4wXV;E2EnxXM;IAOI,0BAAA;E3E+wXV;E2EtxXM;IAOI,2BAAA;E3EkxXV;E2EzxXM;IAOI,wBAAA;E3EqxXV;E2E5xXM;IAOI,0BAAA;E3EwxXV;E2E/xXM;IAOI,wBAAA;E3E2xXV;E2ElyXM;IAOI,0BAAA;E3E8xXV;E2EryXM;IAOI,wBAAA;E3EiyXV;E2ExyXM;IAOI,2BAAA;IAAA,0BAAA;E3EqyXV;E2E5yXM;IAOI,iCAAA;IAAA,gCAAA;E3EyyXV;E2EhzXM;IAOI,gCAAA;IAAA,+BAAA;E3E6yXV;E2EpzXM;IAOI,iCAAA;IAAA,gCAAA;E3EizXV;E2ExzXM;IAOI,8BAAA;IAAA,6BAAA;E3EqzXV;E2E5zXM;IAOI,gCAAA;IAAA,+BAAA;E3EyzXV;E2Eh0XM;IAOI,8BAAA;IAAA,6BAAA;E3E6zXV;E2Ep0XM;IAOI,gCAAA;IAAA,+BAAA;E3Ei0XV;E2Ex0XM;IAOI,8BAAA;IAAA,6BAAA;E3Eq0XV;E2E50XM;IAOI,yBAAA;IAAA,4BAAA;E3Ey0XV;E2Eh1XM;IAOI,+BAAA;IAAA,kCAAA;E3E60XV;E2Ep1XM;IAOI,8BAAA;IAAA,iCAAA;E3Ei1XV;E2Ex1XM;IAOI,+BAAA;IAAA,kCAAA;E3Eq1XV;E2E51XM;IAOI,4BAAA;IAAA,+BAAA;E3Ey1XV;E2Eh2XM;IAOI,8BAAA;IAAA,iCAAA;E3E61XV;E2Ep2XM;IAOI,4BAAA;IAAA,+BAAA;E3Ei2XV;E2Ex2XM;IAOI,8BAAA;IAAA,iCAAA;E3Eq2XV;E2E52XM;IAOI,4BAAA;IAAA,+BAAA;E3Ey2XV;E2Eh3XM;IAOI,yBAAA;E3E42XV;E2En3XM;IAOI,+BAAA;E3E+2XV;E2Et3XM;IAOI,8BAAA;E3Ek3XV;E2Ez3XM;IAOI,+BAAA;E3Eq3XV;E2E53XM;IAOI,4BAAA;E3Ew3XV;E2E/3XM;IAOI,8BAAA;E3E23XV;E2El4XM;IAOI,4BAAA;E3E83XV;E2Er4XM;IAOI,8BAAA;E3Ei4XV;E2Ex4XM;IAOI,4BAAA;E3Eo4XV;E2E34XM;IAOI,2BAAA;E3Eu4XV;E2E94XM;IAOI,iCAAA;E3E04XV;E2Ej5XM;IAOI,gCAAA;E3E64XV;E2Ep5XM;IAOI,iCAAA;E3Eg5XV;E2Ev5XM;IAOI,8BAAA;E3Em5XV;E2E15XM;IAOI,gCAAA;E3Es5XV;E2E75XM;IAOI,8BAAA;E3Ey5XV;E2Eh6XM;IAOI,gCAAA;E3E45XV;E2En6XM;IAOI,8BAAA;E3E+5XV;E2Et6XM;IAOI,4BAAA;E3Ek6XV;E2Ez6XM;IAOI,kCAAA;E3Eq6XV;E2E56XM;IAOI,iCAAA;E3Ew6XV;E2E/6XM;IAOI,kCAAA;E3E26XV;E2El7XM;IAOI,+BAAA;E3E86XV;E2Er7XM;IAOI,iCAAA;E3Ei7XV;E2Ex7XM;IAOI,+BAAA;E3Eo7XV;E2E37XM;IAOI,iCAAA;E3Eu7XV;E2E97XM;IAOI,+BAAA;E3E07XV;E2Ej8XM;IAOI,0BAAA;E3E67XV;E2Ep8XM;IAOI,gCAAA;E3Eg8XV;E2Ev8XM;IAOI,+BAAA;E3Em8XV;E2E18XM;IAOI,gCAAA;E3Es8XV;E2E78XM;IAOI,6BAAA;E3Ey8XV;E2Eh9XM;IAOI,+BAAA;E3E48XV;E2En9XM;IAOI,6BAAA;E3E+8XV;E2Et9XM;IAOI,+BAAA;E3Ek9XV;E2Ez9XM;IAOI,6BAAA;E3Eq9XV;E2E59XM;IAOI,iBAAA;E3Ew9XV;E2E/9XM;IAOI,uBAAA;E3E29XV;E2El+XM;IAOI,sBAAA;E3E89XV;E2Er+XM;IAOI,uBAAA;E3Ei+XV;E2Ex+XM;IAOI,oBAAA;E3Eo+XV;E2E3+XM;IAOI,sBAAA;E3Eu+XV;E2E9+XM;IAOI,oBAAA;E3E0+XV;E2Ej/XM;IAOI,sBAAA;E3E6+XV;E2Ep/XM;IAOI,oBAAA;E3Eg/XV;E2Ev/XM;IAOI,qBAAA;E3Em/XV;E2E1/XM;IAOI,2BAAA;E3Es/XV;E2E7/XM;IAOI,0BAAA;E3Ey/XV;E2EhgYM;IAOI,2BAAA;E3E4/XV;E2EngYM;IAOI,wBAAA;E3E+/XV;E2EtgYM;IAOI,0BAAA;E3EkgYV;E2EzgYM;IAOI,wBAAA;E3EqgYV;E2E5gYM;IAOI,0BAAA;E3EwgYV;E2E/gYM;IAOI,wBAAA;E3E2gYV;E2ElhYM;IAOI,wBAAA;E3E8gYV;E2ErhYM;IAOI,8BAAA;E3EihYV;E2ExhYM;IAOI,6BAAA;E3EohYV;E2E3hYM;IAOI,8BAAA;E3EuhYV;E2E9hYM;IAOI,2BAAA;E3E0hYV;E2EjiYM;IAOI,6BAAA;E3E6hYV;E2EpiYM;IAOI,2BAAA;E3EgiYV;E2EviYM;IAOI,6BAAA;E3EmiYV;E2E1iYM;IAOI,2BAAA;E3EsiYV;E2E7iYM;IAOI,2BAAA;E3EyiYV;E2EhjYM;IAOI,4BAAA;E3E4iYV;E2EnjYM;IAOI,6BAAA;E3E+iYV;AACF;AiB1jYI;E0DGI;IAOI,sBAAA;E3EojYV;E2E3jYM;IAOI,uBAAA;E3EujYV;E2E9jYM;IAOI,sBAAA;E3E0jYV;E2EjkYM;IAOI,8BAAA;E3E6jYV;E2EpkYM;IAOI,4BAAA;E3EgkYV;E2EvkYM;IAOI,2BAAA;E3EmkYV;E2E1kYM;IAOI,iCAAA;E3EskYV;E2E7kYM;IAOI,2BAAA;E3EykYV;E2EhlYM;IAOI,0BAAA;E3E4kYV;E2EnlYM;IAOI,gCAAA;E3E+kYV;E2EtlYM;IAOI,yBAAA;E3EklYV;E2EzlYM;IAOI,wBAAA;E3EqlYV;E2E5lYM;IAOI,+BAAA;E3EwlYV;E2E/lYM;IAOI,yBAAA;E3E2lYV;E2ElmYM;IAOI,6BAAA;E3E8lYV;E2ErmYM;IAOI,8BAAA;E3EimYV;E2ExmYM;IAOI,wBAAA;E3EomYV;E2E3mYM;IAOI,+BAAA;E3EumYV;E2E9mYM;IAOI,wBAAA;E3E0mYV;E2EjnYM;IAOI,yBAAA;E3E6mYV;E2EpnYM;IAOI,8BAAA;E3EgnYV;E2EvnYM;IAOI,iCAAA;E3EmnYV;E2E1nYM;IAOI,sCAAA;E3EsnYV;E2E7nYM;IAOI,yCAAA;E3EynYV;E2EhoYM;IAOI,uBAAA;E3E4nYV;E2EnoYM;IAOI,uBAAA;E3E+nYV;E2EtoYM;IAOI,yBAAA;E3EkoYV;E2EzoYM;IAOI,yBAAA;E3EqoYV;E2E5oYM;IAOI,0BAAA;E3EwoYV;E2E/oYM;IAOI,4BAAA;E3E2oYV;E2ElpYM;IAOI,kCAAA;E3E8oYV;E2ErpYM;IAOI,sCAAA;E3EipYV;E2ExpYM;IAOI,oCAAA;E3EopYV;E2E3pYM;IAOI,kCAAA;E3EupYV;E2E9pYM;IAOI,yCAAA;E3E0pYV;E2EjqYM;IAOI,wCAAA;E3E6pYV;E2EpqYM;IAOI,wCAAA;E3EgqYV;E2EvqYM;IAOI,kCAAA;E3EmqYV;E2E1qYM;IAOI,gCAAA;E3EsqYV;E2E7qYM;IAOI,8BAAA;E3EyqYV;E2EhrYM;IAOI,gCAAA;E3E4qYV;E2EnrYM;IAOI,+BAAA;E3E+qYV;E2EtrYM;IAOI,oCAAA;E3EkrYV;E2EzrYM;IAOI,kCAAA;E3EqrYV;E2E5rYM;IAOI,gCAAA;E3EwrYV;E2E/rYM;IAOI,uCAAA;E3E2rYV;E2ElsYM;IAOI,sCAAA;E3E8rYV;E2ErsYM;IAOI,iCAAA;E3EisYV;E2ExsYM;IAOI,2BAAA;E3EosYV;E2E3sYM;IAOI,iCAAA;E3EusYV;E2E9sYM;IAOI,+BAAA;E3E0sYV;E2EjtYM;IAOI,6BAAA;E3E6sYV;E2EptYM;IAOI,+BAAA;E3EgtYV;E2EvtYM;IAOI,8BAAA;E3EmtYV;E2E1tYM;IAOI,oBAAA;E3EstYV;E2E7tYM;IAOI,mBAAA;E3EytYV;E2EhuYM;IAOI,mBAAA;E3E4tYV;E2EnuYM;IAOI,mBAAA;E3E+tYV;E2EtuYM;IAOI,mBAAA;E3EkuYV;E2EzuYM;IAOI,mBAAA;E3EquYV;E2E5uYM;IAOI,mBAAA;E3EwuYV;E2E/uYM;IAOI,mBAAA;E3E2uYV;E2ElvYM;IAOI,oBAAA;E3E8uYV;E2ErvYM;IAOI,0BAAA;E3EivYV;E2ExvYM;IAOI,yBAAA;E3EovYV;E2E3vYM;IAOI,0BAAA;E3EuvYV;E2E9vYM;IAOI,uBAAA;E3E0vYV;E2EjwYM;IAOI,yBAAA;E3E6vYV;E2EpwYM;IAOI,uBAAA;E3EgwYV;E2EvwYM;IAOI,yBAAA;E3EmwYV;E2E1wYM;IAOI,uBAAA;E3EswYV;E2E7wYM;IAOI,uBAAA;E3EywYV;E2EhxYM;IAOI,0BAAA;IAAA,yBAAA;E3E6wYV;E2EpxYM;IAOI,gCAAA;IAAA,+BAAA;E3EixYV;E2ExxYM;IAOI,+BAAA;IAAA,8BAAA;E3EqxYV;E2E5xYM;IAOI,gCAAA;IAAA,+BAAA;E3EyxYV;E2EhyYM;IAOI,6BAAA;IAAA,4BAAA;E3E6xYV;E2EpyYM;IAOI,+BAAA;IAAA,8BAAA;E3EiyYV;E2ExyYM;IAOI,6BAAA;IAAA,4BAAA;E3EqyYV;E2E5yYM;IAOI,+BAAA;IAAA,8BAAA;E3EyyYV;E2EhzYM;IAOI,6BAAA;IAAA,4BAAA;E3E6yYV;E2EpzYM;IAOI,6BAAA;IAAA,4BAAA;E3EizYV;E2ExzYM;IAOI,wBAAA;IAAA,2BAAA;E3EqzYV;E2E5zYM;IAOI,8BAAA;IAAA,iCAAA;E3EyzYV;E2Eh0YM;IAOI,6BAAA;IAAA,gCAAA;E3E6zYV;E2Ep0YM;IAOI,8BAAA;IAAA,iCAAA;E3Ei0YV;E2Ex0YM;IAOI,2BAAA;IAAA,8BAAA;E3Eq0YV;E2E50YM;IAOI,6BAAA;IAAA,gCAAA;E3Ey0YV;E2Eh1YM;IAOI,2BAAA;IAAA,8BAAA;E3E60YV;E2Ep1YM;IAOI,6BAAA;IAAA,gCAAA;E3Ei1YV;E2Ex1YM;IAOI,2BAAA;IAAA,8BAAA;E3Eq1YV;E2E51YM;IAOI,2BAAA;IAAA,8BAAA;E3Ey1YV;E2Eh2YM;IAOI,wBAAA;E3E41YV;E2En2YM;IAOI,8BAAA;E3E+1YV;E2Et2YM;IAOI,6BAAA;E3Ek2YV;E2Ez2YM;IAOI,8BAAA;E3Eq2YV;E2E52YM;IAOI,2BAAA;E3Ew2YV;E2E/2YM;IAOI,6BAAA;E3E22YV;E2El3YM;IAOI,2BAAA;E3E82YV;E2Er3YM;IAOI,6BAAA;E3Ei3YV;E2Ex3YM;IAOI,2BAAA;E3Eo3YV;E2E33YM;IAOI,2BAAA;E3Eu3YV;E2E93YM;IAOI,0BAAA;E3E03YV;E2Ej4YM;IAOI,gCAAA;E3E63YV;E2Ep4YM;IAOI,+BAAA;E3Eg4YV;E2Ev4YM;IAOI,gCAAA;E3Em4YV;E2E14YM;IAOI,6BAAA;E3Es4YV;E2E74YM;IAOI,+BAAA;E3Ey4YV;E2Eh5YM;IAOI,6BAAA;E3E44YV;E2En5YM;IAOI,+BAAA;E3E+4YV;E2Et5YM;IAOI,6BAAA;E3Ek5YV;E2Ez5YM;IAOI,6BAAA;E3Eq5YV;E2E55YM;IAOI,2BAAA;E3Ew5YV;E2E/5YM;IAOI,iCAAA;E3E25YV;E2El6YM;IAOI,gCAAA;E3E85YV;E2Er6YM;IAOI,iCAAA;E3Ei6YV;E2Ex6YM;IAOI,8BAAA;E3Eo6YV;E2E36YM;IAOI,gCAAA;E3Eu6YV;E2E96YM;IAOI,8BAAA;E3E06YV;E2Ej7YM;IAOI,gCAAA;E3E66YV;E2Ep7YM;IAOI,8BAAA;E3Eg7YV;E2Ev7YM;IAOI,8BAAA;E3Em7YV;E2E17YM;IAOI,yBAAA;E3Es7YV;E2E77YM;IAOI,+BAAA;E3Ey7YV;E2Eh8YM;IAOI,8BAAA;E3E47YV;E2En8YM;IAOI,+BAAA;E3E+7YV;E2Et8YM;IAOI,4BAAA;E3Ek8YV;E2Ez8YM;IAOI,8BAAA;E3Eq8YV;E2E58YM;IAOI,4BAAA;E3Ew8YV;E2E/8YM;IAOI,8BAAA;E3E28YV;E2El9YM;IAOI,4BAAA;E3E88YV;E2Er9YM;IAOI,4BAAA;E3Ei9YV;E2Ex9YM;IAOI,qBAAA;E3Eo9YV;E2E39YM;IAOI,2BAAA;E3Eu9YV;E2E99YM;IAOI,0BAAA;E3E09YV;E2Ej+YM;IAOI,2BAAA;E3E69YV;E2Ep+YM;IAOI,wBAAA;E3Eg+YV;E2Ev+YM;IAOI,0BAAA;E3Em+YV;E2E1+YM;IAOI,wBAAA;E3Es+YV;E2E7+YM;IAOI,0BAAA;E3Ey+YV;E2Eh/YM;IAOI,wBAAA;E3E4+YV;E2En/YM;IAOI,2BAAA;IAAA,0BAAA;E3Eg/YV;E2Ev/YM;IAOI,iCAAA;IAAA,gCAAA;E3Eo/YV;E2E3/YM;IAOI,gCAAA;IAAA,+BAAA;E3Ew/YV;E2E//YM;IAOI,iCAAA;IAAA,gCAAA;E3E4/YV;E2EngZM;IAOI,8BAAA;IAAA,6BAAA;E3EggZV;E2EvgZM;IAOI,gCAAA;IAAA,+BAAA;E3EogZV;E2E3gZM;IAOI,8BAAA;IAAA,6BAAA;E3EwgZV;E2E/gZM;IAOI,gCAAA;IAAA,+BAAA;E3E4gZV;E2EnhZM;IAOI,8BAAA;IAAA,6BAAA;E3EghZV;E2EvhZM;IAOI,yBAAA;IAAA,4BAAA;E3EohZV;E2E3hZM;IAOI,+BAAA;IAAA,kCAAA;E3EwhZV;E2E/hZM;IAOI,8BAAA;IAAA,iCAAA;E3E4hZV;E2EniZM;IAOI,+BAAA;IAAA,kCAAA;E3EgiZV;E2EviZM;IAOI,4BAAA;IAAA,+BAAA;E3EoiZV;E2E3iZM;IAOI,8BAAA;IAAA,iCAAA;E3EwiZV;E2E/iZM;IAOI,4BAAA;IAAA,+BAAA;E3E4iZV;E2EnjZM;IAOI,8BAAA;IAAA,iCAAA;E3EgjZV;E2EvjZM;IAOI,4BAAA;IAAA,+BAAA;E3EojZV;E2E3jZM;IAOI,yBAAA;E3EujZV;E2E9jZM;IAOI,+BAAA;E3E0jZV;E2EjkZM;IAOI,8BAAA;E3E6jZV;E2EpkZM;IAOI,+BAAA;E3EgkZV;E2EvkZM;IAOI,4BAAA;E3EmkZV;E2E1kZM;IAOI,8BAAA;E3EskZV;E2E7kZM;IAOI,4BAAA;E3EykZV;E2EhlZM;IAOI,8BAAA;E3E4kZV;E2EnlZM;IAOI,4BAAA;E3E+kZV;E2EtlZM;IAOI,2BAAA;E3EklZV;E2EzlZM;IAOI,iCAAA;E3EqlZV;E2E5lZM;IAOI,gCAAA;E3EwlZV;E2E/lZM;IAOI,iCAAA;E3E2lZV;E2ElmZM;IAOI,8BAAA;E3E8lZV;E2ErmZM;IAOI,gCAAA;E3EimZV;E2ExmZM;IAOI,8BAAA;E3EomZV;E2E3mZM;IAOI,gCAAA;E3EumZV;E2E9mZM;IAOI,8BAAA;E3E0mZV;E2EjnZM;IAOI,4BAAA;E3E6mZV;E2EpnZM;IAOI,kCAAA;E3EgnZV;E2EvnZM;IAOI,iCAAA;E3EmnZV;E2E1nZM;IAOI,kCAAA;E3EsnZV;E2E7nZM;IAOI,+BAAA;E3EynZV;E2EhoZM;IAOI,iCAAA;E3E4nZV;E2EnoZM;IAOI,+BAAA;E3E+nZV;E2EtoZM;IAOI,iCAAA;E3EkoZV;E2EzoZM;IAOI,+BAAA;E3EqoZV;E2E5oZM;IAOI,0BAAA;E3EwoZV;E2E/oZM;IAOI,gCAAA;E3E2oZV;E2ElpZM;IAOI,+BAAA;E3E8oZV;E2ErpZM;IAOI,gCAAA;E3EipZV;E2ExpZM;IAOI,6BAAA;E3EopZV;E2E3pZM;IAOI,+BAAA;E3EupZV;E2E9pZM;IAOI,6BAAA;E3E0pZV;E2EjqZM;IAOI,+BAAA;E3E6pZV;E2EpqZM;IAOI,6BAAA;E3EgqZV;E2EvqZM;IAOI,iBAAA;E3EmqZV;E2E1qZM;IAOI,uBAAA;E3EsqZV;E2E7qZM;IAOI,sBAAA;E3EyqZV;E2EhrZM;IAOI,uBAAA;E3E4qZV;E2EnrZM;IAOI,oBAAA;E3E+qZV;E2EtrZM;IAOI,sBAAA;E3EkrZV;E2EzrZM;IAOI,oBAAA;E3EqrZV;E2E5rZM;IAOI,sBAAA;E3EwrZV;E2E/rZM;IAOI,oBAAA;E3E2rZV;E2ElsZM;IAOI,qBAAA;E3E8rZV;E2ErsZM;IAOI,2BAAA;E3EisZV;E2ExsZM;IAOI,0BAAA;E3EosZV;E2E3sZM;IAOI,2BAAA;E3EusZV;E2E9sZM;IAOI,wBAAA;E3E0sZV;E2EjtZM;IAOI,0BAAA;E3E6sZV;E2EptZM;IAOI,wBAAA;E3EgtZV;E2EvtZM;IAOI,0BAAA;E3EmtZV;E2E1tZM;IAOI,wBAAA;E3EstZV;E2E7tZM;IAOI,wBAAA;E3EytZV;E2EhuZM;IAOI,8BAAA;E3E4tZV;E2EnuZM;IAOI,6BAAA;E3E+tZV;E2EtuZM;IAOI,8BAAA;E3EkuZV;E2EzuZM;IAOI,2BAAA;E3EquZV;E2E5uZM;IAOI,6BAAA;E3EwuZV;E2E/uZM;IAOI,2BAAA;E3E2uZV;E2ElvZM;IAOI,6BAAA;E3E8uZV;E2ErvZM;IAOI,2BAAA;E3EivZV;E2ExvZM;IAOI,2BAAA;E3EovZV;E2E3vZM;IAOI,4BAAA;E3EuvZV;E2E9vZM;IAOI,6BAAA;E3E0vZV;AACF;A4EjzZA;ED+CQ;IAOI,0BAAA;E3E+vZV;E2EtwZM;IAOI,6BAAA;E3EkwZV;E2EzwZM;IAOI,6BAAA;E3EqwZV;E2E5wZM;IAOI,6BAAA;E3EwwZV;AACF;A4E5yZA;ED4BQ;IAOI,0BAAA;E3E6wZV;E2EpxZM;IAOI,gCAAA;E3EgxZV;E2EvxZM;IAOI,yBAAA;E3EmxZV;E2E1xZM;IAOI,wBAAA;E3EsxZV;E2E7xZM;IAOI,+BAAA;E3EyxZV;E2EhyZM;IAOI,yBAAA;E3E4xZV;E2EnyZM;IAOI,6BAAA;E3E+xZV;E2EtyZM;IAOI,8BAAA;E3EkyZV;E2EzyZM;IAOI,wBAAA;E3EqyZV;E2E5yZM;IAOI,+BAAA;E3EwyZV;E2E/yZM;IAOI,wBAAA;E3E2yZV;AACF;A6E7rZA;;0DAAA;AC5KA;EACE,eDQe;ECPf,YAAA;EACA,uBAAA;A9E82ZF;A8E72ZE;EACE,YAAA;EACA,yBrELM;EqEMN,cDGa;ECqLb;;OAAA;A9E0rZJ;A8Ej3ZI;EACE,UAAA;EACA,kBAAA;EACA,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,kBDmDgB;A7Eg0ZtB;A8El3ZM;EACE,gBAAA;A9Eo3ZR;A8El3ZU;EACE,WAAA;EACA,UAAA;A9Eo3ZZ;A8En3ZY;EACE,+GAAA;A9Eq3Zd;A8E52ZQ;EACE,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A9E82ZV;A8E72ZU;EACE,WAAA;A9E+2ZZ;A8E52ZQ;EACE,yBAAA;EACA,oCAAA;EAEA,aAAA;EACA,kBAAA;A9E62ZV;A8E52ZU;EACE,aAAA;EACA,2BAAA;A9E82ZZ;A8E12ZM;EACE,uCAAA;EACA,gBAAA;EACA,iCAAA;A9E42ZR;A8E32ZQ;EACE,gBAAA;EACA,crE7DC;EqE8DD,kBrErCD;ATk5ZT;A8Ez2ZY;EACE,aAAA;A9E22Zd;A8Ex2ZU;EACE,eAAA;A9E02ZZ;A8El2ZQ;EACE,aAAA;A9Eo2ZV;A8El2ZQ;EACE,eAAA;EACA,aAAA;EACA,8BAAA;A9Eo2ZV;A8El2ZQ;EACE,UAAA;EACA,kBAAA;A9Eo2ZV;A8E51ZQ;EACE,aAAA;A9E81ZV;A8E51ZQ;EACE,oBAAA;EACA,qBAAA;A9E81ZV;A8E51ZQ;EACE,eAAA;EACA,aAAA;EACA,iBAAA;A9E81ZV;A8E51ZQ;EACE,gBAAA;A9E81ZV;A8Et1ZQ;EACE,UAAA;EACA,WAAA;A9Ew1ZV;A8En1ZU;EACE,aAAA;A9Eq1ZZ;A8En1ZU;EACE,oBAAA;EACA,mBAAA;A9Eq1ZZ;A8En1ZU;EACE,eAAA;EACA,mBAAA;A9Eq1ZZ;A8E50ZM;;EACE,oBAAA;EACA,mBAAA;A9E+0ZR;A8Ex0ZM;;EACE,mBAAA;A9E20ZR;A8Ez0ZM;;EACE,eAAA;EACA,aAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;EACA,gBrEtKA;EqEuKA,4CAAA;A9E40ZR;A8Ex0ZI;EACE,WAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,aAAA;EACA,aAAA;A9E00ZN;A8Et0ZI;EACE,mBAAA;A9Ew0ZN;A8Er0ZI;EACE,4EAAA;EAEA,sBAAA;A9Es0ZN;A8E9zZM;EACE,cAAA;A9Eg0ZR;A8E9zZQ;EACE,iBAAA;EACA,kBAAA;A9Eg0ZV;A8E5zZM;EACE,qBAAA;EACA,aAAA;A9E8zZR;A8E5zZQ;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;A9E8zZV;A8ExzZM;;EAEE,2BAAA;A9E0zZR;A8ErzZI;EACE,mBrEnNC;AT0gaP;;A8ElzZA;EACE,gBAAA;A9EqzZF;;A8ElzZA;;CAAA;A7D1LI;E6DiMA;IACE,yBAAA;IACA,YAAA;E9EkzZJ;E8EhzZE;IACE,yBAAA;IACA,WAAA;E9EkzZJ;E8E/yZE;IACE,WAAA;E9EizZJ;E8EhzZI;IACE,YAAA;IACA,mBAAA;E9EkzZN;E8EjzZM;IACE,iCAAA;E9EmzZR;E8EhzZI;IACE,WAAA;IACA,oBAAA;E9EkzZN;E8EjzZM;IACE,kCAAA;E9EmzZR;E8E9yZA;IACE,uBAAA;IACA,mBAAA;IACA,uBAAA;IACA,gBAAA;E9EgzZF;E8E5yZE;IACE,WAAA;E9E8yZJ;AACF;A8E1yZA;EACE,2BAAA;EACA,kCAAA;EACA,8BAAA;A9E4yZF;;A8ExyZE;EACE,oDAAA;A9E2yZJ;;A8EhyZU;EACE,kBAAA;EACA,qBAAA;A9EmyZZ;;A8E1xZA;EACE;IACE,WAAA;E9E6xZF;E8E5xZE;IACE,YAAA;IACA,gBAAA;IACA,kBAAA;E9E8xZJ;AACF;A8ErxZU;EACE,gCAAA;A9EuxZZ;A8ErxZU;EACE,UAAA;A9EuxZZ;A8EhxZI;EACE,WAAA;EACA,iDAAA;A9EkxZN;A8EjxZM;;;;;EAKE,aAAA;A9EmxZR;A8EhxZI;EACE,iBAAA;A9EkxZN;A8EjxZM;EACE,iCAAA;A9EmxZR;A8EhxZI;EACE,iBAAA;A9EkxZN;;A8E7wZA;EAEI;IACE,cAAA;E9E+wZJ;E8E9wZI;IACE,qCAAA;E9EgxZN;E8E7wZE;IACE,cAAA;E9E+wZJ;E8E5wZI;IACE,cAAA;E9E8wZN;AACF;A8EzwZA;EAGM;IACE,qCAAA;E9EywZN;AACF;A+E1paA;;;;;;;;2FAAA;AAgBA;EACI,kBAAA;EACA,WAAA;A/EqpaJ;AiBxmaI;E8D/CJ;IAOQ,mBAAA;E/EopaN;AACF;;A+EjpaA;EACI,eAAA;EACA,YAAA;EACA,gBAAA;A/EopaJ;;A+EjpaA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,oCAAA;EACA,YAAA;EACA,aAAA;A/EopaJ;;A+EjpaA;EACI,YAAA;EACA,WAAA;EACA,eAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;A/EopaJ;;AiBvoaI;E8DTA;IACI,WAAA;E/EopaN;E+ElpaE;IACI,YAAA;E/EopaN;AACF;AgFnsaE;EACE,oBAAA;AhFqsaJ;AgFlsaI;EACE,gBAAA;AhFosaN;AgFhsaM;EACE,mBAAA;AhFksaR;AgF/raI;EACE,wBAAA;AhFisaN;AgF5raE;EACE,gDAAA;AhF8raJ;AgF5raE;EACE,6BAAA;AhF8raJ;;AgFvraE;EACE,gBvE/BI;EuEgCJ,gDAAA;AhF0raJ;AgFvraE;EACE,mBvE7BO;EuE8BP,WvErCI;AT8taR;;AgFpraA;EACE,eAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;AhFuraF;;AiBlraI;E+DDF;IACE,kBAAA;EhFuraF;AACF;AiFvvaA;;;;;;;;2FAAA;AAeA;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,uDAAA;AjFmvaF;AiFlvaE;ECkEA,czERW;EyESX,gBzE9EM;ATiwaR;AkFjraE;EACE,aAAA;AlFmraJ;AkFlraI;EACE,oCAAA;EACA,oBAAA;EACA,4BAhCwB;AlFota9B;AkFnraM;EACE,yCAAA;AlFqraR;AkFjraE;EACE,gBzE5FI;AT+waR;AkFlraI;EACE,qCAAA;EACA,6CAAA;EACA,UAAA;EACA,gBAAA;EACA,uBAAA;AlForaN;AkFnraM;EACE,gBAAA;AlFqraR;AkFjraM;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AlFmraR;AkFlraQ;EACE,YAAA;AlForaV;AkFhraQ;EACE,YAAA;EACA,wBAAA;EACA,6BAAA;AlFkraV;AkF/qaM;EACE,kCAAA;EACA,kBL/DO;EKgEP,iBAAA;EACA,4CAAA;AlFiraR;AkF/qaQ;EACE,+BAAA;AlFiraV;AkF/qaQ;EACE,0CAAA;AlFiraV;AkF7qaQ;EACE,kBAAA;EACA,4CAAA;AlF+qaV;AkF1qaI;EACE,eAAA;AlF4qaN;AkF1qaQ;EACE,eAAA;EACA,iBAAA;AlF4qaV;AkF1qaQ;EACE,kBAAA;EACA,QAAA;AlF4qaV;AkFrqaQ;;;EACE,4BAvGmB;EAwGnB,oCArGqB;EAsGrB,mCAAA;EACA,kBAAA;EACA,kBAAA;AlFyqaV;AkFrqaY;;;EACE,wBAAA;AlFyqad;AkFlqaQ;EACE,aAAA;AlFoqaV;AkFhqaQ;EACE,WzEpLF;EyEqLE,gBAAA;EACA,kBAAA;AlFkqaV;AkF9paM;EACE,oCAlIwB;AlFkyahC;AkF9paQ;EACE,czE7KH;EyE8KG,gBAAA;AlFgqaV;AkF3paU;EACE,oCApIqB;AlFiyajC;AkFxpaM;EACE,UAAA;EACA,SAAA;AlF0paR;AkFvpaQ;EACE,czE3IG;EyE4IH,uBAAA;AlFypaV;AkFxpaU;EACE,4BLvJgB;A7Eiza5B;AkFrpaY;EACE,aAAA;AlFupad;AkFjpaU;;EACE,czE3JC;AT+yab;AkFjpaU;;EACE,cAAA;AlFopaZ;AkFjpac;;EACE,cAAA;AlFopahB;AkF5oaU;EACE,+BA3KkB;AlFyza9B;AkF1oaQ;EACE,sEAAA;EAKA,iDAAA;EACA,kBAAA;AlFwoaV;AkFvoaU;EACE,WzE9PJ;ATu4aR;AkFnoaM;EACE,gBzErQA;AT04aR;AkF/naE;EACE,gBzE5QI;AT64aR;AkF/naM;EACE,czE1MK;AT20ab;AkFhoaQ;EACE,+BAAA;AlFkoaV;AkF5naQ;EACE,oCA/NsB;AlF61ahC;AkFvnaQ;EACE,aAAA;AlFynaV;AkFpnaM;EACE,czEjOK;ATu1ab;AkFnnaM;EACE,cAAA;AlFqnaR;AkFnnaQ;EACE,uCAAA;AlFqnaV;AkFpnaU;EACE,cAAA;EACA,uCAAA;AlFsnaZ;AkF9maM;EACE,+BAnPsB;EAoPtB,0CArPmB;AlFq2a3B;AkF5maI;EACE,+BAxPsB;AlFs2a5B;AkF5maM;EACE,+BAtQmB;EAuQnB,0CAtQgB;AlFo3axB;AkFzmaQ;;EACE,6BAAA;AlF4maV;AiFt6aE;EC8DA,cLrBgB;EKsBhB,mBLrBmB;A7Eg4arB;AkFz2aE;EACE,aAAA;AlF22aJ;AkF12aI;EACE,wDAAA;EACA,oBAAA;EACA,+BAhCwB;AlF44a9B;AkF32aM;EACE,mBAAA;AlF62aR;AkFz2aE;EACE,mBLnCiB;A7E84arB;AkF12aI;EACE,YAAA;EACA,6CAAA;EACA,UAAA;EACA,gBAAA;EACA,uBAAA;AlF42aN;AkF32aM;EACE,gBAAA;AlF62aR;AkFz2aM;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AlF22aR;AkF12aQ;EACE,YAAA;AlF42aV;AkFx2aQ;EACE,YAAA;EACA,wBAAA;EACA,6BAAA;AlF02aV;AkFv2aM;EACE,qCAAA;EACA,kBL/DO;EKgEP,iBAAA;EACA,4CAAA;AlFy2aR;AkFv2aQ;EACE,YAAA;AlFy2aV;AkFv2aQ;EACE,0CAAA;AlFy2aV;AkFr2aQ;EACE,kBAAA;EACA,4CAAA;AlFu2aV;AkFl2aI;EACE,eAAA;AlFo2aN;AkFl2aQ;EACE,eAAA;EACA,iBAAA;AlFo2aV;AkFl2aQ;EACE,kBAAA;EACA,QAAA;AlFo2aV;AkF71aQ;;;EACE,+BAvGmB;EAwGnB,4DArGqB;EAsGrB,mCAAA;EACA,kBAAA;EACA,kBAAA;AlFi2aV;AkF71aY;;;EACE,wBAAA;AlFi2ad;AkF11aQ;EACE,aAAA;AlF41aV;AkFx1aQ;EACE,WzEpLF;EyEqLE,gBAAA;EACA,kBAAA;AlF01aV;AkFt1aM;EACE,2DAlIwB;AlF09ahC;AkFt1aQ;EACE,czE7KH;EyE8KG,gBAAA;AlFw1aV;AkFn1aU;EACE,4DApIqB;AlFy9ajC;AkFh1aM;EACE,UAAA;EACA,SAAA;AlFk1aR;AkF/0aQ;EACE,cLxJQ;EKyJR,uBAAA;AlFi1aV;AkFh1aU;EACE,4BLvJgB;A7Ey+a5B;AkF70aY;EACE,aAAA;AlF+0ad;AkFz0aU;;EACE,cLxKM;A7Eo/alB;AkFz0aU;;EACE,cAAA;AlF40aZ;AkFz0ac;;EACE,cAAA;AlF40ahB;AkFp0aU;EACE,+BA3KkB;AlFi/a9B;AkFl0aQ;EACE,sEAAA;EAKA,iDAAA;EACA,kBAAA;AlFg0aV;AkF/zaU;EACE,WzE9PJ;AT+jbR;AkF3zaM;EACE,mBL5Ma;A7EygbrB;AkFvzaE;EACE,mBLnNiB;A7E4gbrB;AkFvzaM;EACE,cLvNU;A7EghblB;AkFxzaQ;EACE,YAAA;AlF0zaV;AkFpzaQ;EACE,2DA/NsB;AlFqhbhC;AkF/yaQ;EACE,aAAA;AlFizaV;AkF5yaM;EACE,cL9OU;A7E4hblB;AkF3yaM;EACE,cAAA;AlF6yaR;AkF3yaQ;EACE,0DAAA;AlF6yaV;AkF5yaU;EACE,cAAA;EACA,0DAAA;AlF8yaZ;AkFtyaM;EACE,+BAnPsB;EAoPtB,kEArPmB;AlF6hb3B;AkFpyaI;EACE,+BAxPsB;AlF8hb5B;AkFpyaM;EACE,+BAtQmB;EAuQnB,kEAtQgB;AlF4ibxB;AkFjyaQ;;EACE,6BAAA;AlFoyaV;AiF1lbE;EACE,eAAA;EACA,uBAAA;AjF4lbJ;AiF1lbI;EACE,eAAA;AjF4lbN;AiFzlbE;EACE,YAAA;EACA,kCAAA;AjF2lbJ;AiF1lbI;EACE,wBAAA;AjF4lbN;AiFxlbE;EACE,0CAAA;AjF0lbJ;AiFvlbE;EACE,+BAAA;AjFylbJ;AiFrlbE;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,wFAAA;AjFulbJ;AiF9kbI;EACE,kBAAA;AjFglbN;AiF5kbE;EACE,YAAA;EACA,YJJkB;EIKlB,YJpCY;EIqCZ,kBAAA;EACA,oCAAA;EACA,0BAAA;AjF8kbJ;AiF7kbI;EAEE,aAAA;EACA,mBAAA;EACA,mBAAA;AjF8kbN;AiF7kbM;EACE,8DAAA;EACA,gCAAA;EACA,YAAA;EACA,WAAA;AjF+kbR;AiF5kbM;EACE,cxEtED;EwEuEC,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,4EAAA;AjF8kbR;AiF1kbI;EACE,4EAAA;AjF4kbN;AiFvkbE;EACE,oCAAA;EACA,kBAAA;EACA,0BAAA;AjFykbJ;AiFvkbI;EAEE,wCAAA;AjFwkbN;AiFpkbE;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AjFskbJ;AiFpkbI;EACE,kBAAA;AjFskbN;AiFrkbM;EACE,kBAAA;AjFukbR;AiFpkbQ;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;AjFskbV;AiFpkbQ;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,0BAAA;AjFskbV;AiFhkbE;EACE,aAAA;AjFkkbJ;AiFhkbI;EAEE,qBAAA;AjFikbN;AiF7jbE;EACE,4BAAA;EACA,qDAAA;AjF+jbJ;AiF7jbE;EACE,qDAAA;AjF+jbJ;;AiFzjbA;EACE,iBAAA;EACA,kDxEzDsB;EwE0DtB,gBAAA;EACA,kBAAA;EACA,oBAAA;AjF4jbF;AiF1jbE;EACE,kDxE/DoB;EwEgEpB,gBxE/CmB;EwEgDnB,gBzE2d0B;EyE1d1B,kBAAA;EACA,iBAAA;EACA,yBAAA;AjF4jbJ;AiFzjbE;EACE,kBAAA;EACA,mBAAA;AjF2jbJ;AiFzjbI;EACE,cAAA;EACA,uBAAA;EACA,gBAAA;AjF2jbN;AiFxjbI;EACE,oBAAA;EACA,mBAAA;AjF0jbN;AiFrjbM;EACE,sEAAA;EAKA,4DAAA;AjFmjbR;AiF/ibM;EACE,sEAAA;EAKA,4DAAA;AjF6ibR;;AiFnibM;EACE,mBAAA;AjFsibR;;AiF/hbE;EACE,kBAAA;AjFkibJ;AiFhibE;EACE,sBAAA;EACA,kBAAA;EACA,cxEnKS;ATqsbb;AiFhibE;EACE,gCAAA;AjFkibJ;AiF/hbE;EACE,kBAAA;EACA,SAAA;AjFiibJ;AiF/hbE;EACE,WAAA;EACA,UAAA;AjFiibJ;AiFhibI;EACE,mBxErOC;EwEsOD,qBxEtOC;ATwwbP;AiF/hbE;EACE,2BxE7DqB;EwE8DrB,4BxE9DqB;EwE+DrB,mBxE5OG;EwE6OH,WxE9PI;EwE+PJ,kBAAA;AjFiibJ;AiFhibI;EACE,sBAAA;AjFkibN;;AiFthbM;;;;EACE,2CAAA;AjF4hbR;AiFrhbM;;;;EACE,4CAAA;AjF0hbR;AiFnhbM;;;;EACE,2CAAA;AjFwhbR;AiFjhbM;;;;EACE,2CAAA;AjFshbR;AiF/gbM;;;;EACE,4CAAA;AjFohbR;AiF7gbM;;;;EACE,2CAAA;AjFkhbR;;AiFzgbE;EACE,aAAA;AjF4gbJ;AiF1gbI;EACE,iBAAA;AjF4gbN;AiFzgbI;EACE,sBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,+BAAA;AjF2gbN;;AiFpgbA;EACE,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;EACA,4DAAA;AjFugbF;AiFrgbE;EACE,iBAAA;EACA,uCAAA;AjFugbJ;AiFpgbE;EACE,YAAA;AjFsgbJ;AiFpgbI;EAEE,WxErWE;AT02bR;AiFjgbE;EACE,YAAA;EACA,oEAAA;AjFmgbJ;AiFhgbE;EACE,uBAAA;AjFmgbJ;AiF//aE;EACE,UAAA;AjFigbJ;AiF9/aM;EACE,cAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,iEAAA;EACA,kEAAA;AjFggbR;AiF9/aQ;EACE,kBAAA;AjFggbV;AiF7/aQ;EAEE,WxEvYF;ATq4bR;;AiFr/aI;EACE,cAAA;AjFw/aN;;AiF/+aE;EACE,kCAAA;AjFk/aJ;;AiB70bI;EgEmWF;;IAEE,oDAAA;EjF8+aF;EiF3+aA;IACE,2BAAA;IACA,iBAAA;EjF6+aF;EiF5+aE;IACE,yBAAA;IACA,qDAAA;EjF8+aJ;EiF1+aA;IACE,+BAAA;EjF4+aF;AACF;AiB52bI;EgEoYF;IACE,UAAA;EjF2+aF;AACF;AiFp+aM;EACE,YAAA;AjFs+aR;;AiF/9aA;EAGM;IACE,oBAAA;EjFg+aN;AACF;AmFz7bA;;;;;;;;;2FAAA;ANwLA;;0DAAA;AM1JI;EACE,oBAAA;AnF06bN;AmFt6bE;EACE,cAAA;AnFw6bJ;AmFv6bI;EACE,wBAAA;EACA,kCAAA;AnFy6bN;AmFt6bE;EACE,gBAAA;EACA,cAAA;AnFw6bJ;AmFp6bI;EACE,OAAA;AnFs6bN;AmFp6bI;EACE,8DAAA;EACA,gCAAA;EACA,YAAA;EACA,WAAA;AnFs6bN;AmFj6bQ;EACE,iBAAA;AnFm6bV;AmFh6bU;EACE,kBAAA;AnFk6bZ;AmF35bE;EACE,cAAA;AnF65bJ;AmF35bM;EACE,sEAAA;EAKA,oDAAA;EACA,sBAAA;EACA,kBAAA;AnFy5bR;AmFv5bU;EACE,yB1EzEF;ATk+bV;AmFn5bM;EACE,iBAAA;AnFq5bR;AmFl5bI;EACE,6BAAA;EACA,8BAAA;AnFo5bN;AmFn5bM;EACE,c1EnBK;E0EoBL,mCAAA;AnFq5bR;AmFl5bI;EACE,qBAAA;EACA,wBAAA;AnFo5bN;AmFn5bM;EACE,wBAAA;AnFq5bR;AmFl5bI;EACE,c1E/BO;ATm7bb;AmFn5bM;EACE,sBAAA;AnFq5bR;AmFh5bM;EACE,sBAAA;AnFk5bR;AmF94bI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AnFg5bN;AmF74bI;EACE,cAAA;EACA,wBAAA;EACA,yBAAA;EACA,uBAAA;AnF+4bN;AmF74bQ;EACE,aAAA;AnF+4bV;AmF54bM;EACE,4CAAA;EACA,cAAA;AnF84bR;AmF74bQ;EACE,UAAA;AnF+4bV;AmF74bQ;EACE,6BAAA;EACA,4CAAA;EACA,6BAAA;EACA,c1ErEG;ATo9bb;AmF54bU;EACE,UAAA;AnF84bZ;AmF54bU;EACE,6BAAA;EACA,yB1EjJF;AT+hcV;AmF34bQ;EACE,mB1ErJA;ATkicV;AmF54bU;;EAEE,yBAAA;EACA,gBAAA;AnF84bZ;AmFv4bU;EACE,c1E7FC;E0E8FD,mBAAA;AnFy4bZ;AmFr4bM;EACE,eAAA;EACA,aAAA;EACA,mBAAA;AnFu4bR;AmFt4bQ;EACE,yBAAA;AnFw4bV;AmFr4bU;;EAEE,c1E5GC;ATm/bb;AmFp4bQ;EACE,UAAA;AnFs4bV;AmFr4bU;EACE,uBAAA;AnFu4bZ;AmFn4bM;EACE,UAAA;EACA,WAAA;AnFq4bR;AmFl4bM;EACE,mB1E7LG;E0E8LH,mBAAA;AnFo4bR;AmFj4bM;EACE,mB1ErME;E0EsMF,mBAAA;AnFm4bR;AmFh4bI;EACE,aAAA;EACA,oBAAA;EACA,mBAAA;AnFk4bN;AmFh4bI;EACE,mB1E/MI;E0EgNJ,kBAAA;AnFk4bN;AmFh4bI;EACE,eAAA;AnFk4bN;AmFh4bI;EACE,yB1EtNI;ATwlcV;AmF93bM;EAEE,WAAA;EACA,WAAA;AnF+3bR;AmFx3bM;EACE,oBAAA;AnF03bR;AmFv3bI;EACE,iIAAA;EAMA,2BAAA;AnFo3bN;AmFn3bM;EACE,uBAAA;AnFq3bR;AmFh3bI;EACE,8BAAA;AnFk3bN;AmFh3bI;EACE,2HAAA;AnFk3bN;AmF52bM;EACE,8BAAA;AnF82bR;AmF52bU;EACE,mBNrFM;A7Em8blB;AmFt2bI;EACE,mBAAA;AnFw2bN;AmFt2bI;EACE,yB1EhRI;E0EiRJ,gBAAA;AnFw2bN;AmFr2bM;EACE,OAAA;EACA,SAAA;EACA,sB1ExRA;AT+ncR;AmFl2bI;EACE,mBAAA;AnFo2bN;AmFl2bI;EACE,yB1EhSI;E0EiSJ,gBAAA;AnFo2bN;AmFn2bM;EACE,WAAA;AnFq2bR;AmFl2bI;EACE,kBAAA;AnFo2bN;AmFn2bM;EACE,gB1E1SA;AT+ocR;AmFp2bQ;EACE,gBAAA;EACA,gB1E7SF;E0E8SE,OAAA;AnFs2bV;AmF91bE;EACE,eAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AnFg2bJ;AmF91bM;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;AnFg2bR;AmF91bM;EACE,aAAA;AnFg2bR;AmF51bE;EACE,gB1ExUI;E0EyUJ,uBAAA;EACA,cAAA;AnF81bJ;AmF51bI;EACE,gDAAA;EACA,gB1E9UE;AT4qcR;AmF51bI;EACE,oBAAA;EACA,kCAAA;EACA,qB1EtPU;ATolchB;AmF51bI;EACE,eAAA;EACA,WAAA;AnF81bN;AmF31bM;EACE,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;AnF61bR;AmF51bQ;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AnF81bV;AmF11bU;EACE,W1ExWJ;E0EyWI,kBAAA;EACA,uBAAA;EACA,kBAAA;AnF41bZ;AmFp1bQ;EACE,YAAA;AnFs1bV;AmFn1bM;EACE,aAAA;AnFq1bR;AmFn1bM;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;AnFq1bR;AmFp1bQ;EACE,+BAAA;AnFs1bV;AmFr1bU;EACE,c1E1XD;ATitcX;AmFp1bQ;EACE,UAAA;EACA,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;EACA,2BAAA;AnFs1bV;AmFn1bQ;EACE,kBAAA;AnFq1bV;AmFn1bY;EACE,UAAA;EACA,WAAA;AnFq1bd;AmFl1bU;EACE,mB1ErZF;ATyucV;AmFl1bU;EACE,kBAAA;EACA,iBAAA;EACA,qBAAA;AnFo1bZ;AmFn1bY;EACE,6BAAA;AnFq1bd;AmF30bQ;EACE,aAAA;AnF60bV;AmFx0bE;EACE,oBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;AnF00bJ;AmFr0bM;EACE,gCAAA;EACA,yBAAA;AnFu0bR;AmFl0bE;EACE,kBAAA;AnFo0bJ;AmFn0bI;EACE,2BAAA;EACA,0CAAA;AnFq0bN;AmFl0bE;EAGE,2BAAA;EACA,0CAAA;AnFk0bJ;AmFh0bE;EACE,6BAAA;EACA,4CAAA;AnFk0bJ;AmFh0bE;EACE,6BAAA;EACA,4CAAA;AnFk0bJ;AmF/zbI;EACE,6BAAA;EACA,4CAAA;EACA,cAAA;AnFi0bN;AmF/zbI;EACE,2BAAA;EACA,0CAAA;AnFi0bN;AmF/zbI;EACE,6BAAA;EACA,4CAAA;AnFi0bN;;AiBhucI;EkEyaI;IACE,aAAA;EnF2zbR;EmFvzbE;IACE,gB1E/eE;ETwycN;EmFvzbE;IACE,gBAAA;EnFyzbJ;AACF;AmFrzbA;EAKU;IACE,eAAA;EnFmzbV;AACF;AmF5ybA;EACE;IACE,wBAAA;IACA,UAAA;EnF8ybF;EmF3ybA;IACE,2BAAA;IACA,UAAA;EnF6ybF;AACF;AoFxzcA;EACE,0BAAA;ApF0zcF;;AoFxzcA;EACE,yBAAA;ApF2zcF;;AoFzzcA;EACE,gCAAA;ApF4zcF;;AoF1zcA;EACE,wBAAA;ApF6zcF;;AoF3zcA;EACE,8BAAA;ApF8zcF;;AoFzzcA;EACE,MAAA;ApF4zcF;;AoF1zcA;EACE,QAAA;ApF6zcF;;AoF3zcA;EACE,SAAA;ApF8zcF;;AoF5zcA;EACE,OAAA;ApF+zcF;;AoF1zcA;EACE,qBAAA;ApF6zcF;;AoF3zcA;EACE,qBAAA;ApF8zcF;;AoF5zcA;EACE,qBAAA;ApF+zcF;;AoF7zcA;EACE,qBAAA;ApFg0cF;;AoF9zcA;EACE,qBAAA;ApFi0cF;;AoF/zcA;EACE,sBAAA;ApFk0cF;;AoFh0cA;EACE,sBAAA;ApFm0cF;;AoFj0cA;EACE,sBAAA;ApFo0cF;;AoFl0cA;EACE,sBAAA;ApFq0cF;;AoFj0cA;EACE,iBAAA;ApFo0cF;;AoFl0cA;EACE,oBAAA;ApFq0cF;;AoFn0cA;EACE,kBAAA;ApFs0cF;;AoFp0cA;EACE,mBAAA;ApFu0cF;;AoFn0cA;EACE,eAAA;ApFs0cF;;AoFp0cA;EACE,YAAA;ApFu0cF;;AoFr0cA;EACE,eAAA;ApFw0cF;;AoFt0cA;EACE,gBAAA;ApFy0cF;;AoFv0cA;EACE,mBAAA;ApF00cF;;AoFt0cA;EACE,gBAAA;ApFy0cF;;AoFv0cA;EACE,iBAAA;ApF00cF;;AoFx0cA;EACE,cAAA;ApF20cF;;AoFz0cA;EACE,gBAAA;ApF40cF;;AoF10cA;EACE,gBAAA;ApF60cF;;AoF30cA;EACE,gBAAA;ApF80cF;;AoF10cA;EACE,kBAAA;ApF60cF;;AoF30cA;EACE,kBAAA;ApF80cF;;AoF50cA;EACE,kBAAA;ApF+0cF;;AoF70cA;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;ApFg1cF;AoF/0cE;EACE,UAAA;EACA,iBAAA;ApFi1cJ;;AoFz0cA;EACE,iBAAA;ApF40cF;;AoF10cA;EACE,qBAAA;ApF60cF;;AoF30cA;EACE,wBAAA;ApF80cF;;AoF50cA;EACE,sBAAA;ApF+0cF;;AoF70cA;EACE,uBAAA;ApFg1cF;;AoF10cA;EACE,4BAAA;ApF60cF;;AoF30cA;EACE,gCAAA;ApF80cF;;AoF50cA;EACE,mCAAA;ApF+0cF;;AoF70cA;EACE,iCAAA;ApFg1cF;;AoF90cA;EACE,kCAAA;ApFi1cF;;AoF70cA;EACE,4BAAA;ApFg1cF;;AoF90cA;EACE,gCAAA;ApFi1cF;;AoF/0cA;EACE,mCAAA;ApFk1cF;;AoFh1cA;EACE,iCAAA;ApFm1cF;;AoFj1cA;EACE,kCAAA;ApFo1cF;;AoFh1cA;EACE,oCAAA;EACA,qCAAA;ApFm1cF;;AoFj1cA;EACE,uCAAA;EACA,wCAAA;ApFo1cF;;AoFl1cA;EACE,oCAAA;ApFq1cF;;AoFn1cA;EACE,qCAAA;ApFs1cF;;AoFp1cA;EACE,uCAAA;ApFu1cF;;AoFr1cA;EACE,wCAAA;ApFw1cF;;AoFn1cA;EACE,2BAAA;ApFs1cF;;AoFn1cA;EACE,6EAAA;ApFs1cF;;AoFl1cA;EACE,6EAAA;ApFq1cF;;AoFj1cA;EACE,gFAAA;ApFo1cF;;AoFh1cA;EACE,gFAAA;ApFm1cF;;AoF/0cA;EACE,+EAAA;ApFk1cF;;AoF90cA;EACE,4EAAA;ApFi1cF;;AoFt0cA;EACE,0BAAA;ApFy0cF;;AoFv0cA;EACE,qBAAA;ApF00cF;;AoFx0cA;EACE,sBAAA;ApF20cF;;AoFz0cA;EACE,uBAAA;ApF40cF;;AoFx0cA;EACE,sBAAA;ApF20cF;;AoFz0cA;EACE,uBAAA;ApF40cF;;AoF10cA;EACE,uBAAA;ApF60cF;;AoF30cA;EACE,uBAAA;ApF80cF;;AoF50cA;EACE,uBAAA;ApF+0cF;;AoF70cA;EACE,uBAAA;ApFg1cF;;AoF90cA;EACE,uBAAA;ApFi1cF;;AoF/0cA;EACE,uBAAA;ApFk1cF;;AoFh1cA;EACE,uBAAA;ApFm1cF;;AoFj1cA;EACE,uBAAA;ApFo1cF;;AoFl1cA;EACE,uBAAA;ApFq1cF;;AoFn1cA;EACE,uBAAA;ApFs1cF;;AoFp1cA;EACE,uBAAA;ApFu1cF;;AoFr1cA;EACE,uBAAA;ApFw1cF;;AoFt1cA;EACE,uBAAA;ApFy1cF;;AoFv1cA;EACE,uBAAA;ApF01cF;;AoFv1cA;EACE,oBAAA;ApF01cF;;AoFx1cA;EACE,qBAAA;ApF21cF;;AoFz1cA;EACE,qBAAA;ApF41cF;;AoF11cA;EACE,qBAAA;ApF61cF;;AoF31cA;EACE,qBAAA;ApF81cF;;AoF51cA;EACE,qBAAA;ApF+1cF;;AoF71cA;EACE,qBAAA;ApFg2cF;;AoF91cA;EACE,qBAAA;ApFi2cF;;AoF/1cA;EACE,qBAAA;ApFk2cF;;AoFh2cA;EACE,qBAAA;ApFm2cF;;AoFj2cA;EACE,qBAAA;ApFo2cF;;AoFl2cA;EACE,qBAAA;ApFq2cF;;AoFn2cA;EACE,qBAAA;ApFs2cF;;AoFp2cA;EACE,qBAAA;ApFu2cF;;AoFr2cA;EACE,qBAAA;ApFw2cF;;AoFt2cA;EACE,qBAAA;ApFy2cF;;AoFv2cA;EACE,qBAAA;ApF02cF;;AoFx2cA;EACE,qBAAA;ApF22cF;;AoFt2cA;EACE,uBAAA;ApFy2cF;;AoFv2cA;EACE,uBAAA;ApF02cF;;AoFx2cA;EACE,wBAAA;ApF22cF;;AoFz2cA;EACE,wBAAA;ApF42cF;;AoF12cA;EACE,wBAAA;ApF62cF;;AoF32cA;EACE,wBAAA;ApF82cF;;AoF52cA;EACE,wBAAA;ApF+2cF;;AoF72cA;EACE,wBAAA;ApFg3cF;;AoF92cA;EACE,wBAAA;ApFi3cF;;AoF/2cA;EACE,wBAAA;ApFk3cF;;AoFh3cA;EACE,wBAAA;ApFm3cF;;AoFj3cA;EACE,wBAAA;ApFo3cF;;AoFl3cA;EACE,wBAAA;ApFq3cF;;AoFn3cA;EACE,wBAAA;ApFs3cF;;AoFp3cA;EACE,wBAAA;ApFu3cF;;AoFr3cA;EACE,wBAAA;ApFw3cF;;AoFt3cA;EACE,wBAAA;ApFy3cF;;AoFp3cA;EACE,qBAAA;ApFu3cF;;AoFr3cA;EACE,sBAAA;ApFw3cF;;AoFt3cA;EACE,sBAAA;ApFy3cF;;AoFv3cA;EACE,sBAAA;ApF03cF;;AoFx3cA;EACE,sBAAA;ApF23cF;;AoFz3cA;EACE,sBAAA;ApF43cF;;AoF13cA;EACE,sBAAA;ApF63cF;;AoF33cA;EACE,sBAAA;ApF83cF;;AoF53cA;EACE,sBAAA;ApF+3cF;;AoF73cA;EACE,sBAAA;ApFg4cF;;AoF93cA;EACE,sBAAA;ApFi4cF;;AoF/3cA;EACE,sBAAA;ApFk4cF;;AoFh4cA;EACE,sBAAA;ApFm4cF;;AoFj4cA;EACE,sBAAA;ApFo4cF;;AoFl4cA;EACE,sBAAA;ApFq4cF;;AoFn4cA;EACE,sBAAA;ApFs4cF;;AoFl4cA;EACE,aAAA;ApFq4cF;;AoFj4cA;EACE,yBAAA;ApFo4cF;;AoFl4cA;EACE,yBAAA;ApFq4cF;;AoFh4cA;EACE,wBAAA;ApFm4cF;;AoFj4cA;EACE,yBAAA;ApFo4cF;;AoFl4cA;EACE,wBAAA;ApFq4cF;;AoFn4cA;EACE,yBAAA;ApFs4cF;;AoFp4cA;EACE,wBAAA;ApFu4cF;;AoFr4cA;EACE,yBAAA;ApFw4cF;;AoFp4cA;EACE,0BAAA;ApFu4cF;AoFr4cE;EACE,uCAAA;EACA,gDAAA;EACA,WAAA;ApFu4cJ;;AoFl4cA;EACE,qBAAA;EACA,kCAAA;ApFq4cF;;AoFn4cA;EACE;IACE,uBAAA;EpFs4cF;EoFp4cA;IACE,yBAAA;EpFs4cF;AACF;AoFn4cA;EACE,qBAAA;EACA,0CAAA;ApFq4cF;;AoFn4cA;EACE;IACE,uBAAA;EpFs4cF;EoFp4cA;IACE,0BAAA;EpFs4cF;AACF;AoF93cA;EACE,iCAAA;ApFg4cF;;AoF93cA;EACE,oCAAA;ApFi4cF;;AoF/3cA;EACE,uCAAA;ApFk4cF;;AoF93cA;EACE,sBAAA;EACA,uBAAA;ApFi4cF;;AoF73cA;EACE,sBAAA;EACA,uBAAA;ApFg4cF;;AoF53cA;EACE,sBAAA;EACA,uBAAA;ApF+3cF;;AoF33cA;EACE,sBAAA;EACA,uBAAA;ApF83cF;;AoF13cA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;ApF63cF;AoF53cE;EACE,aAAA;EACA,cAAA;ApF83cJ;AoF53cE;EACE,eAAA;EACA,gBAAA;ApF83cJ;AoF53cE;EACE,cAAA;EACA,eAAA;ApF83cJ;;AoFz3cA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;ApF43cF;AoF33cE;EACE,YAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;ApF63cJ;;AoFv3cE;EACE,2BAAA;ApF03cJ;;AqF9+dA;EACE,mBAAA;EACA,yBRee;EQdf,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,W5ETM;E4EUN,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;ArFi/dF;AqF9+dE;EACE,WR2DU;EQ1DV,YR0DU;EQzDV,aAAA;EACA,uBAAA;EACA,mBAAA;ArFg/dJ;AqF9+dM;EACE,aAAA;EACA,cAAA;ArFg/dR;AqF1+dI;EACE,YAAA;EACA,WAAA;ArF4+dN;AqFz+dE;EACE,kBAAA;EACA,WRuCiB;EQtCjB,YRsCiB;EQrCjB,kBAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;ArF2+dJ;AqF1+dI;EACE,WRiCkB;EQhClB,YRgCkB;EQ/BlB,iBAAA;ArF4+dN;AqFz+dE;EACE,yB5EpCI;AT+geR;AqFz+dE;EACE,yB5EzCE;AToheN;AqFz+dE;EACE,yB5E3CK;ATsheT;AqFz+dE;EACE,yB5EtDO;ATiieX;AqFv+dE;EAEE,kBAAA;ArFw+dJ;AqFl+dE;EACE,iBAAA;ArFo+dJ;AqFn+dI;EACE,WRKW;EQJX,YRIW;A7Ei+djB;AqFn+dI;EACE,YRCW;EQAX,WAAA;ArFq+dN;AqFn+dQ;EACE,WAAA;EACA,YAAA;ArFq+dV;AqFh+dE;EACE,iBAAA;ArFk+dJ;AqFj+dI;EACE,WRXW;EQYX,YRZW;A7E++djB;AqFj+dI;EACE,WRfW;EQgBX,YRhBW;A7Em/djB;AqFj+dQ;EACE,WAAA;EACA,YAAA;ArFm+dV;AqF59dI;EACE,WR3BW;EQ4BX,YR5BW;A7E0/djB;AqF59dQ;EACE,WAAA;EACA,YAAA;ArF89dV;AqF19dI;EACE,WRrCW;EQsCX,YRtCW;A7EkgejB;;AsFjmeA;;;;;;;;2FAAA;AAWE;EACE,WAAA;AtFkmeJ;AsFhmeE;EACE,WAAA;EAEA,QAAA;AtFimeJ;AsF/leI;EACE,QAAA;EACA,yBAAA;EACA,6BAAA;EACA,iBAAA;EACA,uBAAA;AtFimeN;AsFhmeM;EACE,qBAAA;EACA,4BAAA;AtFkmeR;AsF/leI;EACE,kBAAA;EACA,OAAA;EAGA,QAAA;EACA,WAAA;EACA,UAAA;EACA,qBAAA;AtF+leN;AsF9leM;;EAEE,cAAA;AtFgmeR;AsF7leM;EACE,WAAA;EAEA,aAAA;EACA,6BAAA;AtF8leR;AsF3leI;EACE,UAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AtF6leN;AsF3leI;EACE,UAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;AtF6leN;AsF3leI;EACE,sBAAA;EACA,sBAAA;AtF6leN;AsF3leI;EACE,gBAAA;AtF6leN;AsF5leM;EACE,WAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AtF8leR;AsF7leQ;EACE,yBAAA;AtF+leV;AsFzleE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;AtF2leJ;AsF1leI;EACE,cAAA;AtF4leN;AsF1leI;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;AtF4leN;AsF1leI;EACE,oCAAA;EACA,WAAA;EACA,gB7E1FE;E6E2FF,oCAAA;EACA,yCAAA;EACA,0CAAA;AtF4leN;AsF3leM;EACE,yBAAA;AtF6leR;AsFxleE;EACE,eAAA;AtF0leJ;AsFxleE;EACE,8BAAA;AtF0leJ;AsFzleI;EACE,aAAA;AtF2leN;;AsFvleA;;;;;;;;;;;;;GAAA;AAiBI;;EACE,cAAA;EACA,qBAAA;EACA,yBAAA;AtFwleN;AsFrleM;;EACE,cAAA;EACA,yBAAA;AtFwleR;;AiB/peI;EqEgFE;IACE,c7E1IG;ET6teT;AACF;AsF7keA;EAEI;IACE,UAAA;EtF8keJ;AACF;AuFlveE;EACE,yBAAA;AvFoveJ;AuFnveI;EACE,sBAAA;AvFqveN;AuF/ueM;EACE,c9EmEK;AT8qeb;;AuF1ueA;EACE,yBAAA;AvF6ueF;;AuFvueI;EACE,sBAAA;AvF0ueN;;AwFlweA;EACE,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AxFqweF;AwFpweE;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,cAjBa;EAkBb,mBAAA;EACA,e/EoGa;E+EnGb,kBAAA;EACA,0CAAA;AxFsweJ;;AwFjweA;EAEE,eAAA;EACA,cAAA;EACA,UAAA;AxFmweF;AwFlweE;EACE,YAAA;EACA,kBAAA;EACA,sBAAA;AxFoweJ;;AwF7ueA;EAjBE,yBAiBuC;EtDrCvC,uBAAA;EACA,oBAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,kCAAA;EACA,wCAAA;EACA,8BAAA;EACA,4CAAA;EACA,mCAAA;EACA,+DAAA;EACA,gCAAA;EACA,6BAAA;EACA,oCAAA;AlCuxeF;;AwF9veA;EAlBE,yBAkBuC;EtDtCvC,uBAAA;EACA,oBAAA;EACA,2BAAA;EACA,0BAAA;EACA,0BAAA;EACA,kCAAA;EACA,wCAAA;EACA,2BAAA;EACA,yCAAA;EACA,mCAAA;EACA,+DAAA;EACA,6BAAA;EACA,6BAAA;EACA,oCAAA;AlCyyeF;;AwF/weA;EAnBE,yBAmBuC;EtDvCvC,uBAAA;EACA,oBAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,kCAAA;EACA,wCAAA;EACA,8BAAA;EACA,yCAAA;EACA,mCAAA;EACA,+DAAA;EACA,gCAAA;EACA,6BAAA;EACA,oCAAA;AlC2zeF;;AwFhyeA;EApBE,yBAoBuC;EtDxCvC,uBAAA;EACA,oBAAA;EACA,2BAAA;EACA,0BAAA;EACA,0BAAA;EACA,kCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2CAAA;EACA,mCAAA;EACA,+DAAA;EACA,6BAAA;EACA,6BAAA;EACA,oCAAA;AlC60eF;;AwFjzeA;EArBE,yBAqBuC;EtDzCvC,uBAAA;EACA,oBAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,kCAAA;EACA,wCAAA;EACA,8BAAA;EACA,uCAAA;EACA,mCAAA;EACA,+DAAA;EACA,gCAAA;EACA,6BAAA;EACA,oCAAA;AlC+1eF;;AwFl0eA;EAtBE,yBAsBuC;EtD1CvC,uBAAA;EACA,oBAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,kCAAA;EACA,wCAAA;EACA,8BAAA;EACA,4CAAA;EACA,mCAAA;EACA,+DAAA;EACA,gCAAA;EACA,6BAAA;EACA,oCAAA;AlCi3eF;;AwFn1eA;EAvBE,yBAuBuC;EtD3CvC,uBAAA;EACA,oBAAA;EACA,2BAAA;EACA,0BAAA;EACA,0BAAA;EACA,kCAAA;EACA,wCAAA;EACA,2BAAA;EACA,4CAAA;EACA,mCAAA;EACA,+DAAA;EACA,6BAAA;EACA,6BAAA;EACA,oCAAA;AlCm4eF;;AwFp2eA;EAxBE,yBAwBuC;EtD5CvC,uBAAA;EACA,oBAAA;EACA,2BAAA;EACA,0BAAA;EACA,0BAAA;EACA,kCAAA;EACA,wCAAA;EACA,8BAAA;EACA,yCAAA;EACA,mCAAA;EACA,+DAAA;EACA,6BAAA;EACA,6BAAA;EACA,oCAAA;AlCq5eF;;AwFr3eA;EAzBE,yBAyBuC;EtD7CvC,uBAAA;EACA,oBAAA;EACA,2BAAA;EACA,0BAAA;EACA,0BAAA;EACA,kCAAA;EACA,wCAAA;EACA,8BAAA;EACA,0CAAA;EACA,mCAAA;EACA,+DAAA;EACA,6BAAA;EACA,6BAAA;EACA,oCAAA;AlCu6eF;;AwFt4eA;EA1BE,yBA0BuC;EtD9CvC,uBAAA;EACA,oBAAA;EACA,2BAAA;EACA,0BAAA;EACA,0BAAA;EACA,kCAAA;EACA,wCAAA;EACA,8BAAA;EACA,yCAAA;EACA,mCAAA;EACA,+DAAA;EACA,6BAAA;EACA,6BAAA;EACA,oCAAA;AlCy7eF;;AwFv5eA;EA3BE,yBA2BuC;EtD/CvC,uBAAA;EACA,oBAAA;EACA,2BAAA;EACA,0BAAA;EACA,0BAAA;EACA,kCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2CAAA;EACA,mCAAA;EACA,+DAAA;EACA,6BAAA;EACA,6BAAA;EACA,oCAAA;AlC28eF;;AwFx6eA;EA5BE,yBA4BuC;EtDhDvC,uBAAA;EACA,oBAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,kCAAA;EACA,wCAAA;EACA,8BAAA;EACA,yCAAA;EACA,mCAAA;EACA,+DAAA;EACA,gCAAA;EACA,6BAAA;EACA,oCAAA;AlC69eF;;AwFz7eA;EA7BE,yBA6BuC;EtDjDvC,uBAAA;EACA,oBAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,kCAAA;EACA,wCAAA;EACA,8BAAA;EACA,yCAAA;EACA,mCAAA;EACA,+DAAA;EACA,gCAAA;EACA,6BAAA;EACA,oCAAA;AlC++eF;;AwF18eA;EA9BE,yBA8BuC;EtDlDvC,uBAAA;EACA,oBAAA;EACA,2BAAA;EACA,0BAAA;EACA,0BAAA;EACA,kCAAA;EACA,wCAAA;EACA,2BAAA;EACA,0CAAA;EACA,mCAAA;EACA,+DAAA;EACA,6BAAA;EACA,6BAAA;EACA,oCAAA;AlCigfF;;AwF39eA;EA/BE,yBA+BuC;EtDnDvC,oBAAA;EACA,oBAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;EACA,kDAAA;EACA,kCAAA;EACA,8BAAA;EACA,0CAAA;EACA,mDAAA;EACA,+DAAA;EACA,gCAAA;EACA,6BAAA;EACA,oCAAA;AlCmhfF;;AwF5+eA;EAhCE,yBAgCuC;EtDpDvC,uBAAA;EACA,oBAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,kCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,mCAAA;EACA,+DAAA;EACA,gCAAA;EACA,6BAAA;EACA,oCAAA;AlCqifF;;AwF7/eA;EAjCE,yBAiCuC;EtDrDvC,uBAAA;EACA,oBAAA;EACA,2BAAA;EACA,0BAAA;EACA,0BAAA;EACA,kCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2CAAA;EACA,mCAAA;EACA,+DAAA;EACA,6BAAA;EACA,6BAAA;EACA,oCAAA;AlCujfF;;AwF9gfA;EAlCE,yBAkCuC;EtDtDvC,uBAAA;EACA,oBAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,kCAAA;EACA,wCAAA;EACA,8BAAA;EACA,0CAAA;EACA,mCAAA;EACA,+DAAA;EACA,gCAAA;EACA,6BAAA;EACA,oCAAA;AlCykfF;;AwF/hfA;EAnCE,yBAmCuC;EtDvDvC,uBAAA;EACA,oBAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,kCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2CAAA;EACA,mCAAA;EACA,+DAAA;EACA,gCAAA;EACA,6BAAA;EACA,oCAAA;AlC2lfF;;AwFhjfA;EApCE,yBAoCuC;EtDxDvC,uBAAA;EACA,oBAAA;EACA,2BAAA;EACA,0BAAA;EACA,0BAAA;EACA,kCAAA;EACA,wCAAA;EACA,8BAAA;EACA,4CAAA;EACA,mCAAA;EACA,+DAAA;EACA,6BAAA;EACA,6BAAA;EACA,oCAAA;AlC6mfF;;AwFjkfA;EArCE,yBAqCuC;EtDzDvC,uBAAA;EACA,oBAAA;EACA,2BAAA;EACA,0BAAA;EACA,0BAAA;EACA,kCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2CAAA;EACA,mCAAA;EACA,+DAAA;EACA,6BAAA;EACA,6BAAA;EACA,oCAAA;AlC+nfF;;AwFhlfA;EAlCE,oCAAA;EACA,cAiCuD;AxFqlfzD;;AwFplfA;EAnCE,oCAAA;EACA,cAkCuD;AxFylfzD;;AwFxlfA;EApCE,oCAAA;EACA,cAmCuD;AxF6lfzD;;AwF5lfA;EArCE,oCAAA;EACA,cAoCuD;AxFimfzD;;AwFhmfA;EAtCE,oCAAA;EACA,cAqCuD;AxFqmfzD;;AwFpmfA;EAvCE,oCAAA;EACA,cAsCuD;AxFymfzD;;AwFxmfA;EAxCE,oCAAA;EACA,cAuCuD;AxF6mfzD;;AwF5mfA;EAzCE,oCAAA;EACA,cAwCuD;AxFinfzD;;AwFhnfA;EA1CE,oCAAA;EACA,cAyCuD;AxFqnfzD;;AwFpnfA;EA3CE,oCAAA;EACA,cA0CuD;AxFynfzD;;AwFxnfA;EA5CE,oCAAA;EACA,cA2CuD;AxF6nfzD;;AwF5nfA;EA7CE,oCAAA;EACA,cA4CuD;AxFiofzD;;AwFhofA;EA9CE,oCAAA;EACA,cA6CuD;AxFqofzD;;AwFpofA;EA/CE,oCAAA;EACA,cA8CuD;AxFyofzD;;AwFxofA;EAhDE,oCAAA;EACA,cA+CuD;AxF6ofzD;;AwF5ofA;EAjDE,oCAAA;EACA,cAgDuD;AxFipfzD;;AwFhpfA;EAlDE,oCAAA;EACA,cAiDuD;AxFqpfzD;;AwFppfA;EAnDE,oCAAA;EACA,cAkDuD;AxFypfzD;;AwFxpfA;EApDE,oCAAA;EACA,cAmDuD;AxF6pfzD;;AwF5pfA;EArDE,oCAAA;EACA,cAoDuD;AxFiqfzD;;AwFhqfA;EAtDE,oCAAA;EACA,cAqDuD;AxFqqfzD;;AwFlqfA;EAnDE,+CAAA;EACA,qEAAA;AxFytfF;;AwFtqfA;EApDE,uDAAA;EACA,6EAAA;AxF8tfF;;AwF1qfA;EArDE,uDAAA;EACA,6EAAA;AxFmufF;;AwF9qfA;EAtDE,uDAAA;EACA,6EAAA;AxFwufF;;AwFlrfA;EAvDE,wBAAA;EACA,8CAAA;AxF6ufF;;AwFtrfA;EAxDE,uDAAA;EACA,6EAAA;AxFkvfF;;AwF1rfA;EAzDE,cAAA;EACA,oCAAA;AxFuvfF;;AwF9rfA;EA1DE,wDAAA;EACA,8EAAA;AxF4vfF;;AwFlsfA;EA3DE,uDAAA;EACA,6EAAA;AxFiwfF;;AwFtsfA;EA5DE,gCAAA;EACA,sDAAA;AxFswfF;;AwF1sfA;EA7DE,wDAAA;EACA,8EAAA;AxF2wfF;;AwF9sfA;EA9DE,4CAAA;EACA,kEAAA;AxFgxfF;;AwFltfA;EA/DE,qDAAA;EACA,2EAAA;AxFqxfF;;AwFttfA;EAhEE,wDAAA;EACA,8EAAA;AxF0xfF;;AwF1tfA;EAjEE,wBAAA;EACA,8CAAA;AxF+xfF;;AwF9tfA;EAlEE,cAAA;EACA,oCAAA;AxFoyfF;;AwFlufA;EAnEE,4CAAA;EACA,kEAAA;AxFyyfF;;AwFtufA;EApEE,yDAAA;EACA,+EAAA;AxF8yfF;;AwF1ufA;EArEE,oCAAA;EACA,0DAAA;AxFmzfF;;AwF9ufA;EAtEE,sDAAA;EACA,4EAAA;AxFwzfF;;AwFlvfA;EAvEE,sDAAA;EACA,4EAAA;AxF6zfF;;AwFpvfA;EAAoB,yBAAA;AxFwvfpB;;AwFvvfA;EAAoB,yBAAA;AxF2vfpB;;AwF1vfA;EAAoB,yBAAA;AxF8vfpB;;AwF7vfA;EAAoB,yBAAA;AxFiwfpB;;AwFhwfA;EAAoB,yBAAA;AxFowfpB;;AwFnwfA;EAAoB,yBAAA;AxFuwfpB;;AwFtwfA;EAAoB,yBAAA;AxF0wfpB;;AwFzwfA;EAAoB,yBAAA;AxF6wfpB;;AwF5wfA;EAAoB,yBAAA;AxFgxfpB;;AwF/wfA;EAAoB,yBAAA;AxFmxfpB;;AwFlxfA;EAAoB,yBAAA;AxFsxfpB;;AwFrxfA;EAAoB,yBAAA;AxFyxfpB;;AwFxxfA;EAAoB,yBAAA;AxF4xfpB;;AwF3xfA;EAAoB,yBAAA;AxF+xfpB;;AwF9xfA;EAAoB,yBAAA;AxFkyfpB;;AwFjyfA;EAAoB,yBAAA;AxFqyfpB;;AwFpyfA;EAAoB,yBAAA;AxFwyfpB;;AwFvyfA;EAAoB,yBAAA;AxF2yfpB;;AwF1yfA;EAAoB,yBAAA;AxF8yfpB;;AwF7yfA;EAAoB,yBAAA;AxFizfpB;;AwFhzfA;EAAoB,yBAAA;AxFozfpB;;AyFt8fA;;;;;;;;2FAAA;AAWE;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EAEA,wBAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;AzFs8fJ;AyFr8fI;EACE,gCAAA;AzFu8fN;AyFt8fM;EACE,ehFID;EgFHC,qBAAA;AzFw8fR;AyFr8fI;EACE,YAAA;AzFu8fN;AyFn8fI;EACE,chFNC;EgFOD,qBAAA;AzFq8fN;AyFj8fE;;EAEE,cAAA;EACA,iBAAA;EACA,gBAAA;AzFm8fJ;AyFh8fE;EACE,eAAA;EACA,kBAAA;AzFk8fJ;;AyF97fA;EACE,eAAA;EACA,kBAAA;EACA,0CAAA;EACA,cAAA;AzFi8fF;AyF/7fE;EACE,aAAA;AzFi8fJ;;AyF77fA;EACE,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EAGA,sBAAA;AzFg8fF;;AyF77fA;EACE,SAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;AzFg8fF;;AyF77fA;EACE,WAAA;AzFg8fF;;AyF77fA;EACE,eAAA;AzFg8fF;;AyF77fA;EACE,WAAA;EACA,YAAA;AzFg8fF;;A0F7hgBA;;;;;;;;6FAAA;AAUA;EACE,YAAA;EACA,aAAA;EACA,UAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,0DAAA;EACA,2BAAA;EACA,0CAAA;EACA,+EAAA;A1F+hgBF;A0F5hgBE;EACE,kCAAA;EACA,kBAAA;EACA,SAAA;A1F8hgBJ;A0F3hgBE;EACE,QAAA;A1F6hgBJ;A0FzhgBE;EACE,kBAAA;EACA,yBAAA;A1F2hgBJ;A0FzhgBI;EACE,sBAAA;A1F2hgBN;A0FthgBE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;A1FwhgBJ;A0FvhgBI;EACE,kBAAA;A1FyhgBN;A0FphgBE;EACE,mBAAA;EACA,WAAA;EACA,cAAA;EACA,2CAAA;EACA,2BAAA;EACA,8BAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;A1FshgBJ;A0FlhgBE;EACE,YAAA;EACA,WAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;A1FohgBJ;A0FnhgBI;EACE,6CAAA;EACA,gCAAA;A1FqhgBN;A0FnhgBI;EACE,oBAAA;EACA,mBAAA;A1FqhgBN;;A0F3ggBQ;;EACE,yBAAA;A1F+ggBV;;A0FxggBA;EACE,eAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;A1F2ggBF;A0F1ggBE;EACE,6CAAA;A1F4ggBJ;A0F3ggBI;EACE,2BAAA;A1F6ggBN;;A0FtggBA;EACE;IACE,oBAAA;E1FyggBF;E0FvggBA;IACE,yBAAA;E1FyggBF;AACF;A2FxogBA;EACE,yBd2Bc;Ec1Bd,iBd8Je;Ec7Jf,uBd8JmB;Ec7JnB,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;A3F0ogBF;A2FtogBE;EACE,yBAAA;EACA,aAAA;EACA,8BAAA;EACA,oBd8Ic;Ec7Id,mBd6Ic;A7E2/flB;A2FvogBI;EACE,yBdUW;EcTX,aAAA;EACA,WduEW;EctEX,YdsEW;EcrEX,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WlFlBE;EkFmBF,0BAAA;A3FyogBN;A2FxogBM;EACE,iBAAA;A3F0ogBR;A2FtogBM;EACE,kBAAA;EACA,YdwDS;EcvDT,WduDS;A7EilgBjB;A2FpogBI;EACE,sBAAA;EACA,kBAAA;A3FsogBN;A2FlogBI;EACE,oBdoHsB;EcnHtB,mBdmHsB;EclHtB,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,+BAAA;EACA,WlFhDE;EkFiDF,0BAAA;EACA,eAAA;A3FoogBN;A2FnogBM;EACE,YAAA;EACA,WAAA;A3FqogBR;;A4FpsgBA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;A5FusgBF;A4FnsgBE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,eAAA;EACA,sBnFJI;ATysgBR;A4FjsgBI;EACE,YAAA;EACA,WAAA;A5FmsgBN;A4F9rgBI;EAEE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,aAAA;EACA,wCAAA;A5F+rgBN;A4F3rgBI;EACE,WAAA;A5F6rgBN;A4F1rgBI;EACE,UAAA;A5F4rgBN;A4FrrgBI;EACE,WAAA;EACA,eAAA;A5FurgBN;A4FrrgBM;EACE,aAAA;A5FurgBR;A4FlrgBI;EACE,UAAA;A5ForgBN;A4F/qgBI;EACE,YAAA;EACA,gBAAA;A5FirgBN;A4FhrgBM;EACE,aAAA;A5FkrgBR;A4F7qgBI;EACE,WAAA;A5F+qgBN;A4FvqgBM;EAEE,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;A5FwqgBR;A4FlqgBM;EAEE,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;A5FmqgBR;;A6FtwgBA,yBAAA;AAEA;EACE,2BAAA;EACA,cAAA;EACA,WAAA;A7FwwgBF;A6FtwgBI;EACE,mBAAA;EACA,WAAA;A7FwwgBN;A6FvwgBM;EACE,mCAAA;EACA,6BAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;A7FywgBR;A6FxwgBQ;EACE,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBpFfF;ATyxgBR;A6FvwgBU;EACE,yBpFTD;EoFUC,WpFpBJ;AT6xgBR;A6FvwgBU;EACE,8BAAA;EACA,2BAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;A7FywgBZ;A6FrwgBU;EACE,gCAAA;A7FuwgBZ;A6FrwgBU;EAEE,8BAAA;EACA,2BAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;A7FswgBZ;A6FpwgBU;EACE,OAAA;A7FswgBZ;A6FpwgBU;EACE,QAAA;A7FswgBZ;A6FlwgBU;EACE,yBAAA;EACA,cpFnDD;ATuzgBX;;A8F7zgBA;EACE,kBAAA;EACA,yBAAA;A9Fg0gBF;A8F/zgBE;EACE,YAAA;EACA,WAAA;EACA,2BAAA;A9Fi0gBJ;A8Fh0gBI;EACE,gBAAA;A9Fk0gBN;A8F/zgBE;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBrFtBI;EqFuBJ,+EAAA;A9Fi0gBJ;A8Fh0gBI;EACE,qBAAA;EACA,crF2CO;ATuxgBb;A8Fj0gBM;EACE,crFyCK;AT0xgBb;A8Fj0gBM;EAEE,yBrF/BE;EqFgCF,crFoCK;AT8xgBb;A8F/zgBM;EACE,eAAA;A9Fi0gBR;;A+Fp2gBA;EACE,kBAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,sBAAA;EACA,6BAAA;A/Fu2gBF;A+Fr2gBE;EACE,iBAAA;A/Fu2gBJ;A+Fp2gBE;;EAEE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,wCAAA;EACA,kBAAA;EAEA,sBAAA;A/Fs2gBJ;A+Fn2gBE;EACE,kCAAA;A/Fq2gBJ;A+Fn2gBE;EACE,8CAAA;A/Fq2gBJ;A+Fn2gBE;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,wCAAA;EAEA,8CAAA;EACA,kBAAA;EAEA,sBAAA;A/Fq2gBJ;A+Fl2gBE;EACE,yBAAA;A/Fo2gBJ;;A+Fj2gBA;EACE,kBAAA;EACA,sBAAA;EACA,QAAA;A/Fo2gBF;;A+Fj2gBA;EACE;IAEE,uBAAA;E/Fo2gBF;E+Fl2gBA;IAEE,wBAAA;E/Fo2gBF;AACF;A+Fl2gBA;EACE;IAEE,uBAAA;IACA,YAAA;E/Fo2gBF;E+Fl2gBA;IAEE,wBAAA;IACA,UAAA;E/Fo2gBF;AACF;AgG96gBI;EACE,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;AhGg7gBN;AgG96gBM;EACE,UAAA;AhGg7gBR;AgG/6gBQ;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;AhGi7gBV;AgGh7gBU;EACE,gBAAA;EACA,cAAA;EACA,YAAA;EACA,qBAAA;EACA,qBAAA;EACA,WAAA;EACA,WvFtBJ;EuFuBI,sEAAA;EAKA,qBAAA;EACA,4EAAA;AhG86gBZ;AgG56gBY;EACE,SAAA;AhG86gBd;AgG16gBQ;EACE,YAAA;AhG46gBV;AgGx6gBU;EACE,WAAA;AhG06gBZ;AgGx6gBU;EACE,SAAA;AhG06gBZ;AgGx6gBU;EACE,gBAAA;EACA,WAAA;EACA,2BAAA;EACA,cvFkBC;EuFjBD,gBAAA;EACA,uBAAA;EACA,yBAAA;AhG06gBZ;;AiGr9gBE;EACE;IAAO,qBAAA;EjGy9gBT;EiGx9gBE;IAAa,8BAAA;EjG29gBf;AACF;AiG99gBE;EACE;IAAO,uBAAA;EjGi+gBT;EiGh+gBE;IAAa,gCAAA;EjGm+gBf;AACF;AiGt+gBE;EACE;IAAO,uBAAA;EjGy+gBT;EiGx+gBE;IAAa,gCAAA;EjG2+gBf;AACF;AiG9+gBE;EACE;IAAO,uBAAA;EjGi/gBT;EiGh/gBE;IAAa,gCAAA;EjGm/gBf;AACF;AiGt/gBE;EACE;IAAO,wBAAA;EjGy/gBT;EiGx/gBE;IAAa,iCAAA;EjG2/gBf;AACF;AiGx/gBA;EAEE,WAAA;AjGy/gBF;AiGv/gBE;EAAQ,8DAAA;AjG0/gBV;;AiGt/gBA;EACE,aAAA;AjGy/gBF;;AiGl+gBA;EAAiB,aAAA;AjGs+gBjB;;AkGnihBA;EACE,mBAAA;AlGsihBF;;AkGlihBA;EACE,cAAA;EACA,WAAA;AlGqihBF;;AkG9hhBA,oBAAA;AAEA;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AlGgihBF;;AkG7hhBA;;kCAAA;AAKE;EACE,0CzF2JW;ATm4gBf;AkG7hhBI;EACE,oBAAA;AlG+hhBN;AkG9hhBM;EACE,QAAA;AlGgihBR;AkG5hhBM;EACE,SAAA;AlG8hhBR;;AkGxhhBA,oBAAA;AAIE;EACE,mBzF6FkB;EyF5FlB,kBAAA;AlGwhhBJ;AkGthhBE;EACE,WAAA;EACA,aAAA;AlGwhhBJ;AkGthhBI;EACE,kBAAA;EACA,SAAA;EACA,4BAAA;AlGwhhBN;;AkGnhhBA;EACE,mCzFuHa;AT+5gBf;;AkGnhhBA;;;;EAIE,iBzF8CiB;ATw+gBnB;;AkGnhhBA;EACE,ezFwCa;AT8+gBf;;AkGnhhBA;EACE,ezFkCe;ATo/gBjB;;AkGnhhBA;EACE,ezF+Ba;ATu/gBf;;AkGnhhBA;EACE,kBrBiBa;A7EqghBf;;AkGlhhBE;;;EAGE,wBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mCAAA;EACA,gCAAA;AlGqhhBJ;AkGnhhBE;EACE,uBAAA;AlGqhhBJ;;AkGjhhBA;EACE,mBAAA;EACA,sBAAA;AlGohhBF;;AkGjhhBA;;EAEE,yBAAA;EACA,yBAAA;EACA,gBAAA;AlGohhBF;;AmGnohBA;EACE,yBAAA;AnGsohBF;AmGnohBE;EACI,gCAAA;EACA,aAAA;AnGqohBN;AmGjohBI;EACI,kBtB0Ja;EsBzJb,SAAA;AnGmohBR;AmG7nhBI;EACI,yBtB+Ha;A7EgghBrB;AmG3nhBI;EACE,sBAAA;AnG6nhBN;AmG5nhBM;EACE,sBAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,OAAA;EACA,WAAA;AnG8nhBR;AmG5nhBM;EACE,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,OAAA;EACA,WAAA;AnG8nhBR;AmGxnhBE;EACE,yBtBqGiB;A7EqhhBrB;AmGvnhBE;EACE,sB1F9CI;ATuqhBR;AmGrnhBE;EACE,yBAAA;AnGunhBJ;AmGrnhBM;EACE,gCAAA;EACA,+BAAA;AnGunhBR;AmG9mhBM;EACE,sDAAA;EACA,yBAAA;EACA,wCAAA;EACA,kBAAA;AnGgnhBR;AmG/mhBQ;EACE,gBAAA;AnGinhBV;;AmGpmhBI;EACE,gBAAA;AnGumhBN;AmGrmhBI;EACE,yEACA;EAGA,iBAAA;AnGomhBN;AmG9lhBI;EACE,gBAAA;EACA,mBAAA;AnGgmhBN;AmG9lhBM;EACE,iBAAA;AnGgmhBR;;AmGzlhBA;EAEE,yB1F5GS;ATushBX;;AmGtlhBA;EAGM;IACE,uBAAA;EnGulhBN;AACF;A6EpihBA;;0DAAA;AuB/JE;EACE,yBvBkKc;EuByKd,gCAAA;EAkCA,+BAAA;EAyoBA,4BAAA;EAqRA,4BAAA;EAmSA,4BAAA;EA0KA,6BAAA;EA4IA,mCAAA;EAugBA,iCAAA;EA6HA,iCAAA;EAqBA,wCAAA;ApGqtcJ;AoG9shBI;;;;;;;;;;;EAME,cvB2JqB;A7E0jhB3B;AoGjthBM;EACE,gCAAA;ApGmthBR;AoG9shBM;EACE,c3FlBD;ATkuhBP;AoG7shBI;;;;;EAIE,cvB0IkB;A7EskhBxB;AoG9shBI;EACE,qBvB2IoB;A7EqkhB1B;AoG5shBI;EACE,yBvB8HY;EuB7HZ,SAAA;ApG8shBN;AoG7shBM;EACE,yBAAA;EACA,iBAAA;ApG+shBR;AoG9shBQ;;EAEE,yBvBuHQ;A7EylhBlB;AoG5shBI;EACE,yBvBkHY;EuBjHZ,c3FxDK;ATswhBX;AoG5shBI;EACE,yBvB8GY;A7EgmhBlB;AoGxshBQ;EACE,mBvB2Gc;A7E+lhBxB;AoGvshBQ;EACE,mBvBqGQ;A7EomhBlB;AoGnshBI;EACE,yBAAA;ApGqshBN;AoGjshBI;EACE,+GAAA;ApGmshBN;AoG5rhBI;EACE,yBvBgFY;A7E8mhBlB;AoGzrhBY;;EACE,cvB6EU;EuB5EV,6BAAA;ApG4rhBd;AoG3rhBc;;EACE,evB0EQ;A7EonhBxB;AoGxrhBgB;;EACE,yBvBgEA;A7E2nhBlB;AoG1rhBkB;;EACE,qBvBqEM;A7EwnhB1B;AoG3rhBkB;;;;;;EAGE,cvB4DI;A7EoohBxB;AoG1rhBc;;EACE,yBvBkDE;A7E2ohBlB;AoG1rhBY;;EACE,yBvB6CI;A7EgphBlB;AoG5rhBc;;EACE,yBvB4CE;A7EmphBlB;AoG1rhBY;;EACE,gBAAA;ApG6rhBd;AoG5rhBc;;EACE,aAAA;ApG+rhBhB;AoG7rhBc;;EACE,qBvBwCU;A7EwphB1B;AoG9rhBkB;;EACE,cvBiCI;A7EgqhBxB;AoG9rhBgB;;EACE,cvB6BM;A7EoqhBxB;AoG/rhBgB;;EACE,yBvBuBA;A7E2qhBlB;AoG/rhBc;;EACE,yBvBmBE;A7E+qhBlB;AoGjshBgB;;EACE,W3FhKV;E2FiKU,qBvBuBQ;A7E6qhB1B;AoGnshBkB;;EACE,yBvBcF;A7EwrhBlB;AoG9rhBgB;;EACE,yBvBIA;A7E6rhBlB;AoG9rhBc;;EACE,W3FhLR;ATi3hBR;AoG9rhBgB;;EACE,W3FpLV;ATq3hBR;AoG7rhBgB;;EACE,sB3FzLV;ATy3hBR;AoG/rhBkB;;EACE,yBvBXF;EuBYE,6BAAA;ApGkshBpB;AoGhshBkB;;EACE,iCAAA;ApGmshBpB;AoG3rhBM;EACE,6BAAA;ApG6rhBR;AoGxrhBY;EACE,yBAAA;ApG0rhBd;AoGzrhBc;EACE,Y3FhNR;AT24hBR;AoGrrhBM;EACE,oCAAA;ApGurhBR;AoGlrhBI;EACE,yBvB5CY;A7EguhBlB;AoGnrhBM;EACE,iGAAA;ApGqrhBR;AoG3qhBY;EACE,yBvB1DI;A7EuuhBlB;AoGtqhBU;EACE,yBAAA;ApGwqhBZ;AoGlqhBc;EACE,sEAAA;EAKA,iDAAA;ApGgqhBhB;AoG5phBc;EACE,sEAAA;EAKA,iDAAA;ApG0phBhB;AoGhphBM;EACE,yBvBlGU;A7EovhBlB;AoGhphBU;EACE,cvBlGY;A7EovhBxB;AoGhphBU;EACE,evBrGY;A7EuvhBxB;AoG/ohBY;EACE,yBvB7GI;A7E8vhBlB;AoG9ohBU;EACE,cvB7GY;A7E6vhBxB;AoG9ohBU;EACE,yBvBnHM;A7EmwhBlB;AoG9ohBc;EACE,W3FvSR;ATu7hBR;AoG5ohBc;EACE,yBvB3HE;EuB4HF,cvBzHQ;A7EuwhBxB;AoGxohBU;;;EAGE,W3FtTJ;E2FuTI,Y3FvTJ;ATi8hBR;AoGtohBU;EACE,mBvB3IM;EuB4IN,kBAAA;ApGwohBZ;AoGtohBU;EACE,yBvB/IM;A7EuxhBlB;AoGvohBY;EACE,UAAA;ApGyohBd;AoGxohBc;EACE,6BAAA;ApG0ohBhB;AoG7nhBY;EACE,8BAAA;ApG+nhBd;AoGpnhBM;;EAEE,yBvB/KU;A7EqyhBlB;AoGrnhBQ;;;;;;EAGE,yBvBnLQ;EuBoLR,qBvB9KY;A7EwyhBtB;AoGvnhBM;EACE,oCAAA;ApGynhBR;AoGvnhBM;;EAEE,oCAAA;ApGynhBR;AoGrnhBM;EACE,yBvBjMU;A7EwzhBlB;AoGlnhBM;EACE,W3FvXA;AT2+hBR;AoG5mhBM;;EAEE,cAAA;ApG8mhBR;AoG5mhBM;EACE,yBAAA;ApG8mhBR;AoG7mhBQ;;EAEE,c3FhYC;AT++hBX;AoGxmhBQ;EACE,cvB5NiB;A7Es0hB3B;AoGtmhBY;EACE,cvBhOU;A7Ew0hBxB;AoGvmhBc;EACE,cvBlOQ;A7E20hBxB;AoGtmhBgB;EACE,c3FzYX;ATi/hBP;AoG5lhBQ;;EACE,cvBnPc;A7Ek1hBxB;AoG9lhBU;;EACE,cvBrPY;A7Es1hBxB;AoG9lhBY;;EACE,c3F5ZP;AT6/hBP;AoGvlhBY;EACE,cvBpQU;A7E61hBxB;AoGtlhBU;EACE,cvBxQY;A7Eg2hBxB;AoGrlhBY;EACE,c3F/aP;ATsgiBP;AoG9khBM;EACE,uCAAA;ApGglhBR;AoG9khBM;EACE,8CAAA;ApGglhBR;AoG9khBM;EACE,qBvBxRkB;A7Ew2hB1B;AoG5khBM;EACE,uCAAA;ApG8khBR;AoG1khBI;EACE,iDAAA;ApG4khBN;AoGtkhBQ;;EACE,uCAAA;ApGykhBV;AoGjkhBQ;EACE,cvBtTc;A7Ey3hBxB;AoG5jhBM;EACE,W3FlfA;ATgjiBR;AoG3jhBQ;EACE,c3F3eF;ATwiiBR;AoGzjhBQ;EACE,W3F3fF;ATsjiBR;AoGxjhBM;EAGE,c3F1fG;ATkjiBX;AoGtjhBM;EACE,oCAAA;ApGwjhBR;AoGtjhBM;EACE,qB3F/fG;E2FggBH,c3FjgBG;ATyjiBX;AoGrjhBQ;EAEE,mB3FrgBC;AT2jiBX;AoGnjhBM;EACE,c3F5cK;ATigiBb;AoGhjhBI;EACE,W3FvhBE;ATykiBR;AoGhjhBQ;EAEE,W3F3hBF;AT4kiBR;AoG5ihBI;EACE,yBvBjXY;A7E+5hBlB;AoG7ihBM;;;EAGE,mBvBrXU;A7Eo6hBlB;AoG7ihBM;EACE,cvBpXgB;A7Em6hBxB;AoG7ihBM;EACE,yBvB1XU;A7Ey6hBlB;AoG7ihBM;EACE,qBvBtXkB;A7Eq6hB1B;AoG1ihBM;EACE,yBAAA;ApG4ihBR;AoGpihBQ;;;EACE,cvBzYc;A7Ei7hBxB;AoG9hhBY;EACE,cvBpZU;A7Eo7hBxB;AoGvhhBM;;EAEE,oCAAA;ApGyhhBR;AoGxhhBQ;;EACE,yBvBraQ;EuBsaR,iBAAA;ApG2hhBV;AoG1hhBU;;EACE,W3FxlBJ;ATqniBR;AoGzhhBM;;;EAGE,yBvB/aU;EuBgbV,cvB5agB;A7Eu8hBxB;AoG1hhBQ;;;;;;;;;;;;EAIE,oCAAA;ApGoihBV;AoG3hhBU;EACE,yBvB/bM;A7E49hBlB;AoG5hhBY;EACE,yB3FhmBP;AT8niBP;AoG7hhBc;EACE,W3FnnBR;ATkpiBR;AoG3hhBU;EACE,yBvBxcM;EuBycN,W3FznBJ;ATspiBR;AoG5hhBY;EACE,c3F1mBP;ATwoiBP;AoGzhhBY;EACE,W3FjoBN;AT4piBR;AoGphhBU;EACE,yBvBzdM;EuB0dN,W3F1oBJ;ATgqiBR;AoGjhhBY;EACE,yBvBheI;A7Em/hBlB;AoGhhhBU;EACE,yBvBpeM;A7Es/hBlB;AoGzghBQ;EACE,cvB1ec;A7Eq/hBxB;AoG1ghBU;EAEE,c3FhpBL;AT2piBP;AoGvghBM;EACE,qBvB9ekB;A7Eu/hB1B;AoGlghBQ;EACE,yBvB9fQ;A7EkgiBlB;AoG7/gBY;;EACE,sBAAA;ApGgghBd;AoG9/gBY;;EACE,yBAAA;ApGighBd;AoGhghBc;;EACE,W3F3rBR;AT8riBR;AoGjghBc;;;;EAEE,sBAAA;EACA,uBAAA;ApGqghBhB;AoGx/gBQ;;;EACE,yBvB7hBQ;A7EyhiBlB;AoG3/gBU;;;EACE,yBvB/hBM;A7E8hiBlB;AoG7/gBU;;;EACE,YAAA;ApGighBZ;AoG5/gBQ;;;EACE,yBvBxiBQ;A7EwiiBlB;AoGr/gBY;EACE,yBvBpjBI;A7E2iiBlB;AoG5+gBU;EACE,W3FjvBJ;AT+tiBR;AoGx+gBU;EACE,wCAAA;ApG0+gBZ;AoGh+gBU;EACE,6BAAA;ApGk+gBZ;AoG39gBI;EACE,yBvB1lBY;A7EujiBlB;AoG59gBM;EACE,gCAAA;ApG89gBR;AoG59gBM;EACE,W3FhxBA;AT8uiBR;AoG59gBM;;EAEE,cvBhmBgB;EuBimBhB,oCAAA;ApG89gBR;AoG59gBM;;EAEE,cvBrmBgB;EuBsmBhB,qBvBlmBkB;A7EgkiB1B;AoG19gBU;;EAEE,W3FhyBJ;AT4viBR;AoGp9gBM;EACE,qBvBjnBkB;A7EukiB1B;AoGj9gBI;EACE,qBvBvnBoB;A7E0kiB1B;AoG98gBM;EACE,sEAAA;ApGg9gBR;AoG38gBQ;EACE,W3F3zBF;ATwwiBR;AoG38gBQ;EACE,6BAAA;ApG68gBV;AoG/7gBkB;EACE,W3F70BZ;AT8wiBR;AoG57gBgB;EACE,yBvB5pBG;EuB6pBH,yBAAA;ApG87gBlB;AoG77gBkB;EACE,cvBlqBI;A7EimiBxB;AoGz7gBU;EACE,6BAAA;ApG27gBZ;AoG17gBY;EACE,8BAAA;ApG47gBd;AoGp7gBI;EACE,W3Fx2BE;AT8xiBR;AoGr7gBM;EACE,W3F12BA;ATiyiBR;AoGp7gBQ;EACE,W3F92BF;AToyiBR;AoG76gBU;EACE,yBvBxsBM;A7EuniBlB;AoGz6gBU;EACE,4B3F92BL;ATyxiBP;AoGr6gBU;EACE,0BvBttBM;A7E6niBlB;AoGj6gBU;EACE,2BvB7tBM;A7EgoiBlB;AoG95gBM;EACE,yBvBnuBU;EuBouBV,cvBhuBgB;A7EgoiBxB;AoG35gBI;EACE,yBvB1uBY;EuB2uBZ,+CAAA;ApG65gBN;AoG55gBM;EACE,yBvB7uBU;EuB8uBV,cvB1uBgB;EuB2uBhB,qBvBvuBkB;A7EqoiB1B;AoG75gBQ;EACE,iBAAA;EACA,UAAA;ApG+5gBV;AoG55gBM;EACE,yBvBtvBU;EuBuvBV,cvBnvBgB;A7EipiBxB;AoGz5gBI;EACE,yBvB7vBY;A7EwpiBlB;AoGv5gBI;EACE,yBvBlwBY;A7E2piBlB;AoGx5gBM;EACE,W3Fp7BA;AT80iBR;AoGr5gBI;EACE,yBvB1wBY;A7EiqiBlB;AoGt5gBM;EACE,yBvB3wBU;A7EmqiBlB;AoGr5gBQ;;EAEE,W3Fj8BF;ATw1iBR;AoGh5gBM;EACE,6BAAA;EACA,cvBtxBgB;A7EwqiBxB;AoGj5gBQ;EAEE,qBvBrxBgB;A7EuqiB1B;AoG74gBU;EAEE,gCAAA;ApG84gBZ;AoGp4gBU;EACE,yBvB/yBM;A7EqriBlB;AoGr4gBY;EACE,cvB7yBU;A7EoriBxB;AoG73gBQ;EAEE,yBvB5zBQ;EuB6zBR,qBvBtzBgB;EuBuzBhB,cvB3zBc;A7EyriBxB;AoG73gBU;EACE,yBvBj0BM;A7EgsiBlB;AoG33gBQ;EACE,yB3Fr+BH;E2Fs+BG,W3Fv/BF;ATo3iBR;AoG53gBU;;;EAEE,W3F1/BJ;ATy3iBR;AoG33gBQ;EACE,yBvB/0BQ;A7E4siBlB;AoGr3gBI;;;EAGE,yBvB11BY;EuB21BZ,cvBv1BkB;A7E8siBxB;AoGt3gBM;;;EACE,SAAA;ApG03gBR;AoGx3gBM;;;EACE,cvB51BgB;A7EwtiBxB;AoGz3gBQ;;;EACE,cvBh2Bc;A7E6tiBxB;AoGx3gBU;;;EACE,c3FzgCL;ATq4iBP;AoGx3gBM;;;;;EAEE,YAAA;ApG63gBR;AoGv3gBM;EACE,yBAAA;ApGy3gBR;AoGv3gBM;EACE,yBAAA;ApGy3gBR;AoGn3gBM;EACE,yBvBj4BU;EuBk4BV,8BAAA;EACA,cvB/3BgB;A7EoviBxB;AoG72gBU;EACE,2BvBp4Bc;A7EmviB1B;AoGz2gBU;EACE,0BvB34Bc;A7EsviB1B;AoGp2gBI;;EAEE,yBvB55BY;EuB65BZ,cvBz5BkB;EuB05BlB,SAAA;ApGs2gBN;AoGr2gBM;;EACE,yBvB/5BU;A7EuwiBlB;AoG91gBY;EAEE,YAAA;ApG+1gBd;AoGv1gBI;;EAEE,yBvBt7BY;EuBu7BZ,qBvB/6BoB;A7EwwiB1B;AoGt1gBQ;;;;;;;;EAEE,cvBx7Bc;A7EsxiBxB;AoG51gBQ;;;;EACE,yBvB97BQ;A7E+xiBlB;AoGh2gBU;;;;EACE,cvB77BY;A7EkyiBxB;AoGh2gBQ;;;;EAEE,yBvBx8BQ;A7E4yiBlB;AoGj2gBY;;;;;;;;;;;;;;;EAEE,yBvB58BI;A7E4ziBlB;AoG12gBQ;;EACE,cvBh9Bc;A7E6ziBxB;AoG52gBU;;EACE,yBvBl9BY;A7Ei0iBxB;AoGx2gBI;EACE,oCAAA;ApG02gBN;AoGz2gBM;EACE,oCAAA;EACA,yBAAA;ApG22gBR;AoGn2gBU;EACE,yBvB1+BM;A7E+0iBlB;AoG/1gBY;;EACE,Y3FjqCN;E2FkqCM,U3FlqCN;ATogjBR;AoGx1gBQ;EACE,YAAA;ApG01gBV;AoGr1gBU;EACE,yB3FlqCL;ATy/iBP;AoGp1gBQ;EACE,yB3FtqCH;AT4/iBP;AoGl1gBQ;EACE,yBvB5gCQ;A7Eg2iBlB;AoGz0gBQ;;EACE,yBvBvhCQ;EuBwhCR,yBAAA;ApG40gBV;AoGx0gBQ;EACE,8BAAA;ApG00gBV;AoGt0gBQ;EACE,8BAAA;ApGw0gBV;AoGj0gBM;EAEE,yBAAA;ApGk0gBR;AoG7zgBI;EACE,yBvBljCY;A7Ei3iBlB;AoG9zgBM;EACE,yBvBpjCU;A7Eo3iBlB;AoG1zgBQ;EAEE,4B3F3tCH;ATshjBP;AoGxzgBM;EACE,mBvBhkCU;EuBikCV,qBvBjkCU;A7E23iBlB;AoGvzgBQ;;EAEE,U3FtvCF;E2FuvCE,W3FvvCF;ATgjjBR;AoGtzgBU;EACE,gB3F3vCJ;ATmjjBR;AoGpzgBU;EACE,W3FhwCJ;ATsjjBR;AoGlzgBM;EACE,qBvBrlCU;A7Ey4iBlB;AoGlzgBU;EAEE,yBvBxlCM;EuBylCN,qBvBzlCM;A7E44iBlB;AoGjzgBU;EAGE,c3F1wCD;AT2jjBX;AoG7ygBM;;EAEE,W3FrxCA;ATokjBR;AoGvygBM;EACE,yBvBzmCc;A7Ek5iBtB;AoGrygBY;;;;EAEE,qBvB5mCY;EuB6mCZ,cvBjnCU;A7E05iBxB;AoGxygBc;;;;EACE,yBvBtnCE;A7Em6iBlB;AoGtygBY;EACE,SAAA;EACA,yBvB3nCQ;EuB4nCR,cvB7nCU;A7Eq6iBxB;AoGhygBc;;EAEE,uBAAA;EACA,c3FjzCR;E2FkzCQ,qBvBroCU;A7Eu6iB1B;AoG9xgBc;;EAEE,W3Fn0CR;ATmmjBR;AoG5xgBc;;EAEE,cvBrpCQ;A7Em7iBxB;AoG3xgBY;EACE,yBvB7pCI;A7E07iBlB;AoG3xgBY;EACE,yBvBhqCI;EuBiqCJ,cvB7pCU;A7E07iBxB;AoGvxgBQ;EACE,yBAAA;ApGyxgBV;AoGrxgBc;;;;EAEE,yBAAA;ApGyxgBhB;AoG9wgBc;EACE,yBvBzrCE;A7Ey8iBlB;AoG9wgBc;;EAEE,uBAAA;ApGgxgBhB;AoGtwgBc;EACE,yBvBxsCE;A7Eg9iBlB;AoGtwgBc;;EAEE,uBAAA;ApGwwgBhB;AoGhwgBQ;EACE,yBvBrtCQ;A7Eu9iBlB;AoG9vgBc;;;;EAEE,yBvB3tCE;A7E69iBlB;AoGvvgBQ;EACE,qBvBhuCgB;A7Ey9iB1B;AoGxvgBU;EACE,yBvB1uCM;EuB2uCN,qBvBnuCc;A7E69iB1B;AoGzvgBY;;EAEE,yBvB7uCI;EuB8uCJ,cvB3uCU;A7Es+iBxB;AoGrvgBY;EACE,yBvBtvCI;EuBuvCJ,qBvB/uCY;A7Es+iB1B;AoGtvgBc;EACE,oCAAA;ApGwvgBhB;AoGtvgBc;EACE,oCAAA;ApGwvgBhB;AoGtvgBkB;EACE,yBvB3vCI;A7Em/iBxB;AoGlvgBU;EACE,qBvB9vCc;A7Ek/iB1B;AoG9ugBU;EACE,yBvB7wCM;EuB8wCN,cvB1wCY;A7E0/iBxB;AoG5ugBU;EACE,yBvBnxCM;EuBoxCN,cvBhxCY;A7E8/iBxB;AoGvugBY;EACE,oCAAA;ApGyugBd;AoGjugBI;EACE,yBvBpyCY;A7EugjBlB;AoGjugBM;EACE,qBvBhyCkB;A7EmgjB1B;AoGlugBQ;EACE,cvBtyCc;A7E0gjBxB;AoGjugBM;EACE,qBvBtyCkB;A7EygjB1B;AoG/tgBU;EACE,yBvBlzCM;EuBmzCN,qBvB5yCc;A7E6gjB1B;AoGhugBY;EACE,qBvB9yCY;EuB+yCZ,yBvBtzCI;A7EwhjBlB;AoG/tgBY;;EAEE,cvBxzCU;A7EyhjBxB;AoG/tgBY;EACE,qBvBvzCY;A7EwhjB1B;AoG7tgBY;EACE,cvBh0CU;EuBi0CV,qBvB7zCY;A7E4hjB1B;AoG7tgBY;EACE,qBvBh0CY;A7E+hjB1B;AoG1tgBM;;;EAGE,oCAAA;ApG4tgBR;AoG1tgBM;EACE,cvB/0CgB;A7E2ijBxB;AoG3tgBQ;EACE,c3Fp/CH;ATitjBP;AoG1tgBM;EACE,qBvBj1CkB;A7E6ijB1B;AoG1tgBU;EACE,yBAAA;ApG4tgBZ;AoG3tgBY;EACE,sBAAA;ApG6tgBd;AoGztgBQ;EACE,yBAAA;EACA,yBAAA;ApG2tgBV;AoGxtgBM;EACE,yBvBx2CU;A7EkkjBlB;AoGztgBQ;EACE,qBvBl2CgB;EuBm2ChB,cvBv2Cc;A7EkkjBxB;AoG1tgBU;EACE,cvBz2CY;EuB02CZ,yBvB92CM;A7E0kjBlB;AoGxtgBU;EACE,cvB/2CY;EuBg3CZ,qBvB52Cc;A7EskjB1B;AoGztgBY;EACE,cvBl3CU;A7E6kjBxB;AoGttgBM;EACE,mB3F3hDD;ATmvjBP;AoGrtgBM;EACE,mBvBh4CU;A7EuljBlB;AoGltgBI;EACE,oCAAA;ApGotgBN;AoGntgBM;EACE,yBAAA;ApGqtgBR;AoG9sgBI;EACE,yBvBv7CW;A7EuojBjB;AoG/sgBM;EACE,cvB94CgB;A7E+ljBxB;AoG/sgBM;;EAEE,yBvBr5CU;A7EsmjBlB;AoG9sgBU;;;;EACE,W3F1kDJ;AT6xjBR;AoG7sgBU;EACE,cvB75CY;A7E4mjBxB;AoGtsgBQ;EACE,yBAAA;ApGwsgBV;AoGjsgBM;EACE,c3Fx+CS;AT2qjBjB;AoGjsgBM;EACE,W3FtmDA;ATyyjBR;AoG5rgBQ;EACE,6BAAA;ApG8rgBV;AoG5rgBQ;EACE,yBvBh8CQ;A7E8njBlB;AoG3rgBU;EACE,cvBj8CY;A7E8njBxB;AoGzrgBM;EACE,sDAAA;ApG2rgBR;AoGrrgBM;EACE,kCAAA;ApGurgBR;AoG/qgBQ;EACE,yBvBz9CQ;A7E0ojBlB;AoG3qgBQ;EACE,yBvBh+CQ;EuBi+CR,cvB99Cc;A7E2ojBxB;AoGvqgBQ;EACE,cvBr+Cc;A7E8ojBxB;AoGlqgBU;EACE,yBvBh/CM;A7EopjBlB;AoGlqgBc;EACE,yB3FnpDT;ATuzjBP;AoGjqgBY;EACE,yBvBv/CI;A7E0pjBlB;AoGzpgBQ;EACE,yBvBlgDQ;A7E6pjBlB;AoGlpgBQ;;EACE,W3F7rDF;ATk1jBR;AoG5ogBU;EACE,yBAAA;ApG8ogBZ;AoGpogBQ;;EACE,c3FjsDH;ATw0jBP;AoG/ngBM;;EACE,SAAA;ApGkogBR;AoG7ngBQ;EACE,yBvBhjDQ;A7E+qjBlB;AoGrngBQ;EACE,evBpjDgB;A7E2qjB1B;AoGnngBM;;;;EAIE,yBvB/jDc;EuBgkDd,qBvBrkDU;A7E0rjBlB;AoGpngBQ;;;;;;;;EAEE,yBvBnkDY;EuBokDZ,cvBrkDc;A7EisjBxB;AoGvngBU;;EAEE,W3FhwDJ;ATy3jBR;AoGpngBQ;EACE,gCAAA;ApGsngBV;AoGpngBQ;EACE,4BvBzlDQ;A7E+sjBlB;AoGlngBQ;EACE,8BAAA;ApGongBV;AoGlngBQ;EACE,0BvBjmDQ;A7EqtjBlB;AoGhngBM;EACE,qBAAA;ApGkngBR;AoG7mgBQ;EACE,yBAAA;ApG+mgBV;AoGzmgBQ;EACE,evBnnDQ;A7E8tjBlB;AoGrmgBQ;EACE,0BAAA;EACA,wBAAA;ApGumgBV;AoGrmgBQ;EACE,avB7nDQ;A7EoujBlB;AoGjmgBQ;EACE,evBroDQ;A7EwujBlB;AoG9lgBM;EACE,yBvB3oDU;EuB4oDV,SAAA;ApGgmgBR;AoGvlgBY;;;;;EACE,avBlpDU;A7E+ujBxB;AoGzlgBQ;EACE,cvBvpDc;A7EkvjBxB;AoG1lgBU;EACE,yBvB5pDM;A7EwvjBlB;AoGplgBM;EACE,evBlqDgB;A7EwvjBxB;AoGplgBM;EACE,U3Fz1DA;AT+6jBR;AoGplgBM;EACE,oCAAA;EACA,gCAAA;EACA,cvB1qDgB;A7EgwjBxB;AoGplgBM;EACE,wBAAA;ApGslgBR;AoGnlgBQ;EACE,evB7qDgB;A7EkwjB1B;AoGjlgBQ;EACE,avB1rDQ;A7E6wjBlB;AoG9kgBI;EACE,qBvBxrDoB;A7EwwjB1B;AoGzkgBM;EACE,yBvBvsDU;EuBwsDV,qBvBjsDkB;A7E4wjB1B;AoGzkgBM;EACE,yBvB3sDU;EuB4sDV,qBvBrsDkB;A7EgxjB1B;AoG1kgBQ;EACE,cvB3sDc;A7EuxjBxB;AoG1kgBQ;EACE,cvB9sDc;A7E0xjBxB;AoG3kgBU;EACE,cvBhtDY;A7E6xjBxB;AoGzkgBc;EACE,c3Fx3DT;ATm8jBP;AoGrkgBU;EACE,cvB5tDY;A7EmyjBxB;AoGnkgBM;EACE,qBvB7tDkB;A7EkyjB1B;AoGpkgBQ;EACE,qBvB/tDgB;A7EqyjB1B;AoG9jgBY;;EACE,mBvB/uDI;A7EgzjBlB;AoGhkgBc;;;EAEE,c3Fl5DT;ATq9jBP;AoGjkgBc;;EACE,cvBlvDQ;A7EszjBxB;AoG7jgBM;EACE,qBvBtvDkB;A7EqzjB1B;AoGzjgBgB;EACE,cvBjwDM;A7E4zjBxB;AoGrjgBY;EACE,qBvBpwDY;A7E2zjB1B;AoGtjgBc;EACE,2BAAA;ApGwjgBhB;AoGpjgBY;;EAEE,yBvBpxDI;A7E00jBlB;AoGnjgBgB;;;;;;;;EAEE,cvBrxDM;A7Eg1jBxB;AoGxjgBkB;;;;EACE,cvBzxDI;A7Es1jBxB;AoGxjgBY;EACE,yBvBlyDI;A7E41jBlB;AoGnjgBM;EACE,qBvBnyDkB;A7Ew1jB1B;AoGpjgBQ;EACE,yBvBxyDY;A7E81jBtB;AoGpjgBQ;EACE,qBvBxyDgB;EuByyDhB,yBvBhzDQ;A7Es2jBlB;AoGnjgBc;EACE,cvBjzDQ;A7Es2jBxB;AoGjjgBU;EACE,cvBtzDY;A7Ey2jBxB;AoGhjgBQ;;EAEE,gCAAA;ApGkjgBV;AoG3igBM;EACE,yBvBv0DU;A7Eo3jBlB;AoG3igBM;EACE,yBvBz0DU;EuB00DV,qBvBn0DkB;A7Eg3jB1B;AoG5igBQ;EACE,qBvBr0DgB;A7Em3jB1B;AoG7igBU;EACE,yBvB90DM;A7E63jBlB;AoG9igBY;EACE,yBAAA;ApGgjgBd;AoG7igBU;EACE,cvBj1DY;A7Eg4jBxB;AoG1igBY;EACE,qBvBn1DY;A7E+3jB1B;AoG3igBc;EACE,mBvB51DE;A7Ey4jBlB;AoGzigBkB;EACE,W3FlhEZ;AT6jkBR;AoGnigBM;EACE,qBvBn2DkB;A7Ew4jB1B;AoGpigBQ;EACE,sBAAA;ApGsigBV;AoGnigBU;EACE,yBvB12DS;A7E+4jBrB;AoGpigBY;;EAEE,mBvBp3DI;A7E05jBlB;AoGjigBc;EACE,2CAAA;ApGmigBhB;AoGligBgB;EACE,cvBx3DM;A7E45jBxB;AoGhigBY;EACE,yBvB13DO;A7E45jBrB;AoGhigBgB;EACE,cvBh4DM;EuBi4DN,yBvBp4DA;EuBq4DA,yBAAA;ApGkigBlB;AoGjigBkB;EACE,cvBp4DI;A7Eu6jBxB;AoG9hgBgB;EACE,W3F9jEV;AT8lkBR;AoG7hgBc;EACE,yBvBl5DE;A7Ei7jBlB;AoG5hgBY;EACE,yBvBr5DI;A7Em7jBlB;AoG7hgBc;EACE,yBvBv5DE;EuBw5DF,yBAAA;ApG+hgBhB;AoGxhgBM;EACE,4BAAA;ApG0hgBR;AoGthgBM;;EAEE,yBvBt6DU;EuBu6DV,gCAAA;ApGwhgBR;AoGvhgBQ;;;;EAEE,qBvBn6DgB;A7E87jB1B;AoG1hgBU;;;;EACE,sBAAA;ApG+hgBZ;AoG7hgBU;;;;EACE,cvB56DY;A7E88jBxB;AoG3hgBI;EACE,qBvBh7DoB;A7E68jB1B;AoG1hgBM;EACE,yBvB37DU;EuB47DV,qBvBr7DkB;A7Ei9jB1B;AoGzhgBY;EACE,cvB77DU;A7Ew9jBxB;AoG1hgBc;EACE,cvB/7DQ;A7E29jBxB;AoGnhgBQ;EACE,qBvBr8DgB;A7E09jB1B;AoGnhgBQ;EACE,yBvB/8DQ;EuBg9DR,gCAAA;ApGqhgBV;AoGphgBU;EACE,cvB/8DY;A7Eq+jBxB;AoGnhgBY;EACE,cvBn9DU;A7Ew+jBxB;AoGhhgBU;EACE,qBvBr9Dc;A7Eu+jB1B;AoGjhgBY;EACE,gBAAA;ApGmhgBd;AoGjhgBY;EACE,yBvBj+DI;A7Eo/jBlB;AoG7ggBgB;;;EACE,cvBr+DM;A7Es/jBxB;AoGxggBM;EACE,yBvBl/DU;A7E4/jBlB;AoGxggBM;EACE,yBvBr/DU;A7E+/jBlB;AoGzggBQ;EACE,cvBp/Dc;A7E+/jBxB;AoGvggBQ;EACE,cvBz/Dc;A7EkgkBxB;AoGhggBQ;EACE,cvBngEc;A7EqgkBxB;AoG//fU;EACE,yBvB3gEM;A7E4gkBlB;AoG7/fU;EAEE,cvB7gEY;A7E2gkBxB;AoGr/fU;EACE,cvBvhEY;A7E8gkBxB;AoGp/fY;EACE,cvB3hEU;A7EihkBxB;AoGh/fY;EACE,yBvBriEI;A7EuhkBlB;AoGj/fc;EACE,cvBpiEQ;A7EuhkBxB;AoG9+fY;EACE,cvB1iEU;A7E0hkBxB;AoG/+fc;EACE,W3FhuER;ATitkBR;AoG/+fc;EACE,yB3FltET;ATmskBP;AoG1+fY;EACE,oCAAA;ApG4+fd;AoG1+fgB;EACE,cvB1jEM;A7EsikBxB;AoGn+fM;EACE,yBvBvkEU;A7E4ikBlB;AoGn+fU;EACE,cvBvkEY;A7E4ikBxB;AoG59fU;;EACE,qBvB7kEc;A7E4ikB1B;AoG79fU;;EACE,sB3FxwEJ;ATwukBR;AoG99fU;;EACE,W3F3wEJ;AT4ukBR;AoG79fc;;EACE,c3FrpEC;ATqnkBjB;AoG59fc;;EACE,W3FrxER;ATovkBR;AoGt9fQ;EACE,yBvB9mEQ;A7EskkBlB;AoGv9fU;EACE,yBvBhnEM;A7EykkBlB;AoGx9fY;EACE,yB3FlxEP;AT4ukBP;AoGv9fU;EACE,yBvBtnEM;A7E+kkBlB;AoGj9fY;EACE,W3FhzEN;ATmwkBR;AoG18fU;EACE,cvBtoEY;A7EklkBxB;AoGx8fM;EACE,mBvB/oEU;A7EylkBlB;AoGt8fM;EACE,yBvB7oEa;A7EqlkBrB;AoGt8fM;EACE,yBvBvpEU;A7E+lkBlB;AoGt8fM;;EAEE,c3F1zED;ATkwkBP;AoGj8fQ;;;;;;;;;;EAUE,gCAAA;ApGm8fV;AoGj8fQ;EACE,cvB3qEc;A7E8mkBxB;AoGj8fQ;EACE,6BAAA;ApGm8fV;AoGh8fM;;EAEE,yBvBtrEU;A7EwnkBlB;AoGj8fQ;;EACE,cvBrrEc;A7EynkBxB;AoG37fU;EACE,6BAAA;ApG67fZ;AoGn7fM;EACE,oCAAA;ApGq7fR;AoGn7fM;EACE,yBvBjtEU;EuBktEV,YAAA;ApGq7fR;AoGh7fI;EACE,yBvBxtEY;A7E0okBlB;AoGh7fQ;EACE,gCAAA;ApGk7fV;AoG36fM;EACE,yBvBnuEU;EuBouEV,qBvB5tEkB;A7EyokB1B;AoGz6fQ;EACE,yBvBxuEQ;EuByuER,qBvBluEgB;A7E6okB1B;AoG16fU;EACE,yBvB3uEM;EuB4uEN,gBAAA;ApG46fZ;AoG16fU;EACE,yBvB5uEY;A7EwpkBxB;AoG16fU;EACE,4BvB/uEY;A7E2pkBxB;AoG16fU;EACE,qBvB9uEc;EuB+uEd,yBvBtvEM;A7EkqkBlB;AoG36fY;;EAEE,yBvB1vEI;A7EuqkBlB;AoGr6fM;EACE,yBvBnwEU;A7E0qkBlB;AoGt6fQ;EACE,cvBjwEc;A7EyqkBxB;AoGl6fI;EACE,yBvB5wEY;EuB6wEZ,gBAAA;ApGo6fN;AoGn6fM;EACE,qBvBvwEkB;A7E4qkB1B;AoGp6fQ;EACE,cvB7wEc;A7EmrkBxB;AoG95fQ;;EAEE,W3F38EF;AT22kBR;AoG55fQ;EACE,yBvBzxEW;A7EurkBrB;AoG15fQ;EACE,yBvB9xEW;A7E0rkBrB;AoGx5fQ;;EAEE,c3Fh9EF;AT02kBR;AoGn5fM;EACE,yBvBnzEU;A7EwskBlB;AoGl5fU;EAEE,yBvBvzEM;A7E0skBlB;AoGh5fU;EACE,oCAAA;ApGk5fZ;AoG/4fU;EACE,evB5zEY;A7E6skBxB;AoGz4fI;EACE,yBvBz0EY;A7EotkBlB;AoGz4fQ;EACE,cvBx0Ec;A7EmtkBxB;AoGx4fM;EACE,yBvB/0EU;EuBg1EV,gCAAA;ApG04fR;AoGr4fM;EACE,yBvBt1EU;A7E6tkBlB;AoGj4fM;EACE,2HAAA;ApGm4fR;AoG53fM;EACE,oCAAA;ApG83fR;AoG33fY;EACE,yBAAA;ApG63fd;AoG33fY;EACE,oCAAA;ApG63fd;AoGz3fc;EACE,cvB92EQ;A7EyukBxB;AoGx3fY;EAEE,wCAAA;ApGy3fd;AoGp3fc;;EAEE,oCAAA;ApGs3fhB;AoGl3fc;EACE,Y3FnjFR;ATu6kBR;AoGj3fgB;;EAEE,8BAAA;ApGm3flB;AoGj3fgB;EACE,8BAAA;ApGm3flB;AoG52fY;EACE,8BAAA;ApG82fd;AoG32fY;EACE,8BAAA;ApG62fd;AoGt2fQ;EACE,mBvB95EQ;A7EswkBlB;;A6E3wkBA;;0DAAA;AwBjKE;EACE,sCAAA;ArGk7kBJ;AqG/6kBI;EACE,yBxBiKY;A7EgxkBlB;AqGh7kBM;EACE,iGAAA;ArGk7kBR;AqGx6kBY;EACE,yBxBmJI;A7EuxkBlB;AqGn6kBU;EACE,yBAAA;ArGq6kBZ;AqGl6kBY;EACE,yBAAA;ArGo6kBd;AqG75kBc;EACE,sEAAA;EAKA,iDAAA;ArG25kBhB;AqGv5kBc;EACE,sEAAA;EAKA,iDAAA;ArGq5kBhB;AqG34kBM;EACE,yBxBsGU;A7EuykBlB;AqG34kBU;EACE,cxBsGY;A7EuykBxB;AqG14kBY;EACE,yBxB8FI;A7E8ykBlB;AqGz4kBU;;EAEE,cxB6FY;A7E8ykBxB;AqGz4kBU;EACE,yBxBuFM;A7EozkBlB;AqGz4kBc;EACE,W5F7FR;ATw+kBR;AqGt4kBgB;EACE,yBxB8EA;A7E0zkBlB;AqGp4kBgB;;EAEE,cxB2EM;A7E2zkBxB;AqG/3kBU;;EAEE,W5FlHJ;ATm/kBR;AqG73kBU;EACE,mBxB0DM;EwBzDN,kBAAA;ArG+3kBZ;AqG73kBU;EACE,yBxBsDM;A7Ey0kBlB;AqG93kBY;EACE,UAAA;ArGg4kBd;AqG/3kBc;EACE,6BAAA;ArGi4kBhB;AqGp3kBY;EACE,8BAAA;ArGs3kBd;;A6Ev1kBA;;0DAAA;AyBvLE;EACE,aAAA;AtGohlBJ;;AsG9glBE;EACE,iBAAA;EACA,kBAAA;AtGihlBJ;AsGhhlBI;EACE,WAAA;EACA,YAAA;AtGkhlBN;AsG/glBI;EACE,mBAAA;EACA,mBAAA;AtGihlBN;AsG9glBI;EACE,mB7FTI;ATyhlBV;;AuG3hlBA;EAAgB,4BAAA;AvG+hlBhB;;AuG9hlBA;EAAgB,4BAAA;AvGkilBhB;;AuGjilBA;EAAgB,4BAAA;AvGqilBhB;;AuGlilBA;EAAiB,4BAAA;AvGsilBjB;;AuGrilBA;EAAiB,4BAAA;AvGyilBjB;;AuGxilBA;EAAiB,4BAAA;AvG4ilBjB;;AuG3ilBA;EAAiB,4BAAA;AvG+ilBjB;;AuG9ilBA;EAAiB,4BAAA;AvGkjlBjB;;AuG/ilBA;EAAgB,0BAAA;AvGmjlBhB;;AuGljlBA;EAAgB,0BAAA;AvGsjlBhB;;AuGrjlBA;EAAgB,0BAAA;AvGyjlBhB;;AuGxjlBA;EAAgB,0BAAA;AvG4jlBhB;;AuG3jlBA;EAAgB,0BAAA;AvG+jlBhB;;AuGzjlBA;ECJE,gBAHW;AxGoklBb;;AuG5jlBA;ECLE,gBAHW;AxGwklBb;;AuG/jlBA;ECNE,gBAHW;AxG4klBb;;AuGlklBA;ECPE,gBAHW;AxGgllBb;;AuGrklBA;ECRE,gBAHW;AxGollBb;;AuGtklBA;EAAe,kBAAA;AvG0klBf;;AuGzklBA;EAAkB,gBAAA;AvG6klBlB;;AuGzklBE;EACE,gBAAA;AvG4klBJ;;AyGznlBA;EACE,sBAAA;EACA,cAAA;EACA,cjGqCQ;EiGpCR,sBhGqQO;ECvPL,sBAAA;AV+mlBJ;;AyG1nlBA;EACE,qBAAA;AzG6nlBF;AyG5nlBE;EACE,wCAAA;AzG8nlBJ;;A0GhnlBE;EACE,gBAAA;A1GmnlBJ;A0G/mlBI;;EAEE,oBAAA;EACA,uBAAA;EACA,yCAAA;EACA,wCAAA;A1GinlBN;A0G7mlBE;;;EAGE,gBAAA;EACA,sCAAA;A1G+mlBJ;;A0G3mlBA;EACE,iBAAA;EACA,sCAAA;A1G8mlBF;;A0G3mlBA;EACE,yCAAA;EACA,yCAAA;A1G8mlBF;;A0G1mlBA;EACE,YAAA;E1FxDA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;AhBsqlBF;;A0GhnlBA;EvF1DE,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AnB6qlBF;;A0GtnlBA;EvF9CE,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AnBwqlBF;AiBnolBI;EyFIJ;IvFpCI,cAAA;IACA,UAAA;EnBuqlBF;AACF;AiBzolBI;EyFIJ;IvFpCI,cAAA;IACA,mBAAA;EnB6qlBF;AACF;;A0G/nlBA;EvF1DE,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AnB6rlBF;AiBxplBI;EyFgBJ;IvFhDI,cAAA;IACA,UAAA;EnB4rlBF;AACF;AiB9plBI;EyFgBJ;IvFhDI,cAAA;IACA,mBAAA;EnBkslBF;AACF;;A2GvtlBE;;EAEE,mBAAA;A3G0tlBJ;;A2GptlBE;EACE,mBAAA;A3GutlBJ;A2GrtlBE;;EAEE,aAAA;EACA,sBAAA;A3GutlBJ;A2GptlBE;EACE,kB9BgJiB;A7EsklBrB;;A2GjtlBA;EACE,WlGxBM;EkGyBN,yBlGZK;ATgulBP;;A2GhtlBA;EACE,yBlG7BQ;ATgvlBV;A2GjtlBI;EACE,6BAAA;EACA,gBAAA;EACA,sBlGnCE;ATsvlBR;A2GhtlBE;;EAEE,SAAA;A3GktlBJ;A2G/slBI;EACE,0BAAA;EACA,sBlG7CE;AT8vlBR;A2GhtlBM;EACE,2BAAA;A3GktlBR;;A4GxwlBE;EACE,kBAAA;EACA,4BAAA;EACA,yBAAA;A5G2wlBJ;A4GnwlBI;EACE,yBAAA;EACA,yBAAA;A5GwwlBN;A4GrwlBM;EACE,enGOD;ATgwlBP;;A4GjwlBA,uBAAA;AAGA;EACE,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;A5GkwlBF;;A4G9vlBA;EACE,mBAAA;EACA,eAAA;A5GiwlBF;;A4G7vlBA;EACE,qBAAA;A5GgwlBF;A4G/vlBE;;EAEE,SAAA;A5GiwlBJ;;A4G5vlBA;EACE,0CAAA;EACA,cAAA;A5G+vlBF;;A4G5vlBA;EACE,cnGzCS;EmG0CT,iBAAA;EACA,mBAAA;EACA,gCAAA;A5G+vlBF;;A4G5vlBA;;GAAA;AAKA;EACE,8CAAA;EACA,eAAA;EACA,gBAAA;A5G6vlBF;A4G3vlBE;EACE,yBnGhEM;AT6zlBV;A4G3vlBE;EACE,kBAAA;A5G6vlBJ;A4G3vlBE;EACE,iBAAA;A5G6vlBJ;A4G1vlBE;EACE,aAAA;EACA,iDAAA;EACA,aAAA;EACA,mBAAA;A5G4vlBJ;AiB1wlBI;E2FkBA;IACE,sBAAA;IACA,mBAAA;E5G2vlBJ;AACF;;AiB7xlBI;E2F0CE;IACE,iBAAA;E5GuvlBN;AACF;;A4GjvlBA;EACE,aAAA;A5GovlBF;A4GnvlBE;EACE,kBAAA;A5GqvlBJ;;A4GhvlBA;EACE,eAAA;A5GmvlBF;A4GlvlBE;EACE,iBAAA;A5GovlBJ;;A4G/ulBA;EACE,sBAAA;A5GkvlBF;A4GjvlBE;EACE,sBAAA;EACA,YAAA;A5GmvlBJ;;A4G7ulBE;EAGE,2EAAA;EACA,qCAAA;EACA,4BAAA;EACA,wBAAA;EACA,qBAAA;EACA,qBAAA;A5G8ulBJ;;A4GzulBA;EACE,oCAAA;EACA,qBAAA;EACA,wBAAA;A5G4ulBF;;A4GxulBA;EACE,yBAAA;EACA,qBAAA;A5G2ulBF;;A4GvulBA;EACE,aAAA;EACA,cAAA;EACA,WAAA;A5G0ulBF;;A4GxulBA;EACE,aAAA;EACA,cAAA;EACA,WAAA;A5G2ulBF;;A4GrulBI;EACE,yBnGvJC;EmGwJD,qBnGxJC;ATg4lBP;;A4G5tlBA,yBAAA;AACA;EACE,kBAAA;EACA,qBAAA;A5G+tlBF;A4G3tlBI;EACE,kBAAA;EACA,aAAA;A5G6tlBN;A4GvtlBI;EACE,iBAAA;A5GytlBN;A4GptlBE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA;EACA,iCAAA;EACA,eAAA;EACA,4BAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;A5GstlBJ;A4GntlBE;;EAEE,eAAA;A5GqtlBJ;A4G3slBM;;;EACE,yBAAA;EACA,iCAAA;EACA,UAAA;A5G+slBR;A4G3slBM;;EACE,uCAAA;A5G8slBR;A4G1slBI;;EACE,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;A5G6slBN;A4GvslBI;EACE,UAAA;A5GyslBN;;A4GpslBA,0BAAA;AACA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;A5GuslBF;A4GtslBE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,MAAA;A5GwslBJ;A4GtslBM;EACE,uBAAA;EACA,qBnGjQD;ATy8lBP;A4GvslBQ;EACE,uBAAA;EACA,yBnGpQH;AT68lBP;A4GxslBU;EACE,uBAAA;EACA,gBAAA;EACA,UAAA;A5G0slBZ;A4GtslBU;EACE,kBAAA;A5GwslBZ;A4GpslBU;EACE,iBAAA;A5GsslBZ;A4GhslBM;EACE,yBAAA;EACA,yBnG1RD;AT49lBP;A4GjslBQ;EACE,UAAA;EACA,yBAAA;A5GmslBV;A4G/rlBI;EACE,eAAA;EACA,oBAAA;A5GislBN;A4GhslBM;EACE,eAAA;EACA,YAAA;A5GkslBR;A4G9rlBE;EACE,eAAA;EACA,kBAAA;EACA,W/BhMc;E+BiMd,Y/BjMc;E+BkMd,iB/BpM6B;E+BqM7B,mBAAA;EACA,qBnG3TO;EmG4TP,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,oBAAA;A5GgslBJ;A4G/rlBI;EACE,W/B1Me;E+B2Mf,Y/B3Me;A7E44lBrB;A4G/rlBI;EACE,W/B7Me;E+B8Mf,Y/B9Me;A7E+4lBrB;A4G/rlBI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,OAAA;EACA,0BAAA;EACA,uBAAA;EACA,yBAAA;EACA,WAAA;A5GislBN;A4GhslBM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WnG9VA;ATgimBR;;A4G5rlBA,uBAAA;AACA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;A5G+rlBF;A4G9rlBE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;A5GgslBJ;A4G9rlBM;EACE,uBAAA;EACA,UAAA;A5GgslBR;A4G/rlBQ;EACE,mBAAA;EACA,iDAAA;EACA,UAAA;EACA,mBAAA;A5GislBV;A4G/rlBQ;EACE,UAAA;EACA,qBAAA;A5GislBV;A4G7rlBI;EACE,eAAA;EACA,oBAAA;A5G+rlBN;A4G9rlBM;EACE,eAAA;EACA,YAAA;A5GgslBR;A4G5rlBM;EACE,qBAAA;A5G8rlBR;A4G1rlBE;EACE,eAAA;EACA,kBAAA;EACA,W/BlRW;E+BmRX,Y/BnRW;E+BoRX,yBAAA;EACA,oBAAA;A5G4rlBJ;A4G3rlBI;EACE,W/BtRY;E+BuRZ,Y/BvRY;A7Eo9lBlB;A4G3rlBI;EACE,W/BzRY;E+B0RZ,Y/B1RY;A7Eu9lBlB;A4G3rlBI;;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,0BAAA;EACA,MAAA;EACA,kBAAA;A5G6rlBN;A4G3rlBI;EACE,uBAAA;EACA,yBAAA;A5G6rlBN;A4G1rlBI;EACE,UAAA;EACA,qBAAA;A5G4rlBN;;A4GvrlBA,aAAA;AAEA;EACE,eAAA;EAyDA,mBAAA;EAaA,8BAAA;A5GqnlBF;A4GzrlBE;EACE,gBAAA;EACA,aAAA;EACA,UAAA;EAEA,0BAAA;EAaA,oBAAA;EAYA,kBAAA;A5GmqlBJ;A4G3rlBI;EACE,YAAA;EACA,yB/B3RY;E+B4RZ,gBAAA;EACA,gBAAA;EACA,2BAAA;EACA,0BAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,MAAA;EACA,OAAA;A5G6rlBN;A4G1rlBI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,sBnGldE;EmGmdF,0BAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;A5G4rlBN;A4GxrlBI;;;;EAIE,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;A5G0rlBN;A4GxrlBI;;EAEE,SAAA;EACA,WnGteE;ATgqmBR;A4GxrlBI;;EAEE,UAAA;A5G0rlBN;A4GxrlBI;EACE,UAAA;A5G0rlBN;A4GprlBE;EACE,kBAAA;A5GsrlBJ;A4GjrlBE;EACE,gBAAA;EACA,yBnG1eG;AT6pmBP;A4G/qlBE;EACE,6BAAA;A5GirlBJ;A4G9qlBI;EACE,UAAA;A5GgrlBN;A4G9qlBI;EACE,UAAA;A5GgrlBN;A4G5qlBI;EACE,UAAA;A5G8qlBN;A4G5qlBI;EACE,UAAA;A5G8qlBN;A4G3qlBE;EACE,yB/B5Wc;A7EyhmBlB;A4GvqlBI;EACE,W/BjXW;E+BkXX,gBAAA;A5GyqlBN;A4GxqlBM;EACE,W/BpXS;E+BqXT,YAAA;EACA,yB/BxXU;E+ByXV,gBAAA;EACA,gBAAA;EACA,2BAAA;EACA,0BAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;A5G0qlBR;A4GxqlBM;EACE,gBAAA;EACA,sBnGziBA;EmG0iBA,0BAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;A5G0qlBR;A4GxqlBM;;EAEE,UAAA;A5G0qlBR;A4GxqlBM;;EAEE,SAAA;A5G0qlBR;A4GvqlBI;EACE,6BAAA;A5GyqlBN;A4GnqlBI;EACE,a/BxZW;E+ByZX,gBAAA;A5GqqlBN;A4GpqlBM;EACE,a/B3ZS;E+B4ZT,YAAA;EACA,yB/BhaU;E+BiaV,gBAAA;EACA,gBAAA;EACA,2BAAA;EACA,0BAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;A5GsqlBR;A4GpqlBM;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,gBAAA;EACA,sBnGplBA;EmGqlBA,0BAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;A5GsqlBR;A4GpqlBM;;EAEE,WAAA;A5GsqlBR;A4GnqlBI;EACE,6BAAA;A5GqqlBN;;A4GhqlBA,0BAAA;AAEA;EACE,yBnGtlBK;EmGulBL,WnGxmBM;EmGymBN,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,kBAAA;A5GkqlBF;;A4G/plBA,gCAAA;AAKM;EACE,sBAAA;EACA,gDAAA;EACA,YAAA;EACA,WAAA;A5G8plBR;A4GxplBM;EACE,sBAAA;EACA,+CAAA;EACA,YAAA;EACA,WAAA;A5G0plBR;;A4GpplBA,yCAAA;AAIE;;EACE,eAAA;A5GqplBJ;;A4GjplBA,gCAAA;AA2BA,2DAAA;AACA;;EAEE,wBAAA;A5G0nlBF;;A4GnnlBE;EACE,sBnGvrBI;AT6ymBR;;A4GhnlBE;EACE,YAAA;A5GmnlBJ;A4G7mlBM;;EACE,OAAA;A5GgnlBR;A4G5mlBI;;;;;;;;EAIE,SAAA;A5GknlBN;A4G7mlBM;EACE,kBAAA;A5G+mlBR;A4G1mlBM;;EACE,gBAAA;EACA,iBAAA;A5G6mlBR;A4GvmlBM;EACE,iBAAA;A5GymlBR;;A4G9llBM;EACE,yBAAA;EACA,4BAAA;A5GimlBR;A4G3llBM;EACE,0BAAA;EACA,6BAAA;A5G6llBR;;A6G31mBE;EACE,eAAA;A7G81mBJ;A6G31mBE;EACE,cpGwES;ATqxmBb;A6G51mBI;EAGE,yBAAA;A7G41mBN;A6Gv1mBE;EACE,WpGPI;ATg2mBR;A6Gx1mBI;EACE,gChCqBe;A7Eq0mBrB;A6Gr1mBE;EACE,WpGfI;ATs2mBR;A6Gt1mBI;EACE,mCAAA;A7Gw1mBN;A6Gp1mBI;EACE,mCAAA;A7Gs1mBN;A6Gl1mBI;EACE,mCAAA;A7Go1mBN;A6G/0mBE;EAGE,iBAAA;A7G+0mBJ;A6G10mBI;EACE,0CAAA;A7G40mBN;A6G10mBI;EAEE,mBpGtCK;ATi3mBX;A6Gt0mBI;EACE,uCAAA;A7Gw0mBN;A6Gt0mBI;EAEE,mBpG7CK;EoG8CL,WpGxDE;AT+3mBR;A6Gl0mBI;EACE,0CAAA;A7Go0mBN;A6Gl0mBI;EAEE,mBpGhEK;ATm4mBX;A6G9zmBE;EACE,+BAAA;EACA,kCAAA;A7Gg0mBJ;A6G/zmBI;EACE,6BAAA;EACA,gCAAA;A7Gi0mBN;A6G/zmBI;EACE,+BAAA;EACA,kCAAA;A7Gi0mBN;A6G5zmBE;EACE,yBpG/EO;EoGgFP,+CAAA;EACA,WpGxFI;ATs5mBR;A6G5zmBI;EACE,WpG3FE;ATy5mBR;A6G3zmBI;EAEE,aAAA;EACA,0BAAA;A7G4zmBN;A6GzzmBE;EACE,yBpGnGO;EoGoGP,+CAAA;EACA,WpGvGI;ATk6mBR;A6GzzmBI;EACE,WpG1GE;ATq6mBR;A6GxzmBI;EAEE,aAAA;EACA,0BAAA;A7GyzmBN;A6GtzmBE;EACE,yBpG1GO;EoG2GP,qDAAA;EACA,WpGtHI;AT86mBR;A6GtzmBI;EACE,WpGzHE;ATi7mBR;A6GrzmBI;EAEE,aAAA;EACA,0BAAA;A7GszmBN;A6GjzmBE;EACE,0BAAA;A7GmzmBJ;A6GhzmBI;EACE,eAAA;A7GkzmBN;A6G7ymBI;EACE,aAAA;A7G+ymBN;A6G1ymBE;EnG7IE,gBAAA;AV07mBJ;A6GzymBE;EnGjJE,mBAAA;AV67mBJ;A6GxymBE;EAIE,aAAA;EACA,2BAAA;A7GuymBJ;A6GpymBI;EACE,cAAA;EACA,aAAA;A7GsymBN;;A6G/xmBI;EACE,qCAAA;EACA,wCAAA;A7GkymBN;A6G9xmBI;EACE,yBAAA;EACA,4BAAA;A7GgymBN;;A6GzxmBI;EACE,wCAAA;EACA,uCAAA;A7G4xmBN;A6GxxmBI;EACE,yBAAA;EACA,0BAAA;A7G0xmBN;;A6G7wmBA;;;;EAIE,eAAA;A7GgxmBF;;A6G5wmBA;EACE,cAAA;A7G+wmBF;;A8Gp/mBE;EACE,kBAAA;A9Gu/mBJ;A8Gn/mBI;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,+BAAA;EACA,iBAAA;A9Gq/mBN;A8Gl/mBI;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,+BAAA;EACA,iBAAA;A9Go/mBN;A8G/+mBI;EACE,kBAAA;A9Gi/mBN;A8G/+mBM;EAEE,UAAA;EACA,WAAA;A9Gg/mBR;A8G79mBM;EACE,yBAAA;A9G+9mBR;A8G19mBM;EACE,0BAAA;A9G49mBR;;A+GphnBM;;EACE,WtGKA;ATmhnBR;A+GphnBE;;EAEE,uBAAA;A/GshnBJ;A+GrhnBI;;ErGKA,mBAAA;AVohnBJ;A+GphnBE;EACE,qBAAA;EACA,sDAAA;EACA,yBAAA;EACA,4BAAA;A/GshnBJ;A+GnhnBE;EACE,yBAAA;A/GqhnBJ;A+GnhnBI;EACE,WtGlBE;ATuinBR;A+GhhnBE;EACE,qCAAA;EACA,kBtGqKqB;EsGpKrB,sBAAA;EACA,yCAAA;EAEA,eAAA;A/GihnBJ;A+GhhnBI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,gBtGtCE;EsGuCF,wCAAA;EACA,wCAAA;EACA,yCAAA;EACA,WAAA;EACA,sBAAA;A/GkhnBN;A+G9gnBM;EACE,aAAA;EACA,UAAA;A/GghnBR;A+G5gnBI;EACE,0BAAA;EACA,oBAAA;A/G8gnBN;A+G3gnBI;EACE,oBAAA;EACA,ctGSO;EsGRP,WAAA;EACA,eAAA;A/G6gnBN;A+G5gnBM;EACE,yBtG/DE;EsGgEF,ctGhDD;AT8jnBP;A+G7gnBQ;;EAEE,ctGnDH;ATkknBP;A+G5gnBM;EACE,WtGxEA;ATslnBR;A+G3gnBM;EACE,6BAAA;EACA,2BvGioC4B;AR44kBpC;A+G1gnBM;EACE,ctG1EG;ATslnBX;A+GpgnBM;EACE,aAAA;A/GsgnBR;;A+GhgnBA;;;;EAIE,kBAAA;A/GmgnBF;A+GjgnBI;;;;EACE,0BAAA;A/GsgnBN;A+GlgnBI;;;;;;;EAEE,aAAA;A/GygnBN;;A+GpgnBE;EACE,sBAAA;EACA,UAAA;EACA,cAAA;A/GugnBJ;;A+GhgnBE;EAYE,aAAA;A/Gw/mBJ;A+Gt/mBE;EACE,kBAAA;EACA,UAAA;A/Gw/mBJ;A+Gt/mBE;EACE,+CAAA;A/Gw/mBJ;A+Gv/mBI;EACE,OAAA;A/Gy/mBN;A+Gn/mBI;EACE,aAAA;A/Gq/mBN;A+Gh/mBE;EACE,UAAA;A/Gk/mBJ;;A+G3+mBI;EACE,oBAAA;EACA,mBAAA;EACA,UAAA;A/G8+mBN;;A+Gx+mBA;;;GAAA;AAQI;EAEE,yBAAA;A/Gs+mBN;;A+Gh+mBA;EACE,kBAAA;A/Gm+mBF;A+Gl+mBE;;EAEE,uBAAA;A/Go+mBJ;A+Gl+mBE;EACE,qBAAA;EACA,iDAAA;A/Go+mBJ;A+Gh+mBI;EACE,2BAAA;EACA,uBAAA;A/Gk+mBN;A+G99mBI;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBtGxNE;EsGyNF,wCAAA;EACA,2CAAA;EACA,0CAAA;EACA,WAAA;EACA,sBAAA;A/Gg+mBN;A+G79mBM;EACE,UAAA;EACA,eAAA;A/G+9mBR;A+G19mBI;EACE,YAAA;EACA,MAAA;A/G49mBN;;A+Gr9mBE;;EAEE,uBAAA;A/Gw9mBJ;A+Gt9mBE;EACE,qBAAA;A/Gw9mBJ;A+G/8mBI;EACE,WAAA;A/Gi9mBN;A+G78mBI;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBtG3QE;EsG4QF,yCAAA;EACA,wCAAA;EACA,yCAAA;EACA,WAAA;EACA,sBAAA;A/G+8mBN;;A+Gx8mBE;;EAEE,uBAAA;A/G28mBJ;A+Gz8mBE;EACE,qBAAA;A/G28mBJ;A+Gv8mBI;EACE,uBAAA;EACA,sBAAA;EACA,2BAAA;A/Gy8mBN;A+Gr8mBI;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBtG/SE;EsGgTF,yCAAA;EACA,2CAAA;EACA,0CAAA;EACA,WAAA;EACA,sBAAA;A/Gu8mBN;;A+G77mBM;;EACE,aAAA;A/Gi8mBR;A+G/7mBM;;EACE,OAAA;A/Gk8mBR;A+G/7mBI;;EACE,eAAA;A/Gk8mBN;A+Gj8mBM;;EACE,sBAAA;EACA,eAAA;A/Go8mBR;A+Gn8mBQ;;EACE,WtG3UF;ATixnBR;;A+G77mBE;EACE,yBAAA;A/Gg8mBJ;A+G97mBE;EACE,ctGnRS;ATmtnBb;;AgHpynBA;;;;;;;;;iGAAA;AAYE;;;EAGE,sBvGHI;ATwynBR;;AgHxvnBA;EACE,cAAA;EACA,qHAAA;EAMA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,MAAA;EACA,WAAA;AhHsvnBF;;AgHnvnBA;EACE,YAAA;EACA,kBAAA;EACA,kDvGoCsB;EuGnCtB,0BAAA;EACA,qHAAA;EAMA,aAAA;EA6TA,iBAAA;AhHq7mBF;AgHjvnBE;EACE,WnCbkB;A7EgwnBtB;AgH7unBQ;EACE,sBAAA;AhH+unBV;AgH7unBY;;EAEE,yBAAA;AhH+unBd;AgH5unBc;;EAEE,sBAAA;AhH8unBhB;AgHzunBQ;;EAEE,sBAAA;AhH2unBV;AgHrunBE;EACE,uBAAA;EACA,qBAAA;EACA,eAAA;EACA,sCAAA;EACA,WAAA;EACA,QAAA;AhHuunBJ;AgHpunBE;EACE,uBAAA;EACA,2BAAA;AhHsunBJ;AgHnunBE;EACE,WAAA;AhHqunBJ;AgHjunBE;EACE,gCAAA;AhHmunBJ;AgHhunBE;EACE,gCAAA;AhHkunBJ;AgH9tnBE;EACE,4CAAA;AhHgunBJ;AgH3tnBI;EACE,aAAA;AhH6tnBN;AgHztnBE;EACE,gBAAA;AhH2tnBJ;AgH1tnBI;EACE,wBAAA;AhH4tnBN;AgH1tnBI;EACE,kBAAA;EACA,uBAAA;EACA,gBAAA;AhH4tnBN;AgHxtnBE;EACE,kBvGjIK;EuGmIL,0BAAA;EACA,mBAAA;EACA,cAAA;AhHytnBJ;AgHvtnBM;EACE,gBAAA;AhHytnBR;AgHxtnBQ;EACE,8BAAA;AhH0tnBV;AgHxtnBY;EACE,cvG1JP;ATo3nBP;AgHrtnBU;EACE,aAAA;AhHutnBZ;AgHltnBQ;EACE,oBAAA;AhHotnBV;AgH9snBI;EACE,UAAA;AhHgtnBN;AgH3snBQ;EACE,SAAA;EAEA,gBAAA;AhH4snBV;AgHzsnBQ;EACE,6BAAA;AhH2snBV;AgHzsnBU;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AhH2snBZ;AgHtsnBU;EACE,uBAAA;AhHwsnBZ;AgHtsnBU;EACE,gBAAA;AhHwsnBZ;AgHpsnBQ;EACE,cvGxJG;EuGyJH,8BAAA;AhHssnBV;AgHpsnBU;EACE,oBAAA;AhHssnBZ;AgHjsnBU;EACE,WAAA;EACA,sBAAA;EACA,eAAA;AhHmsnBZ;AgHjsnBY;EACE,aAAA;AhHmsnBd;AgHjsnBc;EAEE,mBvG/NT;ATi6nBP;AgHjsnBgB;;;EAEE,WvGnPV;ATu7nBR;AgH7rnBQ;EACE,oBAAA;EACA,aAAA;EACA,mBAAA;AhH+rnBV;AgH7rnBU;EACE,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AhH+rnBZ;AgH5rnBU;EACE,kBAAA;AhH8rnBZ;AgH5rnBU;EACE,4EAAA;AhH8rnBZ;AgHzrnBQ;EAEE,kCAAA;AhH0rnBV;AgHxrnBU;EACE,kBAAA;AhH0rnBZ;AgHtrnBQ;EACE,qCAAA;AhHwrnBV;AgHprnBU;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,WAAA;EACA,oBAAA;AhHsrnBZ;AgH7qnBQ;EACE,oBAAA;AhH+qnBV;AgH5qnBQ;EACE,iBAAA;EACA,cvG5OG;AT05nBb;AgH7qnBU;EACE,cvGlSL;ATi9nBP;AgH3qnBQ;EACE,iBAAA;EACA,cAAA;AhH6qnBV;AgH1qnBQ;EACE,kBAAA;AhH4qnBV;AgHtqnBI;EACE,YAAA;EACA,qBAAA;AhHwqnBN;AgHtqnBM;EACE,eAAA;AhHwqnBR;AgHvqnBQ;EACE,aAAA;EACA,YAAA;EACA,gCAAA;AhHyqnBV;AgHvqnBU;EACE,mBvG9UF;ATu/nBV;AgHtqnBU;EACE,cvG9QC;ATs7nBb;AgHpqnBU;EACE,mBAAA;AhHsqnBZ;AgHjqnBM;EACE,gCAAA;EACA,gBAAA;AhHmqnBR;AgHlqnBQ;EACE,UAAA;AhHoqnBV;AgH/pnBQ;EACE,eAAA;EACA,6BAAA;AhHiqnBV;AgH9pnBM;EACE,oBAAA;AhHgqnBR;AgH9pnBU;EACE,gBvG/WJ;EuGgXI,gCAAA;AhHgqnBZ;AgH7pnBQ;EACE,YAAA;AhH+pnBV;AgHxpnBI;EACE,cAAA;AhH0pnBN;AgHjpnBE;EACE,iBAAA;AhHmpnBJ;AiBz9nBI;E+FhDF;IACE,sBAAA;IACA,oBAAA;IACA,kBAAA;EhH4goBF;EgH1goBE;IACE,QAAA;IACA,kBAAA;EhH4goBJ;EgHzgoBE;IACE,iBAAA;EhH2goBJ;EgHxgoBE;IACE,kBAAA;IACA,SAAA;IACA,MAAA;IACA,6BAAA;EhH0goBJ;EgHrgoBE;IACE,WAAA;IACA,cAAA;IACA,SAAA;IACA,YAAA;EhHugoBJ;AACF;;AgHpqnBA,6BAAA;A/F/UI;E+FhDF;IACE,sBAAA;IACA,oBAAA;IACA,kBAAA;EhHwioBF;EgHtioBE;IACE,QAAA;IACA,kBAAA;EhHwioBJ;EgHrioBE;IACE,iBAAA;EhHuioBJ;EgHpioBE;IACE,kBAAA;IACA,SAAA;IACA,MAAA;IACA,6BAAA;EhHsioBJ;EgHjioBE;IACE,WAAA;IACA,cAAA;IACA,SAAA;IACA,YAAA;EhHmioBJ;EgHtrnBI;;IACE,WvGzZA;ETkloBN;EgHtrnBI;;IACE,cvGtZG;ET+koBT;AACF;AgH5qnBA;EACE,gBvG5aM;AT0loBR;AgH5qnBE;EACE,gBvG/aI;AT6loBR;AgH1qnBI;EACE,cAAA;AhH4qnBN;AgHxqnBM;EACE,qCAAA;AhH0qnBR;AgHrqnBM;EACE,gCxGksB4B;ARq+lBpC;;AgHjqnBA;EACE,mBvG/bS;ATmmoBX;AgHlqnBE;EACE,sBAAA;AhHoqnBJ;AgHjqnBE;EACE,mBvGtcO;ATymoBX;AgH7pnBI;;EAEE,WvGrdE;EuGsdF,mBvG/cK;AT8moBX;AgH1pnBI;EACE,cAAA;AhH4pnBN;AgHxpnBM;EACE,2CAAA;AhH0pnBR;AgHrpnBM;EACE,cvGneG;AT0noBX;;AgHjpnBA;EASE,gBvGtfM;ATkooBR;AgHppnBE;EACE,mBvGxeO;AT8noBX;AgHppnBI;EACE,WvGlfE;ATwooBR;AgH/onBI;EACE,cAAA;AhHipnBN;AgH9onBI;EACE,cvGvfK;ATuooBX;AgH5onBM;EACE,qCAAA;AhH8onBR;AgHzonBM;EACE,gCxGwnB4B;ARmhmBpC;;AgHronBA;EASE,mBvGjhBS;ATipoBX;AgHxonBE;EACE,gBvGjhBI;AT2poBR;AgHxonBI;EACE,cvG7gBK;ATupoBX;AgHnonBI;EACE,cAAA;AhHqonBN;AgHlonBI;EACE,WvGhiBE;AToqoBR;AgHhonBM;EACE,qCAAA;AhHkonBR;AgH7nnBM;EACE,gCxGslB4B;ARyimBpC;;AgHznnBA;EAIQ;IACE,kBAAA;IACA,UAAA;IACA,UAAA;EhHynnBR;AACF;AgHlnnBE;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,mBvG9jBO;EuG+jBP,kBAAA;EACA,UAAA;EACA,OAAA;EACA,uBAAA;EACA,6BAAA;AhHonnBJ;;AgHhnnBA;EACE,QAAA;AhHmnnBF;;AgHhnnBA;EACE,SAAA;AhHmnnBF;;AgHhnnBA;EACE,SAAA;AhHmnnBF;;AgHhnnBA;EACE,SAAA;EACA,yBAAA;AhHmnnBF;;AgHhnnBA;EACE,UAAA;EACA,WAAA;AhHmnnBF;;AgHhnnBA;EACE,SAAA;EACA,0BAAA;AhHmnnBF;;AiBzpoBI;E+F+iBE;IACE,gBAAA;EhH8mnBN;EgH3mnBI;IACE,qBAAA;EhH6mnBN;EgHvmnBM;IACE,QAAA;IACA,kBAAA;IACA,WAAA;IACA,WAAA;IACA,aAAA;IACA,gBAAA;EhHymnBR;EgHnmnBQ;IACE,oBAAA;EhHqmnBV;EgHlmnBQ;IACE,sBAAA;EhHomnBV;EgHjmnBQ;IACE,eAAA;IACA,iBAAA;EhHmmnBV;EgHzlnBE;;;;;;IAGE,sBvG7pBE;ET2voBN;EgHzlnBM;;IACE,WvGnqBF;ET+voBN;EgHrlnBM;;IACE,cvGpqBC;ET4voBT;EgH1jnBM;;IACE,mBAAA;IACA,qBAAA;EhH6jnBR;AACF;AgHvjnBA;EACE,sBAAA;EACA,kCAAA;AhHyjnBF;;AgHtjnBA;EACE,yBAAA;AhHyjnBF;;AgHtjnBA;EACE,4BAAA;AhHyjnBF;;AgHtjnBA;EACE,yBAAA;AhHyjnBF;;AgHtjnBA;EACE,2BAAA;AhHyjnBF;;AgHpjnBI;EACE,aAAA;AhHujnBN;;AgH9inBM;EACE,8BAAA;AhHijnBR;;AgH1inBA;EAKQ;IACE,gCAAA;EhHyinBR;AACF;AiB3uoBI;E+FgtBQ;IACE,uBAAA;EhH8hnBZ;EgH1hnBQ;IACE,uBAAA;EhH4hnBV;EgHzhnBQ;IACE,eAAA;IACA,iBAAA;EhH2hnBV;AACF;AgHt/mBA;EAfI;IACE,SAAA;IACA,mBAAA;EhHwgnBJ;EgHtgnBI;IACE,kBAAA;EhHwgnBN;EgHrgnBI;IACE,WAAA;EhHugnBN;AACF;AiBnwoBI;E+FkvBA;IACE,SAAA;IACA,mBAAA;EhHohnBJ;EgHlhnBI;IACE,kBAAA;EhHohnBN;EgHjhnBI;IACE,WAAA;EhHmhnBN;AACF;AgHtgnBA,kDAAA;AAEA,cAAA;AAEA;EAtCQ;IACE,iBAsCwB;EhHugnBhC;AACF;AgHrgnBA,sCAAA;AAEA,cAAA;AAEA;EA9CQ;IACE,iBA8CwB;EhHsgnBhC;AACF;AgHpgnBA,+EAAA;AAGE;EACE,kBAAA;EACA,WAAA;EAIA,aAAA;AhHignBJ;AgHpgnBI;EACE,qBAAA;AhHsgnBN;AgH//mBQ;EACE,WvGx2BF;ATy2oBR;AgHx/mBQ;;;EACE,kBAAA;AhH4/mBV;AgHz/mBU;;;EACE,kBAAA;EACA,QAAA;AhH6/mBZ;AgHl/mBM;EACE,iBAAA;AhHo/mBR;AgHn/mBQ;EACE,UAAA;AhHq/mBV;AgH5+mBI;EACE,gBAAA;AhH8+mBN;;AgHx+mBA;EAGM;IACE,mBAAA;EhHy+mBN;EgHr+mBI;IACE,YAAA;EhHu+mBN;AACF;AgHh+mBA;EAGM;IACE,mBAAA;EhHg+mBN;EgH/9mBM;IACE,mBAAA;EhHi+mBR;AACF;AgH39mBA;EAEI;IACE,OAAA;EhH49mBJ;AACF;AgHv9mBA;EAKU;IACE,gBAAA;EhHq9mBV;AACF;AgH78mBE;EACE,qCAAA;EACA,mBAAA;EACA,oBAAA;AhH+8mBJ;;AgH78mBE;EACE,8BAAA;EACA,+BAAA;AhHg9mBJ;;AgH38mBA;EAGM;IACE,eAAA;EhH48mBN;AACF;AiHp7oBA;;EAEE,sBAAA;AjHs7oBF;;AiHp7oBA;EAEE,qBAAA;EACA,YAAA;EACA,qBxGiGc;EwGhGd,+CAAA;EACA,gCAAA;AjHs7oBF;AiHr7oBE;EACE,2BAAA;AjHu7oBJ;AiHr7oBE;EACE,kBAAA;AjHu7oBJ;AiHr7oBE;EACE,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;EACA,cxGiHa;ATs0oBjB;AiHr7oBE;EACE,uEAAA;AjHu7oBJ;AiHp7oBE;EACE,sCzGuyCgC;AR+omBpC;AiHl7oBE;EACE,cAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,uBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;EACA,cAAA;AjHo7oBJ;AiHl7oBE;EACE,mCAAA;AjHo7oBJ;AiHj7oBI;EACE,+BAAA;AjHm7oBN;AiHj7oBI;EACE,yBAAA;AjHm7oBN;AiHh7oBE;EACE,YAAA;EACA,gBAAA;AjHk7oBJ;AiH/6oBE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,wBAAA;EACA,6BAAA;AjHi7oBJ;AiHh7oBI;EACE,gBAAA;AjHk7oBN;AiH/6oBI;EACE,gBAAA;AjHi7oBN;AiH36oBE;EACE,6BAAA;AjH66oBJ;AiH16oBI;EACE,sBAAA;AjH46oBN;AiH36oBM;EACE,eAAA;AjH66oBR;AiHx6oBQ;EACE,yBAAA;EACA,yBAAA;AjH06oBV;AiHr6oBM;EACE,yBAAA;EACA,yBAAA;AjHu6oBR;AiHn6oBM;EACE,uBAAA;EACA,yBAAA;AjHq6oBR;AiHh6oBQ;EACE,uBAAA;EACA,yBAAA;AjHk6oBV;AiH75oBM;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;AjH+5oBR;AiH55oBQ;EACE,YAAA;AjH85oBV;;AiHt5oBE;EACE,qBAAA;AjHy5oBJ;;AiHp5oBE;EACE,YAAA;AjHu5oBJ;AiHn5oBI;EACE,sBAAA;AjHq5oBN;AiHl5oBE;EACE,uBAAA;AjHo5oBJ;;AiHh5oBA;EACE,WxGhJM;ATmipBR;;AiHj5oBA;EACE,6BAAA;AjHo5oBF;;AiH/4oBE;;EAEE,oBAAA;AjHk5oBJ;;AiH34oBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AjH84oBJ;AiH54oBE;EACE,8BAAA;EACA,kBAAA;EACA,mBAAA;AjH84oBJ;AiH74oBI;EACE,kBAAA;EACA,mBAAA;AjH+4oBN;AiH94oBM;EACE,gBAAA;AjHg5oBR;AiH54oBM;EACE,kBAAA;EACA,MAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,WxGxLA;ATskpBR;AiHx4oBE;EACE,+BAAA;EACA,mBAAA;EACA,oBAAA;AjH04oBJ;AiHz4oBI;EACE,kBAAA;EACA,mBAAA;EACA,iBAAA;AjH24oBN;AiH14oBM;EACE,gBAAA;AjH44oBR;AiHz4oBM;EACE,kBAAA;EACA,MAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,WxGhNA;AT2lpBR;;AkHvmpBA;EACE,ezGsHe;EyGrHf,kDzGkHsB;EyGjHtB,6BAAA;EACA,qCAAA;EACA,gBAAA;AlH0mpBF;AkHvmpBI;EACE,qBAAA;EACA,oBAAA;AlHympBN;AkHrmpBE;EACE,eAAA;AlHumpBJ;AkHtmpBI;EACE,gBAAA;EACA,sBAAA;EACA,czG8DO;AT0ipBb;AkHrmpBE;EACE,czG0DS;AT6ipBb;;AkHnmpBA,uCAAA;AAEE;EACE,YAAA;AlHqmpBJ;;AkHjmpBE;EACE,SAAA;EACA,UAAA;AlHompBJ;;AkHhmpBA;EACE,4EAAA;AlHmmpBF;;AkHhmpBA,uBAAA;AAGE;EACE,YAAA;AlHimpBJ;AkHhmpBI;EACE,eAAA;AlHkmpBN;AkH9lpBI;EACE,YAAA;AlHgmpBN;AkH5lpBI;EACE,YAAA;EACA,kBAAA;EACA,SAAA;AlH8lpBN;AkH1lpBI;EACE,YAAA;AlH4lpBN;AkHxlpBI;EACE,YAAA;AlH0lpBN;AkHtlpBI;EACE,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;AlHwlpBN;;AkHllpBE;EACE,2CAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AlHqlpBJ;AkHplpBI;EACE,YAAA;AlHslpBN;;AmHjrpBA;EACE,W1GSM;E0GRN,gBAAA;AnHorpBF;AmHlrpBI;EACE,cAAA;AnHorpBN;AmHjrpBI;EACE,W1GCE;ATkrpBR;AmHhrpBI;EACE,sBAAA;AnHkrpBN;AmH9qpBM;EACE,mBAAA;AnHgrpBR;AmH1qpBE;EACE,gBAAA;AnH4qpBJ;AmHvqpBE;EACE,kBAAA;EACA,UAAA;EACA,YAAA;AnHyqpBJ;AmHxqpBI;EACE,YAAA;EACA,cAAA;AnH0qpBN;;AmHpqpBA;EACE,iBAAA;AnHuqpBF;;AmHrqpBA;EACE,iBAAA;AnHwqpBF;;AmHtqpBA;EACE,eAAA;AnHyqpBF;;AmHvqpBA;EACE,iBAAA;AnH0qpBF;;AmHrqpBE;EACE,eAAA;EACA,iBAAA;AnHwqpBJ;;AmHlqpBE;EACE,eAAA;AnHqqpBJ;;AoHvupBA;EACE,sBAAA;ApH0upBF;AoHvupBE;EACE,sBAAA;ApHyupBJ;AoHxupBI;EACE,gBAAA;ApH0upBN;AoHxupBI;;EAEE,qBAAA;ApH0upBN;AoHrupBE;EACE,gBAAA;ApHuupBJ;AoHrupBM;EACE,gBAAA;ApHuupBR;AoHjupBE;EACE,mBAAA;EACA,eAAA;ApHmupBJ;AoHjupBI;EACE,sBAAA;ApHmupBN;AoH9tpBE;EACE,mBAAA;ApHgupBJ;AoH7tpBM;EACE,uBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,WvCpBK;A7EmvpBb;AoH9tpBQ;EACE,W3GtCF;ATswpBR;AoH9tpBQ;EACE,c3GlCC;ATkwpBX;AoH9tpBQ;EACE,QAAA;EACA,SAAA;ApHgupBV;AoH1tpBU;EACE,W3GpDJ;ATgxpBR;AoHxtpBc;EACE,c3GxCT;ATkwpBP;AoHjtpBI;EC1EF,WAAA;ArH8xpBF;AqH5xpBE;EACE,WAAA;ArH8xpBJ;AqH3xpBE;EACE,kBAAA;EACA,kBAAA;ArH6xpBJ;AqH1xpBE;EACE,SAAA;EACA,UAAA;ArH4xpBJ;AiB9upBI;EoG1CA;IACE,cAAA;IACA,SAAA;ErH2xpBJ;EqHzxpBE;IACI,gBAAA;ErH2xpBN;AACF;AqHlxpBE;EAEE,eAAA;EACA,qB5GkEY;ATitpBhB;AiB3vpBI;EoGpBD;;;IAGG,gCAAA;ErHkxpBJ;AACF;AoHhvpBM;EACE,cAAA;ApHkvpBR;AoHhvpBQ;EACE,YAAA;ApHkvpBV;AoHhvpBU;EAEE,YAAA;ApHivpBZ;AoHtupBY;EACE,yBAAA;EACA,sBAAA;EACA,c3G1EP;E2G2EO,sB3G5FN;ATo0pBR;AoH/tpBE;EACE,oDAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;ApHiupBJ;AoH/tpBI;EACE,kBAAA;ApHiupBN;AoHhupBM;EACE,WvC/FK;EuCgGL,kBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;ApHkupBR;AoHjupBQ;EACE,YAAA;EACA,kBAAA;EACA,c3GxGH;E2GyGG,yBAAA;EACA,sB3G3HF;E2G4HE,2BAAA;ApHmupBV;AoHlupBU;EACE,0BAAA;EACA,WAAA;EACA,WAAA;EACA,OAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,gFAAA;EAKA,yDAAA;EACA,0BAAA;EACA,2BAAA;ApHgupBZ;AoH3tpBU;EACE,QAAA;EACA,SAAA;ApH6tpBZ;AoHztpBQ;EACE,c3GjJC;AT42pBX;AoHttpBI;ECrKF,WAAA;ArH83pBF;AqH53pBE;EACE,WAAA;ArH83pBJ;AqH33pBE;EACE,kBAAA;EACA,kBAAA;ArH63pBJ;AqH13pBE;EACE,SAAA;EACA,UAAA;ArH43pBJ;AiB90pBI;EoG1CA;IACE,cAAA;IACA,SAAA;ErH23pBJ;EqHz3pBE;IACI,gBAAA;ErH23pBN;AACF;AqHl3pBE;EAEE,eAAA;EACA,qB5GkEY;ATizpBhB;AiB31pBI;EoGpBD;;;IAGG,gCAAA;ErHk3pBJ;AACF;AoHnvpBQ;EACE,cAAA;EACA,gBAAA;ApHqvpBV;AoHnvpBU;EACE,YAAA;EACA,sB3GxKJ;AT65pBR;AoHnvpBU;EACE,yBAAA;ApHqvpBZ;;AoH5upBA;EACE,gBAAA;ApH+upBF;AoH3upBM;EACE,YAAA;EACA,gBAAA;ApH6upBR;AoH3upBQ;EACE,YAAA;EACA,gBAAA;ApH6upBV;AoH3upBU;EACE,wBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;ApH6upBZ;AoHzupBQ;EACE,kBAAA;ApH2upBV;AoHrupBI;EACE,WAAA;EACA,cAAA;EACA,kBAAA;ApHuupBN;AoHpupBQ;EACE,aAAA;EACA,sB3GzNF;E2G0NE,gBAAA;EACA,kBAAA;ApHsupBV;AoHrupBU;EACE,cAAA;ApHuupBZ;AoHhupBI;EACE,YAAA;EACA,cAAA;EACA,iBAAA;ApHkupBN;AoH7tpBY;EACE,YAAA;ApH+tpBd;AoHxtpBQ;EACE,aAAA;EACA,sB3GtPF;E2GuPE,gBAAA;EACA,mBAAA;ApH0tpBV;AoHztpBU;EACE,cAAA;ApH2tpBZ;;AsH/9pBA;EACE,gBAAA;EACA,YAAA;AtHk+pBF;AsH/9pBE;EACE,UAAA;AtHi+pBJ;AsH79pBE;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;AtH+9pBJ;AsH59pBE;EACE,sBAAA;AtH89pBJ;AsHz9pBE;EACE,kBAAA;EACA,sBAAA;AtH29pBJ;AsHv9pBE;EACE,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;EACA,qBAAA;AtHy9pBJ;AsHp9pBI;EACE,UAAA;EACA,SAAA;AtHs9pBN;AsHh9pBI;EC9CF,mDAAA;AvHigqBF;AsH58pBI;ECrDF,sDAAA;AvHogqBF;;AwHtgqBC;EACC,gBAAA;EACA,WAAA;EACA,aAAA;AxHygqBF;AwHxgqBE;EACC,mBAAA;AxH0gqBH;AwHxgqBE;EACC,kBAAA;AxH0gqBH;AwHvgqBC;EACC,yBAAA;AxHygqBF;;AwHpgqBC;EACC,6BAAA;AxHugqBF;AwHtgqBE;EACC,aAAA;AxHwgqBH;;AyH7hqBA;;;;;;;;;;;;;;;2FAAA;AAoBA;EACE,mBAAA;AzH4hqBF;AyHxhqBE;EACE,mBAAA;AzH0hqBJ;AyHrhqBE;EACE,e5CoEe;A7Em9pBnB;AyHphqBE;EACE,gB5CiEe;A7Eq9pBnB;AyHnhqBE;EACE,e5C8De;A7Eu9pBnB;AyHlhqBE;EACE,gB5C2De;A7Ey9pBnB;AyH/gqBE;EACE,sBhH4MqB;ATq0pBzB;AyHhhqBI;EACE,iDAAA;AzHkhqBN;AyH/gqBE;EACE,0BAAA;AzHihqBJ;;AyH3gqBI;EACE,+DAAA;AzH8gqBN;;AyHzgqBA;EACE;IACE,2BAAA;EzH4gqBF;EyHzgqBA;IACE,wBAAA;EzH2gqBF;AACF;AyHzgqBA,eAAA;AACA;EACE;IACE,2BAAA;EzH2gqBF;EyHxgqBA;IACE,2BAAA;EzH0gqBF;AACF;A0H/lqBA;;;;;;;;iGAAA;AAaE;EACE,qBAAA;A1H6lqBJ;A0H1lqBI;EACE,cAAA;EACA,kBAAA;A1H4lqBN;;A0HrlqBE;EACE,gBAAA;A1HwlqBJ;A0HtlqBM;EACE,yBjHDD;ATylqBP;A0HtlqBM;EACE,cjHgDK;EiH/CL,UAAA;A1HwlqBR;A0HvlqBQ;EACE,WjHxBF;ATinqBR;A0HplqBI;EACE,yBjH7BI;ATmnqBV;A0HnlqBI;EACE,cAAA;A1HqlqBN;A0HjlqBI;EACE,yBjHtBC;EiHuBD,WjHxCE;AT2nqBR;A0HjlqBI;EACE,yBjH1CI;EiH2CJ,UAAA;A1HmlqBN;;A0H7kqBA;EACE,gBAAA;A1HglqBF;;A0H3kqBE;EACE,sBAAA;A1H8kqBJ;A0H3kqBI;EACE,sBAAA;EACA,qDAAA;A1H6kqBN;A0H3kqBI;EACE,cjHtDE;ATmoqBR;;A2HvpqBA;EACE,aAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;A3H0pqBF;A2HxpqBE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;A3H0pqBJ;A2HxpqBI;EAEE,UAAA;EACA,aAAA;A3HypqBN;;A2HnpqBA;EACE,gBAAA;EACA,MAAA;A3HspqBF;A2HrpqBE;EACE,eAAA;EACA,MAAA;EACA,aAAA;A3HupqBJ;;A2HlpqBA;EACE,aAAA;EACA,mBAAA;A3HqpqBF;A2HjpqBM;EAEE,aAAA;A3HkpqBR;;A2H1oqBA;EACE,gBAAA;A3H6oqBF;;A2HxoqBA;EACE,UAAA;EACA,cAAA;A3H2oqBF;;A2HroqBE;EACE,WAAA;EACA,YAAA;A3HwoqBJ;;A2HpoqBA;;EAEE,0BAAA;EACA,oBAAA;A3HuoqBF;;A4HhtqBE;EACE,gBAAA;EACA,iBAAA;A5HmtqBJ;A4H/sqBI;;EACE,iCAAA;EACA,yBAAA;A5HktqBN;A4H/sqBE;EACE,iCAAA;EACA,uBAAA;A5HitqBJ;A4H/sqBE;EACE,eAAA;A5HitqBJ;;A4H5sqBA;EACE,cAAA;EACA,eAAA;A5H+sqBF;A4H9sqBE;EACE,cAAA;A5HgtqBJ;;A4H1sqBE;EACE,aAAA;A5H6sqBJ;A4H3sqBE;EACE,gBAAA;A5H6sqBJ;A4H3sqBE;EACE,gBAAA;EACA,4CAAA;EACA,gBAAA;A5H6sqBJ;A4H5sqBI;EACE,aAAA;A5H8sqBN;A4H5sqBI;EACE,aAAA;EACA,gBAAA;A5H8sqBN;;A4HxsqBE;EACE,oCAAA;EACA,gBAAA;EACA,gBAAA;A5H2sqBJ;A4H1sqBI;EACE,2BAAA;EACA,4BAAA;A5H4sqBN;A4H1sqBI;EACE,gBAAA;A5H4sqBN;A4H1sqBI;EACE,+BAAA;EACA,8BAAA;A5H4sqBN;A4H1sqBI;EACE,aAAA;A5H4sqBN;A4H1sqBI;EACE,aAAA;EACA,gBAAA;A5H4sqBN;;A4HtsqBA;EACE,0CAAA;EACA,wBAAA;EACA,qBnHoBc;ATqrqBhB;A4HvsqBI;EACE,uBAAA;EACA,cAAA;EACA,SAAA;EACA,yDAAA;A5HysqBN;A4HtsqBE;EACE,gCAAA;EACA,iCAAA;A5HwsqBJ;A4HtsqBE;EACE,mCAAA;EACA,oCAAA;A5HwsqBJ;;A4HnsqBA;EACE,oCAAA;EACA,qBAAA;A5HssqBF;A4HrsqBE;EACE,oCAAA;A5HusqBJ;;A4HlsqBA;EACE,mBAAA;EACA,iCAAA;EACA,4CAAA;EACA,6CAAA;EACA,6BAAA;A5HqsqBF;A4HpsqBE;EACE,gBAAA;EACA,6BAAA;A5HssqBJ;A4HrsqBI;EACE,aAAA;EACA,kBAAA;A5HusqBN;A4HrsqBI;EACE,aAAA;EACA,mBAAA;A5HusqBN;;A6Hn0qBE;EACE,mBAAA;A7Hs0qBJ;A6H/zqBM;EACE,cpHeD;ATkzqBP;A6H7zqBQ;EACE,cAAA;A7H+zqBV;A6HxzqBI;EACE,uBAAA;A7H0zqBN;A6HzzqBM;EACE,yBhD6Bc;EgD5Bd,wBAAA;EACA,kBAAA;A7H2zqBR;A6HzzqBQ;EACE,aAAA;EACA,cAAA;A7H2zqBV;A6HxzqBQ;EACE,mBpHVH;EoHWG,WpH5BF;ATs1qBR;A6HpzqBU;EACE,gCAAA;A7HszqBZ;A6HnzqBQ;EACE,4BAAA;EACA,+BAAA;A7HqzqBV;A6H/yqBU;EACE,gCAAA;A7HizqBZ;A6H9yqBQ;EACE,6BAAA;EACA,gCAAA;A7HgzqBV;A6H3yqBI;EACE,sBAAA;A7H6yqBN;A6H3yqBM;EACE,yBhDfc;EgDgBd,wBAAA;EACA,kBAAA;A7H6yqBR;A6H3yqBQ;EACE,aAAA;EACA,cAAA;A7H6yqBV;A6H1yqBQ;EACE,mBpHtDH;EoHuDG,WpHxEF;ATo3qBR;A6HryqBI;EACE,YAAA;EACA,SAAA;EACA,yBAAA;EACA,yBhDrCgB;EgDsChB,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;A7HuyqBN;A6HryqBM;EACE,cAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;A7HuyqBR;A6HpyqBM;EACE,gBAAA;A7HsyqBR;A6HnyqBM;EACE,cpHpFD;ATy3qBP;A6HhyqBI;EACE,yBhD7DgB;EgD8DhB,gBAAA;A7HkyqBN;A6HhyqBM;EACE,UAAA;EACA,qBAAA;EACA,yBpHhGD;EoHiGC,WpHlHA;EoHmHA,sBAAA;A7HkyqBR;A6H3xqBM;EACE,gCAAA;EACA,mCAAA;A7H6xqBR;A6H5xqBQ;EACE,mBAAA;A7H8xqBV;A6H3xqBM;EACE,gCAAA;EACA,mCAAA;A7H6xqBR;A6HxxqBM;EACE,iCAAA;EACA,oCAAA;A7H0xqBR;A6HzxqBQ;EACE,mBAAA;A7H2xqBV;A6HxxqBM;EACE,iCAAA;EACA,oCAAA;A7H0xqBR;A6HjxqBM;EACE,iBhD1GkB;EgD2GlB,mBAAA;A7HmxqBR;;A8Hv7qBA;;EAEE,YAAA;EACA,WAAA;A9H07qBF;;A+H77qBE;EACE,yBtHQM;EsHPN,sBAAA;EACA,eAAA;EACA,mBAAA;A/Hg8qBJ;A+H77qBI;EACE,uBAAA;EACA,2CAAA;EACA,uBAAA;EACA,gBtHHE;EsHIF,UAAA;EACA,+BAAA;EACA,kBAAA;EACA,+BAAA;A/H+7qBN;A+H97qBM;EACE,gBAAA;EACA,eAAA;EACA,ctHMD;AT07qBP;A+H77qBM;EAGE,UAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;A/H67qBR;A+Hz7qBI;EACE,WtHzBE;EsH0BF,8BAAA;EACA,+BAAA;A/H27qBN;A+Hz7qBM;EACE,WtH9BA;ATy9qBR;A+Hp7qBQ;EACE,ctHrBH;AT28qBP;A+H/6qBQ;EACE,ctH9BF;AT+8qBR;A+H16qBQ;EACE,ctHzCH;ATq9qBP;A+Hr6qBQ;EACE,ctHhDJ;ATu9qBN;A+Hh6qBQ;EACE,ctHvDD;ATy9qBT;A+H35qBQ;EACE,ctHpEC;ATi+qBX;A+Ht5qBE;EACE,YAAA;EAEA,iBAAA;EACA,2CAAA;A/Hu5qBJ;A+Hn5qBI;EACE,aAAA;EACA,mBAAA;A/Hq5qBN;A+Hh5qBE;EACE,iCAAA;A/Hk5qBJ;;A+H74qBA;EACE,gBAAA;A/Hg5qBF;;A+H54qBA;EACE,gBAAA;A/H+4qBF;;A+H34qBA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;A/H84qBF;;A+Hz4qBA;EACE;IACE,mBAAA;IACA,kBAAA;E/H44qBF;E+H34qBE;;IAEE,gBAAA;E/H64qBJ;AACF;A+Ht4qBE;EACE,2DAAA;A/Hw4qBJ;;AgI5hrBA;EACE,aAAA;AhI+hrBF;AgI9hrBE;EACE,WvHMI;EuHLJ,YAAA;EACA,8BAAA;EACA,+BAAA;AhIgirBJ;AgI7hrBI;EACE,4BvHgBC;AT+grBP;;AiI5irBA;EACI,WxHWI;EwHVJ,eAAA;EACA,kBAAA;AjI+irBJ;;AiI7irBA;EACI,oBAAA;AjIgjrBJ;;AiI9irBA;EACI,oBAAA;AjIijrBJ;;AiI/irBA;EACC,qBAAA;EACE,kCAAA;AjIkjrBH;;AiI/irBA;EACE,wBAAA;AjIkjrBF;;AiIhjrBA;EACE,wBAAA;AjImjrBF;AiI9hrBA;EACG;IACE,uBAAA;EjIijrBH;EiI/irBC;IACE,yBAAA;EjIijrBH;AACF;AiI9irBA;EACC,aAAA;EACA,kBAAA;AjIgjrBD;;AiIxirBC;EACC,eAAA;AjI2irBF;;AiIvirBA;EvH9CI,qBAAA;AVylrBJ;;AiI1irBA;EvH/CI,gBAAA;AV6lrBJ;;AiI5irBA;EACI,8BAAA;AjI+irBJ;;AiIzirBI;EACI,sBAAA;AjI4irBR;;AiIvirBA;EACI,qBAAA;EAGA,kCAAA;AjI0irBJ;;AiIxirBA;EACI;IAAK,uBAAA;EjI4irBP;EiI3irBE;IAAO,yBAAA;EjI8irBT;AACF;AkI3mrBM;EAEE,WAAA;ExGHN,2EAAA;A1BgnrBF;AkIrmrBQ;EAEE,WAAA;AlIsmrBV;;AkIlmrBM;EACE,oDAAA;EAKA,WAAA;AlIimrBR;AkIhmrBQ;EAEE,WAAA;AlIimrBV;;AkI1nrBM;EAEE,WAAA;ExGHN,qEAAA;A1BgorBF;AkIrnrBQ;EAEE,WAAA;AlIsnrBV;;AkIlnrBM;EACE,oDAAA;EAKA,WAAA;AlIinrBR;AkIhnrBQ;EAEE,WAAA;AlIinrBV;;AkI1orBM;EACE,mBAAA;EACA,WAAA;ExGHN,wEAAA;A1BiprBF;AkItorBQ;EAEE,WAAA;AlIuorBV;;AkInorBM;EACE,oDAAA;EAKA,WAAA;AlIkorBR;AkIjorBQ;EAEE,WAAA;AlIkorBV;;AkI3prBM;EACE,mBAAA;EACA,WAAA;ExGHN,2EAAA;A1BkqrBF;AkIvprBQ;EAEE,WAAA;AlIwprBV;;AkIpprBM;EACE,oDAAA;EAKA,WAAA;AlImprBR;AkIlprBQ;EAEE,WAAA;AlImprBV;;AkI5qrBM;EACE,mBAAA;EACA,WAAA;ExGHN,2EAAA;A1BmrrBF;AkIxqrBQ;EAEE,WAAA;AlIyqrBV;;AkIrqrBM;EACE,qGAAA;EAKA,WAAA;AlIoqrBR;AkInqrBQ;EAEE,WAAA;AlIoqrBV;;AkI7rrBM;EACE,mBAAA;EACA,WAAA;ExGHN,2EAAA;A1BosrBF;AkIzrrBQ;EAEE,WAAA;AlI0rrBV;;AkItrrBM;EACE,uGAAA;EAKA,WAAA;AlIqrrBR;AkIprrBQ;EAEE,WAAA;AlIqrrBV;;AkI9srBM;EACE,mBAAA;EACA,WAAA;ExGHN,0EAAA;A1BqtrBF;AkI1srBQ;EAEE,WAAA;AlI2srBV;;AkIvsrBM;EACE,uGAAA;EAKA,WAAA;AlIssrBR;AkIrsrBQ;EAEE,WAAA;AlIssrBV;;AkI/trBM;EACE,mBAAA;EACA,WAAA;ExGHN,yEAAA;A1BsurBF;AkI3trBQ;EAEE,WAAA;AlI4trBV;;AkIxtrBM;EACE,qFAAA;EAKA,WAAA;AlIutrBR;AkIttrBQ;EAEE,WAAA;AlIutrBV;;AkIhvrBM;EACE,mBAAA;EACA,WAAA;ExGHN,0EAAA;A1BuvrBF;AkI5urBQ;EAEE,WAAA;AlI6urBV;;AkIzurBM;EACE,sFAAA;EAKA,WAAA;AlIwurBR;AkIvurBQ;EAEE,WAAA;AlIwurBV;;AkIjwrBM;EACE,mBAAA;EACA,WAAA;ExGHN,yEAAA;A1BwwrBF;AkI7vrBQ;EAEE,WAAA;AlI8vrBV;;AkI1vrBM;EACE,sGAAA;EAKA,WAAA;AlIyvrBR;AkIxvrBQ;EAEE,WAAA;AlIyvrBV;;AmI9vrBM;EACE,yBAAA;AnIiwrBR;;AmI7vrBM;EACE,oCAAA;AnIgwrBR;AmI9vrBQ;;EAEE,6BAAA;AnIgwrBV;;AmI3vrBM;EACE,+CAAA;EACA,yBAAA;AnI8vrBR;AmI5vrBQ;EZjEN,sDAAA;AvHg0rBF;AmI3vrBQ;EACE,6CAAA;AnI6vrBV;;AmIxvrBM;EACE,gDAAA;AnI2vrBR;;AmIvvrBM;EACE,oCAAA;AnI0vrBR;;AmIvvrBM;EACE,6BAAA;AnI0vrBR;;AmIvvrBM;EACE,gCAAA;AnI0vrBR;;AmIvvrBM;EACE,8BAAA;AnI0vrBR;;AmIvvrBM;EACE,+BAAA;AnI0vrBR;;AmItvrBM;EAEE,yBAAA;EACA,gBAAA;EACA,yBAAA;AnIwvrBR;;AmIjvrBQ;;;EACE,gCAAA;AnIsvrBV;;AmIjvrBM;ECxHF,mBCoIK,EDpIe,iBAAA;EACpB,oCAAA;ApI62rBJ;;AmIjvrBM;EACE,wBAAA;EACA,oCAAA;EACA,WAAA;AnIovrBR;AmIlvrBQ;EACE,wBAAA;EACA,sBAAA;EACA,iCAAA;AnIovrBV;AmIjvrBQ;EAEE,sBAAA;AnIkvrBV;;AmI7urBM;EACE,6BAAA;EACA,cEbC;ArI6vrBT;AmI9urBQ;EACE,cEhBD;EFiBC,0CAAA;AnIgvrBV;AmI7urBQ;EAEE,yBEtBD;EFuBC,sBAAA;AnI8urBV;;AmIzurBM;EACE,yBE7BC;EF8BD,+CAAA;EACA,WAAA;AnI4urBR;AmI1urBQ;EACE,WAAA;AnI4urBV;AmIzurBQ;EAEE,aAAA;EACA,0BAAA;AnI0urBV;;AmIrurBM;EACE,yBAAA;EACA,6BAAA;EACA,cEhDC;ArIwxrBT;AmIturBQ;EACE,2CAAA;EACA,cEpDD;ArI4xrBT;AmIturBQ;EACE,sBAAA;AnIwurBV;;AmI9trBY;;;EACE,yBElEL;EFmEK,WAAA;AnImurBd;AmIlurBc;;;EACE,WAAA;AnIsurBhB;AmIjurBc;;;EACE,cE3EP;ArIgzrBT;;AmI5trBQ;EACE,yBErFD;ArIozrBT;AmI9trBU;EACE,6BAAA;EACA,yBAAA;AnIgurBZ;;AmIttrBY;;;;EAEE,8BAAA;EACA,WAAA;AnI2trBd;AmIztrBc;;;;EACE,sBAAA;AnI8trBhB;AmIvtrBY;;;;EACE,yBAAA;AnI4trBd;AmIttrBY;;;EACE,mBEvHL;EFwHK,WAAA;AnI0trBd;;AmIhtrBY;EACE,WAAA;EACA,yBEpIL;ArIu1rBT;;AmI3srBM;EACE,oCAAA;AnI8srBR;AmI7srBQ;EACE,sBAAA;AnI+srBV;;AmIvsrBU;EAEE,gCAAA;AnIysrBZ;;AmI9rrBY;EACE,oCAAA;AnIisrBd;;AmI3rrBM;EACE,iEAAA;AnI8rrBR;;AmIxrrBU;EACE,gCAAA;AnI2rrBZ;AmI1rrBY;EACE,oCAAA;AnI4rrBd;AmIzrrBU;EACE,oCAAA;AnI2rrBZ;;AmIjrrBc;EACE,cEpMP;ArIw3rBT;AmI7qrBgB;EACE,oEAAA;EAKA,4DAAA;AnI2qrBlB;AmIvqrBgB;EACE,oEAAA;EAKA,4DAAA;AnIqqrBlB;;AmI1prBU;EACE,yBAAA;AnI6prBZ;AmIvprBc;EACE,oEAAA;EAKA,4DAAA;AnIqprBhB;;AmI3orBQ;EACE,oCAAA;EACA,WAAA;EACA,6BAAA;AnI8orBV;;AmIzorBM;EACE,6BAAA;AnI4orBR;AmI3orBQ;EACE,qBExQD;ArIq5rBT;AmI3orBQ;EACE,yBE3QD;ArIw5rBT;;AmIrorBY;EACE,4BAAA;EACA,4DAAA;AnIworBd;;AmIj/rBM;EACE,yBAAA;AnIo/rBR;;AmIh/rBM;EACE,oCAAA;AnIm/rBR;AmIj/rBQ;;EAEE,6BAAA;AnIm/rBV;;AmI9+rBM;EACE,yCAAA;EACA,yBAAA;AnIi/rBR;AmI/+rBQ;EZjEN,gDAAA;AvHmjsBF;AmI9+rBQ;EACE,uBAAA;AnIg/rBV;;AmI3+rBM;EACE,0CAAA;AnI8+rBR;;AmI1+rBM;EACE,oCAAA;AnI6+rBR;;AmI1+rBM;EACE,6BAAA;AnI6+rBR;;AmI1+rBM;EACE,gCAAA;AnI6+rBR;;AmI1+rBM;EACE,8BAAA;AnI6+rBR;;AmI1+rBM;EACE,+BAAA;AnI6+rBR;;AmIz+rBM;EAEE,yBAAA;EACA,gBAAA;EACA,yBAAA;AnI2+rBR;;AmIp+rBQ;;;EACE,gCAAA;AnIy+rBV;;AmIp+rBM;ECxHF,mBCoIK,EDpIe,iBAAA;EACpB,8BAAA;ApIgmsBJ;;AmIp+rBM;EACE,wBAAA;EACA,oCAAA;EACA,WAAA;AnIu+rBR;AmIr+rBQ;EACE,wBAAA;EACA,sBAAA;EACA,iCAAA;AnIu+rBV;AmIp+rBQ;EAEE,sBAAA;AnIq+rBV;;AmIh+rBM;EACE,6BAAA;EACA,cEbC;ArIg/rBT;AmIj+rBQ;EACE,cEhBD;EFiBC,oCAAA;AnIm+rBV;AmIh+rBQ;EAEE,yBEtBD;EFuBC,sBAAA;AnIi+rBV;;AmI59rBM;EACE,yBE7BC;EF8BD,+CAAA;EACA,WAAA;AnI+9rBR;AmI79rBQ;EACE,WAAA;AnI+9rBV;AmI59rBQ;EAEE,aAAA;EACA,0BAAA;AnI69rBV;;AmIx9rBM;EACE,yBAAA;EACA,6BAAA;EACA,cEhDC;ArI2gsBT;AmIz9rBQ;EACE,qCAAA;EACA,cEpDD;ArI+gsBT;AmIz9rBQ;EACE,sBAAA;AnI29rBV;;AmIj9rBY;;;EACE,yBElEL;EFmEK,WAAA;AnIs9rBd;AmIr9rBc;;;EACE,WAAA;AnIy9rBhB;AmIp9rBc;;;EACE,cE3EP;ArImisBT;;AmI/8rBQ;EACE,yBErFD;ArIuisBT;AmIj9rBU;EACE,6BAAA;EACA,yBAAA;AnIm9rBZ;;AmIz8rBY;;;;EAEE,8BAAA;EACA,WAAA;AnI88rBd;AmI58rBc;;;;EACE,sBAAA;AnIi9rBhB;AmI18rBY;;;;EACE,yBAAA;AnI+8rBd;AmIz8rBY;;;EACE,mBEvHL;EFwHK,WAAA;AnI68rBd;;AmIn8rBY;EACE,WAAA;EACA,yBEpIL;ArI0ksBT;;AmI97rBM;EACE,oCAAA;AnIi8rBR;AmIh8rBQ;EACE,sBAAA;AnIk8rBV;;AmI17rBU;EAEE,gCAAA;AnI47rBZ;;AmIj7rBY;EACE,oCAAA;AnIo7rBd;;AmI96rBM;EACE,iEAAA;AnIi7rBR;;AmI36rBU;EACE,gCAAA;AnI86rBZ;AmI76rBY;EACE,oCAAA;AnI+6rBd;AmI56rBU;EACE,oCAAA;AnI86rBZ;;AmIp6rBc;EACE,cEpMP;ArI2msBT;AmIh6rBgB;EACE,8DAAA;EAKA,sDAAA;AnI85rBlB;AmI15rBgB;EACE,8DAAA;EAKA,sDAAA;AnIw5rBlB;;AmI74rBU;EACE,yBAAA;AnIg5rBZ;AmI14rBc;EACE,8DAAA;EAKA,sDAAA;AnIw4rBhB;;AmI93rBQ;EACE,oCAAA;EACA,WAAA;EACA,6BAAA;AnIi4rBV;;AmI53rBM;EACE,6BAAA;AnI+3rBR;AmI93rBQ;EACE,qBExQD;ArIwosBT;AmI93rBQ;EACE,yBE3QD;ArI2osBT;;AmIx3rBY;EACE,4BAAA;EACA,sDAAA;AnI23rBd;;AmIpusBM;EACE,yBAAA;AnIuusBR;;AmInusBM;EACE,oCAAA;AnIsusBR;AmIpusBQ;;EAEE,6BAAA;AnIsusBV;;AmIjusBM;EACE,4CAAA;EACA,yBAAA;AnIousBR;AmIlusBQ;EZjEN,mDAAA;AvHsysBF;AmIjusBQ;EACE,gDAAA;AnImusBV;;AmI9tsBM;EACE,6CAAA;AnIiusBR;;AmI7tsBM;EACE,oCAAA;AnIgusBR;;AmI7tsBM;EACE,6BAAA;AnIgusBR;;AmI7tsBM;EACE,gCAAA;AnIgusBR;;AmI7tsBM;EACE,8BAAA;AnIgusBR;;AmI7tsBM;EACE,+BAAA;AnIgusBR;;AmI5tsBM;EAEE,yBAAA;EACA,gBAAA;EACA,yBAAA;AnI8tsBR;;AmIvtsBQ;;;EACE,gCAAA;AnI4tsBV;;AmIvtsBM;ECxHF,mBCoIK,EDpIe,iBAAA;EACpB,iCAAA;ApIm1sBJ;;AmIvtsBM;EACE,wBAAA;EACA,oCAAA;EACA,WAAA;AnI0tsBR;AmIxtsBQ;EACE,wBAAA;EACA,sBAAA;EACA,mCAAA;AnI0tsBV;AmIvtsBQ;EAEE,sBAAA;AnIwtsBV;;AmIntsBM;EACE,6BAAA;EACA,cEbC;ArImusBT;AmIptsBQ;EACE,cEhBD;EFiBC,uCAAA;AnIstsBV;AmIntsBQ;EAEE,yBEtBD;EFuBC,sBAAA;AnIotsBV;;AmI/ssBM;EACE,yBE7BC;EF8BD,+CAAA;EACA,WAAA;AnIktsBR;AmIhtsBQ;EACE,WAAA;AnIktsBV;AmI/ssBQ;EAEE,aAAA;EACA,0BAAA;AnIgtsBV;;AmI3ssBM;EACE,yBAAA;EACA,6BAAA;EACA,cEhDC;ArI8vsBT;AmI5ssBQ;EACE,wCAAA;EACA,cEpDD;ArIkwsBT;AmI5ssBQ;EACE,sBAAA;AnI8ssBV;;AmIpssBY;;;EACE,yBElEL;EFmEK,WAAA;AnIyssBd;AmIxssBc;;;EACE,WAAA;AnI4ssBhB;AmIvssBc;;;EACE,cE3EP;ArIsxsBT;;AmIlssBQ;EACE,yBErFD;ArI0xsBT;AmIpssBU;EACE,6BAAA;EACA,yBAAA;AnIsssBZ;;AmI5rsBY;;;;EAEE,8BAAA;EACA,WAAA;AnIissBd;AmI/rsBc;;;;EACE,sBAAA;AnIossBhB;AmI7rsBY;;;;EACE,yBAAA;AnIkssBd;AmI5rsBY;;;EACE,mBEvHL;EFwHK,WAAA;AnIgssBd;;AmItrsBY;EACE,WAAA;EACA,yBEpIL;ArI6zsBT;;AmIjrsBM;EACE,oCAAA;AnIorsBR;AmInrsBQ;EACE,sBAAA;AnIqrsBV;;AmI7qsBU;EAEE,gCAAA;AnI+qsBZ;;AmIpqsBY;EACE,oCAAA;AnIuqsBd;;AmIjqsBM;EACE,iEAAA;AnIoqsBR;;AmI9psBU;EACE,gCAAA;AnIiqsBZ;AmIhqsBY;EACE,oCAAA;AnIkqsBd;AmI/psBU;EACE,oCAAA;AnIiqsBZ;;AmIvpsBc;EACE,cEpMP;ArI81sBT;AmInpsBgB;EACE,mEAAA;EAKA,yDAAA;AnIipsBlB;AmI7osBgB;EACE,mEAAA;EAKA,yDAAA;AnI2osBlB;;AmIhosBU;EACE,yBAAA;AnImosBZ;AmI7nsBc;EACE,mEAAA;EAKA,yDAAA;AnI2nsBhB;;AmIjnsBQ;EACE,oCAAA;EACA,WAAA;EACA,6BAAA;AnIonsBV;;AmI/msBM;EACE,6BAAA;AnIknsBR;AmIjnsBQ;EACE,qBExQD;ArI23sBT;AmIjnsBQ;EACE,yBE3QD;ArI83sBT;;AmI3msBY;EACE,8BAAA;EACA,yDAAA;AnI8msBd;;AmIxmsBM;EACE,yBAAA;AnI2msBR;;AmIxmsBM;EACE,oCAAA;AnI2msBR;;AmIxmsBM;EACE,wBAAA;EACA,oCAAA;AnI2msBR;AmIzmsBQ;EACE,wBAAA;EACA,4BAAA;AnI2msBV;AmIxmsBQ;EAEE,wBAAA;EACA,4BAAA;AnIymsBV;;AmIrmsBM;EACE,gCAAA;EACA,yBAAA;AnIwmsBR;AmItmsBQ;EACE,oCAAA;AnIwmsBV;;AmIpmsBM;EACE,iEAAA;AnIumsBR;;AmIpmsBM;EACE,oCAAA;AnIumsBR;;AmIpmsBM;EACE,wCAAA;AnIumsBR;;AmIpmsBM;EACE,2CAAA;AnIumsBR;;AmIpmsBM;EACE,yCAAA;AnIumsBR;;AmIpmsBM;EACE,0CAAA;AnIumsBR;;AmIpmsBM;ECxdF,mBCoIK,EDpIe,iBAAA;EACpB,kCAAA;ApIgktBJ;;AmIjhtBM;EACE,yBAAA;AnIohtBR;;AmIhhtBM;EACE,oCAAA;AnImhtBR;AmIjhtBQ;;EAEE,6BAAA;AnImhtBV;;AmI9gtBM;EACE,+CAAA;EACA,yBAAA;AnIihtBR;AmI/gtBQ;EZjEN,sDAAA;AvHmltBF;AmI9gtBQ;EACE,gDAAA;AnIghtBV;;AmI3gtBM;EACE,gDAAA;AnI8gtBR;;AmI1gtBM;EACE,oCAAA;AnI6gtBR;;AmI1gtBM;EACE,6BAAA;AnI6gtBR;;AmI1gtBM;EACE,gCAAA;AnI6gtBR;;AmI1gtBM;EACE,8BAAA;AnI6gtBR;;AmI1gtBM;EACE,+BAAA;AnI6gtBR;;AmIzgtBM;EAEE,yBAAA;EACA,gBAAA;EACA,yBAAA;AnI2gtBR;;AmIpgtBQ;;;EACE,gCAAA;AnIygtBV;;AmIpgtBM;ECxHF,mBCoIK,EDpIe,iBAAA;EACpB,oCAAA;ApIgotBJ;;AmIpgtBM;EACE,wBAAA;EACA,oCAAA;EACA,WAAA;AnIugtBR;AmIrgtBQ;EACE,wBAAA;EACA,sBAAA;EACA,mCAAA;AnIugtBV;AmIpgtBQ;EAEE,sBAAA;AnIqgtBV;;AmIhgtBM;EACE,6BAAA;EACA,cEbC;ArIghtBT;AmIjgtBQ;EACE,cEhBD;EFiBC,0CAAA;AnImgtBV;AmIhgtBQ;EAEE,yBEtBD;EFuBC,sBAAA;AnIigtBV;;AmI5/sBM;EACE,yBE7BC;EF8BD,+CAAA;EACA,WAAA;AnI+/sBR;AmI7/sBQ;EACE,WAAA;AnI+/sBV;AmI5/sBQ;EAEE,aAAA;EACA,0BAAA;AnI6/sBV;;AmIx/sBM;EACE,yBAAA;EACA,6BAAA;EACA,cEhDC;ArI2itBT;AmIz/sBQ;EACE,2CAAA;EACA,cEpDD;ArI+itBT;AmIz/sBQ;EACE,sBAAA;AnI2/sBV;;AmIj/sBY;;;EACE,yBElEL;EFmEK,WAAA;AnIs/sBd;AmIr/sBc;;;EACE,WAAA;AnIy/sBhB;AmIp/sBc;;;EACE,cE3EP;ArImktBT;;AmI/+sBQ;EACE,yBErFD;ArIuktBT;AmIj/sBU;EACE,6BAAA;EACA,yBAAA;AnIm/sBZ;;AmIz+sBY;;;;EAEE,8BAAA;EACA,WAAA;AnI8+sBd;AmI5+sBc;;;;EACE,sBAAA;AnIi/sBhB;AmI1+sBY;;;;EACE,yBAAA;AnI++sBd;AmIz+sBY;;;EACE,mBEvHL;EFwHK,WAAA;AnI6+sBd;;AmIn+sBY;EACE,WAAA;EACA,yBEpIL;ArI0mtBT;;AmI99sBM;EACE,oCAAA;AnIi+sBR;AmIh+sBQ;EACE,sBAAA;AnIk+sBV;;AmI19sBU;EAEE,gCAAA;AnI49sBZ;;AmIj9sBY;EACE,oCAAA;AnIo9sBd;;AmI98sBM;EACE,iEAAA;AnIi9sBR;;AmI38sBU;EACE,gCAAA;AnI88sBZ;AmI78sBY;EACE,oCAAA;AnI+8sBd;AmI58sBU;EACE,oCAAA;AnI88sBZ;;AmIp8sBc;EACE,cEpMP;ArI2otBT;AmIh8sBgB;EACE,sEAAA;EAKA,4DAAA;AnI87sBlB;AmI17sBgB;EACE,sEAAA;EAKA,4DAAA;AnIw7sBlB;;AmI76sBU;EACE,yBAAA;AnIg7sBZ;AmI16sBc;EACE,sEAAA;EAKA,4DAAA;AnIw6sBhB;;AmI95sBQ;EACE,oCAAA;EACA,WAAA;EACA,6BAAA;AnIi6sBV;;AmI55sBM;EACE,6BAAA;AnI+5sBR;AmI95sBQ;EACE,qBExQD;ArIwqtBT;AmI95sBQ;EACE,yBE3QD;ArI2qtBT;;AmIx5sBY;EACE,8BAAA;EACA,4DAAA;AnI25sBd;;AmIr5sBM;EACE,yBAAA;AnIw5sBR;;AmIr5sBM;EACE,oCAAA;AnIw5sBR;;AmIr5sBM;EACE,wBAAA;EACA,oCAAA;AnIw5sBR;AmIt5sBQ;EACE,wBAAA;EACA,4BAAA;AnIw5sBV;AmIr5sBQ;EAEE,wBAAA;EACA,4BAAA;AnIs5sBV;;AmIl5sBM;EACE,gCAAA;EACA,yBAAA;AnIq5sBR;AmIn5sBQ;EACE,oCAAA;AnIq5sBV;;AmIj5sBM;EACE,iEAAA;AnIo5sBR;;AmIj5sBM;EACE,oCAAA;AnIo5sBR;;AmIj5sBM;EACE,wCAAA;AnIo5sBR;;AmIj5sBM;EACE,2CAAA;AnIo5sBR;;AmIj5sBM;EACE,yCAAA;AnIo5sBR;;AmIj5sBM;EACE,0CAAA;AnIo5sBR;;AmIj5sBM;ECxdF,mBCoIK,EDpIe,iBAAA;EACpB,kCAAA;ApI62tBJ;;AmI/8sBM;EACE,kEAAA;AnIk9sBR;;AmI/8sBM;EACE,6EAAA;AnIk9sBR;;AmI/8sBM;EACE,yEAAA;EACA,6EAAA;AnIk9sBR;AmIh9sBQ;EACE,yEAAA;EACA,4EAAA;AnIk9sBV;AmI/8sBQ;EAEE,wEAAA;EACA,8EAAA;AnIg9sBV;;AmI58sBM;EACE,yEAAA;EACA,kEAAA;AnI+8sBR;AmI78sBQ;EACE,6EAAA;AnI+8sBV;;AmI38sBM;EACE,0GAAA;AnI88sBR;;AmI38sBM;EACE,6EAAA;AnI88sBR;;AmI38sBM;EACE,iFAAA;AnI88sBR;;AmI38sBM;EACE,oFAAA;AnI88sBR;;AmI38sBM;EACE,kFAAA;AnI88sBR;;AmI38sBM;EACE,mFAAA;AnI88sBR;;AmI38sBM;ECxdF,4DCoIK,EDpIe,iBAAA;EACpB,kEAAA;ApIu6tBJ;;AmIzgtBM;EACE,qEAAA;AnI4gtBR;;AmIzgtBM;EACE,gFAAA;AnI4gtBR;;AmIzgtBM;EACE,yEAAA;EACA,gFAAA;AnI4gtBR;AmI1gtBQ;EACE,yEAAA;EACA,4EAAA;AnI4gtBV;AmIzgtBQ;EAEE,wEAAA;EACA,8EAAA;AnI0gtBV;;AmItgtBM;EACE,4EAAA;EACA,qEAAA;AnIygtBR;AmIvgtBQ;EACE,gFAAA;AnIygtBV;;AmIrgtBM;EACE,6GAAA;AnIwgtBR;;AmIrgtBM;EACE,gFAAA;AnIwgtBR;;AmIrgtBM;EACE,oFAAA;AnIwgtBR;;AmIrgtBM;EACE,uFAAA;AnIwgtBR;;AmIrgtBM;EACE,qFAAA;AnIwgtBR;;AmIrgtBM;EACE,sFAAA;AnIwgtBR;;AmIrgtBM;ECxdF,+DCoIK,EDpIe,iBAAA;EACpB,qEAAA;ApIi+tBJ;;AmInktBM;EACE,qEAAA;AnIsktBR;;AmInktBM;EACE,gFAAA;AnIsktBR;;AmInktBM;EACE,yEAAA;EACA,gFAAA;AnIsktBR;AmIpktBQ;EACE,yEAAA;EACA,4EAAA;AnIsktBV;AmInktBQ;EAEE,wEAAA;EACA,8EAAA;AnIoktBV;;AmIhktBM;EACE,4EAAA;EACA,qEAAA;AnImktBR;AmIjktBQ;EACE,gFAAA;AnImktBV;;AmI/jtBM;EACE,6GAAA;AnIkktBR;;AmI/jtBM;EACE,gFAAA;AnIkktBR;;AmI/jtBM;EACE,oFAAA;AnIkktBR;;AmI/jtBM;EACE,uFAAA;AnIkktBR;;AmI/jtBM;EACE,qFAAA;AnIkktBR;;AmI/jtBM;EACE,sFAAA;AnIkktBR;;AmI/jtBM;ECxdF,+DCoIK,EDpIe,iBAAA;EACpB,qEAAA;ApI2huBJ;;AmI7ntBM;EACE,qEAAA;AnIgotBR;;AmI7ntBM;EACE,gFAAA;AnIgotBR;;AmI7ntBM;EACE,yEAAA;EACA,gFAAA;AnIgotBR;AmI9ntBQ;EACE,yEAAA;EACA,4EAAA;AnIgotBV;AmI7ntBQ;EAEE,wEAAA;EACA,8EAAA;AnI8ntBV;;AmI1ntBM;EACE,4EAAA;EACA,qEAAA;AnI6ntBR;AmI3ntBQ;EACE,gFAAA;AnI6ntBV;;AmIzntBM;EACE,6GAAA;AnI4ntBR;;AmIzntBM;EACE,gFAAA;AnI4ntBR;;AmIzntBM;EACE,oFAAA;AnI4ntBR;;AmIzntBM;EACE,uFAAA;AnI4ntBR;;AmIzntBM;EACE,qFAAA;AnI4ntBR;;AmIzntBM;EACE,sFAAA;AnI4ntBR;;AmIzntBM;ECxdF,+DCoIK,EDpIe,iBAAA;EACpB,qEAAA;ApIqluBJ;;AmIvrtBM;EACE,mEAAA;AnI0rtBR;;AmIvrtBM;EACE,8EAAA;AnI0rtBR;;AmIvrtBM;EACE,yEAAA;EACA,8EAAA;AnI0rtBR;AmIxrtBQ;EACE,yEAAA;EACA,4EAAA;AnI0rtBV;AmIvrtBQ;EAEE,wEAAA;EACA,8EAAA;AnIwrtBV;;AmIprtBM;EACE,0EAAA;EACA,mEAAA;AnIurtBR;AmIrrtBQ;EACE,8EAAA;AnIurtBV;;AmInrtBM;EACE,2GAAA;AnIsrtBR;;AmInrtBM;EACE,8EAAA;AnIsrtBR;;AmInrtBM;EACE,kFAAA;AnIsrtBR;;AmInrtBM;EACE,qFAAA;AnIsrtBR;;AmInrtBM;EACE,mFAAA;AnIsrtBR;;AmInrtBM;EACE,oFAAA;AnIsrtBR;;AmInrtBM;ECxdF,6DCoIK,EDpIe,iBAAA;EACpB,mEAAA;ApI+ouBJ;;AmIjvtBM;EACE,oEAAA;AnIovtBR;;AmIjvtBM;EACE,+EAAA;AnIovtBR;;AmIjvtBM;EACE,yEAAA;EACA,+EAAA;AnIovtBR;AmIlvtBQ;EACE,yEAAA;EACA,4EAAA;AnIovtBV;AmIjvtBQ;EAEE,wEAAA;EACA,8EAAA;AnIkvtBV;;AmI9utBM;EACE,2EAAA;EACA,oEAAA;AnIivtBR;AmI/utBQ;EACE,+EAAA;AnIivtBV;;AmI7utBM;EACE,4GAAA;AnIgvtBR;;AmI7utBM;EACE,+EAAA;AnIgvtBR;;AmI7utBM;EACE,mFAAA;AnIgvtBR;;AmI7utBM;EACE,sFAAA;AnIgvtBR;;AmI7utBM;EACE,oFAAA;AnIgvtBR;;AmI7utBM;EACE,qFAAA;AnIgvtBR;;AmI7utBM;ECxdF,8DCoIK,EDpIe,iBAAA;EACpB,oEAAA;ApIysuBJ;;AmI3ytBM;EACE,oEAAA;AnI8ytBR;;AmI3ytBM;EACE,+EAAA;AnI8ytBR;;AmI3ytBM;EACE,yEAAA;EACA,+EAAA;AnI8ytBR;AmI5ytBQ;EACE,yEAAA;EACA,4EAAA;AnI8ytBV;AmI3ytBQ;EAEE,wEAAA;EACA,8EAAA;AnI4ytBV;;AmIxytBM;EACE,2EAAA;EACA,oEAAA;AnI2ytBR;AmIzytBQ;EACE,+EAAA;AnI2ytBV;;AmIvytBM;EACE,4GAAA;AnI0ytBR;;AmIvytBM;EACE,+EAAA;AnI0ytBR;;AmIvytBM;EACE,mFAAA;AnI0ytBR;;AmIvytBM;EACE,sFAAA;AnI0ytBR;;AmIvytBM;EACE,oFAAA;AnI0ytBR;;AmIvytBM;EACE,qFAAA;AnI0ytBR;;AmIvytBM;ECxdF,8DCoIK,EDpIe,iBAAA;EACpB,oEAAA;ApImwuBJ;;AmIptuBM;EACE,yBAAA;AnIutuBR;;AmIntuBM;EACE,oCAAA;AnIstuBR;AmIptuBQ;;EAEE,6BAAA;AnIstuBV;;AmIjtuBM;EACE,+CAAA;EACA,yBAAA;AnIotuBR;AmIltuBQ;EZjEN,sDAAA;AvHsxuBF;AmIjtuBQ;EACE,kEAAA;AnImtuBV;;AmI9suBM;EACE,gDAAA;AnIituBR;;AmI7suBM;EACE,oCAAA;AnIgtuBR;;AmI7suBM;EACE,6BAAA;AnIgtuBR;;AmI7suBM;EACE,gCAAA;AnIgtuBR;;AmI7suBM;EACE,8BAAA;AnIgtuBR;;AmI7suBM;EACE,+BAAA;AnIgtuBR;;AmI5suBM;EACE,qEAAA;EACA,yBAAA;EACA,gBAAA;EACA,yBAAA;AnI+suBR;;AmIxsuBQ;;;EACE,gCAAA;AnI6suBV;;AmIxsuBM;ECxHF,mBCoIK,EDpIe,iBAAA;EACpB,oCAAA;ApIo0uBJ;;AmIxsuBM;EACE,yEAAA;EACA,oCAAA;EACA,WAAA;AnI2suBR;AmIzsuBQ;EACE,yEAAA;EACA,sBAAA;EACA,mCAAA;AnI2suBV;AmIxsuBQ;EAEE,sBAAA;AnIysuBV;;AmIpsuBM;EACE,6BAAA;EACA,cEbC;ArIotuBT;AmIrsuBQ;EACE,cEhBD;EFiBC,0CAAA;AnIusuBV;AmIpsuBQ;EAEE,yBEtBD;EFuBC,sBAAA;AnIqsuBV;;AmIhsuBM;EACE,yBE7BC;EF8BD,+CAAA;EACA,WAAA;AnImsuBR;AmIjsuBQ;EACE,WAAA;AnImsuBV;AmIhsuBQ;EAEE,aAAA;EACA,0BAAA;AnIisuBV;;AmI5ruBM;EACE,yBAAA;EACA,6BAAA;EACA,cEhDC;ArI+uuBT;AmI7ruBQ;EACE,2CAAA;EACA,cEpDD;ArImvuBT;AmI7ruBQ;EACE,sBAAA;AnI+ruBV;;AmIrruBY;;;EACE,yBElEL;EFmEK,WAAA;AnI0ruBd;AmIzruBc;;;EACE,WAAA;AnI6ruBhB;AmIxruBc;;;EACE,cE3EP;ArIuwuBT;;AmInruBQ;EACE,yBErFD;ArI2wuBT;AmIrruBU;EACE,6BAAA;EACA,yBAAA;AnIuruBZ;;AmI7quBY;;;;EAEE,8BAAA;EACA,WAAA;AnIkruBd;AmIhruBc;;;;EACE,sBAAA;AnIqruBhB;AmI9quBY;;;;EACE,yBAAA;AnImruBd;AmI7quBY;;;EACE,mBEvHL;EFwHK,WAAA;AnIiruBd;;AmIvquBY;EACE,WAAA;EACA,yBEpIL;ArI8yuBT;;AmIlquBM;EACE,oCAAA;AnIqquBR;AmIpquBQ;EACE,sBAAA;AnIsquBV;;AmI9puBU;EAEE,gCAAA;AnIgquBZ;;AmIrpuBY;EACE,oCAAA;AnIwpuBd;;AmIlpuBM;EACE,iEAAA;AnIqpuBR;;AmI/ouBU;EACE,gCAAA;AnIkpuBZ;AmIjpuBY;EACE,oCAAA;AnImpuBd;AmIhpuBU;EACE,oCAAA;AnIkpuBZ;;AmIxouBc;EACE,cEpMP;ArI+0uBT;AmIpouBgB;EACE,sEAAA;EAKA,4DAAA;AnIkouBlB;AmI9nuBgB;EACE,sEAAA;EAKA,4DAAA;AnI4nuBlB;;AmIjnuBU;EACE,yBAAA;AnIonuBZ;AmI9muBc;EACE,sEAAA;EAKA,4DAAA;AnI4muBhB;;AmIlmuBQ;EACE,oCAAA;EACA,WAAA;EACA,6BAAA;AnIqmuBV;;AmIhmuBM;EACE,6BAAA;AnImmuBR;AmIlmuBQ;EACE,qBExQD;ArI42uBT;AmIlmuBQ;EACE,yBE3QD;ArI+2uBT;;AmI5luBY;EACE,8BAAA;EACA,4DAAA;AnI+luBd;;AmIzluBM;EACE,kEAAA;AnI4luBR;;AmIzluBM;EACE,6EAAA;AnI4luBR;;AmIzluBM;EACE,yEAAA;EACA,6EAAA;AnI4luBR;AmI1luBQ;EACE,yEAAA;EACA,4EAAA;AnI4luBV;AmIzluBQ;EAEE,wEAAA;EACA,8EAAA;AnI0luBV;;AmItluBM;EACE,yEAAA;EACA,kEAAA;AnIyluBR;AmIvluBQ;EACE,6EAAA;AnIyluBV;;AmIrluBM;EACE,0GAAA;AnIwluBR;;AmIrluBM;EACE,6EAAA;AnIwluBR;;AmIrluBM;EACE,iFAAA;AnIwluBR;;AmIrluBM;EACE,oFAAA;AnIwluBR;;AmIrluBM;EACE,kFAAA;AnIwluBR;;AmIrluBM;EACE,mFAAA;AnIwluBR;;AmIrluBM;ECxdF,4DCoIK,EDpIe,iBAAA;EACpB,kEAAA;ApIijvBJ;;AmInpuBM;EACE,kEAAA;AnIspuBR;;AmInpuBM;EACE,6EAAA;AnIspuBR;;AmInpuBM;EACE,yEAAA;EACA,6EAAA;AnIspuBR;AmIppuBQ;EACE,yEAAA;EACA,4EAAA;AnIspuBV;AmInpuBQ;EAEE,wEAAA;EACA,8EAAA;AnIopuBV;;AmIhpuBM;EACE,yEAAA;EACA,kEAAA;AnImpuBR;AmIjpuBQ;EACE,6EAAA;AnImpuBV;;AmI/ouBM;EACE,0GAAA;AnIkpuBR;;AmI/ouBM;EACE,6EAAA;AnIkpuBR;;AmI/ouBM;EACE,iFAAA;AnIkpuBR;;AmI/ouBM;EACE,oFAAA;AnIkpuBR;;AmI/ouBM;EACE,kFAAA;AnIkpuBR;;AmI/ouBM;EACE,mFAAA;AnIkpuBR;;AmI/ouBM;ECxdF,4DCoIK,EDpIe,iBAAA;EACpB,kEAAA;ApI2mvBJ;;AmI7suBM;EACE,iEAAA;AnIgtuBR;;AmI7suBM;EACE,4EAAA;AnIgtuBR;;AmI7suBM;EACE,yEAAA;EACA,4EAAA;AnIgtuBR;AmI9suBQ;EACE,yEAAA;EACA,4EAAA;AnIgtuBV;AmI7suBQ;EAEE,wEAAA;EACA,8EAAA;AnI8suBV;;AmI1suBM;EACE,wEAAA;EACA,iEAAA;AnI6suBR;AmI3suBQ;EACE,4EAAA;AnI6suBV;;AmIzsuBM;EACE,yGAAA;AnI4suBR;;AmIzsuBM;EACE,4EAAA;AnI4suBR;;AmIzsuBM;EACE,gFAAA;AnI4suBR;;AmIzsuBM;EACE,mFAAA;AnI4suBR;;AmIzsuBM;EACE,iFAAA;AnI4suBR;;AmIzsuBM;EACE,kFAAA;AnI4suBR;;AmIzsuBM;ECxdF,2DCoIK,EDpIe,iBAAA;EACpB,iEAAA;ApIqqvBJ;;AmIvwuBM;EACE,mEAAA;AnI0wuBR;;AmIvwuBM;EACE,8EAAA;AnI0wuBR;;AmIvwuBM;EACE,yEAAA;EACA,8EAAA;AnI0wuBR;AmIxwuBQ;EACE,yEAAA;EACA,4EAAA;AnI0wuBV;AmIvwuBQ;EAEE,wEAAA;EACA,8EAAA;AnIwwuBV;;AmIpwuBM;EACE,0EAAA;EACA,mEAAA;AnIuwuBR;AmIrwuBQ;EACE,8EAAA;AnIuwuBV;;AmInwuBM;EACE,2GAAA;AnIswuBR;;AmInwuBM;EACE,8EAAA;AnIswuBR;;AmInwuBM;EACE,kFAAA;AnIswuBR;;AmInwuBM;EACE,qFAAA;AnIswuBR;;AmInwuBM;EACE,mFAAA;AnIswuBR;;AmInwuBM;EACE,oFAAA;AnIswuBR;;AmInwuBM;ECxdF,6DCoIK,EDpIe,iBAAA;EACpB,mEAAA;ApI+tvBJ;;AmIj0uBM;EACE,yBAAA;AnIo0uBR;;AmIj0uBM;EACE,oCAAA;AnIo0uBR;;AmIj0uBM;EACE,yEAAA;EACA,oCAAA;AnIo0uBR;AmIl0uBQ;EACE,yEAAA;EACA,4EAAA;AnIo0uBV;AmIj0uBQ;EAEE,wEAAA;EACA,8EAAA;AnIk0uBV;;AmI9zuBM;EACE,gCAAA;EACA,yBAAA;AnIi0uBR;AmI/zuBQ;EACE,oCAAA;AnIi0uBV;;AmI7zuBM;EACE,iEAAA;AnIg0uBR;;AmI7zuBM;EACE,oCAAA;AnIg0uBR;;AmI7zuBM;EACE,wCAAA;AnIg0uBR;;AmI7zuBM;EACE,2CAAA;AnIg0uBR;;AmI7zuBM;EACE,yCAAA;AnIg0uBR;;AmI7zuBM;EACE,0CAAA;AnIg0uBR;;AmI7zuBM;ECxdF,mBCoIK,EDpIe,iBAAA;EACpB,oCAAA;ApIyxvBJ;;AmI33uBM;EACE,yBAAA;AnI83uBR;;AmI33uBM;EACE,oCAAA;AnI83uBR;;AmI33uBM;EACE,yEAAA;EACA,oCAAA;AnI83uBR;AmI53uBQ;EACE,yEAAA;EACA,4EAAA;AnI83uBV;AmI33uBQ;EAEE,wEAAA;EACA,8EAAA;AnI43uBV;;AmIx3uBM;EACE,gCAAA;EACA,yBAAA;AnI23uBR;AmIz3uBQ;EACE,oCAAA;AnI23uBV;;AmIv3uBM;EACE,iEAAA;AnI03uBR;;AmIv3uBM;EACE,oCAAA;AnI03uBR;;AmIv3uBM;EACE,wCAAA;AnI03uBR;;AmIv3uBM;EACE,2CAAA;AnI03uBR;;AmIv3uBM;EACE,yCAAA;AnI03uBR;;AmIv3uBM;EACE,0CAAA;AnI03uBR;;AmIv3uBM;ECxdF,mBCoIK,EDpIe,iBAAA;EACpB,oCAAA;ApIm1vBJ;;AmIr7uBM;EACE,yBAAA;AnIw7uBR;;AmIr7uBM;EACE,oCAAA;AnIw7uBR;;AmIr7uBM;EACE,yEAAA;EACA,oCAAA;AnIw7uBR;AmIt7uBQ;EACE,yEAAA;EACA,4EAAA;AnIw7uBV;AmIr7uBQ;EAEE,wEAAA;EACA,8EAAA;AnIs7uBV;;AmIl7uBM;EACE,gCAAA;EACA,yBAAA;AnIq7uBR;AmIn7uBQ;EACE,oCAAA;AnIq7uBV;;AmIj7uBM;EACE,iEAAA;AnIo7uBR;;AmIj7uBM;EACE,oCAAA;AnIo7uBR;;AmIj7uBM;EACE,wCAAA;AnIo7uBR;;AmIj7uBM;EACE,2CAAA;AnIo7uBR;;AmIj7uBM;EACE,yCAAA;AnIo7uBR;;AmIj7uBM;EACE,0CAAA;AnIo7uBR;;AmIj7uBM;ECxdF,mBCoIK,EDpIe,iBAAA;EACpB,mCAAA;ApI64vBJ;;AmI/+uBM;EACE,yBAAA;AnIk/uBR;;AmI/+uBM;EACE,oCAAA;AnIk/uBR;;AmI/+uBM;EACE,yEAAA;EACA,oCAAA;AnIk/uBR;AmIh/uBQ;EACE,yEAAA;EACA,4EAAA;AnIk/uBV;AmI/+uBQ;EAEE,wEAAA;EACA,8EAAA;AnIg/uBV;;AmI5+uBM;EACE,gCAAA;EACA,yBAAA;AnI++uBR;AmI7+uBQ;EACE,oCAAA;AnI++uBV;;AmI3+uBM;EACE,iEAAA;AnI8+uBR;;AmI3+uBM;EACE,oCAAA;AnI8+uBR;;AmI3+uBM;EACE,wCAAA;AnI8+uBR;;AmI3+uBM;EACE,2CAAA;AnI8+uBR;;AmI3+uBM;EACE,yCAAA;AnI8+uBR;;AmI3+uBM;EACE,0CAAA;AnI8+uBR;;AmI3+uBM;ECxdF,mBCoIK,EDpIe,iBAAA;EACpB,mCAAA;ApIu8vBJ;;AmIzivBM;EACE,yBAAA;AnI4ivBR;;AmIzivBM;EACE,oCAAA;AnI4ivBR;;AmIzivBM;EACE,yEAAA;EACA,oCAAA;AnI4ivBR;AmI1ivBQ;EACE,yEAAA;EACA,4EAAA;AnI4ivBV;AmIzivBQ;EAEE,wEAAA;EACA,8EAAA;AnI0ivBV;;AmItivBM;EACE,gCAAA;EACA,yBAAA;AnIyivBR;AmIvivBQ;EACE,oCAAA;AnIyivBV;;AmIrivBM;EACE,iEAAA;AnIwivBR;;AmIrivBM;EACE,oCAAA;AnIwivBR;;AmIrivBM;EACE,wCAAA;AnIwivBR;;AmIrivBM;EACE,2CAAA;AnIwivBR;;AmIrivBM;EACE,yCAAA;AnIwivBR;;AmIrivBM;EACE,0CAAA;AnIwivBR;;AmIrivBM;ECxdF,mBCoIK,EDpIe,iBAAA;EACpB,kCAAA;ApIigwBJ;;AmInmvBM;EACE,oEAAA;AnIsmvBR;;AmInmvBM;EACE,+EAAA;AnIsmvBR;;AmInmvBM;EACE,mEAAA;EACA,+EAAA;AnIsmvBR;AmIpmvBQ;EACE,mEAAA;EACA,wEAAA;AnIsmvBV;AmInmvBQ;EAEE,oEAAA;EACA,qEAAA;AnIomvBV;;AmIhmvBM;EACE,2EAAA;EACA,oEAAA;AnImmvBR;AmIjmvBQ;EACE,+EAAA;AnImmvBV;;AmI/lvBM;EACE,4GAAA;AnIkmvBR;;AmI/lvBM;EACE,+EAAA;AnIkmvBR;;AmI/lvBM;EACE,mFAAA;AnIkmvBR;;AmI/lvBM;EACE,sFAAA;AnIkmvBR;;AmI/lvBM;EACE,oFAAA;AnIkmvBR;;AmI/lvBM;EACE,qFAAA;AnIkmvBR;;AmI/lvBM;ECxdF,8DCoIK,EDpIe,iBAAA;EACpB,oEAAA;ApI2jwBJ;;AmI7pvBM;EACE,uBAAA;AnIgqvBR;;AmI7pvBM;EACE,kCAAA;AnIgqvBR;;AmI7pvBM;EACE,mEAAA;EACA,kCAAA;AnIgqvBR;AmI9pvBQ;EACE,mEAAA;EACA,wEAAA;AnIgqvBV;AmI7pvBQ;EAEE,oEAAA;EACA,qEAAA;AnI8pvBV;;AmI1pvBM;EACE,8BAAA;EACA,uBAAA;AnI6pvBR;AmI3pvBQ;EACE,kCAAA;AnI6pvBV;;AmIzpvBM;EACE,+DAAA;AnI4pvBR;;AmIzpvBM;EACE,kCAAA;AnI4pvBR;;AmIzpvBM;EACE,sCAAA;AnI4pvBR;;AmIzpvBM;EACE,yCAAA;AnI4pvBR;;AmIzpvBM;EACE,uCAAA;AnI4pvBR;;AmIzpvBM;EACE,wCAAA;AnI4pvBR;;AmIzpvBM;ECxdF,iBCoIK,EDpIe,iBAAA;EACpB,oCAAA;ApIqnwBJ;;AmIvtvBM;EACE,uBAAA;AnI0tvBR;;AmIvtvBM;EACE,kCAAA;AnI0tvBR;;AmIvtvBM;EACE,mEAAA;EACA,kCAAA;AnI0tvBR;AmIxtvBQ;EACE,mEAAA;EACA,wEAAA;AnI0tvBV;AmIvtvBQ;EAEE,oEAAA;EACA,qEAAA;AnIwtvBV;;AmIptvBM;EACE,8BAAA;EACA,uBAAA;AnIutvBR;AmIrtvBQ;EACE,kCAAA;AnIutvBV;;AmIntvBM;EACE,+DAAA;AnIstvBR;;AmIntvBM;EACE,kCAAA;AnIstvBR;;AmIntvBM;EACE,sCAAA;AnIstvBR;;AmIntvBM;EACE,yCAAA;AnIstvBR;;AmIntvBM;EACE,uCAAA;AnIstvBR;;AmIntvBM;EACE,wCAAA;AnIstvBR;;AmIntvBM;ECxdF,iBCoIK,EDpIe,iBAAA;EACpB,oCAAA;ApI+qwBJ;;AmIjxvBM;EACE,0DAAA;AnIoxvBR;;AmIjxvBM;EACE,qEAAA;AnIoxvBR;;AmIjxvBM;EACE,mEAAA;EACA,qEAAA;AnIoxvBR;AmIlxvBQ;EACE,mEAAA;EACA,wEAAA;AnIoxvBV;AmIjxvBQ;EAEE,oEAAA;EACA,qEAAA;AnIkxvBV;;AmI9wvBM;EACE,iEAAA;EACA,0DAAA;AnIixvBR;AmI/wvBQ;EACE,qEAAA;AnIixvBV;;AmI7wvBM;EACE,kGAAA;AnIgxvBR;;AmI7wvBM;EACE,qEAAA;AnIgxvBR;;AmI7wvBM;EACE,yEAAA;AnIgxvBR;;AmI7wvBM;EACE,4EAAA;AnIgxvBR;;AmI7wvBM;EACE,0EAAA;AnIgxvBR;;AmI7wvBM;EACE,2EAAA;AnIgxvBR;;AmI7wvBM;ECxdF,oDCoIK,EDpIe,iBAAA;EACpB,0DAAA;ApIyuwBJ;;AmI30vBM;EACE,6DAAA;AnI80vBR;;AmI30vBM;EACE,wEAAA;AnI80vBR;;AmI30vBM;EACE,mEAAA;EACA,wEAAA;AnI80vBR;AmI50vBQ;EACE,mEAAA;EACA,wEAAA;AnI80vBV;AmI30vBQ;EAEE,oEAAA;EACA,qEAAA;AnI40vBV;;AmIx0vBM;EACE,oEAAA;EACA,6DAAA;AnI20vBR;AmIz0vBQ;EACE,wEAAA;AnI20vBV;;AmIv0vBM;EACE,qGAAA;AnI00vBR;;AmIv0vBM;EACE,wEAAA;AnI00vBR;;AmIv0vBM;EACE,4EAAA;AnI00vBR;;AmIv0vBM;EACE,+EAAA;AnI00vBR;;AmIv0vBM;EACE,6EAAA;AnI00vBR;;AmIv0vBM;EACE,8EAAA;AnI00vBR;;AmIv0vBM;ECxdF,uDCoIK,EDpIe,iBAAA;EACpB,6DAAA;ApImywBJ;;AmIr4vBM;EACE,4DAAA;AnIw4vBR;;AmIr4vBM;EACE,uEAAA;AnIw4vBR;;AmIr4vBM;EACE,mEAAA;EACA,uEAAA;AnIw4vBR;AmIt4vBQ;EACE,mEAAA;EACA,wEAAA;AnIw4vBV;AmIr4vBQ;EAEE,oEAAA;EACA,qEAAA;AnIs4vBV;;AmIl4vBM;EACE,mEAAA;EACA,4DAAA;AnIq4vBR;AmIn4vBQ;EACE,uEAAA;AnIq4vBV;;AmIj4vBM;EACE,oGAAA;AnIo4vBR;;AmIj4vBM;EACE,uEAAA;AnIo4vBR;;AmIj4vBM;EACE,2EAAA;AnIo4vBR;;AmIj4vBM;EACE,8EAAA;AnIo4vBR;;AmIj4vBM;EACE,4EAAA;AnIo4vBR;;AmIj4vBM;EACE,6EAAA;AnIo4vBR;;AmIj4vBM;ECxdF,sDCoIK,EDpIe,iBAAA;EACpB,4DAAA;ApI61wBJ;;AmI/7vBM;EACE,6DAAA;AnIk8vBR;;AmI/7vBM;EACE,wEAAA;AnIk8vBR;;AmI/7vBM;EACE,mEAAA;EACA,wEAAA;AnIk8vBR;AmIh8vBQ;EACE,mEAAA;EACA,wEAAA;AnIk8vBV;AmI/7vBQ;EAEE,oEAAA;EACA,qEAAA;AnIg8vBV;;AmI57vBM;EACE,oEAAA;EACA,6DAAA;AnI+7vBR;AmI77vBQ;EACE,wEAAA;AnI+7vBV;;AmI37vBM;EACE,qGAAA;AnI87vBR;;AmI37vBM;EACE,wEAAA;AnI87vBR;;AmI37vBM;EACE,4EAAA;AnI87vBR;;AmI37vBM;EACE,+EAAA;AnI87vBR;;AmI37vBM;EACE,6EAAA;AnI87vBR;;AmI37vBM;EACE,8EAAA;AnI87vBR;;AmI37vBM;ECxdF,uDCoIK,EDpIe,iBAAA;EACpB,6DAAA;ApIu5wBJ;;AmIx2wBM;EACE,yBAAA;AnI22wBR;;AmIv2wBM;EACE,oCAAA;AnI02wBR;AmIx2wBQ;;EAEE,6BAAA;AnI02wBV;;AmIr2wBM;EACE,+CAAA;EACA,yBAAA;AnIw2wBR;AmIt2wBQ;EZjEN,sDAAA;AvH06wBF;AmIr2wBQ;EACE,6DAAA;AnIu2wBV;;AmIl2wBM;EACE,gDAAA;AnIq2wBR;;AmIj2wBM;EACE,oCAAA;AnIo2wBR;;AmIj2wBM;EACE,6BAAA;AnIo2wBR;;AmIj2wBM;EACE,gCAAA;AnIo2wBR;;AmIj2wBM;EACE,8BAAA;AnIo2wBR;;AmIj2wBM;EACE,+BAAA;AnIo2wBR;;AmIh2wBM;EACE,uBAAA;EACA,yBAAA;EACA,gBAAA;EACA,yBAAA;AnIm2wBR;;AmI51wBQ;;;EACE,gCAAA;AnIi2wBV;;AmI51wBM;ECxHF,mBCoIK,EDpIe,iBAAA;EACpB,oCAAA;ApIw9wBJ;;AmI51wBM;EACE,mEAAA;EACA,oCAAA;EACA,WAAA;AnI+1wBR;AmI71wBQ;EACE,oEAAA;EACA,sBAAA;EACA,mCAAA;AnI+1wBV;AmI51wBQ;EAEE,sBAAA;AnI61wBV;;AmIx1wBM;EACE,6BAAA;EACA,cEbC;ArIw2wBT;AmIz1wBQ;EACE,cEhBD;EFiBC,0CAAA;AnI21wBV;AmIx1wBQ;EAEE,yBEtBD;EFuBC,sBAAA;AnIy1wBV;;AmIp1wBM;EACE,yBE7BC;EF8BD,+CAAA;EACA,WAAA;AnIu1wBR;AmIr1wBQ;EACE,WAAA;AnIu1wBV;AmIp1wBQ;EAEE,aAAA;EACA,0BAAA;AnIq1wBV;;AmIh1wBM;EACE,yBAAA;EACA,6BAAA;EACA,cEhDC;ArIm4wBT;AmIj1wBQ;EACE,2CAAA;EACA,cEpDD;ArIu4wBT;AmIj1wBQ;EACE,sBAAA;AnIm1wBV;;AmIz0wBY;;;EACE,yBElEL;EFmEK,WAAA;AnI80wBd;AmI70wBc;;;EACE,WAAA;AnIi1wBhB;AmI50wBc;;;EACE,cE3EP;ArI25wBT;;AmIv0wBQ;EACE,yBErFD;ArI+5wBT;AmIz0wBU;EACE,6BAAA;EACA,yBAAA;AnI20wBZ;;AmIj0wBY;;;;EAEE,8BAAA;EACA,WAAA;AnIs0wBd;AmIp0wBc;;;;EACE,sBAAA;AnIy0wBhB;AmIl0wBY;;;;EACE,yBAAA;AnIu0wBd;AmIj0wBY;;;EACE,mBEvHL;EFwHK,WAAA;AnIq0wBd;;AmI3zwBY;EACE,WAAA;EACA,yBEpIL;ArIk8wBT;;AmItzwBM;EACE,oCAAA;AnIyzwBR;AmIxzwBQ;EACE,sBAAA;AnI0zwBV;;AmIlzwBU;EAEE,gCAAA;AnIozwBZ;;AmIzywBY;EACE,oCAAA;AnI4ywBd;;AmItywBM;EACE,iEAAA;AnIyywBR;;AmInywBU;EACE,gCAAA;AnIsywBZ;AmIrywBY;EACE,oCAAA;AnIuywBd;AmIpywBU;EACE,oCAAA;AnIsywBZ;;AmI5xwBc;EACE,cEpMP;ArIm+wBT;AmIxxwBgB;EACE,sEAAA;EAKA,4DAAA;AnIsxwBlB;AmIlxwBgB;EACE,sEAAA;EAKA,4DAAA;AnIgxwBlB;;AmIrwwBU;EACE,yBAAA;AnIwwwBZ;AmIlwwBc;EACE,sEAAA;EAKA,4DAAA;AnIgwwBhB;;AmItvwBQ;EACE,oCAAA;EACA,WAAA;EACA,6BAAA;AnIyvwBV;;AmIpvwBM;EACE,6BAAA;AnIuvwBR;AmItvwBQ;EACE,qBExQD;ArIggxBT;AmItvwBQ;EACE,yBE3QD;ArImgxBT;;AmIhvwBY;EACE,8BAAA;EACA,4DAAA;AnImvwBd;;AmI7uwBM;EACE,6DAAA;AnIgvwBR;;AmI7uwBM;EACE,wEAAA;AnIgvwBR;;AmI7uwBM;EACE,mEAAA;EACA,wEAAA;AnIgvwBR;AmI9uwBQ;EACE,mEAAA;EACA,wEAAA;AnIgvwBV;AmI7uwBQ;EAEE,oEAAA;EACA,qEAAA;AnI8uwBV;;AmI1uwBM;EACE,oEAAA;EACA,6DAAA;AnI6uwBR;AmI3uwBQ;EACE,wEAAA;AnI6uwBV;;AmIzuwBM;EACE,qGAAA;AnI4uwBR;;AmIzuwBM;EACE,wEAAA;AnI4uwBR;;AmIzuwBM;EACE,4EAAA;AnI4uwBR;;AmIzuwBM;EACE,+EAAA;AnI4uwBR;;AmIzuwBM;EACE,6EAAA;AnI4uwBR;;AmIzuwBM;EACE,8EAAA;AnI4uwBR;;AmIzuwBM;ECxdF,uDCoIK,EDpIe,iBAAA;EACpB,6DAAA;ApIqsxBJ;;AmIvywBM;EACE,4DAAA;AnI0ywBR;;AmIvywBM;EACE,uEAAA;AnI0ywBR;;AmIvywBM;EACE,mEAAA;EACA,uEAAA;AnI0ywBR;AmIxywBQ;EACE,mEAAA;EACA,wEAAA;AnI0ywBV;AmIvywBQ;EAEE,oEAAA;EACA,qEAAA;AnIwywBV;;AmIpywBM;EACE,mEAAA;EACA,4DAAA;AnIuywBR;AmIrywBQ;EACE,uEAAA;AnIuywBV;;AmInywBM;EACE,oGAAA;AnIsywBR;;AmInywBM;EACE,uEAAA;AnIsywBR;;AmInywBM;EACE,2EAAA;AnIsywBR;;AmInywBM;EACE,8EAAA;AnIsywBR;;AmInywBM;EACE,4EAAA;AnIsywBR;;AmInywBM;EACE,6EAAA;AnIsywBR;;AmInywBM;ECxdF,sDCoIK,EDpIe,iBAAA;EACpB,4DAAA;ApI+vxBJ;;AmIj2wBM;EACE,6DAAA;AnIo2wBR;;AmIj2wBM;EACE,wEAAA;AnIo2wBR;;AmIj2wBM;EACE,mEAAA;EACA,wEAAA;AnIo2wBR;AmIl2wBQ;EACE,mEAAA;EACA,wEAAA;AnIo2wBV;AmIj2wBQ;EAEE,oEAAA;EACA,qEAAA;AnIk2wBV;;AmI91wBM;EACE,oEAAA;EACA,6DAAA;AnIi2wBR;AmI/1wBQ;EACE,wEAAA;AnIi2wBV;;AmI71wBM;EACE,qGAAA;AnIg2wBR;;AmI71wBM;EACE,wEAAA;AnIg2wBR;;AmI71wBM;EACE,4EAAA;AnIg2wBR;;AmI71wBM;EACE,+EAAA;AnIg2wBR;;AmI71wBM;EACE,6EAAA;AnIg2wBR;;AmI71wBM;EACE,8EAAA;AnIg2wBR;;AmI71wBM;ECxdF,uDCoIK,EDpIe,iBAAA;EACpB,6DAAA;ApIyzxBJ;;AmI35wBM;EACE,0DAAA;AnI85wBR;;AmI35wBM;EACE,qEAAA;AnI85wBR;;AmI35wBM;EACE,mEAAA;EACA,qEAAA;AnI85wBR;AmI55wBQ;EACE,mEAAA;EACA,wEAAA;AnI85wBV;AmI35wBQ;EAEE,oEAAA;EACA,qEAAA;AnI45wBV;;AmIx5wBM;EACE,iEAAA;EACA,0DAAA;AnI25wBR;AmIz5wBQ;EACE,qEAAA;AnI25wBV;;AmIv5wBM;EACE,kGAAA;AnI05wBR;;AmIv5wBM;EACE,qEAAA;AnI05wBR;;AmIv5wBM;EACE,yEAAA;AnI05wBR;;AmIv5wBM;EACE,4EAAA;AnI05wBR;;AmIv5wBM;EACE,0EAAA;AnI05wBR;;AmIv5wBM;EACE,2EAAA;AnI05wBR;;AmIv5wBM;ECxdF,oDCoIK,EDpIe,iBAAA;EACpB,0DAAA;ApIm3xBJ;;AmIr9wBM;EACE,yBAAA;AnIw9wBR;;AmIr9wBM;EACE,oCAAA;AnIw9wBR;;AmIr9wBM;EACE,mEAAA;EACA,oCAAA;AnIw9wBR;AmIt9wBQ;EACE,mEAAA;EACA,wEAAA;AnIw9wBV;AmIr9wBQ;EAEE,oEAAA;EACA,qEAAA;AnIs9wBV;;AmIl9wBM;EACE,gCAAA;EACA,yBAAA;AnIq9wBR;AmIn9wBQ;EACE,oCAAA;AnIq9wBV;;AmIj9wBM;EACE,iEAAA;AnIo9wBR;;AmIj9wBM;EACE,oCAAA;AnIo9wBR;;AmIj9wBM;EACE,wCAAA;AnIo9wBR;;AmIj9wBM;EACE,2CAAA;AnIo9wBR;;AmIj9wBM;EACE,yCAAA;AnIo9wBR;;AmIj9wBM;EACE,0CAAA;AnIo9wBR;;AmIj9wBM;ECxdF,mBCoIK,EDpIe,iBAAA;EACpB,kCAAA;ApI66xBJ;;AmI/gxBM;EACE,oEAAA;AnIkhxBR;;AmI/gxBM;EACE,+EAAA;AnIkhxBR;;AmI/gxBM;EACE,0EAAA;EACA,+EAAA;AnIkhxBR;AmIhhxBQ;EACE,0EAAA;EACA,8EAAA;AnIkhxBV;AmI/gxBQ;EAEE,0EAAA;EACA,8EAAA;AnIghxBV;;AmI5gxBM;EACE,2EAAA;EACA,oEAAA;AnI+gxBR;AmI7gxBQ;EACE,+EAAA;AnI+gxBV;;AmI3gxBM;EACE,4GAAA;AnI8gxBR;;AmI3gxBM;EACE,+EAAA;AnI8gxBR;;AmI3gxBM;EACE,mFAAA;AnI8gxBR;;AmI3gxBM;EACE,sFAAA;AnI8gxBR;;AmI3gxBM;EACE,oFAAA;AnI8gxBR;;AmI3gxBM;EACE,qFAAA;AnI8gxBR;;AmI3gxBM;ECxdF,8DCoIK,EDpIe,iBAAA;EACpB,oEAAA;ApIu+xBJ;;AmIzkxBM;EACE,qEAAA;AnI4kxBR;;AmIzkxBM;EACE,gFAAA;AnI4kxBR;;AmIzkxBM;EACE,0EAAA;EACA,gFAAA;AnI4kxBR;AmI1kxBQ;EACE,0EAAA;EACA,8EAAA;AnI4kxBV;AmIzkxBQ;EAEE,0EAAA;EACA,8EAAA;AnI0kxBV;;AmItkxBM;EACE,4EAAA;EACA,qEAAA;AnIykxBR;AmIvkxBQ;EACE,gFAAA;AnIykxBV;;AmIrkxBM;EACE,6GAAA;AnIwkxBR;;AmIrkxBM;EACE,gFAAA;AnIwkxBR;;AmIrkxBM;EACE,oFAAA;AnIwkxBR;;AmIrkxBM;EACE,uFAAA;AnIwkxBR;;AmIrkxBM;EACE,qFAAA;AnIwkxBR;;AmIrkxBM;EACE,sFAAA;AnIwkxBR;;AmIrkxBM;ECxdF,+DCoIK,EDpIe,iBAAA;EACpB,qEAAA;ApIiiyBJ;;AmInoxBM;EACE,qEAAA;AnIsoxBR;;AmInoxBM;EACE,gFAAA;AnIsoxBR;;AmInoxBM;EACE,0EAAA;EACA,gFAAA;AnIsoxBR;AmIpoxBQ;EACE,0EAAA;EACA,8EAAA;AnIsoxBV;AmInoxBQ;EAEE,0EAAA;EACA,8EAAA;AnIooxBV;;AmIhoxBM;EACE,4EAAA;EACA,qEAAA;AnImoxBR;AmIjoxBQ;EACE,gFAAA;AnImoxBV;;AmI/nxBM;EACE,6GAAA;AnIkoxBR;;AmI/nxBM;EACE,gFAAA;AnIkoxBR;;AmI/nxBM;EACE,oFAAA;AnIkoxBR;;AmI/nxBM;EACE,uFAAA;AnIkoxBR;;AmI/nxBM;EACE,qFAAA;AnIkoxBR;;AmI/nxBM;EACE,sFAAA;AnIkoxBR;;AmI/nxBM;ECxdF,+DCoIK,EDpIe,iBAAA;EACpB,qEAAA;ApI2lyBJ;;AmI7rxBM;EACE,oEAAA;AnIgsxBR;;AmI7rxBM;EACE,+EAAA;AnIgsxBR;;AmI7rxBM;EACE,0EAAA;EACA,+EAAA;AnIgsxBR;AmI9rxBQ;EACE,0EAAA;EACA,8EAAA;AnIgsxBV;AmI7rxBQ;EAEE,0EAAA;EACA,8EAAA;AnI8rxBV;;AmI1rxBM;EACE,2EAAA;EACA,oEAAA;AnI6rxBR;AmI3rxBQ;EACE,+EAAA;AnI6rxBV;;AmIzrxBM;EACE,4GAAA;AnI4rxBR;;AmIzrxBM;EACE,+EAAA;AnI4rxBR;;AmIzrxBM;EACE,mFAAA;AnI4rxBR;;AmIzrxBM;EACE,sFAAA;AnI4rxBR;;AmIzrxBM;EACE,oFAAA;AnI4rxBR;;AmIzrxBM;EACE,qFAAA;AnI4rxBR;;AmIzrxBM;ECxdF,8DCoIK,EDpIe,iBAAA;EACpB,oEAAA;ApIqpyBJ;;AmIvvxBM;EACE,oEAAA;AnI0vxBR;;AmIvvxBM;EACE,+EAAA;AnI0vxBR;;AmIvvxBM;EACE,0EAAA;EACA,+EAAA;AnI0vxBR;AmIxvxBQ;EACE,0EAAA;EACA,8EAAA;AnI0vxBV;AmIvvxBQ;EAEE,0EAAA;EACA,8EAAA;AnIwvxBV;;AmIpvxBM;EACE,2EAAA;EACA,oEAAA;AnIuvxBR;AmIrvxBQ;EACE,+EAAA;AnIuvxBV;;AmInvxBM;EACE,4GAAA;AnIsvxBR;;AmInvxBM;EACE,+EAAA;AnIsvxBR;;AmInvxBM;EACE,mFAAA;AnIsvxBR;;AmInvxBM;EACE,sFAAA;AnIsvxBR;;AmInvxBM;EACE,oFAAA;AnIsvxBR;;AmInvxBM;EACE,qFAAA;AnIsvxBR;;AmInvxBM;ECxdF,8DCoIK,EDpIe,iBAAA;EACpB,oEAAA;ApI+syBJ;;AmIjzxBM;EACE,kEAAA;AnIozxBR;;AmIjzxBM;EACE,6EAAA;AnIozxBR;;AmIjzxBM;EACE,0EAAA;EACA,6EAAA;AnIozxBR;AmIlzxBQ;EACE,0EAAA;EACA,8EAAA;AnIozxBV;AmIjzxBQ;EAEE,0EAAA;EACA,8EAAA;AnIkzxBV;;AmI9yxBM;EACE,yEAAA;EACA,kEAAA;AnIizxBR;AmI/yxBQ;EACE,6EAAA;AnIizxBV;;AmI7yxBM;EACE,0GAAA;AnIgzxBR;;AmI7yxBM;EACE,6EAAA;AnIgzxBR;;AmI7yxBM;EACE,iFAAA;AnIgzxBR;;AmI7yxBM;EACE,oFAAA;AnIgzxBR;;AmI7yxBM;EACE,kFAAA;AnIgzxBR;;AmI7yxBM;EACE,mFAAA;AnIgzxBR;;AmI7yxBM;ECxdF,4DCoIK,EDpIe,iBAAA;EACpB,kEAAA;ApIywyBJ;;AmI32xBM;EACE,oEAAA;AnI82xBR;;AmI32xBM;EACE,+EAAA;AnI82xBR;;AmI32xBM;EACE,0EAAA;EACA,+EAAA;AnI82xBR;AmI52xBQ;EACE,0EAAA;EACA,8EAAA;AnI82xBV;AmI32xBQ;EAEE,0EAAA;EACA,8EAAA;AnI42xBV;;AmIx2xBM;EACE,2EAAA;EACA,oEAAA;AnI22xBR;AmIz2xBQ;EACE,+EAAA;AnI22xBV;;AmIv2xBM;EACE,4GAAA;AnI02xBR;;AmIv2xBM;EACE,+EAAA;AnI02xBR;;AmIv2xBM;EACE,mFAAA;AnI02xBR;;AmIv2xBM;EACE,sFAAA;AnI02xBR;;AmIv2xBM;EACE,oFAAA;AnI02xBR;;AmIv2xBM;EACE,qFAAA;AnI02xBR;;AmIv2xBM;ECxdF,8DCoIK,EDpIe,iBAAA;EACpB,oEAAA;ApIm0yBJ;;AmIpxyBM;EACE,yBAAA;AnIuxyBR;;AmInxyBM;EACE,oCAAA;AnIsxyBR;AmIpxyBQ;;EAEE,6BAAA;AnIsxyBV;;AmIjxyBM;EACE,8CAAA;EACA,yBAAA;AnIoxyBR;AmIlxyBQ;EZjEN,qDAAA;AvHs1yBF;AmIjxyBQ;EACE,mEAAA;AnImxyBV;;AmI9wyBM;EACE,+CAAA;AnIixyBR;;AmI7wyBM;EACE,oCAAA;AnIgxyBR;;AmI7wyBM;EACE,6BAAA;AnIgxyBR;;AmI7wyBM;EACE,gCAAA;AnIgxyBR;;AmI7wyBM;EACE,8BAAA;AnIgxyBR;;AmI7wyBM;EACE,+BAAA;AnIgxyBR;;AmI5wyBM;EACE,qEAAA;EACA,yBAAA;EACA,gBAAA;EACA,yBAAA;AnI+wyBR;;AmIxwyBQ;;;EACE,gCAAA;AnI6wyBV;;AmIxwyBM;ECxHF,mBCoIK,EDpIe,iBAAA;EACpB,mCAAA;ApIo4yBJ;;AmIxwyBM;EACE,0EAAA;EACA,oCAAA;EACA,WAAA;AnI2wyBR;AmIzwyBQ;EACE,0EAAA;EACA,sBAAA;EACA,mCAAA;AnI2wyBV;AmIxwyBQ;EAEE,sBAAA;AnIywyBV;;AmIpwyBM;EACE,6BAAA;EACA,cEbC;ArIoxyBT;AmIrwyBQ;EACE,cEhBD;EFiBC,yCAAA;AnIuwyBV;AmIpwyBQ;EAEE,yBEtBD;EFuBC,sBAAA;AnIqwyBV;;AmIhwyBM;EACE,yBE7BC;EF8BD,+CAAA;EACA,WAAA;AnImwyBR;AmIjwyBQ;EACE,WAAA;AnImwyBV;AmIhwyBQ;EAEE,aAAA;EACA,0BAAA;AnIiwyBV;;AmI5vyBM;EACE,yBAAA;EACA,6BAAA;EACA,cEhDC;ArI+yyBT;AmI7vyBQ;EACE,0CAAA;EACA,cEpDD;ArImzyBT;AmI7vyBQ;EACE,sBAAA;AnI+vyBV;;AmIrvyBY;;;EACE,yBElEL;EFmEK,WAAA;AnI0vyBd;AmIzvyBc;;;EACE,WAAA;AnI6vyBhB;AmIxvyBc;;;EACE,cE3EP;ArIu0yBT;;AmInvyBQ;EACE,yBErFD;ArI20yBT;AmIrvyBU;EACE,6BAAA;EACA,yBAAA;AnIuvyBZ;;AmI7uyBY;;;;EAEE,8BAAA;EACA,WAAA;AnIkvyBd;AmIhvyBc;;;;EACE,sBAAA;AnIqvyBhB;AmI9uyBY;;;;EACE,yBAAA;AnImvyBd;AmI7uyBY;;;EACE,mBEvHL;EFwHK,WAAA;AnIivyBd;;AmIvuyBY;EACE,WAAA;EACA,yBEpIL;ArI82yBT;;AmIluyBM;EACE,oCAAA;AnIquyBR;AmIpuyBQ;EACE,sBAAA;AnIsuyBV;;AmI9tyBU;EAEE,gCAAA;AnIguyBZ;;AmIrtyBY;EACE,oCAAA;AnIwtyBd;;AmIltyBM;EACE,iEAAA;AnIqtyBR;;AmI/syBU;EACE,gCAAA;AnIktyBZ;AmIjtyBY;EACE,oCAAA;AnImtyBd;AmIhtyBU;EACE,oCAAA;AnIktyBZ;;AmIxsyBc;EACE,cEpMP;ArI+4yBT;AmIpsyBgB;EACE,qEAAA;EAKA,2DAAA;AnIksyBlB;AmI9ryBgB;EACE,qEAAA;EAKA,2DAAA;AnI4ryBlB;;AmIjryBU;EACE,yBAAA;AnIoryBZ;AmI9qyBc;EACE,qEAAA;EAKA,2DAAA;AnI4qyBhB;;AmIlqyBQ;EACE,oCAAA;EACA,WAAA;EACA,6BAAA;AnIqqyBV;;AmIhqyBM;EACE,6BAAA;AnImqyBR;AmIlqyBQ;EACE,qBExQD;ArI46yBT;AmIlqyBQ;EACE,yBE3QD;ArI+6yBT;;AmI5pyBY;EACE,8BAAA;EACA,2DAAA;AnI+pyBd;;AmIzpyBM;EACE,mEAAA;AnI4pyBR;;AmIzpyBM;EACE,8EAAA;AnI4pyBR;;AmIzpyBM;EACE,0EAAA;EACA,8EAAA;AnI4pyBR;AmI1pyBQ;EACE,0EAAA;EACA,8EAAA;AnI4pyBV;AmIzpyBQ;EAEE,0EAAA;EACA,8EAAA;AnI0pyBV;;AmItpyBM;EACE,0EAAA;EACA,mEAAA;AnIypyBR;AmIvpyBQ;EACE,8EAAA;AnIypyBV;;AmIrpyBM;EACE,2GAAA;AnIwpyBR;;AmIrpyBM;EACE,8EAAA;AnIwpyBR;;AmIrpyBM;EACE,kFAAA;AnIwpyBR;;AmIrpyBM;EACE,qFAAA;AnIwpyBR;;AmIrpyBM;EACE,mFAAA;AnIwpyBR;;AmIrpyBM;EACE,oFAAA;AnIwpyBR;;AmIrpyBM;ECxdF,6DCoIK,EDpIe,iBAAA;EACpB,mEAAA;ApIinzBJ;;AmIntyBM;EACE,mEAAA;AnIstyBR;;AmIntyBM;EACE,8EAAA;AnIstyBR;;AmIntyBM;EACE,0EAAA;EACA,8EAAA;AnIstyBR;AmIptyBQ;EACE,0EAAA;EACA,8EAAA;AnIstyBV;AmIntyBQ;EAEE,0EAAA;EACA,8EAAA;AnIotyBV;;AmIhtyBM;EACE,0EAAA;EACA,mEAAA;AnImtyBR;AmIjtyBQ;EACE,8EAAA;AnImtyBV;;AmI/syBM;EACE,2GAAA;AnIktyBR;;AmI/syBM;EACE,8EAAA;AnIktyBR;;AmI/syBM;EACE,kFAAA;AnIktyBR;;AmI/syBM;EACE,qFAAA;AnIktyBR;;AmI/syBM;EACE,mFAAA;AnIktyBR;;AmI/syBM;EACE,oFAAA;AnIktyBR;;AmI/syBM;ECxdF,6DCoIK,EDpIe,iBAAA;EACpB,mEAAA;ApI2qzBJ;;AmI7wyBM;EACE,mEAAA;AnIgxyBR;;AmI7wyBM;EACE,8EAAA;AnIgxyBR;;AmI7wyBM;EACE,0EAAA;EACA,8EAAA;AnIgxyBR;AmI9wyBQ;EACE,0EAAA;EACA,8EAAA;AnIgxyBV;AmI7wyBQ;EAEE,0EAAA;EACA,8EAAA;AnI8wyBV;;AmI1wyBM;EACE,0EAAA;EACA,mEAAA;AnI6wyBR;AmI3wyBQ;EACE,8EAAA;AnI6wyBV;;AmIzwyBM;EACE,2GAAA;AnI4wyBR;;AmIzwyBM;EACE,8EAAA;AnI4wyBR;;AmIzwyBM;EACE,kFAAA;AnI4wyBR;;AmIzwyBM;EACE,qFAAA;AnI4wyBR;;AmIzwyBM;EACE,mFAAA;AnI4wyBR;;AmIzwyBM;EACE,oFAAA;AnI4wyBR;;AmIzwyBM;ECxdF,6DCoIK,EDpIe,iBAAA;EACpB,mEAAA;ApIquzBJ;;AmIv0yBM;EACE,mEAAA;AnI00yBR;;AmIv0yBM;EACE,8EAAA;AnI00yBR;;AmIv0yBM;EACE,0EAAA;EACA,8EAAA;AnI00yBR;AmIx0yBQ;EACE,0EAAA;EACA,8EAAA;AnI00yBV;AmIv0yBQ;EAEE,0EAAA;EACA,8EAAA;AnIw0yBV;;AmIp0yBM;EACE,0EAAA;EACA,mEAAA;AnIu0yBR;AmIr0yBQ;EACE,8EAAA;AnIu0yBV;;AmIn0yBM;EACE,2GAAA;AnIs0yBR;;AmIn0yBM;EACE,8EAAA;AnIs0yBR;;AmIn0yBM;EACE,kFAAA;AnIs0yBR;;AmIn0yBM;EACE,qFAAA;AnIs0yBR;;AmIn0yBM;EACE,mFAAA;AnIs0yBR;;AmIn0yBM;EACE,oFAAA;AnIs0yBR;;AmIn0yBM;ECxdF,6DCoIK,EDpIe,iBAAA;EACpB,mEAAA;ApI+xzBJ;;AmIj4yBM;EACE,yBAAA;AnIo4yBR;;AmIj4yBM;EACE,oCAAA;AnIo4yBR;;AmIj4yBM;EACE,0EAAA;EACA,oCAAA;AnIo4yBR;AmIl4yBQ;EACE,0EAAA;EACA,8EAAA;AnIo4yBV;AmIj4yBQ;EAEE,0EAAA;EACA,8EAAA;AnIk4yBV;;AmI93yBM;EACE,gCAAA;EACA,yBAAA;AnIi4yBR;AmI/3yBQ;EACE,oCAAA;AnIi4yBV;;AmI73yBM;EACE,iEAAA;AnIg4yBR;;AmI73yBM;EACE,oCAAA;AnIg4yBR;;AmI73yBM;EACE,wCAAA;AnIg4yBR;;AmI73yBM;EACE,2CAAA;AnIg4yBR;;AmI73yBM;EACE,yCAAA;AnIg4yBR;;AmI73yBM;EACE,0CAAA;AnIg4yBR;;AmI73yBM;ECxdF,mBCoIK,EDpIe,iBAAA;EACpB,oCAAA;ApIy1zBJ;;AmI37yBM;EACE,yBAAA;AnI87yBR;;AmI37yBM;EACE,oCAAA;AnI87yBR;;AmI37yBM;EACE,0EAAA;EACA,oCAAA;AnI87yBR;AmI57yBQ;EACE,0EAAA;EACA,8EAAA;AnI87yBV;AmI37yBQ;EAEE,0EAAA;EACA,8EAAA;AnI47yBV;;AmIx7yBM;EACE,gCAAA;EACA,yBAAA;AnI27yBR;AmIz7yBQ;EACE,oCAAA;AnI27yBV;;AmIv7yBM;EACE,iEAAA;AnI07yBR;;AmIv7yBM;EACE,oCAAA;AnI07yBR;;AmIv7yBM;EACE,wCAAA;AnI07yBR;;AmIv7yBM;EACE,2CAAA;AnI07yBR;;AmIv7yBM;EACE,yCAAA;AnI07yBR;;AmIv7yBM;EACE,0CAAA;AnI07yBR;;AmIv7yBM;ECxdF,mBCoIK,EDpIe,iBAAA;EACpB,oCAAA;ApIm5zBJ;;AmIr/yBM;EACE,yBAAA;AnIw/yBR;;AmIr/yBM;EACE,oCAAA;AnIw/yBR;;AmIr/yBM;EACE,0EAAA;EACA,oCAAA;AnIw/yBR;AmIt/yBQ;EACE,0EAAA;EACA,8EAAA;AnIw/yBV;AmIr/yBQ;EAEE,0EAAA;EACA,8EAAA;AnIs/yBV;;AmIl/yBM;EACE,gCAAA;EACA,yBAAA;AnIq/yBR;AmIn/yBQ;EACE,oCAAA;AnIq/yBV;;AmIj/yBM;EACE,iEAAA;AnIo/yBR;;AmIj/yBM;EACE,oCAAA;AnIo/yBR;;AmIj/yBM;EACE,wCAAA;AnIo/yBR;;AmIj/yBM;EACE,2CAAA;AnIo/yBR;;AmIj/yBM;EACE,yCAAA;AnIo/yBR;;AmIj/yBM;EACE,0CAAA;AnIo/yBR;;AmIj/yBM;ECxdF,mBCoIK,EDpIe,iBAAA;EACpB,oCAAA;ApI68zBJ;;AmI/izBM;EACE,yBAAA;AnIkjzBR;;AmI/izBM;EACE,oCAAA;AnIkjzBR;;AmI/izBM;EACE,0EAAA;EACA,oCAAA;AnIkjzBR;AmIhjzBQ;EACE,0EAAA;EACA,8EAAA;AnIkjzBV;AmI/izBQ;EAEE,0EAAA;EACA,8EAAA;AnIgjzBV;;AmI5izBM;EACE,gCAAA;EACA,yBAAA;AnI+izBR;AmI7izBQ;EACE,oCAAA;AnI+izBV;;AmI3izBM;EACE,iEAAA;AnI8izBR;;AmI3izBM;EACE,oCAAA;AnI8izBR;;AmI3izBM;EACE,wCAAA;AnI8izBR;;AmI3izBM;EACE,2CAAA;AnI8izBR;;AmI3izBM;EACE,yCAAA;AnI8izBR;;AmI3izBM;EACE,0CAAA;AnI8izBR;;AmI3izBM;ECxdF,mBCoIK,EDpIe,iBAAA;EACpB,mCAAA;ApIug0BJ;;AmIzmzBM;EACE,yBAAA;AnI4mzBR;;AmIzmzBM;EACE,oCAAA;AnI4mzBR;;AmIzmzBM;EACE,0EAAA;EACA,oCAAA;AnI4mzBR;AmI1mzBQ;EACE,0EAAA;EACA,8EAAA;AnI4mzBV;AmIzmzBQ;EAEE,0EAAA;EACA,8EAAA;AnI0mzBV;;AmItmzBM;EACE,gCAAA;EACA,yBAAA;AnIymzBR;AmIvmzBQ;EACE,oCAAA;AnIymzBV;;AmIrmzBM;EACE,iEAAA;AnIwmzBR;;AmIrmzBM;EACE,oCAAA;AnIwmzBR;;AmIrmzBM;EACE,wCAAA;AnIwmzBR;;AmIrmzBM;EACE,2CAAA;AnIwmzBR;;AmIrmzBM;EACE,yCAAA;AnIwmzBR;;AmIrmzBM;EACE,0CAAA;AnIwmzBR;;AmIrmzBM;ECxdF,mBCoIK,EDpIe,iBAAA;EACpB,kCAAA;ApIik0BJ;;AmInqzBM;EACE,kDAAA;AnIsqzBR;;AmInqzBM;EACE,6DAAA;AnIsqzBR;;AmInqzBM;EACE,oDAAA;EACA,6DAAA;AnIsqzBR;AmIpqzBQ;EACE,oDAAA;EACA,0DAAA;AnIsqzBV;AmInqzBQ;EAEE,sDAAA;EACA,wDAAA;AnIoqzBV;;AmIhqzBM;EACE,yDAAA;EACA,kDAAA;AnImqzBR;AmIjqzBQ;EACE,6DAAA;AnImqzBV;;AmI/pzBM;EACE,0FAAA;AnIkqzBR;;AmI/pzBM;EACE,6DAAA;AnIkqzBR;;AmI/pzBM;EACE,iEAAA;AnIkqzBR;;AmI/pzBM;EACE,oEAAA;AnIkqzBR;;AmI/pzBM;EACE,kEAAA;AnIkqzBR;;AmI/pzBM;EACE,mEAAA;AnIkqzBR;;AmI/pzBM;ECxdF,4CCoIK,EDpIe,iBAAA;EACpB,kDAAA;ApI2n0BJ;;AmI7tzBM;EACE,8CAAA;AnIguzBR;;AmI7tzBM;EACE,yDAAA;AnIguzBR;;AmI7tzBM;EACE,oDAAA;EACA,yDAAA;AnIguzBR;AmI9tzBQ;EACE,oDAAA;EACA,0DAAA;AnIguzBV;AmI7tzBQ;EAEE,sDAAA;EACA,wDAAA;AnI8tzBV;;AmI1tzBM;EACE,qDAAA;EACA,8CAAA;AnI6tzBR;AmI3tzBQ;EACE,yDAAA;AnI6tzBV;;AmIztzBM;EACE,sFAAA;AnI4tzBR;;AmIztzBM;EACE,yDAAA;AnI4tzBR;;AmIztzBM;EACE,6DAAA;AnI4tzBR;;AmIztzBM;EACE,gEAAA;AnI4tzBR;;AmIztzBM;EACE,8DAAA;AnI4tzBR;;AmIztzBM;EACE,+DAAA;AnI4tzBR;;AmIztzBM;ECxdF,wCCoIK,EDpIe,iBAAA;EACpB,8CAAA;ApIqr0BJ;;AmIvxzBM;EACE,iDAAA;AnI0xzBR;;AmIvxzBM;EACE,4DAAA;AnI0xzBR;;AmIvxzBM;EACE,oDAAA;EACA,4DAAA;AnI0xzBR;AmIxxzBQ;EACE,oDAAA;EACA,0DAAA;AnI0xzBV;AmIvxzBQ;EAEE,sDAAA;EACA,wDAAA;AnIwxzBV;;AmIpxzBM;EACE,wDAAA;EACA,iDAAA;AnIuxzBR;AmIrxzBQ;EACE,4DAAA;AnIuxzBV;;AmInxzBM;EACE,yFAAA;AnIsxzBR;;AmInxzBM;EACE,4DAAA;AnIsxzBR;;AmInxzBM;EACE,gEAAA;AnIsxzBR;;AmInxzBM;EACE,mEAAA;AnIsxzBR;;AmInxzBM;EACE,iEAAA;AnIsxzBR;;AmInxzBM;EACE,kEAAA;AnIsxzBR;;AmInxzBM;ECxdF,2CCoIK,EDpIe,iBAAA;EACpB,iDAAA;ApI+u0BJ;;AmIj1zBM;EACE,8CAAA;AnIo1zBR;;AmIj1zBM;EACE,yDAAA;AnIo1zBR;;AmIj1zBM;EACE,oDAAA;EACA,yDAAA;AnIo1zBR;AmIl1zBQ;EACE,oDAAA;EACA,0DAAA;AnIo1zBV;AmIj1zBQ;EAEE,sDAAA;EACA,wDAAA;AnIk1zBV;;AmI90zBM;EACE,qDAAA;EACA,8CAAA;AnIi1zBR;AmI/0zBQ;EACE,yDAAA;AnIi1zBV;;AmI70zBM;EACE,sFAAA;AnIg1zBR;;AmI70zBM;EACE,yDAAA;AnIg1zBR;;AmI70zBM;EACE,6DAAA;AnIg1zBR;;AmI70zBM;EACE,gEAAA;AnIg1zBR;;AmI70zBM;EACE,8DAAA;AnIg1zBR;;AmI70zBM;EACE,+DAAA;AnIg1zBR;;AmI70zBM;ECxdF,wCCoIK,EDpIe,iBAAA;EACpB,8CAAA;ApIyy0BJ;;AmI34zBM;EACE,+CAAA;AnI84zBR;;AmI34zBM;EACE,0DAAA;AnI84zBR;;AmI34zBM;EACE,oDAAA;EACA,0DAAA;AnI84zBR;AmI54zBQ;EACE,oDAAA;EACA,0DAAA;AnI84zBV;AmI34zBQ;EAEE,sDAAA;EACA,wDAAA;AnI44zBV;;AmIx4zBM;EACE,sDAAA;EACA,+CAAA;AnI24zBR;AmIz4zBQ;EACE,0DAAA;AnI24zBV;;AmIv4zBM;EACE,uFAAA;AnI04zBR;;AmIv4zBM;EACE,0DAAA;AnI04zBR;;AmIv4zBM;EACE,8DAAA;AnI04zBR;;AmIv4zBM;EACE,iEAAA;AnI04zBR;;AmIv4zBM;EACE,+DAAA;AnI04zBR;;AmIv4zBM;EACE,gEAAA;AnI04zBR;;AmIv4zBM;ECxdF,yCCoIK,EDpIe,iBAAA;EACpB,+CAAA;ApIm20BJ;;AmIr8zBM;EACE,8CAAA;AnIw8zBR;;AmIr8zBM;EACE,yDAAA;AnIw8zBR;;AmIr8zBM;EACE,oDAAA;EACA,yDAAA;AnIw8zBR;AmIt8zBQ;EACE,oDAAA;EACA,0DAAA;AnIw8zBV;AmIr8zBQ;EAEE,sDAAA;EACA,wDAAA;AnIs8zBV;;AmIl8zBM;EACE,qDAAA;EACA,8CAAA;AnIq8zBR;AmIn8zBQ;EACE,yDAAA;AnIq8zBV;;AmIj8zBM;EACE,sFAAA;AnIo8zBR;;AmIj8zBM;EACE,yDAAA;AnIo8zBR;;AmIj8zBM;EACE,6DAAA;AnIo8zBR;;AmIj8zBM;EACE,gEAAA;AnIo8zBR;;AmIj8zBM;EACE,8DAAA;AnIo8zBR;;AmIj8zBM;EACE,+DAAA;AnIo8zBR;;AmIj8zBM;ECxdF,wCCoIK,EDpIe,iBAAA;EACpB,8CAAA;ApI650BJ;;AmI//zBM;EACE,+CAAA;AnIkg0BR;;AmI//zBM;EACE,0DAAA;AnIkg0BR;;AmI//zBM;EACE,oDAAA;EACA,0DAAA;AnIkg0BR;AmIhg0BQ;EACE,oDAAA;EACA,0DAAA;AnIkg0BV;AmI//zBQ;EAEE,sDAAA;EACA,wDAAA;AnIgg0BV;;AmI5/zBM;EACE,sDAAA;EACA,+CAAA;AnI+/zBR;AmI7/zBQ;EACE,0DAAA;AnI+/zBV;;AmI3/zBM;EACE,uFAAA;AnI8/zBR;;AmI3/zBM;EACE,0DAAA;AnI8/zBR;;AmI3/zBM;EACE,8DAAA;AnI8/zBR;;AmI3/zBM;EACE,iEAAA;AnI8/zBR;;AmI3/zBM;EACE,+DAAA;AnI8/zBR;;AmI3/zBM;EACE,gEAAA;AnI8/zBR;;AmI3/zBM;ECxdF,yCCoIK,EDpIe,iBAAA;EACpB,+CAAA;ApIu90BJ;;AmIx60BM;EACE,yBAAA;AnI260BR;;AmIv60BM;EACE,oCAAA;AnI060BR;AmIx60BQ;;EAEE,6BAAA;AnI060BV;;AmIr60BM;EACE,6CAAA;EACA,yBAAA;AnIw60BR;AmIt60BQ;EZjEN,oDAAA;AvH0+0BF;AmIr60BQ;EACE,+CAAA;AnIu60BV;;AmIl60BM;EACE,8CAAA;AnIq60BR;;AmIj60BM;EACE,oCAAA;AnIo60BR;;AmIj60BM;EACE,6BAAA;AnIo60BR;;AmIj60BM;EACE,gCAAA;AnIo60BR;;AmIj60BM;EACE,8BAAA;AnIo60BR;;AmIj60BM;EACE,+BAAA;AnIo60BR;;AmIh60BM;EACE,8CAAA;EACA,yBAAA;EACA,gBAAA;EACA,yBAAA;AnIm60BR;;AmI550BQ;;;EACE,gCAAA;AnIi60BV;;AmI550BM;ECxHF,mBCoIK,EDpIe,iBAAA;EACpB,kCAAA;ApIwh1BJ;;AmI550BM;EACE,oDAAA;EACA,oCAAA;EACA,WAAA;AnI+50BR;AmI750BQ;EACE,sDAAA;EACA,sBAAA;EACA,mCAAA;AnI+50BV;AmI550BQ;EAEE,sBAAA;AnI650BV;;AmIx50BM;EACE,6BAAA;EACA,cEbC;ArIw60BT;AmIz50BQ;EACE,cEhBD;EFiBC,wCAAA;AnI250BV;AmIx50BQ;EAEE,yBEtBD;EFuBC,sBAAA;AnIy50BV;;AmIp50BM;EACE,yBE7BC;EF8BD,+CAAA;EACA,WAAA;AnIu50BR;AmIr50BQ;EACE,WAAA;AnIu50BV;AmIp50BQ;EAEE,aAAA;EACA,0BAAA;AnIq50BV;;AmIh50BM;EACE,yBAAA;EACA,6BAAA;EACA,cEhDC;ArIm80BT;AmIj50BQ;EACE,yCAAA;EACA,cEpDD;ArIu80BT;AmIj50BQ;EACE,sBAAA;AnIm50BV;;AmIz40BY;;;EACE,yBElEL;EFmEK,WAAA;AnI840Bd;AmI740Bc;;;EACE,WAAA;AnIi50BhB;AmI540Bc;;;EACE,cE3EP;ArI290BT;;AmIv40BQ;EACE,yBErFD;ArI+90BT;AmIz40BU;EACE,6BAAA;EACA,yBAAA;AnI240BZ;;AmIj40BY;;;;EAEE,8BAAA;EACA,WAAA;AnIs40Bd;AmIp40Bc;;;;EACE,sBAAA;AnIy40BhB;AmIl40BY;;;;EACE,yBAAA;AnIu40Bd;AmIj40BY;;;EACE,mBEvHL;EFwHK,WAAA;AnIq40Bd;;AmI330BY;EACE,WAAA;EACA,yBEpIL;ArIkg1BT;;AmIt30BM;EACE,oCAAA;AnIy30BR;AmIx30BQ;EACE,sBAAA;AnI030BV;;AmIl30BU;EAEE,gCAAA;AnIo30BZ;;AmIz20BY;EACE,oCAAA;AnI420Bd;;AmIt20BM;EACE,iEAAA;AnIy20BR;;AmIn20BU;EACE,gCAAA;AnIs20BZ;AmIr20BY;EACE,oCAAA;AnIu20Bd;AmIp20BU;EACE,oCAAA;AnIs20BZ;;AmI510Bc;EACE,cEpMP;ArImi1BT;AmIx10BgB;EACE,oEAAA;EAKA,0DAAA;AnIs10BlB;AmIl10BgB;EACE,oEAAA;EAKA,0DAAA;AnIg10BlB;;AmIr00BU;EACE,yBAAA;AnIw00BZ;AmIl00Bc;EACE,oEAAA;EAKA,0DAAA;AnIg00BhB;;AmItz0BQ;EACE,oCAAA;EACA,WAAA;EACA,6BAAA;AnIyz0BV;;AmIpz0BM;EACE,6BAAA;AnIuz0BR;AmItz0BQ;EACE,qBExQD;ArIgk1BT;AmItz0BQ;EACE,yBE3QD;ArImk1BT;;AmIhz0BY;EACE,8BAAA;EACA,0DAAA;AnImz0Bd;;AmI7y0BM;EACE,+CAAA;AnIgz0BR;;AmI7y0BM;EACE,0DAAA;AnIgz0BR;;AmI7y0BM;EACE,oDAAA;EACA,0DAAA;AnIgz0BR;AmI9y0BQ;EACE,oDAAA;EACA,0DAAA;AnIgz0BV;AmI7y0BQ;EAEE,sDAAA;EACA,wDAAA;AnI8y0BV;;AmI1y0BM;EACE,sDAAA;EACA,+CAAA;AnI6y0BR;AmI3y0BQ;EACE,0DAAA;AnI6y0BV;;AmIzy0BM;EACE,uFAAA;AnI4y0BR;;AmIzy0BM;EACE,0DAAA;AnI4y0BR;;AmIzy0BM;EACE,8DAAA;AnI4y0BR;;AmIzy0BM;EACE,iEAAA;AnI4y0BR;;AmIzy0BM;EACE,+DAAA;AnI4y0BR;;AmIzy0BM;EACE,gEAAA;AnI4y0BR;;AmIzy0BM;ECxdF,yCCoIK,EDpIe,iBAAA;EACpB,+CAAA;ApIqw1BJ;;AmIv20BM;EACE,6CAAA;AnI020BR;;AmIv20BM;EACE,wDAAA;AnI020BR;;AmIv20BM;EACE,oDAAA;EACA,wDAAA;AnI020BR;AmIx20BQ;EACE,oDAAA;EACA,0DAAA;AnI020BV;AmIv20BQ;EAEE,sDAAA;EACA,wDAAA;AnIw20BV;;AmIp20BM;EACE,oDAAA;EACA,6CAAA;AnIu20BR;AmIr20BQ;EACE,wDAAA;AnIu20BV;;AmIn20BM;EACE,qFAAA;AnIs20BR;;AmIn20BM;EACE,wDAAA;AnIs20BR;;AmIn20BM;EACE,4DAAA;AnIs20BR;;AmIn20BM;EACE,+DAAA;AnIs20BR;;AmIn20BM;EACE,6DAAA;AnIs20BR;;AmIn20BM;EACE,8DAAA;AnIs20BR;;AmIn20BM;ECxdF,uCCoIK,EDpIe,iBAAA;EACpB,6CAAA;ApI+z1BJ;;AmIj60BM;EACE,+CAAA;AnIo60BR;;AmIj60BM;EACE,0DAAA;AnIo60BR;;AmIj60BM;EACE,oDAAA;EACA,0DAAA;AnIo60BR;AmIl60BQ;EACE,oDAAA;EACA,0DAAA;AnIo60BV;AmIj60BQ;EAEE,sDAAA;EACA,wDAAA;AnIk60BV;;AmI950BM;EACE,sDAAA;EACA,+CAAA;AnIi60BR;AmI/50BQ;EACE,0DAAA;AnIi60BV;;AmI750BM;EACE,uFAAA;AnIg60BR;;AmI750BM;EACE,0DAAA;AnIg60BR;;AmI750BM;EACE,8DAAA;AnIg60BR;;AmI750BM;EACE,iEAAA;AnIg60BR;;AmI750BM;EACE,+DAAA;AnIg60BR;;AmI750BM;EACE,gEAAA;AnIg60BR;;AmI750BM;ECxdF,yCCoIK,EDpIe,iBAAA;EACpB,+CAAA;ApIy31BJ;;AmI390BM;EACE,6CAAA;AnI890BR;;AmI390BM;EACE,wDAAA;AnI890BR;;AmI390BM;EACE,oDAAA;EACA,wDAAA;AnI890BR;AmI590BQ;EACE,oDAAA;EACA,0DAAA;AnI890BV;AmI390BQ;EAEE,sDAAA;EACA,wDAAA;AnI490BV;;AmIx90BM;EACE,oDAAA;EACA,6CAAA;AnI290BR;AmIz90BQ;EACE,wDAAA;AnI290BV;;AmIv90BM;EACE,qFAAA;AnI090BR;;AmIv90BM;EACE,wDAAA;AnI090BR;;AmIv90BM;EACE,4DAAA;AnI090BR;;AmIv90BM;EACE,+DAAA;AnI090BR;;AmIv90BM;EACE,6DAAA;AnI090BR;;AmIv90BM;EACE,8DAAA;AnI090BR;;AmIv90BM;ECxdF,uCCoIK,EDpIe,iBAAA;EACpB,6CAAA;ApIm71BJ;;AmIrh1BM;EACE,yBAAA;AnIwh1BR;;AmIrh1BM;EACE,oCAAA;AnIwh1BR;;AmIrh1BM;EACE,oDAAA;EACA,oCAAA;AnIwh1BR;AmIth1BQ;EACE,oDAAA;EACA,0DAAA;AnIwh1BV;AmIrh1BQ;EAEE,sDAAA;EACA,wDAAA;AnIsh1BV;;AmIlh1BM;EACE,gCAAA;EACA,yBAAA;AnIqh1BR;AmInh1BQ;EACE,oCAAA;AnIqh1BV;;AmIjh1BM;EACE,iEAAA;AnIoh1BR;;AmIjh1BM;EACE,oCAAA;AnIoh1BR;;AmIjh1BM;EACE,wCAAA;AnIoh1BR;;AmIjh1BM;EACE,2CAAA;AnIoh1BR;;AmIjh1BM;EACE,yCAAA;AnIoh1BR;;AmIjh1BM;EACE,0CAAA;AnIoh1BR;;AmIjh1BM;ECxdF,mBCoIK,EDpIe,iBAAA;EACpB,oCAAA;ApI6+1BJ;;AmI/k1BM;EACE,yBAAA;AnIkl1BR;;AmI/k1BM;EACE,oCAAA;AnIkl1BR;;AmI/k1BM;EACE,oDAAA;EACA,oCAAA;AnIkl1BR;AmIhl1BQ;EACE,oDAAA;EACA,0DAAA;AnIkl1BV;AmI/k1BQ;EAEE,sDAAA;EACA,wDAAA;AnIgl1BV;;AmI5k1BM;EACE,gCAAA;EACA,yBAAA;AnI+k1BR;AmI7k1BQ;EACE,oCAAA;AnI+k1BV;;AmI3k1BM;EACE,iEAAA;AnI8k1BR;;AmI3k1BM;EACE,oCAAA;AnI8k1BR;;AmI3k1BM;EACE,wCAAA;AnI8k1BR;;AmI3k1BM;EACE,2CAAA;AnI8k1BR;;AmI3k1BM;EACE,yCAAA;AnI8k1BR;;AmI3k1BM;EACE,0CAAA;AnI8k1BR;;AmI3k1BM;ECxdF,mBCoIK,EDpIe,iBAAA;EACpB,oCAAA;ApIui2BJ;;AmIzo1BM;EACE,yBAAA;AnI4o1BR;;AmIzo1BM;EACE,oCAAA;AnI4o1BR;;AmIzo1BM;EACE,oDAAA;EACA,oCAAA;AnI4o1BR;AmI1o1BQ;EACE,oDAAA;EACA,0DAAA;AnI4o1BV;AmIzo1BQ;EAEE,sDAAA;EACA,wDAAA;AnI0o1BV;;AmIto1BM;EACE,gCAAA;EACA,yBAAA;AnIyo1BR;AmIvo1BQ;EACE,oCAAA;AnIyo1BV;;AmIro1BM;EACE,iEAAA;AnIwo1BR;;AmIro1BM;EACE,oCAAA;AnIwo1BR;;AmIro1BM;EACE,wCAAA;AnIwo1BR;;AmIro1BM;EACE,2CAAA;AnIwo1BR;;AmIro1BM;EACE,yCAAA;AnIwo1BR;;AmIro1BM;EACE,0CAAA;AnIwo1BR;;AmIro1BM;ECxdF,mBCoIK,EDpIe,iBAAA;EACpB,oCAAA;ApIim2BJ;;AmIns1BM;EACE,yBAAA;AnIss1BR;;AmIns1BM;EACE,oCAAA;AnIss1BR;;AmIns1BM;EACE,oDAAA;EACA,oCAAA;AnIss1BR;AmIps1BQ;EACE,oDAAA;EACA,0DAAA;AnIss1BV;AmIns1BQ;EAEE,sDAAA;EACA,wDAAA;AnIos1BV;;AmIhs1BM;EACE,gCAAA;EACA,yBAAA;AnIms1BR;AmIjs1BQ;EACE,oCAAA;AnIms1BV;;AmI/r1BM;EACE,iEAAA;AnIks1BR;;AmI/r1BM;EACE,oCAAA;AnIks1BR;;AmI/r1BM;EACE,wCAAA;AnIks1BR;;AmI/r1BM;EACE,2CAAA;AnIks1BR;;AmI/r1BM;EACE,yCAAA;AnIks1BR;;AmI/r1BM;EACE,0CAAA;AnIks1BR;;AmI/r1BM;ECxdF,mBCoIK,EDpIe,iBAAA;EACpB,oCAAA;ApI2p2BJ;;AmI7v1BM;EACE,yBAAA;AnIgw1BR;;AmI7v1BM;EACE,oCAAA;AnIgw1BR;;AmI7v1BM;EACE,oDAAA;EACA,oCAAA;AnIgw1BR;AmI9v1BQ;EACE,oDAAA;EACA,0DAAA;AnIgw1BV;AmI7v1BQ;EAEE,sDAAA;EACA,wDAAA;AnI8v1BV;;AmI1v1BM;EACE,gCAAA;EACA,yBAAA;AnI6v1BR;AmI3v1BQ;EACE,oCAAA;AnI6v1BV;;AmIzv1BM;EACE,iEAAA;AnI4v1BR;;AmIzv1BM;EACE,oCAAA;AnI4v1BR;;AmIzv1BM;EACE,wCAAA;AnI4v1BR;;AmIzv1BM;EACE,2CAAA;AnI4v1BR;;AmIzv1BM;EACE,yCAAA;AnI4v1BR;;AmIzv1BM;EACE,0CAAA;AnI4v1BR;;AmIzv1BM;ECxdF,mBCoIK,EDpIe,iBAAA;EACpB,kCAAA;ApIqt2BJ;;AmIvz1BM;EACE,mDAAA;AnI0z1BR;;AmIvz1BM;EACE,8DAAA;AnI0z1BR;;AmIvz1BM;EACE,qDAAA;EACA,8DAAA;AnI0z1BR;AmIxz1BQ;EACE,qDAAA;EACA,0DAAA;AnI0z1BV;AmIvz1BQ;EAEE,sDAAA;EACA,wDAAA;AnIwz1BV;;AmIpz1BM;EACE,0DAAA;EACA,mDAAA;AnIuz1BR;AmIrz1BQ;EACE,8DAAA;AnIuz1BV;;AmInz1BM;EACE,2FAAA;AnIsz1BR;;AmInz1BM;EACE,8DAAA;AnIsz1BR;;AmInz1BM;EACE,kEAAA;AnIsz1BR;;AmInz1BM;EACE,qEAAA;AnIsz1BR;;AmInz1BM;EACE,mEAAA;AnIsz1BR;;AmInz1BM;EACE,oEAAA;AnIsz1BR;;AmInz1BM;ECxdF,6CCoIK,EDpIe,iBAAA;EACpB,mDAAA;ApI+w2BJ;;AmIj31BM;EACE,iDAAA;AnIo31BR;;AmIj31BM;EACE,4DAAA;AnIo31BR;;AmIj31BM;EACE,qDAAA;EACA,4DAAA;AnIo31BR;AmIl31BQ;EACE,qDAAA;EACA,0DAAA;AnIo31BV;AmIj31BQ;EAEE,sDAAA;EACA,wDAAA;AnIk31BV;;AmI921BM;EACE,wDAAA;EACA,iDAAA;AnIi31BR;AmI/21BQ;EACE,4DAAA;AnIi31BV;;AmI721BM;EACE,yFAAA;AnIg31BR;;AmI721BM;EACE,4DAAA;AnIg31BR;;AmI721BM;EACE,gEAAA;AnIg31BR;;AmI721BM;EACE,mEAAA;AnIg31BR;;AmI721BM;EACE,iEAAA;AnIg31BR;;AmI721BM;EACE,kEAAA;AnIg31BR;;AmI721BM;ECxdF,2CCoIK,EDpIe,iBAAA;EACpB,iDAAA;ApIy02BJ;;AmI361BM;EACE,iDAAA;AnI861BR;;AmI361BM;EACE,4DAAA;AnI861BR;;AmI361BM;EACE,qDAAA;EACA,4DAAA;AnI861BR;AmI561BQ;EACE,qDAAA;EACA,0DAAA;AnI861BV;AmI361BQ;EAEE,sDAAA;EACA,wDAAA;AnI461BV;;AmIx61BM;EACE,wDAAA;EACA,iDAAA;AnI261BR;AmIz61BQ;EACE,4DAAA;AnI261BV;;AmIv61BM;EACE,yFAAA;AnI061BR;;AmIv61BM;EACE,4DAAA;AnI061BR;;AmIv61BM;EACE,gEAAA;AnI061BR;;AmIv61BM;EACE,mEAAA;AnI061BR;;AmIv61BM;EACE,iEAAA;AnI061BR;;AmIv61BM;EACE,kEAAA;AnI061BR;;AmIv61BM;ECxdF,2CCoIK,EDpIe,iBAAA;EACpB,iDAAA;ApIm42BJ;;AmIr+1BM;EACE,8CAAA;AnIw+1BR;;AmIr+1BM;EACE,yDAAA;AnIw+1BR;;AmIr+1BM;EACE,qDAAA;EACA,yDAAA;AnIw+1BR;AmIt+1BQ;EACE,qDAAA;EACA,0DAAA;AnIw+1BV;AmIr+1BQ;EAEE,sDAAA;EACA,wDAAA;AnIs+1BV;;AmIl+1BM;EACE,qDAAA;EACA,8CAAA;AnIq+1BR;AmIn+1BQ;EACE,yDAAA;AnIq+1BV;;AmIj+1BM;EACE,sFAAA;AnIo+1BR;;AmIj+1BM;EACE,yDAAA;AnIo+1BR;;AmIj+1BM;EACE,6DAAA;AnIo+1BR;;AmIj+1BM;EACE,gEAAA;AnIo+1BR;;AmIj+1BM;EACE,8DAAA;AnIo+1BR;;AmIj+1BM;EACE,+DAAA;AnIo+1BR;;AmIj+1BM;ECxdF,wCCoIK,EDpIe,iBAAA;EACpB,8CAAA;ApI672BJ;;AmI/h2BM;EACE,iDAAA;AnIki2BR;;AmI/h2BM;EACE,4DAAA;AnIki2BR;;AmI/h2BM;EACE,qDAAA;EACA,4DAAA;AnIki2BR;AmIhi2BQ;EACE,qDAAA;EACA,0DAAA;AnIki2BV;AmI/h2BQ;EAEE,sDAAA;EACA,wDAAA;AnIgi2BV;;AmI5h2BM;EACE,wDAAA;EACA,iDAAA;AnI+h2BR;AmI7h2BQ;EACE,4DAAA;AnI+h2BV;;AmI3h2BM;EACE,yFAAA;AnI8h2BR;;AmI3h2BM;EACE,4DAAA;AnI8h2BR;;AmI3h2BM;EACE,gEAAA;AnI8h2BR;;AmI3h2BM;EACE,mEAAA;AnI8h2BR;;AmI3h2BM;EACE,iEAAA;AnI8h2BR;;AmI3h2BM;EACE,kEAAA;AnI8h2BR;;AmI3h2BM;ECxdF,2CCoIK,EDpIe,iBAAA;EACpB,iDAAA;ApIu/2BJ;;AmIzl2BM;EACE,+CAAA;AnI4l2BR;;AmIzl2BM;EACE,0DAAA;AnI4l2BR;;AmIzl2BM;EACE,qDAAA;EACA,0DAAA;AnI4l2BR;AmI1l2BQ;EACE,qDAAA;EACA,0DAAA;AnI4l2BV;AmIzl2BQ;EAEE,sDAAA;EACA,wDAAA;AnI0l2BV;;AmItl2BM;EACE,sDAAA;EACA,+CAAA;AnIyl2BR;AmIvl2BQ;EACE,0DAAA;AnIyl2BV;;AmIrl2BM;EACE,uFAAA;AnIwl2BR;;AmIrl2BM;EACE,0DAAA;AnIwl2BR;;AmIrl2BM;EACE,8DAAA;AnIwl2BR;;AmIrl2BM;EACE,iEAAA;AnIwl2BR;;AmIrl2BM;EACE,+DAAA;AnIwl2BR;;AmIrl2BM;EACE,gEAAA;AnIwl2BR;;AmIrl2BM;ECxdF,yCCoIK,EDpIe,iBAAA;EACpB,+CAAA;ApIij3BJ;;AmInp2BM;EACE,gDAAA;AnIsp2BR;;AmInp2BM;EACE,2DAAA;AnIsp2BR;;AmInp2BM;EACE,qDAAA;EACA,2DAAA;AnIsp2BR;AmIpp2BQ;EACE,qDAAA;EACA,0DAAA;AnIsp2BV;AmInp2BQ;EAEE,sDAAA;EACA,wDAAA;AnIop2BV;;AmIhp2BM;EACE,uDAAA;EACA,gDAAA;AnImp2BR;AmIjp2BQ;EACE,2DAAA;AnImp2BV;;AmI/o2BM;EACE,wFAAA;AnIkp2BR;;AmI/o2BM;EACE,2DAAA;AnIkp2BR;;AmI/o2BM;EACE,+DAAA;AnIkp2BR;;AmI/o2BM;EACE,kEAAA;AnIkp2BR;;AmI/o2BM;EACE,gEAAA;AnIkp2BR;;AmI/o2BM;EACE,iEAAA;AnIkp2BR;;AmI/o2BM;ECxdF,0CCoIK,EDpIe,iBAAA;EACpB,gDAAA;ApI2m3BJ;;AmI5j3BM;EACE,yBAAA;AnI+j3BR;;AmI3j3BM;EACE,oCAAA;AnI8j3BR;AmI5j3BQ;;EAEE,6BAAA;AnI8j3BV;;AmIzj3BM;EACE,8CAAA;EACA,yBAAA;AnI4j3BR;AmI1j3BQ;EZjEN,qDAAA;AvH8n3BF;AmIzj3BQ;EACE,gDAAA;AnI2j3BV;;AmItj3BM;EACE,+CAAA;AnIyj3BR;;AmIrj3BM;EACE,oCAAA;AnIwj3BR;;AmIrj3BM;EACE,6BAAA;AnIwj3BR;;AmIrj3BM;EACE,gCAAA;AnIwj3BR;;AmIrj3BM;EACE,8BAAA;AnIwj3BR;;AmIrj3BM;EACE,+BAAA;AnIwj3BR;;AmIpj3BM;EACE,iDAAA;EACA,yBAAA;EACA,gBAAA;EACA,yBAAA;AnIuj3BR;;AmIhj3BQ;;;EACE,gCAAA;AnIqj3BV;;AmIhj3BM;ECxHF,mBCoIK,EDpIe,iBAAA;EACpB,mCAAA;ApI4q3BJ;;AmIhj3BM;EACE,qDAAA;EACA,oCAAA;EACA,WAAA;AnImj3BR;AmIjj3BQ;EACE,uDAAA;EACA,sBAAA;EACA,mCAAA;AnImj3BV;AmIhj3BQ;EAEE,sBAAA;AnIij3BV;;AmI5i3BM;EACE,6BAAA;EACA,cEbC;ArI4j3BT;AmI7i3BQ;EACE,cEhBD;EFiBC,yCAAA;AnI+i3BV;AmI5i3BQ;EAEE,yBEtBD;EFuBC,sBAAA;AnI6i3BV;;AmIxi3BM;EACE,yBE7BC;EF8BD,+CAAA;EACA,WAAA;AnI2i3BR;AmIzi3BQ;EACE,WAAA;AnI2i3BV;AmIxi3BQ;EAEE,aAAA;EACA,0BAAA;AnIyi3BV;;AmIpi3BM;EACE,yBAAA;EACA,6BAAA;EACA,cEhDC;ArIul3BT;AmIri3BQ;EACE,0CAAA;EACA,cEpDD;ArI2l3BT;AmIri3BQ;EACE,sBAAA;AnIui3BV;;AmI7h3BY;;;EACE,yBElEL;EFmEK,WAAA;AnIki3Bd;AmIji3Bc;;;EACE,WAAA;AnIqi3BhB;AmIhi3Bc;;;EACE,cE3EP;ArI+m3BT;;AmI3h3BQ;EACE,yBErFD;ArImn3BT;AmI7h3BU;EACE,6BAAA;EACA,yBAAA;AnI+h3BZ;;AmIrh3BY;;;;EAEE,8BAAA;EACA,WAAA;AnI0h3Bd;AmIxh3Bc;;;;EACE,sBAAA;AnI6h3BhB;AmIth3BY;;;;EACE,yBAAA;AnI2h3Bd;AmIrh3BY;;;EACE,mBEvHL;EFwHK,WAAA;AnIyh3Bd;;AmI/g3BY;EACE,WAAA;EACA,yBEpIL;ArIsp3BT;;AmI1g3BM;EACE,oCAAA;AnI6g3BR;AmI5g3BQ;EACE,sBAAA;AnI8g3BV;;AmItg3BU;EAEE,gCAAA;AnIwg3BZ;;AmI7/2BY;EACE,oCAAA;AnIgg3Bd;;AmI1/2BM;EACE,iEAAA;AnI6/2BR;;AmIv/2BU;EACE,gCAAA;AnI0/2BZ;AmIz/2BY;EACE,oCAAA;AnI2/2Bd;AmIx/2BU;EACE,oCAAA;AnI0/2BZ;;AmIh/2Bc;EACE,cEpMP;ArIur3BT;AmI5+2BgB;EACE,qEAAA;EAKA,2DAAA;AnI0+2BlB;AmIt+2BgB;EACE,qEAAA;EAKA,2DAAA;AnIo+2BlB;;AmIz92BU;EACE,yBAAA;AnI492BZ;AmIt92Bc;EACE,qEAAA;EAKA,2DAAA;AnIo92BhB;;AmI182BQ;EACE,oCAAA;EACA,WAAA;EACA,6BAAA;AnI682BV;;AmIx82BM;EACE,6BAAA;AnI282BR;AmI182BQ;EACE,qBExQD;ArIot3BT;AmI182BQ;EACE,yBE3QD;ArIut3BT;;AmIp82BY;EACE,8BAAA;EACA,2DAAA;AnIu82Bd;;AmIj82BM;EACE,gDAAA;AnIo82BR;;AmIj82BM;EACE,2DAAA;AnIo82BR;;AmIj82BM;EACE,qDAAA;EACA,2DAAA;AnIo82BR;AmIl82BQ;EACE,qDAAA;EACA,0DAAA;AnIo82BV;AmIj82BQ;EAEE,sDAAA;EACA,wDAAA;AnIk82BV;;AmI972BM;EACE,uDAAA;EACA,gDAAA;AnIi82BR;AmI/72BQ;EACE,2DAAA;AnIi82BV;;AmI772BM;EACE,wFAAA;AnIg82BR;;AmI772BM;EACE,2DAAA;AnIg82BR;;AmI772BM;EACE,+DAAA;AnIg82BR;;AmI772BM;EACE,kEAAA;AnIg82BR;;AmI772BM;EACE,gEAAA;AnIg82BR;;AmI772BM;EACE,iEAAA;AnIg82BR;;AmI772BM;ECxdF,0CCoIK,EDpIe,iBAAA;EACpB,gDAAA;ApIy53BJ;;AmI3/2BM;EACE,8CAAA;AnI8/2BR;;AmI3/2BM;EACE,yDAAA;AnI8/2BR;;AmI3/2BM;EACE,qDAAA;EACA,yDAAA;AnI8/2BR;AmI5/2BQ;EACE,qDAAA;EACA,0DAAA;AnI8/2BV;AmI3/2BQ;EAEE,sDAAA;EACA,wDAAA;AnI4/2BV;;AmIx/2BM;EACE,qDAAA;EACA,8CAAA;AnI2/2BR;AmIz/2BQ;EACE,yDAAA;AnI2/2BV;;AmIv/2BM;EACE,sFAAA;AnI0/2BR;;AmIv/2BM;EACE,yDAAA;AnI0/2BR;;AmIv/2BM;EACE,6DAAA;AnI0/2BR;;AmIv/2BM;EACE,gEAAA;AnI0/2BR;;AmIv/2BM;EACE,8DAAA;AnI0/2BR;;AmIv/2BM;EACE,+DAAA;AnI0/2BR;;AmIv/2BM;ECxdF,wCCoIK,EDpIe,iBAAA;EACpB,8CAAA;ApIm93BJ;;AmIrj3BM;EACE,+CAAA;AnIwj3BR;;AmIrj3BM;EACE,0DAAA;AnIwj3BR;;AmIrj3BM;EACE,qDAAA;EACA,0DAAA;AnIwj3BR;AmItj3BQ;EACE,qDAAA;EACA,0DAAA;AnIwj3BV;AmIrj3BQ;EAEE,sDAAA;EACA,wDAAA;AnIsj3BV;;AmIlj3BM;EACE,sDAAA;EACA,+CAAA;AnIqj3BR;AmInj3BQ;EACE,0DAAA;AnIqj3BV;;AmIjj3BM;EACE,uFAAA;AnIoj3BR;;AmIjj3BM;EACE,0DAAA;AnIoj3BR;;AmIjj3BM;EACE,8DAAA;AnIoj3BR;;AmIjj3BM;EACE,iEAAA;AnIoj3BR;;AmIjj3BM;EACE,+DAAA;AnIoj3BR;;AmIjj3BM;EACE,gEAAA;AnIoj3BR;;AmIjj3BM;ECxdF,yCCoIK,EDpIe,iBAAA;EACpB,+CAAA;ApI6g4BJ;;AmI/m3BM;EACE,6CAAA;AnIkn3BR;;AmI/m3BM;EACE,wDAAA;AnIkn3BR;;AmI/m3BM;EACE,qDAAA;EACA,wDAAA;AnIkn3BR;AmIhn3BQ;EACE,qDAAA;EACA,0DAAA;AnIkn3BV;AmI/m3BQ;EAEE,sDAAA;EACA,wDAAA;AnIgn3BV;;AmI5m3BM;EACE,oDAAA;EACA,6CAAA;AnI+m3BR;AmI7m3BQ;EACE,wDAAA;AnI+m3BV;;AmI3m3BM;EACE,qFAAA;AnI8m3BR;;AmI3m3BM;EACE,wDAAA;AnI8m3BR;;AmI3m3BM;EACE,4DAAA;AnI8m3BR;;AmI3m3BM;EACE,+DAAA;AnI8m3BR;;AmI3m3BM;EACE,6DAAA;AnI8m3BR;;AmI3m3BM;EACE,8DAAA;AnI8m3BR;;AmI3m3BM;ECxdF,uCCoIK,EDpIe,iBAAA;EACpB,6CAAA;ApIuk4BJ;;AmIzq3BM;EACE,yBAAA;AnI4q3BR;;AmIzq3BM;EACE,oCAAA;AnI4q3BR;;AmIzq3BM;EACE,qDAAA;EACA,oCAAA;AnI4q3BR;AmI1q3BQ;EACE,qDAAA;EACA,0DAAA;AnI4q3BV;AmIzq3BQ;EAEE,sDAAA;EACA,wDAAA;AnI0q3BV;;AmItq3BM;EACE,gCAAA;EACA,yBAAA;AnIyq3BR;AmIvq3BQ;EACE,oCAAA;AnIyq3BV;;AmIrq3BM;EACE,iEAAA;AnIwq3BR;;AmIrq3BM;EACE,oCAAA;AnIwq3BR;;AmIrq3BM;EACE,wCAAA;AnIwq3BR;;AmIrq3BM;EACE,2CAAA;AnIwq3BR;;AmIrq3BM;EACE,yCAAA;AnIwq3BR;;AmIrq3BM;EACE,0CAAA;AnIwq3BR;;AmIrq3BM;ECxdF,mBCoIK,EDpIe,iBAAA;EACpB,oCAAA;ApIio4BJ;;AmInu3BM;EACE,yBAAA;AnIsu3BR;;AmInu3BM;EACE,oCAAA;AnIsu3BR;;AmInu3BM;EACE,qDAAA;EACA,oCAAA;AnIsu3BR;AmIpu3BQ;EACE,qDAAA;EACA,0DAAA;AnIsu3BV;AmInu3BQ;EAEE,sDAAA;EACA,wDAAA;AnIou3BV;;AmIhu3BM;EACE,gCAAA;EACA,yBAAA;AnImu3BR;AmIju3BQ;EACE,oCAAA;AnImu3BV;;AmI/t3BM;EACE,iEAAA;AnIku3BR;;AmI/t3BM;EACE,oCAAA;AnIku3BR;;AmI/t3BM;EACE,wCAAA;AnIku3BR;;AmI/t3BM;EACE,2CAAA;AnIku3BR;;AmI/t3BM;EACE,yCAAA;AnIku3BR;;AmI/t3BM;EACE,0CAAA;AnIku3BR;;AmI/t3BM;ECxdF,mBCoIK,EDpIe,iBAAA;EACpB,oCAAA;ApI2r4BJ;;AmI7x3BM;EACE,yBAAA;AnIgy3BR;;AmI7x3BM;EACE,oCAAA;AnIgy3BR;;AmI7x3BM;EACE,qDAAA;EACA,oCAAA;AnIgy3BR;AmI9x3BQ;EACE,qDAAA;EACA,0DAAA;AnIgy3BV;AmI7x3BQ;EAEE,sDAAA;EACA,wDAAA;AnI8x3BV;;AmI1x3BM;EACE,gCAAA;EACA,yBAAA;AnI6x3BR;AmI3x3BQ;EACE,oCAAA;AnI6x3BV;;AmIzx3BM;EACE,iEAAA;AnI4x3BR;;AmIzx3BM;EACE,oCAAA;AnI4x3BR;;AmIzx3BM;EACE,wCAAA;AnI4x3BR;;AmIzx3BM;EACE,2CAAA;AnI4x3BR;;AmIzx3BM;EACE,yCAAA;AnI4x3BR;;AmIzx3BM;EACE,0CAAA;AnI4x3BR;;AmIzx3BM;ECxdF,mBCoIK,EDpIe,iBAAA;EACpB,oCAAA;ApIqv4BJ;;AmIv13BM;EACE,yBAAA;AnI013BR;;AmIv13BM;EACE,oCAAA;AnI013BR;;AmIv13BM;EACE,qDAAA;EACA,oCAAA;AnI013BR;AmIx13BQ;EACE,qDAAA;EACA,0DAAA;AnI013BV;AmIv13BQ;EAEE,sDAAA;EACA,wDAAA;AnIw13BV;;AmIp13BM;EACE,gCAAA;EACA,yBAAA;AnIu13BR;AmIr13BQ;EACE,oCAAA;AnIu13BV;;AmIn13BM;EACE,iEAAA;AnIs13BR;;AmIn13BM;EACE,oCAAA;AnIs13BR;;AmIn13BM;EACE,wCAAA;AnIs13BR;;AmIn13BM;EACE,2CAAA;AnIs13BR;;AmIn13BM;EACE,yCAAA;AnIs13BR;;AmIn13BM;EACE,0CAAA;AnIs13BR;;AmIn13BM;ECxdF,mBCoIK,EDpIe,iBAAA;EACpB,oCAAA;ApI+y4BJ;;AmIj53BM;EACE,yBAAA;AnIo53BR;;AmIj53BM;EACE,oCAAA;AnIo53BR;;AmIj53BM;EACE,qDAAA;EACA,oCAAA;AnIo53BR;AmIl53BQ;EACE,qDAAA;EACA,0DAAA;AnIo53BV;AmIj53BQ;EAEE,sDAAA;EACA,wDAAA;AnIk53BV;;AmI943BM;EACE,gCAAA;EACA,yBAAA;AnIi53BR;AmI/43BQ;EACE,oCAAA;AnIi53BV;;AmI743BM;EACE,iEAAA;AnIg53BR;;AmI743BM;EACE,oCAAA;AnIg53BR;;AmI743BM;EACE,wCAAA;AnIg53BR;;AmI743BM;EACE,2CAAA;AnIg53BR;;AmI743BM;EACE,yCAAA;AnIg53BR;;AmI743BM;EACE,0CAAA;AnIg53BR;;AmI743BM;ECxdF,mBCoIK,EDpIe,iBAAA;EACpB,oCAAA;ApIy24BJ;;AmI383BM;EACE,mEAAA;AnI883BR;;AmI383BM;EACE,8EAAA;AnI883BR;;AmI383BM;EACE,6DAAA;EACA,8EAAA;AnI883BR;AmI583BQ;EACE,6DAAA;EACA,oEAAA;AnI883BV;AmI383BQ;EAEE,gEAAA;EACA,wDAAA;AnI483BV;;AmIx83BM;EACE,0EAAA;EACA,mEAAA;AnI283BR;AmIz83BQ;EACE,8EAAA;AnI283BV;;AmIv83BM;EACE,2GAAA;AnI083BR;;AmIv83BM;EACE,8EAAA;AnI083BR;;AmIv83BM;EACE,kFAAA;AnI083BR;;AmIv83BM;EACE,qFAAA;AnI083BR;;AmIv83BM;EACE,mFAAA;AnI083BR;;AmIv83BM;EACE,oFAAA;AnI083BR;;AmIv83BM;ECxdF,6DCoIK,EDpIe,iBAAA;EACpB,mEAAA;ApIm64BJ;;AmIrg4BM;EACE,wDAAA;AnIwg4BR;;AmIrg4BM;EACE,mEAAA;AnIwg4BR;;AmIrg4BM;EACE,6DAAA;EACA,mEAAA;AnIwg4BR;AmItg4BQ;EACE,6DAAA;EACA,oEAAA;AnIwg4BV;AmIrg4BQ;EAEE,gEAAA;EACA,wDAAA;AnIsg4BV;;AmIlg4BM;EACE,+DAAA;EACA,wDAAA;AnIqg4BR;AmIng4BQ;EACE,mEAAA;AnIqg4BV;;AmIjg4BM;EACE,gGAAA;AnIog4BR;;AmIjg4BM;EACE,mEAAA;AnIog4BR;;AmIjg4BM;EACE,uEAAA;AnIog4BR;;AmIjg4BM;EACE,0EAAA;AnIog4BR;;AmIjg4BM;EACE,wEAAA;AnIog4BR;;AmIjg4BM;EACE,yEAAA;AnIog4BR;;AmIjg4BM;ECxdF,kDCoIK,EDpIe,iBAAA;EACpB,wDAAA;ApI694BJ;;AmI/j4BM;EACE,2DAAA;AnIkk4BR;;AmI/j4BM;EACE,sEAAA;AnIkk4BR;;AmI/j4BM;EACE,6DAAA;EACA,sEAAA;AnIkk4BR;AmIhk4BQ;EACE,6DAAA;EACA,oEAAA;AnIkk4BV;AmI/j4BQ;EAEE,gEAAA;EACA,wDAAA;AnIgk4BV;;AmI5j4BM;EACE,kEAAA;EACA,2DAAA;AnI+j4BR;AmI7j4BQ;EACE,sEAAA;AnI+j4BV;;AmI3j4BM;EACE,mGAAA;AnI8j4BR;;AmI3j4BM;EACE,sEAAA;AnI8j4BR;;AmI3j4BM;EACE,0EAAA;AnI8j4BR;;AmI3j4BM;EACE,6EAAA;AnI8j4BR;;AmI3j4BM;EACE,2EAAA;AnI8j4BR;;AmI3j4BM;EACE,4EAAA;AnI8j4BR;;AmI3j4BM;ECxdF,qDCoIK,EDpIe,iBAAA;EACpB,2DAAA;ApIuh5BJ;;AmIzn4BM;EACE,qDAAA;AnI4n4BR;;AmIzn4BM;EACE,gEAAA;AnI4n4BR;;AmIzn4BM;EACE,6DAAA;EACA,gEAAA;AnI4n4BR;AmI1n4BQ;EACE,6DAAA;EACA,oEAAA;AnI4n4BV;AmIzn4BQ;EAEE,gEAAA;EACA,wDAAA;AnI0n4BV;;AmItn4BM;EACE,4DAAA;EACA,qDAAA;AnIyn4BR;AmIvn4BQ;EACE,gEAAA;AnIyn4BV;;AmIrn4BM;EACE,6FAAA;AnIwn4BR;;AmIrn4BM;EACE,gEAAA;AnIwn4BR;;AmIrn4BM;EACE,oEAAA;AnIwn4BR;;AmIrn4BM;EACE,uEAAA;AnIwn4BR;;AmIrn4BM;EACE,qEAAA;AnIwn4BR;;AmIrn4BM;EACE,sEAAA;AnIwn4BR;;AmIrn4BM;ECxdF,+CCoIK,EDpIe,iBAAA;EACpB,qDAAA;ApIil5BJ;;AmInr4BM;EACE,2DAAA;AnIsr4BR;;AmInr4BM;EACE,sEAAA;AnIsr4BR;;AmInr4BM;EACE,6DAAA;EACA,sEAAA;AnIsr4BR;AmIpr4BQ;EACE,6DAAA;EACA,oEAAA;AnIsr4BV;AmInr4BQ;EAEE,gEAAA;EACA,wDAAA;AnIor4BV;;AmIhr4BM;EACE,kEAAA;EACA,2DAAA;AnImr4BR;AmIjr4BQ;EACE,sEAAA;AnImr4BV;;AmI/q4BM;EACE,mGAAA;AnIkr4BR;;AmI/q4BM;EACE,sEAAA;AnIkr4BR;;AmI/q4BM;EACE,0EAAA;AnIkr4BR;;AmI/q4BM;EACE,6EAAA;AnIkr4BR;;AmI/q4BM;EACE,2EAAA;AnIkr4BR;;AmI/q4BM;EACE,4EAAA;AnIkr4BR;;AmI/q4BM;ECxdF,qDCoIK,EDpIe,iBAAA;EACpB,2DAAA;ApI2o5BJ;;AmI7u4BM;EACE,wDAAA;AnIgv4BR;;AmI7u4BM;EACE,mEAAA;AnIgv4BR;;AmI7u4BM;EACE,6DAAA;EACA,mEAAA;AnIgv4BR;AmI9u4BQ;EACE,6DAAA;EACA,oEAAA;AnIgv4BV;AmI7u4BQ;EAEE,gEAAA;EACA,wDAAA;AnI8u4BV;;AmI1u4BM;EACE,+DAAA;EACA,wDAAA;AnI6u4BR;AmI3u4BQ;EACE,mEAAA;AnI6u4BV;;AmIzu4BM;EACE,gGAAA;AnI4u4BR;;AmIzu4BM;EACE,mEAAA;AnI4u4BR;;AmIzu4BM;EACE,uEAAA;AnI4u4BR;;AmIzu4BM;EACE,0EAAA;AnI4u4BR;;AmIzu4BM;EACE,wEAAA;AnI4u4BR;;AmIzu4BM;EACE,yEAAA;AnI4u4BR;;AmIzu4BM;ECxdF,kDCoIK,EDpIe,iBAAA;EACpB,wDAAA;ApIqs5BJ;;AmIvy4BM;EACE,2DAAA;AnI0y4BR;;AmIvy4BM;EACE,sEAAA;AnI0y4BR;;AmIvy4BM;EACE,6DAAA;EACA,sEAAA;AnI0y4BR;AmIxy4BQ;EACE,6DAAA;EACA,oEAAA;AnI0y4BV;AmIvy4BQ;EAEE,gEAAA;EACA,wDAAA;AnIwy4BV;;AmIpy4BM;EACE,kEAAA;EACA,2DAAA;AnIuy4BR;AmIry4BQ;EACE,sEAAA;AnIuy4BV;;AmIny4BM;EACE,mGAAA;AnIsy4BR;;AmIny4BM;EACE,sEAAA;AnIsy4BR;;AmIny4BM;EACE,0EAAA;AnIsy4BR;;AmIny4BM;EACE,6EAAA;AnIsy4BR;;AmIny4BM;EACE,2EAAA;AnIsy4BR;;AmIny4BM;EACE,4EAAA;AnIsy4BR;;AmIny4BM;ECxdF,qDCoIK,EDpIe,iBAAA;EACpB,2DAAA;ApI+v5BJ;;AmIht5BM;EACE,yBAAA;AnImt5BR;;AmI/s5BM;EACE,oCAAA;AnIkt5BR;AmIht5BQ;;EAEE,6BAAA;AnIkt5BV;;AmI7s5BM;EACE,6CAAA;EACA,yBAAA;AnIgt5BR;AmI9s5BQ;EZjEN,oDAAA;AvHkx5BF;AmI7s5BQ;EACE,yDAAA;AnI+s5BV;;AmI1s5BM;EACE,8CAAA;AnI6s5BR;;AmIzs5BM;EACE,oCAAA;AnI4s5BR;;AmIzs5BM;EACE,6BAAA;AnI4s5BR;;AmIzs5BM;EACE,gCAAA;AnI4s5BR;;AmIzs5BM;EACE,8BAAA;AnI4s5BR;;AmIzs5BM;EACE,+BAAA;AnI4s5BR;;AmIxs5BM;EACE,wDAAA;EACA,yBAAA;EACA,gBAAA;EACA,yBAAA;AnI2s5BR;;AmIps5BQ;;;EACE,gCAAA;AnIys5BV;;AmIps5BM;ECxHF,mBCoIK,EDpIe,iBAAA;EACpB,kCAAA;ApIg05BJ;;AmIps5BM;EACE,6DAAA;EACA,oCAAA;EACA,WAAA;AnIus5BR;AmIrs5BQ;EACE,gEAAA;EACA,sBAAA;EACA,mCAAA;AnIus5BV;AmIps5BQ;EAEE,sBAAA;AnIqs5BV;;AmIhs5BM;EACE,6BAAA;EACA,cEbC;ArIgt5BT;AmIjs5BQ;EACE,cEhBD;EFiBC,wCAAA;AnIms5BV;AmIhs5BQ;EAEE,yBEtBD;EFuBC,sBAAA;AnIis5BV;;AmI5r5BM;EACE,yBE7BC;EF8BD,+CAAA;EACA,WAAA;AnI+r5BR;AmI7r5BQ;EACE,WAAA;AnI+r5BV;AmI5r5BQ;EAEE,aAAA;EACA,0BAAA;AnI6r5BV;;AmIxr5BM;EACE,yBAAA;EACA,6BAAA;EACA,cEhDC;ArI2u5BT;AmIzr5BQ;EACE,yCAAA;EACA,cEpDD;ArI+u5BT;AmIzr5BQ;EACE,sBAAA;AnI2r5BV;;AmIjr5BY;;;EACE,yBElEL;EFmEK,WAAA;AnIsr5Bd;AmIrr5Bc;;;EACE,WAAA;AnIyr5BhB;AmIpr5Bc;;;EACE,cE3EP;ArImw5BT;;AmI/q5BQ;EACE,yBErFD;ArIuw5BT;AmIjr5BU;EACE,6BAAA;EACA,yBAAA;AnImr5BZ;;AmIzq5BY;;;;EAEE,8BAAA;EACA,WAAA;AnI8q5Bd;AmI5q5Bc;;;;EACE,sBAAA;AnIir5BhB;AmI1q5BY;;;;EACE,yBAAA;AnI+q5Bd;AmIzq5BY;;;EACE,mBEvHL;EFwHK,WAAA;AnI6q5Bd;;AmInq5BY;EACE,WAAA;EACA,yBEpIL;ArI0y5BT;;AmI9p5BM;EACE,oCAAA;AnIiq5BR;AmIhq5BQ;EACE,sBAAA;AnIkq5BV;;AmI1p5BU;EAEE,gCAAA;AnI4p5BZ;;AmIjp5BY;EACE,oCAAA;AnIop5Bd;;AmI9o5BM;EACE,iEAAA;AnIip5BR;;AmI3o5BU;EACE,gCAAA;AnI8o5BZ;AmI7o5BY;EACE,oCAAA;AnI+o5Bd;AmI5o5BU;EACE,oCAAA;AnI8o5BZ;;AmIpo5Bc;EACE,cEpMP;ArI205BT;AmIho5BgB;EACE,oEAAA;EAKA,0DAAA;AnI8n5BlB;AmI1n5BgB;EACE,oEAAA;EAKA,0DAAA;AnIwn5BlB;;AmI7m5BU;EACE,yBAAA;AnIgn5BZ;AmI1m5Bc;EACE,oEAAA;EAKA,0DAAA;AnIwm5BhB;;AmI9l5BQ;EACE,oCAAA;EACA,WAAA;EACA,6BAAA;AnIim5BV;;AmI5l5BM;EACE,6BAAA;AnI+l5BR;AmI9l5BQ;EACE,qBExQD;ArIw25BT;AmI9l5BQ;EACE,yBE3QD;ArI225BT;;AmIxl5BY;EACE,8BAAA;EACA,0DAAA;AnI2l5Bd;;AmIrl5BM;EACE,yDAAA;AnIwl5BR;;AmIrl5BM;EACE,oEAAA;AnIwl5BR;;AmIrl5BM;EACE,6DAAA;EACA,oEAAA;AnIwl5BR;AmItl5BQ;EACE,6DAAA;EACA,oEAAA;AnIwl5BV;AmIrl5BQ;EAEE,gEAAA;EACA,wDAAA;AnIsl5BV;;AmIll5BM;EACE,gEAAA;EACA,yDAAA;AnIql5BR;AmInl5BQ;EACE,oEAAA;AnIql5BV;;AmIjl5BM;EACE,iGAAA;AnIol5BR;;AmIjl5BM;EACE,oEAAA;AnIol5BR;;AmIjl5BM;EACE,wEAAA;AnIol5BR;;AmIjl5BM;EACE,2EAAA;AnIol5BR;;AmIjl5BM;EACE,yEAAA;AnIol5BR;;AmIjl5BM;EACE,0EAAA;AnIol5BR;;AmIjl5BM;ECxdF,mDCoIK,EDpIe,iBAAA;EACpB,yDAAA;ApI6i6BJ;;AmI/o5BM;EACE,sDAAA;AnIkp5BR;;AmI/o5BM;EACE,iEAAA;AnIkp5BR;;AmI/o5BM;EACE,6DAAA;EACA,iEAAA;AnIkp5BR;AmIhp5BQ;EACE,6DAAA;EACA,oEAAA;AnIkp5BV;AmI/o5BQ;EAEE,gEAAA;EACA,wDAAA;AnIgp5BV;;AmI5o5BM;EACE,6DAAA;EACA,sDAAA;AnI+o5BR;AmI7o5BQ;EACE,iEAAA;AnI+o5BV;;AmI3o5BM;EACE,8FAAA;AnI8o5BR;;AmI3o5BM;EACE,iEAAA;AnI8o5BR;;AmI3o5BM;EACE,qEAAA;AnI8o5BR;;AmI3o5BM;EACE,wEAAA;AnI8o5BR;;AmI3o5BM;EACE,sEAAA;AnI8o5BR;;AmI3o5BM;EACE,uEAAA;AnI8o5BR;;AmI3o5BM;ECxdF,gDCoIK,EDpIe,iBAAA;EACpB,sDAAA;ApIum6BJ;;AmIzs5BM;EACE,yDAAA;AnI4s5BR;;AmIzs5BM;EACE,oEAAA;AnI4s5BR;;AmIzs5BM;EACE,6DAAA;EACA,oEAAA;AnI4s5BR;AmI1s5BQ;EACE,6DAAA;EACA,oEAAA;AnI4s5BV;AmIzs5BQ;EAEE,gEAAA;EACA,wDAAA;AnI0s5BV;;AmIts5BM;EACE,gEAAA;EACA,yDAAA;AnIys5BR;AmIvs5BQ;EACE,oEAAA;AnIys5BV;;AmIrs5BM;EACE,iGAAA;AnIws5BR;;AmIrs5BM;EACE,oEAAA;AnIws5BR;;AmIrs5BM;EACE,wEAAA;AnIws5BR;;AmIrs5BM;EACE,2EAAA;AnIws5BR;;AmIrs5BM;EACE,yEAAA;AnIws5BR;;AmIrs5BM;EACE,0EAAA;AnIws5BR;;AmIrs5BM;ECxdF,mDCoIK,EDpIe,iBAAA;EACpB,yDAAA;ApIiq6BJ;;AmInw5BM;EACE,6CAAA;AnIsw5BR;;AmInw5BM;EACE,wDAAA;AnIsw5BR;;AmInw5BM;EACE,6DAAA;EACA,wDAAA;AnIsw5BR;AmIpw5BQ;EACE,6DAAA;EACA,oEAAA;AnIsw5BV;AmInw5BQ;EAEE,gEAAA;EACA,wDAAA;AnIow5BV;;AmIhw5BM;EACE,oDAAA;EACA,6CAAA;AnImw5BR;AmIjw5BQ;EACE,wDAAA;AnImw5BV;;AmI/v5BM;EACE,qFAAA;AnIkw5BR;;AmI/v5BM;EACE,wDAAA;AnIkw5BR;;AmI/v5BM;EACE,4DAAA;AnIkw5BR;;AmI/v5BM;EACE,+DAAA;AnIkw5BR;;AmI/v5BM;EACE,6DAAA;AnIkw5BR;;AmI/v5BM;EACE,8DAAA;AnIkw5BR;;AmI/v5BM;ECxdF,uCCoIK,EDpIe,iBAAA;EACpB,6CAAA;ApI2t6BJ;;AmI7z5BM;EACE,yBAAA;AnIg05BR;;AmI7z5BM;EACE,oCAAA;AnIg05BR;;AmI7z5BM;EACE,6DAAA;EACA,oCAAA;AnIg05BR;AmI9z5BQ;EACE,6DAAA;EACA,oEAAA;AnIg05BV;AmI7z5BQ;EAEE,gEAAA;EACA,wDAAA;AnI8z5BV;;AmI1z5BM;EACE,gCAAA;EACA,yBAAA;AnI6z5BR;AmI3z5BQ;EACE,oCAAA;AnI6z5BV;;AmIzz5BM;EACE,iEAAA;AnI4z5BR;;AmIzz5BM;EACE,oCAAA;AnI4z5BR;;AmIzz5BM;EACE,wCAAA;AnI4z5BR;;AmIzz5BM;EACE,2CAAA;AnI4z5BR;;AmIzz5BM;EACE,yCAAA;AnI4z5BR;;AmIzz5BM;EACE,0CAAA;AnI4z5BR;;AmIzz5BM;ECxdF,mBCoIK,EDpIe,iBAAA;EACpB,oCAAA;ApIqx6BJ;;AmIv35BM;EACE,yBAAA;AnI035BR;;AmIv35BM;EACE,oCAAA;AnI035BR;;AmIv35BM;EACE,6DAAA;EACA,oCAAA;AnI035BR;AmIx35BQ;EACE,6DAAA;EACA,oEAAA;AnI035BV;AmIv35BQ;EAEE,gEAAA;EACA,wDAAA;AnIw35BV;;AmIp35BM;EACE,gCAAA;EACA,yBAAA;AnIu35BR;AmIr35BQ;EACE,oCAAA;AnIu35BV;;AmIn35BM;EACE,iEAAA;AnIs35BR;;AmIn35BM;EACE,oCAAA;AnIs35BR;;AmIn35BM;EACE,wCAAA;AnIs35BR;;AmIn35BM;EACE,2CAAA;AnIs35BR;;AmIn35BM;EACE,yCAAA;AnIs35BR;;AmIn35BM;EACE,0CAAA;AnIs35BR;;AmIn35BM;ECxdF,mBCoIK,EDpIe,iBAAA;EACpB,oCAAA;ApI+06BJ;;AmIj75BM;EACE,yBAAA;AnIo75BR;;AmIj75BM;EACE,oCAAA;AnIo75BR;;AmIj75BM;EACE,6DAAA;EACA,oCAAA;AnIo75BR;AmIl75BQ;EACE,6DAAA;EACA,oEAAA;AnIo75BV;AmIj75BQ;EAEE,gEAAA;EACA,wDAAA;AnIk75BV;;AmI965BM;EACE,gCAAA;EACA,yBAAA;AnIi75BR;AmI/65BQ;EACE,oCAAA;AnIi75BV;;AmI765BM;EACE,iEAAA;AnIg75BR;;AmI765BM;EACE,oCAAA;AnIg75BR;;AmI765BM;EACE,wCAAA;AnIg75BR;;AmI765BM;EACE,2CAAA;AnIg75BR;;AmI765BM;EACE,yCAAA;AnIg75BR;;AmI765BM;EACE,0CAAA;AnIg75BR;;AmI765BM;ECxdF,mBCoIK,EDpIe,iBAAA;EACpB,oCAAA;ApIy46BJ;;AmI3+5BM;EACE,yBAAA;AnI8+5BR;;AmI3+5BM;EACE,oCAAA;AnI8+5BR;;AmI3+5BM;EACE,6DAAA;EACA,oCAAA;AnI8+5BR;AmI5+5BQ;EACE,6DAAA;EACA,oEAAA;AnI8+5BV;AmI3+5BQ;EAEE,gEAAA;EACA,wDAAA;AnI4+5BV;;AmIx+5BM;EACE,gCAAA;EACA,yBAAA;AnI2+5BR;AmIz+5BQ;EACE,oCAAA;AnI2+5BV;;AmIv+5BM;EACE,iEAAA;AnI0+5BR;;AmIv+5BM;EACE,oCAAA;AnI0+5BR;;AmIv+5BM;EACE,wCAAA;AnI0+5BR;;AmIv+5BM;EACE,2CAAA;AnI0+5BR;;AmIv+5BM;EACE,yCAAA;AnI0+5BR;;AmIv+5BM;EACE,0CAAA;AnI0+5BR;;AmIv+5BM;ECxdF,mBCoIK,EDpIe,iBAAA;EACpB,oCAAA;ApIm86BJ;;AmIri6BM;EACE,yBAAA;AnIwi6BR;;AmIri6BM;EACE,oCAAA;AnIwi6BR;;AmIri6BM;EACE,6DAAA;EACA,oCAAA;AnIwi6BR;AmIti6BQ;EACE,6DAAA;EACA,oEAAA;AnIwi6BV;AmIri6BQ;EAEE,gEAAA;EACA,wDAAA;AnIsi6BV;;AmIli6BM;EACE,gCAAA;EACA,yBAAA;AnIqi6BR;AmIni6BQ;EACE,oCAAA;AnIqi6BV;;AmIji6BM;EACE,iEAAA;AnIoi6BR;;AmIji6BM;EACE,oCAAA;AnIoi6BR;;AmIji6BM;EACE,wCAAA;AnIoi6BR;;AmIji6BM;EACE,2CAAA;AnIoi6BR;;AmIji6BM;EACE,yCAAA;AnIoi6BR;;AmIji6BM;EACE,0CAAA;AnIoi6BR;;AmIji6BM;ECxdF,mBCoIK,EDpIe,iBAAA;EACpB,kCAAA;ApI6/6BJ;;AsI//6BA;EACE,sBAAA;EACA,6CAAA,EAAA,OAAA;EACA,uPAAA,EAMuE,aAAA;AtI4/6BzE;AsIz/6BA;EACE,+EAAA;EACA,iCAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EAEA,sCAAA;EACA,mCAAA;EACA,kCAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;AsIv/6BA;EACE,gBAAA;AtI0/6BF;;A6E158BA;;0DAAA;A0D7JI;EACE,OAAA;EACA,WAAA;AvI6j9BN;AuI3j9BI;EACE,QAAA;AvI6j9BN;AuItj9BM;EACE,QAAA;AvIwj9BR;AuI/i9BQ;EACE,yBAAA;AvIij9BV;AuIzi9BI;EACE,gBAAA;AvI2i9BN;AuIli9BU;EACE,yBAAA;AvIoi9BZ;AuIhi9BU;EACE,mCAAA;AvIki9BZ;AuI1h9BE;EACE,cAAA;AvI4h9BJ;AuI3h9BI;EACE,0BAAA;EACA,4BAAA;AvI6h9BN;AuI3h9BI;EACE,yBAAA;EACA,6BAAA;AvI6h9BN;AuIvh9BI;EACE,gBAAA;AvIyh9BN;AuIph9BE;EACE,cAAA;AvIsh9BJ;AuIlh9BE;EACE,aAAA;AvIoh9BJ;AuI7g9BQ;EACE,cAAA;AvI+g9BV;AuI1g9BU;EACE,iDAAA;AvI4g9BZ;AuIjg9BM;;;;EAEE,yBAAA;AvIqg9BR;AuIz/8BM;;;;;;;;EACE,yBAAA;AvIkg9BR;AuI5/8BQ;;;;EACE,yBAAA;AvIig9BV;AuIv/8BM;;EACE,yBAAA;AvI0/8BR;AuIp/8BM;EACE,mCAAA;AvIs/8BR;AuIh/8BE;EACE,UAAA;EACA,WAAA;AvIk/8BJ;AuI/+8BI;EACE,WAAA;AvIi/8BN;AuIx+8BY;EACE,yBAAA;AvI0+8Bd;AuIt+8BQ;EACE,mBAAA;EACA,qBAAA;EACA,oBAAA;AvIw+8BV;AuIv+8BU;EACE,qBAAA;EACA,sBAAA;EACA,iBAAA;AvIy+8BZ;AuI/98BI;EACE,aAAA;EACA,mBAAA;AvIi+8BN;AuI398BI;EACE,aAAA;AvI698BN;AuI598BM;EACE,QAAA;AvI898BR;AuIt98BM;;EACE,WAAA;EACA,YAAA;AvIy98BR;AuIl98BI;;EACE,sBAAA;EACA,iBAAA;EACA,qBAAA;AvIq98BN;AuIn98BM;;EACE,qBAAA;EACA,mBAAA;AvIs98BR;AuIp98BQ;;EACE,aAAA;EACA,UAAA;AvIu98BV;AuI/88BI;EACE,iBAAA;EACA,sBAAA;EACA,oBAAA;AvIi98BN;AuI588BE;EACE,wBAAA;AvI888BJ;AuI388BE;;EAEE,cAAA;AvI688BJ;AuI188BE;EACE;;IAEE,iBAAA;EvI488BJ;AACF;AuIr88BQ;EACE,yBAAA;AvIu88BV;AuIh88BE;;EAEE,oCAAA;EACA,0B9HlES;ATog9Bb;AuI/78BE;;EAEE,QAAA;EACA,UAAA;AvIi88BJ;AuI978BE;;EAEE,oCAAA;EACA,2B9H9ES;AT8g9Bb;AuI778BE;;EAEE,OAAA;EACA,WAAA;AvI+78BJ;AuI378BE;EACE,sBAAA;AvI678BJ;AuIz78BE;EACE,sBAAA;EACA,oBAAA;AvI278BJ;;AuIv78BA;EAIQ;IACE,eAAA;EvIu78BR;AACF;AuIj78BA;EAQgB;IACE,qBAAA;EvI468BhB;EuI368BgB;IACE,qBAAA;IACA,uBAAA;EvI668BlB;EuIx68BgB;IACE,mDAAA;EvI068BlB;EuIz68BkB;IACE,mDAAA;EvI268BpB;EuIt68BgB;IACE,kDAAA;EvIw68BlB;EuIp68BgB;IACE,sBAAA;EvIs68BlB;AACF;AuI358BA;EAKS;IACE,mDAAA;EvIy58BT;EuIx58BS;IACE,mDAAA;EvI058BX;EuIr58BO;IACE,kDAAA;EvIu58BT;EuIn58BO;IACE,mDAAA;EvIq58BT;AACF;AuI948BA;EAMY;IACE,kDAAA;EvI248BZ;EuI148BY;IACE,kDAAA;EvI448Bd;EuIv48BU;IACE,kBAAA;IACA,sBAAA;EvIy48BZ;EuIr48BU;IACE,kDAAA;EvIu48BZ;AACF;AwIxz9BA;EACI,qCAAA;AxI0z9BJ;;AwItz9BA;EACI,aAAA;EACA,sBAAA;AxIyz9BJ;;AwItz9BA;EACI,kBAAA;EACA,mBAAA;AxIyz9BJ;;AwIrz9BA;EACI,cAAA;EACA,eAAA;AxIwz9BJ;;AwIrz9BA;EACI,kBAAA;AxIwz9BJ;;AwIpz9BA;EACI,kBAAA;EACA,wBAAA;EAAA,mBAAA;AxIuz9BJ;;AwIpz9BA;EACI,wBAAA;AxIuz9BJ;;AwInz9BA;EACI,2BAAA;AxIsz9BJ;;AwIlz9BA;EACI,aAAA;AxIqz9BJ;;AwIlz9BA;EACI,cAAA;EACA,qBAAA;EACA,eAAA;AxIqz9BJ;;AwIlz9BA;EACI,2BAAA;EAAA,sBAAA;AxIqz9BJ;;AwIlz9BI;EACI,iBAAA;AxIqz9BR","sourcesContent":["@charset \"UTF-8\";\n/**\n * prism.js tomorrow night eighties for JavaScript, CoffeeScript, CSS and HTML\n * Based on https://github.com/chriskempson/tomorrow-theme\n * @author Rose Pritchard\n */\ncode[class*=language-],\npre[class*=language-] {\n  color: #ccc;\n  background: none;\n  font-family: Consolas, Monaco, \"Andale Mono\", \"Ubuntu Mono\", monospace;\n  font-size: 1em;\n  text-align: left;\n  white-space: pre;\n  word-spacing: normal;\n  word-break: normal;\n  word-wrap: normal;\n  line-height: 1.5;\n  -moz-tab-size: 4;\n  -o-tab-size: 4;\n  tab-size: 4;\n  -webkit-hyphens: none;\n  -moz-hyphens: none;\n  -ms-hyphens: none;\n  hyphens: none;\n}\n\n/* Code blocks */\npre[class*=language-] {\n  padding: 1em;\n  margin: 0.5em 0;\n  overflow: auto;\n}\n\n:not(pre) > code[class*=language-],\npre[class*=language-] {\n  background: #2d2d2d;\n}\n\n/* Inline code */\n:not(pre) > code[class*=language-] {\n  padding: 0.1em;\n  border-radius: 0.3em;\n  white-space: normal;\n}\n\n.token.comment,\n.token.block-comment,\n.token.prolog,\n.token.doctype,\n.token.cdata {\n  color: #999;\n}\n\n.token.punctuation {\n  color: #ccc;\n}\n\n.token.tag,\n.token.attr-name,\n.token.namespace,\n.token.deleted {\n  color: #e2777a;\n}\n\n.token.function-name {\n  color: #6196cc;\n}\n\n.token.boolean,\n.token.number,\n.token.function {\n  color: #f08d49;\n}\n\n.token.property,\n.token.class-name,\n.token.constant,\n.token.symbol {\n  color: #f8c555;\n}\n\n.token.selector,\n.token.important,\n.token.atrule,\n.token.keyword,\n.token.builtin {\n  color: #cc99cd;\n}\n\n.token.string,\n.token.char,\n.token.attr-value,\n.token.regex,\n.token.variable {\n  color: #7ec699;\n}\n\n.token.operator,\n.token.entity,\n.token.url {\n  color: #67cdcc;\n}\n\n.token.important,\n.token.bold {\n  font-weight: bold;\n}\n\n.token.italic {\n  font-style: italic;\n}\n\n.token.entity {\n  cursor: help;\n}\n\n.token.inserted {\n  color: green;\n}\n\n/*!\n * Bootstrap v4.3.1 (https://getbootstrap.com/)\n * Copyright 2011-2020 The Bootstrap Authors\n * Copyright 2011-2020 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n */\n/*!\n * Bootstrap  v5.3.3 (https://getbootstrap.com/)\n * Copyright 2011-2024 The Bootstrap Authors\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n:root,\n[data-bs-theme=light] {\n  --bs-blue: #00cfe8;\n  --bs-indigo: #6610f2;\n  --bs-purple: #6f42c1;\n  --bs-pink: #d63384;\n  --bs-red: #ea5455;\n  --bs-orange: #ff9f43;\n  --bs-yellow: #ffc107;\n  --bs-green: #28c76f;\n  --bs-teal: #20c997;\n  --bs-cyan: #7367f0;\n  --bs-black: #22292f;\n  --bs-white: #fff;\n  --bs-gray: #b8c2cc;\n  --bs-gray-dark: #1e1e1e;\n  --bs-gray-100: #babfc7;\n  --bs-gray-200: #ededed;\n  --bs-gray-300: #dae1e7;\n  --bs-gray-400: #636363;\n  --bs-gray-500: #adb5bd;\n  --bs-gray-600: #b8c2cc;\n  --bs-gray-700: #4e5154;\n  --bs-gray-800: #1e1e1e;\n  --bs-gray-900: #2a2e30;\n  --bs-primary: #7367f0;\n  --bs-secondary: #b8c2cc;\n  --bs-success: #28c76f;\n  --bs-info: #00cfe8;\n  --bs-warning: #ff9f43;\n  --bs-danger: #ea5455;\n  --bs-light: #babfc7;\n  --bs-dark: #2a2e30;\n  --bs-primary-rgb: 115, 103, 240;\n  --bs-secondary-rgb: 184, 194, 204;\n  --bs-success-rgb: 40, 199, 111;\n  --bs-info-rgb: 0, 207, 232;\n  --bs-warning-rgb: 255, 159, 67;\n  --bs-danger-rgb: 234, 84, 85;\n  --bs-light-rgb: 186, 191, 199;\n  --bs-dark-rgb: 42, 46, 48;\n  --bs-primary-text-emphasis: rgb(46, 41.2, 96);\n  --bs-secondary-text-emphasis: rgb(73.6, 77.6, 81.6);\n  --bs-success-text-emphasis: rgb(16, 79.6, 44.4);\n  --bs-info-text-emphasis: rgb(0, 82.8, 92.8);\n  --bs-warning-text-emphasis: rgb(102, 63.6, 26.8);\n  --bs-danger-text-emphasis: rgb(93.6, 33.6, 34);\n  --bs-light-text-emphasis: #4e5154;\n  --bs-dark-text-emphasis: #4e5154;\n  --bs-primary-bg-subtle: rgb(227, 224.6, 252);\n  --bs-secondary-bg-subtle: rgb(240.8, 242.8, 244.8);\n  --bs-success-bg-subtle: rgb(212, 243.8, 226.2);\n  --bs-info-bg-subtle: rgb(204, 245.4, 250.4);\n  --bs-warning-bg-subtle: rgb(255, 235.8, 217.4);\n  --bs-danger-bg-subtle: rgb(250.8, 220.8, 221);\n  --bs-light-bg-subtle: rgb(220.5, 223, 227);\n  --bs-dark-bg-subtle: #636363;\n  --bs-primary-border-subtle: rgb(199, 194.2, 249);\n  --bs-secondary-border-subtle: rgb(226.6, 230.6, 234.6);\n  --bs-success-border-subtle: rgb(169, 232.6, 197.4);\n  --bs-info-border-subtle: rgb(153, 235.8, 245.8);\n  --bs-warning-border-subtle: rgb(255, 216.6, 179.8);\n  --bs-danger-border-subtle: rgb(246.6, 186.6, 187);\n  --bs-light-border-subtle: #ededed;\n  --bs-dark-border-subtle: #adb5bd;\n  --bs-white-rgb: 255, 255, 255;\n  --bs-black-rgb: 34, 41, 47;\n  --bs-font-sans-serif: \"Montserrat\", Helvetica, Arial, serif;\n  --bs-font-monospace: \"Montserrat\", Helvetica, Arial, serif;\n  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));\n  --bs-body-font-family: var(--bs-font-sans-serif);\n  --bs-body-font-size: 1rem;\n  --bs-body-font-weight: 400;\n  --bs-body-line-height: 1.45;\n  --bs-body-color: #626262;\n  --bs-body-color-rgb: 98, 98, 98;\n  --bs-body-bg: #f8f8f8;\n  --bs-body-bg-rgb: 248, 248, 248;\n  --bs-emphasis-color: #22292f;\n  --bs-emphasis-color-rgb: 34, 41, 47;\n  --bs-secondary-color: rgba(98, 98, 98, 0.75);\n  --bs-secondary-color-rgb: 98, 98, 98;\n  --bs-secondary-bg: #ededed;\n  --bs-secondary-bg-rgb: 237, 237, 237;\n  --bs-tertiary-color: rgba(98, 98, 98, 0.5);\n  --bs-tertiary-color-rgb: 98, 98, 98;\n  --bs-tertiary-bg: #babfc7;\n  --bs-tertiary-bg-rgb: 186, 191, 199;\n  --bs-heading-color: #2c2c2c;\n  --bs-link-color: #7367f0;\n  --bs-link-color-rgb: 115, 103, 240;\n  --bs-link-decoration: underline;\n  --bs-link-hover-color: rgb(93.622754491, 79.7904191617, 237.7095808383);\n  --bs-link-hover-color-rgb: 94, 80, 238;\n  --bs-link-hover-decoration: none;\n  --bs-code-color: #d63384;\n  --bs-highlight-color: #626262;\n  --bs-highlight-bg: rgb(255, 242.6, 205.4);\n  --bs-border-width: 1px;\n  --bs-border-style: solid;\n  --bs-border-color: #ededed;\n  --bs-border-color-translucent: rgba(34, 41, 47, 0.175);\n  --bs-border-radius: 0.5rem;\n  --bs-border-radius-sm: 0.25rem;\n  --bs-border-radius-lg: 0.6rem;\n  --bs-border-radius-xl: 1rem;\n  --bs-border-radius-xxl: 2rem;\n  --bs-border-radius-2xl: var(--bs-border-radius-xxl);\n  --bs-border-radius-pill: 50rem;\n  --bs-box-shadow: 0 0.5rem 1rem rgba(34, 41, 47, 0.15);\n  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(34, 41, 47, 0.075);\n  --bs-box-shadow-lg: 0 1rem 3rem rgba(34, 41, 47, 0.175);\n  --bs-box-shadow-inset: inset 0 1px 2px rgba(34, 41, 47, 0.075);\n  --bs-focus-ring-width: 0.25rem;\n  --bs-focus-ring-opacity: 0.25;\n  --bs-focus-ring-color: rgba(115, 103, 240, 0.25);\n  --bs-form-valid-color: #28c76f;\n  --bs-form-valid-border-color: #28c76f;\n  --bs-form-invalid-color: #ea5455;\n  --bs-form-invalid-border-color: #ea5455;\n}\n\n[data-bs-theme=dark] {\n  color-scheme: dark;\n  --bs-body-color: #dae1e7;\n  --bs-body-color-rgb: 218, 225, 231;\n  --bs-body-bg: #2a2e30;\n  --bs-body-bg-rgb: 42, 46, 48;\n  --bs-emphasis-color: #fff;\n  --bs-emphasis-color-rgb: 255, 255, 255;\n  --bs-secondary-color: rgba(218, 225, 231, 0.75);\n  --bs-secondary-color-rgb: 218, 225, 231;\n  --bs-secondary-bg: #1e1e1e;\n  --bs-secondary-bg-rgb: 30, 30, 30;\n  --bs-tertiary-color: rgba(218, 225, 231, 0.5);\n  --bs-tertiary-color-rgb: 218, 225, 231;\n  --bs-tertiary-bg: #242627;\n  --bs-tertiary-bg-rgb: 36, 38, 39;\n  --bs-primary-text-emphasis: rgb(171, 163.8, 246);\n  --bs-secondary-text-emphasis: rgb(212.4, 218.4, 224.4);\n  --bs-success-text-emphasis: rgb(126, 221.4, 168.6);\n  --bs-info-text-emphasis: rgb(102, 226.2, 241.2);\n  --bs-warning-text-emphasis: rgb(255, 197.4, 142.2);\n  --bs-danger-text-emphasis: rgb(242.4, 152.4, 153);\n  --bs-light-text-emphasis: #babfc7;\n  --bs-dark-text-emphasis: #dae1e7;\n  --bs-primary-bg-subtle: rgb(23, 20.6, 48);\n  --bs-secondary-bg-subtle: rgb(36.8, 38.8, 40.8);\n  --bs-success-bg-subtle: rgb(8, 39.8, 22.2);\n  --bs-info-bg-subtle: rgb(0, 41.4, 46.4);\n  --bs-warning-bg-subtle: rgb(51, 31.8, 13.4);\n  --bs-danger-bg-subtle: rgb(46.8, 16.8, 17);\n  --bs-light-bg-subtle: #1e1e1e;\n  --bs-dark-bg-subtle: rgb(32, 35.5, 38.5);\n  --bs-primary-border-subtle: rgb(69, 61.8, 144);\n  --bs-secondary-border-subtle: rgb(110.4, 116.4, 122.4);\n  --bs-success-border-subtle: rgb(24, 119.4, 66.6);\n  --bs-info-border-subtle: rgb(0, 124.2, 139.2);\n  --bs-warning-border-subtle: rgb(153, 95.4, 40.2);\n  --bs-danger-border-subtle: rgb(140.4, 50.4, 51);\n  --bs-light-border-subtle: #4e5154;\n  --bs-dark-border-subtle: #1e1e1e;\n  --bs-heading-color: inherit;\n  --bs-link-color: rgb(171, 163.8, 246);\n  --bs-link-hover-color: rgb(187.8, 182.04, 247.8);\n  --bs-link-color-rgb: 171, 164, 246;\n  --bs-link-hover-color-rgb: 188, 182, 248;\n  --bs-code-color: rgb(230.4, 132.6, 181.2);\n  --bs-highlight-color: #dae1e7;\n  --bs-highlight-bg: rgb(102, 77.2, 2.8);\n  --bs-border-color: #4e5154;\n  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);\n  --bs-form-valid-color: rgb(126, 221.4, 168.6);\n  --bs-form-valid-border-color: rgb(126, 221.4, 168.6);\n  --bs-form-invalid-color: rgb(242.4, 152.4, 153);\n  --bs-form-invalid-border-color: rgb(242.4, 152.4, 153);\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  :root {\n    scroll-behavior: smooth;\n  }\n}\n\nbody {\n  margin: 0;\n  font-family: var(--bs-body-font-family);\n  font-size: var(--bs-body-font-size);\n  font-weight: var(--bs-body-font-weight);\n  line-height: var(--bs-body-line-height);\n  color: var(--bs-body-color);\n  text-align: var(--bs-body-text-align);\n  background-color: var(--bs-body-bg);\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(34, 41, 47, 0);\n}\n\nhr {\n  margin: 1rem 0;\n  color: inherit;\n  border: 0;\n  border-top: var(--bs-border-width) solid;\n  opacity: 0.25;\n}\n\nh6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.2;\n  color: var(--bs-heading-color);\n}\n\nh1, .h1 {\n  font-size: calc(1.325rem + 0.9vw);\n}\n@media (min-width: 1200px) {\n  h1, .h1 {\n    font-size: 2rem;\n  }\n}\n\nh2, .h2 {\n  font-size: calc(1.299rem + 0.588vw);\n}\n@media (min-width: 1200px) {\n  h2, .h2 {\n    font-size: 1.74rem;\n  }\n}\n\nh3, .h3 {\n  font-size: calc(1.276rem + 0.312vw);\n}\n@media (min-width: 1200px) {\n  h3, .h3 {\n    font-size: 1.51rem;\n  }\n}\n\nh4, .h4 {\n  font-size: calc(1.257rem + 0.084vw);\n}\n@media (min-width: 1200px) {\n  h4, .h4 {\n    font-size: 1.32rem;\n  }\n}\n\nh5, .h5 {\n  font-size: 1.14rem;\n}\n\nh6, .h6 {\n  font-size: 1rem;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nabbr[title] {\n  text-decoration: underline dotted;\n  cursor: help;\n  text-decoration-skip-ink: none;\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: 700;\n}\n\ndd {\n  margin-bottom: 0.5rem;\n  margin-left: 0;\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\nsmall, .small {\n  font-size: smaller;\n}\n\nmark, .mark {\n  padding: 0.1875em;\n  color: var(--bs-highlight-color);\n  background-color: var(--bs-highlight-bg);\n}\n\nsub,\nsup {\n  position: relative;\n  font-size: 0.75em;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\na {\n  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));\n  text-decoration: underline;\n}\na:hover {\n  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);\n  text-decoration: none;\n}\n\na:not([href]):not([class]), a:not([href]):not([class]):hover {\n  color: inherit;\n  text-decoration: none;\n}\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: var(--bs-font-monospace);\n  font-size: 1em;\n}\n\npre {\n  display: block;\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  font-size: 90%;\n}\npre code {\n  font-size: inherit;\n  color: inherit;\n  word-break: normal;\n}\n\ncode {\n  font-size: 90%;\n  color: var(--bs-code-color);\n  word-wrap: break-word;\n}\na > code {\n  color: inherit;\n}\n\nkbd {\n  padding: 0.1875rem 0.375rem;\n  font-size: 90%;\n  color: var(--bs-body-bg);\n  background-color: #eee;\n  border-radius: 0.25rem;\n}\nkbd kbd {\n  padding: 0;\n  font-size: 1em;\n}\n\nfigure {\n  margin: 0 0 1rem;\n}\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  color: var(--bs-secondary-color);\n  text-align: left;\n}\n\nth {\n  text-align: inherit;\n  text-align: -webkit-match-parent;\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\nlabel {\n  display: inline-block;\n}\n\nbutton {\n  border-radius: 0;\n}\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n[role=button] {\n  cursor: pointer;\n}\n\nselect {\n  word-wrap: normal;\n}\nselect:disabled {\n  opacity: 1;\n}\n\n[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\nbutton,\n[type=button],\n[type=reset],\n[type=submit] {\n  -webkit-appearance: button;\n}\nbutton:not(:disabled),\n[type=button]:not(:disabled),\n[type=reset]:not(:disabled),\n[type=submit]:not(:disabled) {\n  cursor: pointer;\n}\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ntextarea {\n  resize: vertical;\n}\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  float: left;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 0.5rem;\n  font-size: calc(1.275rem + 0.3vw);\n  line-height: inherit;\n}\n@media (min-width: 1200px) {\n  legend {\n    font-size: 1.5rem;\n  }\n}\nlegend + * {\n  clear: left;\n}\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n[type=search] {\n  -webkit-appearance: textfield;\n  outline-offset: -2px;\n}\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n::file-selector-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n\noutput {\n  display: inline-block;\n}\n\niframe {\n  border: 0;\n}\n\nsummary {\n  display: list-item;\n  cursor: pointer;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n.lead {\n  font-size: 1.25rem;\n  font-weight: 300;\n}\n\n.display-1 {\n  font-size: calc(1.625rem + 4.5vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-1 {\n    font-size: 5rem;\n  }\n}\n\n.display-2 {\n  font-size: calc(1.575rem + 3.9vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-2 {\n    font-size: 4.5rem;\n  }\n}\n\n.display-3 {\n  font-size: calc(1.525rem + 3.3vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-3 {\n    font-size: 4rem;\n  }\n}\n\n.display-4 {\n  font-size: calc(1.475rem + 2.7vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-4 {\n    font-size: 3.5rem;\n  }\n}\n\n.display-5 {\n  font-size: calc(1.425rem + 2.1vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-5 {\n    font-size: 3rem;\n  }\n}\n\n.display-6 {\n  font-size: calc(1.375rem + 1.5vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-6 {\n    font-size: 2.5rem;\n  }\n}\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline-item {\n  display: inline-block;\n}\n.list-inline-item:not(:last-child) {\n  margin-right: 0.5rem;\n}\n\n.initialism {\n  font-size: smaller;\n  text-transform: uppercase;\n}\n\n.blockquote {\n  margin-bottom: 1rem;\n  font-size: 1.25rem;\n}\n.blockquote > :last-child {\n  margin-bottom: 0;\n}\n\n.blockquote-footer {\n  margin-top: -1rem;\n  margin-bottom: 1rem;\n  font-size: smaller;\n  color: #b8c2cc;\n}\n.blockquote-footer::before {\n  content: \"— \";\n}\n\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: var(--bs-body-bg);\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: var(--bs-border-radius);\n  max-width: 100%;\n  height: auto;\n}\n\n.figure {\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: 0.5rem;\n  line-height: 1;\n}\n\n.figure-caption {\n  font-size: smaller;\n  color: var(--bs-secondary-color);\n}\n\n.container,\n.container-fluid,\n.container-xxl,\n.container-xl,\n.container-lg,\n.container-md,\n.container-sm {\n  --bs-gutter-x: 28px;\n  --bs-gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@media (min-width: 576px) {\n  .container-sm, .container {\n    max-width: 540px;\n  }\n}\n@media (min-width: 768px) {\n  .container-md, .container-sm, .container {\n    max-width: 720px;\n  }\n}\n@media (min-width: 992px) {\n  .container-lg, .container-md, .container-sm, .container {\n    max-width: 960px;\n  }\n}\n@media (min-width: 1200px) {\n  .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1140px;\n  }\n}\n@media (min-width: 1400px) {\n  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1320px;\n  }\n}\n:root {\n  --bs-breakpoint-xs: 0;\n  --bs-breakpoint-sm: 576px;\n  --bs-breakpoint-md: 768px;\n  --bs-breakpoint-lg: 992px;\n  --bs-breakpoint-xl: 1200px;\n  --bs-breakpoint-xxl: 1400px;\n}\n\n.row {\n  --bs-gutter-x: 28px;\n  --bs-gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: calc(-1 * var(--bs-gutter-y));\n  margin-right: calc(-0.5 * var(--bs-gutter-x));\n  margin-left: calc(-0.5 * var(--bs-gutter-x));\n}\n.row > * {\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-top: var(--bs-gutter-y);\n}\n\n.col {\n  flex: 1 0 0%;\n}\n\n.row-cols-auto > * {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.row-cols-1 > * {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.row-cols-2 > * {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.row-cols-3 > * {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n\n.row-cols-4 > * {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.row-cols-5 > * {\n  flex: 0 0 auto;\n  width: 20%;\n}\n\n.row-cols-6 > * {\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n\n.col-auto {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.col-1 {\n  flex: 0 0 auto;\n  width: 8.33333333%;\n}\n\n.col-2 {\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n\n.col-3 {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.col-4 {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n\n.col-5 {\n  flex: 0 0 auto;\n  width: 41.66666667%;\n}\n\n.col-6 {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.col-7 {\n  flex: 0 0 auto;\n  width: 58.33333333%;\n}\n\n.col-8 {\n  flex: 0 0 auto;\n  width: 66.66666667%;\n}\n\n.col-9 {\n  flex: 0 0 auto;\n  width: 75%;\n}\n\n.col-10 {\n  flex: 0 0 auto;\n  width: 83.33333333%;\n}\n\n.col-11 {\n  flex: 0 0 auto;\n  width: 91.66666667%;\n}\n\n.col-12 {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.offset-1 {\n  margin-left: 8.33333333%;\n}\n\n.offset-2 {\n  margin-left: 16.66666667%;\n}\n\n.offset-3 {\n  margin-left: 25%;\n}\n\n.offset-4 {\n  margin-left: 33.33333333%;\n}\n\n.offset-5 {\n  margin-left: 41.66666667%;\n}\n\n.offset-6 {\n  margin-left: 50%;\n}\n\n.offset-7 {\n  margin-left: 58.33333333%;\n}\n\n.offset-8 {\n  margin-left: 66.66666667%;\n}\n\n.offset-9 {\n  margin-left: 75%;\n}\n\n.offset-10 {\n  margin-left: 83.33333333%;\n}\n\n.offset-11 {\n  margin-left: 91.66666667%;\n}\n\n.g-0,\n.gx-0 {\n  --bs-gutter-x: 0;\n}\n\n.g-0,\n.gy-0 {\n  --bs-gutter-y: 0;\n}\n\n.g-25,\n.gx-25 {\n  --bs-gutter-x: 0.25rem;\n}\n\n.g-25,\n.gy-25 {\n  --bs-gutter-y: 0.25rem;\n}\n\n.g-50,\n.gx-50 {\n  --bs-gutter-x: 0.5rem;\n}\n\n.g-50,\n.gy-50 {\n  --bs-gutter-y: 0.5rem;\n}\n\n.g-75,\n.gx-75 {\n  --bs-gutter-x: 0.75rem;\n}\n\n.g-75,\n.gy-75 {\n  --bs-gutter-y: 0.75rem;\n}\n\n.g-1,\n.gx-1 {\n  --bs-gutter-x: 1rem;\n}\n\n.g-1,\n.gy-1 {\n  --bs-gutter-y: 1rem;\n}\n\n.g-2,\n.gx-2 {\n  --bs-gutter-x: 1.5rem;\n}\n\n.g-2,\n.gy-2 {\n  --bs-gutter-y: 1.5rem;\n}\n\n.g-3,\n.gx-3 {\n  --bs-gutter-x: 3rem;\n}\n\n.g-3,\n.gy-3 {\n  --bs-gutter-y: 3rem;\n}\n\n.g-4,\n.gx-4 {\n  --bs-gutter-x: 3.5rem;\n}\n\n.g-4,\n.gy-4 {\n  --bs-gutter-y: 3.5rem;\n}\n\n.g-5,\n.gx-5 {\n  --bs-gutter-x: 4rem;\n}\n\n.g-5,\n.gy-5 {\n  --bs-gutter-y: 4rem;\n}\n\n@media (min-width: 576px) {\n  .col-sm {\n    flex: 1 0 0%;\n  }\n  .row-cols-sm-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-sm-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-sm-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-sm-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-sm-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-sm-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-sm-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-sm-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-sm-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-sm-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-sm-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-sm-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-sm-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-sm-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-sm-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-sm-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-sm-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-sm-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-sm-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-sm-0 {\n    margin-left: 0;\n  }\n  .offset-sm-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-sm-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-sm-3 {\n    margin-left: 25%;\n  }\n  .offset-sm-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-sm-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-sm-6 {\n    margin-left: 50%;\n  }\n  .offset-sm-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-sm-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-sm-9 {\n    margin-left: 75%;\n  }\n  .offset-sm-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-sm-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-sm-0,\n  .gx-sm-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-sm-0,\n  .gy-sm-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-sm-25,\n  .gx-sm-25 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-sm-25,\n  .gy-sm-25 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-sm-50,\n  .gx-sm-50 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-sm-50,\n  .gy-sm-50 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-sm-75,\n  .gx-sm-75 {\n    --bs-gutter-x: 0.75rem;\n  }\n  .g-sm-75,\n  .gy-sm-75 {\n    --bs-gutter-y: 0.75rem;\n  }\n  .g-sm-1,\n  .gx-sm-1 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-sm-1,\n  .gy-sm-1 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-sm-2,\n  .gx-sm-2 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-sm-2,\n  .gy-sm-2 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-sm-3,\n  .gx-sm-3 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-sm-3,\n  .gy-sm-3 {\n    --bs-gutter-y: 3rem;\n  }\n  .g-sm-4,\n  .gx-sm-4 {\n    --bs-gutter-x: 3.5rem;\n  }\n  .g-sm-4,\n  .gy-sm-4 {\n    --bs-gutter-y: 3.5rem;\n  }\n  .g-sm-5,\n  .gx-sm-5 {\n    --bs-gutter-x: 4rem;\n  }\n  .g-sm-5,\n  .gy-sm-5 {\n    --bs-gutter-y: 4rem;\n  }\n}\n@media (min-width: 768px) {\n  .col-md {\n    flex: 1 0 0%;\n  }\n  .row-cols-md-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-md-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-md-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-md-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-md-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-md-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-md-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-md-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-md-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-md-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-md-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-md-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-md-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-md-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-md-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-md-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-md-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-md-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-md-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-md-0 {\n    margin-left: 0;\n  }\n  .offset-md-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-md-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-md-3 {\n    margin-left: 25%;\n  }\n  .offset-md-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-md-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-md-6 {\n    margin-left: 50%;\n  }\n  .offset-md-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-md-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-md-9 {\n    margin-left: 75%;\n  }\n  .offset-md-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-md-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-md-0,\n  .gx-md-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-md-0,\n  .gy-md-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-md-25,\n  .gx-md-25 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-md-25,\n  .gy-md-25 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-md-50,\n  .gx-md-50 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-md-50,\n  .gy-md-50 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-md-75,\n  .gx-md-75 {\n    --bs-gutter-x: 0.75rem;\n  }\n  .g-md-75,\n  .gy-md-75 {\n    --bs-gutter-y: 0.75rem;\n  }\n  .g-md-1,\n  .gx-md-1 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-md-1,\n  .gy-md-1 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-md-2,\n  .gx-md-2 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-md-2,\n  .gy-md-2 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-md-3,\n  .gx-md-3 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-md-3,\n  .gy-md-3 {\n    --bs-gutter-y: 3rem;\n  }\n  .g-md-4,\n  .gx-md-4 {\n    --bs-gutter-x: 3.5rem;\n  }\n  .g-md-4,\n  .gy-md-4 {\n    --bs-gutter-y: 3.5rem;\n  }\n  .g-md-5,\n  .gx-md-5 {\n    --bs-gutter-x: 4rem;\n  }\n  .g-md-5,\n  .gy-md-5 {\n    --bs-gutter-y: 4rem;\n  }\n}\n@media (min-width: 992px) {\n  .col-lg {\n    flex: 1 0 0%;\n  }\n  .row-cols-lg-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-lg-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-lg-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-lg-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-lg-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-lg-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-lg-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-lg-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-lg-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-lg-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-lg-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-lg-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-lg-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-lg-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-lg-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-lg-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-lg-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-lg-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-lg-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-lg-0 {\n    margin-left: 0;\n  }\n  .offset-lg-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-lg-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-lg-3 {\n    margin-left: 25%;\n  }\n  .offset-lg-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-lg-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-lg-6 {\n    margin-left: 50%;\n  }\n  .offset-lg-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-lg-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-lg-9 {\n    margin-left: 75%;\n  }\n  .offset-lg-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-lg-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-lg-0,\n  .gx-lg-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-lg-0,\n  .gy-lg-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-lg-25,\n  .gx-lg-25 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-lg-25,\n  .gy-lg-25 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-lg-50,\n  .gx-lg-50 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-lg-50,\n  .gy-lg-50 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-lg-75,\n  .gx-lg-75 {\n    --bs-gutter-x: 0.75rem;\n  }\n  .g-lg-75,\n  .gy-lg-75 {\n    --bs-gutter-y: 0.75rem;\n  }\n  .g-lg-1,\n  .gx-lg-1 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-lg-1,\n  .gy-lg-1 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-lg-2,\n  .gx-lg-2 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-lg-2,\n  .gy-lg-2 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-lg-3,\n  .gx-lg-3 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-lg-3,\n  .gy-lg-3 {\n    --bs-gutter-y: 3rem;\n  }\n  .g-lg-4,\n  .gx-lg-4 {\n    --bs-gutter-x: 3.5rem;\n  }\n  .g-lg-4,\n  .gy-lg-4 {\n    --bs-gutter-y: 3.5rem;\n  }\n  .g-lg-5,\n  .gx-lg-5 {\n    --bs-gutter-x: 4rem;\n  }\n  .g-lg-5,\n  .gy-lg-5 {\n    --bs-gutter-y: 4rem;\n  }\n}\n@media (min-width: 1200px) {\n  .col-xl {\n    flex: 1 0 0%;\n  }\n  .row-cols-xl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-xl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-xl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-xl-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-xl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-xl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-xl-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-xl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-xl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-xl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-xl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-xl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-xl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-xl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-xl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-xl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-xl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-xl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-xl-0 {\n    margin-left: 0;\n  }\n  .offset-xl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xl-3 {\n    margin-left: 25%;\n  }\n  .offset-xl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xl-6 {\n    margin-left: 50%;\n  }\n  .offset-xl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xl-9 {\n    margin-left: 75%;\n  }\n  .offset-xl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xl-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-xl-0,\n  .gx-xl-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-xl-0,\n  .gy-xl-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-xl-25,\n  .gx-xl-25 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-xl-25,\n  .gy-xl-25 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-xl-50,\n  .gx-xl-50 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-xl-50,\n  .gy-xl-50 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-xl-75,\n  .gx-xl-75 {\n    --bs-gutter-x: 0.75rem;\n  }\n  .g-xl-75,\n  .gy-xl-75 {\n    --bs-gutter-y: 0.75rem;\n  }\n  .g-xl-1,\n  .gx-xl-1 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-xl-1,\n  .gy-xl-1 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-xl-2,\n  .gx-xl-2 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-xl-2,\n  .gy-xl-2 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-xl-3,\n  .gx-xl-3 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-xl-3,\n  .gy-xl-3 {\n    --bs-gutter-y: 3rem;\n  }\n  .g-xl-4,\n  .gx-xl-4 {\n    --bs-gutter-x: 3.5rem;\n  }\n  .g-xl-4,\n  .gy-xl-4 {\n    --bs-gutter-y: 3.5rem;\n  }\n  .g-xl-5,\n  .gx-xl-5 {\n    --bs-gutter-x: 4rem;\n  }\n  .g-xl-5,\n  .gy-xl-5 {\n    --bs-gutter-y: 4rem;\n  }\n}\n@media (min-width: 1400px) {\n  .col-xxl {\n    flex: 1 0 0%;\n  }\n  .row-cols-xxl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-xxl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-xxl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-xxl-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-xxl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-xxl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-xxl-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xxl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-xxl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-xxl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xxl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-xxl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-xxl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-xxl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-xxl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-xxl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-xxl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-xxl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-xxl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-xxl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-xxl-0 {\n    margin-left: 0;\n  }\n  .offset-xxl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xxl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xxl-3 {\n    margin-left: 25%;\n  }\n  .offset-xxl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xxl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xxl-6 {\n    margin-left: 50%;\n  }\n  .offset-xxl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xxl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xxl-9 {\n    margin-left: 75%;\n  }\n  .offset-xxl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xxl-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-xxl-0,\n  .gx-xxl-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-xxl-0,\n  .gy-xxl-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-xxl-25,\n  .gx-xxl-25 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-xxl-25,\n  .gy-xxl-25 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-xxl-50,\n  .gx-xxl-50 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-xxl-50,\n  .gy-xxl-50 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-xxl-75,\n  .gx-xxl-75 {\n    --bs-gutter-x: 0.75rem;\n  }\n  .g-xxl-75,\n  .gy-xxl-75 {\n    --bs-gutter-y: 0.75rem;\n  }\n  .g-xxl-1,\n  .gx-xxl-1 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-xxl-1,\n  .gy-xxl-1 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-xxl-2,\n  .gx-xxl-2 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-xxl-2,\n  .gy-xxl-2 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-xxl-3,\n  .gx-xxl-3 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-xxl-3,\n  .gy-xxl-3 {\n    --bs-gutter-y: 3rem;\n  }\n  .g-xxl-4,\n  .gx-xxl-4 {\n    --bs-gutter-x: 3.5rem;\n  }\n  .g-xxl-4,\n  .gy-xxl-4 {\n    --bs-gutter-y: 3.5rem;\n  }\n  .g-xxl-5,\n  .gx-xxl-5 {\n    --bs-gutter-x: 4rem;\n  }\n  .g-xxl-5,\n  .gy-xxl-5 {\n    --bs-gutter-y: 4rem;\n  }\n}\n.table {\n  --bs-table-color-type: initial;\n  --bs-table-bg-type: initial;\n  --bs-table-color-state: initial;\n  --bs-table-bg-state: initial;\n  --bs-table-color: var(--bs-emphasis-color);\n  --bs-table-bg: var(--bs-body-bg);\n  --bs-table-border-color: #f8f8f8;\n  --bs-table-accent-bg: transparent;\n  --bs-table-striped-color: var(--bs-emphasis-color);\n  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);\n  --bs-table-active-color: var(--bs-emphasis-color);\n  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);\n  --bs-table-hover-color: var(--bs-emphasis-color);\n  --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);\n  width: 100%;\n  margin-bottom: 1rem;\n  vertical-align: top;\n  border-color: var(--bs-table-border-color);\n}\n.table > :not(caption) > * > * {\n  padding: 0.5rem 0.5rem;\n  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));\n  background-color: var(--bs-table-bg);\n  border-bottom-width: var(--bs-border-width);\n  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));\n}\n.table > tbody {\n  vertical-align: inherit;\n}\n.table > thead {\n  vertical-align: bottom;\n}\n\n.table-group-divider {\n  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;\n}\n\n.caption-top {\n  caption-side: top;\n}\n\n.table-sm > :not(caption) > * > * {\n  padding: 0.25rem 0.25rem;\n}\n\n.table-bordered > :not(caption) > * {\n  border-width: var(--bs-border-width) 0;\n}\n.table-bordered > :not(caption) > * > * {\n  border-width: 0 var(--bs-border-width);\n}\n\n.table-borderless > :not(caption) > * > * {\n  border-bottom-width: 0;\n}\n.table-borderless > :not(:first-child) {\n  border-top-width: 0;\n}\n\n.table-striped > tbody > tr:nth-of-type(odd) > * {\n  --bs-table-color-type: var(--bs-table-striped-color);\n  --bs-table-bg-type: var(--bs-table-striped-bg);\n}\n\n.table-striped-columns > :not(caption) > tr > :nth-child(even) {\n  --bs-table-color-type: var(--bs-table-striped-color);\n  --bs-table-bg-type: var(--bs-table-striped-bg);\n}\n\n.table-active {\n  --bs-table-color-state: var(--bs-table-active-color);\n  --bs-table-bg-state: var(--bs-table-active-bg);\n}\n\n.table-hover > tbody > tr:hover > * {\n  --bs-table-color-state: var(--bs-table-hover-color);\n  --bs-table-bg-state: var(--bs-table-hover-bg);\n}\n\n.table-primary {\n  --bs-table-color: #22292f;\n  --bs-table-bg: rgb(227, 224.6, 252);\n  --bs-table-border-color: rgb(188.4, 187.88, 211);\n  --bs-table-striped-bg: rgb(217.35, 215.42, 241.75);\n  --bs-table-striped-color: #22292f;\n  --bs-table-active-bg: rgb(207.7, 206.24, 231.5);\n  --bs-table-active-color: #22292f;\n  --bs-table-hover-bg: rgb(212.525, 210.83, 236.625);\n  --bs-table-hover-color: #22292f;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-secondary {\n  --bs-table-color: #22292f;\n  --bs-table-bg: rgb(240.8, 242.8, 244.8);\n  --bs-table-border-color: rgb(199.44, 202.44, 205.24);\n  --bs-table-striped-bg: rgb(230.46, 232.71, 234.91);\n  --bs-table-striped-color: #22292f;\n  --bs-table-active-bg: rgb(220.12, 222.62, 225.02);\n  --bs-table-active-color: #22292f;\n  --bs-table-hover-bg: rgb(225.29, 227.665, 229.965);\n  --bs-table-hover-color: #22292f;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-success {\n  --bs-table-color: #22292f;\n  --bs-table-bg: rgb(212, 243.8, 226.2);\n  --bs-table-border-color: rgb(176.4, 203.24, 190.36);\n  --bs-table-striped-bg: rgb(203.1, 233.66, 217.24);\n  --bs-table-striped-color: #22292f;\n  --bs-table-active-bg: rgb(194.2, 223.52, 208.28);\n  --bs-table-active-color: #22292f;\n  --bs-table-hover-bg: rgb(198.65, 228.59, 212.76);\n  --bs-table-hover-color: #22292f;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-info {\n  --bs-table-color: #22292f;\n  --bs-table-bg: rgb(204, 245.4, 250.4);\n  --bs-table-border-color: rgb(170, 204.52, 209.72);\n  --bs-table-striped-bg: rgb(195.5, 235.18, 240.23);\n  --bs-table-striped-color: #22292f;\n  --bs-table-active-bg: rgb(187, 224.96, 230.06);\n  --bs-table-active-color: #22292f;\n  --bs-table-hover-bg: rgb(191.25, 230.07, 235.145);\n  --bs-table-hover-color: #22292f;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-warning {\n  --bs-table-color: #22292f;\n  --bs-table-bg: rgb(255, 235.8, 217.4);\n  --bs-table-border-color: rgb(210.8, 196.84, 183.32);\n  --bs-table-striped-bg: rgb(243.95, 226.06, 208.88);\n  --bs-table-striped-color: #22292f;\n  --bs-table-active-bg: rgb(232.9, 216.32, 200.36);\n  --bs-table-active-color: #22292f;\n  --bs-table-hover-bg: rgb(238.425, 221.19, 204.62);\n  --bs-table-hover-color: #22292f;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-danger {\n  --bs-table-color: #22292f;\n  --bs-table-bg: rgb(250.8, 220.8, 221);\n  --bs-table-border-color: rgb(207.44, 184.84, 186.2);\n  --bs-table-striped-bg: rgb(239.96, 211.81, 212.3);\n  --bs-table-striped-color: #22292f;\n  --bs-table-active-bg: rgb(229.12, 202.82, 203.6);\n  --bs-table-active-color: #22292f;\n  --bs-table-hover-bg: rgb(234.54, 207.315, 207.95);\n  --bs-table-hover-color: #22292f;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-light {\n  --bs-table-color: #22292f;\n  --bs-table-bg: #babfc7;\n  --bs-table-border-color: rgb(155.6, 161, 168.6);\n  --bs-table-striped-bg: rgb(178.4, 183.5, 191.4);\n  --bs-table-striped-color: #22292f;\n  --bs-table-active-bg: rgb(170.8, 176, 183.8);\n  --bs-table-active-color: #22292f;\n  --bs-table-hover-bg: rgb(174.6, 179.75, 187.6);\n  --bs-table-hover-color: #22292f;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-dark {\n  --bs-table-color: #fff;\n  --bs-table-bg: #2a2e30;\n  --bs-table-border-color: rgb(84.6, 87.8, 89.4);\n  --bs-table-striped-bg: rgb(52.65, 56.45, 58.35);\n  --bs-table-striped-color: #fff;\n  --bs-table-active-bg: rgb(63.3, 66.9, 68.7);\n  --bs-table-active-color: #fff;\n  --bs-table-hover-bg: rgb(57.975, 61.675, 63.525);\n  --bs-table-hover-color: #fff;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-responsive {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n@media (max-width: 575.98px) {\n  .table-responsive-sm {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 767.98px) {\n  .table-responsive-md {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 991.98px) {\n  .table-responsive-lg {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1199.98px) {\n  .table-responsive-xl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1399.98px) {\n  .table-responsive-xxl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n.form-label {\n  margin-bottom: 0.5rem;\n}\n\n.col-form-label {\n  padding-top: calc(0.7rem + 1px);\n  padding-bottom: calc(0.7rem + 1px);\n  margin-bottom: 0;\n  font-size: inherit;\n  line-height: 1.25;\n}\n\n.col-form-label-lg {\n  padding-top: calc(1rem + 1px);\n  padding-bottom: calc(1rem + 1px);\n  font-size: 1.25rem;\n}\n\n.col-form-label-sm {\n  padding-top: calc(0.5rem + 1px);\n  padding-bottom: calc(0.5rem + 1px);\n  font-size: 0.7rem;\n}\n\n.form-text {\n  margin-top: 0.25rem;\n  font-size: smaller;\n  color: var(--bs-secondary-color);\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.7rem 0.7rem;\n  font-size: 0.96rem;\n  font-weight: 400;\n  line-height: 1.25;\n  color: #4e5154;\n  appearance: none;\n  background-color: var(--bs-body-bg);\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 5px;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control {\n    transition: none;\n  }\n}\n.form-control[type=file] {\n  overflow: hidden;\n}\n.form-control[type=file]:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control:focus {\n  color: #4e5154;\n  background-color: var(--bs-body-bg);\n  border-color: #7367f0;\n  outline: 0;\n  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);\n}\n.form-control::-webkit-date-and-time-value {\n  min-width: 85px;\n  height: 1.25em;\n  margin: 0;\n}\n.form-control::-webkit-datetime-edit {\n  display: block;\n  padding: 0;\n}\n.form-control::placeholder {\n  color: rgba(0, 0, 0, 0.5);\n  opacity: 1;\n}\n.form-control:disabled {\n  background-color: #f5f5f1;\n  opacity: 1;\n}\n.form-control::file-selector-button {\n  padding: 0.7rem 0.7rem;\n  margin: -0.7rem -0.7rem;\n  margin-inline-end: 0.7rem;\n  color: #4e5154;\n  background-color: var(--bs-tertiary-bg);\n  pointer-events: none;\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n  border-inline-end-width: 1px;\n  border-radius: 0;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control::file-selector-button {\n    transition: none;\n  }\n}\n.form-control:hover:not(:disabled):not([readonly])::file-selector-button {\n  background-color: var(--bs-secondary-bg);\n}\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: 0.7rem 0;\n  margin-bottom: 0;\n  line-height: 1.25;\n  color: #adb5bd;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: 1px 0;\n}\n.form-control-plaintext:focus {\n  outline: 0;\n}\n.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.form-control-sm {\n  min-height: calc(1.25em + 1rem + calc(1px * 2));\n  padding: 0.5rem 1.5rem;\n  font-size: 0.7rem;\n  border-radius: 4px;\n}\n.form-control-sm::file-selector-button {\n  padding: 0.5rem 1.5rem;\n  margin: -0.5rem -1.5rem;\n  margin-inline-end: 1.5rem;\n}\n\n.form-control-lg {\n  min-height: calc(1.25em + 2rem + calc(1px * 2));\n  padding: 1rem 2.5rem;\n  font-size: 1.25rem;\n  border-radius: 6px;\n}\n.form-control-lg::file-selector-button {\n  padding: 1rem 2.5rem;\n  margin: -1rem -2.5rem;\n  margin-inline-end: 2.5rem;\n}\n\ntextarea.form-control {\n  min-height: calc(1.25em + 1.4rem + 1px);\n}\ntextarea.form-control-sm {\n  min-height: calc(1.25em + 1rem + calc(1px * 2));\n}\ntextarea.form-control-lg {\n  min-height: calc(1.25em + 2rem + calc(1px * 2));\n}\n\n.form-control-color {\n  width: 3rem;\n  height: calc(1.25em + 1.4rem + 1px);\n  padding: 0.7rem;\n}\n.form-control-color:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control-color::-moz-color-swatch {\n  border: 0 !important;\n  border-radius: 5px;\n}\n.form-control-color::-webkit-color-swatch {\n  border: 0 !important;\n  border-radius: 5px;\n}\n.form-control-color.form-control-sm {\n  height: calc(1.25em + 1rem + calc(1px * 2));\n}\n.form-control-color.form-control-lg {\n  height: calc(1.25em + 2rem + calc(1px * 2));\n}\n\n.form-select {\n  --bs-form-select-bg-img: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%231e1e1e' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n  display: block;\n  width: 100%;\n  padding: 0.7rem 2.1rem 0.7rem 0.7rem;\n  font-size: 0.96rem;\n  font-weight: 400;\n  line-height: 1.25;\n  color: #4e5154;\n  appearance: none;\n  background-color: var(--bs-body-bg);\n  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: right 0.7rem center;\n  background-size: 16px 12px;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 5px;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-select {\n    transition: none;\n  }\n}\n.form-select:focus {\n  border-color: #7367f0;\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(115, 103, 240, 0.25);\n}\n.form-select[multiple], .form-select[size]:not([size=\"1\"]) {\n  padding-right: 0.7rem;\n  background-image: none;\n}\n.form-select:disabled {\n  background-color: #f5f5f1;\n}\n.form-select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #4e5154;\n}\n\n.form-select-sm {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  padding-left: 1.5rem;\n  font-size: 0.7rem;\n  border-radius: 4px;\n}\n\n.form-select-lg {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n  padding-left: 2.5rem;\n  font-size: 1.25rem;\n  border-radius: 6px;\n}\n\n[data-bs-theme=dark] .form-select {\n  --bs-form-select-bg-img: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23dae1e7' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n}\n\n.form-check {\n  display: block;\n  min-height: 1.45rem;\n  padding-left: 1.5em;\n  margin-bottom: 0.125rem;\n}\n.form-check .form-check-input {\n  float: left;\n  margin-left: -1.5em;\n}\n\n.form-check-reverse {\n  padding-right: 1.5em;\n  padding-left: 0;\n  text-align: right;\n}\n.form-check-reverse .form-check-input {\n  float: right;\n  margin-right: -1.5em;\n  margin-left: 0;\n}\n\n.form-check-input {\n  --bs-form-check-bg: var(--bs-body-bg);\n  flex-shrink: 0;\n  width: 1em;\n  height: 1em;\n  margin-top: 0.225em;\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--bs-form-check-bg);\n  background-image: var(--bs-form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  print-color-adjust: exact;\n}\n.form-check-input[type=checkbox] {\n  border-radius: 0.25em;\n}\n.form-check-input[type=radio] {\n  border-radius: 50%;\n}\n.form-check-input:active {\n  filter: brightness(90%);\n}\n.form-check-input:focus {\n  border-color: #7367f0;\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(115, 103, 240, 0.25);\n}\n.form-check-input:checked {\n  background-color: #7367f0;\n  border-color: #7367f0;\n}\n.form-check-input:checked[type=checkbox] {\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e\");\n}\n.form-check-input:checked[type=radio] {\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23fff'/%3e%3c/svg%3e\");\n}\n.form-check-input[type=checkbox]:indeterminate {\n  background-color: #7367f0;\n  border-color: #7367f0;\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e\");\n}\n.form-check-input:disabled {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.5;\n}\n.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {\n  cursor: default;\n  opacity: 0.5;\n}\n\n.form-switch {\n  padding-left: 2.5em;\n}\n.form-switch .form-check-input {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%2834, 41, 47, 0.25%29'/%3e%3c/svg%3e\");\n  width: 2em;\n  margin-left: -2.5em;\n  background-image: var(--bs-form-switch-bg);\n  background-position: left center;\n  border-radius: 2em;\n  transition: background-position 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-switch .form-check-input {\n    transition: none;\n  }\n}\n.form-switch .form-check-input:focus {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%237367f0'/%3e%3c/svg%3e\");\n}\n.form-switch .form-check-input:checked {\n  background-position: right center;\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\n}\n.form-switch.form-check-reverse {\n  padding-right: 2.5em;\n  padding-left: 0;\n}\n.form-switch.form-check-reverse .form-check-input {\n  margin-right: -2.5em;\n  margin-left: 0;\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: 1rem;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n.btn-check[disabled] + .btn, .btn-check:disabled + .btn {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.65;\n}\n\n[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%28255, 255, 255, 0.25%29'/%3e%3c/svg%3e\");\n}\n\n.form-range {\n  width: 100%;\n  height: 1.5rem;\n  padding: 0;\n  appearance: none;\n  background-color: transparent;\n}\n.form-range:focus {\n  outline: 0;\n}\n.form-range:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 1px #f8f8f8, 0 3px 10px 0 rgba(0, 0, 0, 0.15);\n}\n.form-range:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 1px #f8f8f8, 0 3px 10px 0 rgba(0, 0, 0, 0.15);\n}\n.form-range::-moz-focus-outer {\n  border: 0;\n}\n.form-range::-webkit-slider-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: -0.25rem;\n  appearance: none;\n  background-color: #7367f0;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-webkit-slider-thumb {\n    transition: none;\n  }\n}\n.form-range::-webkit-slider-thumb:active {\n  background-color: rgb(213, 209.4, 250.5);\n}\n.form-range::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: var(--bs-secondary-bg);\n  border-color: transparent;\n  border-radius: 1rem;\n}\n.form-range::-moz-range-thumb {\n  width: 1rem;\n  height: 1rem;\n  appearance: none;\n  background-color: #7367f0;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-moz-range-thumb {\n    transition: none;\n  }\n}\n.form-range::-moz-range-thumb:active {\n  background-color: rgb(213, 209.4, 250.5);\n}\n.form-range::-moz-range-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: var(--bs-secondary-bg);\n  border-color: transparent;\n  border-radius: 1rem;\n}\n.form-range:disabled {\n  pointer-events: none;\n}\n.form-range:disabled::-webkit-slider-thumb {\n  background-color: var(--bs-secondary-color);\n}\n.form-range:disabled::-moz-range-thumb {\n  background-color: var(--bs-secondary-color);\n}\n\n.form-floating {\n  position: relative;\n}\n.form-floating > .form-control,\n.form-floating > .form-control-plaintext,\n.form-floating > .form-select {\n  height: calc(3.5rem + calc(1px * 2));\n  min-height: calc(3.5rem + calc(1px * 2));\n  line-height: 1.25;\n}\n.form-floating > label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  height: 100%;\n  padding: 1rem 0.7rem;\n  overflow: hidden;\n  text-align: start;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  pointer-events: none;\n  border: 1px solid transparent;\n  transform-origin: 0 0;\n  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-floating > label {\n    transition: none;\n  }\n}\n.form-floating > .form-control,\n.form-floating > .form-control-plaintext {\n  padding: 1rem 0.7rem;\n}\n.form-floating > .form-control::placeholder,\n.form-floating > .form-control-plaintext::placeholder {\n  color: transparent;\n}\n.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),\n.form-floating > .form-control-plaintext:focus,\n.form-floating > .form-control-plaintext:not(:placeholder-shown) {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:-webkit-autofill,\n.form-floating > .form-control-plaintext:-webkit-autofill {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-select {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:focus ~ label,\n.form-floating > .form-control:not(:placeholder-shown) ~ label,\n.form-floating > .form-control-plaintext ~ label,\n.form-floating > .form-select ~ label {\n  color: rgba(var(--bs-body-color-rgb), 0.65);\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > .form-control:focus ~ label::after,\n.form-floating > .form-control:not(:placeholder-shown) ~ label::after,\n.form-floating > .form-control-plaintext ~ label::after,\n.form-floating > .form-select ~ label::after {\n  position: absolute;\n  inset: 1rem 0.35rem;\n  z-index: -1;\n  height: 1.5em;\n  content: \"\";\n  background-color: var(--bs-body-bg);\n  border-radius: 5px;\n}\n.form-floating > .form-control:-webkit-autofill ~ label {\n  color: rgba(var(--bs-body-color-rgb), 0.65);\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > .form-control-plaintext ~ label {\n  border-width: 1px 0;\n}\n.form-floating > :disabled ~ label,\n.form-floating > .form-control:disabled ~ label {\n  color: #b8c2cc;\n}\n.form-floating > :disabled ~ label::after,\n.form-floating > .form-control:disabled ~ label::after {\n  background-color: #f5f5f1;\n}\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%;\n}\n.input-group > .form-control,\n.input-group > .form-select,\n.input-group > .form-floating {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n  min-width: 0;\n}\n.input-group > .form-control:focus,\n.input-group > .form-select:focus,\n.input-group > .form-floating:focus-within {\n  z-index: 5;\n}\n.input-group .btn {\n  position: relative;\n  z-index: 2;\n}\n.input-group .btn:focus {\n  z-index: 5;\n}\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.7rem 0.7rem;\n  font-size: 0.96rem;\n  font-weight: 400;\n  line-height: 1.25;\n  color: #4e5154;\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--bs-tertiary-bg);\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 5px;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: 1rem 2.5rem;\n  font-size: 1.25rem;\n  border-radius: 6px;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: 0.5rem 1.5rem;\n  font-size: 0.7rem;\n  border-radius: 4px;\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: 2.8rem;\n}\n\n.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),\n.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,\n.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),\n.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,\n.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {\n  margin-left: calc(1px * -1);\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group > .form-floating:not(:first-child) > .form-control,\n.input-group > .form-floating:not(:first-child) > .form-select {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: smaller;\n  color: var(--bs-form-valid-color);\n}\n\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.4rem 0.775rem;\n  margin-top: 0.1rem;\n  font-size: 0.857rem;\n  color: #fff;\n  background-color: var(--bs-success);\n  border-radius: 0.428rem;\n}\n\n.was-validated :valid ~ .valid-feedback,\n.was-validated :valid ~ .valid-tooltip,\n.is-valid ~ .valid-feedback,\n.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:valid, .form-control.is-valid {\n  border-color: var(--bs-form-valid-border-color);\n  padding-right: calc(1.25em + 1.4rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2328c76f' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.3125em + 0.35rem) center;\n  background-size: calc(0.625em + 0.7rem) calc(0.625em + 0.7rem);\n}\n.was-validated .form-control:valid:focus, .form-control.is-valid:focus {\n  border-color: var(--bs-form-valid-border-color);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n\n.was-validated textarea.form-control:valid, textarea.form-control.is-valid {\n  padding-right: calc(1.25em + 1.4rem);\n  background-position: top calc(0.3125em + 0.35rem) right calc(0.3125em + 0.35rem);\n}\n\n.was-validated .form-select:valid, .form-select.is-valid {\n  border-color: var(--bs-form-valid-border-color);\n}\n.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size=\"1\"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size=\"1\"] {\n  --bs-form-select-bg-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2328c76f' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  padding-right: 3.85rem;\n  background-position: right 0.7rem center, center right 2.1rem;\n  background-size: 16px 12px, calc(0.625em + 0.7rem) calc(0.625em + 0.7rem);\n}\n.was-validated .form-select:valid:focus, .form-select.is-valid:focus {\n  border-color: var(--bs-form-valid-border-color);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n\n.was-validated .form-control-color:valid, .form-control-color.is-valid {\n  width: calc(3rem + calc(1.25em + 1.4rem));\n}\n\n.was-validated .form-check-input:valid, .form-check-input.is-valid {\n  border-color: var(--bs-form-valid-border-color);\n}\n.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {\n  background-color: var(--bs-form-valid-color);\n}\n.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {\n  color: var(--bs-form-valid-color);\n}\n\n.form-check-inline .form-check-input ~ .valid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,\n.was-validated .input-group > .form-select:not(:focus):valid,\n.input-group > .form-select:not(:focus).is-valid,\n.was-validated .input-group > .form-floating:not(:focus-within):valid,\n.input-group > .form-floating:not(:focus-within).is-valid {\n  z-index: 3;\n}\n\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: smaller;\n  color: var(--bs-form-invalid-color);\n}\n\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.4rem 0.775rem;\n  margin-top: 0.1rem;\n  font-size: 0.857rem;\n  color: #fff;\n  background-color: var(--bs-danger);\n  border-radius: 0.428rem;\n}\n\n.was-validated :invalid ~ .invalid-feedback,\n.was-validated :invalid ~ .invalid-tooltip,\n.is-invalid ~ .invalid-feedback,\n.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:invalid, .form-control.is-invalid {\n  border-color: var(--bs-form-invalid-border-color);\n  padding-right: calc(1.25em + 1.4rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23ea5455'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23ea5455' stroke='none'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.3125em + 0.35rem) center;\n  background-size: calc(0.625em + 0.7rem) calc(0.625em + 0.7rem);\n}\n.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {\n  border-color: var(--bs-form-invalid-border-color);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n\n.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {\n  padding-right: calc(1.25em + 1.4rem);\n  background-position: top calc(0.3125em + 0.35rem) right calc(0.3125em + 0.35rem);\n}\n\n.was-validated .form-select:invalid, .form-select.is-invalid {\n  border-color: var(--bs-form-invalid-border-color);\n}\n.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size=\"1\"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size=\"1\"] {\n  --bs-form-select-bg-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23ea5455'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23ea5455' stroke='none'/%3e%3c/svg%3e\");\n  padding-right: 3.85rem;\n  background-position: right 0.7rem center, center right 2.1rem;\n  background-size: 16px 12px, calc(0.625em + 0.7rem) calc(0.625em + 0.7rem);\n}\n.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {\n  border-color: var(--bs-form-invalid-border-color);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n\n.was-validated .form-control-color:invalid, .form-control-color.is-invalid {\n  width: calc(3rem + calc(1.25em + 1.4rem));\n}\n\n.was-validated .form-check-input:invalid, .form-check-input.is-invalid {\n  border-color: var(--bs-form-invalid-border-color);\n}\n.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {\n  background-color: var(--bs-form-invalid-color);\n}\n.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {\n  color: var(--bs-form-invalid-color);\n}\n\n.form-check-inline .form-check-input ~ .invalid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,\n.was-validated .input-group > .form-select:not(:focus):invalid,\n.input-group > .form-select:not(:focus).is-invalid,\n.was-validated .input-group > .form-floating:not(:focus-within):invalid,\n.input-group > .form-floating:not(:focus-within).is-invalid {\n  z-index: 4;\n}\n\n.btn {\n  --bs-btn-padding-x: 2rem;\n  --bs-btn-padding-y: 0.9rem;\n  --bs-btn-font-family: ;\n  --bs-btn-font-size: 1rem;\n  --bs-btn-font-weight: 400;\n  --bs-btn-line-height: 1;\n  --bs-btn-color: var(--bs-body-color);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-width: 0;\n  --bs-btn-border-color: transparent;\n  --bs-btn-border-radius: 0.4285rem;\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(34, 41, 47, 0.075);\n  --bs-btn-disabled-opacity: 0.65;\n  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);\n  display: inline-block;\n  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);\n  font-family: var(--bs-btn-font-family);\n  font-size: var(--bs-btn-font-size);\n  font-weight: var(--bs-btn-font-weight);\n  line-height: var(--bs-btn-line-height);\n  color: var(--bs-btn-color);\n  text-align: center;\n  text-decoration: none;\n  vertical-align: middle;\n  cursor: pointer;\n  user-select: none;\n  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);\n  border-radius: var(--bs-btn-border-radius);\n  background-color: var(--bs-btn-bg);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .btn {\n    transition: none;\n  }\n}\n.btn:hover {\n  color: var(--bs-btn-hover-color);\n  background-color: var(--bs-btn-hover-bg);\n  border-color: var(--bs-btn-hover-border-color);\n}\n.btn-check + .btn:hover {\n  color: var(--bs-btn-color);\n  background-color: var(--bs-btn-bg);\n  border-color: var(--bs-btn-border-color);\n}\n.btn:focus-visible {\n  color: var(--bs-btn-hover-color);\n  background-color: var(--bs-btn-hover-bg);\n  border-color: var(--bs-btn-hover-border-color);\n  outline: 0;\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn-check:focus-visible + .btn {\n  border-color: var(--bs-btn-hover-border-color);\n  outline: 0;\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {\n  color: var(--bs-btn-active-color);\n  background-color: var(--bs-btn-active-bg);\n  border-color: var(--bs-btn-active-border-color);\n}\n.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn-check:checked:focus-visible + .btn {\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn:disabled, .btn.disabled, fieldset:disabled .btn {\n  color: var(--bs-btn-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-btn-disabled-bg);\n  border-color: var(--bs-btn-disabled-border-color);\n  opacity: var(--bs-btn-disabled-opacity);\n}\n\n.btn-primary {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #7367f0;\n  --bs-btn-border-color: #7367f0;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgb(97.75, 87.55, 204);\n  --bs-btn-hover-border-color: rgb(92, 82.4, 192);\n  --bs-btn-focus-shadow-rgb: 136, 126, 242;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(92, 82.4, 192);\n  --bs-btn-active-border-color: rgb(86.25, 77.25, 180);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #7367f0;\n  --bs-btn-disabled-border-color: #7367f0;\n}\n\n.btn-secondary {\n  --bs-btn-color: #22292f;\n  --bs-btn-bg: #b8c2cc;\n  --bs-btn-border-color: #b8c2cc;\n  --bs-btn-hover-color: #22292f;\n  --bs-btn-hover-bg: rgb(194.65, 203.15, 211.65);\n  --bs-btn-hover-border-color: rgb(191.1, 200.1, 209.1);\n  --bs-btn-focus-shadow-rgb: 162, 171, 180;\n  --bs-btn-active-color: #22292f;\n  --bs-btn-active-bg: rgb(198.2, 206.2, 214.2);\n  --bs-btn-active-border-color: rgb(191.1, 200.1, 209.1);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #22292f;\n  --bs-btn-disabled-bg: #b8c2cc;\n  --bs-btn-disabled-border-color: #b8c2cc;\n}\n\n.btn-success {\n  --bs-btn-color: #22292f;\n  --bs-btn-bg: #28c76f;\n  --bs-btn-border-color: #28c76f;\n  --bs-btn-hover-color: #22292f;\n  --bs-btn-hover-bg: rgb(72.25, 207.4, 132.6);\n  --bs-btn-hover-border-color: rgb(61.5, 204.6, 125.4);\n  --bs-btn-focus-shadow-rgb: 39, 175, 101;\n  --bs-btn-active-color: #22292f;\n  --bs-btn-active-bg: rgb(83, 210.2, 139.8);\n  --bs-btn-active-border-color: rgb(61.5, 204.6, 125.4);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #22292f;\n  --bs-btn-disabled-bg: #28c76f;\n  --bs-btn-disabled-border-color: #28c76f;\n}\n\n.btn-info {\n  --bs-btn-color: #22292f;\n  --bs-btn-bg: #00cfe8;\n  --bs-btn-border-color: #00cfe8;\n  --bs-btn-hover-color: #22292f;\n  --bs-btn-hover-bg: rgb(38.25, 214.2, 235.45);\n  --bs-btn-hover-border-color: rgb(25.5, 211.8, 234.3);\n  --bs-btn-focus-shadow-rgb: 5, 182, 204;\n  --bs-btn-active-color: #22292f;\n  --bs-btn-active-bg: rgb(51, 216.6, 236.6);\n  --bs-btn-active-border-color: rgb(25.5, 211.8, 234.3);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #22292f;\n  --bs-btn-disabled-bg: #00cfe8;\n  --bs-btn-disabled-border-color: #00cfe8;\n}\n\n.btn-warning {\n  --bs-btn-color: #22292f;\n  --bs-btn-bg: #ff9f43;\n  --bs-btn-border-color: #ff9f43;\n  --bs-btn-hover-color: #22292f;\n  --bs-btn-hover-bg: rgb(255, 173.4, 95.2);\n  --bs-btn-hover-border-color: rgb(255, 168.6, 85.8);\n  --bs-btn-focus-shadow-rgb: 222, 141, 64;\n  --bs-btn-active-color: #22292f;\n  --bs-btn-active-bg: rgb(255, 178.2, 104.6);\n  --bs-btn-active-border-color: rgb(255, 168.6, 85.8);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #22292f;\n  --bs-btn-disabled-bg: #ff9f43;\n  --bs-btn-disabled-border-color: #ff9f43;\n}\n\n.btn-danger {\n  --bs-btn-color: #22292f;\n  --bs-btn-bg: #ea5455;\n  --bs-btn-border-color: #ea5455;\n  --bs-btn-hover-color: #22292f;\n  --bs-btn-hover-bg: rgb(237.15, 109.65, 110.5);\n  --bs-btn-hover-border-color: rgb(236.1, 101.1, 102);\n  --bs-btn-focus-shadow-rgb: 204, 78, 79;\n  --bs-btn-active-color: #22292f;\n  --bs-btn-active-bg: rgb(238.2, 118.2, 119);\n  --bs-btn-active-border-color: rgb(236.1, 101.1, 102);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #22292f;\n  --bs-btn-disabled-bg: #ea5455;\n  --bs-btn-disabled-border-color: #ea5455;\n}\n\n.btn-light {\n  --bs-btn-color: #22292f;\n  --bs-btn-bg: #babfc7;\n  --bs-btn-border-color: #babfc7;\n  --bs-btn-hover-color: #22292f;\n  --bs-btn-hover-bg: rgb(158.1, 162.35, 169.15);\n  --bs-btn-hover-border-color: rgb(148.8, 152.8, 159.2);\n  --bs-btn-focus-shadow-rgb: 163, 169, 176;\n  --bs-btn-active-color: #22292f;\n  --bs-btn-active-bg: rgb(148.8, 152.8, 159.2);\n  --bs-btn-active-border-color: rgb(139.5, 143.25, 149.25);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #22292f;\n  --bs-btn-disabled-bg: #babfc7;\n  --bs-btn-disabled-border-color: #babfc7;\n}\n\n.btn-dark {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #2a2e30;\n  --bs-btn-border-color: #2a2e30;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgb(73.95, 77.35, 79.05);\n  --bs-btn-hover-border-color: rgb(63.3, 66.9, 68.7);\n  --bs-btn-focus-shadow-rgb: 74, 77, 79;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(84.6, 87.8, 89.4);\n  --bs-btn-active-border-color: rgb(63.3, 66.9, 68.7);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #2a2e30;\n  --bs-btn-disabled-border-color: #2a2e30;\n}\n\n.btn-outline-primary {\n  --bs-btn-color: #7367f0;\n  --bs-btn-border-color: #7367f0;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #7367f0;\n  --bs-btn-hover-border-color: #7367f0;\n  --bs-btn-focus-shadow-rgb: 115, 103, 240;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #7367f0;\n  --bs-btn-active-border-color: #7367f0;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #7367f0;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #7367f0;\n  --bs-gradient: none;\n}\n\n.btn-outline-secondary {\n  --bs-btn-color: #b8c2cc;\n  --bs-btn-border-color: #b8c2cc;\n  --bs-btn-hover-color: #22292f;\n  --bs-btn-hover-bg: #b8c2cc;\n  --bs-btn-hover-border-color: #b8c2cc;\n  --bs-btn-focus-shadow-rgb: 184, 194, 204;\n  --bs-btn-active-color: #22292f;\n  --bs-btn-active-bg: #b8c2cc;\n  --bs-btn-active-border-color: #b8c2cc;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #b8c2cc;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #b8c2cc;\n  --bs-gradient: none;\n}\n\n.btn-outline-success {\n  --bs-btn-color: #28c76f;\n  --bs-btn-border-color: #28c76f;\n  --bs-btn-hover-color: #22292f;\n  --bs-btn-hover-bg: #28c76f;\n  --bs-btn-hover-border-color: #28c76f;\n  --bs-btn-focus-shadow-rgb: 40, 199, 111;\n  --bs-btn-active-color: #22292f;\n  --bs-btn-active-bg: #28c76f;\n  --bs-btn-active-border-color: #28c76f;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #28c76f;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #28c76f;\n  --bs-gradient: none;\n}\n\n.btn-outline-info {\n  --bs-btn-color: #00cfe8;\n  --bs-btn-border-color: #00cfe8;\n  --bs-btn-hover-color: #22292f;\n  --bs-btn-hover-bg: #00cfe8;\n  --bs-btn-hover-border-color: #00cfe8;\n  --bs-btn-focus-shadow-rgb: 0, 207, 232;\n  --bs-btn-active-color: #22292f;\n  --bs-btn-active-bg: #00cfe8;\n  --bs-btn-active-border-color: #00cfe8;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #00cfe8;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #00cfe8;\n  --bs-gradient: none;\n}\n\n.btn-outline-warning {\n  --bs-btn-color: #ff9f43;\n  --bs-btn-border-color: #ff9f43;\n  --bs-btn-hover-color: #22292f;\n  --bs-btn-hover-bg: #ff9f43;\n  --bs-btn-hover-border-color: #ff9f43;\n  --bs-btn-focus-shadow-rgb: 255, 159, 67;\n  --bs-btn-active-color: #22292f;\n  --bs-btn-active-bg: #ff9f43;\n  --bs-btn-active-border-color: #ff9f43;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #ff9f43;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #ff9f43;\n  --bs-gradient: none;\n}\n\n.btn-outline-danger {\n  --bs-btn-color: #ea5455;\n  --bs-btn-border-color: #ea5455;\n  --bs-btn-hover-color: #22292f;\n  --bs-btn-hover-bg: #ea5455;\n  --bs-btn-hover-border-color: #ea5455;\n  --bs-btn-focus-shadow-rgb: 234, 84, 85;\n  --bs-btn-active-color: #22292f;\n  --bs-btn-active-bg: #ea5455;\n  --bs-btn-active-border-color: #ea5455;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #ea5455;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #ea5455;\n  --bs-gradient: none;\n}\n\n.btn-outline-light {\n  --bs-btn-color: #babfc7;\n  --bs-btn-border-color: #babfc7;\n  --bs-btn-hover-color: #22292f;\n  --bs-btn-hover-bg: #babfc7;\n  --bs-btn-hover-border-color: #babfc7;\n  --bs-btn-focus-shadow-rgb: 186, 191, 199;\n  --bs-btn-active-color: #22292f;\n  --bs-btn-active-bg: #babfc7;\n  --bs-btn-active-border-color: #babfc7;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #babfc7;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #babfc7;\n  --bs-gradient: none;\n}\n\n.btn-outline-dark {\n  --bs-btn-color: #2a2e30;\n  --bs-btn-border-color: #2a2e30;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #2a2e30;\n  --bs-btn-hover-border-color: #2a2e30;\n  --bs-btn-focus-shadow-rgb: 42, 46, 48;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #2a2e30;\n  --bs-btn-active-border-color: #2a2e30;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #2a2e30;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #2a2e30;\n  --bs-gradient: none;\n}\n\n.btn-link {\n  --bs-btn-font-weight: 400;\n  --bs-btn-color: var(--bs-link-color);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-color: transparent;\n  --bs-btn-hover-color: var(--bs-link-hover-color);\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-active-color: var(--bs-link-hover-color);\n  --bs-btn-active-border-color: transparent;\n  --bs-btn-disabled-color: #b8c2cc;\n  --bs-btn-disabled-border-color: transparent;\n  --bs-btn-box-shadow: 0 0 0 #000;\n  --bs-btn-focus-shadow-rgb: 136, 126, 242;\n  text-decoration: underline;\n}\n.btn-link:hover, .btn-link:focus-visible {\n  text-decoration: none;\n}\n.btn-link:focus-visible {\n  color: var(--bs-btn-color);\n}\n.btn-link:hover {\n  color: var(--bs-btn-hover-color);\n}\n\n.btn-lg, .btn-group-lg > .btn {\n  --bs-btn-padding-y: 1rem;\n  --bs-btn-padding-x: 2.5rem;\n  --bs-btn-font-size: 1.25rem;\n  --bs-btn-border-radius: var(--bs-border-radius-lg);\n}\n\n.btn-sm, .btn-group-sm > .btn {\n  --bs-btn-padding-y: 0.5rem;\n  --bs-btn-padding-x: 1.5rem;\n  --bs-btn-font-size: 0.7rem;\n  --bs-btn-border-radius: var(--bs-border-radius-sm);\n}\n\n.fade {\n  transition: opacity 0.15s linear;\n}\n@media (prefers-reduced-motion: reduce) {\n  .fade {\n    transition: none;\n  }\n}\n.fade:not(.show) {\n  opacity: 0;\n}\n\n.collapse:not(.show) {\n  display: none;\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing {\n    transition: none;\n  }\n}\n.collapsing.collapse-horizontal {\n  width: 0;\n  height: auto;\n  transition: width 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing.collapse-horizontal {\n    transition: none;\n  }\n}\n\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n}\n.dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n}\n.dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropdown-menu {\n  --bs-dropdown-zindex: 1000;\n  --bs-dropdown-min-width: 10rem;\n  --bs-dropdown-padding-x: 0;\n  --bs-dropdown-padding-y: 0.5rem;\n  --bs-dropdown-spacer: 0.5rem;\n  --bs-dropdown-font-size: 0.9375rem;\n  --bs-dropdown-color: var(--bs-body-color);\n  --bs-dropdown-bg: var(--bs-body-bg);\n  --bs-dropdown-border-color: var(--bs-border-color-translucent);\n  --bs-dropdown-border-radius: 5px;\n  --bs-dropdown-border-width: var(--bs-border-width);\n  --bs-dropdown-inner-border-radius: calc(5px - var(--bs-border-width));\n  --bs-dropdown-divider-bg: rgba(0, 0, 0, 0.08);\n  --bs-dropdown-divider-margin-y: 0.5rem;\n  --bs-dropdown-box-shadow: var(--bs-box-shadow);\n  --bs-dropdown-link-color: var(--bs-body-color);\n  --bs-dropdown-link-hover-color: var(--bs-body-color);\n  --bs-dropdown-link-hover-bg: #f8f8f8;\n  --bs-dropdown-link-active-color: #fff;\n  --bs-dropdown-link-active-bg: #7367f0;\n  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);\n  --bs-dropdown-item-padding-x: 1rem;\n  --bs-dropdown-item-padding-y: 0.25rem;\n  --bs-dropdown-header-color: #b8c2cc;\n  --bs-dropdown-header-padding-x: 1rem;\n  --bs-dropdown-header-padding-y: 0.5rem;\n  position: absolute;\n  z-index: var(--bs-dropdown-zindex);\n  display: none;\n  min-width: var(--bs-dropdown-min-width);\n  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);\n  margin: 0;\n  font-size: var(--bs-dropdown-font-size);\n  color: var(--bs-dropdown-color);\n  text-align: left;\n  list-style: none;\n  background-color: var(--bs-dropdown-bg);\n  background-clip: padding-box;\n  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);\n  border-radius: var(--bs-dropdown-border-radius);\n}\n.dropdown-menu[data-bs-popper] {\n  top: 100%;\n  left: 0;\n  margin-top: var(--bs-dropdown-spacer);\n}\n\n.dropdown-menu-start {\n  --bs-position: start;\n}\n.dropdown-menu-start[data-bs-popper] {\n  right: auto;\n  left: 0;\n}\n\n.dropdown-menu-end {\n  --bs-position: end;\n}\n.dropdown-menu-end[data-bs-popper] {\n  right: 0;\n  left: auto;\n}\n\n@media (min-width: 576px) {\n  .dropdown-menu-sm-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-sm-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-sm-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-sm-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 768px) {\n  .dropdown-menu-md-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-md-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-md-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-md-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 992px) {\n  .dropdown-menu-lg-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-lg-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-lg-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-lg-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1200px) {\n  .dropdown-menu-xl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1400px) {\n  .dropdown-menu-xxl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xxl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xxl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xxl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n.dropup .dropdown-menu[data-bs-popper] {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: var(--bs-dropdown-spacer);\n}\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0.3em solid;\n  border-left: 0.3em solid transparent;\n}\n.dropup .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropend .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: auto;\n  left: 100%;\n  margin-top: 0;\n  margin-left: var(--bs-dropdown-spacer);\n}\n.dropend .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0;\n  border-bottom: 0.3em solid transparent;\n  border-left: 0.3em solid;\n}\n.dropend .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropend .dropdown-toggle::after {\n  vertical-align: 0;\n}\n\n.dropstart .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: var(--bs-dropdown-spacer);\n}\n.dropstart .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n}\n.dropstart .dropdown-toggle::after {\n  display: none;\n}\n.dropstart .dropdown-toggle::before {\n  display: inline-block;\n  margin-right: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0.3em solid;\n  border-bottom: 0.3em solid transparent;\n}\n.dropstart .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropstart .dropdown-toggle::before {\n  vertical-align: 0;\n}\n\n.dropdown-divider {\n  height: 0;\n  margin: var(--bs-dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--bs-dropdown-divider-bg);\n  opacity: 1;\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n  clear: both;\n  font-weight: 400;\n  color: var(--bs-dropdown-link-color);\n  text-align: inherit;\n  text-decoration: none;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n  border-radius: var(--bs-dropdown-item-border-radius, 0);\n}\n.dropdown-item:hover, .dropdown-item:focus {\n  color: var(--bs-dropdown-link-hover-color);\n  background-color: var(--bs-dropdown-link-hover-bg);\n}\n.dropdown-item.active, .dropdown-item:active {\n  color: var(--bs-dropdown-link-active-color);\n  text-decoration: none;\n  background-color: var(--bs-dropdown-link-active-bg);\n}\n.dropdown-item.disabled, .dropdown-item:disabled {\n  color: var(--bs-dropdown-link-disabled-color);\n  pointer-events: none;\n  background-color: transparent;\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n.dropdown-header {\n  display: block;\n  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);\n  margin-bottom: 0;\n  font-size: 1rem;\n  color: var(--bs-dropdown-header-color);\n  white-space: nowrap;\n}\n\n.dropdown-item-text {\n  display: block;\n  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n  color: var(--bs-dropdown-link-color);\n}\n\n.dropdown-menu-dark {\n  --bs-dropdown-color: #dae1e7;\n  --bs-dropdown-bg: #1e1e1e;\n  --bs-dropdown-border-color: var(--bs-border-color-translucent);\n  --bs-dropdown-box-shadow: ;\n  --bs-dropdown-link-color: #dae1e7;\n  --bs-dropdown-link-hover-color: #fff;\n  --bs-dropdown-divider-bg: rgba(0, 0, 0, 0.08);\n  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);\n  --bs-dropdown-link-active-color: #fff;\n  --bs-dropdown-link-active-bg: #7367f0;\n  --bs-dropdown-link-disabled-color: #adb5bd;\n  --bs-dropdown-header-color: #adb5bd;\n}\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle;\n}\n.btn-group > .btn,\n.btn-group-vertical > .btn {\n  position: relative;\n  flex: 1 1 auto;\n}\n.btn-group > .btn-check:checked + .btn,\n.btn-group > .btn-check:focus + .btn,\n.btn-group > .btn:hover,\n.btn-group > .btn:focus,\n.btn-group > .btn:active,\n.btn-group > .btn.active,\n.btn-group-vertical > .btn-check:checked + .btn,\n.btn-group-vertical > .btn-check:focus + .btn,\n.btn-group-vertical > .btn:hover,\n.btn-group-vertical > .btn:focus,\n.btn-group-vertical > .btn:active,\n.btn-group-vertical > .btn.active {\n  z-index: 1;\n}\n\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n.btn-toolbar .input-group {\n  width: auto;\n}\n\n.btn-group {\n  border-radius: 0.4285rem;\n}\n.btn-group > :not(.btn-check:first-child) + .btn,\n.btn-group > .btn-group:not(:first-child) {\n  margin-left: calc(0 * -1);\n}\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group > .btn.dropdown-toggle-split:first-child,\n.btn-group > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.btn-group > .btn:nth-child(n+3),\n.btn-group > :not(.btn-check) + .btn,\n.btn-group > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.dropdown-toggle-split {\n  padding-right: 1.5rem;\n  padding-left: 1.5rem;\n}\n.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {\n  margin-left: 0;\n}\n.dropstart .dropdown-toggle-split::before {\n  margin-right: 0;\n}\n\n.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {\n  padding-right: 1.125rem;\n  padding-left: 1.125rem;\n}\n\n.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {\n  padding-right: 1.875rem;\n  padding-left: 1.875rem;\n}\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n.btn-group-vertical > .btn,\n.btn-group-vertical > .btn-group {\n  width: 100%;\n}\n.btn-group-vertical > .btn:not(:first-child),\n.btn-group-vertical > .btn-group:not(:first-child) {\n  margin-top: calc(0 * -1);\n}\n.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-vertical > .btn-group:not(:last-child) > .btn {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn ~ .btn,\n.btn-group-vertical > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav {\n  --bs-nav-link-padding-x: 0.5rem;\n  --bs-nav-link-padding-y: 0.357rem;\n  --bs-nav-link-font-weight: ;\n  --bs-nav-link-color: var(--bs-link-color);\n  --bs-nav-link-hover-color: var(--bs-link-hover-color);\n  --bs-nav-link-disabled-color: var(--bs-secondary-color);\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);\n  font-size: var(--bs-nav-link-font-size);\n  font-weight: var(--bs-nav-link-font-weight);\n  color: var(--bs-nav-link-color);\n  text-decoration: none;\n  background: none;\n  border: 0;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .nav-link {\n    transition: none;\n  }\n}\n.nav-link:hover, .nav-link:focus {\n  color: var(--bs-nav-link-hover-color);\n}\n.nav-link:focus-visible {\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(115, 103, 240, 0.25);\n}\n.nav-link.disabled, .nav-link:disabled {\n  color: var(--bs-nav-link-disabled-color);\n  pointer-events: none;\n  cursor: default;\n}\n\n.nav-tabs {\n  --bs-nav-tabs-border-width: var(--bs-border-width);\n  --bs-nav-tabs-border-color: var(--bs-border-color);\n  --bs-nav-tabs-border-radius: var(--bs-border-radius);\n  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);\n  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);\n  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);\n  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);\n  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);\n}\n.nav-tabs .nav-link {\n  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));\n  border: var(--bs-nav-tabs-border-width) solid transparent;\n  border-top-left-radius: var(--bs-nav-tabs-border-radius);\n  border-top-right-radius: var(--bs-nav-tabs-border-radius);\n}\n.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {\n  isolation: isolate;\n  border-color: var(--bs-nav-tabs-link-hover-border-color);\n}\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  color: var(--bs-nav-tabs-link-active-color);\n  background-color: var(--bs-nav-tabs-link-active-bg);\n  border-color: var(--bs-nav-tabs-link-active-border-color);\n}\n.nav-tabs .dropdown-menu {\n  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav-pills {\n  --bs-nav-pills-border-radius: var(--bs-border-radius);\n  --bs-nav-pills-link-active-color: #fff;\n  --bs-nav-pills-link-active-bg: #7367f0;\n}\n.nav-pills .nav-link {\n  border-radius: var(--bs-nav-pills-border-radius);\n}\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: var(--bs-nav-pills-link-active-color);\n  background-color: var(--bs-nav-pills-link-active-bg);\n}\n\n.nav-underline {\n  --bs-nav-underline-gap: 1rem;\n  --bs-nav-underline-border-width: 0.125rem;\n  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);\n  gap: var(--bs-nav-underline-gap);\n}\n.nav-underline .nav-link {\n  padding-right: 0;\n  padding-left: 0;\n  border-bottom: var(--bs-nav-underline-border-width) solid transparent;\n}\n.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {\n  border-bottom-color: currentcolor;\n}\n.nav-underline .nav-link.active,\n.nav-underline .show > .nav-link {\n  font-weight: 700;\n  color: var(--bs-nav-underline-link-active-color);\n  border-bottom-color: currentcolor;\n}\n\n.nav-fill > .nav-link,\n.nav-fill .nav-item {\n  flex: 1 1 auto;\n  text-align: center;\n}\n\n.nav-justified > .nav-link,\n.nav-justified .nav-item {\n  flex-basis: 0;\n  flex-grow: 1;\n  text-align: center;\n}\n\n.nav-fill .nav-item .nav-link,\n.nav-justified .nav-item .nav-link {\n  width: 100%;\n}\n\n.tab-content > .tab-pane {\n  display: none;\n}\n.tab-content > .active {\n  display: block;\n}\n\n.navbar {\n  --bs-navbar-padding-x: 0;\n  --bs-navbar-padding-y: 0.5rem;\n  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);\n  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);\n  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);\n  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);\n  --bs-navbar-brand-padding-y: -0.368rem;\n  --bs-navbar-brand-margin-end: 1rem;\n  --bs-navbar-brand-font-size: 2rem;\n  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);\n  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);\n  --bs-navbar-nav-link-padding-x: 0.5rem;\n  --bs-navbar-toggler-padding-y: 0.25rem;\n  --bs-navbar-toggler-padding-x: 0.75rem;\n  --bs-navbar-toggler-font-size: 2rem;\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%2898, 98, 98, 0.75%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);\n  --bs-navbar-toggler-border-radius: 0.4285rem;\n  --bs-navbar-toggler-focus-width: 0.25rem;\n  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);\n}\n.navbar > .container,\n.navbar > .container-fluid,\n.navbar > .container-sm,\n.navbar > .container-md,\n.navbar > .container-lg,\n.navbar > .container-xl,\n.navbar > .container-xxl {\n  display: flex;\n  flex-wrap: inherit;\n  align-items: center;\n  justify-content: space-between;\n}\n.navbar-brand {\n  padding-top: var(--bs-navbar-brand-padding-y);\n  padding-bottom: var(--bs-navbar-brand-padding-y);\n  margin-right: var(--bs-navbar-brand-margin-end);\n  font-size: var(--bs-navbar-brand-font-size);\n  color: var(--bs-navbar-brand-color);\n  text-decoration: none;\n  white-space: nowrap;\n}\n.navbar-brand:hover, .navbar-brand:focus {\n  color: var(--bs-navbar-brand-hover-color);\n}\n\n.navbar-nav {\n  --bs-nav-link-padding-x: 0;\n  --bs-nav-link-padding-y: 0.357rem;\n  --bs-nav-link-font-weight: ;\n  --bs-nav-link-color: var(--bs-navbar-color);\n  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);\n  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {\n  color: var(--bs-navbar-active-color);\n}\n.navbar-nav .dropdown-menu {\n  position: static;\n}\n\n.navbar-text {\n  padding-top: 0.357rem;\n  padding-bottom: 0.357rem;\n  color: var(--bs-navbar-color);\n}\n.navbar-text a,\n.navbar-text a:hover,\n.navbar-text a:focus {\n  color: var(--bs-navbar-active-color);\n}\n\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  align-items: center;\n}\n\n.navbar-toggler {\n  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);\n  font-size: var(--bs-navbar-toggler-font-size);\n  line-height: 1;\n  color: var(--bs-navbar-color);\n  background-color: transparent;\n  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);\n  border-radius: var(--bs-navbar-toggler-border-radius);\n  transition: var(--bs-navbar-toggler-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .navbar-toggler {\n    transition: none;\n  }\n}\n.navbar-toggler:hover {\n  text-decoration: none;\n}\n.navbar-toggler:focus {\n  text-decoration: none;\n  outline: 0;\n  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);\n}\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--bs-navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--bs-scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-sm .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-sm .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-sm .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-sm .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-sm .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-sm .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-sm .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-sm .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-md .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-md .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-md .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-md .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-md .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-md .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-md .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-md .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-md .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-lg .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-lg .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-lg .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-lg .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-lg .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-lg .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-lg .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-lg .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xl .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-xl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xl .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-xl .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-xl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1400px) {\n  .navbar-expand-xxl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xxl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xxl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xxl .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-xxl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xxl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xxl .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xxl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-xxl .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-xxl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n.navbar-expand {\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n}\n.navbar-expand .navbar-nav {\n  flex-direction: row;\n}\n.navbar-expand .navbar-nav .dropdown-menu {\n  position: absolute;\n}\n.navbar-expand .navbar-nav .nav-link {\n  padding-right: var(--bs-navbar-nav-link-padding-x);\n  padding-left: var(--bs-navbar-nav-link-padding-x);\n}\n.navbar-expand .navbar-nav-scroll {\n  overflow: visible;\n}\n.navbar-expand .navbar-collapse {\n  display: flex !important;\n  flex-basis: auto;\n}\n.navbar-expand .navbar-toggler {\n  display: none;\n}\n.navbar-expand .offcanvas {\n  position: static;\n  z-index: auto;\n  flex-grow: 1;\n  width: auto !important;\n  height: auto !important;\n  visibility: visible !important;\n  background-color: transparent !important;\n  border: 0 !important;\n  transform: none !important;\n  transition: none;\n}\n.navbar-expand .offcanvas .offcanvas-header {\n  display: none;\n}\n.navbar-expand .offcanvas .offcanvas-body {\n  display: flex;\n  flex-grow: 0;\n  padding: 0;\n  overflow-y: visible;\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=dark] {\n  --bs-navbar-color: rgba(255, 255, 255, 0.55);\n  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);\n  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);\n  --bs-navbar-active-color: #fff;\n  --bs-navbar-brand-color: #fff;\n  --bs-navbar-brand-hover-color: #fff;\n  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n[data-bs-theme=dark] .navbar-toggler-icon {\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n.card {\n  --bs-card-spacer-y: 1.5rem;\n  --bs-card-spacer-x: 1.5rem;\n  --bs-card-title-spacer-y: 0.5rem;\n  --bs-card-title-color: ;\n  --bs-card-subtitle-color: ;\n  --bs-card-border-width: var(--bs-border-width);\n  --bs-card-border-color: var(--bs-border-color-translucent);\n  --bs-card-border-radius: var(--bs-border-radius);\n  --bs-card-box-shadow: ;\n  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));\n  --bs-card-cap-padding-y: 0.75rem;\n  --bs-card-cap-padding-x: 1.5rem;\n  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);\n  --bs-card-cap-color: ;\n  --bs-card-height: ;\n  --bs-card-color: ;\n  --bs-card-bg: var(--bs-body-bg);\n  --bs-card-img-overlay-padding: 1rem;\n  --bs-card-group-margin: 14px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  height: var(--bs-card-height);\n  color: var(--bs-body-color);\n  word-wrap: break-word;\n  background-color: var(--bs-card-bg);\n  background-clip: border-box;\n  border: var(--bs-card-border-width) solid var(--bs-card-border-color);\n  border-radius: var(--bs-card-border-radius);\n}\n.card > hr {\n  margin-right: 0;\n  margin-left: 0;\n}\n.card > .list-group {\n  border-top: inherit;\n  border-bottom: inherit;\n}\n.card > .list-group:first-child {\n  border-top-width: 0;\n  border-top-left-radius: var(--bs-card-inner-border-radius);\n  border-top-right-radius: var(--bs-card-inner-border-radius);\n}\n.card > .list-group:last-child {\n  border-bottom-width: 0;\n  border-bottom-right-radius: var(--bs-card-inner-border-radius);\n  border-bottom-left-radius: var(--bs-card-inner-border-radius);\n}\n.card > .card-header + .list-group,\n.card > .list-group + .card-footer {\n  border-top: 0;\n}\n\n.card-body {\n  flex: 1 1 auto;\n  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);\n  color: var(--bs-card-color);\n}\n\n.card-title {\n  margin-bottom: var(--bs-card-title-spacer-y);\n  color: var(--bs-card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));\n  margin-bottom: 0;\n  color: var(--bs-card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link + .card-link {\n  margin-left: var(--bs-card-spacer-x);\n}\n\n.card-header {\n  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n  margin-bottom: 0;\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);\n}\n.card-header:first-child {\n  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;\n}\n\n.card-footer {\n  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);\n}\n.card-footer:last-child {\n  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);\n}\n\n.card-header-tabs {\n  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));\n  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));\n  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));\n  border-bottom: 0;\n}\n.card-header-tabs .nav-link.active {\n  background-color: var(--bs-card-bg);\n  border-bottom-color: var(--bs-card-bg);\n}\n\n.card-header-pills {\n  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));\n  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));\n}\n\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--bs-card-img-overlay-padding);\n  border-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%;\n}\n\n.card-img,\n.card-img-top {\n  border-top-left-radius: var(--bs-card-inner-border-radius);\n  border-top-right-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  border-bottom-right-radius: var(--bs-card-inner-border-radius);\n  border-bottom-left-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-group > .card {\n  margin-bottom: var(--bs-card-group-margin);\n}\n@media (min-width: 576px) {\n  .card-group {\n    display: flex;\n    flex-flow: row wrap;\n  }\n  .card-group > .card {\n    flex: 1 0 0%;\n    margin-bottom: 0;\n  }\n  .card-group > .card + .card {\n    margin-left: 0;\n    border-left: 0;\n  }\n  .card-group > .card:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-top,\n  .card-group > .card:not(:last-child) .card-header {\n    border-top-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-bottom,\n  .card-group > .card:not(:last-child) .card-footer {\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-top,\n  .card-group > .card:not(:first-child) .card-header {\n    border-top-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-bottom,\n  .card-group > .card:not(:first-child) .card-footer {\n    border-bottom-left-radius: 0;\n  }\n}\n\n.accordion {\n  --bs-accordion-color: var(--bs-body-color);\n  --bs-accordion-bg: var(--bs-body-bg);\n  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;\n  --bs-accordion-border-color: var(--bs-border-color);\n  --bs-accordion-border-width: var(--bs-border-width);\n  --bs-accordion-border-radius: var(--bs-border-radius);\n  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));\n  --bs-accordion-btn-padding-x: 1.25rem;\n  --bs-accordion-btn-padding-y: 1rem;\n  --bs-accordion-btn-color: var(--bs-body-color);\n  --bs-accordion-btn-bg: var(--bs-accordion-bg);\n  --bs-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='%23626262' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M2 5L8 11L14 5'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-icon-width: 1.25rem;\n  --bs-accordion-btn-icon-transform: rotate(-180deg);\n  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;\n  --bs-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='rgb%2846, 41.2, 96%29' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M2 5L8 11L14 5'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(115, 103, 240, 0.25);\n  --bs-accordion-body-padding-x: 1.25rem;\n  --bs-accordion-body-padding-y: 1rem;\n  --bs-accordion-active-color: var(--bs-primary-text-emphasis);\n  --bs-accordion-active-bg: var(--bs-primary-bg-subtle);\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);\n  font-size: 1rem;\n  color: var(--bs-accordion-btn-color);\n  text-align: left;\n  background-color: var(--bs-accordion-btn-bg);\n  border: 0;\n  border-radius: 0;\n  overflow-anchor: none;\n  transition: var(--bs-accordion-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button {\n    transition: none;\n  }\n}\n.accordion-button:not(.collapsed) {\n  color: var(--bs-accordion-active-color);\n  background-color: var(--bs-accordion-active-bg);\n  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);\n}\n.accordion-button:not(.collapsed)::after {\n  background-image: var(--bs-accordion-btn-active-icon);\n  transform: var(--bs-accordion-btn-icon-transform);\n}\n.accordion-button::after {\n  flex-shrink: 0;\n  width: var(--bs-accordion-btn-icon-width);\n  height: var(--bs-accordion-btn-icon-width);\n  margin-left: auto;\n  content: \"\";\n  background-image: var(--bs-accordion-btn-icon);\n  background-repeat: no-repeat;\n  background-size: var(--bs-accordion-btn-icon-width);\n  transition: var(--bs-accordion-btn-icon-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button::after {\n    transition: none;\n  }\n}\n.accordion-button:hover {\n  z-index: 2;\n}\n.accordion-button:focus {\n  z-index: 3;\n  outline: 0;\n  box-shadow: var(--bs-accordion-btn-focus-box-shadow);\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--bs-accordion-color);\n  background-color: var(--bs-accordion-bg);\n  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);\n}\n.accordion-item:first-of-type {\n  border-top-left-radius: var(--bs-accordion-border-radius);\n  border-top-right-radius: var(--bs-accordion-border-radius);\n}\n.accordion-item:first-of-type > .accordion-header .accordion-button {\n  border-top-left-radius: var(--bs-accordion-inner-border-radius);\n  border-top-right-radius: var(--bs-accordion-inner-border-radius);\n}\n.accordion-item:not(:first-of-type) {\n  border-top: 0;\n}\n.accordion-item:last-of-type {\n  border-bottom-right-radius: var(--bs-accordion-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-border-radius);\n}\n.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {\n  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);\n}\n.accordion-item:last-of-type > .accordion-collapse {\n  border-bottom-right-radius: var(--bs-accordion-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-border-radius);\n}\n\n.accordion-body {\n  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);\n}\n\n.accordion-flush > .accordion-item {\n  border-right: 0;\n  border-left: 0;\n  border-radius: 0;\n}\n.accordion-flush > .accordion-item:first-child {\n  border-top: 0;\n}\n.accordion-flush > .accordion-item:last-child {\n  border-bottom: 0;\n}\n.accordion-flush > .accordion-item > .accordion-header .accordion-button, .accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {\n  border-radius: 0;\n}\n.accordion-flush > .accordion-item > .accordion-collapse {\n  border-radius: 0;\n}\n\n[data-bs-theme=dark] .accordion-button::after {\n  --bs-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='rgb%28171, 163.8, 246%29'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='rgb%28171, 163.8, 246%29'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n\n.breadcrumb {\n  --bs-breadcrumb-padding-x: 0;\n  --bs-breadcrumb-padding-y: 0;\n  --bs-breadcrumb-margin-bottom: 1rem;\n  --bs-breadcrumb-bg: ;\n  --bs-breadcrumb-border-radius: ;\n  --bs-breadcrumb-divider-color: var(--bs-secondary-color);\n  --bs-breadcrumb-item-padding-x: 0.5rem;\n  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);\n  margin-bottom: var(--bs-breadcrumb-margin-bottom);\n  font-size: var(--bs-breadcrumb-font-size);\n  list-style: none;\n  background-color: var(--bs-breadcrumb-bg);\n  border-radius: var(--bs-breadcrumb-border-radius);\n}\n\n.breadcrumb-item + .breadcrumb-item {\n  padding-left: var(--bs-breadcrumb-item-padding-x);\n}\n.breadcrumb-item + .breadcrumb-item::before {\n  float: left;\n  padding-right: var(--bs-breadcrumb-item-padding-x);\n  color: var(--bs-breadcrumb-divider-color);\n  content: var(--bs-breadcrumb-divider, \">>\") /* rtl: var(--bs-breadcrumb-divider, \">>\") */;\n}\n.breadcrumb-item.active {\n  color: var(--bs-breadcrumb-item-active-color);\n}\n\n.pagination {\n  --bs-pagination-padding-x: 0.911rem;\n  --bs-pagination-padding-y: 0.65rem;\n  --bs-pagination-font-size: 1rem;\n  --bs-pagination-color: var(--bs-link-color);\n  --bs-pagination-bg: var(--bs-body-bg);\n  --bs-pagination-border-width: var(--bs-border-width);\n  --bs-pagination-border-color: var(--bs-border-color);\n  --bs-pagination-border-radius: var(--bs-border-radius);\n  --bs-pagination-hover-color: var(--bs-link-hover-color);\n  --bs-pagination-hover-bg: var(--bs-tertiary-bg);\n  --bs-pagination-hover-border-color: var(--bs-border-color);\n  --bs-pagination-focus-color: var(--bs-link-hover-color);\n  --bs-pagination-focus-bg: var(--bs-secondary-bg);\n  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(115, 103, 240, 0.25);\n  --bs-pagination-active-color: #fff;\n  --bs-pagination-active-bg: #7367f0;\n  --bs-pagination-active-border-color: #7367f0;\n  --bs-pagination-disabled-color: var(--bs-secondary-color);\n  --bs-pagination-disabled-bg: var(--bs-secondary-bg);\n  --bs-pagination-disabled-border-color: var(--bs-border-color);\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);\n  font-size: var(--bs-pagination-font-size);\n  color: var(--bs-pagination-color);\n  text-decoration: none;\n  background-color: var(--bs-pagination-bg);\n  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .page-link {\n    transition: none;\n  }\n}\n.page-link:hover {\n  z-index: 2;\n  color: var(--bs-pagination-hover-color);\n  background-color: var(--bs-pagination-hover-bg);\n  border-color: var(--bs-pagination-hover-border-color);\n}\n.page-link:focus {\n  z-index: 3;\n  color: var(--bs-pagination-focus-color);\n  background-color: var(--bs-pagination-focus-bg);\n  outline: 0;\n  box-shadow: var(--bs-pagination-focus-box-shadow);\n}\n.page-link.active, .active > .page-link {\n  z-index: 3;\n  color: var(--bs-pagination-active-color);\n  background-color: var(--bs-pagination-active-bg);\n  border-color: var(--bs-pagination-active-border-color);\n}\n.page-link.disabled, .disabled > .page-link {\n  color: var(--bs-pagination-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-pagination-disabled-bg);\n  border-color: var(--bs-pagination-disabled-border-color);\n}\n\n.page-item:not(:first-child) .page-link {\n  margin-left: calc(var(--bs-border-width) * -1);\n}\n.page-item:first-child .page-link {\n  border-top-left-radius: var(--bs-pagination-border-radius);\n  border-bottom-left-radius: var(--bs-pagination-border-radius);\n}\n.page-item:last-child .page-link {\n  border-top-right-radius: var(--bs-pagination-border-radius);\n  border-bottom-right-radius: var(--bs-pagination-border-radius);\n}\n\n.pagination-lg {\n  --bs-pagination-padding-x: 1rem;\n  --bs-pagination-padding-y: 0.5rem;\n  --bs-pagination-font-size: calc(1.325rem + 0.9vw);\n  --bs-pagination-border-radius: var(--bs-border-radius-lg);\n}\n@media (min-width: 1200px) {\n  .pagination-lg {\n    --bs-pagination-font-size: 2rem;\n  }\n}\n\n.pagination-sm {\n  --bs-pagination-padding-x: 0.75rem;\n  --bs-pagination-padding-y: 0.5rem;\n  --bs-pagination-font-size: 1rem;\n  --bs-pagination-border-radius: var(--bs-border-radius-sm);\n}\n\n.badge {\n  --bs-badge-padding-x: 0.4em;\n  --bs-badge-padding-y: 0.4em;\n  --bs-badge-font-size: 80%;\n  --bs-badge-font-weight: 700;\n  --bs-badge-color: #fff;\n  --bs-badge-border-radius: 0.25rem;\n  display: inline-block;\n  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);\n  font-size: var(--bs-badge-font-size);\n  font-weight: var(--bs-badge-font-weight);\n  line-height: 1;\n  color: var(--bs-badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: var(--bs-badge-border-radius);\n}\n.badge:empty {\n  display: none;\n}\n\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n.alert {\n  --bs-alert-bg: transparent;\n  --bs-alert-padding-x: 0.71rem;\n  --bs-alert-padding-y: 0.71rem;\n  --bs-alert-margin-bottom: 1rem;\n  --bs-alert-color: inherit;\n  --bs-alert-border-color: transparent;\n  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);\n  --bs-alert-border-radius: var(--bs-border-radius);\n  --bs-alert-link-color: inherit;\n  position: relative;\n  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);\n  margin-bottom: var(--bs-alert-margin-bottom);\n  color: var(--bs-alert-color);\n  background-color: var(--bs-alert-bg);\n  border: var(--bs-alert-border);\n  border-radius: var(--bs-alert-border-radius);\n}\n\n.alert-heading {\n  color: inherit;\n}\n\n.alert-link {\n  font-weight: 700;\n  color: var(--bs-alert-link-color);\n}\n\n.alert-dismissible {\n  padding-right: 2.13rem;\n}\n.alert-dismissible .btn-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  padding: 0.8875rem 0.71rem;\n}\n\n.alert-primary {\n  --bs-alert-color: var(--bs-primary-text-emphasis);\n  --bs-alert-bg: var(--bs-primary-bg-subtle);\n  --bs-alert-border-color: var(--bs-primary-border-subtle);\n  --bs-alert-link-color: var(--bs-primary-text-emphasis);\n}\n\n.alert-secondary {\n  --bs-alert-color: var(--bs-secondary-text-emphasis);\n  --bs-alert-bg: var(--bs-secondary-bg-subtle);\n  --bs-alert-border-color: var(--bs-secondary-border-subtle);\n  --bs-alert-link-color: var(--bs-secondary-text-emphasis);\n}\n\n.alert-success {\n  --bs-alert-color: var(--bs-success-text-emphasis);\n  --bs-alert-bg: var(--bs-success-bg-subtle);\n  --bs-alert-border-color: var(--bs-success-border-subtle);\n  --bs-alert-link-color: var(--bs-success-text-emphasis);\n}\n\n.alert-info {\n  --bs-alert-color: var(--bs-info-text-emphasis);\n  --bs-alert-bg: var(--bs-info-bg-subtle);\n  --bs-alert-border-color: var(--bs-info-border-subtle);\n  --bs-alert-link-color: var(--bs-info-text-emphasis);\n}\n\n.alert-warning {\n  --bs-alert-color: var(--bs-warning-text-emphasis);\n  --bs-alert-bg: var(--bs-warning-bg-subtle);\n  --bs-alert-border-color: var(--bs-warning-border-subtle);\n  --bs-alert-link-color: var(--bs-warning-text-emphasis);\n}\n\n.alert-danger {\n  --bs-alert-color: var(--bs-danger-text-emphasis);\n  --bs-alert-bg: var(--bs-danger-bg-subtle);\n  --bs-alert-border-color: var(--bs-danger-border-subtle);\n  --bs-alert-link-color: var(--bs-danger-text-emphasis);\n}\n\n.alert-light {\n  --bs-alert-color: var(--bs-light-text-emphasis);\n  --bs-alert-bg: var(--bs-light-bg-subtle);\n  --bs-alert-border-color: var(--bs-light-border-subtle);\n  --bs-alert-link-color: var(--bs-light-text-emphasis);\n}\n\n.alert-dark {\n  --bs-alert-color: var(--bs-dark-text-emphasis);\n  --bs-alert-bg: var(--bs-dark-bg-subtle);\n  --bs-alert-border-color: var(--bs-dark-border-subtle);\n  --bs-alert-link-color: var(--bs-dark-text-emphasis);\n}\n\n@keyframes progress-bar-stripes {\n  0% {\n    background-position-x: 0.357rem;\n  }\n}\n.progress,\n.progress-stacked {\n  --bs-progress-height: 0.357rem;\n  --bs-progress-font-size: 0.75rem;\n  --bs-progress-bg: var(--bs-secondary-bg);\n  --bs-progress-border-radius: 1.28rem;\n  --bs-progress-box-shadow: var(--bs-box-shadow-inset);\n  --bs-progress-bar-color: #fff;\n  --bs-progress-bar-bg: #7367f0;\n  --bs-progress-bar-transition: width 0.6s ease;\n  display: flex;\n  height: var(--bs-progress-height);\n  overflow: hidden;\n  font-size: var(--bs-progress-font-size);\n  background-color: var(--bs-progress-bg);\n  border-radius: var(--bs-progress-border-radius);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--bs-progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--bs-progress-bar-bg);\n  transition: var(--bs-progress-bar-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar {\n    transition: none;\n  }\n}\n\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: var(--bs-progress-height) var(--bs-progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n.progress-bar-animated {\n  animation: 1s linear infinite progress-bar-stripes;\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar-animated {\n    animation: none;\n  }\n}\n\n.list-group {\n  --bs-list-group-color: var(--bs-body-color);\n  --bs-list-group-bg: var(--bs-body-bg);\n  --bs-list-group-border-color: var(--bs-border-color);\n  --bs-list-group-border-width: var(--bs-border-width);\n  --bs-list-group-border-radius: var(--bs-border-radius);\n  --bs-list-group-item-padding-x: 1rem;\n  --bs-list-group-item-padding-y: 0.5rem;\n  --bs-list-group-action-color: var(--bs-secondary-color);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);\n  --bs-list-group-action-active-color: var(--bs-body-color);\n  --bs-list-group-action-active-bg: var(--bs-secondary-bg);\n  --bs-list-group-disabled-color: var(--bs-secondary-color);\n  --bs-list-group-disabled-bg: var(--bs-body-bg);\n  --bs-list-group-active-color: #fff;\n  --bs-list-group-active-bg: #7367f0;\n  --bs-list-group-active-border-color: #7367f0;\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  border-radius: var(--bs-list-group-border-radius);\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n}\n.list-group-numbered > .list-group-item::before {\n  content: counters(section, \".\") \". \";\n  counter-increment: section;\n}\n\n.list-group-item-action {\n  width: 100%;\n  color: var(--bs-list-group-action-color);\n  text-align: inherit;\n}\n.list-group-item-action:hover, .list-group-item-action:focus {\n  z-index: 1;\n  color: var(--bs-list-group-action-hover-color);\n  text-decoration: none;\n  background-color: var(--bs-list-group-action-hover-bg);\n}\n.list-group-item-action:active {\n  color: var(--bs-list-group-action-active-color);\n  background-color: var(--bs-list-group-action-active-bg);\n}\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);\n  color: var(--bs-list-group-color);\n  text-decoration: none;\n  background-color: var(--bs-list-group-bg);\n  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);\n}\n.list-group-item:first-child {\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n}\n.list-group-item:last-child {\n  border-bottom-right-radius: inherit;\n  border-bottom-left-radius: inherit;\n}\n.list-group-item.disabled, .list-group-item:disabled {\n  color: var(--bs-list-group-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-list-group-disabled-bg);\n}\n.list-group-item.active {\n  z-index: 2;\n  color: var(--bs-list-group-active-color);\n  background-color: var(--bs-list-group-active-bg);\n  border-color: var(--bs-list-group-active-border-color);\n}\n.list-group-item + .list-group-item {\n  border-top-width: 0;\n}\n.list-group-item + .list-group-item.active {\n  margin-top: calc(-1 * var(--bs-list-group-border-width));\n  border-top-width: var(--bs-list-group-border-width);\n}\n\n.list-group-horizontal {\n  flex-direction: row;\n}\n.list-group-horizontal > .list-group-item:first-child:not(:last-child) {\n  border-bottom-left-radius: var(--bs-list-group-border-radius);\n  border-top-right-radius: 0;\n}\n.list-group-horizontal > .list-group-item:last-child:not(:first-child) {\n  border-top-right-radius: var(--bs-list-group-border-radius);\n  border-bottom-left-radius: 0;\n}\n.list-group-horizontal > .list-group-item.active {\n  margin-top: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item {\n  border-top-width: var(--bs-list-group-border-width);\n  border-left-width: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item.active {\n  margin-left: calc(-1 * var(--bs-list-group-border-width));\n  border-left-width: var(--bs-list-group-border-width);\n}\n\n@media (min-width: 576px) {\n  .list-group-horizontal-sm {\n    flex-direction: row;\n  }\n  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 768px) {\n  .list-group-horizontal-md {\n    flex-direction: row;\n  }\n  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 992px) {\n  .list-group-horizontal-lg {\n    flex-direction: row;\n  }\n  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 1200px) {\n  .list-group-horizontal-xl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 1400px) {\n  .list-group-horizontal-xxl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n.list-group-flush {\n  border-radius: 0;\n}\n.list-group-flush > .list-group-item {\n  border-width: 0 0 var(--bs-list-group-border-width);\n}\n.list-group-flush > .list-group-item:last-child {\n  border-bottom-width: 0;\n}\n\n.list-group-item-primary {\n  --bs-list-group-color: var(--bs-primary-text-emphasis);\n  --bs-list-group-bg: var(--bs-primary-bg-subtle);\n  --bs-list-group-border-color: var(--bs-primary-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);\n  --bs-list-group-active-color: var(--bs-primary-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);\n}\n\n.list-group-item-secondary {\n  --bs-list-group-color: var(--bs-secondary-text-emphasis);\n  --bs-list-group-bg: var(--bs-secondary-bg-subtle);\n  --bs-list-group-border-color: var(--bs-secondary-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);\n  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);\n}\n\n.list-group-item-success {\n  --bs-list-group-color: var(--bs-success-text-emphasis);\n  --bs-list-group-bg: var(--bs-success-bg-subtle);\n  --bs-list-group-border-color: var(--bs-success-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);\n  --bs-list-group-active-color: var(--bs-success-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-success-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);\n}\n\n.list-group-item-info {\n  --bs-list-group-color: var(--bs-info-text-emphasis);\n  --bs-list-group-bg: var(--bs-info-bg-subtle);\n  --bs-list-group-border-color: var(--bs-info-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);\n  --bs-list-group-active-color: var(--bs-info-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-info-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);\n}\n\n.list-group-item-warning {\n  --bs-list-group-color: var(--bs-warning-text-emphasis);\n  --bs-list-group-bg: var(--bs-warning-bg-subtle);\n  --bs-list-group-border-color: var(--bs-warning-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);\n  --bs-list-group-active-color: var(--bs-warning-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);\n}\n\n.list-group-item-danger {\n  --bs-list-group-color: var(--bs-danger-text-emphasis);\n  --bs-list-group-bg: var(--bs-danger-bg-subtle);\n  --bs-list-group-border-color: var(--bs-danger-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);\n  --bs-list-group-active-color: var(--bs-danger-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);\n}\n\n.list-group-item-light {\n  --bs-list-group-color: var(--bs-light-text-emphasis);\n  --bs-list-group-bg: var(--bs-light-bg-subtle);\n  --bs-list-group-border-color: var(--bs-light-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);\n  --bs-list-group-active-color: var(--bs-light-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-light-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);\n}\n\n.list-group-item-dark {\n  --bs-list-group-color: var(--bs-dark-text-emphasis);\n  --bs-list-group-bg: var(--bs-dark-bg-subtle);\n  --bs-list-group-border-color: var(--bs-dark-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);\n  --bs-list-group-active-color: var(--bs-dark-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);\n}\n\n.btn-close {\n  --bs-btn-close-color: #22292f;\n  --bs-btn-close-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%2322292f'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e\");\n  --bs-btn-close-opacity: 0.5;\n  --bs-btn-close-hover-opacity: 0.75;\n  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(115, 103, 240, 0.25);\n  --bs-btn-close-focus-opacity: 1;\n  --bs-btn-close-disabled-opacity: 0.25;\n  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);\n  box-sizing: content-box;\n  width: 1em;\n  height: 1em;\n  padding: 0.25em 0.25em;\n  color: var(--bs-btn-close-color);\n  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;\n  border: 0;\n  border-radius: 0.5rem;\n  opacity: var(--bs-btn-close-opacity);\n}\n.btn-close:hover {\n  color: var(--bs-btn-close-color);\n  text-decoration: none;\n  opacity: var(--bs-btn-close-hover-opacity);\n}\n.btn-close:focus {\n  outline: 0;\n  box-shadow: var(--bs-btn-close-focus-shadow);\n  opacity: var(--bs-btn-close-focus-opacity);\n}\n.btn-close:disabled, .btn-close.disabled {\n  pointer-events: none;\n  user-select: none;\n  opacity: var(--bs-btn-close-disabled-opacity);\n}\n\n.btn-close-white {\n  filter: var(--bs-btn-close-white-filter);\n}\n\n[data-bs-theme=dark] .btn-close {\n  filter: var(--bs-btn-close-white-filter);\n}\n\n.toast {\n  --bs-toast-zindex: 1090;\n  --bs-toast-padding-x: 0.75rem;\n  --bs-toast-padding-y: 0.5rem;\n  --bs-toast-spacing: 28px;\n  --bs-toast-max-width: 350px;\n  --bs-toast-font-size: 0.875rem;\n  --bs-toast-color: ;\n  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);\n  --bs-toast-border-width: var(--bs-border-width);\n  --bs-toast-border-color: var(--bs-border-color-translucent);\n  --bs-toast-border-radius: var(--bs-border-radius);\n  --bs-toast-box-shadow: var(--bs-box-shadow);\n  --bs-toast-header-color: var(--bs-secondary-color);\n  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);\n  --bs-toast-header-border-color: var(--bs-border-color-translucent);\n  width: var(--bs-toast-max-width);\n  max-width: 100%;\n  font-size: var(--bs-toast-font-size);\n  color: var(--bs-toast-color);\n  pointer-events: auto;\n  background-color: var(--bs-toast-bg);\n  background-clip: padding-box;\n  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);\n  box-shadow: var(--bs-toast-box-shadow);\n  border-radius: var(--bs-toast-border-radius);\n}\n.toast.showing {\n  opacity: 0;\n}\n.toast:not(.show) {\n  display: none;\n}\n\n.toast-container {\n  --bs-toast-zindex: 1090;\n  position: absolute;\n  z-index: var(--bs-toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n}\n.toast-container > :not(:last-child) {\n  margin-bottom: var(--bs-toast-spacing);\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);\n  color: var(--bs-toast-header-color);\n  background-color: var(--bs-toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);\n  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n}\n.toast-header .btn-close {\n  margin-right: calc(-0.5 * var(--bs-toast-padding-x));\n  margin-left: var(--bs-toast-padding-x);\n}\n\n.toast-body {\n  padding: var(--bs-toast-padding-x);\n  word-wrap: break-word;\n}\n\n.modal {\n  --bs-modal-zindex: 1055;\n  --bs-modal-width: 500px;\n  --bs-modal-padding: 1rem;\n  --bs-modal-margin: 0.5rem;\n  --bs-modal-color: ;\n  --bs-modal-bg: var(--bs-body-bg);\n  --bs-modal-border-color: var(--bs-border-color-translucent);\n  --bs-modal-border-width: var(--bs-border-width);\n  --bs-modal-border-radius: var(--bs-border-radius-lg);\n  --bs-modal-box-shadow: var(--bs-box-shadow-sm);\n  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));\n  --bs-modal-header-padding-x: 1rem;\n  --bs-modal-header-padding-y: 1rem;\n  --bs-modal-header-padding: 1rem 1rem;\n  --bs-modal-header-border-color: var(--bs-border-color);\n  --bs-modal-header-border-width: var(--bs-border-width);\n  --bs-modal-title-line-height: 1.45;\n  --bs-modal-footer-gap: 0.5rem;\n  --bs-modal-footer-bg: ;\n  --bs-modal-footer-border-color: var(--bs-border-color);\n  --bs-modal-footer-border-width: var(--bs-border-width);\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--bs-modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  outline: 0;\n}\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--bs-modal-margin);\n  pointer-events: none;\n}\n.modal.fade .modal-dialog {\n  transition: transform 0.3s ease-out;\n  transform: translate(0, -50px);\n}\n@media (prefers-reduced-motion: reduce) {\n  .modal.fade .modal-dialog {\n    transition: none;\n  }\n}\n.modal.show .modal-dialog {\n  transform: none;\n}\n.modal.modal-static .modal-dialog {\n  transform: scale(1.02);\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--bs-modal-margin) * 2);\n}\n.modal-dialog-scrollable .modal-content {\n  max-height: 100%;\n  overflow: hidden;\n}\n.modal-dialog-scrollable .modal-body {\n  overflow-y: auto;\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--bs-modal-margin) * 2);\n}\n\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  color: var(--bs-modal-color);\n  pointer-events: auto;\n  background-color: var(--bs-modal-bg);\n  background-clip: padding-box;\n  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);\n  border-radius: var(--bs-modal-border-radius);\n  outline: 0;\n}\n\n.modal-backdrop {\n  --bs-backdrop-zindex: 1050;\n  --bs-backdrop-bg: #22292f;\n  --bs-backdrop-opacity: 0.5;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--bs-backdrop-zindex);\n  width: 100vw;\n  height: 100vh;\n  background-color: var(--bs-backdrop-bg);\n}\n.modal-backdrop.fade {\n  opacity: 0;\n}\n.modal-backdrop.show {\n  opacity: var(--bs-backdrop-opacity);\n}\n\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--bs-modal-header-padding);\n  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);\n  border-top-left-radius: var(--bs-modal-inner-border-radius);\n  border-top-right-radius: var(--bs-modal-inner-border-radius);\n}\n.modal-header .btn-close {\n  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);\n  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;\n}\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--bs-modal-title-line-height);\n}\n\n.modal-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: var(--bs-modal-padding);\n}\n\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);\n  background-color: var(--bs-modal-footer-bg);\n  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);\n  border-bottom-right-radius: var(--bs-modal-inner-border-radius);\n  border-bottom-left-radius: var(--bs-modal-inner-border-radius);\n}\n.modal-footer > * {\n  margin: calc(var(--bs-modal-footer-gap) * 0.5);\n}\n\n@media (min-width: 576px) {\n  .modal {\n    --bs-modal-margin: 1.75rem;\n    --bs-modal-box-shadow: var(--bs-box-shadow);\n  }\n  .modal-dialog {\n    max-width: var(--bs-modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n  .modal-sm {\n    --bs-modal-width: 300px;\n  }\n}\n@media (min-width: 992px) {\n  .modal-lg,\n  .modal-xl {\n    --bs-modal-width: 800px;\n  }\n}\n@media (min-width: 1200px) {\n  .modal-xl {\n    --bs-modal-width: 1140px;\n  }\n}\n.modal-fullscreen {\n  width: 100vw;\n  max-width: none;\n  height: 100%;\n  margin: 0;\n}\n.modal-fullscreen .modal-content {\n  height: 100%;\n  border: 0;\n  border-radius: 0;\n}\n.modal-fullscreen .modal-header,\n.modal-fullscreen .modal-footer {\n  border-radius: 0;\n}\n.modal-fullscreen .modal-body {\n  overflow-y: auto;\n}\n\n@media (max-width: 575.98px) {\n  .modal-fullscreen-sm-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-sm-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-header,\n  .modal-fullscreen-sm-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 767.98px) {\n  .modal-fullscreen-md-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-md-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-header,\n  .modal-fullscreen-md-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 991.98px) {\n  .modal-fullscreen-lg-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-lg-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-header,\n  .modal-fullscreen-lg-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 1199.98px) {\n  .modal-fullscreen-xl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-header,\n  .modal-fullscreen-xl-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 1399.98px) {\n  .modal-fullscreen-xxl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-header,\n  .modal-fullscreen-xxl-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n.tooltip {\n  --bs-tooltip-zindex: 1032;\n  --bs-tooltip-max-width: 220px;\n  --bs-tooltip-padding-x: 0.775rem;\n  --bs-tooltip-padding-y: 0.4rem;\n  --bs-tooltip-margin: ;\n  --bs-tooltip-font-size: 0.857rem;\n  --bs-tooltip-color: var(--bs-body-bg);\n  --bs-tooltip-bg: #323232;\n  --bs-tooltip-border-radius: 0.428rem;\n  --bs-tooltip-opacity: 1;\n  --bs-tooltip-arrow-width: 0.8rem;\n  --bs-tooltip-arrow-height: 0.4rem;\n  z-index: var(--bs-tooltip-zindex);\n  display: block;\n  margin: var(--bs-tooltip-margin);\n  font-family: var(--bs-font-sans-serif);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.45;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: var(--bs-tooltip-font-size);\n  word-wrap: break-word;\n  opacity: 0;\n}\n.tooltip.show {\n  opacity: var(--bs-tooltip-opacity);\n}\n.tooltip .tooltip-arrow {\n  display: block;\n  width: var(--bs-tooltip-arrow-width);\n  height: var(--bs-tooltip-arrow-height);\n}\n.tooltip .tooltip-arrow::before {\n  position: absolute;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {\n  bottom: calc(-1 * var(--bs-tooltip-arrow-height));\n}\n.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {\n  top: -1px;\n  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;\n  border-top-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {\n  left: calc(-1 * var(--bs-tooltip-arrow-height));\n  width: var(--bs-tooltip-arrow-height);\n  height: var(--bs-tooltip-arrow-width);\n}\n.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {\n  right: -1px;\n  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;\n  border-right-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:end:ignore */\n.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {\n  top: calc(-1 * var(--bs-tooltip-arrow-height));\n}\n.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {\n  bottom: -1px;\n  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);\n  border-bottom-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {\n  right: calc(-1 * var(--bs-tooltip-arrow-height));\n  width: var(--bs-tooltip-arrow-height);\n  height: var(--bs-tooltip-arrow-width);\n}\n.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {\n  left: -1px;\n  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);\n  border-left-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:end:ignore */\n.tooltip-inner {\n  max-width: var(--bs-tooltip-max-width);\n  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);\n  color: var(--bs-tooltip-color);\n  text-align: center;\n  background-color: var(--bs-tooltip-bg);\n  border-radius: var(--bs-tooltip-border-radius);\n}\n\n.popover {\n  --bs-popover-zindex: 1070;\n  --bs-popover-max-width: 276px;\n  --bs-popover-font-size: 0.857rem;\n  --bs-popover-bg: var(--bs-body-bg);\n  --bs-popover-border-width: var(--bs-border-width);\n  --bs-popover-border-color: var(--bs-border-color-translucent);\n  --bs-popover-border-radius: 0.428rem;\n  --bs-popover-inner-border-radius: calc(0.428rem - var(--bs-border-width));\n  --bs-popover-box-shadow: var(--bs-box-shadow);\n  --bs-popover-header-padding-x: 1rem;\n  --bs-popover-header-padding-y: 0.5rem;\n  --bs-popover-header-font-size: 1rem;\n  --bs-popover-header-color: #2c2c2c;\n  --bs-popover-header-bg: #7367f0;\n  --bs-popover-body-padding-x: 1rem;\n  --bs-popover-body-padding-y: 1rem;\n  --bs-popover-body-color: var(--bs-body-color);\n  --bs-popover-arrow-width: 1rem;\n  --bs-popover-arrow-height: 0.5rem;\n  --bs-popover-arrow-border: var(--bs-popover-border-color);\n  z-index: var(--bs-popover-zindex);\n  display: block;\n  max-width: var(--bs-popover-max-width);\n  font-family: var(--bs-font-sans-serif);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.45;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: var(--bs-popover-font-size);\n  word-wrap: break-word;\n  background-color: var(--bs-popover-bg);\n  background-clip: padding-box;\n  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n  border-radius: var(--bs-popover-border-radius);\n}\n.popover .popover-arrow {\n  display: block;\n  width: var(--bs-popover-arrow-width);\n  height: var(--bs-popover-arrow-height);\n}\n.popover .popover-arrow::before, .popover .popover-arrow::after {\n  position: absolute;\n  display: block;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n  border-width: 0;\n}\n\n.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {\n  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n}\n.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;\n}\n.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {\n  bottom: 0;\n  border-top-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  bottom: var(--bs-popover-border-width);\n  border-top-color: var(--bs-popover-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {\n  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n  width: var(--bs-popover-arrow-height);\n  height: var(--bs-popover-arrow-width);\n}\n.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;\n}\n.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {\n  left: 0;\n  border-right-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  left: var(--bs-popover-border-width);\n  border-right-color: var(--bs-popover-bg);\n}\n\n/* rtl:end:ignore */\n.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {\n  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n}\n.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);\n}\n.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {\n  top: 0;\n  border-bottom-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  top: var(--bs-popover-border-width);\n  border-bottom-color: var(--bs-popover-bg);\n}\n.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  display: block;\n  width: var(--bs-popover-arrow-width);\n  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));\n  content: \"\";\n  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {\n  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n  width: var(--bs-popover-arrow-height);\n  height: var(--bs-popover-arrow-width);\n}\n.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);\n}\n.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {\n  right: 0;\n  border-left-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  right: var(--bs-popover-border-width);\n  border-left-color: var(--bs-popover-bg);\n}\n\n/* rtl:end:ignore */\n.popover-header {\n  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);\n  margin-bottom: 0;\n  font-size: var(--bs-popover-header-font-size);\n  color: var(--bs-popover-header-color);\n  background-color: var(--bs-popover-header-bg);\n  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n  border-top-left-radius: var(--bs-popover-inner-border-radius);\n  border-top-right-radius: var(--bs-popover-inner-border-radius);\n}\n.popover-header:empty {\n  display: none;\n}\n\n.popover-body {\n  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);\n  color: var(--bs-popover-body-color);\n}\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n.carousel-inner::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  transition: transform 0.6s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-item {\n    transition: none;\n  }\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n.carousel-fade .carousel-item {\n  opacity: 0;\n  transition-property: opacity;\n  transform: none;\n}\n.carousel-fade .carousel-item.active,\n.carousel-fade .carousel-item-next.carousel-item-start,\n.carousel-fade .carousel-item-prev.carousel-item-end {\n  z-index: 1;\n  opacity: 1;\n}\n.carousel-fade .active.carousel-item-start,\n.carousel-fade .active.carousel-item-end {\n  z-index: 0;\n  opacity: 0;\n  transition: opacity 0s 0.6s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-fade .active.carousel-item-start,\n  .carousel-fade .active.carousel-item-end {\n    transition: none;\n  }\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 15%;\n  padding: 0;\n  color: #fff;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: 0.5;\n  transition: opacity 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-control-prev,\n  .carousel-control-next {\n    transition: none;\n  }\n}\n.carousel-control-prev:hover, .carousel-control-prev:focus,\n.carousel-control-next:hover,\n.carousel-control-next:focus {\n  color: #fff;\n  text-decoration: none;\n  outline: 0;\n  opacity: 0.9;\n}\n\n.carousel-control-prev {\n  left: 0;\n}\n\n.carousel-control-next {\n  right: 0;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\") /*rtl:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\")*/;\n}\n\n.carousel-control-next-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\") /*rtl:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\")*/;\n}\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  margin-right: 15%;\n  margin-bottom: 1rem;\n  margin-left: 15%;\n}\n.carousel-indicators [data-bs-target] {\n  box-sizing: content-box;\n  flex: 0 1 auto;\n  width: 30px;\n  height: 3px;\n  padding: 0;\n  margin-right: 3px;\n  margin-left: 3px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  opacity: 0.5;\n  transition: opacity 0.6s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-indicators [data-bs-target] {\n    transition: none;\n  }\n}\n.carousel-indicators .active {\n  opacity: 1;\n}\n\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 1.25rem;\n  left: 15%;\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n  color: #fff;\n  text-align: center;\n}\n\n.carousel-dark .carousel-control-prev-icon,\n.carousel-dark .carousel-control-next-icon {\n  filter: invert(1) grayscale(100);\n}\n.carousel-dark .carousel-indicators [data-bs-target] {\n  background-color: #22292f;\n}\n.carousel-dark .carousel-caption {\n  color: #22292f;\n}\n\n[data-bs-theme=dark] .carousel .carousel-control-prev-icon,\n[data-bs-theme=dark] .carousel .carousel-control-next-icon, [data-bs-theme=dark].carousel .carousel-control-prev-icon,\n[data-bs-theme=dark].carousel .carousel-control-next-icon {\n  filter: invert(1) grayscale(100);\n}\n[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target], [data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {\n  background-color: #22292f;\n}\n[data-bs-theme=dark] .carousel .carousel-caption, [data-bs-theme=dark].carousel .carousel-caption {\n  color: #22292f;\n}\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--bs-spinner-width);\n  height: var(--bs-spinner-height);\n  vertical-align: var(--bs-spinner-vertical-align);\n  border-radius: 50%;\n  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);\n}\n\n@keyframes spinner-border {\n  to {\n    transform: rotate(360deg) /* rtl:ignore */;\n  }\n}\n.spinner-border {\n  --bs-spinner-width: 2rem;\n  --bs-spinner-height: 2rem;\n  --bs-spinner-vertical-align: -0.125em;\n  --bs-spinner-border-width: 0.25em;\n  --bs-spinner-animation-speed: 0.75s;\n  --bs-spinner-animation-name: spinner-border;\n  border: var(--bs-spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  --bs-spinner-width: 1rem;\n  --bs-spinner-height: 1rem;\n  --bs-spinner-border-width: 0.2em;\n}\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n.spinner-grow {\n  --bs-spinner-width: 2rem;\n  --bs-spinner-height: 2rem;\n  --bs-spinner-vertical-align: -0.125em;\n  --bs-spinner-animation-speed: 0.75s;\n  --bs-spinner-animation-name: spinner-grow;\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --bs-spinner-width: 1rem;\n  --bs-spinner-height: 1rem;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .spinner-border,\n  .spinner-grow {\n    --bs-spinner-animation-speed: 1.5s;\n  }\n}\n.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {\n  --bs-offcanvas-zindex: 1045;\n  --bs-offcanvas-width: 400px;\n  --bs-offcanvas-height: 30vh;\n  --bs-offcanvas-padding-x: 1rem;\n  --bs-offcanvas-padding-y: 1rem;\n  --bs-offcanvas-color: var(--bs-body-color);\n  --bs-offcanvas-bg: var(--bs-body-bg);\n  --bs-offcanvas-border-width: var(--bs-border-width);\n  --bs-offcanvas-border-color: var(--bs-border-color-translucent);\n  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);\n  --bs-offcanvas-transition: transform 0.3s ease-in-out;\n  --bs-offcanvas-title-line-height: 1.45;\n}\n\n@media (max-width: 575.98px) {\n  .offcanvas-sm {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-sm {\n    transition: none;\n  }\n}\n@media (max-width: 575.98px) {\n  .offcanvas-sm.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-sm.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-sm.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-sm.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 576px) {\n  .offcanvas-sm {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-sm .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-sm .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .offcanvas-md {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-md {\n    transition: none;\n  }\n}\n@media (max-width: 767.98px) {\n  .offcanvas-md.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-md.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-md.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-md.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 768px) {\n  .offcanvas-md {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-md .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-md .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .offcanvas-lg {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-lg {\n    transition: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .offcanvas-lg.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-lg.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-lg.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-lg.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 992px) {\n  .offcanvas-lg {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-lg .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-lg .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .offcanvas-xl {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-xl {\n    transition: none;\n  }\n}\n@media (max-width: 1199.98px) {\n  .offcanvas-xl.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-xl.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-xl.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-xl.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 1200px) {\n  .offcanvas-xl {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-xl .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-xl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-xxl {\n    transition: none;\n  }\n}\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-xxl.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-xxl.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-xxl.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 1400px) {\n  .offcanvas-xxl {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-xxl .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-xxl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n.offcanvas {\n  position: fixed;\n  bottom: 0;\n  z-index: var(--bs-offcanvas-zindex);\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  color: var(--bs-offcanvas-color);\n  visibility: hidden;\n  background-color: var(--bs-offcanvas-bg);\n  background-clip: padding-box;\n  outline: 0;\n  transition: var(--bs-offcanvas-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .offcanvas {\n    transition: none;\n  }\n}\n.offcanvas.offcanvas-start {\n  top: 0;\n  left: 0;\n  width: var(--bs-offcanvas-width);\n  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateX(-100%);\n}\n.offcanvas.offcanvas-end {\n  top: 0;\n  right: 0;\n  width: var(--bs-offcanvas-width);\n  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateX(100%);\n}\n.offcanvas.offcanvas-top {\n  top: 0;\n  right: 0;\n  left: 0;\n  height: var(--bs-offcanvas-height);\n  max-height: 100%;\n  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateY(-100%);\n}\n.offcanvas.offcanvas-bottom {\n  right: 0;\n  left: 0;\n  height: var(--bs-offcanvas-height);\n  max-height: 100%;\n  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateY(100%);\n}\n.offcanvas.showing, .offcanvas.show:not(.hiding) {\n  transform: none;\n}\n.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {\n  visibility: visible;\n}\n\n.offcanvas-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: #22292f;\n}\n.offcanvas-backdrop.fade {\n  opacity: 0;\n}\n.offcanvas-backdrop.show {\n  opacity: 0.5;\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n}\n.offcanvas-header .btn-close {\n  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);\n  margin: calc(-0.5 * var(--bs-offcanvas-padding-y)) calc(-0.5 * var(--bs-offcanvas-padding-x)) calc(-0.5 * var(--bs-offcanvas-padding-y)) auto;\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--bs-offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n  overflow-y: auto;\n}\n\n.placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: 0.5;\n}\n.placeholder.btn::before {\n  display: inline-block;\n  content: \"\";\n}\n\n.placeholder-xs {\n  min-height: 0.6em;\n}\n\n.placeholder-sm {\n  min-height: 0.8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n.placeholder-glow .placeholder {\n  animation: placeholder-glow 2s ease-in-out infinite;\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: 0.2;\n  }\n}\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, #22292f 55%, rgba(0, 0, 0, 0.8) 75%, #22292f 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.text-bg-primary {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-secondary {\n  color: #22292f !important;\n  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-success {\n  color: #22292f !important;\n  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-info {\n  color: #22292f !important;\n  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-warning {\n  color: #22292f !important;\n  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-danger {\n  color: #22292f !important;\n  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-light {\n  color: #22292f !important;\n  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-dark {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.link-primary {\n  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-primary:hover, .link-primary:focus {\n  color: RGBA(92, 82, 192, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(92, 82, 192, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-secondary {\n  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-secondary:hover, .link-secondary:focus {\n  color: RGBA(198, 206, 214, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(198, 206, 214, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-success {\n  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-success:hover, .link-success:focus {\n  color: RGBA(83, 210, 140, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(83, 210, 140, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-info {\n  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-info:hover, .link-info:focus {\n  color: RGBA(51, 217, 237, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(51, 217, 237, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-warning {\n  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-warning:hover, .link-warning:focus {\n  color: RGBA(255, 178, 105, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(255, 178, 105, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-danger {\n  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-danger:hover, .link-danger:focus {\n  color: RGBA(238, 118, 119, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(238, 118, 119, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-light {\n  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-light:hover, .link-light:focus {\n  color: RGBA(200, 204, 210, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(200, 204, 210, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-dark {\n  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-dark:hover, .link-dark:focus {\n  color: RGBA(34, 37, 38, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(34, 37, 38, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-body-emphasis {\n  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-body-emphasis:hover, .link-body-emphasis:focus {\n  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;\n  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;\n}\n\n.focus-ring:focus {\n  outline: 0;\n  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);\n}\n\n.icon-link {\n  display: inline-flex;\n  gap: 0.375rem;\n  align-items: center;\n  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));\n  text-underline-offset: 0.25em;\n  backface-visibility: hidden;\n}\n.icon-link > .bi {\n  flex-shrink: 0;\n  width: 1em;\n  height: 1em;\n  fill: currentcolor;\n  transition: 0.2s ease-in-out transform;\n}\n@media (prefers-reduced-motion: reduce) {\n  .icon-link > .bi {\n    transition: none;\n  }\n}\n\n.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {\n  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));\n}\n\n.ratio {\n  position: relative;\n  width: 100%;\n}\n.ratio::before {\n  display: block;\n  padding-top: var(--bs-aspect-ratio);\n  content: \"\";\n}\n.ratio > * {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.ratio-1x1 {\n  --bs-aspect-ratio: 100%;\n}\n\n.ratio-4x3 {\n  --bs-aspect-ratio: 75%;\n}\n\n.ratio-16x9 {\n  --bs-aspect-ratio: 56.25%;\n}\n\n.ratio-21x9 {\n  --bs-aspect-ratio: 42.8571428571%;\n}\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.sticky-top {\n  position: sticky;\n  top: 0;\n  z-index: 1020;\n}\n\n.sticky-bottom {\n  position: sticky;\n  bottom: 0;\n  z-index: 1020;\n}\n\n@media (min-width: 576px) {\n  .sticky-sm-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-sm-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 768px) {\n  .sticky-md-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-md-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 992px) {\n  .sticky-lg-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-lg-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1200px) {\n  .sticky-xl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-xl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1400px) {\n  .sticky-xxl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-xxl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n.visually-hidden:not(caption),\n.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {\n  position: absolute !important;\n}\n\n.stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  content: \"\";\n}\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.vr {\n  display: inline-block;\n  align-self: stretch;\n  width: var(--bs-border-width);\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: 0.25;\n}\n\n.align-baseline {\n  vertical-align: baseline !important;\n}\n\n.align-top {\n  vertical-align: top !important;\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.align-bottom {\n  vertical-align: bottom !important;\n}\n\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n\n.align-text-top {\n  vertical-align: text-top !important;\n}\n\n.float-start {\n  float: left !important;\n}\n\n.float-end {\n  float: right !important;\n}\n\n.float-none {\n  float: none !important;\n}\n\n.object-fit-contain {\n  object-fit: contain !important;\n}\n\n.object-fit-cover {\n  object-fit: cover !important;\n}\n\n.object-fit-fill {\n  object-fit: fill !important;\n}\n\n.object-fit-scale {\n  object-fit: scale-down !important;\n}\n\n.object-fit-none {\n  object-fit: none !important;\n}\n\n.opacity-0 {\n  opacity: 0 !important;\n}\n\n.opacity-25 {\n  opacity: 0.25 !important;\n}\n\n.opacity-50 {\n  opacity: 0.5 !important;\n}\n\n.opacity-75 {\n  opacity: 0.75 !important;\n}\n\n.opacity-100 {\n  opacity: 1 !important;\n}\n\n.overflow-auto {\n  overflow: auto !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.overflow-visible {\n  overflow: visible !important;\n}\n\n.overflow-scroll {\n  overflow: scroll !important;\n}\n\n.overflow-x-auto {\n  overflow-x: auto !important;\n}\n\n.overflow-x-hidden {\n  overflow-x: hidden !important;\n}\n\n.overflow-x-visible {\n  overflow-x: visible !important;\n}\n\n.overflow-x-scroll {\n  overflow-x: scroll !important;\n}\n\n.overflow-y-auto {\n  overflow-y: auto !important;\n}\n\n.overflow-y-hidden {\n  overflow-y: hidden !important;\n}\n\n.overflow-y-visible {\n  overflow-y: visible !important;\n}\n\n.overflow-y-scroll {\n  overflow-y: scroll !important;\n}\n\n.d-inline {\n  display: inline !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-grid {\n  display: grid !important;\n}\n\n.d-inline-grid {\n  display: inline-grid !important;\n}\n\n.d-table {\n  display: table !important;\n}\n\n.d-table-row {\n  display: table-row !important;\n}\n\n.d-table-cell {\n  display: table-cell !important;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: inline-flex !important;\n}\n\n.d-none {\n  display: none !important;\n}\n\n.shadow {\n  box-shadow: var(--bs-box-shadow) !important;\n}\n\n.shadow-sm {\n  box-shadow: var(--bs-box-shadow-sm) !important;\n}\n\n.shadow-lg {\n  box-shadow: var(--bs-box-shadow-lg) !important;\n}\n\n.shadow-none {\n  box-shadow: none !important;\n}\n\n.focus-ring-primary {\n  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-secondary {\n  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-success {\n  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-info {\n  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-warning {\n  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-danger {\n  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-light {\n  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-dark {\n  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));\n}\n\n.position-static {\n  position: static !important;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.position-fixed {\n  position: fixed !important;\n}\n\n.position-sticky {\n  position: sticky !important;\n}\n\n.top-0 {\n  top: 0 !important;\n}\n\n.top-50 {\n  top: 50% !important;\n}\n\n.top-100 {\n  top: 100% !important;\n}\n\n.bottom-0 {\n  bottom: 0 !important;\n}\n\n.bottom-50 {\n  bottom: 50% !important;\n}\n\n.bottom-100 {\n  bottom: 100% !important;\n}\n\n.start-0 {\n  left: 0 !important;\n}\n\n.start-50 {\n  left: 50% !important;\n}\n\n.start-100 {\n  left: 100% !important;\n}\n\n.end-0 {\n  right: 0 !important;\n}\n\n.end-50 {\n  right: 50% !important;\n}\n\n.end-100 {\n  right: 100% !important;\n}\n\n.translate-middle {\n  transform: translate(-50%, -50%) !important;\n}\n\n.translate-middle-x {\n  transform: translateX(-50%) !important;\n}\n\n.translate-middle-y {\n  transform: translateY(-50%) !important;\n}\n\n.border {\n  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-0 {\n  border: 0 !important;\n}\n\n.border-top {\n  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-top-0 {\n  border-top: 0 !important;\n}\n\n.border-end {\n  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-end-0 {\n  border-right: 0 !important;\n}\n\n.border-bottom {\n  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n\n.border-start {\n  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-start-0 {\n  border-left: 0 !important;\n}\n\n.border-primary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-secondary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-success {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-info {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-warning {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-danger {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-light {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-dark {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-black {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-white {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-primary-subtle {\n  border-color: var(--bs-primary-border-subtle) !important;\n}\n\n.border-secondary-subtle {\n  border-color: var(--bs-secondary-border-subtle) !important;\n}\n\n.border-success-subtle {\n  border-color: var(--bs-success-border-subtle) !important;\n}\n\n.border-info-subtle {\n  border-color: var(--bs-info-border-subtle) !important;\n}\n\n.border-warning-subtle {\n  border-color: var(--bs-warning-border-subtle) !important;\n}\n\n.border-danger-subtle {\n  border-color: var(--bs-danger-border-subtle) !important;\n}\n\n.border-light-subtle {\n  border-color: var(--bs-light-border-subtle) !important;\n}\n\n.border-dark-subtle {\n  border-color: var(--bs-dark-border-subtle) !important;\n}\n\n.border-1 {\n  border-width: 1px !important;\n}\n\n.border-2 {\n  border-width: 2px !important;\n}\n\n.border-3 {\n  border-width: 3px !important;\n}\n\n.border-4 {\n  border-width: 4px !important;\n}\n\n.border-5 {\n  border-width: 5px !important;\n}\n\n.border-opacity-10 {\n  --bs-border-opacity: 0.1;\n}\n\n.border-opacity-25 {\n  --bs-border-opacity: 0.25;\n}\n\n.border-opacity-50 {\n  --bs-border-opacity: 0.5;\n}\n\n.border-opacity-75 {\n  --bs-border-opacity: 0.75;\n}\n\n.border-opacity-100 {\n  --bs-border-opacity: 1;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto !important;\n}\n\n.mw-100 {\n  max-width: 100% !important;\n}\n\n.vw-100 {\n  width: 100vw !important;\n}\n\n.min-vw-100 {\n  min-width: 100vw !important;\n}\n\n.h-25 {\n  height: 25% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.mh-100 {\n  max-height: 100% !important;\n}\n\n.vh-100 {\n  height: 100vh !important;\n}\n\n.min-vh-100 {\n  min-height: 100vh !important;\n}\n\n.flex-fill {\n  flex: 1 1 auto !important;\n}\n\n.flex-row {\n  flex-direction: row !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n\n.flex-grow-0 {\n  flex-grow: 0 !important;\n}\n\n.flex-grow-1 {\n  flex-grow: 1 !important;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important;\n}\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.justify-content-center {\n  justify-content: center !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-around {\n  justify-content: space-around !important;\n}\n\n.justify-content-evenly {\n  justify-content: space-evenly !important;\n}\n\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n.align-items-end {\n  align-items: flex-end !important;\n}\n\n.align-items-center {\n  align-items: center !important;\n}\n\n.align-items-baseline {\n  align-items: baseline !important;\n}\n\n.align-items-stretch {\n  align-items: stretch !important;\n}\n\n.align-content-start {\n  align-content: flex-start !important;\n}\n\n.align-content-end {\n  align-content: flex-end !important;\n}\n\n.align-content-center {\n  align-content: center !important;\n}\n\n.align-content-between {\n  align-content: space-between !important;\n}\n\n.align-content-around {\n  align-content: space-around !important;\n}\n\n.align-content-stretch {\n  align-content: stretch !important;\n}\n\n.align-self-auto {\n  align-self: auto !important;\n}\n\n.align-self-start {\n  align-self: flex-start !important;\n}\n\n.align-self-end {\n  align-self: flex-end !important;\n}\n\n.align-self-center {\n  align-self: center !important;\n}\n\n.align-self-baseline {\n  align-self: baseline !important;\n}\n\n.align-self-stretch {\n  align-self: stretch !important;\n}\n\n.order-first {\n  order: -1 !important;\n}\n\n.order-0 {\n  order: 0 !important;\n}\n\n.order-1 {\n  order: 1 !important;\n}\n\n.order-2 {\n  order: 2 !important;\n}\n\n.order-3 {\n  order: 3 !important;\n}\n\n.order-4 {\n  order: 4 !important;\n}\n\n.order-5 {\n  order: 5 !important;\n}\n\n.order-last {\n  order: 6 !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.m-25 {\n  margin: 0.25rem !important;\n}\n\n.m-50 {\n  margin: 0.5rem !important;\n}\n\n.m-75 {\n  margin: 0.75rem !important;\n}\n\n.m-1 {\n  margin: 1rem !important;\n}\n\n.m-2 {\n  margin: 1.5rem !important;\n}\n\n.m-3 {\n  margin: 3rem !important;\n}\n\n.m-4 {\n  margin: 3.5rem !important;\n}\n\n.m-5 {\n  margin: 4rem !important;\n}\n\n.m-auto {\n  margin: auto !important;\n}\n\n.mx-0 {\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n\n.mx-25 {\n  margin-right: 0.25rem !important;\n  margin-left: 0.25rem !important;\n}\n\n.mx-50 {\n  margin-right: 0.5rem !important;\n  margin-left: 0.5rem !important;\n}\n\n.mx-75 {\n  margin-right: 0.75rem !important;\n  margin-left: 0.75rem !important;\n}\n\n.mx-1 {\n  margin-right: 1rem !important;\n  margin-left: 1rem !important;\n}\n\n.mx-2 {\n  margin-right: 1.5rem !important;\n  margin-left: 1.5rem !important;\n}\n\n.mx-3 {\n  margin-right: 3rem !important;\n  margin-left: 3rem !important;\n}\n\n.mx-4 {\n  margin-right: 3.5rem !important;\n  margin-left: 3.5rem !important;\n}\n\n.mx-5 {\n  margin-right: 4rem !important;\n  margin-left: 4rem !important;\n}\n\n.mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n\n.my-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n.my-25 {\n  margin-top: 0.25rem !important;\n  margin-bottom: 0.25rem !important;\n}\n\n.my-50 {\n  margin-top: 0.5rem !important;\n  margin-bottom: 0.5rem !important;\n}\n\n.my-75 {\n  margin-top: 0.75rem !important;\n  margin-bottom: 0.75rem !important;\n}\n\n.my-1 {\n  margin-top: 1rem !important;\n  margin-bottom: 1rem !important;\n}\n\n.my-2 {\n  margin-top: 1.5rem !important;\n  margin-bottom: 1.5rem !important;\n}\n\n.my-3 {\n  margin-top: 3rem !important;\n  margin-bottom: 3rem !important;\n}\n\n.my-4 {\n  margin-top: 3.5rem !important;\n  margin-bottom: 3.5rem !important;\n}\n\n.my-5 {\n  margin-top: 4rem !important;\n  margin-bottom: 4rem !important;\n}\n\n.my-auto {\n  margin-top: auto !important;\n  margin-bottom: auto !important;\n}\n\n.mt-0 {\n  margin-top: 0 !important;\n}\n\n.mt-25 {\n  margin-top: 0.25rem !important;\n}\n\n.mt-50 {\n  margin-top: 0.5rem !important;\n}\n\n.mt-75 {\n  margin-top: 0.75rem !important;\n}\n\n.mt-1 {\n  margin-top: 1rem !important;\n}\n\n.mt-2 {\n  margin-top: 1.5rem !important;\n}\n\n.mt-3 {\n  margin-top: 3rem !important;\n}\n\n.mt-4 {\n  margin-top: 3.5rem !important;\n}\n\n.mt-5 {\n  margin-top: 4rem !important;\n}\n\n.mt-auto {\n  margin-top: auto !important;\n}\n\n.me-0 {\n  margin-right: 0 !important;\n}\n\n.me-25 {\n  margin-right: 0.25rem !important;\n}\n\n.me-50 {\n  margin-right: 0.5rem !important;\n}\n\n.me-75 {\n  margin-right: 0.75rem !important;\n}\n\n.me-1 {\n  margin-right: 1rem !important;\n}\n\n.me-2 {\n  margin-right: 1.5rem !important;\n}\n\n.me-3 {\n  margin-right: 3rem !important;\n}\n\n.me-4 {\n  margin-right: 3.5rem !important;\n}\n\n.me-5 {\n  margin-right: 4rem !important;\n}\n\n.me-auto {\n  margin-right: auto !important;\n}\n\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n\n.mb-25 {\n  margin-bottom: 0.25rem !important;\n}\n\n.mb-50 {\n  margin-bottom: 0.5rem !important;\n}\n\n.mb-75 {\n  margin-bottom: 0.75rem !important;\n}\n\n.mb-1 {\n  margin-bottom: 1rem !important;\n}\n\n.mb-2 {\n  margin-bottom: 1.5rem !important;\n}\n\n.mb-3 {\n  margin-bottom: 3rem !important;\n}\n\n.mb-4 {\n  margin-bottom: 3.5rem !important;\n}\n\n.mb-5 {\n  margin-bottom: 4rem !important;\n}\n\n.mb-auto {\n  margin-bottom: auto !important;\n}\n\n.ms-0 {\n  margin-left: 0 !important;\n}\n\n.ms-25 {\n  margin-left: 0.25rem !important;\n}\n\n.ms-50 {\n  margin-left: 0.5rem !important;\n}\n\n.ms-75 {\n  margin-left: 0.75rem !important;\n}\n\n.ms-1 {\n  margin-left: 1rem !important;\n}\n\n.ms-2 {\n  margin-left: 1.5rem !important;\n}\n\n.ms-3 {\n  margin-left: 3rem !important;\n}\n\n.ms-4 {\n  margin-left: 3.5rem !important;\n}\n\n.ms-5 {\n  margin-left: 4rem !important;\n}\n\n.ms-auto {\n  margin-left: auto !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.p-25 {\n  padding: 0.25rem !important;\n}\n\n.p-50 {\n  padding: 0.5rem !important;\n}\n\n.p-75 {\n  padding: 0.75rem !important;\n}\n\n.p-1 {\n  padding: 1rem !important;\n}\n\n.p-2 {\n  padding: 1.5rem !important;\n}\n\n.p-3 {\n  padding: 3rem !important;\n}\n\n.p-4 {\n  padding: 3.5rem !important;\n}\n\n.p-5 {\n  padding: 4rem !important;\n}\n\n.px-0 {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n}\n\n.px-25 {\n  padding-right: 0.25rem !important;\n  padding-left: 0.25rem !important;\n}\n\n.px-50 {\n  padding-right: 0.5rem !important;\n  padding-left: 0.5rem !important;\n}\n\n.px-75 {\n  padding-right: 0.75rem !important;\n  padding-left: 0.75rem !important;\n}\n\n.px-1 {\n  padding-right: 1rem !important;\n  padding-left: 1rem !important;\n}\n\n.px-2 {\n  padding-right: 1.5rem !important;\n  padding-left: 1.5rem !important;\n}\n\n.px-3 {\n  padding-right: 3rem !important;\n  padding-left: 3rem !important;\n}\n\n.px-4 {\n  padding-right: 3.5rem !important;\n  padding-left: 3.5rem !important;\n}\n\n.px-5 {\n  padding-right: 4rem !important;\n  padding-left: 4rem !important;\n}\n\n.py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.py-25 {\n  padding-top: 0.25rem !important;\n  padding-bottom: 0.25rem !important;\n}\n\n.py-50 {\n  padding-top: 0.5rem !important;\n  padding-bottom: 0.5rem !important;\n}\n\n.py-75 {\n  padding-top: 0.75rem !important;\n  padding-bottom: 0.75rem !important;\n}\n\n.py-1 {\n  padding-top: 1rem !important;\n  padding-bottom: 1rem !important;\n}\n\n.py-2 {\n  padding-top: 1.5rem !important;\n  padding-bottom: 1.5rem !important;\n}\n\n.py-3 {\n  padding-top: 3rem !important;\n  padding-bottom: 3rem !important;\n}\n\n.py-4 {\n  padding-top: 3.5rem !important;\n  padding-bottom: 3.5rem !important;\n}\n\n.py-5 {\n  padding-top: 4rem !important;\n  padding-bottom: 4rem !important;\n}\n\n.pt-0 {\n  padding-top: 0 !important;\n}\n\n.pt-25 {\n  padding-top: 0.25rem !important;\n}\n\n.pt-50 {\n  padding-top: 0.5rem !important;\n}\n\n.pt-75 {\n  padding-top: 0.75rem !important;\n}\n\n.pt-1 {\n  padding-top: 1rem !important;\n}\n\n.pt-2 {\n  padding-top: 1.5rem !important;\n}\n\n.pt-3 {\n  padding-top: 3rem !important;\n}\n\n.pt-4 {\n  padding-top: 3.5rem !important;\n}\n\n.pt-5 {\n  padding-top: 4rem !important;\n}\n\n.pe-0 {\n  padding-right: 0 !important;\n}\n\n.pe-25 {\n  padding-right: 0.25rem !important;\n}\n\n.pe-50 {\n  padding-right: 0.5rem !important;\n}\n\n.pe-75 {\n  padding-right: 0.75rem !important;\n}\n\n.pe-1 {\n  padding-right: 1rem !important;\n}\n\n.pe-2 {\n  padding-right: 1.5rem !important;\n}\n\n.pe-3 {\n  padding-right: 3rem !important;\n}\n\n.pe-4 {\n  padding-right: 3.5rem !important;\n}\n\n.pe-5 {\n  padding-right: 4rem !important;\n}\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n\n.pb-25 {\n  padding-bottom: 0.25rem !important;\n}\n\n.pb-50 {\n  padding-bottom: 0.5rem !important;\n}\n\n.pb-75 {\n  padding-bottom: 0.75rem !important;\n}\n\n.pb-1 {\n  padding-bottom: 1rem !important;\n}\n\n.pb-2 {\n  padding-bottom: 1.5rem !important;\n}\n\n.pb-3 {\n  padding-bottom: 3rem !important;\n}\n\n.pb-4 {\n  padding-bottom: 3.5rem !important;\n}\n\n.pb-5 {\n  padding-bottom: 4rem !important;\n}\n\n.ps-0 {\n  padding-left: 0 !important;\n}\n\n.ps-25 {\n  padding-left: 0.25rem !important;\n}\n\n.ps-50 {\n  padding-left: 0.5rem !important;\n}\n\n.ps-75 {\n  padding-left: 0.75rem !important;\n}\n\n.ps-1 {\n  padding-left: 1rem !important;\n}\n\n.ps-2 {\n  padding-left: 1.5rem !important;\n}\n\n.ps-3 {\n  padding-left: 3rem !important;\n}\n\n.ps-4 {\n  padding-left: 3.5rem !important;\n}\n\n.ps-5 {\n  padding-left: 4rem !important;\n}\n\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-25 {\n  gap: 0.25rem !important;\n}\n\n.gap-50 {\n  gap: 0.5rem !important;\n}\n\n.gap-75 {\n  gap: 0.75rem !important;\n}\n\n.gap-1 {\n  gap: 1rem !important;\n}\n\n.gap-2 {\n  gap: 1.5rem !important;\n}\n\n.gap-3 {\n  gap: 3rem !important;\n}\n\n.gap-4 {\n  gap: 3.5rem !important;\n}\n\n.gap-5 {\n  gap: 4rem !important;\n}\n\n.row-gap-0 {\n  row-gap: 0 !important;\n}\n\n.row-gap-25 {\n  row-gap: 0.25rem !important;\n}\n\n.row-gap-50 {\n  row-gap: 0.5rem !important;\n}\n\n.row-gap-75 {\n  row-gap: 0.75rem !important;\n}\n\n.row-gap-1 {\n  row-gap: 1rem !important;\n}\n\n.row-gap-2 {\n  row-gap: 1.5rem !important;\n}\n\n.row-gap-3 {\n  row-gap: 3rem !important;\n}\n\n.row-gap-4 {\n  row-gap: 3.5rem !important;\n}\n\n.row-gap-5 {\n  row-gap: 4rem !important;\n}\n\n.column-gap-0 {\n  column-gap: 0 !important;\n}\n\n.column-gap-25 {\n  column-gap: 0.25rem !important;\n}\n\n.column-gap-50 {\n  column-gap: 0.5rem !important;\n}\n\n.column-gap-75 {\n  column-gap: 0.75rem !important;\n}\n\n.column-gap-1 {\n  column-gap: 1rem !important;\n}\n\n.column-gap-2 {\n  column-gap: 1.5rem !important;\n}\n\n.column-gap-3 {\n  column-gap: 3rem !important;\n}\n\n.column-gap-4 {\n  column-gap: 3.5rem !important;\n}\n\n.column-gap-5 {\n  column-gap: 4rem !important;\n}\n\n.font-monospace {\n  font-family: var(--bs-font-monospace) !important;\n}\n\n.fs-1 {\n  font-size: calc(1.325rem + 0.9vw) !important;\n}\n\n.fs-2 {\n  font-size: calc(1.299rem + 0.588vw) !important;\n}\n\n.fs-3 {\n  font-size: calc(1.276rem + 0.312vw) !important;\n}\n\n.fs-4 {\n  font-size: calc(1.257rem + 0.084vw) !important;\n}\n\n.fs-5 {\n  font-size: 1.14rem !important;\n}\n\n.fs-6 {\n  font-size: 1rem !important;\n}\n\n.fst-italic {\n  font-style: italic !important;\n}\n\n.fst-normal {\n  font-style: normal !important;\n}\n\n.fw-lighter {\n  font-weight: lighter !important;\n}\n\n.fw-light {\n  font-weight: 300 !important;\n}\n\n.fw-normal {\n  font-weight: 400 !important;\n}\n\n.fw-medium {\n  font-weight: 500 !important;\n}\n\n.fw-semibold {\n  font-weight: 600 !important;\n}\n\n.fw-bold {\n  font-weight: 700 !important;\n}\n\n.fw-bolder {\n  font-weight: bolder !important;\n}\n\n.lh-1 {\n  line-height: 1 !important;\n}\n\n.lh-sm {\n  line-height: 1 !important;\n}\n\n.lh-base {\n  line-height: 1.45 !important;\n}\n\n.lh-lg {\n  line-height: 1.25 !important;\n}\n\n.text-start {\n  text-align: left !important;\n}\n\n.text-end {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n.text-decoration-none {\n  text-decoration: none !important;\n}\n\n.text-decoration-underline {\n  text-decoration: underline !important;\n}\n\n.text-decoration-line-through {\n  text-decoration: line-through !important;\n}\n\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.text-wrap {\n  white-space: normal !important;\n}\n\n.text-nowrap {\n  white-space: nowrap !important;\n}\n\n/* rtl:begin:remove */\n.text-break {\n  word-wrap: break-word !important;\n  word-break: break-word !important;\n}\n\n/* rtl:end:remove */\n.text-primary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-secondary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-success {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-info {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-warning {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-danger {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-light {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-dark {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-black {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-white {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-body {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-muted {\n  --bs-text-opacity: 1;\n  color: var(--bs-secondary-color) !important;\n}\n\n.text-black-50 {\n  --bs-text-opacity: 1;\n  color: rgba(34, 41, 47, 0.5) !important;\n}\n\n.text-white-50 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.text-body-secondary {\n  --bs-text-opacity: 1;\n  color: var(--bs-secondary-color) !important;\n}\n\n.text-body-tertiary {\n  --bs-text-opacity: 1;\n  color: var(--bs-tertiary-color) !important;\n}\n\n.text-body-emphasis {\n  --bs-text-opacity: 1;\n  color: var(--bs-emphasis-color) !important;\n}\n\n.text-reset {\n  --bs-text-opacity: 1;\n  color: inherit !important;\n}\n\n.text-opacity-25 {\n  --bs-text-opacity: 0.25;\n}\n\n.text-opacity-50 {\n  --bs-text-opacity: 0.5;\n}\n\n.text-opacity-75 {\n  --bs-text-opacity: 0.75;\n}\n\n.text-opacity-100 {\n  --bs-text-opacity: 1;\n}\n\n.text-primary-emphasis {\n  color: var(--bs-primary-text-emphasis) !important;\n}\n\n.text-secondary-emphasis {\n  color: var(--bs-secondary-text-emphasis) !important;\n}\n\n.text-success-emphasis {\n  color: var(--bs-success-text-emphasis) !important;\n}\n\n.text-info-emphasis {\n  color: var(--bs-info-text-emphasis) !important;\n}\n\n.text-warning-emphasis {\n  color: var(--bs-warning-text-emphasis) !important;\n}\n\n.text-danger-emphasis {\n  color: var(--bs-danger-text-emphasis) !important;\n}\n\n.text-light-emphasis {\n  color: var(--bs-light-text-emphasis) !important;\n}\n\n.text-dark-emphasis {\n  color: var(--bs-dark-text-emphasis) !important;\n}\n\n.link-opacity-10 {\n  --bs-link-opacity: 0.1;\n}\n\n.link-opacity-10-hover:hover {\n  --bs-link-opacity: 0.1;\n}\n\n.link-opacity-25 {\n  --bs-link-opacity: 0.25;\n}\n\n.link-opacity-25-hover:hover {\n  --bs-link-opacity: 0.25;\n}\n\n.link-opacity-50 {\n  --bs-link-opacity: 0.5;\n}\n\n.link-opacity-50-hover:hover {\n  --bs-link-opacity: 0.5;\n}\n\n.link-opacity-75 {\n  --bs-link-opacity: 0.75;\n}\n\n.link-opacity-75-hover:hover {\n  --bs-link-opacity: 0.75;\n}\n\n.link-opacity-100 {\n  --bs-link-opacity: 1;\n}\n\n.link-opacity-100-hover:hover {\n  --bs-link-opacity: 1;\n}\n\n.link-offset-1 {\n  text-underline-offset: 0.125em !important;\n}\n\n.link-offset-1-hover:hover {\n  text-underline-offset: 0.125em !important;\n}\n\n.link-offset-2 {\n  text-underline-offset: 0.25em !important;\n}\n\n.link-offset-2-hover:hover {\n  text-underline-offset: 0.25em !important;\n}\n\n.link-offset-3 {\n  text-underline-offset: 0.375em !important;\n}\n\n.link-offset-3-hover:hover {\n  text-underline-offset: 0.375em !important;\n}\n\n.link-underline-primary {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-secondary {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-success {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-info {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-warning {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-danger {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-light {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-dark {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-underline-opacity-0 {\n  --bs-link-underline-opacity: 0;\n}\n\n.link-underline-opacity-0-hover:hover {\n  --bs-link-underline-opacity: 0;\n}\n\n.link-underline-opacity-10 {\n  --bs-link-underline-opacity: 0.1;\n}\n\n.link-underline-opacity-10-hover:hover {\n  --bs-link-underline-opacity: 0.1;\n}\n\n.link-underline-opacity-25 {\n  --bs-link-underline-opacity: 0.25;\n}\n\n.link-underline-opacity-25-hover:hover {\n  --bs-link-underline-opacity: 0.25;\n}\n\n.link-underline-opacity-50 {\n  --bs-link-underline-opacity: 0.5;\n}\n\n.link-underline-opacity-50-hover:hover {\n  --bs-link-underline-opacity: 0.5;\n}\n\n.link-underline-opacity-75 {\n  --bs-link-underline-opacity: 0.75;\n}\n\n.link-underline-opacity-75-hover:hover {\n  --bs-link-underline-opacity: 0.75;\n}\n\n.link-underline-opacity-100 {\n  --bs-link-underline-opacity: 1;\n}\n\n.link-underline-opacity-100-hover:hover {\n  --bs-link-underline-opacity: 1;\n}\n\n.bg-primary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-secondary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-success {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-info {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-warning {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-light {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-dark {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-black {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-white {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-transparent {\n  --bs-bg-opacity: 1;\n  background-color: transparent !important;\n}\n\n.bg-body-secondary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body-tertiary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-opacity-10 {\n  --bs-bg-opacity: 0.1;\n}\n\n.bg-opacity-25 {\n  --bs-bg-opacity: 0.25;\n}\n\n.bg-opacity-50 {\n  --bs-bg-opacity: 0.5;\n}\n\n.bg-opacity-75 {\n  --bs-bg-opacity: 0.75;\n}\n\n.bg-opacity-100 {\n  --bs-bg-opacity: 1;\n}\n\n.bg-primary-subtle {\n  background-color: var(--bs-primary-bg-subtle) !important;\n}\n\n.bg-secondary-subtle {\n  background-color: var(--bs-secondary-bg-subtle) !important;\n}\n\n.bg-success-subtle {\n  background-color: var(--bs-success-bg-subtle) !important;\n}\n\n.bg-info-subtle {\n  background-color: var(--bs-info-bg-subtle) !important;\n}\n\n.bg-warning-subtle {\n  background-color: var(--bs-warning-bg-subtle) !important;\n}\n\n.bg-danger-subtle {\n  background-color: var(--bs-danger-bg-subtle) !important;\n}\n\n.bg-light-subtle {\n  background-color: var(--bs-light-bg-subtle) !important;\n}\n\n.bg-dark-subtle {\n  background-color: var(--bs-dark-bg-subtle) !important;\n}\n\n.bg-gradient {\n  background-image: var(--bs-gradient) !important;\n}\n\n.user-select-all {\n  user-select: all !important;\n}\n\n.user-select-auto {\n  user-select: auto !important;\n}\n\n.user-select-none {\n  user-select: none !important;\n}\n\n.pe-none {\n  pointer-events: none !important;\n}\n\n.pe-auto {\n  pointer-events: auto !important;\n}\n\n.rounded {\n  border-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n\n.rounded-1 {\n  border-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-2 {\n  border-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-3 {\n  border-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-4 {\n  border-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-5 {\n  border-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-top {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-0 {\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n}\n\n.rounded-top-1 {\n  border-top-left-radius: var(--bs-border-radius-sm) !important;\n  border-top-right-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-top-2 {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-3 {\n  border-top-left-radius: var(--bs-border-radius-lg) !important;\n  border-top-right-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-top-4 {\n  border-top-left-radius: var(--bs-border-radius-xl) !important;\n  border-top-right-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-top-5 {\n  border-top-left-radius: var(--bs-border-radius-xxl) !important;\n  border-top-right-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-top-circle {\n  border-top-left-radius: 50% !important;\n  border-top-right-radius: 50% !important;\n}\n\n.rounded-top-pill {\n  border-top-left-radius: var(--bs-border-radius-pill) !important;\n  border-top-right-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-end {\n  border-top-right-radius: var(--bs-border-radius) !important;\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-end-0 {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.rounded-end-1 {\n  border-top-right-radius: var(--bs-border-radius-sm) !important;\n  border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-end-2 {\n  border-top-right-radius: var(--bs-border-radius) !important;\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-end-3 {\n  border-top-right-radius: var(--bs-border-radius-lg) !important;\n  border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-end-4 {\n  border-top-right-radius: var(--bs-border-radius-xl) !important;\n  border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-end-5 {\n  border-top-right-radius: var(--bs-border-radius-xxl) !important;\n  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-end-circle {\n  border-top-right-radius: 50% !important;\n  border-bottom-right-radius: 50% !important;\n}\n\n.rounded-end-pill {\n  border-top-right-radius: var(--bs-border-radius-pill) !important;\n  border-bottom-right-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-0 {\n  border-bottom-right-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n\n.rounded-bottom-1 {\n  border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n  border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-bottom-2 {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-3 {\n  border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n  border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-bottom-4 {\n  border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-bottom-5 {\n  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-bottom-circle {\n  border-bottom-right-radius: 50% !important;\n  border-bottom-left-radius: 50% !important;\n}\n\n.rounded-bottom-pill {\n  border-bottom-right-radius: var(--bs-border-radius-pill) !important;\n  border-bottom-left-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-start {\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n  border-top-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-start-0 {\n  border-bottom-left-radius: 0 !important;\n  border-top-left-radius: 0 !important;\n}\n\n.rounded-start-1 {\n  border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n  border-top-left-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-start-2 {\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n  border-top-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-start-3 {\n  border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n  border-top-left-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-start-4 {\n  border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n  border-top-left-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-start-5 {\n  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;\n  border-top-left-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-start-circle {\n  border-bottom-left-radius: 50% !important;\n  border-top-left-radius: 50% !important;\n}\n\n.rounded-start-pill {\n  border-bottom-left-radius: var(--bs-border-radius-pill) !important;\n  border-top-left-radius: var(--bs-border-radius-pill) !important;\n}\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n\n.z-n1 {\n  z-index: -1 !important;\n}\n\n.z-0 {\n  z-index: 0 !important;\n}\n\n.z-1 {\n  z-index: 1 !important;\n}\n\n.z-2 {\n  z-index: 2 !important;\n}\n\n.z-3 {\n  z-index: 3 !important;\n}\n\n@media (min-width: 576px) {\n  .float-sm-start {\n    float: left !important;\n  }\n  .float-sm-end {\n    float: right !important;\n  }\n  .float-sm-none {\n    float: none !important;\n  }\n  .object-fit-sm-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-sm-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-sm-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-sm-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-sm-none {\n    object-fit: none !important;\n  }\n  .d-sm-inline {\n    display: inline !important;\n  }\n  .d-sm-inline-block {\n    display: inline-block !important;\n  }\n  .d-sm-block {\n    display: block !important;\n  }\n  .d-sm-grid {\n    display: grid !important;\n  }\n  .d-sm-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-sm-table {\n    display: table !important;\n  }\n  .d-sm-table-row {\n    display: table-row !important;\n  }\n  .d-sm-table-cell {\n    display: table-cell !important;\n  }\n  .d-sm-flex {\n    display: flex !important;\n  }\n  .d-sm-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-sm-none {\n    display: none !important;\n  }\n  .flex-sm-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-sm-row {\n    flex-direction: row !important;\n  }\n  .flex-sm-column {\n    flex-direction: column !important;\n  }\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-sm-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-sm-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-sm-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-sm-center {\n    justify-content: center !important;\n  }\n  .justify-content-sm-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-sm-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-sm-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-sm-start {\n    align-items: flex-start !important;\n  }\n  .align-items-sm-end {\n    align-items: flex-end !important;\n  }\n  .align-items-sm-center {\n    align-items: center !important;\n  }\n  .align-items-sm-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-sm-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-sm-start {\n    align-content: flex-start !important;\n  }\n  .align-content-sm-end {\n    align-content: flex-end !important;\n  }\n  .align-content-sm-center {\n    align-content: center !important;\n  }\n  .align-content-sm-between {\n    align-content: space-between !important;\n  }\n  .align-content-sm-around {\n    align-content: space-around !important;\n  }\n  .align-content-sm-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-sm-auto {\n    align-self: auto !important;\n  }\n  .align-self-sm-start {\n    align-self: flex-start !important;\n  }\n  .align-self-sm-end {\n    align-self: flex-end !important;\n  }\n  .align-self-sm-center {\n    align-self: center !important;\n  }\n  .align-self-sm-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-sm-stretch {\n    align-self: stretch !important;\n  }\n  .order-sm-first {\n    order: -1 !important;\n  }\n  .order-sm-0 {\n    order: 0 !important;\n  }\n  .order-sm-1 {\n    order: 1 !important;\n  }\n  .order-sm-2 {\n    order: 2 !important;\n  }\n  .order-sm-3 {\n    order: 3 !important;\n  }\n  .order-sm-4 {\n    order: 4 !important;\n  }\n  .order-sm-5 {\n    order: 5 !important;\n  }\n  .order-sm-last {\n    order: 6 !important;\n  }\n  .m-sm-0 {\n    margin: 0 !important;\n  }\n  .m-sm-25 {\n    margin: 0.25rem !important;\n  }\n  .m-sm-50 {\n    margin: 0.5rem !important;\n  }\n  .m-sm-75 {\n    margin: 0.75rem !important;\n  }\n  .m-sm-1 {\n    margin: 1rem !important;\n  }\n  .m-sm-2 {\n    margin: 1.5rem !important;\n  }\n  .m-sm-3 {\n    margin: 3rem !important;\n  }\n  .m-sm-4 {\n    margin: 3.5rem !important;\n  }\n  .m-sm-5 {\n    margin: 4rem !important;\n  }\n  .m-sm-auto {\n    margin: auto !important;\n  }\n  .mx-sm-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-sm-25 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-sm-50 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-sm-75 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n  .mx-sm-1 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-sm-2 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-sm-3 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-sm-4 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n  .mx-sm-5 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n  .mx-sm-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-sm-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-sm-25 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-sm-50 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-sm-75 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n  .my-sm-1 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-sm-2 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-sm-3 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-sm-4 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n  .my-sm-5 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n  .my-sm-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-sm-0 {\n    margin-top: 0 !important;\n  }\n  .mt-sm-25 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-sm-50 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-sm-75 {\n    margin-top: 0.75rem !important;\n  }\n  .mt-sm-1 {\n    margin-top: 1rem !important;\n  }\n  .mt-sm-2 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-sm-3 {\n    margin-top: 3rem !important;\n  }\n  .mt-sm-4 {\n    margin-top: 3.5rem !important;\n  }\n  .mt-sm-5 {\n    margin-top: 4rem !important;\n  }\n  .mt-sm-auto {\n    margin-top: auto !important;\n  }\n  .me-sm-0 {\n    margin-right: 0 !important;\n  }\n  .me-sm-25 {\n    margin-right: 0.25rem !important;\n  }\n  .me-sm-50 {\n    margin-right: 0.5rem !important;\n  }\n  .me-sm-75 {\n    margin-right: 0.75rem !important;\n  }\n  .me-sm-1 {\n    margin-right: 1rem !important;\n  }\n  .me-sm-2 {\n    margin-right: 1.5rem !important;\n  }\n  .me-sm-3 {\n    margin-right: 3rem !important;\n  }\n  .me-sm-4 {\n    margin-right: 3.5rem !important;\n  }\n  .me-sm-5 {\n    margin-right: 4rem !important;\n  }\n  .me-sm-auto {\n    margin-right: auto !important;\n  }\n  .mb-sm-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-sm-25 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-sm-50 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-sm-75 {\n    margin-bottom: 0.75rem !important;\n  }\n  .mb-sm-1 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-sm-2 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-sm-3 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-sm-4 {\n    margin-bottom: 3.5rem !important;\n  }\n  .mb-sm-5 {\n    margin-bottom: 4rem !important;\n  }\n  .mb-sm-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-sm-0 {\n    margin-left: 0 !important;\n  }\n  .ms-sm-25 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-sm-50 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-sm-75 {\n    margin-left: 0.75rem !important;\n  }\n  .ms-sm-1 {\n    margin-left: 1rem !important;\n  }\n  .ms-sm-2 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-sm-3 {\n    margin-left: 3rem !important;\n  }\n  .ms-sm-4 {\n    margin-left: 3.5rem !important;\n  }\n  .ms-sm-5 {\n    margin-left: 4rem !important;\n  }\n  .ms-sm-auto {\n    margin-left: auto !important;\n  }\n  .p-sm-0 {\n    padding: 0 !important;\n  }\n  .p-sm-25 {\n    padding: 0.25rem !important;\n  }\n  .p-sm-50 {\n    padding: 0.5rem !important;\n  }\n  .p-sm-75 {\n    padding: 0.75rem !important;\n  }\n  .p-sm-1 {\n    padding: 1rem !important;\n  }\n  .p-sm-2 {\n    padding: 1.5rem !important;\n  }\n  .p-sm-3 {\n    padding: 3rem !important;\n  }\n  .p-sm-4 {\n    padding: 3.5rem !important;\n  }\n  .p-sm-5 {\n    padding: 4rem !important;\n  }\n  .px-sm-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-sm-25 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-sm-50 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-sm-75 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n  .px-sm-1 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-sm-2 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-sm-3 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .px-sm-4 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n  .px-sm-5 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n  .py-sm-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-sm-25 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-sm-50 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-sm-75 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n  .py-sm-1 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-sm-2 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-sm-3 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .py-sm-4 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n  .py-sm-5 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n  .pt-sm-0 {\n    padding-top: 0 !important;\n  }\n  .pt-sm-25 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-sm-50 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-sm-75 {\n    padding-top: 0.75rem !important;\n  }\n  .pt-sm-1 {\n    padding-top: 1rem !important;\n  }\n  .pt-sm-2 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-sm-3 {\n    padding-top: 3rem !important;\n  }\n  .pt-sm-4 {\n    padding-top: 3.5rem !important;\n  }\n  .pt-sm-5 {\n    padding-top: 4rem !important;\n  }\n  .pe-sm-0 {\n    padding-right: 0 !important;\n  }\n  .pe-sm-25 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-sm-50 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-sm-75 {\n    padding-right: 0.75rem !important;\n  }\n  .pe-sm-1 {\n    padding-right: 1rem !important;\n  }\n  .pe-sm-2 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-sm-3 {\n    padding-right: 3rem !important;\n  }\n  .pe-sm-4 {\n    padding-right: 3.5rem !important;\n  }\n  .pe-sm-5 {\n    padding-right: 4rem !important;\n  }\n  .pb-sm-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-sm-25 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-sm-50 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-sm-75 {\n    padding-bottom: 0.75rem !important;\n  }\n  .pb-sm-1 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-sm-2 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-sm-3 {\n    padding-bottom: 3rem !important;\n  }\n  .pb-sm-4 {\n    padding-bottom: 3.5rem !important;\n  }\n  .pb-sm-5 {\n    padding-bottom: 4rem !important;\n  }\n  .ps-sm-0 {\n    padding-left: 0 !important;\n  }\n  .ps-sm-25 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-sm-50 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-sm-75 {\n    padding-left: 0.75rem !important;\n  }\n  .ps-sm-1 {\n    padding-left: 1rem !important;\n  }\n  .ps-sm-2 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-sm-3 {\n    padding-left: 3rem !important;\n  }\n  .ps-sm-4 {\n    padding-left: 3.5rem !important;\n  }\n  .ps-sm-5 {\n    padding-left: 4rem !important;\n  }\n  .gap-sm-0 {\n    gap: 0 !important;\n  }\n  .gap-sm-25 {\n    gap: 0.25rem !important;\n  }\n  .gap-sm-50 {\n    gap: 0.5rem !important;\n  }\n  .gap-sm-75 {\n    gap: 0.75rem !important;\n  }\n  .gap-sm-1 {\n    gap: 1rem !important;\n  }\n  .gap-sm-2 {\n    gap: 1.5rem !important;\n  }\n  .gap-sm-3 {\n    gap: 3rem !important;\n  }\n  .gap-sm-4 {\n    gap: 3.5rem !important;\n  }\n  .gap-sm-5 {\n    gap: 4rem !important;\n  }\n  .row-gap-sm-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-sm-25 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-sm-50 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-sm-75 {\n    row-gap: 0.75rem !important;\n  }\n  .row-gap-sm-1 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-sm-2 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-sm-3 {\n    row-gap: 3rem !important;\n  }\n  .row-gap-sm-4 {\n    row-gap: 3.5rem !important;\n  }\n  .row-gap-sm-5 {\n    row-gap: 4rem !important;\n  }\n  .column-gap-sm-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-sm-25 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-sm-50 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-sm-75 {\n    column-gap: 0.75rem !important;\n  }\n  .column-gap-sm-1 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-sm-2 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-sm-3 {\n    column-gap: 3rem !important;\n  }\n  .column-gap-sm-4 {\n    column-gap: 3.5rem !important;\n  }\n  .column-gap-sm-5 {\n    column-gap: 4rem !important;\n  }\n  .text-sm-start {\n    text-align: left !important;\n  }\n  .text-sm-end {\n    text-align: right !important;\n  }\n  .text-sm-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 768px) {\n  .float-md-start {\n    float: left !important;\n  }\n  .float-md-end {\n    float: right !important;\n  }\n  .float-md-none {\n    float: none !important;\n  }\n  .object-fit-md-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-md-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-md-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-md-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-md-none {\n    object-fit: none !important;\n  }\n  .d-md-inline {\n    display: inline !important;\n  }\n  .d-md-inline-block {\n    display: inline-block !important;\n  }\n  .d-md-block {\n    display: block !important;\n  }\n  .d-md-grid {\n    display: grid !important;\n  }\n  .d-md-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-md-table {\n    display: table !important;\n  }\n  .d-md-table-row {\n    display: table-row !important;\n  }\n  .d-md-table-cell {\n    display: table-cell !important;\n  }\n  .d-md-flex {\n    display: flex !important;\n  }\n  .d-md-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-md-none {\n    display: none !important;\n  }\n  .flex-md-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-md-row {\n    flex-direction: row !important;\n  }\n  .flex-md-column {\n    flex-direction: column !important;\n  }\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-md-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-md-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-md-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-md-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-md-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-md-center {\n    justify-content: center !important;\n  }\n  .justify-content-md-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-md-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-md-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-md-start {\n    align-items: flex-start !important;\n  }\n  .align-items-md-end {\n    align-items: flex-end !important;\n  }\n  .align-items-md-center {\n    align-items: center !important;\n  }\n  .align-items-md-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-md-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-md-start {\n    align-content: flex-start !important;\n  }\n  .align-content-md-end {\n    align-content: flex-end !important;\n  }\n  .align-content-md-center {\n    align-content: center !important;\n  }\n  .align-content-md-between {\n    align-content: space-between !important;\n  }\n  .align-content-md-around {\n    align-content: space-around !important;\n  }\n  .align-content-md-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-md-auto {\n    align-self: auto !important;\n  }\n  .align-self-md-start {\n    align-self: flex-start !important;\n  }\n  .align-self-md-end {\n    align-self: flex-end !important;\n  }\n  .align-self-md-center {\n    align-self: center !important;\n  }\n  .align-self-md-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-md-stretch {\n    align-self: stretch !important;\n  }\n  .order-md-first {\n    order: -1 !important;\n  }\n  .order-md-0 {\n    order: 0 !important;\n  }\n  .order-md-1 {\n    order: 1 !important;\n  }\n  .order-md-2 {\n    order: 2 !important;\n  }\n  .order-md-3 {\n    order: 3 !important;\n  }\n  .order-md-4 {\n    order: 4 !important;\n  }\n  .order-md-5 {\n    order: 5 !important;\n  }\n  .order-md-last {\n    order: 6 !important;\n  }\n  .m-md-0 {\n    margin: 0 !important;\n  }\n  .m-md-25 {\n    margin: 0.25rem !important;\n  }\n  .m-md-50 {\n    margin: 0.5rem !important;\n  }\n  .m-md-75 {\n    margin: 0.75rem !important;\n  }\n  .m-md-1 {\n    margin: 1rem !important;\n  }\n  .m-md-2 {\n    margin: 1.5rem !important;\n  }\n  .m-md-3 {\n    margin: 3rem !important;\n  }\n  .m-md-4 {\n    margin: 3.5rem !important;\n  }\n  .m-md-5 {\n    margin: 4rem !important;\n  }\n  .m-md-auto {\n    margin: auto !important;\n  }\n  .mx-md-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-md-25 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-md-50 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-md-75 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n  .mx-md-1 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-md-2 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-md-3 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-md-4 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n  .mx-md-5 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n  .mx-md-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-md-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-md-25 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-md-50 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-md-75 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n  .my-md-1 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-md-2 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-md-3 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-md-4 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n  .my-md-5 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n  .my-md-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-md-0 {\n    margin-top: 0 !important;\n  }\n  .mt-md-25 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-md-50 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-md-75 {\n    margin-top: 0.75rem !important;\n  }\n  .mt-md-1 {\n    margin-top: 1rem !important;\n  }\n  .mt-md-2 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-md-3 {\n    margin-top: 3rem !important;\n  }\n  .mt-md-4 {\n    margin-top: 3.5rem !important;\n  }\n  .mt-md-5 {\n    margin-top: 4rem !important;\n  }\n  .mt-md-auto {\n    margin-top: auto !important;\n  }\n  .me-md-0 {\n    margin-right: 0 !important;\n  }\n  .me-md-25 {\n    margin-right: 0.25rem !important;\n  }\n  .me-md-50 {\n    margin-right: 0.5rem !important;\n  }\n  .me-md-75 {\n    margin-right: 0.75rem !important;\n  }\n  .me-md-1 {\n    margin-right: 1rem !important;\n  }\n  .me-md-2 {\n    margin-right: 1.5rem !important;\n  }\n  .me-md-3 {\n    margin-right: 3rem !important;\n  }\n  .me-md-4 {\n    margin-right: 3.5rem !important;\n  }\n  .me-md-5 {\n    margin-right: 4rem !important;\n  }\n  .me-md-auto {\n    margin-right: auto !important;\n  }\n  .mb-md-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-md-25 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-md-50 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-md-75 {\n    margin-bottom: 0.75rem !important;\n  }\n  .mb-md-1 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-md-2 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-md-3 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-md-4 {\n    margin-bottom: 3.5rem !important;\n  }\n  .mb-md-5 {\n    margin-bottom: 4rem !important;\n  }\n  .mb-md-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-md-0 {\n    margin-left: 0 !important;\n  }\n  .ms-md-25 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-md-50 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-md-75 {\n    margin-left: 0.75rem !important;\n  }\n  .ms-md-1 {\n    margin-left: 1rem !important;\n  }\n  .ms-md-2 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-md-3 {\n    margin-left: 3rem !important;\n  }\n  .ms-md-4 {\n    margin-left: 3.5rem !important;\n  }\n  .ms-md-5 {\n    margin-left: 4rem !important;\n  }\n  .ms-md-auto {\n    margin-left: auto !important;\n  }\n  .p-md-0 {\n    padding: 0 !important;\n  }\n  .p-md-25 {\n    padding: 0.25rem !important;\n  }\n  .p-md-50 {\n    padding: 0.5rem !important;\n  }\n  .p-md-75 {\n    padding: 0.75rem !important;\n  }\n  .p-md-1 {\n    padding: 1rem !important;\n  }\n  .p-md-2 {\n    padding: 1.5rem !important;\n  }\n  .p-md-3 {\n    padding: 3rem !important;\n  }\n  .p-md-4 {\n    padding: 3.5rem !important;\n  }\n  .p-md-5 {\n    padding: 4rem !important;\n  }\n  .px-md-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-md-25 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-md-50 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-md-75 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n  .px-md-1 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-md-2 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-md-3 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .px-md-4 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n  .px-md-5 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n  .py-md-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-md-25 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-md-50 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-md-75 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n  .py-md-1 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-md-2 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-md-3 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .py-md-4 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n  .py-md-5 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n  .pt-md-0 {\n    padding-top: 0 !important;\n  }\n  .pt-md-25 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-md-50 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-md-75 {\n    padding-top: 0.75rem !important;\n  }\n  .pt-md-1 {\n    padding-top: 1rem !important;\n  }\n  .pt-md-2 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-md-3 {\n    padding-top: 3rem !important;\n  }\n  .pt-md-4 {\n    padding-top: 3.5rem !important;\n  }\n  .pt-md-5 {\n    padding-top: 4rem !important;\n  }\n  .pe-md-0 {\n    padding-right: 0 !important;\n  }\n  .pe-md-25 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-md-50 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-md-75 {\n    padding-right: 0.75rem !important;\n  }\n  .pe-md-1 {\n    padding-right: 1rem !important;\n  }\n  .pe-md-2 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-md-3 {\n    padding-right: 3rem !important;\n  }\n  .pe-md-4 {\n    padding-right: 3.5rem !important;\n  }\n  .pe-md-5 {\n    padding-right: 4rem !important;\n  }\n  .pb-md-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-md-25 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-md-50 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-md-75 {\n    padding-bottom: 0.75rem !important;\n  }\n  .pb-md-1 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-md-2 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-md-3 {\n    padding-bottom: 3rem !important;\n  }\n  .pb-md-4 {\n    padding-bottom: 3.5rem !important;\n  }\n  .pb-md-5 {\n    padding-bottom: 4rem !important;\n  }\n  .ps-md-0 {\n    padding-left: 0 !important;\n  }\n  .ps-md-25 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-md-50 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-md-75 {\n    padding-left: 0.75rem !important;\n  }\n  .ps-md-1 {\n    padding-left: 1rem !important;\n  }\n  .ps-md-2 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-md-3 {\n    padding-left: 3rem !important;\n  }\n  .ps-md-4 {\n    padding-left: 3.5rem !important;\n  }\n  .ps-md-5 {\n    padding-left: 4rem !important;\n  }\n  .gap-md-0 {\n    gap: 0 !important;\n  }\n  .gap-md-25 {\n    gap: 0.25rem !important;\n  }\n  .gap-md-50 {\n    gap: 0.5rem !important;\n  }\n  .gap-md-75 {\n    gap: 0.75rem !important;\n  }\n  .gap-md-1 {\n    gap: 1rem !important;\n  }\n  .gap-md-2 {\n    gap: 1.5rem !important;\n  }\n  .gap-md-3 {\n    gap: 3rem !important;\n  }\n  .gap-md-4 {\n    gap: 3.5rem !important;\n  }\n  .gap-md-5 {\n    gap: 4rem !important;\n  }\n  .row-gap-md-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-md-25 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-md-50 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-md-75 {\n    row-gap: 0.75rem !important;\n  }\n  .row-gap-md-1 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-md-2 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-md-3 {\n    row-gap: 3rem !important;\n  }\n  .row-gap-md-4 {\n    row-gap: 3.5rem !important;\n  }\n  .row-gap-md-5 {\n    row-gap: 4rem !important;\n  }\n  .column-gap-md-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-md-25 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-md-50 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-md-75 {\n    column-gap: 0.75rem !important;\n  }\n  .column-gap-md-1 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-md-2 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-md-3 {\n    column-gap: 3rem !important;\n  }\n  .column-gap-md-4 {\n    column-gap: 3.5rem !important;\n  }\n  .column-gap-md-5 {\n    column-gap: 4rem !important;\n  }\n  .text-md-start {\n    text-align: left !important;\n  }\n  .text-md-end {\n    text-align: right !important;\n  }\n  .text-md-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 992px) {\n  .float-lg-start {\n    float: left !important;\n  }\n  .float-lg-end {\n    float: right !important;\n  }\n  .float-lg-none {\n    float: none !important;\n  }\n  .object-fit-lg-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-lg-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-lg-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-lg-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-lg-none {\n    object-fit: none !important;\n  }\n  .d-lg-inline {\n    display: inline !important;\n  }\n  .d-lg-inline-block {\n    display: inline-block !important;\n  }\n  .d-lg-block {\n    display: block !important;\n  }\n  .d-lg-grid {\n    display: grid !important;\n  }\n  .d-lg-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-lg-table {\n    display: table !important;\n  }\n  .d-lg-table-row {\n    display: table-row !important;\n  }\n  .d-lg-table-cell {\n    display: table-cell !important;\n  }\n  .d-lg-flex {\n    display: flex !important;\n  }\n  .d-lg-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-lg-none {\n    display: none !important;\n  }\n  .flex-lg-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-lg-row {\n    flex-direction: row !important;\n  }\n  .flex-lg-column {\n    flex-direction: column !important;\n  }\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-lg-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-lg-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-lg-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-lg-center {\n    justify-content: center !important;\n  }\n  .justify-content-lg-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-lg-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-lg-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-lg-start {\n    align-items: flex-start !important;\n  }\n  .align-items-lg-end {\n    align-items: flex-end !important;\n  }\n  .align-items-lg-center {\n    align-items: center !important;\n  }\n  .align-items-lg-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-lg-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-lg-start {\n    align-content: flex-start !important;\n  }\n  .align-content-lg-end {\n    align-content: flex-end !important;\n  }\n  .align-content-lg-center {\n    align-content: center !important;\n  }\n  .align-content-lg-between {\n    align-content: space-between !important;\n  }\n  .align-content-lg-around {\n    align-content: space-around !important;\n  }\n  .align-content-lg-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-lg-auto {\n    align-self: auto !important;\n  }\n  .align-self-lg-start {\n    align-self: flex-start !important;\n  }\n  .align-self-lg-end {\n    align-self: flex-end !important;\n  }\n  .align-self-lg-center {\n    align-self: center !important;\n  }\n  .align-self-lg-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-lg-stretch {\n    align-self: stretch !important;\n  }\n  .order-lg-first {\n    order: -1 !important;\n  }\n  .order-lg-0 {\n    order: 0 !important;\n  }\n  .order-lg-1 {\n    order: 1 !important;\n  }\n  .order-lg-2 {\n    order: 2 !important;\n  }\n  .order-lg-3 {\n    order: 3 !important;\n  }\n  .order-lg-4 {\n    order: 4 !important;\n  }\n  .order-lg-5 {\n    order: 5 !important;\n  }\n  .order-lg-last {\n    order: 6 !important;\n  }\n  .m-lg-0 {\n    margin: 0 !important;\n  }\n  .m-lg-25 {\n    margin: 0.25rem !important;\n  }\n  .m-lg-50 {\n    margin: 0.5rem !important;\n  }\n  .m-lg-75 {\n    margin: 0.75rem !important;\n  }\n  .m-lg-1 {\n    margin: 1rem !important;\n  }\n  .m-lg-2 {\n    margin: 1.5rem !important;\n  }\n  .m-lg-3 {\n    margin: 3rem !important;\n  }\n  .m-lg-4 {\n    margin: 3.5rem !important;\n  }\n  .m-lg-5 {\n    margin: 4rem !important;\n  }\n  .m-lg-auto {\n    margin: auto !important;\n  }\n  .mx-lg-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-lg-25 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-lg-50 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-lg-75 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n  .mx-lg-1 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-lg-2 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-lg-3 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-lg-4 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n  .mx-lg-5 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n  .mx-lg-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-lg-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-lg-25 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-lg-50 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-lg-75 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n  .my-lg-1 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-lg-2 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-lg-3 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-lg-4 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n  .my-lg-5 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n  .my-lg-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-lg-0 {\n    margin-top: 0 !important;\n  }\n  .mt-lg-25 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-lg-50 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-lg-75 {\n    margin-top: 0.75rem !important;\n  }\n  .mt-lg-1 {\n    margin-top: 1rem !important;\n  }\n  .mt-lg-2 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-lg-3 {\n    margin-top: 3rem !important;\n  }\n  .mt-lg-4 {\n    margin-top: 3.5rem !important;\n  }\n  .mt-lg-5 {\n    margin-top: 4rem !important;\n  }\n  .mt-lg-auto {\n    margin-top: auto !important;\n  }\n  .me-lg-0 {\n    margin-right: 0 !important;\n  }\n  .me-lg-25 {\n    margin-right: 0.25rem !important;\n  }\n  .me-lg-50 {\n    margin-right: 0.5rem !important;\n  }\n  .me-lg-75 {\n    margin-right: 0.75rem !important;\n  }\n  .me-lg-1 {\n    margin-right: 1rem !important;\n  }\n  .me-lg-2 {\n    margin-right: 1.5rem !important;\n  }\n  .me-lg-3 {\n    margin-right: 3rem !important;\n  }\n  .me-lg-4 {\n    margin-right: 3.5rem !important;\n  }\n  .me-lg-5 {\n    margin-right: 4rem !important;\n  }\n  .me-lg-auto {\n    margin-right: auto !important;\n  }\n  .mb-lg-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-lg-25 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-lg-50 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-lg-75 {\n    margin-bottom: 0.75rem !important;\n  }\n  .mb-lg-1 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-lg-2 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-lg-3 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-lg-4 {\n    margin-bottom: 3.5rem !important;\n  }\n  .mb-lg-5 {\n    margin-bottom: 4rem !important;\n  }\n  .mb-lg-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-lg-0 {\n    margin-left: 0 !important;\n  }\n  .ms-lg-25 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-lg-50 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-lg-75 {\n    margin-left: 0.75rem !important;\n  }\n  .ms-lg-1 {\n    margin-left: 1rem !important;\n  }\n  .ms-lg-2 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-lg-3 {\n    margin-left: 3rem !important;\n  }\n  .ms-lg-4 {\n    margin-left: 3.5rem !important;\n  }\n  .ms-lg-5 {\n    margin-left: 4rem !important;\n  }\n  .ms-lg-auto {\n    margin-left: auto !important;\n  }\n  .p-lg-0 {\n    padding: 0 !important;\n  }\n  .p-lg-25 {\n    padding: 0.25rem !important;\n  }\n  .p-lg-50 {\n    padding: 0.5rem !important;\n  }\n  .p-lg-75 {\n    padding: 0.75rem !important;\n  }\n  .p-lg-1 {\n    padding: 1rem !important;\n  }\n  .p-lg-2 {\n    padding: 1.5rem !important;\n  }\n  .p-lg-3 {\n    padding: 3rem !important;\n  }\n  .p-lg-4 {\n    padding: 3.5rem !important;\n  }\n  .p-lg-5 {\n    padding: 4rem !important;\n  }\n  .px-lg-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-lg-25 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-lg-50 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-lg-75 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n  .px-lg-1 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-lg-2 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-lg-3 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .px-lg-4 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n  .px-lg-5 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n  .py-lg-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-lg-25 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-lg-50 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-lg-75 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n  .py-lg-1 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-lg-2 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-lg-3 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .py-lg-4 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n  .py-lg-5 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n  .pt-lg-0 {\n    padding-top: 0 !important;\n  }\n  .pt-lg-25 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-lg-50 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-lg-75 {\n    padding-top: 0.75rem !important;\n  }\n  .pt-lg-1 {\n    padding-top: 1rem !important;\n  }\n  .pt-lg-2 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-lg-3 {\n    padding-top: 3rem !important;\n  }\n  .pt-lg-4 {\n    padding-top: 3.5rem !important;\n  }\n  .pt-lg-5 {\n    padding-top: 4rem !important;\n  }\n  .pe-lg-0 {\n    padding-right: 0 !important;\n  }\n  .pe-lg-25 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-lg-50 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-lg-75 {\n    padding-right: 0.75rem !important;\n  }\n  .pe-lg-1 {\n    padding-right: 1rem !important;\n  }\n  .pe-lg-2 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-lg-3 {\n    padding-right: 3rem !important;\n  }\n  .pe-lg-4 {\n    padding-right: 3.5rem !important;\n  }\n  .pe-lg-5 {\n    padding-right: 4rem !important;\n  }\n  .pb-lg-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-lg-25 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-lg-50 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-lg-75 {\n    padding-bottom: 0.75rem !important;\n  }\n  .pb-lg-1 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-lg-2 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-lg-3 {\n    padding-bottom: 3rem !important;\n  }\n  .pb-lg-4 {\n    padding-bottom: 3.5rem !important;\n  }\n  .pb-lg-5 {\n    padding-bottom: 4rem !important;\n  }\n  .ps-lg-0 {\n    padding-left: 0 !important;\n  }\n  .ps-lg-25 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-lg-50 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-lg-75 {\n    padding-left: 0.75rem !important;\n  }\n  .ps-lg-1 {\n    padding-left: 1rem !important;\n  }\n  .ps-lg-2 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-lg-3 {\n    padding-left: 3rem !important;\n  }\n  .ps-lg-4 {\n    padding-left: 3.5rem !important;\n  }\n  .ps-lg-5 {\n    padding-left: 4rem !important;\n  }\n  .gap-lg-0 {\n    gap: 0 !important;\n  }\n  .gap-lg-25 {\n    gap: 0.25rem !important;\n  }\n  .gap-lg-50 {\n    gap: 0.5rem !important;\n  }\n  .gap-lg-75 {\n    gap: 0.75rem !important;\n  }\n  .gap-lg-1 {\n    gap: 1rem !important;\n  }\n  .gap-lg-2 {\n    gap: 1.5rem !important;\n  }\n  .gap-lg-3 {\n    gap: 3rem !important;\n  }\n  .gap-lg-4 {\n    gap: 3.5rem !important;\n  }\n  .gap-lg-5 {\n    gap: 4rem !important;\n  }\n  .row-gap-lg-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-lg-25 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-lg-50 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-lg-75 {\n    row-gap: 0.75rem !important;\n  }\n  .row-gap-lg-1 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-lg-2 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-lg-3 {\n    row-gap: 3rem !important;\n  }\n  .row-gap-lg-4 {\n    row-gap: 3.5rem !important;\n  }\n  .row-gap-lg-5 {\n    row-gap: 4rem !important;\n  }\n  .column-gap-lg-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-lg-25 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-lg-50 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-lg-75 {\n    column-gap: 0.75rem !important;\n  }\n  .column-gap-lg-1 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-lg-2 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-lg-3 {\n    column-gap: 3rem !important;\n  }\n  .column-gap-lg-4 {\n    column-gap: 3.5rem !important;\n  }\n  .column-gap-lg-5 {\n    column-gap: 4rem !important;\n  }\n  .text-lg-start {\n    text-align: left !important;\n  }\n  .text-lg-end {\n    text-align: right !important;\n  }\n  .text-lg-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .float-xl-start {\n    float: left !important;\n  }\n  .float-xl-end {\n    float: right !important;\n  }\n  .float-xl-none {\n    float: none !important;\n  }\n  .object-fit-xl-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-xl-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-xl-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-xl-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-xl-none {\n    object-fit: none !important;\n  }\n  .d-xl-inline {\n    display: inline !important;\n  }\n  .d-xl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xl-block {\n    display: block !important;\n  }\n  .d-xl-grid {\n    display: grid !important;\n  }\n  .d-xl-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-xl-table {\n    display: table !important;\n  }\n  .d-xl-table-row {\n    display: table-row !important;\n  }\n  .d-xl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xl-flex {\n    display: flex !important;\n  }\n  .d-xl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xl-none {\n    display: none !important;\n  }\n  .flex-xl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xl-row {\n    flex-direction: row !important;\n  }\n  .flex-xl-column {\n    flex-direction: column !important;\n  }\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-xl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xl-center {\n    align-items: center !important;\n  }\n  .align-items-xl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xl-center {\n    align-content: center !important;\n  }\n  .align-content-xl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xl-center {\n    align-self: center !important;\n  }\n  .align-self-xl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xl-first {\n    order: -1 !important;\n  }\n  .order-xl-0 {\n    order: 0 !important;\n  }\n  .order-xl-1 {\n    order: 1 !important;\n  }\n  .order-xl-2 {\n    order: 2 !important;\n  }\n  .order-xl-3 {\n    order: 3 !important;\n  }\n  .order-xl-4 {\n    order: 4 !important;\n  }\n  .order-xl-5 {\n    order: 5 !important;\n  }\n  .order-xl-last {\n    order: 6 !important;\n  }\n  .m-xl-0 {\n    margin: 0 !important;\n  }\n  .m-xl-25 {\n    margin: 0.25rem !important;\n  }\n  .m-xl-50 {\n    margin: 0.5rem !important;\n  }\n  .m-xl-75 {\n    margin: 0.75rem !important;\n  }\n  .m-xl-1 {\n    margin: 1rem !important;\n  }\n  .m-xl-2 {\n    margin: 1.5rem !important;\n  }\n  .m-xl-3 {\n    margin: 3rem !important;\n  }\n  .m-xl-4 {\n    margin: 3.5rem !important;\n  }\n  .m-xl-5 {\n    margin: 4rem !important;\n  }\n  .m-xl-auto {\n    margin: auto !important;\n  }\n  .mx-xl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xl-25 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-xl-50 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-xl-75 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n  .mx-xl-1 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-xl-2 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xl-3 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-xl-4 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n  .mx-xl-5 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n  .mx-xl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xl-25 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-xl-50 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-xl-75 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n  .my-xl-1 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-xl-2 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xl-3 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-xl-4 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n  .my-xl-5 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n  .my-xl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xl-25 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-xl-50 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-xl-75 {\n    margin-top: 0.75rem !important;\n  }\n  .mt-xl-1 {\n    margin-top: 1rem !important;\n  }\n  .mt-xl-2 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xl-3 {\n    margin-top: 3rem !important;\n  }\n  .mt-xl-4 {\n    margin-top: 3.5rem !important;\n  }\n  .mt-xl-5 {\n    margin-top: 4rem !important;\n  }\n  .mt-xl-auto {\n    margin-top: auto !important;\n  }\n  .me-xl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xl-25 {\n    margin-right: 0.25rem !important;\n  }\n  .me-xl-50 {\n    margin-right: 0.5rem !important;\n  }\n  .me-xl-75 {\n    margin-right: 0.75rem !important;\n  }\n  .me-xl-1 {\n    margin-right: 1rem !important;\n  }\n  .me-xl-2 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xl-3 {\n    margin-right: 3rem !important;\n  }\n  .me-xl-4 {\n    margin-right: 3.5rem !important;\n  }\n  .me-xl-5 {\n    margin-right: 4rem !important;\n  }\n  .me-xl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xl-25 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-xl-50 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-xl-75 {\n    margin-bottom: 0.75rem !important;\n  }\n  .mb-xl-1 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-xl-2 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xl-3 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-xl-4 {\n    margin-bottom: 3.5rem !important;\n  }\n  .mb-xl-5 {\n    margin-bottom: 4rem !important;\n  }\n  .mb-xl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xl-25 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-xl-50 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-xl-75 {\n    margin-left: 0.75rem !important;\n  }\n  .ms-xl-1 {\n    margin-left: 1rem !important;\n  }\n  .ms-xl-2 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xl-3 {\n    margin-left: 3rem !important;\n  }\n  .ms-xl-4 {\n    margin-left: 3.5rem !important;\n  }\n  .ms-xl-5 {\n    margin-left: 4rem !important;\n  }\n  .ms-xl-auto {\n    margin-left: auto !important;\n  }\n  .p-xl-0 {\n    padding: 0 !important;\n  }\n  .p-xl-25 {\n    padding: 0.25rem !important;\n  }\n  .p-xl-50 {\n    padding: 0.5rem !important;\n  }\n  .p-xl-75 {\n    padding: 0.75rem !important;\n  }\n  .p-xl-1 {\n    padding: 1rem !important;\n  }\n  .p-xl-2 {\n    padding: 1.5rem !important;\n  }\n  .p-xl-3 {\n    padding: 3rem !important;\n  }\n  .p-xl-4 {\n    padding: 3.5rem !important;\n  }\n  .p-xl-5 {\n    padding: 4rem !important;\n  }\n  .px-xl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xl-25 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-xl-50 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-xl-75 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n  .px-xl-1 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-xl-2 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xl-3 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .px-xl-4 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n  .px-xl-5 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n  .py-xl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xl-25 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-xl-50 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-xl-75 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n  .py-xl-1 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-xl-2 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xl-3 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .py-xl-4 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n  .py-xl-5 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n  .pt-xl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xl-25 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-xl-50 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-xl-75 {\n    padding-top: 0.75rem !important;\n  }\n  .pt-xl-1 {\n    padding-top: 1rem !important;\n  }\n  .pt-xl-2 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xl-3 {\n    padding-top: 3rem !important;\n  }\n  .pt-xl-4 {\n    padding-top: 3.5rem !important;\n  }\n  .pt-xl-5 {\n    padding-top: 4rem !important;\n  }\n  .pe-xl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xl-25 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-xl-50 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-xl-75 {\n    padding-right: 0.75rem !important;\n  }\n  .pe-xl-1 {\n    padding-right: 1rem !important;\n  }\n  .pe-xl-2 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xl-3 {\n    padding-right: 3rem !important;\n  }\n  .pe-xl-4 {\n    padding-right: 3.5rem !important;\n  }\n  .pe-xl-5 {\n    padding-right: 4rem !important;\n  }\n  .pb-xl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xl-25 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-xl-50 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-xl-75 {\n    padding-bottom: 0.75rem !important;\n  }\n  .pb-xl-1 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-xl-2 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xl-3 {\n    padding-bottom: 3rem !important;\n  }\n  .pb-xl-4 {\n    padding-bottom: 3.5rem !important;\n  }\n  .pb-xl-5 {\n    padding-bottom: 4rem !important;\n  }\n  .ps-xl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xl-25 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-xl-50 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-xl-75 {\n    padding-left: 0.75rem !important;\n  }\n  .ps-xl-1 {\n    padding-left: 1rem !important;\n  }\n  .ps-xl-2 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xl-3 {\n    padding-left: 3rem !important;\n  }\n  .ps-xl-4 {\n    padding-left: 3.5rem !important;\n  }\n  .ps-xl-5 {\n    padding-left: 4rem !important;\n  }\n  .gap-xl-0 {\n    gap: 0 !important;\n  }\n  .gap-xl-25 {\n    gap: 0.25rem !important;\n  }\n  .gap-xl-50 {\n    gap: 0.5rem !important;\n  }\n  .gap-xl-75 {\n    gap: 0.75rem !important;\n  }\n  .gap-xl-1 {\n    gap: 1rem !important;\n  }\n  .gap-xl-2 {\n    gap: 1.5rem !important;\n  }\n  .gap-xl-3 {\n    gap: 3rem !important;\n  }\n  .gap-xl-4 {\n    gap: 3.5rem !important;\n  }\n  .gap-xl-5 {\n    gap: 4rem !important;\n  }\n  .row-gap-xl-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-xl-25 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-xl-50 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-xl-75 {\n    row-gap: 0.75rem !important;\n  }\n  .row-gap-xl-1 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-xl-2 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-xl-3 {\n    row-gap: 3rem !important;\n  }\n  .row-gap-xl-4 {\n    row-gap: 3.5rem !important;\n  }\n  .row-gap-xl-5 {\n    row-gap: 4rem !important;\n  }\n  .column-gap-xl-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-xl-25 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-xl-50 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-xl-75 {\n    column-gap: 0.75rem !important;\n  }\n  .column-gap-xl-1 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-xl-2 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-xl-3 {\n    column-gap: 3rem !important;\n  }\n  .column-gap-xl-4 {\n    column-gap: 3.5rem !important;\n  }\n  .column-gap-xl-5 {\n    column-gap: 4rem !important;\n  }\n  .text-xl-start {\n    text-align: left !important;\n  }\n  .text-xl-end {\n    text-align: right !important;\n  }\n  .text-xl-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1400px) {\n  .float-xxl-start {\n    float: left !important;\n  }\n  .float-xxl-end {\n    float: right !important;\n  }\n  .float-xxl-none {\n    float: none !important;\n  }\n  .object-fit-xxl-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-xxl-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-xxl-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-xxl-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-xxl-none {\n    object-fit: none !important;\n  }\n  .d-xxl-inline {\n    display: inline !important;\n  }\n  .d-xxl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xxl-block {\n    display: block !important;\n  }\n  .d-xxl-grid {\n    display: grid !important;\n  }\n  .d-xxl-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-xxl-table {\n    display: table !important;\n  }\n  .d-xxl-table-row {\n    display: table-row !important;\n  }\n  .d-xxl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xxl-flex {\n    display: flex !important;\n  }\n  .d-xxl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xxl-none {\n    display: none !important;\n  }\n  .flex-xxl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xxl-row {\n    flex-direction: row !important;\n  }\n  .flex-xxl-column {\n    flex-direction: column !important;\n  }\n  .flex-xxl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xxl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xxl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xxl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xxl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xxl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xxl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xxl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xxl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-xxl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xxl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xxl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xxl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xxl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xxl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xxl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xxl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xxl-center {\n    align-items: center !important;\n  }\n  .align-items-xxl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xxl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xxl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xxl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xxl-center {\n    align-content: center !important;\n  }\n  .align-content-xxl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xxl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xxl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xxl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xxl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xxl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xxl-center {\n    align-self: center !important;\n  }\n  .align-self-xxl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xxl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xxl-first {\n    order: -1 !important;\n  }\n  .order-xxl-0 {\n    order: 0 !important;\n  }\n  .order-xxl-1 {\n    order: 1 !important;\n  }\n  .order-xxl-2 {\n    order: 2 !important;\n  }\n  .order-xxl-3 {\n    order: 3 !important;\n  }\n  .order-xxl-4 {\n    order: 4 !important;\n  }\n  .order-xxl-5 {\n    order: 5 !important;\n  }\n  .order-xxl-last {\n    order: 6 !important;\n  }\n  .m-xxl-0 {\n    margin: 0 !important;\n  }\n  .m-xxl-25 {\n    margin: 0.25rem !important;\n  }\n  .m-xxl-50 {\n    margin: 0.5rem !important;\n  }\n  .m-xxl-75 {\n    margin: 0.75rem !important;\n  }\n  .m-xxl-1 {\n    margin: 1rem !important;\n  }\n  .m-xxl-2 {\n    margin: 1.5rem !important;\n  }\n  .m-xxl-3 {\n    margin: 3rem !important;\n  }\n  .m-xxl-4 {\n    margin: 3.5rem !important;\n  }\n  .m-xxl-5 {\n    margin: 4rem !important;\n  }\n  .m-xxl-auto {\n    margin: auto !important;\n  }\n  .mx-xxl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xxl-25 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-xxl-50 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-xxl-75 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n  .mx-xxl-1 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-xxl-2 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xxl-3 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-xxl-4 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n  .mx-xxl-5 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n  .mx-xxl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xxl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xxl-25 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-xxl-50 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-xxl-75 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n  .my-xxl-1 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-xxl-2 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xxl-3 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-xxl-4 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n  .my-xxl-5 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n  .my-xxl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xxl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xxl-25 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-xxl-50 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-xxl-75 {\n    margin-top: 0.75rem !important;\n  }\n  .mt-xxl-1 {\n    margin-top: 1rem !important;\n  }\n  .mt-xxl-2 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xxl-3 {\n    margin-top: 3rem !important;\n  }\n  .mt-xxl-4 {\n    margin-top: 3.5rem !important;\n  }\n  .mt-xxl-5 {\n    margin-top: 4rem !important;\n  }\n  .mt-xxl-auto {\n    margin-top: auto !important;\n  }\n  .me-xxl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xxl-25 {\n    margin-right: 0.25rem !important;\n  }\n  .me-xxl-50 {\n    margin-right: 0.5rem !important;\n  }\n  .me-xxl-75 {\n    margin-right: 0.75rem !important;\n  }\n  .me-xxl-1 {\n    margin-right: 1rem !important;\n  }\n  .me-xxl-2 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xxl-3 {\n    margin-right: 3rem !important;\n  }\n  .me-xxl-4 {\n    margin-right: 3.5rem !important;\n  }\n  .me-xxl-5 {\n    margin-right: 4rem !important;\n  }\n  .me-xxl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xxl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xxl-25 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-xxl-50 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-xxl-75 {\n    margin-bottom: 0.75rem !important;\n  }\n  .mb-xxl-1 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-xxl-2 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xxl-3 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-xxl-4 {\n    margin-bottom: 3.5rem !important;\n  }\n  .mb-xxl-5 {\n    margin-bottom: 4rem !important;\n  }\n  .mb-xxl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xxl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xxl-25 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-xxl-50 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-xxl-75 {\n    margin-left: 0.75rem !important;\n  }\n  .ms-xxl-1 {\n    margin-left: 1rem !important;\n  }\n  .ms-xxl-2 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xxl-3 {\n    margin-left: 3rem !important;\n  }\n  .ms-xxl-4 {\n    margin-left: 3.5rem !important;\n  }\n  .ms-xxl-5 {\n    margin-left: 4rem !important;\n  }\n  .ms-xxl-auto {\n    margin-left: auto !important;\n  }\n  .p-xxl-0 {\n    padding: 0 !important;\n  }\n  .p-xxl-25 {\n    padding: 0.25rem !important;\n  }\n  .p-xxl-50 {\n    padding: 0.5rem !important;\n  }\n  .p-xxl-75 {\n    padding: 0.75rem !important;\n  }\n  .p-xxl-1 {\n    padding: 1rem !important;\n  }\n  .p-xxl-2 {\n    padding: 1.5rem !important;\n  }\n  .p-xxl-3 {\n    padding: 3rem !important;\n  }\n  .p-xxl-4 {\n    padding: 3.5rem !important;\n  }\n  .p-xxl-5 {\n    padding: 4rem !important;\n  }\n  .px-xxl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xxl-25 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-xxl-50 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-xxl-75 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n  .px-xxl-1 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-xxl-2 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xxl-3 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .px-xxl-4 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n  .px-xxl-5 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n  .py-xxl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xxl-25 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-xxl-50 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-xxl-75 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n  .py-xxl-1 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-xxl-2 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xxl-3 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .py-xxl-4 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n  .py-xxl-5 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n  .pt-xxl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xxl-25 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-xxl-50 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-xxl-75 {\n    padding-top: 0.75rem !important;\n  }\n  .pt-xxl-1 {\n    padding-top: 1rem !important;\n  }\n  .pt-xxl-2 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xxl-3 {\n    padding-top: 3rem !important;\n  }\n  .pt-xxl-4 {\n    padding-top: 3.5rem !important;\n  }\n  .pt-xxl-5 {\n    padding-top: 4rem !important;\n  }\n  .pe-xxl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xxl-25 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-xxl-50 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-xxl-75 {\n    padding-right: 0.75rem !important;\n  }\n  .pe-xxl-1 {\n    padding-right: 1rem !important;\n  }\n  .pe-xxl-2 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xxl-3 {\n    padding-right: 3rem !important;\n  }\n  .pe-xxl-4 {\n    padding-right: 3.5rem !important;\n  }\n  .pe-xxl-5 {\n    padding-right: 4rem !important;\n  }\n  .pb-xxl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xxl-25 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-xxl-50 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-xxl-75 {\n    padding-bottom: 0.75rem !important;\n  }\n  .pb-xxl-1 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-xxl-2 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xxl-3 {\n    padding-bottom: 3rem !important;\n  }\n  .pb-xxl-4 {\n    padding-bottom: 3.5rem !important;\n  }\n  .pb-xxl-5 {\n    padding-bottom: 4rem !important;\n  }\n  .ps-xxl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xxl-25 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-xxl-50 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-xxl-75 {\n    padding-left: 0.75rem !important;\n  }\n  .ps-xxl-1 {\n    padding-left: 1rem !important;\n  }\n  .ps-xxl-2 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xxl-3 {\n    padding-left: 3rem !important;\n  }\n  .ps-xxl-4 {\n    padding-left: 3.5rem !important;\n  }\n  .ps-xxl-5 {\n    padding-left: 4rem !important;\n  }\n  .gap-xxl-0 {\n    gap: 0 !important;\n  }\n  .gap-xxl-25 {\n    gap: 0.25rem !important;\n  }\n  .gap-xxl-50 {\n    gap: 0.5rem !important;\n  }\n  .gap-xxl-75 {\n    gap: 0.75rem !important;\n  }\n  .gap-xxl-1 {\n    gap: 1rem !important;\n  }\n  .gap-xxl-2 {\n    gap: 1.5rem !important;\n  }\n  .gap-xxl-3 {\n    gap: 3rem !important;\n  }\n  .gap-xxl-4 {\n    gap: 3.5rem !important;\n  }\n  .gap-xxl-5 {\n    gap: 4rem !important;\n  }\n  .row-gap-xxl-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-xxl-25 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-xxl-50 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-xxl-75 {\n    row-gap: 0.75rem !important;\n  }\n  .row-gap-xxl-1 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-xxl-2 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-xxl-3 {\n    row-gap: 3rem !important;\n  }\n  .row-gap-xxl-4 {\n    row-gap: 3.5rem !important;\n  }\n  .row-gap-xxl-5 {\n    row-gap: 4rem !important;\n  }\n  .column-gap-xxl-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-xxl-25 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-xxl-50 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-xxl-75 {\n    column-gap: 0.75rem !important;\n  }\n  .column-gap-xxl-1 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-xxl-2 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-xxl-3 {\n    column-gap: 3rem !important;\n  }\n  .column-gap-xxl-4 {\n    column-gap: 3.5rem !important;\n  }\n  .column-gap-xxl-5 {\n    column-gap: 4rem !important;\n  }\n  .text-xxl-start {\n    text-align: left !important;\n  }\n  .text-xxl-end {\n    text-align: right !important;\n  }\n  .text-xxl-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .fs-1 {\n    font-size: 2rem !important;\n  }\n  .fs-2 {\n    font-size: 1.74rem !important;\n  }\n  .fs-3 {\n    font-size: 1.51rem !important;\n  }\n  .fs-4 {\n    font-size: 1.32rem !important;\n  }\n}\n@media print {\n  .d-print-inline {\n    display: inline !important;\n  }\n  .d-print-inline-block {\n    display: inline-block !important;\n  }\n  .d-print-block {\n    display: block !important;\n  }\n  .d-print-grid {\n    display: grid !important;\n  }\n  .d-print-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-print-table {\n    display: table !important;\n  }\n  .d-print-table-row {\n    display: table-row !important;\n  }\n  .d-print-table-cell {\n    display: table-cell !important;\n  }\n  .d-print-flex {\n    display: flex !important;\n  }\n  .d-print-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-print-none {\n    display: none !important;\n  }\n}\n/*========================================================\n        DARK LAYOUT\n=========================================================*/\nhtml {\n  font-size: 14px;\n  height: 100%;\n  letter-spacing: 0.01rem;\n}\nhtml body {\n  height: 100%;\n  background-color: #f8f8f8;\n  direction: ltr;\n  /*\n      * Blank page\n      */\n}\nhtml body .content {\n  padding: 0;\n  position: relative;\n  transition: 300ms ease all;\n  backface-visibility: hidden;\n  min-height: calc(100% - 4rem);\n  margin-left: 260px;\n}\nhtml body .content.app-content {\n  overflow: hidden;\n}\nhtml body .content.app-content.show-overlay .content-overlay {\n  z-index: 10;\n  opacity: 1;\n}\nhtml body .content.app-content.show-overlay .content-overlay ~ .header-navbar-shadow {\n  background: linear-gradient(180deg, rgba(44, 48, 60, 0.9) 44%, rgba(44, 48, 60, 0.43) 73%, rgba(44, 48, 60, 0));\n}\nhtml body .content.app-content .content-overlay {\n  position: fixed;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  cursor: pointer;\n  transition: all 0.7s;\n  z-index: -1;\n}\nhtml body .content.app-content .content-overlay.show {\n  z-index: 12;\n}\nhtml body .content.app-content .content-area-wrapper {\n  height: calc(100% - 5rem);\n  margin: calc(5rem + 2.7rem) 2.2rem 0;\n  display: flex;\n  position: relative;\n}\nhtml body .content.app-content .content-area-wrapper .content-wrapper {\n  margin-top: 0;\n  height: calc(100vh - 13rem);\n}\nhtml body .content .content-wrapper {\n  padding: calc(2.2rem - 0.4rem) 2.2rem 0;\n  margin-top: 6rem;\n  min-height: calc(100vh - 9.75rem);\n}\nhtml body .content .content-wrapper .content-header-title {\n  font-weight: 500;\n  color: #636363;\n  margin-right: 1rem;\n}\nhtml body .content .content-wrapper .content-header-right .dropdown-toggle::after {\n  display: none;\n}\nhtml body .content .content-wrapper .content-header-right .btn-icon {\n  padding: 0.8rem;\n}\nhtml body .vertical-layout.navbar-hidden .app-content .header-navbar-shadow {\n  display: none;\n}\nhtml body .vertical-layout.navbar-hidden .app-content .content-wrapper {\n  padding: 2.2rem;\n  margin-top: 0;\n  min-height: calc(100vh - 4rem);\n}\nhtml body .vertical-layout.navbar-hidden .app-content .content-area-wrapper {\n  padding: 0;\n  margin-top: 2.5rem;\n}\nhtml body .vertical-layout.navbar-static .app-content .header-navbar-shadow {\n  display: none;\n}\nhtml body .vertical-layout.navbar-static .app-content .navbar-container {\n  padding-left: 2.2rem;\n  padding-right: 1.2rem;\n}\nhtml body .vertical-layout.navbar-static .app-content .content-wrapper {\n  padding: 2.2rem;\n  margin-top: 0;\n  padding-top: 1rem;\n}\nhtml body .vertical-layout.navbar-static .app-content .content-area-wrapper {\n  margin-top: 1rem;\n}\nhtml body .vertical-layout.menu-collapsed .header-navbar.fixed-top {\n  left: 60px;\n  width: auto;\n}\nhtml body .vertical-layout.navbar-sticky .app-content .header-navbar-shadow {\n  display: none;\n}\nhtml body .vertical-layout.navbar-sticky .app-content .navbar-container {\n  padding-left: 2.2rem;\n  padding-right: 1rem;\n}\nhtml body .vertical-layout.navbar-sticky .app-content .content-wrapper {\n  padding: 2.2rem;\n  margin-top: 4.65rem;\n}\nhtml body .vertical-layout.navbar-static .navbar-container,\nhtml body .vertical-layout.navbar-sticky .navbar-container {\n  padding-left: 2.2rem;\n  padding-right: 1rem;\n}\nhtml body .vertical-layout.fixed-footer .app-content,\nhtml body .horizontal-layout.fixed-footer .app-content {\n  margin-bottom: 3rem;\n}\nhtml body .vertical-layout.fixed-footer .footer,\nhtml body .horizontal-layout.fixed-footer .footer {\n  position: fixed;\n  z-index: 1030;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background: #fff;\n  box-shadow: 0 -1px 4px 0 rgba(0, 0, 0, 0.15);\n}\nhtml body .vertical-layout .menu-swipe-area {\n  width: 30px;\n  position: fixed;\n  left: 0;\n  top: 0;\n  z-index: 1032;\n  height: 100vh;\n}\nhtml body p {\n  line-height: 1.5rem;\n}\nhtml body .bg-full-screen-image {\n  background: url(\"../../../img/pages/vuesax-login-bg.jpg\") no-repeat center center;\n  background-size: cover;\n}\nhtml body .blank-page .content {\n  margin-left: 0;\n}\nhtml body .blank-page .content.app-content {\n  overflow: overlay;\n  overflow-x: hidden;\n}\nhtml body .blank-page .content-wrapper {\n  padding: 0 !important;\n  margin-top: 0;\n}\nhtml body .blank-page .content-wrapper .flexbox-container {\n  display: flex;\n  align-items: center;\n  height: 100vh;\n  justify-content: center;\n  overflow: hidden;\n}\nhtml body[data-col=\"1-column\"] .content,\nhtml body[data-col=\"1-column\"] .footer {\n  margin-left: 0px !important;\n}\nhtml .pace .pace-progress {\n  background: #7367f0;\n}\n\n.app-content.center-layout {\n  overflow: hidden;\n}\n\n/*\n* Col 3 layout for detached and general type\n*/\n@media (min-width: 992px) {\n  body .content-right {\n    width: calc(100% - 260px);\n    float: right;\n  }\n  body .content-left {\n    width: calc(100% - 260px);\n    float: left;\n  }\n  body .content-detached {\n    width: 100%;\n  }\n  body .content-detached.content-right {\n    float: right;\n    margin-left: -260px;\n  }\n  body .content-detached.content-right .content-body {\n    margin-left: calc(260px + 2.2rem);\n  }\n  body .content-detached.content-left {\n    float: left;\n    margin-right: -260px;\n  }\n  body .content-detached.content-left .content-body {\n    margin-right: calc(260px + 2.2rem);\n  }\n  .sidebar-right.sidebar-sticky {\n    float: right !important;\n    margin-left: -260px;\n    width: 260px !important;\n    margin-top: 6rem;\n  }\n  [data-col=content-left-sidebar] .sticky-wrapper {\n    float: left;\n  }\n}\n.truncate {\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  white-space: nowrap !important;\n}\n\nhtml body .content .content-wrapper {\n  padding: calc(2.2rem - 0.4rem) calc(2.2rem - 1rem) 0;\n}\n\nbody.navbar-static .app-content .header-navbar .navbar-container, body.navbar-sticky .app-content .header-navbar .navbar-container {\n  padding-left: 1rem;\n  padding-right: 0.5rem;\n}\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  html.full-screen {\n    width: 100%;\n  }\n  html.full-screen .content.app-content {\n    height: 100%;\n    overflow: scroll;\n    overflow-x: hidden;\n  }\n}\n.vertical-layout .main-menu .navigation .menu-content li a svg:first-child {\n  margin-right: 1.38rem !important;\n}\n.vertical-layout .main-menu .navigation .menu-content li a .menu-toggle-icon {\n  right: 9px;\n}\n.vertical-layout.menu-collapsed .main-menu.collapsed {\n  width: 80px;\n  transition: 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n}\n.vertical-layout.menu-collapsed .main-menu.collapsed .badge,\n.vertical-layout.menu-collapsed .main-menu.collapsed svg.menu-toggle-icon,\n.vertical-layout.menu-collapsed .main-menu.collapsed .brand-text,\n.vertical-layout.menu-collapsed .main-menu.collapsed .navigation-header,\n.vertical-layout.menu-collapsed .main-menu.collapsed ul.menu-content {\n  display: none;\n}\n.vertical-layout.menu-collapsed .app-content {\n  margin-left: 80px;\n}\n.vertical-layout.menu-collapsed .app-content .header-navbar {\n  width: calc(100% - 4.4rem - 80px);\n}\n.vertical-layout.menu-collapsed .footer {\n  margin-left: 80px;\n}\n\n@media (max-width: 1200px) {\n  .vertical-layout .app-content {\n    margin-left: 0;\n  }\n  .vertical-layout .app-content .header-navbar.floating-nav {\n    width: calc(100% - 4.4rem) !important;\n  }\n  .vertical-layout .footer {\n    margin-left: 0;\n  }\n  .vertical-layout .main-menu:not(.hide-sidebar) ~ .sidenav-overlay {\n    display: block;\n  }\n}\n@media (max-width: 576px) {\n  .vertical-layout .app-content .header-navbar.floating-nav {\n    width: calc(100% - 2.4rem) !important;\n  }\n}\n/*=========================================================================================\n    File Name: sidebar.scss\n    Description: content sidebar specific scss.\n    ----------------------------------------------------------------------------------------\n    Item Name: Vuexy React admin Template\n    Version: 1.0\n    Author: PIXINVENT\n    Author URL: http://www.themeforest.net/user/pixinvent\n==========================================================================================*/\n.sidebar {\n  position: relative;\n  width: 100%;\n}\n@media (min-width: 992px) {\n  .sidebar {\n    vertical-align: top;\n  }\n}\n\n.sidebar-fixed {\n  position: fixed;\n  height: 100%;\n  overflow: scroll;\n}\n\n.sidenav-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 120vh;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 997;\n  display: none;\n}\n\n.drag-target {\n  height: 100%;\n  width: 40px;\n  position: fixed;\n  top: 0;\n  left: -10px;\n  z-index: 1036;\n}\n\n@media (min-width: 992px) {\n  .sidebar-left {\n    float: left;\n  }\n  .sidebar-right {\n    float: right;\n  }\n}\nfooter.footer {\n  padding: 1rem 2.2rem;\n}\nfooter.footer a {\n  margin: 0 0.3rem;\n}\nfooter.footer span svg {\n  margin-left: 0.5rem;\n}\nfooter.footer .scroll-top {\n  padding: 0.81rem 0.83rem;\n}\nfooter.navbar-shadow {\n  box-shadow: 0px -1px 4px 0px rgba(0, 0, 0, 0.15);\n}\nfooter.navbar-border {\n  border-top: 1px solid #e4e7ed;\n}\n\n.fixed-footer.footer-light {\n  background: #fff;\n  box-shadow: 0px -1px 4px 0px rgba(0, 0, 0, 0.15);\n}\n.fixed-footer.footer-dark {\n  background: #b8c2cc;\n  color: #fff;\n}\n\n.scroll-top {\n  position: fixed;\n  bottom: 5%;\n  right: 30px;\n  z-index: 99;\n}\n\n@media (min-width: 992px) {\n  .footer {\n    margin-left: 260px;\n  }\n}\n/*=========================================================================================\n    File Name: navigations.scss\n    Description: Common mixin for menus, contain dark and light version scss.\n    ----------------------------------------------------------------------------------------\n    Item Name: Vuexy React  admin Template\n    Version: 1.0\n    Author: PIXINVENT\n    Author URL: http://www.themeforest.net/user/pixinvent\n==========================================================================================*/\n.main-menu {\n  z-index: 1031;\n  position: absolute;\n  display: table-cell;\n  height: 100%;\n  overflow: hidden;\n  width: 260px;\n  transition: width 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n}\n.main-menu.menu-light {\n  color: #626262;\n  background: #fff;\n}\n.main-menu.menu-light .main-menu-header {\n  padding: 20px;\n}\n.main-menu.menu-light .main-menu-header .menu-search {\n  background: rgb(229.5, 229.5, 229.5);\n  padding: 0.5rem 1rem;\n  color: rgb(72.5, 72.5, 72.5);\n}\n.main-menu.menu-light .main-menu-header .menu-search:focus {\n  border-color: rgb(216.75, 216.75, 216.75);\n}\n.main-menu.menu-light .navigation {\n  background: #fff;\n}\n.main-menu.menu-light .navigation .navigation-header {\n  color: rgb(152.825, 152.825, 152.825);\n  margin: calc(2.2rem - 0.2rem) 0 0.8rem 2.2rem;\n  padding: 0;\n  line-height: 1.5;\n  letter-spacing: 0.01rem;\n}\n.main-menu.menu-light .navigation .navigation-header span {\n  font-weight: 500;\n}\n.main-menu.menu-light .navigation li .menu-text {\n  width: 170px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.main-menu.menu-light .navigation li .menu-text:last-child {\n  width: 180px;\n}\n.main-menu.menu-light .navigation li.has-sub ul.menu-content {\n  padding: 7px;\n  margin: -7px -7px 0 -7px;\n  transition: height 0.25s ease;\n}\n.main-menu.menu-light .navigation li a {\n  color: rgb(85.505, 85.505, 85.505);\n  padding: 10px 15px;\n  line-height: 1.45;\n  transition: padding 0.35s ease 0s !important;\n}\n.main-menu.menu-light .navigation li a span.menu-sub-title {\n  color: rgb(174.5, 174.5, 174.5);\n}\n.main-menu.menu-light .navigation li a .badge {\n  box-shadow: 0 0 7px 3px rgba(0, 0, 0, 0.1);\n}\n.main-menu.menu-light .navigation li.hover > a {\n  padding-left: 25px;\n  transition: padding 0.35s ease 0s !important;\n}\n.main-menu.menu-light .navigation > li {\n  padding: 0 15px;\n}\n.main-menu.menu-light .navigation > li > a .label {\n  margin-top: 4px;\n  margin-right: 5px;\n}\n.main-menu.menu-light .navigation > li > a i {\n  position: relative;\n  top: 1px;\n}\n.main-menu.menu-light .navigation > li.open > a, .main-menu.menu-light .navigation > li.sidebar-group-active > a,\n.main-menu.menu-light .navigation > li ul.menu-content .sidebar-group-active > a,\n.main-menu.menu-light .navigation > li ul.menu-content .open > a {\n  color: rgb(72.5, 72.5, 72.5);\n  background: rgb(244.8, 244.8, 244.8);\n  transition: transform 0.25s ease 0s, -webkit-transform 0.25s ease 0s;\n  border-radius: 6px;\n  margin-bottom: 7px;\n}\n.main-menu.menu-light .navigation > li.open.open > a svg.menu-toggle-icon, .main-menu.menu-light .navigation > li.sidebar-group-active.open > a svg.menu-toggle-icon,\n.main-menu.menu-light .navigation > li ul.menu-content .sidebar-group-active.open > a svg.menu-toggle-icon,\n.main-menu.menu-light .navigation > li ul.menu-content .open.open > a svg.menu-toggle-icon {\n  transform: rotate(90deg);\n}\n.main-menu.menu-light .navigation > li:not(.open) > ul {\n  display: none;\n}\n.main-menu.menu-light .navigation > li.active > a {\n  color: #fff;\n  font-weight: 400;\n  border-radius: 4px;\n}\n.main-menu.menu-light .navigation > li .active {\n  background: rgb(239.7, 239.7, 239.7);\n}\n.main-menu.menu-light .navigation > li .active > a {\n  color: #7367f0;\n  margin-bottom: 0;\n}\n.main-menu.menu-light .navigation > li .active .hover > a {\n  background: rgb(244.8, 244.8, 244.8);\n}\n.main-menu.menu-light .navigation > li ul {\n  padding: 0;\n  margin: 0;\n}\n.main-menu.menu-light .navigation > li ul li {\n  color: #626262;\n  background: transparent;\n}\n.main-menu.menu-light .navigation > li ul li > a {\n  padding: 10px 15px 10px 20px;\n}\n.main-menu.menu-light .navigation > li ul .has-sub:not(.open) > ul {\n  display: none;\n}\n.main-menu.menu-light .navigation > li ul .open > a,\n.main-menu.menu-light .navigation > li ul .sidebar-group-active > a {\n  color: #626262;\n}\n.main-menu.menu-light .navigation > li ul .open > ul,\n.main-menu.menu-light .navigation > li ul .sidebar-group-active > ul {\n  display: block;\n}\n.main-menu.menu-light .navigation > li ul .open > ul .open > ul,\n.main-menu.menu-light .navigation > li ul .sidebar-group-active > ul .open > ul {\n  display: block;\n}\n.main-menu.menu-light .navigation > li ul .hover > a, .main-menu.menu-light .navigation > li ul:hover > a {\n  color: rgb(108.2, 108.2, 108.2);\n}\n.main-menu.menu-light .navigation > li ul .active {\n  background: linear-gradient(118deg, #7367f0, rgba(115, 103, 240, 0.7));\n  box-shadow: 0 0 10px 1px rgba(115, 103, 240, 0.7);\n  border-radius: 4px;\n}\n.main-menu.menu-light .navigation > li ul .active > a {\n  color: #fff;\n}\n.main-menu.menu-light .navigation > li > ul {\n  background: #fff;\n}\n.main-menu.menu-light ul.menu-popout {\n  background: #fff;\n}\n.main-menu.menu-light ul.menu-popout li a {\n  color: #626262;\n}\n.main-menu.menu-light ul.menu-popout li a span.menu-sub-title {\n  color: rgb(174.5, 174.5, 174.5);\n}\n.main-menu.menu-light ul.menu-popout li.hover > a, .main-menu.menu-light ul.menu-popout li:hover > a, .main-menu.menu-light ul.menu-popout li.open > a {\n  background: rgb(239.7, 239.7, 239.7);\n}\n.main-menu.menu-light ul.menu-popout .has-sub:not(.open) > ul {\n  display: none;\n}\n.main-menu.menu-light ul.menu-popout .open > a {\n  color: #626262;\n}\n.main-menu.menu-light ul.menu-popout .open > ul {\n  display: block;\n}\n.main-menu.menu-light ul.menu-popout .open > ul .open {\n  background: rgb(232.05, 232.05, 232.05);\n}\n.main-menu.menu-light ul.menu-popout .open > ul .open > ul {\n  display: block;\n  background: rgb(232.05, 232.05, 232.05);\n}\n.main-menu.menu-light ul.menu-popout .hover > a, .main-menu.menu-light ul.menu-popout:hover > a {\n  color: rgb(108.2, 108.2, 108.2);\n  background-color: rgb(244.8, 244.8, 244.8);\n}\n.main-menu.menu-light ul.menu-popout .active {\n  background: rgba(0, 0, 0, 0.06);\n}\n.main-menu.menu-light ul.menu-popout .active > a {\n  color: rgb(123.5, 123.5, 123.5);\n  background-color: rgb(244.8, 244.8, 244.8);\n}\n.main-menu.menu-light ul.menu-popout .active .hover > a,\n.main-menu.menu-light ul.menu-popout .active :hover > a {\n  background-color: transparent;\n}\n.main-menu.menu-dark {\n  color: #dcdcdc;\n  background: #10163a;\n}\n.main-menu.menu-dark .main-menu-header {\n  padding: 20px;\n}\n.main-menu.menu-dark .main-menu-header .menu-search {\n  background: rgb(4.972972973, 6.8378378378, 18.027027027);\n  padding: 0.5rem 1rem;\n  color: rgb(194.5, 194.5, 194.5);\n}\n.main-menu.menu-dark .main-menu-header .menu-search:focus {\n  border-color: black;\n}\n.main-menu.menu-dark .navigation {\n  background: #10163a;\n}\n.main-menu.menu-dark .navigation .navigation-header {\n  color: white;\n  margin: calc(2.2rem - 0.2rem) 0 0.8rem 2.2rem;\n  padding: 0;\n  line-height: 1.5;\n  letter-spacing: 0.01rem;\n}\n.main-menu.menu-dark .navigation .navigation-header span {\n  font-weight: 500;\n}\n.main-menu.menu-dark .navigation li .menu-text {\n  width: 170px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.main-menu.menu-dark .navigation li .menu-text:last-child {\n  width: 180px;\n}\n.main-menu.menu-dark .navigation li.has-sub ul.menu-content {\n  padding: 7px;\n  margin: -7px -7px 0 -7px;\n  transition: height 0.25s ease;\n}\n.main-menu.menu-dark .navigation li a {\n  color: rgb(207.505, 207.505, 207.505);\n  padding: 10px 15px;\n  line-height: 1.45;\n  transition: padding 0.35s ease 0s !important;\n}\n.main-menu.menu-dark .navigation li a span.menu-sub-title {\n  color: white;\n}\n.main-menu.menu-dark .navigation li a .badge {\n  box-shadow: 0 0 7px 3px rgba(0, 0, 0, 0.1);\n}\n.main-menu.menu-dark .navigation li.hover > a {\n  padding-left: 25px;\n  transition: padding 0.35s ease 0s !important;\n}\n.main-menu.menu-dark .navigation > li {\n  padding: 0 15px;\n}\n.main-menu.menu-dark .navigation > li > a .label {\n  margin-top: 4px;\n  margin-right: 5px;\n}\n.main-menu.menu-dark .navigation > li > a i {\n  position: relative;\n  top: 1px;\n}\n.main-menu.menu-dark .navigation > li.open > a, .main-menu.menu-dark .navigation > li.sidebar-group-active > a,\n.main-menu.menu-dark .navigation > li ul.menu-content .sidebar-group-active > a,\n.main-menu.menu-dark .navigation > li ul.menu-content .open > a {\n  color: rgb(194.5, 194.5, 194.5);\n  background: rgb(11.5891891892, 15.9351351351, 42.0108108108);\n  transition: transform 0.25s ease 0s, -webkit-transform 0.25s ease 0s;\n  border-radius: 6px;\n  margin-bottom: 7px;\n}\n.main-menu.menu-dark .navigation > li.open.open > a svg.menu-toggle-icon, .main-menu.menu-dark .navigation > li.sidebar-group-active.open > a svg.menu-toggle-icon,\n.main-menu.menu-dark .navigation > li ul.menu-content .sidebar-group-active.open > a svg.menu-toggle-icon,\n.main-menu.menu-dark .navigation > li ul.menu-content .open.open > a svg.menu-toggle-icon {\n  transform: rotate(90deg);\n}\n.main-menu.menu-dark .navigation > li:not(.open) > ul {\n  display: none;\n}\n.main-menu.menu-dark .navigation > li.active > a {\n  color: #fff;\n  font-weight: 400;\n  border-radius: 4px;\n}\n.main-menu.menu-dark .navigation > li .active {\n  background: rgb(9.3837837838, 12.9027027027, 34.0162162162);\n}\n.main-menu.menu-dark .navigation > li .active > a {\n  color: #7367f0;\n  margin-bottom: 0;\n}\n.main-menu.menu-dark .navigation > li .active .hover > a {\n  background: rgb(11.5891891892, 15.9351351351, 42.0108108108);\n}\n.main-menu.menu-dark .navigation > li ul {\n  padding: 0;\n  margin: 0;\n}\n.main-menu.menu-dark .navigation > li ul li {\n  color: #dcdcdc;\n  background: transparent;\n}\n.main-menu.menu-dark .navigation > li ul li > a {\n  padding: 10px 15px 10px 20px;\n}\n.main-menu.menu-dark .navigation > li ul .has-sub:not(.open) > ul {\n  display: none;\n}\n.main-menu.menu-dark .navigation > li ul .open > a,\n.main-menu.menu-dark .navigation > li ul .sidebar-group-active > a {\n  color: #dcdcdc;\n}\n.main-menu.menu-dark .navigation > li ul .open > ul,\n.main-menu.menu-dark .navigation > li ul .sidebar-group-active > ul {\n  display: block;\n}\n.main-menu.menu-dark .navigation > li ul .open > ul .open > ul,\n.main-menu.menu-dark .navigation > li ul .sidebar-group-active > ul .open > ul {\n  display: block;\n}\n.main-menu.menu-dark .navigation > li ul .hover > a, .main-menu.menu-dark .navigation > li ul:hover > a {\n  color: rgb(230.2, 230.2, 230.2);\n}\n.main-menu.menu-dark .navigation > li ul .active {\n  background: linear-gradient(118deg, #7367f0, rgba(115, 103, 240, 0.7));\n  box-shadow: 0 0 10px 1px rgba(115, 103, 240, 0.7);\n  border-radius: 4px;\n}\n.main-menu.menu-dark .navigation > li ul .active > a {\n  color: #fff;\n}\n.main-menu.menu-dark .navigation > li > ul {\n  background: #10163a;\n}\n.main-menu.menu-dark ul.menu-popout {\n  background: #10163a;\n}\n.main-menu.menu-dark ul.menu-popout li a {\n  color: #dcdcdc;\n}\n.main-menu.menu-dark ul.menu-popout li a span.menu-sub-title {\n  color: white;\n}\n.main-menu.menu-dark ul.menu-popout li.hover > a, .main-menu.menu-dark ul.menu-popout li:hover > a, .main-menu.menu-dark ul.menu-popout li.open > a {\n  background: rgb(9.3837837838, 12.9027027027, 34.0162162162);\n}\n.main-menu.menu-dark ul.menu-popout .has-sub:not(.open) > ul {\n  display: none;\n}\n.main-menu.menu-dark ul.menu-popout .open > a {\n  color: #dcdcdc;\n}\n.main-menu.menu-dark ul.menu-popout .open > ul {\n  display: block;\n}\n.main-menu.menu-dark ul.menu-popout .open > ul .open {\n  background: rgb(6.0756756757, 8.3540540541, 22.0243243243);\n}\n.main-menu.menu-dark ul.menu-popout .open > ul .open > ul {\n  display: block;\n  background: rgb(6.0756756757, 8.3540540541, 22.0243243243);\n}\n.main-menu.menu-dark ul.menu-popout .hover > a, .main-menu.menu-dark ul.menu-popout:hover > a {\n  color: rgb(230.2, 230.2, 230.2);\n  background-color: rgb(11.5891891892, 15.9351351351, 42.0108108108);\n}\n.main-menu.menu-dark ul.menu-popout .active {\n  background: rgba(0, 0, 0, 0.06);\n}\n.main-menu.menu-dark ul.menu-popout .active > a {\n  color: rgb(245.5, 245.5, 245.5);\n  background-color: rgb(11.5891891892, 15.9351351351, 42.0108108108);\n}\n.main-menu.menu-dark ul.menu-popout .active .hover > a,\n.main-menu.menu-dark ul.menu-popout .active :hover > a {\n  background-color: transparent;\n}\n.main-menu.menu-fixed {\n  position: fixed;\n  /* fallback if needed */\n}\n.main-menu.menu-fixed .main-menu-footer {\n  position: fixed;\n}\n.main-menu.menu-static {\n  height: auto;\n  padding-bottom: calc(100% - 35rem);\n}\n.main-menu.menu-static .main-menu-content {\n  height: unset !important;\n}\n.main-menu.menu-shadow {\n  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.05);\n}\n.main-menu.menu-border {\n  border-right: 1px solid #e4e7ed;\n}\n.main-menu .shadow-bottom {\n  position: absolute;\n  z-index: 2;\n  height: 60px;\n  width: 100%;\n  pointer-events: none;\n  margin-top: -1.3rem;\n  margin-left: -1rem;\n  filter: blur(5px);\n  background: linear-gradient(#fff 41%, hsla(0, 0%, 100%, 0.11) 95%, hsla(0, 0%, 100%, 0));\n}\n.main-menu.menu-native-scroll .main-menu-content {\n  overflow-y: scroll;\n}\n.main-menu .navbar-header {\n  height: 100%;\n  width: 260px;\n  height: 5rem;\n  position: relative;\n  padding: 0.35rem 1rem 0.3rem 1.64rem;\n  transition: 300ms ease all;\n}\n.main-menu .navbar-header .navbar-brand {\n  display: flex;\n  align-items: center;\n  margin-top: 1.35rem;\n}\n.main-menu .navbar-header .navbar-brand .brand-logo {\n  background: url(\"../../../img/logo/vuesax-logo.png\") no-repeat;\n  background-position: -65px -54px;\n  height: 24px;\n  width: 35px;\n}\n.main-menu .navbar-header .navbar-brand .brand-text {\n  color: #7367f0;\n  padding-left: 1rem;\n  font-weight: 600;\n  letter-spacing: 0.01rem;\n  font-size: 1.57rem;\n  animation: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) 0s normal forwards 1 fadein;\n}\n.main-menu .navbar-header .modern-nav-toggle {\n  animation: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) 0s normal forwards 1 fadein;\n}\n.main-menu .main-menu-content {\n  height: calc(100% - 6rem) !important;\n  position: relative;\n  transition: all 0.25s ease;\n}\n.main-menu .main-menu-content .ps__rail-y:hover, .main-menu .main-menu-content.ps--active-y .ps__rail-y {\n  background-color: transparent !important;\n}\n.main-menu ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.main-menu ul.navigation-main {\n  overflow-x: hidden;\n}\n.main-menu ul.navigation-main > li:first-child {\n  margin-top: 0.5rem;\n}\n.main-menu ul.navigation-main .nav-item svg:first-child {\n  margin-right: 1rem;\n  position: relative;\n  top: -1px;\n}\n.main-menu ul.navigation-main .nav-item svg.menu-toggle-icon {\n  position: absolute;\n  right: 22px;\n  top: 15px;\n  transition: all 0.25s ease;\n}\n.main-menu a {\n  outline: none;\n}\n.main-menu a:hover, .main-menu a:focus {\n  text-decoration: none;\n}\n.main-menu.hide-sidebar {\n  transform: translateX(-100%);\n  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n}\n.main-menu:not(.hide-sidebar) {\n  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n}\n\n.navigation {\n  font-size: 1.1rem;\n  font-family: \"Montserrat\", Helvetica, Arial, serif;\n  font-weight: 400;\n  overflow-y: hidden;\n  padding-bottom: 20px;\n}\n.navigation .navigation-header {\n  font-family: \"Montserrat\", Helvetica, Arial, serif;\n  font-weight: 500;\n  line-height: 1.2;\n  padding: 12px 22px;\n  font-size: 0.9rem;\n  text-transform: uppercase;\n}\n.navigation li {\n  position: relative;\n  white-space: nowrap;\n}\n.navigation li a {\n  display: block;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.navigation li.disabled {\n  pointer-events: none;\n  cursor: not-allowed;\n}\n.navigation .nav-item.active a {\n  background: linear-gradient(118deg, #7367f0, rgba(115, 103, 240, 0.7));\n  box-shadow: 0 0 10px 1px rgba(115, 103, 240, 0.7) !important;\n}\n.navigation .nav-item .menu-content li.active {\n  background: linear-gradient(118deg, #7367f0, rgba(115, 103, 240, 0.7));\n  box-shadow: 0 0 10px 1px rgba(115, 103, 240, 0.7) !important;\n}\n\n.menu-popout li.disabled a {\n  cursor: not-allowed;\n}\n\n.dropdown-notification .nav-link-label {\n  position: relative;\n}\n.dropdown-notification .notification-text {\n  margin-bottom: 0.25rem;\n  font-size: smaller;\n  color: #626262;\n}\n.dropdown-notification .notification-title {\n  color: rgba(255, 255, 255, 0.75);\n}\n.dropdown-notification .notification-tag {\n  position: relative;\n  top: -4px;\n}\n.dropdown-notification .dropdown-menu.dropdown-menu-right {\n  right: -2px;\n  padding: 0;\n}\n.dropdown-notification .dropdown-menu.dropdown-menu-right::before {\n  background: #7367f0;\n  border-color: #7367f0;\n}\n.dropdown-notification .dropdown-menu-header {\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n  background: #7367f0;\n  color: #fff;\n  text-align: center;\n}\n.dropdown-notification .dropdown-menu-header .dropdown-header h3, .dropdown-notification .dropdown-menu-header .dropdown-header .h3 {\n  margin-bottom: 0.25rem;\n}\n\n.horizontal-layout.theme-primary .navbar-container .brand-logo,\n.horizontal-layout.theme-primary .navbar-header .brand-logo,\n.vertical-layout.theme-primary .navbar-container .brand-logo,\n.vertical-layout.theme-primary .navbar-header .brand-logo {\n  background-position: -65px -54px !important;\n}\n.horizontal-layout.theme-success .navbar-container .brand-logo,\n.horizontal-layout.theme-success .navbar-header .brand-logo,\n.vertical-layout.theme-success .navbar-container .brand-logo,\n.vertical-layout.theme-success .navbar-header .brand-logo {\n  background-position: -120px -10px !important;\n}\n.horizontal-layout.theme-danger .navbar-container .brand-logo,\n.horizontal-layout.theme-danger .navbar-header .brand-logo,\n.vertical-layout.theme-danger .navbar-container .brand-logo,\n.vertical-layout.theme-danger .navbar-header .brand-logo {\n  background-position: -10px -10px !important;\n}\n.horizontal-layout.theme-info .navbar-container .brand-logo,\n.horizontal-layout.theme-info .navbar-header .brand-logo,\n.vertical-layout.theme-info .navbar-container .brand-logo,\n.vertical-layout.theme-info .navbar-header .brand-logo {\n  background-position: -10px -54px !important;\n}\n.horizontal-layout.theme-warning .navbar-container .brand-logo,\n.horizontal-layout.theme-warning .navbar-header .brand-logo,\n.vertical-layout.theme-warning .navbar-container .brand-logo,\n.vertical-layout.theme-warning .navbar-header .brand-logo {\n  background-position: -120px -54px !important;\n}\n.horizontal-layout.theme-dark .navbar-container .brand-logo,\n.horizontal-layout.theme-dark .navbar-header .brand-logo,\n.vertical-layout.theme-dark .navbar-container .brand-logo,\n.vertical-layout.theme-dark .navbar-header .brand-logo {\n  background-position: -65px -10px !important;\n}\n\n.main-menu-header .user-content {\n  padding: 20px;\n}\n.main-menu-header .user-content .media {\n  overflow: inherit;\n}\n.main-menu-header .user-content .media-body {\n  vertical-align: bottom;\n  opacity: 1;\n  width: 150px;\n  white-space: nowrap;\n  transition: all 0.3s ease 0.15s;\n}\n\n.main-menu-footer {\n  position: relative;\n  overflow: hidden;\n  bottom: 0;\n  display: block;\n  z-index: 1000;\n  color: white;\n  background-color: rgb(154.3196721311, 168.5, 182.6803278689);\n}\n.main-menu-footer.footer-open {\n  max-height: 500px;\n  transition: max-height 0.2s ease-in-out;\n}\n.main-menu-footer a {\n  color: white;\n}\n.main-menu-footer a:hover, .main-menu-footer a:focus {\n  color: #fff;\n}\n.main-menu-footer .header {\n  height: 19px;\n  border-bottom: 1px solid rgb(169.1598360656, 181.25, 193.3401639344);\n}\n.main-menu-footer .toggle {\n  transform: rotate(0deg);\n  transition: -webkit-transform 0.2s ease-in-out;\n}\n.main-menu-footer .content {\n  padding: 0;\n}\n.main-menu-footer .content .actions > a {\n  display: block;\n  float: left;\n  width: 33.3333333333%;\n  padding: 1rem 0;\n  color: white;\n  text-align: center;\n  border-top: 1px solid rgb(169.1598360656, 181.25, 193.3401639344);\n  border-left: 1px solid rgb(169.1598360656, 181.25, 193.3401639344);\n}\n.main-menu-footer .content .actions > a > span {\n  font-size: 1.35rem;\n}\n.main-menu-footer .content .actions > a:hover, .main-menu-footer .content .actions > a:focus {\n  color: #fff;\n}\n\nbody .main-menu-footer .content {\n  margin-left: 0;\n}\n\nbody.menu-collapsed .menu-static {\n  padding-bottom: calc(100% - 14rem);\n}\n\n@media (max-width: 575.98px) {\n  .menu-hide .main-menu,\n  .menu-open .main-menu {\n    transition: transform 0.25s, top 0.35s, height 0.35s;\n  }\n  .main-menu {\n    backface-visibility: hidden;\n    perspective: 1000;\n  }\n  .main-menu:not(.hide-sidebar) {\n    transform: translate3d(0);\n    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n  }\n  .menu-open .main-menu {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@media (min-width: 768px) {\n  .drag-target {\n    z-index: 0;\n  }\n}\nbody .vertical-layout.fixed-footer .main-menu.menu-fixed {\n  height: 100%;\n}\n\n@media (max-width: 768px) {\n  body .main-menu.menu-static {\n    padding-bottom: 100%;\n  }\n}\n/*=========================================================================================\n\tFile Name: horizontal-menu.scss\n\tDescription: A classic horizontal menu for easy navingation & support all devices.\n\tIt support light & dark version, filpped layout, right side icons, borders menu for\n\titem seperation.\n\t----------------------------------------------------------------------------------------\n\tItem Name: Vuexy  - Vuejs, HTML & Laravel admin Dashboard TemplateTheme\n\tAuthor: PIXINVENT\n\tAuthor URL: http://www.themeforest.net/user/pixinvent\n==========================================================================================*/\n/*========================================================\n        DARK LAYOUT\n=========================================================*/\n.horizontal-layout.navbar-floating .app-content {\n  padding-top: 9.75rem;\n}\n.horizontal-layout .content {\n  margin-left: 0;\n}\n.horizontal-layout .content .content-wrapper {\n  margin-top: 0 !important;\n  min-height: calc(100vh - 13.75rem);\n}\n.horizontal-layout footer {\n  position: static;\n  margin-left: 0;\n}\n.horizontal-layout .header-navbar.fixed-top {\n  left: 0;\n}\n.horizontal-layout .header-navbar .brand-logo {\n  background: url(\"../../../img/logo/vuesax-logo.png\") no-repeat;\n  background-position: -65px -54px;\n  height: 24px;\n  width: 35px;\n}\n.horizontal-layout .header-navbar .navbar-nav.float-right .nav-item:not(:last-child) a.nav-link {\n  margin-right: 4px;\n}\n.horizontal-layout .header-navbar .navbar-nav.float-right .nav-item:not(:last-child) .dropdown-notification .nav-link {\n  margin-right: 10px;\n}\n.horizontal-layout ul#main-menu-navigation > li {\n  line-height: 1;\n}\n.horizontal-layout ul#main-menu-navigation > li.active .nav-link {\n  background: linear-gradient(118deg, #7367f0, rgba(115, 103, 240, 0.7));\n  box-shadow: 0px 0px 6px 1px rgba(115, 103, 240, 0.6);\n  color: #fff !important;\n  border-radius: 4px;\n}\n.horizontal-layout ul#main-menu-navigation > li.active .nav-link .dropdown-menu .active {\n  background-color: #f8f8f8;\n}\n.horizontal-layout ul#main-menu-navigation > li.nav-item:not(:last-child) .nav-link.dropdown {\n  margin-right: 4px;\n}\n.horizontal-layout ul#main-menu-navigation > li .single-item {\n  padding-left: 11px !important;\n  padding-right: 11px !important;\n}\n.horizontal-layout ul#main-menu-navigation > li .single-item .nav-link {\n  color: #626262;\n  padding: 0.75rem 1.25rem !important;\n}\n.horizontal-layout ul#main-menu-navigation > li .dropdown:not(.sub-menu) {\n  padding-top: 0.965rem;\n  padding-bottom: 0.965rem;\n}\n.horizontal-layout ul#main-menu-navigation > li .dropdown:not(.sub-menu).nav-link {\n  padding: 0.75rem 1.25rem;\n}\n.horizontal-layout ul#main-menu-navigation > li .item-content {\n  color: #626262;\n}\n.horizontal-layout ul#main-menu-navigation > li .item-content span {\n  vertical-align: middle;\n}\n.horizontal-layout ul#main-menu-navigation > li .dropdown-text span:not(.menu-icon) {\n  vertical-align: bottom;\n}\n.horizontal-layout ul#main-menu-navigation > li .has-sub-arrow {\n  position: absolute;\n  right: 1rem;\n  top: 15px;\n}\n.horizontal-layout ul#main-menu-navigation > li .dropdown-menu {\n  margin-left: 0;\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  animation-name: slideIn;\n}\n.horizontal-layout ul#main-menu-navigation > li .dropdown-menu li:focus {\n  outline: none;\n}\n.horizontal-layout ul#main-menu-navigation > li .dropdown-menu .dropdown-item {\n  transition: padding 0.35s ease 0s !important;\n  line-height: 1;\n}\n.horizontal-layout ul#main-menu-navigation > li .dropdown-menu .dropdown-item:focus {\n  outline: 0;\n}\n.horizontal-layout ul#main-menu-navigation > li .dropdown-menu .dropdown-item.hover {\n  padding-left: 25px !important;\n  transition: padding 0.35s ease 0s !important;\n  background-color: transparent;\n  color: #626262;\n}\n.horizontal-layout ul#main-menu-navigation > li .dropdown-menu .dropdown-item.has-sub:focus {\n  outline: 0;\n}\n.horizontal-layout ul#main-menu-navigation > li .dropdown-menu .dropdown-item.has-sub.hover {\n  padding-left: 10px !important;\n  background-color: #f8f8f8;\n}\n.horizontal-layout ul#main-menu-navigation > li .dropdown-menu .dropdown-item.active {\n  background: #f8f8f8;\n}\n.horizontal-layout ul#main-menu-navigation > li .dropdown-menu .dropdown-item.active span,\n.horizontal-layout ul#main-menu-navigation > li .dropdown-menu .dropdown-item.active svg {\n  color: #7367f0 !important;\n  font-weight: 500;\n}\n.horizontal-layout ul#main-menu-navigation > li .dropdown-menu .open.active > a {\n  color: #626262;\n  font-weight: normal;\n}\n.horizontal-layout ul#main-menu-navigation > li .dropdown-menu .dropdown-item {\n  font-size: 1rem;\n  display: flex;\n  align-items: center;\n}\n.horizontal-layout ul#main-menu-navigation > li .dropdown-menu .dropdown-item:not(.has-sub) {\n  padding: 0.95rem 1.428rem;\n}\n.horizontal-layout ul#main-menu-navigation > li .dropdown-menu .dropdown-item:hover span,\n.horizontal-layout ul#main-menu-navigation > li .dropdown-menu .dropdown-item:hover svg {\n  color: #626262;\n}\n.horizontal-layout ul#main-menu-navigation > li .dropdown-menu .dropdown-item.has-sub {\n  padding: 0;\n}\n.horizontal-layout ul#main-menu-navigation > li .dropdown-menu .dropdown-item.has-sub .dropdown {\n  padding: 0.95rem 1.4rem;\n}\n.horizontal-layout ul#main-menu-navigation > li .dropdown-menu::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n}\n.horizontal-layout ul#main-menu-navigation > li .dropdown-menu::-webkit-scrollbar-thumb {\n  background: #dae1e7;\n  border-radius: 20px;\n}\n.horizontal-layout ul#main-menu-navigation > li .dropdown-menu::-webkit-scrollbar-track {\n  background: #f8f8f8;\n  border-radius: 30px;\n}\n.horizontal-layout ul#main-menu-navigation > li > .dropdown a {\n  display: flex;\n  margin-right: 0.5rem;\n  align-items: center;\n}\n.horizontal-layout ul#main-menu-navigation > li.hover .nav-link {\n  background: #f8f8f8;\n  border-radius: 4px;\n}\n.horizontal-layout ul#main-menu-navigation > li .nav-item-wrapper {\n  padding: 11px 0;\n}\n.horizontal-layout ul#main-menu-navigation > li .dropdown.has-active-child {\n  background-color: #f8f8f8;\n}\n.horizontal-layout ul#main-menu-navigation > li .dropdown-menu[x-placement=left-start], .horizontal-layout ul#main-menu-navigation > li .dropdown-menu[x-placement=left-start] .dropdown-menu {\n  left: -100%;\n  right: 100%;\n}\n.horizontal-layout.navbar-floating:not(.blank-page) .app-content {\n  padding-top: 9.75rem;\n}\n.horizontal-layout.navbar-floating .horizontal-menu-wrapper {\n  background: linear-gradient(to bottom, rgba(248, 248, 248, 0.95) 44%, rgba(248, 248, 248, 0.46) 73%, rgba(255, 255, 255, 0) 100%);\n  background-repeat: repeat-x;\n}\n.horizontal-layout.navbar-floating .horizontal-menu-wrapper .navbar-horizontal.floating-nav {\n  margin: 1.3rem 2.2rem 0;\n}\n.horizontal-layout.dark-layout .header-navbar {\n  background: inherit !important;\n}\n.horizontal-layout.dark-layout .horizontal-menu-wrapper {\n  background: linear-gradient(to bottom, rgba(37, 43, 71, 0.76) 44%, rgba(56, 53, 53, 0.46) 73%, rgba(255, 255, 255, 0) 100%);\n}\n.horizontal-layout.dark-layout .horizontal-menu-wrapper .header-navbar {\n  background: #10163a !important;\n}\n.horizontal-layout.dark-layout .horizontal-menu-wrapper .header-navbar.navbar-horizontal ul#main-menu-navigation > li:hover:not(.active) > a {\n  background: #262c49;\n}\n.horizontal-layout.navbar-sticky .app-content {\n  padding-top: 8.5rem;\n}\n.horizontal-layout.navbar-sticky .header-navbar {\n  background-color: #f8f8f8;\n  box-shadow: none;\n}\n.horizontal-layout.navbar-sticky .horizontal-menu-wrapper .navbar-horizontal.header-navbar.fixed-top {\n  left: 0;\n  top: 62px;\n  background-color: #fff;\n}\n.horizontal-layout.navbar-static .app-content {\n  padding-top: 2.5rem;\n}\n.horizontal-layout.navbar-static .header-navbar:not(.scrolling) {\n  background-color: #f8f8f8;\n  box-shadow: none;\n}\n.horizontal-layout.navbar-static .header-navbar:not(.scrolling) .navbar-wrapper {\n  width: 100%;\n}\n.horizontal-layout.navbar-static .horizontal-menu-wrapper {\n  position: relative;\n}\n.horizontal-layout.navbar-static .horizontal-menu-wrapper .navbar-horizontal.header-navbar {\n  background: #fff;\n}\n.horizontal-layout.navbar-static .horizontal-menu-wrapper .navbar-horizontal.header-navbar.navbar-static-top {\n  position: static;\n  background: #fff;\n  left: 0;\n}\n.horizontal-layout .horizontal-menu-wrapper {\n  position: fixed;\n  top: 62px;\n  z-index: 990;\n  width: 100%;\n  height: 99px;\n}\n.horizontal-layout .horizontal-menu-wrapper .header-navbar .navbar-container {\n  padding-left: 1rem;\n  padding-right: 1rem;\n  width: 100%;\n}\n.horizontal-layout .horizontal-menu-wrapper .header-navbar .navbar-header {\n  display: none;\n}\n.horizontal-layout .header-navbar {\n  background: #fff;\n  z-index: 999 !important;\n  line-height: 1;\n}\n.horizontal-layout .header-navbar.navbar-horizontal.floating-nav {\n  width: calc(100vw - (100vw - 100%) - 2.2rem * 2);\n  background: #fff;\n}\n.horizontal-layout .header-navbar .navbar-container {\n  padding-left: 2.2rem;\n  padding-right: calc(2.2rem - 1rem);\n  border-radius: 0.5rem;\n}\n.horizontal-layout .header-navbar.navbar-fixed {\n  position: fixed;\n  width: 100%;\n}\n.horizontal-layout .header-navbar.navbar-brand-center .navbar-header {\n  position: absolute;\n  left: 50%;\n  margin-left: -65px;\n  padding: 0;\n  z-index: 1000;\n}\n.horizontal-layout .header-navbar.navbar-brand-center .navbar-header .navbar-brand {\n  display: flex;\n  align-items: center;\n  margin-right: 0;\n}\n.horizontal-layout .header-navbar.navbar-brand-center .navbar-header .navbar-brand .brand-text {\n  color: #fff;\n  padding-left: 1rem;\n  letter-spacing: 0.01rem;\n  font-size: 1.57rem;\n}\n.horizontal-layout .header-navbar.navbar-horizontal .nav-link.dropdown-toggle::after {\n  left: 0.4rem;\n}\n.horizontal-layout .header-navbar.navbar-horizontal .dropdown-menu::before {\n  display: none;\n}\n.horizontal-layout .header-navbar.navbar-horizontal .dropdown-menu {\n  min-width: 215px;\n  border: none;\n  min-height: 52px;\n}\n.horizontal-layout .header-navbar.navbar-horizontal .dropdown-menu .disabled {\n  pointer-events: none !important;\n}\n.horizontal-layout .header-navbar.navbar-horizontal .dropdown-menu .disabled a {\n  color: #b8c2cc;\n}\n.horizontal-layout .header-navbar.navbar-horizontal .dropdown-menu .dropdown-toggle::after {\n  left: auto;\n  position: absolute;\n  top: 50%;\n  margin-top: -7px;\n  right: 1rem;\n  content: \"\\e844\" !important;\n}\n.horizontal-layout .header-navbar.navbar-horizontal .dropdown-menu .dropdown-submenu {\n  position: relative;\n}\n.horizontal-layout .header-navbar.navbar-horizontal .dropdown-menu .dropdown-submenu.openLeft .dropdown-menu {\n  left: auto;\n  right: 100%;\n}\n.horizontal-layout .header-navbar.navbar-horizontal .dropdown-menu .dropdown-submenu.show {\n  background: #f8f8f8;\n}\n.horizontal-layout .header-navbar.navbar-horizontal .dropdown-menu .dropdown-submenu > .dropdown-menu {\n  position: absolute;\n  top: 0 !important;\n  left: 100% !important;\n}\n.horizontal-layout .header-navbar.navbar-horizontal .dropdown-menu .dropdown-submenu > .dropdown-menu i {\n  font-size: 0.75rem !important;\n}\n.horizontal-layout.menu-collapsed #main-menu-navigation .nav-item > a span {\n  display: none;\n}\n.horizontal-layout .navigation-header {\n  font-family: inherit;\n  color: #929292;\n  padding: 8px 20px;\n  font-size: 1rem;\n  text-transform: uppercase;\n}\n.horizontal-layout .navbar-dark .nav-item.active > a {\n  border-bottom: 2px solid #7367f0;\n  background-color: #313c50;\n}\n.horizontal-layout .content.app-content .content-area-wrapper {\n  margin-top: 2.2rem;\n}\n.horizontal-layout .content.app-content .content-area-wrapper .content-wrapper {\n  height: calc(100vh - 16rem);\n  height: calc(var(--vh, 1vh) * 100 - 16rem);\n}\n.horizontal-layout.chat-application .sidebar-content, .horizontal-layout.email-application .content-area-wrapper .sidebar .email-app-sidebar, .horizontal-layout.todo-application .content-area-wrapper .sidebar .todo-sidebar {\n  height: calc(100vh - 16rem);\n  height: calc(var(--vh, 1vh) * 100 - 16rem);\n}\n.horizontal-layout.todo-application .content-area-wrapper .content-right .todo-task-list {\n  height: calc(100vh - 19.5rem);\n  height: calc(var(--vh, 1vh) * 100 - 19.5rem);\n}\n.horizontal-layout.email-application .app-content .content-area-wrapper .email-user-list {\n  height: calc(100vh - 23.3rem);\n  height: calc(var(--vh, 1vh) * 100 - 23.3rem);\n}\n.horizontal-layout.chat-application .user-profile-sidebar {\n  height: calc(100vh - 16.1rem);\n  height: calc(var(--vh, 1vh) * 100 - 16.1rem);\n  bottom: 4.1rem;\n}\n.horizontal-layout.chat-application .chat-profile-sidebar {\n  height: calc(100vh - 16rem);\n  height: calc(var(--vh, 1vh) * 100 - 16rem);\n}\n.horizontal-layout.chat-application .chat-app-window .user-chats {\n  height: calc(100vh - 26.5rem);\n  height: calc(var(--vh, 1vh) * 100 - 26.5rem);\n}\n\n@media (max-width: 991.98px) {\n  body.horizontal-layout.horizontal-menu .horizontal-menu-wrapper .header-navbar {\n    display: none;\n  }\n  body.horizontal-layout .header-navbar {\n    background: #fff;\n  }\n  body.horizontal-layout .content .content-wrapper {\n    margin-top: 5rem;\n  }\n}\n@media (max-width: 1230px) and (min-width: 1200px) {\n  .horizontal-layout .horizontal-menu-wrapper #main-menu-navigation .nav-item .nav-link a {\n    margin-right: 0;\n  }\n}\n@keyframes slideIn {\n  100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n  0% {\n    transform: translateY(1rem);\n    opacity: 0;\n  }\n}\n.display-inline {\n  display: inline !important;\n}\n\n.display-block {\n  display: block !important;\n}\n\n.display-inline-block {\n  display: inline-block !important;\n}\n\n.display-hidden {\n  display: none !important;\n}\n\n.display-table-cell {\n  display: table-cell !important;\n}\n\n.position-top-0 {\n  top: 0;\n}\n\n.position-right-0 {\n  right: 0;\n}\n\n.position-bottom-0 {\n  bottom: 0;\n}\n\n.position-left-0 {\n  left: 0;\n}\n\n.zindex-1 {\n  z-index: 1 !important;\n}\n\n.zindex-2 {\n  z-index: 2 !important;\n}\n\n.zindex-3 {\n  z-index: 3 !important;\n}\n\n.zindex-4 {\n  z-index: 4 !important;\n}\n\n.zindex-0 {\n  z-index: 0 !important;\n}\n\n.zindex-minus-1 {\n  z-index: -1 !important;\n}\n\n.zindex-minus-2 {\n  z-index: -2 !important;\n}\n\n.zindex-minus-3 {\n  z-index: -3 !important;\n}\n\n.zindex-minus-4 {\n  z-index: -4 !important;\n}\n\n.no-edge-top {\n  top: 0 !important;\n}\n\n.no-edge-bottom {\n  bottom: 0 !important;\n}\n\n.no-edge-left {\n  left: 0 !important;\n}\n\n.no-edge-right {\n  right: 0 !important;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-move {\n  cursor: move;\n}\n\n.cursor-default {\n  cursor: default;\n}\n\n.cursor-progress {\n  cursor: progress;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed;\n}\n\n.overflow-hidden {\n  overflow: hidden;\n}\n\n.overflow-visible {\n  overflow: visible;\n}\n\n.overflow-auto {\n  overflow: auto;\n}\n\n.overflow-scroll {\n  overflow: scroll;\n}\n\n.overflow-x-scroll {\n  overflow: scroll;\n}\n\n.overflow-y-scroll {\n  overflow: scroll;\n}\n\n.bullets-inside {\n  list-style: inside;\n}\n\n.list-style-circle {\n  list-style: circle;\n}\n\n.list-style-square {\n  list-style: square;\n}\n\n.list-style-icons {\n  padding-left: 10px;\n  margin-left: 0;\n  list-style: none;\n}\n.list-style-icons > li svg {\n  width: 1em;\n  margin: 0 6px 0 0;\n}\n\n.border {\n  border: 1px solid;\n}\n\n.border-top {\n  border-top: 1px solid;\n}\n\n.border-bottom {\n  border-bottom: 1px solid;\n}\n\n.border-left {\n  border-left: 1px solid;\n}\n\n.border-right {\n  border-right: 1px solid;\n}\n\n.border-2 {\n  border-width: 2px !important;\n}\n\n.border-top-2 {\n  border-top-width: 2px !important;\n}\n\n.border-bottom-2 {\n  border-bottom-width: 2px !important;\n}\n\n.border-left-2 {\n  border-left-width: 2px !important;\n}\n\n.border-right-2 {\n  border-right-width: 2px !important;\n}\n\n.border-3 {\n  border-width: 3px !important;\n}\n\n.border-top-3 {\n  border-top-width: 3px !important;\n}\n\n.border-bottom-3 {\n  border-bottom-width: 3px !important;\n}\n\n.border-left-3 {\n  border-left-width: 3px !important;\n}\n\n.border-right-3 {\n  border-right-width: 3px !important;\n}\n\n.no-border-top-radius {\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n}\n\n.no-border-bottom-radius {\n  border-bottom-left-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.no-border-top-left-radius {\n  border-top-left-radius: 0 !important;\n}\n\n.no-border-top-right-radius {\n  border-top-right-radius: 0 !important;\n}\n\n.no-border-bottom-left-radius {\n  border-bottom-left-radius: 0 !important;\n}\n\n.no-border-bottom-right-radius {\n  border-bottom-right-radius: 0 !important;\n}\n\n.box-shadow-0 {\n  box-shadow: none !important;\n}\n\n.box-shadow-1 {\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);\n}\n\n.box-shadow-2 {\n  box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n\n.box-shadow-3 {\n  box-shadow: 0 12px 15px 0 rgba(0, 0, 0, 0.24), 0 17px 50px 0 rgba(0, 0, 0, 0.19);\n}\n\n.box-shadow-4 {\n  box-shadow: 0 16px 28px 0 rgba(0, 0, 0, 0.22), 0 25px 55px 0 rgba(0, 0, 0, 0.21);\n}\n\n.box-shadow-5 {\n  box-shadow: 0 27px 24px 0 rgba(0, 0, 0, 0.2), 0 40px 77px 0 rgba(0, 0, 0, 0.22);\n}\n\n.box-shadow-6 {\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.08);\n}\n\n.fit {\n  max-width: 100% !important;\n}\n\n.half-width {\n  width: 50% !important;\n}\n\n.full-width {\n  width: 100% !important;\n}\n\n.full-height {\n  height: 100% !important;\n}\n\n.width-50 {\n  width: 50px !important;\n}\n\n.width-100 {\n  width: 100px !important;\n}\n\n.width-150 {\n  width: 150px !important;\n}\n\n.width-200 {\n  width: 200px !important;\n}\n\n.width-250 {\n  width: 250px !important;\n}\n\n.width-300 {\n  width: 300px !important;\n}\n\n.width-350 {\n  width: 350px !important;\n}\n\n.width-400 {\n  width: 400px !important;\n}\n\n.width-450 {\n  width: 450px !important;\n}\n\n.width-500 {\n  width: 500px !important;\n}\n\n.width-550 {\n  width: 550px !important;\n}\n\n.width-600 {\n  width: 600px !important;\n}\n\n.width-650 {\n  width: 650px !important;\n}\n\n.width-700 {\n  width: 700px !important;\n}\n\n.width-750 {\n  width: 750px !important;\n}\n\n.width-800 {\n  width: 800px !important;\n}\n\n.width-5-per {\n  width: 5% !important;\n}\n\n.width-10-per {\n  width: 10% !important;\n}\n\n.width-15-per {\n  width: 15% !important;\n}\n\n.width-20-per {\n  width: 20% !important;\n}\n\n.width-25-per {\n  width: 25% !important;\n}\n\n.width-30-per {\n  width: 30% !important;\n}\n\n.width-35-per {\n  width: 35% !important;\n}\n\n.width-40-per {\n  width: 40% !important;\n}\n\n.width-45-per {\n  width: 45% !important;\n}\n\n.width-50-per {\n  width: 50% !important;\n}\n\n.width-55-per {\n  width: 55% !important;\n}\n\n.width-60-per {\n  width: 60% !important;\n}\n\n.width-65-per {\n  width: 65% !important;\n}\n\n.width-70-per {\n  width: 70% !important;\n}\n\n.width-75-per {\n  width: 75% !important;\n}\n\n.width-80-per {\n  width: 80% !important;\n}\n\n.width-90-per {\n  width: 90% !important;\n}\n\n.width-95-per {\n  width: 95% !important;\n}\n\n.height-50 {\n  height: 50px !important;\n}\n\n.height-75 {\n  height: 75px !important;\n}\n\n.height-100 {\n  height: 100px !important;\n}\n\n.height-150 {\n  height: 150px !important;\n}\n\n.height-200 {\n  height: 200px !important;\n}\n\n.height-250 {\n  height: 250px !important;\n}\n\n.height-300 {\n  height: 300px !important;\n}\n\n.height-350 {\n  height: 350px !important;\n}\n\n.height-400 {\n  height: 400px !important;\n}\n\n.height-450 {\n  height: 450px !important;\n}\n\n.height-500 {\n  height: 500px !important;\n}\n\n.height-550 {\n  height: 550px !important;\n}\n\n.height-600 {\n  height: 600px !important;\n}\n\n.height-650 {\n  height: 650px !important;\n}\n\n.height-700 {\n  height: 700px !important;\n}\n\n.height-750 {\n  height: 750px !important;\n}\n\n.height-800 {\n  height: 800px !important;\n}\n\n.height-5-per {\n  height: 5% !important;\n}\n\n.height-10-per {\n  height: 10% !important;\n}\n\n.height-15-per {\n  height: 15% !important;\n}\n\n.height-20-per {\n  height: 20% !important;\n}\n\n.height-25-per {\n  height: 25% !important;\n}\n\n.height-30-per {\n  height: 30% !important;\n}\n\n.height-35-per {\n  height: 35% !important;\n}\n\n.height-40-per {\n  height: 40% !important;\n}\n\n.height-45-per {\n  height: 45% !important;\n}\n\n.height-50-per {\n  height: 50% !important;\n}\n\n.height-55-per {\n  height: 55% !important;\n}\n\n.height-60-per {\n  height: 60% !important;\n}\n\n.height-65-per {\n  height: 65% !important;\n}\n\n.height-70-per {\n  height: 70% !important;\n}\n\n.height-75-per {\n  height: 75% !important;\n}\n\n.height-80-per {\n  height: 80% !important;\n}\n\n.full-height-vh {\n  height: 100vh;\n}\n\n.line-height-1 {\n  line-height: 1 !important;\n}\n\n.line-height-2 {\n  line-height: 2 !important;\n}\n\n.rotate-45 {\n  transform: rotate(45deg);\n}\n\n.rotate-45-inverse {\n  transform: rotate(-45deg);\n}\n\n.rotate-90 {\n  transform: rotate(45deg);\n}\n\n.rotate-90-inverse {\n  transform: rotate(-45deg);\n}\n\n.rotate-180 {\n  transform: rotate(45deg);\n}\n\n.rotate-180-inverse {\n  transform: rotate(-45deg);\n}\n\n.pull-up {\n  transition: all 0.25s ease;\n}\n.pull-up:hover {\n  transform: translateY(-4px) scale(1.02);\n  box-shadow: 0px 14px 24px rgba(62, 57, 107, 0.2);\n  z-index: 30;\n}\n\n.spinner {\n  display: inline-block;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.spinner-reverse {\n  display: inline-block;\n  animation: spin-reverse 1s linear infinite;\n}\n\n@keyframes spin-reverse {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(-360deg);\n  }\n}\n.bg-cover {\n  background-size: cover !important;\n}\n\n.background-repeat {\n  background-repeat: repeat !important;\n}\n\n.background-no-repeat {\n  background-repeat: no-repeat !important;\n}\n\n.img-xl {\n  width: 64px !important;\n  height: 64px !important;\n}\n\n.img-lg {\n  width: 44px !important;\n  height: 44px !important;\n}\n\n.img-sm {\n  width: 36px !important;\n  height: 36px !important;\n}\n\n.img-xs {\n  width: 32px !important;\n  height: 32px !important;\n}\n\n.bullet {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  display: inline-block;\n}\n.bullet.bullet-xs {\n  width: 0.5rem;\n  height: 0.5rem;\n}\n.bullet.bullet-sm {\n  width: 0.714rem;\n  height: 0.714rem;\n}\n.bullet.bullet-lg {\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n.color-radio {\n  position: relative;\n  height: 30px;\n  width: 30px;\n  border-radius: 50%;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.color-radio .radio-content {\n  height: 20px;\n  width: 20px;\n  display: block;\n  border-radius: 50%;\n}\n\n.match-height .card {\n  height: calc(100% - 2.2rem);\n}\n\n.avatar {\n  white-space: nowrap;\n  background-color: #c3c3c3;\n  border-radius: 50%;\n  position: relative;\n  cursor: pointer;\n  color: #fff;\n  display: inline-flex;\n  font-size: 0.75rem;\n  text-align: center;\n  vertical-align: middle;\n  margin: 5px;\n}\n.avatar .avatar-content {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.avatar .avatar-content .avatar-icon svg {\n  width: 1.2rem;\n  height: 1.2rem;\n}\n.avatar:not(.avatar-stats) svg {\n  height: 12px;\n  width: 12px;\n}\n.avatar [class*=avatar-status-] {\n  border-radius: 50%;\n  width: 11px;\n  height: 11px;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  border: 1px solid #fff;\n}\n.avatar [class*=avatar-status-].avatar-status-lg {\n  width: 17px;\n  height: 17px;\n  border-width: 2px;\n}\n.avatar .avatar-status-online {\n  background-color: #28c76f;\n}\n.avatar .avatar-status-busy {\n  background-color: #ea5455;\n}\n.avatar .avatar-status-away {\n  background-color: #ff9f43;\n}\n.avatar .avatar-status-offline {\n  background-color: #b8c2cc;\n}\n.avatar img {\n  border-radius: 50%;\n}\n.avatar.avatar-xl {\n  font-size: 1.5rem;\n}\n.avatar.avatar-xl img {\n  width: 70px;\n  height: 70px;\n}\n.avatar.avatar-xl .avatar-content {\n  height: 70px;\n  width: 70px;\n}\n.avatar.avatar-xl .avatar-content .avatar-icon svg {\n  width: 3rem;\n  height: 3rem;\n}\n.avatar.avatar-lg {\n  font-size: 1.2rem;\n}\n.avatar.avatar-lg img {\n  width: 50px;\n  height: 50px;\n}\n.avatar.avatar-lg .avatar-content {\n  width: 50px;\n  height: 50px;\n}\n.avatar.avatar-lg .avatar-content .avatar-icon svg {\n  width: 2rem;\n  height: 2rem;\n}\n.avatar.avatar-sm .avatar-content {\n  width: 24px;\n  height: 24px;\n}\n.avatar.avatar-sm .avatar-content .avatar-icon svg {\n  width: 1rem;\n  height: 1rem;\n}\n.avatar.avatar-sm img {\n  width: 24px;\n  height: 24px;\n}\n\n/*=========================================================================================\n\tFile Name: search.scss\n\tDescription: Search  functionality.\n\t----------------------------------------------------------------------------------------\n\tItem Name: Vuexy React admin Template\n\tVersion: 1.0\n\tAuthor: PIXINVENT\n\tAuthor URL: http://www.themeforest.net/user/pixinvent\n==========================================================================================*/\n.navbar-container a.nav-link-search {\n  float: left;\n}\n.navbar-container .search-input {\n  float: left;\n  width: 0;\n}\n.navbar-container .search-input input {\n  width: 0;\n  border: \"2px solid black\";\n  transition: all 0.2s ease-out;\n  line-height: 16px;\n  padding: 1.75rem 3.6rem;\n}\n.navbar-container .search-input input:focus {\n  outline: 0 !important;\n  outline-offset: 0 !important;\n}\n.navbar-container .search-input.open {\n  position: absolute;\n  left: 0;\n  right: 0;\n  width: 100%;\n  z-index: 1;\n  border-radius: 0.5rem;\n}\n.navbar-container .search-input.open .search-input-close,\n.navbar-container .search-input.open .search-input-icon {\n  display: block;\n}\n.navbar-container .search-input.open input {\n  width: 100%;\n  outline: none;\n  transition: all 0.3s ease-out;\n}\n.navbar-container .search-input .search-input-icon {\n  z-index: 2;\n  display: none;\n  position: absolute;\n  left: 1.5rem;\n  top: 1.75rem;\n  cursor: pointer;\n}\n.navbar-container .search-input .search-input-close {\n  z-index: 1;\n  display: none;\n  position: absolute;\n  right: 2rem;\n  top: 20px;\n  cursor: pointer;\n}\n.navbar-container .search-input .search-header {\n  padding: 1.2rem 1.5rem;\n  padding-bottom: 0.5rem;\n}\n.navbar-container .search-input .other-results {\n  overflow: hidden;\n}\n.navbar-container .search-input .other-results .permanent-result {\n  width: 100%;\n  cursor: pointer;\n  padding: 0.5rem;\n  padding-left: 1rem;\n}\n.navbar-container .search-input .other-results .permanent-result:hover {\n  background-color: #f1f1f1;\n}\n.navbar-container .bookmark-input {\n  position: absolute;\n  top: 102%;\n  width: 25%;\n  display: none;\n}\n.navbar-container .bookmark-input.show {\n  display: block;\n}\n.navbar-container .bookmark-input .bookmark-input-icon {\n  position: absolute;\n  z-index: 1;\n  top: 0.75rem;\n  left: 1rem;\n}\n.navbar-container .bookmark-input input {\n  padding: 0.7rem 0.7rem 0.7rem 2.5rem;\n  width: 100%;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-bottom-left-radius: 5px !important;\n  border-bottom-right-radius: 5px !important;\n}\n.navbar-container .bookmark-input input:focus {\n  border: 1px solid #7367f0;\n}\n.navbar-container .bookmark-icon {\n  cursor: pointer;\n}\n.navbar-container .dropdown.bookmark-dropdown {\n  padding: 1.4rem 0.5rem 1.35rem;\n}\n.navbar-container .dropdown.bookmark-dropdown .dropdown-toggle:after {\n  display: none;\n}\n\n/* .navbar-light, .navbar-semi-dark{\n\t.search-input{\n\t\t.input{\n\t\t\tcolor: $gray-600;\n\t\t}\n\t\t&.open{\n\t\t\t.input{\n\t\t\t\tcolor: $gray-600;\n\t\t\t\t// border-bottom: 1px solid $gray-600;\n\n\t\t\t}\n\t\t}\n\t}\n} */\n.navbar-dark .search-input .input,\n.navbar-semi-light .search-input .input {\n  color: #f5f7fa;\n  border-radius: 0.5rem;\n  border: \"2px solid black\";\n}\n.navbar-dark .search-input.open .input,\n.navbar-semi-light .search-input.open .input {\n  color: #f5f7fa;\n  border: 1px solid #f5f7fa;\n}\n\n@media (max-width: 575.98px) {\n  #navbar-mobile .search-input.open .input {\n    color: #b8c2cc;\n  }\n}\n@media (max-width: 1300px) {\n  .navbar-container .bookmark-input {\n    width: 35%;\n  }\n}\n.apexcharts-canvas .apexcharts-tooltip {\n  color: #626262 !important;\n}\n.apexcharts-canvas .apexcharts-tooltip.dark {\n  color: #fff !important;\n}\n.apexcharts-canvas .apexcharts-toolbar .apexcharts-menu .apexcharts-menu-item {\n  color: #626262;\n}\n\n.apexcharts-xaxistooltip {\n  color: #626262 !important;\n}\n\n#client-retention-chart .apexcharts-canvas .apexcharts-legend {\n  left: -14px !important;\n}\n\n.btn-social, .btn-social-icon {\n  position: relative;\n  padding-left: 4.95rem;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.btn-social > :first-child, .btn-social-icon > :first-child {\n  position: absolute;\n  left: 0;\n  top: 2px;\n  bottom: 0;\n  width: 2.95rem;\n  line-height: 2.7rem;\n  font-size: 1rem;\n  text-align: center;\n  border-right: 1px solid rgba(0, 0, 0, 0.2);\n}\n\n.btn-social-icon {\n  height: 2.95rem;\n  width: 2.95rem;\n  padding: 0;\n}\n.btn-social-icon > :first-child {\n  border: none;\n  text-align: center;\n  width: 100% !important;\n}\n\n.btn-adn {\n  background-color: #d87a68;\n  --bs-btn-color: #d87a68;\n  --bs-btn-bg: #d87a68;\n  --bs-btn-border-color: #fff;\n  --bs-btn-hover-color: #22292f;\n  --bs-btn-hover-bg: #d87a68;\n  --bs-btn-hover-border-color: white;\n  --bs-btn-focus-shadow-rgb: 249, 235, 232;\n  --bs-btn-active-color: #22292f;\n  --bs-btn-active-bg: rgb(223.8, 148.6, 134.2);\n  --bs-btn-active-border-color: white;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #22292f;\n  --bs-btn-disabled-bg: #d87a68;\n  --bs-btn-disabled-border-color: #fff;\n}\n\n.btn-bitbucket {\n  background-color: #205081;\n  --bs-btn-color: #205081;\n  --bs-btn-bg: #205081;\n  --bs-btn-border-color: #fff;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #205081;\n  --bs-btn-hover-border-color: white;\n  --bs-btn-focus-shadow-rgb: 222, 229, 236;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(76.6, 115, 154.2);\n  --bs-btn-active-border-color: white;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #205081;\n  --bs-btn-disabled-border-color: #fff;\n}\n\n.btn-dropbox {\n  background-color: #1087dd;\n  --bs-btn-color: #1087dd;\n  --bs-btn-bg: #1087dd;\n  --bs-btn-border-color: #fff;\n  --bs-btn-hover-color: #22292f;\n  --bs-btn-hover-bg: #1087dd;\n  --bs-btn-hover-border-color: white;\n  --bs-btn-focus-shadow-rgb: 219, 237, 250;\n  --bs-btn-active-color: #22292f;\n  --bs-btn-active-bg: rgb(63.8, 159, 227.8);\n  --bs-btn-active-border-color: white;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #22292f;\n  --bs-btn-disabled-bg: #1087dd;\n  --bs-btn-disabled-border-color: #fff;\n}\n\n.btn-facebook {\n  background-color: #3b5998;\n  --bs-btn-color: #3b5998;\n  --bs-btn-bg: #3b5998;\n  --bs-btn-border-color: #fff;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #3b5998;\n  --bs-btn-hover-border-color: white;\n  --bs-btn-focus-shadow-rgb: 226, 230, 240;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(98.2, 122.2, 172.6);\n  --bs-btn-active-border-color: white;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #3b5998;\n  --bs-btn-disabled-border-color: #fff;\n}\n\n.btn-flickr {\n  background-color: #ff0084;\n  --bs-btn-color: #ff0084;\n  --bs-btn-bg: #ff0084;\n  --bs-btn-border-color: #fff;\n  --bs-btn-hover-color: #22292f;\n  --bs-btn-hover-bg: #ff0084;\n  --bs-btn-hover-border-color: white;\n  --bs-btn-focus-shadow-rgb: 255, 217, 237;\n  --bs-btn-active-color: #22292f;\n  --bs-btn-active-bg: rgb(255, 51, 156.6);\n  --bs-btn-active-border-color: white;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #22292f;\n  --bs-btn-disabled-bg: #ff0084;\n  --bs-btn-disabled-border-color: #fff;\n}\n\n.btn-foursquare {\n  background-color: #f94877;\n  --bs-btn-color: #f94877;\n  --bs-btn-bg: #f94877;\n  --bs-btn-border-color: #fff;\n  --bs-btn-hover-color: #22292f;\n  --bs-btn-hover-bg: #f94877;\n  --bs-btn-hover-border-color: white;\n  --bs-btn-focus-shadow-rgb: 254, 228, 235;\n  --bs-btn-active-color: #22292f;\n  --bs-btn-active-bg: rgb(250.2, 108.6, 146.2);\n  --bs-btn-active-border-color: white;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #22292f;\n  --bs-btn-disabled-bg: #f94877;\n  --bs-btn-disabled-border-color: #fff;\n}\n\n.btn-github {\n  background-color: #444444;\n  --bs-btn-color: #444444;\n  --bs-btn-bg: #444444;\n  --bs-btn-border-color: #fff;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #444444;\n  --bs-btn-hover-border-color: white;\n  --bs-btn-focus-shadow-rgb: 227, 227, 227;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(105.4, 105.4, 105.4);\n  --bs-btn-active-border-color: white;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #444444;\n  --bs-btn-disabled-border-color: #fff;\n}\n\n.btn-google {\n  background-color: #dd4b39;\n  --bs-btn-color: #dd4b39;\n  --bs-btn-bg: #dd4b39;\n  --bs-btn-border-color: #fff;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #dd4b39;\n  --bs-btn-hover-border-color: white;\n  --bs-btn-focus-shadow-rgb: 250, 228, 225;\n  --bs-btn-active-color: #22292f;\n  --bs-btn-active-bg: rgb(227.8, 111, 96.6);\n  --bs-btn-active-border-color: white;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #dd4b39;\n  --bs-btn-disabled-border-color: #fff;\n}\n\n.btn-instagram {\n  background-color: #3f729b;\n  --bs-btn-color: #3f729b;\n  --bs-btn-bg: #3f729b;\n  --bs-btn-border-color: #fff;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #3f729b;\n  --bs-btn-hover-border-color: white;\n  --bs-btn-focus-shadow-rgb: 226, 234, 240;\n  --bs-btn-active-color: #22292f;\n  --bs-btn-active-bg: rgb(101.4, 142.2, 175);\n  --bs-btn-active-border-color: white;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #3f729b;\n  --bs-btn-disabled-border-color: #fff;\n}\n\n.btn-linkedin {\n  background-color: #007bb6;\n  --bs-btn-color: #007bb6;\n  --bs-btn-bg: #007bb6;\n  --bs-btn-border-color: #fff;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #007bb6;\n  --bs-btn-hover-border-color: white;\n  --bs-btn-focus-shadow-rgb: 217, 235, 244;\n  --bs-btn-active-color: #22292f;\n  --bs-btn-active-bg: rgb(51, 149.4, 196.6);\n  --bs-btn-active-border-color: white;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #007bb6;\n  --bs-btn-disabled-border-color: #fff;\n}\n\n.btn-microsoft {\n  background-color: #2672ec;\n  --bs-btn-color: #2672ec;\n  --bs-btn-bg: #2672ec;\n  --bs-btn-border-color: #fff;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #2672ec;\n  --bs-btn-hover-border-color: white;\n  --bs-btn-focus-shadow-rgb: 222, 234, 252;\n  --bs-btn-active-color: #22292f;\n  --bs-btn-active-bg: rgb(81.4, 142.2, 239.8);\n  --bs-btn-active-border-color: white;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #2672ec;\n  --bs-btn-disabled-border-color: #fff;\n}\n\n.btn-odnoklassniki {\n  background-color: #f4731c;\n  --bs-btn-color: #f4731c;\n  --bs-btn-bg: #f4731c;\n  --bs-btn-border-color: #fff;\n  --bs-btn-hover-color: #22292f;\n  --bs-btn-hover-bg: #f4731c;\n  --bs-btn-hover-border-color: white;\n  --bs-btn-focus-shadow-rgb: 253, 234, 221;\n  --bs-btn-active-color: #22292f;\n  --bs-btn-active-bg: rgb(246.2, 143, 73.4);\n  --bs-btn-active-border-color: white;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #22292f;\n  --bs-btn-disabled-bg: #f4731c;\n  --bs-btn-disabled-border-color: #fff;\n}\n\n.btn-openid {\n  background-color: #f7931e;\n  --bs-btn-color: #f7931e;\n  --bs-btn-bg: #f7931e;\n  --bs-btn-border-color: #fff;\n  --bs-btn-hover-color: #22292f;\n  --bs-btn-hover-bg: #f7931e;\n  --bs-btn-hover-border-color: white;\n  --bs-btn-focus-shadow-rgb: 254, 239, 221;\n  --bs-btn-active-color: #22292f;\n  --bs-btn-active-bg: rgb(248.6, 168.6, 75);\n  --bs-btn-active-border-color: white;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #22292f;\n  --bs-btn-disabled-bg: #f7931e;\n  --bs-btn-disabled-border-color: #fff;\n}\n\n.btn-pinterest {\n  background-color: #cb2027;\n  --bs-btn-color: #cb2027;\n  --bs-btn-bg: #cb2027;\n  --bs-btn-border-color: #fff;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #cb2027;\n  --bs-btn-hover-border-color: white;\n  --bs-btn-focus-shadow-rgb: 247, 222, 223;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(213.4, 76.6, 82.2);\n  --bs-btn-active-border-color: white;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #cb2027;\n  --bs-btn-disabled-border-color: #fff;\n}\n\n.btn-reddit {\n  background-color: #eff7ff;\n  --bs-btn-color: #000;\n  --bs-btn-bg: #eff7ff;\n  --bs-btn-border-color: #000;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #000;\n  --bs-btn-hover-border-color: rgb(25.5, 25.5, 25.5);\n  --bs-btn-focus-shadow-rgb: 0, 0, 0;\n  --bs-btn-active-color: #22292f;\n  --bs-btn-active-bg: rgb(242.2, 248.6, 255);\n  --bs-btn-active-border-color: rgb(25.5, 25.5, 25.5);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #22292f;\n  --bs-btn-disabled-bg: #eff7ff;\n  --bs-btn-disabled-border-color: #000;\n}\n\n.btn-soundcloud {\n  background-color: #ff5500;\n  --bs-btn-color: #ff5500;\n  --bs-btn-bg: #ff5500;\n  --bs-btn-border-color: #fff;\n  --bs-btn-hover-color: #22292f;\n  --bs-btn-hover-bg: #ff5500;\n  --bs-btn-hover-border-color: white;\n  --bs-btn-focus-shadow-rgb: 255, 230, 217;\n  --bs-btn-active-color: #22292f;\n  --bs-btn-active-bg: #ff7733;\n  --bs-btn-active-border-color: white;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #22292f;\n  --bs-btn-disabled-bg: #ff5500;\n  --bs-btn-disabled-border-color: #fff;\n}\n\n.btn-tumblr {\n  background-color: #2c4762;\n  --bs-btn-color: #2c4762;\n  --bs-btn-bg: #2c4762;\n  --bs-btn-border-color: #fff;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #2c4762;\n  --bs-btn-hover-border-color: white;\n  --bs-btn-focus-shadow-rgb: 223, 227, 231;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(86.2, 107.8, 129.4);\n  --bs-btn-active-border-color: white;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #2c4762;\n  --bs-btn-disabled-border-color: #fff;\n}\n\n.btn-twitter {\n  background-color: #55acee;\n  --bs-btn-color: #55acee;\n  --bs-btn-bg: #55acee;\n  --bs-btn-border-color: #fff;\n  --bs-btn-hover-color: #22292f;\n  --bs-btn-hover-bg: #55acee;\n  --bs-btn-hover-border-color: white;\n  --bs-btn-focus-shadow-rgb: 230, 243, 252;\n  --bs-btn-active-color: #22292f;\n  --bs-btn-active-bg: rgb(119, 188.6, 241.4);\n  --bs-btn-active-border-color: white;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #22292f;\n  --bs-btn-disabled-bg: #55acee;\n  --bs-btn-disabled-border-color: #fff;\n}\n\n.btn-vimeo {\n  background-color: #1ab7ea;\n  --bs-btn-color: #1ab7ea;\n  --bs-btn-bg: #1ab7ea;\n  --bs-btn-border-color: #fff;\n  --bs-btn-hover-color: #22292f;\n  --bs-btn-hover-bg: #1ab7ea;\n  --bs-btn-hover-border-color: white;\n  --bs-btn-focus-shadow-rgb: 221, 244, 252;\n  --bs-btn-active-color: #22292f;\n  --bs-btn-active-bg: rgb(71.8, 197.4, 238.2);\n  --bs-btn-active-border-color: white;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #22292f;\n  --bs-btn-disabled-bg: #1ab7ea;\n  --bs-btn-disabled-border-color: #fff;\n}\n\n.btn-vk {\n  background-color: #587ea3;\n  --bs-btn-color: #587ea3;\n  --bs-btn-bg: #587ea3;\n  --bs-btn-border-color: #fff;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #587ea3;\n  --bs-btn-hover-border-color: white;\n  --bs-btn-focus-shadow-rgb: 230, 236, 241;\n  --bs-btn-active-color: #22292f;\n  --bs-btn-active-bg: rgb(121.4, 151.8, 181.4);\n  --bs-btn-active-border-color: white;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #587ea3;\n  --bs-btn-disabled-border-color: #fff;\n}\n\n.btn-yahoo {\n  background-color: #720e9e;\n  --bs-btn-color: #720e9e;\n  --bs-btn-bg: #720e9e;\n  --bs-btn-border-color: #fff;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #720e9e;\n  --bs-btn-hover-border-color: white;\n  --bs-btn-focus-shadow-rgb: 234, 219, 240;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(142.2, 62.2, 177.4);\n  --bs-btn-active-border-color: white;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(34, 41, 47, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #720e9e;\n  --bs-btn-disabled-border-color: #fff;\n}\n\n.btn-outline-adn {\n  border: 1px solid #d87a68 !important;\n  color: #d87a68;\n}\n\n.btn-outline-bitbucket {\n  border: 1px solid #205081 !important;\n  color: #205081;\n}\n\n.btn-outline-dropbox {\n  border: 1px solid #1087dd !important;\n  color: #1087dd;\n}\n\n.btn-outline-facebook {\n  border: 1px solid #3b5998 !important;\n  color: #3b5998;\n}\n\n.btn-outline-flickr {\n  border: 1px solid #ff0084 !important;\n  color: #ff0084;\n}\n\n.btn-outline-foursquare {\n  border: 1px solid #f94877 !important;\n  color: #f94877;\n}\n\n.btn-outline-github {\n  border: 1px solid #444444 !important;\n  color: #444444;\n}\n\n.btn-outline-google {\n  border: 1px solid #dd4b39 !important;\n  color: #dd4b39;\n}\n\n.btn-outline-instagram {\n  border: 1px solid #3f729b !important;\n  color: #3f729b;\n}\n\n.btn-outline-linkedin {\n  border: 1px solid #007bb6 !important;\n  color: #007bb6;\n}\n\n.btn-outline-microsoft {\n  border: 1px solid #2672ec !important;\n  color: #2672ec;\n}\n\n.btn-outline-odnoklassniki {\n  border: 1px solid #f4731c !important;\n  color: #f4731c;\n}\n\n.btn-outline-openid {\n  border: 1px solid #f7931e !important;\n  color: #f7931e;\n}\n\n.btn-outline-pinterest {\n  border: 1px solid #cb2027 !important;\n  color: #cb2027;\n}\n\n.btn-outline-reddit {\n  border: 1px solid #ff4500 !important;\n  color: #ff4500;\n}\n\n.btn-outline-soundcloud {\n  border: 1px solid #ff5500 !important;\n  color: #ff5500;\n}\n\n.btn-outline-tumblr {\n  border: 1px solid #2c4762 !important;\n  color: #2c4762;\n}\n\n.btn-outline-twitter {\n  border: 1px solid #55acee !important;\n  color: #55acee;\n}\n\n.btn-outline-vimeo {\n  border: 1px solid #1ab7ea !important;\n  color: #1ab7ea;\n}\n\n.btn-outline-vk {\n  border: 1px solid #587ea3 !important;\n  color: #587ea3;\n}\n\n.btn-outline-yahoo {\n  border: 1px solid #720e9e !important;\n  color: #720e9e;\n}\n\n.btn-outline-adn:hover {\n  color: rgb(173.2526315789, 65.4, 44.7473684211);\n  border: 1px solid rgb(173.2526315789, 65.4, 44.7473684211) !important;\n}\n\n.btn-outline-bitbucket:hover {\n  color: rgb(11.7267080745, 29.3167701863, 47.2732919255);\n  border: 1px solid rgb(11.7267080745, 29.3167701863, 47.2732919255) !important;\n}\n\n.btn-outline-dropbox:hover {\n  color: rgb(9.1139240506, 76.8987341772, 125.8860759494);\n  border: 1px solid rgb(9.1139240506, 76.8987341772, 125.8860759494) !important;\n}\n\n.btn-outline-facebook:hover {\n  color: rgb(30.4786729858, 45.9763033175, 78.5213270142);\n  border: 1px solid rgb(30.4786729858, 45.9763033175, 78.5213270142) !important;\n}\n\n.btn-outline-flickr:hover {\n  color: rgb(153, 0, 79.2);\n  border: 1px solid rgb(153, 0, 79.2) !important;\n}\n\n.btn-outline-foursquare:hover {\n  color: rgb(212.0476190476, 6.9523809524, 61.4126984127);\n  border: 1px solid rgb(212.0476190476, 6.9523809524, 61.4126984127) !important;\n}\n\n.btn-outline-github:hover {\n  color: #111111;\n  border: 1px solid #111111 !important;\n}\n\n.btn-outline-google:hover {\n  color: rgb(150.2068965517, 39.4482758621, 25.7931034483);\n  border: 1px solid rgb(150.2068965517, 39.4482758621, 25.7931034483) !important;\n}\n\n.btn-outline-instagram:hover {\n  color: rgb(33.5229357798, 60.6605504587, 82.4770642202);\n  border: 1px solid rgb(33.5229357798, 60.6605504587, 82.4770642202) !important;\n}\n\n.btn-outline-linkedin:hover {\n  color: rgb(0, 54.0659340659, 80);\n  border: 1px solid rgb(0, 54.0659340659, 80) !important;\n}\n\n.btn-outline-microsoft:hover {\n  color: rgb(13.8474576271, 69.2372881356, 158.1525423729);\n  border: 1px solid rgb(13.8474576271, 69.2372881356, 158.1525423729) !important;\n}\n\n.btn-outline-odnoklassniki:hover {\n  color: rgb(162.1428571429, 70, 7.8571428571);\n  border: 1px solid rgb(162.1428571429, 70, 7.8571428571) !important;\n}\n\n.btn-outline-openid:hover {\n  color: rgb(168.991416309, 93.8841201717, 6.008583691);\n  border: 1px solid rgb(168.991416309, 93.8841201717, 6.008583691) !important;\n}\n\n.btn-outline-pinterest:hover {\n  color: rgb(114.8893617021, 18.1106382979, 22.0723404255);\n  border: 1px solid rgb(114.8893617021, 18.1106382979, 22.0723404255) !important;\n}\n\n.btn-outline-reddit:hover {\n  color: rgb(153, 41.4, 0);\n  border: 1px solid rgb(153, 41.4, 0) !important;\n}\n\n.btn-outline-soundcloud:hover {\n  color: #993300;\n  border: 1px solid #993300 !important;\n}\n\n.btn-outline-tumblr:hover {\n  color: rgb(12.3943661972, 20, 27.6056338028);\n  border: 1px solid rgb(12.3943661972, 20, 27.6056338028) !important;\n}\n\n.btn-outline-twitter:hover {\n  color: rgb(20.0909090909, 122.9090909091, 200.9090909091);\n  border: 1px solid rgb(20.0909090909, 122.9090909091, 200.9090909091) !important;\n}\n\n.btn-outline-vimeo:hover {\n  color: rgb(13.272, 112.496, 144.728);\n  border: 1px solid rgb(13.272, 112.496, 144.728) !important;\n}\n\n.btn-outline-vk:hover {\n  color: rgb(52.2390438247, 74.796812749, 96.7609561753);\n  border: 1px solid rgb(52.2390438247, 74.796812749, 96.7609561753) !important;\n}\n\n.btn-outline-yahoo:hover {\n  color: rgb(46.3953488372, 5.6976744186, 64.3023255814);\n  border: 1px solid rgb(46.3953488372, 5.6976744186, 64.3023255814) !important;\n}\n\n.bg-adn {\n  background-color: #d87a68;\n}\n\n.bg-bitbucket {\n  background-color: #205081;\n}\n\n.bg-dropbox {\n  background-color: #1087dd;\n}\n\n.bg-facebook {\n  background-color: #3b5998;\n}\n\n.bg-flickr {\n  background-color: #ff0084;\n}\n\n.bg-foursquare {\n  background-color: #f94877;\n}\n\n.bg-github {\n  background-color: #444444;\n}\n\n.bg-google {\n  background-color: #dd4b39;\n}\n\n.bg-instagram {\n  background-color: #3f729b;\n}\n\n.bg-linkedin {\n  background-color: #007bb6;\n}\n\n.bg-microsoft {\n  background-color: #2672ec;\n}\n\n.bg-odnoklassniki {\n  background-color: #f4731c;\n}\n\n.bg-openid {\n  background-color: #f7931e;\n}\n\n.bg-pinterest {\n  background-color: #cb2027;\n}\n\n.bg-reddit {\n  background-color: #ff4500;\n}\n\n.bg-soundcloud {\n  background-color: #ff5500;\n}\n\n.bg-tumblr {\n  background-color: #2c4762;\n}\n\n.bg-twitter {\n  background-color: #55acee;\n}\n\n.bg-vimeo {\n  background-color: #1ab7ea;\n}\n\n.bg-vk {\n  background-color: #587ea3;\n}\n\n.bg-yahoo {\n  background-color: #720e9e;\n}\n\n/*=========================================================================================\n    File Name: demo.scss\n    Description: CSS used for demo purpose only. Remove this css from your project.\n    ----------------------------------------------------------------------------------------\n    Item Name: Vuexy React admin Template\n    Version: 1.0\n    Author: PIXINVENT\n    Author URL: http://www.themeforest.net/user/pixinvent\n==========================================================================================*/\n.fonticon-container > .fonticon-wrap {\n  float: left;\n  width: 60px;\n  height: 60px;\n  line-height: 1rem;\n  text-align: center;\n  border-radius: 0.1875rem;\n  margin-right: 0;\n  margin-bottom: 1.5rem;\n  cursor: pointer;\n}\n.fonticon-container > .fonticon-wrap > svg {\n  transition: all 0.2s ease-in-out;\n}\n.fonticon-container > .fonticon-wrap > svg:hover {\n  stroke: #7367f0;\n  transform: scale(1.3);\n}\n.fonticon-container > .fonticon-wrap.youtube {\n  width: 100px;\n}\n.fonticon-container:hover svg {\n  color: #7367f0;\n  transform: scale(1.3);\n}\n.fonticon-container > .fonticon-classname,\n.fonticon-container > .fonticon-unit {\n  display: block;\n  font-size: 1.5rem;\n  line-height: 1.2;\n}\n.fonticon-container > .fonticon-unit {\n  font-size: 1rem;\n  font-style: italic;\n}\n\n.scroll-example {\n  padding: 0.5rem;\n  position: relative;\n  border: 2px solid rgb(222.5, 222.5, 222.5);\n  overflow: auto;\n}\n.scroll-example .horz-scroll-content {\n  width: 1200px;\n}\n\n.browser {\n  background: #e0e0e0;\n  border: 4px solid #e0e0e0;\n  width: 100%;\n  height: 12rem;\n  padding-top: 20px;\n  margin: 0 0 10px;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.browser iframe {\n  border: 0;\n  background: #fff;\n  height: 100%;\n  width: 100%;\n}\n\n.loader-wrapper {\n  height: 8em;\n}\n\n.maintenance-icon {\n  font-size: 4rem;\n}\n\n.animationIcon {\n  right: 30px;\n  bottom: 10px;\n}\n\n/*=========================================================================================\n\tFile Name: customizer.scss\n\tDescription: CSS used for demo purpose only. Remove this css from your project.\n\t----------------------------------------------------------------------------------------\n\tItem Name: Vuexy React admin Template\n\tVersion: 1.0\n\tAuthor: PIXINVENT\n\tAuthor URL: http://www.themeforest.net/user/pixinvent\n  ==========================================================================================*/\n.customizer {\n  width: 400px;\n  right: -400px;\n  padding: 0;\n  background-color: #fff;\n  z-index: 1051;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  height: 100vh;\n  transition: right 0.4s cubic-bezier(0.05, 0.74, 0.2, 0.99);\n  backface-visibility: hidden;\n  border-left: 1px solid rgba(0, 0, 0, 0.05);\n  box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11), 0 5px 15px 0 rgba(0, 0, 0, 0.08);\n}\n.customizer .open-icon {\n  animation: Spin 2s infinite linear;\n  position: relative;\n  top: -2px;\n}\n.customizer.open {\n  right: 0;\n}\n.customizer .customizer-content {\n  position: relative;\n  height: calc(100% - 7rem);\n}\n.customizer .customizer-content .bg-default {\n  background-color: #fff;\n}\n.customizer .customizer-close {\n  position: absolute;\n  right: 30px;\n  top: 20px;\n  padding: 7px;\n  width: auto;\n  z-index: 10;\n  color: #626262;\n}\n.customizer .customizer-close i {\n  font-size: 1.71rem;\n}\n.customizer .customizer-toggle {\n  background: #7367f0;\n  color: #fff;\n  display: block;\n  box-shadow: -3px 0px 8px rgba(0, 0, 0, 0.1);\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n  position: absolute;\n  top: 50%;\n  width: 38px;\n  height: 38px;\n  left: -39px;\n  text-align: center;\n  line-height: 40px;\n  cursor: pointer;\n}\n.customizer .color-box {\n  height: 35px;\n  width: 35px;\n  margin: 0.5rem;\n  border-radius: 0.5rem;\n  cursor: pointer;\n}\n.customizer .color-box.selected {\n  box-shadow: 0 0 0 3px rgba(52, 144, 220, 0.5);\n  transition: all 0.2s ease-in-out;\n}\n.customizer .color-box.disabled {\n  pointer-events: none;\n  cursor: not-allowed;\n}\n\nbody.dark-layout .hide-scroll-top-switch .custom-switch .custom-control-label:before,\nbody.dark-layout .collapse-sidebar .custom-switch .custom-control-label:before {\n  background-color: #10163a;\n}\n\n.buy-now {\n  position: fixed;\n  bottom: 5%;\n  right: 79px;\n  z-index: 1031;\n}\n.buy-now .btn {\n  box-shadow: 0 1px 20px 1px #EA5455 !important;\n}\n.buy-now .btn:hover {\n  box-shadow: none !important;\n}\n\n@keyframes Spin {\n  from {\n    transform: rotate(0);\n  }\n  to {\n    transform: rotate(359deg);\n  }\n}\n.chip {\n  background-color: #f0f0f0;\n  font-size: 0.8rem;\n  border-radius: 1.428rem;\n  display: inline-flex;\n  padding: 0 10px;\n  margin-bottom: 5px;\n  vertical-align: middle;\n  justify-content: center;\n}\n.chip .chip-body {\n  color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: space-between;\n  min-height: 1.857rem;\n  min-width: 1.857rem;\n}\n.chip .chip-body .avatar {\n  background-color: #c3c3c3;\n  display: flex;\n  width: 24px;\n  height: 24px;\n  margin: 2px 0;\n  border-radius: 50%;\n  justify-content: center;\n  align-items: center;\n  color: #fff;\n  transform: translate(-8px);\n}\n.chip .chip-body .avatar .avatar-content {\n  font-size: 0.8rem;\n}\n.chip .chip-body .avatar img {\n  border-radius: 50%;\n  height: 24px;\n  width: 24px;\n}\n.chip .chip-body .chip-text {\n  vertical-align: middle;\n  align-self: center;\n}\n.chip .chip-body .chip-closable {\n  min-height: 1.428rem;\n  min-width: 1.428rem;\n  margin: 0 4px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-self: center;\n  border-radius: 50%;\n  background: rgba(0, 0, 0, 0.15);\n  color: #fff;\n  transform: translate(10px);\n  cursor: pointer;\n}\n.chip .chip-body .chip-closable svg {\n  height: 12px;\n  width: 12px;\n}\n\n.divider {\n  display: block;\n  text-align: center;\n  overflow: hidden;\n  white-space: nowrap;\n  margin: 1rem 0;\n}\n.divider .divider-text {\n  position: relative;\n  display: inline-block;\n  font-size: 0.9375rem;\n  padding: 0 1rem;\n  background-color: #fff;\n}\n.divider .divider-text svg {\n  height: 1rem;\n  width: 1rem;\n}\n.divider .divider-text:before, .divider .divider-text:after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  width: 9999px;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n.divider .divider-text:before {\n  right: 100%;\n}\n.divider .divider-text:after {\n  left: 100%;\n}\n.divider.divider-left .divider-text {\n  float: left;\n  padding-left: 0;\n}\n.divider.divider-left .divider-text:before {\n  display: none;\n}\n.divider.divider-left-center .divider-text {\n  left: -25%;\n}\n.divider.divider-right .divider-text {\n  float: right;\n  padding-right: 0;\n}\n.divider.divider-right .divider-text:after {\n  display: none;\n}\n.divider.divider-right-center .divider-text {\n  right: -25%;\n}\n.divider.divider-dotted .divider-text:before, .divider.divider-dotted .divider-text:after {\n  border-style: dotted;\n  border-width: 1px;\n  border-top-width: 0;\n  border-color: black;\n}\n.divider.divider-dashed .divider-text:before, .divider.divider-dashed .divider-text:after {\n  border-style: dashed;\n  border-width: 1px;\n  border-top-width: 0;\n  border-color: black;\n}\n\n/***** Vuexy Wizard *****/\n.vx-wizard {\n  box-shadow: none !important;\n  display: table;\n  width: 100%;\n}\n.vx-wizard.nav.nav-tabs .step-wrapper.nav-item {\n  display: table-cell;\n  width: auto;\n}\n.vx-wizard.nav.nav-tabs .step-wrapper.nav-item .step.nav-link {\n  transform: translateY(0) !important;\n  text-align: center !important;\n  z-index: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.vx-wizard.nav.nav-tabs .step-wrapper.nav-item .step.nav-link .step-text {\n  border-radius: 50%;\n  font-size: 1.5rem;\n  z-index: 2;\n  height: 50px;\n  width: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 500;\n  background: #fff;\n}\n.vx-wizard.nav.nav-tabs .step-wrapper.nav-item .step.nav-link.active .step-text {\n  background-color: #2a2e30;\n  color: #fff;\n}\n.vx-wizard.nav.nav-tabs .step-wrapper.nav-item .step.nav-link.active:after {\n  background: #2a2e30 !important;\n  box-shadow: none !important;\n  height: 3px;\n  top: 50% !important;\n  z-index: -1;\n  width: 50%;\n}\n.vx-wizard.nav.nav-tabs .step-wrapper.nav-item .step.nav-link.done .step-text {\n  border-color: #2a2e30 !important;\n}\n.vx-wizard.nav.nav-tabs .step-wrapper.nav-item .step.nav-link.done:before, .vx-wizard.nav.nav-tabs .step-wrapper.nav-item .step.nav-link.done:after {\n  background: #2a2e30 !important;\n  box-shadow: none !important;\n  height: 3px;\n  top: 50% !important;\n  z-index: -1;\n  width: 50%;\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  width: 45.5%;\n}\n.vx-wizard.nav.nav-tabs .step-wrapper.nav-item .step.nav-link.done:before {\n  left: 0;\n}\n.vx-wizard.nav.nav-tabs .step-wrapper.nav-item .step.nav-link.done:after {\n  right: 0;\n}\n.vx-wizard.nav.nav-tabs .step-wrapper.nav-item .step.nav-link:not(.active) .step-text {\n  border: 3px solid #b8c2cc;\n  color: #b8c2cc;\n}\n\n.vx-autocomplete-container {\n  position: relative;\n  border: \"2px solid black\";\n}\n.vx-autocomplete-container .vx-autocomplete-search {\n  height: 100%;\n  width: 100%;\n  background-color: \"#XXXXXX\";\n}\n.vx-autocomplete-container .vx-autocomplete-search:focus {\n  box-shadow: none;\n}\n.vx-autocomplete-container .suggestions-list {\n  z-index: 998;\n  list-style: none;\n  padding-left: 0;\n  border-radius: 0.5rem;\n  max-height: 450px;\n  height: auto;\n  width: 100%;\n  position: absolute;\n  margin-top: 0.5rem;\n  background-color: #fff;\n  box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11), 0 5px 15px 0 rgba(0, 0, 0, 0.08);\n}\n.vx-autocomplete-container .suggestions-list .suggestion-item {\n  padding: 0.85rem 1rem;\n  color: #626262;\n}\n.vx-autocomplete-container .suggestions-list .suggestion-item a {\n  color: #626262;\n}\n.vx-autocomplete-container .suggestions-list .suggestion-item.active, .vx-autocomplete-container .suggestions-list .suggestion-item:hover:not(.suggestion-title):not(.no-result) {\n  background-color: #f8f8f8;\n  color: #626262;\n}\n.vx-autocomplete-container .suggestions-list .suggestion-item:hover:not(.suggestion-title):not(.no-result) {\n  cursor: pointer;\n}\n\n.loading {\n  position: absolute;\n  left: calc(50% - 35px);\n  top: 50%;\n  width: 55px;\n  height: 55px;\n  border-radius: 50%;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  border: 3px solid transparent;\n}\n.loading.component-loader {\n  margin-top: -60px;\n}\n.loading .effect-1,\n.loading .effect-2 {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  border: 3px solid transparent;\n  border-left: 3px solid rgb(121, 97, 249);\n  border-radius: 50%;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.loading .effect-1 {\n  animation: rotate 1s ease infinite;\n}\n.loading .effect-2 {\n  animation: rotateOpacity 1s ease infinite 0.1s;\n}\n.loading .effect-3 {\n  width: 100%;\n  height: 100%;\n  border: 3px solid transparent;\n  border-left: 3px solid rgb(121, 97, 249);\n  -webkit-animation: rotateOpacity 1s ease infinite 0.2s;\n  animation: rotateOpacity 1s ease infinite 0.2s;\n  border-radius: 50%;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.loading .loading .effects {\n  transition: all 0.3s ease;\n}\n\n.fallback-logo {\n  position: absolute;\n  left: calc(50% - 45px);\n  top: 40%;\n}\n\n@keyframes rotate {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(1turn);\n    transform: rotate(1turn);\n  }\n}\n@keyframes rotateOpacity {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n    opacity: 0.1;\n  }\n  100% {\n    -webkit-transform: rotate(1turn);\n    transform: rotate(1turn);\n    opacity: 1;\n  }\n}\n.chat-widget .chat-app-window .user-chats {\n  padding: 10px 20px;\n  position: relative;\n  text-align: center;\n  height: 415px;\n}\n.chat-widget .chat-app-window .user-chats .chats {\n  padding: 0;\n}\n.chat-widget .chat-app-window .user-chats .chats .chat-body {\n  display: block;\n  margin: 10px 30px 0 0;\n  overflow: hidden;\n}\n.chat-widget .chat-app-window .user-chats .chats .chat-body .chat-content {\n  text-align: left;\n  display: block;\n  float: right;\n  padding: 0.75rem 1rem;\n  margin: 0 20px 10px 0;\n  clear: both;\n  color: #fff;\n  background: linear-gradient(118deg, #7367f0, rgba(115, 103, 240, 0.7));\n  border-radius: 0.5rem;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.08);\n}\n.chat-widget .chat-app-window .user-chats .chats .chat-body .chat-content p {\n  margin: 0;\n}\n.chat-widget .chat-app-window .user-chats .chats .chat-avatar {\n  float: right;\n}\n.chat-widget .chat-app-window .user-chats .chats .chat-left .chat-avatar {\n  float: left;\n}\n.chat-widget .chat-app-window .user-chats .chats .chat-left .chat-body {\n  margin: 0;\n}\n.chat-widget .chat-app-window .user-chats .chats .chat-left .chat-content {\n  text-align: left;\n  float: left;\n  margin: 10px 10px 10px 20px;\n  color: #626262;\n  background: none;\n  background-color: white;\n  border: 1px solid #dae1e7;\n}\n\n@media screen and (min-width: 0px) {\n  head {\n    font-family: \"xs 0px\";\n  }\n  body:after {\n    content: \"xs - min-width: 0px\";\n  }\n}\n@media screen and (min-width: 544px) {\n  head {\n    font-family: \"sm 544px\";\n  }\n  body:after {\n    content: \"sm - min-width: 544px\";\n  }\n}\n@media screen and (min-width: 768px) {\n  head {\n    font-family: \"md 768px\";\n  }\n  body:after {\n    content: \"md - min-width: 768px\";\n  }\n}\n@media screen and (min-width: 992px) {\n  head {\n    font-family: \"lg 992px\";\n  }\n  body:after {\n    content: \"lg - min-width: 992px\";\n  }\n}\n@media screen and (min-width: 1200px) {\n  head {\n    font-family: \"xl 1200px\";\n  }\n  body:after {\n    content: \"xl - min-width: 1200px\";\n  }\n}\nhead {\n  clear: both;\n}\nhead title {\n  font-family: \"xs 0px, sm 544px, md 768px, lg 992px, xl 1200px\";\n}\n\nbody:after {\n  display: none;\n}\n\n*[data-usn-if] {\n  display: none;\n}\n\n.group-area {\n  margin-bottom: 3rem;\n}\n\n.block {\n  display: block;\n  width: 100%;\n}\n\n/* Input with icon */\n.form-control-position {\n  position: absolute;\n  top: 1px;\n  right: 0;\n  z-index: 2;\n  display: block;\n  width: 2.5rem;\n  height: 2.5rem;\n  line-height: 2.5rem;\n  text-align: center;\n}\n\n/*---------------------------------\nInput Icon\n---------------------------------*/\n.position-relative .form-control {\n  padding-right: calc(1.25em + 1.4rem + 1px);\n}\n.position-relative .form-control.form-control-lg {\n  padding-left: 2.5rem;\n}\n.position-relative .form-control.form-control-lg ~ .form-control-position {\n  top: 9px;\n}\n.position-relative .form-control.form-control-sm ~ .form-control-position {\n  top: -3px;\n}\n\n/* Input Icon left */\n.has-icon-left .form-control {\n  padding-right: 2rem;\n  padding-left: 3rem;\n}\n.has-icon-left .form-control-position {\n  right: auto;\n  left: inherit;\n}\n.has-icon-left .form-control-position svg {\n  position: relative;\n  left: 5px;\n  color: rgba(34, 41, 47, 0.4);\n}\n\ninput[type=color] {\n  height: calc(1.25em + 1.4rem + 1px);\n}\n\ninput[type=date].form-control,\ninput[type=time].form-control,\ninput[type=datetime-local].form-control,\ninput[type=month].form-control {\n  line-height: 1.45;\n}\n\n.font-size-large {\n  font-size: 2rem;\n}\n\n.font-size-base {\n  font-size: 1rem;\n}\n\n.font-size-small {\n  font-size: 1rem;\n}\n\n.font-size-xsmall {\n  font-size: 0.75rem;\n}\n\n.input-group-xs .form-control,\n.input-group-xs .input-group-addon,\n.input-group-xs .input-group-btn > button {\n  padding: 0.175rem 0.5rem;\n  font-size: 0.725rem;\n  line-height: 1.677777;\n  border-bottom-left-radius: 0.175rem;\n  border-top-left-radius: 0.175rem;\n}\n.input-group-xs .input-group-btn > button {\n  border-radius: 0.175rem;\n}\n\n.input-group-addon {\n  padding-top: 0.2rem;\n  padding-bottom: 0.2rem;\n}\n\n.floating-label-form-group-with-focus label,\n.floating-label-form-group-with-value label {\n  color: #7367f0 !important;\n  text-transform: uppercase;\n  font-weight: 400;\n}\n\ntable.dataTable {\n  border: 2px solid #f8f8f8;\n}\ntable.dataTable th, table.dataTable td {\n  border-bottom: 1px solid #f8f8f8;\n  border-top: 0;\n}\ntable.dataTable thead th, table.dataTable thead td, table.dataTable tfoot th, table.dataTable tfoot td {\n  font-size: 0.85rem;\n  border: 0;\n}\ntable.dataTable thead tr {\n  background-color: #f8f8f8;\n}\ntable.dataTable thead .sorting, table.dataTable thead .sorting_asc, table.dataTable thead .sorting_desc {\n  padding-right: inherit;\n}\ntable.dataTable thead .sorting:before, table.dataTable thead .sorting_asc:before, table.dataTable thead .sorting_desc:before {\n  font-family: \"feather\";\n  content: \"\\e845\";\n  padding-right: 0.3rem;\n  font-size: 0.7rem;\n  left: 0;\n  top: 0.9rem;\n}\ntable.dataTable thead .sorting:after, table.dataTable thead .sorting_asc:after, table.dataTable thead .sorting_desc:after {\n  font-family: \"feather\";\n  content: \"\\e842\";\n  font-size: 0.7rem;\n  left: 0;\n  top: 1.3rem;\n}\ntable.dataTable.table-striped tbody tr:nth-of-type(even) {\n  background-color: #f8f8f8;\n}\ntable.dataTable.table-striped tbody tr:nth-of-type(odd) {\n  background-color: #fff;\n}\ntable.dataTable.complex-headers {\n  border: 1px solid #dae1e7;\n}\ntable.dataTable.complex-headers thead th, table.dataTable.complex-headers thead td, table.dataTable.complex-headers tfoot th, table.dataTable.complex-headers tfoot td {\n  border-bottom: 1px solid #dae1e7;\n  border-right: 1px solid #dae1e7;\n}\ntable.dataTable tbody tr.selected {\n  background-color: rgba(115, 103, 240, 0.05) !important;\n  color: #7367f0 !important;\n  box-shadow: 0 0 1px 0 #7367f0 !important;\n  border-radius: 5px;\n}\ntable.dataTable tbody tr.selected td, table.dataTable tbody tr.selected th {\n  border-bottom: 0;\n}\n\ndiv.dataTables_wrapper div.dataTables_filter label, div.dataTables_wrapper div.dataTables_length label {\n  margin-top: 1rem;\n}\ndiv.dataTables_wrapper div.dataTables_filter select, div.dataTables_wrapper div.dataTables_length select {\n  background-position: calc(100% - 3px) 5px, calc(100% - 20px) 13px, 100% 0;\n  padding: 0 0.8rem;\n}\ndiv.dataTables_wrapper div.dataTables_paginate ul.pagination {\n  margin-top: 1rem;\n  padding-bottom: 7px;\n}\ndiv.dataTables_wrapper div.dataTables_paginate ul.pagination li a {\n  font-size: 0.8rem;\n}\n\ntr.group {\n  background-color: #ededed;\n}\n\n@media only screen and (max-width: 768px) {\n  div.dataTables_wrapper div.dataTables_paginate ul.pagination {\n    justify-content: center;\n  }\n}\n/*========================================================\n        DARK LAYOUT\n=========================================================*/\nbody.dark-layout {\n  background-color: #262c49;\n  /********* UI ELEMENTS *********/\n  /********* COMPONENTS *********/\n  /********** FORMS **********/\n  /********** TABLE **********/\n  /********** PAGES **********/\n  /********** CHARTS **********/\n  /********** APPLICATIONS **********/\n  /********** EXTENSIONS **********/\n  /********** CUSTOMIZER **********/\n  /********** HORIZONTAL Layout **********/\n}\nbody.dark-layout h1, body.dark-layout .h1,\nbody.dark-layout h2,\nbody.dark-layout .h2,\nbody.dark-layout h3,\nbody.dark-layout .h3,\nbody.dark-layout h4,\nbody.dark-layout .h4,\nbody.dark-layout h5,\nbody.dark-layout .h5,\nbody.dark-layout h6,\nbody.dark-layout .h6 {\n  color: #ebeefd;\n}\nbody.dark-layout [class*=border-]:not(.bullet):not(.spinner-border) {\n  border-color: #414561 !important;\n}\nbody.dark-layout a:hover {\n  color: #7367f0;\n}\nbody.dark-layout p,\nbody.dark-layout small,\nbody.dark-layout .small,\nbody.dark-layout span,\nbody.dark-layout label {\n  color: #c2c6dc;\n}\nbody.dark-layout hr {\n  border-color: #414561;\n}\nbody.dark-layout pre {\n  background-color: #262c49;\n  border: 0;\n}\nbody.dark-layout pre code {\n  background-color: inherit;\n  text-shadow: none;\n}\nbody.dark-layout pre code .operator,\nbody.dark-layout pre code .url {\n  background-color: #262c49;\n}\nbody.dark-layout code {\n  background-color: #262c49;\n  color: #b8c2cc;\n}\nbody.dark-layout kbd {\n  background-color: #262c49;\n}\nbody.dark-layout .component-code pre::-webkit-scrollbar-thumb {\n  background: #c2c6dc;\n}\nbody.dark-layout .component-code pre::-webkit-scrollbar-track {\n  background: #343661;\n}\nbody.dark-layout .text-dark {\n  color: #b8c2cc !important;\n}\nbody.dark-layout .header-navbar-shadow {\n  background: linear-gradient(180deg, rgba(44, 48, 60, 0.9) 44%, rgba(44, 48, 60, 0.43) 73%, rgba(17, 30, 70, 0));\n}\nbody.dark-layout .header-navbar {\n  background-color: #10163a;\n}\nbody.dark-layout .header-navbar .navbar-container .nav .nav-item .nav-link,\nbody.dark-layout .header-navbar .navbar-container .navbar-nav .nav-item .nav-link {\n  color: #c2c6dc;\n  background-color: transparent;\n}\nbody.dark-layout .header-navbar .navbar-container .nav .nav-item .nav-link svg,\nbody.dark-layout .header-navbar .navbar-container .navbar-nav .nav-item .nav-link svg {\n  stroke: #c2c6dc;\n}\nbody.dark-layout .header-navbar .navbar-container .nav .nav-item.nav-search .search-input.open,\nbody.dark-layout .header-navbar .navbar-container .navbar-nav .nav-item.nav-search .search-input.open {\n  background-color: #10163a;\n}\nbody.dark-layout .header-navbar .navbar-container .nav .nav-item.nav-search .search-input.open .input,\nbody.dark-layout .header-navbar .navbar-container .navbar-nav .nav-item.nav-search .search-input.open .input {\n  border-color: #414561;\n}\nbody.dark-layout .header-navbar .navbar-container .nav .nav-item.nav-search .search-input.open .input,\nbody.dark-layout .header-navbar .navbar-container .nav .nav-item.nav-search .search-input.open .input::placeholder,\nbody.dark-layout .header-navbar .navbar-container .nav .nav-item.nav-search .search-input.open .search-input-close,\nbody.dark-layout .header-navbar .navbar-container .navbar-nav .nav-item.nav-search .search-input.open .input,\nbody.dark-layout .header-navbar .navbar-container .navbar-nav .nav-item.nav-search .search-input.open .input::placeholder,\nbody.dark-layout .header-navbar .navbar-container .navbar-nav .nav-item.nav-search .search-input.open .search-input-close {\n  color: #c2c6dc;\n}\nbody.dark-layout .header-navbar .navbar-container .nav .nav-item .bookmark-input .form-control,\nbody.dark-layout .header-navbar .navbar-container .navbar-nav .nav-item .bookmark-input .form-control {\n  background-color: #10163a;\n}\nbody.dark-layout .header-navbar .navbar-container .nav .nav-item .search-list,\nbody.dark-layout .header-navbar .navbar-container .navbar-nav .nav-item .search-list {\n  background-color: #262c49;\n}\nbody.dark-layout .header-navbar .navbar-container .nav .nav-item .search-list .current_item,\nbody.dark-layout .header-navbar .navbar-container .navbar-nav .nav-item .search-list .current_item {\n  background-color: #10163a;\n}\nbody.dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-menu.dropdown-menu-media,\nbody.dark-layout .header-navbar .navbar-container .navbar-nav .dropdown-notification .dropdown-menu.dropdown-menu-media {\n  overflow: hidden;\n}\nbody.dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-menu.dropdown-menu-media:before,\nbody.dark-layout .header-navbar .navbar-container .navbar-nav .dropdown-notification .dropdown-menu.dropdown-menu-media:before {\n  display: none;\n}\nbody.dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-menu.dropdown-menu-media .media,\nbody.dark-layout .header-navbar .navbar-container .navbar-nav .dropdown-notification .dropdown-menu.dropdown-menu-media .media {\n  border-color: #414561;\n}\nbody.dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-menu.dropdown-menu-media .media .media-body .notification-text,\nbody.dark-layout .header-navbar .navbar-container .navbar-nav .dropdown-notification .dropdown-menu.dropdown-menu-media .media .media-body .notification-text {\n  color: #c2c6dc;\n}\nbody.dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-menu.dropdown-menu-media .media .media-meta,\nbody.dark-layout .header-navbar .navbar-container .navbar-nav .dropdown-notification .dropdown-menu.dropdown-menu-media .media .media-meta {\n  color: #c2c6dc;\n}\nbody.dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-menu.dropdown-menu-media .media:hover,\nbody.dark-layout .header-navbar .navbar-container .navbar-nav .dropdown-notification .dropdown-menu.dropdown-menu-media .media:hover {\n  background-color: #10163a;\n}\nbody.dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-menu.dropdown-menu-media .dropdown-menu-footer,\nbody.dark-layout .header-navbar .navbar-container .navbar-nav .dropdown-notification .dropdown-menu.dropdown-menu-media .dropdown-menu-footer {\n  background-color: #10163a;\n}\nbody.dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-menu.dropdown-menu-media .dropdown-menu-footer .dropdown-item,\nbody.dark-layout .header-navbar .navbar-container .navbar-nav .dropdown-notification .dropdown-menu.dropdown-menu-media .dropdown-menu-footer .dropdown-item {\n  color: #fff;\n  border-color: #414561;\n}\nbody.dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-menu.dropdown-menu-media .dropdown-menu-footer .dropdown-item:hover,\nbody.dark-layout .header-navbar .navbar-container .navbar-nav .dropdown-notification .dropdown-menu.dropdown-menu-media .dropdown-menu-footer .dropdown-item:hover {\n  background-color: #10163a;\n}\nbody.dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-cart.empty-cart:before,\nbody.dark-layout .header-navbar .navbar-container .navbar-nav .dropdown-notification .dropdown-cart.empty-cart:before {\n  background-color: #262c49;\n}\nbody.dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-cart li,\nbody.dark-layout .header-navbar .navbar-container .navbar-nav .dropdown-notification .dropdown-cart li {\n  color: #fff;\n}\nbody.dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-cart .dropdown-header span,\nbody.dark-layout .header-navbar .navbar-container .navbar-nav .dropdown-notification .dropdown-cart .dropdown-header span {\n  color: #fff;\n}\nbody.dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-cart .media-list .media,\nbody.dark-layout .header-navbar .navbar-container .navbar-nav .dropdown-notification .dropdown-cart .media-list .media {\n  background-color: #fff;\n}\nbody.dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-cart .media-list .media .media-body,\nbody.dark-layout .header-navbar .navbar-container .navbar-nav .dropdown-notification .dropdown-cart .media-list .media .media-body {\n  background-color: #262c49;\n  padding-left: 1rem !important;\n}\nbody.dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-cart .media-list .media:hover,\nbody.dark-layout .header-navbar .navbar-container .navbar-nav .dropdown-notification .dropdown-cart .media-list .media:hover {\n  background-color: #fff !important;\n}\nbody.dark-layout .header-navbar.navbar-static-top {\n  background-color: transparent;\n}\nbody.dark-layout .header-navbar[class*=bg-] .navbar-nav .nav-item .nav-link {\n  background-color: inherit;\n}\nbody.dark-layout .header-navbar[class*=bg-] .navbar-nav .nav-item .nav-link svg {\n  stroke: #fff;\n}\nbody.dark-layout .header-navbar.bg-dark {\n  background-color: #adb5bd !important;\n}\nbody.dark-layout .main-menu {\n  background-color: #10163a;\n}\nbody.dark-layout .main-menu .shadow-bottom {\n  background: linear-gradient(180deg, #0f1642 44%, rgba(15, 22, 66, 0.51) 73%, rgba(44, 48, 60, 0));\n}\nbody.dark-layout .main-menu:not(.expanded) .navigation .sidebar-group-active a {\n  background-color: #262c49;\n}\nbody.dark-layout .main-menu.theme-dark .navbar-header .brand-text {\n  color: #adb5bd !important;\n}\nbody.dark-layout .main-menu.theme-dark .navigation .nav-item.active a {\n  background: linear-gradient(118deg, #adb5bd, rgba(173, 181, 189, 0.7));\n  box-shadow: 0 0 10px 1px rgba(173, 181, 189, 0.7);\n}\nbody.dark-layout .main-menu.theme-dark .navigation .nav-item .menu-content li.active {\n  background: linear-gradient(118deg, #adb5bd, rgba(173, 181, 189, 0.7));\n  box-shadow: 0 0 10px 1px rgba(173, 181, 189, 0.7);\n}\nbody.dark-layout .main-menu-content .navigation-main {\n  background-color: #10163a;\n}\nbody.dark-layout .main-menu-content .navigation-main .nav-item .menu-text {\n  color: #c2c6dc;\n}\nbody.dark-layout .main-menu-content .navigation-main .nav-item svg {\n  stroke: #c2c6dc;\n}\nbody.dark-layout .main-menu-content .navigation-main .nav-item.open a {\n  background-color: #262c49;\n}\nbody.dark-layout .main-menu-content .navigation-main .nav-item a:after {\n  color: #c2c6dc;\n}\nbody.dark-layout .main-menu-content .navigation-main .nav-item .menu-content {\n  background-color: #10163a;\n}\nbody.dark-layout .main-menu-content .navigation-main .nav-item .menu-content .active .menu-item {\n  color: #fff;\n}\nbody.dark-layout .main-menu-content .navigation-main .nav-item .menu-content li:not(.active) a {\n  background-color: #10163a;\n  color: #c2c6dc;\n}\nbody.dark-layout .main-menu-content .navigation-main .active .menu-text,\nbody.dark-layout .main-menu-content .navigation-main .active svg,\nbody.dark-layout .main-menu-content .navigation-main .active span {\n  color: #fff;\n  stroke: #fff;\n}\nbody.dark-layout .main-menu-content .navigation-main .sidebar-group-active a {\n  background: #10163a;\n  border-radius: 4px;\n}\nbody.dark-layout .main-menu-content .navigation-main .sidebar-group-active .menu-content {\n  background-color: #10163a;\n}\nbody.dark-layout .main-menu-content .navigation-main .sidebar-group-active .menu-content .active {\n  z-index: 1;\n}\nbody.dark-layout .main-menu-content .navigation-main .sidebar-group-active .menu-content .active a {\n  background-color: transparent;\n}\nbody.dark-layout.menu-collapsed .main-menu:not(.expanded) .navigation-main li.active a {\n  background: #262c49 !important;\n}\nbody.dark-layout .bd-example .row,\nbody.dark-layout .bd-example .d-flex {\n  background-color: #262c49;\n}\nbody.dark-layout .bd-example .row .col,\nbody.dark-layout .bd-example .row [class*=col-],\nbody.dark-layout .bd-example .row .bd-highlight,\nbody.dark-layout .bd-example .d-flex .col,\nbody.dark-layout .bd-example .d-flex [class*=col-],\nbody.dark-layout .bd-example .d-flex .bd-highlight {\n  background-color: #262c49;\n  border-color: #808080;\n}\nbody.dark-layout .bd-example .height-example-wrapper {\n  background-color: #343661 !important;\n}\nbody.dark-layout .bd-example .width-example,\nbody.dark-layout .bd-example .height-example {\n  background-color: #262c49 !important;\n}\nbody.dark-layout .bd-example-row-flex-cols .row {\n  background-color: #262c49;\n}\nbody.dark-layout .colors-container span {\n  color: #fff;\n}\nbody.dark-layout .alert .alert-heading,\nbody.dark-layout .alert p {\n  color: inherit;\n}\nbody.dark-layout .alert.alert-dark {\n  color: #b8c2cc !important;\n}\nbody.dark-layout .alert.alert-dark .alert-heading,\nbody.dark-layout .alert.alert-dark p {\n  color: #b8c2cc;\n}\nbody.dark-layout .content-header-left .breadcrumbs-top .content-header-title {\n  color: #ebeefd;\n}\nbody.dark-layout .content-header-left .breadcrumbs-top .breadcrumb-wrapper .breadcrumb .breadcrumb-item {\n  color: #c2c6dc;\n}\nbody.dark-layout .content-header-left .breadcrumbs-top .breadcrumb-wrapper .breadcrumb .breadcrumb-item:before {\n  color: #c2c6dc;\n}\nbody.dark-layout .content-header-left .breadcrumbs-top .breadcrumb-wrapper .breadcrumb .breadcrumb-item:not(.active) a:hover {\n  color: #7367f0;\n}\nbody.dark-layout #breadcrumb-slash .breadcrumb .breadcrumb-item,\nbody.dark-layout #breadcrumb-alignment .breadcrumb .breadcrumb-item {\n  color: #c2c6dc;\n}\nbody.dark-layout #breadcrumb-slash .breadcrumb .breadcrumb-item:before,\nbody.dark-layout #breadcrumb-alignment .breadcrumb .breadcrumb-item:before {\n  color: #c2c6dc;\n}\nbody.dark-layout #breadcrumb-slash .breadcrumb .breadcrumb-item:not(.active) a:hover,\nbody.dark-layout #breadcrumb-alignment .breadcrumb .breadcrumb-item:not(.active) a:hover {\n  color: #7367f0;\n}\nbody.dark-layout #component-breadcrumbs .breadcrumb .breadcrumb-item:not(.active) a {\n  color: #c2c6dc;\n}\nbody.dark-layout #component-breadcrumbs .breadcrumb .breadcrumb-item:before {\n  color: #c2c6dc;\n}\nbody.dark-layout #component-breadcrumbs .breadcrumb .breadcrumb-item.active span {\n  color: #7367f0;\n}\nbody.dark-layout .collapse-bordered .collapse-header {\n  border-color: rgba(255, 255, 255, 0.04);\n}\nbody.dark-layout .collapse-bordered.accordion-shadow {\n  box-shadow: 0 0 8px 0 rgba(255, 255, 255, 0.1);\n}\nbody.dark-layout .collapse-bordered .card {\n  border-color: #414561;\n}\nbody.dark-layout .accordion .collapse-border-item {\n  border-color: rgba(255, 255, 255, 0.04);\n}\nbody.dark-layout .collapse-margin {\n  box-shadow: 0 2px 15px 0 rgba(255, 255, 255, 0.1);\n}\nbody.dark-layout .accordion[data-toggle-hover=true] .card,\nbody.dark-layout .collapse[data-toggle-hover=true] .card {\n  border-color: rgba(255, 255, 255, 0.04);\n}\nbody.dark-layout .collapse-icon .card-header a {\n  color: #c2c6dc;\n}\nbody.dark-layout .btn span {\n  color: #fff;\n}\nbody.dark-layout .btn.btn-white span {\n  color: #22292f;\n}\nbody.dark-layout .btn.btn-icon i {\n  color: #fff;\n}\nbody.dark-layout .btn.btn-dark, body.dark-layout .btn.btn-outline-dark, body.dark-layout .btn.btn-flat-dark {\n  color: #b8c2cc;\n}\nbody.dark-layout .btn.btn-dark {\n  background-color: #4e5154 !important;\n}\nbody.dark-layout .btn.btn-outline-dark {\n  border-color: #4e5154;\n  color: #b8c2cc;\n}\nbody.dark-layout .btn.btn-flat-dark:active, body.dark-layout .btn.btn-flat-dark:focus {\n  background: #4e5154;\n}\nbody.dark-layout .btn.btn-white {\n  color: #626262;\n}\nbody.dark-layout .dropdown-toggle {\n  color: #fff;\n}\nbody.dark-layout .dropdown-toggle:hover i, body.dark-layout .dropdown-toggle:hover:after {\n  color: #fff;\n}\nbody.dark-layout .dropdown-menu {\n  background-color: #262c49;\n}\nbody.dark-layout .dropdown-menu:before,\nbody.dark-layout .dropdown-menu .dropdown-item:hover,\nbody.dark-layout .dropdown-menu .dropdown-item:focus {\n  background: #262c49;\n}\nbody.dark-layout .dropdown-menu .dropdown-item {\n  color: #c2c6dc;\n}\nbody.dark-layout .dropdown-menu .form-control {\n  background-color: #10163a;\n}\nbody.dark-layout .dropdown-menu .dropdown-divider {\n  border-color: #414561;\n}\nbody.dark-layout .btn-white ~ .dropdown-menu .dropdown-item:not(.acitve):hover {\n  color: #7367f0 !important;\n}\nbody.dark-layout .btn-dark ~ .dropdown-menu .dropdown-item:hover,\nbody.dark-layout .btn-outline-dark ~ .dropdown-menu .dropdown-item:hover,\nbody.dark-layout .btn-flat-dark ~ .dropdown-menu .dropdown-item:hover {\n  color: #c2c6dc;\n}\nbody.dark-layout .dropup.dropdown-icon-wrapper .dropdown-menu .dropdown-item i {\n  color: #c2c6dc;\n}\nbody.dark-layout .modal .modal-header,\nbody.dark-layout .modal .modal-header[class*=bg-] {\n  background-color: #10163a !important;\n}\nbody.dark-layout .modal .modal-header .close,\nbody.dark-layout .modal .modal-header[class*=bg-] .close {\n  background-color: #262c49;\n  text-shadow: none;\n}\nbody.dark-layout .modal .modal-header .close span,\nbody.dark-layout .modal .modal-header[class*=bg-] .close span {\n  color: #fff;\n}\nbody.dark-layout .modal .modal-content,\nbody.dark-layout .modal .modal-body,\nbody.dark-layout .modal .modal-footer {\n  background-color: #262c49;\n  color: #c2c6dc;\n}\nbody.dark-layout .modal .modal-content .form-control,\nbody.dark-layout .modal .modal-content .picker__input,\nbody.dark-layout .modal .modal-content .custom-file-label,\nbody.dark-layout .modal .modal-content .custom-file-label:after,\nbody.dark-layout .modal .modal-body .form-control,\nbody.dark-layout .modal .modal-body .picker__input,\nbody.dark-layout .modal .modal-body .custom-file-label,\nbody.dark-layout .modal .modal-body .custom-file-label:after,\nbody.dark-layout .modal .modal-footer .form-control,\nbody.dark-layout .modal .modal-footer .picker__input,\nbody.dark-layout .modal .modal-footer .custom-file-label,\nbody.dark-layout .modal .modal-footer .custom-file-label:after {\n  background-color: #10163a !important;\n}\nbody.dark-layout .pagination:not([class*=pagination-]) .page-item.active {\n  background-color: #262c49;\n}\nbody.dark-layout .pagination:not([class*=pagination-]) .page-item.active .page-link {\n  background-color: #7367f0;\n}\nbody.dark-layout .pagination:not([class*=pagination-]) .page-item.active .page-link:hover {\n  color: #fff;\n}\nbody.dark-layout .pagination:not([class*=pagination-]) .page-item .page-link {\n  background-color: #262c49;\n  color: #fff;\n}\nbody.dark-layout .pagination:not([class*=pagination-]) .page-item .page-link:hover {\n  color: #7367f0;\n}\nbody.dark-layout .pagination:not([class*=pagination-]) .page-item.prev-item .page-link:hover, body.dark-layout .pagination:not([class*=pagination-]) .page-item.next-item .page-link:hover {\n  color: #fff;\n}\nbody.dark-layout .pagination[class*=pagination-] .page-item:not(.active):not(:hover) .page-link {\n  background-color: #262c49;\n  color: #fff;\n}\nbody.dark-layout .pagination[class*=pagination-] .page-item:not(.active) .page-link:hover {\n  background-color: #262c49;\n}\nbody.dark-layout .pagination[class*=pagination-] .page-item.active {\n  background-color: #262c49;\n}\nbody.dark-layout .nav .nav-item .nav-link {\n  color: #c2c6dc;\n}\nbody.dark-layout .nav .nav-item .nav-link.active, body.dark-layout .nav .nav-item .nav-link:hover {\n  color: #7367f0;\n}\nbody.dark-layout .nav.wrap-border {\n  border-color: #414561;\n}\nbody.dark-layout #navbar-component .basic-navbar .navbar {\n  background-color: #262c49;\n}\nbody.dark-layout #navbar-component .navbar .nav .nav-item a,\nbody.dark-layout #navbar-component .navbar .navbar-nav .nav-item a {\n  color: #fff !important;\n}\nbody.dark-layout #navbar-component .navbar .nav .nav-item .nav-link,\nbody.dark-layout #navbar-component .navbar .navbar-nav .nav-item .nav-link {\n  background-color: inherit;\n}\nbody.dark-layout #navbar-component .navbar .nav .nav-item .nav-link span,\nbody.dark-layout #navbar-component .navbar .navbar-nav .nav-item .nav-link span {\n  color: #fff;\n}\nbody.dark-layout #navbar-component .navbar .nav .nav-item .nav-link .badge,\nbody.dark-layout #navbar-component .navbar .nav .nav-item .nav-link svg,\nbody.dark-layout #navbar-component .navbar .navbar-nav .nav-item .nav-link .badge,\nbody.dark-layout #navbar-component .navbar .navbar-nav .nav-item .nav-link svg {\n  color: #fff !important;\n  stroke: #fff !important;\n}\nbody.dark-layout .nav-tabs .nav-item .nav-link,\nbody.dark-layout .nav-tabs.nav-justified .nav-item .nav-link,\nbody.dark-layout .nav:not(.nav-pills) .nav-item .nav-link {\n  background-color: #10163a;\n}\nbody.dark-layout .nav-tabs .nav-item .nav-link.active,\nbody.dark-layout .nav-tabs.nav-justified .nav-item .nav-link.active,\nbody.dark-layout .nav:not(.nav-pills) .nav-item .nav-link.active {\n  background-color: #10163a;\n}\nbody.dark-layout .nav-tabs .nav-item .nav-link.disabled,\nbody.dark-layout .nav-tabs.nav-justified .nav-item .nav-link.disabled,\nbody.dark-layout .nav:not(.nav-pills) .nav-item .nav-link.disabled {\n  opacity: 0.5;\n}\nbody.dark-layout .nav-tabs ~ .tab-content .tab-pane,\nbody.dark-layout .nav-tabs.nav-justified ~ .tab-content .tab-pane,\nbody.dark-layout .nav:not(.nav-pills) ~ .tab-content .tab-pane {\n  background-color: #10163a;\n}\nbody.dark-layout .nav-vertical .nav.nav-tabs.nav-left ~ .tab-content .tab-pane, body.dark-layout .nav-vertical .nav.nav-tabs.nav-right ~ .tab-content .tab-pane {\n  background-color: #10163a;\n}\nbody.dark-layout .nav-pills .nav-item .nav-link.active {\n  color: #fff;\n}\nbody.dark-layout .nav-pills.nav-active-bordered-pill .nav-item .nav-link.active {\n  background-color: transparent !important;\n}\nbody.dark-layout .nav-justified.nav.nav-tabs .nav-item .nav-link.active {\n  background-color: transparent;\n}\nbody.dark-layout .card {\n  background-color: #10163a;\n}\nbody.dark-layout .card.border {\n  border-color: #414561 !important;\n}\nbody.dark-layout .card .card-title {\n  color: #fff;\n}\nbody.dark-layout .card .card-header,\nbody.dark-layout .card .card-footer {\n  color: #c2c6dc;\n  background-color: #10163a !important;\n}\nbody.dark-layout .card .card-body,\nbody.dark-layout .card .card-footer {\n  color: #c2c6dc;\n  border-color: #414561;\n}\nbody.dark-layout .card.overlay-img-card .card-img-overlay span,\nbody.dark-layout .card.overlay-img-card .card-img-overlay p {\n  color: #fff;\n}\nbody.dark-layout .media-bordered .media {\n  border-color: #414561;\n}\nbody.dark-layout .activity-timeline {\n  border-color: #414561;\n}\nbody.dark-layout #dashboard-analytics .bg-analytics {\n  background: linear-gradient(118deg, #7367f0, rgba(115, 103, 240, 0.7));\n}\nbody.dark-layout #dashboard-analytics .bg-analytics p {\n  color: #fff;\n}\nbody.dark-layout #dashboard-analytics .bg-analytics .card-body {\n  background-color: transparent;\n}\nbody.dark-layout .chat-widget.chat-application .chat-app-window .user-chats .chats .chat-body .chat-content p {\n  color: #fff;\n}\nbody.dark-layout .chat-widget.chat-application .chat-app-window .user-chats .chats .chat-left .chat-content {\n  background-color: #171e49;\n  border: 1px solid #414561;\n}\nbody.dark-layout .chat-widget.chat-application .chat-app-window .user-chats .chats .chat-left .chat-content p {\n  color: #c2c6dc;\n}\nbody.dark-layout .chat-widget.chat-application .chat-app-window .chat-footer {\n  border-top: 1px solid #414561;\n}\nbody.dark-layout .chat-widget.chat-application .chat-app-window .chat-footer .card-body {\n  padding-top: 1.5rem !important;\n}\nbody.dark-layout .badge {\n  color: #fff;\n}\nbody.dark-layout .badge span {\n  color: #fff;\n}\nbody.dark-layout .badge:hover i {\n  color: #fff;\n}\nbody.dark-layout .popover[x-placement=top] .arrow:after {\n  border-top-color: #262c49;\n}\nbody.dark-layout .popover[x-placement=bottom] .arrow:after {\n  border-bottom-color: #7367f0;\n}\nbody.dark-layout .popover[x-placement=left] .arrow:after {\n  border-left-color: #262c49;\n}\nbody.dark-layout .popover[x-placement=right] .arrow:after {\n  border-right-color: #262c49;\n}\nbody.dark-layout .popover .popover-body {\n  background-color: #262c49;\n  color: #c2c6dc;\n}\nbody.dark-layout .toast {\n  background-color: #262c49;\n  box-shadow: -5px 5px 5px 0px rgba(0, 0, 0, 0.3);\n}\nbody.dark-layout .toast .toast-header {\n  background-color: #262c49;\n  color: #c2c6dc;\n  border-color: #414561;\n}\nbody.dark-layout .toast .toast-header .close {\n  text-shadow: none;\n  opacity: 1;\n}\nbody.dark-layout .toast .toast-body {\n  background-color: #262c49;\n  color: #c2c6dc;\n}\nbody.dark-layout .progress {\n  background-color: #262c49;\n}\nbody.dark-layout .avatar {\n  background-color: #262c49;\n}\nbody.dark-layout .avatar .avatar-content {\n  color: #fff;\n}\nbody.dark-layout .chip {\n  background-color: #262c49;\n}\nbody.dark-layout .chip .avatar {\n  background-color: #10163a;\n}\nbody.dark-layout .chip .chip-body .chip-text,\nbody.dark-layout .chip .chip-body span {\n  color: #fff;\n}\nbody.dark-layout .divider .divider-text {\n  background-color: transparent;\n  color: #c2c6dc;\n}\nbody.dark-layout .divider .divider-text::before, body.dark-layout .divider .divider-text::after {\n  border-color: #414561;\n}\nbody.dark-layout .divider.divider-dark .divider-text::before, body.dark-layout .divider.divider-dark .divider-text::after {\n  border-color: #4e5154 !important;\n}\nbody.dark-layout .vx-wizard.nav.nav-tabs .step-wrapper.nav-item .step.nav-link:not(.active) .step-text {\n  background-color: #262c49;\n}\nbody.dark-layout .vx-wizard.nav.nav-tabs .step-wrapper.nav-item .step.nav-link:not(.active) .step-text svg {\n  color: #c2c6dc;\n}\nbody.dark-layout .list-group .list-group-item:not([class*=list-group-item-]), body.dark-layout .list-group .list-group-item.list-group-item-action {\n  background-color: #10163a;\n  border-color: #414561;\n  color: #c2c6dc;\n}\nbody.dark-layout .list-group .list-group-item:not([class*=list-group-item-]):hover, body.dark-layout .list-group .list-group-item.list-group-item-action:hover {\n  background-color: #262c49;\n}\nbody.dark-layout .list-group .list-group-item.active {\n  background-color: #7367f0;\n  color: #fff;\n}\nbody.dark-layout .list-group .list-group-item.active p,\nbody.dark-layout .list-group .list-group-item.active small,\nbody.dark-layout .list-group .list-group-item.active .small {\n  color: #fff;\n}\nbody.dark-layout .list-group .list-group-item.disabled {\n  background-color: #262c49;\n}\nbody.dark-layout input.form-control,\nbody.dark-layout .custom-file-label,\nbody.dark-layout textarea.form-control {\n  background-color: #262c49;\n  color: #c2c6dc;\n}\nbody.dark-layout input.form-control:not(:focus),\nbody.dark-layout .custom-file-label:not(:focus),\nbody.dark-layout textarea.form-control:not(:focus) {\n  border: 0;\n}\nbody.dark-layout input.form-control::placeholder,\nbody.dark-layout .custom-file-label::placeholder,\nbody.dark-layout textarea.form-control::placeholder {\n  color: #c2c6dc;\n}\nbody.dark-layout input.form-control ~ .form-control-position svg,\nbody.dark-layout .custom-file-label ~ .form-control-position svg,\nbody.dark-layout textarea.form-control ~ .form-control-position svg {\n  color: #c2c6dc;\n}\nbody.dark-layout input.form-control:focus ~ .form-control-position i,\nbody.dark-layout .custom-file-label:focus ~ .form-control-position i,\nbody.dark-layout textarea.form-control:focus ~ .form-control-position i {\n  color: #7367f0;\n}\nbody.dark-layout input.form-control:disabled, body.dark-layout input.form-control[readonly],\nbody.dark-layout .custom-file-label:disabled,\nbody.dark-layout .custom-file-label[readonly],\nbody.dark-layout textarea.form-control:disabled,\nbody.dark-layout textarea.form-control[readonly] {\n  opacity: 0.5;\n}\nbody.dark-layout .char-textarea.active {\n  color: #c2c6dc !important;\n}\nbody.dark-layout .char-textarea.max-limit {\n  color: #ea5455 !important;\n}\nbody.dark-layout .custom-file-label:after {\n  background-color: #262c49;\n  border-left: 1px solid #414561;\n  color: #c2c6dc;\n}\nbody.dark-layout .has-icon-left.input-divider-left .form-control-position i {\n  border-right-color: #414561;\n}\nbody.dark-layout .has-icon-left.input-divider-right .form-control-position i {\n  border-left-color: #414561;\n}\nbody.dark-layout select.form-control,\nbody.dark-layout .custom-select {\n  background-color: #262c49;\n  color: #c2c6dc;\n  border: 0;\n}\nbody.dark-layout select.form-control option:checked,\nbody.dark-layout .custom-select option:checked {\n  background-color: #10163a;\n}\nbody.dark-layout .custom-control.custom-radio input[disabled] ~ label:before, body.dark-layout .custom-control.custom-radio input[disabled] ~ label:after, body.dark-layout .custom-control.custom-checkbox input[disabled] ~ label:before, body.dark-layout .custom-control.custom-checkbox input[disabled] ~ label:after {\n  opacity: 0.5;\n}\nbody.dark-layout .select__control,\nbody.dark-layout .React__control {\n  background-color: #262c49;\n  border-color: #414561;\n}\nbody.dark-layout .select__control .select__value-container .select__single-value,\nbody.dark-layout .select__control .select__value-container .React__single-value,\nbody.dark-layout .select__control .React__value-container .select__single-value,\nbody.dark-layout .select__control .React__value-container .React__single-value,\nbody.dark-layout .React__control .select__value-container .select__single-value,\nbody.dark-layout .React__control .select__value-container .React__single-value,\nbody.dark-layout .React__control .React__value-container .select__single-value,\nbody.dark-layout .React__control .React__value-container .React__single-value {\n  color: #c2c6dc;\n}\nbody.dark-layout .select__control .select__value-container .select__multi-value,\nbody.dark-layout .select__control .React__value-container .select__multi-value,\nbody.dark-layout .React__control .select__value-container .select__multi-value,\nbody.dark-layout .React__control .React__value-container .select__multi-value {\n  background-color: #10163a;\n}\nbody.dark-layout .select__control .select__value-container .select__multi-value .select__multi-value__label,\nbody.dark-layout .select__control .React__value-container .select__multi-value .select__multi-value__label,\nbody.dark-layout .React__control .select__value-container .select__multi-value .select__multi-value__label,\nbody.dark-layout .React__control .React__value-container .select__multi-value .select__multi-value__label {\n  color: #c2c6dc;\n}\nbody.dark-layout .select__control ~ .select__menu,\nbody.dark-layout .select__control ~ .React__menu,\nbody.dark-layout .React__control ~ .select__menu,\nbody.dark-layout .React__control ~ .React__menu {\n  background-color: #262c49;\n}\nbody.dark-layout .select__control ~ .select__menu .select__menu-list.select__option--is-selected, body.dark-layout .select__control ~ .select__menu .select__menu-list.React__option--is-selected,\nbody.dark-layout .select__control ~ .select__menu .React__menu-list.select__option--is-selected,\nbody.dark-layout .select__control ~ .select__menu .React__menu-list.React__option--is-selected,\nbody.dark-layout .select__control ~ .React__menu .select__menu-list.select__option--is-selected,\nbody.dark-layout .select__control ~ .React__menu .select__menu-list.React__option--is-selected,\nbody.dark-layout .select__control ~ .React__menu .React__menu-list.select__option--is-selected,\nbody.dark-layout .select__control ~ .React__menu .React__menu-list.React__option--is-selected,\nbody.dark-layout .React__control ~ .select__menu .select__menu-list.select__option--is-selected,\nbody.dark-layout .React__control ~ .select__menu .select__menu-list.React__option--is-selected,\nbody.dark-layout .React__control ~ .select__menu .React__menu-list.select__option--is-selected,\nbody.dark-layout .React__control ~ .select__menu .React__menu-list.React__option--is-selected,\nbody.dark-layout .React__control ~ .React__menu .select__menu-list.select__option--is-selected,\nbody.dark-layout .React__control ~ .React__menu .select__menu-list.React__option--is-selected,\nbody.dark-layout .React__control ~ .React__menu .React__menu-list.select__option--is-selected,\nbody.dark-layout .React__control ~ .React__menu .React__menu-list.React__option--is-selected {\n  background-color: #10163a;\n}\nbody.dark-layout .select__control.select__control--is-focused .select__loading-indicator,\nbody.dark-layout .React__control.select__control--is-focused .select__loading-indicator {\n  color: #c2c6dc;\n}\nbody.dark-layout .select__control.select__control--is-focused .select__loading-indicator span,\nbody.dark-layout .React__control.select__control--is-focused .select__loading-indicator span {\n  background-color: #c2c6dc;\n}\nbody.dark-layout .react-numeric-input {\n  background-color: #262c49 !important;\n}\nbody.dark-layout .react-numeric-input input {\n  background-color: #262c49 !important;\n  color: #c2c6dc !important;\n}\nbody.dark-layout .react-toggle-wrapper .react-toggle:not(.react-toggle--checked):not([class*=switch-]) .react-toggle-track {\n  background-color: #262c49;\n}\nbody.dark-layout .react-toggle-wrapper .react-toggle .react-toggle-track .react-toggle-track-x svg,\nbody.dark-layout .react-toggle-wrapper .react-toggle .react-toggle-track .react-toggle-track-check svg {\n  stroke: #fff;\n  fill: #fff;\n}\nbody.dark-layout .custom-switch .custom-control-input[disabled] ~ .custom-control-label {\n  opacity: 0.5;\n}\nbody.dark-layout .custom-switch .custom-control-input:not(:disabled):active ~ .custom-control-label::before {\n  background-color: #7367f0;\n}\nbody.dark-layout .custom-switch .custom-control-input:checked ~ .custom-control-label::before {\n  background-color: #7367f0;\n}\nbody.dark-layout .custom-switch .custom-control-label:before {\n  background-color: #262c49;\n}\nbody.dark-layout .input-group .input-group-prepend .input-group-text,\nbody.dark-layout .input-group .input-group-append .input-group-text {\n  background-color: #10163a;\n  border: 1px solid #414561;\n}\nbody.dark-layout .input-group .input-group-prepend ~ .form-control {\n  border-left: 1px solid #414561;\n}\nbody.dark-layout .input-group .form-control ~ .input-group-append {\n  border-left: 1px solid #414561;\n}\nbody.dark-layout .form-label-group > input:not(:focus):not(:placeholder-shown) ~ label, body.dark-layout .form-label-group > textarea:not(:focus):not(:placeholder-shown) ~ label {\n  color: #c2c6dc !important;\n}\nbody.dark-layout .form-control.flatpickr-input {\n  background-color: #262c49;\n}\nbody.dark-layout .form-control.flatpickr-input ~ input {\n  background-color: #262c49;\n}\nbody.dark-layout .flatpickr-calendar:not(.inline):after, body.dark-layout .flatpickr-calendar:not(.inline):before {\n  border-bottom-color: #7367f0;\n}\nbody.dark-layout .flatpickr-calendar .flatpickr-innerContainer {\n  background: #262c49;\n  border-color: #262c49;\n}\nbody.dark-layout .flatpickr-calendar .flatpickr-months .flatpickr-prev-month,\nbody.dark-layout .flatpickr-calendar .flatpickr-months .flatpickr-next-month {\n  fill: #fff;\n  color: #fff;\n}\nbody.dark-layout .flatpickr-calendar .flatpickr-months .flatpickr-month select:hover {\n  background: #fff;\n}\nbody.dark-layout .flatpickr-calendar .flatpickr-months .numInputWrapper .numInput {\n  color: #fff;\n}\nbody.dark-layout .flatpickr-calendar .flatpickr-days {\n  border-color: #262c49;\n}\nbody.dark-layout .flatpickr-calendar .flatpickr-days .flatpickr-day:hover, body.dark-layout .flatpickr-calendar .flatpickr-days .flatpickr-day:focus {\n  background-color: #10163a;\n  border-color: #10163a;\n}\nbody.dark-layout .flatpickr-calendar .flatpickr-days .flatpickr-day.prevMonthDay, body.dark-layout .flatpickr-calendar .flatpickr-days .flatpickr-day.nextMonthDay, body.dark-layout .flatpickr-calendar .flatpickr-days .flatpickr-day.flatpickr-disabled {\n  color: #636363;\n}\nbody.dark-layout .flatpickr-calendar .flatpickr-weekdays,\nbody.dark-layout .flatpickr-calendar .flatpickr-weekday {\n  color: #fff;\n}\nbody.dark-layout .table:not(.table-inverse) {\n  background-color: #212744;\n}\nbody.dark-layout .table:not(.table-inverse) .thead tr:not([class*=table-]) th,\nbody.dark-layout .table:not(.table-inverse) .thead tr:not([class*=table-]) td,\nbody.dark-layout .table:not(.table-inverse) tbody tr:not([class*=table-]) th,\nbody.dark-layout .table:not(.table-inverse) tbody tr:not([class*=table-]) td {\n  border-color: #414561;\n  color: #c2c6dc;\n}\nbody.dark-layout .table:not(.table-inverse) .thead tr:not([class*=table-]) th code,\nbody.dark-layout .table:not(.table-inverse) .thead tr:not([class*=table-]) td code,\nbody.dark-layout .table:not(.table-inverse) tbody tr:not([class*=table-]) th code,\nbody.dark-layout .table:not(.table-inverse) tbody tr:not([class*=table-]) td code {\n  background-color: #10163a;\n}\nbody.dark-layout .table:not(.table-inverse) thead tr th {\n  border: 0;\n  background-color: #212744;\n  color: #c2c6dc;\n}\nbody.dark-layout .table:not(.table-inverse) tbody tr[class*=table-] td,\nbody.dark-layout .table:not(.table-inverse) tbody tr[class*=table-] th {\n  background-color: unset;\n  color: #22292f;\n  border-color: #414561;\n}\nbody.dark-layout .table:not(.table-inverse) tbody tr.table-dark td,\nbody.dark-layout .table:not(.table-inverse) tbody tr.table-dark th {\n  color: #fff;\n}\nbody.dark-layout .table:not(.table-inverse) tbody tr.table-active td,\nbody.dark-layout .table:not(.table-inverse) tbody tr.table-active th {\n  color: #c2c6dc;\n}\nbody.dark-layout .table:not(.table-inverse) tbody tr th {\n  background-color: #262c49;\n}\nbody.dark-layout .table:not(.table-inverse) tbody tr td {\n  background-color: #262c49;\n  color: #c2c6dc;\n}\nbody.dark-layout .table:not(.table-inverse).table-bordered {\n  border: 1px solid #414561;\n}\nbody.dark-layout .table:not(.table-inverse).table-bordered thead tr th,\nbody.dark-layout .table:not(.table-inverse).table-bordered thead tr td,\nbody.dark-layout .table:not(.table-inverse).table-bordered tbody tr th,\nbody.dark-layout .table:not(.table-inverse).table-bordered tbody tr td {\n  border: 1px solid #414561;\n}\nbody.dark-layout .table:not(.table-inverse).table-hover tbody tr:hover {\n  background-color: #10163a;\n}\nbody.dark-layout .table:not(.table-inverse).table-hover tbody tr th,\nbody.dark-layout .table:not(.table-inverse).table-hover tbody tr td {\n  background-color: unset;\n}\nbody.dark-layout .table:not(.table-inverse).table-striped tbody tr:nth-of-type(odd) {\n  background-color: #10163a;\n}\nbody.dark-layout .table:not(.table-inverse).table-striped tbody tr td,\nbody.dark-layout .table:not(.table-inverse).table-striped tbody tr th {\n  background-color: unset;\n}\nbody.dark-layout .table:not(.table-inverse).table-mx-0 {\n  background-color: #10163a;\n}\nbody.dark-layout .table:not(.table-inverse).table-mx-0 thead tr th,\nbody.dark-layout .table:not(.table-inverse).table-mx-0 thead tr td,\nbody.dark-layout .table:not(.table-inverse).table-mx-0 tbody tr th,\nbody.dark-layout .table:not(.table-inverse).table-mx-0 tbody tr td {\n  background-color: #10163a;\n}\nbody.dark-layout .ReactTable .rt-table .rt-thead {\n  border-color: #414561;\n}\nbody.dark-layout .ReactTable .rt-table .rt-thead .rt-th {\n  background-color: #262c49;\n  border-color: #414561;\n}\nbody.dark-layout .ReactTable .rt-table .rt-thead .rt-th input,\nbody.dark-layout .ReactTable .rt-table .rt-thead .rt-th select {\n  background-color: #10163a;\n  color: #c2c6dc;\n}\nbody.dark-layout .ReactTable .rt-table .rt-tbody .rt-tr .rt-td {\n  background-color: #262c49;\n  border-color: #414561;\n}\nbody.dark-layout .ReactTable .rt-table .rt-tbody .rt-tr .rt-td div:not(.rt-expander) {\n  background-color: #262c49 !important;\n}\nbody.dark-layout .ReactTable .rt-table .rt-tbody .rt-tr .rt-td.rt-expandable {\n  background-color: #262c49 !important;\n}\nbody.dark-layout .ReactTable .rt-table .rt-tbody .rt-tr .rt-td.rt-expandable .rt-expander:after {\n  border-top-color: #c2c6dc;\n}\nbody.dark-layout .ReactTable .rt-table .rt-tbody .rt-tr-group {\n  border-color: #414561;\n}\nbody.dark-layout .ReactTable .pagination-bottom .-pageJump input {\n  background-color: #262c49;\n  color: #c2c6dc;\n}\nbody.dark-layout .ReactTable .pagination-bottom .select-wrap select {\n  background-color: #262c49;\n  color: #c2c6dc;\n}\nbody.dark-layout .ReactTable.nested-table .rt-tbody .rt-tr-group .rt-td:first-child {\n  background-color: #262c49 !important;\n}\nbody.dark-layout .ag-grid-table {\n  background-color: #10163a;\n}\nbody.dark-layout .ag-grid-table .ag-dropdown {\n  border-color: #414561;\n}\nbody.dark-layout .ag-grid-table .ag-dropdown div {\n  color: #c2c6dc;\n}\nbody.dark-layout .ag-grid-table .ag-pinned-left-header {\n  border-color: #414561;\n}\nbody.dark-layout .ag-grid-table .ag-root-wrapper .ag-root-wrapper-body .ag-header {\n  background-color: #10163a;\n  border-color: #414561;\n}\nbody.dark-layout .ag-grid-table .ag-root-wrapper .ag-root-wrapper-body .ag-header .ag-header-cell {\n  border-color: #414561;\n  background-color: #10163a;\n}\nbody.dark-layout .ag-grid-table .ag-root-wrapper .ag-root-wrapper-body .ag-header .ag-header-cell-label,\nbody.dark-layout .ag-grid-table .ag-root-wrapper .ag-root-wrapper-body .ag-header .ag-floating-filter-input {\n  color: #c2c6dc;\n}\nbody.dark-layout .ag-grid-table .ag-root-wrapper .ag-root-wrapper-body .ag-header .ag-floating-filter-input {\n  border-color: #414561;\n}\nbody.dark-layout .ag-grid-table .ag-root-wrapper .ag-root-wrapper-body .ag-body-viewport .ag-cell {\n  color: #c2c6dc;\n  border-color: #414561;\n}\nbody.dark-layout .ag-grid-table .ag-root-wrapper .ag-root-wrapper-body .ag-body-viewport .ag-row {\n  border-color: #414561;\n}\nbody.dark-layout .ag-grid-table .ag-row-hover,\nbody.dark-layout .ag-grid-table .ag-header-cell:hover,\nbody.dark-layout .ag-grid-table .ag-row-selected {\n  background-color: #262c49 !important;\n}\nbody.dark-layout .ag-grid-table .ag-icon {\n  color: #c2c6dc;\n}\nbody.dark-layout .ag-grid-table .ag-icon.ag-icon-checkbox-checked {\n  color: #7367f0;\n}\nbody.dark-layout .ag-grid-table .ag-paging-panel {\n  border-color: #414561;\n}\nbody.dark-layout .ag-grid-table .ag-paging-panel .ag-paging-button.ag-disabled {\n  background-color: #373f6d;\n}\nbody.dark-layout .ag-grid-table .ag-paging-panel .ag-paging-button.ag-disabled span {\n  color: #fff !important;\n}\nbody.dark-layout .ag-grid-table .ag-paging-panel span[ref=lbTotal] {\n  background-color: #373f6d;\n  color: #c2c6dc !important;\n}\nbody.dark-layout .ag-grid-table .ag-menu {\n  background-color: #262c49;\n}\nbody.dark-layout .ag-grid-table .ag-menu .ag-filter-select {\n  border-color: #414561;\n  color: #c2c6dc;\n}\nbody.dark-layout .ag-grid-table .ag-menu .ag-filter-select option {\n  color: #c2c6dc;\n  background-color: #262c49;\n}\nbody.dark-layout .ag-grid-table .ag-menu .ag-input-wrapper .ag-filter-filter {\n  color: #c2c6dc;\n  border-color: #414561;\n}\nbody.dark-layout .ag-grid-table .ag-menu .ag-input-wrapper .ag-filter-filter::placeholder {\n  color: #c2c6dc;\n}\nbody.dark-layout .ag-grid-table ::-webkit-scrollbar-thumb {\n  background: #7367f0;\n}\nbody.dark-layout .ag-grid-table ::-webkit-scrollbar-track {\n  background: #262c49;\n}\nbody.dark-layout .sweet-alert {\n  background-color: #10163a !important;\n}\nbody.dark-layout .sweet-alert h2, body.dark-layout .sweet-alert .h2, body.dark-layout .sweet-alert p {\n  color: #c2c6dc !important;\n}\nbody.dark-layout .bg-authentication {\n  background-color: #eff2f7;\n}\nbody.dark-layout .bg-authentication .auth-title {\n  color: #c2c6dc;\n}\nbody.dark-layout .bg-authentication .form-group.row,\nbody.dark-layout .bg-authentication .card-footer {\n  background-color: #10163a;\n}\nbody.dark-layout .bg-authentication .form-group.row .btn-facebook span,\nbody.dark-layout .bg-authentication .form-group.row .btn-twitter span,\nbody.dark-layout .bg-authentication .card-footer .btn-facebook span,\nbody.dark-layout .bg-authentication .card-footer .btn-twitter span {\n  color: #fff;\n}\nbody.dark-layout .bg-authentication .form-group .vx-checkbox-con span {\n  color: #c2c6dc;\n}\nbody.dark-layout .getting-started .clockCard p {\n  color: #c2c6dc !important;\n}\nbody.dark-layout .auth-card h1, body.dark-layout .auth-card .h1 {\n  color: #2c2c2c;\n}\nbody.dark-layout .auth-card p {\n  color: #fff;\n}\nbody.dark-layout #user-profile .profile-header img {\n  border-color: #fff !important;\n}\nbody.dark-layout #user-profile .profile-header .profile-header-nav {\n  background-color: #10163a;\n}\nbody.dark-layout #user-profile .profile-header .navbar svg {\n  color: #c2c6dc;\n}\nbody.dark-layout #user-profile .btn-load.loading {\n  background-color: rgba(255, 255, 255, 0.75) !important;\n}\nbody.dark-layout .account-settings-tab .nav-link {\n  background: transparent !important;\n}\nbody.dark-layout #search-website .search-bar .form-control {\n  background-color: #10163a;\n}\nbody.dark-layout #search-website .search-menu .search-filter {\n  background-color: #10163a;\n  color: #c2c6dc;\n}\nbody.dark-layout #search-website .search-result-info .dropdown-toggle {\n  color: #c2c6dc;\n}\nbody.dark-layout #search-website .search-pagination .pagination .page-item {\n  background-color: #10163a;\n}\nbody.dark-layout #search-website .search-pagination .pagination .page-item.active .page-link {\n  background-color: #7367f0;\n}\nbody.dark-layout #search-website .search-pagination .pagination .page-item .page-link {\n  background-color: #10163a;\n}\nbody.dark-layout .faq .accordion .collapse-margin {\n  background-color: #10163a;\n}\nbody.dark-layout .faq-bg .card-body .card-text,\nbody.dark-layout .knowledge-base-bg .card-body .card-text {\n  color: #fff;\n}\nbody.dark-layout .search-content .card .card-body .text-dark {\n  color: #c2c6dc !important;\n}\nbody.dark-layout .knowledge-base-category .list-group .list-group-item,\nbody.dark-layout .knowledge-base-question .list-group .list-group-item {\n  color: #7367f0;\n}\nbody.dark-layout .invoice-items-table .table-borderless,\nbody.dark-layout .invoice-total-table .table-borderless {\n  border: 0;\n}\nbody.dark-layout .invoice-header .input-group .form-control {\n  background-color: #10163a;\n}\nbody.dark-layout .apexcharts-canvas .apexcharts-gridlines-horizontal .apexcharts-gridline {\n  stroke: #414561;\n}\nbody.dark-layout .apexcharts-canvas .apexcharts-tooltip.light,\nbody.dark-layout .apexcharts-canvas .apexcharts-yaxistooltip,\nbody.dark-layout .apexcharts-canvas .apexcharts-xaxistooltip,\nbody.dark-layout .apexcharts-canvas .apexcharts-tooltip {\n  background-color: #212744;\n  border-color: #262c49;\n}\nbody.dark-layout .apexcharts-canvas .apexcharts-tooltip.light .apexcharts-tooltip-title,\nbody.dark-layout .apexcharts-canvas .apexcharts-tooltip.light .apexcharts-tooltip-text,\nbody.dark-layout .apexcharts-canvas .apexcharts-yaxistooltip .apexcharts-tooltip-title,\nbody.dark-layout .apexcharts-canvas .apexcharts-yaxistooltip .apexcharts-tooltip-text,\nbody.dark-layout .apexcharts-canvas .apexcharts-xaxistooltip .apexcharts-tooltip-title,\nbody.dark-layout .apexcharts-canvas .apexcharts-xaxistooltip .apexcharts-tooltip-text,\nbody.dark-layout .apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-title,\nbody.dark-layout .apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-text {\n  background-color: #212744;\n  color: #c2c6dc;\n}\nbody.dark-layout .apexcharts-canvas .apexcharts-tooltip.dark .apexcharts-tooltip-text .apexcharts-tooltip-text-label,\nbody.dark-layout .apexcharts-canvas .apexcharts-tooltip.dark .apexcharts-tooltip-text .apexcharts-tooltip-text-value {\n  color: #fff;\n}\nbody.dark-layout .apexcharts-canvas .apexcharts-xaxistooltip-bottom:before {\n  border-bottom-color: transparent;\n}\nbody.dark-layout .apexcharts-canvas .apexcharts-xaxistooltip-bottom:after {\n  border-bottom-color: #262c49;\n}\nbody.dark-layout .apexcharts-canvas .apexcharts-yaxistooltip-left:before {\n  border-left-color: transparent;\n}\nbody.dark-layout .apexcharts-canvas .apexcharts-yaxistooltip-left:after {\n  border-left-color: #262c49;\n}\nbody.dark-layout .apexcharts-canvas text {\n  fill: #fff !important;\n}\nbody.dark-layout .apexcharts-canvas .apexcharts-legend-series .apexcharts-legend-text {\n  color: #c2c6dc !important;\n}\nbody.dark-layout .apexcharts-canvas .apexcharts-radialbar-track path {\n  stroke: #262c49;\n}\nbody.dark-layout .apexcharts-canvas .apexcharts-inner polygon {\n  stroke: #212744 !important;\n  fill: #262c49 !important;\n}\nbody.dark-layout .apexcharts-canvas .apexcharts-inner rect {\n  fill: #10163a;\n}\nbody.dark-layout .apexcharts-canvas .apexcharts-pie-series path {\n  stroke: #262c49;\n}\nbody.dark-layout .apexcharts-canvas .apexcharts-menu {\n  background-color: #262c49;\n  border: 0;\n}\nbody.dark-layout .apexcharts-canvas .apexcharts-toolbar .apexcharts-zoom-in-icon:hover svg,\nbody.dark-layout .apexcharts-canvas .apexcharts-toolbar .apexcharts-zoom-out-icon:hover svg,\nbody.dark-layout .apexcharts-canvas .apexcharts-toolbar .apexcharts-zoom-icon:hover svg,\nbody.dark-layout .apexcharts-canvas .apexcharts-toolbar .apexcharts-menu-icon:hover svg,\nbody.dark-layout .apexcharts-canvas .apexcharts-toolbar .apexcharts-reset-zoom-icon:hover svg {\n  fill: #c2c6dc;\n}\nbody.dark-layout .apexcharts-canvas .apexcharts-toolbar .apexcharts-menu-item {\n  color: #c2c6dc;\n}\nbody.dark-layout .apexcharts-canvas .apexcharts-toolbar .apexcharts-menu-item:hover {\n  background-color: #10163a;\n}\nbody.dark-layout .recharts-wrapper line {\n  stroke: #c2c6dc;\n}\nbody.dark-layout .recharts-wrapper text {\n  fill: #fff;\n}\nbody.dark-layout .recharts-wrapper .recharts-default-tooltip {\n  background-color: #10163a !important;\n  border-color: #414561 !important;\n  color: #c2c6dc;\n}\nbody.dark-layout .recharts-wrapper .recharts-rectangle.recharts-tooltip-cursor {\n  fill: #262c49 !important;\n}\nbody.dark-layout .recharts-wrapper .recharts-pie-sector .recharts-sector {\n  stroke: #414561;\n}\nbody.dark-layout .recharts-wrapper .recharts-radial-bar-background .recharts-radial-bar-background-sector {\n  fill: #262c49;\n}\nbody.dark-layout .dropdown-divider {\n  border-color: #414561;\n}\nbody.dark-layout .email-application .email-app-sidebar {\n  background-color: #10163a;\n  border-color: #414561;\n}\nbody.dark-layout .email-application .app-fixed-search {\n  background-color: #10163a;\n  border-color: #414561;\n}\nbody.dark-layout .email-application .app-fixed-search svg {\n  color: #c2c6dc;\n}\nbody.dark-layout .email-application .app-fixed-search .form-control {\n  color: #c2c6dc;\n}\nbody.dark-layout .email-application .app-fixed-search .form-control::placeholder {\n  color: #c2c6dc;\n}\nbody.dark-layout .email-application .app-fixed-search .form-control:focus ~ .form-control-position svg {\n  color: #7367f0;\n}\nbody.dark-layout .email-application .app-fixed-search .form-control-position svg {\n  color: #c2c6dc;\n}\nbody.dark-layout .email-application .email-app-list-wrapper {\n  border-color: #414561;\n}\nbody.dark-layout .email-application .email-app-list-wrapper .app-action {\n  border-color: #414561;\n}\nbody.dark-layout .email-application .email-app-menu .sidebar-menu-list .list-group-messages .list-group-item,\nbody.dark-layout .email-application .email-app-menu .sidebar-menu-list .list-group-labels .list-group-item {\n  background: #10163a;\n}\nbody.dark-layout .email-application .email-app-menu .sidebar-menu-list .list-group-messages .list-group-item.active, body.dark-layout .email-application .email-app-menu .sidebar-menu-list .list-group-messages .list-group-item.active:hover,\nbody.dark-layout .email-application .email-app-menu .sidebar-menu-list .list-group-labels .list-group-item.active,\nbody.dark-layout .email-application .email-app-menu .sidebar-menu-list .list-group-labels .list-group-item.active:hover {\n  color: #7367f0;\n}\nbody.dark-layout .email-application .email-app-menu .sidebar-menu-list .list-group-messages .list-group-item:hover,\nbody.dark-layout .email-application .email-app-menu .sidebar-menu-list .list-group-labels .list-group-item:hover {\n  color: #c2c6dc;\n}\nbody.dark-layout .email-application .content-right {\n  border-color: #414561;\n}\nbody.dark-layout .email-application .content-right .email-app-list .app-action .action-right .list-inline-item svg {\n  color: #c2c6dc;\n}\nbody.dark-layout .email-application .content-right .email-app-list .email-user-list .media {\n  border-color: #414561;\n}\nbody.dark-layout .email-application .content-right .email-app-list .email-user-list .media:hover {\n  box-shadow: 0 0 0 0 #1e1e1e;\n}\nbody.dark-layout .email-application .content-right .email-app-list .email-user-list .mail-read,\nbody.dark-layout .email-application .content-right .email-app-list .email-user-list .media {\n  background-color: #262c49;\n}\nbody.dark-layout .email-application .content-right .email-app-list .email-user-list .mail-read .user-details p,\nbody.dark-layout .email-application .content-right .email-app-list .email-user-list .mail-read .user-details .list-group-item-text,\nbody.dark-layout .email-application .content-right .email-app-list .email-user-list .mail-read .mail-message p,\nbody.dark-layout .email-application .content-right .email-app-list .email-user-list .mail-read .mail-message .list-group-item-text,\nbody.dark-layout .email-application .content-right .email-app-list .email-user-list .media .user-details p,\nbody.dark-layout .email-application .content-right .email-app-list .email-user-list .media .user-details .list-group-item-text,\nbody.dark-layout .email-application .content-right .email-app-list .email-user-list .media .mail-message p,\nbody.dark-layout .email-application .content-right .email-app-list .email-user-list .media .mail-message .list-group-item-text {\n  color: #c2c6dc;\n}\nbody.dark-layout .email-application .content-right .email-app-list .email-user-list .mail-read .user-details .mail-meta .mail-date,\nbody.dark-layout .email-application .content-right .email-app-list .email-user-list .mail-read .mail-message .mail-meta .mail-date,\nbody.dark-layout .email-application .content-right .email-app-list .email-user-list .media .user-details .mail-meta .mail-date,\nbody.dark-layout .email-application .content-right .email-app-list .email-user-list .media .mail-message .mail-meta .mail-date {\n  color: #c2c6dc;\n}\nbody.dark-layout .email-application .content-right .email-app-list .email-user-list .mail-unread {\n  background-color: #10163a;\n}\nbody.dark-layout .email-application .email-app-details {\n  border-color: #414561;\n}\nbody.dark-layout .email-application .email-app-details.show {\n  background-color: #212744;\n}\nbody.dark-layout .email-application .email-app-details .email-detail-header {\n  border-color: #414561;\n  background-color: #10163a;\n}\nbody.dark-layout .email-application .email-app-details .email-detail-header .email-header-right .list-inline-item .dropdown-toggle {\n  color: #c2c6dc;\n}\nbody.dark-layout .email-application .email-app-details .email-detail-header svg {\n  color: #c2c6dc;\n}\nbody.dark-layout .email-application .email-app-details .mail-message-wrapper,\nbody.dark-layout .email-application .email-app-details .email-detail-head {\n  border-color: #414561 !important;\n}\nbody.dark-layout .chat-application .chat-profile-sidebar {\n  background-color: #262c49;\n}\nbody.dark-layout .chat-application .sidebar-content {\n  background-color: #10163a;\n  border-color: #414561;\n}\nbody.dark-layout .chat-application .sidebar-content .chat-fixed-search {\n  border-color: #414561;\n}\nbody.dark-layout .chat-application .sidebar-content .chat-fixed-search .form-control {\n  background-color: #10163a;\n}\nbody.dark-layout .chat-application .sidebar-content .chat-fixed-search .form-control:not(:focus) {\n  border: 1px solid #414561;\n}\nbody.dark-layout .chat-application .sidebar-content .chat-fixed-search svg {\n  color: #c2c6dc;\n}\nbody.dark-layout .chat-application .sidebar-content .chat-user-list .chat-users-list-wrapper li {\n  border-color: #414561;\n}\nbody.dark-layout .chat-application .sidebar-content .chat-user-list .chat-users-list-wrapper li:not(.active):hover {\n  background: #10163a;\n}\nbody.dark-layout .chat-application .sidebar-content .chat-user-list .chat-users-list-wrapper li.active .contact-info p {\n  color: #fff;\n}\nbody.dark-layout .chat-application .content-right {\n  border-color: #414561;\n}\nbody.dark-layout .chat-application .content-right .avatar {\n  border: 2px solid #fff;\n}\nbody.dark-layout .chat-application .content-right .chat-app-window .start-chat-area {\n  background-color: #171e49;\n}\nbody.dark-layout .chat-application .content-right .chat-app-window .start-chat-area .start-chat-icon,\nbody.dark-layout .chat-application .content-right .chat-app-window .start-chat-area .start-chat-text {\n  background: #262c49;\n}\nbody.dark-layout .chat-application .content-right .chat-app-window .active-chat .chat_navbar .chat_header {\n  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.5);\n}\nbody.dark-layout .chat-application .content-right .chat-app-window .active-chat .chat_navbar .chat_header svg {\n  color: #c2c6dc;\n}\nbody.dark-layout .chat-application .content-right .chat-app-window .active-chat .user-chats {\n  background-color: #171e49;\n}\nbody.dark-layout .chat-application .content-right .chat-app-window .active-chat .user-chats .chat-left .chat-content {\n  color: #c2c6dc;\n  background-color: #10163a;\n  border: 1px solid #c2c6dc;\n}\nbody.dark-layout .chat-application .content-right .chat-app-window .active-chat .user-chats .chat-left .chat-content p {\n  color: #c2c6dc;\n}\nbody.dark-layout .chat-application .content-right .chat-app-window .active-chat .user-chats .chat-content p {\n  color: #fff;\n}\nbody.dark-layout .chat-application .content-right .chat-app-window .active-chat .user-chats .chat-content {\n  background-color: #262c49;\n}\nbody.dark-layout .chat-application .content-right .chat-app-window .active-chat .chat-app-form {\n  background-color: #10163a;\n}\nbody.dark-layout .chat-application .content-right .chat-app-window .active-chat .chat-app-form .form-control {\n  background-color: #10163a;\n  border: 1px solid #414561;\n}\nbody.dark-layout .chat-application .chat-profile-sidebar {\n  border: 1px solid !important;\n}\nbody.dark-layout .chat-application .user-profile-sidebar,\nbody.dark-layout .chat-application .chat-profile-sidebar {\n  background-color: #10163a;\n  border-color: #414561 !important;\n}\nbody.dark-layout .chat-application .user-profile-sidebar .user-profile-header,\nbody.dark-layout .chat-application .user-profile-sidebar .chat-profile-header,\nbody.dark-layout .chat-application .chat-profile-sidebar .user-profile-header,\nbody.dark-layout .chat-application .chat-profile-sidebar .chat-profile-header {\n  border-color: #414561;\n}\nbody.dark-layout .chat-application .user-profile-sidebar .user-profile-header .avatar,\nbody.dark-layout .chat-application .user-profile-sidebar .chat-profile-header .avatar,\nbody.dark-layout .chat-application .chat-profile-sidebar .user-profile-header .avatar,\nbody.dark-layout .chat-application .chat-profile-sidebar .chat-profile-header .avatar {\n  border: 2px solid #fff;\n}\nbody.dark-layout .chat-application .user-profile-sidebar .user-profile-header .close-icon,\nbody.dark-layout .chat-application .user-profile-sidebar .chat-profile-header .close-icon,\nbody.dark-layout .chat-application .chat-profile-sidebar .user-profile-header .close-icon,\nbody.dark-layout .chat-application .chat-profile-sidebar .chat-profile-header .close-icon {\n  color: #c2c6dc;\n}\nbody.dark-layout .todo-application {\n  border-color: #414561;\n}\nbody.dark-layout .todo-application .todo-sidebar {\n  background-color: #10163a;\n  border-color: #414561;\n}\nbody.dark-layout .todo-application .todo-sidebar .list-group .list-group-item:hover {\n  color: #c2c6dc;\n}\nbody.dark-layout .todo-application .todo-sidebar .list-group .list-group-item:hover svg {\n  color: #c2c6dc;\n}\nbody.dark-layout .todo-application .todo-app-area .todo-app-list-wrapper {\n  border-color: #414561;\n}\nbody.dark-layout .todo-application .todo-app-area .app-fixed-search {\n  background-color: #10163a;\n  border-color: #414561 !important;\n}\nbody.dark-layout .todo-application .todo-app-area .app-fixed-search svg {\n  color: #c2c6dc;\n}\nbody.dark-layout .todo-application .todo-app-area .app-fixed-search .form-control-position svg {\n  color: #c2c6dc;\n}\nbody.dark-layout .todo-application .todo-app-area .todo-task-list .todo-item {\n  border-color: #414561;\n}\nbody.dark-layout .todo-application .todo-app-area .todo-task-list .todo-item:hover {\n  box-shadow: none;\n}\nbody.dark-layout .todo-application .todo-app-area .todo-task-list .todo-item .chip {\n  background-color: #10163a;\n}\nbody.dark-layout .todo-application .todo-app-area .todo-task-list .todo-item .todo-item-action .todo-item-favorite svg,\nbody.dark-layout .todo-application .todo-app-area .todo-task-list .todo-item .todo-item-action .todo-item-delete svg,\nbody.dark-layout .todo-application .todo-app-area .todo-task-list .todo-item .todo-item-action .todo-item-info svg {\n  color: #c2c6dc;\n}\nbody.dark-layout .todo-application .task-sidebar {\n  background-color: #10163a;\n}\nbody.dark-layout .todo-application .task-header {\n  background-color: #10163a;\n}\nbody.dark-layout .todo-application .task-header .close-icon {\n  color: #c2c6dc;\n}\nbody.dark-layout .todo-application .task-body svg {\n  color: #c2c6dc;\n}\nbody.dark-layout .ecommerce-application .sidebar-shop .filter-heading {\n  color: #c2c6dc;\n}\nbody.dark-layout .ecommerce-application .sidebar-shop .price-slider .range-slider {\n  background-color: #262c49;\n}\nbody.dark-layout .ecommerce-application .sidebar-shop .ratings-list li, body.dark-layout .ecommerce-application .sidebar-shop .ratings-list ~ .stars-received {\n  color: #c2c6dc;\n}\nbody.dark-layout .ecommerce-application .ecommerce-header-items .result-toggler .search-results {\n  color: #c2c6dc;\n}\nbody.dark-layout .ecommerce-application .ecommerce-header-items .result-toggler .shop-sidebar-toggler svg {\n  color: #c2c6dc;\n}\nbody.dark-layout .ecommerce-application .ecommerce-header-items .view-options .React-Select .select__control {\n  background-color: #10163a;\n}\nbody.dark-layout .ecommerce-application .ecommerce-header-items .view-options .React-Select .select__control .select__single-value {\n  color: #c2c6dc;\n}\nbody.dark-layout .ecommerce-application .ecommerce-header-items .view-options .select__menu .select__option {\n  color: #c2c6dc;\n}\nbody.dark-layout .ecommerce-application .ecommerce-header-items .view-options .select__menu .select__option:hover {\n  color: #fff;\n}\nbody.dark-layout .ecommerce-application .ecommerce-header-items .view-options .select__menu .select__option.select__option--is-selected {\n  background-color: #7367f0;\n}\nbody.dark-layout .ecommerce-application .ecommerce-header-items .view-options .view-btn-option .view-btn {\n  background-color: #10163a !important;\n}\nbody.dark-layout .ecommerce-application .ecommerce-header-items .view-options .view-btn-option .view-btn:not(.active) svg {\n  color: #c2c6dc;\n}\nbody.dark-layout .ecommerce-application .search-product {\n  background-color: #10163a;\n}\nbody.dark-layout .ecommerce-application .search-product ~ .form-control-position svg {\n  color: #c2c6dc;\n}\nbody.dark-layout .ecommerce-application .grid-view .ecommerce-card .card-body,\nbody.dark-layout .ecommerce-application .list-view .ecommerce-card .card-body {\n  border-color: #414561;\n}\nbody.dark-layout .ecommerce-application .grid-view .ecommerce-card .item-img,\nbody.dark-layout .ecommerce-application .list-view .ecommerce-card .item-img {\n  background-color: #fff;\n}\nbody.dark-layout .ecommerce-application .grid-view .ecommerce-card .item-name,\nbody.dark-layout .ecommerce-application .list-view .ecommerce-card .item-name {\n  color: #fff;\n}\nbody.dark-layout .ecommerce-application .grid-view .ecommerce-card .item-options .wishlist span,\nbody.dark-layout .ecommerce-application .list-view .ecommerce-card .item-options .wishlist span {\n  color: #2c2c2c;\n}\nbody.dark-layout .ecommerce-application .grid-view .ecommerce-card .item-options .cart span,\nbody.dark-layout .ecommerce-application .list-view .ecommerce-card .item-options .cart span {\n  color: #fff;\n}\nbody.dark-layout .ecommerce-application .pagination .page-item {\n  background-color: #10163a;\n}\nbody.dark-layout .ecommerce-application .pagination .page-item.active {\n  background-color: #10163a;\n}\nbody.dark-layout .ecommerce-application .pagination .page-item.active .page-link {\n  background-color: #7367f0;\n}\nbody.dark-layout .ecommerce-application .pagination .page-item .page-link {\n  background-color: #10163a;\n}\nbody.dark-layout .ecommerce-application .wishlist-items .ecommerce-card .move-cart .move-to-cart {\n  color: #fff;\n}\nbody.dark-layout .ecommerce-application .product-checkout .checkout-options .detail-total {\n  color: #c2c6dc;\n}\nbody.dark-layout .ecommerce-application .product-checkout.list-view {\n  background: #262c49;\n}\nbody.dark-layout .app-ecommerce-details .item-features {\n  background-color: #171e49;\n}\nbody.dark-layout .app-ecommerce-details .swiper-slide {\n  background-color: #262c49;\n}\nbody.dark-layout .app-ecommerce-details .swiper-button-next,\nbody.dark-layout .app-ecommerce-details .swiper-button-prev {\n  color: #7367f0;\n}\nbody.dark-layout .app-calendar .rbc-calendar .rbc-month-view,\nbody.dark-layout .app-calendar .rbc-calendar .rbc-month-row,\nbody.dark-layout .app-calendar .rbc-calendar .rbc-day-bg,\nbody.dark-layout .app-calendar .rbc-calendar .rbc-header,\nbody.dark-layout .app-calendar .rbc-calendar .rbc-time-view,\nbody.dark-layout .app-calendar .rbc-calendar .rbc-time-content,\nbody.dark-layout .app-calendar .rbc-calendar .rbc-time-header-content,\nbody.dark-layout .app-calendar .rbc-calendar .rbc-events-container,\nbody.dark-layout .app-calendar .rbc-calendar .rbc-timeslot-group,\nbody.dark-layout .app-calendar .rbc-calendar .rbc-time-slot {\n  border-color: #414561 !important;\n}\nbody.dark-layout .app-calendar .rbc-calendar .rbc-date-cell.rbc-off-range {\n  color: #c2c6dc;\n}\nbody.dark-layout .app-calendar .rbc-calendar .rbc-today {\n  background-color: transparent;\n}\nbody.dark-layout .app-calendar .add-event-sidebar,\nbody.dark-layout .app-calendar .add-event-sidebar .header {\n  background-color: #10163a;\n}\nbody.dark-layout .app-calendar .add-event-sidebar svg,\nbody.dark-layout .app-calendar .add-event-sidebar .header svg {\n  color: #c2c6dc;\n}\nbody.dark-layout .app-user-list .ag-grid-table .ag-header .ag-header-cell {\n  background-color: transparent;\n}\nbody.dark-layout .rc-slider .rc-slider-rail {\n  background-color: #262c49 !important;\n}\nbody.dark-layout .rc-slider.rc-slider-disabled {\n  background-color: #262c49;\n  opacity: 0.7;\n}\nbody.dark-layout .dropzone {\n  background-color: #262c49;\n}\nbody.dark-layout .dropzone ~ .thumb-container .dz-thumb {\n  border-color: #414561 !important;\n}\nbody.dark-layout .rdw-editor-wrapper .rdw-editor-toolbar {\n  background-color: #262c49;\n  border-color: #414561;\n}\nbody.dark-layout .rdw-editor-wrapper .rdw-editor-toolbar .rdw-dropdown-wrapper {\n  background-color: #10163a;\n  border-color: #414561;\n}\nbody.dark-layout .rdw-editor-wrapper .rdw-editor-toolbar .rdw-dropdown-wrapper:hover {\n  background-color: #10163a;\n  box-shadow: none;\n}\nbody.dark-layout .rdw-editor-wrapper .rdw-editor-toolbar .rdw-dropdown-wrapper .rdw-dropdown-carettoopen {\n  border-top-color: #c2c6dc;\n}\nbody.dark-layout .rdw-editor-wrapper .rdw-editor-toolbar .rdw-dropdown-wrapper .rdw-dropdown-carettoclose {\n  border-bottom-color: #c2c6dc;\n}\nbody.dark-layout .rdw-editor-wrapper .rdw-editor-toolbar .rdw-dropdown-wrapper .rdw-dropdown-optionwrapper {\n  border-color: #414561;\n  background-color: #10163a;\n}\nbody.dark-layout .rdw-editor-wrapper .rdw-editor-toolbar .rdw-dropdown-wrapper .rdw-dropdown-optionwrapper .rdw-dropdownoption-active,\nbody.dark-layout .rdw-editor-wrapper .rdw-editor-toolbar .rdw-dropdown-wrapper .rdw-dropdown-optionwrapper .rdw-dropdownoption-highlighted {\n  background-color: #262c49;\n}\nbody.dark-layout .vx-pagination li {\n  background-color: #262c49;\n}\nbody.dark-layout .vx-pagination li a {\n  color: #c2c6dc;\n}\nbody.dark-layout .react-contexify {\n  background-color: #262c49;\n  box-shadow: none;\n}\nbody.dark-layout .react-contexify .react-contexify__item {\n  border-color: #414561;\n}\nbody.dark-layout .react-contexify .react-contexify__item .react-contexify__item__content {\n  color: #c2c6dc;\n}\nbody.dark-layout .swiper-container .swiper-slide.swiper-slide-active span,\nbody.dark-layout .swiper-container .swiper-slide.swiper-slide-active svg {\n  color: #fff;\n}\nbody.dark-layout .swiper-container.centered-style-1 .swiper-slide {\n  background-color: #171e49;\n}\nbody.dark-layout .swiper-container.centered-style-2 .swiper-slide:not(.swiper-slide-active) {\n  background-color: #171e49;\n}\nbody.dark-layout .swiper-container.swiper-parallax .swiper-slide,\nbody.dark-layout .swiper-container.swiper-parallax .swiper-slide p {\n  color: #22292f;\n}\nbody.dark-layout .vx-autocomplete-container .suggestions-list {\n  background-color: #262c49;\n}\nbody.dark-layout .vx-autocomplete-container .suggestions-list .suggestion-item.active, body.dark-layout .vx-autocomplete-container .suggestions-list .suggestion-item.active:hover {\n  background-color: #10163a;\n}\nbody.dark-layout .vx-autocomplete-container .suggestions-list .suggestion-item:hover {\n  background-color: #10163a !important;\n}\nbody.dark-layout .vx-autocomplete-container .suggestions-list .suggestion-item svg:not([class*=text-]) {\n  stroke: #c2c6dc;\n}\nbody.dark-layout .customizer {\n  background-color: #262c49;\n}\nbody.dark-layout .customizer .close-icon svg {\n  color: #c2c6dc;\n}\nbody.dark-layout .customizer .bg-default {\n  background-color: #10163a;\n  border-color: #10163a !important;\n}\nbody.dark-layout .vertical-layout.fixed-footer .footer {\n  background-color: #10163a;\n}\nbody.dark-layout .horizontal-layout .horizontal-menu-wrapper {\n  background: linear-gradient(to bottom, rgba(37, 43, 71, 0.76) 44%, rgba(56, 53, 53, 0.46) 73%, rgba(255, 255, 255, 0) 100%);\n}\nbody.dark-layout .horizontal-layout .header-navbar {\n  background-color: #10163a !important;\n}\nbody.dark-layout .horizontal-layout .header-navbar #main-menu-navigation .dropdown-item .item-content {\n  color: #c2c6dc !important;\n}\nbody.dark-layout .horizontal-layout .header-navbar #main-menu-navigation .dropdown-item.active {\n  background-color: #10163a !important;\n}\nbody.dark-layout .horizontal-layout .header-navbar #main-menu-navigation .dropdown-item:not(.active):hover span {\n  color: #c2c6dc;\n}\nbody.dark-layout .horizontal-layout .header-navbar #main-menu-navigation .dropdown-item.has-sub.hover, body.dark-layout .horizontal-layout .header-navbar #main-menu-navigation .dropdown-item.has-sub.hover .dropdown {\n  background-color: transparent !important;\n}\nbody.dark-layout .horizontal-layout .header-navbar #main-menu-navigation .nav-item.hover:not(.active) .dropdown,\nbody.dark-layout .horizontal-layout .header-navbar #main-menu-navigation .nav-item.hover:not(.active) a.nav-link {\n  background-color: #262c49 !important;\n}\nbody.dark-layout .horizontal-layout .header-navbar #main-menu-navigation .nav-item.active .menu-icon svg {\n  stroke: #fff;\n}\nbody.dark-layout .horizontal-layout .header-navbar #main-menu-navigation .nav-item.active .dropdown-menu li.active,\nbody.dark-layout .horizontal-layout .header-navbar #main-menu-navigation .nav-item.active .dropdown-menu li.active:hover {\n  background: #10163a !important;\n}\nbody.dark-layout .horizontal-layout .header-navbar #main-menu-navigation .nav-item.active .dropdown-menu .dropdown-item:hover {\n  background: #10163a !important;\n}\nbody.dark-layout .horizontal-layout .header-navbar #main-menu-navigation .dropdown-menu::-webkit-scrollbar-thumb {\n  background: #10163a !important;\n}\nbody.dark-layout .horizontal-layout .header-navbar #main-menu-navigation .dropdown-menu::-webkit-scrollbar-track {\n  background: #262c49 !important;\n}\nbody.dark-layout .horizontal-layout.fixed-footer .footer {\n  background: #10163a;\n}\n\n/*========================================================\n        DARK LAYOUT\n=========================================================*/\nbody.semi-dark-layout {\n  /************ Main Menu **************/\n}\nbody.semi-dark-layout .main-menu {\n  background-color: #10163a;\n}\nbody.semi-dark-layout .main-menu .shadow-bottom {\n  background: linear-gradient(180deg, #0f1642 44%, rgba(15, 22, 66, 0.51) 73%, rgba(44, 48, 60, 0));\n}\nbody.semi-dark-layout .main-menu:not(.expanded) .navigation .sidebar-group-active a {\n  background-color: #262c49;\n}\nbody.semi-dark-layout .main-menu.theme-dark .navbar-header .brand-text {\n  color: #adb5bd !important;\n}\nbody.semi-dark-layout .main-menu.theme-dark .navbar-header .modern-nav-toggle svg {\n  color: #adb5bd !important;\n}\nbody.semi-dark-layout .main-menu.theme-dark .navigation .nav-item.active a {\n  background: linear-gradient(118deg, #adb5bd, rgba(173, 181, 189, 0.7));\n  box-shadow: 0 0 10px 1px rgba(173, 181, 189, 0.7);\n}\nbody.semi-dark-layout .main-menu.theme-dark .navigation .nav-item .menu-content li.active {\n  background: linear-gradient(118deg, #adb5bd, rgba(173, 181, 189, 0.7));\n  box-shadow: 0 0 10px 1px rgba(173, 181, 189, 0.7);\n}\nbody.semi-dark-layout .main-menu-content .navigation-main {\n  background-color: #10163a;\n}\nbody.semi-dark-layout .main-menu-content .navigation-main .nav-item svg {\n  color: #c2c6dc;\n}\nbody.semi-dark-layout .main-menu-content .navigation-main .nav-item.open a {\n  background-color: #262c49;\n}\nbody.semi-dark-layout .main-menu-content .navigation-main .nav-item a:after,\nbody.semi-dark-layout .main-menu-content .navigation-main .nav-item a {\n  color: #c2c6dc;\n}\nbody.semi-dark-layout .main-menu-content .navigation-main .nav-item .menu-content {\n  background-color: #10163a;\n}\nbody.semi-dark-layout .main-menu-content .navigation-main .nav-item .menu-content .active .menu-item {\n  color: #fff;\n}\nbody.semi-dark-layout .main-menu-content .navigation-main .nav-item .menu-content li:not(.active) a {\n  background-color: #10163a;\n}\nbody.semi-dark-layout .main-menu-content .navigation-main .nav-item .menu-content li.hover a,\nbody.semi-dark-layout .main-menu-content .navigation-main .nav-item .menu-content li.hover svg {\n  color: #c2c6dc;\n}\nbody.semi-dark-layout .main-menu-content .navigation-main .active .menu-title,\nbody.semi-dark-layout .main-menu-content .navigation-main .active svg {\n  color: #fff;\n}\nbody.semi-dark-layout .main-menu-content .navigation-main .sidebar-group-active a {\n  background: #10163a;\n  border-radius: 4px;\n}\nbody.semi-dark-layout .main-menu-content .navigation-main .sidebar-group-active .menu-content {\n  background-color: #10163a;\n}\nbody.semi-dark-layout .main-menu-content .navigation-main .sidebar-group-active .menu-content .active {\n  z-index: 1;\n}\nbody.semi-dark-layout .main-menu-content .navigation-main .sidebar-group-active .menu-content .active a {\n  background-color: transparent;\n}\nbody.semi-dark-layout.menu-collapsed .main-menu:not(.expanded) .navigation-main li.active a {\n  background: #262c49 !important;\n}\n\n/*========================================================\n        DARK LAYOUT\n=========================================================*/\na:focus {\n  outline: none;\n}\n\n.component-code pre {\n  max-height: 300px;\n  overflow-y: scroll;\n}\n.component-code pre::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n.component-code pre::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 20px;\n}\n.component-code pre::-webkit-scrollbar-track {\n  background: #f8f8f8;\n}\n\n.font-small-1 {\n  font-size: 0.7rem !important;\n}\n\n.font-small-2 {\n  font-size: 0.8rem !important;\n}\n\n.font-small-3 {\n  font-size: 0.9rem !important;\n}\n\n.font-medium-1 {\n  font-size: 1.1rem !important;\n}\n\n.font-medium-2 {\n  font-size: 1.2rem !important;\n}\n\n.font-medium-3 {\n  font-size: 1.3rem !important;\n}\n\n.font-medium-4 {\n  font-size: 1.4rem !important;\n}\n\n.font-medium-5 {\n  font-size: 1.5rem !important;\n}\n\n.font-large-1 {\n  font-size: 2rem !important;\n}\n\n.font-large-2 {\n  font-size: 3rem !important;\n}\n\n.font-large-3 {\n  font-size: 4rem !important;\n}\n\n.font-large-4 {\n  font-size: 5rem !important;\n}\n\n.font-large-5 {\n  font-size: 6rem !important;\n}\n\n.text-bold-300 {\n  font-weight: 300;\n}\n\n.text-bold-400 {\n  font-weight: 400;\n}\n\n.text-bold-500 {\n  font-weight: 500;\n}\n\n.text-bold-600 {\n  font-weight: 600;\n}\n\n.text-bold-700 {\n  font-weight: 700;\n}\n\n.text-italic {\n  font-style: italic;\n}\n\n.text-highlight {\n  padding: 4px 6px;\n}\n\nol li, ul li, dl li {\n  line-height: 1.2;\n}\n\ncode {\n  padding: 0.1rem 0.4rem;\n  font-size: 90%;\n  color: #d63384;\n  background-color: #eee;\n  border-radius: 0.25rem;\n}\n\npre {\n  border-radius: 0.5rem;\n}\npre code {\n  background-color: transparent !important;\n}\n\n.bd-example-row .row + .row {\n  margin-top: 1rem;\n}\n.bd-example-row .row > .col,\n.bd-example-row .row > [class^=col-] {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  background-color: rgba(86, 61, 124, 0.15);\n  border: 1px solid rgba(86, 61, 124, 0.2);\n}\n.bd-example-row .flex-items-top,\n.bd-example-row .flex-items-middle,\n.bd-example-row .flex-items-bottom {\n  min-height: 6rem;\n  background-color: rgba(255, 0, 0, 0.1);\n}\n\n.bd-example-row-flex-cols .row {\n  min-height: 10rem;\n  background-color: rgba(255, 0, 0, 0.1);\n}\n\n.bd-highlight {\n  background-color: rgba(86, 61, 124, 0.15);\n  border: 1px solid rgba(86, 61, 124, 0.15);\n}\n\n.example-container {\n  width: 800px;\n  --bs-gutter-x: 28px;\n  --bs-gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.example-row {\n  --bs-gutter-x: 28px;\n  --bs-gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: calc(-1 * var(--bs-gutter-y));\n  margin-right: calc(-0.5 * var(--bs-gutter-x));\n  margin-left: calc(-0.5 * var(--bs-gutter-x));\n}\n\n.example-content-main {\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-top: var(--bs-gutter-y);\n}\n@media (min-width: 576px) {\n  .example-content-main {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n}\n@media (min-width: 992px) {\n  .example-content-main {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n}\n\n.example-content-secondary {\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-top: var(--bs-gutter-y);\n}\n@media (min-width: 576px) {\n  .example-content-secondary {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n}\n@media (min-width: 992px) {\n  .example-content-secondary {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n}\n\n.table-white-space th,\n.table-white-space td {\n  white-space: nowrap;\n}\n\n.table thead th {\n  vertical-align: top;\n}\n.table th,\n.table td {\n  padding: 1rem;\n  vertical-align: middle;\n}\n.table th {\n  font-size: 0.85rem;\n}\n\n.table-inverse {\n  color: #fff;\n  background-color: #00cfe8;\n}\n\n.table-hover-animation {\n  background-color: #f8f8f8;\n}\n.table-hover-animation thead th {\n  border-top: 2px solid #f8f8f8;\n  border-bottom: 0;\n  background-color: #fff;\n}\n.table-hover-animation th,\n.table-hover-animation td {\n  border: 0;\n}\n.table-hover-animation tbody tr {\n  transition: all 0.25s ease;\n  background-color: #fff;\n}\n.table-hover-animation tbody tr:hover {\n  transform: translateY(-4px);\n}\n\n.form-control::placeholder {\n  font-size: 0.85rem;\n  color: rgba(34, 41, 47, 0.4);\n  transition: all 0.2s ease;\n}\n.form-control:-ms-input-placeholder {\n  color: #c5c5c5;\n}\n.form-control:focus::placeholder {\n  transform: translate(5px);\n  transition: all 0.2s ease;\n}\n.form-control:focus ~ .form-control-position svg {\n  stroke: #7367f0;\n}\n\n/* Form specific Scss */\nlabel {\n  color: rgb(69.5, 69.5, 69.5);\n  font-size: 0.85rem;\n  margin-bottom: 0;\n  padding-left: 0.2rem;\n}\n\ntextarea.form-control {\n  line-height: 1.6rem;\n  font-size: 1rem;\n}\n\n.form-group {\n  margin-bottom: 1.5rem;\n}\n.form-group .valid-tooltip,\n.form-group .invalid-tooltip {\n  top: auto;\n}\n\n.form-control {\n  border: 1px solid rgb(217.4, 217.4, 217.4);\n  color: #5f5f5f;\n}\n\n.form-section {\n  color: #b8c2cc;\n  line-height: 3rem;\n  margin-bottom: 20px;\n  border-bottom: 1px solid #b8c2cc;\n}\n\n/* .form-body{\n    overflow: hidden;\n} */\n.form-actions {\n  border-top: 1px solid rgb(222.5, 222.5, 222.5);\n  padding: 20px 0;\n  margin-top: 20px;\n}\n.form-actions.filled {\n  background-color: #f8f8f8;\n}\n.form-actions.center {\n  text-align: center;\n}\n.form-actions.right {\n  text-align: right;\n}\n.form-actions.top {\n  border-top: 0;\n  border-bottom: 1px solid rgb(222.5, 222.5, 222.5);\n  margin-top: 0;\n  margin-bottom: 20px;\n}\n@media (max-width: 575.98px) {\n  .form-actions .buttons-group {\n    float: left !important;\n    margin-bottom: 10px;\n  }\n}\n\n@media (min-width: 576px) {\n  .form-horizontal .form-group .label-control {\n    text-align: right;\n  }\n}\n\n.form-control.form-control-lg {\n  padding: 1rem;\n}\n.form-control.form-control-lg::placeholder {\n  font-size: 1.25rem;\n}\n\n.form-control.form-control-sm {\n  padding: 0.6rem;\n}\n.form-control.form-control-sm::placeholder {\n  font-size: 0.7rem;\n}\n\n.custom-file-label {\n  padding: 0.7rem 0.5rem;\n}\n.custom-file-label::after {\n  padding: 0.7rem 0.5rem;\n  height: auto;\n}\n\nselect.form-control:not([multiple=multiple]) {\n  background-position: calc(100% - 12px) 13px, calc(100% - 20px) 13px, 100% 0;\n  background-size: 12px 12px, 10px 10px;\n  background-repeat: no-repeat;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  padding-right: 1.5rem;\n}\n\n.custom-select {\n  padding: 0.7rem 1.7rem 0.6rem 0.7rem;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n}\n\n.input-group-addon {\n  background-color: #eceff1;\n  border-color: #babfc7;\n}\n\n.custom-control-label::before {\n  width: 1.1rem;\n  height: 1.1rem;\n  top: 0.1rem;\n}\n\n.custom-control-label::after {\n  width: 1.1rem;\n  height: 1.1rem;\n  top: 0.1rem;\n}\n\n.custom-control-input:not(:disabled):active ~ .custom-control-label::before {\n  background-color: #7367f0;\n  border-color: #7367f0;\n}\n\n/* Floating label Group */\n.form-label-group {\n  position: relative;\n  margin-bottom: 1.5rem;\n}\n.form-label-group .form-control-lg ~ label {\n  font-size: 1.25rem;\n  padding: 1rem;\n}\n.form-label-group .form-control-sm ~ label {\n  font-size: 0.7rem;\n}\n.form-label-group > label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: block;\n  transition: all 0.25s ease-in-out;\n  padding: 0.6rem;\n  color: rgba(34, 41, 47, 0.4);\n  font-size: 0.85rem;\n  opacity: 0;\n  z-index: -1;\n}\n.form-label-group > input,\n.form-label-group textarea {\n  padding: 0.6rem;\n}\n.form-label-group > input:focus:not(:placeholder-shown) ~ label, .form-label-group > input:not(:active):not(:placeholder-shown) ~ label,\n.form-label-group textarea:focus:not(:placeholder-shown) ~ label,\n.form-label-group textarea:not(:active):not(:placeholder-shown) ~ label {\n  color: #7367f0 !important;\n  transition: all 0.25s ease-in-out;\n  opacity: 1;\n}\n.form-label-group > input:not(:focus):not(:placeholder-shown) ~ label,\n.form-label-group textarea:not(:focus):not(:placeholder-shown) ~ label {\n  color: rgba(34, 41, 47, 0.4) !important;\n}\n.form-label-group > input:not(:placeholder-shown) ~ label,\n.form-label-group textarea:not(:placeholder-shown) ~ label {\n  padding: 0.25rem 0;\n  font-size: 0.7rem;\n  top: -20px;\n  left: 3px;\n  z-index: 1;\n}\n.form-label-group.has-icon-left > label {\n  left: 36px;\n}\n\n/* Vuexy Custom Checkbox */\n.vx-checkbox-con {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  margin: 0.25rem 0;\n}\n.vx-checkbox-con input {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  z-index: 200;\n  cursor: pointer;\n  top: 0;\n}\n.vx-checkbox-con input:checked ~ .vx-checkbox {\n  transform: rotate(0deg);\n  border-color: #7367f0;\n}\n.vx-checkbox-con input:checked ~ .vx-checkbox .vx-checkbox--check {\n  transform: translate(0);\n  background-color: #7367f0;\n}\n.vx-checkbox-con input:checked ~ .vx-checkbox .vx-checkbox--check .vx-icon {\n  transform: translate(0);\n  line-height: 1.2;\n  opacity: 1;\n}\n.vx-checkbox-con input:checked ~ .vx-checkbox.vx-checkbox-sm .vx-checkbox--check .vx-icon {\n  font-size: 0.75rem;\n}\n.vx-checkbox-con input:checked ~ .vx-checkbox.vx-checkbox-lg .vx-checkbox--check .vx-icon {\n  font-size: 1.2rem;\n}\n.vx-checkbox-con input:active:checked + .vx-checkbox .vx-checkbox--check {\n  transform: translate(3px);\n  background-color: #7367f0;\n}\n.vx-checkbox-con input:active:checked + .vx-checkbox .vx-checkbox--check .vx-icon {\n  opacity: 1;\n  transform: translate(6px);\n}\n.vx-checkbox-con input:disabled {\n  cursor: default;\n  pointer-events: none;\n}\n.vx-checkbox-con input:disabled + .vx-checkbox {\n  cursor: default;\n  opacity: 0.5;\n}\n.vx-checkbox-con .vx-checkbox {\n  cursor: pointer;\n  position: relative;\n  width: 20px;\n  height: 20px;\n  border-width: 2px;\n  border-style: solid;\n  border-color: #b8c2cc;\n  border-radius: 2px;\n  transform: rotate(-90deg);\n  transition: all 0.2s ease;\n  overflow: hidden;\n  margin-right: 0.5rem;\n}\n.vx-checkbox-con .vx-checkbox.vx-checkbox-sm {\n  width: 15px;\n  height: 15px;\n}\n.vx-checkbox-con .vx-checkbox.vx-checkbox-lg {\n  width: 24px;\n  height: 24px;\n}\n.vx-checkbox-con .vx-checkbox .vx-checkbox--check {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  display: flex;\n  left: 0;\n  transform: translate(100%);\n  transform-origin: right;\n  transition: all 0.2s ease;\n  z-index: 10;\n}\n.vx-checkbox-con .vx-checkbox .vx-checkbox--check .vx-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #fff;\n}\n\n/* Vuexy Custom Radio */\n.vx-radio-con {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  margin: 0.25rem 0;\n}\n.vx-radio-con input {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  z-index: 200;\n  cursor: pointer;\n}\n.vx-radio-con input:checked ~ .vx-radio {\n  transform: rotate(0deg);\n  outline: 0;\n}\n.vx-radio-con input:checked ~ .vx-radio .vx-radio--circle {\n  background: #7367f0;\n  box-shadow: 0 3px 12px 0 rgba(115, 103, 240, 0.4);\n  opacity: 1;\n  transform: scale(1);\n}\n.vx-radio-con input:checked ~ .vx-radio .vx-radio--border {\n  opacity: 0;\n  transform: scale(0.3);\n}\n.vx-radio-con input:disabled {\n  cursor: default;\n  pointer-events: none;\n}\n.vx-radio-con input:disabled + .vx-radio {\n  cursor: default;\n  opacity: 0.5;\n}\n.vx-radio-con input:active ~ .vx-radio {\n  transform: scale(1.1);\n}\n.vx-radio-con .vx-radio {\n  cursor: pointer;\n  position: relative;\n  width: 18px;\n  height: 18px;\n  transition: all 0.2s ease;\n  margin-right: 0.5rem;\n}\n.vx-radio-con .vx-radio.vx-radio-sm {\n  width: 13px;\n  height: 13px;\n}\n.vx-radio-con .vx-radio.vx-radio-lg {\n  width: 22px;\n  height: 22px;\n}\n.vx-radio-con .vx-radio .vx-radio--border,\n.vx-radio-con .vx-radio .vx-radio--circle {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  transition: all 0.25s ease;\n  top: 0;\n  border-radius: 50%;\n}\n.vx-radio-con .vx-radio .vx-radio--border {\n  background: transparent;\n  border: 2px solid #b8c2cc;\n}\n.vx-radio-con .vx-radio .vx-radio--circle {\n  opacity: 0;\n  transform: scale(0.1);\n}\n\n/* Switches */\n.custom-switch {\n  padding-left: 0;\n  /*For Switch label*/\n  /*For Switch Handle Animation*/\n}\n.custom-switch .custom-control-label {\n  height: 1.571rem;\n  width: 3.1rem;\n  padding: 0;\n  /* For bg color of switch*/\n  /*For Switch handle*/\n  /*For Switch text*/\n}\n.custom-switch .custom-control-label::before {\n  border: none;\n  background-color: #e2e2e2;\n  height: 1.571rem;\n  left: -0.2857rem;\n  box-shadow: none !important;\n  transition: all 0.25s ease;\n  cursor: pointer;\n  user-select: none;\n  top: 0;\n  left: 0;\n}\n.custom-switch .custom-control-label:after {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  box-shadow: none;\n  background-color: #fff;\n  transition: all 0.25s ease;\n  cursor: pointer;\n  user-select: none;\n}\n.custom-switch .custom-control-label .switch-text-left,\n.custom-switch .custom-control-label .switch-text-right,\n.custom-switch .custom-control-label .switch-icon-left,\n.custom-switch .custom-control-label .switch-icon-right {\n  position: absolute;\n  top: 5px;\n  font-size: 0.7rem;\n  cursor: pointer;\n  user-select: none;\n}\n.custom-switch .custom-control-label .switch-text-left,\n.custom-switch .custom-control-label .switch-icon-left {\n  left: 7px;\n  color: #fff;\n}\n.custom-switch .custom-control-label .switch-text-right,\n.custom-switch .custom-control-label .switch-icon-right {\n  right: 7px;\n}\n.custom-switch .custom-control-label:focus {\n  outline: 0;\n}\n.custom-switch .switch-label {\n  padding-left: 1rem;\n}\n.custom-switch .custom-control-input:checked ~ .custom-control-label::before {\n  box-shadow: none;\n  background-color: #7367f0;\n}\n.custom-switch .custom-control-input:checked ~ .custom-control-label::after {\n  transform: translateX(1.4rem);\n}\n.custom-switch .custom-control-input:not(:checked) ~ .custom-control-label .switch-text-left {\n  opacity: 0;\n}\n.custom-switch .custom-control-input:not(:checked) ~ .custom-control-label .switch-text-right {\n  opacity: 1;\n}\n.custom-switch .custom-control-input:checked ~ .custom-control-label .switch-text-right {\n  opacity: 0;\n}\n.custom-switch .custom-control-input:checked ~ .custom-control-label .switch-text-left {\n  opacity: 1;\n}\n.custom-switch .custom-control-input:not(:disabled):active ~ .custom-control-label::before {\n  background-color: #e2e2e2;\n}\n.custom-switch.switch-md .custom-control-label {\n  width: 4rem;\n  height: 1.571rem;\n}\n.custom-switch.switch-md .custom-control-label::before {\n  width: 4rem;\n  border: none;\n  background-color: #e2e2e2;\n  height: 1.571rem;\n  left: -0.2857rem;\n  box-shadow: none !important;\n  transition: all 0.25s ease;\n  cursor: pointer;\n  user-select: none;\n}\n.custom-switch.switch-md .custom-control-label:after {\n  box-shadow: none;\n  background-color: #fff;\n  transition: all 0.25s ease;\n  cursor: pointer;\n  user-select: none;\n  position: absolute;\n  top: 2px;\n  left: -2px;\n}\n.custom-switch.switch-md .custom-control-label .switch-text-right,\n.custom-switch.switch-md .custom-control-label .switch-icon-right {\n  right: 9px;\n}\n.custom-switch.switch-md .custom-control-label .switch-text-left,\n.custom-switch.switch-md .custom-control-label .switch-icon-left {\n  left: 5px;\n}\n.custom-switch.switch-md .custom-control-input:checked ~ .custom-control-label::after {\n  transform: translateX(2.3rem);\n}\n.custom-switch.switch-lg .custom-control-label {\n  width: 5.5rem;\n  height: 1.571rem;\n}\n.custom-switch.switch-lg .custom-control-label::before {\n  width: 5.5rem;\n  border: none;\n  background-color: #e2e2e2;\n  height: 1.571rem;\n  left: -0.2857rem;\n  box-shadow: none !important;\n  transition: all 0.25s ease;\n  cursor: pointer;\n  user-select: none;\n}\n.custom-switch.switch-lg .custom-control-label:after {\n  position: absolute;\n  top: 2px;\n  left: -2px;\n  box-shadow: none;\n  background-color: #fff;\n  transition: all 0.25s ease;\n  cursor: pointer;\n  user-select: none;\n}\n.custom-switch.switch-lg .custom-control-label .switch-text-right,\n.custom-switch.switch-lg .custom-control-label .switch-icon-right {\n  right: 10px;\n}\n.custom-switch.switch-lg .custom-control-input:checked ~ .custom-control-label::after {\n  transform: translateX(3.8rem);\n}\n\n/* Textarea with Counter */\n.counter-value {\n  background-color: #7367f0;\n  color: #fff;\n  padding: 1px 6px;\n  font-size: 0.6rem;\n  border-radius: 0 0 5px 5px;\n  margin-right: 1rem;\n}\n\n/* Input box with icon divider */\n.form-group.input-divider-left .form-control-position svg {\n  padding: 0.2rem 0.5rem;\n  border-right: 1px solid rgb(217.4, 217.4, 217.4);\n  height: 25px;\n  width: 30px;\n}\n.form-group.input-divider-right .form-control-position svg {\n  padding: 0.2rem 0.5rem;\n  border-left: 1px solid rgb(217.4, 217.4, 217.4);\n  height: 25px;\n  width: 30px;\n}\n\n/* input-groups-lg and input-groups-sm  */\n.input-group-lg .form-control,\n.input-group-sm .form-control {\n  padding: 0.7rem;\n}\n\n/***** React Numeric Input *****/\n/* Number Type Input Box Scss for - Remove arrow on hover */\ninput[type=number]::-webkit-inner-spin-button,\ninput[type=number]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n}\n\n.picker__input.form-control {\n  background-color: #fff;\n}\n\n.input-group .form-control {\n  height: auto;\n}\n.input-group .input-group-prepend .dropdown-toggle::after,\n.input-group .input-group-append .dropdown-toggle::after {\n  left: 0;\n}\n.input-group .input-group-prepend .vx-checkbox-con,\n.input-group .input-group-prepend .vx-checkbox,\n.input-group .input-group-prepend .vx-radio-con,\n.input-group .input-group-prepend .vx-radio,\n.input-group .input-group-append .vx-checkbox-con,\n.input-group .input-group-append .vx-checkbox,\n.input-group .input-group-append .vx-radio-con,\n.input-group .input-group-append .vx-radio {\n  margin: 0;\n}\n.input-group.input-group-lg .form-control::placeholder {\n  font-size: 1.25rem;\n}\n.input-group.input-group-lg .input-group-prepend .btn,\n.input-group.input-group-lg .input-group-append .btn {\n  line-height: 1.3;\n  font-size: 1.3rem;\n}\n.input-group.input-group-sm .form-control::placeholder {\n  font-size: 0.7rem;\n}\n\n.input-group .input-group-append .react-ripples .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group .input-group-prepend .react-ripples .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.btn:disabled {\n  cursor: default;\n}\n.btn.btn-white {\n  color: #626262;\n}\n.btn.btn-white:hover, .btn.btn-white:focus, .btn.btn-white:active {\n  color: #626262 !important;\n}\n.btn[class*=bg-gradient-] {\n  color: #fff;\n}\n.btn[class*=bg-gradient-]:hover {\n  box-shadow: 0 8px 25px -8px #aaa;\n}\n.btn.btn-secondary {\n  color: #fff;\n}\n.btn.btn-secondary:hover {\n  box-shadow: 0 8px 25px -8px #b8c2cc;\n}\n.btn.btn-dark:hover {\n  box-shadow: 0 8px 25px -8px #2a2e30;\n}\n.btn.btn-light:hover {\n  box-shadow: 0 8px 25px -8px #babfc7;\n}\n.btn.btn-outline-secondary, .btn.btn-outline-dark, .btn.btn-outline-light {\n  border: 1px solid;\n}\n.btn.btn-flat-secondary:hover {\n  background-color: rgba(184, 194, 204, 0.1);\n}\n.btn.btn-flat-secondary:active, .btn.btn-flat-secondary:focus {\n  background: #b8c2cc;\n}\n.btn.btn-flat-dark:hover {\n  background-color: rgba(42, 46, 48, 0.1);\n}\n.btn.btn-flat-dark:active, .btn.btn-flat-dark:focus {\n  background: #2a2e30;\n  color: #fff;\n}\n.btn.btn-flat-light:hover {\n  background-color: rgba(186, 191, 199, 0.1);\n}\n.btn.btn-flat-light:active, .btn.btn-flat-light:focus {\n  background: #babfc7;\n}\n.btn[class*=btn-outline-] {\n  padding-top: calc(0.9rem - 1px);\n  padding-bottom: calc(0.9rem - 1px);\n}\n.btn[class*=btn-outline-].btn-lg, .btn-group-lg > .btn[class*=btn-outline-] {\n  padding-top: calc(1rem - 1px);\n  padding-bottom: calc(1rem - 1px);\n}\n.btn[class*=btn-outline-].btn-sm, .btn-group-sm > .btn[class*=btn-outline-] {\n  padding-top: calc(0.5rem - 1px);\n  padding-bottom: calc(0.5rem - 1px);\n}\n.btn.btn-relief-secondary {\n  background-color: #b8c2cc;\n  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.2);\n  color: #fff;\n}\n.btn.btn-relief-secondary:hover {\n  color: #fff;\n}\n.btn.btn-relief-secondary:active, .btn.btn-relief-secondary:focus {\n  outline: none;\n  transform: translateY(3px);\n}\n.btn.btn-relief-light {\n  background-color: #babfc7;\n  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.2);\n  color: #fff;\n}\n.btn.btn-relief-light:hover {\n  color: #fff;\n}\n.btn.btn-relief-light:active, .btn.btn-relief-light:focus {\n  outline: none;\n  transform: translateY(3px);\n}\n.btn.btn-relief-dark {\n  background-color: #2a2e30;\n  box-shadow: inset 0 -3px 0 0 rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n.btn.btn-relief-dark:hover {\n  color: #fff;\n}\n.btn.btn-relief-dark:active, .btn.btn-relief-dark:focus {\n  outline: none;\n  transform: translateY(3px);\n}\n.btn.btn-icon {\n  padding: 0.715rem 0.736rem;\n}\n.btn.btn-sm.btn-icon, .btn-group-sm > .btn.btn-icon {\n  padding: 0.5rem;\n}\n.btn.btn-lg.btn-icon, .btn-group-lg > .btn.btn-icon {\n  padding: 1rem;\n}\n.btn.btn-square {\n  border-radius: 0;\n}\n.btn.btn-round {\n  border-radius: 2rem;\n}\n.btn:focus, .btn.focus, .btn:active, .btn.active {\n  outline: none;\n  box-shadow: none !important;\n}\n.btn.btn-icon svg {\n  height: 1.1rem;\n  width: 1.1rem;\n}\n\n.btn-group .react-ripples:not(:last-child) .btn {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.btn-group .react-ripples:not(:first-child) .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.btn-group-vertical .react-ripples:not(:last-child) .btn {\n  border-bottom-right-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.btn-group-vertical .react-ripples:not(:first-child) .btn {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\nbutton,\nhtml [type=button],\n[type=reset],\n[type=submit] {\n  cursor: pointer;\n}\n\n.waves-button-input {\n  padding: unset;\n}\n\n.collapse-icon .card-header {\n  position: relative;\n}\n.collapse-icon .card-header:after {\n  position: absolute;\n  top: 48%;\n  right: 20px;\n  margin-top: -8px;\n  font-family: \"feather\";\n  content: \"\\e845\";\n  transition: all 300ms linear 0s;\n  font-size: 0.9rem;\n}\n.collapse-icon .card-header:before {\n  position: absolute;\n  top: 48%;\n  right: 20px;\n  margin-top: -8px;\n  font-family: \"feather\";\n  content: \"\\e842\";\n  transition: all 300ms linear 0s;\n  font-size: 0.9rem;\n}\n.collapse-icon.left a {\n  padding-left: 28px;\n}\n.collapse-icon.left a:before, .collapse-icon.left a:after {\n  left: 20px;\n  right: auto;\n}\n.collapse-icon.accordion-icon-rotate .collapse.show:before {\n  transform: rotate(180deg);\n}\n.collapse-icon.accordion-icon-rotate .collapse:not(.show):after {\n  transform: rotate(-180deg);\n}\n\n.dropdown.show .btn-outline-warning.dropdown-toggle,\n.dropdown.show .btn-outline-light.dropdown-toggle {\n  color: #fff;\n}\n.dropdown .btn:not(.btn-sm):not(.btn-lg),\n.dropdown .btn:not(.btn-sm):not(.btn-lg).dropdown-toggle {\n  padding: 0.85rem 1.5rem;\n}\n.dropdown .btn:not(.btn-sm):not(.btn-lg).btn-round,\n.dropdown .btn:not(.btn-sm):not(.btn-lg).dropdown-toggle.btn-round {\n  border-radius: 2rem;\n}\n.dropdown .btn.dropdown-toggle.dropdown-toggle-split {\n  padding: 0.85rem 1rem;\n  border-left-color: rgba(255, 255, 255, 0.2) !important;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.dropdown [class*=btn-outline-].dropdown-toggle.dropdown-toggle-split {\n  border-left: 0 !important;\n}\n.dropdown [class*=btn-outline-].dropdown-toggle.dropdown-toggle-split:active {\n  color: #fff;\n}\n.dropdown .dropdown-menu {\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  border-radius: 5px;\n  transform: scale(1, 0);\n  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.1);\n  min-width: 8rem;\n}\n.dropdown .dropdown-menu::before {\n  content: \"\";\n  position: absolute;\n  top: -1px;\n  left: 1.2rem;\n  width: 0.75rem;\n  height: 0.75rem;\n  display: block;\n  background: #fff;\n  transform: rotate(45deg) translate(-7px);\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n  border-left: 1px solid rgba(0, 0, 0, 0.1);\n  z-index: 10;\n  box-sizing: border-box;\n}\n.dropdown .dropdown-menu.dropdown-menu-right::before {\n  right: 0.6rem;\n  left: auto;\n}\n.dropdown .dropdown-menu .dropdown-header {\n  padding: 0.714rem 1.428rem;\n  margin-top: 0.714rem;\n}\n.dropdown .dropdown-menu .dropdown-item {\n  padding: 0.5rem 1rem;\n  color: #626262;\n  width: auto;\n  cursor: pointer;\n}\n.dropdown .dropdown-menu .dropdown-item:hover {\n  background-color: #f8f8f8;\n  color: #7367f0;\n}\n.dropdown .dropdown-menu .dropdown-item:hover svg,\n.dropdown .dropdown-menu .dropdown-item:hover span {\n  color: #7367f0;\n}\n.dropdown .dropdown-menu .dropdown-item.active {\n  color: #fff;\n}\n.dropdown .dropdown-menu .dropdown-item:active {\n  background-color: transparent;\n  color: var(--bs-body-color);\n}\n.dropdown .dropdown-menu .dropdown-item.disabled {\n  color: #b8c2cc;\n}\n.dropdown.no-arrow .dropdown-toggle:after {\n  display: none;\n}\n\n.dropdown,\n.dropup,\n.dropright,\n.dropleft {\n  position: relative;\n}\n.dropdown .dropdown-menu .dropdown-item,\n.dropup .dropdown-menu .dropdown-item,\n.dropright .dropdown-menu .dropdown-item,\n.dropleft .dropdown-menu .dropdown-item {\n  padding: 0.714rem 1.428rem;\n}\n.dropdown .dropdown-toggle:after, .dropdown .dropdown-toggle:before,\n.dropup .dropdown-toggle:after,\n.dropup .dropdown-toggle:before,\n.dropright .dropdown-toggle:after,\n.dropright .dropdown-toggle:before,\n.dropleft .dropdown-toggle:after,\n.dropleft .dropdown-toggle:before {\n  display: none;\n}\n\n.show > .dropdown-menu {\n  transform: scale(1, 1);\n  opacity: 1;\n  display: block;\n}\n\n.dropdown-toggle::after {\n  display: none;\n}\n.dropdown-toggle svg {\n  position: relative;\n  left: 10px;\n}\n.dropdown-toggle.dropdown-toggle-split {\n  border-left: 1px solid rgba(255, 255, 255, 0.2);\n}\n.dropdown-toggle.dropdown-toggle-split svg {\n  left: 0;\n}\n.dropdown-toggle.nav-hide-arrow::after {\n  display: none;\n}\n.dropdown-toggle:focus {\n  outline: 0;\n}\n\n.navbar-horizontal .dropdown-submenu .dropdown-toggle::after {\n  top: -9px !important;\n  margin-top: 1.25rem;\n  right: 1px;\n}\n\n/* .dropdown-menu-right {\n  left: auto !important; // Input group with dropdown issue for dropdown-menu-right\n  right: 0;\n} */\n.btn-secondary ~ .dropdown-menu .dropdown-item.active, .btn-secondary ~ .dropdown-menu .dropdown-item:hover {\n  background-color: #cccccc;\n}\n\n.dropup {\n  position: relative;\n}\n.dropup .btn,\n.dropup .btn.dropdown-toggle {\n  padding: 0.85rem 1.5rem;\n}\n.dropup .btn.dropdown-toggle.dropdown-toggle-split {\n  padding: 0.85rem 1rem;\n  border-color: rgba(255, 255, 255, 0.2) !important;\n}\n.dropup .dropdown-toggle::after {\n  content: \"\\e845\" !important;\n  vertical-align: 0.05rem;\n}\n.dropup .dropdown-menu::before {\n  content: \"\";\n  position: absolute;\n  bottom: -0.714rem;\n  left: 1.214rem;\n  width: 0.714rem;\n  height: 0.714rem;\n  display: block;\n  background: #fff;\n  transform: rotate(45deg) translate(-7px);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  border-right: 1px solid rgba(0, 0, 0, 0.1);\n  z-index: 10;\n  box-sizing: border-box;\n}\n.dropup .dropdown-menu.dropdown-menu-right::before {\n  left: auto;\n  right: 0.714rem;\n}\n.dropup .dropdown-submenu .dropdown-menu {\n  bottom: auto;\n  top: 0;\n}\n\n.dropleft .btn,\n.dropleft .btn.dropdown-toggle {\n  padding: 0.85rem 1.5rem;\n}\n.dropleft .btn.dropdown-toggle.dropdown-toggle-split {\n  padding: 0.85rem 1rem;\n}\n.dropleft .dropdown-toggle svg {\n  left: -10px;\n}\n.dropleft .dropdown-menu::before {\n  content: \"\";\n  position: absolute;\n  top: 1.285rem;\n  right: 0;\n  width: 0.714rem;\n  height: 0.714rem;\n  display: block;\n  background: #fff;\n  transform: rotate(130deg) translate(-8px);\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n  border-left: 1px solid rgba(0, 0, 0, 0.1);\n  z-index: 10;\n  box-sizing: border-box;\n}\n\n.dropright .btn,\n.dropright .btn.dropdown-toggle {\n  padding: 0.85rem 1.5rem;\n}\n.dropright .btn.dropdown-toggle.dropdown-toggle-split {\n  padding: 0.85rem 1rem;\n}\n.dropright .dropdown-toggle::after {\n  border: none !important;\n  font-family: \"feather\";\n  content: \"\\e844\" !important;\n}\n.dropright .dropdown-menu::before {\n  content: \"\";\n  position: absolute;\n  top: 1.285rem;\n  left: -0.9rem;\n  width: 0.714rem;\n  height: 0.714rem;\n  display: block;\n  background: #fff;\n  transform: rotate(140deg) translate(-9px);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  border-right: 1px solid rgba(0, 0, 0, 0.1);\n  z-index: 10;\n  box-sizing: border-box;\n}\n\n.dropdown.dropdown-icon .dropdown-toggle:after,\n.dropup.dropdown-icon .dropdown-toggle:after {\n  display: none;\n}\n.dropdown.dropdown-icon .dropdown-toggle svg,\n.dropup.dropdown-icon .dropdown-toggle svg {\n  left: 0;\n}\n.dropdown.dropdown-icon .dropdown-menu,\n.dropup.dropdown-icon .dropdown-menu {\n  min-width: auto;\n}\n.dropdown.dropdown-icon .dropdown-menu .dropdown-item,\n.dropup.dropdown-icon .dropdown-menu .dropdown-item {\n  padding: 0.5rem 1.1rem;\n  cursor: pointer;\n}\n.dropdown.dropdown-icon .dropdown-menu .dropdown-item:hover,\n.dropup.dropdown-icon .dropdown-menu .dropdown-item:hover {\n  color: #fff;\n}\n\n.btn.btn-white ~ .dropdown-menu .dropdown-item:not(.acitve):hover {\n  color: #626262 !important;\n}\n.btn.btn-white ~ .dropdown-menu .dropdown-item.active {\n  color: #626262;\n}\n\n/* ===============================================================================================\n    File Name: navbar.scss\n    Description: Contain header navigation bar, vertical main navigation bar and\n    horiznotal main navigation bar related SCSS.\n    ----------------------------------------------------------------------------------------------\n    Item Name: Vuexy React admin Template\n    Version: 1.0\n    Author: PIXINVENT\n    Author URL: http://www.themeforest.net/user/pixinvent\n================================================================================================*/\n.navbar-dark .hamburger-inner,\n.navbar-dark .hamburger-inner::before,\n.navbar-dark .hamburger-inner::after {\n  background-color: #fff;\n}\n\n.header-navbar-shadow {\n  display: block;\n  background: linear-gradient(180deg, hsla(0, 0%, 97.3%, 0.95) 44%, hsla(0, 0%, 97.3%, 0.46) 73%, hsla(0, 0%, 100%, 0));\n  padding-top: 2.2rem;\n  background-repeat: repeat;\n  width: 100%;\n  height: 102px;\n  position: fixed;\n  top: 0;\n  z-index: 11;\n}\n\n.header-navbar {\n  padding: 0px;\n  min-height: 4.5rem;\n  font-family: \"Montserrat\", Helvetica, Arial, serif;\n  transition: 300ms ease all;\n  background: linear-gradient(180deg, hsla(0, 0%, 97.3%, 0.95) 44%, hsla(0, 0%, 97.3%, 0.46) 73%, hsla(0, 0%, 100%, 0));\n  z-index: 1000;\n  /* For sm screen*/\n}\n.header-navbar.fixed-top {\n  left: 260px;\n}\n.header-navbar[class*=bg-] .navbar-nav .nav-item a {\n  color: #fff !important;\n}\n.header-navbar[class*=bg-] .navbar-nav .nav-item a.dropdown-item span,\n.header-navbar[class*=bg-] .navbar-nav .nav-item a.dropdown-item svg {\n  color: #626262 !important;\n}\n.header-navbar[class*=bg-] .navbar-nav .nav-item a.dropdown-item:hover span,\n.header-navbar[class*=bg-] .navbar-nav .nav-item a.dropdown-item:hover svg {\n  color: #fff !important;\n}\n.header-navbar[class*=bg-] .navbar-nav .nav-item svg,\n.header-navbar[class*=bg-] .navbar-nav .nav-item span {\n  color: #fff !important;\n}\n.header-navbar.floating-nav {\n  margin: 1.3rem 2.2rem 0;\n  border-radius: 0.5rem;\n  position: fixed;\n  width: calc(100% - 2.2rem * 2 - 260px);\n  z-index: 11;\n  right: 0;\n}\n.header-navbar.navbar-static-top {\n  background: transparent;\n  box-shadow: none !important;\n}\n.header-navbar .navbar-wrapper {\n  width: 100%;\n}\n.header-navbar.navbar-border {\n  border-bottom: 1px solid #e4e7ed;\n}\n.header-navbar.navbar-dark.navbar-border {\n  border-bottom: 1px solid #8596b5;\n}\n.header-navbar.navbar-shadow {\n  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);\n}\n.header-navbar .nav-link.dropdown-toggle::after {\n  display: none;\n}\n.header-navbar .navbar-container ul.nav li.dropdown-language {\n  padding-right: 0;\n}\n.header-navbar .navbar-container ul.nav li.dropdown-language .country-flag {\n  width: 1.5rem !important;\n}\n.header-navbar .navbar-container ul.nav li.dropdown-language .selected-language {\n  font-size: 0.97rem;\n  letter-spacing: -0.25px;\n  font-weight: 500;\n}\n.header-navbar .navbar-container {\n  padding-left: 1rem;\n  transition: 300ms ease all;\n  background: inherit;\n  margin-left: 0;\n}\n.header-navbar .navbar-container ul.navbar-nav li {\n  line-height: 0.5;\n}\n.header-navbar .navbar-container ul.navbar-nav li > .nav-link {\n  padding: 1.4rem 0.5rem 1.35rem;\n}\n.header-navbar .navbar-container ul.navbar-nav li > .nav-link svg:hover {\n  color: #7367f0;\n}\n.header-navbar .navbar-container ul.navbar-nav li.dropdown-notification .dropdown-menu:focus {\n  outline: none;\n}\n.header-navbar .navbar-container ul.navbar-nav.navbar-nav-user li:not(:last-child) > .nav-link {\n  margin-right: 0.5rem;\n}\n.header-navbar .navbar-container .bookmark-input {\n  z-index: 1;\n}\n.header-navbar .navbar-container ul.nav li.dropdown .dropdown-menu {\n  top: 48px;\n  margin-top: -4px;\n}\n.header-navbar .navbar-container ul.nav li .badge {\n  padding: 0.42em 0.6em 0.25rem;\n}\n.header-navbar .navbar-container ul.nav li .badge.badge-up {\n  position: absolute;\n  top: 12px;\n  right: -7px;\n}\n.header-navbar .navbar-container ul.nav li.dropdown-language > a.nav-link {\n  padding: 1.75rem 0.5rem;\n}\n.header-navbar .navbar-container ul.nav li.dropdown-language .dropdown-menu {\n  min-width: 12rem;\n}\n.header-navbar .navbar-container ul.nav li > .nav-link {\n  color: #626262;\n  padding: 1.4rem 0.5rem 1.35rem;\n}\n.header-navbar .navbar-container ul.nav li > .nav-link i.flag-icon {\n  margin-right: 0.5rem;\n}\n.header-navbar .navbar-container ul.nav li.dropdown-user .dropdown-menu-right {\n  right: 26px;\n  left: -12px !important;\n  padding: 0.5rem;\n}\n.header-navbar .navbar-container ul.nav li.dropdown-user .dropdown-menu-right .dropdown-item {\n  padding: 10px;\n}\n.header-navbar .navbar-container ul.nav li.dropdown-user .dropdown-menu-right .dropdown-item:hover, .header-navbar .navbar-container ul.nav li.dropdown-user .dropdown-menu-right .dropdown-item:active {\n  background: #7367f0;\n}\n.header-navbar .navbar-container ul.nav li.dropdown-user .dropdown-menu-right .dropdown-item:hover span,\n.header-navbar .navbar-container ul.nav li.dropdown-user .dropdown-menu-right .dropdown-item:hover svg, .header-navbar .navbar-container ul.nav li.dropdown-user .dropdown-menu-right .dropdown-item:active span,\n.header-navbar .navbar-container ul.nav li.dropdown-user .dropdown-menu-right .dropdown-item:active svg {\n  color: #fff;\n}\n.header-navbar .navbar-container ul.nav li a.dropdown-user-link {\n  padding: 0.7rem 1rem;\n  display: flex;\n  align-items: center;\n}\n.header-navbar .navbar-container ul.nav li a.dropdown-user-link .user-name {\n  display: inline-block;\n  margin-bottom: 0.435rem;\n  margin-left: 0.2rem;\n  line-height: 1;\n}\n.header-navbar .navbar-container ul.nav li a.dropdown-user-link .user-status {\n  font-size: smaller;\n}\n.header-navbar .navbar-container ul.nav li a.dropdown-user-link img {\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.08);\n}\n.header-navbar .navbar-container ul.nav li a.menu-toggle {\n  padding: 1.34rem 0.22rem 1.35rem 0;\n}\n.header-navbar .navbar-container ul.nav li a.menu-toggle i {\n  font-size: 1.75rem;\n}\n.header-navbar .navbar-container ul.nav li a.nav-link-label {\n  padding: 1.6rem 0.2rem 1.35rem 0.8rem;\n}\n.header-navbar .navbar-container ul.nav li a.dropdown-user-link .user-nav {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  float: left;\n  margin-right: 0.8rem;\n}\n.header-navbar .navbar-container ul.nav li div.input-group {\n  padding: 0.7rem 1rem;\n}\n.header-navbar .navbar-container ul.nav li i.ficon {\n  font-size: 1.5rem;\n  color: #626262;\n}\n.header-navbar .navbar-container ul.nav li i.ficon:hover {\n  color: #7367f0;\n}\n.header-navbar .navbar-container ul.nav li .media-list {\n  max-height: 24rem;\n  line-height: 1;\n}\n.header-navbar .navbar-container ul.nav li .scrollable-container {\n  position: relative;\n}\n.header-navbar .navbar-container .dropdown-menu-media {\n  width: 26rem;\n  left: 10px !important;\n}\n.header-navbar .navbar-container .dropdown-menu-media .media-list {\n  cursor: pointer;\n}\n.header-navbar .navbar-container .dropdown-menu-media .media-list .media {\n  padding: 1rem;\n  border: none;\n  border-bottom: 1px solid #dae1e7;\n}\n.header-navbar .navbar-container .dropdown-menu-media .media-list .media:hover {\n  background: #f8f8f8;\n}\n.header-navbar .navbar-container .dropdown-menu-media .media-list .media .media-meta {\n  color: #626262;\n}\n.header-navbar .navbar-container .dropdown-menu-media .media-list a:last-of-type .media {\n  border-bottom: none;\n}\n.header-navbar .navbar-container .dropdown-menu-media .dropdown-menu-header {\n  border-bottom: 1px solid #dae1e7;\n  padding: 1.25rem;\n}\n.header-navbar .navbar-container .dropdown-menu-media .dropdown-menu-header .dropdown-header {\n  padding: 0;\n}\n.header-navbar .navbar-container .dropdown-menu-media .dropdown-menu-footer a {\n  padding: 0.3rem;\n  border-top: 1px solid #dae1e7;\n}\n.header-navbar .navbar-container .dropdown-menu-media.dropdown-cart {\n  left: 5px !important;\n}\n.header-navbar .navbar-container .dropdown-menu-media.dropdown-cart.empty-cart:before {\n  background: #fff;\n  border-color: rgba(0, 0, 0, 0.1);\n}\n.header-navbar .navbar-container .dropdown-menu-media.dropdown-cart .media-left {\n  width: 100px;\n}\n.header-navbar.navbar-without-menu .navbar-container {\n  margin-left: 0;\n}\n.header-navbar .nav-item + .nav-item {\n  margin-left: 0rem;\n}\n@media (max-width: 575.98px) {\n  .header-navbar .navbar-header {\n    width: 100% !important;\n    padding: 0.5rem 1rem;\n    position: relative;\n  }\n  .header-navbar .navbar-header .menu-toggle {\n    top: 2px;\n    position: relative;\n  }\n  .header-navbar .navbar-header .open-navbar-container i {\n    font-size: 1.8rem;\n  }\n  .header-navbar .navbar-header .navbar-brand {\n    position: absolute;\n    left: 50%;\n    top: 0;\n    transform: translate(-50%, 0);\n  }\n  .header-navbar.navbar-with-menu .navbar-container {\n    width: 100%;\n    display: table;\n    margin: 0;\n    height: auto;\n  }\n}\n\n/* Modern menu For md screen*/\n@media (max-width: 767.98px) {\n  [data-menu=vertical-menu-modern] .header-navbar .navbar-header {\n    width: 100% !important;\n    padding: 0.5rem 1rem;\n    position: relative;\n  }\n  [data-menu=vertical-menu-modern] .header-navbar .navbar-header .menu-toggle {\n    top: 2px;\n    position: relative;\n  }\n  [data-menu=vertical-menu-modern] .header-navbar .navbar-header .open-navbar-container i {\n    font-size: 1.8rem;\n  }\n  [data-menu=vertical-menu-modern] .header-navbar .navbar-header .navbar-brand {\n    position: absolute;\n    left: 50%;\n    top: 0;\n    transform: translate(-50%, 0);\n  }\n  [data-menu=vertical-menu-modern] .header-navbar.navbar-with-menu .navbar-container {\n    width: 100%;\n    display: table;\n    margin: 0;\n    height: auto;\n  }\n  [data-menu=vertical-menu-modern] .navbar-dark .navbar-header .navbar-nav .nav-link,\n  [data-menu=vertical-menu-modern] .navbar-semi-dark .navbar-header .navbar-nav .nav-link {\n    color: #fff;\n  }\n  [data-menu=vertical-menu-modern] .navbar-dark .navbar-container .navbar-nav .nav-link,\n  [data-menu=vertical-menu-modern] .navbar-semi-dark .navbar-container .navbar-nav .nav-link {\n    color: #b8c2cc;\n  }\n}\n.navbar-light {\n  background: #fff;\n}\n.navbar-light.navbar-horizontal {\n  background: #fff;\n}\n.navbar-light .navbar-nav li {\n  line-height: 1;\n}\n.navbar-light .navbar-nav .active.nav-link {\n  background-color: rgba(0, 0, 0, 0.03);\n}\n.navbar-light .navbar-nav .disabled.nav-link {\n  color: var(--bs-secondary-color);\n}\n\n.navbar-dark {\n  background: #b8c2cc;\n}\n.navbar-dark .navbar-brand {\n  color: #fff !important;\n}\n.navbar-dark.navbar-horizontal {\n  background: #b8c2cc;\n}\n.navbar-dark .nav-search .form-control,\n.navbar-dark .nav-search .btn-secondary {\n  color: #fff;\n  background: #b8c2cc;\n}\n.navbar-dark .navbar-nav li {\n  line-height: 1;\n}\n.navbar-dark .navbar-nav .active.nav-link {\n  background-color: rgba(255, 255, 255, 0.05);\n}\n.navbar-dark .navbar-nav .disabled.nav-link {\n  color: #dae1e7;\n}\n\n.navbar-semi-dark {\n  background: #fff;\n}\n.navbar-semi-dark .navbar-header {\n  background: #b8c2cc;\n}\n.navbar-semi-dark .navbar-header .brand-text {\n  color: #fff;\n}\n.navbar-semi-dark .navbar-nav li {\n  line-height: 1;\n}\n.navbar-semi-dark .navbar-nav .nav-link {\n  color: #b8c2cc;\n}\n.navbar-semi-dark .navbar-nav .active.nav-link {\n  background-color: rgba(0, 0, 0, 0.03);\n}\n.navbar-semi-dark .navbar-nav .disabled.nav-link {\n  color: var(--bs-secondary-color);\n}\n\n.navbar-semi-light {\n  background: #b8c2cc;\n}\n.navbar-semi-light .navbar-header {\n  background: #fff;\n}\n.navbar-semi-light .navbar-header .brand-text {\n  color: #b8c2cc;\n}\n.navbar-semi-light .navbar-nav li {\n  line-height: 1;\n}\n.navbar-semi-light .navbar-nav .nav-link {\n  color: #fff;\n}\n.navbar-semi-light .navbar-nav .active.nav-link {\n  background-color: rgba(0, 0, 0, 0.03);\n}\n.navbar-semi-light .navbar-nav .disabled.nav-link {\n  color: var(--bs-secondary-color);\n}\n\n@-moz-document url-prefix() {\n  ul li a .children-in {\n    position: relative;\n    right: 3px;\n    top: -14px;\n  }\n}\n.navbar-menu-icon span {\n  display: block;\n  position: absolute;\n  height: 2px;\n  width: 100%;\n  background: #b8c2cc;\n  border-radius: 9px;\n  opacity: 1;\n  left: 0;\n  transform: rotate(0deg);\n  transition: 0.25s ease-in-out;\n}\n\n.navbar-menu-icon span:nth-child(1) {\n  top: 0px;\n}\n\n.navbar-menu-icon span:nth-child(2) {\n  top: 10px;\n}\n\n.navbar-menu-icon span:nth-child(3) {\n  top: 20px;\n}\n\n.navbar-menu-icon.show span:nth-child(1) {\n  top: 10px;\n  transform: rotate(135deg);\n}\n\n.navbar-menu-icon.show span:nth-child(2) {\n  opacity: 0;\n  left: -60px;\n}\n\n.navbar-menu-icon.show span:nth-child(3) {\n  top: 10px;\n  transform: rotate(-135deg);\n}\n\n@media (max-width: 575.98px) {\n  .header-navbar .navbar-nav .show {\n    position: static;\n  }\n  .header-navbar .navbar-nav .open-navbar-container {\n    padding-top: 0.625rem;\n  }\n  .header-navbar .navbar-container .show .dropdown-menu {\n    right: 0;\n    left: 0 !important;\n    float: none;\n    width: auto;\n    margin-top: 0;\n    overflow: hidden;\n  }\n  .header-navbar .navbar-container ul.nav li.nav-item i {\n    margin-right: 0.2rem;\n  }\n  .header-navbar .navbar-container ul.nav li a.dropdown-user-link {\n    padding: 0.8rem 0.6rem;\n  }\n  .header-navbar .navbar-container ul.nav li .dropdown-toggle::after {\n    margin-right: 0;\n    margin-left: -2px;\n  }\n  .navbar-dark .hamburger-inner,\n  .navbar-dark .hamburger-inner::before,\n  .navbar-dark .hamburger-inner::after,\n  .navbar-semi-dark .hamburger-inner,\n  .navbar-semi-dark .hamburger-inner::before,\n  .navbar-semi-dark .hamburger-inner::after {\n    background-color: #fff;\n  }\n  .navbar-dark .navbar-header .navbar-nav .nav-link,\n  .navbar-semi-dark .navbar-header .navbar-nav .nav-link {\n    color: #fff;\n  }\n  .navbar-dark .navbar-container .navbar-nav .nav-link,\n  .navbar-semi-dark .navbar-container .navbar-nav .nav-link {\n    color: #b8c2cc;\n  }\n  .header-navbar .navbar-container .dropdown-notification .dropdown-menu,\n  .header-navbar .navbar-container .dropdown-language .dropdown-menu {\n    right: 0 !important;\n    left: 31px !important;\n  }\n}\n.headroom {\n  will-change: transform;\n  transition: transform 200ms linear;\n}\n\n.headroom--pinned-top {\n  transform: translateY(0%);\n}\n\n.headroom--unpinned-top {\n  transform: translateY(-100%);\n}\n\n.headroom--pinned-bottom {\n  transform: translateY(0%);\n}\n\n.headroom--unpinned-bottom {\n  transform: translateY(100%);\n}\n\n.header-navbar .navbar-container ul.nav li .selected-language {\n  display: none;\n}\n\nbody[data-col=\"1-column\"] .header-navbar.floating-nav {\n  width: calc(100% - 2.2rem * 2);\n}\n\n@media (min-width: 1200px) and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  body:not([data-col=\"1-columns\"]) .header-navbar.floating-nav {\n    width: calc(100% - 60px - 260px);\n  }\n}\n@media (max-width: 991.98px) {\n  .header-navbar .navbar-container ul.nav li.dropdown-language > a.nav-link {\n    padding: 1.75rem 0.5rem;\n  }\n  .header-navbar .navbar-container ul.nav li a.dropdown-user-link {\n    padding: 0.7rem 1.23rem;\n  }\n  .header-navbar .navbar-container ul.nav li .dropdown-toggle::after {\n    margin-right: 0;\n    margin-left: -2px;\n  }\n}\n@media (max-width: 767px) {\n  #navbar-mobile.navbar-collapse .navbar-nav {\n    margin: 0;\n    flex-flow: row wrap;\n  }\n  #navbar-mobile.navbar-collapse .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  #navbar-mobile.navbar-collapse .navbar-nav .nav-item {\n    float: left;\n  }\n}\n@media (max-width: 767.98px) {\n  #navbar-mobile.navbar-collapse .navbar-nav {\n    margin: 0;\n    flex-flow: row wrap;\n  }\n  #navbar-mobile.navbar-collapse .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  #navbar-mobile.navbar-collapse .navbar-nav .nav-item {\n    float: left;\n  }\n}\n/* ----------- iPhone 5, 5S  iPhone 6----------- */\n/* Landscape */\n@media only screen and (min-device-width: 26.78em) and (max-device-width: 47.64em) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {\n  .header-navbar .navbar-container .show .dropdown-menu {\n    max-height: 180px;\n  }\n}\n/* ----------- iPhone 6+ ----------- */\n/* Landscape */\n@media only screen and (min-device-width: 29.57em) and (max-device-width: 52.57em) and (-webkit-min-device-pixel-ratio: 3) and (orientation: landscape) {\n  .header-navbar .navbar-container .show .dropdown-menu {\n    max-height: 280px;\n  }\n}\n/*----------------------------- For Navbar Component -------------------------*/\n#navbar-component .navbar {\n  position: relative;\n  width: auto;\n  z-index: auto;\n}\n#navbar-component .navbar.floating-nav {\n  border-radius: 0.5rem;\n}\n#navbar-component .navbar.header-navbar.navbar-dark .navbar-nav .nav-link {\n  color: #fff;\n}\n#navbar-component .navbar .navbar-nav .dropdown-language.show,\n#navbar-component .navbar .navbar-nav .dropdown-notification.show,\n#navbar-component .navbar .navbar-nav .dropdown-user.show {\n  position: relative;\n}\n#navbar-component .navbar .navbar-nav .dropdown-language .dropdown-menu.show,\n#navbar-component .navbar .navbar-nav .dropdown-notification .dropdown-menu.show,\n#navbar-component .navbar .navbar-nav .dropdown-user .dropdown-menu.show {\n  position: absolute;\n  right: 0;\n}\n#navbar-component .navbar.navbar-dark .navbar-toggler, #navbar-component .navbar.navbar-light .navbar-toggler {\n  font-size: 1.2rem;\n}\n#navbar-component .navbar.navbar-dark .navbar-toggler:focus, #navbar-component .navbar.navbar-light .navbar-toggler:focus {\n  outline: 0;\n}\n#navbar-component #navbar-collapsed .navbar {\n  border-radius: 0;\n}\n\n@media (min-width: 992px) {\n  #navbar-component .navbar .navbar-container {\n    background: inherit;\n  }\n  #navbar-component .nav .dropdown-language {\n    float: right;\n  }\n}\n@media (max-width: 992px) {\n  #navbar-component .navbar .navbar-container {\n    background: inherit;\n  }\n  #navbar-component .navbar .navbar-container .navbar-nav {\n    flex-direction: row;\n  }\n}\n@media (max-width: 1200px) {\n  .header-navbar.fixed-top {\n    left: 0;\n  }\n}\n@media (max-width: 768px) {\n  #navbar-component .navbar .navbar-nav .dropdown-notification.show {\n    position: static;\n  }\n}\n.header-navbar.floating-nav {\n  width: calc(100% - 2.4rem) !important;\n  margin-left: 1.2rem;\n  margin-right: 1.2rem;\n}\n\n.content.app-content .content-area-wrapper {\n  margin-left: 1.2rem !important;\n  margin-right: 1.2rem !important;\n}\n\n@media (max-width: 992px) {\n  .navbar-container #navbar-mobile .nav-back {\n    margin-top: 5px;\n  }\n}\n.card-group,\n.card-deck {\n  margin-bottom: 0.75rem;\n}\n\n.card {\n  margin-bottom: 2.2rem;\n  border: none;\n  border-radius: 0.5rem;\n  box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease-in-out;\n}\n.card .card {\n  box-shadow: none !important;\n}\n.card .card-subtitle {\n  margin-top: 0.5rem;\n}\n.card .card-title {\n  font-weight: 500;\n  letter-spacing: 0.05rem;\n  font-size: 1.32rem;\n  margin-bottom: 0.5rem;\n  color: #2c2c2c;\n}\n.card .card-bordered {\n  border: var(--bs-border-width) solid var(--bs-border-color-translucent);\n}\n.card .card-img-overlay {\n  border-radius: var(--bs-border-radius);\n}\n.card.card-fullscreen {\n  display: block;\n  z-index: 9999;\n  position: fixed;\n  width: 100% !important;\n  height: 100% !important;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  overflow: auto;\n}\n.card .card-body[class*=border-bottom-] {\n  border-bottom-width: 2px !important;\n}\n.card .card-img-overlay.bg-overlay {\n  background: rgba(0, 0, 0, 0.45);\n}\n.card .card-img-overlay .text-muted {\n  color: #1e1e1e !important;\n}\n.card.card-minimal {\n  border: none;\n  box-shadow: none;\n}\n.card .card-header {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  border-bottom: none;\n  padding: 1.5rem 1.5rem 0;\n  background-color: transparent;\n}\n.card .card-header .card-title {\n  margin-bottom: 0;\n}\n.card .card-header .nav-tabs {\n  margin-bottom: 0;\n}\n.card .card-footer {\n  border-top: 1px solid #dae1e7;\n}\n.card.card-action .card-header {\n  padding-bottom: 1.5rem;\n}\n.card.card-action .card-header svg {\n  cursor: pointer;\n}\n.card.card-action.card-collapsed .card-header .collapse-icon {\n  transform: rotate(180deg);\n  transition: all 0.5s ease;\n}\n.card.card-action.closing .collapse-icon {\n  transform: rotate(180deg);\n  transition: all 0.5s ease;\n}\n.card.card-action.opening .collapse-icon {\n  transform: rotate(0deg);\n  transition: all 0.5s ease;\n}\n.card.card-action.card-shown .card-header .collapse-icon {\n  transform: rotate(0deg);\n  transition: all 0.5s ease;\n}\n.card.card-action.card-reload .reload-spinner {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  z-index: 1;\n}\n.card.card-action.card-reload.refreshing .card-body {\n  opacity: 0.5;\n}\n\n.card-columns .card {\n  margin-bottom: 2.2rem;\n}\n\n.text-white .card-text {\n  color: white;\n}\n.text-white .card-img-overlay .text-muted {\n  color: #fff !important;\n}\n.text-white code {\n  background-color: white;\n}\n\n.card-head-inverse {\n  color: #fff;\n}\n\n.card-transparent {\n  background-color: transparent;\n}\n\n.overlay-img-card .card-img-overlay,\n.overlay-img-card img {\n  max-height: 34.64rem;\n}\n\n.activity-timeline .timeline-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.activity-timeline.timeline-left {\n  border-left: 2px solid #dae1e7;\n  padding-left: 40px;\n  margin-left: 1.5rem;\n}\n.activity-timeline.timeline-left li {\n  position: relative;\n  margin-bottom: 20px;\n}\n.activity-timeline.timeline-left li p {\n  margin-bottom: 0;\n}\n.activity-timeline.timeline-left li .timeline-icon {\n  position: absolute;\n  top: 0;\n  left: -4.3rem;\n  padding: 0.7rem;\n  border-radius: 50%;\n  color: #fff;\n}\n.activity-timeline.timeline-right {\n  border-right: 2px solid #dae1e7;\n  padding-right: 40px;\n  margin-right: 1.5rem;\n}\n.activity-timeline.timeline-right li {\n  position: relative;\n  margin-bottom: 20px;\n  text-align: right;\n}\n.activity-timeline.timeline-right li p {\n  margin-bottom: 0;\n}\n.activity-timeline.timeline-right li .timeline-icon {\n  position: absolute;\n  top: 0;\n  right: -4.3rem;\n  padding: 0.6rem 0.7rem;\n  border-radius: 50%;\n  color: #fff;\n}\n\n.breadcrumb {\n  font-size: 1rem;\n  font-family: \"Montserrat\", Helvetica, Arial, serif;\n  background-color: transparent;\n  padding: 0.5rem 0 0.5rem 0 !important;\n  border-radius: 0;\n}\n.breadcrumb > li + li::before {\n  padding-right: 0.6rem;\n  padding-left: 0.6rem;\n}\n.breadcrumb .breadcrumb-item + .breadcrumb-item {\n  padding-left: 0;\n}\n.breadcrumb .breadcrumb-item + .breadcrumb-item:before {\n  content: \"\\e847\";\n  font-family: \"feather\";\n  color: #626262;\n}\n.breadcrumb .breadcrumb-item.active {\n  color: #626262;\n}\n\n/* Custom scss for page headers style */\n.breadcrumbs-right .breadcrumb {\n  float: right;\n}\n\n.breadcrumbs-top .breadcrumb {\n  margin: 0;\n  padding: 0;\n}\n\n.vx-breadcrumbs .breadcrumb {\n  border-left: 1px solid rgb(213.6803278689, 219.5, 225.3196721311) !important;\n}\n\n/* Component Specific */\n#component-breadcrumbs .breadcrumb {\n  border: none;\n}\n#component-breadcrumbs .breadcrumb .breadcrumb-item + .breadcrumb-item:before {\n  padding: 0 1rem;\n}\n#component-breadcrumbs .breadcrumb-slash .breadcrumb-item + .breadcrumb-item:before {\n  content: \"/\";\n}\n#component-breadcrumbs .breadcrumb-dots .breadcrumb-item + .breadcrumb-item:before {\n  content: \".\";\n  position: relative;\n  top: -4px;\n}\n#component-breadcrumbs .breadcrumb-dashes .breadcrumb-item + .breadcrumb-item:before {\n  content: \"-\";\n}\n#component-breadcrumbs .breadcrumb-pipes .breadcrumb-item + .breadcrumb-item:before {\n  content: \"|\";\n}\n#component-breadcrumbs .breadcrumb-chevron .breadcrumb-item + .breadcrumb-item:before {\n  content: \"\\e844\";\n  font-family: \"feather\";\n  position: relative;\n  top: 1px;\n}\n\n#breadcrumb-alignment .breadcrumb-wrapper {\n  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);\n  padding: 1px;\n  border-radius: 10px;\n  display: flex;\n  margin-bottom: 1rem;\n}\n#breadcrumb-alignment .breadcrumb-wrapper .breadcrumb {\n  margin: 1rem;\n}\n\n.badge {\n  color: #fff;\n  font-weight: 400;\n}\n.badge[class*=badge-] [class*=icon-] {\n  line-height: 1;\n}\n.badge[class*=badge-] a {\n  color: #fff;\n}\n.badge[class*=badge-] span {\n  vertical-align: middle;\n}\n.badge[class*=badge-] svg ~ span {\n  margin-left: 0.5rem;\n}\n.badge.badge-square {\n  border-radius: 0;\n}\n.badge.badge-up {\n  position: absolute;\n  top: -1rem;\n  right: -1rem;\n}\n.badge.badge-up.badge-sm {\n  top: -0.5rem;\n  right: -0.5rem;\n}\n\n.badge-xl {\n  font-size: 1.8rem;\n}\n\n.badge-lg {\n  font-size: 1.2rem;\n}\n\n.badge-md {\n  font-size: 1rem;\n}\n\n.badge-sm {\n  font-size: 0.7rem;\n}\n\n.badge-icon svg {\n  font-size: 100%;\n  margin-right: 5px;\n}\n\n.dropup .badge {\n  cursor: pointer;\n}\n\n.nav {\n  border-radius: 0.25rem;\n}\n.nav.wrap-border {\n  border: 1px solid #ddd;\n}\n.nav.wrap-border li.nav-header {\n  margin: 0 0.5rem;\n}\n.nav.wrap-border li.nav-item,\n.nav.wrap-border div {\n  padding: 2px 0.714rem;\n}\n.nav.square-border {\n  border-radius: 0;\n}\n.nav.square-border .nav-item .nav-link.active {\n  border-radius: 0;\n}\n.nav .modern-nav-toggle {\n  padding: 1.571rem 0;\n  cursor: pointer;\n}\n.nav .modern-nav-toggle .toggle-icon {\n  margin-right: 0.425rem;\n}\n.nav.nav-pills {\n  margin-bottom: 1rem;\n}\n.nav.nav-pills .nav-item .nav-link {\n  border-radius: 0.357rem;\n  padding: 0.2rem 1rem;\n  padding-top: 0.3rem;\n  font-size: 0.98rem;\n  margin-right: 0.5rem;\n  color: #000;\n}\n.nav.nav-pills .nav-item .nav-link.active {\n  color: #fff;\n}\n.nav.nav-pills .nav-item .nav-link.disabled {\n  color: #b8c2cc;\n}\n.nav.nav-pills .nav-item .nav-link.dropdown-toggle::after {\n  top: 1px;\n  left: 1px;\n}\n.nav.nav-pills .nav-item.dropdown.show .nav-link {\n  color: #fff;\n}\n.nav.nav-pills .nav-item.dropdown.show .dropdown-item.active:hover {\n  color: #7367f0;\n}\n.nav.nav-pills.nav-justified {\n  width: 100%;\n}\n.nav.nav-pills.nav-justified .nav-item {\n  float: none;\n}\n.nav.nav-pills.nav-justified .nav-link {\n  text-align: center;\n  margin-bottom: 5px;\n}\n.nav.nav-pills.nav-justified > .dropdown .dropdown-menu {\n  top: auto;\n  left: auto;\n}\n@media (min-width: 576px) {\n  .nav.nav-pills.nav-justified .nav-item {\n    display: block;\n    width: 1%;\n  }\n  .nav.nav-pills.nav-justified .nav-link {\n    margin-bottom: 0;\n  }\n}\n.nav.nav-pills.nav-justified .nav-link {\n  margin-right: 0;\n  border-radius: 0.5rem;\n}\n@media (min-width: 576px) {\n  .nav.nav-pills.nav-justified .nav-link.active,\n  .nav.nav-pills.nav-justified .nav-link.active:hover,\n  .nav.nav-pills.nav-justified .nav-link.active:focus {\n    border-bottom-color: transparent;\n  }\n}\n.nav.nav-pills.nav-justified .nav-link {\n  display: block;\n}\n.nav.nav-pills.nav-justified .nav-link.active {\n  border: none;\n}\n.nav.nav-pills.nav-justified .nav-link.active:hover, .nav.nav-pills.nav-justified .nav-link.active:focus {\n  border: none;\n}\n.nav.nav-pills.nav-active-bordered-pill .nav-item a.nav-link.active {\n  border: 1px solid #7367f0;\n  border-radius: 0.25rem;\n  color: #7367f0;\n  background-color: #fff;\n}\n.nav.nav-tabs {\n  box-shadow: -1px 11px 17px -10px rgba(0, 0, 0, 0.04);\n  border: none;\n  margin-bottom: 1rem;\n  position: relative;\n  border-radius: 0;\n}\n.nav.nav-tabs .nav-item {\n  position: relative;\n}\n.nav.nav-tabs .nav-item .nav-link {\n  color: #000;\n  font-size: 0.95rem;\n  border: none;\n  min-width: auto;\n  font-weight: 450;\n  padding: 0.61rem 0.635rem;\n  border-radius: 0;\n}\n.nav.nav-tabs .nav-item .nav-link.active {\n  border: none;\n  position: relative;\n  color: #7367f0;\n  transition: all 0.2s ease;\n  background-color: #fff;\n  transform: translateY(-2px);\n}\n.nav.nav-tabs .nav-item .nav-link.active:after {\n  content: attr(data-before);\n  height: 2px;\n  width: 100%;\n  left: 0;\n  position: absolute;\n  bottom: 0;\n  top: 100%;\n  background: linear-gradient(30deg, #7367f0, rgba(115, 103, 240, 0.5)) !important;\n  box-shadow: 0 0 8px 0 rgba(115, 103, 240, 0.5) !important;\n  transform: translateY(0px);\n  transition: all 0.2s linear;\n}\n.nav.nav-tabs .nav-item .nav-link.dropdown-toggle::after {\n  top: 1px;\n  left: 1px;\n}\n.nav.nav-tabs .nav-item .nav-link.disabled {\n  color: #b8c2cc;\n}\n.nav.nav-tabs.nav-justified {\n  width: 100%;\n}\n.nav.nav-tabs.nav-justified .nav-item {\n  float: none;\n}\n.nav.nav-tabs.nav-justified .nav-link {\n  text-align: center;\n  margin-bottom: 5px;\n}\n.nav.nav-tabs.nav-justified > .dropdown .dropdown-menu {\n  top: auto;\n  left: auto;\n}\n@media (min-width: 576px) {\n  .nav.nav-tabs.nav-justified .nav-item {\n    display: block;\n    width: 1%;\n  }\n  .nav.nav-tabs.nav-justified .nav-link {\n    margin-bottom: 0;\n  }\n}\n.nav.nav-tabs.nav-justified .nav-link {\n  margin-right: 0;\n  border-radius: 0.5rem;\n}\n@media (min-width: 576px) {\n  .nav.nav-tabs.nav-justified .nav-link.active,\n  .nav.nav-tabs.nav-justified .nav-link.active:hover,\n  .nav.nav-tabs.nav-justified .nav-link.active:focus {\n    border-bottom-color: transparent;\n  }\n}\n.nav.nav-tabs.nav-justified .nav-item a.nav-link {\n  display: block;\n  border-radius: 0;\n}\n.nav.nav-tabs.nav-justified .nav-item a.nav-link.active {\n  border: none;\n  background-color: #fff;\n}\n.nav.nav-tabs.nav-justified .nav-item a.nav-link:hover {\n  border-color: transparent;\n}\n\n.nav-vertical {\n  overflow: hidden;\n}\n.nav-vertical .nav.nav-tabs .nav-item .nav-link {\n  border: none;\n  margin-bottom: 0;\n}\n.nav-vertical .nav.nav-tabs .nav-item .nav-link.active {\n  border: none;\n  border-radius: 0;\n}\n.nav-vertical .nav.nav-tabs .nav-item .nav-link.active:after {\n  transform: rotate(90deg);\n  left: -1rem;\n  bottom: 100%;\n  top: 1rem;\n  width: 2.14rem;\n}\n.nav-vertical .nav.nav-tabs .nav-item .nav-link:hover {\n  border-right: none;\n}\n.nav-vertical .nav.nav-tabs.nav-left {\n  float: left;\n  display: table;\n  margin-right: 1rem;\n}\n.nav-vertical .nav.nav-tabs.nav-left ~ .tab-content .tab-pane {\n  display: none;\n  background-color: #fff;\n  overflow-y: auto;\n  padding-left: 1rem;\n}\n.nav-vertical .nav.nav-tabs.nav-left ~ .tab-content .tab-pane.active {\n  display: block;\n}\n.nav-vertical .nav.nav-tabs.nav-right {\n  float: right;\n  display: table;\n  margin-left: 1rem;\n}\n.nav-vertical .nav.nav-tabs.nav-right .nav-item .nav-link.active:after {\n  left: 2.6rem;\n}\n.nav-vertical .nav.nav-tabs.nav-right ~ .tab-content .tab-pane {\n  display: none;\n  background-color: #fff;\n  overflow-y: auto;\n  padding-right: 1rem;\n}\n.nav-vertical .nav.nav-tabs.nav-right ~ .tab-content .tab-pane.active {\n  display: block;\n}\n\n.alert {\n  font-weight: 500;\n  border: none;\n}\n.alert .close:focus {\n  outline: 0;\n}\n.alert p {\n  font-weight: 500;\n  padding: 2px 0;\n  margin-bottom: 0;\n  vertical-align: middle;\n}\n.alert span {\n  vertical-align: middle;\n}\n.alert svg {\n  margin-right: 1rem;\n  vertical-align: middle;\n}\n.alert .alert-heading {\n  font-weight: 700;\n  font-size: 0.9rem;\n  padding: 0;\n  padding-bottom: 8px;\n  margin-bottom: 0.5rem;\n}\n.alert.alert-dismissible .close {\n  opacity: 1;\n  top: -2px;\n}\n.alert.alert-dark .alert-heading {\n  box-shadow: rgba(42, 46, 48, 0.4) 0px 6px 15px -7px;\n}\n.alert.alert-light .alert-heading {\n  box-shadow: rgba(186, 191, 199, 0.4) 0px 6px 15px -7px;\n}\n\n.media-list .media {\n  padding: 1.25rem;\n  width: 100%;\n  margin-top: 0;\n}\n.media-list .media .media-left {\n  padding-right: 1rem;\n}\n.media-list .media .media-right {\n  padding-left: 1rem;\n}\n.media-list a.media {\n  color: #b8c2cc !important;\n}\n\n.media-bordered .media {\n  border-top: 1px solid #e4e7ed;\n}\n.media-bordered .media:first-child {\n  border-top: 0;\n}\n\n/*=========================================================================================\n  File Name: progress.scss\n  Description: Extended bootstrap progress bar scss.\n  ----------------------------------------------------------------------------------------\n  Item Name: Vuexy React admin Template\n  Version: 1.0\n  Author: PIXINVENT\n  Author URL: http://www.themeforest.net/user/pixinvent\n  ----------------------------------------------------------------------------------------\n\n  Modifiers:       `progress-lg`\n                   `progress-md`\n                   `progress-sm`\n                   `progress-xs`\n\n==========================================================================================*/\n.progress {\n  margin-bottom: 3rem;\n}\n.progress:last-child {\n  margin-bottom: 1rem;\n}\n.progress.progress-xl {\n  height: 1.14rem;\n}\n.progress.progress-lg {\n  height: 0.857rem;\n}\n.progress.progress-md {\n  height: 0.57rem;\n}\n.progress.progress-sm {\n  height: 0.143rem;\n}\n.progress .progress-bar {\n  border-radius: 1.28rem;\n}\n.progress .progress-bar.progress-bar-animated {\n  animation: progressBarAnimated 1s linear infinite;\n}\n.progress .progress-bar-striped {\n  background-size: 1rem 1rem;\n}\n\n[dir=rtl] .progress .progress-bar.progress-bar-animated {\n  animation: progressBarAnimatedRTL 1s linear infinite !important;\n}\n\n@keyframes progressBarAnimated {\n  0% {\n    background-position: 1rem 0;\n  }\n  100% {\n    background-position: 0 0;\n  }\n}\n/* rtl:ignore */\n@keyframes progressBarAnimatedRTL {\n  0% {\n    background-position: 1rem 0;\n  }\n  100% {\n    background-position: 0 100%;\n  }\n}\n/* ===============================================================================================\n\tFile Name: list-group.scss\n\tDescription: Contain list item, list group related extended SCSS.\n\t----------------------------------------------------------------------------------------------\n\tItem Name: Vuexy React admin Template\n\tVersion: 1.0\n\tAuthor: PIXINVENT\n\tAuthor URL: http://www.themeforest.net/user/pixinvent\n================================================================================================*/\nul.list-inline li {\n  display: inline-block;\n}\nul.list-inline.list-inline-pipe > li + li:before {\n  content: \" | \";\n  padding-right: 2px;\n}\n\n.list-group .list-group-item {\n  line-height: 1.5;\n}\n.list-group .list-group-item.active:hover {\n  background-color: #7367f0;\n}\n.list-group .list-group-item.active:focus {\n  color: #626262;\n  outline: 0;\n}\n.list-group .list-group-item.active:focus:hover {\n  color: #fff;\n}\n.list-group .list-group-item:hover {\n  background-color: #f8f8f8;\n}\n.list-group .list-group-item:not(.active):focus:active {\n  color: inherit;\n}\n.list-group .list-group-item-action:active {\n  background-color: #7367f0;\n  color: #fff;\n}\n.list-group .list-group-item-action:focus {\n  background-color: #f8f8f8;\n  outline: 0;\n}\n\n.list-group-item.gu-mirror {\n  border-radius: 0;\n}\n\n.users-list li + li {\n  margin-left: -0.785rem;\n}\n.users-list li img {\n  border: 2px solid #fff;\n  box-shadow: 0px 2px 10px 0px rgba(184, 194, 204, 0.3);\n}\n.users-list li .badge {\n  color: #22292f;\n}\n\n.toast-bs-container {\n  z-index: 1040;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n}\n.toast-bs-container .toast-position {\n  position: relative;\n  top: 0;\n  right: 0;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap-reverse;\n}\n.toast-bs-container .toast-position .toast.show {\n  opacity: 1;\n  z-index: 1030;\n}\n\n.toast-placement {\n  position: static;\n  top: 0;\n}\n.toast-placement .toast {\n  position: fixed;\n  top: 0;\n  z-index: 1030;\n}\n\n.toast {\n  display: none;\n  margin-top: 0.75rem;\n}\n.toast .toast-header .close:focus, .toast .toast-header .close:active {\n  outline: none;\n}\n\n.toast.show.toast-wrapper {\n  position: static;\n}\n\n.toast.toast-translucent {\n  opacity: 1;\n  display: block;\n}\n\n.toast-header img {\n  width: 35px;\n  height: 24px;\n}\n\n_:-ms-lang(x),\n.toast-bs-container {\n  position: fixed !important;\n  left: 74% !important;\n}\n\n.vx-collapse .collapse-title {\n  font-weight: 400;\n  font-size: 1.2rem;\n}\n.vx-collapse .opening .collapse-icon,\n.vx-collapse .collapse-shown .collapse-icon {\n  transition: all 0.25s ease-in-out;\n  transform: rotate(180deg);\n}\n.vx-collapse .collapse-icon {\n  transition: all 0.25s ease-in-out;\n  transform: rotate(0deg);\n}\n.vx-collapse .card {\n  cursor: pointer;\n}\n\n.collapse-title {\n  color: inherit;\n  cursor: pointer;\n}\n.collapse-title:hover {\n  color: inherit;\n}\n\n.collapse-bordered .card:first-child {\n  border-top: 0;\n}\n.collapse-bordered .card:last-child {\n  border-bottom: 0;\n}\n.collapse-bordered .card {\n  margin-bottom: 0;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.04);\n  border-radius: 0;\n}\n.collapse-bordered .card .card-header {\n  padding: 1rem;\n}\n.collapse-bordered .card .card-body {\n  padding: 1rem;\n  line-height: 1.5;\n}\n\n.collapse-border-item.card {\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  margin-bottom: 0;\n  border-radius: 0;\n}\n.collapse-border-item.card:first-child {\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n}\n.collapse-border-item.card:not(:last-child) {\n  border-bottom: 0;\n}\n.collapse-border-item.card:last-child {\n  border-bottom-right-radius: 5px;\n  border-bottom-left-radius: 5px;\n}\n.collapse-border-item.card .card-header {\n  padding: 1rem;\n}\n.collapse-border-item.card .card-body {\n  padding: 1rem;\n  line-height: 1.5;\n}\n\n.accordion-shadow {\n  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.1);\n  padding: 0.15rem 0.75rem;\n  border-radius: 0.5rem;\n}\n.accordion-shadow .card.open {\n  border-radius: 0.571rem;\n  margin: 10px 0;\n  border: 0;\n  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1) !important;\n}\n.accordion-shadow .card:first-child {\n  border-top-left-radius: 0.571rem;\n  border-top-right-radius: 0.571rem;\n}\n.accordion-shadow .card:last-child {\n  border-bottom-left-radius: 0.571rem;\n  border-bottom-right-radius: 0.571rem;\n}\n\n.collapse-border {\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 0.5rem;\n}\n.collapse-border + .collapse.show {\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.collapse-margin {\n  margin-top: 0.71rem;\n  margin-bottom: 0.71rem !important;\n  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.05);\n  border-bottom: 0 solid transparent !important;\n  border-radius: 5px !important;\n}\n.collapse-margin .card {\n  margin-bottom: 0;\n  border-radius: 5px !important;\n}\n.collapse-margin .card .card-header {\n  padding: 1rem;\n  border-radius: 5px;\n}\n.collapse-margin .card .card-body {\n  padding: 1rem;\n  line-height: 1.5rem;\n}\n\n.pagination .page-item {\n  border-radius: 5rem;\n}\n.pagination .page-item.prev-item .page-link, .pagination .page-item.next-item .page-link, .pagination .page-item.first .page-link, .pagination .page-item.last .page-link, .pagination .page-item.prev .page-link, .pagination .page-item.next .page-link {\n  color: #7367f0;\n}\n.pagination .page-item.prev-item.disabled .page-link, .pagination .page-item.next-item.disabled .page-link, .pagination .page-item.first.disabled .page-link, .pagination .page-item.last.disabled .page-link, .pagination .page-item.prev.disabled .page-link, .pagination .page-item.next.disabled .page-link {\n  color: #b8c2cc;\n}\n.pagination .page-item.prev-item {\n  margin-right: 0.3571rem;\n}\n.pagination .page-item.prev-item .page-link {\n  background-color: #f0f0f0;\n  padding: 0.572rem 0.7rem;\n  border-radius: 50%;\n}\n.pagination .page-item.prev-item .page-link svg {\n  width: 1.2rem;\n  height: 1.2rem;\n}\n.pagination .page-item.prev-item .page-link:hover {\n  background: #7367f0;\n  color: #fff;\n}\n.pagination .page-item.prev-item ~ .page-item:nth-child(2).active .page-link {\n  border-radius: 0.5rem !important;\n}\n.pagination .page-item.prev-item ~ .page-item:nth-child(2) .page-link {\n  border-top-left-radius: 20px;\n  border-bottom-left-radius: 20px;\n}\n.pagination .page-item.prev-item ~ .page-item:nth-last-child(-n+2).active .page-link {\n  border-radius: 0.5rem !important;\n}\n.pagination .page-item.prev-item ~ .page-item:nth-last-child(-n+2) .page-link {\n  border-top-right-radius: 20px;\n  border-bottom-right-radius: 20px;\n}\n.pagination .page-item.next-item {\n  margin-left: 0.3571rem;\n}\n.pagination .page-item.next-item .page-link {\n  background-color: #f0f0f0;\n  padding: 0.572rem 0.7rem;\n  border-radius: 50%;\n}\n.pagination .page-item.next-item .page-link svg {\n  width: 1.2rem;\n  height: 1.2rem;\n}\n.pagination .page-item.next-item .page-link:hover {\n  background: #7367f0;\n  color: #fff;\n}\n.pagination .page-item .page-link {\n  border: none;\n  margin: 0;\n  color: rgba(0, 0, 0, 0.6);\n  background-color: #f0f0f0;\n  margin-left: 0;\n  font-size: 1rem;\n  font-weight: 700;\n  line-height: 1.4rem;\n}\n.pagination .page-item .page-link svg {\n  height: 1.2rem;\n  width: 1.2rem;\n  position: relative;\n  top: -1px;\n}\n.pagination .page-item .page-link:focus {\n  box-shadow: none;\n}\n.pagination .page-item .page-link:hover {\n  color: #7367f0;\n}\n.pagination .page-item.active {\n  background-color: #f0f0f0;\n  border-radius: 0;\n}\n.pagination .page-item.active .page-link {\n  z-index: 3;\n  border-radius: 0.5rem;\n  background-color: #7367f0;\n  color: #fff;\n  transform: scale(1.05);\n}\n.pagination .page-item:first-child:not(.prev-item).active {\n  border-top-left-radius: 1.428rem;\n  border-bottom-left-radius: 1.428rem;\n}\n.pagination .page-item:first-child:not(.prev-item).active .page-link {\n  border-radius: 5rem;\n}\n.pagination .page-item:first-child:not(.prev-item) .page-link {\n  border-top-left-radius: 1.428rem;\n  border-bottom-left-radius: 1.428rem;\n}\n.pagination .page-item:last-child:not(.next-item).active {\n  border-top-right-radius: 1.428rem;\n  border-bottom-right-radius: 1.428rem;\n}\n.pagination .page-item:last-child:not(.next-item).active .page-link {\n  border-radius: 5rem;\n}\n.pagination .page-item:last-child:not(.next-item) .page-link {\n  border-top-right-radius: 1.428rem;\n  border-bottom-right-radius: 1.428rem;\n}\n.pagination.pagination-lg .page-item .page-link {\n  font-size: 1.5rem;\n  transform: scale(1);\n}\n\n.spinner-border-lg,\n.spinner-grow-lg {\n  height: 3rem;\n  width: 3rem;\n}\n\n.modal .modal-header {\n  background-color: #f8f8f8;\n  border-radius: 0.42rem;\n  padding: 0.8rem;\n  border-bottom: none;\n}\n.modal .modal-header .close {\n  padding: 0.2rem 0.62rem;\n  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.1);\n  border-radius: 0.357rem;\n  background: #fff;\n  opacity: 1;\n  transition: all 0.23s ease 0.1s;\n  position: relative;\n  transform: translate(8px, -2px);\n}\n.modal .modal-header .close span {\n  font-weight: 400;\n  font-size: 2rem;\n  color: #7367f0;\n}\n.modal .modal-header .close:hover, .modal .modal-header .close:focus, .modal .modal-header .close:active {\n  opacity: 1;\n  outline: none;\n  transform: translate(5px, 3px);\n  box-shadow: none;\n}\n.modal .modal-header[class*=bg-] {\n  color: #fff;\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n}\n.modal .modal-header[class*=bg-] .modal-title {\n  color: #fff;\n}\n.modal .modal-header.bg-primary .close span {\n  color: #7367f0;\n}\n.modal .modal-header.bg-success .close span {\n  color: #28c76f;\n}\n.modal .modal-header.bg-info .close span {\n  color: #00cfe8;\n}\n.modal .modal-header.bg-danger .close span {\n  color: #ea5455;\n}\n.modal .modal-header.bg-warning .close span {\n  color: #ff9f43;\n}\n.modal .modal-header.bg-dark .close span {\n  color: #2a2e30;\n}\n.modal .modal-content {\n  border: none;\n  overflow: visible;\n  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.1);\n}\n.modal.modal-centered .modal-dialog {\n  display: flex;\n  align-items: center;\n}\n.modal .modal-footer {\n  border-color: rgba(0, 0, 0, 0.05);\n}\n\n.modal-sm {\n  max-width: 400px;\n}\n\n.modal-xs {\n  max-width: 300px;\n}\n\n.modal-xl {\n  max-width: 94%;\n  margin-left: 3%;\n  margin-right: 3%;\n}\n\n@media (max-width: 576px) {\n  .modal {\n    padding-right: 1rem;\n    padding-left: 1rem;\n  }\n  .modal .modal-xs,\n  .modal .modal-sm {\n    max-width: unset;\n  }\n}\n.demo-modal-form .btn-outline-success:focus {\n  box-shadow: 0 0 0 0.2rem rgba(40, 199, 111, 0.5) !important;\n}\n\n.popover {\n  z-index: 1060;\n}\n.popover .popover-header {\n  color: #fff;\n  border: none;\n  border-top-left-radius: 0.3rem;\n  border-top-right-radius: 0.3rem;\n}\n.popover.bs-popover-bottom .arrow:after, .popover.bs-popover-auto[data-popper-placement^=bottom] .arrow:after {\n  border-bottom-color: #7367f0;\n}\n\n.icon-bg-circle {\n  color: #fff;\n  padding: 0.5rem;\n  border-radius: 50%;\n}\n\n.icon-left {\n  margin-right: 0.5rem;\n}\n\n.icon-right {\n  margin-right: 0.5rem;\n}\n\n.icon-spin {\n  display: inline-block;\n  animation: spin 1s infinite linear;\n}\n\n.blockOverlay {\n  z-index: 1050 !important;\n}\n\n.blockElement, .blockPage {\n  z-index: 1051 !important;\n}\n\n@-moz-keyframes spin {\n  from {\n    -moz-transform: rotate(0deg);\n  }\n  to {\n    -moz-transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes spin {\n  from {\n    -webkit-transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n.hidden {\n  display: none;\n  visibility: hidden;\n}\n\na:hover {\n  cursor: pointer;\n}\n\n.round {\n  border-radius: 1.5rem;\n}\n\n.square {\n  border-radius: 0;\n}\n\n.icon-line-height {\n  line-height: 1.5rem !important;\n}\n\n.table-middle td {\n  vertical-align: middle;\n}\n\n.spinner {\n  display: inline-block;\n  -webkit-animation: spin 1s linear infinite;\n  -o-animation: spin 1s linear infinite;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.bg-gradient-white {\n  color: #fff;\n  background-image: linear-gradient(30deg, #ffffff, rgba(255, 255, 255, 0.5));\n}\n.bg-gradient-white:hover, .bg-gradient-white:active {\n  color: #fff;\n}\n\n.gradient-light-white {\n  background: linear-gradient(30deg, #ffffff 0%, 100%);\n  color: #fff;\n}\n.gradient-light-white:hover, .gradient-light-white:active {\n  color: #fff;\n}\n\n.bg-gradient-black {\n  color: #fff;\n  background-image: linear-gradient(30deg, #000000, rgba(0, 0, 0, 0.5));\n}\n.bg-gradient-black:hover, .bg-gradient-black:active {\n  color: #fff;\n}\n\n.gradient-light-black {\n  background: linear-gradient(30deg, #000000 0%, 100%);\n  color: #fff;\n}\n.gradient-light-black:hover, .gradient-light-black:active {\n  color: #fff;\n}\n\n.bg-gradient-dark {\n  background: #640064;\n  color: #fff;\n  background-image: linear-gradient(30deg, #2a2e30, rgba(42, 46, 48, 0.5));\n}\n.bg-gradient-dark:hover, .bg-gradient-dark:active {\n  color: #fff;\n}\n\n.gradient-light-dark {\n  background: linear-gradient(30deg, #2a2e30 0%, 100%);\n  color: #fff;\n}\n.gradient-light-dark:hover, .gradient-light-dark:active {\n  color: #fff;\n}\n\n.bg-gradient-light {\n  background: #640064;\n  color: #fff;\n  background-image: linear-gradient(30deg, #babfc7, rgba(186, 191, 199, 0.5));\n}\n.bg-gradient-light:hover, .bg-gradient-light:active {\n  color: #fff;\n}\n\n.gradient-light-light {\n  background: linear-gradient(30deg, #babfc7 0%, 100%);\n  color: #fff;\n}\n.gradient-light-light:hover, .gradient-light-light:active {\n  color: #fff;\n}\n\n.bg-gradient-primary {\n  background: #640064;\n  color: #fff;\n  background-image: linear-gradient(30deg, #7367f0, rgba(115, 103, 240, 0.5));\n}\n.bg-gradient-primary:hover, .bg-gradient-primary:active {\n  color: #fff;\n}\n\n.gradient-light-primary {\n  background: linear-gradient(30deg, #7367f0 0%, rgb(205.887538787, 158.985231015, 251.997768985) 100%);\n  color: #fff;\n}\n.gradient-light-primary:hover, .gradient-light-primary:active {\n  color: #fff;\n}\n\n.bg-gradient-secondary {\n  background: #640064;\n  color: #fff;\n  background-image: linear-gradient(30deg, #b8c2cc, rgba(184, 194, 204, 0.5));\n}\n.bg-gradient-secondary:hover, .bg-gradient-secondary:active {\n  color: #fff;\n}\n\n.gradient-light-secondary {\n  background: linear-gradient(30deg, #b8c2cc 0%, rgb(220.3498655492, 221.623471291, 235.6331344508) 100%);\n  color: #fff;\n}\n.gradient-light-secondary:hover, .gradient-light-secondary:active {\n  color: #fff;\n}\n\n.bg-gradient-success {\n  background: #0064fa;\n  color: #fff;\n  background-image: linear-gradient(30deg, #28c76f, rgba(40, 199, 111, 0.5));\n}\n.bg-gradient-success:hover, .bg-gradient-success:active {\n  color: #fff;\n}\n\n.gradient-light-success {\n  background: linear-gradient(30deg, #28c76f 0%, rgb(73.8812290858, 233.1017709142, 211.3216024566) 100%);\n  color: #fff;\n}\n.gradient-light-success:hover, .gradient-light-success:active {\n  color: #fff;\n}\n\n.bg-gradient-info {\n  background: #640064;\n  color: #fff;\n  background-image: linear-gradient(30deg, #00cfe8, rgba(0, 207, 232, 0.5));\n}\n.bg-gradient-info:hover, .bg-gradient-info:active {\n  color: #fff;\n}\n\n.gradient-light-info {\n  background: linear-gradient(30deg, #00cfe8 0%, rgb(44.983, 144.8617744253, 255) 100%);\n  color: #fff;\n}\n.gradient-light-info:hover, .gradient-light-info:active {\n  color: #fff;\n}\n\n.bg-gradient-warning {\n  background: #fafafa;\n  color: #fff;\n  background-image: linear-gradient(30deg, #ff9f43, rgba(255, 159, 67, 0.5));\n}\n.bg-gradient-warning:hover, .bg-gradient-warning:active {\n  color: #fff;\n}\n\n.gradient-light-warning {\n  background: linear-gradient(30deg, #ff9f43 0%, rgb(255, 243.7218067376, 134.983) 100%);\n  color: #fff;\n}\n.gradient-light-warning:hover, .gradient-light-warning:active {\n  color: #fff;\n}\n\n.bg-gradient-danger {\n  background: #640064;\n  color: #fff;\n  background-image: linear-gradient(30deg, #ea5455, rgba(234, 84, 85, 0.5));\n}\n.bg-gradient-danger:hover, .bg-gradient-danger:active {\n  color: #fff;\n}\n\n.gradient-light-danger {\n  background: linear-gradient(30deg, #ea5455 0%, rgb(248.814652125, 182.9433326175, 137.168347875) 100%);\n  color: #fff;\n}\n.gradient-light-danger:hover, .gradient-light-danger:active {\n  color: #fff;\n}\n\n.white {\n  color: #ffffff !important;\n}\n\n.bg-white {\n  background-color: #ffffff !important;\n}\n.bg-white .card-header,\n.bg-white .card-footer {\n  background-color: transparent;\n}\n\n.alert-white {\n  background: rgba(255, 255, 255, 0.2) !important;\n  color: #ffffff !important;\n}\n.alert-white .alert-heading {\n  box-shadow: rgba(255, 255, 255, 0.4) 0px 6px 15px -7px;\n}\n.alert-white .alert-link {\n  color: rgb(242.25, 242.25, 242.25) !important;\n}\n\n.bg-rgba-white {\n  background: rgba(255, 255, 255, 0.15) !important;\n}\n\n.border-white {\n  border: 1px solid #ffffff !important;\n}\n\n.border-top-white {\n  border-top: 1px solid #ffffff;\n}\n\n.border-bottom-white {\n  border-bottom: 1px solid #ffffff;\n}\n\n.border-left-white {\n  border-left: 1px solid #ffffff;\n}\n\n.border-right-white {\n  border-right: 1px solid #ffffff;\n}\n\n.badge.badge-light-white {\n  color: #ffffff !important;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.bg-white.badge-glow,\n.border-white.badge-glow,\n.badge-white.badge-glow {\n  box-shadow: 0px 0px 10px #ffffff;\n}\n\n.overlay-white {\n  background: #ffffff; /* The Fallback */\n  background: rgba(255, 255, 255, 0.6);\n}\n\n.btn-white {\n  border-color: !important;\n  background-color: #ffffff !important;\n  color: #fff;\n}\n.btn-white:hover {\n  border-color: !important;\n  color: #fff !important;\n  box-shadow: 0 8px 25px -8px white;\n}\n.btn-white:focus, .btn-white:active {\n  color: #fff !important;\n}\n\n.btn-flat-white {\n  background-color: transparent;\n  color: #ffffff;\n}\n.btn-flat-white:hover {\n  color: #ffffff;\n  background-color: rgba(255, 255, 255, 0.1);\n}\n.btn-flat-white:active, .btn-flat-white:focus {\n  background-color: #ffffff;\n  color: #fff !important;\n}\n\n.btn-relief-white {\n  background-color: #ffffff;\n  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.2);\n  color: #fff;\n}\n.btn-relief-white:hover {\n  color: #fff;\n}\n.btn-relief-white:active, .btn-relief-white:focus {\n  outline: none;\n  transform: translateY(3px);\n}\n\n.btn-outline-white {\n  border: 1px solid #ffffff;\n  background-color: transparent;\n  color: #ffffff;\n}\n.btn-outline-white:hover {\n  background-color: rgba(255, 255, 255, 0.08);\n  color: #ffffff;\n}\n.btn-outline-white:active {\n  color: #fff !important;\n}\n\n.btn-white ~ .dropdown-menu .dropdown-item.active,\n.btn-outline-white ~ .dropdown-menu .dropdown-item.active,\n.btn-flat-white ~ .dropdown-menu .dropdown-item.active {\n  background-color: #ffffff;\n  color: #fff;\n}\n.btn-white ~ .dropdown-menu .dropdown-item.active:hover,\n.btn-outline-white ~ .dropdown-menu .dropdown-item.active:hover,\n.btn-flat-white ~ .dropdown-menu .dropdown-item.active:hover {\n  color: #fff;\n}\n.btn-white ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,\n.btn-outline-white ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,\n.btn-flat-white ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover {\n  color: #ffffff;\n}\n\n.bullet.bullet-white {\n  background-color: #ffffff;\n}\n.bullet.bullet-white.bullet-bordered {\n  background-color: transparent;\n  border: 2px solid #ffffff;\n}\n\n.pagination-white li.active a,\n.pagination-white li.active .page-link,\n.pagination-white .page-item.active a,\n.pagination-white .page-item.active .page-link {\n  background: #ffffff !important;\n  color: #fff;\n}\n.pagination-white li.active a:hover,\n.pagination-white li.active .page-link:hover,\n.pagination-white .page-item.active a:hover,\n.pagination-white .page-item.active .page-link:hover {\n  color: #fff !important;\n}\n.pagination-white li a:hover,\n.pagination-white li .page-link:hover,\n.pagination-white .page-item a:hover,\n.pagination-white .page-item .page-link:hover {\n  color: #ffffff !important;\n}\n.pagination-white li.prev-item .page-link:hover, .pagination-white li.next-item .page-link:hover,\n.pagination-white .page-item.prev-item .page-link:hover,\n.pagination-white .page-item.next-item .page-link:hover {\n  background: #ffffff;\n  color: #fff;\n}\n\n.nav-pill-white .nav-item .nav-link.active {\n  color: #fff;\n  background-color: #ffffff;\n}\n\n.chip-white {\n  background-color: #ffffff !important;\n}\n.chip-white .chip-body {\n  color: #fff !important;\n}\n\n.divider.divider-white .divider-text:before, .divider.divider-white .divider-text:after {\n  border-color: #ffffff !important;\n}\n\ninput[type=checkbox].bg-white + .custom-control-label:before, input[type=radio].bg-white + .custom-control-label:before {\n  background-color: #ffffff !important;\n}\n\ninput:focus ~ .bg-white {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #ffffff !important;\n}\n\n.vx-checkbox-white input:checked ~ .vx-checkbox {\n  border-color: #ffffff !important;\n}\n.vx-checkbox-white input:checked ~ .vx-checkbox .vx-checkbox--check {\n  background-color: #ffffff !important;\n}\n.vx-checkbox-white input:active:checked + .vx-checkbox .vx-checkbox--check {\n  background-color: #ffffff !important;\n}\n\n.vertical-layout .main-menu.theme-white .navbar-header .navbar-nav .brand-text {\n  color: #ffffff;\n}\n.vertical-layout .main-menu.theme-white .navigation .nav-item.active a {\n  background: linear-gradient(118deg, white, rgba(255, 255, 255, 0.7));\n  box-shadow: 0 0 10px 1px rgba(255, 255, 255, 0.7) !important;\n}\n.vertical-layout .main-menu.theme-white .navigation .nav-item .menu-content li.active {\n  background: linear-gradient(118deg, white, rgba(255, 255, 255, 0.7));\n  box-shadow: 0 0 10px 1px rgba(255, 255, 255, 0.7) !important;\n}\n\n.horizontal-layout.theme-white .header-navbar .brand-text {\n  color: #ffffff !important;\n}\n.horizontal-layout.theme-white .navbar-horizontal #main-menu-navigation .nav-item.active .nav-link {\n  background: linear-gradient(118deg, white, rgba(255, 255, 255, 0.7));\n  box-shadow: 0 0 10px 1px rgba(255, 255, 255, 0.7) !important;\n}\n\n.custom-switch-white .custom-control-input:checked ~ .custom-control-label::before {\n  background-color: #ffffff !important;\n  color: #fff;\n  transition: all 0.2s ease-out;\n}\n\n.color-radio.color-radio-white {\n  border: 1px solid transparent;\n}\n.color-radio.color-radio-white.selected {\n  border-color: #ffffff;\n}\n.color-radio.color-radio-white .radio-content {\n  background-color: #ffffff;\n}\n\n.vx-radio-white input:checked ~ .vx-radio .vx-radio--circle {\n  background: white !important;\n  box-shadow: 0 3px 12px 0 rgba(255, 255, 255, 0.4) !important;\n}\n\n.black {\n  color: #000000 !important;\n}\n\n.bg-black {\n  background-color: #000000 !important;\n}\n.bg-black .card-header,\n.bg-black .card-footer {\n  background-color: transparent;\n}\n\n.alert-black {\n  background: rgba(0, 0, 0, 0.2) !important;\n  color: #000000 !important;\n}\n.alert-black .alert-heading {\n  box-shadow: rgba(0, 0, 0, 0.4) 0px 6px 15px -7px;\n}\n.alert-black .alert-link {\n  color: black !important;\n}\n\n.bg-rgba-black {\n  background: rgba(0, 0, 0, 0.15) !important;\n}\n\n.border-black {\n  border: 1px solid #000000 !important;\n}\n\n.border-top-black {\n  border-top: 1px solid #000000;\n}\n\n.border-bottom-black {\n  border-bottom: 1px solid #000000;\n}\n\n.border-left-black {\n  border-left: 1px solid #000000;\n}\n\n.border-right-black {\n  border-right: 1px solid #000000;\n}\n\n.badge.badge-light-black {\n  color: #000000 !important;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.bg-black.badge-glow,\n.border-black.badge-glow,\n.badge-black.badge-glow {\n  box-shadow: 0px 0px 10px #000000;\n}\n\n.overlay-black {\n  background: #000000; /* The Fallback */\n  background: rgba(0, 0, 0, 0.6);\n}\n\n.btn-black {\n  border-color: !important;\n  background-color: #000000 !important;\n  color: #fff;\n}\n.btn-black:hover {\n  border-color: !important;\n  color: #fff !important;\n  box-shadow: 0 8px 25px -8px black;\n}\n.btn-black:focus, .btn-black:active {\n  color: #fff !important;\n}\n\n.btn-flat-black {\n  background-color: transparent;\n  color: #000000;\n}\n.btn-flat-black:hover {\n  color: #000000;\n  background-color: rgba(0, 0, 0, 0.1);\n}\n.btn-flat-black:active, .btn-flat-black:focus {\n  background-color: #000000;\n  color: #fff !important;\n}\n\n.btn-relief-black {\n  background-color: #000000;\n  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.2);\n  color: #fff;\n}\n.btn-relief-black:hover {\n  color: #fff;\n}\n.btn-relief-black:active, .btn-relief-black:focus {\n  outline: none;\n  transform: translateY(3px);\n}\n\n.btn-outline-black {\n  border: 1px solid #000000;\n  background-color: transparent;\n  color: #000000;\n}\n.btn-outline-black:hover {\n  background-color: rgba(0, 0, 0, 0.08);\n  color: #000000;\n}\n.btn-outline-black:active {\n  color: #fff !important;\n}\n\n.btn-black ~ .dropdown-menu .dropdown-item.active,\n.btn-outline-black ~ .dropdown-menu .dropdown-item.active,\n.btn-flat-black ~ .dropdown-menu .dropdown-item.active {\n  background-color: #000000;\n  color: #fff;\n}\n.btn-black ~ .dropdown-menu .dropdown-item.active:hover,\n.btn-outline-black ~ .dropdown-menu .dropdown-item.active:hover,\n.btn-flat-black ~ .dropdown-menu .dropdown-item.active:hover {\n  color: #fff;\n}\n.btn-black ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,\n.btn-outline-black ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,\n.btn-flat-black ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover {\n  color: #000000;\n}\n\n.bullet.bullet-black {\n  background-color: #000000;\n}\n.bullet.bullet-black.bullet-bordered {\n  background-color: transparent;\n  border: 2px solid #000000;\n}\n\n.pagination-black li.active a,\n.pagination-black li.active .page-link,\n.pagination-black .page-item.active a,\n.pagination-black .page-item.active .page-link {\n  background: #000000 !important;\n  color: #fff;\n}\n.pagination-black li.active a:hover,\n.pagination-black li.active .page-link:hover,\n.pagination-black .page-item.active a:hover,\n.pagination-black .page-item.active .page-link:hover {\n  color: #fff !important;\n}\n.pagination-black li a:hover,\n.pagination-black li .page-link:hover,\n.pagination-black .page-item a:hover,\n.pagination-black .page-item .page-link:hover {\n  color: #000000 !important;\n}\n.pagination-black li.prev-item .page-link:hover, .pagination-black li.next-item .page-link:hover,\n.pagination-black .page-item.prev-item .page-link:hover,\n.pagination-black .page-item.next-item .page-link:hover {\n  background: #000000;\n  color: #fff;\n}\n\n.nav-pill-black .nav-item .nav-link.active {\n  color: #fff;\n  background-color: #000000;\n}\n\n.chip-black {\n  background-color: #000000 !important;\n}\n.chip-black .chip-body {\n  color: #fff !important;\n}\n\n.divider.divider-black .divider-text:before, .divider.divider-black .divider-text:after {\n  border-color: #000000 !important;\n}\n\ninput[type=checkbox].bg-black + .custom-control-label:before, input[type=radio].bg-black + .custom-control-label:before {\n  background-color: #000000 !important;\n}\n\ninput:focus ~ .bg-black {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #000000 !important;\n}\n\n.vx-checkbox-black input:checked ~ .vx-checkbox {\n  border-color: #000000 !important;\n}\n.vx-checkbox-black input:checked ~ .vx-checkbox .vx-checkbox--check {\n  background-color: #000000 !important;\n}\n.vx-checkbox-black input:active:checked + .vx-checkbox .vx-checkbox--check {\n  background-color: #000000 !important;\n}\n\n.vertical-layout .main-menu.theme-black .navbar-header .navbar-nav .brand-text {\n  color: #000000;\n}\n.vertical-layout .main-menu.theme-black .navigation .nav-item.active a {\n  background: linear-gradient(118deg, black, rgba(0, 0, 0, 0.7));\n  box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.7) !important;\n}\n.vertical-layout .main-menu.theme-black .navigation .nav-item .menu-content li.active {\n  background: linear-gradient(118deg, black, rgba(0, 0, 0, 0.7));\n  box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.7) !important;\n}\n\n.horizontal-layout.theme-black .header-navbar .brand-text {\n  color: #000000 !important;\n}\n.horizontal-layout.theme-black .navbar-horizontal #main-menu-navigation .nav-item.active .nav-link {\n  background: linear-gradient(118deg, black, rgba(0, 0, 0, 0.7));\n  box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.7) !important;\n}\n\n.custom-switch-black .custom-control-input:checked ~ .custom-control-label::before {\n  background-color: #000000 !important;\n  color: #fff;\n  transition: all 0.2s ease-out;\n}\n\n.color-radio.color-radio-black {\n  border: 1px solid transparent;\n}\n.color-radio.color-radio-black.selected {\n  border-color: #000000;\n}\n.color-radio.color-radio-black .radio-content {\n  background-color: #000000;\n}\n\n.vx-radio-black input:checked ~ .vx-radio .vx-radio--circle {\n  background: black !important;\n  box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.4) !important;\n}\n\n.dark {\n  color: #2a2e30 !important;\n}\n\n.bg-dark {\n  background-color: #2a2e30 !important;\n}\n.bg-dark .card-header,\n.bg-dark .card-footer {\n  background-color: transparent;\n}\n\n.alert-dark {\n  background: rgba(42, 46, 48, 0.2) !important;\n  color: #2a2e30 !important;\n}\n.alert-dark .alert-heading {\n  box-shadow: rgba(42, 46, 48, 0.4) 0px 6px 15px -7px;\n}\n.alert-dark .alert-link {\n  color: rgb(30.1, 32.9666666667, 34.4) !important;\n}\n\n.bg-rgba-dark {\n  background: rgba(42, 46, 48, 0.15) !important;\n}\n\n.border-dark {\n  border: 1px solid #2a2e30 !important;\n}\n\n.border-top-dark {\n  border-top: 1px solid #2a2e30;\n}\n\n.border-bottom-dark {\n  border-bottom: 1px solid #2a2e30;\n}\n\n.border-left-dark {\n  border-left: 1px solid #2a2e30;\n}\n\n.border-right-dark {\n  border-right: 1px solid #2a2e30;\n}\n\n.badge.badge-light-dark {\n  color: #2a2e30 !important;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.bg-dark.badge-glow,\n.border-dark.badge-glow,\n.badge-dark.badge-glow {\n  box-shadow: 0px 0px 10px #2a2e30;\n}\n\n.overlay-dark {\n  background: #2a2e30; /* The Fallback */\n  background: rgba(42, 46, 48, 0.6);\n}\n\n.btn-dark {\n  border-color: !important;\n  background-color: #2a2e30 !important;\n  color: #fff;\n}\n.btn-dark:hover {\n  border-color: !important;\n  color: #fff !important;\n  box-shadow: 0 8px 25px -8px #2a2e30;\n}\n.btn-dark:focus, .btn-dark:active {\n  color: #fff !important;\n}\n\n.btn-flat-dark {\n  background-color: transparent;\n  color: #2a2e30;\n}\n.btn-flat-dark:hover {\n  color: #2a2e30;\n  background-color: rgba(42, 46, 48, 0.1);\n}\n.btn-flat-dark:active, .btn-flat-dark:focus {\n  background-color: #2a2e30;\n  color: #fff !important;\n}\n\n.btn-relief-dark {\n  background-color: #2a2e30;\n  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.2);\n  color: #fff;\n}\n.btn-relief-dark:hover {\n  color: #fff;\n}\n.btn-relief-dark:active, .btn-relief-dark:focus {\n  outline: none;\n  transform: translateY(3px);\n}\n\n.btn-outline-dark {\n  border: 1px solid #2a2e30;\n  background-color: transparent;\n  color: #2a2e30;\n}\n.btn-outline-dark:hover {\n  background-color: rgba(42, 46, 48, 0.08);\n  color: #2a2e30;\n}\n.btn-outline-dark:active {\n  color: #fff !important;\n}\n\n.btn-dark ~ .dropdown-menu .dropdown-item.active,\n.btn-outline-dark ~ .dropdown-menu .dropdown-item.active,\n.btn-flat-dark ~ .dropdown-menu .dropdown-item.active {\n  background-color: #2a2e30;\n  color: #fff;\n}\n.btn-dark ~ .dropdown-menu .dropdown-item.active:hover,\n.btn-outline-dark ~ .dropdown-menu .dropdown-item.active:hover,\n.btn-flat-dark ~ .dropdown-menu .dropdown-item.active:hover {\n  color: #fff;\n}\n.btn-dark ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,\n.btn-outline-dark ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,\n.btn-flat-dark ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover {\n  color: #2a2e30;\n}\n\n.bullet.bullet-dark {\n  background-color: #2a2e30;\n}\n.bullet.bullet-dark.bullet-bordered {\n  background-color: transparent;\n  border: 2px solid #2a2e30;\n}\n\n.pagination-dark li.active a,\n.pagination-dark li.active .page-link,\n.pagination-dark .page-item.active a,\n.pagination-dark .page-item.active .page-link {\n  background: #2a2e30 !important;\n  color: #fff;\n}\n.pagination-dark li.active a:hover,\n.pagination-dark li.active .page-link:hover,\n.pagination-dark .page-item.active a:hover,\n.pagination-dark .page-item.active .page-link:hover {\n  color: #fff !important;\n}\n.pagination-dark li a:hover,\n.pagination-dark li .page-link:hover,\n.pagination-dark .page-item a:hover,\n.pagination-dark .page-item .page-link:hover {\n  color: #2a2e30 !important;\n}\n.pagination-dark li.prev-item .page-link:hover, .pagination-dark li.next-item .page-link:hover,\n.pagination-dark .page-item.prev-item .page-link:hover,\n.pagination-dark .page-item.next-item .page-link:hover {\n  background: #2a2e30;\n  color: #fff;\n}\n\n.nav-pill-dark .nav-item .nav-link.active {\n  color: #fff;\n  background-color: #2a2e30;\n}\n\n.chip-dark {\n  background-color: #2a2e30 !important;\n}\n.chip-dark .chip-body {\n  color: #fff !important;\n}\n\n.divider.divider-dark .divider-text:before, .divider.divider-dark .divider-text:after {\n  border-color: #2a2e30 !important;\n}\n\ninput[type=checkbox].bg-dark + .custom-control-label:before, input[type=radio].bg-dark + .custom-control-label:before {\n  background-color: #2a2e30 !important;\n}\n\ninput:focus ~ .bg-dark {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #2a2e30 !important;\n}\n\n.vx-checkbox-dark input:checked ~ .vx-checkbox {\n  border-color: #2a2e30 !important;\n}\n.vx-checkbox-dark input:checked ~ .vx-checkbox .vx-checkbox--check {\n  background-color: #2a2e30 !important;\n}\n.vx-checkbox-dark input:active:checked + .vx-checkbox .vx-checkbox--check {\n  background-color: #2a2e30 !important;\n}\n\n.vertical-layout .main-menu.theme-dark .navbar-header .navbar-nav .brand-text {\n  color: #2a2e30;\n}\n.vertical-layout .main-menu.theme-dark .navigation .nav-item.active a {\n  background: linear-gradient(118deg, #2a2e30, rgba(42, 46, 48, 0.7));\n  box-shadow: 0 0 10px 1px rgba(42, 46, 48, 0.7) !important;\n}\n.vertical-layout .main-menu.theme-dark .navigation .nav-item .menu-content li.active {\n  background: linear-gradient(118deg, #2a2e30, rgba(42, 46, 48, 0.7));\n  box-shadow: 0 0 10px 1px rgba(42, 46, 48, 0.7) !important;\n}\n\n.horizontal-layout.theme-dark .header-navbar .brand-text {\n  color: #2a2e30 !important;\n}\n.horizontal-layout.theme-dark .navbar-horizontal #main-menu-navigation .nav-item.active .nav-link {\n  background: linear-gradient(118deg, #2a2e30, rgba(42, 46, 48, 0.7));\n  box-shadow: 0 0 10px 1px rgba(42, 46, 48, 0.7) !important;\n}\n\n.custom-switch-dark .custom-control-input:checked ~ .custom-control-label::before {\n  background-color: #2a2e30 !important;\n  color: #fff;\n  transition: all 0.2s ease-out;\n}\n\n.color-radio.color-radio-dark {\n  border: 1px solid transparent;\n}\n.color-radio.color-radio-dark.selected {\n  border-color: #2a2e30;\n}\n.color-radio.color-radio-dark .radio-content {\n  background-color: #2a2e30;\n}\n\n.vx-radio-dark input:checked ~ .vx-radio .vx-radio--circle {\n  background: #2a2e30 !important;\n  box-shadow: 0 3px 12px 0 rgba(42, 46, 48, 0.4) !important;\n}\n\n.dark.gradient-bg {\n  color: #640064 !important;\n}\n\n.bg-dark.bg-gradient-bg {\n  background-color: #640064 !important;\n}\n\n.btn-dark.btn-gradient-bg {\n  border-color: !important;\n  background-color: #640064 !important;\n}\n.btn-dark.btn-gradient-bg:hover {\n  border-color: !important;\n  background-color: !important;\n}\n.btn-dark.btn-gradient-bg:focus, .btn-dark.btn-gradient-bg:active {\n  border-color: !important;\n  background-color: !important;\n}\n\n.btn-outline-dark.btn-outline-gradient-bg {\n  border-color: #640064 !important;\n  color: #640064 !important;\n}\n.btn-outline-dark.btn-outline-gradient-bg:hover {\n  background-color: #640064 !important;\n}\n\ninput:focus ~ .bg-dark {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #640064 !important;\n}\n\n.border-dark.border-gradient-bg {\n  border: 1px solid #640064 !important;\n}\n\n.border-top-dark.border-top-gradient-bg {\n  border-top: 1px solid #640064 !important;\n}\n\n.border-bottom-dark.border-bottom-gradient-bg {\n  border-bottom: 1px solid #640064 !important;\n}\n\n.border-left-dark.border-left-gradient-bg {\n  border-left: 1px solid #640064 !important;\n}\n\n.border-right-dark.border-right-gradient-bg {\n  border-right: 1px solid #640064 !important;\n}\n\n.overlay-dark.overlay-gradient-bg {\n  background: #640064; /* The Fallback */\n  background: rgba(100, 0, 100, 0.6);\n}\n\n.light {\n  color: #babfc7 !important;\n}\n\n.bg-light {\n  background-color: #babfc7 !important;\n}\n.bg-light .card-header,\n.bg-light .card-footer {\n  background-color: transparent;\n}\n\n.alert-light {\n  background: rgba(186, 191, 199, 0.2) !important;\n  color: #babfc7 !important;\n}\n.alert-light .alert-heading {\n  box-shadow: rgba(186, 191, 199, 0.4) 0px 6px 15px -7px;\n}\n.alert-light .alert-link {\n  color: rgb(171.924, 177.944, 187.576) !important;\n}\n\n.bg-rgba-light {\n  background: rgba(186, 191, 199, 0.15) !important;\n}\n\n.border-light {\n  border: 1px solid #babfc7 !important;\n}\n\n.border-top-light {\n  border-top: 1px solid #babfc7;\n}\n\n.border-bottom-light {\n  border-bottom: 1px solid #babfc7;\n}\n\n.border-left-light {\n  border-left: 1px solid #babfc7;\n}\n\n.border-right-light {\n  border-right: 1px solid #babfc7;\n}\n\n.badge.badge-light-light {\n  color: #babfc7 !important;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.bg-light.badge-glow,\n.border-light.badge-glow,\n.badge-light.badge-glow {\n  box-shadow: 0px 0px 10px #babfc7;\n}\n\n.overlay-light {\n  background: #babfc7; /* The Fallback */\n  background: rgba(186, 191, 199, 0.6);\n}\n\n.btn-light {\n  border-color: !important;\n  background-color: #babfc7 !important;\n  color: #fff;\n}\n.btn-light:hover {\n  border-color: !important;\n  color: #fff !important;\n  box-shadow: 0 8px 25px -8px #babfc7;\n}\n.btn-light:focus, .btn-light:active {\n  color: #fff !important;\n}\n\n.btn-flat-light {\n  background-color: transparent;\n  color: #babfc7;\n}\n.btn-flat-light:hover {\n  color: #babfc7;\n  background-color: rgba(186, 191, 199, 0.1);\n}\n.btn-flat-light:active, .btn-flat-light:focus {\n  background-color: #babfc7;\n  color: #fff !important;\n}\n\n.btn-relief-light {\n  background-color: #babfc7;\n  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.2);\n  color: #fff;\n}\n.btn-relief-light:hover {\n  color: #fff;\n}\n.btn-relief-light:active, .btn-relief-light:focus {\n  outline: none;\n  transform: translateY(3px);\n}\n\n.btn-outline-light {\n  border: 1px solid #babfc7;\n  background-color: transparent;\n  color: #babfc7;\n}\n.btn-outline-light:hover {\n  background-color: rgba(186, 191, 199, 0.08);\n  color: #babfc7;\n}\n.btn-outline-light:active {\n  color: #fff !important;\n}\n\n.btn-light ~ .dropdown-menu .dropdown-item.active,\n.btn-outline-light ~ .dropdown-menu .dropdown-item.active,\n.btn-flat-light ~ .dropdown-menu .dropdown-item.active {\n  background-color: #babfc7;\n  color: #fff;\n}\n.btn-light ~ .dropdown-menu .dropdown-item.active:hover,\n.btn-outline-light ~ .dropdown-menu .dropdown-item.active:hover,\n.btn-flat-light ~ .dropdown-menu .dropdown-item.active:hover {\n  color: #fff;\n}\n.btn-light ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,\n.btn-outline-light ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,\n.btn-flat-light ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover {\n  color: #babfc7;\n}\n\n.bullet.bullet-light {\n  background-color: #babfc7;\n}\n.bullet.bullet-light.bullet-bordered {\n  background-color: transparent;\n  border: 2px solid #babfc7;\n}\n\n.pagination-light li.active a,\n.pagination-light li.active .page-link,\n.pagination-light .page-item.active a,\n.pagination-light .page-item.active .page-link {\n  background: #babfc7 !important;\n  color: #fff;\n}\n.pagination-light li.active a:hover,\n.pagination-light li.active .page-link:hover,\n.pagination-light .page-item.active a:hover,\n.pagination-light .page-item.active .page-link:hover {\n  color: #fff !important;\n}\n.pagination-light li a:hover,\n.pagination-light li .page-link:hover,\n.pagination-light .page-item a:hover,\n.pagination-light .page-item .page-link:hover {\n  color: #babfc7 !important;\n}\n.pagination-light li.prev-item .page-link:hover, .pagination-light li.next-item .page-link:hover,\n.pagination-light .page-item.prev-item .page-link:hover,\n.pagination-light .page-item.next-item .page-link:hover {\n  background: #babfc7;\n  color: #fff;\n}\n\n.nav-pill-light .nav-item .nav-link.active {\n  color: #fff;\n  background-color: #babfc7;\n}\n\n.chip-light {\n  background-color: #babfc7 !important;\n}\n.chip-light .chip-body {\n  color: #fff !important;\n}\n\n.divider.divider-light .divider-text:before, .divider.divider-light .divider-text:after {\n  border-color: #babfc7 !important;\n}\n\ninput[type=checkbox].bg-light + .custom-control-label:before, input[type=radio].bg-light + .custom-control-label:before {\n  background-color: #babfc7 !important;\n}\n\ninput:focus ~ .bg-light {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #babfc7 !important;\n}\n\n.vx-checkbox-light input:checked ~ .vx-checkbox {\n  border-color: #babfc7 !important;\n}\n.vx-checkbox-light input:checked ~ .vx-checkbox .vx-checkbox--check {\n  background-color: #babfc7 !important;\n}\n.vx-checkbox-light input:active:checked + .vx-checkbox .vx-checkbox--check {\n  background-color: #babfc7 !important;\n}\n\n.vertical-layout .main-menu.theme-light .navbar-header .navbar-nav .brand-text {\n  color: #babfc7;\n}\n.vertical-layout .main-menu.theme-light .navigation .nav-item.active a {\n  background: linear-gradient(118deg, #babfc7, rgba(186, 191, 199, 0.7));\n  box-shadow: 0 0 10px 1px rgba(186, 191, 199, 0.7) !important;\n}\n.vertical-layout .main-menu.theme-light .navigation .nav-item .menu-content li.active {\n  background: linear-gradient(118deg, #babfc7, rgba(186, 191, 199, 0.7));\n  box-shadow: 0 0 10px 1px rgba(186, 191, 199, 0.7) !important;\n}\n\n.horizontal-layout.theme-light .header-navbar .brand-text {\n  color: #babfc7 !important;\n}\n.horizontal-layout.theme-light .navbar-horizontal #main-menu-navigation .nav-item.active .nav-link {\n  background: linear-gradient(118deg, #babfc7, rgba(186, 191, 199, 0.7));\n  box-shadow: 0 0 10px 1px rgba(186, 191, 199, 0.7) !important;\n}\n\n.custom-switch-light .custom-control-input:checked ~ .custom-control-label::before {\n  background-color: #babfc7 !important;\n  color: #fff;\n  transition: all 0.2s ease-out;\n}\n\n.color-radio.color-radio-light {\n  border: 1px solid transparent;\n}\n.color-radio.color-radio-light.selected {\n  border-color: #babfc7;\n}\n.color-radio.color-radio-light .radio-content {\n  background-color: #babfc7;\n}\n\n.vx-radio-light input:checked ~ .vx-radio .vx-radio--circle {\n  background: #babfc7 !important;\n  box-shadow: 0 3px 12px 0 rgba(186, 191, 199, 0.4) !important;\n}\n\n.light.gradient-bg {\n  color: #640064 !important;\n}\n\n.bg-light.bg-gradient-bg {\n  background-color: #640064 !important;\n}\n\n.btn-light.btn-gradient-bg {\n  border-color: !important;\n  background-color: #640064 !important;\n}\n.btn-light.btn-gradient-bg:hover {\n  border-color: !important;\n  background-color: !important;\n}\n.btn-light.btn-gradient-bg:focus, .btn-light.btn-gradient-bg:active {\n  border-color: !important;\n  background-color: !important;\n}\n\n.btn-outline-light.btn-outline-gradient-bg {\n  border-color: #640064 !important;\n  color: #640064 !important;\n}\n.btn-outline-light.btn-outline-gradient-bg:hover {\n  background-color: #640064 !important;\n}\n\ninput:focus ~ .bg-light {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #640064 !important;\n}\n\n.border-light.border-gradient-bg {\n  border: 1px solid #640064 !important;\n}\n\n.border-top-light.border-top-gradient-bg {\n  border-top: 1px solid #640064 !important;\n}\n\n.border-bottom-light.border-bottom-gradient-bg {\n  border-bottom: 1px solid #640064 !important;\n}\n\n.border-left-light.border-left-gradient-bg {\n  border-left: 1px solid #640064 !important;\n}\n\n.border-right-light.border-right-gradient-bg {\n  border-right: 1px solid #640064 !important;\n}\n\n.overlay-light.overlay-gradient-bg {\n  background: #640064; /* The Fallback */\n  background: rgba(100, 0, 100, 0.6);\n}\n\n.primary.gradient-light {\n  color: rgb(205.887538787, 158.985231015, 251.997768985) !important;\n}\n\n.bg-primary.bg-gradient-light {\n  background-color: rgb(205.887538787, 158.985231015, 251.997768985) !important;\n}\n\n.btn-primary.btn-gradient-light {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: rgb(205.887538787, 158.985231015, 251.997768985) !important;\n}\n.btn-primary.btn-gradient-light:hover {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n}\n.btn-primary.btn-gradient-light:focus, .btn-primary.btn-gradient-light:active {\n  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;\n}\n\n.btn-outline-primary.btn-outline-gradient-light {\n  border-color: rgb(205.887538787, 158.985231015, 251.997768985) !important;\n  color: rgb(205.887538787, 158.985231015, 251.997768985) !important;\n}\n.btn-outline-primary.btn-outline-gradient-light:hover {\n  background-color: rgb(205.887538787, 158.985231015, 251.997768985) !important;\n}\n\ninput:focus ~ .bg-primary {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(205.887538787, 158.985231015, 251.997768985) !important;\n}\n\n.border-primary.border-gradient-light {\n  border: 1px solid rgb(205.887538787, 158.985231015, 251.997768985) !important;\n}\n\n.border-top-primary.border-top-gradient-light {\n  border-top: 1px solid rgb(205.887538787, 158.985231015, 251.997768985) !important;\n}\n\n.border-bottom-primary.border-bottom-gradient-light {\n  border-bottom: 1px solid rgb(205.887538787, 158.985231015, 251.997768985) !important;\n}\n\n.border-left-primary.border-left-gradient-light {\n  border-left: 1px solid rgb(205.887538787, 158.985231015, 251.997768985) !important;\n}\n\n.border-right-primary.border-right-gradient-light {\n  border-right: 1px solid rgb(205.887538787, 158.985231015, 251.997768985) !important;\n}\n\n.overlay-primary.overlay-gradient-light {\n  background: rgb(205.887538787, 158.985231015, 251.997768985); /* The Fallback */\n  background: rgba(205.887538787, 158.985231015, 251.997768985, 0.6);\n}\n\n.primary.light-badge {\n  color: rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;\n}\n\n.bg-primary.bg-light-badge {\n  background-color: rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;\n}\n\n.btn-primary.btn-light-badge {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;\n}\n.btn-primary.btn-light-badge:hover {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n}\n.btn-primary.btn-light-badge:focus, .btn-primary.btn-light-badge:active {\n  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;\n}\n\n.btn-outline-primary.btn-outline-light-badge {\n  border-color: rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;\n  color: rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;\n}\n.btn-outline-primary.btn-outline-light-badge:hover {\n  background-color: rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;\n}\n\ninput:focus ~ .bg-primary {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;\n}\n\n.border-primary.border-light-badge {\n  border: 1px solid rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;\n}\n\n.border-top-primary.border-top-light-badge {\n  border-top: 1px solid rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;\n}\n\n.border-bottom-primary.border-bottom-light-badge {\n  border-bottom: 1px solid rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;\n}\n\n.border-left-primary.border-left-light-badge {\n  border-left: 1px solid rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;\n}\n\n.border-right-primary.border-right-light-badge {\n  border-right: 1px solid rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;\n}\n\n.overlay-primary.overlay-light-badge {\n  background: rgb(221.8862275449, 219.0479041916, 251.4520958084); /* The Fallback */\n  background: rgba(221.8862275449, 219.0479041916, 251.4520958084, 0.6);\n}\n\n.primary.lighten-5 {\n  color: rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;\n}\n\n.bg-primary.bg-lighten-5 {\n  background-color: rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;\n}\n\n.btn-primary.btn-lighten-5 {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;\n}\n.btn-primary.btn-lighten-5:hover {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n}\n.btn-primary.btn-lighten-5:focus, .btn-primary.btn-lighten-5:active {\n  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;\n}\n\n.btn-outline-primary.btn-outline-lighten-5 {\n  border-color: rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;\n  color: rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;\n}\n.btn-outline-primary.btn-outline-lighten-5:hover {\n  background-color: rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;\n}\n\ninput:focus ~ .bg-primary {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;\n}\n\n.border-primary.border-lighten-5 {\n  border: 1px solid rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;\n}\n\n.border-top-primary.border-top-lighten-5 {\n  border-top: 1px solid rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;\n}\n\n.border-bottom-primary.border-bottom-lighten-5 {\n  border-bottom: 1px solid rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;\n}\n\n.border-left-primary.border-left-lighten-5 {\n  border-left: 1px solid rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;\n}\n\n.border-right-primary.border-right-lighten-5 {\n  border-right: 1px solid rgb(221.8862275449, 219.0479041916, 251.4520958084) !important;\n}\n\n.overlay-primary.overlay-lighten-5 {\n  background: rgb(221.8862275449, 219.0479041916, 251.4520958084); /* The Fallback */\n  background: rgba(221.8862275449, 219.0479041916, 251.4520958084, 0.6);\n}\n\n.primary.lighten-4 {\n  color: rgb(200.5089820359, 195.8383233533, 249.1616766467) !important;\n}\n\n.bg-primary.bg-lighten-4 {\n  background-color: rgb(200.5089820359, 195.8383233533, 249.1616766467) !important;\n}\n\n.btn-primary.btn-lighten-4 {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: rgb(200.5089820359, 195.8383233533, 249.1616766467) !important;\n}\n.btn-primary.btn-lighten-4:hover {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n}\n.btn-primary.btn-lighten-4:focus, .btn-primary.btn-lighten-4:active {\n  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;\n}\n\n.btn-outline-primary.btn-outline-lighten-4 {\n  border-color: rgb(200.5089820359, 195.8383233533, 249.1616766467) !important;\n  color: rgb(200.5089820359, 195.8383233533, 249.1616766467) !important;\n}\n.btn-outline-primary.btn-outline-lighten-4:hover {\n  background-color: rgb(200.5089820359, 195.8383233533, 249.1616766467) !important;\n}\n\ninput:focus ~ .bg-primary {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(200.5089820359, 195.8383233533, 249.1616766467) !important;\n}\n\n.border-primary.border-lighten-4 {\n  border: 1px solid rgb(200.5089820359, 195.8383233533, 249.1616766467) !important;\n}\n\n.border-top-primary.border-top-lighten-4 {\n  border-top: 1px solid rgb(200.5089820359, 195.8383233533, 249.1616766467) !important;\n}\n\n.border-bottom-primary.border-bottom-lighten-4 {\n  border-bottom: 1px solid rgb(200.5089820359, 195.8383233533, 249.1616766467) !important;\n}\n\n.border-left-primary.border-left-lighten-4 {\n  border-left: 1px solid rgb(200.5089820359, 195.8383233533, 249.1616766467) !important;\n}\n\n.border-right-primary.border-right-lighten-4 {\n  border-right: 1px solid rgb(200.5089820359, 195.8383233533, 249.1616766467) !important;\n}\n\n.overlay-primary.overlay-lighten-4 {\n  background: rgb(200.5089820359, 195.8383233533, 249.1616766467); /* The Fallback */\n  background: rgba(200.5089820359, 195.8383233533, 249.1616766467, 0.6);\n}\n\n.primary.lighten-3 {\n  color: rgb(179.1317365269, 172.628742515, 246.871257485) !important;\n}\n\n.bg-primary.bg-lighten-3 {\n  background-color: rgb(179.1317365269, 172.628742515, 246.871257485) !important;\n}\n\n.btn-primary.btn-lighten-3 {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: rgb(179.1317365269, 172.628742515, 246.871257485) !important;\n}\n.btn-primary.btn-lighten-3:hover {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n}\n.btn-primary.btn-lighten-3:focus, .btn-primary.btn-lighten-3:active {\n  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;\n}\n\n.btn-outline-primary.btn-outline-lighten-3 {\n  border-color: rgb(179.1317365269, 172.628742515, 246.871257485) !important;\n  color: rgb(179.1317365269, 172.628742515, 246.871257485) !important;\n}\n.btn-outline-primary.btn-outline-lighten-3:hover {\n  background-color: rgb(179.1317365269, 172.628742515, 246.871257485) !important;\n}\n\ninput:focus ~ .bg-primary {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(179.1317365269, 172.628742515, 246.871257485) !important;\n}\n\n.border-primary.border-lighten-3 {\n  border: 1px solid rgb(179.1317365269, 172.628742515, 246.871257485) !important;\n}\n\n.border-top-primary.border-top-lighten-3 {\n  border-top: 1px solid rgb(179.1317365269, 172.628742515, 246.871257485) !important;\n}\n\n.border-bottom-primary.border-bottom-lighten-3 {\n  border-bottom: 1px solid rgb(179.1317365269, 172.628742515, 246.871257485) !important;\n}\n\n.border-left-primary.border-left-lighten-3 {\n  border-left: 1px solid rgb(179.1317365269, 172.628742515, 246.871257485) !important;\n}\n\n.border-right-primary.border-right-lighten-3 {\n  border-right: 1px solid rgb(179.1317365269, 172.628742515, 246.871257485) !important;\n}\n\n.overlay-primary.overlay-lighten-3 {\n  background: rgb(179.1317365269, 172.628742515, 246.871257485); /* The Fallback */\n  background: rgba(179.1317365269, 172.628742515, 246.871257485, 0.6);\n}\n\n.primary.lighten-2 {\n  color: rgb(157.754491018, 149.4191616766, 244.5808383234) !important;\n}\n\n.bg-primary.bg-lighten-2 {\n  background-color: rgb(157.754491018, 149.4191616766, 244.5808383234) !important;\n}\n\n.btn-primary.btn-lighten-2 {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: rgb(157.754491018, 149.4191616766, 244.5808383234) !important;\n}\n.btn-primary.btn-lighten-2:hover {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n}\n.btn-primary.btn-lighten-2:focus, .btn-primary.btn-lighten-2:active {\n  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;\n}\n\n.btn-outline-primary.btn-outline-lighten-2 {\n  border-color: rgb(157.754491018, 149.4191616766, 244.5808383234) !important;\n  color: rgb(157.754491018, 149.4191616766, 244.5808383234) !important;\n}\n.btn-outline-primary.btn-outline-lighten-2:hover {\n  background-color: rgb(157.754491018, 149.4191616766, 244.5808383234) !important;\n}\n\ninput:focus ~ .bg-primary {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(157.754491018, 149.4191616766, 244.5808383234) !important;\n}\n\n.border-primary.border-lighten-2 {\n  border: 1px solid rgb(157.754491018, 149.4191616766, 244.5808383234) !important;\n}\n\n.border-top-primary.border-top-lighten-2 {\n  border-top: 1px solid rgb(157.754491018, 149.4191616766, 244.5808383234) !important;\n}\n\n.border-bottom-primary.border-bottom-lighten-2 {\n  border-bottom: 1px solid rgb(157.754491018, 149.4191616766, 244.5808383234) !important;\n}\n\n.border-left-primary.border-left-lighten-2 {\n  border-left: 1px solid rgb(157.754491018, 149.4191616766, 244.5808383234) !important;\n}\n\n.border-right-primary.border-right-lighten-2 {\n  border-right: 1px solid rgb(157.754491018, 149.4191616766, 244.5808383234) !important;\n}\n\n.overlay-primary.overlay-lighten-2 {\n  background: rgb(157.754491018, 149.4191616766, 244.5808383234); /* The Fallback */\n  background: rgba(157.754491018, 149.4191616766, 244.5808383234, 0.6);\n}\n\n.primary.lighten-1 {\n  color: rgb(136.377245509, 126.2095808383, 242.2904191617) !important;\n}\n\n.bg-primary.bg-lighten-1 {\n  background-color: rgb(136.377245509, 126.2095808383, 242.2904191617) !important;\n}\n\n.btn-primary.btn-lighten-1 {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: rgb(136.377245509, 126.2095808383, 242.2904191617) !important;\n}\n.btn-primary.btn-lighten-1:hover {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n}\n.btn-primary.btn-lighten-1:focus, .btn-primary.btn-lighten-1:active {\n  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;\n}\n\n.btn-outline-primary.btn-outline-lighten-1 {\n  border-color: rgb(136.377245509, 126.2095808383, 242.2904191617) !important;\n  color: rgb(136.377245509, 126.2095808383, 242.2904191617) !important;\n}\n.btn-outline-primary.btn-outline-lighten-1:hover {\n  background-color: rgb(136.377245509, 126.2095808383, 242.2904191617) !important;\n}\n\ninput:focus ~ .bg-primary {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(136.377245509, 126.2095808383, 242.2904191617) !important;\n}\n\n.border-primary.border-lighten-1 {\n  border: 1px solid rgb(136.377245509, 126.2095808383, 242.2904191617) !important;\n}\n\n.border-top-primary.border-top-lighten-1 {\n  border-top: 1px solid rgb(136.377245509, 126.2095808383, 242.2904191617) !important;\n}\n\n.border-bottom-primary.border-bottom-lighten-1 {\n  border-bottom: 1px solid rgb(136.377245509, 126.2095808383, 242.2904191617) !important;\n}\n\n.border-left-primary.border-left-lighten-1 {\n  border-left: 1px solid rgb(136.377245509, 126.2095808383, 242.2904191617) !important;\n}\n\n.border-right-primary.border-right-lighten-1 {\n  border-right: 1px solid rgb(136.377245509, 126.2095808383, 242.2904191617) !important;\n}\n\n.overlay-primary.overlay-lighten-1 {\n  background: rgb(136.377245509, 126.2095808383, 242.2904191617); /* The Fallback */\n  background: rgba(136.377245509, 126.2095808383, 242.2904191617, 0.6);\n}\n\n.primary {\n  color: #7367f0 !important;\n}\n\n.bg-primary {\n  background-color: #7367f0 !important;\n}\n.bg-primary .card-header,\n.bg-primary .card-footer {\n  background-color: transparent;\n}\n\n.alert-primary {\n  background: rgba(115, 103, 240, 0.2) !important;\n  color: #7367f0 !important;\n}\n.alert-primary .alert-heading {\n  box-shadow: rgba(115, 103, 240, 0.4) 0px 6px 15px -7px;\n}\n.alert-primary .alert-link {\n  color: rgb(93.622754491, 79.7904191617, 237.7095808383) !important;\n}\n\n.bg-rgba-primary {\n  background: rgba(115, 103, 240, 0.15) !important;\n}\n\n.border-primary {\n  border: 1px solid #7367f0 !important;\n}\n\n.border-top-primary {\n  border-top: 1px solid #7367f0;\n}\n\n.border-bottom-primary {\n  border-bottom: 1px solid #7367f0;\n}\n\n.border-left-primary {\n  border-left: 1px solid #7367f0;\n}\n\n.border-right-primary {\n  border-right: 1px solid #7367f0;\n}\n\n.badge.badge-light-primary {\n  background-color: rgb(221.8862275449, 219.0479041916, 251.4520958084);\n  color: #7367f0 !important;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.bg-primary.badge-glow,\n.border-primary.badge-glow,\n.badge-primary.badge-glow {\n  box-shadow: 0px 0px 10px #7367f0;\n}\n\n.overlay-primary {\n  background: #7367f0; /* The Fallback */\n  background: rgba(115, 103, 240, 0.6);\n}\n\n.btn-primary {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: #7367f0 !important;\n  color: #fff;\n}\n.btn-primary:hover {\n  border-color: rgb(93.622754491, 79.7904191617, 237.7095808383) !important;\n  color: #fff !important;\n  box-shadow: 0 8px 25px -8px #7367f0;\n}\n.btn-primary:focus, .btn-primary:active {\n  color: #fff !important;\n}\n\n.btn-flat-primary {\n  background-color: transparent;\n  color: #7367f0;\n}\n.btn-flat-primary:hover {\n  color: #7367f0;\n  background-color: rgba(115, 103, 240, 0.1);\n}\n.btn-flat-primary:active, .btn-flat-primary:focus {\n  background-color: #7367f0;\n  color: #fff !important;\n}\n\n.btn-relief-primary {\n  background-color: #7367f0;\n  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.2);\n  color: #fff;\n}\n.btn-relief-primary:hover {\n  color: #fff;\n}\n.btn-relief-primary:active, .btn-relief-primary:focus {\n  outline: none;\n  transform: translateY(3px);\n}\n\n.btn-outline-primary {\n  border: 1px solid #7367f0;\n  background-color: transparent;\n  color: #7367f0;\n}\n.btn-outline-primary:hover {\n  background-color: rgba(115, 103, 240, 0.08);\n  color: #7367f0;\n}\n.btn-outline-primary:active {\n  color: #fff !important;\n}\n\n.btn-primary ~ .dropdown-menu .dropdown-item.active,\n.btn-outline-primary ~ .dropdown-menu .dropdown-item.active,\n.btn-flat-primary ~ .dropdown-menu .dropdown-item.active {\n  background-color: #7367f0;\n  color: #fff;\n}\n.btn-primary ~ .dropdown-menu .dropdown-item.active:hover,\n.btn-outline-primary ~ .dropdown-menu .dropdown-item.active:hover,\n.btn-flat-primary ~ .dropdown-menu .dropdown-item.active:hover {\n  color: #fff;\n}\n.btn-primary ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,\n.btn-outline-primary ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,\n.btn-flat-primary ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover {\n  color: #7367f0;\n}\n\n.bullet.bullet-primary {\n  background-color: #7367f0;\n}\n.bullet.bullet-primary.bullet-bordered {\n  background-color: transparent;\n  border: 2px solid #7367f0;\n}\n\n.pagination-primary li.active a,\n.pagination-primary li.active .page-link,\n.pagination-primary .page-item.active a,\n.pagination-primary .page-item.active .page-link {\n  background: #7367f0 !important;\n  color: #fff;\n}\n.pagination-primary li.active a:hover,\n.pagination-primary li.active .page-link:hover,\n.pagination-primary .page-item.active a:hover,\n.pagination-primary .page-item.active .page-link:hover {\n  color: #fff !important;\n}\n.pagination-primary li a:hover,\n.pagination-primary li .page-link:hover,\n.pagination-primary .page-item a:hover,\n.pagination-primary .page-item .page-link:hover {\n  color: #7367f0 !important;\n}\n.pagination-primary li.prev-item .page-link:hover, .pagination-primary li.next-item .page-link:hover,\n.pagination-primary .page-item.prev-item .page-link:hover,\n.pagination-primary .page-item.next-item .page-link:hover {\n  background: #7367f0;\n  color: #fff;\n}\n\n.nav-pill-primary .nav-item .nav-link.active {\n  color: #fff;\n  background-color: #7367f0;\n}\n\n.chip-primary {\n  background-color: #7367f0 !important;\n}\n.chip-primary .chip-body {\n  color: #fff !important;\n}\n\n.divider.divider-primary .divider-text:before, .divider.divider-primary .divider-text:after {\n  border-color: #7367f0 !important;\n}\n\ninput[type=checkbox].bg-primary + .custom-control-label:before, input[type=radio].bg-primary + .custom-control-label:before {\n  background-color: #7367f0 !important;\n}\n\ninput:focus ~ .bg-primary {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #7367f0 !important;\n}\n\n.vx-checkbox-primary input:checked ~ .vx-checkbox {\n  border-color: #7367f0 !important;\n}\n.vx-checkbox-primary input:checked ~ .vx-checkbox .vx-checkbox--check {\n  background-color: #7367f0 !important;\n}\n.vx-checkbox-primary input:active:checked + .vx-checkbox .vx-checkbox--check {\n  background-color: #7367f0 !important;\n}\n\n.vertical-layout .main-menu.theme-primary .navbar-header .navbar-nav .brand-text {\n  color: #7367f0;\n}\n.vertical-layout .main-menu.theme-primary .navigation .nav-item.active a {\n  background: linear-gradient(118deg, #7367f0, rgba(115, 103, 240, 0.7));\n  box-shadow: 0 0 10px 1px rgba(115, 103, 240, 0.7) !important;\n}\n.vertical-layout .main-menu.theme-primary .navigation .nav-item .menu-content li.active {\n  background: linear-gradient(118deg, #7367f0, rgba(115, 103, 240, 0.7));\n  box-shadow: 0 0 10px 1px rgba(115, 103, 240, 0.7) !important;\n}\n\n.horizontal-layout.theme-primary .header-navbar .brand-text {\n  color: #7367f0 !important;\n}\n.horizontal-layout.theme-primary .navbar-horizontal #main-menu-navigation .nav-item.active .nav-link {\n  background: linear-gradient(118deg, #7367f0, rgba(115, 103, 240, 0.7));\n  box-shadow: 0 0 10px 1px rgba(115, 103, 240, 0.7) !important;\n}\n\n.custom-switch-primary .custom-control-input:checked ~ .custom-control-label::before {\n  background-color: #7367f0 !important;\n  color: #fff;\n  transition: all 0.2s ease-out;\n}\n\n.color-radio.color-radio-primary {\n  border: 1px solid transparent;\n}\n.color-radio.color-radio-primary.selected {\n  border-color: #7367f0;\n}\n.color-radio.color-radio-primary .radio-content {\n  background-color: #7367f0;\n}\n\n.vx-radio-primary input:checked ~ .vx-radio .vx-radio--circle {\n  background: #7367f0 !important;\n  box-shadow: 0 3px 12px 0 rgba(115, 103, 240, 0.4) !important;\n}\n\n.primary.darken-1 {\n  color: rgb(93.622754491, 79.7904191617, 237.7095808383) !important;\n}\n\n.bg-primary.bg-darken-1 {\n  background-color: rgb(93.622754491, 79.7904191617, 237.7095808383) !important;\n}\n\n.btn-primary.btn-darken-1 {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: rgb(93.622754491, 79.7904191617, 237.7095808383) !important;\n}\n.btn-primary.btn-darken-1:hover {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n}\n.btn-primary.btn-darken-1:focus, .btn-primary.btn-darken-1:active {\n  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;\n}\n\n.btn-outline-primary.btn-outline-darken-1 {\n  border-color: rgb(93.622754491, 79.7904191617, 237.7095808383) !important;\n  color: rgb(93.622754491, 79.7904191617, 237.7095808383) !important;\n}\n.btn-outline-primary.btn-outline-darken-1:hover {\n  background-color: rgb(93.622754491, 79.7904191617, 237.7095808383) !important;\n}\n\ninput:focus ~ .bg-primary {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(93.622754491, 79.7904191617, 237.7095808383) !important;\n}\n\n.border-primary.border-darken-1 {\n  border: 1px solid rgb(93.622754491, 79.7904191617, 237.7095808383) !important;\n}\n\n.border-top-primary.border-top-darken-1 {\n  border-top: 1px solid rgb(93.622754491, 79.7904191617, 237.7095808383) !important;\n}\n\n.border-bottom-primary.border-bottom-darken-1 {\n  border-bottom: 1px solid rgb(93.622754491, 79.7904191617, 237.7095808383) !important;\n}\n\n.border-left-primary.border-left-darken-1 {\n  border-left: 1px solid rgb(93.622754491, 79.7904191617, 237.7095808383) !important;\n}\n\n.border-right-primary.border-right-darken-1 {\n  border-right: 1px solid rgb(93.622754491, 79.7904191617, 237.7095808383) !important;\n}\n\n.overlay-primary.overlay-darken-1 {\n  background: rgb(93.622754491, 79.7904191617, 237.7095808383); /* The Fallback */\n  background: rgba(93.622754491, 79.7904191617, 237.7095808383, 0.6);\n}\n\n.primary.darken-2 {\n  color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n}\n\n.bg-primary.bg-darken-2 {\n  background-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n}\n\n.btn-primary.btn-darken-2 {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n}\n.btn-primary.btn-darken-2:hover {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n}\n.btn-primary.btn-darken-2:focus, .btn-primary.btn-darken-2:active {\n  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;\n}\n\n.btn-outline-primary.btn-outline-darken-2 {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n}\n.btn-outline-primary.btn-outline-darken-2:hover {\n  background-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n}\n\ninput:focus ~ .bg-primary {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n}\n\n.border-primary.border-darken-2 {\n  border: 1px solid rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n}\n\n.border-top-primary.border-top-darken-2 {\n  border-top: 1px solid rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n}\n\n.border-bottom-primary.border-bottom-darken-2 {\n  border-bottom: 1px solid rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n}\n\n.border-left-primary.border-left-darken-2 {\n  border-left: 1px solid rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n}\n\n.border-right-primary.border-right-darken-2 {\n  border-right: 1px solid rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n}\n\n.overlay-primary.overlay-darken-2 {\n  background: rgb(72.245508982, 56.5808383234, 235.4191616766); /* The Fallback */\n  background: rgba(72.245508982, 56.5808383234, 235.4191616766, 0.6);\n}\n\n.primary.darken-3 {\n  color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n}\n\n.bg-primary.bg-darken-3 {\n  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n}\n\n.btn-primary.btn-darken-3 {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n}\n.btn-primary.btn-darken-3:hover {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n}\n.btn-primary.btn-darken-3:focus, .btn-primary.btn-darken-3:active {\n  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;\n}\n\n.btn-outline-primary.btn-outline-darken-3 {\n  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n  color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n}\n.btn-outline-primary.btn-outline-darken-3:hover {\n  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n}\n\ninput:focus ~ .bg-primary {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n}\n\n.border-primary.border-darken-3 {\n  border: 1px solid rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n}\n\n.border-top-primary.border-top-darken-3 {\n  border-top: 1px solid rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n}\n\n.border-bottom-primary.border-bottom-darken-3 {\n  border-bottom: 1px solid rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n}\n\n.border-left-primary.border-left-darken-3 {\n  border-left: 1px solid rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n}\n\n.border-right-primary.border-right-darken-3 {\n  border-right: 1px solid rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n}\n\n.overlay-primary.overlay-darken-3 {\n  background: rgb(50.8682634731, 33.371257485, 233.128742515); /* The Fallback */\n  background: rgba(50.8682634731, 33.371257485, 233.128742515, 0.6);\n}\n\n.primary.darken-4 {\n  color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;\n}\n\n.bg-primary.bg-darken-4 {\n  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;\n}\n\n.btn-primary.btn-darken-4 {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;\n}\n.btn-primary.btn-darken-4:hover {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n}\n.btn-primary.btn-darken-4:focus, .btn-primary.btn-darken-4:active {\n  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;\n}\n\n.btn-outline-primary.btn-outline-darken-4 {\n  border-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;\n  color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;\n}\n.btn-outline-primary.btn-outline-darken-4:hover {\n  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;\n}\n\ninput:focus ~ .bg-primary {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;\n}\n\n.border-primary.border-darken-4 {\n  border: 1px solid rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;\n}\n\n.border-top-primary.border-top-darken-4 {\n  border-top: 1px solid rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;\n}\n\n.border-bottom-primary.border-bottom-darken-4 {\n  border-bottom: 1px solid rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;\n}\n\n.border-left-primary.border-left-darken-4 {\n  border-left: 1px solid rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;\n}\n\n.border-right-primary.border-right-darken-4 {\n  border-right: 1px solid rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;\n}\n\n.overlay-primary.overlay-darken-4 {\n  background: rgb(38.9640718563, 21.6467065868, 219.3532934132); /* The Fallback */\n  background: rgba(38.9640718563, 21.6467065868, 219.3532934132, 0.6);\n}\n\n.primary.accent-1 {\n  color: #bdfdff !important;\n}\n\n.bg-primary.bg-accent-1 {\n  background-color: #bdfdff !important;\n}\n\n.btn-primary.btn-accent-1 {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: #bdfdff !important;\n}\n.btn-primary.btn-accent-1:hover {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n}\n.btn-primary.btn-accent-1:focus, .btn-primary.btn-accent-1:active {\n  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;\n}\n\n.btn-outline-primary.btn-outline-accent-1 {\n  border-color: #bdfdff !important;\n  color: #bdfdff !important;\n}\n.btn-outline-primary.btn-outline-accent-1:hover {\n  background-color: #bdfdff !important;\n}\n\ninput:focus ~ .bg-primary {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #bdfdff !important;\n}\n\n.border-primary.border-accent-1 {\n  border: 1px solid #bdfdff !important;\n}\n\n.border-top-primary.border-top-accent-1 {\n  border-top: 1px solid #bdfdff !important;\n}\n\n.border-bottom-primary.border-bottom-accent-1 {\n  border-bottom: 1px solid #bdfdff !important;\n}\n\n.border-left-primary.border-left-accent-1 {\n  border-left: 1px solid #bdfdff !important;\n}\n\n.border-right-primary.border-right-accent-1 {\n  border-right: 1px solid #bdfdff !important;\n}\n\n.overlay-primary.overlay-accent-1 {\n  background: #bdfdff; /* The Fallback */\n  background: rgba(189, 253, 255, 0.6);\n}\n\n.primary.accent-2 {\n  color: #8afbff !important;\n}\n\n.bg-primary.bg-accent-2 {\n  background-color: #8afbff !important;\n}\n\n.btn-primary.btn-accent-2 {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: #8afbff !important;\n}\n.btn-primary.btn-accent-2:hover {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n}\n.btn-primary.btn-accent-2:focus, .btn-primary.btn-accent-2:active {\n  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;\n}\n\n.btn-outline-primary.btn-outline-accent-2 {\n  border-color: #8afbff !important;\n  color: #8afbff !important;\n}\n.btn-outline-primary.btn-outline-accent-2:hover {\n  background-color: #8afbff !important;\n}\n\ninput:focus ~ .bg-primary {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #8afbff !important;\n}\n\n.border-primary.border-accent-2 {\n  border: 1px solid #8afbff !important;\n}\n\n.border-top-primary.border-top-accent-2 {\n  border-top: 1px solid #8afbff !important;\n}\n\n.border-bottom-primary.border-bottom-accent-2 {\n  border-bottom: 1px solid #8afbff !important;\n}\n\n.border-left-primary.border-left-accent-2 {\n  border-left: 1px solid #8afbff !important;\n}\n\n.border-right-primary.border-right-accent-2 {\n  border-right: 1px solid #8afbff !important;\n}\n\n.overlay-primary.overlay-accent-2 {\n  background: #8afbff; /* The Fallback */\n  background: rgba(138, 251, 255, 0.6);\n}\n\n.primary.accent-3 {\n  color: #57faff !important;\n}\n\n.bg-primary.bg-accent-3 {\n  background-color: #57faff !important;\n}\n\n.btn-primary.btn-accent-3 {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: #57faff !important;\n}\n.btn-primary.btn-accent-3:hover {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n}\n.btn-primary.btn-accent-3:focus, .btn-primary.btn-accent-3:active {\n  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;\n}\n\n.btn-outline-primary.btn-outline-accent-3 {\n  border-color: #57faff !important;\n  color: #57faff !important;\n}\n.btn-outline-primary.btn-outline-accent-3:hover {\n  background-color: #57faff !important;\n}\n\ninput:focus ~ .bg-primary {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #57faff !important;\n}\n\n.border-primary.border-accent-3 {\n  border: 1px solid #57faff !important;\n}\n\n.border-top-primary.border-top-accent-3 {\n  border-top: 1px solid #57faff !important;\n}\n\n.border-bottom-primary.border-bottom-accent-3 {\n  border-bottom: 1px solid #57faff !important;\n}\n\n.border-left-primary.border-left-accent-3 {\n  border-left: 1px solid #57faff !important;\n}\n\n.border-right-primary.border-right-accent-3 {\n  border-right: 1px solid #57faff !important;\n}\n\n.overlay-primary.overlay-accent-3 {\n  background: #57faff; /* The Fallback */\n  background: rgba(87, 250, 255, 0.6);\n}\n\n.primary.accent-4 {\n  color: #3df9ff !important;\n}\n\n.bg-primary.bg-accent-4 {\n  background-color: #3df9ff !important;\n}\n\n.btn-primary.btn-accent-4 {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: #3df9ff !important;\n}\n.btn-primary.btn-accent-4:hover {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n}\n.btn-primary.btn-accent-4:focus, .btn-primary.btn-accent-4:active {\n  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;\n}\n\n.btn-outline-primary.btn-outline-accent-4 {\n  border-color: #3df9ff !important;\n  color: #3df9ff !important;\n}\n.btn-outline-primary.btn-outline-accent-4:hover {\n  background-color: #3df9ff !important;\n}\n\ninput:focus ~ .bg-primary {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #3df9ff !important;\n}\n\n.border-primary.border-accent-4 {\n  border: 1px solid #3df9ff !important;\n}\n\n.border-top-primary.border-top-accent-4 {\n  border-top: 1px solid #3df9ff !important;\n}\n\n.border-bottom-primary.border-bottom-accent-4 {\n  border-bottom: 1px solid #3df9ff !important;\n}\n\n.border-left-primary.border-left-accent-4 {\n  border-left: 1px solid #3df9ff !important;\n}\n\n.border-right-primary.border-right-accent-4 {\n  border-right: 1px solid #3df9ff !important;\n}\n\n.overlay-primary.overlay-accent-4 {\n  background: #3df9ff; /* The Fallback */\n  background: rgba(61, 249, 255, 0.6);\n}\n\n.primary.gradient-bg {\n  color: #640064 !important;\n}\n\n.bg-primary.bg-gradient-bg {\n  background-color: #640064 !important;\n}\n\n.btn-primary.btn-gradient-bg {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: #640064 !important;\n}\n.btn-primary.btn-gradient-bg:hover {\n  border-color: rgb(72.245508982, 56.5808383234, 235.4191616766) !important;\n  background-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n}\n.btn-primary.btn-gradient-bg:focus, .btn-primary.btn-gradient-bg:active {\n  border-color: rgb(50.8682634731, 33.371257485, 233.128742515) !important;\n  background-color: rgb(38.9640718563, 21.6467065868, 219.3532934132) !important;\n}\n\n.btn-outline-primary.btn-outline-gradient-bg {\n  border-color: #640064 !important;\n  color: #640064 !important;\n}\n.btn-outline-primary.btn-outline-gradient-bg:hover {\n  background-color: #640064 !important;\n}\n\ninput:focus ~ .bg-primary {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #640064 !important;\n}\n\n.border-primary.border-gradient-bg {\n  border: 1px solid #640064 !important;\n}\n\n.border-top-primary.border-top-gradient-bg {\n  border-top: 1px solid #640064 !important;\n}\n\n.border-bottom-primary.border-bottom-gradient-bg {\n  border-bottom: 1px solid #640064 !important;\n}\n\n.border-left-primary.border-left-gradient-bg {\n  border-left: 1px solid #640064 !important;\n}\n\n.border-right-primary.border-right-gradient-bg {\n  border-right: 1px solid #640064 !important;\n}\n\n.overlay-primary.overlay-gradient-bg {\n  background: #640064; /* The Fallback */\n  background: rgba(100, 0, 100, 0.6);\n}\n\n.secondary.gradient-light {\n  color: rgb(220.3498655492, 221.623471291, 235.6331344508) !important;\n}\n\n.bg-secondary.bg-gradient-light {\n  background-color: rgb(220.3498655492, 221.623471291, 235.6331344508) !important;\n}\n\n.btn-secondary.btn-gradient-light {\n  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;\n  background-color: rgb(220.3498655492, 221.623471291, 235.6331344508) !important;\n}\n.btn-secondary.btn-gradient-light:hover {\n  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;\n  background-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;\n}\n.btn-secondary.btn-gradient-light:focus, .btn-secondary.btn-gradient-light:active {\n  border-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;\n  background-color: rgb(124.6393442623, 143, 161.3606557377) !important;\n}\n\n.btn-outline-secondary.btn-outline-gradient-light {\n  border-color: rgb(220.3498655492, 221.623471291, 235.6331344508) !important;\n  color: rgb(220.3498655492, 221.623471291, 235.6331344508) !important;\n}\n.btn-outline-secondary.btn-outline-gradient-light:hover {\n  background-color: rgb(220.3498655492, 221.623471291, 235.6331344508) !important;\n}\n\ninput:focus ~ .bg-secondary {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(220.3498655492, 221.623471291, 235.6331344508) !important;\n}\n\n.border-secondary.border-gradient-light {\n  border: 1px solid rgb(220.3498655492, 221.623471291, 235.6331344508) !important;\n}\n\n.border-top-secondary.border-top-gradient-light {\n  border-top: 1px solid rgb(220.3498655492, 221.623471291, 235.6331344508) !important;\n}\n\n.border-bottom-secondary.border-bottom-gradient-light {\n  border-bottom: 1px solid rgb(220.3498655492, 221.623471291, 235.6331344508) !important;\n}\n\n.border-left-secondary.border-left-gradient-light {\n  border-left: 1px solid rgb(220.3498655492, 221.623471291, 235.6331344508) !important;\n}\n\n.border-right-secondary.border-right-gradient-light {\n  border-right: 1px solid rgb(220.3498655492, 221.623471291, 235.6331344508) !important;\n}\n\n.overlay-secondary.overlay-gradient-light {\n  background: rgb(220.3498655492, 221.623471291, 235.6331344508); /* The Fallback */\n  background: rgba(220.3498655492, 221.623471291, 235.6331344508, 0.6);\n}\n\n.secondary.light-badge {\n  color: white !important;\n}\n\n.bg-secondary.bg-light-badge {\n  background-color: white !important;\n}\n\n.btn-secondary.btn-light-badge {\n  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;\n  background-color: white !important;\n}\n.btn-secondary.btn-light-badge:hover {\n  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;\n  background-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;\n}\n.btn-secondary.btn-light-badge:focus, .btn-secondary.btn-light-badge:active {\n  border-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;\n  background-color: rgb(124.6393442623, 143, 161.3606557377) !important;\n}\n\n.btn-outline-secondary.btn-outline-light-badge {\n  border-color: white !important;\n  color: white !important;\n}\n.btn-outline-secondary.btn-outline-light-badge:hover {\n  background-color: white !important;\n}\n\ninput:focus ~ .bg-secondary {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem white !important;\n}\n\n.border-secondary.border-light-badge {\n  border: 1px solid white !important;\n}\n\n.border-top-secondary.border-top-light-badge {\n  border-top: 1px solid white !important;\n}\n\n.border-bottom-secondary.border-bottom-light-badge {\n  border-bottom: 1px solid white !important;\n}\n\n.border-left-secondary.border-left-light-badge {\n  border-left: 1px solid white !important;\n}\n\n.border-right-secondary.border-right-light-badge {\n  border-right: 1px solid white !important;\n}\n\n.overlay-secondary.overlay-light-badge {\n  background: white; /* The Fallback */\n  background: rgba(255, 255, 255, 0.6);\n}\n\n.secondary.lighten-5 {\n  color: white !important;\n}\n\n.bg-secondary.bg-lighten-5 {\n  background-color: white !important;\n}\n\n.btn-secondary.btn-lighten-5 {\n  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;\n  background-color: white !important;\n}\n.btn-secondary.btn-lighten-5:hover {\n  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;\n  background-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;\n}\n.btn-secondary.btn-lighten-5:focus, .btn-secondary.btn-lighten-5:active {\n  border-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;\n  background-color: rgb(124.6393442623, 143, 161.3606557377) !important;\n}\n\n.btn-outline-secondary.btn-outline-lighten-5 {\n  border-color: white !important;\n  color: white !important;\n}\n.btn-outline-secondary.btn-outline-lighten-5:hover {\n  background-color: white !important;\n}\n\ninput:focus ~ .bg-secondary {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem white !important;\n}\n\n.border-secondary.border-lighten-5 {\n  border: 1px solid white !important;\n}\n\n.border-top-secondary.border-top-lighten-5 {\n  border-top: 1px solid white !important;\n}\n\n.border-bottom-secondary.border-bottom-lighten-5 {\n  border-bottom: 1px solid white !important;\n}\n\n.border-left-secondary.border-left-lighten-5 {\n  border-left: 1px solid white !important;\n}\n\n.border-right-secondary.border-right-lighten-5 {\n  border-right: 1px solid white !important;\n}\n\n.overlay-secondary.overlay-lighten-5 {\n  background: white; /* The Fallback */\n  background: rgba(255, 255, 255, 0.6);\n}\n\n.secondary.lighten-4 {\n  color: rgb(243.3606557377, 245, 246.6393442623) !important;\n}\n\n.bg-secondary.bg-lighten-4 {\n  background-color: rgb(243.3606557377, 245, 246.6393442623) !important;\n}\n\n.btn-secondary.btn-lighten-4 {\n  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;\n  background-color: rgb(243.3606557377, 245, 246.6393442623) !important;\n}\n.btn-secondary.btn-lighten-4:hover {\n  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;\n  background-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;\n}\n.btn-secondary.btn-lighten-4:focus, .btn-secondary.btn-lighten-4:active {\n  border-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;\n  background-color: rgb(124.6393442623, 143, 161.3606557377) !important;\n}\n\n.btn-outline-secondary.btn-outline-lighten-4 {\n  border-color: rgb(243.3606557377, 245, 246.6393442623) !important;\n  color: rgb(243.3606557377, 245, 246.6393442623) !important;\n}\n.btn-outline-secondary.btn-outline-lighten-4:hover {\n  background-color: rgb(243.3606557377, 245, 246.6393442623) !important;\n}\n\ninput:focus ~ .bg-secondary {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(243.3606557377, 245, 246.6393442623) !important;\n}\n\n.border-secondary.border-lighten-4 {\n  border: 1px solid rgb(243.3606557377, 245, 246.6393442623) !important;\n}\n\n.border-top-secondary.border-top-lighten-4 {\n  border-top: 1px solid rgb(243.3606557377, 245, 246.6393442623) !important;\n}\n\n.border-bottom-secondary.border-bottom-lighten-4 {\n  border-bottom: 1px solid rgb(243.3606557377, 245, 246.6393442623) !important;\n}\n\n.border-left-secondary.border-left-lighten-4 {\n  border-left: 1px solid rgb(243.3606557377, 245, 246.6393442623) !important;\n}\n\n.border-right-secondary.border-right-lighten-4 {\n  border-right: 1px solid rgb(243.3606557377, 245, 246.6393442623) !important;\n}\n\n.overlay-secondary.overlay-lighten-4 {\n  background: rgb(243.3606557377, 245, 246.6393442623); /* The Fallback */\n  background: rgba(243.3606557377, 245, 246.6393442623, 0.6);\n}\n\n.secondary.lighten-3 {\n  color: rgb(228.5204918033, 232.25, 235.9795081967) !important;\n}\n\n.bg-secondary.bg-lighten-3 {\n  background-color: rgb(228.5204918033, 232.25, 235.9795081967) !important;\n}\n\n.btn-secondary.btn-lighten-3 {\n  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;\n  background-color: rgb(228.5204918033, 232.25, 235.9795081967) !important;\n}\n.btn-secondary.btn-lighten-3:hover {\n  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;\n  background-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;\n}\n.btn-secondary.btn-lighten-3:focus, .btn-secondary.btn-lighten-3:active {\n  border-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;\n  background-color: rgb(124.6393442623, 143, 161.3606557377) !important;\n}\n\n.btn-outline-secondary.btn-outline-lighten-3 {\n  border-color: rgb(228.5204918033, 232.25, 235.9795081967) !important;\n  color: rgb(228.5204918033, 232.25, 235.9795081967) !important;\n}\n.btn-outline-secondary.btn-outline-lighten-3:hover {\n  background-color: rgb(228.5204918033, 232.25, 235.9795081967) !important;\n}\n\ninput:focus ~ .bg-secondary {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(228.5204918033, 232.25, 235.9795081967) !important;\n}\n\n.border-secondary.border-lighten-3 {\n  border: 1px solid rgb(228.5204918033, 232.25, 235.9795081967) !important;\n}\n\n.border-top-secondary.border-top-lighten-3 {\n  border-top: 1px solid rgb(228.5204918033, 232.25, 235.9795081967) !important;\n}\n\n.border-bottom-secondary.border-bottom-lighten-3 {\n  border-bottom: 1px solid rgb(228.5204918033, 232.25, 235.9795081967) !important;\n}\n\n.border-left-secondary.border-left-lighten-3 {\n  border-left: 1px solid rgb(228.5204918033, 232.25, 235.9795081967) !important;\n}\n\n.border-right-secondary.border-right-lighten-3 {\n  border-right: 1px solid rgb(228.5204918033, 232.25, 235.9795081967) !important;\n}\n\n.overlay-secondary.overlay-lighten-3 {\n  background: rgb(228.5204918033, 232.25, 235.9795081967); /* The Fallback */\n  background: rgba(228.5204918033, 232.25, 235.9795081967, 0.6);\n}\n\n.secondary.lighten-2 {\n  color: rgb(213.6803278689, 219.5, 225.3196721311) !important;\n}\n\n.bg-secondary.bg-lighten-2 {\n  background-color: rgb(213.6803278689, 219.5, 225.3196721311) !important;\n}\n\n.btn-secondary.btn-lighten-2 {\n  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;\n  background-color: rgb(213.6803278689, 219.5, 225.3196721311) !important;\n}\n.btn-secondary.btn-lighten-2:hover {\n  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;\n  background-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;\n}\n.btn-secondary.btn-lighten-2:focus, .btn-secondary.btn-lighten-2:active {\n  border-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;\n  background-color: rgb(124.6393442623, 143, 161.3606557377) !important;\n}\n\n.btn-outline-secondary.btn-outline-lighten-2 {\n  border-color: rgb(213.6803278689, 219.5, 225.3196721311) !important;\n  color: rgb(213.6803278689, 219.5, 225.3196721311) !important;\n}\n.btn-outline-secondary.btn-outline-lighten-2:hover {\n  background-color: rgb(213.6803278689, 219.5, 225.3196721311) !important;\n}\n\ninput:focus ~ .bg-secondary {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(213.6803278689, 219.5, 225.3196721311) !important;\n}\n\n.border-secondary.border-lighten-2 {\n  border: 1px solid rgb(213.6803278689, 219.5, 225.3196721311) !important;\n}\n\n.border-top-secondary.border-top-lighten-2 {\n  border-top: 1px solid rgb(213.6803278689, 219.5, 225.3196721311) !important;\n}\n\n.border-bottom-secondary.border-bottom-lighten-2 {\n  border-bottom: 1px solid rgb(213.6803278689, 219.5, 225.3196721311) !important;\n}\n\n.border-left-secondary.border-left-lighten-2 {\n  border-left: 1px solid rgb(213.6803278689, 219.5, 225.3196721311) !important;\n}\n\n.border-right-secondary.border-right-lighten-2 {\n  border-right: 1px solid rgb(213.6803278689, 219.5, 225.3196721311) !important;\n}\n\n.overlay-secondary.overlay-lighten-2 {\n  background: rgb(213.6803278689, 219.5, 225.3196721311); /* The Fallback */\n  background: rgba(213.6803278689, 219.5, 225.3196721311, 0.6);\n}\n\n.secondary.lighten-1 {\n  color: rgb(198.8401639344, 206.75, 214.6598360656) !important;\n}\n\n.bg-secondary.bg-lighten-1 {\n  background-color: rgb(198.8401639344, 206.75, 214.6598360656) !important;\n}\n\n.btn-secondary.btn-lighten-1 {\n  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;\n  background-color: rgb(198.8401639344, 206.75, 214.6598360656) !important;\n}\n.btn-secondary.btn-lighten-1:hover {\n  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;\n  background-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;\n}\n.btn-secondary.btn-lighten-1:focus, .btn-secondary.btn-lighten-1:active {\n  border-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;\n  background-color: rgb(124.6393442623, 143, 161.3606557377) !important;\n}\n\n.btn-outline-secondary.btn-outline-lighten-1 {\n  border-color: rgb(198.8401639344, 206.75, 214.6598360656) !important;\n  color: rgb(198.8401639344, 206.75, 214.6598360656) !important;\n}\n.btn-outline-secondary.btn-outline-lighten-1:hover {\n  background-color: rgb(198.8401639344, 206.75, 214.6598360656) !important;\n}\n\ninput:focus ~ .bg-secondary {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(198.8401639344, 206.75, 214.6598360656) !important;\n}\n\n.border-secondary.border-lighten-1 {\n  border: 1px solid rgb(198.8401639344, 206.75, 214.6598360656) !important;\n}\n\n.border-top-secondary.border-top-lighten-1 {\n  border-top: 1px solid rgb(198.8401639344, 206.75, 214.6598360656) !important;\n}\n\n.border-bottom-secondary.border-bottom-lighten-1 {\n  border-bottom: 1px solid rgb(198.8401639344, 206.75, 214.6598360656) !important;\n}\n\n.border-left-secondary.border-left-lighten-1 {\n  border-left: 1px solid rgb(198.8401639344, 206.75, 214.6598360656) !important;\n}\n\n.border-right-secondary.border-right-lighten-1 {\n  border-right: 1px solid rgb(198.8401639344, 206.75, 214.6598360656) !important;\n}\n\n.overlay-secondary.overlay-lighten-1 {\n  background: rgb(198.8401639344, 206.75, 214.6598360656); /* The Fallback */\n  background: rgba(198.8401639344, 206.75, 214.6598360656, 0.6);\n}\n\n.secondary {\n  color: #b8c2cc !important;\n}\n\n.bg-secondary {\n  background-color: #b8c2cc !important;\n}\n.bg-secondary .card-header,\n.bg-secondary .card-footer {\n  background-color: transparent;\n}\n\n.alert-secondary {\n  background: rgba(184, 194, 204, 0.2) !important;\n  color: #b8c2cc !important;\n}\n.alert-secondary .alert-heading {\n  box-shadow: rgba(184, 194, 204, 0.4) 0px 6px 15px -7px;\n}\n.alert-secondary .alert-link {\n  color: rgb(169.1598360656, 181.25, 193.3401639344) !important;\n}\n\n.bg-rgba-secondary {\n  background: rgba(184, 194, 204, 0.15) !important;\n}\n\n.border-secondary {\n  border: 1px solid #b8c2cc !important;\n}\n\n.border-top-secondary {\n  border-top: 1px solid #b8c2cc;\n}\n\n.border-bottom-secondary {\n  border-bottom: 1px solid #b8c2cc;\n}\n\n.border-left-secondary {\n  border-left: 1px solid #b8c2cc;\n}\n\n.border-right-secondary {\n  border-right: 1px solid #b8c2cc;\n}\n\n.badge.badge-light-secondary {\n  background-color: white;\n  color: #b8c2cc !important;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.bg-secondary.badge-glow,\n.border-secondary.badge-glow,\n.badge-secondary.badge-glow {\n  box-shadow: 0px 0px 10px #b8c2cc;\n}\n\n.overlay-secondary {\n  background: #b8c2cc; /* The Fallback */\n  background: rgba(184, 194, 204, 0.6);\n}\n\n.btn-secondary {\n  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;\n  background-color: #b8c2cc !important;\n  color: #fff;\n}\n.btn-secondary:hover {\n  border-color: rgb(169.1598360656, 181.25, 193.3401639344) !important;\n  color: #fff !important;\n  box-shadow: 0 8px 25px -8px #b8c2cc;\n}\n.btn-secondary:focus, .btn-secondary:active {\n  color: #fff !important;\n}\n\n.btn-flat-secondary {\n  background-color: transparent;\n  color: #b8c2cc;\n}\n.btn-flat-secondary:hover {\n  color: #b8c2cc;\n  background-color: rgba(184, 194, 204, 0.1);\n}\n.btn-flat-secondary:active, .btn-flat-secondary:focus {\n  background-color: #b8c2cc;\n  color: #fff !important;\n}\n\n.btn-relief-secondary {\n  background-color: #b8c2cc;\n  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.2);\n  color: #fff;\n}\n.btn-relief-secondary:hover {\n  color: #fff;\n}\n.btn-relief-secondary:active, .btn-relief-secondary:focus {\n  outline: none;\n  transform: translateY(3px);\n}\n\n.btn-outline-secondary {\n  border: 1px solid #b8c2cc;\n  background-color: transparent;\n  color: #b8c2cc;\n}\n.btn-outline-secondary:hover {\n  background-color: rgba(184, 194, 204, 0.08);\n  color: #b8c2cc;\n}\n.btn-outline-secondary:active {\n  color: #fff !important;\n}\n\n.btn-secondary ~ .dropdown-menu .dropdown-item.active,\n.btn-outline-secondary ~ .dropdown-menu .dropdown-item.active,\n.btn-flat-secondary ~ .dropdown-menu .dropdown-item.active {\n  background-color: #b8c2cc;\n  color: #fff;\n}\n.btn-secondary ~ .dropdown-menu .dropdown-item.active:hover,\n.btn-outline-secondary ~ .dropdown-menu .dropdown-item.active:hover,\n.btn-flat-secondary ~ .dropdown-menu .dropdown-item.active:hover {\n  color: #fff;\n}\n.btn-secondary ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,\n.btn-outline-secondary ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,\n.btn-flat-secondary ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover {\n  color: #b8c2cc;\n}\n\n.bullet.bullet-secondary {\n  background-color: #b8c2cc;\n}\n.bullet.bullet-secondary.bullet-bordered {\n  background-color: transparent;\n  border: 2px solid #b8c2cc;\n}\n\n.pagination-secondary li.active a,\n.pagination-secondary li.active .page-link,\n.pagination-secondary .page-item.active a,\n.pagination-secondary .page-item.active .page-link {\n  background: #b8c2cc !important;\n  color: #fff;\n}\n.pagination-secondary li.active a:hover,\n.pagination-secondary li.active .page-link:hover,\n.pagination-secondary .page-item.active a:hover,\n.pagination-secondary .page-item.active .page-link:hover {\n  color: #fff !important;\n}\n.pagination-secondary li a:hover,\n.pagination-secondary li .page-link:hover,\n.pagination-secondary .page-item a:hover,\n.pagination-secondary .page-item .page-link:hover {\n  color: #b8c2cc !important;\n}\n.pagination-secondary li.prev-item .page-link:hover, .pagination-secondary li.next-item .page-link:hover,\n.pagination-secondary .page-item.prev-item .page-link:hover,\n.pagination-secondary .page-item.next-item .page-link:hover {\n  background: #b8c2cc;\n  color: #fff;\n}\n\n.nav-pill-secondary .nav-item .nav-link.active {\n  color: #fff;\n  background-color: #b8c2cc;\n}\n\n.chip-secondary {\n  background-color: #b8c2cc !important;\n}\n.chip-secondary .chip-body {\n  color: #fff !important;\n}\n\n.divider.divider-secondary .divider-text:before, .divider.divider-secondary .divider-text:after {\n  border-color: #b8c2cc !important;\n}\n\ninput[type=checkbox].bg-secondary + .custom-control-label:before, input[type=radio].bg-secondary + .custom-control-label:before {\n  background-color: #b8c2cc !important;\n}\n\ninput:focus ~ .bg-secondary {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #b8c2cc !important;\n}\n\n.vx-checkbox-secondary input:checked ~ .vx-checkbox {\n  border-color: #b8c2cc !important;\n}\n.vx-checkbox-secondary input:checked ~ .vx-checkbox .vx-checkbox--check {\n  background-color: #b8c2cc !important;\n}\n.vx-checkbox-secondary input:active:checked + .vx-checkbox .vx-checkbox--check {\n  background-color: #b8c2cc !important;\n}\n\n.vertical-layout .main-menu.theme-secondary .navbar-header .navbar-nav .brand-text {\n  color: #b8c2cc;\n}\n.vertical-layout .main-menu.theme-secondary .navigation .nav-item.active a {\n  background: linear-gradient(118deg, #b8c2cc, rgba(184, 194, 204, 0.7));\n  box-shadow: 0 0 10px 1px rgba(184, 194, 204, 0.7) !important;\n}\n.vertical-layout .main-menu.theme-secondary .navigation .nav-item .menu-content li.active {\n  background: linear-gradient(118deg, #b8c2cc, rgba(184, 194, 204, 0.7));\n  box-shadow: 0 0 10px 1px rgba(184, 194, 204, 0.7) !important;\n}\n\n.horizontal-layout.theme-secondary .header-navbar .brand-text {\n  color: #b8c2cc !important;\n}\n.horizontal-layout.theme-secondary .navbar-horizontal #main-menu-navigation .nav-item.active .nav-link {\n  background: linear-gradient(118deg, #b8c2cc, rgba(184, 194, 204, 0.7));\n  box-shadow: 0 0 10px 1px rgba(184, 194, 204, 0.7) !important;\n}\n\n.custom-switch-secondary .custom-control-input:checked ~ .custom-control-label::before {\n  background-color: #b8c2cc !important;\n  color: #fff;\n  transition: all 0.2s ease-out;\n}\n\n.color-radio.color-radio-secondary {\n  border: 1px solid transparent;\n}\n.color-radio.color-radio-secondary.selected {\n  border-color: #b8c2cc;\n}\n.color-radio.color-radio-secondary .radio-content {\n  background-color: #b8c2cc;\n}\n\n.vx-radio-secondary input:checked ~ .vx-radio .vx-radio--circle {\n  background: #b8c2cc !important;\n  box-shadow: 0 3px 12px 0 rgba(184, 194, 204, 0.4) !important;\n}\n\n.secondary.darken-1 {\n  color: rgb(169.1598360656, 181.25, 193.3401639344) !important;\n}\n\n.bg-secondary.bg-darken-1 {\n  background-color: rgb(169.1598360656, 181.25, 193.3401639344) !important;\n}\n\n.btn-secondary.btn-darken-1 {\n  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;\n  background-color: rgb(169.1598360656, 181.25, 193.3401639344) !important;\n}\n.btn-secondary.btn-darken-1:hover {\n  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;\n  background-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;\n}\n.btn-secondary.btn-darken-1:focus, .btn-secondary.btn-darken-1:active {\n  border-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;\n  background-color: rgb(124.6393442623, 143, 161.3606557377) !important;\n}\n\n.btn-outline-secondary.btn-outline-darken-1 {\n  border-color: rgb(169.1598360656, 181.25, 193.3401639344) !important;\n  color: rgb(169.1598360656, 181.25, 193.3401639344) !important;\n}\n.btn-outline-secondary.btn-outline-darken-1:hover {\n  background-color: rgb(169.1598360656, 181.25, 193.3401639344) !important;\n}\n\ninput:focus ~ .bg-secondary {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(169.1598360656, 181.25, 193.3401639344) !important;\n}\n\n.border-secondary.border-darken-1 {\n  border: 1px solid rgb(169.1598360656, 181.25, 193.3401639344) !important;\n}\n\n.border-top-secondary.border-top-darken-1 {\n  border-top: 1px solid rgb(169.1598360656, 181.25, 193.3401639344) !important;\n}\n\n.border-bottom-secondary.border-bottom-darken-1 {\n  border-bottom: 1px solid rgb(169.1598360656, 181.25, 193.3401639344) !important;\n}\n\n.border-left-secondary.border-left-darken-1 {\n  border-left: 1px solid rgb(169.1598360656, 181.25, 193.3401639344) !important;\n}\n\n.border-right-secondary.border-right-darken-1 {\n  border-right: 1px solid rgb(169.1598360656, 181.25, 193.3401639344) !important;\n}\n\n.overlay-secondary.overlay-darken-1 {\n  background: rgb(169.1598360656, 181.25, 193.3401639344); /* The Fallback */\n  background: rgba(169.1598360656, 181.25, 193.3401639344, 0.6);\n}\n\n.secondary.darken-2 {\n  color: rgb(154.3196721311, 168.5, 182.6803278689) !important;\n}\n\n.bg-secondary.bg-darken-2 {\n  background-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;\n}\n\n.btn-secondary.btn-darken-2 {\n  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;\n  background-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;\n}\n.btn-secondary.btn-darken-2:hover {\n  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;\n  background-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;\n}\n.btn-secondary.btn-darken-2:focus, .btn-secondary.btn-darken-2:active {\n  border-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;\n  background-color: rgb(124.6393442623, 143, 161.3606557377) !important;\n}\n\n.btn-outline-secondary.btn-outline-darken-2 {\n  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;\n  color: rgb(154.3196721311, 168.5, 182.6803278689) !important;\n}\n.btn-outline-secondary.btn-outline-darken-2:hover {\n  background-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;\n}\n\ninput:focus ~ .bg-secondary {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(154.3196721311, 168.5, 182.6803278689) !important;\n}\n\n.border-secondary.border-darken-2 {\n  border: 1px solid rgb(154.3196721311, 168.5, 182.6803278689) !important;\n}\n\n.border-top-secondary.border-top-darken-2 {\n  border-top: 1px solid rgb(154.3196721311, 168.5, 182.6803278689) !important;\n}\n\n.border-bottom-secondary.border-bottom-darken-2 {\n  border-bottom: 1px solid rgb(154.3196721311, 168.5, 182.6803278689) !important;\n}\n\n.border-left-secondary.border-left-darken-2 {\n  border-left: 1px solid rgb(154.3196721311, 168.5, 182.6803278689) !important;\n}\n\n.border-right-secondary.border-right-darken-2 {\n  border-right: 1px solid rgb(154.3196721311, 168.5, 182.6803278689) !important;\n}\n\n.overlay-secondary.overlay-darken-2 {\n  background: rgb(154.3196721311, 168.5, 182.6803278689); /* The Fallback */\n  background: rgba(154.3196721311, 168.5, 182.6803278689, 0.6);\n}\n\n.secondary.darken-3 {\n  color: rgb(139.4795081967, 155.75, 172.0204918033) !important;\n}\n\n.bg-secondary.bg-darken-3 {\n  background-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;\n}\n\n.btn-secondary.btn-darken-3 {\n  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;\n  background-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;\n}\n.btn-secondary.btn-darken-3:hover {\n  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;\n  background-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;\n}\n.btn-secondary.btn-darken-3:focus, .btn-secondary.btn-darken-3:active {\n  border-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;\n  background-color: rgb(124.6393442623, 143, 161.3606557377) !important;\n}\n\n.btn-outline-secondary.btn-outline-darken-3 {\n  border-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;\n  color: rgb(139.4795081967, 155.75, 172.0204918033) !important;\n}\n.btn-outline-secondary.btn-outline-darken-3:hover {\n  background-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;\n}\n\ninput:focus ~ .bg-secondary {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(139.4795081967, 155.75, 172.0204918033) !important;\n}\n\n.border-secondary.border-darken-3 {\n  border: 1px solid rgb(139.4795081967, 155.75, 172.0204918033) !important;\n}\n\n.border-top-secondary.border-top-darken-3 {\n  border-top: 1px solid rgb(139.4795081967, 155.75, 172.0204918033) !important;\n}\n\n.border-bottom-secondary.border-bottom-darken-3 {\n  border-bottom: 1px solid rgb(139.4795081967, 155.75, 172.0204918033) !important;\n}\n\n.border-left-secondary.border-left-darken-3 {\n  border-left: 1px solid rgb(139.4795081967, 155.75, 172.0204918033) !important;\n}\n\n.border-right-secondary.border-right-darken-3 {\n  border-right: 1px solid rgb(139.4795081967, 155.75, 172.0204918033) !important;\n}\n\n.overlay-secondary.overlay-darken-3 {\n  background: rgb(139.4795081967, 155.75, 172.0204918033); /* The Fallback */\n  background: rgba(139.4795081967, 155.75, 172.0204918033, 0.6);\n}\n\n.secondary.darken-4 {\n  color: rgb(124.6393442623, 143, 161.3606557377) !important;\n}\n\n.bg-secondary.bg-darken-4 {\n  background-color: rgb(124.6393442623, 143, 161.3606557377) !important;\n}\n\n.btn-secondary.btn-darken-4 {\n  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;\n  background-color: rgb(124.6393442623, 143, 161.3606557377) !important;\n}\n.btn-secondary.btn-darken-4:hover {\n  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;\n  background-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;\n}\n.btn-secondary.btn-darken-4:focus, .btn-secondary.btn-darken-4:active {\n  border-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;\n  background-color: rgb(124.6393442623, 143, 161.3606557377) !important;\n}\n\n.btn-outline-secondary.btn-outline-darken-4 {\n  border-color: rgb(124.6393442623, 143, 161.3606557377) !important;\n  color: rgb(124.6393442623, 143, 161.3606557377) !important;\n}\n.btn-outline-secondary.btn-outline-darken-4:hover {\n  background-color: rgb(124.6393442623, 143, 161.3606557377) !important;\n}\n\ninput:focus ~ .bg-secondary {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(124.6393442623, 143, 161.3606557377) !important;\n}\n\n.border-secondary.border-darken-4 {\n  border: 1px solid rgb(124.6393442623, 143, 161.3606557377) !important;\n}\n\n.border-top-secondary.border-top-darken-4 {\n  border-top: 1px solid rgb(124.6393442623, 143, 161.3606557377) !important;\n}\n\n.border-bottom-secondary.border-bottom-darken-4 {\n  border-bottom: 1px solid rgb(124.6393442623, 143, 161.3606557377) !important;\n}\n\n.border-left-secondary.border-left-darken-4 {\n  border-left: 1px solid rgb(124.6393442623, 143, 161.3606557377) !important;\n}\n\n.border-right-secondary.border-right-darken-4 {\n  border-right: 1px solid rgb(124.6393442623, 143, 161.3606557377) !important;\n}\n\n.overlay-secondary.overlay-darken-4 {\n  background: rgb(124.6393442623, 143, 161.3606557377); /* The Fallback */\n  background: rgba(124.6393442623, 143, 161.3606557377, 0.6);\n}\n\n.secondary.gradient-bg {\n  color: #640064 !important;\n}\n\n.bg-secondary.bg-gradient-bg {\n  background-color: #640064 !important;\n}\n\n.btn-secondary.btn-gradient-bg {\n  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;\n  background-color: #640064 !important;\n}\n.btn-secondary.btn-gradient-bg:hover {\n  border-color: rgb(154.3196721311, 168.5, 182.6803278689) !important;\n  background-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;\n}\n.btn-secondary.btn-gradient-bg:focus, .btn-secondary.btn-gradient-bg:active {\n  border-color: rgb(139.4795081967, 155.75, 172.0204918033) !important;\n  background-color: rgb(124.6393442623, 143, 161.3606557377) !important;\n}\n\n.btn-outline-secondary.btn-outline-gradient-bg {\n  border-color: #640064 !important;\n  color: #640064 !important;\n}\n.btn-outline-secondary.btn-outline-gradient-bg:hover {\n  background-color: #640064 !important;\n}\n\ninput:focus ~ .bg-secondary {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #640064 !important;\n}\n\n.border-secondary.border-gradient-bg {\n  border: 1px solid #640064 !important;\n}\n\n.border-top-secondary.border-top-gradient-bg {\n  border-top: 1px solid #640064 !important;\n}\n\n.border-bottom-secondary.border-bottom-gradient-bg {\n  border-bottom: 1px solid #640064 !important;\n}\n\n.border-left-secondary.border-left-gradient-bg {\n  border-left: 1px solid #640064 !important;\n}\n\n.border-right-secondary.border-right-gradient-bg {\n  border-right: 1px solid #640064 !important;\n}\n\n.overlay-secondary.overlay-gradient-bg {\n  background: #640064; /* The Fallback */\n  background: rgba(100, 0, 100, 0.6);\n}\n\n.success.gradient-light {\n  color: rgb(73.8812290858, 233.1017709142, 211.3216024566) !important;\n}\n\n.bg-success.bg-gradient-light {\n  background-color: rgb(73.8812290858, 233.1017709142, 211.3216024566) !important;\n}\n\n.btn-success.btn-gradient-light {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: rgb(73.8812290858, 233.1017709142, 211.3216024566) !important;\n}\n.btn-success.btn-gradient-light:hover {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n}\n.btn-success.btn-gradient-light:focus, .btn-success.btn-gradient-light:active {\n  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;\n}\n\n.btn-outline-success.btn-outline-gradient-light {\n  border-color: rgb(73.8812290858, 233.1017709142, 211.3216024566) !important;\n  color: rgb(73.8812290858, 233.1017709142, 211.3216024566) !important;\n}\n.btn-outline-success.btn-outline-gradient-light:hover {\n  background-color: rgb(73.8812290858, 233.1017709142, 211.3216024566) !important;\n}\n\ninput:focus ~ .bg-success {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(73.8812290858, 233.1017709142, 211.3216024566) !important;\n}\n\n.border-success.border-gradient-light {\n  border: 1px solid rgb(73.8812290858, 233.1017709142, 211.3216024566) !important;\n}\n\n.border-top-success.border-top-gradient-light {\n  border-top: 1px solid rgb(73.8812290858, 233.1017709142, 211.3216024566) !important;\n}\n\n.border-bottom-success.border-bottom-gradient-light {\n  border-bottom: 1px solid rgb(73.8812290858, 233.1017709142, 211.3216024566) !important;\n}\n\n.border-left-success.border-left-gradient-light {\n  border-left: 1px solid rgb(73.8812290858, 233.1017709142, 211.3216024566) !important;\n}\n\n.border-right-success.border-right-gradient-light {\n  border-right: 1px solid rgb(73.8812290858, 233.1017709142, 211.3216024566) !important;\n}\n\n.overlay-success.overlay-gradient-light {\n  background: rgb(73.8812290858, 233.1017709142, 211.3216024566); /* The Fallback */\n  background: rgba(73.8812290858, 233.1017709142, 211.3216024566, 0.6);\n}\n\n.success.light-badge {\n  color: rgb(199.2133891213, 243.7866108787, 219.1171548117) !important;\n}\n\n.bg-success.bg-light-badge {\n  background-color: rgb(199.2133891213, 243.7866108787, 219.1171548117) !important;\n}\n\n.btn-success.btn-light-badge {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: rgb(199.2133891213, 243.7866108787, 219.1171548117) !important;\n}\n.btn-success.btn-light-badge:hover {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n}\n.btn-success.btn-light-badge:focus, .btn-success.btn-light-badge:active {\n  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;\n}\n\n.btn-outline-success.btn-outline-light-badge {\n  border-color: rgb(199.2133891213, 243.7866108787, 219.1171548117) !important;\n  color: rgb(199.2133891213, 243.7866108787, 219.1171548117) !important;\n}\n.btn-outline-success.btn-outline-light-badge:hover {\n  background-color: rgb(199.2133891213, 243.7866108787, 219.1171548117) !important;\n}\n\ninput:focus ~ .bg-success {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(199.2133891213, 243.7866108787, 219.1171548117) !important;\n}\n\n.border-success.border-light-badge {\n  border: 1px solid rgb(199.2133891213, 243.7866108787, 219.1171548117) !important;\n}\n\n.border-top-success.border-top-light-badge {\n  border-top: 1px solid rgb(199.2133891213, 243.7866108787, 219.1171548117) !important;\n}\n\n.border-bottom-success.border-bottom-light-badge {\n  border-bottom: 1px solid rgb(199.2133891213, 243.7866108787, 219.1171548117) !important;\n}\n\n.border-left-success.border-left-light-badge {\n  border-left: 1px solid rgb(199.2133891213, 243.7866108787, 219.1171548117) !important;\n}\n\n.border-right-success.border-right-light-badge {\n  border-right: 1px solid rgb(199.2133891213, 243.7866108787, 219.1171548117) !important;\n}\n\n.overlay-success.overlay-light-badge {\n  background: rgb(199.2133891213, 243.7866108787, 219.1171548117); /* The Fallback */\n  background: rgba(199.2133891213, 243.7866108787, 219.1171548117, 0.6);\n}\n\n.success.lighten-5 {\n  color: rgb(135.5167364017, 230.9832635983, 178.1464435146) !important;\n}\n\n.bg-success.bg-lighten-5 {\n  background-color: rgb(135.5167364017, 230.9832635983, 178.1464435146) !important;\n}\n\n.btn-success.btn-lighten-5 {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: rgb(135.5167364017, 230.9832635983, 178.1464435146) !important;\n}\n.btn-success.btn-lighten-5:hover {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n}\n.btn-success.btn-lighten-5:focus, .btn-success.btn-lighten-5:active {\n  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;\n}\n\n.btn-outline-success.btn-outline-lighten-5 {\n  border-color: rgb(135.5167364017, 230.9832635983, 178.1464435146) !important;\n  color: rgb(135.5167364017, 230.9832635983, 178.1464435146) !important;\n}\n.btn-outline-success.btn-outline-lighten-5:hover {\n  background-color: rgb(135.5167364017, 230.9832635983, 178.1464435146) !important;\n}\n\ninput:focus ~ .bg-success {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(135.5167364017, 230.9832635983, 178.1464435146) !important;\n}\n\n.border-success.border-lighten-5 {\n  border: 1px solid rgb(135.5167364017, 230.9832635983, 178.1464435146) !important;\n}\n\n.border-top-success.border-top-lighten-5 {\n  border-top: 1px solid rgb(135.5167364017, 230.9832635983, 178.1464435146) !important;\n}\n\n.border-bottom-success.border-bottom-lighten-5 {\n  border-bottom: 1px solid rgb(135.5167364017, 230.9832635983, 178.1464435146) !important;\n}\n\n.border-left-success.border-left-lighten-5 {\n  border-left: 1px solid rgb(135.5167364017, 230.9832635983, 178.1464435146) !important;\n}\n\n.border-right-success.border-right-lighten-5 {\n  border-right: 1px solid rgb(135.5167364017, 230.9832635983, 178.1464435146) !important;\n}\n\n.overlay-success.overlay-lighten-5 {\n  background: rgb(135.5167364017, 230.9832635983, 178.1464435146); /* The Fallback */\n  background: rgba(135.5167364017, 230.9832635983, 178.1464435146, 0.6);\n}\n\n.success.lighten-4 {\n  color: rgb(114.2845188285, 226.7154811715, 164.489539749) !important;\n}\n\n.bg-success.bg-lighten-4 {\n  background-color: rgb(114.2845188285, 226.7154811715, 164.489539749) !important;\n}\n\n.btn-success.btn-lighten-4 {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: rgb(114.2845188285, 226.7154811715, 164.489539749) !important;\n}\n.btn-success.btn-lighten-4:hover {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n}\n.btn-success.btn-lighten-4:focus, .btn-success.btn-lighten-4:active {\n  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;\n}\n\n.btn-outline-success.btn-outline-lighten-4 {\n  border-color: rgb(114.2845188285, 226.7154811715, 164.489539749) !important;\n  color: rgb(114.2845188285, 226.7154811715, 164.489539749) !important;\n}\n.btn-outline-success.btn-outline-lighten-4:hover {\n  background-color: rgb(114.2845188285, 226.7154811715, 164.489539749) !important;\n}\n\ninput:focus ~ .bg-success {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(114.2845188285, 226.7154811715, 164.489539749) !important;\n}\n\n.border-success.border-lighten-4 {\n  border: 1px solid rgb(114.2845188285, 226.7154811715, 164.489539749) !important;\n}\n\n.border-top-success.border-top-lighten-4 {\n  border-top: 1px solid rgb(114.2845188285, 226.7154811715, 164.489539749) !important;\n}\n\n.border-bottom-success.border-bottom-lighten-4 {\n  border-bottom: 1px solid rgb(114.2845188285, 226.7154811715, 164.489539749) !important;\n}\n\n.border-left-success.border-left-lighten-4 {\n  border-left: 1px solid rgb(114.2845188285, 226.7154811715, 164.489539749) !important;\n}\n\n.border-right-success.border-right-lighten-4 {\n  border-right: 1px solid rgb(114.2845188285, 226.7154811715, 164.489539749) !important;\n}\n\n.overlay-success.overlay-lighten-4 {\n  background: rgb(114.2845188285, 226.7154811715, 164.489539749); /* The Fallback */\n  background: rgba(114.2845188285, 226.7154811715, 164.489539749, 0.6);\n}\n\n.success.lighten-3 {\n  color: rgb(93.0523012552, 222.4476987448, 150.8326359833) !important;\n}\n\n.bg-success.bg-lighten-3 {\n  background-color: rgb(93.0523012552, 222.4476987448, 150.8326359833) !important;\n}\n\n.btn-success.btn-lighten-3 {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: rgb(93.0523012552, 222.4476987448, 150.8326359833) !important;\n}\n.btn-success.btn-lighten-3:hover {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n}\n.btn-success.btn-lighten-3:focus, .btn-success.btn-lighten-3:active {\n  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;\n}\n\n.btn-outline-success.btn-outline-lighten-3 {\n  border-color: rgb(93.0523012552, 222.4476987448, 150.8326359833) !important;\n  color: rgb(93.0523012552, 222.4476987448, 150.8326359833) !important;\n}\n.btn-outline-success.btn-outline-lighten-3:hover {\n  background-color: rgb(93.0523012552, 222.4476987448, 150.8326359833) !important;\n}\n\ninput:focus ~ .bg-success {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(93.0523012552, 222.4476987448, 150.8326359833) !important;\n}\n\n.border-success.border-lighten-3 {\n  border: 1px solid rgb(93.0523012552, 222.4476987448, 150.8326359833) !important;\n}\n\n.border-top-success.border-top-lighten-3 {\n  border-top: 1px solid rgb(93.0523012552, 222.4476987448, 150.8326359833) !important;\n}\n\n.border-bottom-success.border-bottom-lighten-3 {\n  border-bottom: 1px solid rgb(93.0523012552, 222.4476987448, 150.8326359833) !important;\n}\n\n.border-left-success.border-left-lighten-3 {\n  border-left: 1px solid rgb(93.0523012552, 222.4476987448, 150.8326359833) !important;\n}\n\n.border-right-success.border-right-lighten-3 {\n  border-right: 1px solid rgb(93.0523012552, 222.4476987448, 150.8326359833) !important;\n}\n\n.overlay-success.overlay-lighten-3 {\n  background: rgb(93.0523012552, 222.4476987448, 150.8326359833); /* The Fallback */\n  background: rgba(93.0523012552, 222.4476987448, 150.8326359833, 0.6);\n}\n\n.success.lighten-2 {\n  color: rgb(71.820083682, 218.179916318, 137.1757322176) !important;\n}\n\n.bg-success.bg-lighten-2 {\n  background-color: rgb(71.820083682, 218.179916318, 137.1757322176) !important;\n}\n\n.btn-success.btn-lighten-2 {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: rgb(71.820083682, 218.179916318, 137.1757322176) !important;\n}\n.btn-success.btn-lighten-2:hover {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n}\n.btn-success.btn-lighten-2:focus, .btn-success.btn-lighten-2:active {\n  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;\n}\n\n.btn-outline-success.btn-outline-lighten-2 {\n  border-color: rgb(71.820083682, 218.179916318, 137.1757322176) !important;\n  color: rgb(71.820083682, 218.179916318, 137.1757322176) !important;\n}\n.btn-outline-success.btn-outline-lighten-2:hover {\n  background-color: rgb(71.820083682, 218.179916318, 137.1757322176) !important;\n}\n\ninput:focus ~ .bg-success {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(71.820083682, 218.179916318, 137.1757322176) !important;\n}\n\n.border-success.border-lighten-2 {\n  border: 1px solid rgb(71.820083682, 218.179916318, 137.1757322176) !important;\n}\n\n.border-top-success.border-top-lighten-2 {\n  border-top: 1px solid rgb(71.820083682, 218.179916318, 137.1757322176) !important;\n}\n\n.border-bottom-success.border-bottom-lighten-2 {\n  border-bottom: 1px solid rgb(71.820083682, 218.179916318, 137.1757322176) !important;\n}\n\n.border-left-success.border-left-lighten-2 {\n  border-left: 1px solid rgb(71.820083682, 218.179916318, 137.1757322176) !important;\n}\n\n.border-right-success.border-right-lighten-2 {\n  border-right: 1px solid rgb(71.820083682, 218.179916318, 137.1757322176) !important;\n}\n\n.overlay-success.overlay-lighten-2 {\n  background: rgb(71.820083682, 218.179916318, 137.1757322176); /* The Fallback */\n  background: rgba(71.820083682, 218.179916318, 137.1757322176, 0.6);\n}\n\n.success.lighten-1 {\n  color: rgb(50.5878661088, 213.9121338912, 123.5188284519) !important;\n}\n\n.bg-success.bg-lighten-1 {\n  background-color: rgb(50.5878661088, 213.9121338912, 123.5188284519) !important;\n}\n\n.btn-success.btn-lighten-1 {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: rgb(50.5878661088, 213.9121338912, 123.5188284519) !important;\n}\n.btn-success.btn-lighten-1:hover {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n}\n.btn-success.btn-lighten-1:focus, .btn-success.btn-lighten-1:active {\n  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;\n}\n\n.btn-outline-success.btn-outline-lighten-1 {\n  border-color: rgb(50.5878661088, 213.9121338912, 123.5188284519) !important;\n  color: rgb(50.5878661088, 213.9121338912, 123.5188284519) !important;\n}\n.btn-outline-success.btn-outline-lighten-1:hover {\n  background-color: rgb(50.5878661088, 213.9121338912, 123.5188284519) !important;\n}\n\ninput:focus ~ .bg-success {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(50.5878661088, 213.9121338912, 123.5188284519) !important;\n}\n\n.border-success.border-lighten-1 {\n  border: 1px solid rgb(50.5878661088, 213.9121338912, 123.5188284519) !important;\n}\n\n.border-top-success.border-top-lighten-1 {\n  border-top: 1px solid rgb(50.5878661088, 213.9121338912, 123.5188284519) !important;\n}\n\n.border-bottom-success.border-bottom-lighten-1 {\n  border-bottom: 1px solid rgb(50.5878661088, 213.9121338912, 123.5188284519) !important;\n}\n\n.border-left-success.border-left-lighten-1 {\n  border-left: 1px solid rgb(50.5878661088, 213.9121338912, 123.5188284519) !important;\n}\n\n.border-right-success.border-right-lighten-1 {\n  border-right: 1px solid rgb(50.5878661088, 213.9121338912, 123.5188284519) !important;\n}\n\n.overlay-success.overlay-lighten-1 {\n  background: rgb(50.5878661088, 213.9121338912, 123.5188284519); /* The Fallback */\n  background: rgba(50.5878661088, 213.9121338912, 123.5188284519, 0.6);\n}\n\n.success {\n  color: #28c76f !important;\n}\n\n.bg-success {\n  background-color: #28c76f !important;\n}\n.bg-success .card-header,\n.bg-success .card-footer {\n  background-color: transparent;\n}\n\n.alert-success {\n  background: rgba(40, 199, 111, 0.2) !important;\n  color: #28c76f !important;\n}\n.alert-success .alert-heading {\n  box-shadow: rgba(40, 199, 111, 0.4) 0px 6px 15px -7px;\n}\n.alert-success .alert-link {\n  color: rgb(35.7322175732, 177.7677824268, 99.1569037657) !important;\n}\n\n.bg-rgba-success {\n  background: rgba(40, 199, 111, 0.15) !important;\n}\n\n.border-success {\n  border: 1px solid #28c76f !important;\n}\n\n.border-top-success {\n  border-top: 1px solid #28c76f;\n}\n\n.border-bottom-success {\n  border-bottom: 1px solid #28c76f;\n}\n\n.border-left-success {\n  border-left: 1px solid #28c76f;\n}\n\n.border-right-success {\n  border-right: 1px solid #28c76f;\n}\n\n.badge.badge-light-success {\n  background-color: rgb(199.2133891213, 243.7866108787, 219.1171548117);\n  color: #28c76f !important;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.bg-success.badge-glow,\n.border-success.badge-glow,\n.badge-success.badge-glow {\n  box-shadow: 0px 0px 10px #28c76f;\n}\n\n.overlay-success {\n  background: #28c76f; /* The Fallback */\n  background: rgba(40, 199, 111, 0.6);\n}\n\n.btn-success {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: #28c76f !important;\n  color: #fff;\n}\n.btn-success:hover {\n  border-color: rgb(35.7322175732, 177.7677824268, 99.1569037657) !important;\n  color: #fff !important;\n  box-shadow: 0 8px 25px -8px #28c76f;\n}\n.btn-success:focus, .btn-success:active {\n  color: #fff !important;\n}\n\n.btn-flat-success {\n  background-color: transparent;\n  color: #28c76f;\n}\n.btn-flat-success:hover {\n  color: #28c76f;\n  background-color: rgba(40, 199, 111, 0.1);\n}\n.btn-flat-success:active, .btn-flat-success:focus {\n  background-color: #28c76f;\n  color: #fff !important;\n}\n\n.btn-relief-success {\n  background-color: #28c76f;\n  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.2);\n  color: #fff;\n}\n.btn-relief-success:hover {\n  color: #fff;\n}\n.btn-relief-success:active, .btn-relief-success:focus {\n  outline: none;\n  transform: translateY(3px);\n}\n\n.btn-outline-success {\n  border: 1px solid #28c76f;\n  background-color: transparent;\n  color: #28c76f;\n}\n.btn-outline-success:hover {\n  background-color: rgba(40, 199, 111, 0.08);\n  color: #28c76f;\n}\n.btn-outline-success:active {\n  color: #fff !important;\n}\n\n.btn-success ~ .dropdown-menu .dropdown-item.active,\n.btn-outline-success ~ .dropdown-menu .dropdown-item.active,\n.btn-flat-success ~ .dropdown-menu .dropdown-item.active {\n  background-color: #28c76f;\n  color: #fff;\n}\n.btn-success ~ .dropdown-menu .dropdown-item.active:hover,\n.btn-outline-success ~ .dropdown-menu .dropdown-item.active:hover,\n.btn-flat-success ~ .dropdown-menu .dropdown-item.active:hover {\n  color: #fff;\n}\n.btn-success ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,\n.btn-outline-success ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,\n.btn-flat-success ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover {\n  color: #28c76f;\n}\n\n.bullet.bullet-success {\n  background-color: #28c76f;\n}\n.bullet.bullet-success.bullet-bordered {\n  background-color: transparent;\n  border: 2px solid #28c76f;\n}\n\n.pagination-success li.active a,\n.pagination-success li.active .page-link,\n.pagination-success .page-item.active a,\n.pagination-success .page-item.active .page-link {\n  background: #28c76f !important;\n  color: #fff;\n}\n.pagination-success li.active a:hover,\n.pagination-success li.active .page-link:hover,\n.pagination-success .page-item.active a:hover,\n.pagination-success .page-item.active .page-link:hover {\n  color: #fff !important;\n}\n.pagination-success li a:hover,\n.pagination-success li .page-link:hover,\n.pagination-success .page-item a:hover,\n.pagination-success .page-item .page-link:hover {\n  color: #28c76f !important;\n}\n.pagination-success li.prev-item .page-link:hover, .pagination-success li.next-item .page-link:hover,\n.pagination-success .page-item.prev-item .page-link:hover,\n.pagination-success .page-item.next-item .page-link:hover {\n  background: #28c76f;\n  color: #fff;\n}\n\n.nav-pill-success .nav-item .nav-link.active {\n  color: #fff;\n  background-color: #28c76f;\n}\n\n.chip-success {\n  background-color: #28c76f !important;\n}\n.chip-success .chip-body {\n  color: #fff !important;\n}\n\n.divider.divider-success .divider-text:before, .divider.divider-success .divider-text:after {\n  border-color: #28c76f !important;\n}\n\ninput[type=checkbox].bg-success + .custom-control-label:before, input[type=radio].bg-success + .custom-control-label:before {\n  background-color: #28c76f !important;\n}\n\ninput:focus ~ .bg-success {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #28c76f !important;\n}\n\n.vx-checkbox-success input:checked ~ .vx-checkbox {\n  border-color: #28c76f !important;\n}\n.vx-checkbox-success input:checked ~ .vx-checkbox .vx-checkbox--check {\n  background-color: #28c76f !important;\n}\n.vx-checkbox-success input:active:checked + .vx-checkbox .vx-checkbox--check {\n  background-color: #28c76f !important;\n}\n\n.vertical-layout .main-menu.theme-success .navbar-header .navbar-nav .brand-text {\n  color: #28c76f;\n}\n.vertical-layout .main-menu.theme-success .navigation .nav-item.active a {\n  background: linear-gradient(118deg, #28c76f, rgba(40, 199, 111, 0.7));\n  box-shadow: 0 0 10px 1px rgba(40, 199, 111, 0.7) !important;\n}\n.vertical-layout .main-menu.theme-success .navigation .nav-item .menu-content li.active {\n  background: linear-gradient(118deg, #28c76f, rgba(40, 199, 111, 0.7));\n  box-shadow: 0 0 10px 1px rgba(40, 199, 111, 0.7) !important;\n}\n\n.horizontal-layout.theme-success .header-navbar .brand-text {\n  color: #28c76f !important;\n}\n.horizontal-layout.theme-success .navbar-horizontal #main-menu-navigation .nav-item.active .nav-link {\n  background: linear-gradient(118deg, #28c76f, rgba(40, 199, 111, 0.7));\n  box-shadow: 0 0 10px 1px rgba(40, 199, 111, 0.7) !important;\n}\n\n.custom-switch-success .custom-control-input:checked ~ .custom-control-label::before {\n  background-color: #28c76f !important;\n  color: #fff;\n  transition: all 0.2s ease-out;\n}\n\n.color-radio.color-radio-success {\n  border: 1px solid transparent;\n}\n.color-radio.color-radio-success.selected {\n  border-color: #28c76f;\n}\n.color-radio.color-radio-success .radio-content {\n  background-color: #28c76f;\n}\n\n.vx-radio-success input:checked ~ .vx-radio .vx-radio--circle {\n  background: #28c76f !important;\n  box-shadow: 0 3px 12px 0 rgba(40, 199, 111, 0.4) !important;\n}\n\n.success.darken-1 {\n  color: rgb(35.7322175732, 177.7677824268, 99.1569037657) !important;\n}\n\n.bg-success.bg-darken-1 {\n  background-color: rgb(35.7322175732, 177.7677824268, 99.1569037657) !important;\n}\n\n.btn-success.btn-darken-1 {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: rgb(35.7322175732, 177.7677824268, 99.1569037657) !important;\n}\n.btn-success.btn-darken-1:hover {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n}\n.btn-success.btn-darken-1:focus, .btn-success.btn-darken-1:active {\n  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;\n}\n\n.btn-outline-success.btn-outline-darken-1 {\n  border-color: rgb(35.7322175732, 177.7677824268, 99.1569037657) !important;\n  color: rgb(35.7322175732, 177.7677824268, 99.1569037657) !important;\n}\n.btn-outline-success.btn-outline-darken-1:hover {\n  background-color: rgb(35.7322175732, 177.7677824268, 99.1569037657) !important;\n}\n\ninput:focus ~ .bg-success {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(35.7322175732, 177.7677824268, 99.1569037657) !important;\n}\n\n.border-success.border-darken-1 {\n  border: 1px solid rgb(35.7322175732, 177.7677824268, 99.1569037657) !important;\n}\n\n.border-top-success.border-top-darken-1 {\n  border-top: 1px solid rgb(35.7322175732, 177.7677824268, 99.1569037657) !important;\n}\n\n.border-bottom-success.border-bottom-darken-1 {\n  border-bottom: 1px solid rgb(35.7322175732, 177.7677824268, 99.1569037657) !important;\n}\n\n.border-left-success.border-left-darken-1 {\n  border-left: 1px solid rgb(35.7322175732, 177.7677824268, 99.1569037657) !important;\n}\n\n.border-right-success.border-right-darken-1 {\n  border-right: 1px solid rgb(35.7322175732, 177.7677824268, 99.1569037657) !important;\n}\n\n.overlay-success.overlay-darken-1 {\n  background: rgb(35.7322175732, 177.7677824268, 99.1569037657); /* The Fallback */\n  background: rgba(35.7322175732, 177.7677824268, 99.1569037657, 0.6);\n}\n\n.success.darken-2 {\n  color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n}\n\n.bg-success.bg-darken-2 {\n  background-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n}\n\n.btn-success.btn-darken-2 {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n}\n.btn-success.btn-darken-2:hover {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n}\n.btn-success.btn-darken-2:focus, .btn-success.btn-darken-2:active {\n  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;\n}\n\n.btn-outline-success.btn-outline-darken-2 {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n}\n.btn-outline-success.btn-outline-darken-2:hover {\n  background-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n}\n\ninput:focus ~ .bg-success {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n}\n\n.border-success.border-darken-2 {\n  border: 1px solid rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n}\n\n.border-top-success.border-top-darken-2 {\n  border-top: 1px solid rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n}\n\n.border-bottom-success.border-bottom-darken-2 {\n  border-bottom: 1px solid rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n}\n\n.border-left-success.border-left-darken-2 {\n  border-left: 1px solid rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n}\n\n.border-right-success.border-right-darken-2 {\n  border-right: 1px solid rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n}\n\n.overlay-success.overlay-darken-2 {\n  background: rgb(31.4644351464, 156.5355648536, 87.3138075314); /* The Fallback */\n  background: rgba(31.4644351464, 156.5355648536, 87.3138075314, 0.6);\n}\n\n.success.darken-3 {\n  color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n}\n\n.bg-success.bg-darken-3 {\n  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n}\n\n.btn-success.btn-darken-3 {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n}\n.btn-success.btn-darken-3:hover {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n}\n.btn-success.btn-darken-3:focus, .btn-success.btn-darken-3:active {\n  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;\n}\n\n.btn-outline-success.btn-outline-darken-3 {\n  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n  color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n}\n.btn-outline-success.btn-outline-darken-3:hover {\n  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n}\n\ninput:focus ~ .bg-success {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n}\n\n.border-success.border-darken-3 {\n  border: 1px solid rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n}\n\n.border-top-success.border-top-darken-3 {\n  border-top: 1px solid rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n}\n\n.border-bottom-success.border-bottom-darken-3 {\n  border-bottom: 1px solid rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n}\n\n.border-left-success.border-left-darken-3 {\n  border-left: 1px solid rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n}\n\n.border-right-success.border-right-darken-3 {\n  border-right: 1px solid rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n}\n\n.overlay-success.overlay-darken-3 {\n  background: rgb(27.1966527197, 135.3033472803, 75.4707112971); /* The Fallback */\n  background: rgba(27.1966527197, 135.3033472803, 75.4707112971, 0.6);\n}\n\n.success.darken-4 {\n  color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;\n}\n\n.bg-success.bg-darken-4 {\n  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;\n}\n\n.btn-success.btn-darken-4 {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;\n}\n.btn-success.btn-darken-4:hover {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n}\n.btn-success.btn-darken-4:focus, .btn-success.btn-darken-4:active {\n  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;\n}\n\n.btn-outline-success.btn-outline-darken-4 {\n  border-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;\n  color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;\n}\n.btn-outline-success.btn-outline-darken-4:hover {\n  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;\n}\n\ninput:focus ~ .bg-success {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;\n}\n\n.border-success.border-darken-4 {\n  border: 1px solid rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;\n}\n\n.border-top-success.border-top-darken-4 {\n  border-top: 1px solid rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;\n}\n\n.border-bottom-success.border-bottom-darken-4 {\n  border-bottom: 1px solid rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;\n}\n\n.border-left-success.border-left-darken-4 {\n  border-left: 1px solid rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;\n}\n\n.border-right-success.border-right-darken-4 {\n  border-right: 1px solid rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;\n}\n\n.overlay-success.overlay-darken-4 {\n  background: rgb(22.9288702929, 114.0711297071, 63.6276150628); /* The Fallback */\n  background: rgba(22.9288702929, 114.0711297071, 63.6276150628, 0.6);\n}\n\n.success.accent-1 {\n  color: #e1fff1 !important;\n}\n\n.bg-success.bg-accent-1 {\n  background-color: #e1fff1 !important;\n}\n\n.btn-success.btn-accent-1 {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: #e1fff1 !important;\n}\n.btn-success.btn-accent-1:hover {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n}\n.btn-success.btn-accent-1:focus, .btn-success.btn-accent-1:active {\n  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;\n}\n\n.btn-outline-success.btn-outline-accent-1 {\n  border-color: #e1fff1 !important;\n  color: #e1fff1 !important;\n}\n.btn-outline-success.btn-outline-accent-1:hover {\n  background-color: #e1fff1 !important;\n}\n\ninput:focus ~ .bg-success {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #e1fff1 !important;\n}\n\n.border-success.border-accent-1 {\n  border: 1px solid #e1fff1 !important;\n}\n\n.border-top-success.border-top-accent-1 {\n  border-top: 1px solid #e1fff1 !important;\n}\n\n.border-bottom-success.border-bottom-accent-1 {\n  border-bottom: 1px solid #e1fff1 !important;\n}\n\n.border-left-success.border-left-accent-1 {\n  border-left: 1px solid #e1fff1 !important;\n}\n\n.border-right-success.border-right-accent-1 {\n  border-right: 1px solid #e1fff1 !important;\n}\n\n.overlay-success.overlay-accent-1 {\n  background: #e1fff1; /* The Fallback */\n  background: rgba(225, 255, 241, 0.6);\n}\n\n.success.accent-2 {\n  color: #aeffd9 !important;\n}\n\n.bg-success.bg-accent-2 {\n  background-color: #aeffd9 !important;\n}\n\n.btn-success.btn-accent-2 {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: #aeffd9 !important;\n}\n.btn-success.btn-accent-2:hover {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n}\n.btn-success.btn-accent-2:focus, .btn-success.btn-accent-2:active {\n  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;\n}\n\n.btn-outline-success.btn-outline-accent-2 {\n  border-color: #aeffd9 !important;\n  color: #aeffd9 !important;\n}\n.btn-outline-success.btn-outline-accent-2:hover {\n  background-color: #aeffd9 !important;\n}\n\ninput:focus ~ .bg-success {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #aeffd9 !important;\n}\n\n.border-success.border-accent-2 {\n  border: 1px solid #aeffd9 !important;\n}\n\n.border-top-success.border-top-accent-2 {\n  border-top: 1px solid #aeffd9 !important;\n}\n\n.border-bottom-success.border-bottom-accent-2 {\n  border-bottom: 1px solid #aeffd9 !important;\n}\n\n.border-left-success.border-left-accent-2 {\n  border-left: 1px solid #aeffd9 !important;\n}\n\n.border-right-success.border-right-accent-2 {\n  border-right: 1px solid #aeffd9 !important;\n}\n\n.overlay-success.overlay-accent-2 {\n  background: #aeffd9; /* The Fallback */\n  background: rgba(174, 255, 217, 0.6);\n}\n\n.success.accent-3 {\n  color: #7bffc1 !important;\n}\n\n.bg-success.bg-accent-3 {\n  background-color: #7bffc1 !important;\n}\n\n.btn-success.btn-accent-3 {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: #7bffc1 !important;\n}\n.btn-success.btn-accent-3:hover {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n}\n.btn-success.btn-accent-3:focus, .btn-success.btn-accent-3:active {\n  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;\n}\n\n.btn-outline-success.btn-outline-accent-3 {\n  border-color: #7bffc1 !important;\n  color: #7bffc1 !important;\n}\n.btn-outline-success.btn-outline-accent-3:hover {\n  background-color: #7bffc1 !important;\n}\n\ninput:focus ~ .bg-success {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #7bffc1 !important;\n}\n\n.border-success.border-accent-3 {\n  border: 1px solid #7bffc1 !important;\n}\n\n.border-top-success.border-top-accent-3 {\n  border-top: 1px solid #7bffc1 !important;\n}\n\n.border-bottom-success.border-bottom-accent-3 {\n  border-bottom: 1px solid #7bffc1 !important;\n}\n\n.border-left-success.border-left-accent-3 {\n  border-left: 1px solid #7bffc1 !important;\n}\n\n.border-right-success.border-right-accent-3 {\n  border-right: 1px solid #7bffc1 !important;\n}\n\n.overlay-success.overlay-accent-3 {\n  background: #7bffc1; /* The Fallback */\n  background: rgba(123, 255, 193, 0.6);\n}\n\n.success.accent-4 {\n  color: #62ffb5 !important;\n}\n\n.bg-success.bg-accent-4 {\n  background-color: #62ffb5 !important;\n}\n\n.btn-success.btn-accent-4 {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: #62ffb5 !important;\n}\n.btn-success.btn-accent-4:hover {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n}\n.btn-success.btn-accent-4:focus, .btn-success.btn-accent-4:active {\n  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;\n}\n\n.btn-outline-success.btn-outline-accent-4 {\n  border-color: #62ffb5 !important;\n  color: #62ffb5 !important;\n}\n.btn-outline-success.btn-outline-accent-4:hover {\n  background-color: #62ffb5 !important;\n}\n\ninput:focus ~ .bg-success {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #62ffb5 !important;\n}\n\n.border-success.border-accent-4 {\n  border: 1px solid #62ffb5 !important;\n}\n\n.border-top-success.border-top-accent-4 {\n  border-top: 1px solid #62ffb5 !important;\n}\n\n.border-bottom-success.border-bottom-accent-4 {\n  border-bottom: 1px solid #62ffb5 !important;\n}\n\n.border-left-success.border-left-accent-4 {\n  border-left: 1px solid #62ffb5 !important;\n}\n\n.border-right-success.border-right-accent-4 {\n  border-right: 1px solid #62ffb5 !important;\n}\n\n.overlay-success.overlay-accent-4 {\n  background: #62ffb5; /* The Fallback */\n  background: rgba(98, 255, 181, 0.6);\n}\n\n.success.gradient-bg {\n  color: #0064fa !important;\n}\n\n.bg-success.bg-gradient-bg {\n  background-color: #0064fa !important;\n}\n\n.btn-success.btn-gradient-bg {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: #0064fa !important;\n}\n.btn-success.btn-gradient-bg:hover {\n  border-color: rgb(31.4644351464, 156.5355648536, 87.3138075314) !important;\n  background-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n}\n.btn-success.btn-gradient-bg:focus, .btn-success.btn-gradient-bg:active {\n  border-color: rgb(27.1966527197, 135.3033472803, 75.4707112971) !important;\n  background-color: rgb(22.9288702929, 114.0711297071, 63.6276150628) !important;\n}\n\n.btn-outline-success.btn-outline-gradient-bg {\n  border-color: #0064fa !important;\n  color: #0064fa !important;\n}\n.btn-outline-success.btn-outline-gradient-bg:hover {\n  background-color: #0064fa !important;\n}\n\ninput:focus ~ .bg-success {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #0064fa !important;\n}\n\n.border-success.border-gradient-bg {\n  border: 1px solid #0064fa !important;\n}\n\n.border-top-success.border-top-gradient-bg {\n  border-top: 1px solid #0064fa !important;\n}\n\n.border-bottom-success.border-bottom-gradient-bg {\n  border-bottom: 1px solid #0064fa !important;\n}\n\n.border-left-success.border-left-gradient-bg {\n  border-left: 1px solid #0064fa !important;\n}\n\n.border-right-success.border-right-gradient-bg {\n  border-right: 1px solid #0064fa !important;\n}\n\n.overlay-success.overlay-gradient-bg {\n  background: #0064fa; /* The Fallback */\n  background: rgba(0, 100, 250, 0.6);\n}\n\n.info.gradient-light {\n  color: rgb(44.983, 144.8617744253, 255) !important;\n}\n\n.bg-info.bg-gradient-light {\n  background-color: rgb(44.983, 144.8617744253, 255) !important;\n}\n\n.btn-info.btn-gradient-light {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: rgb(44.983, 144.8617744253, 255) !important;\n}\n.btn-info.btn-gradient-light:hover {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: rgb(0, 138.7435344828, 155.5) !important;\n}\n.btn-info.btn-gradient-light:focus, .btn-info.btn-gradient-light:active {\n  border-color: rgb(0, 138.7435344828, 155.5) !important;\n  background-color: rgb(0, 115.9913793103, 130) !important;\n}\n\n.btn-outline-info.btn-outline-gradient-light {\n  border-color: rgb(44.983, 144.8617744253, 255) !important;\n  color: rgb(44.983, 144.8617744253, 255) !important;\n}\n.btn-outline-info.btn-outline-gradient-light:hover {\n  background-color: rgb(44.983, 144.8617744253, 255) !important;\n}\n\ninput:focus ~ .bg-info {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(44.983, 144.8617744253, 255) !important;\n}\n\n.border-info.border-gradient-light {\n  border: 1px solid rgb(44.983, 144.8617744253, 255) !important;\n}\n\n.border-top-info.border-top-gradient-light {\n  border-top: 1px solid rgb(44.983, 144.8617744253, 255) !important;\n}\n\n.border-bottom-info.border-bottom-gradient-light {\n  border-bottom: 1px solid rgb(44.983, 144.8617744253, 255) !important;\n}\n\n.border-left-info.border-left-gradient-light {\n  border-left: 1px solid rgb(44.983, 144.8617744253, 255) !important;\n}\n\n.border-right-info.border-right-gradient-light {\n  border-right: 1px solid rgb(44.983, 144.8617744253, 255) !important;\n}\n\n.overlay-info.overlay-gradient-light {\n  background: rgb(44.983, 144.8617744253, 255); /* The Fallback */\n  background: rgba(44.983, 144.8617744253, 255, 0.6);\n}\n\n.info.light-badge {\n  color: rgb(181, 247.025862069, 255) !important;\n}\n\n.bg-info.bg-light-badge {\n  background-color: rgb(181, 247.025862069, 255) !important;\n}\n\n.btn-info.btn-light-badge {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: rgb(181, 247.025862069, 255) !important;\n}\n.btn-info.btn-light-badge:hover {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: rgb(0, 138.7435344828, 155.5) !important;\n}\n.btn-info.btn-light-badge:focus, .btn-info.btn-light-badge:active {\n  border-color: rgb(0, 138.7435344828, 155.5) !important;\n  background-color: rgb(0, 115.9913793103, 130) !important;\n}\n\n.btn-outline-info.btn-outline-light-badge {\n  border-color: rgb(181, 247.025862069, 255) !important;\n  color: rgb(181, 247.025862069, 255) !important;\n}\n.btn-outline-info.btn-outline-light-badge:hover {\n  background-color: rgb(181, 247.025862069, 255) !important;\n}\n\ninput:focus ~ .bg-info {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(181, 247.025862069, 255) !important;\n}\n\n.border-info.border-light-badge {\n  border: 1px solid rgb(181, 247.025862069, 255) !important;\n}\n\n.border-top-info.border-top-light-badge {\n  border-top: 1px solid rgb(181, 247.025862069, 255) !important;\n}\n\n.border-bottom-info.border-bottom-light-badge {\n  border-bottom: 1px solid rgb(181, 247.025862069, 255) !important;\n}\n\n.border-left-info.border-left-light-badge {\n  border-left: 1px solid rgb(181, 247.025862069, 255) !important;\n}\n\n.border-right-info.border-right-light-badge {\n  border-right: 1px solid rgb(181, 247.025862069, 255) !important;\n}\n\n.overlay-info.overlay-light-badge {\n  background: rgb(181, 247.025862069, 255); /* The Fallback */\n  background: rgba(181, 247.025862069, 255, 0.6);\n}\n\n.info.lighten-5 {\n  color: rgb(104.5, 238.7823275862, 255) !important;\n}\n\n.bg-info.bg-lighten-5 {\n  background-color: rgb(104.5, 238.7823275862, 255) !important;\n}\n\n.btn-info.btn-lighten-5 {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: rgb(104.5, 238.7823275862, 255) !important;\n}\n.btn-info.btn-lighten-5:hover {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: rgb(0, 138.7435344828, 155.5) !important;\n}\n.btn-info.btn-lighten-5:focus, .btn-info.btn-lighten-5:active {\n  border-color: rgb(0, 138.7435344828, 155.5) !important;\n  background-color: rgb(0, 115.9913793103, 130) !important;\n}\n\n.btn-outline-info.btn-outline-lighten-5 {\n  border-color: rgb(104.5, 238.7823275862, 255) !important;\n  color: rgb(104.5, 238.7823275862, 255) !important;\n}\n.btn-outline-info.btn-outline-lighten-5:hover {\n  background-color: rgb(104.5, 238.7823275862, 255) !important;\n}\n\ninput:focus ~ .bg-info {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(104.5, 238.7823275862, 255) !important;\n}\n\n.border-info.border-lighten-5 {\n  border: 1px solid rgb(104.5, 238.7823275862, 255) !important;\n}\n\n.border-top-info.border-top-lighten-5 {\n  border-top: 1px solid rgb(104.5, 238.7823275862, 255) !important;\n}\n\n.border-bottom-info.border-bottom-lighten-5 {\n  border-bottom: 1px solid rgb(104.5, 238.7823275862, 255) !important;\n}\n\n.border-left-info.border-left-lighten-5 {\n  border-left: 1px solid rgb(104.5, 238.7823275862, 255) !important;\n}\n\n.border-right-info.border-right-lighten-5 {\n  border-right: 1px solid rgb(104.5, 238.7823275862, 255) !important;\n}\n\n.overlay-info.overlay-lighten-5 {\n  background: rgb(104.5, 238.7823275862, 255); /* The Fallback */\n  background: rgba(104.5, 238.7823275862, 255, 0.6);\n}\n\n.info.lighten-4 {\n  color: rgb(79, 236.0344827586, 255) !important;\n}\n\n.bg-info.bg-lighten-4 {\n  background-color: rgb(79, 236.0344827586, 255) !important;\n}\n\n.btn-info.btn-lighten-4 {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: rgb(79, 236.0344827586, 255) !important;\n}\n.btn-info.btn-lighten-4:hover {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: rgb(0, 138.7435344828, 155.5) !important;\n}\n.btn-info.btn-lighten-4:focus, .btn-info.btn-lighten-4:active {\n  border-color: rgb(0, 138.7435344828, 155.5) !important;\n  background-color: rgb(0, 115.9913793103, 130) !important;\n}\n\n.btn-outline-info.btn-outline-lighten-4 {\n  border-color: rgb(79, 236.0344827586, 255) !important;\n  color: rgb(79, 236.0344827586, 255) !important;\n}\n.btn-outline-info.btn-outline-lighten-4:hover {\n  background-color: rgb(79, 236.0344827586, 255) !important;\n}\n\ninput:focus ~ .bg-info {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(79, 236.0344827586, 255) !important;\n}\n\n.border-info.border-lighten-4 {\n  border: 1px solid rgb(79, 236.0344827586, 255) !important;\n}\n\n.border-top-info.border-top-lighten-4 {\n  border-top: 1px solid rgb(79, 236.0344827586, 255) !important;\n}\n\n.border-bottom-info.border-bottom-lighten-4 {\n  border-bottom: 1px solid rgb(79, 236.0344827586, 255) !important;\n}\n\n.border-left-info.border-left-lighten-4 {\n  border-left: 1px solid rgb(79, 236.0344827586, 255) !important;\n}\n\n.border-right-info.border-right-lighten-4 {\n  border-right: 1px solid rgb(79, 236.0344827586, 255) !important;\n}\n\n.overlay-info.overlay-lighten-4 {\n  background: rgb(79, 236.0344827586, 255); /* The Fallback */\n  background: rgba(79, 236.0344827586, 255, 0.6);\n}\n\n.info.lighten-3 {\n  color: rgb(53.5, 233.286637931, 255) !important;\n}\n\n.bg-info.bg-lighten-3 {\n  background-color: rgb(53.5, 233.286637931, 255) !important;\n}\n\n.btn-info.btn-lighten-3 {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: rgb(53.5, 233.286637931, 255) !important;\n}\n.btn-info.btn-lighten-3:hover {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: rgb(0, 138.7435344828, 155.5) !important;\n}\n.btn-info.btn-lighten-3:focus, .btn-info.btn-lighten-3:active {\n  border-color: rgb(0, 138.7435344828, 155.5) !important;\n  background-color: rgb(0, 115.9913793103, 130) !important;\n}\n\n.btn-outline-info.btn-outline-lighten-3 {\n  border-color: rgb(53.5, 233.286637931, 255) !important;\n  color: rgb(53.5, 233.286637931, 255) !important;\n}\n.btn-outline-info.btn-outline-lighten-3:hover {\n  background-color: rgb(53.5, 233.286637931, 255) !important;\n}\n\ninput:focus ~ .bg-info {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(53.5, 233.286637931, 255) !important;\n}\n\n.border-info.border-lighten-3 {\n  border: 1px solid rgb(53.5, 233.286637931, 255) !important;\n}\n\n.border-top-info.border-top-lighten-3 {\n  border-top: 1px solid rgb(53.5, 233.286637931, 255) !important;\n}\n\n.border-bottom-info.border-bottom-lighten-3 {\n  border-bottom: 1px solid rgb(53.5, 233.286637931, 255) !important;\n}\n\n.border-left-info.border-left-lighten-3 {\n  border-left: 1px solid rgb(53.5, 233.286637931, 255) !important;\n}\n\n.border-right-info.border-right-lighten-3 {\n  border-right: 1px solid rgb(53.5, 233.286637931, 255) !important;\n}\n\n.overlay-info.overlay-lighten-3 {\n  background: rgb(53.5, 233.286637931, 255); /* The Fallback */\n  background: rgba(53.5, 233.286637931, 255, 0.6);\n}\n\n.info.lighten-2 {\n  color: rgb(28, 230.5387931034, 255) !important;\n}\n\n.bg-info.bg-lighten-2 {\n  background-color: rgb(28, 230.5387931034, 255) !important;\n}\n\n.btn-info.btn-lighten-2 {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: rgb(28, 230.5387931034, 255) !important;\n}\n.btn-info.btn-lighten-2:hover {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: rgb(0, 138.7435344828, 155.5) !important;\n}\n.btn-info.btn-lighten-2:focus, .btn-info.btn-lighten-2:active {\n  border-color: rgb(0, 138.7435344828, 155.5) !important;\n  background-color: rgb(0, 115.9913793103, 130) !important;\n}\n\n.btn-outline-info.btn-outline-lighten-2 {\n  border-color: rgb(28, 230.5387931034, 255) !important;\n  color: rgb(28, 230.5387931034, 255) !important;\n}\n.btn-outline-info.btn-outline-lighten-2:hover {\n  background-color: rgb(28, 230.5387931034, 255) !important;\n}\n\ninput:focus ~ .bg-info {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(28, 230.5387931034, 255) !important;\n}\n\n.border-info.border-lighten-2 {\n  border: 1px solid rgb(28, 230.5387931034, 255) !important;\n}\n\n.border-top-info.border-top-lighten-2 {\n  border-top: 1px solid rgb(28, 230.5387931034, 255) !important;\n}\n\n.border-bottom-info.border-bottom-lighten-2 {\n  border-bottom: 1px solid rgb(28, 230.5387931034, 255) !important;\n}\n\n.border-left-info.border-left-lighten-2 {\n  border-left: 1px solid rgb(28, 230.5387931034, 255) !important;\n}\n\n.border-right-info.border-right-lighten-2 {\n  border-right: 1px solid rgb(28, 230.5387931034, 255) !important;\n}\n\n.overlay-info.overlay-lighten-2 {\n  background: rgb(28, 230.5387931034, 255); /* The Fallback */\n  background: rgba(28, 230.5387931034, 255, 0.6);\n}\n\n.info.lighten-1 {\n  color: rgb(2.5, 227.7909482759, 255) !important;\n}\n\n.bg-info.bg-lighten-1 {\n  background-color: rgb(2.5, 227.7909482759, 255) !important;\n}\n\n.btn-info.btn-lighten-1 {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: rgb(2.5, 227.7909482759, 255) !important;\n}\n.btn-info.btn-lighten-1:hover {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: rgb(0, 138.7435344828, 155.5) !important;\n}\n.btn-info.btn-lighten-1:focus, .btn-info.btn-lighten-1:active {\n  border-color: rgb(0, 138.7435344828, 155.5) !important;\n  background-color: rgb(0, 115.9913793103, 130) !important;\n}\n\n.btn-outline-info.btn-outline-lighten-1 {\n  border-color: rgb(2.5, 227.7909482759, 255) !important;\n  color: rgb(2.5, 227.7909482759, 255) !important;\n}\n.btn-outline-info.btn-outline-lighten-1:hover {\n  background-color: rgb(2.5, 227.7909482759, 255) !important;\n}\n\ninput:focus ~ .bg-info {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(2.5, 227.7909482759, 255) !important;\n}\n\n.border-info.border-lighten-1 {\n  border: 1px solid rgb(2.5, 227.7909482759, 255) !important;\n}\n\n.border-top-info.border-top-lighten-1 {\n  border-top: 1px solid rgb(2.5, 227.7909482759, 255) !important;\n}\n\n.border-bottom-info.border-bottom-lighten-1 {\n  border-bottom: 1px solid rgb(2.5, 227.7909482759, 255) !important;\n}\n\n.border-left-info.border-left-lighten-1 {\n  border-left: 1px solid rgb(2.5, 227.7909482759, 255) !important;\n}\n\n.border-right-info.border-right-lighten-1 {\n  border-right: 1px solid rgb(2.5, 227.7909482759, 255) !important;\n}\n\n.overlay-info.overlay-lighten-1 {\n  background: rgb(2.5, 227.7909482759, 255); /* The Fallback */\n  background: rgba(2.5, 227.7909482759, 255, 0.6);\n}\n\n.info {\n  color: #00cfe8 !important;\n}\n\n.bg-info {\n  background-color: #00cfe8 !important;\n}\n.bg-info .card-header,\n.bg-info .card-footer {\n  background-color: transparent;\n}\n\n.alert-info {\n  background: rgba(0, 207, 232, 0.2) !important;\n  color: #00cfe8 !important;\n}\n.alert-info .alert-heading {\n  box-shadow: rgba(0, 207, 232, 0.4) 0px 6px 15px -7px;\n}\n.alert-info .alert-link {\n  color: rgb(0, 184.2478448276, 206.5) !important;\n}\n\n.bg-rgba-info {\n  background: rgba(0, 207, 232, 0.15) !important;\n}\n\n.border-info {\n  border: 1px solid #00cfe8 !important;\n}\n\n.border-top-info {\n  border-top: 1px solid #00cfe8;\n}\n\n.border-bottom-info {\n  border-bottom: 1px solid #00cfe8;\n}\n\n.border-left-info {\n  border-left: 1px solid #00cfe8;\n}\n\n.border-right-info {\n  border-right: 1px solid #00cfe8;\n}\n\n.badge.badge-light-info {\n  background-color: rgb(181, 247.025862069, 255);\n  color: #00cfe8 !important;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.bg-info.badge-glow,\n.border-info.badge-glow,\n.badge-info.badge-glow {\n  box-shadow: 0px 0px 10px #00cfe8;\n}\n\n.overlay-info {\n  background: #00cfe8; /* The Fallback */\n  background: rgba(0, 207, 232, 0.6);\n}\n\n.btn-info {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: #00cfe8 !important;\n  color: #fff;\n}\n.btn-info:hover {\n  border-color: rgb(0, 184.2478448276, 206.5) !important;\n  color: #fff !important;\n  box-shadow: 0 8px 25px -8px #00cfe8;\n}\n.btn-info:focus, .btn-info:active {\n  color: #fff !important;\n}\n\n.btn-flat-info {\n  background-color: transparent;\n  color: #00cfe8;\n}\n.btn-flat-info:hover {\n  color: #00cfe8;\n  background-color: rgba(0, 207, 232, 0.1);\n}\n.btn-flat-info:active, .btn-flat-info:focus {\n  background-color: #00cfe8;\n  color: #fff !important;\n}\n\n.btn-relief-info {\n  background-color: #00cfe8;\n  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.2);\n  color: #fff;\n}\n.btn-relief-info:hover {\n  color: #fff;\n}\n.btn-relief-info:active, .btn-relief-info:focus {\n  outline: none;\n  transform: translateY(3px);\n}\n\n.btn-outline-info {\n  border: 1px solid #00cfe8;\n  background-color: transparent;\n  color: #00cfe8;\n}\n.btn-outline-info:hover {\n  background-color: rgba(0, 207, 232, 0.08);\n  color: #00cfe8;\n}\n.btn-outline-info:active {\n  color: #fff !important;\n}\n\n.btn-info ~ .dropdown-menu .dropdown-item.active,\n.btn-outline-info ~ .dropdown-menu .dropdown-item.active,\n.btn-flat-info ~ .dropdown-menu .dropdown-item.active {\n  background-color: #00cfe8;\n  color: #fff;\n}\n.btn-info ~ .dropdown-menu .dropdown-item.active:hover,\n.btn-outline-info ~ .dropdown-menu .dropdown-item.active:hover,\n.btn-flat-info ~ .dropdown-menu .dropdown-item.active:hover {\n  color: #fff;\n}\n.btn-info ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,\n.btn-outline-info ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,\n.btn-flat-info ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover {\n  color: #00cfe8;\n}\n\n.bullet.bullet-info {\n  background-color: #00cfe8;\n}\n.bullet.bullet-info.bullet-bordered {\n  background-color: transparent;\n  border: 2px solid #00cfe8;\n}\n\n.pagination-info li.active a,\n.pagination-info li.active .page-link,\n.pagination-info .page-item.active a,\n.pagination-info .page-item.active .page-link {\n  background: #00cfe8 !important;\n  color: #fff;\n}\n.pagination-info li.active a:hover,\n.pagination-info li.active .page-link:hover,\n.pagination-info .page-item.active a:hover,\n.pagination-info .page-item.active .page-link:hover {\n  color: #fff !important;\n}\n.pagination-info li a:hover,\n.pagination-info li .page-link:hover,\n.pagination-info .page-item a:hover,\n.pagination-info .page-item .page-link:hover {\n  color: #00cfe8 !important;\n}\n.pagination-info li.prev-item .page-link:hover, .pagination-info li.next-item .page-link:hover,\n.pagination-info .page-item.prev-item .page-link:hover,\n.pagination-info .page-item.next-item .page-link:hover {\n  background: #00cfe8;\n  color: #fff;\n}\n\n.nav-pill-info .nav-item .nav-link.active {\n  color: #fff;\n  background-color: #00cfe8;\n}\n\n.chip-info {\n  background-color: #00cfe8 !important;\n}\n.chip-info .chip-body {\n  color: #fff !important;\n}\n\n.divider.divider-info .divider-text:before, .divider.divider-info .divider-text:after {\n  border-color: #00cfe8 !important;\n}\n\ninput[type=checkbox].bg-info + .custom-control-label:before, input[type=radio].bg-info + .custom-control-label:before {\n  background-color: #00cfe8 !important;\n}\n\ninput:focus ~ .bg-info {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #00cfe8 !important;\n}\n\n.vx-checkbox-info input:checked ~ .vx-checkbox {\n  border-color: #00cfe8 !important;\n}\n.vx-checkbox-info input:checked ~ .vx-checkbox .vx-checkbox--check {\n  background-color: #00cfe8 !important;\n}\n.vx-checkbox-info input:active:checked + .vx-checkbox .vx-checkbox--check {\n  background-color: #00cfe8 !important;\n}\n\n.vertical-layout .main-menu.theme-info .navbar-header .navbar-nav .brand-text {\n  color: #00cfe8;\n}\n.vertical-layout .main-menu.theme-info .navigation .nav-item.active a {\n  background: linear-gradient(118deg, #00cfe8, rgba(0, 207, 232, 0.7));\n  box-shadow: 0 0 10px 1px rgba(0, 207, 232, 0.7) !important;\n}\n.vertical-layout .main-menu.theme-info .navigation .nav-item .menu-content li.active {\n  background: linear-gradient(118deg, #00cfe8, rgba(0, 207, 232, 0.7));\n  box-shadow: 0 0 10px 1px rgba(0, 207, 232, 0.7) !important;\n}\n\n.horizontal-layout.theme-info .header-navbar .brand-text {\n  color: #00cfe8 !important;\n}\n.horizontal-layout.theme-info .navbar-horizontal #main-menu-navigation .nav-item.active .nav-link {\n  background: linear-gradient(118deg, #00cfe8, rgba(0, 207, 232, 0.7));\n  box-shadow: 0 0 10px 1px rgba(0, 207, 232, 0.7) !important;\n}\n\n.custom-switch-info .custom-control-input:checked ~ .custom-control-label::before {\n  background-color: #00cfe8 !important;\n  color: #fff;\n  transition: all 0.2s ease-out;\n}\n\n.color-radio.color-radio-info {\n  border: 1px solid transparent;\n}\n.color-radio.color-radio-info.selected {\n  border-color: #00cfe8;\n}\n.color-radio.color-radio-info .radio-content {\n  background-color: #00cfe8;\n}\n\n.vx-radio-info input:checked ~ .vx-radio .vx-radio--circle {\n  background: #00cfe8 !important;\n  box-shadow: 0 3px 12px 0 rgba(0, 207, 232, 0.4) !important;\n}\n\n.info.darken-1 {\n  color: rgb(0, 184.2478448276, 206.5) !important;\n}\n\n.bg-info.bg-darken-1 {\n  background-color: rgb(0, 184.2478448276, 206.5) !important;\n}\n\n.btn-info.btn-darken-1 {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: rgb(0, 184.2478448276, 206.5) !important;\n}\n.btn-info.btn-darken-1:hover {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: rgb(0, 138.7435344828, 155.5) !important;\n}\n.btn-info.btn-darken-1:focus, .btn-info.btn-darken-1:active {\n  border-color: rgb(0, 138.7435344828, 155.5) !important;\n  background-color: rgb(0, 115.9913793103, 130) !important;\n}\n\n.btn-outline-info.btn-outline-darken-1 {\n  border-color: rgb(0, 184.2478448276, 206.5) !important;\n  color: rgb(0, 184.2478448276, 206.5) !important;\n}\n.btn-outline-info.btn-outline-darken-1:hover {\n  background-color: rgb(0, 184.2478448276, 206.5) !important;\n}\n\ninput:focus ~ .bg-info {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(0, 184.2478448276, 206.5) !important;\n}\n\n.border-info.border-darken-1 {\n  border: 1px solid rgb(0, 184.2478448276, 206.5) !important;\n}\n\n.border-top-info.border-top-darken-1 {\n  border-top: 1px solid rgb(0, 184.2478448276, 206.5) !important;\n}\n\n.border-bottom-info.border-bottom-darken-1 {\n  border-bottom: 1px solid rgb(0, 184.2478448276, 206.5) !important;\n}\n\n.border-left-info.border-left-darken-1 {\n  border-left: 1px solid rgb(0, 184.2478448276, 206.5) !important;\n}\n\n.border-right-info.border-right-darken-1 {\n  border-right: 1px solid rgb(0, 184.2478448276, 206.5) !important;\n}\n\n.overlay-info.overlay-darken-1 {\n  background: rgb(0, 184.2478448276, 206.5); /* The Fallback */\n  background: rgba(0, 184.2478448276, 206.5, 0.6);\n}\n\n.info.darken-2 {\n  color: rgb(0, 161.4956896552, 181) !important;\n}\n\n.bg-info.bg-darken-2 {\n  background-color: rgb(0, 161.4956896552, 181) !important;\n}\n\n.btn-info.btn-darken-2 {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: rgb(0, 161.4956896552, 181) !important;\n}\n.btn-info.btn-darken-2:hover {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: rgb(0, 138.7435344828, 155.5) !important;\n}\n.btn-info.btn-darken-2:focus, .btn-info.btn-darken-2:active {\n  border-color: rgb(0, 138.7435344828, 155.5) !important;\n  background-color: rgb(0, 115.9913793103, 130) !important;\n}\n\n.btn-outline-info.btn-outline-darken-2 {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  color: rgb(0, 161.4956896552, 181) !important;\n}\n.btn-outline-info.btn-outline-darken-2:hover {\n  background-color: rgb(0, 161.4956896552, 181) !important;\n}\n\ninput:focus ~ .bg-info {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(0, 161.4956896552, 181) !important;\n}\n\n.border-info.border-darken-2 {\n  border: 1px solid rgb(0, 161.4956896552, 181) !important;\n}\n\n.border-top-info.border-top-darken-2 {\n  border-top: 1px solid rgb(0, 161.4956896552, 181) !important;\n}\n\n.border-bottom-info.border-bottom-darken-2 {\n  border-bottom: 1px solid rgb(0, 161.4956896552, 181) !important;\n}\n\n.border-left-info.border-left-darken-2 {\n  border-left: 1px solid rgb(0, 161.4956896552, 181) !important;\n}\n\n.border-right-info.border-right-darken-2 {\n  border-right: 1px solid rgb(0, 161.4956896552, 181) !important;\n}\n\n.overlay-info.overlay-darken-2 {\n  background: rgb(0, 161.4956896552, 181); /* The Fallback */\n  background: rgba(0, 161.4956896552, 181, 0.6);\n}\n\n.info.darken-3 {\n  color: rgb(0, 138.7435344828, 155.5) !important;\n}\n\n.bg-info.bg-darken-3 {\n  background-color: rgb(0, 138.7435344828, 155.5) !important;\n}\n\n.btn-info.btn-darken-3 {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: rgb(0, 138.7435344828, 155.5) !important;\n}\n.btn-info.btn-darken-3:hover {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: rgb(0, 138.7435344828, 155.5) !important;\n}\n.btn-info.btn-darken-3:focus, .btn-info.btn-darken-3:active {\n  border-color: rgb(0, 138.7435344828, 155.5) !important;\n  background-color: rgb(0, 115.9913793103, 130) !important;\n}\n\n.btn-outline-info.btn-outline-darken-3 {\n  border-color: rgb(0, 138.7435344828, 155.5) !important;\n  color: rgb(0, 138.7435344828, 155.5) !important;\n}\n.btn-outline-info.btn-outline-darken-3:hover {\n  background-color: rgb(0, 138.7435344828, 155.5) !important;\n}\n\ninput:focus ~ .bg-info {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(0, 138.7435344828, 155.5) !important;\n}\n\n.border-info.border-darken-3 {\n  border: 1px solid rgb(0, 138.7435344828, 155.5) !important;\n}\n\n.border-top-info.border-top-darken-3 {\n  border-top: 1px solid rgb(0, 138.7435344828, 155.5) !important;\n}\n\n.border-bottom-info.border-bottom-darken-3 {\n  border-bottom: 1px solid rgb(0, 138.7435344828, 155.5) !important;\n}\n\n.border-left-info.border-left-darken-3 {\n  border-left: 1px solid rgb(0, 138.7435344828, 155.5) !important;\n}\n\n.border-right-info.border-right-darken-3 {\n  border-right: 1px solid rgb(0, 138.7435344828, 155.5) !important;\n}\n\n.overlay-info.overlay-darken-3 {\n  background: rgb(0, 138.7435344828, 155.5); /* The Fallback */\n  background: rgba(0, 138.7435344828, 155.5, 0.6);\n}\n\n.info.darken-4 {\n  color: rgb(0, 115.9913793103, 130) !important;\n}\n\n.bg-info.bg-darken-4 {\n  background-color: rgb(0, 115.9913793103, 130) !important;\n}\n\n.btn-info.btn-darken-4 {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: rgb(0, 115.9913793103, 130) !important;\n}\n.btn-info.btn-darken-4:hover {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: rgb(0, 138.7435344828, 155.5) !important;\n}\n.btn-info.btn-darken-4:focus, .btn-info.btn-darken-4:active {\n  border-color: rgb(0, 138.7435344828, 155.5) !important;\n  background-color: rgb(0, 115.9913793103, 130) !important;\n}\n\n.btn-outline-info.btn-outline-darken-4 {\n  border-color: rgb(0, 115.9913793103, 130) !important;\n  color: rgb(0, 115.9913793103, 130) !important;\n}\n.btn-outline-info.btn-outline-darken-4:hover {\n  background-color: rgb(0, 115.9913793103, 130) !important;\n}\n\ninput:focus ~ .bg-info {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(0, 115.9913793103, 130) !important;\n}\n\n.border-info.border-darken-4 {\n  border: 1px solid rgb(0, 115.9913793103, 130) !important;\n}\n\n.border-top-info.border-top-darken-4 {\n  border-top: 1px solid rgb(0, 115.9913793103, 130) !important;\n}\n\n.border-bottom-info.border-bottom-darken-4 {\n  border-bottom: 1px solid rgb(0, 115.9913793103, 130) !important;\n}\n\n.border-left-info.border-left-darken-4 {\n  border-left: 1px solid rgb(0, 115.9913793103, 130) !important;\n}\n\n.border-right-info.border-right-darken-4 {\n  border-right: 1px solid rgb(0, 115.9913793103, 130) !important;\n}\n\n.overlay-info.overlay-darken-4 {\n  background: rgb(0, 115.9913793103, 130); /* The Fallback */\n  background: rgba(0, 115.9913793103, 130, 0.6);\n}\n\n.info.accent-1 {\n  color: #feffff !important;\n}\n\n.bg-info.bg-accent-1 {\n  background-color: #feffff !important;\n}\n\n.btn-info.btn-accent-1 {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: #feffff !important;\n}\n.btn-info.btn-accent-1:hover {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: rgb(0, 138.7435344828, 155.5) !important;\n}\n.btn-info.btn-accent-1:focus, .btn-info.btn-accent-1:active {\n  border-color: rgb(0, 138.7435344828, 155.5) !important;\n  background-color: rgb(0, 115.9913793103, 130) !important;\n}\n\n.btn-outline-info.btn-outline-accent-1 {\n  border-color: #feffff !important;\n  color: #feffff !important;\n}\n.btn-outline-info.btn-outline-accent-1:hover {\n  background-color: #feffff !important;\n}\n\ninput:focus ~ .bg-info {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #feffff !important;\n}\n\n.border-info.border-accent-1 {\n  border: 1px solid #feffff !important;\n}\n\n.border-top-info.border-top-accent-1 {\n  border-top: 1px solid #feffff !important;\n}\n\n.border-bottom-info.border-bottom-accent-1 {\n  border-bottom: 1px solid #feffff !important;\n}\n\n.border-left-info.border-left-accent-1 {\n  border-left: 1px solid #feffff !important;\n}\n\n.border-right-info.border-right-accent-1 {\n  border-right: 1px solid #feffff !important;\n}\n\n.overlay-info.overlay-accent-1 {\n  background: #feffff; /* The Fallback */\n  background: rgba(254, 255, 255, 0.6);\n}\n\n.info.accent-2 {\n  color: #cbf5ff !important;\n}\n\n.bg-info.bg-accent-2 {\n  background-color: #cbf5ff !important;\n}\n\n.btn-info.btn-accent-2 {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: #cbf5ff !important;\n}\n.btn-info.btn-accent-2:hover {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: rgb(0, 138.7435344828, 155.5) !important;\n}\n.btn-info.btn-accent-2:focus, .btn-info.btn-accent-2:active {\n  border-color: rgb(0, 138.7435344828, 155.5) !important;\n  background-color: rgb(0, 115.9913793103, 130) !important;\n}\n\n.btn-outline-info.btn-outline-accent-2 {\n  border-color: #cbf5ff !important;\n  color: #cbf5ff !important;\n}\n.btn-outline-info.btn-outline-accent-2:hover {\n  background-color: #cbf5ff !important;\n}\n\ninput:focus ~ .bg-info {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #cbf5ff !important;\n}\n\n.border-info.border-accent-2 {\n  border: 1px solid #cbf5ff !important;\n}\n\n.border-top-info.border-top-accent-2 {\n  border-top: 1px solid #cbf5ff !important;\n}\n\n.border-bottom-info.border-bottom-accent-2 {\n  border-bottom: 1px solid #cbf5ff !important;\n}\n\n.border-left-info.border-left-accent-2 {\n  border-left: 1px solid #cbf5ff !important;\n}\n\n.border-right-info.border-right-accent-2 {\n  border-right: 1px solid #cbf5ff !important;\n}\n\n.overlay-info.overlay-accent-2 {\n  background: #cbf5ff; /* The Fallback */\n  background: rgba(203, 245, 255, 0.6);\n}\n\n.info.accent-3 {\n  color: #98ecff !important;\n}\n\n.bg-info.bg-accent-3 {\n  background-color: #98ecff !important;\n}\n\n.btn-info.btn-accent-3 {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: #98ecff !important;\n}\n.btn-info.btn-accent-3:hover {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: rgb(0, 138.7435344828, 155.5) !important;\n}\n.btn-info.btn-accent-3:focus, .btn-info.btn-accent-3:active {\n  border-color: rgb(0, 138.7435344828, 155.5) !important;\n  background-color: rgb(0, 115.9913793103, 130) !important;\n}\n\n.btn-outline-info.btn-outline-accent-3 {\n  border-color: #98ecff !important;\n  color: #98ecff !important;\n}\n.btn-outline-info.btn-outline-accent-3:hover {\n  background-color: #98ecff !important;\n}\n\ninput:focus ~ .bg-info {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #98ecff !important;\n}\n\n.border-info.border-accent-3 {\n  border: 1px solid #98ecff !important;\n}\n\n.border-top-info.border-top-accent-3 {\n  border-top: 1px solid #98ecff !important;\n}\n\n.border-bottom-info.border-bottom-accent-3 {\n  border-bottom: 1px solid #98ecff !important;\n}\n\n.border-left-info.border-left-accent-3 {\n  border-left: 1px solid #98ecff !important;\n}\n\n.border-right-info.border-right-accent-3 {\n  border-right: 1px solid #98ecff !important;\n}\n\n.overlay-info.overlay-accent-3 {\n  background: #98ecff; /* The Fallback */\n  background: rgba(152, 236, 255, 0.6);\n}\n\n.info.accent-4 {\n  color: #7fe7ff !important;\n}\n\n.bg-info.bg-accent-4 {\n  background-color: #7fe7ff !important;\n}\n\n.btn-info.btn-accent-4 {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: #7fe7ff !important;\n}\n.btn-info.btn-accent-4:hover {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: rgb(0, 138.7435344828, 155.5) !important;\n}\n.btn-info.btn-accent-4:focus, .btn-info.btn-accent-4:active {\n  border-color: rgb(0, 138.7435344828, 155.5) !important;\n  background-color: rgb(0, 115.9913793103, 130) !important;\n}\n\n.btn-outline-info.btn-outline-accent-4 {\n  border-color: #7fe7ff !important;\n  color: #7fe7ff !important;\n}\n.btn-outline-info.btn-outline-accent-4:hover {\n  background-color: #7fe7ff !important;\n}\n\ninput:focus ~ .bg-info {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #7fe7ff !important;\n}\n\n.border-info.border-accent-4 {\n  border: 1px solid #7fe7ff !important;\n}\n\n.border-top-info.border-top-accent-4 {\n  border-top: 1px solid #7fe7ff !important;\n}\n\n.border-bottom-info.border-bottom-accent-4 {\n  border-bottom: 1px solid #7fe7ff !important;\n}\n\n.border-left-info.border-left-accent-4 {\n  border-left: 1px solid #7fe7ff !important;\n}\n\n.border-right-info.border-right-accent-4 {\n  border-right: 1px solid #7fe7ff !important;\n}\n\n.overlay-info.overlay-accent-4 {\n  background: #7fe7ff; /* The Fallback */\n  background: rgba(127, 231, 255, 0.6);\n}\n\n.info.gradient-bg {\n  color: #640064 !important;\n}\n\n.bg-info.bg-gradient-bg {\n  background-color: #640064 !important;\n}\n\n.btn-info.btn-gradient-bg {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: #640064 !important;\n}\n.btn-info.btn-gradient-bg:hover {\n  border-color: rgb(0, 161.4956896552, 181) !important;\n  background-color: rgb(0, 138.7435344828, 155.5) !important;\n}\n.btn-info.btn-gradient-bg:focus, .btn-info.btn-gradient-bg:active {\n  border-color: rgb(0, 138.7435344828, 155.5) !important;\n  background-color: rgb(0, 115.9913793103, 130) !important;\n}\n\n.btn-outline-info.btn-outline-gradient-bg {\n  border-color: #640064 !important;\n  color: #640064 !important;\n}\n.btn-outline-info.btn-outline-gradient-bg:hover {\n  background-color: #640064 !important;\n}\n\ninput:focus ~ .bg-info {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #640064 !important;\n}\n\n.border-info.border-gradient-bg {\n  border: 1px solid #640064 !important;\n}\n\n.border-top-info.border-top-gradient-bg {\n  border-top: 1px solid #640064 !important;\n}\n\n.border-bottom-info.border-bottom-gradient-bg {\n  border-bottom: 1px solid #640064 !important;\n}\n\n.border-left-info.border-left-gradient-bg {\n  border-left: 1px solid #640064 !important;\n}\n\n.border-right-info.border-right-gradient-bg {\n  border-right: 1px solid #640064 !important;\n}\n\n.overlay-info.overlay-gradient-bg {\n  background: #640064; /* The Fallback */\n  background: rgba(100, 0, 100, 0.6);\n}\n\n.warning.gradient-light {\n  color: rgb(255, 243.7218067376, 134.983) !important;\n}\n\n.bg-warning.bg-gradient-light {\n  background-color: rgb(255, 243.7218067376, 134.983) !important;\n}\n\n.btn-warning.btn-gradient-light {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: rgb(255, 243.7218067376, 134.983) !important;\n}\n.btn-warning.btn-gradient-light:hover {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: rgb(245.5, 120.1382978723, 0) !important;\n}\n.btn-warning.btn-gradient-light:focus, .btn-warning.btn-gradient-light:active {\n  border-color: rgb(245.5, 120.1382978723, 0) !important;\n  background-color: rgb(220, 107.6595744681, 0) !important;\n}\n\n.btn-outline-warning.btn-outline-gradient-light {\n  border-color: rgb(255, 243.7218067376, 134.983) !important;\n  color: rgb(255, 243.7218067376, 134.983) !important;\n}\n.btn-outline-warning.btn-outline-gradient-light:hover {\n  background-color: rgb(255, 243.7218067376, 134.983) !important;\n}\n\ninput:focus ~ .bg-warning {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(255, 243.7218067376, 134.983) !important;\n}\n\n.border-warning.border-gradient-light {\n  border: 1px solid rgb(255, 243.7218067376, 134.983) !important;\n}\n\n.border-top-warning.border-top-gradient-light {\n  border-top: 1px solid rgb(255, 243.7218067376, 134.983) !important;\n}\n\n.border-bottom-warning.border-bottom-gradient-light {\n  border-bottom: 1px solid rgb(255, 243.7218067376, 134.983) !important;\n}\n\n.border-left-warning.border-left-gradient-light {\n  border-left: 1px solid rgb(255, 243.7218067376, 134.983) !important;\n}\n\n.border-right-warning.border-right-gradient-light {\n  border-right: 1px solid rgb(255, 243.7218067376, 134.983) !important;\n}\n\n.overlay-warning.overlay-gradient-light {\n  background: rgb(255, 243.7218067376, 134.983); /* The Fallback */\n  background: rgba(255, 243.7218067376, 134.983, 0.6);\n}\n\n.warning.light-badge {\n  color: rgb(255, 224.1063829787, 194.5) !important;\n}\n\n.bg-warning.bg-light-badge {\n  background-color: rgb(255, 224.1063829787, 194.5) !important;\n}\n\n.btn-warning.btn-light-badge {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: rgb(255, 224.1063829787, 194.5) !important;\n}\n.btn-warning.btn-light-badge:hover {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: rgb(245.5, 120.1382978723, 0) !important;\n}\n.btn-warning.btn-light-badge:focus, .btn-warning.btn-light-badge:active {\n  border-color: rgb(245.5, 120.1382978723, 0) !important;\n  background-color: rgb(220, 107.6595744681, 0) !important;\n}\n\n.btn-outline-warning.btn-outline-light-badge {\n  border-color: rgb(255, 224.1063829787, 194.5) !important;\n  color: rgb(255, 224.1063829787, 194.5) !important;\n}\n.btn-outline-warning.btn-outline-light-badge:hover {\n  background-color: rgb(255, 224.1063829787, 194.5) !important;\n}\n\ninput:focus ~ .bg-warning {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(255, 224.1063829787, 194.5) !important;\n}\n\n.border-warning.border-light-badge {\n  border: 1px solid rgb(255, 224.1063829787, 194.5) !important;\n}\n\n.border-top-warning.border-top-light-badge {\n  border-top: 1px solid rgb(255, 224.1063829787, 194.5) !important;\n}\n\n.border-bottom-warning.border-bottom-light-badge {\n  border-bottom: 1px solid rgb(255, 224.1063829787, 194.5) !important;\n}\n\n.border-left-warning.border-left-light-badge {\n  border-left: 1px solid rgb(255, 224.1063829787, 194.5) !important;\n}\n\n.border-right-warning.border-right-light-badge {\n  border-right: 1px solid rgb(255, 224.1063829787, 194.5) !important;\n}\n\n.overlay-warning.overlay-light-badge {\n  background: rgb(255, 224.1063829787, 194.5); /* The Fallback */\n  background: rgba(255, 224.1063829787, 194.5, 0.6);\n}\n\n.warning.lighten-5 {\n  color: rgb(255, 224.1063829787, 194.5) !important;\n}\n\n.bg-warning.bg-lighten-5 {\n  background-color: rgb(255, 224.1063829787, 194.5) !important;\n}\n\n.btn-warning.btn-lighten-5 {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: rgb(255, 224.1063829787, 194.5) !important;\n}\n.btn-warning.btn-lighten-5:hover {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: rgb(245.5, 120.1382978723, 0) !important;\n}\n.btn-warning.btn-lighten-5:focus, .btn-warning.btn-lighten-5:active {\n  border-color: rgb(245.5, 120.1382978723, 0) !important;\n  background-color: rgb(220, 107.6595744681, 0) !important;\n}\n\n.btn-outline-warning.btn-outline-lighten-5 {\n  border-color: rgb(255, 224.1063829787, 194.5) !important;\n  color: rgb(255, 224.1063829787, 194.5) !important;\n}\n.btn-outline-warning.btn-outline-lighten-5:hover {\n  background-color: rgb(255, 224.1063829787, 194.5) !important;\n}\n\ninput:focus ~ .bg-warning {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(255, 224.1063829787, 194.5) !important;\n}\n\n.border-warning.border-lighten-5 {\n  border: 1px solid rgb(255, 224.1063829787, 194.5) !important;\n}\n\n.border-top-warning.border-top-lighten-5 {\n  border-top: 1px solid rgb(255, 224.1063829787, 194.5) !important;\n}\n\n.border-bottom-warning.border-bottom-lighten-5 {\n  border-bottom: 1px solid rgb(255, 224.1063829787, 194.5) !important;\n}\n\n.border-left-warning.border-left-lighten-5 {\n  border-left: 1px solid rgb(255, 224.1063829787, 194.5) !important;\n}\n\n.border-right-warning.border-right-lighten-5 {\n  border-right: 1px solid rgb(255, 224.1063829787, 194.5) !important;\n}\n\n.overlay-warning.overlay-lighten-5 {\n  background: rgb(255, 224.1063829787, 194.5); /* The Fallback */\n  background: rgba(255, 224.1063829787, 194.5, 0.6);\n}\n\n.warning.lighten-4 {\n  color: rgb(255, 211.085106383, 169) !important;\n}\n\n.bg-warning.bg-lighten-4 {\n  background-color: rgb(255, 211.085106383, 169) !important;\n}\n\n.btn-warning.btn-lighten-4 {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: rgb(255, 211.085106383, 169) !important;\n}\n.btn-warning.btn-lighten-4:hover {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: rgb(245.5, 120.1382978723, 0) !important;\n}\n.btn-warning.btn-lighten-4:focus, .btn-warning.btn-lighten-4:active {\n  border-color: rgb(245.5, 120.1382978723, 0) !important;\n  background-color: rgb(220, 107.6595744681, 0) !important;\n}\n\n.btn-outline-warning.btn-outline-lighten-4 {\n  border-color: rgb(255, 211.085106383, 169) !important;\n  color: rgb(255, 211.085106383, 169) !important;\n}\n.btn-outline-warning.btn-outline-lighten-4:hover {\n  background-color: rgb(255, 211.085106383, 169) !important;\n}\n\ninput:focus ~ .bg-warning {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(255, 211.085106383, 169) !important;\n}\n\n.border-warning.border-lighten-4 {\n  border: 1px solid rgb(255, 211.085106383, 169) !important;\n}\n\n.border-top-warning.border-top-lighten-4 {\n  border-top: 1px solid rgb(255, 211.085106383, 169) !important;\n}\n\n.border-bottom-warning.border-bottom-lighten-4 {\n  border-bottom: 1px solid rgb(255, 211.085106383, 169) !important;\n}\n\n.border-left-warning.border-left-lighten-4 {\n  border-left: 1px solid rgb(255, 211.085106383, 169) !important;\n}\n\n.border-right-warning.border-right-lighten-4 {\n  border-right: 1px solid rgb(255, 211.085106383, 169) !important;\n}\n\n.overlay-warning.overlay-lighten-4 {\n  background: rgb(255, 211.085106383, 169); /* The Fallback */\n  background: rgba(255, 211.085106383, 169, 0.6);\n}\n\n.warning.lighten-3 {\n  color: rgb(255, 198.0638297872, 143.5) !important;\n}\n\n.bg-warning.bg-lighten-3 {\n  background-color: rgb(255, 198.0638297872, 143.5) !important;\n}\n\n.btn-warning.btn-lighten-3 {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: rgb(255, 198.0638297872, 143.5) !important;\n}\n.btn-warning.btn-lighten-3:hover {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: rgb(245.5, 120.1382978723, 0) !important;\n}\n.btn-warning.btn-lighten-3:focus, .btn-warning.btn-lighten-3:active {\n  border-color: rgb(245.5, 120.1382978723, 0) !important;\n  background-color: rgb(220, 107.6595744681, 0) !important;\n}\n\n.btn-outline-warning.btn-outline-lighten-3 {\n  border-color: rgb(255, 198.0638297872, 143.5) !important;\n  color: rgb(255, 198.0638297872, 143.5) !important;\n}\n.btn-outline-warning.btn-outline-lighten-3:hover {\n  background-color: rgb(255, 198.0638297872, 143.5) !important;\n}\n\ninput:focus ~ .bg-warning {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(255, 198.0638297872, 143.5) !important;\n}\n\n.border-warning.border-lighten-3 {\n  border: 1px solid rgb(255, 198.0638297872, 143.5) !important;\n}\n\n.border-top-warning.border-top-lighten-3 {\n  border-top: 1px solid rgb(255, 198.0638297872, 143.5) !important;\n}\n\n.border-bottom-warning.border-bottom-lighten-3 {\n  border-bottom: 1px solid rgb(255, 198.0638297872, 143.5) !important;\n}\n\n.border-left-warning.border-left-lighten-3 {\n  border-left: 1px solid rgb(255, 198.0638297872, 143.5) !important;\n}\n\n.border-right-warning.border-right-lighten-3 {\n  border-right: 1px solid rgb(255, 198.0638297872, 143.5) !important;\n}\n\n.overlay-warning.overlay-lighten-3 {\n  background: rgb(255, 198.0638297872, 143.5); /* The Fallback */\n  background: rgba(255, 198.0638297872, 143.5, 0.6);\n}\n\n.warning.lighten-2 {\n  color: rgb(255, 185.0425531915, 118) !important;\n}\n\n.bg-warning.bg-lighten-2 {\n  background-color: rgb(255, 185.0425531915, 118) !important;\n}\n\n.btn-warning.btn-lighten-2 {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: rgb(255, 185.0425531915, 118) !important;\n}\n.btn-warning.btn-lighten-2:hover {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: rgb(245.5, 120.1382978723, 0) !important;\n}\n.btn-warning.btn-lighten-2:focus, .btn-warning.btn-lighten-2:active {\n  border-color: rgb(245.5, 120.1382978723, 0) !important;\n  background-color: rgb(220, 107.6595744681, 0) !important;\n}\n\n.btn-outline-warning.btn-outline-lighten-2 {\n  border-color: rgb(255, 185.0425531915, 118) !important;\n  color: rgb(255, 185.0425531915, 118) !important;\n}\n.btn-outline-warning.btn-outline-lighten-2:hover {\n  background-color: rgb(255, 185.0425531915, 118) !important;\n}\n\ninput:focus ~ .bg-warning {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(255, 185.0425531915, 118) !important;\n}\n\n.border-warning.border-lighten-2 {\n  border: 1px solid rgb(255, 185.0425531915, 118) !important;\n}\n\n.border-top-warning.border-top-lighten-2 {\n  border-top: 1px solid rgb(255, 185.0425531915, 118) !important;\n}\n\n.border-bottom-warning.border-bottom-lighten-2 {\n  border-bottom: 1px solid rgb(255, 185.0425531915, 118) !important;\n}\n\n.border-left-warning.border-left-lighten-2 {\n  border-left: 1px solid rgb(255, 185.0425531915, 118) !important;\n}\n\n.border-right-warning.border-right-lighten-2 {\n  border-right: 1px solid rgb(255, 185.0425531915, 118) !important;\n}\n\n.overlay-warning.overlay-lighten-2 {\n  background: rgb(255, 185.0425531915, 118); /* The Fallback */\n  background: rgba(255, 185.0425531915, 118, 0.6);\n}\n\n.warning.lighten-1 {\n  color: rgb(255, 172.0212765957, 92.5) !important;\n}\n\n.bg-warning.bg-lighten-1 {\n  background-color: rgb(255, 172.0212765957, 92.5) !important;\n}\n\n.btn-warning.btn-lighten-1 {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: rgb(255, 172.0212765957, 92.5) !important;\n}\n.btn-warning.btn-lighten-1:hover {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: rgb(245.5, 120.1382978723, 0) !important;\n}\n.btn-warning.btn-lighten-1:focus, .btn-warning.btn-lighten-1:active {\n  border-color: rgb(245.5, 120.1382978723, 0) !important;\n  background-color: rgb(220, 107.6595744681, 0) !important;\n}\n\n.btn-outline-warning.btn-outline-lighten-1 {\n  border-color: rgb(255, 172.0212765957, 92.5) !important;\n  color: rgb(255, 172.0212765957, 92.5) !important;\n}\n.btn-outline-warning.btn-outline-lighten-1:hover {\n  background-color: rgb(255, 172.0212765957, 92.5) !important;\n}\n\ninput:focus ~ .bg-warning {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(255, 172.0212765957, 92.5) !important;\n}\n\n.border-warning.border-lighten-1 {\n  border: 1px solid rgb(255, 172.0212765957, 92.5) !important;\n}\n\n.border-top-warning.border-top-lighten-1 {\n  border-top: 1px solid rgb(255, 172.0212765957, 92.5) !important;\n}\n\n.border-bottom-warning.border-bottom-lighten-1 {\n  border-bottom: 1px solid rgb(255, 172.0212765957, 92.5) !important;\n}\n\n.border-left-warning.border-left-lighten-1 {\n  border-left: 1px solid rgb(255, 172.0212765957, 92.5) !important;\n}\n\n.border-right-warning.border-right-lighten-1 {\n  border-right: 1px solid rgb(255, 172.0212765957, 92.5) !important;\n}\n\n.overlay-warning.overlay-lighten-1 {\n  background: rgb(255, 172.0212765957, 92.5); /* The Fallback */\n  background: rgba(255, 172.0212765957, 92.5, 0.6);\n}\n\n.warning {\n  color: #ff9f43 !important;\n}\n\n.bg-warning {\n  background-color: #ff9f43 !important;\n}\n.bg-warning .card-header,\n.bg-warning .card-footer {\n  background-color: transparent;\n}\n\n.alert-warning {\n  background: rgba(255, 159, 67, 0.2) !important;\n  color: #ff9f43 !important;\n}\n.alert-warning .alert-heading {\n  box-shadow: rgba(255, 159, 67, 0.4) 0px 6px 15px -7px;\n}\n.alert-warning .alert-link {\n  color: rgb(255, 145.9787234043, 41.5) !important;\n}\n\n.bg-rgba-warning {\n  background: rgba(255, 159, 67, 0.15) !important;\n}\n\n.border-warning {\n  border: 1px solid #ff9f43 !important;\n}\n\n.border-top-warning {\n  border-top: 1px solid #ff9f43;\n}\n\n.border-bottom-warning {\n  border-bottom: 1px solid #ff9f43;\n}\n\n.border-left-warning {\n  border-left: 1px solid #ff9f43;\n}\n\n.border-right-warning {\n  border-right: 1px solid #ff9f43;\n}\n\n.badge.badge-light-warning {\n  background-color: rgb(255, 224.1063829787, 194.5);\n  color: #ff9f43 !important;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.bg-warning.badge-glow,\n.border-warning.badge-glow,\n.badge-warning.badge-glow {\n  box-shadow: 0px 0px 10px #ff9f43;\n}\n\n.overlay-warning {\n  background: #ff9f43; /* The Fallback */\n  background: rgba(255, 159, 67, 0.6);\n}\n\n.btn-warning {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: #ff9f43 !important;\n  color: #fff;\n}\n.btn-warning:hover {\n  border-color: rgb(255, 145.9787234043, 41.5) !important;\n  color: #fff !important;\n  box-shadow: 0 8px 25px -8px #ff9f43;\n}\n.btn-warning:focus, .btn-warning:active {\n  color: #fff !important;\n}\n\n.btn-flat-warning {\n  background-color: transparent;\n  color: #ff9f43;\n}\n.btn-flat-warning:hover {\n  color: #ff9f43;\n  background-color: rgba(255, 159, 67, 0.1);\n}\n.btn-flat-warning:active, .btn-flat-warning:focus {\n  background-color: #ff9f43;\n  color: #fff !important;\n}\n\n.btn-relief-warning {\n  background-color: #ff9f43;\n  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.2);\n  color: #fff;\n}\n.btn-relief-warning:hover {\n  color: #fff;\n}\n.btn-relief-warning:active, .btn-relief-warning:focus {\n  outline: none;\n  transform: translateY(3px);\n}\n\n.btn-outline-warning {\n  border: 1px solid #ff9f43;\n  background-color: transparent;\n  color: #ff9f43;\n}\n.btn-outline-warning:hover {\n  background-color: rgba(255, 159, 67, 0.08);\n  color: #ff9f43;\n}\n.btn-outline-warning:active {\n  color: #fff !important;\n}\n\n.btn-warning ~ .dropdown-menu .dropdown-item.active,\n.btn-outline-warning ~ .dropdown-menu .dropdown-item.active,\n.btn-flat-warning ~ .dropdown-menu .dropdown-item.active {\n  background-color: #ff9f43;\n  color: #fff;\n}\n.btn-warning ~ .dropdown-menu .dropdown-item.active:hover,\n.btn-outline-warning ~ .dropdown-menu .dropdown-item.active:hover,\n.btn-flat-warning ~ .dropdown-menu .dropdown-item.active:hover {\n  color: #fff;\n}\n.btn-warning ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,\n.btn-outline-warning ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,\n.btn-flat-warning ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover {\n  color: #ff9f43;\n}\n\n.bullet.bullet-warning {\n  background-color: #ff9f43;\n}\n.bullet.bullet-warning.bullet-bordered {\n  background-color: transparent;\n  border: 2px solid #ff9f43;\n}\n\n.pagination-warning li.active a,\n.pagination-warning li.active .page-link,\n.pagination-warning .page-item.active a,\n.pagination-warning .page-item.active .page-link {\n  background: #ff9f43 !important;\n  color: #fff;\n}\n.pagination-warning li.active a:hover,\n.pagination-warning li.active .page-link:hover,\n.pagination-warning .page-item.active a:hover,\n.pagination-warning .page-item.active .page-link:hover {\n  color: #fff !important;\n}\n.pagination-warning li a:hover,\n.pagination-warning li .page-link:hover,\n.pagination-warning .page-item a:hover,\n.pagination-warning .page-item .page-link:hover {\n  color: #ff9f43 !important;\n}\n.pagination-warning li.prev-item .page-link:hover, .pagination-warning li.next-item .page-link:hover,\n.pagination-warning .page-item.prev-item .page-link:hover,\n.pagination-warning .page-item.next-item .page-link:hover {\n  background: #ff9f43;\n  color: #fff;\n}\n\n.nav-pill-warning .nav-item .nav-link.active {\n  color: #fff;\n  background-color: #ff9f43;\n}\n\n.chip-warning {\n  background-color: #ff9f43 !important;\n}\n.chip-warning .chip-body {\n  color: #fff !important;\n}\n\n.divider.divider-warning .divider-text:before, .divider.divider-warning .divider-text:after {\n  border-color: #ff9f43 !important;\n}\n\ninput[type=checkbox].bg-warning + .custom-control-label:before, input[type=radio].bg-warning + .custom-control-label:before {\n  background-color: #ff9f43 !important;\n}\n\ninput:focus ~ .bg-warning {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #ff9f43 !important;\n}\n\n.vx-checkbox-warning input:checked ~ .vx-checkbox {\n  border-color: #ff9f43 !important;\n}\n.vx-checkbox-warning input:checked ~ .vx-checkbox .vx-checkbox--check {\n  background-color: #ff9f43 !important;\n}\n.vx-checkbox-warning input:active:checked + .vx-checkbox .vx-checkbox--check {\n  background-color: #ff9f43 !important;\n}\n\n.vertical-layout .main-menu.theme-warning .navbar-header .navbar-nav .brand-text {\n  color: #ff9f43;\n}\n.vertical-layout .main-menu.theme-warning .navigation .nav-item.active a {\n  background: linear-gradient(118deg, #ff9f43, rgba(255, 159, 67, 0.7));\n  box-shadow: 0 0 10px 1px rgba(255, 159, 67, 0.7) !important;\n}\n.vertical-layout .main-menu.theme-warning .navigation .nav-item .menu-content li.active {\n  background: linear-gradient(118deg, #ff9f43, rgba(255, 159, 67, 0.7));\n  box-shadow: 0 0 10px 1px rgba(255, 159, 67, 0.7) !important;\n}\n\n.horizontal-layout.theme-warning .header-navbar .brand-text {\n  color: #ff9f43 !important;\n}\n.horizontal-layout.theme-warning .navbar-horizontal #main-menu-navigation .nav-item.active .nav-link {\n  background: linear-gradient(118deg, #ff9f43, rgba(255, 159, 67, 0.7));\n  box-shadow: 0 0 10px 1px rgba(255, 159, 67, 0.7) !important;\n}\n\n.custom-switch-warning .custom-control-input:checked ~ .custom-control-label::before {\n  background-color: #ff9f43 !important;\n  color: #fff;\n  transition: all 0.2s ease-out;\n}\n\n.color-radio.color-radio-warning {\n  border: 1px solid transparent;\n}\n.color-radio.color-radio-warning.selected {\n  border-color: #ff9f43;\n}\n.color-radio.color-radio-warning .radio-content {\n  background-color: #ff9f43;\n}\n\n.vx-radio-warning input:checked ~ .vx-radio .vx-radio--circle {\n  background: #ff9f43 !important;\n  box-shadow: 0 3px 12px 0 rgba(255, 159, 67, 0.4) !important;\n}\n\n.warning.darken-1 {\n  color: rgb(255, 145.9787234043, 41.5) !important;\n}\n\n.bg-warning.bg-darken-1 {\n  background-color: rgb(255, 145.9787234043, 41.5) !important;\n}\n\n.btn-warning.btn-darken-1 {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: rgb(255, 145.9787234043, 41.5) !important;\n}\n.btn-warning.btn-darken-1:hover {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: rgb(245.5, 120.1382978723, 0) !important;\n}\n.btn-warning.btn-darken-1:focus, .btn-warning.btn-darken-1:active {\n  border-color: rgb(245.5, 120.1382978723, 0) !important;\n  background-color: rgb(220, 107.6595744681, 0) !important;\n}\n\n.btn-outline-warning.btn-outline-darken-1 {\n  border-color: rgb(255, 145.9787234043, 41.5) !important;\n  color: rgb(255, 145.9787234043, 41.5) !important;\n}\n.btn-outline-warning.btn-outline-darken-1:hover {\n  background-color: rgb(255, 145.9787234043, 41.5) !important;\n}\n\ninput:focus ~ .bg-warning {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(255, 145.9787234043, 41.5) !important;\n}\n\n.border-warning.border-darken-1 {\n  border: 1px solid rgb(255, 145.9787234043, 41.5) !important;\n}\n\n.border-top-warning.border-top-darken-1 {\n  border-top: 1px solid rgb(255, 145.9787234043, 41.5) !important;\n}\n\n.border-bottom-warning.border-bottom-darken-1 {\n  border-bottom: 1px solid rgb(255, 145.9787234043, 41.5) !important;\n}\n\n.border-left-warning.border-left-darken-1 {\n  border-left: 1px solid rgb(255, 145.9787234043, 41.5) !important;\n}\n\n.border-right-warning.border-right-darken-1 {\n  border-right: 1px solid rgb(255, 145.9787234043, 41.5) !important;\n}\n\n.overlay-warning.overlay-darken-1 {\n  background: rgb(255, 145.9787234043, 41.5); /* The Fallback */\n  background: rgba(255, 145.9787234043, 41.5, 0.6);\n}\n\n.warning.darken-2 {\n  color: rgb(255, 132.9574468085, 16) !important;\n}\n\n.bg-warning.bg-darken-2 {\n  background-color: rgb(255, 132.9574468085, 16) !important;\n}\n\n.btn-warning.btn-darken-2 {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: rgb(255, 132.9574468085, 16) !important;\n}\n.btn-warning.btn-darken-2:hover {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: rgb(245.5, 120.1382978723, 0) !important;\n}\n.btn-warning.btn-darken-2:focus, .btn-warning.btn-darken-2:active {\n  border-color: rgb(245.5, 120.1382978723, 0) !important;\n  background-color: rgb(220, 107.6595744681, 0) !important;\n}\n\n.btn-outline-warning.btn-outline-darken-2 {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  color: rgb(255, 132.9574468085, 16) !important;\n}\n.btn-outline-warning.btn-outline-darken-2:hover {\n  background-color: rgb(255, 132.9574468085, 16) !important;\n}\n\ninput:focus ~ .bg-warning {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(255, 132.9574468085, 16) !important;\n}\n\n.border-warning.border-darken-2 {\n  border: 1px solid rgb(255, 132.9574468085, 16) !important;\n}\n\n.border-top-warning.border-top-darken-2 {\n  border-top: 1px solid rgb(255, 132.9574468085, 16) !important;\n}\n\n.border-bottom-warning.border-bottom-darken-2 {\n  border-bottom: 1px solid rgb(255, 132.9574468085, 16) !important;\n}\n\n.border-left-warning.border-left-darken-2 {\n  border-left: 1px solid rgb(255, 132.9574468085, 16) !important;\n}\n\n.border-right-warning.border-right-darken-2 {\n  border-right: 1px solid rgb(255, 132.9574468085, 16) !important;\n}\n\n.overlay-warning.overlay-darken-2 {\n  background: rgb(255, 132.9574468085, 16); /* The Fallback */\n  background: rgba(255, 132.9574468085, 16, 0.6);\n}\n\n.warning.darken-3 {\n  color: rgb(245.5, 120.1382978723, 0) !important;\n}\n\n.bg-warning.bg-darken-3 {\n  background-color: rgb(245.5, 120.1382978723, 0) !important;\n}\n\n.btn-warning.btn-darken-3 {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: rgb(245.5, 120.1382978723, 0) !important;\n}\n.btn-warning.btn-darken-3:hover {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: rgb(245.5, 120.1382978723, 0) !important;\n}\n.btn-warning.btn-darken-3:focus, .btn-warning.btn-darken-3:active {\n  border-color: rgb(245.5, 120.1382978723, 0) !important;\n  background-color: rgb(220, 107.6595744681, 0) !important;\n}\n\n.btn-outline-warning.btn-outline-darken-3 {\n  border-color: rgb(245.5, 120.1382978723, 0) !important;\n  color: rgb(245.5, 120.1382978723, 0) !important;\n}\n.btn-outline-warning.btn-outline-darken-3:hover {\n  background-color: rgb(245.5, 120.1382978723, 0) !important;\n}\n\ninput:focus ~ .bg-warning {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(245.5, 120.1382978723, 0) !important;\n}\n\n.border-warning.border-darken-3 {\n  border: 1px solid rgb(245.5, 120.1382978723, 0) !important;\n}\n\n.border-top-warning.border-top-darken-3 {\n  border-top: 1px solid rgb(245.5, 120.1382978723, 0) !important;\n}\n\n.border-bottom-warning.border-bottom-darken-3 {\n  border-bottom: 1px solid rgb(245.5, 120.1382978723, 0) !important;\n}\n\n.border-left-warning.border-left-darken-3 {\n  border-left: 1px solid rgb(245.5, 120.1382978723, 0) !important;\n}\n\n.border-right-warning.border-right-darken-3 {\n  border-right: 1px solid rgb(245.5, 120.1382978723, 0) !important;\n}\n\n.overlay-warning.overlay-darken-3 {\n  background: rgb(245.5, 120.1382978723, 0); /* The Fallback */\n  background: rgba(245.5, 120.1382978723, 0, 0.6);\n}\n\n.warning.darken-4 {\n  color: rgb(220, 107.6595744681, 0) !important;\n}\n\n.bg-warning.bg-darken-4 {\n  background-color: rgb(220, 107.6595744681, 0) !important;\n}\n\n.btn-warning.btn-darken-4 {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: rgb(220, 107.6595744681, 0) !important;\n}\n.btn-warning.btn-darken-4:hover {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: rgb(245.5, 120.1382978723, 0) !important;\n}\n.btn-warning.btn-darken-4:focus, .btn-warning.btn-darken-4:active {\n  border-color: rgb(245.5, 120.1382978723, 0) !important;\n  background-color: rgb(220, 107.6595744681, 0) !important;\n}\n\n.btn-outline-warning.btn-outline-darken-4 {\n  border-color: rgb(220, 107.6595744681, 0) !important;\n  color: rgb(220, 107.6595744681, 0) !important;\n}\n.btn-outline-warning.btn-outline-darken-4:hover {\n  background-color: rgb(220, 107.6595744681, 0) !important;\n}\n\ninput:focus ~ .bg-warning {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(220, 107.6595744681, 0) !important;\n}\n\n.border-warning.border-darken-4 {\n  border: 1px solid rgb(220, 107.6595744681, 0) !important;\n}\n\n.border-top-warning.border-top-darken-4 {\n  border-top: 1px solid rgb(220, 107.6595744681, 0) !important;\n}\n\n.border-bottom-warning.border-bottom-darken-4 {\n  border-bottom: 1px solid rgb(220, 107.6595744681, 0) !important;\n}\n\n.border-left-warning.border-left-darken-4 {\n  border-left: 1px solid rgb(220, 107.6595744681, 0) !important;\n}\n\n.border-right-warning.border-right-darken-4 {\n  border-right: 1px solid rgb(220, 107.6595744681, 0) !important;\n}\n\n.overlay-warning.overlay-darken-4 {\n  background: rgb(220, 107.6595744681, 0); /* The Fallback */\n  background: rgba(220, 107.6595744681, 0, 0.6);\n}\n\n.warning.accent-1 {\n  color: #fff5ef !important;\n}\n\n.bg-warning.bg-accent-1 {\n  background-color: #fff5ef !important;\n}\n\n.btn-warning.btn-accent-1 {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: #fff5ef !important;\n}\n.btn-warning.btn-accent-1:hover {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: rgb(245.5, 120.1382978723, 0) !important;\n}\n.btn-warning.btn-accent-1:focus, .btn-warning.btn-accent-1:active {\n  border-color: rgb(245.5, 120.1382978723, 0) !important;\n  background-color: rgb(220, 107.6595744681, 0) !important;\n}\n\n.btn-outline-warning.btn-outline-accent-1 {\n  border-color: #fff5ef !important;\n  color: #fff5ef !important;\n}\n.btn-outline-warning.btn-outline-accent-1:hover {\n  background-color: #fff5ef !important;\n}\n\ninput:focus ~ .bg-warning {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #fff5ef !important;\n}\n\n.border-warning.border-accent-1 {\n  border: 1px solid #fff5ef !important;\n}\n\n.border-top-warning.border-top-accent-1 {\n  border-top: 1px solid #fff5ef !important;\n}\n\n.border-bottom-warning.border-bottom-accent-1 {\n  border-bottom: 1px solid #fff5ef !important;\n}\n\n.border-left-warning.border-left-accent-1 {\n  border-left: 1px solid #fff5ef !important;\n}\n\n.border-right-warning.border-right-accent-1 {\n  border-right: 1px solid #fff5ef !important;\n}\n\n.overlay-warning.overlay-accent-1 {\n  background: #fff5ef; /* The Fallback */\n  background: rgba(255, 245, 239, 0.6);\n}\n\n.warning.accent-2 {\n  color: #ffe5d8 !important;\n}\n\n.bg-warning.bg-accent-2 {\n  background-color: #ffe5d8 !important;\n}\n\n.btn-warning.btn-accent-2 {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: #ffe5d8 !important;\n}\n.btn-warning.btn-accent-2:hover {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: rgb(245.5, 120.1382978723, 0) !important;\n}\n.btn-warning.btn-accent-2:focus, .btn-warning.btn-accent-2:active {\n  border-color: rgb(245.5, 120.1382978723, 0) !important;\n  background-color: rgb(220, 107.6595744681, 0) !important;\n}\n\n.btn-outline-warning.btn-outline-accent-2 {\n  border-color: #ffe5d8 !important;\n  color: #ffe5d8 !important;\n}\n.btn-outline-warning.btn-outline-accent-2:hover {\n  background-color: #ffe5d8 !important;\n}\n\ninput:focus ~ .bg-warning {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #ffe5d8 !important;\n}\n\n.border-warning.border-accent-2 {\n  border: 1px solid #ffe5d8 !important;\n}\n\n.border-top-warning.border-top-accent-2 {\n  border-top: 1px solid #ffe5d8 !important;\n}\n\n.border-bottom-warning.border-bottom-accent-2 {\n  border-bottom: 1px solid #ffe5d8 !important;\n}\n\n.border-left-warning.border-left-accent-2 {\n  border-left: 1px solid #ffe5d8 !important;\n}\n\n.border-right-warning.border-right-accent-2 {\n  border-right: 1px solid #ffe5d8 !important;\n}\n\n.overlay-warning.overlay-accent-2 {\n  background: #ffe5d8; /* The Fallback */\n  background: rgba(255, 229, 216, 0.6);\n}\n\n.warning.accent-3 {\n  color: #fff6f3 !important;\n}\n\n.bg-warning.bg-accent-3 {\n  background-color: #fff6f3 !important;\n}\n\n.btn-warning.btn-accent-3 {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: #fff6f3 !important;\n}\n.btn-warning.btn-accent-3:hover {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: rgb(245.5, 120.1382978723, 0) !important;\n}\n.btn-warning.btn-accent-3:focus, .btn-warning.btn-accent-3:active {\n  border-color: rgb(245.5, 120.1382978723, 0) !important;\n  background-color: rgb(220, 107.6595744681, 0) !important;\n}\n\n.btn-outline-warning.btn-outline-accent-3 {\n  border-color: #fff6f3 !important;\n  color: #fff6f3 !important;\n}\n.btn-outline-warning.btn-outline-accent-3:hover {\n  background-color: #fff6f3 !important;\n}\n\ninput:focus ~ .bg-warning {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #fff6f3 !important;\n}\n\n.border-warning.border-accent-3 {\n  border: 1px solid #fff6f3 !important;\n}\n\n.border-top-warning.border-top-accent-3 {\n  border-top: 1px solid #fff6f3 !important;\n}\n\n.border-bottom-warning.border-bottom-accent-3 {\n  border-bottom: 1px solid #fff6f3 !important;\n}\n\n.border-left-warning.border-left-accent-3 {\n  border-left: 1px solid #fff6f3 !important;\n}\n\n.border-right-warning.border-right-accent-3 {\n  border-right: 1px solid #fff6f3 !important;\n}\n\n.overlay-warning.overlay-accent-3 {\n  background: #fff6f3; /* The Fallback */\n  background: rgba(255, 246, 243, 0.6);\n}\n\n.warning.accent-4 {\n  color: #ffe3da !important;\n}\n\n.bg-warning.bg-accent-4 {\n  background-color: #ffe3da !important;\n}\n\n.btn-warning.btn-accent-4 {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: #ffe3da !important;\n}\n.btn-warning.btn-accent-4:hover {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: rgb(245.5, 120.1382978723, 0) !important;\n}\n.btn-warning.btn-accent-4:focus, .btn-warning.btn-accent-4:active {\n  border-color: rgb(245.5, 120.1382978723, 0) !important;\n  background-color: rgb(220, 107.6595744681, 0) !important;\n}\n\n.btn-outline-warning.btn-outline-accent-4 {\n  border-color: #ffe3da !important;\n  color: #ffe3da !important;\n}\n.btn-outline-warning.btn-outline-accent-4:hover {\n  background-color: #ffe3da !important;\n}\n\ninput:focus ~ .bg-warning {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #ffe3da !important;\n}\n\n.border-warning.border-accent-4 {\n  border: 1px solid #ffe3da !important;\n}\n\n.border-top-warning.border-top-accent-4 {\n  border-top: 1px solid #ffe3da !important;\n}\n\n.border-bottom-warning.border-bottom-accent-4 {\n  border-bottom: 1px solid #ffe3da !important;\n}\n\n.border-left-warning.border-left-accent-4 {\n  border-left: 1px solid #ffe3da !important;\n}\n\n.border-right-warning.border-right-accent-4 {\n  border-right: 1px solid #ffe3da !important;\n}\n\n.overlay-warning.overlay-accent-4 {\n  background: #ffe3da; /* The Fallback */\n  background: rgba(255, 227, 218, 0.6);\n}\n\n.warning.gradient-bg {\n  color: #fafafa !important;\n}\n\n.bg-warning.bg-gradient-bg {\n  background-color: #fafafa !important;\n}\n\n.btn-warning.btn-gradient-bg {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: #fafafa !important;\n}\n.btn-warning.btn-gradient-bg:hover {\n  border-color: rgb(255, 132.9574468085, 16) !important;\n  background-color: rgb(245.5, 120.1382978723, 0) !important;\n}\n.btn-warning.btn-gradient-bg:focus, .btn-warning.btn-gradient-bg:active {\n  border-color: rgb(245.5, 120.1382978723, 0) !important;\n  background-color: rgb(220, 107.6595744681, 0) !important;\n}\n\n.btn-outline-warning.btn-outline-gradient-bg {\n  border-color: #fafafa !important;\n  color: #fafafa !important;\n}\n.btn-outline-warning.btn-outline-gradient-bg:hover {\n  background-color: #fafafa !important;\n}\n\ninput:focus ~ .bg-warning {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #fafafa !important;\n}\n\n.border-warning.border-gradient-bg {\n  border: 1px solid #fafafa !important;\n}\n\n.border-top-warning.border-top-gradient-bg {\n  border-top: 1px solid #fafafa !important;\n}\n\n.border-bottom-warning.border-bottom-gradient-bg {\n  border-bottom: 1px solid #fafafa !important;\n}\n\n.border-left-warning.border-left-gradient-bg {\n  border-left: 1px solid #fafafa !important;\n}\n\n.border-right-warning.border-right-gradient-bg {\n  border-right: 1px solid #fafafa !important;\n}\n\n.overlay-warning.overlay-gradient-bg {\n  background: #fafafa; /* The Fallback */\n  background: rgba(250, 250, 250, 0.6);\n}\n\n.danger.gradient-light {\n  color: rgb(248.814652125, 182.9433326175, 137.168347875) !important;\n}\n\n.bg-danger.bg-gradient-light {\n  background-color: rgb(248.814652125, 182.9433326175, 137.168347875) !important;\n}\n\n.btn-danger.btn-gradient-light {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: rgb(248.814652125, 182.9433326175, 137.168347875) !important;\n}\n.btn-danger.btn-gradient-light:hover {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n}\n.btn-danger.btn-gradient-light:focus, .btn-danger.btn-gradient-light:active {\n  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n  background-color: rgb(192.375, 23.625, 24.75) !important;\n}\n\n.btn-outline-danger.btn-outline-gradient-light {\n  border-color: rgb(248.814652125, 182.9433326175, 137.168347875) !important;\n  color: rgb(248.814652125, 182.9433326175, 137.168347875) !important;\n}\n.btn-outline-danger.btn-outline-gradient-light:hover {\n  background-color: rgb(248.814652125, 182.9433326175, 137.168347875) !important;\n}\n\ninput:focus ~ .bg-danger {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(248.814652125, 182.9433326175, 137.168347875) !important;\n}\n\n.border-danger.border-gradient-light {\n  border: 1px solid rgb(248.814652125, 182.9433326175, 137.168347875) !important;\n}\n\n.border-top-danger.border-top-gradient-light {\n  border-top: 1px solid rgb(248.814652125, 182.9433326175, 137.168347875) !important;\n}\n\n.border-bottom-danger.border-bottom-gradient-light {\n  border-bottom: 1px solid rgb(248.814652125, 182.9433326175, 137.168347875) !important;\n}\n\n.border-left-danger.border-left-gradient-light {\n  border-left: 1px solid rgb(248.814652125, 182.9433326175, 137.168347875) !important;\n}\n\n.border-right-danger.border-right-gradient-light {\n  border-right: 1px solid rgb(248.814652125, 182.9433326175, 137.168347875) !important;\n}\n\n.overlay-danger.overlay-gradient-light {\n  background: rgb(248.814652125, 182.9433326175, 137.168347875); /* The Fallback */\n  background: rgba(248.814652125, 182.9433326175, 137.168347875, 0.6);\n}\n\n.danger.light-badge {\n  color: rgb(250.734375, 220.265625, 220.46875) !important;\n}\n\n.bg-danger.bg-light-badge {\n  background-color: rgb(250.734375, 220.265625, 220.46875) !important;\n}\n\n.btn-danger.btn-light-badge {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: rgb(250.734375, 220.265625, 220.46875) !important;\n}\n.btn-danger.btn-light-badge:hover {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n}\n.btn-danger.btn-light-badge:focus, .btn-danger.btn-light-badge:active {\n  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n  background-color: rgb(192.375, 23.625, 24.75) !important;\n}\n\n.btn-outline-danger.btn-outline-light-badge {\n  border-color: rgb(250.734375, 220.265625, 220.46875) !important;\n  color: rgb(250.734375, 220.265625, 220.46875) !important;\n}\n.btn-outline-danger.btn-outline-light-badge:hover {\n  background-color: rgb(250.734375, 220.265625, 220.46875) !important;\n}\n\ninput:focus ~ .bg-danger {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(250.734375, 220.265625, 220.46875) !important;\n}\n\n.border-danger.border-light-badge {\n  border: 1px solid rgb(250.734375, 220.265625, 220.46875) !important;\n}\n\n.border-top-danger.border-top-light-badge {\n  border-top: 1px solid rgb(250.734375, 220.265625, 220.46875) !important;\n}\n\n.border-bottom-danger.border-bottom-light-badge {\n  border-bottom: 1px solid rgb(250.734375, 220.265625, 220.46875) !important;\n}\n\n.border-left-danger.border-left-light-badge {\n  border-left: 1px solid rgb(250.734375, 220.265625, 220.46875) !important;\n}\n\n.border-right-danger.border-right-light-badge {\n  border-right: 1px solid rgb(250.734375, 220.265625, 220.46875) !important;\n}\n\n.overlay-danger.overlay-light-badge {\n  background: rgb(250.734375, 220.265625, 220.46875); /* The Fallback */\n  background: rgba(250.734375, 220.265625, 220.46875, 0.6);\n}\n\n.danger.lighten-5 {\n  color: rgb(247.9453125, 197.5546875, 197.890625) !important;\n}\n\n.bg-danger.bg-lighten-5 {\n  background-color: rgb(247.9453125, 197.5546875, 197.890625) !important;\n}\n\n.btn-danger.btn-lighten-5 {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: rgb(247.9453125, 197.5546875, 197.890625) !important;\n}\n.btn-danger.btn-lighten-5:hover {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n}\n.btn-danger.btn-lighten-5:focus, .btn-danger.btn-lighten-5:active {\n  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n  background-color: rgb(192.375, 23.625, 24.75) !important;\n}\n\n.btn-outline-danger.btn-outline-lighten-5 {\n  border-color: rgb(247.9453125, 197.5546875, 197.890625) !important;\n  color: rgb(247.9453125, 197.5546875, 197.890625) !important;\n}\n.btn-outline-danger.btn-outline-lighten-5:hover {\n  background-color: rgb(247.9453125, 197.5546875, 197.890625) !important;\n}\n\ninput:focus ~ .bg-danger {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(247.9453125, 197.5546875, 197.890625) !important;\n}\n\n.border-danger.border-lighten-5 {\n  border: 1px solid rgb(247.9453125, 197.5546875, 197.890625) !important;\n}\n\n.border-top-danger.border-top-lighten-5 {\n  border-top: 1px solid rgb(247.9453125, 197.5546875, 197.890625) !important;\n}\n\n.border-bottom-danger.border-bottom-lighten-5 {\n  border-bottom: 1px solid rgb(247.9453125, 197.5546875, 197.890625) !important;\n}\n\n.border-left-danger.border-left-lighten-5 {\n  border-left: 1px solid rgb(247.9453125, 197.5546875, 197.890625) !important;\n}\n\n.border-right-danger.border-right-lighten-5 {\n  border-right: 1px solid rgb(247.9453125, 197.5546875, 197.890625) !important;\n}\n\n.overlay-danger.overlay-lighten-5 {\n  background: rgb(247.9453125, 197.5546875, 197.890625); /* The Fallback */\n  background: rgba(247.9453125, 197.5546875, 197.890625, 0.6);\n}\n\n.danger.lighten-4 {\n  color: rgb(245.15625, 174.84375, 175.3125) !important;\n}\n\n.bg-danger.bg-lighten-4 {\n  background-color: rgb(245.15625, 174.84375, 175.3125) !important;\n}\n\n.btn-danger.btn-lighten-4 {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: rgb(245.15625, 174.84375, 175.3125) !important;\n}\n.btn-danger.btn-lighten-4:hover {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n}\n.btn-danger.btn-lighten-4:focus, .btn-danger.btn-lighten-4:active {\n  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n  background-color: rgb(192.375, 23.625, 24.75) !important;\n}\n\n.btn-outline-danger.btn-outline-lighten-4 {\n  border-color: rgb(245.15625, 174.84375, 175.3125) !important;\n  color: rgb(245.15625, 174.84375, 175.3125) !important;\n}\n.btn-outline-danger.btn-outline-lighten-4:hover {\n  background-color: rgb(245.15625, 174.84375, 175.3125) !important;\n}\n\ninput:focus ~ .bg-danger {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(245.15625, 174.84375, 175.3125) !important;\n}\n\n.border-danger.border-lighten-4 {\n  border: 1px solid rgb(245.15625, 174.84375, 175.3125) !important;\n}\n\n.border-top-danger.border-top-lighten-4 {\n  border-top: 1px solid rgb(245.15625, 174.84375, 175.3125) !important;\n}\n\n.border-bottom-danger.border-bottom-lighten-4 {\n  border-bottom: 1px solid rgb(245.15625, 174.84375, 175.3125) !important;\n}\n\n.border-left-danger.border-left-lighten-4 {\n  border-left: 1px solid rgb(245.15625, 174.84375, 175.3125) !important;\n}\n\n.border-right-danger.border-right-lighten-4 {\n  border-right: 1px solid rgb(245.15625, 174.84375, 175.3125) !important;\n}\n\n.overlay-danger.overlay-lighten-4 {\n  background: rgb(245.15625, 174.84375, 175.3125); /* The Fallback */\n  background: rgba(245.15625, 174.84375, 175.3125, 0.6);\n}\n\n.danger.lighten-3 {\n  color: rgb(242.3671875, 152.1328125, 152.734375) !important;\n}\n\n.bg-danger.bg-lighten-3 {\n  background-color: rgb(242.3671875, 152.1328125, 152.734375) !important;\n}\n\n.btn-danger.btn-lighten-3 {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: rgb(242.3671875, 152.1328125, 152.734375) !important;\n}\n.btn-danger.btn-lighten-3:hover {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n}\n.btn-danger.btn-lighten-3:focus, .btn-danger.btn-lighten-3:active {\n  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n  background-color: rgb(192.375, 23.625, 24.75) !important;\n}\n\n.btn-outline-danger.btn-outline-lighten-3 {\n  border-color: rgb(242.3671875, 152.1328125, 152.734375) !important;\n  color: rgb(242.3671875, 152.1328125, 152.734375) !important;\n}\n.btn-outline-danger.btn-outline-lighten-3:hover {\n  background-color: rgb(242.3671875, 152.1328125, 152.734375) !important;\n}\n\ninput:focus ~ .bg-danger {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(242.3671875, 152.1328125, 152.734375) !important;\n}\n\n.border-danger.border-lighten-3 {\n  border: 1px solid rgb(242.3671875, 152.1328125, 152.734375) !important;\n}\n\n.border-top-danger.border-top-lighten-3 {\n  border-top: 1px solid rgb(242.3671875, 152.1328125, 152.734375) !important;\n}\n\n.border-bottom-danger.border-bottom-lighten-3 {\n  border-bottom: 1px solid rgb(242.3671875, 152.1328125, 152.734375) !important;\n}\n\n.border-left-danger.border-left-lighten-3 {\n  border-left: 1px solid rgb(242.3671875, 152.1328125, 152.734375) !important;\n}\n\n.border-right-danger.border-right-lighten-3 {\n  border-right: 1px solid rgb(242.3671875, 152.1328125, 152.734375) !important;\n}\n\n.overlay-danger.overlay-lighten-3 {\n  background: rgb(242.3671875, 152.1328125, 152.734375); /* The Fallback */\n  background: rgba(242.3671875, 152.1328125, 152.734375, 0.6);\n}\n\n.danger.lighten-2 {\n  color: rgb(239.578125, 129.421875, 130.15625) !important;\n}\n\n.bg-danger.bg-lighten-2 {\n  background-color: rgb(239.578125, 129.421875, 130.15625) !important;\n}\n\n.btn-danger.btn-lighten-2 {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: rgb(239.578125, 129.421875, 130.15625) !important;\n}\n.btn-danger.btn-lighten-2:hover {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n}\n.btn-danger.btn-lighten-2:focus, .btn-danger.btn-lighten-2:active {\n  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n  background-color: rgb(192.375, 23.625, 24.75) !important;\n}\n\n.btn-outline-danger.btn-outline-lighten-2 {\n  border-color: rgb(239.578125, 129.421875, 130.15625) !important;\n  color: rgb(239.578125, 129.421875, 130.15625) !important;\n}\n.btn-outline-danger.btn-outline-lighten-2:hover {\n  background-color: rgb(239.578125, 129.421875, 130.15625) !important;\n}\n\ninput:focus ~ .bg-danger {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(239.578125, 129.421875, 130.15625) !important;\n}\n\n.border-danger.border-lighten-2 {\n  border: 1px solid rgb(239.578125, 129.421875, 130.15625) !important;\n}\n\n.border-top-danger.border-top-lighten-2 {\n  border-top: 1px solid rgb(239.578125, 129.421875, 130.15625) !important;\n}\n\n.border-bottom-danger.border-bottom-lighten-2 {\n  border-bottom: 1px solid rgb(239.578125, 129.421875, 130.15625) !important;\n}\n\n.border-left-danger.border-left-lighten-2 {\n  border-left: 1px solid rgb(239.578125, 129.421875, 130.15625) !important;\n}\n\n.border-right-danger.border-right-lighten-2 {\n  border-right: 1px solid rgb(239.578125, 129.421875, 130.15625) !important;\n}\n\n.overlay-danger.overlay-lighten-2 {\n  background: rgb(239.578125, 129.421875, 130.15625); /* The Fallback */\n  background: rgba(239.578125, 129.421875, 130.15625, 0.6);\n}\n\n.danger.lighten-1 {\n  color: rgb(236.7890625, 106.7109375, 107.578125) !important;\n}\n\n.bg-danger.bg-lighten-1 {\n  background-color: rgb(236.7890625, 106.7109375, 107.578125) !important;\n}\n\n.btn-danger.btn-lighten-1 {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: rgb(236.7890625, 106.7109375, 107.578125) !important;\n}\n.btn-danger.btn-lighten-1:hover {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n}\n.btn-danger.btn-lighten-1:focus, .btn-danger.btn-lighten-1:active {\n  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n  background-color: rgb(192.375, 23.625, 24.75) !important;\n}\n\n.btn-outline-danger.btn-outline-lighten-1 {\n  border-color: rgb(236.7890625, 106.7109375, 107.578125) !important;\n  color: rgb(236.7890625, 106.7109375, 107.578125) !important;\n}\n.btn-outline-danger.btn-outline-lighten-1:hover {\n  background-color: rgb(236.7890625, 106.7109375, 107.578125) !important;\n}\n\ninput:focus ~ .bg-danger {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(236.7890625, 106.7109375, 107.578125) !important;\n}\n\n.border-danger.border-lighten-1 {\n  border: 1px solid rgb(236.7890625, 106.7109375, 107.578125) !important;\n}\n\n.border-top-danger.border-top-lighten-1 {\n  border-top: 1px solid rgb(236.7890625, 106.7109375, 107.578125) !important;\n}\n\n.border-bottom-danger.border-bottom-lighten-1 {\n  border-bottom: 1px solid rgb(236.7890625, 106.7109375, 107.578125) !important;\n}\n\n.border-left-danger.border-left-lighten-1 {\n  border-left: 1px solid rgb(236.7890625, 106.7109375, 107.578125) !important;\n}\n\n.border-right-danger.border-right-lighten-1 {\n  border-right: 1px solid rgb(236.7890625, 106.7109375, 107.578125) !important;\n}\n\n.overlay-danger.overlay-lighten-1 {\n  background: rgb(236.7890625, 106.7109375, 107.578125); /* The Fallback */\n  background: rgba(236.7890625, 106.7109375, 107.578125, 0.6);\n}\n\n.danger {\n  color: #ea5455 !important;\n}\n\n.bg-danger {\n  background-color: #ea5455 !important;\n}\n.bg-danger .card-header,\n.bg-danger .card-footer {\n  background-color: transparent;\n}\n\n.alert-danger {\n  background: rgba(234, 84, 85, 0.2) !important;\n  color: #ea5455 !important;\n}\n.alert-danger .alert-heading {\n  box-shadow: rgba(234, 84, 85, 0.4) 0px 6px 15px -7px;\n}\n.alert-danger .alert-link {\n  color: rgb(231.2109375, 61.2890625, 62.421875) !important;\n}\n\n.bg-rgba-danger {\n  background: rgba(234, 84, 85, 0.15) !important;\n}\n\n.border-danger {\n  border: 1px solid #ea5455 !important;\n}\n\n.border-top-danger {\n  border-top: 1px solid #ea5455;\n}\n\n.border-bottom-danger {\n  border-bottom: 1px solid #ea5455;\n}\n\n.border-left-danger {\n  border-left: 1px solid #ea5455;\n}\n\n.border-right-danger {\n  border-right: 1px solid #ea5455;\n}\n\n.badge.badge-light-danger {\n  background-color: rgb(250.734375, 220.265625, 220.46875);\n  color: #ea5455 !important;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.bg-danger.badge-glow,\n.border-danger.badge-glow,\n.badge-danger.badge-glow {\n  box-shadow: 0px 0px 10px #ea5455;\n}\n\n.overlay-danger {\n  background: #ea5455; /* The Fallback */\n  background: rgba(234, 84, 85, 0.6);\n}\n\n.btn-danger {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: #ea5455 !important;\n  color: #fff;\n}\n.btn-danger:hover {\n  border-color: rgb(231.2109375, 61.2890625, 62.421875) !important;\n  color: #fff !important;\n  box-shadow: 0 8px 25px -8px #ea5455;\n}\n.btn-danger:focus, .btn-danger:active {\n  color: #fff !important;\n}\n\n.btn-flat-danger {\n  background-color: transparent;\n  color: #ea5455;\n}\n.btn-flat-danger:hover {\n  color: #ea5455;\n  background-color: rgba(234, 84, 85, 0.1);\n}\n.btn-flat-danger:active, .btn-flat-danger:focus {\n  background-color: #ea5455;\n  color: #fff !important;\n}\n\n.btn-relief-danger {\n  background-color: #ea5455;\n  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.2);\n  color: #fff;\n}\n.btn-relief-danger:hover {\n  color: #fff;\n}\n.btn-relief-danger:active, .btn-relief-danger:focus {\n  outline: none;\n  transform: translateY(3px);\n}\n\n.btn-outline-danger {\n  border: 1px solid #ea5455;\n  background-color: transparent;\n  color: #ea5455;\n}\n.btn-outline-danger:hover {\n  background-color: rgba(234, 84, 85, 0.08);\n  color: #ea5455;\n}\n.btn-outline-danger:active {\n  color: #fff !important;\n}\n\n.btn-danger ~ .dropdown-menu .dropdown-item.active,\n.btn-outline-danger ~ .dropdown-menu .dropdown-item.active,\n.btn-flat-danger ~ .dropdown-menu .dropdown-item.active {\n  background-color: #ea5455;\n  color: #fff;\n}\n.btn-danger ~ .dropdown-menu .dropdown-item.active:hover,\n.btn-outline-danger ~ .dropdown-menu .dropdown-item.active:hover,\n.btn-flat-danger ~ .dropdown-menu .dropdown-item.active:hover {\n  color: #fff;\n}\n.btn-danger ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,\n.btn-outline-danger ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover,\n.btn-flat-danger ~ .dropdown-menu .dropdown-item:not(.active):not(:active):hover {\n  color: #ea5455;\n}\n\n.bullet.bullet-danger {\n  background-color: #ea5455;\n}\n.bullet.bullet-danger.bullet-bordered {\n  background-color: transparent;\n  border: 2px solid #ea5455;\n}\n\n.pagination-danger li.active a,\n.pagination-danger li.active .page-link,\n.pagination-danger .page-item.active a,\n.pagination-danger .page-item.active .page-link {\n  background: #ea5455 !important;\n  color: #fff;\n}\n.pagination-danger li.active a:hover,\n.pagination-danger li.active .page-link:hover,\n.pagination-danger .page-item.active a:hover,\n.pagination-danger .page-item.active .page-link:hover {\n  color: #fff !important;\n}\n.pagination-danger li a:hover,\n.pagination-danger li .page-link:hover,\n.pagination-danger .page-item a:hover,\n.pagination-danger .page-item .page-link:hover {\n  color: #ea5455 !important;\n}\n.pagination-danger li.prev-item .page-link:hover, .pagination-danger li.next-item .page-link:hover,\n.pagination-danger .page-item.prev-item .page-link:hover,\n.pagination-danger .page-item.next-item .page-link:hover {\n  background: #ea5455;\n  color: #fff;\n}\n\n.nav-pill-danger .nav-item .nav-link.active {\n  color: #fff;\n  background-color: #ea5455;\n}\n\n.chip-danger {\n  background-color: #ea5455 !important;\n}\n.chip-danger .chip-body {\n  color: #fff !important;\n}\n\n.divider.divider-danger .divider-text:before, .divider.divider-danger .divider-text:after {\n  border-color: #ea5455 !important;\n}\n\ninput[type=checkbox].bg-danger + .custom-control-label:before, input[type=radio].bg-danger + .custom-control-label:before {\n  background-color: #ea5455 !important;\n}\n\ninput:focus ~ .bg-danger {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #ea5455 !important;\n}\n\n.vx-checkbox-danger input:checked ~ .vx-checkbox {\n  border-color: #ea5455 !important;\n}\n.vx-checkbox-danger input:checked ~ .vx-checkbox .vx-checkbox--check {\n  background-color: #ea5455 !important;\n}\n.vx-checkbox-danger input:active:checked + .vx-checkbox .vx-checkbox--check {\n  background-color: #ea5455 !important;\n}\n\n.vertical-layout .main-menu.theme-danger .navbar-header .navbar-nav .brand-text {\n  color: #ea5455;\n}\n.vertical-layout .main-menu.theme-danger .navigation .nav-item.active a {\n  background: linear-gradient(118deg, #ea5455, rgba(234, 84, 85, 0.7));\n  box-shadow: 0 0 10px 1px rgba(234, 84, 85, 0.7) !important;\n}\n.vertical-layout .main-menu.theme-danger .navigation .nav-item .menu-content li.active {\n  background: linear-gradient(118deg, #ea5455, rgba(234, 84, 85, 0.7));\n  box-shadow: 0 0 10px 1px rgba(234, 84, 85, 0.7) !important;\n}\n\n.horizontal-layout.theme-danger .header-navbar .brand-text {\n  color: #ea5455 !important;\n}\n.horizontal-layout.theme-danger .navbar-horizontal #main-menu-navigation .nav-item.active .nav-link {\n  background: linear-gradient(118deg, #ea5455, rgba(234, 84, 85, 0.7));\n  box-shadow: 0 0 10px 1px rgba(234, 84, 85, 0.7) !important;\n}\n\n.custom-switch-danger .custom-control-input:checked ~ .custom-control-label::before {\n  background-color: #ea5455 !important;\n  color: #fff;\n  transition: all 0.2s ease-out;\n}\n\n.color-radio.color-radio-danger {\n  border: 1px solid transparent;\n}\n.color-radio.color-radio-danger.selected {\n  border-color: #ea5455;\n}\n.color-radio.color-radio-danger .radio-content {\n  background-color: #ea5455;\n}\n\n.vx-radio-danger input:checked ~ .vx-radio .vx-radio--circle {\n  background: #ea5455 !important;\n  box-shadow: 0 3px 12px 0 rgba(234, 84, 85, 0.4) !important;\n}\n\n.danger.darken-1 {\n  color: rgb(231.2109375, 61.2890625, 62.421875) !important;\n}\n\n.bg-danger.bg-darken-1 {\n  background-color: rgb(231.2109375, 61.2890625, 62.421875) !important;\n}\n\n.btn-danger.btn-darken-1 {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: rgb(231.2109375, 61.2890625, 62.421875) !important;\n}\n.btn-danger.btn-darken-1:hover {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n}\n.btn-danger.btn-darken-1:focus, .btn-danger.btn-darken-1:active {\n  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n  background-color: rgb(192.375, 23.625, 24.75) !important;\n}\n\n.btn-outline-danger.btn-outline-darken-1 {\n  border-color: rgb(231.2109375, 61.2890625, 62.421875) !important;\n  color: rgb(231.2109375, 61.2890625, 62.421875) !important;\n}\n.btn-outline-danger.btn-outline-darken-1:hover {\n  background-color: rgb(231.2109375, 61.2890625, 62.421875) !important;\n}\n\ninput:focus ~ .bg-danger {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(231.2109375, 61.2890625, 62.421875) !important;\n}\n\n.border-danger.border-darken-1 {\n  border: 1px solid rgb(231.2109375, 61.2890625, 62.421875) !important;\n}\n\n.border-top-danger.border-top-darken-1 {\n  border-top: 1px solid rgb(231.2109375, 61.2890625, 62.421875) !important;\n}\n\n.border-bottom-danger.border-bottom-darken-1 {\n  border-bottom: 1px solid rgb(231.2109375, 61.2890625, 62.421875) !important;\n}\n\n.border-left-danger.border-left-darken-1 {\n  border-left: 1px solid rgb(231.2109375, 61.2890625, 62.421875) !important;\n}\n\n.border-right-danger.border-right-darken-1 {\n  border-right: 1px solid rgb(231.2109375, 61.2890625, 62.421875) !important;\n}\n\n.overlay-danger.overlay-darken-1 {\n  background: rgb(231.2109375, 61.2890625, 62.421875); /* The Fallback */\n  background: rgba(231.2109375, 61.2890625, 62.421875, 0.6);\n}\n\n.danger.darken-2 {\n  color: rgb(228.421875, 38.578125, 39.84375) !important;\n}\n\n.bg-danger.bg-darken-2 {\n  background-color: rgb(228.421875, 38.578125, 39.84375) !important;\n}\n\n.btn-danger.btn-darken-2 {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: rgb(228.421875, 38.578125, 39.84375) !important;\n}\n.btn-danger.btn-darken-2:hover {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n}\n.btn-danger.btn-darken-2:focus, .btn-danger.btn-darken-2:active {\n  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n  background-color: rgb(192.375, 23.625, 24.75) !important;\n}\n\n.btn-outline-danger.btn-outline-darken-2 {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  color: rgb(228.421875, 38.578125, 39.84375) !important;\n}\n.btn-outline-danger.btn-outline-darken-2:hover {\n  background-color: rgb(228.421875, 38.578125, 39.84375) !important;\n}\n\ninput:focus ~ .bg-danger {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(228.421875, 38.578125, 39.84375) !important;\n}\n\n.border-danger.border-darken-2 {\n  border: 1px solid rgb(228.421875, 38.578125, 39.84375) !important;\n}\n\n.border-top-danger.border-top-darken-2 {\n  border-top: 1px solid rgb(228.421875, 38.578125, 39.84375) !important;\n}\n\n.border-bottom-danger.border-bottom-darken-2 {\n  border-bottom: 1px solid rgb(228.421875, 38.578125, 39.84375) !important;\n}\n\n.border-left-danger.border-left-darken-2 {\n  border-left: 1px solid rgb(228.421875, 38.578125, 39.84375) !important;\n}\n\n.border-right-danger.border-right-darken-2 {\n  border-right: 1px solid rgb(228.421875, 38.578125, 39.84375) !important;\n}\n\n.overlay-danger.overlay-darken-2 {\n  background: rgb(228.421875, 38.578125, 39.84375); /* The Fallback */\n  background: rgba(228.421875, 38.578125, 39.84375, 0.6);\n}\n\n.danger.darken-3 {\n  color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n}\n\n.bg-danger.bg-darken-3 {\n  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n}\n\n.btn-danger.btn-darken-3 {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n}\n.btn-danger.btn-darken-3:hover {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n}\n.btn-danger.btn-darken-3:focus, .btn-danger.btn-darken-3:active {\n  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n  background-color: rgb(192.375, 23.625, 24.75) !important;\n}\n\n.btn-outline-danger.btn-outline-darken-3 {\n  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n  color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n}\n.btn-outline-danger.btn-outline-darken-3:hover {\n  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n}\n\ninput:focus ~ .bg-danger {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(215.0859375, 26.4140625, 27.671875) !important;\n}\n\n.border-danger.border-darken-3 {\n  border: 1px solid rgb(215.0859375, 26.4140625, 27.671875) !important;\n}\n\n.border-top-danger.border-top-darken-3 {\n  border-top: 1px solid rgb(215.0859375, 26.4140625, 27.671875) !important;\n}\n\n.border-bottom-danger.border-bottom-darken-3 {\n  border-bottom: 1px solid rgb(215.0859375, 26.4140625, 27.671875) !important;\n}\n\n.border-left-danger.border-left-darken-3 {\n  border-left: 1px solid rgb(215.0859375, 26.4140625, 27.671875) !important;\n}\n\n.border-right-danger.border-right-darken-3 {\n  border-right: 1px solid rgb(215.0859375, 26.4140625, 27.671875) !important;\n}\n\n.overlay-danger.overlay-darken-3 {\n  background: rgb(215.0859375, 26.4140625, 27.671875); /* The Fallback */\n  background: rgba(215.0859375, 26.4140625, 27.671875, 0.6);\n}\n\n.danger.darken-4 {\n  color: rgb(192.375, 23.625, 24.75) !important;\n}\n\n.bg-danger.bg-darken-4 {\n  background-color: rgb(192.375, 23.625, 24.75) !important;\n}\n\n.btn-danger.btn-darken-4 {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: rgb(192.375, 23.625, 24.75) !important;\n}\n.btn-danger.btn-darken-4:hover {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n}\n.btn-danger.btn-darken-4:focus, .btn-danger.btn-darken-4:active {\n  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n  background-color: rgb(192.375, 23.625, 24.75) !important;\n}\n\n.btn-outline-danger.btn-outline-darken-4 {\n  border-color: rgb(192.375, 23.625, 24.75) !important;\n  color: rgb(192.375, 23.625, 24.75) !important;\n}\n.btn-outline-danger.btn-outline-darken-4:hover {\n  background-color: rgb(192.375, 23.625, 24.75) !important;\n}\n\ninput:focus ~ .bg-danger {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem rgb(192.375, 23.625, 24.75) !important;\n}\n\n.border-danger.border-darken-4 {\n  border: 1px solid rgb(192.375, 23.625, 24.75) !important;\n}\n\n.border-top-danger.border-top-darken-4 {\n  border-top: 1px solid rgb(192.375, 23.625, 24.75) !important;\n}\n\n.border-bottom-danger.border-bottom-darken-4 {\n  border-bottom: 1px solid rgb(192.375, 23.625, 24.75) !important;\n}\n\n.border-left-danger.border-left-darken-4 {\n  border-left: 1px solid rgb(192.375, 23.625, 24.75) !important;\n}\n\n.border-right-danger.border-right-darken-4 {\n  border-right: 1px solid rgb(192.375, 23.625, 24.75) !important;\n}\n\n.overlay-danger.overlay-darken-4 {\n  background: rgb(192.375, 23.625, 24.75); /* The Fallback */\n  background: rgba(192.375, 23.625, 24.75, 0.6);\n}\n\n.danger.accent-1 {\n  color: #ffeef1 !important;\n}\n\n.bg-danger.bg-accent-1 {\n  background-color: #ffeef1 !important;\n}\n\n.btn-danger.btn-accent-1 {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: #ffeef1 !important;\n}\n.btn-danger.btn-accent-1:hover {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n}\n.btn-danger.btn-accent-1:focus, .btn-danger.btn-accent-1:active {\n  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n  background-color: rgb(192.375, 23.625, 24.75) !important;\n}\n\n.btn-outline-danger.btn-outline-accent-1 {\n  border-color: #ffeef1 !important;\n  color: #ffeef1 !important;\n}\n.btn-outline-danger.btn-outline-accent-1:hover {\n  background-color: #ffeef1 !important;\n}\n\ninput:focus ~ .bg-danger {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #ffeef1 !important;\n}\n\n.border-danger.border-accent-1 {\n  border: 1px solid #ffeef1 !important;\n}\n\n.border-top-danger.border-top-accent-1 {\n  border-top: 1px solid #ffeef1 !important;\n}\n\n.border-bottom-danger.border-bottom-accent-1 {\n  border-bottom: 1px solid #ffeef1 !important;\n}\n\n.border-left-danger.border-left-accent-1 {\n  border-left: 1px solid #ffeef1 !important;\n}\n\n.border-right-danger.border-right-accent-1 {\n  border-right: 1px solid #ffeef1 !important;\n}\n\n.overlay-danger.overlay-accent-1 {\n  background: #ffeef1; /* The Fallback */\n  background: rgba(255, 238, 241, 0.6);\n}\n\n.danger.accent-2 {\n  color: #ffd6db !important;\n}\n\n.bg-danger.bg-accent-2 {\n  background-color: #ffd6db !important;\n}\n\n.btn-danger.btn-accent-2 {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: #ffd6db !important;\n}\n.btn-danger.btn-accent-2:hover {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n}\n.btn-danger.btn-accent-2:focus, .btn-danger.btn-accent-2:active {\n  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n  background-color: rgb(192.375, 23.625, 24.75) !important;\n}\n\n.btn-outline-danger.btn-outline-accent-2 {\n  border-color: #ffd6db !important;\n  color: #ffd6db !important;\n}\n.btn-outline-danger.btn-outline-accent-2:hover {\n  background-color: #ffd6db !important;\n}\n\ninput:focus ~ .bg-danger {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #ffd6db !important;\n}\n\n.border-danger.border-accent-2 {\n  border: 1px solid #ffd6db !important;\n}\n\n.border-top-danger.border-top-accent-2 {\n  border-top: 1px solid #ffd6db !important;\n}\n\n.border-bottom-danger.border-bottom-accent-2 {\n  border-bottom: 1px solid #ffd6db !important;\n}\n\n.border-left-danger.border-left-accent-2 {\n  border-left: 1px solid #ffd6db !important;\n}\n\n.border-right-danger.border-right-accent-2 {\n  border-right: 1px solid #ffd6db !important;\n}\n\n.overlay-danger.overlay-accent-2 {\n  background: #ffd6db; /* The Fallback */\n  background: rgba(255, 214, 219, 0.6);\n}\n\n.danger.accent-3 {\n  color: #ffecee !important;\n}\n\n.bg-danger.bg-accent-3 {\n  background-color: #ffecee !important;\n}\n\n.btn-danger.btn-accent-3 {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: #ffecee !important;\n}\n.btn-danger.btn-accent-3:hover {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n}\n.btn-danger.btn-accent-3:focus, .btn-danger.btn-accent-3:active {\n  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n  background-color: rgb(192.375, 23.625, 24.75) !important;\n}\n\n.btn-outline-danger.btn-outline-accent-3 {\n  border-color: #ffecee !important;\n  color: #ffecee !important;\n}\n.btn-outline-danger.btn-outline-accent-3:hover {\n  background-color: #ffecee !important;\n}\n\ninput:focus ~ .bg-danger {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #ffecee !important;\n}\n\n.border-danger.border-accent-3 {\n  border: 1px solid #ffecee !important;\n}\n\n.border-top-danger.border-top-accent-3 {\n  border-top: 1px solid #ffecee !important;\n}\n\n.border-bottom-danger.border-bottom-accent-3 {\n  border-bottom: 1px solid #ffecee !important;\n}\n\n.border-left-danger.border-left-accent-3 {\n  border-left: 1px solid #ffecee !important;\n}\n\n.border-right-danger.border-right-accent-3 {\n  border-right: 1px solid #ffecee !important;\n}\n\n.overlay-danger.overlay-accent-3 {\n  background: #ffecee; /* The Fallback */\n  background: rgba(255, 236, 238, 0.6);\n}\n\n.danger.accent-4 {\n  color: #ffd3d7 !important;\n}\n\n.bg-danger.bg-accent-4 {\n  background-color: #ffd3d7 !important;\n}\n\n.btn-danger.btn-accent-4 {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: #ffd3d7 !important;\n}\n.btn-danger.btn-accent-4:hover {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n}\n.btn-danger.btn-accent-4:focus, .btn-danger.btn-accent-4:active {\n  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n  background-color: rgb(192.375, 23.625, 24.75) !important;\n}\n\n.btn-outline-danger.btn-outline-accent-4 {\n  border-color: #ffd3d7 !important;\n  color: #ffd3d7 !important;\n}\n.btn-outline-danger.btn-outline-accent-4:hover {\n  background-color: #ffd3d7 !important;\n}\n\ninput:focus ~ .bg-danger {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #ffd3d7 !important;\n}\n\n.border-danger.border-accent-4 {\n  border: 1px solid #ffd3d7 !important;\n}\n\n.border-top-danger.border-top-accent-4 {\n  border-top: 1px solid #ffd3d7 !important;\n}\n\n.border-bottom-danger.border-bottom-accent-4 {\n  border-bottom: 1px solid #ffd3d7 !important;\n}\n\n.border-left-danger.border-left-accent-4 {\n  border-left: 1px solid #ffd3d7 !important;\n}\n\n.border-right-danger.border-right-accent-4 {\n  border-right: 1px solid #ffd3d7 !important;\n}\n\n.overlay-danger.overlay-accent-4 {\n  background: #ffd3d7; /* The Fallback */\n  background: rgba(255, 211, 215, 0.6);\n}\n\n.danger.gradient-bg {\n  color: #640064 !important;\n}\n\n.bg-danger.bg-gradient-bg {\n  background-color: #640064 !important;\n}\n\n.btn-danger.btn-gradient-bg {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: #640064 !important;\n}\n.btn-danger.btn-gradient-bg:hover {\n  border-color: rgb(228.421875, 38.578125, 39.84375) !important;\n  background-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n}\n.btn-danger.btn-gradient-bg:focus, .btn-danger.btn-gradient-bg:active {\n  border-color: rgb(215.0859375, 26.4140625, 27.671875) !important;\n  background-color: rgb(192.375, 23.625, 24.75) !important;\n}\n\n.btn-outline-danger.btn-outline-gradient-bg {\n  border-color: #640064 !important;\n  color: #640064 !important;\n}\n.btn-outline-danger.btn-outline-gradient-bg:hover {\n  background-color: #640064 !important;\n}\n\ninput:focus ~ .bg-danger {\n  box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #640064 !important;\n}\n\n.border-danger.border-gradient-bg {\n  border: 1px solid #640064 !important;\n}\n\n.border-top-danger.border-top-gradient-bg {\n  border-top: 1px solid #640064 !important;\n}\n\n.border-bottom-danger.border-bottom-gradient-bg {\n  border-bottom: 1px solid #640064 !important;\n}\n\n.border-left-danger.border-left-gradient-bg {\n  border-left: 1px solid #640064 !important;\n}\n\n.border-right-danger.border-right-gradient-bg {\n  border-right: 1px solid #640064 !important;\n}\n\n.overlay-danger.overlay-gradient-bg {\n  background: #640064; /* The Fallback */\n  background: rgba(100, 0, 100, 0.6);\n}\n\n@font-face {\n  font-family: \"feather\";\n  src: url(\"../fonts/feather.eot?t=1501834582692\"); /* IE9*/\n  src: url(\"../fonts/feather.eot?t=1501834582692#iefix\") format(\"embedded-opentype\"), url(\"../fonts/feather.woff?t=1501834582692\") format(\"woff\"), url(\"../fonts/feather.ttf?t=1501834582692\") format(\"truetype\"), url(\"../fonts/feather.svg?t=1501834582692#feather\") format(\"svg\"); /* iOS 4.1- */\n}\n.feather {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: \"feather\" !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-alert-octagon:before {\n  content: \"\\e81b\";\n}\n\n.icon-alert-circle:before {\n  content: \"\\e81c\";\n}\n\n.icon-activity:before {\n  content: \"\\e81d\";\n}\n\n.icon-alert-triangle:before {\n  content: \"\\e81e\";\n}\n\n.icon-align-center:before {\n  content: \"\\e81f\";\n}\n\n.icon-airplay:before {\n  content: \"\\e820\";\n}\n\n.icon-align-justify:before {\n  content: \"\\e821\";\n}\n\n.icon-align-left:before {\n  content: \"\\e822\";\n}\n\n.icon-align-right:before {\n  content: \"\\e823\";\n}\n\n.icon-arrow-down-left:before {\n  content: \"\\e824\";\n}\n\n.icon-arrow-down-right:before {\n  content: \"\\e825\";\n}\n\n.icon-anchor:before {\n  content: \"\\e826\";\n}\n\n.icon-aperture:before {\n  content: \"\\e827\";\n}\n\n.icon-arrow-left:before {\n  content: \"\\e828\";\n}\n\n.icon-arrow-right:before {\n  content: \"\\e829\";\n}\n\n.icon-arrow-down:before {\n  content: \"\\e82a\";\n}\n\n.icon-arrow-up-left:before {\n  content: \"\\e82b\";\n}\n\n.icon-arrow-up-right:before {\n  content: \"\\e82c\";\n}\n\n.icon-arrow-up:before {\n  content: \"\\e82d\";\n}\n\n.icon-award:before {\n  content: \"\\e82e\";\n}\n\n.icon-bar-chart:before {\n  content: \"\\e82f\";\n}\n\n.icon-at-sign:before {\n  content: \"\\e830\";\n}\n\n.icon-bar-chart-2:before {\n  content: \"\\e831\";\n}\n\n.icon-battery-charging:before {\n  content: \"\\e832\";\n}\n\n.icon-bell-off:before {\n  content: \"\\e833\";\n}\n\n.icon-battery:before {\n  content: \"\\e834\";\n}\n\n.icon-bluetooth:before {\n  content: \"\\e835\";\n}\n\n.icon-bell:before {\n  content: \"\\e836\";\n}\n\n.icon-book:before {\n  content: \"\\e837\";\n}\n\n.icon-briefcase:before {\n  content: \"\\e838\";\n}\n\n.icon-camera-off:before {\n  content: \"\\e839\";\n}\n\n.icon-calendar:before {\n  content: \"\\e83a\";\n}\n\n.icon-bookmark:before {\n  content: \"\\e83b\";\n}\n\n.icon-box:before {\n  content: \"\\e83c\";\n}\n\n.icon-camera:before {\n  content: \"\\e83d\";\n}\n\n.icon-check-circle:before {\n  content: \"\\e83e\";\n}\n\n.icon-check:before {\n  content: \"\\e83f\";\n}\n\n.icon-check-square:before {\n  content: \"\\e840\";\n}\n\n.icon-cast:before {\n  content: \"\\e841\";\n}\n\n.icon-chevron-down:before {\n  content: \"\\e842\";\n}\n\n.icon-chevron-left:before {\n  content: \"\\e843\";\n}\n\n.icon-chevron-right:before {\n  content: \"\\e844\";\n}\n\n.icon-chevron-up:before {\n  content: \"\\e845\";\n}\n\n.icon-chevrons-down:before {\n  content: \"\\e846\";\n}\n\n.icon-chevrons-right:before {\n  content: \"\\e847\";\n}\n\n.icon-chevrons-up:before {\n  content: \"\\e848\";\n}\n\n.icon-chevrons-left:before {\n  content: \"\\e849\";\n}\n\n.icon-circle:before {\n  content: \"\\e84a\";\n}\n\n.icon-clipboard:before {\n  content: \"\\e84b\";\n}\n\n.icon-chrome:before {\n  content: \"\\e84c\";\n}\n\n.icon-clock:before {\n  content: \"\\e84d\";\n}\n\n.icon-cloud-lightning:before {\n  content: \"\\e84e\";\n}\n\n.icon-cloud-drizzle:before {\n  content: \"\\e84f\";\n}\n\n.icon-cloud-rain:before {\n  content: \"\\e850\";\n}\n\n.icon-cloud-off:before {\n  content: \"\\e851\";\n}\n\n.icon-codepen:before {\n  content: \"\\e852\";\n}\n\n.icon-cloud-snow:before {\n  content: \"\\e853\";\n}\n\n.icon-compass:before {\n  content: \"\\e854\";\n}\n\n.icon-copy:before {\n  content: \"\\e855\";\n}\n\n.icon-corner-down-right:before {\n  content: \"\\e856\";\n}\n\n.icon-corner-down-left:before {\n  content: \"\\e857\";\n}\n\n.icon-corner-left-down:before {\n  content: \"\\e858\";\n}\n\n.icon-corner-left-up:before {\n  content: \"\\e859\";\n}\n\n.icon-corner-up-left:before {\n  content: \"\\e85a\";\n}\n\n.icon-corner-up-right:before {\n  content: \"\\e85b\";\n}\n\n.icon-corner-right-down:before {\n  content: \"\\e85c\";\n}\n\n.icon-corner-right-up:before {\n  content: \"\\e85d\";\n}\n\n.icon-cpu:before {\n  content: \"\\e85e\";\n}\n\n.icon-credit-card:before {\n  content: \"\\e85f\";\n}\n\n.icon-crosshair:before {\n  content: \"\\e860\";\n}\n\n.icon-disc:before {\n  content: \"\\e861\";\n}\n\n.icon-delete:before {\n  content: \"\\e862\";\n}\n\n.icon-download-cloud:before {\n  content: \"\\e863\";\n}\n\n.icon-download:before {\n  content: \"\\e864\";\n}\n\n.icon-droplet:before {\n  content: \"\\e865\";\n}\n\n.icon-edit-2:before {\n  content: \"\\e866\";\n}\n\n.icon-edit:before {\n  content: \"\\e867\";\n}\n\n.icon-edit-1:before {\n  content: \"\\e868\";\n}\n\n.icon-external-link:before {\n  content: \"\\e869\";\n}\n\n.icon-eye:before {\n  content: \"\\e86a\";\n}\n\n.icon-feather:before {\n  content: \"\\e86b\";\n}\n\n.icon-facebook:before {\n  content: \"\\e86c\";\n}\n\n.icon-file-minus:before {\n  content: \"\\e86d\";\n}\n\n.icon-eye-off:before {\n  content: \"\\e86e\";\n}\n\n.icon-fast-forward:before {\n  content: \"\\e86f\";\n}\n\n.icon-file-text:before {\n  content: \"\\e870\";\n}\n\n.icon-film:before {\n  content: \"\\e871\";\n}\n\n.icon-file:before {\n  content: \"\\e872\";\n}\n\n.icon-file-plus:before {\n  content: \"\\e873\";\n}\n\n.icon-folder:before {\n  content: \"\\e874\";\n}\n\n.icon-filter:before {\n  content: \"\\e875\";\n}\n\n.icon-flag:before {\n  content: \"\\e876\";\n}\n\n.icon-globe:before {\n  content: \"\\e877\";\n}\n\n.icon-grid:before {\n  content: \"\\e878\";\n}\n\n.icon-heart:before {\n  content: \"\\e879\";\n}\n\n.icon-home:before {\n  content: \"\\e87a\";\n}\n\n.icon-github:before {\n  content: \"\\e87b\";\n}\n\n.icon-image:before {\n  content: \"\\e87c\";\n}\n\n.icon-inbox:before {\n  content: \"\\e87d\";\n}\n\n.icon-layers:before {\n  content: \"\\e87e\";\n}\n\n.icon-info:before {\n  content: \"\\e87f\";\n}\n\n.icon-instagram:before {\n  content: \"\\e880\";\n}\n\n.icon-layout:before {\n  content: \"\\e881\";\n}\n\n.icon-link-2:before {\n  content: \"\\e882\";\n}\n\n.icon-life-buoy:before {\n  content: \"\\e883\";\n}\n\n.icon-link:before {\n  content: \"\\e884\";\n}\n\n.icon-log-in:before {\n  content: \"\\e885\";\n}\n\n.icon-list:before {\n  content: \"\\e886\";\n}\n\n.icon-lock:before {\n  content: \"\\e887\";\n}\n\n.icon-log-out:before {\n  content: \"\\e888\";\n}\n\n.icon-loader:before {\n  content: \"\\e889\";\n}\n\n.icon-mail:before {\n  content: \"\\e88a\";\n}\n\n.icon-maximize-2:before {\n  content: \"\\e88b\";\n}\n\n.icon-map:before {\n  content: \"\\e88c\";\n}\n\n.icon-map-pin:before {\n  content: \"\\e88e\";\n}\n\n.icon-menu:before {\n  content: \"\\e88f\";\n}\n\n.icon-message-circle:before {\n  content: \"\\e890\";\n}\n\n.icon-message-square:before {\n  content: \"\\e891\";\n}\n\n.icon-minimize-2:before {\n  content: \"\\e892\";\n}\n\n.icon-mic-off:before {\n  content: \"\\e893\";\n}\n\n.icon-minus-circle:before {\n  content: \"\\e894\";\n}\n\n.icon-mic:before {\n  content: \"\\e895\";\n}\n\n.icon-minus-square:before {\n  content: \"\\e896\";\n}\n\n.icon-minus:before {\n  content: \"\\e897\";\n}\n\n.icon-moon:before {\n  content: \"\\e898\";\n}\n\n.icon-monitor:before {\n  content: \"\\e899\";\n}\n\n.icon-more-vertical:before {\n  content: \"\\e89a\";\n}\n\n.icon-more-horizontal:before {\n  content: \"\\e89b\";\n}\n\n.icon-move:before {\n  content: \"\\e89c\";\n}\n\n.icon-music:before {\n  content: \"\\e89d\";\n}\n\n.icon-navigation-2:before {\n  content: \"\\e89e\";\n}\n\n.icon-navigation:before {\n  content: \"\\e89f\";\n}\n\n.icon-octagon:before {\n  content: \"\\e8a0\";\n}\n\n.icon-package:before {\n  content: \"\\e8a1\";\n}\n\n.icon-pause-circle:before {\n  content: \"\\e8a2\";\n}\n\n.icon-pause:before {\n  content: \"\\e8a3\";\n}\n\n.icon-percent:before {\n  content: \"\\e8a4\";\n}\n\n.icon-phone-call:before {\n  content: \"\\e8a5\";\n}\n\n.icon-phone-forwarded:before {\n  content: \"\\e8a6\";\n}\n\n.icon-phone-missed:before {\n  content: \"\\e8a7\";\n}\n\n.icon-phone-off:before {\n  content: \"\\e8a8\";\n}\n\n.icon-phone-incoming:before {\n  content: \"\\e8a9\";\n}\n\n.icon-phone:before {\n  content: \"\\e8aa\";\n}\n\n.icon-phone-outgoing:before {\n  content: \"\\e8ab\";\n}\n\n.icon-pie-chart:before {\n  content: \"\\e8ac\";\n}\n\n.icon-play-circle:before {\n  content: \"\\e8ad\";\n}\n\n.icon-play:before {\n  content: \"\\e8ae\";\n}\n\n.icon-plus-square:before {\n  content: \"\\e8af\";\n}\n\n.icon-plus-circle:before {\n  content: \"\\e8b0\";\n}\n\n.icon-plus:before {\n  content: \"\\e8b1\";\n}\n\n.icon-pocket:before {\n  content: \"\\e8b2\";\n}\n\n.icon-printer:before {\n  content: \"\\e8b3\";\n}\n\n.icon-power:before {\n  content: \"\\e8b4\";\n}\n\n.icon-radio:before {\n  content: \"\\e8b5\";\n}\n\n.icon-repeat:before {\n  content: \"\\e8b6\";\n}\n\n.icon-refresh-ccw:before {\n  content: \"\\e8b7\";\n}\n\n.icon-rewind:before {\n  content: \"\\e8b8\";\n}\n\n.icon-rotate-ccw:before {\n  content: \"\\e8b9\";\n}\n\n.icon-refresh-cw:before {\n  content: \"\\e8ba\";\n}\n\n.icon-rotate-cw:before {\n  content: \"\\e8bb\";\n}\n\n.icon-save:before {\n  content: \"\\e8bc\";\n}\n\n.icon-search:before {\n  content: \"\\e8bd\";\n}\n\n.icon-server:before {\n  content: \"\\e8be\";\n}\n\n.icon-scissors:before {\n  content: \"\\e8bf\";\n}\n\n.icon-share-2:before {\n  content: \"\\e8c0\";\n}\n\n.icon-share:before {\n  content: \"\\e8c1\";\n}\n\n.icon-shield:before {\n  content: \"\\e8c2\";\n}\n\n.icon-settings:before {\n  content: \"\\e8c3\";\n}\n\n.icon-skip-back:before {\n  content: \"\\e8c4\";\n}\n\n.icon-shuffle:before {\n  content: \"\\e8c5\";\n}\n\n.icon-sidebar:before {\n  content: \"\\e8c6\";\n}\n\n.icon-skip-forward:before {\n  content: \"\\e8c7\";\n}\n\n.icon-slack:before {\n  content: \"\\e8c8\";\n}\n\n.icon-slash:before {\n  content: \"\\e8c9\";\n}\n\n.icon-smartphone:before {\n  content: \"\\e8ca\";\n}\n\n.icon-square:before {\n  content: \"\\e8cb\";\n}\n\n.icon-speaker:before {\n  content: \"\\e8cc\";\n}\n\n.icon-star:before {\n  content: \"\\e8cd\";\n}\n\n.icon-stop-circle:before {\n  content: \"\\e8ce\";\n}\n\n.icon-sun:before {\n  content: \"\\e8cf\";\n}\n\n.icon-sunrise:before {\n  content: \"\\e8d0\";\n}\n\n.icon-tablet:before {\n  content: \"\\e8d1\";\n}\n\n.icon-tag:before {\n  content: \"\\e8d2\";\n}\n\n.icon-sunset:before {\n  content: \"\\e8d3\";\n}\n\n.icon-target:before {\n  content: \"\\e8d4\";\n}\n\n.icon-thermometer:before {\n  content: \"\\e8d5\";\n}\n\n.icon-thumbs-up:before {\n  content: \"\\e8d6\";\n}\n\n.icon-thumbs-down:before {\n  content: \"\\e8d7\";\n}\n\n.icon-toggle-left:before {\n  content: \"\\e8d8\";\n}\n\n.icon-toggle-right:before {\n  content: \"\\e8d9\";\n}\n\n.icon-trash-2:before {\n  content: \"\\e8da\";\n}\n\n.icon-trash:before {\n  content: \"\\e8db\";\n}\n\n.icon-trending-up:before {\n  content: \"\\e8dc\";\n}\n\n.icon-trending-down:before {\n  content: \"\\e8dd\";\n}\n\n.icon-triangle:before {\n  content: \"\\e8de\";\n}\n\n.icon-type:before {\n  content: \"\\e8df\";\n}\n\n.icon-twitter:before {\n  content: \"\\e8e0\";\n}\n\n.icon-upload:before {\n  content: \"\\e8e1\";\n}\n\n.icon-umbrella:before {\n  content: \"\\e8e2\";\n}\n\n.icon-upload-cloud:before {\n  content: \"\\e8e3\";\n}\n\n.icon-unlock:before {\n  content: \"\\e8e4\";\n}\n\n.icon-user-check:before {\n  content: \"\\e8e5\";\n}\n\n.icon-user-minus:before {\n  content: \"\\e8e6\";\n}\n\n.icon-user-plus:before {\n  content: \"\\e8e7\";\n}\n\n.icon-user-x:before {\n  content: \"\\e8e8\";\n}\n\n.icon-user:before {\n  content: \"\\e8e9\";\n}\n\n.icon-users:before {\n  content: \"\\e8ea\";\n}\n\n.icon-video-off:before {\n  content: \"\\e8eb\";\n}\n\n.icon-video:before {\n  content: \"\\e8ec\";\n}\n\n.icon-voicemail:before {\n  content: \"\\e8ed\";\n}\n\n.icon-volume-x:before {\n  content: \"\\e8ee\";\n}\n\n.icon-volume-2:before {\n  content: \"\\e8ef\";\n}\n\n.icon-volume-1:before {\n  content: \"\\e8f0\";\n}\n\n.icon-volume:before {\n  content: \"\\e8f1\";\n}\n\n.icon-watch:before {\n  content: \"\\e8f2\";\n}\n\n.icon-wifi:before {\n  content: \"\\e8f3\";\n}\n\n.icon-x-square:before {\n  content: \"\\e8f4\";\n}\n\n.icon-wind:before {\n  content: \"\\e8f5\";\n}\n\n.icon-x:before {\n  content: \"\\e8f6\";\n}\n\n.icon-x-circle:before {\n  content: \"\\e8f7\";\n}\n\n.icon-zap:before {\n  content: \"\\e8f8\";\n}\n\n.icon-zoom-in:before {\n  content: \"\\e8f9\";\n}\n\n.icon-zoom-out:before {\n  content: \"\\e8fa\";\n}\n\n.icon-command:before {\n  content: \"\\e8fb\";\n}\n\n.icon-cloud:before {\n  content: \"\\e8fc\";\n}\n\n.icon-hash:before {\n  content: \"\\e8fd\";\n}\n\n.icon-headphones:before {\n  content: \"\\e8fe\";\n}\n\n.icon-underline:before {\n  content: \"\\e8ff\";\n}\n\n.icon-italic:before {\n  content: \"\\e900\";\n}\n\n.icon-bold:before {\n  content: \"\\e901\";\n}\n\n.icon-crop:before {\n  content: \"\\e902\";\n}\n\n.icon-help-circle:before {\n  content: \"\\e903\";\n}\n\n.icon-paperclip:before {\n  content: \"\\e904\";\n}\n\n.icon-shopping-cart:before {\n  content: \"\\e905\";\n}\n\n.icon-tv:before {\n  content: \"\\e906\";\n}\n\n.icon-wifi-off:before {\n  content: \"\\e907\";\n}\n\n.icon-minimize:before {\n  content: \"\\e88d\";\n}\n\n.icon-maximize:before {\n  content: \"\\e908\";\n}\n\n.icon-gitlab:before {\n  content: \"\\e909\";\n}\n\n.icon-sliders:before {\n  content: \"\\e90a\";\n}\n\n.icon-star-on:before {\n  content: \"\\e90b\";\n}\n\n.icon-heart-on:before {\n  content: \"\\e90c\";\n}\n\n.icon-archive:before {\n  content: \"\\e90d\";\n}\n\n.icon-arrow-down-circle:before {\n  content: \"\\e90e\";\n}\n\n.icon-arrow-up-circle:before {\n  content: \"\\e90f\";\n}\n\n.icon-arrow-left-circle:before {\n  content: \"\\e910\";\n}\n\n.icon-arrow-right-circle:before {\n  content: \"\\e911\";\n}\n\n.icon-bar-chart-line-:before {\n  content: \"\\e912\";\n}\n\n.icon-bar-chart-line:before {\n  content: \"\\e913\";\n}\n\n.icon-book-open:before {\n  content: \"\\e914\";\n}\n\n.icon-code:before {\n  content: \"\\e915\";\n}\n\n.icon-database:before {\n  content: \"\\e916\";\n}\n\n.icon-dollar-sign:before {\n  content: \"\\e917\";\n}\n\n.icon-folder-plus:before {\n  content: \"\\e918\";\n}\n\n.icon-gift:before {\n  content: \"\\e919\";\n}\n\n.icon-folder-minus:before {\n  content: \"\\e91a\";\n}\n\n.icon-git-commit:before {\n  content: \"\\e91b\";\n}\n\n.icon-git-branch:before {\n  content: \"\\e91c\";\n}\n\n.icon-git-pull-request:before {\n  content: \"\\e91d\";\n}\n\n.icon-git-merge:before {\n  content: \"\\e91e\";\n}\n\n.icon-linkedin:before {\n  content: \"\\e91f\";\n}\n\n.icon-hard-drive:before {\n  content: \"\\e920\";\n}\n\n.icon-more-vertical-:before {\n  content: \"\\e921\";\n}\n\n.icon-more-horizontal-:before {\n  content: \"\\e922\";\n}\n\n.icon-rss:before {\n  content: \"\\e923\";\n}\n\n.icon-send:before {\n  content: \"\\e924\";\n}\n\n.icon-shield-off:before {\n  content: \"\\e925\";\n}\n\n.icon-shopping-bag:before {\n  content: \"\\e926\";\n}\n\n.icon-terminal:before {\n  content: \"\\e927\";\n}\n\n.icon-truck:before {\n  content: \"\\e928\";\n}\n\n.icon-zap-off:before {\n  content: \"\\e929\";\n}\n\n.icon-youtube:before {\n  content: \"\\e92a\";\n}\n\n/*========================================================\n        DARK LAYOUT\n=========================================================*/\nhtml[dir=rtl] .sales-card .img-left {\n  left: 0;\n  right: auto;\n}\nhtml[dir=rtl] .sales-card .img-right {\n  right: 0;\n}\nhtml[dir=rtl] .breadcrum-right .dropdown-toggle svg {\n  right: 0;\n}\nhtml[dir=rtl] .breadcrumb-wrapper .breadcrumb .breadcrumb-item:before {\n  transform: rotate(180deg);\n}\nhtml[dir=rtl] .dropup-form .dropdown-menu {\n  min-width: 16rem;\n}\nhtml[dir=rtl] .main-menu ul.navigation-main .nav-item:not(.open) svg.menu-toggle-icon {\n  transform: rotate(180deg);\n}\nhtml[dir=rtl] .main-menu ul.navigation-main .nav-item.open svg.menu-toggle-icon {\n  transform: rotate(90deg) !important;\n}\nhtml[dir=rtl] .ag-rtl {\n  direction: rtl;\n}\nhtml[dir=rtl] .ag-rtl .ag-header-select-all {\n  margin-right: 0 !important;\n  margin-left: 24px !important;\n}\nhtml[dir=rtl] .ag-rtl .ag-cell-value {\n  margin-left: 0 !important;\n  margin-right: 24px !important;\n}\nhtml[dir=rtl] .component-code pre {\n  text-align: left;\n}\nhtml[dir=rtl] .recharts-layer {\n  direction: ltr;\n}\nhtml[dir=rtl] .react-contexify {\n  z-index: 1031;\n}\nhtml[dir=rtl] .email-application .content-right .app-fixed-search .sidebar-toggle {\n  margin-left: 0;\n}\nhtml[dir=rtl] .email-application .content-right .email-detail-header .dropdown .dropdown-menu, html[dir=rtl] .email-application .content-right .app-action .dropdown .dropdown-menu {\n  transform: translate3d(0px, 22px, 0px) !important;\n}\nhtml[dir=rtl] .carousel .carousel-control-prev .carousel-control-prev-icon,\nhtml[dir=rtl] .carousel .carousel-control-prev .carousel-control-next-icon,\nhtml[dir=rtl] .carousel .carousel-control-next .carousel-control-prev-icon,\nhtml[dir=rtl] .carousel .carousel-control-next .carousel-control-next-icon {\n  transform: rotate(180deg);\n}\nhtml[dir=rtl] .pagination .prev-item a svg,\nhtml[dir=rtl] .pagination .previous a svg,\nhtml[dir=rtl] .pagination .next-item a svg,\nhtml[dir=rtl] .pagination .next a svg,\nhtml[dir=rtl] .vx-pagination .prev-item a svg,\nhtml[dir=rtl] .vx-pagination .previous a svg,\nhtml[dir=rtl] .vx-pagination .next-item a svg,\nhtml[dir=rtl] .vx-pagination .next a svg {\n  transform: rotate(180deg);\n}\nhtml[dir=rtl] .pagination li:first-child a span svg,\nhtml[dir=rtl] .pagination li:last-child a span svg,\nhtml[dir=rtl] .vx-pagination li:first-child a span svg,\nhtml[dir=rtl] .vx-pagination li:last-child a span svg {\n  transform: rotate(180deg);\n}\nhtml[dir=rtl] .swiper-container .swiper-button-next:after,\nhtml[dir=rtl] .swiper-container .swiper-button-prev:after {\n  transform: rotate(180deg);\n}\nhtml[dir=rtl] .swiper-container-cube.swiper-container-rtl .swiper-slide {\n  transform-origin: 100% 0 !important;\n}\nhtml[dir=rtl] .rc-slider-tooltip {\n  right: 50%;\n  width: 30px;\n}\nhtml[dir=rtl] .rc-slider-vertical .rc-slider-dot {\n  right: -1px;\n}\nhtml[dir=rtl] .horizontal-layout .horizontal-menu-wrapper #main-menu-navigation .nav-item .has-sub svg.has-sub-arrow {\n  transform: rotate(180deg);\n}\nhtml[dir=rtl] .horizontal-layout .horizontal-menu-wrapper #main-menu-navigation .dropdown-menu {\n  right: 0 !important;\n  left: auto !important;\n  top: 100% !important;\n}\nhtml[dir=rtl] .horizontal-layout .horizontal-menu-wrapper #main-menu-navigation .dropdown-menu .dropdown-menu {\n  left: auto !important;\n  right: 100% !important;\n  top: 0 !important;\n}\nhtml[dir=rtl] .main-menu .navigation > li ul li > a {\n  display: flex;\n  align-items: center;\n}\nhtml[dir=rtl] .header-navbar .navbar-container ul.nav li.dropdown .dropdown-menu {\n  margin-top: 0;\n}\nhtml[dir=rtl] .header-navbar .navbar-container ul.nav li.dropdown .dropdown-menu::before {\n  top: 1px;\n}\nhtml[dir=rtl] .header-navbar .dropdown .dropdown-menu.dropdown-menu-right::before,\nhtml[dir=rtl] .header-navbar .dropup .dropdown-menu.dropdown-menu-right::before {\n  right: auto;\n  left: 0.5rem;\n}\nhtml[dir=rtl] .dropdown .dropdown-menu,\nhtml[dir=rtl] .dropup .dropdown-menu {\n  right: auto !important;\n  top: 0 !important;\n  left: auto !important;\n}\nhtml[dir=rtl] .dropdown .dropdown-menu.dropdown-menu-right,\nhtml[dir=rtl] .dropup .dropdown-menu.dropdown-menu-right {\n  left: auto !important;\n  right: 0 !important;\n}\nhtml[dir=rtl] .dropdown .dropdown-menu.dropdown-menu-right::before,\nhtml[dir=rtl] .dropup .dropdown-menu.dropdown-menu-right::before {\n  right: 0.6rem;\n  left: auto;\n}\nhtml[dir=rtl] .input-group .dropdown-menu.show {\n  top: 0 !important;\n  right: auto !important;\n  left: 0px !important;\n}\nhtml[dir=rtl] .context-menu-list {\n  z-index: 1031 !important;\n}\nhtml[dir=rtl] code[class*=language-],\nhtml[dir=rtl] pre[class*=language-] {\n  direction: ltr;\n}\n@media print {\n  html[dir=rtl] code[class*=language-],\n  html[dir=rtl] pre[class*=language-] {\n    text-shadow: none;\n  }\n}\nhtml[dir=rtl] .app-calendar .calendar-navigation .btn svg {\n  transform: rotate(180deg);\n}\nhtml[dir=rtl] .bs-tooltip-left .arrow::before,\nhtml[dir=rtl] .bs-tooltip-auto[x-placement^=left] .arrow::before {\n  border-width: 0.4rem 0 0.4rem 0.4rem;\n  border-left-color: #323232;\n}\nhtml[dir=rtl] .bs-tooltip-left .arrow,\nhtml[dir=rtl] .bs-tooltip-auto[x-placement^=left] .arrow {\n  right: 0;\n  left: auto;\n}\nhtml[dir=rtl] .bs-tooltip-right .arrow::before,\nhtml[dir=rtl] .bs-tooltip-auto[x-placement^=right] .arrow::before {\n  border-width: 0.4rem 0.4rem 0.4rem 0;\n  border-right-color: #323232;\n}\nhtml[dir=rtl] .bs-tooltip-right .arrow,\nhtml[dir=rtl] .bs-tooltip-auto[x-placement^=right] .arrow {\n  left: 0;\n  right: auto;\n}\nhtml[dir=rtl] .popover {\n  right: auto !important;\n}\nhtml[dir=rtl] body .ps__rail-y {\n  right: auto !important;\n  left: 1px !important;\n}\n\n@media (max-width: 1200px) {\n  html[dir=rtl] .vertical-layout.menu-collapsed .app-content {\n    margin-right: 0;\n  }\n}\n@media (max-width: 575.98px) {\n  html[dir=rtl] .vertical-layout .navbar-container .header-navbar ul.nav .nav-item.dropdown .dropdown-menu {\n    left: 12px !important;\n  }\n  html[dir=rtl] .vertical-layout .navbar-container .header-navbar ul.nav .nav-item.dropdown .dropdown-menu.dropdown-menu-media {\n    left: 15px !important;\n    right: -15px !important;\n  }\n  html[dir=rtl] .vertical-layout .navbar-container .header-navbar ul.nav .nav-item.dropdown.dropdown-notification .dropdown-menu {\n    transform: translate3d(-12px, 62px, 0px) !important;\n  }\n  html[dir=rtl] .vertical-layout .navbar-container .header-navbar ul.nav .nav-item.dropdown.dropdown-notification .dropdown-menu.dropdown-cart {\n    transform: translate3d(-12px, 59px, 0px) !important;\n  }\n  html[dir=rtl] .vertical-layout .navbar-container .header-navbar ul.nav .nav-item.dropdown.dropdown-user .dropdown-menu {\n    transform: translate3d(20px, 60px, 0px) !important;\n  }\n  html[dir=rtl] .vertical-layout .navbar-container .header-navbar ul.nav .nav-item.dropdown.dropdown-language .dropdown-menu {\n    right: 28px !important;\n  }\n}\n@media (min-width: 769px) {\n  html[dir=rtl] .header-navbar .dropdown.dropdown-notification .dropdown-menu {\n    transform: translate3d(324px, 62px, 0px) !important;\n  }\n  html[dir=rtl] .header-navbar .dropdown.dropdown-notification .dropdown-menu.dropdowncart {\n    transform: translate3d(335px, 62px, 0px) !important;\n  }\n  html[dir=rtl] .header-navbar .dropdown.dropdown-user .dropdown-menu {\n    transform: translate3d(20px, 60px, 0px) !important;\n  }\n  html[dir=rtl] .header-navbar .dropdown.dropdown-language .dropdown-menu {\n    transform: translate3d(114px, 64px, 0px) !important;\n  }\n}\n@media (max-width: 768px) {\n  html[dir=rtl] .app-content .header-navbar .dropdown.dropdown-notification .dropdown-menu {\n    transform: translate3d(26px, 59px, 0px) !important;\n  }\n  html[dir=rtl] .app-content .header-navbar .dropdown.dropdown-notification .dropdown-menu.dropdown-cart {\n    transform: translate3d(26px, 59px, 0px) !important;\n  }\n  html[dir=rtl] .app-content .header-navbar .dropdown.dropdown-user .dropdown-menu {\n    left: 0 !important;\n    right: 28px !important;\n  }\n  html[dir=rtl] .app-content .header-navbar .dropdown.dropdown-language .dropdown-menu {\n    transform: translate3d(26px, 64px, 0px) !important;\n  }\n}\n* {\n  font-family: \"Montserrat\", sans-serif;\n}\n\n.uploadFormGroup {\n  display: flex;\n  flex-direction: column;\n}\n\n.uploadFormGroup .uploadButton {\n  align-self: center;\n  align-items: center;\n}\n\n.image-crop-modal {\n  min-width: 80%;\n  min-height: 70%;\n}\n\n.image-crop-modal-body {\n  text-align: center;\n}\n\n.ag-root.ag-layout-normal {\n  /* height: 100%; */\n  height: fit-content;\n}\n\n.ag-grid-table {\n  height: 750px !important;\n}\n\n.ag-paging-description span {\n  display: initial !important;\n}\n\n.ag-paging-page-summary-panel .ag-paging-number {\n  display: none;\n}\n\n.breadcrumb-item {\n  color: #7367f0;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.delete-modal {\n  min-width: fit-content;\n}\n\n.textarea-auto textarea {\n  min-height: 200px;\n}","/**\n * prism.js tomorrow night eighties for JavaScript, CoffeeScript, CSS and HTML\n * Based on https://github.com/chriskempson/tomorrow-theme\n * @author Rose Pritchard\n */\n\ncode[class*=\"language-\"],\npre[class*=\"language-\"] {\n\tcolor: #ccc;\n\tbackground: none;\n\tfont-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;\n\tfont-size: 1em;\n\ttext-align: left;\n\twhite-space: pre;\n\tword-spacing: normal;\n\tword-break: normal;\n\tword-wrap: normal;\n\tline-height: 1.5;\n\n\t-moz-tab-size: 4;\n\t-o-tab-size: 4;\n\ttab-size: 4;\n\n\t-webkit-hyphens: none;\n\t-moz-hyphens: none;\n\t-ms-hyphens: none;\n\thyphens: none;\n\n}\n\n/* Code blocks */\npre[class*=\"language-\"] {\n\tpadding: 1em;\n\tmargin: .5em 0;\n\toverflow: auto;\n}\n\n:not(pre) > code[class*=\"language-\"],\npre[class*=\"language-\"] {\n\tbackground: #2d2d2d;\n}\n\n/* Inline code */\n:not(pre) > code[class*=\"language-\"] {\n\tpadding: .1em;\n\tborder-radius: .3em;\n\twhite-space: normal;\n}\n\n.token.comment,\n.token.block-comment,\n.token.prolog,\n.token.doctype,\n.token.cdata {\n\tcolor: #999;\n}\n\n.token.punctuation {\n\tcolor: #ccc;\n}\n\n.token.tag,\n.token.attr-name,\n.token.namespace,\n.token.deleted {\n\tcolor: #e2777a;\n}\n\n.token.function-name {\n\tcolor: #6196cc;\n}\n\n.token.boolean,\n.token.number,\n.token.function {\n\tcolor: #f08d49;\n}\n\n.token.property,\n.token.class-name,\n.token.constant,\n.token.symbol {\n\tcolor: #f8c555;\n}\n\n.token.selector,\n.token.important,\n.token.atrule,\n.token.keyword,\n.token.builtin {\n\tcolor: #cc99cd;\n}\n\n.token.string,\n.token.char,\n.token.attr-value,\n.token.regex,\n.token.variable {\n\tcolor: #7ec699;\n}\n\n.token.operator,\n.token.entity,\n.token.url {\n\tcolor: #67cdcc;\n}\n\n.token.important,\n.token.bold {\n\tfont-weight: bold;\n}\n.token.italic {\n\tfont-style: italic;\n}\n\n.token.entity {\n\tcursor: help;\n}\n\n.token.inserted {\n\tcolor: green;\n}\n","/*!\n * Bootstrap v4.3.1 (https://getbootstrap.com/)\n * Copyright 2011-2020 The Bootstrap Authors\n * Copyright 2011-2020 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n */\n@import \"~bootstrap/scss/_functions.scss\";\n@import \"core/variables/variables\";\n@import \"~bootstrap/scss/_variables.scss\";\n@import \"~bootstrap/scss/bootstrap.scss\";\n\n\n","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.3 (https://getbootstrap.com/)\n   * Copyright 2011-2024 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(#{$pagination-border-width} * -1) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n// fusv-disable\n$accordion-button-focus-border-color:     $input-focus-border-color !default; // Deprecated in v5.3.3\n// fusv-enable\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-color}' stroke-linecap='round' stroke-linejoin='round'><path d='M2 5L8 11L14 5'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-active-color}' stroke-linecap='round' stroke-linejoin='round'><path d='M2 5L8 11L14 5'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $black !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n\n@import \"variables-dark\"; // TODO: can be removed safely in v6, only here to avoid breaking changes in v5.3\n","//  ================================================================================================\n//  File Name: variables.scss\n//  Description: Custom overrides of Bootstrap variables\n//  ----------------------------------------------------------------------------------------------\n//  Item Name: Vuexy React admin Template\n//  Version: 2.1\n//  Author: PIXINVENT\n//  Author URL: http://www.themeforest.net/user/pixinvent\n//  ================================================================================================\n\n// Color system\n\n$white: #fff;\n$body-bg: #f8f8f8;\n$gray-100: #babfc7; // $gray-lightest\n$gray-200: #ededed; // $gray-lighter\n$gray-300: #dae1e7; // $gray-light\n$gray-400: #636363;\n$gray-500: #adb5bd;\n$gray-600: #b8c2cc; // $gray\n$gray-700: #4e5154;\n$gray-800: #1e1e1e; // $gray-dark\n$gray-900: #2a2e30;\n$black: #22292f;\n\n$blue: #00cfe8; //$info\n$red: #ea5455; //$danger\n$orange: #ff9f43; //$warning\n$green: #28c76f; //$success\n$cyan: #7367f0; //$primary\n\n$primary: $cyan;\n$info: $blue;\n$warning: $orange;\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// stylelint-disable\n$spacer: 1rem;\n$spacers: ();\n// stylelint-disable-next-line scss/dollar-variable-default\n$spacers: map-merge(\n  (\n    0: 0,\n    25: (\n      $spacer * 0.25\n    ),\n    50: (\n      $spacer * 0.5\n    ),\n    75: (\n      $spacer * 0.75\n    ),\n    1: (\n      $spacer\n    ),\n    2: (\n      $spacer * 1.5\n    ),\n    3: (\n      $spacer * 3\n    ),\n    4: (\n      $spacer * 3.5\n    ),\n    5: (\n      $spacer * 4\n    )\n  ),\n  $spacers\n);\n\n// Body\n//\n// Settings for the `<body>` element.\n\n// $body-bg: $body-bg;\n$body-color: #626262;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color: $primary;\n$link-hover-color: darken($link-color, 5%);\n$link-hover-decoration: none;\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-gutter-width: 28px;\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n$line-height-lg: 1.25;\n$line-height-sm: 1;\n$border-width: 1px;\n$border-color: $gray-200;\n$border-radius: 0.5rem;\n$border-radius-lg: 0.6rem;\n$border-radius-sm: 0.25rem;\n\n// Typography\n\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// stylelint-disable value-keyword-case\n$font-family-sans-serif: \"Montserrat\", Helvetica, Arial, serif;\n$font-family-monospace: \"Montserrat\", Helvetica, Arial, serif;\n\n// stylelint-enable value-keyword-case\n$font-size-base: 1rem;\n$font-size-sm: ceil($font-size-base * 0.85);\n$font-size-lg: ceil($font-size-base * 1.25);\n\n$line-height-base: 1.45;\n\n$h1-font-size: $font-size-base * 2;\n$h2-font-size: $font-size-base * 1.74;\n$h3-font-size: $font-size-base * 1.51;\n$h4-font-size: $font-size-base * 1.32;\n$h5-font-size: $font-size-base * 1.14;\n\n$headings-margin-bottom: ($spacer / 2);\n$headings-font-family: inherit;\n$headings-font-weight: 500;\n\n$headings-color: #2c2c2c;\n\n$small-font-size: smaller;\n\n// Tables\n\n$table-border-color: $body-bg;\n\n// Buttons + Forms\n$btn-padding-y: 0.9rem;\n$btn-padding-x: 2rem;\n$input-btn-padding-y: 0.75rem;\n$input-btn-padding-x: 2rem;\n\n$input-btn-padding-y-sm: 0.5rem;\n$input-btn-padding-x-sm: 1.5rem;\n$input-btn-font-size-sm: $font-size-base * 0.7;\n\n$input-btn-padding-y-lg: 1rem;\n$input-btn-padding-x-lg: 2.5rem;\n$input-btn-font-size-lg: $font-size-base * 1.25;\n$btn-line-height: 1;\n$input-btn-border-width: 0;\n$btn-border-radius: 0.4285rem;\n\n// Forms\n\n$input-padding-y: 0.7rem !default;\n$input-padding-x: 0.7rem !default;\n$input-font-size: 0.96rem;\n$input-line-height: $line-height-lg;\n\n$input-padding-y-sm: 0.5rem !default;\n$input-padding-x-sm: 1.5rem !default;\n\n$input-padding-y-lg: $input-btn-padding-y-lg !default;\n$input-padding-x-lg: 2.5rem !default;\n\n$input-disabled-bg: #f5f5f1;\n\n$input-color: $gray-700;\n$input-border-color: rgba(0, 0, 0, 0.2);\n$input-border-width: $border-width;\n\n$input-border-radius: 5px;\n$input-border-radius-lg: 6px;\n$input-border-radius-sm: 4px;\n\n$input-focus-border-color: $primary;\n$input-focus-box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);\n\n$input-placeholder-color: rgba(0, 0, 0, 0.5);\n$input-plaintext-color: $gray-500;\n\n$input-height: calc(1.25 * 1em + #{$input-padding-y * 2} + 1px) !default;\n\n$custom-checkbox-indicator-border-radius: $border-radius-sm;\n\n$custom-select-border-radius: $input-border-radius;\n$custom-select-focus-box-shadow: $input-focus-box-shadow;\n\n$custom-file-line-height: 1.5rem;\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n$dropdown-border-radius: 5px;\n$dropdown-link-hover-bg: $body-bg;\n$dropdown-divider-bg: rgba(0, 0, 0, 0.08);\n$dropdown-font-size: 0.9375rem;\n$dropdown-spacer: 0.5rem;\n\n// pagination\n\n$pagination-padding-y: 0.65rem;\n$pagination-padding-x: 0.911rem;\n$pagination-padding-y-lg: 0.5rem;\n$pagination-padding-x-lg: 1rem;\n$pagination-padding-y-sm: 0.5rem;\n$pagination-padding-x-sm: 0.75rem;\n\n// BreadCrumbs\n$breadcrumb-divider: quote(\">>\");\n\n// Cards\n$card-spacer-y: 1.5rem;\n$card-spacer-x: 1.5rem;\n\n//Alerts\n\n$alert-padding-y: 0.71rem;\n$alert-padding-x: 0.71rem;\n\n// Nav tabs\n\n$nav-link-padding-y: 0.357rem;\n$nav-link-padding-x: 0.5rem;\n\n// Tooltips\n\n$tooltip-bg: #323232;\n$tooltip-padding-y: 0.4rem;\n$tooltip-padding-x: 0.775rem;\n$tooltip-font-size: 0.857rem;\n$tooltip-border-radius: 0.428rem;\n$tooltip-opacity: 1;\n$tooltip-max-width: 220px;\n$zindex-tooltip: 1032;\n\n// Popovers\n\n$popover-border-radius: 0.428rem;\n$popover-header-bg: $primary;\n$popover-font-size: 0.857rem;\n\n// Progress\n\n$progress-height: 0.357rem;\n$progress-border-radius: 1.28rem;\n\n// Badges\n\n$badge-font-size: 80%;\n$badge-padding-y: 0.4em;\n$badge-padding-x: 0.4em;\n$badge-border-radius: 0.25rem;\n\n// Code\n\n$code-font-size: 90% !default;\n$kbd-bg: #eee;\n\n// Switch\n$custom-switch-width: 3rem;\n$custom-switch-indicator-border-radius: 0.857rem;\n$custom-switch-indicator-size: 1.28rem;\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is an invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefore we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius, 0);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n\n      &::after {\n        position: absolute;\n        inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n        z-index: -1;\n        height: $form-floating-label-height;\n        content: \"\";\n        background-color: $input-bg;\n        @include border-radius($input-border-radius);\n      }\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n\n    &::after {\n      background-color: $input-disabled-bg;\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(#{$input-border-width} * -1); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($input-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($form-select-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  .btn-check:checked:focus-visible + & {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $spacing;\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $spacing;\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    > .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  > .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    // stylelint-disable selector-max-class\n    > .accordion-header .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n    // stylelint-enable selector-max-class\n\n    > .accordion-collapse {\n      @include border-radius(0);\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(#{$pagination-border-width} * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  --#{$prefix}btn-close-white-filter: #{$btn-close-white-filter};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  filter: var(--#{$prefix}btn-close-white-filter);\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .btn-close {\n      @include btn-close-white();\n    }\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-next-icon-bg) + \"*/\"};\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-prev-icon-bg) + \"*/\"};\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-bs-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    @if $color-mode-type == \"media-query\" {\n      .carousel {\n        @include carousel-dark();\n      }\n    } @else {\n      .carousel,\n      &.carousel {\n        @include carousel-dark();\n      }\n    }\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}offcanvas-padding-y)) calc(-.5 * var(--#{$prefix}offcanvas-padding-x)) calc(-.5 * var(--#{$prefix}offcanvas-padding-y)) auto;\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","//  ================================================================================================\n//  File Name: components-variables.scss\n//  Description: Custom theme specific variables and other content variations\n//  ----------------------------------------------------------------------------------------------\n//  Item Name: Vuexy React admin Template\n//  Version: 1.0\n//  Author: PIXINVENT\n//  Author URL: http://www.themeforest.net/user/pixinvent\n//  ================================================================================================\n\n//  ================================================================================================\n//  WARNING: PLEASE DO NOT CHANGE THIS VARIABLE FILE.\n//  THIS FILE WILL GET OVERWRITTEN WITH EACH VUESAX HTML TEMPLATE RELEASE.\n//  TIP:\n//  We suggest you to use this (assets/scss/variables/components-variables.scss) file for overriding app variables.\n//  ================================================================================================\n\n// Bootstrap  variables\n@import \"~bootstrap/scss/_variables.scss\";\n@import \"variables\";\n\n$base-font-size: 14px;\n$body-direction: ltr; // Default ltr, change it to rtl for Right To Left support.\n$content-padding: 2.2rem;\n\n//  ------------------------------\n//    Colors\n//  ------------------------------\n$pure-black: #000;\n$nav-component-border-color: #ddd;\n$custom-border-color: #e4e7ed;\n$chip-bg-color: #f0f0f0;\n$chip-avatar-bg: #c3c3c3;\n$avatar-bg: $chip-avatar-bg;\n$swiper-bg: #f2f4f4;\n$hover-color: #eee;\n\n//  ------------------------------\n//    Buttons\n//  ------------------------------\n$btn-border-radius-square: 0;\n$btn-border-radius: 0.42rem;\n$gradient-button-bs: 0 8px 25px -8px #aaa;\n//  ------------------------------\n//    Navbar\n//  ------------------------------\n$navbar-height: 5rem;\n\n//  ------------------------------\n//    Dropdown\n//  ------------------------------\n$dropdown-btn-padding-x: 1.5rem;\n$dropdown-btn-padding-y: 0.85rem;\n$dropdown-btn-split-padding-x: 1rem;\n\n//  ------------------------------\n//    pagination\n//  ------------------------------\n$pagination-bg-color: #f0f0f0;\n$pagination-action-padding-y: 0.572rem;\n$pagination-action-padding-x: 0.7rem;\n$pagination-font-size-lg: 1.5rem;\n\n//  ------------------------------\n//    Main Menu\n//  ------------------------------\n\n//main menu dark\n$menu-dark-color: #dcdcdc;\n$menu-dark-bg-color: #10163a;\n\n$menu-padding: 10px 15px;\n$menu-second-level-padding: 10px 15px 10px 20px;\n$menu-third-level-padding: 10px 15px 10px 20px;\n$menu-forth-level-padding: 10px 15px 10px 30px;\n\n// vertical menu\n$menu-expanded-width: 260px;\n$menu-collapsed-width: 80px;\n\n//  ------------------------------\n//    Sidebar\n//  -------------------------------\n$sidebar-width: 260px;\n$chat-sidebar-width: 400px;\n//  -------------------------------\n//    Avatar\n//  -------------------------------\n\n$avatar-size: 32px;\n$avatar-status-size: 11px;\n$avatar-status-size-lg: 17px;\n\n$avatar-size-xl: 70px;\n$avatar-size-lg: 50px;\n$avatar-size-sm: 24px;\n\n//  -------------------------------\n//  Progress\n//  -------------------------------\n$progress-size-xl: 1.14rem;\n$progress-size-lg: 0.857rem;\n$progress-size-md: 0.57rem;\n$progress-size-sm: 0.143rem;\n\n//  -------------------------------\n//  Form\n//  -------------------------------\n\n// $input-height, $input-height-lg, $input-height-sm are in variables\n$font-size-xs: 0.75rem;\n$font-size-xl: ($font-size-base + 0.5);\n$line-height-xl: 1.7;\n$line-height-xs: 1.5;\n$input-padding-y-xl: 0.5rem !default;\n$input-padding-x-xl: 0.5rem !default;\n\n$input-padding-y-xs: 0.2rem !default;\n$input-padding-x-xs: 0.275rem !default;\n\n$border-radius-xl: 0.35rem !default;\n$border-radius-xs: 0.12rem !default;\n$input-border-radius-xl: $border-radius-xl;\n$input-border-radius-xs: $border-radius-xs;\n\n$input-height-xl: (\n  ($font-size-xl * $line-height-xl) + ($input-padding-y-xl * 2)\n) !default;\n$input-height-xs: (\n  ($font-size-xs * $line-height-xs) + ($input-padding-y-xs * 2)\n) !default;\n$input-height-sm: (\n  ($font-size-sm * $line-height-sm) + ($input-padding-y-sm * 2)\n) !default;\n\n//  Custom VueSax Checkbox\n$vs-checkbox-radio-border-width: 2px;\n$vs-checkbox-radio-border-color: $gray-600;\n$vs-checkbox-box: 20px;\n$vs-checkbox-box-sm: 15px;\n$vs-checkbox-box-lg: 24px;\n$vs-radio-box: 18px;\n$vs-radio-box-sm: 13px;\n$vs-radio-box-lg: 22px;\n\n//  -------------------------------\n//  Blank Page Bg Color\n//  -------------------------------\n\n$blank-bg-color: #eff2f7;\n\n//  -------------------------------\n//  Data Tables Bg Color\n//  -------------------------------\n\n$datatable-bg-color: #f8f8f8;\n\n//  -------------------------------\n//  Chips\n//  -------------------------------\n\n$chip-min-height: 1.857rem;\n$chip-min-width: $chip-min-height;\n$chip-font-size: 0.8rem;\n$chip-border-radius: 1.428rem;\n$chip-avatar-min-height: 1.714rem;\n$chip-avatar-min-width: $chip-avatar-min-height;\n$chip-closeable-min-height: 1.428rem;\n$chip-closeable-min-width: $chip-closeable-min-height;\n\n//  -------------------------------\n//  Tables\n//  -------------------------------\n\n$table-th-font-size: 0.85rem;\n\n//  -------------------------------\n//  Switch\n//  -------------------------------\n$switch-bg-color: #e2e2e2;\n$switch-indicator-color: $white;\n$switch-md-size: 4rem;\n$switch-lg-size: 5.5rem;\n\n/*========================================================\n        DARK LAYOUT\n=========================================================*/\n\n$content-dark-bg: #262c49;\n$dark-card-color: #10163a;\n$grid-dark-color: #343661;\n$theme-dark-heading-color: #ebeefd;\n$theme-dark-text-color: #c2c6dc;\n$theme-dark-table-bg: #212744;\n$ex-col-border-color: #808080;\n$dark-chat-bg-color: #171e49;\n$theme-dark-border-color: #414561;\n\n// $theme-light-dark-bg: #262c49;\n// $theme-dark-bg: #10163a;\n","// ================================================================================================\n//     File Name: content.scss\n//     Description: Page content level SCSS for different screen size, layout and device.\n//     ----------------------------------------------------------------------------------------------\n//     Item Name: Vuexy React admin Template\n//     Version: 1.0\n//     Author: PIXINVENT\n//     Authuseror URL: http://www.themeforest.net//pixinvent\n// ================================================================================================\n\n// Contest margin left for expanded & collapsed stats width & margin left\n// ================================================================================================\nhtml {\n  font-size: $base-font-size;\n  height: 100%;\n  letter-spacing: 0.01rem;\n  body {\n    height: 100%;\n    background-color: $body-bg;\n    direction: $body-direction;\n    .content {\n      padding: 0;\n      position: relative;\n      transition: 300ms ease all;\n      backface-visibility: hidden;\n      min-height: calc(100% - 4rem);\n      margin-left: $menu-expanded-width;\n      &.app-content {\n        overflow: hidden;\n        &.show-overlay {\n          .content-overlay {\n            z-index: 10;\n            opacity: 1;\n            ~ .header-navbar-shadow {\n              background: linear-gradient(\n                180deg,\n                rgba(44, 48, 60, 0.9) 44%,\n                rgba(44, 48, 60, 0.43) 73%,\n                rgba(44, 48, 60, 0)\n              );\n            }\n          }\n        }\n        .content-overlay {\n          position: fixed;\n          opacity: 0;\n          width: 100%;\n          height: 100%;\n          top: 0;\n          left: 0;\n          right: 0;\n          bottom: 0;\n          background-color: rgba($pure-black, 0.5);\n          cursor: pointer;\n          transition: all 0.7s;\n          z-index: -1;\n          &.show {\n            z-index: 12;\n          }\n        }\n        .content-area-wrapper {\n          height: calc(100% - #{$navbar-height});\n          margin: calc(#{$navbar-height} + 2.7rem) #{$content-padding} 0;\n          // padding: calc(#{$content-padding} - 0.4rem) #{$content-padding};\n          display: flex;\n          position: relative;\n          .content-wrapper {\n            margin-top: 0;\n            height: calc(100vh - 13rem);\n          }\n        }\n      }\n      .content-wrapper {\n        padding: calc(#{$content-padding} - 0.4rem) #{$content-padding} 0;\n        margin-top: $navbar-height + 1;\n        min-height: calc(100vh - 9.75rem);\n        .content-header-title {\n          font-weight: 500;\n          color: $gray-400;\n          margin-right: $spacer;\n        }\n        .content-header-right {\n          .dropdown-toggle {\n            &::after {\n              display: none;\n            }\n          }\n          .btn-icon {\n            padding: 0.8rem;\n          }\n        }\n      }\n    }\n    //for navbar hidden\n    .vertical-layout.navbar-hidden {\n      .app-content {\n        .header-navbar-shadow {\n          display: none;\n        }\n        .content-wrapper {\n          padding: 2.2rem;\n          margin-top: 0;\n          min-height: calc(100vh - 4rem);\n        }\n        .content-area-wrapper {\n          padding: 0;\n          margin-top: 2.5rem;\n        }\n      }\n    }\n\n    // for static navbar\n    .vertical-layout.navbar-static {\n      .app-content {\n        .header-navbar-shadow {\n          display: none;\n        }\n        .navbar-container {\n          padding-left: 2.2rem;\n          padding-right: 1.2rem;\n        }\n        .content-wrapper {\n          padding: 2.2rem;\n          margin-top: 0;\n          padding-top: 1rem;\n        }\n        .content-area-wrapper {\n          margin-top: 1rem;\n        }\n      }\n    }\n\n    // for sticky navbar\n    .vertical-layout {\n      &.menu-collapsed {\n        .header-navbar.fixed-top {\n          left: 60px;\n          width: auto;\n        }\n      }\n      &.navbar-sticky {\n        .app-content {\n          .header-navbar-shadow {\n            display: none;\n          }\n          .navbar-container {\n            padding-left: 2.2rem;\n            padding-right: 1rem;\n          }\n          .content-wrapper {\n            padding: 2.2rem;\n            margin-top: 4.65rem;\n          }\n        }\n      }\n    }\n\n    // navbar search width for sticky and static navbar\n    .vertical-layout.navbar-static,\n    .vertical-layout.navbar-sticky {\n      .navbar-container {\n        padding-left: 2.2rem;\n        padding-right: 1rem;\n      }\n    }\n\n    // Fixed layout\n    .vertical-layout.fixed-footer,\n    .horizontal-layout.fixed-footer {\n      .app-content {\n        margin-bottom: 3rem;\n      }\n      .footer {\n        position: fixed;\n        z-index: 1030;\n        right: 0;\n        left: 0;\n        bottom: 0;\n        background: $white;\n        box-shadow: 0 -1px 4px 0 rgba(0, 0, 0, 0.15);\n      }\n    }\n\n    .vertical-layout .menu-swipe-area {\n      width: 30px;\n      position: fixed;\n      left: 0;\n      top: 0;\n      z-index: 1032;\n      height: 100vh;\n    }\n\n    // paragraph line-height\n    p {\n      line-height: 1.5rem;\n    }\n\n    .bg-full-screen-image {\n      background: url(\"../../../img/pages/vuesax-login-bg.jpg\") no-repeat center\n        center;\n      background-size: cover;\n    }\n\n    /*\n        * Blank page\n        */\n\n    .blank-page {\n      .content {\n        margin-left: 0;\n        // overflow-x hidden, overflow for y in sm screen issue resolved default\n        &.app-content {\n          overflow: overlay;\n          overflow-x: hidden;\n        }\n      }\n      // blank page content-wrapper\n      .content-wrapper {\n        padding: 0 !important;\n        margin-top: 0;\n        // content to be in center horizontally and vertically\n        .flexbox-container {\n          display: flex;\n          align-items: center;\n          height: 100vh;\n          justify-content: center;\n          overflow: hidden;\n        }\n      }\n    }\n    //Remove left margin for 1 column layout\n    &[data-col=\"1-column\"] {\n      .content,\n      .footer {\n        margin-left: 0px !important;\n      }\n    }\n  }\n  .pace {\n    .pace-progress {\n      background: $primary;\n    }\n  }\n}\n\n.app-content.center-layout {\n  overflow: hidden;\n}\n\n/*\n* Col 3 layout for detached and general type\n*/\n\n@include media-breakpoint-up(lg) {\n  body {\n    // Normal sidebar\n    .content-right {\n      width: calc(100% - #{$sidebar-width});\n      float: right;\n    }\n    .content-left {\n      width: calc(100% - #{$sidebar-width});\n      float: left;\n    }\n    // Detached sidebar\n    .content-detached {\n      width: 100%;\n      &.content-right {\n        float: right;\n        margin-left: -$sidebar-width;\n        .content-body {\n          margin-left: calc(#{$sidebar-width} + #{$content-padding});\n        }\n      }\n      &.content-left {\n        float: left;\n        margin-right: -$sidebar-width;\n        .content-body {\n          margin-right: calc(#{$sidebar-width} + #{$content-padding});\n        }\n      }\n    }\n  }\n  .sidebar-right.sidebar-sticky {\n    float: right !important;\n    margin-left: -$sidebar-width;\n    width: $sidebar-width !important;\n    margin-top: $navbar-height + 1;\n  }\n  //left sticky sidebar\n  [data-col=\"content-left-sidebar\"] {\n    .sticky-wrapper {\n      float: left;\n    }\n  }\n}\n\n.truncate {\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  white-space: nowrap !important;\n}\n\n@include media-breakpoint-down(xs) {\n  html body .content .content-wrapper {\n    padding: calc(#{$content-padding} - 0.4rem) calc(#{$content-padding} - 1rem)\n      0;\n  }\n}\n\n@include media-breakpoint-down(xs) {\n  body {\n    &.navbar-static,\n    &.navbar-sticky {\n      .app-content {\n        .header-navbar {\n          .navbar-container {\n            padding-left: 1rem;\n            padding-right: 0.5rem;\n          }\n        }\n      }\n    }\n  }\n}\n\n// For Fullscreen IE\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  html.full-screen {\n    width: 100%;\n    .content.app-content {\n      height: 100%;\n      overflow: scroll;\n      overflow-x: hidden;\n    }\n  }\n}\n\n.vertical-layout {\n  .main-menu{\n    .navigation{\n      .menu-content{\n        li a{\n          svg:first-child{\n            margin-right: 1.38rem !important;\n          }\n          .menu-toggle-icon{\n            right: 9px;\n          }\n        }\n      }\n    }\n  }\n  &.menu-collapsed {\n    .main-menu.collapsed {\n      width: 80px;\n      transition: 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n      .badge,\n      svg.menu-toggle-icon,\n      .brand-text,\n      .navigation-header,\n      ul.menu-content {\n        display: none;\n      }\n    }\n    .app-content {\n      margin-left: 80px;\n      .header-navbar {\n        width: calc(100% - 4.4rem - 80px);\n      }\n    }\n    .footer {\n      margin-left: 80px;\n    }\n  }\n}\n\n@media (max-width: 1200px) {\n  .vertical-layout {\n    .app-content {\n      margin-left: 0;\n      .header-navbar.floating-nav {\n        width: calc(100% - 4.4rem) !important;\n      }\n    }\n    .footer {\n      margin-left: 0;\n    }\n    .main-menu:not(.hide-sidebar) {\n      & ~ .sidenav-overlay {\n        display: block;\n      }\n    }\n  }\n}\n\n@media (max-width: 576px) {\n  .vertical-layout {\n    .app-content {\n      .header-navbar.floating-nav {\n        width: calc(100% - 2.4rem) !important;\n      }\n    }\n  }\n}\n","/*=========================================================================================\n    File Name: sidebar.scss\n    Description: content sidebar specific scss.\n    ----------------------------------------------------------------------------------------\n    Item Name: Vuexy React admin Template\n    Version: 1.0\n    Author: PIXINVENT\n    Author URL: http://www.themeforest.net/user/pixinvent\n==========================================================================================*/\n\n\n\n// Sidebar base\n// ------------------------------\n\n// Base\n.sidebar {\n    position: relative;\n    width: 100%;\n\n    // For desktop only\n    @include media-breakpoint-up(lg){\n        // display: table-cell;\n        vertical-align: top;\n        // width: $sidebar-width;\n    }   \n}\n.sidebar-fixed{\n    position: fixed;\n    height: 100%;\n    overflow: scroll;\n}\n\n.sidenav-overlay{\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 120vh;\n    background-color: rgba(0,0,0,0.5);\n    z-index: 997;\n    display: none;\n}\n\n.drag-target {\n    height: 100%;\n    width: 40px;\n    position: fixed;\n    top: 0;\n    left:-10px;\n    z-index: 1036;\n}\n\n@include media-breakpoint-up(lg){\n    .sidebar-left{\n        float:left;\n    }\n    .sidebar-right{\n        float:right;\n    }\n}\n","// ================================================================================================\n//     File Name: Footer.scss\n//     Description: *  Main footer styles.\n//     ----------------------------------------------------------------------------------------------\n//     Item Name: Vuexy React admin Template\n//     Version: 1.0\n//     Author: PIXINVENT\n//     Author URL: http://www.themeforest.net/user/pixinvent\n// ================================================================================================\n\n// Stick footer to the bottom of the page\nfooter {\n  &.footer {\n    padding: $spacer ($spacer * 2.2);\n\n    // a tag margin - PIXINVENT text\n    a {\n      margin: 0 0.3rem;\n    }\n    // heart icon scss\n    span {\n      svg {\n        margin-left: 0.5rem;\n      }\n    }\n    .scroll-top {\n      padding: 0.81rem 0.83rem;\n    }\n  }\n\n  //shadow & border options\n  &.navbar-shadow {\n    box-shadow: 0px -1px 4px 0px rgba(0, 0, 0, 0.15);\n  }\n  &.navbar-border {\n    border-top: 1px solid $custom-border-color;\n  }\n}\n\n// Fixed Footer\n.fixed-footer {\n  // Footer Light\n  &.footer-light {\n    background: $white;\n    box-shadow: 0px -1px 4px 0px rgba(0, 0, 0, 0.15);\n  }\n  // Footer Dark\n  &.footer-dark {\n    background: $gray-600;\n    color: $white;\n  }\n}\n\n// scroll to Top Footer Button\n.scroll-top {\n  position: fixed;\n  bottom: 5%;\n  right: 30px;\n  z-index: 99;\n}\n\n@include media-breakpoint-up(lg) {\n  .footer {\n    margin-left: 260px;\n  }\n}\n","/*=========================================================================================\n    File Name: navigations.scss\n    Description: Common mixin for menus, contain dark and light version scss.\n    ----------------------------------------------------------------------------------------\n    Item Name: Vuexy React  admin Template\n    Version: 1.0\n    Author: PIXINVENT\n    Author URL: http://www.themeforest.net/user/pixinvent\n==========================================================================================*/\n\n// Import first main menu mixin\n@import \"../mixins/main-menu-mixin\";\n\n// Main menu base\n//==============\n.main-menu {\n  z-index: 1031;\n  position: absolute;\n  display: table-cell;\n  height: 100%;\n  overflow: hidden;\n  width: 260px;\n  transition: width 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n  &.menu-light {\n    @include menu-theme($body-color, $white);\n  }\n\n  &.menu-dark {\n    @include menu-theme($menu-dark-color, $menu-dark-bg-color);\n  }\n\n  &.menu-fixed {\n    position: fixed;\n    /* fallback if needed */\n    // top: $navbar-height;\n    .main-menu-footer {\n      position: fixed;\n    }\n  }\n  &.menu-static {\n    height: auto;\n    padding-bottom: calc(100% - 35rem);\n    .main-menu-content {\n      height: unset !important;\n    }\n  }\n\n  &.menu-shadow {\n    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.05);\n  }\n\n  &.menu-border {\n    border-right: 1px solid $custom-border-color;\n  }\n\n  // menu scroll shadow\n  .shadow-bottom {\n    position: absolute;\n    z-index: 2;\n    height: 60px;\n    width: 100%;\n    pointer-events: none;\n    margin-top: -1.3rem;\n    margin-left: -1rem;\n    filter: blur(5px);\n    background: linear-gradient(\n      #fff 41%,\n      hsla(0, 0%, 100%, 0.11) 95%,\n      hsla(0, 0%, 100%, 0)\n    );\n  }\n\n  // Native Scrollbar (.menu-native-scroll)\n  &.menu-native-scroll {\n    .main-menu-content {\n      overflow-y: scroll;\n    }\n  }\n\n  .navbar-header {\n    height: 100%;\n    width: $menu-expanded-width;\n    height: $navbar-height;\n    position: relative;\n    padding: 0.35rem 1rem 0.3rem 1.64rem;\n    transition: 300ms ease all;\n    .navbar-brand {\n      // padding: 15px 0px;\n      display: flex;\n      align-items: center;\n      margin-top: 1.35rem;\n      .brand-logo {\n        background: url(\"../../../img/logo/vuesax-logo.png\") no-repeat;\n        background-position: -65px -54px;\n        height: 24px;\n        width: 35px;\n      }\n\n      .brand-text {\n        color: $primary;\n        padding-left: 1rem;\n        font-weight: 600;\n        letter-spacing: 0.01rem;\n        font-size: 1.57rem;\n        animation: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) 0s normal forwards 1\n          fadein;\n      }\n    }\n    .modern-nav-toggle {\n      animation: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) 0s normal forwards 1\n        fadein;\n    }\n  }\n\n  .main-menu-content {\n    height: calc(100% - 6rem) !important;\n    position: relative;\n    transition: all 0.25s ease;\n    // margin-top: 0.45rem;\n    .ps__rail-y:hover,\n    &.ps--active-y .ps__rail-y {\n      background-color: transparent !important;\n    }\n  }\n\n  ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n\n    &.navigation-main {\n      overflow-x: hidden;\n      > li:first-child {\n        margin-top: 0.5rem;\n      }\n      .nav-item {\n        svg:first-child {\n          margin-right: 1rem;\n          position: relative;\n          top: -1px;\n        }\n        svg.menu-toggle-icon {\n          position: absolute;\n          right: 22px;\n          top: 15px;\n          transition: all 0.25s ease;\n        }\n      }\n    }\n  }\n\n  a {\n    outline: none;\n\n    &:hover,\n    &:focus {\n      text-decoration: none;\n    }\n  }\n\n  &.hide-sidebar {\n    transform: translateX(-100%);\n    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n  }\n  &:not(.hide-sidebar) {\n    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n  }\n\n}\n\n// Main Navigation\n.navigation {\n  font-size: 1.1rem;\n  font-family: $font-family-monospace;\n  font-weight: 400;\n  overflow-y: hidden;\n  padding-bottom: 20px;\n\n  .navigation-header {\n    font-family: $font-family-monospace;\n    font-weight: $headings-font-weight;\n    line-height: $headings-line-height;\n    padding: 12px 22px;\n    font-size: 0.9rem;\n    text-transform: uppercase;\n  }\n\n  li {\n    position: relative;\n    white-space: nowrap;\n\n    a {\n      display: block;\n      text-overflow: ellipsis;\n      overflow: hidden;\n    }\n\n    &.disabled {\n      pointer-events: none;\n      cursor: not-allowed;\n    }\n  }\n  .nav-item {\n    &.active {\n      a {\n        background: linear-gradient(\n          118deg,\n          rgba($primary, 1),\n          rgba($primary, 0.7)\n        );\n        box-shadow: 0 0 10px 1px rgba($primary, 0.7) !important;\n      }\n    }\n    .menu-content {\n      li.active {\n        background: linear-gradient(\n          118deg,\n          rgba($primary, 1),\n          rgba($primary, 0.7)\n        );\n        box-shadow: 0 0 10px 1px rgba($primary, 0.7) !important;\n      }\n    }\n  }\n}\n\n// For compact menu popout\n.menu-popout {\n  li {\n    &.disabled {\n      a {\n        cursor: not-allowed;\n      }\n    }\n  }\n}\n\n.dropdown-notification {\n  .nav-link-label {\n    position: relative;\n  }\n  .notification-text {\n    margin-bottom: 0.25rem;\n    font-size: smaller;\n    color: $body-color;\n  }\n  .notification-title {\n    color: rgba($white, 0.75);\n  }\n\n  .notification-tag {\n    position: relative;\n    top: -4px;\n  }\n  .dropdown-menu.dropdown-menu-right {\n    right: -2px;\n    padding: 0;\n    &::before {\n      background: $primary;\n      border-color: $primary;\n    }\n  }\n  .dropdown-menu-header {\n    border-top-left-radius: $dropdown-border-radius;\n    border-top-right-radius: $dropdown-border-radius;\n    background: $primary;\n    color: $white;\n    text-align: center;\n    .dropdown-header h3 {\n      margin-bottom: 0.25rem;\n    }\n  }\n}\n\n// Navigation Themes\n\n.horizontal-layout,\n.vertical-layout{\n  &.theme-primary {\n    .navbar-container,\n    .navbar-header {\n      .brand-logo {\n        background-position: -65px -54px !important;\n      }\n    }\n  }\n  &.theme-success {\n    .navbar-container,\n    .navbar-header {\n      .brand-logo {\n        background-position: -120px -10px !important;\n      }\n    }\n  }\n  &.theme-danger {\n    .navbar-container,\n    .navbar-header {\n      .brand-logo {\n        background-position: -10px -10px !important;\n      }\n    }\n  }\n  &.theme-info {\n    .navbar-container,\n    .navbar-header {\n      .brand-logo {\n        background-position: -10px -54px !important;\n      }\n    }\n  }\n  &.theme-warning {\n    .navbar-container,\n    .navbar-header {\n      .brand-logo {\n        background-position: -120px -54px !important;\n      }\n    }\n  }\n  &.theme-dark {\n    .navbar-container,\n    .navbar-header {\n      .brand-logo {\n        background-position: -65px -10px !important;\n      }\n    }\n  }\n}\n\n// Navigation Header\n//=====================\n.main-menu-header {\n  .user-content {\n    padding: 20px;\n\n    .media {\n      overflow: inherit;\n    }\n\n    .media-body {\n      vertical-align: bottom;\n      opacity: 1;\n      width: 150px;\n      white-space: nowrap;\n      transition: all 0.3s ease 0.15s;\n    }\n  }\n}\n\n// Navigation Footer\n//=====================\n.main-menu-footer {\n  position: relative;\n  overflow: hidden;\n  bottom: 0;\n  display: block;\n  z-index: 1000;\n  color: lighten($gray-600, 60%);\n  background-color: darken($gray-600, 10%);\n\n  &.footer-open {\n    max-height: 500px;\n    transition: max-height 0.2s ease-in-out;\n  }\n\n  a {\n    color: lighten($gray-600, 50%);\n\n    &:hover,\n    &:focus {\n      color: $white;\n    }\n  }\n\n  .header {\n    height: 19px;\n    border-bottom: 1px solid darken($gray-600, 5%);\n  }\n\n  .toggle {\n    transform: rotate(0deg);\n    transition: -webkit-transform 0.2s ease-in-out;\n  }\n\n  .content {\n    padding: 0;\n\n    .actions {\n      > a {\n        display: block;\n        float: left;\n        width: (100% / 3);\n        padding: 1rem 0;\n        color: lighten($gray-600, 50%);\n        text-align: center;\n        border-top: 1px solid darken($gray-600, 5%);\n        border-left: 1px solid darken($gray-600, 5%);\n\n        > span {\n          font-size: 1.35rem;\n        }\n\n        &:hover,\n        &:focus {\n          color: $white;\n        }\n      }\n    }\n  }\n}\n\nbody {\n  .main-menu-footer {\n    .content {\n      margin-left: 0;\n    }\n  }\n}\n\n\n\n// for collapsed static layout\nbody.menu-collapsed {\n  .menu-static {\n    padding-bottom: calc(100% - 14rem);\n  }\n}\n\n// Media queries for small screen devices\n// =========================================\n@include media-breakpoint-down(sm) {\n  // menu hide/open animation\n  .menu-hide .main-menu,\n  .menu-open .main-menu {\n    transition: transform 0.25s, top 0.35s, height 0.35s;\n  }\n\n  .main-menu {\n    backface-visibility: hidden;\n    perspective: 1000;\n    &:not(.hide-sidebar) {\n      transform: translate3d(0);\n      transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n    }\n  }\n\n  .menu-open .main-menu {\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n@include media-breakpoint-up(md) {\n  .drag-target {\n    z-index: 0;\n  }\n}\n\n// For Fixed Layout set menu-fixed height\nbody {\n  .vertical-layout.fixed-footer {\n    .main-menu {\n      &.menu-fixed {\n        height: 100%;\n      }\n    }\n  }\n}\n\n// for static main menu height\n@media (max-width: 768px) {\n  body {\n    .main-menu {\n      &.menu-static {\n        padding-bottom: 100%;\n      }\n    }\n  }\n}\n","//  =========================================================================================\n// File Name: main-menu-mixin.scss\n// Description: Common mixin for menus, contain dark and light version scss.\n// ----------------------------------------------------------------------------------------\n// Item Name: Vuexy React admin Template\n// Version: 1.0\n// Author: PIXINVENT\n// Author URL: http://www.themeforest.net/user/pixinvent\n//==========================================================================================\n\n// Header navbar content and brand expanded & collapsed stats\n// spacing and sizing.\n// ================================================\n\n// Mixins for the menu and navbar position, margin and width change\n@mixin main-menu-width($menu-width) {\n  margin-left: $menu-width;\n}\n@mixin menu-navbar-width($menu-width) {\n  float: left;\n  width: $menu-width;\n  // z-index: 999;\n}\n// Mixins for the menu show hide based on width\n@mixin vertical-menu-transform-show($transform-width) {\n  transform: translate3d($transform-width, 0, 0);\n  backface-visibility: hidden;\n  perspective: 1000;\n}\n@mixin vertical-menu-transform-hide() {\n  transform: translate3d(0, 0, 0);\n}\n// Mixins for the menu flipped menu\n@mixin vertical-flipped-menu($menu-width) {\n  margin: 0;\n  margin-right: $menu-width;\n}\n// Mixins for the sub menu arrow\n@mixin vertical-menu-has-sub-arrow($arrow-font-size) {\n  &.has-sub {\n    > a:not(.mm-next):after {\n      content: \"\\f105\";\n      font-family: \"FontAwesome\";\n      font-size: $arrow-font-size;\n      display: inline-block;\n      position: absolute;\n      right: 25px;\n      top: 10px;\n      transform: rotate(0deg);\n      transition: -webkit-transform 0.2s ease-in-out;\n    }\n  }\n  &.open {\n    > a:not(.mm-next):after {\n      transform: rotate(90deg);\n    }\n  }\n}\n\n// Light & Dark menu mixin\n// $theme-color : Menu text color\n// $theme-bg    : Menu background color\n// ================================================\n@mixin menu-theme($theme-color, $theme-bg) {\n  $main-menu-top-hover-bg: darken($theme-bg, 4%); //$primary\n  $main-menu-top-hover-color: darken($theme-color, 10%);\n\n  $main-menu-top-open-color: darken($theme-color, 10%);\n  $main-menu-top-open-bg: darken($theme-bg, 4%);\n  $main-menu-top-open-hover-bg: darken($theme-bg, 6%);\n  $main-menu-top-open-head-bg: darken($theme-bg, 4%);\n\n  $main-menu-active-color: lighten($theme-color, 10%);\n  $main-menu-active-bg: darken($theme-bg, 4%);\n\n  $main-menu-top-active-bg: darken($theme-bg, 4%); //$primary\n  $main-menu-top-active-color: $white;\n  $main-menu-top-active-head-bg: darken($theme-bg, 4%); //$primary\n\n  $main-menu-sub-bg: darken($theme-bg, 4%);\n  $main-menu-sub-color: $theme-color;\n  $main-menu-sub-hover-bg: darken($theme-bg, 4%);\n  $main-menu-sub-hover-color: lighten($theme-color, 4%);\n  $main-menu-sub-active-bg: rgba(0, 0, 0, 0.06);\n\n  $main-menu-sub-open-bg: darken($theme-bg, 4%);\n  $main-menu-sub-open-color: $theme-color;\n  $main-menu-sub-open-hover-bg: darken($theme-bg, 4%);\n\n  color: $theme-color;\n  background: $theme-bg;\n\n  .main-menu-header {\n    padding: 20px;\n    .menu-search {\n      background: darken($theme-bg, 10%);\n      padding: 0.5rem 1rem;\n      color: $main-menu-top-hover-color;\n      &:focus {\n        border-color: darken($theme-bg, 15%);\n      }\n    }\n  }\n  .navigation {\n    background: $theme-bg;\n    .navigation-header {\n      color: lighten($theme-color, 21.5%);\n      margin: calc(#{$content-padding} - 0.2rem) 0 0.8rem $content-padding;\n      padding: 0;\n      line-height: 1.5;\n      letter-spacing: 0.01rem;\n      span {\n        font-weight: 500;\n      }\n    }\n    li {\n      .menu-text {\n        width: 170px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        &:last-child {\n          width: 180px;\n        }\n      }\n      &.has-sub {\n        ul.menu-content {\n          padding: 7px;\n          margin: -7px -7px 0 -7px;\n          transition: height 0.25s ease;\n        }\n      }\n      a {\n        color: darken($theme-color, 4.9%);\n        padding: $menu-padding;\n        line-height: 1.45;\n        transition: padding 0.35s ease 0s !important;\n\n        span.menu-sub-title {\n          color: lighten($theme-color, 30%);\n        }\n        .badge {\n          box-shadow: 0 0 7px 3px rgba(0, 0, 0, 0.1);\n        }\n      }\n      &.hover {\n        > a {\n          padding-left: 25px;\n          transition: padding 0.35s ease 0s !important;\n        }\n      }\n    }\n\n    > li {\n      padding: 0 15px;\n      > a {\n        .label {\n          margin-top: 4px;\n          margin-right: 5px;\n        }\n        i {\n          position: relative;\n          top: 1px;\n        }\n      }\n      &.open,\n      &.sidebar-group-active,\n      ul.menu-content .sidebar-group-active,\n      ul.menu-content .open {\n        > a {\n          color: $main-menu-top-open-color;\n          background: $main-menu-top-open-head-bg;\n          transition: transform 0.25s ease 0s, -webkit-transform 0.25s ease 0s;\n          border-radius: 6px;\n          margin-bottom: 7px;\n        }\n        &.open {\n          > a {\n            svg.menu-toggle-icon {\n              transform: rotate(90deg);\n            }\n          }\n        }\n      }\n\n      &:not(.open) {\n        > ul {\n          display: none;\n        }\n      }\n      &.active {\n        > a {\n          color: $white;\n          font-weight: 400;\n          border-radius: 4px;\n        }\n      }\n\n      .active {\n        background: $main-menu-top-open-hover-bg;\n\n        > a {\n          color: $primary;\n          margin-bottom: 0;\n          // font-weight: 500;\n        }\n\n        .hover {\n          > a {\n            background: $main-menu-top-active-head-bg;\n          }\n        }\n      }\n\n      ul {\n        padding: 0;\n        margin: 0;\n        // font-size: 1rem;\n\n        li {\n          color: $main-menu-sub-color;\n          background: transparent;\n          > a {\n            padding: $menu-second-level-padding;\n          }\n        }\n        .has-sub {\n          &:not(.open) {\n            > ul {\n              display: none;\n            }\n          }\n        }\n        .open,\n        .sidebar-group-active {\n          > a {\n            color: $main-menu-sub-open-color;\n          }\n          //for 2rd level menu\n          > ul {\n            display: block;\n            //for 3rd level menu\n            .open {\n              > ul {\n                display: block;\n              }\n            }\n          }\n        }\n\n        .hover,\n        &:hover {\n          > a {\n            color: $main-menu-sub-hover-color;\n          }\n        }\n\n        .active {\n          background: linear-gradient(\n            118deg,\n            rgba($primary, 1),\n            rgba($primary, 0.7)\n          );\n          box-shadow: 0 0 10px 1px rgba($primary, 0.7);\n          border-radius: 4px;\n          > a {\n            color: $white;\n            // font-weight: 500;\n          }\n        }\n      }\n\n      > ul {\n        background: $theme-bg;\n      }\n    }\n  }\n\n  //For popout menu\n  ul.menu-popout {\n    background: $theme-bg;\n    li {\n      a {\n        color: $theme-color;\n        span.menu-sub-title {\n          color: lighten($theme-color, 30%);\n        }\n      }\n      &.hover,\n      &:hover,\n      &.open {\n        > a {\n          background: $main-menu-top-open-hover-bg;\n        }\n      }\n    }\n\n    .has-sub {\n      &:not(.open) {\n        > ul {\n          display: none;\n        }\n      }\n    }\n    .open {\n      > a {\n        color: $main-menu-sub-open-color;\n      }\n      //for 2rd level menu\n      > ul {\n        display: block;\n        //for 3rd level menu\n        .open {\n          background: darken($main-menu-sub-open-bg, 5%);\n          > ul {\n            display: block;\n            background: darken($main-menu-sub-open-bg, 5%);\n          }\n        }\n      }\n    }\n\n    .hover,\n    &:hover {\n      > a {\n        color: $main-menu-sub-hover-color;\n        background-color: $main-menu-sub-hover-bg;\n      }\n    }\n\n    .active {\n      background: $main-menu-sub-active-bg;\n\n      > a {\n        color: $main-menu-active-color;\n        background-color: $main-menu-active-bg;\n      }\n\n      .hover,\n      :hover {\n        > a {\n          background-color: transparent;\n        }\n      }\n    }\n  }\n  //For pop\n}\n// Menucontent display mixin\n// $menu-expanded-width : Expanded menu width\n// $menu-collapsed-width: Collapsed menu width\n// ================================================\n@mixin menu-content(\n  $menu-expanded-width,\n  $menu-collapsed-width,\n  $theme-color,\n  $theme-bg\n) {\n  .main-menu-content {\n    > span.menu-title,\n    a.menu-title {\n      right: -($menu-expanded-width);\n      width: $menu-expanded-width;\n      font-weight: 600;\n      color: #fff;\n      text-transform: uppercase;\n      text-align: left;\n      background-color: $primary;\n      border-color: $primary;\n      padding: 13px 20px;\n    }\n    > ul.menu-content {\n      left: $menu-collapsed-width;\n      width: $menu-expanded-width;\n      transition: visibility 0.25s, opacity 0.25s;\n      box-shadow: 1px 0px 2px rgba(0, 0, 0, 0.1);\n      border-bottom: 2px solid rgba(0, 0, 0, 0.2);\n      border-left: 1px solid rgba(0, 0, 0, 0.02);\n\n      li {\n        white-space: nowrap;\n        position: relative;\n\n        a {\n          display: block;\n          padding: 8px 20px 8px 20px;\n        }\n\n        @include vertical-menu-has-sub-arrow(1rem);\n      }\n    }\n    .ps__rail-y:hover {\n      background-color: transparent !important;\n    }\n  }\n}\n","/*=========================================================================================\n\tFile Name: horizontal-menu.scss\n\tDescription: A classic horizontal menu for easy navingation & support all devices.\n\tIt support light & dark version, filpped layout, right side icons, borders menu for\n\titem seperation.\n\t----------------------------------------------------------------------------------------\n\tItem Name: Vuexy  - Vuejs, HTML & Laravel admin Dashboard TemplateTheme\n\tAuthor: PIXINVENT\n\tAuthor URL: http://www.themeforest.net/user/pixinvent\n==========================================================================================*/\n\n// Core variables and mixins\n@import \"~bootstrap/scss/_functions.scss\";\n@import \"~bootstrap/scss/mixins\";\n@import \"../../bootstrap-extended/mixins\";\n\n// Core variables and mixins overrides\n@import \"../variables/variables\";\n@import \"~bootstrap/scss/_variables.scss\";\n\n// Overrides user variable\n@import \"../variables/components-variables\";\n\n// Import first main menu mixin\n@import \"../mixins/main-menu-mixin\";\n\n// Horizontal Menu\n//=========================\n.horizontal-layout {\n  &.navbar-floating {\n    .app-content {\n      padding-top: 9.75rem;\n    }\n  }\n\n  .content {\n    margin-left: 0;\n    .content-wrapper {\n      margin-top: 0 !important;\n      min-height: calc(100vh - 13.75rem);\n    }\n  }\n  footer {\n    position: static;\n    margin-left: 0;\n  }\n\n  .header-navbar {\n    &.fixed-top {\n      left: 0;\n    }\n    .brand-logo {\n      background: url(\"../../../img/logo/vuesax-logo.png\") no-repeat;\n      background-position: -65px -54px;\n      height: 24px;\n      width: 35px;\n    }\n\n    .navbar-nav.float-right {\n      .nav-item:not(:last-child) {\n        a.nav-link {\n          margin-right: 4px;\n        }\n        .dropdown-notification {\n          .nav-link {\n            margin-right: 10px;\n          }\n        }\n      }\n    }\n  }\n\n  ul#main-menu-navigation > li {\n    line-height: 1;\n    &.active {\n      .nav-link {\n        background: linear-gradient(\n          118deg,\n          rgba($primary, 1),\n          rgba($primary, 0.7)\n        );\n        box-shadow: 0px 0px 6px 1px rgba($primary, 0.6);\n        color: $white !important;\n        border-radius: 4px;\n        .dropdown-menu {\n          .active {\n            background-color: $body-bg;\n          }\n        }\n      }\n    }\n    &.nav-item {\n      &:not(:last-child) .nav-link.dropdown {\n        margin-right: 4px;\n      }\n    }\n    .single-item {\n      padding-left: 11px !important;\n      padding-right: 11px !important;\n      .nav-link {\n        color: $body-color;\n        padding: 0.75rem 1.25rem !important;\n      }\n    }\n    .dropdown:not(.sub-menu) {\n      padding-top: 0.965rem;\n      padding-bottom: 0.965rem;\n      &.nav-link {\n        padding: 0.75rem 1.25rem;\n      }\n    }\n    .item-content {\n      color: $body-color;\n      span {\n        vertical-align: middle;\n      }\n    }\n\n    .dropdown-text {\n      span:not(.menu-icon) {\n        vertical-align: bottom;\n      }\n    }\n\n    .has-sub-arrow {\n      position: absolute;\n      right: 1rem;\n      top: 15px;\n    }\n\n    .dropdown-menu {\n      margin-left: 0;\n      animation-duration: 0.3s;\n      animation-fill-mode: both;\n      animation-name: slideIn;\n      li {\n        &:focus {\n          outline: none;\n        }\n      }\n      .dropdown-item {\n        transition: padding 0.35s ease 0s !important;\n        line-height: 1;\n        &:focus {\n          outline: 0;\n        }\n        &.hover {\n          padding-left: 25px !important;\n          transition: padding 0.35s ease 0s !important;\n          background-color: transparent;\n          color: $body-color;\n        }\n        &.has-sub {\n          &:focus {\n            outline: 0;\n          }\n          &.hover {\n            padding-left: 10px !important;\n            background-color: $body-bg;\n          }\n        }\n        &.active {\n          background: $body-bg;\n          span,\n          svg {\n            color: $primary !important;\n            font-weight: 500;\n          }\n        }\n      }\n\n      .open {\n        &.active {\n          > a {\n            color: $body-color;\n            font-weight: normal;\n          }\n        }\n      }\n      .dropdown-item {\n        font-size: 1rem;\n        display: flex;\n        align-items: center;\n        &:not(.has-sub) {\n          padding: 0.95rem 1.428rem;\n        }\n        &:hover {\n          span,\n          svg {\n            color: $body-color;\n          }\n        }\n        &.has-sub {\n          padding: 0;\n          .dropdown {\n            padding: 0.95rem 1.4rem;\n          }\n        }\n      }\n      &::-webkit-scrollbar {\n        width: 5px;\n        height: 5px;\n      }\n\n      &::-webkit-scrollbar-thumb {\n        background: $gray-300;\n        border-radius: 20px;\n      }\n\n      &::-webkit-scrollbar-track {\n        background: $body-bg;\n        border-radius: 30px;\n      }\n    }\n    > .dropdown a {\n      display: flex;\n      margin-right: 0.5rem;\n      align-items: center;\n    }\n    &.hover .nav-link {\n      background: $body-bg;\n      border-radius: 4px;\n    }\n    .nav-item-wrapper {\n      padding: 11px 0;\n    }\n    .dropdown.has-active-child {\n      background-color: $body-bg;\n    }\n\n    .dropdown-menu {\n      &[x-placement=\"left-start\"],\n      &[x-placement=\"left-start\"] .dropdown-menu {\n        left: -100%;\n        right: 100%;\n      }\n    }\n  }\n\n  &.navbar-floating {\n    &:not(.blank-page) {\n      .app-content {\n        padding-top: 9.75rem;\n      }\n    }\n    .horizontal-menu-wrapper {\n      background: linear-gradient(\n        to bottom,\n        rgba(248, 248, 248, 0.95) 44%,\n        rgba(248, 248, 248, 0.46) 73%,\n        rgba(255, 255, 255, 0) 100%\n      );\n      background-repeat: repeat-x;\n      .navbar-horizontal.floating-nav {\n        margin: 1.3rem 2.2rem 0;\n      }\n    }\n  }\n  &.dark-layout {\n    .header-navbar {\n      background: inherit !important;\n    }\n    .horizontal-menu-wrapper {\n      background: linear-gradient(\n        to bottom,\n        rgba(37, 43, 71, 0.76) 44%,\n        rgba(56, 53, 53, 0.46) 73%,\n        rgba(255, 255, 255, 0) 100%\n      );\n      .header-navbar {\n        background: $menu-dark-bg-color !important;\n        &.navbar-horizontal {\n          ul#main-menu-navigation > li:hover:not(.active) > a {\n            background: $content-dark-bg;\n          }\n        }\n      }\n    }\n  }\n\n  &.navbar-sticky {\n    .app-content {\n      padding-top: 8.5rem;\n    }\n    .header-navbar {\n      background-color: $body-bg;\n      box-shadow: none;\n    }\n    .horizontal-menu-wrapper {\n      .navbar-horizontal.header-navbar.fixed-top {\n        left: 0;\n        top: 62px;\n        background-color: $white;\n      }\n    }\n  }\n  &.navbar-static {\n    .app-content {\n      padding-top: 2.5rem;\n    }\n    .header-navbar:not(.scrolling) {\n      background-color: $body-bg;\n      box-shadow: none;\n      .navbar-wrapper {\n        width: 100%;\n      }\n    }\n    .horizontal-menu-wrapper {\n      position: relative;\n      .navbar-horizontal.header-navbar {\n        background: $white;\n        &.navbar-static-top {\n          position: static;\n          background: $white;\n          left: 0;\n        }\n      }\n    }\n  }\n  //---------------//\n  // Navbar Header //\n  //---------------//\n  .horizontal-menu-wrapper {\n    position: fixed;\n    top: 62px;\n    z-index: 990;\n    width: 100%;\n    height: 99px;\n    .header-navbar {\n      .navbar-container {\n        padding-left: 1rem;\n        padding-right: 1rem;\n        width: 100%;\n      }\n      .navbar-header {\n        display: none;\n      }\n    }\n  }\n  .header-navbar {\n    background: $white;\n    z-index: 999 !important;\n    line-height: 1;\n    // Navbar- Brand Center - Logo\n    &.navbar-horizontal.floating-nav {\n      width: calc(100vw - (100vw - 100%) - calc(#{$content-padding} * 2));\n      background: $white;\n    }\n    .navbar-container {\n      padding-left: #{$content-padding};\n      padding-right: calc(#{$content-padding} - 1rem);\n      border-radius: $border-radius;\n    }\n    &.navbar-fixed {\n      position: fixed;\n      width: 100%;\n    }\n    &.navbar-brand-center {\n      .navbar-header {\n        position: absolute;\n        left: 50%;\n        margin-left: -65px;\n        padding: 0;\n        z-index: 1000;\n        .navbar-brand {\n          display: flex;\n          align-items: center;\n          margin-right: 0;\n          // Brand Logo Scss\n\n          // Brand Text Scss\n          .brand-text {\n            color: $white;\n            padding-left: 1rem;\n            letter-spacing: 0.01rem;\n            font-size: 1.57rem;\n          }\n        }\n      }\n    }\n\n    &.navbar-horizontal {\n      .nav-link {\n        &.dropdown-toggle::after {\n          left: 0.4rem;\n        }\n      }\n      .dropdown-menu::before {\n        display: none;\n      }\n      .dropdown-menu {\n        min-width: 215px;\n        border: none;\n        min-height: 52px;\n        .disabled {\n          pointer-events: none !important;\n          a {\n            color: $gray-600;\n          }\n        }\n        .dropdown-toggle::after {\n          left: auto;\n          position: absolute;\n          top: 50%;\n          margin-top: -7px;\n          right: 1rem;\n          content: \"\\e844\" !important;\n        }\n\n        .dropdown-submenu {\n          position: relative;\n          &.openLeft {\n            .dropdown-menu {\n              left: auto;\n              right: 100%;\n            }\n          }\n          &.show {\n            background: $body-bg;\n          }\n          & > .dropdown-menu {\n            position: absolute;\n            top: 0 !important;\n            left: 100% !important;\n            i {\n              font-size: 0.75rem !important;\n            }\n          }\n        }\n      }\n    }\n  }\n  &.menu-collapsed {\n    #main-menu-navigation {\n      .nav-item {\n        > a span {\n          display: none;\n        }\n      }\n    }\n  }\n  .navigation-header {\n    font-family: inherit;\n    color: #929292;\n    padding: 8px 20px;\n    font-size: 1rem;\n    text-transform: uppercase;\n  }\n\n  .navbar-dark {\n    .nav-item {\n      &.active > a {\n        border-bottom: 2px solid $primary;\n        background-color: #313c50;\n      }\n    }\n  }\n  // App related CSS for Horizontal\n  .content.app-content .content-area-wrapper {\n    margin-top: 2.2rem;\n    .content-wrapper {\n      height: calc(100vh - 16rem);\n      height: calc(var(--vh, 1vh) * 100 - 16rem);\n    }\n  }\n  &.chat-application .sidebar-content,\n  &.email-application .content-area-wrapper .sidebar .email-app-sidebar,\n  &.todo-application .content-area-wrapper .sidebar .todo-sidebar {\n    height: calc(100vh - 16rem);\n    height: calc(var(--vh, 1vh) * 100 - 16rem);\n  }\n  &.todo-application .content-area-wrapper .content-right .todo-task-list {\n    height: calc(100vh - 19.5rem);\n    height: calc(var(--vh, 1vh) * 100 - 19.5rem);\n  }\n  &.email-application .app-content .content-area-wrapper .email-user-list {\n    height: calc(100vh - 23.3rem);\n    height: calc(var(--vh, 1vh) * 100 - 23.3rem);\n  }\n  &.chat-application {\n    .user-profile-sidebar {\n      height: calc(100vh - 16.1rem);\n      height: calc(var(--vh, 1vh) * 100 - 16.1rem);\n      bottom: 4.1rem;\n    }\n    .chat-profile-sidebar {\n      height: calc(100vh - 16rem);\n      height: calc(var(--vh, 1vh) * 100 - 16rem);\n    }\n    .chat-app-window .user-chats {\n      height: calc(100vh - 26.5rem);\n      height: calc(var(--vh, 1vh) * 100 - 26.5rem);\n    }\n  }\n}\n\n// Initially menu & content width for md and down screen\n@include media-breakpoint-down(lg) {\n  body.horizontal-layout {\n    &.horizontal-menu {\n      .horizontal-menu-wrapper {\n        .header-navbar {\n          display: none;\n        }\n      }\n    }\n    .header-navbar {\n      background: $white;\n    }\n    .content .content-wrapper {\n      margin-top: 5rem;\n    }\n  }\n}\n\n@media (max-width: 1230px) and (min-width: 1200px) {\n  .horizontal-layout {\n    .horizontal-menu-wrapper {\n      #main-menu-navigation {\n        .nav-item .nav-link {\n          a {\n            margin-right: 0;\n          }\n        }\n      }\n    }\n  }\n}\n\n@keyframes slideIn {\n  100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n\n  0% {\n    transform: translateY(1rem);\n    opacity: 0;\n  }\n}\n","// ================================================================================================\n// \tFile Name: helper.scss\n// \tDescription: Helper classes provides color, width, position & background etc..\n// \t\t\t\t related customiztion.\n// \t----------------------------------------------------------------------------------------------\n// \tItem Name: Vuexy React admin Template\n// \tVersion: 1.0\n// \tAuthor: PIXINVENT\n// \tAuthor URL: http://www.themeforest.net/user/pixinvent\n// ================================================================================================\n\n// Content helpers\n// -------------------------\n// Display\n\n.display-inline {\n  display: inline !important;\n}\n.display-block {\n  display: block !important;\n}\n.display-inline-block {\n  display: inline-block !important;\n}\n.display-hidden {\n  display: none !important;\n}\n.display-table-cell {\n  display: table-cell !important;\n}\n\n// Position\n\n.position-top-0 {\n  top: 0;\n}\n.position-right-0 {\n  right: 0;\n}\n.position-bottom-0 {\n  bottom: 0;\n}\n.position-left-0 {\n  left: 0;\n}\n\n// Z-index\n\n.zindex-1 {\n  z-index: 1 !important;\n}\n.zindex-2 {\n  z-index: 2 !important;\n}\n.zindex-3 {\n  z-index: 3 !important;\n}\n.zindex-4 {\n  z-index: 4 !important;\n}\n.zindex-0 {\n  z-index: 0 !important;\n}\n.zindex-minus-1 {\n  z-index: -1 !important;\n}\n.zindex-minus-2 {\n  z-index: -2 !important;\n}\n.zindex-minus-3 {\n  z-index: -3 !important;\n}\n.zindex-minus-4 {\n  z-index: -4 !important;\n}\n\n// Edges\n.no-edge-top {\n  top: 0 !important;\n}\n.no-edge-bottom {\n  bottom: 0 !important;\n}\n.no-edge-left {\n  left: 0 !important;\n}\n.no-edge-right {\n  right: 0 !important;\n}\n\n// Cursors\n.cursor-pointer {\n  cursor: pointer;\n}\n.cursor-move {\n  cursor: move;\n}\n.cursor-default {\n  cursor: default;\n}\n.cursor-progress {\n  cursor: progress;\n}\n.cursor-not-allowed {\n  cursor: not-allowed;\n}\n\n// Overflow\n.overflow-hidden {\n  overflow: hidden;\n}\n.overflow-visible {\n  overflow: visible;\n}\n.overflow-auto {\n  overflow: auto;\n}\n.overflow-scroll {\n  overflow: scroll;\n}\n.overflow-x-scroll {\n  overflow: scroll;\n}\n.overflow-y-scroll {\n  overflow: scroll;\n}\n\n// Lists\n.bullets-inside {\n  list-style: inside;\n}\n.list-style-circle {\n  list-style: circle;\n}\n.list-style-square {\n  list-style: square;\n}\n.list-style-icons {\n  padding-left: 10px;\n  margin-left: 0;\n  list-style: none;\n  > li svg {\n    width: 1em;\n    margin: 0 6px 0 0;\n  }\n}\n\n// Borders\n// -------------------------\n\n// Add borders\n.border {\n  border: 1px solid;\n}\n.border-top {\n  border-top: 1px solid;\n}\n.border-bottom {\n  border-bottom: 1px solid;\n}\n.border-left {\n  border-left: 1px solid;\n}\n.border-right {\n  border-right: 1px solid;\n}\n\n// Border widths\n\n// Med - 2px\n.border-2 {\n  border-width: 2px !important;\n}\n.border-top-2 {\n  border-top-width: 2px !important;\n}\n.border-bottom-2 {\n  border-bottom-width: 2px !important;\n}\n.border-left-2 {\n  border-left-width: 2px !important;\n}\n.border-right-2 {\n  border-right-width: 2px !important;\n}\n\n// Large - 3px\n.border-3 {\n  border-width: 3px !important;\n}\n.border-top-3 {\n  border-top-width: 3px !important;\n}\n.border-bottom-3 {\n  border-bottom-width: 3px !important;\n}\n.border-left-3 {\n  border-left-width: 3px !important;\n}\n.border-right-3 {\n  border-right-width: 3px !important;\n}\n\n// No border radious\n.no-border-top-radius {\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n}\n.no-border-bottom-radius {\n  border-bottom-left-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.no-border-top-left-radius {\n  border-top-left-radius: 0 !important;\n}\n.no-border-top-right-radius {\n  border-top-right-radius: 0 !important;\n}\n.no-border-bottom-left-radius {\n  border-bottom-left-radius: 0 !important;\n}\n.no-border-bottom-right-radius {\n  border-bottom-right-radius: 0 !important;\n}\n\n// Box Shadow\n\n.box-shadow-0 {\n  box-shadow: none !important;\n}\n\n.box-shadow-1 {\n  box-shadow: 0 2px 5px 0 rgba($pure-black, 0.16),\n    0 2px 10px 0 rgba($pure-black, 0.12);\n}\n\n.box-shadow-2 {\n  box-shadow: 0 8px 17px 0 rgba($pure-black, 0.2),\n    0 6px 20px 0 rgba($pure-black, 0.19);\n}\n\n.box-shadow-3 {\n  box-shadow: 0 12px 15px 0 rgba($pure-black, 0.24),\n    0 17px 50px 0 rgba($pure-black, 0.19);\n}\n\n.box-shadow-4 {\n  box-shadow: 0 16px 28px 0 rgba($pure-black, 0.22),\n    0 25px 55px 0 rgba($pure-black, 0.21);\n}\n\n.box-shadow-5 {\n  box-shadow: 0 27px 24px 0 rgba($pure-black, 0.2),\n    0 40px 77px 0 rgba($pure-black, 0.22);\n}\n\n.box-shadow-6 {\n  box-shadow: 0 4px 8px 0 rgba($pure-black, 0.12),\n    0 2px 4px 0 rgba($pure-black, 0.08);\n}\n\n// Sizing\n// -------------------------\n\n//\n// Width && Height\n//\n\n.fit {\n  max-width: 100% !important;\n}\n.half-width {\n  width: 50% !important;\n}\n.full-width {\n  width: 100% !important;\n}\n.full-height {\n  height: 100% !important;\n}\n\n// Fixed widths\n.width-50 {\n  width: 50px !important;\n}\n.width-100 {\n  width: 100px !important;\n}\n.width-150 {\n  width: 150px !important;\n}\n.width-200 {\n  width: 200px !important;\n}\n.width-250 {\n  width: 250px !important;\n}\n.width-300 {\n  width: 300px !important;\n}\n.width-350 {\n  width: 350px !important;\n}\n.width-400 {\n  width: 400px !important;\n}\n.width-450 {\n  width: 450px !important;\n}\n.width-500 {\n  width: 500px !important;\n}\n.width-550 {\n  width: 550px !important;\n}\n.width-600 {\n  width: 600px !important;\n}\n.width-650 {\n  width: 650px !important;\n}\n.width-700 {\n  width: 700px !important;\n}\n.width-750 {\n  width: 750px !important;\n}\n.width-800 {\n  width: 800px !important;\n}\n// Width in %\n.width-5-per {\n  width: 5% !important;\n}\n.width-10-per {\n  width: 10% !important;\n}\n.width-15-per {\n  width: 15% !important;\n}\n.width-20-per {\n  width: 20% !important;\n}\n.width-25-per {\n  width: 25% !important;\n}\n.width-30-per {\n  width: 30% !important;\n}\n.width-35-per {\n  width: 35% !important;\n}\n.width-40-per {\n  width: 40% !important;\n}\n.width-45-per {\n  width: 45% !important;\n}\n.width-50-per {\n  width: 50% !important;\n}\n.width-55-per {\n  width: 55% !important;\n}\n.width-60-per {\n  width: 60% !important;\n}\n.width-65-per {\n  width: 65% !important;\n}\n.width-70-per {\n  width: 70% !important;\n}\n.width-75-per {\n  width: 75% !important;\n}\n.width-80-per {\n  width: 80% !important;\n}\n.width-90-per {\n  width: 90% !important;\n}\n.width-95-per {\n  width: 95% !important;\n}\n\n//Fixed Height in px\n\n.height-50 {\n  height: 50px !important;\n}\n.height-75 {\n  height: 75px !important;\n}\n.height-100 {\n  height: 100px !important;\n}\n.height-150 {\n  height: 150px !important;\n}\n.height-200 {\n  height: 200px !important;\n}\n.height-250 {\n  height: 250px !important;\n}\n.height-300 {\n  height: 300px !important;\n}\n.height-350 {\n  height: 350px !important;\n}\n.height-400 {\n  height: 400px !important;\n}\n.height-450 {\n  height: 450px !important;\n}\n.height-500 {\n  height: 500px !important;\n}\n.height-550 {\n  height: 550px !important;\n}\n.height-600 {\n  height: 600px !important;\n}\n.height-650 {\n  height: 650px !important;\n}\n.height-700 {\n  height: 700px !important;\n}\n.height-750 {\n  height: 750px !important;\n}\n.height-800 {\n  height: 800px !important;\n}\n\n//Fixed Height in %\n\n.height-5-per {\n  height: 5% !important;\n}\n.height-10-per {\n  height: 10% !important;\n}\n.height-15-per {\n  height: 15% !important;\n}\n.height-20-per {\n  height: 20% !important;\n}\n.height-25-per {\n  height: 25% !important;\n}\n.height-30-per {\n  height: 30% !important;\n}\n.height-35-per {\n  height: 35% !important;\n}\n.height-40-per {\n  height: 40% !important;\n}\n.height-45-per {\n  height: 45% !important;\n}\n.height-50-per {\n  height: 50% !important;\n}\n.height-55-per {\n  height: 55% !important;\n}\n.height-60-per {\n  height: 60% !important;\n}\n.height-65-per {\n  height: 65% !important;\n}\n.height-70-per {\n  height: 70% !important;\n}\n.height-75-per {\n  height: 75% !important;\n}\n.height-80-per {\n  height: 80% !important;\n}\n\n//vh height\n.full-height-vh {\n  height: 100vh;\n}\n\n// Line height\n.line-height-1 {\n  line-height: 1 !important;\n}\n.line-height-2 {\n  line-height: 2 !important;\n}\n\n//Transformations\n\n.rotate-45 {\n  transform: rotate(45deg);\n}\n.rotate-45-inverse {\n  transform: rotate(-45deg);\n}\n.rotate-90 {\n  transform: rotate(45deg);\n}\n.rotate-90-inverse {\n  transform: rotate(-45deg);\n}\n.rotate-180 {\n  transform: rotate(45deg);\n}\n.rotate-180-inverse {\n  transform: rotate(-45deg);\n}\n\n//Pull the element\n.pull-up {\n  transition: all 0.25s ease;\n\n  &:hover {\n    transform: translateY(-4px) scale(1.02);\n    box-shadow: 0px 14px 24px rgba(62, 57, 107, 0.2);\n    z-index: 30;\n  }\n}\n\n// Spinner classes\n.spinner {\n  display: inline-block;\n  animation: spin 1s linear infinite;\n}\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.spinner-reverse {\n  display: inline-block;\n  animation: spin-reverse 1s linear infinite;\n}\n@keyframes spin-reverse {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(-360deg);\n  }\n}\n\n//\n// Image\n//\n\n//Background Image\n.bg-cover {\n  background-size: cover !important;\n}\n.background-repeat {\n  background-repeat: repeat !important;\n}\n.background-no-repeat {\n  background-repeat: no-repeat !important;\n}\n\n// Extra large\n.img-xl {\n  width: 64px !important;\n  height: 64px !important;\n}\n\n// Large\n.img-lg {\n  width: 44px !important;\n  height: 44px !important;\n}\n\n// Small\n.img-sm {\n  width: 36px !important;\n  height: 36px !important;\n}\n\n// Mini\n.img-xs {\n  width: 32px !important;\n  height: 32px !important;\n}\n\n// Bullets used in application pages\n.bullet {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  display: inline-block;\n  &.bullet-xs {\n    width: 0.5rem;\n    height: 0.5rem;\n  }\n  &.bullet-sm {\n    width: 0.714rem;\n    height: 0.714rem;\n  }\n  &.bullet-lg {\n    width: 1.25rem;\n    height: 1.25rem;\n  }\n}\n\n// color adio\n.color-radio {\n  position: relative;\n  height: 30px;\n  width: 30px;\n  border-radius: 50%;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  .radio-content {\n    height: 20px;\n    width: 20px;\n    display: block;\n    border-radius: 50%;\n  }\n}\n\n// Match Height\n.match-height {\n  .card {\n    height: calc(100% - 2.2rem);\n  }\n}\n","// =========================================================================================\n//   File Name: avatar.scss\n//   Description: Avatar images.\n//   ----------------------------------------------------------------------------------------\n//   Item Name: Vuexy React admin Template\n//   Version: 1.0\n//   Author: PIXINVENT\n//   Author URL: http://www.themeforest.net/user/pixinvent\n// ==========================================================================================\n\n// Component: Avatar\n// ========================================================================\n\n// avatar\n\n.avatar {\n  white-space: nowrap;\n  background-color: $avatar-bg;\n  border-radius: 50%;\n  position: relative;\n  cursor: pointer;\n  color: $white;\n  display: inline-flex;\n  font-size: 0.75rem;\n  text-align: center;\n  vertical-align: middle;\n  margin: 5px;\n\n  // avatar content\n  .avatar-content {\n    width: $avatar-size;\n    height: $avatar-size;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    .avatar-icon {\n      svg {\n        width: 1.2rem;\n        height: 1.2rem;\n      }\n    }\n  }\n\n  &:not(.avatar-stats) {\n    svg {\n      height: 12px;\n      width: 12px;\n    }\n  }\n  [class*=\"avatar-status-\"] {\n    border-radius: 50%;\n    width: $avatar-status-size;\n    height: $avatar-status-size;\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    border: 1px solid $white;\n    &.avatar-status-lg {\n      width: $avatar-status-size-lg;\n      height: $avatar-status-size-lg;\n      border-width: 2px;\n    }\n  }\n  .avatar-status-online {\n    background-color: $success;\n  }\n  .avatar-status-busy {\n    background-color: $danger;\n  }\n  .avatar-status-away {\n    background-color: $warning;\n  }\n  .avatar-status-offline {\n    background-color: $secondary;\n  }\n\n  // avatar img\n  img {\n    // max-width: 100%; // removed as not affecting in avatar images\n    border-radius: 50%;\n  }\n\n  // Size Modifier\n  // ========================================================================\n\n  &.avatar-xl {\n    font-size: 1.5rem;\n    img {\n      width: $avatar-size-xl;\n      height: $avatar-size-xl;\n    }\n    .avatar-content {\n      height: $avatar-size-xl;\n      width: $avatar-size-xl;\n      .avatar-icon {\n        svg {\n          width: 3rem;\n          height: 3rem;\n        }\n      }\n    }\n  }\n  &.avatar-lg {\n    font-size: 1.2rem;\n    img {\n      width: $avatar-size-lg;\n      height: $avatar-size-lg;\n    }\n    .avatar-content {\n      width: $avatar-size-lg;\n      height: $avatar-size-lg;\n      .avatar-icon {\n        svg {\n          width: 2rem;\n          height: 2rem;\n        }\n      }\n    }\n  }\n\n  &.avatar-sm {\n    .avatar-content {\n      width: $avatar-size-sm;\n      height: $avatar-size-sm;\n      .avatar-icon {\n        svg {\n          width: 1rem;\n          height: 1rem;\n        }\n      }\n    }\n    img {\n      width: $avatar-size-sm;\n      height: $avatar-size-sm;\n    }\n  }\n}\n","/*=========================================================================================\n\tFile Name: search.scss\n\tDescription: Search  functionality.\n\t----------------------------------------------------------------------------------------\n\tItem Name: Vuexy React admin Template\n\tVersion: 1.0\n\tAuthor: PIXINVENT\n\tAuthor URL: http://www.themeforest.net/user/pixinvent\n==========================================================================================*/\n\n.navbar-container {\n  a.nav-link-search {\n    float: left;\n  }\n  .search-input {\n    float: left;\n    // padding-top: 1.2rem;\n    width: 0;\n    // select{\n    input {\n      width: 0;\n      border: \"2px solid black\";\n      transition: all 0.2s ease-out;\n      line-height: 16px;\n      padding: 1.75rem 3.6rem;\n      &:focus {\n        outline: 0 !important;\n        outline-offset: 0 !important;\n      }\n    }\n    &.open {\n      position: absolute;\n      left: 0;\n      // padding: 1.6rem;\n      // background: #fff;\n      right: 0;\n      width: 100%;\n      z-index: 1;\n      border-radius: 0.5rem;\n      .search-input-close,\n      .search-input-icon {\n        display: block;\n      }\n      // select{\n      input {\n        width: 100%;\n        // padding-right:2rem;\n        outline: none;\n        transition: all 0.3s ease-out;\n      }\n    }\n    .search-input-icon {\n      z-index: 2;\n      display: none;\n      position: absolute;\n      left: 1.5rem;\n      top: 1.75rem;\n      cursor: pointer;\n    }\n    .search-input-close {\n      z-index: 1;\n      display: none;\n      position: absolute;\n      right: 2rem;\n      top: 20px;\n      cursor: pointer;\n    }\n    .search-header {\n      padding: 1.2rem 1.5rem;\n      padding-bottom: 0.5rem;\n    }\n    .other-results {\n      overflow: hidden;\n      .permanent-result {\n        width: 100%;\n        cursor: pointer;\n        padding: 0.5rem;\n        padding-left: 1rem;\n        &:hover {\n          background-color: #f1f1f1;\n        }\n      }\n    }\n  }\n\n  .bookmark-input {\n    position: absolute;\n    top: 102%;\n    width: 25%;\n    display: none;\n    &.show {\n      display: block;\n    }\n    .bookmark-input-icon {\n      position: absolute;\n      z-index: 1;\n      top: 0.75rem;\n      left: 1rem;\n    }\n    input {\n      padding: 0.7rem 0.7rem 0.7rem 2.5rem;\n      width: 100%;\n      background: $white;\n      border: 1px solid rgba($pure_black, 0.2);\n      border-bottom-left-radius: 5px !important;\n      border-bottom-right-radius: 5px !important;\n      &:focus {\n        border: 1px solid $primary;\n      }\n    }\n\n  }\n  .bookmark-icon {\n    cursor: pointer;\n  }\n  .dropdown.bookmark-dropdown {\n    padding: 1.4rem 0.5rem 1.35rem;\n    .dropdown-toggle:after {\n      display: none;\n    }\n  }\n}\n/* .navbar-light, .navbar-semi-dark{\n\t.search-input{\n\t\t.input{\n\t\t\tcolor: $gray-600;\n\t\t}\n\t\t&.open{\n\t\t\t.input{\n\t\t\t\tcolor: $gray-600;\n\t\t\t\t// border-bottom: 1px solid $gray-600;\n\n\t\t\t}\n\t\t}\n\t}\n} */\n.navbar-dark,\n.navbar-semi-light {\n  .search-input {\n    .input {\n      color: #f5f7fa;\n      border-radius: 0.5rem;\n      border:\"2px solid black\"\n    }\n    &.open {\n      .input {\n        color: #f5f7fa;\n        border: 1px solid #f5f7fa;\n      }\n    }\n  }\n}\n\n@include media-breakpoint-down(sm) {\n  #navbar-mobile {\n    .search-input.open {\n      .input {\n        color: $gray-600;\n      }\n    }\n  }\n}\n\n\n@media (max-width : 1300px){\n  .navbar-container{\n    .bookmark-input{\n      width: 35%;\n    }\n  }\n}\n","// Apex chart Scss\n\n.apexcharts-canvas{\n  // Tooltip Color\n  .apexcharts-tooltip{\n    color: $body-color !important;\n    &.dark{\n      color: $white !important;\n    }\n  }\n  // Toolbar Download Option Color\n  .apexcharts-toolbar{\n    .apexcharts-menu{\n      .apexcharts-menu-item{\n        color: $body-color;\n      }\n    }\n  }\n}\n\n// apex charts tooltip\n.apexcharts-xaxistooltip{\n  color: $body-color !important;\n}\n\n// client-retention Chart - legend position for left\n#client-retention-chart{\n  .apexcharts-canvas{\n    .apexcharts-legend{\n      left: -14px !important;\n    }\n  }\n}\n","$bs-height-base: ($line-height-base + $input-btn-padding-y * 2) !default;\n$bs-height-lg:   (floor($font-size-lg * $line-height-base) + $input-btn-padding-y-lg * 2) !default;\n$bs-height-sm:   (floor($font-size-sm * 1.5) + $input-btn-padding-y-lg * 2) !default;\n$bs-height-xs:   (floor($font-size-sm * 0.2) + $input-btn-padding-y-lg) !default;\n\n.btn-social {\n  position: relative;\n  padding-left: ($bs-height-base + $input-btn-padding-x);\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  > :first-child {\n    position: absolute;\n    left: 0;\n    top: 2px;\n    bottom: 0;\n    width: $bs-height-base;\n    line-height: ($bs-height-base - 0.25);\n    font-size: $font-size-base;\n    text-align: center;\n    border-right: 1px solid rgba(0, 0, 0, 0.2);\n  }\n  \n}\n\n.btn-social-icon {\n  @extend .btn-social;\n  height: ($bs-height-base);\n  width: ($bs-height-base);\n  padding: 0;\n  > :first-child {\n    border: none;\n    text-align: center;\n    width: 100%!important;\n  }\n}\n\n// Social button Mixin\n@mixin btn-social($color-bg, $color: #fff, $hover:$color-bg, $border-hover:$color-bg) {\n  background-color: $color-bg;\n  @include button-variant($color-bg, $color, $hover, $border-hover);\n}\n\n// Social Outline Button Mixin\n@mixin btn-social-outline($color-bg) {\n  border: 1px solid $color-bg !important;\n  color: $color-bg;\n}\n\n// Social Outline Button Hover Mixin\n@mixin btn-hover-outline($color-bg) {\n  color: darken($color-bg, 20%);\n  border: 1px solid darken($color-bg, 20%) !important;\n}\n\n// Social button\n.btn-adn           { @include btn-social(#d87a68); }\n.btn-bitbucket     { @include btn-social(#205081); }\n.btn-dropbox       { @include btn-social(#1087dd); }\n.btn-facebook      { @include btn-social(#3b5998); }\n.btn-flickr        { @include btn-social(#ff0084); }\n.btn-foursquare    { @include btn-social(#f94877); }\n.btn-github        { @include btn-social(#444444); }\n.btn-google        { @include btn-social(#dd4b39); }\n.btn-instagram     { @include btn-social(#3f729b); }\n.btn-linkedin      { @include btn-social(#007bb6); }\n.btn-microsoft     { @include btn-social(#2672ec); }\n.btn-odnoklassniki { @include btn-social(#f4731c); }\n.btn-openid        { @include btn-social(#f7931e); }\n.btn-pinterest     { @include btn-social(#cb2027); }\n.btn-reddit        { @include btn-social(#eff7ff, #000, #000, #000); }\n.btn-soundcloud    { @include btn-social(#ff5500); }\n.btn-tumblr        { @include btn-social(#2c4762); }\n.btn-twitter       { @include btn-social(#55acee, #fff); }\n.btn-vimeo         { @include btn-social(#1ab7ea); }\n.btn-vk            { @include btn-social(#587ea3); }\n.btn-yahoo         { @include btn-social(#720e9e); }\n\n// Social Outline button\n.btn-outline-adn           { @include btn-social-outline(#d87a68); }\n.btn-outline-bitbucket     { @include btn-social-outline(#205081); }\n.btn-outline-dropbox       { @include btn-social-outline(#1087dd); }\n.btn-outline-facebook      { @include btn-social-outline(#3b5998); }\n.btn-outline-flickr        { @include btn-social-outline(#ff0084); }\n.btn-outline-foursquare    { @include btn-social-outline(#f94877); }\n.btn-outline-github        { @include btn-social-outline(#444444); }\n.btn-outline-google        { @include btn-social-outline(#dd4b39); }\n.btn-outline-instagram     { @include btn-social-outline(#3f729b); }\n.btn-outline-linkedin      { @include btn-social-outline(#007bb6); }\n.btn-outline-microsoft     { @include btn-social-outline(#2672ec); }\n.btn-outline-odnoklassniki { @include btn-social-outline(#f4731c); }\n.btn-outline-openid        { @include btn-social-outline(#f7931e); }\n.btn-outline-pinterest     { @include btn-social-outline(#cb2027); }\n.btn-outline-reddit        { @include btn-social-outline(#ff4500); }\n.btn-outline-soundcloud    { @include btn-social-outline(#ff5500); }\n.btn-outline-tumblr        { @include btn-social-outline(#2c4762); }\n.btn-outline-twitter       { @include btn-social-outline(#55acee); }\n.btn-outline-vimeo         { @include btn-social-outline(#1ab7ea); }\n.btn-outline-vk            { @include btn-social-outline(#587ea3); }\n.btn-outline-yahoo         { @include btn-social-outline(#720e9e); }\n\n// Social Outline hover button\n.btn-outline-adn:hover           { @include btn-hover-outline(#d87a68); }\n.btn-outline-bitbucket:hover     { @include btn-hover-outline(#205081); }\n.btn-outline-dropbox:hover       { @include btn-hover-outline(#1087dd); }\n.btn-outline-facebook:hover      { @include btn-hover-outline(#3b5998); }\n.btn-outline-flickr:hover        { @include btn-hover-outline(#ff0084); }\n.btn-outline-foursquare:hover    { @include btn-hover-outline(#f94877); }\n.btn-outline-github:hover        { @include btn-hover-outline(#444444); }\n.btn-outline-google:hover        { @include btn-hover-outline(#dd4b39); }\n.btn-outline-instagram:hover     { @include btn-hover-outline(#3f729b); }\n.btn-outline-linkedin:hover      { @include btn-hover-outline(#007bb6); }\n.btn-outline-microsoft:hover     { @include btn-hover-outline(#2672ec); }\n.btn-outline-odnoklassniki:hover { @include btn-hover-outline(#f4731c); }\n.btn-outline-openid:hover        { @include btn-hover-outline(#f7931e); }\n.btn-outline-pinterest:hover     { @include btn-hover-outline(#cb2027); }\n.btn-outline-reddit:hover        { @include btn-hover-outline(#ff4500); }\n.btn-outline-soundcloud:hover    { @include btn-hover-outline(#ff5500); }\n.btn-outline-tumblr:hover        { @include btn-hover-outline(#2c4762); }\n.btn-outline-twitter:hover       { @include btn-hover-outline(#55acee); }\n.btn-outline-vimeo:hover         { @include btn-hover-outline(#1ab7ea); }\n.btn-outline-vk:hover            { @include btn-hover-outline(#587ea3); }\n.btn-outline-yahoo:hover         { @include btn-hover-outline(#720e9e); }\n\n// Social Background colors\n.bg-adn           { background-color: #d87a68; }\n.bg-bitbucket     { background-color: #205081; }\n.bg-dropbox       { background-color: #1087dd; }\n.bg-facebook      { background-color: #3b5998; }\n.bg-flickr        { background-color: #ff0084; }\n.bg-foursquare    { background-color: #f94877; }\n.bg-github        { background-color: #444444; }\n.bg-google        { background-color: #dd4b39; }\n.bg-instagram     { background-color: #3f729b; }\n.bg-linkedin      { background-color: #007bb6; }\n.bg-microsoft     { background-color: #2672ec; }\n.bg-odnoklassniki { background-color: #f4731c; }\n.bg-openid        { background-color: #f7931e; }\n.bg-pinterest     { background-color: #cb2027; }\n.bg-reddit        { background-color: #ff4500; }\n.bg-soundcloud    { background-color: #ff5500; }\n.bg-tumblr        { background-color: #2c4762; }\n.bg-twitter       { background-color: #55acee; }\n.bg-vimeo         { background-color: #1ab7ea; }\n.bg-vk            { background-color: #587ea3; }\n.bg-yahoo         { background-color: #720e9e; }","/*=========================================================================================\n    File Name: demo.scss\n    Description: CSS used for demo purpose only. Remove this css from your project.\n    ----------------------------------------------------------------------------------------\n    Item Name: Vuexy React admin Template\n    Version: 1.0\n    Author: PIXINVENT\n    Author URL: http://www.themeforest.net/user/pixinvent\n==========================================================================================*/\n\n.fonticon-container {\n  > .fonticon-wrap {\n    float: left;\n    width: 60px;\n    height: 60px;\n    line-height: 1rem;\n    text-align: center;\n    // border: 2px solid $primary;\n    border-radius: 0.1875rem;\n    margin-right: 0;\n    margin-bottom: 1.5rem;\n    cursor: pointer;\n    > svg {\n      transition: all 0.2s ease-in-out;\n      &:hover {\n        stroke: $primary;\n        transform: scale(1.3);\n      }\n    }\n    &.youtube {\n      width: 100px;\n    }\n  }\n  &:hover {\n    svg {\n      color: $primary;\n      transform: scale(1.3);\n    }\n  }\n\n  > .fonticon-classname,\n  > .fonticon-unit {\n    display: block;\n    font-size: 1.5rem;\n    line-height: 1.2;\n  }\n\n  > .fonticon-unit {\n    font-size: 1rem;\n    font-style: italic;\n  }\n}\n\n.scroll-example {\n  padding: 0.5rem;\n  position: relative;\n  border: 2px solid darken($body-bg, 10%);\n  overflow: auto;\n\n  .horz-scroll-content {\n    width: 1200px;\n  }\n}\n\n.browser {\n  background: #e0e0e0;\n  border: 4px solid #e0e0e0;\n  width: 100%;\n  height: 12rem;\n  padding-top: 20px;\n  margin: 0 0 10px;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.browser iframe {\n  border: 0;\n  background: #fff;\n  height: 100%;\n  width: 100%;\n}\n\n.loader-wrapper {\n  height: 8em;\n}\n\n.maintenance-icon {\n  font-size: 4rem;\n}\n\n.animationIcon {\n  right: 30px;\n  bottom: 10px;\n}\n","/*=========================================================================================\n\tFile Name: customizer.scss\n\tDescription: CSS used for demo purpose only. Remove this css from your project.\n\t----------------------------------------------------------------------------------------\n\tItem Name: Vuexy React admin Template\n\tVersion: 1.0\n\tAuthor: PIXINVENT\n\tAuthor URL: http://www.themeforest.net/user/pixinvent\n  ==========================================================================================*/\n\n.customizer {\n  width: 400px;\n  right: -400px;\n  padding: 0;\n  background-color: #fff;\n  z-index: 1051;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  height: 100vh;\n  transition: right 0.4s cubic-bezier(0.05, 0.74, 0.2, 0.99);\n  backface-visibility: hidden;\n  border-left: 1px solid rgba(0, 0, 0, 0.05);\n  box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11),\n    0 5px 15px 0 rgba(0, 0, 0, 0.08);\n\n  .open-icon {\n    animation: Spin 2s infinite linear;\n    position: relative;\n    top: -2px;\n  }\n\n  &.open {\n    right: 0;\n  }\n\n  // customizer content height\n  .customizer-content {\n    position: relative;\n    height: calc(100% - 7rem);\n\n    .bg-default {\n      background-color: #fff;\n    }\n  }\n\n  //customizer close button\n  .customizer-close {\n    position: absolute;\n    right: 30px;\n    top: 20px;\n    padding: 7px;\n    width: auto;\n    z-index: 10;\n    color: #626262;\n    i {\n      font-size: 1.71rem;\n    }\n  }\n\n  // customizer toggle icon\n  .customizer-toggle {\n    background: #7367f0;\n    color: #fff;\n    display: block;\n    box-shadow: -3px 0px 8px rgba(0, 0, 0, 0.1);\n    border-top-left-radius: 6px;\n    border-bottom-left-radius: 6px;\n    position: absolute;\n    top: 50%;\n    width: 38px;\n    height: 38px;\n    left: -39px;\n    text-align: center;\n    line-height: 40px;\n    cursor: pointer;\n  }\n\n  // theme color box styles\n  .color-box {\n    height: 35px;\n    width: 35px;\n    margin: 0.5rem;\n    border-radius: 0.5rem;\n    cursor: pointer;\n    &.selected {\n      box-shadow: 0 0 0 3px rgba(52, 144, 220, 0.5);\n      transition: all 0.2s ease-in-out;\n    }\n    &.disabled {\n      pointer-events: none;\n      cursor: not-allowed;\n    }\n  }\n}\n\nbody.dark-layout {\n  .hide-scroll-top-switch,\n  .collapse-sidebar {\n    .custom-switch {\n      .custom-control-label {\n        &:before {\n          background-color: #10163a;\n        }\n      }\n    }\n  }\n}\n\n.buy-now {\n  position: fixed;\n  bottom: 5%;\n  right: 79px;\n  z-index: 1031;\n  .btn {\n    box-shadow: 0 1px 20px 1px #EA5455 !important;\n    &:hover {\n      box-shadow: none !important;\n    }\n  }\n}\n\n// Spining Animation\n\n@keyframes Spin {\n  from {\n    transform: rotate(0);\n  }\n  to {\n    transform: rotate(359deg);\n  }\n}\n","// Chips\n\n// chip styles\n.chip {\n  background-color: $chip-bg-color;\n  font-size: $chip-font-size;\n  border-radius: $chip-border-radius;\n  display: inline-flex;\n  padding: 0 10px;\n  margin-bottom: 5px;\n  vertical-align: middle;\n  justify-content: center;\n\n  // chip body customization\n\n  .chip-body {\n    color: rgba($pure-black, 0.7);\n    display: flex;\n    justify-content: space-between;\n    min-height: $chip-min-height;\n    min-width: $chip-min-width;\n    .avatar {\n      background-color: $chip-avatar-bg;\n      display: flex;\n      width: $avatar-size-sm;\n      height: $avatar-size-sm;\n      margin: 2px 0;\n      border-radius: 50%;\n      justify-content: center;\n      align-items: center;\n      color: $white;\n      transform: translate(-8px);\n      .avatar-content {\n        font-size: 0.8rem;\n      }\n\n      // chip image\n      img {\n        border-radius: 50%;\n        height: $avatar-size-sm;\n        width: $avatar-size-sm;\n      }\n    }\n    // chip text\n    .chip-text {\n      vertical-align: middle;\n      align-self: center;\n    }\n\n    // chip closeable\n    .chip-closable {\n      min-height: $chip-closeable-min-height;\n      min-width: $chip-closeable-min-width;\n      margin: 0 4px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      align-self: center;\n      border-radius: 50%;\n      background: rgba($pure-black, 0.15);\n      color: $white;\n      transform: translate(10px);\n      cursor: pointer;\n      svg {\n        height: 12px;\n        width: 12px;\n      }\n    }\n  }\n}\n","// Divider\n\n.divider {\n  display: block;\n  text-align: center;\n  overflow: hidden;\n  white-space: nowrap;\n  margin: 1rem 0;\n\n  // divider text display prop\n\n  .divider-text {\n    position: relative;\n    display: inline-block;\n    font-size: 0.9375rem;\n    padding: 0 1rem;\n    background-color: $white;\n\n    // divider icon font size\n\n    svg {\n      height: 1rem;\n      width: 1rem;\n    }\n\n    // divider border\n\n    &:before,\n    &:after {\n      content: \"\";\n      position: absolute;\n      top: 50%;\n      width: 9999px;\n      border-top: 1px solid rgba($pure-black, 0.1);\n    }\n\n    // divider spacing\n    &:before {\n      right: 100%;\n    }\n\n    &:after {\n      left: 100%;\n    }\n  }\n\n  // divider positions config\n\n  &.divider-left {\n    .divider-text {\n      float: left;\n      padding-left: 0;\n\n      &:before {\n        display: none;\n      }\n    }\n  }\n  &.divider-left-center {\n    .divider-text {\n      left: -25%;\n    }\n  }\n\n  &.divider-right {\n    .divider-text {\n      float: right;\n      padding-right: 0;\n      &:after {\n        display: none;\n      }\n    }\n  }\n  &.divider-right-center {\n    .divider-text {\n      right: -25%;\n    }\n  }\n\n  // divider styles\n\n  &.divider-dotted {\n    .divider-text {\n      &:before,\n      &:after {\n        border-style: dotted;\n        border-width: 1px;\n        border-top-width: 0;\n        border-color: rgba($pure-black, 1);\n      }\n    }\n  }\n  &.divider-dashed {\n    .divider-text {\n      &:before,\n      &:after {\n        border-style: dashed;\n        border-width: 1px;\n        border-top-width: 0;\n        border-color: rgba($pure-black, 1);\n      }\n    }\n  }\n}\n","/***** Vuexy Wizard *****/\n\n.vx-wizard {\n  box-shadow: none !important;\n  display: table;\n  width: 100%;\n  &.nav.nav-tabs {\n    .step-wrapper.nav-item {\n      display: table-cell;\n      width: auto;\n      .step.nav-link {\n        transform: translateY(0) !important;\n        text-align: center !important;\n        z-index: 1;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        .step-text {\n          border-radius: 50%;\n          font-size: 1.5rem;\n          z-index: 2;\n          height: 50px;\n          width: 50px;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          font-weight: 500;\n          background: $white;\n        }\n        &.active {\n          .step-text {\n            background-color: $dark;\n            color: $white;\n          }\n          &:after {\n            background: $dark !important;\n            box-shadow: none !important;\n            height: 3px;\n            top: 50% !important;\n            z-index: -1;\n            width: 50%;\n          }\n        }\n        &.done {\n          .step-text {\n            border-color: $dark !important;\n          }\n          &:before,\n          &:after {\n            background: $dark !important;\n            box-shadow: none !important;\n            height: 3px;\n            top: 50% !important;\n            z-index: -1;\n            width: 50%;\n            content: \"\";\n            position: absolute;\n            top: 50%;\n            width: 45.5%;\n          }\n          &:before {\n            left: 0;\n          }\n          &:after {\n            right: 0;\n          }\n        }\n        &:not(.active) {\n          .step-text {\n            border: 3px solid $gray-600;\n            color: $gray-600;\n          }\n        }\n      }\n    }\n  }\n}\n","// =========================================================================================\n//   File Name: autocomplete.scss\n//   Description: Custom vuexy autocomplete component.\n//   ----------------------------------------------------------------------------------------\n//   Item Name: Vuexy React admin Template\n//   Version: 1.0\n//   Author: PIXINVENT\n//   Author URL: http://www.themeforest.net/user/pixinvent\n// ==========================================================================================\n\n// Component: autocomplete\n// ========================================================================\n\n.vx-autocomplete-container {\n  position: relative;\n  border:\"2px solid black\";\n  .vx-autocomplete-search {\n    height: 100%;\n    width: 100%;\n    background-color: \"#XXXXXX\";\n    &:focus {\n      box-shadow: none;\n    }\n  }\n  .suggestions-list {\n    z-index: 998;\n    list-style: none;\n    padding-left: 0;\n    border-radius: 0.5rem;\n    max-height: 450px;\n    height: auto;\n    width: 100%;\n    position: absolute;\n    margin-top: 0.5rem;\n    background-color: $white;\n    box-shadow: 0 15px 30px 0 rgba(0,0,0,.11),0 5px 15px 0 rgba(0,0,0,.08);\n    .suggestion-item {\n      padding: 0.85rem 1rem;\n      color: $body-color;\n      a {\n        color: $body-color;\n      }\n      &.active,\n      &:hover:not(.suggestion-title):not(.no-result) {\n        background-color: $body-bg;\n        color: $body-color;\n      }\n\n      &:hover:not(.suggestion-title):not(.no-result) {\n        cursor: pointer;\n      }\n    }\n  }\n}\n","// =========================================================================================\n//   File Name: app loader.scss\n//   Description: Custom vuexy app loader component.\n//   ----------------------------------------------------------------------------------------\n//   Item Name: Vuexy React admin Template\n//   Version: 1.0\n//   Author: PIXINVENT\n//   Author URL: http://www.themeforest.net/user/pixinvent\n// ==========================================================================================\n\n// Component: app loader\n// ========================================================================\n\n\n.loading {\n  position: absolute;\n  left: calc(50% - 35px);\n  top: 50%;\n  width: 55px;\n  height: 55px;\n  border-radius: 50%;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  border: 3px solid transparent;\n\n  &.component-loader {\n    margin-top: -60px;\n  }\n\n  .effect-1,\n  .effect-2 {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border: 3px solid transparent;\n    border-left: 3px solid rgba(121, 97, 249, 1);\n    border-radius: 50%;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n  }\n\n  .effect-1 {\n    animation: rotate 1s ease infinite;\n  }\n  .effect-2 {\n    animation: rotateOpacity 1s ease infinite 0.1s;\n  }\n  .effect-3 {\n    width: 100%;\n    height: 100%;\n    border: 3px solid transparent;\n    border-left: 3px solid rgba(121, 97, 249, 1);\n    -webkit-animation: rotateOpacity 1s ease infinite 0.2s;\n    animation: rotateOpacity 1s ease infinite 0.2s;\n    border-radius: 50%;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n  }\n\n  .loading .effects {\n    transition: all 0.3s ease;\n  }\n}\n.fallback-logo {\n  position: absolute;\n  left: calc(50% - 45px);\n  top: 40%;\n}\n\n@keyframes rotate {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(1turn);\n    transform: rotate(1turn);\n  }\n}\n@keyframes rotateOpacity {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n    opacity: 0.1;\n  }\n  100% {\n    -webkit-transform: rotate(1turn);\n    transform: rotate(1turn);\n    opacity: 1;\n  }\n}\n","// =========================================================================================\n//   File Name: chat-widget.scss\n//   Description: Custom vuexy chat-widget component.\n//   ----------------------------------------------------------------------------------------\n//   Item Name: Vuexy React admin Template\n//   Version: 1.0\n//   Author: PIXINVENT\n//   Author URL: http://www.themeforest.net/user/pixinvent\n// ==========================================================================================\n\n// Component: chat-widget\n// ========================================================================\n\n.chat-widget {\n  .chat-app-window {\n    .user-chats {\n      padding: 10px 20px;\n      position: relative;\n      text-align: center;\n      height: 415px;\n      // Chat area css\n      .chats {\n        padding: 0;\n        .chat-body {\n          display: block;\n          margin: 10px 30px 0 0;\n          overflow: hidden;\n          .chat-content {\n            text-align: left;\n            display: block;\n            float: right;\n            padding: 0.75rem 1rem;\n            margin: 0 20px 10px 0;\n            clear: both;\n            color: $white;\n            background: linear-gradient(\n              118deg,\n              rgba($primary, 1),\n              rgba($primary, 0.7)\n            );\n            border-radius: 0.5rem;\n            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12),\n              0 2px 4px 0 rgba(0, 0, 0, 0.08);\n            p {\n              margin: 0;\n            }\n          }\n        }\n        .chat-avatar {\n          float: right;\n        }\n        // Chat area left css\n        .chat-left {\n          .chat-avatar {\n            float: left;\n          }\n          .chat-body {\n            margin: 0;\n          }\n          .chat-content {\n            text-align: left;\n            float: left;\n            margin: 10px 10px 10px 20px;\n            color: $body-color;\n            background: none;\n            background-color: lighten($white, 18%);\n            border: 1px solid $gray-300;\n          }\n        }\n      }\n    }\n  }\n}\n","// config\n$debug: false;\n\n// declare breakpoints\n$usn-x-small         : 0px;\n$usn-small           : 544px;\n$usn-medium          : 768px;\n$usn-large           : 992px;\n$usn-x-large         : 1200px;\n\n// create sass list to pass media query data\n// if a breakpoint name changes, remember to\n// update it in the list below as well\n$mq-sync:\n  xs        $usn-x-small,\n  sm          $usn-small,\n  md         $usn-medium,\n  lg          $usn-large,\n  xl        $usn-x-large\n;\n\n// build each media query for js ingestion\n@each $mq in $mq-sync {\n  @media screen and (min-width: nth($mq, 2)) {\n    head { font-family: \"#{nth($mq, 1)} #{nth($mq, 2)}\"; }\n    body:after { content: \"#{nth($mq, 1)} - min-width: #{nth($mq, 2)}\"; }\n  }\n}\n\nhead {\n  // set clear on head to show Unison is set up correctly\n  clear: both;\n  // store hash of all breakpoints\n  title { font-family: \"#{$mq-sync}\"; }\n}\n\n// debug styles to see breakpoint info\nbody:after {\n  display: none;\n}\n\n@if $debug == true {\n  body:after {\n    display: block;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    background-color: #000;\n    background-color: rgba(0,0,0,0.8);\n    text-align: center;\n    color: #FFF;\n    padding: 10px;\n    z-index: 1000;\n    font-size: 12px;\n    font-family: sans-serif;\n  }\n}\n\n// hide elements for conditional loading\n// only used for responsive comments plugin\n*[data-usn-if] { display: none; }",".group-area {\n  margin-bottom: 3rem;\n}\n\n// Used many times\n.block {\n  display: block;\n  width: 100%;\n}\n\nselect[multiple=\"multiple\"] {\n  // overflow: hidden;\n}\n\n/* Input with icon */\n\n.form-control-position {\n  position: absolute;\n  top: 1px;\n  right: 0;\n  z-index: 2;\n  display: block;\n  width: 2.5rem;\n  height: 2.5rem;\n  line-height: 2.5rem;\n  text-align: center;\n}\n\n/*---------------------------------\nInput Icon\n---------------------------------*/\n\n.position-relative {\n  .form-control {\n    padding-right: $input-height;\n    &.form-control-lg {\n      padding-left: 2.5rem;\n      & ~ .form-control-position {\n        top: 9px;\n      }\n    }\n    &.form-control-sm {\n      & ~ .form-control-position {\n        top: -3px;\n      }\n    }\n  }\n}\n\n/* Input Icon left */\n\n.has-icon-left {\n  // form-control - padding\n  .form-control {\n    padding-right: $input-btn-padding-x;\n    padding-left: 3rem;\n  }\n  .form-control-position {\n    right: auto;\n    left: inherit;\n    // icon - padding\n    svg {\n      position: relative;\n      left: 5px;\n      color: rgba($black, 0.4);\n    }\n  }\n}\n\ninput[type=\"color\"] {\n  height: $input-height;\n}\n\ninput[type=\"date\"].form-control,\ninput[type=\"time\"].form-control,\ninput[type=\"datetime-local\"].form-control,\ninput[type=\"month\"].form-control {\n  line-height: $line-height-base;\n}\n\n.font-size-large {\n  font-size: $font-size-lg;\n}\n\n.font-size-base {\n  font-size: $font-size-base;\n}\n\n.font-size-small {\n  font-size: $font-size-sm;\n}\n\n.font-size-xsmall {\n  font-size: $font-size-xs;\n}\n\n.input-group-xs {\n  .form-control,\n  .input-group-addon,\n  .input-group-btn > button {\n    padding: 0.175rem 0.5rem;\n    font-size: 0.725rem;\n    line-height: 1.677777;\n    border-bottom-left-radius: 0.175rem;\n    border-top-left-radius: 0.175rem;\n  }\n  .input-group-btn > button {\n    border-radius: 0.175rem;\n  }\n}\n\n.input-group-addon {\n  padding-top: 0.2rem;\n  padding-bottom: 0.2rem;\n}\n\n.floating-label-form-group-with-focus label,\n.floating-label-form-group-with-value label {\n  color: $primary !important;\n  text-transform: uppercase;\n  font-weight: 400;\n}\n","// ================================================================================================\n//     File Name: datatables.scss\n//     Description: Datatables pages custom scss\n//     ----------------------------------------------------------------------------------------------\n//     Item Name: Vuexy React admin Template\n//     Version: 1.0\n//     Author: PIXINVENT\n//     Author URL: http://www.themeforest.net/user/pixinvent\n// ================================================================================================\ntable.dataTable{\n  border: 2px solid $datatable-bg-color;\n\n  // datatable th, td\n  th, td{\n      border-bottom: 1px solid $datatable-bg-color;\n      border-top: 0;\n  }\n  // thead, tfoot - font, border\n  thead, tfoot{\n    th, td{\n        font-size: $table-th-font-size;\n        border: 0;\n    }\n  }\n\n  thead{\n    //thead - tr bg-color\n    tr{\n        background-color: $datatable-bg-color;\n    }\n\n    // Sorting Icons Change\n    .sorting, .sorting_asc, .sorting_desc{\n      padding-right: inherit;\n      &:before{\n        font-family: 'feather';\n        content: \"\\e845\";\n        padding-right: 0.3rem;\n        font-size: .7rem;\n        left: 0;\n        top: .9rem;\n      }\n      &:after{\n        font-family: 'feather';\n        content: \"\\e842\";\n        font-size: .7rem;\n        left: 0;\n        top: 1.3rem;\n      }\n    }\n  }\n\n  // table-striped bg color for even row\n  &.table-striped tbody tr:nth-of-type(even){\n    background-color: $datatable-bg-color;\n  }\n  // table-striped bg color for odd row\n  &.table-striped tbody tr:nth-of-type(odd){\n    background-color: $white;\n  }\n\n  // Complex headers table\n  &.complex-headers{\n    border: 1px solid $gray-300;\n    thead, tfoot{\n      th, td{\n        border-bottom: 1px solid $gray-300;\n        border-right: 1px solid $gray-300;\n      }\n    }\n  }\n\n  // selected row bg color\n\n  tbody{\n    tr{\n      &.selected {\n        background-color: rgba($primary, 0.05) !important;\n        color: rgba($primary, 1) !important;\n        box-shadow: 0 0 1px 0 rgba($primary, 1)!important;\n        border-radius: 5px;\n        td, th{\n          border-bottom: 0;\n        }\n      }\n\n    }\n  }\n}\n\n\n// data table search, labels and\ndiv.dataTables_wrapper {\n  // data table search, labels\n  div.dataTables_filter, div.dataTables_length {\n    label{\n      margin-top: 1rem;\n    }\n    select{\n      background-position:\n      calc(100% - 3px) 5px,\n      calc(100% - 20px) 13px,\n      100% 0;\n      padding: 0 0.8rem;\n    }\n  }\n\n  // pagination\n  div.dataTables_paginate {\n    ul.pagination {\n      margin-top: 1rem;\n      padding-bottom: 7px;\n      // font size for pagination\n      li a{\n        font-size: 0.8rem;\n      }\n    }\n  }\n}\n\n// row grouping\ntr.group {\n  // row grouping color\n  background-color: $gray-200;\n}\n\n\n// pagination in center\n@media only screen and (max-width:768px){\n  div.dataTables_wrapper {\n    div.dataTables_paginate {\n      ul.pagination {\n        justify-content: center;\n      }\n    }\n  }\n}\n","// ================================================================================================\n// \tFile Name: dark-layout.scss\n// \tDescription: SCSS file for dark layout.\n// \t----------------------------------------------------------------------------------------------\n// \tItem Name: Vuexy React admin Template\n// \tVersion: 1.0\n// \tAuthor: PIXINVENT\n// \tAuthor URL: http://www.themeforest.net/user/pixinvent\n// ================================================================================================\n\n// Core variables and mixins\n@import \"~bootstrap/scss/_functions.scss\";\n@import \"~bootstrap/scss/mixins\";\n@import \"../bootstrap-extended/mixins\";\n\n// Load variable overrides\n@import \"../core/variables/variables\";\n@import \"~bootstrap/scss/_variables.scss\";\n\n// Overrides user variable\n@import \"../core/variables/components-variables\";\n\n$calendarPastMonth: #6a6d83;\n\nbody {\n  &.dark-layout {\n    background-color: $content-dark-bg;\n\n    // universal elements\n    //heading tags\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n      color: $theme-dark-heading-color;\n    }\n    // border color\n    [class*=\"border-\"] {\n      &:not(.bullet):not(.spinner-border) {\n        border-color: $theme-dark-border-color !important;\n      }\n    }\n    // other tags\n    a {\n      &:hover {\n        color: $primary;\n      }\n    }\n    p,\n    small,\n    span,\n    label {\n      color: $theme-dark-text-color;\n    }\n    hr {\n      border-color: $theme-dark-border-color;\n    }\n\n    // code, pre, kbd\n    pre {\n      background-color: $content-dark-bg;\n      border: 0;\n      code {\n        background-color: inherit;\n        text-shadow: none;\n        .operator,\n        .url {\n          background-color: $content-dark-bg;\n        }\n      }\n    }\n    code {\n      background-color: $content-dark-bg;\n      color: $gray-600;\n    }\n    kbd {\n      background-color: $content-dark-bg;\n    }\n\n    // Code component\n    .component-code {\n      pre {\n        &::-webkit-scrollbar-thumb {\n          background: $theme-dark-text-color;\n        }\n    \n        &::-webkit-scrollbar-track {\n          background: $grid-dark-color\n        }\n      }\n    }\n\n    // for dark text\n    .text-dark {\n      color: $gray-600 !important;\n    }\n\n    // main navbar and header navbar shadow(generic navbar)\n    .header-navbar-shadow {\n      background: linear-gradient(\n        180deg,\n        rgba(44, 48, 60, 0.9) 44%,\n        rgba(44, 48, 60, 0.43) 73%,\n        rgba(17, 30, 70, 0)\n      );\n    }\n    .header-navbar {\n      background-color: $dark-card-color;\n      .navbar-container {\n        .nav,\n        .navbar-nav {\n          .nav-item {\n            .nav-link {\n              color: $theme-dark-text-color;\n              background-color: transparent;\n              svg{\n                stroke: $theme-dark-text-color;\n              }\n              \n            }\n            &.nav-search {\n              .search-input {\n                &.open {\n                  background-color: $dark-card-color;\n                  .input {\n                    border-color: $theme-dark-border-color;\n                  }\n                  .input,\n                  .input::placeholder,\n                  .search-input-close {\n                    color: $theme-dark-text-color;\n                  }\n                }\n              }\n            }\n            .bookmark-input {\n              .form-control {\n                background-color: $dark-card-color;\n              }\n            }\n            .search-list {\n              background-color: $content-dark-bg;\n              .current_item {\n                background-color: $dark-card-color;\n              }\n            }\n          }\n          .dropdown-notification {\n            .dropdown-menu.dropdown-menu-media {\n              overflow: hidden;\n              &:before {\n                display: none;\n              }\n              .media {\n                border-color: $theme-dark-border-color;\n                .media-body {\n                  .notification-text {\n                    color: $theme-dark-text-color;\n                  }\n                }\n                .media-meta {\n                  color: $theme-dark-text-color;\n                }\n                &:hover {\n                  background-color: $dark-card-color;\n                }\n              }\n              .dropdown-menu-footer {\n                background-color: $dark-card-color;\n                .dropdown-item {\n                  color: $white;\n                  border-color: $theme-dark-border-color;\n                  &:hover {\n                    background-color: $dark-card-color;\n                  }\n                }\n              }\n            }\n\n            .dropdown-cart {\n              &.empty-cart {\n                &:before {\n                  background-color: $content-dark-bg;\n                }\n              }\n              li {\n                color: $white;\n              }\n              .dropdown-header {\n                span {\n                  color: $white;\n                }\n              }\n              .media-list {\n                .media {\n                  background-color: $white;\n                  .media-body {\n                    background-color: $content-dark-bg;\n                    padding-left: 1rem !important;\n                  }\n                  &:hover {\n                    background-color: $white !important;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      &.navbar-static-top {\n        background-color: transparent;\n      }\n      &[class*=\"bg-\"] {\n        .navbar-nav {\n          .nav-item {\n            .nav-link {\n              background-color: inherit;\n              svg {\n                stroke: $white;\n              }\n            }\n          }\n        }\n      }\n      &.bg-dark {\n        background-color: $gray-500 !important;\n      }\n    }\n\n    // main menu\n    .main-menu {\n      background-color: $dark-card-color;\n      .shadow-bottom {\n        background: linear-gradient(\n          180deg,\n          #0f1642 44%,\n          rgba(15, 22, 66, 0.51) 73%,\n          rgba(44, 48, 60, 0)\n        );\n      }\n      &:not(.expanded) {\n        .navigation {\n          .sidebar-group-active {\n            a {\n              background-color: $content-dark-bg;\n            }\n          }\n        }\n      }\n      &.theme-dark {\n        .navbar-header {\n          .brand-text {\n            color: $gray-500 !important;\n          }\n        }\n        .navigation {\n          .nav-item {\n            &.active {\n              a {\n                background: linear-gradient(\n                  118deg,\n                  $gray-500,\n                  rgba($gray-500, 0.7)\n                );\n                box-shadow: 0 0 10px 1px rgba($gray-500, 0.7);\n              }\n            }\n            .menu-content {\n              li.active {\n                background: linear-gradient(\n                  118deg,\n                  $gray-500,\n                  rgba($gray-500, 0.7)\n                );\n                box-shadow: 0 0 10px 1px rgba($gray-500, 0.7);\n              }\n            }\n          }\n        }\n      }\n    }\n\n    // main menu content\n    .main-menu-content {\n      .navigation-main {\n        background-color: $dark-card-color;\n        .nav-item {\n          .menu-text {\n            color: $theme-dark-text-color;\n          }\n          svg {\n            stroke: $theme-dark-text-color;\n          }\n          &.open {\n            a {\n              background-color: $content-dark-bg;\n            }\n          }\n          a:after {\n            color: $theme-dark-text-color;\n          }\n          .menu-content {\n            background-color: $dark-card-color;\n            .active {\n              .menu-item {\n                color: $white;\n              }\n            }\n            li:not(.active) {\n              a {\n                background-color: $dark-card-color;\n                color: $theme-dark-text-color;\n              }\n            }\n          }\n        }\n        .active {\n          .menu-text,\n          svg,\n          span {\n            color: $white;\n            stroke: $white;\n          }\n        }\n        .sidebar-group-active {\n          a {\n            background: $dark-card-color;\n            border-radius: 4px;\n          }\n          .menu-content {\n            background-color: $dark-card-color;\n            .active {\n              z-index: 1;\n              a {\n                background-color: transparent;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    // menu collapsed active item color\n    &.menu-collapsed {\n      .main-menu:not(.expanded) {\n        .navigation-main {\n          li.active {\n            a {\n              background: $content-dark-bg !important;\n            }\n          }\n        }\n      }\n    }\n\n    /********* UI ELEMENTS *********/\n\n    // Grid\n    .bd-example {\n      .row,\n      .d-flex {\n        background-color: $content-dark-bg;\n        .col,\n        [class*=\"col-\"],\n        .bd-highlight {\n          background-color: $content-dark-bg;\n          border-color: $ex-col-border-color;\n        }\n      }\n      .height-example-wrapper {\n        background-color: $grid-dark-color !important;\n      }\n      .width-example,\n      .height-example {\n        background-color: $content-dark-bg !important;\n      }\n    }\n    .bd-example-row-flex-cols {\n      .row {\n        background-color: $content-dark-bg;\n      }\n    }\n    //colors\n    .colors-container {\n      span {\n        color: $white;\n      }\n    }\n\n    /********* COMPONENTS *********/\n\n    // alerts\n    .alert {\n      .alert-heading,\n      p {\n        color: inherit;\n      }\n      &.alert-dark {\n        color: $gray-600 !important;\n        .alert-heading,\n        p {\n          color: $gray-600;\n        }\n      }\n    }\n    // breadcrumbs\n    .content-header-left {\n      .breadcrumbs-top {\n        .content-header-title {\n          color: $theme-dark-heading-color;\n        }\n        .breadcrumb-wrapper {\n          .breadcrumb {\n            .breadcrumb-item {\n              color: $theme-dark-text-color;\n              &:before {\n                color: $theme-dark-text-color;\n              }\n              &:not(.active) {\n                a:hover {\n                  color: $primary;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    // for demo breadcrumb page\n    #breadcrumb-slash,\n    #breadcrumb-alignment {\n      .breadcrumb {\n        .breadcrumb-item {\n          color: $theme-dark-text-color;\n          &:before {\n            color: $theme-dark-text-color;\n          }\n          &:not(.active) {\n            a:hover {\n              color: $primary;\n            }\n          }\n        }\n      }\n    }\n    #component-breadcrumbs {\n      .breadcrumb {\n        .breadcrumb-item {\n          &:not(.active) {\n            a {\n              color: $theme-dark-text-color;\n            }\n          }\n          &:before {\n            color: $theme-dark-text-color;\n          }\n          &.active {\n            span {\n              color: $primary;\n            }\n          }\n        }\n      }\n    }\n    // collapse\n    // for shadow and bordered\n    .collapse-bordered {\n      .collapse-header {\n        border-color: rgba($white, 0.04);\n      }\n      &.accordion-shadow {\n        box-shadow: 0 0 8px 0 rgba($white, 0.1);\n      }\n      .card {\n        border-color: $theme-dark-border-color;\n      }\n    }\n    .accordion {\n      .collapse-border-item {\n        border-color: rgba($white, 0.04);\n      }\n    }\n    // margin collapse\n    .collapse-margin {\n      box-shadow: 0 2px 15px 0 rgba($white, 0.1);\n    }\n    // for hover collapse\n    .accordion,\n    .collapse {\n      &[data-toggle-hover=\"true\"] {\n        .card {\n          border-color: rgba($white, 0.04);\n        }\n      }\n    }\n\n    // if there is an anchor tag inside\n    .collapse-icon {\n      .card-header {\n        a {\n          color: $theme-dark-text-color;\n        }\n      }\n    }\n\n    // buttons\n    .btn {\n      span {\n        color: $white;\n      }\n      &.btn-white {\n        span {\n          color: $black;\n        }\n      }\n      &.btn-icon {\n        i {\n          color: $white;\n        }\n      }\n      &.btn-dark,\n      &.btn-outline-dark,\n      &.btn-flat-dark {\n        color: $gray-600;\n      }\n      &.btn-dark {\n        background-color: $gray-700 !important;\n      }\n      &.btn-outline-dark {\n        border-color: $gray-700;\n        color: $gray-600;\n      }\n      &.btn-flat-dark {\n        &:active,\n        &:focus {\n          background: $gray-700;\n        }\n      }\n      &.btn-white {\n        color: $body-color;\n      }\n    }\n\n    // drodpown\n    .dropdown-toggle {\n      color: $white;\n      &:hover {\n        i,\n        &:after {\n          color: $white;\n        }\n      }\n    }\n\n    .dropdown-menu {\n      background-color: $content-dark-bg;\n      &:before,\n      .dropdown-item:hover,\n      .dropdown-item:focus {\n        background: $content-dark-bg;\n      }\n      .dropdown-item {\n        color: $theme-dark-text-color;\n      }\n      .form-control {\n        background-color: $dark-card-color;\n      }\n      .dropdown-divider {\n        border-color: $theme-dark-border-color;\n      }\n    }\n\n    .btn-white ~ .dropdown-menu {\n      .dropdown-item:not(.acitve):hover {\n        color: $primary !important;\n      }\n    }\n\n    .btn-dark,\n    .btn-outline-dark,\n    .btn-flat-dark {\n      & ~ .dropdown-menu {\n        .dropdown-item:hover {\n          color: $theme-dark-text-color;\n        }\n      }\n    }\n\n    // dropdown icon\n    .dropup {\n      &.dropdown-icon-wrapper {\n        .dropdown-menu {\n          .dropdown-item {\n            i {\n              color: $theme-dark-text-color;\n            }\n          }\n        }\n      }\n    }\n\n    // modal\n    .modal {\n      .modal-header,\n      .modal-header[class*=\"bg-\"] {\n        background-color: $dark-card-color !important;\n        .close {\n          background-color: $content-dark-bg;\n          text-shadow: none;\n          span {\n            color: $white;\n          }\n        }\n      }\n      .modal-content,\n      .modal-body,\n      .modal-footer {\n        background-color: $content-dark-bg;\n        color: $theme-dark-text-color;\n        .form-control,\n        .picker__input,\n        .custom-file-label,\n        .custom-file-label:after {\n          background-color: $dark-card-color !important;\n        }\n      }\n    }\n\n    //pagination\n    .pagination {\n      &:not([class*=\"pagination-\"]) {\n        .page-item {\n          &.active {\n            background-color: $content-dark-bg;\n            .page-link {\n              background-color: $primary;\n              &:hover {\n                color: $white;\n              }\n            }\n          }\n          .page-link {\n            background-color: $content-dark-bg;\n            color: $white;\n            &:hover {\n              color: $primary;\n            }\n          }\n          &.prev-item,\n          &.next-item {\n            .page-link:hover {\n              color: $white;\n            }\n          }\n        }\n      }\n      &[class*=\"pagination-\"] {\n        .page-item:not(.active):not(:hover) {\n          .page-link {\n            background-color: $content-dark-bg;\n            color: $white;\n          }\n        }\n        .page-item {\n          &:not(.active) {\n            .page-link:hover {\n              background-color: $content-dark-bg;\n            }\n          }\n          &.active {\n            background-color: $content-dark-bg;\n          }\n        }\n      }\n    }\n\n    // nav component\n    .nav {\n      .nav-item {\n        .nav-link {\n          color: $theme-dark-text-color;\n          &.active,\n          &:hover {\n            color: $primary;\n          }\n        }\n      }\n      &.wrap-border{\n        border-color: $theme-dark-border-color;\n      }\n    }\n\n    // navbar\n    #navbar-component {\n      .basic-navbar {\n        .navbar {\n          background-color: $content-dark-bg;\n        }\n      }\n      .navbar {\n        .nav,\n        .navbar-nav {\n          .nav-item {\n            a {\n              color: $white !important;\n            }\n            .nav-link {\n              background-color: inherit;\n              span {\n                color: $white;\n              }\n              .badge,\n              svg {\n                color: $white !important;\n                stroke: $white !important;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    // nav-tabs\n    .nav-tabs,\n    .nav-tabs.nav-justified,\n    .nav:not(.nav-pills) {\n      .nav-item {\n        .nav-link {\n          background-color: $dark-card-color;\n          &.active {\n            background-color: $dark-card-color;\n          }\n          &.disabled {\n            opacity: 0.5;\n          }\n        }\n      }\n      & ~ .tab-content {\n        .tab-pane {\n          background-color: $dark-card-color;\n        }\n      }\n    }\n\n    // vertical nav tabs\n    .nav-vertical {\n      .nav.nav-tabs {\n        &.nav-left,\n        &.nav-right {\n          & ~ .tab-content {\n            .tab-pane {\n              background-color: $dark-card-color;\n            }\n          }\n        }\n      }\n    }\n\n    // nav pills\n    .nav-pills {\n      .nav-item {\n        .nav-link {\n          &.active {\n            color: $white;\n          }\n        }\n      }\n      &.nav-active-bordered-pill {\n        .nav-item {\n          .nav-link.active {\n            background-color: transparent !important;\n          }\n        }\n      }\n    }\n\n    // Active Item in nav tabs justified\n    .nav-justified {\n      &.nav.nav-tabs {\n        .nav-item .nav-link {\n          &.active {\n            background-color: transparent;\n          }\n        }\n      }\n    }\n\n    // card\n    .card {\n      background-color: $dark-card-color;\n      &.border{\n        border-color: $theme-dark-border-color !important;\n      }\n      .card-title {\n        color: $white;\n      }\n      .card-header,\n      .card-footer {\n        color: $theme-dark-text-color;\n        background-color: $dark-card-color !important;\n      }\n      .card-body,\n      .card-footer {\n        color: $theme-dark-text-color;\n        border-color: $theme-dark-border-color;\n      }\n      &.overlay-img-card {\n        .card-img-overlay {\n          span,\n          p {\n            color: $white;\n          }\n        }\n      }\n    }\n\n    // media\n    .media-bordered {\n      .media {\n        border-color: $theme-dark-border-color;\n      }\n    }\n\n    // activity timeline\n    .activity-timeline {\n      border-color: $theme-dark-border-color;\n    }\n\n    // analytics decor card\n    #dashboard-analytics {\n      .bg-analytics {\n        background: linear-gradient(\n          118deg,\n          rgba($primary, 1),\n          rgba($primary, 0.7)\n        );\n        p {\n          color: $white;\n        }\n        .card-body {\n          background-color: transparent;\n        }\n      }\n    }\n\n    // Dashboard ecommerce + Advance Card\n    .chat-widget {\n      &.chat-application {\n        .chat-app-window {\n          .user-chats {\n            // Chat area css\n            .chats {\n              .chat-body {\n                .chat-content {\n                  p {\n                    color: $white;\n                  }\n                }\n              }\n              .chat-left {\n                .chat-content {\n                  background-color: $dark-chat-bg-color;\n                  border: 1px solid $theme-dark-border-color;\n                  p {\n                    color: $theme-dark-text-color;\n                  }\n                }\n              }\n            }\n          }\n          .chat-footer {\n            border-top: 1px solid $theme-dark-border-color;\n            .card-body {\n              padding-top: 1.5rem !important;\n            }\n          }\n        }\n      }\n    }\n\n    //badge\n    .badge {\n      color: $white;\n      span {\n        color: $white;\n      }\n      &:hover {\n        i {\n          color: $white;\n        }\n      }\n    }\n\n    // popover\n    .popover {\n      &[x-placement=\"top\"] {\n        .arrow {\n          &:after {\n            border-top-color: $content-dark-bg;\n          }\n        }\n      }\n      &[x-placement=\"bottom\"] {\n        .arrow {\n          &:after {\n            border-bottom-color: $primary;\n          }\n        }\n      }\n      &[x-placement=\"left\"] {\n        .arrow {\n          &:after {\n            border-left-color: $content-dark-bg;\n          }\n        }\n      }\n      &[x-placement=\"right\"] {\n        .arrow {\n          &:after {\n            border-right-color: $content-dark-bg;\n          }\n        }\n      }\n\n      .popover-body {\n        background-color: $content-dark-bg;\n        color: $theme-dark-text-color;\n      }\n    }\n\n    // toast\n    .toast {\n      background-color: $content-dark-bg;\n      box-shadow: -5px 5px 5px 0px rgba($pure-black, 0.3);\n      .toast-header {\n        background-color: $content-dark-bg;\n        color: $theme-dark-text-color;\n        border-color: $theme-dark-border-color;\n        .close {\n          text-shadow: none;\n          opacity: 1;\n        }\n      }\n      .toast-body {\n        background-color: $content-dark-bg;\n        color: $theme-dark-text-color;\n      }\n    }\n\n    // Progress\n    .progress {\n      background-color: $content-dark-bg;\n    }\n\n    // avatar\n    .avatar {\n      background-color: $content-dark-bg;\n      .avatar-content {\n        color: $white;\n      }\n    }\n\n    // chip\n    .chip {\n      background-color: $content-dark-bg;\n      .avatar {\n        background-color: $dark-card-color;\n      }\n      .chip-body {\n        .chip-text,\n        span {\n          color: $white;\n        }\n      }\n    }\n\n    // divider\n    .divider {\n      .divider-text {\n        background-color: transparent;\n        color: $theme-dark-text-color;\n        &::before,\n        &::after {\n          border-color: $theme-dark-border-color;\n        }\n      }\n      &.divider-dark {\n        .divider-text {\n          &::before,\n          &::after {\n            border-color: $gray-700 !important;\n          }\n        }\n      }\n    }\n\n    // Form Wizard\n    .vx-wizard.nav.nav-tabs {\n      .step-wrapper.nav-item {\n        .step.nav-link:not(.active) {\n          .step-text {\n            background-color: $content-dark-bg;\n            svg {\n              color: $theme-dark-text-color;\n            }\n          }\n        }\n      }\n    }\n\n    // list group\n    .list-group {\n      .list-group-item {\n        &:not([class*=\"list-group-item-\"]),\n        &.list-group-item-action {\n          background-color: $dark-card-color;\n          border-color: $theme-dark-border-color;\n          color: $theme-dark-text-color;\n          &:hover {\n            background-color: $content-dark-bg;\n          }\n        }\n\n        &.active {\n          background-color: $primary;\n          color: $white;\n          p,\n          small {\n            color: $white;\n          }\n        }\n\n        &.disabled {\n          background-color: $content-dark-bg;\n        }\n      }\n    }\n\n    /********** FORMS **********/\n\n    // input\n    input.form-control,\n    .custom-file-label,\n    textarea.form-control {\n      background-color: $content-dark-bg;\n      color: $theme-dark-text-color;\n      &:not(:focus) {\n        border: 0;\n      }\n      &::placeholder {\n        color: $theme-dark-text-color;\n      }\n      & ~ .form-control-position {\n        svg {\n          color: $theme-dark-text-color;\n        }\n      }\n      &:focus {\n        & ~ .form-control-position {\n          i {\n            color: $primary;\n          }\n        }\n      }\n      &:disabled,\n      &[readonly] {\n        opacity: 0.5;\n      }\n    }\n\n    // text area counter\n    .char-textarea {\n      &.active {\n        color: $theme-dark-text-color !important;\n      }\n      &.max-limit {\n        color: $danger !important;\n      }\n    }\n\n    // file uploader default\n    .custom-file-label {\n      &:after {\n        background-color: $content-dark-bg;\n        border-left: 1px solid $theme-dark-border-color;\n        color: $theme-dark-text-color;\n      }\n    }\n\n    // form group icons\n    .has-icon-left {\n      &.input-divider-left {\n        .form-control-position {\n          i {\n            border-right-color: $theme-dark-border-color;\n          }\n        }\n      }\n      &.input-divider-right {\n        .form-control-position {\n          i {\n            border-left-color: $theme-dark-border-color;\n          }\n        }\n      }\n    }\n\n    // select\n    select.form-control,\n    .custom-select {\n      background-color: $content-dark-bg;\n      color: $theme-dark-text-color;\n      border: 0;\n      option:checked {\n        background-color: $dark-card-color;\n      }\n    }\n\n    // Custom Input Checkbox/Radio\n    .custom-control {\n      &.custom-radio,\n      &.custom-checkbox {\n        input[disabled] {\n          & ~ label {\n            &:before,\n            &:after {\n              opacity: 0.5;\n            }\n          }\n        }\n      }\n    }\n\n    // React Select\n    .select__control,\n    .React__control {\n      background-color: $content-dark-bg;\n      border-color: $theme-dark-border-color;\n      .select__value-container,\n      .React__value-container {\n        .select__single-value,\n        .React__single-value {\n          color: $theme-dark-text-color;\n        }\n        .select__multi-value {\n          background-color: $dark-card-color;\n          .select__multi-value__label {\n            color: $theme-dark-text-color;\n          }\n        }\n      }\n      & ~ {\n        .select__menu,\n        .React__menu {\n          background-color: $content-dark-bg;\n          .select__menu-list,\n          .React__menu-list {\n            &.select__option--is-selected,\n            &.React__option--is-selected {\n              background-color: $dark-card-color;\n            }\n          }\n        }\n      }\n      &.select__control--is-focused {\n        .select__loading-indicator {\n          color: $theme-dark-text-color;\n          span {\n            background-color: $theme-dark-text-color;\n          }\n        }\n      }\n    }\n\n    // React Number Input\n    .react-numeric-input {\n      background-color: $content-dark-bg !important;\n      input {\n        background-color: $content-dark-bg !important;\n        color: $theme-dark-text-color !important;\n      }\n    }\n\n    // React Toggle\n    .react-toggle-wrapper {\n      .react-toggle {\n        &:not(.react-toggle--checked):not([class*=\"switch-\"]) {\n          .react-toggle-track {\n            background-color: $content-dark-bg;\n          }\n        }\n        .react-toggle-track {\n          .react-toggle-track-x,\n          .react-toggle-track-check {\n            svg {\n              stroke: $white;\n              fill: $white;\n            }\n          }\n        }\n      }\n    }\n\n    // switch\n    .custom-switch {\n      .custom-control-input[disabled] {\n        & ~ .custom-control-label {\n          opacity: 0.5;\n        }\n      }\n      .custom-control-input {\n        &:not(:disabled):active {\n          & ~ .custom-control-label::before {\n            background-color: $primary;\n          }\n        }\n        &:checked ~ .custom-control-label::before {\n          background-color: $primary;\n        }\n      }\n      .custom-control-label {\n        &:before {\n          background-color: $content-dark-bg;\n        }\n      }\n    }\n\n\n\n    // input groups\n    .input-group {\n      .input-group-prepend,\n      .input-group-append {\n        .input-group-text {\n          background-color: $dark-card-color;\n          border: 1px solid $theme-dark-border-color;\n        }\n      }\n      .input-group-prepend {\n        & ~ .form-control {\n          border-left: 1px solid $theme-dark-border-color;\n        }\n      }\n      .form-control {\n        & ~ .input-group-append {\n          border-left: 1px solid $theme-dark-border-color;\n        }\n      }\n    }\n\n    // floating label\n    .form-label-group {\n      & > input:not(:focus):not(:placeholder-shown) ~ label,\n      & > textarea:not(:focus):not(:placeholder-shown) ~ label {\n        color: $theme-dark-text-color !important;\n      }\n    }\n\n    // Datepicker\n    .form-control.flatpickr-input{\n      background-color: $content-dark-bg;\n      & ~ input{\n        background-color: $content-dark-bg;\n      }\n    }\n    \n    .flatpickr-calendar{\n      &:not(.inline){\n        &:after,\n        &:before{\n          border-bottom-color: $primary;\n        }\n      }\n      .flatpickr-innerContainer{\n        background: $content-dark-bg;\n        border-color: $content-dark-bg;\n      }\n      .flatpickr-months {\n        .flatpickr-prev-month,\n        .flatpickr-next-month{\n          fill : $white;\n          color : $white;\n        }\n        .flatpickr-month{\n          select:hover{\n            background: $white;\n          }\n        }\n        .numInputWrapper{\n          .numInput{\n            color: $white;\n          }\n        }\n      }\n      .flatpickr-days{\n        border-color: $content-dark-bg;\n        .flatpickr-day{\n          &:hover,\n          &:focus{\n            background-color: $dark-card-color;\n            border-color: $dark-card-color;\n          }\n          &.prevMonthDay,\n          &.nextMonthDay,\n          &.flatpickr-disabled{\n            color: $gray-400;\n          }\n        }\n      }\n      .flatpickr-weekdays,\n      .flatpickr-weekday{    \n        color : $white;\n      }\n    }\n\n    /********** TABLE **********/\n\n    // table\n    .table {\n      &:not(.table-inverse) {\n        background-color: $theme-dark-table-bg;\n        .thead,\n        tbody {\n          tr:not([class*=\"table-\"]) {\n            th,\n            td {\n              border-color: $theme-dark-border-color;\n              color: $theme-dark-text-color;\n              code {\n                background-color: $dark-card-color;\n              }\n            }\n          }\n        }\n        thead {\n          tr {\n            th {\n              border: 0;\n              background-color: $theme-dark-table-bg;\n              color: $theme-dark-text-color;\n            }\n          }\n        }\n        tbody {\n          tr {\n            // for contextual classes\n            &[class*=\"table-\"] {\n              td,\n              th {\n                background-color: unset;\n                color: $black;\n                border-color: $theme-dark-border-color;\n              }\n            }\n            &.table-dark {\n              td,\n              th {\n                color: $white;\n              }\n            }\n            &.table-active {\n              td,\n              th {\n                color: $theme-dark-text-color;\n              }\n            }\n            th {\n              background-color: $content-dark-bg;\n            }\n            td {\n              background-color: $content-dark-bg;\n              color: $theme-dark-text-color;\n            }\n          }\n        }\n\n        // bordered table\n        &.table-bordered {\n          border: 1px solid $theme-dark-border-color;\n          thead,\n          tbody {\n            tr {\n              th,\n              td {\n                border: 1px solid $theme-dark-border-color;\n              }\n            }\n          }\n        }\n\n        // table hover effect\n\n        &.table-hover {\n          tbody {\n            tr {\n              &:hover {\n                background-color: $dark-card-color;\n              }\n              th,\n              td {\n                background-color: unset;\n              }\n            }\n          }\n        }\n\n        // table striped\n        &.table-striped {\n          tbody {\n            tr {\n              &:nth-of-type(odd) {\n                background-color: $dark-card-color;\n              }\n              td,\n              th {\n                background-color: unset;\n              }\n            }\n          }\n        }\n\n        // for table in content section\n\n        &.table-mx-0 {\n          background-color: $dark-card-color;\n          thead,\n          tbody {\n            tr {\n              th,\n              td {\n                background-color: $dark-card-color;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    // React datatable\n    .ReactTable {\n      .rt-table {\n        .rt-thead {\n          border-color: $theme-dark-border-color;\n          .rt-th {\n            background-color: $content-dark-bg;\n            border-color: $theme-dark-border-color;\n            input,\n            select {\n              background-color: $dark-card-color;\n              color: $theme-dark-text-color;\n            }\n          }\n        }\n        .rt-tbody {\n          .rt-tr {\n            .rt-td {\n              background-color: $content-dark-bg;\n              border-color: $theme-dark-border-color;\n              div:not(.rt-expander) {\n                background-color: $content-dark-bg !important;\n              }\n              &.rt-expandable {\n                background-color: $content-dark-bg !important;\n                .rt-expander {\n                  &:after {\n                    border-top-color: $theme-dark-text-color;\n                  }\n                }\n              }\n            }\n          }\n          .rt-tr-group {\n            border-color: $theme-dark-border-color;\n          }\n        }\n      }\n      .pagination-bottom {\n        .-pageJump {\n          input {\n            background-color: $content-dark-bg;\n            color: $theme-dark-text-color;\n          }\n        }\n        .select-wrap {\n          select {\n            background-color: $content-dark-bg;\n            color: $theme-dark-text-color;\n          }\n        }\n      }\n      &.nested-table {\n        .rt-tbody {\n          .rt-tr-group {\n            .rt-td:first-child {\n              background-color: $content-dark-bg !important;\n            }\n          }\n        }\n      }\n    }\n\n    // AG Grid\n    .ag-grid-table {\n      background-color: $dark-card-color;\n\n      .ag-dropdown {\n        border-color: $theme-dark-border-color;\n        div {\n          color: $theme-dark-text-color;\n        }\n      }\n      .ag-pinned-left-header {\n        border-color: $theme-dark-border-color;\n      }\n      .ag-root-wrapper {\n        .ag-root-wrapper-body {\n          .ag-header {\n            background-color: $dark-card-color;\n            border-color: $theme-dark-border-color;\n            .ag-header-cell {\n              border-color: $theme-dark-border-color;\n              background-color: $dark-card-color;\n            }\n\n            .ag-header-cell-label,\n            .ag-floating-filter-input {\n              color: $theme-dark-text-color;\n            }\n            .ag-floating-filter-input {\n              border-color: $theme-dark-border-color;\n            }\n          }\n          .ag-body-viewport {\n            .ag-cell {\n              color: $theme-dark-text-color;\n              border-color: $theme-dark-border-color;\n            }\n            .ag-row {\n              border-color: $theme-dark-border-color;\n            }\n          }\n        }\n      }\n      .ag-row-hover,\n      .ag-header-cell:hover,\n      .ag-row-selected {\n        background-color: $content-dark-bg !important;\n      }\n      .ag-icon {\n        color: $theme-dark-text-color;\n        &.ag-icon-checkbox-checked {\n          color: $primary;\n        }\n      }\n      .ag-paging-panel {\n        border-color: $theme-dark-border-color;\n        .ag-paging-button {\n          &.ag-disabled {\n            background-color: #373f6d;\n            span {\n              color: $white !important;\n            }\n          }\n        }\n        span[ref=\"lbTotal\"] {\n          background-color: #373f6d;\n          color: $theme-dark-text-color !important;\n        }\n      }\n      .ag-menu {\n        background-color: $content-dark-bg;\n        .ag-filter-select {\n          border-color: $theme-dark-border-color;\n          color: $theme-dark-text-color;\n          option {\n            color: $theme-dark-text-color;\n            background-color: $content-dark-bg;\n          }\n        }\n        .ag-input-wrapper {\n          .ag-filter-filter {\n            color: $theme-dark-text-color;\n            border-color: $theme-dark-border-color;\n            &::placeholder {\n              color: $theme-dark-text-color;\n            }\n          }\n        }\n      }\n      ::-webkit-scrollbar-thumb {\n        background: $primary;\n      }\n\n      ::-webkit-scrollbar-track {\n        background: $content-dark-bg;\n      }\n    }\n\n    // Sweet Alert\n    .sweet-alert{\n      background-color: $dark-card-color !important;\n      h2,p{\n        color: $theme-dark-text-color !important;\n      }\n    }\n\n    /********** PAGES **********/\n\n    // authentication\n    .bg-authentication {\n      background-color: $blank-bg-color;\n      .auth-title {\n        color: $theme-dark-text-color;\n      }\n      .form-group.row,\n      .card-footer {\n        background-color: $dark-card-color;\n        .btn-facebook,\n        .btn-twitter {\n          span {\n            color: $white;\n          }\n        }\n      }\n      .form-group {\n        .vx-checkbox-con {\n          span {\n            color: $theme-dark-text-color;\n          }\n        }\n      }\n    }\n\n    // coming soon\n    .getting-started {\n      .clockCard {\n        p {\n          color: $theme-dark-text-color !important;\n        }\n      }\n    }\n\n    // Error Pages\n    .auth-card {\n      h1 {\n        color: $headings-color;\n      }\n      p {\n        color: $white;\n      }\n    }\n\n    // user profile\n    #user-profile {\n      .profile-header {\n        img {\n          border-color: $white !important;\n        }\n        .profile-header-nav {\n          background-color: $dark-card-color;\n        }\n        .navbar {\n          svg {\n            color: $theme-dark-text-color;\n          }\n        }\n      }\n      .btn-load.loading {\n        background-color: rgba($white, 0.75) !important;\n      }\n    }\n\n    // Account Settings\n    .account-settings-tab{\n      .nav-link{\n        background: transparent !important;\n      }\n    }\n\n    // Search Page\n    #search-website {\n      // search page\n      .search-bar {\n        .form-control {\n          background-color: $dark-card-color;\n        }\n      }\n\n      // search filters\n      .search-menu {\n        .search-filter {\n          background-color: $dark-card-color;\n          color: $theme-dark-text-color;\n        }\n      }\n\n      // search results\n      .search-result-info {\n        .dropdown-toggle {\n          color: $theme-dark-text-color;\n        }\n      }\n\n      // search pagination\n      .search-pagination {\n        .pagination {\n          .page-item {\n            background-color: $dark-card-color;\n            &.active {\n              .page-link {\n                background-color: $primary;\n              }\n            }\n            .page-link {\n              background-color: $dark-card-color;\n            }\n          }\n        }\n      }\n    }\n\n    // FAQ\n    .faq {\n      .accordion {\n        .collapse-margin {\n          background-color: $dark-card-color;\n        }\n      }\n    }\n\n    // knowledge base and faq card text color\n    .faq-bg,\n    .knowledge-base-bg {\n      .card-body {\n        .card-text {\n          color: $white;\n        }\n      }\n    }\n\n    // knowledge base card\n    .search-content {\n      .card {\n        .card-body {\n          .text-dark {\n            color: $theme-dark-text-color !important;\n          }\n        }\n      }\n    }\n\n    // knowledge base category and knowledge base question\n    .knowledge-base-category,\n    .knowledge-base-question {\n      .list-group {\n        .list-group-item {\n          color: $primary;\n        }\n      }\n    }\n\n    // invoice page\n    .invoice-items-table,\n    .invoice-total-table {\n      .table-borderless {\n        border: 0;\n      }\n    }\n    .invoice-header {\n      .input-group {\n        .form-control {\n          background-color: $dark-card-color;\n        }\n      }\n    }\n\n    /********** CHARTS **********/\n\n    // Apex Charts\n    .apexcharts-canvas {\n      .apexcharts-gridlines-horizontal {\n        .apexcharts-gridline {\n          stroke: $theme-dark-border-color;\n        }\n      }\n      // chart tooltip\n      .apexcharts-tooltip.light,\n      .apexcharts-yaxistooltip,\n      .apexcharts-xaxistooltip,\n      .apexcharts-tooltip {\n        background-color: $theme-dark-table-bg;\n        border-color: $content-dark-bg;\n        .apexcharts-tooltip-title,\n        .apexcharts-tooltip-text {\n          background-color: $theme-dark-table-bg;\n          color: $theme-dark-text-color;\n        }\n      }\n      .apexcharts-tooltip.dark {\n        .apexcharts-tooltip-text {\n          .apexcharts-tooltip-text-label,\n          .apexcharts-tooltip-text-value {\n            color: $white;\n          }\n        }\n      }\n      .apexcharts-xaxistooltip-bottom {\n        &:before {\n          border-bottom-color: transparent;\n        }\n        &:after {\n          border-bottom-color: $content-dark-bg;\n        }\n      }\n      .apexcharts-yaxistooltip-left {\n        &:before {\n          border-left-color: transparent;\n        }\n        &:after {\n          border-left-color: $content-dark-bg;\n        }\n      }\n      // chart text\n      text {\n        fill: $white !important;\n      }\n\n      // chart legend\n      .apexcharts-legend-series {\n        .apexcharts-legend-text {\n          color: $theme-dark-text-color !important;\n        }\n      }\n\n      // support chart\n      .apexcharts-radialbar-track {\n        path {\n          stroke: $content-dark-bg;\n        }\n      }\n\n      .apexcharts-inner {\n        // polygon sales chart\n        polygon {\n          stroke: $theme-dark-table-bg !important;\n          fill: $content-dark-bg !important;\n        }\n        rect {\n          fill: $dark-card-color;\n        }\n      }\n\n      // apex charts pie series\n      .apexcharts-pie-series {\n        path {\n          stroke: $content-dark-bg;\n        }\n      }\n\n      // apex chart menu\n      .apexcharts-menu {\n        background-color: $content-dark-bg;\n        border: 0;\n      }\n      .apexcharts-toolbar {\n        .apexcharts-zoom-in-icon,\n        .apexcharts-zoom-out-icon,\n        .apexcharts-zoom-icon,\n        .apexcharts-menu-icon,\n        .apexcharts-reset-zoom-icon {\n          &:hover {\n            svg {\n              fill: $theme-dark-text-color;\n            }\n          }\n        }\n        .apexcharts-menu-item {\n          color: $theme-dark-text-color;\n          &:hover {\n            background-color: $dark-card-color;\n          }\n        }\n      }\n    }\n\n    // Recharts\n    .recharts-wrapper {\n      line {\n        stroke: $theme-dark-text-color;\n      }\n      text {\n        fill: $white;\n      }\n      .recharts-default-tooltip {\n        background-color: $dark-card-color !important;\n        border-color: $theme-dark-border-color !important;\n        color: $theme-dark-text-color;\n      }\n      .recharts-rectangle.recharts-tooltip-cursor {\n        fill: $content-dark-bg !important;\n      }\n      .recharts-pie-sector {\n        .recharts-sector {\n          stroke: $theme-dark-border-color;\n        }\n      }\n      .recharts-radial-bar-background {\n        .recharts-radial-bar-background-sector {\n          fill: $content-dark-bg;\n        }\n      }\n    }\n    // Dropdown Divider\n    .dropdown-divider {\n      border-color: $theme-dark-border-color;\n    }\n    /********** APPLICATIONS **********/\n\n    // email application\n    .email-application {\n      // search and sidebar\n      .email-app-sidebar {\n        background-color: $dark-card-color;\n        border-color: $theme-dark-border-color;\n      }\n      .app-fixed-search {\n        background-color: $dark-card-color;\n        border-color: $theme-dark-border-color;\n        svg {\n          color: $theme-dark-text-color;\n        }\n        .form-control {\n          color: $theme-dark-text-color;\n          &::placeholder {\n            color: $theme-dark-text-color;\n          }\n          &:focus {\n            & ~ .form-control-position {\n              svg {\n                color: $primary;\n              }\n            }\n          }\n        }\n        .form-control-position {\n          svg {\n            color: $theme-dark-text-color;\n          }\n        }\n      }\n      .email-app-list-wrapper {\n        border-color: $theme-dark-border-color;\n        .app-action {\n          border-color: $theme-dark-border-color;\n        }\n      }\n      // for app-menu text color\n      .email-app-menu {\n        .sidebar-menu-list {\n          .list-group-messages,\n          .list-group-labels {\n            .list-group-item {\n              background: $dark-card-color;\n              &.active,\n              &.active:hover {\n                color: $primary;\n              }\n              &:hover {\n                color: $theme-dark-text-color;\n              }\n            }\n          }\n        }\n      }\n      // Content Right\n      .content-right {\n        border-color: $theme-dark-border-color;\n        // mails\n        .email-app-list {\n          .app-action {\n            .action-right {\n              .list-inline-item {\n                svg {\n                  color: $theme-dark-text-color;\n                }\n              }\n            }\n          }\n          .email-user-list {\n            .media {\n              border-color: $theme-dark-border-color;\n              &:hover {\n                box-shadow: 0 0 0 0 $gray-800;\n              }\n            }\n\n            .mail-read,\n            .media {\n              background-color: $content-dark-bg;\n              .user-details,\n              .mail-message {\n                p,\n                .list-group-item-text {\n                  color: $theme-dark-text-color;\n                }\n                .mail-meta {\n                  .mail-date {\n                    color: $theme-dark-text-color;\n                  }\n                }\n              }\n            }\n            .mail-unread {\n              background-color: $dark-card-color;\n            }\n          }\n        }\n      }\n\n      // app email details\n      .email-app-details {\n        border-color: $theme-dark-border-color;\n        &.show {\n          background-color: $theme-dark-table-bg;\n        }\n        .email-detail-header {\n          border-color: $theme-dark-border-color;\n          background-color: $dark-card-color;\n          .email-header-right {\n            .list-inline-item {\n              .dropdown-toggle {\n                color: $theme-dark-text-color;\n              }\n            }\n          }\n          svg {\n            color: $theme-dark-text-color;\n          }\n        }\n        .mail-message-wrapper,\n        .email-detail-head {\n          border-color: $theme-dark-border-color !important;\n        }\n      }\n    }\n\n    // chat application\n    .chat-application {\n      .chat-profile-sidebar {\n        background-color: $content-dark-bg;\n      }\n      .sidebar-content {\n        background-color: $dark-card-color;\n        border-color: $theme-dark-border-color;\n        .chat-fixed-search {\n          border-color: $theme-dark-border-color;\n          .form-control {\n            background-color: $dark-card-color;\n            &:not(:focus) {\n              border: 1px solid $theme-dark-border-color;\n            }\n          }\n          svg {\n            color: $theme-dark-text-color;\n          }\n        }\n        .chat-user-list {\n          .chat-users-list-wrapper {\n            li {\n              border-color: $theme-dark-border-color;\n              &:not(.active):hover {\n                background: $dark-card-color;\n              }\n              &.active {\n                .contact-info {\n                  p {\n                    color: $white;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      .content-right {\n        border-color: $theme-dark-border-color;\n        .avatar {\n          border: 2px solid $white;\n        }\n        .chat-app-window {\n          .start-chat-area {\n            background-color: $dark-chat-bg-color;\n            .start-chat-icon,\n            .start-chat-text {\n              background: $content-dark-bg;\n            }\n          }\n          .active-chat {\n            .chat_navbar {\n              .chat_header {\n                box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.5);\n                svg {\n                  color: $theme-dark-text-color;\n                }\n              }\n            }\n            .user-chats {\n              background-color: $dark-chat-bg-color;\n              .chat-left {\n                .chat-content {\n                  color: $theme-dark-text-color;\n                  background-color: $dark-card-color;\n                  border: 1px solid $theme-dark-text-color;\n                  p {\n                    color: $theme-dark-text-color;\n                  }\n                }\n              }\n              .chat-content {\n                p {\n                  color: $white;\n                }\n              }\n              .chat-content {\n                background-color: $content-dark-bg;\n              }\n            }\n            .chat-app-form {\n              background-color: $dark-card-color;\n              .form-control {\n                background-color: $dark-card-color;\n                border: 1px solid $theme-dark-border-color;\n              }\n            }\n          }\n        }\n      }\n\n      .chat-profile-sidebar {\n        border: 1px solid !important;\n      }\n\n      // User Sidebar (LEFT SIDEBAR) AND  Right Sidebar\n      .user-profile-sidebar,\n      .chat-profile-sidebar {\n        background-color: $dark-card-color;\n        border-color: $theme-dark-border-color !important;\n        .user-profile-header,\n        .chat-profile-header {\n          border-color: $theme-dark-border-color;\n          .avatar {\n            border: 2px solid $white;\n          }\n          .close-icon {\n            color: $theme-dark-text-color;\n          }\n        }\n      }\n    }\n\n    // todo-application\n    .todo-application {\n      border-color: $theme-dark-border-color;\n\n      // Main Sidebar\n      .todo-sidebar {\n        background-color: $dark-card-color;\n        border-color: $theme-dark-border-color;\n        .list-group {\n          .list-group-item {\n            &:hover {\n              color: $theme-dark-text-color;\n              svg {\n                color: $theme-dark-text-color;\n              }\n            }\n          }\n        }\n      }\n\n      // Todo List\n      .todo-app-area {\n        .todo-app-list-wrapper {\n          border-color: $theme-dark-border-color;\n        }\n        .app-fixed-search {\n          background-color: $dark-card-color;\n          border-color: $theme-dark-border-color !important;\n          svg {\n            color: $theme-dark-text-color;\n          }\n          .form-control-position {\n            svg {\n              color: $theme-dark-text-color;\n            }\n          }\n        }\n        .todo-task-list {\n          .todo-item {\n            border-color: $theme-dark-border-color;\n            &:hover {\n              box-shadow: none;\n            }\n            .chip {\n              background-color: $dark-card-color;\n            }\n            .todo-item-action {\n              .todo-item-favorite,\n              .todo-item-delete,\n              .todo-item-info {\n                svg {\n                  color: $theme-dark-text-color;\n                }\n              }\n            }\n          }\n        }\n      }\n\n      // Add Task Sidebar\n      .task-sidebar {\n        background-color: $dark-card-color;\n      }\n      .task-header {\n        background-color: $dark-card-color;\n        .close-icon {\n          color: $theme-dark-text-color;\n        }\n      }\n      .task-body {\n        svg {\n          color: $theme-dark-text-color;\n        }\n      }\n    }\n\n    // ecommerce application\n    .ecommerce-application {\n      // sidebar\n      .sidebar-shop {\n        .filter-heading {\n          color: $theme-dark-text-color;\n        }\n        .price-slider {\n          .range-slider {\n            background-color: $content-dark-bg;\n          }\n        }\n        .ratings-list {\n          li,\n          & ~ .stars-received {\n            color: $theme-dark-text-color;\n          }\n        }\n      }\n\n      // main content\n      // header items\n      .ecommerce-header-items {\n        .result-toggler {\n          .search-results {\n            color: $theme-dark-text-color;\n          }\n          .shop-sidebar-toggler {\n            svg {\n              color: $theme-dark-text-color;\n            }\n          }\n        }\n        .view-options {\n          .React-Select {\n            .select__control {\n              background-color: $dark-card-color;\n              .select__single-value {\n                color: $theme-dark-text-color;\n              }\n            }\n          }\n          .select__menu {\n            .select__option {\n              color: $theme-dark-text-color;\n              &:hover {\n                color: $white;\n              }\n              &.select__option--is-selected {\n                background-color: $primary;\n              }\n            }\n          }\n\n          // change view btn\n          .view-btn-option {\n            .view-btn {\n              background-color: $dark-card-color !important;\n              &:not(.active) {\n                svg {\n                  color: $theme-dark-text-color;\n                }\n              }\n            }\n          }\n        }\n      }\n\n      // product search\n      .search-product {\n        background-color: $dark-card-color;\n        & ~ .form-control-position {\n          svg {\n            color: $theme-dark-text-color;\n          }\n        }\n      }\n\n      // list and grid view\n      .grid-view,\n      .list-view {\n        .ecommerce-card {\n          .card-body {\n            border-color: $theme-dark-border-color;\n          }\n          .item-img {\n            background-color: $white;\n          }\n          .item-name {\n            color: $white;\n          }\n          .item-options {\n            .wishlist {\n              span {\n                color: $headings-color;\n              }\n            }\n            .cart {\n              span {\n                color: $white;\n              }\n            }\n          }\n        }\n      }\n\n      // pagination\n      .pagination {\n        .page-item {\n          background-color: $dark-card-color;\n          &.active {\n            background-color: $dark-card-color;\n            .page-link {\n              background-color: $primary;\n            }\n          }\n          .page-link {\n            background-color: $dark-card-color;\n          }\n        }\n      }\n      // wishlist-items\n      .wishlist-items {\n        .ecommerce-card {\n          .move-cart {\n            .move-to-cart {\n              color: $white;\n            }\n          }\n        }\n      }\n\n      // checkout\n      .product-checkout {\n        .checkout-options {\n          .detail-total {\n            color: $theme-dark-text-color;\n          }\n        }\n      }\n      .product-checkout.list-view {\n        background: $content-dark-bg;\n      }\n    }\n    .app-ecommerce-details {\n      .item-features {\n        background-color: $dark-chat-bg-color;\n      }\n      .swiper-slide {\n        background-color: $content-dark-bg;\n      }\n      .swiper-button-next,\n      .swiper-button-prev {\n        color: $primary;\n      }\n    }\n\n    // calendar\n    .app-calendar {\n      .rbc-calendar {\n        .rbc-month-view,\n        .rbc-month-row,\n        .rbc-day-bg,\n        .rbc-header,\n        .rbc-time-view,\n        .rbc-time-content,\n        .rbc-time-header-content,\n        .rbc-events-container,\n        .rbc-timeslot-group,\n        .rbc-time-slot {\n          border-color: $theme-dark-border-color !important;\n        }\n        .rbc-date-cell.rbc-off-range {\n          color: $theme-dark-text-color;\n        }\n        .rbc-today {\n          background-color: transparent;\n        }\n      }\n      .add-event-sidebar,\n      .add-event-sidebar .header {\n        background-color: $dark-card-color;\n        svg {\n          color: $theme-dark-text-color;\n        }\n      }\n    }\n\n    // app user list\n    .app-user-list {\n      .ag-grid-table {\n        .ag-header {\n          .ag-header-cell {\n            background-color: transparent;\n          }\n        }\n      }\n    }\n\n    /********** EXTENSIONS **********/\n\n    // RC slider\n    .rc-slider {\n      .rc-slider-rail {\n        background-color: $content-dark-bg !important;\n      }\n      &.rc-slider-disabled {\n        background-color: $content-dark-bg;\n        opacity: 0.7;\n      }\n    }\n\n    // dropzone\n    .dropzone {\n      background-color: $content-dark-bg;\n      & ~ .thumb-container {\n        .dz-thumb {\n          border-color: $theme-dark-border-color !important;\n        }\n      }\n    }\n\n    // Wysiwyg Editor\n    .rdw-editor-wrapper {\n      .rdw-editor-toolbar {\n        background-color: $content-dark-bg;\n        border-color: $theme-dark-border-color;\n        // .rdw-option-wrapper {\n        //   background-color: transparent;\n        // }\n        .rdw-dropdown-wrapper {\n          background-color: $dark-card-color;\n          border-color: $theme-dark-border-color;\n          &:hover {\n            background-color: $dark-card-color;\n            box-shadow: none;\n          }\n          .rdw-dropdown-carettoopen {\n            border-top-color: $theme-dark-text-color;\n          }\n          .rdw-dropdown-carettoclose {\n            border-bottom-color: $theme-dark-text-color;\n          }\n          .rdw-dropdown-optionwrapper {\n            border-color: $theme-dark-border-color;\n            background-color: $dark-card-color;\n            .rdw-dropdownoption-active,\n            .rdw-dropdownoption-highlighted {\n              background-color: $content-dark-bg;\n            }\n          }\n        }\n      }\n    }\n    // Extensions pagination\n    .vx-pagination {\n      li {\n        background-color: $content-dark-bg;\n        a {\n          color: $theme-dark-text-color;\n        }\n      }\n    }\n\n    // React Contexify\n    .react-contexify {\n      background-color: $content-dark-bg;\n      box-shadow: none;\n      .react-contexify__item {\n        border-color: $theme-dark-border-color;\n        .react-contexify__item__content {\n          color: $theme-dark-text-color;\n        }\n      }\n    }\n\n    // Swiper\n    .swiper-container {\n      .swiper-slide.swiper-slide-active {\n        span,\n        svg {\n          color: $white;\n        }\n      }\n      &.centered-style-1 {\n        .swiper-slide {\n          background-color: $dark-chat-bg-color;\n        }\n      }\n      &.centered-style-2 {\n        .swiper-slide:not(.swiper-slide-active) {\n          background-color: $dark-chat-bg-color;\n        }\n      }\n      &.swiper-parallax {\n        .swiper-slide,\n        .swiper-slide p {\n          color: $black;\n        }\n      }\n    }\n\n    // Vuexy Search\n    .vx-autocomplete-container {\n      .suggestions-list {\n        background-color: $content-dark-bg;\n\n        .suggestion-item {\n          &.active,\n          &.active:hover {\n            background-color: $dark-card-color;\n          }\n\n          &:hover{\n            background-color: $dark-card-color !important;\n          }\n\n          svg:not([class*=\"text-\"]) {\n            stroke: $theme-dark-text-color;\n          }\n        }\n      }\n    }\n\n    /********** CUSTOMIZER **********/\n\n    .customizer {\n      background-color: $content-dark-bg;\n      .close-icon {\n        svg {\n          color: $theme-dark-text-color;\n        }\n      }\n      .bg-default {\n        background-color: $dark-card-color;\n        border-color: $dark-card-color !important;\n      }\n    }\n\n    .vertical-layout.fixed-footer {\n      .footer {\n        background-color: $dark-card-color;\n      }\n    }\n\n    /********** HORIZONTAL Layout **********/\n    .horizontal-layout {\n      .horizontal-menu-wrapper {\n        background: linear-gradient(\n          to bottom,\n          rgba(37, 43, 71, 0.76) 44%,\n          rgba(56, 53, 53, 0.46) 73%,\n          rgba(255, 255, 255, 0) 100%\n        );\n      }\n      .header-navbar {\n        background-color: $dark-card-color !important;\n        #main-menu-navigation {\n          .dropdown-item {\n            .item-content {\n              color: $theme-dark-text-color !important;\n            }\n            &.active {\n              background-color: $dark-card-color !important;\n             \n            }\n            &:not(.active):hover {\n              span {\n                color: $theme-dark-text-color;\n              }\n            }\n            &.has-sub.hover,\n            &.has-sub.hover .dropdown {\n              background-color: transparent !important;\n            }\n          }\n          .nav-item {\n            &.hover:not(.active) {\n              .dropdown,\n              a.nav-link {\n                background-color: $content-dark-bg !important ;\n              }\n            }\n            &.active {\n              .menu-icon svg {\n                stroke: $white;\n              }\n              .dropdown-menu{\n                li.active,\n                li.active:hover{\n                  background: $dark-card-color !important;\n                }\n                .dropdown-item:hover{\n                  background: $dark-card-color !important;\n                }\n              }\n            }\n          }\n\n          .dropdown-menu {\n            &::-webkit-scrollbar-thumb {\n              background: $dark-card-color !important;\n            }\n\n            &::-webkit-scrollbar-track {\n              background: $content-dark-bg !important;\n            }\n          }\n        }\n      }\n\n      &.fixed-footer{\n        .footer{\n          background: $dark-card-color;\n        }\n      }\n    }\n  }\n}\n","// ================================================================================================\n// \tFile Name: semi-dark-layout.scss\n// \tDescription: SCSS file for semi dark layout.\n// \t----------------------------------------------------------------------------------------------\n// \tItem Name: Vuexy React admin Template\n// \tVersion: 1.0\n// \tAuthor: PIXINVENT\n// \tAuthor URL: http://www.themeforest.net/user/pixinvent\n// ================================================================================================\n\n// Core variables and mixins\n@import \"~bootstrap/scss/_functions.scss\";\n@import \"~bootstrap/scss/mixins\";\n@import \"../bootstrap-extended/mixins\";\n\n// Load variable overrides\n@import \"../core/variables/variables\";\n@import \"~bootstrap/scss/_variables.scss\";\n\n// Overrides user variable\n@import \"../core/variables/components-variables\";\n\nbody {\n  &.semi-dark-layout {\n    /************ Main Menu **************/\n\n    // main menu\n    .main-menu {\n      background-color: $dark-card-color;\n      .shadow-bottom {\n        background: linear-gradient(\n          180deg,\n          #0f1642 44%,\n          rgba(15, 22, 66, 0.51) 73%,\n          rgba(44, 48, 60, 0)\n        );\n      }\n      &:not(.expanded) {\n        .navigation {\n          .sidebar-group-active {\n            a {\n              background-color: $content-dark-bg;\n            }\n          }\n        }\n      }\n      &.theme-dark {\n        .navbar-header {\n          .brand-text {\n            color: $gray-500 !important;\n          }\n          .modern-nav-toggle {\n            svg {\n              color: $gray-500 !important;\n            }\n          }\n        }\n        .navigation {\n          .nav-item {\n            &.active {\n              a {\n                background: linear-gradient(\n                  118deg,\n                  $gray-500,\n                  rgba($gray-500, 0.7)\n                );\n                box-shadow: 0 0 10px 1px rgba($gray-500, 0.7);\n              }\n            }\n            .menu-content {\n              li.active {\n                background: linear-gradient(\n                  118deg,\n                  $gray-500,\n                  rgba($gray-500, 0.7)\n                );\n                box-shadow: 0 0 10px 1px rgba($gray-500, 0.7);\n              }\n            }\n          }\n        }\n      }\n    }\n\n    // main menu content\n    .main-menu-content {\n      .navigation-main {\n        background-color: $dark-card-color;\n        .nav-item {\n          svg {\n            color: $theme-dark-text-color;\n          }\n          &.open {\n            a {\n              background-color: $content-dark-bg;\n            }\n          }\n          a:after,\n          a {\n            color: $theme-dark-text-color;\n          }\n          .menu-content {\n            background-color: $dark-card-color;\n            .active {\n              .menu-item {\n                color: $white;\n              }\n            }\n            li {\n              &:not(.active) {\n                a {\n                  background-color: $dark-card-color;\n                }\n              }\n              &.hover {\n                a,\n                svg {\n                  color: $theme-dark-text-color;\n                }\n              }\n            }\n          }\n        }\n        .active {\n          .menu-title,\n          svg {\n            color: $white;\n          }\n        }\n        .sidebar-group-active {\n          a {\n            background: $dark-card-color;\n            border-radius: 4px;\n          }\n          .menu-content {\n            background-color: $dark-card-color;\n            .active {\n              z-index: 1;\n              a {\n                background-color: transparent;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    // menu collapsed active item color\n    &.menu-collapsed {\n      .main-menu:not(.expanded) {\n        .navigation-main {\n          li.active {\n            a {\n              background: $content-dark-bg !important;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","a {\n  &:focus {\n    outline: none;\n  }\n}\n\n// Component Code\n.component-code {\n  pre {\n    max-height: 300px;\n    overflow-y: scroll;\n    &::-webkit-scrollbar {\n      width: 10px;\n      height: 10px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: #c1c1c1;\n      border-radius: 20px;\n    }\n\n    &::-webkit-scrollbar-track {\n      background: $body-bg;\n    }\n  }\n}\n","// ================================================================================================ //\n// File Name: type.scss\n// Description: Type pages custom scss\n// ---------------------------------------------------------------------------------------------- //\n// Item Name: Vuexy React admin Template\n// Version: 1.0\n// Author: PIXINVENT\n// Author URL: http://www.themeforest.net/user/pixinvent\n// ================================================================================================\n\n// Small font sizes\n.font-small-1 { font-size: 0.7rem !important; }\n.font-small-2 { font-size: 0.8rem !important; }\n.font-small-3 { font-size: 0.9rem !important; }\n\n// Medium font sizes\n.font-medium-1 { font-size: 1.1rem !important; }\n.font-medium-2 { font-size: 1.2rem !important; }\n.font-medium-3 { font-size: 1.3rem !important; }\n.font-medium-4 { font-size: 1.4rem !important; }\n.font-medium-5 { font-size: 1.5rem !important; }\n\n// Large font sizes\n.font-large-1 { font-size: 2rem !important; }\n.font-large-2 { font-size: 3rem !important; }\n.font-large-3 { font-size: 4rem !important; }\n.font-large-4 { font-size: 5rem !important; }\n.font-large-5 { font-size: 6rem !important; }\n\n// Text styling\n// -------------------------\n\n// Font weights\n.text-bold-300 { @include font-weight(light); }\n.text-bold-400 { @include font-weight(book); }\n.text-bold-500 { @include font-weight(medium); }\n.text-bold-600 { @include font-weight(semi-bold); }\n.text-bold-700 { @include font-weight(bold); }\n\n// Font style\n.text-italic { font-style: italic; }\n.text-highlight { padding: 4px 6px; }\n\n// List Item\nol, ul, dl {\n  li {\n    line-height: 1.2;\n  }\n}","// Font weight mixins\n// ------------------\n@mixin font-weight($weight) {\n  $weights: (\n    thin: 100,\n    extra-light: 200,\n    ultra-light: 200,\n    light: 300,\n    normal: 400,\n    book: 400,\n    regular: 400,\n    medium: 500,\n    semi-bold: 600,\n    demi-bold: 600,\n    bold: 700,\n    extra-bold: 800,\n    ultra-bold: 900,\n    heavy: 900,\n    black: 900,\n    ultra: 900,\n    ultra-black: 900,\n    extra-ultra: 900\n  );\n  \n  $output: $weight;\n  @if map-has-key($weights, $weight) {\n    $output: map-get($weights, $weight);\n  }\n  \n  font-weight: $output;\n}","// Inline code\ncode {\n  padding: 0.1rem 0.4rem;\n  font-size: 90%;\n  color: $code-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius/2);\n}\npre {\n  border-radius: 0.5rem;\n  code {\n    background-color: transparent !important;\n  }\n}\n","// .bs-example{\n// \t[class^=\"col-\"]{\n// \t\tspan{\n// \t\t\tpadding: .75rem;\n// \t\t\tbackground-color: rgba(86, 61, 124, 0.15);\n// \t\t\tborder: 1px solid rgba(86, 61, 124, 0.2);\n// \t\t\tdisplay: block;\n// \t\t}\n// \t\tmargin-bottom: 1rem;\n// \t}\n// \t.row + .row {\n// \t\tmargin-top: 1rem;\n// \t}\n// }\n\n//\n// Grid examples\n//\n\n// [dir=ltr] .row {\n//   margin-right: 31px;\n//   margin-left: -30px;\n// }\n\n.bd-example-row {\n  .row + .row {\n    margin-top: 1rem;\n  }\n\n  .row {\n    > .col,\n    > [class^=\"col-\"] {\n      padding-top: 0.75rem;\n      padding-bottom: 0.75rem;\n      background-color: rgba(86, 61, 124, 0.15);\n      border: 1px solid rgba(86, 61, 124, 0.2);\n    }\n  }\n\n  .flex-items-top,\n  .flex-items-middle,\n  .flex-items-bottom {\n    min-height: 6rem;\n    background-color: rgba(255, 0, 0, 0.1);\n  }\n}\n\n.bd-example-row-flex-cols .row {\n  min-height: 10rem;\n  background-color: rgba(255, 0, 0, 0.1);\n}\n\n.bd-highlight {\n  background-color: rgba(86, 61, 124, 0.15);\n  border: 1px solid rgba(86, 61, 124, 0.15);\n}\n\n// Grid mixins\n.example-container {\n  width: 800px;\n  @include make-container();\n}\n\n.example-row {\n  @include make-row();\n}\n\n.example-content-main {\n  @include make-col-ready();\n\n  @include media-breakpoint-up(sm) {\n    @include make-col(6);\n  }\n\n  @include media-breakpoint-up(lg) {\n    @include make-col(8);\n  }\n}\n\n.example-content-secondary {\n  @include make-col-ready();\n\n  @include media-breakpoint-up(sm) {\n    @include make-col(6);\n  }\n\n  @include media-breakpoint-up(lg) {\n    @include make-col(4);\n  }\n}\n","// ================================================================================================\n//     File Name: tables.scss\n//     Description: Tables pages custom scss\n//     ----------------------------------------------------------------------------------------------\n//     Item Name: Vuexy React admin Template\n//     Version: 1.0\n//     Author: PIXINVENT\n//     Author URL: http://www.themeforest.net/user/pixinvent\n// ================================================================================================\n\n// table-white-space\n.table-white-space {\n  th,\n  td {\n    white-space: nowrap;\n  }\n}\n\n// table th, td padding\n.table {\n  thead th {\n    vertical-align: top;\n  }\n  th,\n  td {\n    padding: 1rem;\n    vertical-align: middle;\n  }\n  //table heading font-size\n  th {\n    font-size: $table-th-font-size;\n  }\n}\n\n// table - inverse\n.table-inverse {\n  color: $white;\n  background-color: $info;\n}\n\n// table - hover animation\n.table-hover-animation {\n  background-color: $body-bg;\n  thead {\n    th {\n      border-top: 2px solid $table-border-color;\n      border-bottom: 0;\n      background-color: $white;\n    }\n  }\n  th,\n  td {\n    border: 0;\n  }\n  tbody {\n    tr {\n      transition: all 0.25s ease;\n      background-color: $white;\n      &:hover {\n        transform: translateY(-4px);\n      }\n    }\n  }\n}\n","// placeholder spacific scss\n$custom-file-padding-y: 1rem;\n$custom-file-padding-x: .5rem;\n\n.form-control {\n  &::placeholder {\n    font-size: 0.85rem;\n    color: rgba($black, 0.4);\n    transition: all 0.2s ease;\n  }\n\n  &:-ms-input-placeholder {\n    color: darken($body-bg, 20%);\n  }\n\n  &:focus {\n    &::placeholder {\n      transform: translate(5px);\n      transition: all 0.2s ease;\n    }\n    ~ .form-control-position {\n      svg {\n        stroke: $primary;\n      }\n    }\n  }\n}\n\n/* Form specific Scss */\n\n// Form Label Scscc\nlabel {\n  color: darken($body-bg, 70%);\n  font-size: 0.85rem;\n  margin-bottom: 0;\n  padding-left: 0.2rem;\n}\n\n// Text area fontsize and line height\ntextarea.form-control {\n  line-height: 1.6rem;\n  font-size: 1rem;\n}\n\n// Form group Scscc\n.form-group {\n  margin-bottom: 1.5rem;\n  .valid-tooltip,\n  .invalid-tooltip {\n    top: auto;\n  }\n}\n\n// Form control Scscc\n.form-control {\n  border: 1px solid darken($body-bg, 12%);\n  color: darken($body-bg, 60%);\n}\n// Used for Card - Check it and remove if not used\n.form-section {\n  color: $gray-600;\n  line-height: 3rem;\n  margin-bottom: 20px;\n  border-bottom: 1px solid $gray-600;\n}\n\n/* .form-body{\n    overflow: hidden;\n} */\n\n// Used for Card - Check it and remove if not used\n.form-actions {\n  border-top: 1px solid darken($body-bg, 10%);\n  padding: 20px 0;\n  margin-top: 20px;\n\n  &.filled {\n    background-color: $body-bg;\n  }\n  &.center {\n    text-align: center;\n  }\n  &.right {\n    text-align: right;\n  }\n\n  &.top {\n    border-top: 0;\n    border-bottom: 1px solid darken($body-bg, 10%);\n    margin-top: 0;\n    margin-bottom: 20px;\n  }\n\n  @include media-breakpoint-down(sm) {\n    .buttons-group {\n      float: left !important;\n      margin-bottom: 10px;\n    }\n  }\n}\n\n// Form-horizotnal layout\n.form-horizontal {\n  .form-group {\n    @include media-breakpoint-up(sm) {\n      .label-control {\n        text-align: right;\n      }\n    }\n  }\n}\n\n// Form Control Large\n.form-control.form-control-lg {\n  padding: 1rem;\n  &::placeholder {\n    font-size: 1.25rem;\n  }\n}\n\n// Form Control Small\n.form-control.form-control-sm {\n  padding: 0.6rem;\n  &::placeholder {\n    font-size: 0.7rem;\n  }\n}\n\n// Custom-File-Input\n.custom-file-label {\n  padding: ($custom-file-padding-y - 0.3) $custom-file-padding-x;\n  &::after {\n    padding: ($custom-file-padding-y - 0.3) $custom-file-padding-x;\n    height: auto;\n  }\n}\n\n// Select Inputs Specific SCSS\nselect.form-control {\n  &:not([multiple=\"multiple\"]) {\n    // background-image:\n    //   url(\"../../app-assets/images/pages/arrow-down.png\");\n    background-position: calc(100% - 12px) 13px, calc(100% - 20px) 13px, 100% 0;\n    background-size: 12px 12px, 10px 10px;\n    background-repeat: no-repeat;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    padding-right: 1.5rem;\n  }\n}\n\n// For customs-select remove double arrow && padding\n.custom-select {\n  padding: 0.7rem 1.7rem 0.6rem 0.7rem;\n  -moz-appearance: none; // For firefox\n  -webkit-appearance: none; // for chorme\n}\n\n// input group addon\n.input-group-addon {\n  background-color: #eceff1;\n  border-color: #babfc7;\n}\n\n// Custom Checkbox\n.custom-control-label::before {\n  width: 1.1rem;\n  height: 1.1rem;\n  top: 0.1rem;\n}\n.custom-control-label::after {\n  width: 1.1rem;\n  height: 1.1rem;\n  top: 0.1rem;\n}\n\n// Custom-checkbox when not disabled and active\n.custom-control-input:not(:disabled) {\n  &:active ~ .custom-control-label {\n    &::before {\n      background-color: $primary;\n      border-color: $primary;\n    }\n  }\n}\n\n//form-tags-input\n// .tagging-js-tags, .tagging-methods{\n//     .form-control{\n//         height: auto;\n//     }\n// }\n\n/* Floating label Group */\n.form-label-group {\n  position: relative;\n  margin-bottom: 1.5rem;\n\n  // Form-Control-Large in Floating Label Group\n  .form-control-lg {\n    ~ label {\n      font-size: 1.25rem;\n      padding: 1rem;\n    }\n  }\n\n  // Form-Control-Small in Floating Label Group\n  .form-control-sm {\n    ~ label {\n      font-size: 0.7rem;\n    }\n  }\n\n  // Form-label\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: block;\n    transition: all 0.25s ease-in-out;\n    padding: 0.6rem;\n    color: rgba($black, 0.4);\n    font-size: 0.85rem;\n    opacity: 0;\n    z-index: -1;\n  }\n  // form-input\n  > input,\n  textarea {\n    padding: 0.6rem;\n\n    // input place holder make transparent as it mix with label color\n    &::placeholder {\n      // color: transparent;\n      // opacity: 1;\n    }\n    // from-input on focus change label color\n    &:focus,\n    &:not(:active) {\n      &:not(:placeholder-shown) ~ label {\n        color: rgba($primary, 1) !important;\n        transition: all 0.25s ease-in-out;\n        opacity: 1;\n      }\n    }\n    &:not(:focus) {\n      &:not(:placeholder-shown) ~ label {\n        color: rgba($black, 0.4) !important;\n      }\n    }\n    // form-label after entering text in input box\n    &:not(:placeholder-shown) ~ label {\n      padding: 0.25rem 0;\n      font-size: 0.7rem;\n      top: -20px;\n      left: 3px;\n      z-index: 1;\n    }\n  }\n\n  // has-icon left with input\n  &.has-icon-left {\n    > label {\n      left: 36px;\n    }\n  }\n}\n\n/* Vuexy Custom Checkbox */\n.vx-checkbox-con {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  margin: 0.25rem 0;\n  input {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    z-index: 200;\n    cursor: pointer;\n    top: 0;\n    &:checked {\n      ~ .vx-checkbox {\n        transform: rotate(0deg);\n        border-color: $primary;\n        .vx-checkbox--check {\n          transform: translate(0);\n          background-color: $primary;\n          .vx-icon {\n            transform: translate(0);\n            line-height: 1.2;\n            opacity: 1;\n          }\n        }\n        &.vx-checkbox-sm {\n          .vx-checkbox--check .vx-icon {\n            font-size: 0.75rem;\n          }\n        }\n        &.vx-checkbox-lg {\n          .vx-checkbox--check .vx-icon {\n            font-size: 1.2rem;\n          }\n        }\n      }\n    }\n    &:active:checked + .vx-checkbox {\n      .vx-checkbox--check {\n        transform: translate(3px);\n        background-color: $primary;\n        .vx-icon {\n          opacity: 1;\n          transform: translate(6px);\n        }\n      }\n    }\n    &:disabled {\n      cursor: default;\n      pointer-events: none;\n      + .vx-checkbox {\n        cursor: default;\n        opacity: 0.5;\n      }\n    }\n  }\n  .vx-checkbox {\n    cursor: pointer;\n    position: relative;\n    width: $vs-checkbox-box;\n    height: $vs-checkbox-box;\n    border-width: $vs-checkbox-radio-border-width;\n    border-style: solid;\n    border-color: $vs-checkbox-radio-border-color;\n    border-radius: 2px;\n    transform: rotate(-90deg);\n    transition: all 0.2s ease;\n    overflow: hidden;\n    margin-right: 0.5rem;\n    &.vx-checkbox-sm {\n      width: $vs-checkbox-box-sm;\n      height: $vs-checkbox-box-sm;\n    }\n    &.vx-checkbox-lg {\n      width: $vs-checkbox-box-lg;\n      height: $vs-checkbox-box-lg;\n    }\n    .vx-checkbox--check {\n      width: 100%;\n      height: 100%;\n      position: absolute;\n      display: flex;\n      left: 0;\n      transform: translate(100%);\n      transform-origin: right;\n      transition: all 0.2s ease;\n      z-index: 10;\n      .vx-icon {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        color: $white;\n      }\n    }\n  }\n}\n\n/* Vuexy Custom Radio */\n.vx-radio-con {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  margin: 0.25rem 0;\n  input {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    z-index: 200;\n    cursor: pointer;\n    &:checked {\n      ~ .vx-radio {\n        transform: rotate(0deg);\n        outline: 0;\n        .vx-radio--circle {\n          background: rgba($primary, 1);\n          box-shadow: 0 3px 12px 0 rgba($primary, 0.4);\n          opacity: 1;\n          transform: scale(1);\n        }\n        .vx-radio--border {\n          opacity: 0;\n          transform: scale(0.3);\n        }\n      }\n    }\n    &:disabled {\n      cursor: default;\n      pointer-events: none;\n      + .vx-radio {\n        cursor: default;\n        opacity: 0.5;\n      }\n    }\n    &:active {\n      ~ .vx-radio {\n        transform: scale(1.1);\n      }\n    }\n  }\n  .vx-radio {\n    cursor: pointer;\n    position: relative;\n    width: $vs-radio-box;\n    height: $vs-radio-box;\n    transition: all 0.2s ease;\n    margin-right: 0.5rem;\n    &.vx-radio-sm {\n      width: $vs-radio-box-sm;\n      height: $vs-radio-box-sm;\n    }\n    &.vx-radio-lg {\n      width: $vs-radio-box-lg;\n      height: $vs-radio-box-lg;\n    }\n    .vx-radio--border,\n    .vx-radio--circle {\n      width: 100%;\n      height: 100%;\n      position: absolute;\n      left: 0;\n      transition: all 0.25s ease;\n      top: 0;\n      border-radius: 50%;\n    }\n    .vx-radio--border {\n      background: transparent;\n      border: $vs-checkbox-radio-border-width solid\n        $vs-checkbox-radio-border-color;\n    }\n    .vx-radio--circle {\n      opacity: 0;\n      transform: scale(0.1);\n    }\n  }\n}\n\n/* Switches */\n\n.custom-switch {\n  padding-left: 0;\n\n  .custom-control-label {\n    height: 1.571rem;\n    width: 3.1rem;\n    padding: 0;\n\n    /* For bg color of switch*/\n    &::before {\n      border: none;\n      background-color: $switch-bg-color;\n      height: 1.571rem;\n      left: -0.2857rem;\n      box-shadow: none !important;\n      transition: all 0.25s ease;\n      cursor: pointer;\n      user-select: none;\n      top: 0;\n      left: 0;\n    }\n    /*For Switch handle*/\n    &:after {\n      position: absolute;\n      top: 2px;\n      left: 2px;\n      box-shadow: none;\n      background-color: $switch-indicator-color;\n      transition: all 0.25s ease;\n      cursor: pointer;\n      user-select: none;\n    }\n\n    /*For Switch text*/\n    .switch-text-left,\n    .switch-text-right,\n    .switch-icon-left,\n    .switch-icon-right {\n      position: absolute;\n      top: 5px;\n      font-size: 0.7rem;\n      cursor: pointer;\n      user-select: none;\n    }\n    .switch-text-left,\n    .switch-icon-left {\n      left: 7px;\n      color: $white;\n    }\n    .switch-text-right,\n    .switch-icon-right {\n      right: 7px;\n    }\n    &:focus {\n      outline: 0;\n    }\n  }\n\n  /*For Switch label*/\n\n  .switch-label {\n    padding-left: 1rem;\n  }\n\n  // after its checked\n\n  .custom-control-input:checked ~ .custom-control-label::before {\n    box-shadow: none;\n    background-color: $primary;\n  }\n\n  /*For Switch Handle Animation*/\n  .custom-control-input:checked ~ .custom-control-label::after {\n    transform: translateX(1.4rem);\n  }\n  .custom-control-input:not(:checked) ~ .custom-control-label {\n    .switch-text-left {\n      opacity: 0;\n    }\n    .switch-text-right {\n      opacity: 1;\n    }\n  }\n  .custom-control-input:checked ~ .custom-control-label {\n    .switch-text-right {\n      opacity: 0;\n    }\n    .switch-text-left {\n      opacity: 1;\n    }\n  }\n  .custom-control-input:not(:disabled):active ~ .custom-control-label::before {\n    background-color: $switch-bg-color;\n  }\n  // For Switch Sizes\n\n  // switch md\n  &.switch-md {\n    .custom-control-label {\n      width: $switch-md-size;\n      height: 1.571rem;\n      &::before {\n        width: $switch-md-size;\n        border: none;\n        background-color: $switch-bg-color;\n        height: 1.571rem;\n        left: -0.2857rem;\n        box-shadow: none !important;\n        transition: all 0.25s ease;\n        cursor: pointer;\n        user-select: none;\n      }\n      &:after {\n        box-shadow: none;\n        background-color: $switch-indicator-color;\n        transition: all 0.25s ease;\n        cursor: pointer;\n        user-select: none;\n        position: absolute;\n        top: 2px;\n        left: -2px;\n      }\n      .switch-text-right,\n      .switch-icon-right {\n        right: 9px;\n      }\n      .switch-text-left,\n      .switch-icon-left {\n        left: 5px;\n      }\n    }\n    .custom-control-input:checked ~ .custom-control-label::after {\n      transform: translateX(2.3rem);\n    }\n  }\n\n  // switch lg\n  &.switch-lg {\n    .custom-control-label {\n      width: $switch-lg-size;\n      height: 1.571rem;\n      &::before {\n        width: $switch-lg-size;\n        border: none;\n        background-color: $switch-bg-color;\n        height: 1.571rem;\n        left: -0.2857rem;\n        box-shadow: none !important;\n        transition: all 0.25s ease;\n        cursor: pointer;\n        user-select: none;\n      }\n      &:after {\n        position: absolute;\n        top: 2px;\n        left: -2px;\n        box-shadow: none;\n        background-color: $switch-indicator-color;\n        transition: all 0.25s ease;\n        cursor: pointer;\n        user-select: none;\n      }\n      .switch-text-right,\n      .switch-icon-right {\n        right: 10px;\n      }\n    }\n    .custom-control-input:checked ~ .custom-control-label::after {\n      transform: translateX(3.8rem);\n    }\n  }\n}\n\n/* Textarea with Counter */\n\n.counter-value {\n  background-color: $primary;\n  color: $white;\n  padding: 1px 6px;\n  font-size: 0.6rem;\n  border-radius: 0 0 5px 5px;\n  margin-right: 1rem;\n}\n\n/* Input box with icon divider */\n\n.form-group {\n  &.input-divider-left {\n    .form-control-position {\n      svg {\n        padding: 0.2rem 0.5rem;\n        border-right: 1px solid darken($body-bg, 12%);\n        height: 25px;\n        width: 30px;\n      }\n    }\n  }\n  &.input-divider-right {\n    .form-control-position {\n      svg {\n        padding: 0.2rem 0.5rem;\n        border-left: 1px solid darken($body-bg, 12%);\n        height: 25px;\n        width: 30px;\n      }\n    }\n  }\n}\n\n/* input-groups-lg and input-groups-sm  */\n\n.input-group-lg,\n.input-group-sm {\n  .form-control {\n    padding: 0.7rem;\n  }\n}\n\n/***** React Numeric Input *****/\n// .react-numeric-input {\n//   input {\n//     background-color: $body-bg;\n//     padding: 0 !important;\n//     border: none !important;\n//     // width: 100px;\n//     height: 26px;\n//     font-size: 1rem !important;\n//     font-weight: 400;\n//     &:focus {\n//       outline: 0;\n//     }\n//   }\n//   b {\n//     width: 22px;\n//     height: 22px;\n//     border-radius: 5px !important;\n//     bottom: auto !important;\n//     background-color: $primary !important;\n//     cursor: pointer !important;\n//     i {\n//       background: $white !important;\n//     }\n//   }\n// }\n\n/* Number Type Input Box Scss for - Remove arrow on hover */\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  // appearance: none;\n  // margin: 0;\n}\n\n// Date & Time Picker - Form Control Bg color\n.picker__input {\n  &.form-control {\n    background-color: $white;\n  }\n}\n\n// input Groups specific SCSS\n.input-group {\n  .form-control {\n    height: auto;\n  }\n  .input-group-prepend,\n  .input-group-append {\n    // dropdown arrow position\n    .dropdown-toggle {\n      &::after {\n        left: 0;\n      }\n    }\n    // checkbox and radio margin\n    .vx-checkbox-con,\n    .vx-checkbox,\n    .vx-radio-con,\n    .vx-radio {\n      margin: 0;\n    }\n  }\n  &.input-group-lg {\n    .form-control {\n      &::placeholder {\n        font-size: 1.25rem;\n      }\n    }\n    .input-group-prepend,\n    .input-group-append {\n      .btn {\n        line-height: 1.3;\n        font-size: 1.3rem;\n      }\n    }\n  }\n  &.input-group-sm {\n    .form-control {\n      &::placeholder {\n        font-size: 0.7rem;\n      }\n    }\n  }\n}\n\n// Input Group\n\n.input-group {\n  .input-group-append {\n    .react-ripples {\n      .btn {\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n      }\n    }\n  }\n  .input-group-prepend {\n    .react-ripples {\n      .btn {\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n      }\n    }\n  }\n}\n","// var for boxshadow of gradient buttons\n// Buttons\n.btn {\n  // to change cursor of disabled button\n  &:disabled {\n    cursor: default;\n  }\n  // for white button\n  &.btn-white {\n    color: $body-color;\n    &:hover,\n    &:focus,\n    &:active {\n      color: $body-color !important;\n    }\n  }\n\n  // box shadow for gradient colors\n  &[class*=\"bg-gradient-\"] {\n    color: $white;\n    &:hover {\n      box-shadow: $gradient-button-bs;\n    }\n  }\n\n  // For Boxshadow on hover of normal light, dark and secondary btn\n  &.btn-secondary {\n    color: $white;\n    &:hover {\n      box-shadow: 0 8px 25px -8px rgba($secondary, 1);\n    }\n  }\n  &.btn-dark {\n    &:hover {\n      box-shadow: 0 8px 25px -8px rgba($dark, 1);\n    }\n  }\n  &.btn-light {\n    &:hover {\n      box-shadow: 0 8px 25px -8px rgba($light, 1);\n    }\n  }\n\n  // For Light,dark and secondary outline btns\n  &.btn-outline-secondary,\n  &.btn-outline-dark,\n  &.btn-outline-light {\n    border: 1px solid;\n  }\n\n  // Flat Secondary, Light and Dark\n  &.btn-flat-secondary {\n    &:hover {\n      background-color: rgba($secondary, 0.1);\n    }\n    &:active,\n    &:focus {\n      background: $secondary;\n    }\n  }\n\n  &.btn-flat-dark {\n    &:hover {\n      background-color: rgba($dark, 0.1);\n    }\n    &:active,\n    &:focus {\n      background: $dark;\n      color: $white;\n    }\n  }\n\n  &.btn-flat-light {\n    &:hover {\n      background-color: rgba($light, 0.1);\n    }\n    &:active,\n    &:focus {\n      background: $light;\n    }\n  }\n\n  // to remove extra spacing because of border in btn outline\n  &[class*=\"btn-outline-\"] {\n    padding-top: calc(#{$btn-padding-y} - 1px);\n    padding-bottom: calc(#{$btn-padding-y} - 1px);\n    &.btn-lg {\n      padding-top: calc(#{$btn-padding-y-lg} - 1px);\n      padding-bottom: calc(#{$btn-padding-y-lg} - 1px);\n    }\n    &.btn-sm {\n      padding-top: calc(#{$btn-padding-y-sm} - 1px);\n      padding-bottom: calc(#{$btn-padding-y-sm} - 1px);\n    }\n  }\n\n  // Relief Buttons Secondary, Light and Dark\n  &.btn-relief-secondary {\n    background-color: $secondary;\n    box-shadow: inset 0 -3px 0 0 rgba($pure-black, 0.2);\n    color: $white;\n\n    &:hover {\n      color: $white;\n    }\n\n    &:active,\n    &:focus {\n      outline: none;\n      transform: translateY(3px);\n    }\n  }\n  &.btn-relief-light {\n    background-color: $light;\n    box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.2);\n    color: $white;\n\n    &:hover {\n      color: $white;\n    }\n\n    &:active,\n    &:focus {\n      outline: none;\n      transform: translateY(3px);\n    }\n  }\n  &.btn-relief-dark {\n    background-color: $dark;\n    box-shadow: inset 0 -3px 0 0 rgba(255, 255, 255, 0.1);\n    color: $white;\n\n    &:hover {\n      color: $white;\n    }\n\n    &:active,\n    &:focus {\n      outline: none;\n      transform: translateY(3px);\n    }\n  }\n\n  // For btn-icon\n  &.btn-icon {\n    padding: 0.715rem 0.736rem;\n  }\n  &.btn-sm {\n    &.btn-icon {\n      padding: 0.5rem;\n      \n    }\n  }\n  &.btn-lg {\n    &.btn-icon {\n      padding: 1rem;\n    }\n  }\n\n  // Remove focus/active focus outline\n  &.btn-square {\n    @include button-square-variant(0);\n  }\n\n  &.btn-round {\n    @include button-round-variant(2rem);\n  }\n\n  &:focus,\n  &.focus,\n  &:active,\n  &.active {\n    outline: none;\n    box-shadow: none !important;\n  }\n  &.btn-icon {\n    svg {\n      height: 1.1rem;\n      width: 1.1rem;\n    }\n  }\n}\n// Button Group\n.btn-group {\n  .react-ripples:not(:last-child) {\n    .btn {\n      border-top-right-radius: 0 !important;\n      border-bottom-right-radius: 0 !important;\n    }\n  }\n  .react-ripples:not(:first-child) {\n    .btn {\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0;\n    }\n  }\n}\n\n.btn-group-vertical {\n  .react-ripples:not(:last-child) {\n    .btn {\n      border-bottom-right-radius: 0 !important;\n      border-bottom-left-radius: 0 !important;\n    }\n  }\n  .react-ripples:not(:first-child) {\n    .btn {\n      border-top-left-radius: 0;\n      border-top-right-radius: 0;\n    }\n  }\n}\n// For White Btn // commented because of tour btns\n// .btn.btn-outline-white,\n// .btn-white {\n//   &:hover {\n//     color: $black !important;\n//   }\n// }\n\n// Added cursor pointer as in latest bootstrap do not have this\nbutton,\nhtml [type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  cursor: pointer;\n}\n\n// For Waves Padding\n.waves-button-input {\n  padding: unset;\n}\n",".collapse-icon {\n  .card-header {\n    position: relative;\n  }\n\n  .card-header {\n    &:after {\n      position: absolute;\n      top: 48%;\n      right: 20px;\n      margin-top: -8px;\n      font-family: \"feather\";\n      content: \"\\e845\";\n      transition: all 300ms linear 0s;\n      font-size: 0.9rem;\n    }\n\n    &:before {\n      position: absolute;\n      top: 48%;\n      right: 20px;\n      margin-top: -8px;\n      font-family: \"feather\";\n      content: \"\\e842\";\n      transition: all 300ms linear 0s;\n      font-size: 0.9rem;\n    }\n  }\n\n  &.left {\n    a {\n      padding-left: 28px;\n\n      &:before,\n      &:after {\n        left: 20px;\n        right: auto;\n      }\n    }\n  }\n\n  // .card-header {\n  //   &:before {\n  //     opacity: 0;\n  //   }\n  // }\n\n  // .card-header {\n  //   &:after {\n  //     opacity: 0;\n  //   }\n  // }\n\n  &.accordion-icon-rotate {\n    .collapse.show {\n      &:before {\n        transform: rotate(180deg);\n      }\n    }\n\n    .collapse:not(.show) {\n      &:after {\n        transform: rotate(-180deg);\n      }\n    }\n  }\n}\n","// The dropdown menu\n.dropdown {\n  // split warning dropdown toggle\n  &.show {\n    .btn-outline-warning,\n    .btn-outline-light {\n      &.dropdown-toggle {\n        color: $white;\n      }\n    }\n  }\n  .btn:not(.btn-sm):not(.btn-lg),\n  .btn:not(.btn-sm):not(.btn-lg).dropdown-toggle {\n    padding: $dropdown-btn-padding-y $dropdown-btn-padding-x;\n    &.btn-round {\n      @include button-round-variant(2rem);\n    }\n  }\n\n  .btn.dropdown-toggle.dropdown-toggle-split {\n    padding: $dropdown-btn-padding-y $dropdown-btn-split-padding-x;\n    border-left-color: rgba($white, 0.2) !important;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  [class*=\"btn-outline-\"].dropdown-toggle.dropdown-toggle-split {\n    border-left: 0 !important;\n\n    &:active {\n      color: $white;\n    }\n  }\n\n  // dropdown menu\n  .dropdown-menu {\n    border: 1px solid rgba($pure-black, 0.05); // border opacity has been reduced to make it look same as vue's dropdown border [component page, list view page]\n    border-radius: $dropdown-border-radius;\n    transform: scale(1, 0);\n    box-shadow: 0 5px 25px rgba($pure-black, 0.1); // this according to vue version\n    // left: 5px;  // it creates issue in navbar - notification dropdown\n    min-width: 8rem;\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: -1px;\n      left: 1.2rem;\n      width: 0.75rem;\n      height: 0.75rem;\n      display: block;\n      background: $white;\n      transform: rotate(45deg) translate(-7px);\n      border-top: 1px solid rgba($pure-black, 0.1);\n      border-left: 1px solid rgba($pure-black, 0.1);\n      z-index: 10;\n      box-sizing: border-box;\n    }\n\n    &.dropdown-menu-right {\n      &::before {\n        right: 0.6rem;\n        left: auto;\n      }\n    }\n\n    .dropdown-header {\n      padding: 0.714rem 1.428rem;\n      margin-top: 0.714rem;\n    }\n\n    .dropdown-item {\n      padding: 0.5rem 1rem;\n      color: $body-color;\n      width: auto;\n      cursor: pointer;\n      &:hover {\n        background-color: $body-bg;\n        color: $primary;\n        svg,\n        span {\n          color: $primary;\n        }\n      }\n      &.active {\n        color: $white;\n      }\n\n      &:active {\n        background-color: transparent;\n        color: $dropdown-color;\n      }\n\n      &.disabled {\n        color: $secondary;\n      }\n    }\n  }\n\n  // If don't won't dropdown/up arrow\n  &.no-arrow {\n    .dropdown-toggle {\n      &:after {\n        display: none;\n      }\n    }\n  }\n}\n// same padding for diffrent directions\n.dropdown,\n.dropup,\n.dropright,\n.dropleft {\n  position: relative;\n  .dropdown-menu {\n    .dropdown-item {\n      padding: 0.714rem 1.428rem;\n    }\n  }\n  .dropdown-toggle {\n    &:after,\n    &:before {\n      display: none;\n    }\n  }\n}\n.show {\n  > .dropdown-menu {\n    transform: scale(1, 1);\n    opacity: 1;\n    display: block;\n  }\n}\n\n.dropdown-toggle {\n  // changed icon caret\n\n  &::after {\n    // border: none !important;\n    // font-family: \"feather\";\n    // content: \"\\e842\" !important;\n    // position: relative;\n    // top: 1px;\n    // right: 0px;\n    // left: 0.714rem;\n    // padding: 0;\n    // // left: 1.4rem;\n    // margin: 0;\n    // vertical-align: 0;\n    display: none;\n  }\n  svg {\n    position: relative;\n    left: 10px;\n  }\n  &.dropdown-toggle-split {\n    border-left: 1px solid rgba($white, 0.2);\n    svg {\n      left: 0;\n    }\n  }\n\n  // hide default arrow to show custom icon DD\n  &.nav-hide-arrow {\n    &::after {\n      display: none;\n    }\n  }\n\n  // Prevent the focus on the dropdown toggle when closing dropdowns\n  &:focus {\n    outline: 0;\n  }\n}\n\n// Horizontal layout navigation menu dropdown arrow\n.navbar-horizontal {\n  .dropdown-submenu {\n    .dropdown-toggle::after {\n      top: -9px !important;\n      margin-top: 1.25rem;\n      right: 1px;\n    }\n  }\n}\n\n// Add extra class to `.dropdown-menu` to flip the alignment of the dropdown menu with the parent.\n/* .dropdown-menu-right {\n  left: auto !important; // Input group with dropdown issue for dropdown-menu-right\n  right: 0;\n} */\n\n// Color theme active & hover\n.btn-secondary ~ .dropdown-menu {\n  .dropdown-item {\n    &.active,\n    &:hover {\n      background-color: darken($white, 20%);\n    }\n  }\n}\n\n// DropUp\n.dropup {\n  position: relative;\n  .btn,\n  .btn.dropdown-toggle {\n    padding: $dropdown-btn-padding-y $dropdown-btn-padding-x;\n  }\n  .btn.dropdown-toggle.dropdown-toggle-split {\n    padding: $dropdown-btn-padding-y $dropdown-btn-split-padding-x;\n    border-color: rgba($white, 0.2) !important;\n  }\n  .dropdown-toggle {\n    // changed icon dropup caret\n    &::after {\n      content: \"\\e845\" !important;\n      vertical-align: 0.05rem;\n    }\n  }\n  .dropdown-menu {\n    &::before {\n      content: \"\";\n      position: absolute;\n      bottom: -0.714rem;\n      left: 1.214rem;\n      width: 0.714rem;\n      height: 0.714rem;\n      display: block;\n      background: $white;\n      transform: rotate(45deg) translate(-7px);\n      border-bottom: 1px solid rgba($pure-black, 0.1);\n      border-right: 1px solid rgba($pure-black, 0.1);\n      z-index: 10;\n      box-sizing: border-box;\n    }\n    &.dropdown-menu-right {\n      &::before {\n        left: auto;\n        right: 0.714rem;\n      }\n    }\n  }\n  .dropdown-submenu {\n    .dropdown-menu {\n      bottom: auto;\n      top: 0;\n    }\n  }\n}\n\n// DropLeft\n.dropleft {\n  .btn,\n  .btn.dropdown-toggle {\n    padding: $dropdown-btn-padding-y $dropdown-btn-padding-x;\n  }\n  .btn.dropdown-toggle.dropdown-toggle-split {\n    padding: $dropdown-btn-padding-y $dropdown-btn-split-padding-x;\n  }\n  .dropdown-toggle {\n    // changed icon dropup caret\n    // &::before {\n    //   border: none !important;\n    //   font-family: \"feather\";\n    //   content: \"\\e843\" !important;\n    // }\n    svg {\n      left: -10px;\n    }\n  }\n  .dropdown-menu {\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 1.285rem;\n      right: 0;\n      width: 0.714rem;\n      height: 0.714rem;\n      display: block;\n      background: $white;\n      transform: rotate(130deg) translate(-8px);\n      border-top: 1px solid rgba($pure-black, 0.1);\n      border-left: 1px solid rgba($pure-black, 0.1);\n      z-index: 10;\n      box-sizing: border-box;\n    }\n  }\n}\n\n// DropRight\n.dropright {\n  .btn,\n  .btn.dropdown-toggle {\n    padding: $dropdown-btn-padding-y $dropdown-btn-padding-x;\n  }\n  .btn.dropdown-toggle.dropdown-toggle-split {\n    padding: $dropdown-btn-padding-y $dropdown-btn-split-padding-x;\n  }\n  .dropdown-toggle {\n    // changed icon dropup caret\n    &::after {\n      border: none !important;\n      font-family: \"feather\";\n      content: \"\\e844\" !important;\n    }\n  }\n  .dropdown-menu {\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 1.285rem;\n      left: -0.9rem;\n      width: 0.714rem;\n      height: 0.714rem;\n      display: block;\n      background: $white;\n      transform: rotate(140deg) translate(-9px);\n      border-bottom: 1px solid rgba($pure-black, 0.1);\n      border-right: 1px solid rgba($pure-black, 0.1);\n      z-index: 10;\n      box-sizing: border-box;\n    }\n  }\n}\n\n// Dropdown icon\n.dropdown,\n.dropup {\n  &.dropdown-icon {\n    .dropdown-toggle {\n      &:after {\n        display: none;\n      }\n      svg {\n        left: 0;\n      }\n    }\n    .dropdown-menu {\n      min-width: auto;\n      .dropdown-item {\n        padding: 0.5rem 1.1rem;\n        cursor: pointer;\n        &:hover {\n          color: $white;\n        }\n      }\n    }\n  }\n}\n\n// for white button\n.btn.btn-white ~ .dropdown-menu {\n  .dropdown-item:not(.acitve):hover {\n    color: $body-color !important;\n  }\n  .dropdown-item.active {\n    color: $body-color;\n  }\n}\n","/* ===============================================================================================\n    File Name: navbar.scss\n    Description: Contain header navigation bar, vertical main navigation bar and\n    horiznotal main navigation bar related SCSS.\n    ----------------------------------------------------------------------------------------------\n    Item Name: Vuexy React admin Template\n    Version: 1.0\n    Author: PIXINVENT\n    Author URL: http://www.themeforest.net/user/pixinvent\n================================================================================================*/\n\n%extend_hamburger_color {\n  .hamburger-inner,\n  .hamburger-inner::before,\n  .hamburger-inner::after {\n    background-color: $white;\n  }\n}\n\n@function set-navbar-text-color($color) {\n  @if (lightness($color) > 50) {\n    @return $white; // Lighter backgorund, return dark color\n  } @else {\n    @return $black; // Darker background, return light color\n  }\n}\n\n@mixin fullNav {\n  .navbar-header {\n    width: 100% !important;\n    padding: 0.5rem 1rem;\n    position: relative;\n\n    .menu-toggle {\n      top: 2px;\n      position: relative;\n    }\n\n    .open-navbar-container i {\n      font-size: 1.8rem;\n    }\n\n    .navbar-brand {\n      position: absolute;\n      left: 50%;\n      top: 0;\n      transform: translate(-50%, 0);\n    }\n  }\n\n  &.navbar-with-menu {\n    .navbar-container {\n      width: 100%;\n      display: table;\n      margin: 0;\n      height: auto;\n    }\n  }\n}\n\n.header-navbar-shadow {\n  display: block;\n  background: linear-gradient(\n    180deg,\n    hsla(0, 0%, 97.3%, 0.95) 44%,\n    hsla(0, 0%, 97.3%, 0.46) 73%,\n    hsla(0, 0%, 100%, 0)\n  );\n  padding-top: 2.2rem;\n  background-repeat: repeat;\n  width: 100%;\n  height: 102px;\n  position: fixed;\n  top: 0;\n  z-index: 11;\n}\n\n.header-navbar {\n  padding: 0px;\n  min-height: $navbar-height - 0.5;\n  font-family: $font-family-monospace;\n  transition: 300ms ease all;\n  background: linear-gradient(\n    180deg,\n    hsla(0, 0%, 97.3%, 0.95) 44%,\n    hsla(0, 0%, 97.3%, 0.46) 73%,\n    hsla(0, 0%, 100%, 0)\n  );\n  z-index: 1000;\n  &.fixed-top {\n    left: $menu-expanded-width;\n  }\n\n  &[class*=\"bg-\"] {\n    .navbar-nav {\n      .nav-item {\n        a {\n          color: set-navbar-text-color($theme-dark-text-color) !important;\n          &.dropdown-item {\n            span,\n            svg {\n              color: $body-color !important;\n            }\n            &:hover {\n              span,\n              svg {\n                color: $white !important;\n              }\n            }\n          }\n        }\n        svg,\n        span {\n          color: set-navbar-text-color($theme-dark-text-color) !important;\n        }\n      }\n    }\n  }\n\n  &.floating-nav {\n    margin: 1.3rem #{$content-padding} 0;\n    border-radius: 0.5rem;\n    position: fixed;\n    width: calc(100% - calc(#{$content-padding} * 2) - #{$menu-expanded-width});\n    z-index: 11;\n    right: 0;\n  }\n\n  &.navbar-static-top {\n    background: transparent;\n    box-shadow: none !important; // remove this if removing \"menu-shadow\" class\n  }\n\n  .navbar-wrapper {\n    width: 100%;\n  }\n\n  // add border to navbar\n  &.navbar-border {\n    border-bottom: 1px solid $custom-border-color;\n  }\n\n  &.navbar-dark.navbar-border {\n    border-bottom: 1px solid #8596b5;\n  }\n\n  // add shadow to navbar\n  &.navbar-shadow {\n    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);\n  }\n\n  // hide top horizontal menu drop-down arrow\n  .nav-link {\n    &.dropdown-toggle::after {\n      display: none;\n    }\n  }\n\n  .navbar-container ul.nav li.dropdown-language {\n    padding-right: 0;\n    .country-flag{\n      width: 1.5rem !important;\n    }\n    .selected-language {\n      font-size: 0.97rem;\n      letter-spacing: -0.25px;\n      font-weight: 500;\n    }\n  }\n\n  .navbar-container {\n    padding-left: $spacer;\n    // height: $navbar-height;\n    transition: 300ms ease all;\n    background: inherit;\n    margin-left: 0;\n    ul.navbar-nav {\n      li {\n        line-height: .5;\n        > .nav-link {\n          padding: 1.4rem 0.5rem 1.35rem;\n          svg {\n            &:hover {\n              color: $primary;\n            }\n          }\n        }\n        &.dropdown-notification{\n          .dropdown-menu:focus{\n            outline: none;\n          }\n        }\n      }\n      &.navbar-nav-user{\n        li:not(:last-child) > .nav-link{\n          margin-right: .5rem;\n        }\n      }\n    }\n\n    // for bookmark z-index\n    .bookmark-input {\n      z-index: 1;\n    }\n\n    ul.nav {\n      li {\n        &.dropdown .dropdown-menu {\n          top: 48px;\n          // top: 90%;\n          margin-top: -4px;\n        }\n\n        .badge {\n          padding: 0.42em 0.6em 0.25rem;\n\n          &.badge-up {\n            position: absolute;\n            top: 12px;\n            right: -7px;\n          }\n        }\n\n        &.dropdown-language {\n          > a.nav-link {\n            padding: 1.75rem 0.5rem;\n          }\n          .dropdown-menu {\n            min-width: 12rem;\n          }\n        }\n\n        > .nav-link {\n          color: $body-color;\n          padding: 1.4rem 0.5rem 1.35rem;\n\n          i.flag-icon {\n            margin-right: 0.5rem;\n          }\n        }\n\n        &.dropdown-user {\n          .dropdown-menu-right {\n            right: 26px;\n            left: -12px !important;\n            padding: 0.5rem;\n\n            .dropdown-item {\n              padding: 10px;\n\n              &:hover,\n              &:active {\n                background: $primary;\n                span,\n                svg {\n                  color: $white;\n                }\n              }\n            }\n          }\n        }\n\n        a.dropdown-user-link {\n          padding: 0.7rem 1rem;\n          display: flex;\n          align-items: center;\n\n          .user-name {\n            display: inline-block;\n            margin-bottom: 0.435rem;\n            margin-left: 0.2rem;\n            line-height: 1;\n          }\n\n          .user-status {\n            font-size: smaller;\n          }\n          img {\n            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12),\n              0 2px 4px 0 rgba(0, 0, 0, 0.08);\n          }\n        }\n\n        a.menu-toggle {\n          // padding: 1.1rem 0.8rem 1rem 1rem;\n          padding: 1.34rem 0.22rem 1.35rem 0;\n\n          i {\n            font-size: 1.75rem;\n          }\n        }\n\n        a.nav-link-label {\n          padding: 1.6rem 0.2rem 1.35rem 0.8rem;\n        }\n\n        a.dropdown-user-link {\n          .user-nav {\n            display: flex;\n            flex-direction: column;\n            align-items: flex-end;\n            float: left;\n            margin-right: $spacer - 0.2;\n          }\n        }\n\n        a.nav-link-search,\n        a.nav-link-expand {\n          // padding: 1.4rem 1rem 1.3rem 1rem;\n        }\n\n        div.input-group {\n          padding: 0.7rem 1rem;\n        }\n\n        i.ficon {\n          font-size: 1.5rem;\n          color: $body-color;\n          &:hover {\n            color: $primary;\n          }\n        }\n\n        .media-list {\n          max-height: 24rem;\n          line-height: 1;\n        }\n\n        .scrollable-container {\n          position: relative;\n        }\n      }\n    }\n\n    //Navbar notification css\n    .dropdown-menu-media {\n      width: 26rem;\n      left: 10px !important;\n      // overflow: hidden;\n      .media-list {\n        cursor: pointer;\n        .media {\n          padding: 1rem;\n          border: none;\n          border-bottom: 1px solid $gray-300;\n\n          &:hover {\n            background: $body-bg;\n          }\n\n          .media-meta {\n            color: $body-color;\n          }\n        }\n        a:last-of-type {\n          .media {\n            border-bottom: none;\n          }\n        }\n      }\n\n      .dropdown-menu-header {\n        border-bottom: 1px solid $gray-300;\n        padding: 1.25rem;\n        .dropdown-header {\n          padding: 0;\n        }\n      }\n\n      .dropdown-menu-footer {\n        a {\n          padding: 0.3rem;\n          border-top: 1px solid $gray-300;\n        }\n      }\n      &.dropdown-cart {\n        left: 5px !important;\n        &.empty-cart {\n          &:before {\n            background: $white;\n            border-color: rgba($color: $pure-black, $alpha: 0.1);\n          }\n        }\n        .media-left {\n          width: 100px;\n        }\n      }\n    }\n  }\n\n  &.navbar-without-menu {\n    .navbar-container {\n      margin-left: 0;\n    }\n  }\n\n  &.navbar-with-menu {\n    .navbar-container {\n    }\n  }\n\n  .nav-item + .nav-item {\n    margin-left: 0rem;\n  }\n\n  /* For sm screen*/\n  @include media-breakpoint-down(sm) {\n    @include fullNav;\n  }\n}\n\n/* Modern menu For md screen*/\n@include media-breakpoint-down(md) {\n  [data-menu=\"vertical-menu-modern\"] {\n    .header-navbar {\n      @include fullNav;\n    }\n\n    .navbar-dark,\n    .navbar-semi-dark {\n      .navbar-header .navbar-nav .nav-link {\n        color: $white;\n      }\n\n      .navbar-container .navbar-nav .nav-link {\n        color: $gray-600;\n      }\n    }\n\n    // .navbar-light {\n    //   .navbar-header .navbar-nav .nav-link {\n    //     color: $gray-600;\n    //   }\n    // }\n  }\n}\n\n// Navbar colors\n\n.navbar-light {\n  background: $white;\n\n  &.navbar-horizontal {\n    background: $white;\n  }\n\n  .navbar-nav {\n    li {\n      line-height: 1;\n    }\n\n    .active {\n      &.nav-link {\n        background-color: rgba(0, 0, 0, 0.03);\n      }\n    }\n\n    .disabled {\n      &.nav-link {\n        color: $nav-link-disabled-color;\n      }\n    }\n  }\n}\n\n.navbar-dark {\n  background: $gray-600;\n\n  .navbar-brand {\n    color: $white !important;\n  }\n\n  &.navbar-horizontal {\n    background: $gray-600;\n  }\n\n  @extend %extend_hamburger_color;\n\n  .nav-search {\n    .form-control,\n    .btn-secondary {\n      color: $white;\n      background: $gray-600;\n    }\n  }\n\n  .navbar-nav {\n    li {\n      line-height: 1;\n    }\n\n    .active {\n      &.nav-link {\n        background-color: rgba(255, 255, 255, 0.05);\n      }\n    }\n\n    .disabled {\n      &.nav-link {\n        color: $gray-300;\n      }\n    }\n  }\n}\n\n.navbar-semi-dark {\n  .navbar-header {\n    background: $gray-600;\n\n    .brand-text {\n      color: $white;\n    }\n  }\n\n  background: $white;\n\n  .navbar-nav {\n    li {\n      line-height: 1;\n    }\n\n    .nav-link {\n      color: $gray-600;\n    }\n\n    .active {\n      &.nav-link {\n        background-color: rgba(0, 0, 0, 0.03);\n      }\n    }\n\n    .disabled {\n      &.nav-link {\n        color: $nav-link-disabled-color;\n      }\n    }\n  }\n}\n\n.navbar-semi-light {\n  .navbar-header {\n    background: $white;\n\n    .brand-text {\n      color: $gray-600;\n    }\n  }\n\n  background: $gray-600;\n\n  .navbar-nav {\n    li {\n      line-height: 1;\n    }\n\n    .nav-link {\n      color: $white;\n    }\n\n    .active {\n      &.nav-link {\n        background-color: rgba(0, 0, 0, 0.03);\n      }\n    }\n\n    .disabled {\n      &.nav-link {\n        color: $nav-link-disabled-color;\n      }\n    }\n  }\n}\n\n@-moz-document url-prefix() {\n  ul {\n    li {\n      a {\n        .children-in {\n          position: relative;\n          right: 3px;\n          top: -14px;\n        }\n      }\n    }\n  }\n}\n\n.navbar-menu-icon {\n  span {\n    display: block;\n    position: absolute;\n    height: 2px;\n    width: 100%;\n    background: $gray-600;\n    border-radius: 9px;\n    opacity: 1;\n    left: 0;\n    transform: rotate(0deg);\n    transition: 0.25s ease-in-out;\n  }\n}\n\n.navbar-menu-icon span:nth-child(1) {\n  top: 0px;\n}\n\n.navbar-menu-icon span:nth-child(2) {\n  top: 10px;\n}\n\n.navbar-menu-icon span:nth-child(3) {\n  top: 20px;\n}\n\n.navbar-menu-icon.show span:nth-child(1) {\n  top: 10px;\n  transform: rotate(135deg);\n}\n\n.navbar-menu-icon.show span:nth-child(2) {\n  opacity: 0;\n  left: -60px;\n}\n\n.navbar-menu-icon.show span:nth-child(3) {\n  top: 10px;\n  transform: rotate(-135deg);\n}\n\n// Media queries for device support\n// =========================================\n@include media-breakpoint-down(sm) {\n  .header-navbar {\n    // generic navbar dropdown specific\n    .navbar-nav {\n      .show {\n        position: static;\n      }\n\n      .open-navbar-container {\n        padding-top: 0.625rem;\n      }\n    }\n\n    .navbar-container {\n      .show {\n        .dropdown-menu {\n          right: 0;\n          left: 0 !important;\n          float: none;\n          width: auto;\n          margin-top: 0;\n          overflow: hidden;\n        }\n      }\n\n      ul.nav {\n        li {\n          &.nav-item i {\n            margin-right: 0.2rem;\n          }\n\n          a.dropdown-user-link {\n            padding: 0.8rem 0.6rem;\n          }\n\n          .dropdown-toggle::after {\n            margin-right: 0;\n            margin-left: -2px;\n          }\n        }\n      }\n    }\n  }\n\n  // dark navbar\n  .navbar-dark,\n  .navbar-semi-dark {\n    .hamburger-inner,\n    .hamburger-inner::before,\n    .hamburger-inner::after {\n      background-color: $white;\n    }\n\n    .navbar-header {\n      .navbar-nav {\n        .nav-link {\n          color: $white;\n        }\n      }\n    }\n\n    .navbar-container {\n      .navbar-nav {\n        .nav-link {\n          color: $gray-600;\n        }\n      }\n    }\n  }\n\n  // light navbar\n  .navbar-light,\n  .navbar-semi-light {\n    .navbar-header {\n      .navbar-nav {\n        .nav-link {\n          // color: $gray-600;\n        }\n      }\n    }\n\n    .navbar-container {\n      .navbar-nav {\n        .nav-link {\n          // color: $gray-600;\n        }\n      }\n    }\n  }\n\n  .header-navbar {\n    .navbar-container {\n      .dropdown-notification,\n      .dropdown-language {\n        .dropdown-menu {\n          right: 0 !important;\n          left: 31px !important;\n        }\n      }\n    }\n  }\n}\n\n.headroom {\n  will-change: transform;\n  transition: transform 200ms linear;\n}\n\n.headroom--pinned-top {\n  transform: translateY(0%);\n}\n\n.headroom--unpinned-top {\n  transform: translateY(-100%);\n}\n\n.headroom--pinned-bottom {\n  transform: translateY(0%);\n}\n\n.headroom--unpinned-bottom {\n  transform: translateY(100%);\n}\n\n@include media-breakpoint-down(xs) {\n  .header-navbar {\n    .navbar-container ul.nav li .selected-language {\n      display: none;\n    }\n  }\n}\n\n// header navbar when floating nav\nbody {\n  &[data-col=\"1-column\"] {\n    .header-navbar {\n      &.floating-nav {\n        width: calc(100% - calc(#{$content-padding} * 2));\n      }\n    }\n  }\n}\n\n// header navbar when floating nav\n@media (min-width: 1200px) and (-ms-high-contrast: active),\n  (-ms-high-contrast: none) {\n  body {\n    &:not([data-col=\"1-columns\"]) {\n      .header-navbar {\n        &.floating-nav {\n          width: calc(100% - 60px - #{$menu-expanded-width});\n        }\n      }\n    }\n  }\n}\n\n// For Medium and down: iPad support for navbr\n\n@include media-breakpoint-down(lg) {\n  .header-navbar {\n    .navbar-container {\n      ul.nav {\n        li {\n          &.dropdown-language {\n            > a.nav-link {\n              padding: 1.75rem 0.5rem;\n            }\n          }\n\n          a.dropdown-user-link {\n            padding: 0.7rem 1.23rem;\n          }\n\n          .dropdown-toggle::after {\n            margin-right: 0;\n            margin-left: -2px;\n          }\n        }\n      }\n    }\n  }\n}\n\n@mixin extend_mobile_specific($menu_height) {\n  .header-navbar {\n    .navbar-container {\n      .show {\n        .dropdown-menu {\n          max-height: $menu_height;\n        }\n      }\n    }\n  }\n}\n\n@mixin responsive_sub_nav {\n  //For responsive sub nav\n  #navbar-mobile.navbar-collapse {\n    .navbar-nav {\n      margin: 0;\n      flex-flow: row wrap;\n\n      .dropdown-menu {\n        position: absolute;\n      }\n\n      .nav-item {\n        float: left;\n      }\n    }\n  }\n}\n\n@media (max-width: 767px) {\n  @include responsive_sub_nav;\n}\n\n@include media-breakpoint-down(md) {\n  @include responsive_sub_nav;\n}\n\n/* ----------- iPhone 5, 5S  iPhone 6----------- */\n\n/* Landscape */\n\n@media only screen and (min-device-width: 26.78em) and (max-device-width: 47.64em) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {\n  @include extend_mobile_specific(180px);\n}\n\n/* ----------- iPhone 6+ ----------- */\n\n/* Landscape */\n\n@media only screen and (min-device-width: 29.57em) and (max-device-width: 52.57em) and (-webkit-min-device-pixel-ratio: 3) and (orientation: landscape) {\n  @include extend_mobile_specific(280px);\n}\n\n/*----------------------------- For Navbar Component -------------------------*/\n\n#navbar-component {\n  .navbar {\n    position: relative;\n    width: auto;\n    &.floating-nav {\n      border-radius: 0.5rem;\n    }\n    z-index: auto;\n    // navbar dark color\n\n    &.header-navbar.navbar-dark {\n      .navbar-nav {\n        .nav-link {\n          color: $white;\n        }\n      }\n    }\n\n    .navbar-nav {\n      .dropdown-language,\n      .dropdown-notification,\n      .dropdown-user {\n        &.show {\n          position: relative;\n        }\n        .dropdown-menu {\n          &.show {\n            position: absolute;\n            right: 0;\n            // left: auto !important;\n          }\n        }\n      }\n    }\n\n    // for font size of navbar toggler\n\n    &.navbar-dark,\n    &.navbar-light {\n      .navbar-toggler {\n        font-size: 1.2rem;\n        &:focus {\n          outline: 0;\n        }\n      }\n    }\n  }\n\n  // to remove border radius for collapsed navbar\n\n  #navbar-collapsed {\n    .navbar {\n      border-radius: 0;\n    }\n  }\n}\n\n// for alignment of language dropdown and name\n@media (min-width: 992px) {\n  #navbar-component {\n    .navbar {\n      .navbar-container {\n        background: inherit;\n      }\n    }\n    .nav {\n      .dropdown-language {\n        float: right;\n      }\n    }\n  }\n}\n\n// background color\n\n@media (max-width: 992px) {\n  #navbar-component {\n    .navbar {\n      .navbar-container {\n        background: inherit;\n        .navbar-nav {\n          flex-direction: row;\n        }\n      }\n    }\n  }\n}\n// for width of navbar in fixed-top\n@media (max-width: 1200px) {\n  .header-navbar {\n    &.fixed-top {\n      left: 0;\n    }\n  }\n}\n\n// for notification dropdown of navbar component page\n@media (max-width: 768px) {\n  #navbar-component {\n    .navbar {\n      .navbar-nav {\n        .dropdown-notification {\n          &.show {\n            position: static;\n          }\n        }\n      }\n    }\n  }\n}\n\n@include media-breakpoint-down(xs) {\n  .header-navbar.floating-nav {\n    width: calc(100% - 2.4rem) !important;\n    margin-left: 1.2rem;\n    margin-right: 1.2rem;\n  }\n  .content.app-content .content-area-wrapper {\n    margin-left: 1.2rem !important;\n    margin-right: 1.2rem !important;\n  }\n}\n\n// 1-column Layout - Back Link in Center\n@media (max-width: 992px) {\n  .navbar-container {\n    #navbar-mobile {\n      .nav-back {\n        margin-top: 5px;\n      }\n    }\n  }\n}\n",".card-group,\n.card-deck {\n  margin-bottom: 0.75rem;\n}\n.card {\n  // box-shadow: 0px 2px 1px rgba(0, 0, 0, 0.05);\n  margin-bottom: $spacer * 2.2;\n  border: none;\n  border-radius: $border-radius;\n  box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease-in-out;\n  .card {\n    box-shadow: none !important;\n  }\n  .card-subtitle {\n    margin-top: 0.5rem;\n  }\n  .card-title {\n    font-weight: 500;\n    letter-spacing: 0.05rem;\n    font-size: 1.32rem;\n    margin-bottom: $card-spacer-y / 3;\n    color: $headings-color;\n  }\n  .card-bordered {\n    border: $card-border-width solid $card-border-color;\n  }\n\n  .card-img-overlay {\n    border-radius: $card-border-radius;\n  }\n\n  //fullscreen card\n  &.card-fullscreen {\n    display: block;\n    z-index: 9999;\n    position: fixed;\n    width: 100% !important;\n    height: 100% !important;\n    top: 0;\n    right: 0;\n    left: 0;\n    bottom: 0;\n    overflow: auto;\n  }\n  .card-body[class*=\"border-bottom-\"] {\n    border-bottom-width: 2px !important;\n  }\n  .card-img-overlay {\n    &.bg-overlay {\n      background: rgba(0, 0, 0, 0.45);\n    }\n    .text-muted {\n      color: $gray-800 !important;\n    }\n  }\n  &.card-minimal {\n    border: none;\n    box-shadow: none;\n  }\n\n  .card-header {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    border-bottom: none;\n    padding: 1.5rem 1.5rem 0;\n    background-color: transparent;\n    .card-title {\n      margin-bottom: 0;\n    }\n\n    .nav-tabs {\n      margin-bottom: 0;\n    }\n  }\n  .card-body {\n    // padding-top: 1rem;\n  }\n  .card-footer {\n    border-top: 1px solid $gray-300;\n  }\n  &.card-action {\n    .card-header {\n      padding-bottom: 1.5rem;\n      svg {\n        cursor: pointer;\n      }\n    }\n    &.card-collapsed {\n      .card-header {\n        .collapse-icon {\n          transform: rotate(180deg);\n          transition: all 0.5s ease;\n        }\n      }\n    }\n    &.closing {\n      .collapse-icon {\n        transform: rotate(180deg);\n        transition: all 0.5s ease;\n      }\n    }\n    &.opening {\n      .collapse-icon {\n        transform: rotate(0deg);\n        transition: all 0.5s ease;\n      }\n    }\n    &.card-shown {\n      .card-header {\n        .collapse-icon {\n          transform: rotate(0deg);\n          transition: all 0.5s ease;\n        }\n      }\n    }\n    &.card-reload {\n      .reload-spinner {\n        position: absolute;\n        left: 50%;\n        top: 50%;\n        z-index: 1;\n      }\n      &.refreshing {\n        .card-body {\n          opacity: 0.5;\n        }\n      }\n    }\n  }\n}\n// Card Column\n.card-columns {\n  .card {\n    margin-bottom: $spacer * 2.2;\n  }\n}\n\n.text-white {\n  .card-text {\n    color: rgba($white, 1);\n  }\n\n  .card-img-overlay {\n    .text-muted {\n      color: $white !important;\n    }\n  }\n  code {\n    background-color: rgba($white, 1);\n  }\n}\n\n.card-head-inverse {\n  color: $white;\n}\n.card-transparent {\n  background-color: transparent;\n}\n\n// overlay-img-card\n.overlay-img-card {\n  .card-img-overlay,\n  img {\n    max-height: 34.64rem;\n  }\n}\n\n// activity timeline for cards page\n.activity-timeline {\n  // for left time line\n  .timeline-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  &.timeline-left {\n    border-left: 2px solid $gray-300;\n    padding-left: 40px;\n    margin-left: 1.5rem;\n    li {\n      position: relative;\n      margin-bottom: 20px;\n      p {\n        margin-bottom: 0;\n      }\n\n      //icon styles\n      .timeline-icon {\n        position: absolute;\n        top: 0;\n        left: -4.3rem;\n        padding: 0.7rem;\n        border-radius: 50%;\n        color: $white;\n      }\n    }\n  }\n\n  // for right timeline\n  &.timeline-right {\n    border-right: 2px solid $gray-300;\n    padding-right: 40px;\n    margin-right: 1.5rem;\n    li {\n      position: relative;\n      margin-bottom: 20px;\n      text-align: right;\n      p {\n        margin-bottom: 0;\n      }\n      // icon styles\n      .timeline-icon {\n        position: absolute;\n        top: 0;\n        right: -4.3rem;\n        padding: 0.6rem 0.7rem;\n        border-radius: 50%;\n        color: $white;\n      }\n    }\n  }\n}\n",".breadcrumb {\n  font-size: $font-size-base;\n  font-family: $font-family-monospace;\n  background-color: transparent;\n  padding: 0.5rem 0 0.5rem $breadcrumb-padding-x !important;\n  border-radius: 0;\n \n  > li {\n    + li::before {\n      padding-right: 0.6rem;\n      padding-left: 0.6rem;\n    }\n  }\n\n  .breadcrumb-item + .breadcrumb-item {\n    padding-left: 0;\n    &:before {\n      content: \"\\e847\";\n      font-family: \"feather\";\n      color: $body-color;\n    }\n  }\n  .breadcrumb-item.active {\n    color: $body-color;\n  }\n}\n\n/* Custom scss for page headers style */\n.breadcrumbs-right {\n  .breadcrumb {\n    float: right;\n  }\n}\n.breadcrumbs-top {\n  .breadcrumb {\n    margin: 0;\n    padding: 0;\n  }\n}\n\n.vx-breadcrumbs .breadcrumb{\n  border-left: 1px solid lighten($gray-600, 10%) !important;\n}\n\n/* Component Specific */\n\n#component-breadcrumbs {\n  .breadcrumb {\n    border: none;\n    .breadcrumb-item + .breadcrumb-item:before {\n      padding: 0 1rem;\n    }\n  }\n  .breadcrumb-slash {\n    .breadcrumb-item + .breadcrumb-item:before {\n      content: \"/\";\n    }\n  }\n  .breadcrumb-dots {\n    .breadcrumb-item + .breadcrumb-item:before {\n      content: \".\";\n      position: relative;\n      top: -4px;\n    }\n  }\n  .breadcrumb-dashes {\n    .breadcrumb-item + .breadcrumb-item:before {\n      content: \"-\";\n    }\n  }\n  .breadcrumb-pipes {\n    .breadcrumb-item + .breadcrumb-item:before {\n      content: \"|\";\n    }\n  }\n  .breadcrumb-chevron {\n    .breadcrumb-item + .breadcrumb-item:before {\n      content: \"\\e844\";\n      font-family: \"feather\";\n      position: relative;\n      top: 1px;\n    }\n  }\n}\n\n#breadcrumb-alignment {\n  .breadcrumb-wrapper {\n    box-shadow: 1px 1px 10px rgba($pure-black, 0.1);\n    padding: 1px;\n    border-radius: 10px;\n    display: flex;\n    margin-bottom: 1rem;\n    .breadcrumb {\n      margin: 1rem;\n    }\n  }\n}\n","// Badge\n\n.badge {\n  color: $white;\n  font-weight: 400;\n  &[class*=\"badge-\"] {\n    [class*=\"icon-\"] {\n      line-height: 1;\n    }\n\n    a {\n      color: $white;\n    }\n\n    span {\n      vertical-align: middle;\n    }\n\n    svg {\n      & ~ span {\n        margin-left: 0.5rem;\n      }\n    }\n  }\n\n  // square badge\n  &.badge-square {\n    border-radius: 0;\n  }\n\n  // badge-up\n  // to align badge over any element\n  &.badge-up {\n    position: absolute;\n    top: -1rem;\n    right: -1rem;\n    &.badge-sm {\n      top: -0.5rem;\n      right: -0.5rem;\n    }\n  }\n}\n\n// badge sizes\n.badge-xl {\n  font-size: 1.8rem;\n}\n.badge-lg {\n  font-size: 1.2rem;\n}\n.badge-md {\n  font-size: 1rem;\n}\n.badge-sm {\n  font-size: 0.7rem;\n}\n\n// For fullscreen search\n.badge-icon {\n  svg {\n    font-size: 100%;\n    margin-right: 5px;\n  }\n}\n\n// badge dropup pointer\n.dropup {\n  .badge {\n    cursor: pointer;\n  }\n}\n","// Component nav and nav/pill tabs\n\n.nav {\n  border-radius: 0.25rem;\n  // for component navs\n  // to wrap border around nav component\n  &.wrap-border {\n    border: 1px solid $nav-component-border-color;\n    li.nav-header {\n      margin: 0 0.5rem;\n    }\n    li.nav-item,\n    div {\n      padding: 2px 0.714rem;\n    }\n  }\n\n  // Square Border\n  &.square-border {\n    border-radius: 0;\n    .nav-item {\n      .nav-link.active {\n        border-radius: 0;\n      }\n    }\n  }\n\n  // for main menu toggle lock\n  .modern-nav-toggle {\n    padding: 1.571rem 0;\n    cursor: pointer;\n\n    .toggle-icon{\n      margin-right: .425rem;\n    }\n  }\n\n  // nav pills\n  &.nav-pills {\n    margin-bottom: 1rem;\n    // nav item of nav pill\n    .nav-item {\n      .nav-link {\n        border-radius: 0.357rem;\n        padding: 0.2rem 1rem;\n        padding-top: 0.3rem;\n        font-size: 0.98rem;\n        margin-right: 0.5rem;\n        color: $pure-black;\n        &.active {\n          color: $white;\n        }\n        &.disabled {\n          color: $secondary;\n        }\n        &.dropdown-toggle::after {\n          top: 1px;\n          left: 1px;\n        }\n      }\n\n      &.dropdown {\n        &.show {\n          .nav-link {\n            color: $white;\n          }\n          .dropdown-item {\n            &.active {\n              &:hover {\n                color: $primary;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    // Justified Pills\n    &.nav-justified {\n      @include nav-justified;\n      @include nav-tabs-justified;\n      .nav-link {\n        display: block;\n\n        &.active {\n          border: none;\n\n          &:hover,\n          &:focus {\n            border: none;\n          }\n        }\n      }\n    }\n\n    // Nav Active Bordered Pill\n    &.nav-active-bordered-pill {\n      .nav-item {\n        a {\n          &.nav-link {\n            &.active {\n              border: 1px solid $primary;\n              border-radius: 0.25rem;\n              color: $primary;\n              background-color: $white;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // Basic Nav Tabs\n  &.nav-tabs {\n    box-shadow: -1px 11px 17px -10px rgba($pure-black, 0.04);\n    border: none;\n    margin-bottom: 1rem;\n    position: relative;\n    border-radius: 0;\n    // Basic nav item\n    .nav-item {\n      position: relative;\n      .nav-link {\n        color: $pure-black;\n        font-size: 0.95rem;\n        border: none;\n        min-width: auto;\n        font-weight: 450;\n        padding: 0.61rem 0.635rem;\n        border-radius: 0;\n        &.active {\n          border: none;\n          position: relative;\n          color: $primary;\n          transition: all 0.2s ease;\n          background-color: $white;\n          transform: translateY(-2px);\n          &:after {\n            content: attr(data-before);\n            height: 2px;\n            width: 100%;\n            left: 0;\n            position: absolute;\n            bottom: 0;\n            top: 100%;\n            background: linear-gradient(\n              30deg,\n              rgba($primary, 1),\n              rgba($primary, 0.5)\n            ) !important;\n            box-shadow: 0 0 8px 0 rgba($primary, 0.5) !important;\n            transform: translateY(0px);\n            transition: all 0.2s linear;\n          }\n        }\n\n        &.dropdown-toggle {\n          &::after {\n            top: 1px;\n            left: 1px;\n          }\n        }\n\n        &.disabled {\n          color: $secondary;\n        }\n      }\n    }\n    // Justified Tabs\n    &.nav-justified {\n      @include nav-justified;\n      @include nav-tabs-justified;\n\n      .nav-item {\n        a.nav-link {\n          display: block;\n          border-radius: 0;\n\n          &.active {\n            border: none;\n            background-color: $white;\n          }\n          &:hover {\n            border-color: transparent;\n          }\n        }\n      }\n    }\n  }\n}\n\n// Nav Tabs Vertical\n.nav-vertical {\n  overflow: hidden;\n  .nav.nav-tabs {\n    // nav item styles for vertical nav tabs\n    .nav-item {\n      .nav-link {\n        border: none;\n        margin-bottom: 0;\n\n        &.active {\n          border: none;\n          border-radius: 0;\n\n          &:after {\n            transform: rotate(90deg);\n            left: -1rem;\n            bottom: 100%;\n            top: 1rem;\n            width: 2.14rem;\n          }\n        }\n\n        &:hover {\n          border-right: none;\n        }\n      }\n    }\n\n    // vertical nav left tabs\n    &.nav-left {\n      float: left;\n      display: table;\n      margin-right: 1rem;\n\n      ~ .tab-content {\n        .tab-pane {\n          display: none;\n          background-color: $white;\n          overflow-y: auto;\n          padding-left: 1rem;\n          &.active {\n            display: block;\n          }\n        }\n      }\n    }\n\n    // vertical right nav tabs\n    &.nav-right {\n      float: right;\n      display: table;\n      margin-left: 1rem;\n\n      .nav-item {\n        .nav-link {\n          &.active {\n            &:after {\n              left: 2.6rem;\n            }\n          }\n        }\n      }\n\n      ~ .tab-content {\n        .tab-pane {\n          display: none;\n          background-color: $white;\n          overflow-y: auto;\n          padding-right: 1rem;\n          &.active {\n            display: block;\n          }\n        }\n      }\n    }\n  }\n}\n\n","// Justified nav links\n// -------------------------\n\n@mixin nav-justified {\n  width: 100%;\n\n  .nav-item {\n    float: none;\n  }\n\n  .nav-link {\n    text-align: center;\n    margin-bottom: 5px;\n  }\n\n  > .dropdown .dropdown-menu {\n    top: auto;\n    left: auto;\n  }\n\n  @include media-breakpoint-up(sm) {\n    .nav-item {\n      display: block;\n      width: 1%;\n    }\n    .nav-link {\n        margin-bottom: 0;\n    }\n  }\n}\n\n// Move borders to anchors instead of bottom of list\n//\n// Mixin for adding on top the shared `.nav-justified` styles for our tabs\n@mixin nav-tabs-justified {\n\n  .nav-link {\n    // Override margin from .nav-tabs\n    margin-right: 0;\n    border-radius: $border-radius;\n  }\n\n  @include media-breakpoint-up(sm) {\n   .nav-link.active,\n   .nav-link.active:hover,\n   .nav-link.active:focus {\n      border-bottom-color: transparent;//$nav-tabs-justified-active-link-border-color;\n    }\n  }\n}\n","// Alerts\n\n.alert {\n  font-weight: 500;\n  border: none;\n  // close\n\n  .close:focus {\n    outline: 0;\n  }\n\n  // For Alert Content\n  p {\n    font-weight: 500;\n    padding: 2px 0;\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n\n  span {\n    vertical-align: middle;\n  }\n\n  // For alert svg icons\n\n  svg {\n    margin-right: 1rem;\n    vertical-align: middle;\n  }\n\n  // For alert heading\n  .alert-heading {\n    font-weight: 700;\n    font-size: 0.9rem;\n    padding: 0;\n    padding-bottom: 8px;\n    margin-bottom: 0.5rem;\n  }\n\n  // For dismissible alert\n  &.alert-dismissible {\n    .close {\n      opacity: 1;\n      top: -2px;\n    }\n  }\n\n  // For dark alert\n  &.alert-dark {\n    .alert-heading {\n      @include alert-heading-bs($dark);\n    }\n  }\n\n  // For light alert\n  &.alert-light {\n    .alert-heading {\n      @include alert-heading-bs($light);\n    }\n  }\n}\n","// For alert's heading box-shadow\n\n@mixin alert-heading-bs($color) {\n  box-shadow: rgba($color, 0.4) 0px 6px 15px -7px;\n}\n",".media-list{\n\t.media{\n\t\tpadding: 1.25rem;\n\t\twidth: 100%;\n\t\tmargin-top: 0;\n\t\t.media-left{\n\t\t\tpadding-right: 1rem\n\t\t}\n\t\t.media-right{\n\t\t\tpadding-left: 1rem;\n\t\t}\n\t}\n\ta.media{\n\t\tcolor: $gray-600 !important;\n\t}\n}\n\n.media-bordered{\n\t.media{\n\t\tborder-top: 1px solid $custom-border-color;\n\t\t&:first-child{\n\t\t\tborder-top: 0;\n\t\t}\n\t}\n}\n","/*=========================================================================================\n  File Name: progress.scss\n  Description: Extended bootstrap progress bar scss.\n  ----------------------------------------------------------------------------------------\n  Item Name: Vuexy React admin Template\n  Version: 1.0\n  Author: PIXINVENT\n  Author URL: http://www.themeforest.net/user/pixinvent\n  ----------------------------------------------------------------------------------------\n\n  Modifiers:       `progress-lg`\n                   `progress-md`\n                   `progress-sm`\n                   `progress-xs`\n\n==========================================================================================*/\n\n// Size Modifier\n// ========================================================================\n\n.progress {\n  margin-bottom: 3rem;\n\n  // margin for last progress bar\n\n  &:last-child {\n    margin-bottom: 1rem;\n  }\n\n  // progress bar sizes\n\n  &.progress-xl {\n    height: $progress-size-xl;\n  }\n\n  &.progress-lg {\n    height: $progress-size-lg;\n  }\n\n  &.progress-md {\n    height: $progress-size-md;\n  }\n\n  &.progress-sm {\n    height: $progress-size-sm;\n  }\n\n  // progress bar radius\n\n  .progress-bar {\n    border-radius: $progress-border-radius;\n    &.progress-bar-animated {\n      animation: progressBarAnimated 1s linear infinite;\n    }\n  }\n  .progress-bar-striped {\n    background-size: 1rem 1rem;\n  }\n}\n\n[dir=\"rtl\"] {\n  .progress {\n    .progress-bar.progress-bar-animated {\n      animation: progressBarAnimatedRTL 1s linear infinite !important;\n    }\n  }\n}\n\n@keyframes progressBarAnimated {\n  0% {\n    background-position: 1rem 0;\n  }\n\n  100% {\n    background-position: 0 0;\n  }\n}\n/* rtl:ignore */\n@keyframes progressBarAnimatedRTL {\n  0% {\n    background-position: 1rem 0;\n  }\n\n  100% {\n    background-position: 0 100%;\n  }\n}\n","/* ===============================================================================================\n\tFile Name: list-group.scss\n\tDescription: Contain list item, list group related extended SCSS.\n\t----------------------------------------------------------------------------------------------\n\tItem Name: Vuexy React admin Template\n\tVersion: 1.0\n\tAuthor: PIXINVENT\n\tAuthor URL: http://www.themeforest.net/user/pixinvent\n================================================================================================*/\n\n// Inline list style with pipeline seperator\n\nul.list-inline {\n  li {\n    display: inline-block;\n  }\n  &.list-inline-pipe {\n    > li + li:before {\n      content: \" | \";\n      padding-right: 2px;\n    }\n  }\n}\n\n// bootstrap list group\n.list-group {\n  .list-group-item {\n    line-height: 1.5;\n    &.active {\n      &:hover {\n        background-color: $primary;\n      }\n      &:focus {\n        color: $body-color;\n        outline: 0;\n        &:hover {\n          color: $white;\n        }\n      }\n    }\n\n    &:hover {\n      background-color: $body-bg;\n    }\n\n    &:not(.active):focus:active {\n      color: inherit;\n    }\n  }\n  .list-group-item-action {\n    &:active {\n      background-color: $primary;\n      color: $white;\n    }\n    &:focus {\n      background-color: $body-bg;\n      outline: 0;\n    }\n  }\n}\n\n// for drag and drop border radius on selected\n.list-group-item.gu-mirror {\n  border-radius: 0;\n}\n\n// Inline users list\n.users-list {\n  li + li {\n    margin-left: -0.785rem;\n  }\n  li {\n    img {\n      border: 2px solid $white;\n      box-shadow: 0px 2px 10px 0px rgba($gray-600, 0.3);\n    }\n    .badge {\n      color: $black;\n    }\n  }\n}\n","// Toasts\n\n// toast container customization\n.toast-bs-container {\n  z-index: 1040;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n\n  .toast-position {\n    position: relative;\n    top: 0;\n    right: 0;\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap-reverse;\n\n    .toast.show {\n      // display: block;\n      opacity: 1;\n      z-index: 1030;\n    }\n  }\n}\n\n// placement of toast on body\n.toast-placement {\n  position: static;\n  top: 0;\n  .toast {\n    position: fixed;\n    top: 0;\n    z-index: 1030;\n  }\n}\n\n// default toast customization\n.toast {\n  display: none;\n  margin-top: 0.75rem;\n\n  .toast-header {\n    .close {\n      &:focus,\n      &:active {\n        outline: none;\n      }\n    }\n  }\n}\n\n// toast on show\n\n.toast.show.toast-wrapper {\n  position: static;\n}\n\n// translucent toast opacity and display\n\n.toast.toast-translucent {\n  opacity: 1;\n  display: block;\n}\n\n// toast header img size\n\n.toast-header {\n  img {\n    width: 35px;\n    height: 24px;\n  }\n}\n\n_:-ms-lang(x),\n.toast-bs-container {\n  position: fixed !important;\n  left: 74% !important;\n}\n","// For Collaspe And Accordion\n\n// for vuexy collapse\n.vx-collapse {\n  .collapse-title {\n    font-weight: 400;\n    font-size: 1.2rem;\n  }\n  .opening,\n  .collapse-shown {\n    .collapse-icon {\n      transition: all 0.25s ease-in-out;\n      transform: rotate(180deg);\n    }\n  }\n  .collapse-icon {\n    transition: all 0.25s ease-in-out;\n    transform: rotate(0deg);\n  }\n  .card {\n    cursor: pointer;\n  }\n}\n\n// For collapse title\n.collapse-title {\n  color: inherit;\n  cursor: pointer;\n  &:hover {\n    color: inherit;\n  }\n}\n\n// To add a border below collapse/accordion heading\n.collapse-bordered {\n  .card:first-child {\n    border-top: 0;\n  }\n  .card:last-child {\n    border-bottom: 0;\n  }\n  .card {\n    margin-bottom: 0;\n    border-bottom: 1px solid rgba($pure-black, 0.04);\n    border-radius: 0;\n    .card-header {\n      padding: 1rem;\n    }\n    .card-body {\n      padding: 1rem;\n      line-height: 1.5;\n    }\n  }\n}\n\n.collapse-border-item {\n  &.card {\n    border: 1px solid rgba($pure-black, 0.1);\n    margin-bottom: 0;\n    border-radius: 0;\n    &:first-child {\n      border-top-left-radius: 5px;\n      border-top-right-radius: 5px;\n    }\n    &:not(:last-child) {\n      border-bottom: 0;\n    }\n    &:last-child {\n      border-bottom-right-radius: 5px;\n      border-bottom-left-radius: 5px;\n    }\n    .card-header {\n      padding: 1rem;\n    }\n    .card-body {\n      padding: 1rem;\n      line-height: 1.5;\n    }\n  }\n}\n\n// For Collapse with shadow\n.accordion-shadow {\n  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.1);\n  padding: 0.15rem 0.75rem;\n  border-radius: $border-radius;\n  .card {\n    &.open {\n      border-radius: 0.571rem;\n      margin: 10px 0;\n      border: 0;\n      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1) !important;\n    }\n  }\n  .card:first-child {\n    border-top-left-radius: 0.571rem;\n    border-top-right-radius: 0.571rem;\n  }\n  .card:last-child {\n    border-bottom-left-radius: 0.571rem;\n    border-bottom-right-radius: 0.571rem;\n  }\n}\n\n// For Collapse with border\n.collapse-border {\n  border: 1px solid rgba($pure-black, 0.1);\n  border-radius: 0.5rem;\n  & + .collapse.show {\n    border: 1px solid rgba($pure-black, 0.1);\n  }\n}\n\n// For Collapse with margin\n.collapse-margin {\n  margin-top: 0.71rem;\n  margin-bottom: 0.71rem !important;\n  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.05);\n  border-bottom: 0 solid transparent !important;\n  border-radius: 5px !important;\n  .card {\n    margin-bottom: 0;\n    border-radius: 5px !important;\n    .card-header {\n      padding: 1rem;\n      border-radius: 5px;\n    }\n    .card-body {\n      padding: 1rem;\n      line-height: 1.5rem;\n    }\n  }\n}\n","// pagination\n\n.pagination {\n  // default look for page item, firsy and last item\n\n  .page-item {\n    border-radius: 5rem;\n    &.prev-item,\n    &.next-item,\n    &.first,\n    &.last,\n    &.prev,\n    &.next {\n      .page-link {\n        color: $primary;\n      }\n\n      &.disabled {\n        .page-link {\n          color: $secondary;\n        }\n      }\n    }\n\n    // prev and last item styles\n\n    &.prev-item {\n      margin-right: 0.3571rem;\n      .page-link {\n        background-color: $pagination-bg-color;\n        padding: $pagination-action-padding-y $pagination-action-padding-x;\n        border-radius: 50%;\n\n        svg {\n          width: 1.2rem;\n          height: 1.2rem;\n        }\n\n        &:hover {\n          background: $primary;\n          color: $white;\n        }\n      }\n\n      & ~ .page-item:nth-child(2) {\n        &.active {\n          .page-link {\n            border-radius: 0.5rem !important;\n          }\n        }\n        .page-link {\n          border-top-left-radius: 20px;\n          border-bottom-left-radius: 20px;\n        }\n      }\n\n      & ~ .page-item:nth-last-child(-n + 2) {\n        &.active {\n          .page-link {\n            border-radius: 0.5rem !important;\n          }\n        }\n        .page-link {\n          border-top-right-radius: 20px;\n          border-bottom-right-radius: 20px;\n        }\n      }\n    }\n\n    &.next-item {\n      margin-left: 0.3571rem;\n\n      .page-link {\n        background-color: $pagination-bg-color;\n        padding: $pagination-action-padding-y $pagination-action-padding-x;\n        border-radius: 50%;\n\n        svg {\n          width: 1.2rem;\n          height: 1.2rem;\n        }\n\n        &:hover {\n          background: $primary;\n          color: $white;\n        }\n      }\n    }\n\n    // page link customization\n\n    .page-link {\n      border: none;\n      margin: 0;\n      color: rgba($pure-black, 0.6);\n      background-color: $pagination-bg-color;\n      margin-left: 0;\n      font-size: 1rem;\n      font-weight: 700;\n      line-height: 1.4rem;\n\n      svg {\n        height: 1.2rem;\n        width: 1.2rem;\n        position: relative;\n        top: -1px;\n      }\n\n      &:focus {\n        box-shadow: none;\n      }\n\n      &:hover {\n        color: $primary;\n      }\n    }\n\n    // for active page item\n    &.active {\n      background-color: $pagination-bg-color;\n      border-radius: 0;\n\n      .page-link {\n        z-index: 3;\n        border-radius: 0.5rem;\n        background-color: $primary;\n        color: $white;\n        transform: scale(1.05);\n      }\n    }\n\n    // if you dont want seprated look\n\n    &:first-child:not(.prev-item) {\n      &.active {\n        border-top-left-radius: 1.428rem;\n        border-bottom-left-radius: 1.428rem;\n        .page-link {\n          border-radius: 5rem;\n        }\n      }\n      .page-link {\n        border-top-left-radius: 1.428rem;\n        border-bottom-left-radius: 1.428rem;\n      }\n    }\n\n    &:last-child:not(.next-item) {\n      &.active {\n        border-top-right-radius: 1.428rem;\n        border-bottom-right-radius: 1.428rem;\n        .page-link {\n          border-radius: 5rem;\n        }\n      }\n      .page-link {\n        border-top-right-radius: 1.428rem;\n        border-bottom-right-radius: 1.428rem;\n      }\n    }\n  }\n\n  // For pagination lg\n\n  &.pagination-lg {\n    .page-item {\n      .page-link {\n        font-size: $pagination-font-size-lg;\n        transform: scale(1);\n      }\n    }\n  }\n}\n","// Spinners\n\n// Sizes\n\n.spinner-border-lg,\n.spinner-grow-lg {\n  height: 3rem;\n  width: 3rem;\n}\n","// Modals\n\n.modal {\n  // Modal Header\n  .modal-header {\n    background-color: $body-bg;\n    border-radius: 0.42rem;\n    padding: 0.8rem;\n    border-bottom: none;\n\n    // close button\n    .close {\n      padding: 0.2rem 0.62rem;\n      box-shadow: 0 5px 20px 0 rgba($pure-black, 0.1);\n      border-radius: 0.357rem;\n      background: $white;\n      opacity: 1;\n      transition: all 0.23s ease 0.1s;\n      position: relative;\n      transform: translate(8px, -2px);\n      span {\n        font-weight: 400;\n        font-size: 2rem;\n        color: $primary;\n      }\n      // For hover effect of close btn\n      &:hover,\n      &:focus,\n      &:active {\n        opacity: 1;\n        outline: none;\n        transform: translate(5px, 3px);\n        box-shadow: none;\n      }\n    }\n\n    &[class*=\"bg-\"] {\n      color: $white;\n      border-bottom-left-radius: 5px;\n      border-bottom-right-radius: 5px;\n\n      .modal-title {\n        color: $white;\n      }\n    }\n\n    // Themed Modals\n    &.bg-primary {\n      .close {\n        span {\n          color: $primary;\n        }\n      }\n    }\n\n    &.bg-success {\n      .close {\n        span {\n          color: $success;\n        }\n      }\n    }\n\n    &.bg-info {\n      .close {\n        span {\n          color: $info;\n        }\n      }\n    }\n\n    &.bg-danger {\n      .close {\n        span {\n          color: $danger;\n        }\n      }\n    }\n\n    &.bg-warning {\n      .close {\n        span {\n          color: $warning;\n        }\n      }\n    }\n\n    &.bg-dark {\n      .close {\n        span {\n          color: $dark;\n        }\n      }\n    }\n  }\n\n  // Modal Content\n  .modal-content {\n    border: none;\n    // overflow: unset; updated to \"visible\" as close icon is not visible in IE\n    overflow: visible;\n    box-shadow: 0 5px 20px 0 rgba($pure-black, 0.1);\n  }\n\n  &.modal-centered {\n    .modal-dialog {\n      display: flex;\n      align-items: center;\n    }\n  }\n\n  // Modal Footer\n  .modal-footer {\n    border-color: rgba($pure-black, 0.05);\n  }\n}\n\n// Modal SM\n.modal-sm {\n  max-width: 400px;\n}\n\n// Modal XS\n.modal-xs {\n  max-width: 300px;\n}\n\n// Modal XL\n.modal-xl {\n  max-width: 94%;\n  margin-left: 3%;\n  margin-right: 3%;\n}\n\n// To remove Max-width of XS Modal in Small Screen\n\n@media (max-width: 576px) {\n  .modal {\n    padding-right: 1rem;\n    padding-left: 1rem;\n    .modal-xs,\n    .modal-sm {\n      max-width: unset;\n    }\n  }\n}\n\n// For Demo Modal Focus After Close\n\n.demo-modal-form {\n  .btn-outline-success:focus {\n    box-shadow: 0 0 0 0.2rem rgba($success, 0.5) !important;\n  }\n}\n","// Popovers\n\n// popover header color and border-radius\n.popover {\n  z-index: 1060;\n  .popover-header {\n    color: $white;\n    border: none;\n    border-top-left-radius: 0.3rem;\n    border-top-right-radius: 0.3rem;\n  }\n  &.bs-popover-bottom {\n    .arrow:after {\n      border-bottom-color: $primary;\n    }\n  }\n}\n",".icon-bg-circle{\n    color: $white;\n    padding: 0.5rem;\n    border-radius: 50%;\n}\n.icon-left{\n    margin-right:0.5rem;\n}\n.icon-right{\n    margin-right:0.5rem;\n}\n.icon-spin {\n\tdisplay: inline-block;\n  \tanimation: spin 1s infinite linear;\n}\n\n.blockOverlay{\n  z-index: 1050 !important;\n}\n.blockElement, .blockPage{\n  z-index: 1051 !important;\n}\n\n@-moz-keyframes spin {\n  \tfrom {\n    \t-moz-transform: rotate(0deg);\n  \t}\n  \tto {\n    \t-moz-transform: rotate(360deg);\n  \t}\n}\n\n@-webkit-keyframes spin {\n  \tfrom {\n    \t-webkit-transform: rotate(0deg);\n  \t}\n  \tto {\n    \t-webkit-transform: rotate(360deg);\n  \t}\n}\n\n@keyframes spin {\n  \tfrom {\n    \ttransform: rotate(0deg);\n  \t}\n  \tto {\n    \ttransform: rotate(360deg);\n  \t}\n}\n\n.hidden{\n\tdisplay: none;\n\tvisibility: hidden;\n}\n\n//Disabled\na{\n\t&.disabled{\n\t\t// color: $dropdown-link-disabled-color !important;\n\t}\n\t&:hover {\n\t\tcursor: pointer;\n\t}\n}\n\n.round{@include border-radius(1.5rem);}\n.square{@include border-radius($btn-border-radius-square);}\n\n.icon-line-height{\n    line-height : 1.5rem !important; \n}\n\n//Tables\n//--------------------------\n.table-middle{\n    td{\n        vertical-align: middle;\n    }\n}\n\n// Spinner classes\n.spinner {\n    display: inline-block;\n    -webkit-animation: spin 1s linear infinite;\n    -o-animation: spin 1s linear infinite;\n    animation: spin 1s linear infinite;\n}\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}","// ================================================================================================\n//   File Name: pallette-gradient.scss\n//   Description: gradient color system styles\n//   ----------------------------------------------------------------------------------------------\n//   Item Name: Vuexy React admin Template\n//   Version: 1.0\n//   Author: PIXINVENT\n//   Author URL: http://www.themeforest.net/user/pixinvent\n// ================================================================================================\n\n@function color-function($color, $type) {\n  @if map-has-key($colors, $color) {\n    $curr_color: map-get($colors, $color);\n    @if map-has-key($curr_color, $type) {\n      @return map-get($curr_color, $type);\n    }\n  }\n  // @warn \"Unknown `#{name}` in $colors.\";\n  @return null;\n}\n\n// Color palettes\n@import \"palette-variables\";\n\n@import \"~bootstrap/scss/mixins/_gradients.scss\";\n\n@each $color_name, $color in $colors {\n  @each $color_type, $color_value in $color {\n    @if $color_type == \"base\" {\n      .bg-gradient-#{$color_name} {\n        background: map-get(($color), \"gradient-bg\");\n        color: #fff;\n        @if (color-function($color_name, \"base\") != null) {\n          @include gradient-directional(\n            map-get(($color), \"base\"),\n            rgba(map-get(($color), \"base\"), 0.5),\n            30deg\n          );\n        }\n        &:hover,\n        &:active {\n          color: #fff;\n        }\n      }\n\n      .gradient-light-#{$color-name} {\n        background: linear-gradient(\n          30deg,\n          $color-value 0%,\n          map-get(($color), \"gradient-light\") 100%\n        );\n        color: #fff;\n        &:hover,\n        &:active {\n          color: #fff;\n        }\n      }\n    }\n  }\n}\n","// ================================================================================================\n//   File Name: pallette.scss\n//   Description: Custom color system styles, includes background, border and text colors\n//   ----------------------------------------------------------------------------------------------\n//   Item Name: Vuexy React admin Template\n//   Version: 1.0\n//   Author: PIXINVENT\n//   Author URL: http://www.themeforest.net/user/pixinvent\n// ================================================================================================\n\n//  ================================================================================================\n//  WARNING: PLEASE DO NOT CHANGE THIS VARIABLE FILE.\n//  THIS FILE WILL GET OVERWRITTEN WITH EACH VUESAX HTML TEMPLATE RELEASE.\n//  TIP:\n//  We suggest you to use this (assets/scss/colors/palette.scss) file for overriding color variables.\n//  ================================================================================================\n\n// usage: theme-color(\"name_of_color\", \"type_of_color\")\n// to avoid to repeating map-get($colors, ...)\n\n@function color-function($color, $type) {\n  @if map-has-key($colors, $color) {\n    $curr_color: map-get($colors, $color);\n\n    @if map-has-key($curr_color, $type) {\n      @return map-get($curr_color, $type);\n    }\n  }\n\n  // @warn \"Unknown `#{name}` in $colors.\";\n  @return null;\n}\n\n// Color palettes\n@import \"palette-variables\";\n@import \"./palette-gradient\";\n\n// Color Classes\n//   Text color: .color .lighten-* / .darken-* / .accent-*\n//   Background: .bg-color .bg-lighten-* / .bg-darken-* / .bg-accent-*\n//   border: .border-color .border-lighten-* / .border-darken-* / .border-accent-*\n//   border-top: .border-top-color .border-top-lighten-* / .border-top-darken-* / .border-top-accent-*\n//   border-bottom: .border-bottom-color .border-bottom-lighten-* / .border-bottom-darken-* / .border-bottom-accent-*\n//   border-left: .border-left-color .border-left-lighten-* / .border-left-darken-* / .border-left-accent-*\n//   border-right: .border-right-color .border-right-lighten-* / .border-right-darken-* / .border-right-accent-*\n\n@each $color_name, $color in $colors {\n  @each $color_type, $color_value in $color {\n    @if $color_type== \"base\" {\n      .#{$color_name} {\n        color: $color_value !important;\n      }\n\n      // background color\n      .bg-#{$color_name} {\n        background-color: $color_value !important;\n\n        .card-header,\n        .card-footer {\n          background-color: transparent;\n        }\n      }\n\n      // Alert\n      .alert-#{$color_name} {\n        background: rgba($color_value, 0.2) !important;\n        color: $color_value !important;\n\n        .alert-heading {\n          @include alert-heading-bs($color_value);\n        }\n\n        .alert-link {\n          color: darken($color_value, 5%) !important;\n        }\n      }\n\n      // bg color lighten for rgba - opacity set\n      .bg-rgba-#{$color_name} {\n        background: rgba($color_value, 0.15) !important;\n      }\n\n      // Border colors\n      .border-#{$color_name} {\n        border: 1px solid $color_value !important;\n      }\n\n      .border-top-#{$color_name} {\n        border-top: 1px solid $color_value;\n      }\n\n      .border-bottom-#{$color_name} {\n        border-bottom: 1px solid $color_value;\n      }\n\n      .border-left-#{$color_name} {\n        border-left: 1px solid $color_value;\n      }\n\n      .border-right-#{$color_name} {\n        border-right: 1px solid $color_value;\n      }\n\n      // badge\n      .badge.badge-light-#{$color_name} {\n        background-color: color-function($color_name, \"light-badge\");\n        color: $color_value !important;\n        font-weight: 500;\n        text-transform: uppercase;\n      }\n\n      // bagde glow colors\n      .bg-#{$color_name},\n      .border-#{$color_name},\n      .badge-#{$color-name} {\n        &.badge-glow {\n          box-shadow: 0px 0px 10px $color_value;\n        }\n      }\n\n      // Overlay colors\n      .overlay-#{$color_name} {\n        @include bg-opacity($color_value, 0.6);\n      }\n\n      // Basic buttons\n      .btn-#{$color_name} {\n        border-color: color-function($color_name, \"darken-2\") !important;\n        background-color: $color_value !important;\n        color: #fff;\n\n        &:hover {\n          border-color: color-function($color_name, \"darken-1\") !important;\n          color: #fff !important;\n          box-shadow: 0 8px 25px -8px rgba($color-value, 1);\n        }\n\n        &:focus,\n        &:active {\n          color: #fff !important;\n        }\n      }\n\n      // For Btn Flat\n      .btn-flat-#{$color-name} {\n        background-color: transparent;\n        color: $color-value;\n\n        &:hover {\n          color: $color-value;\n          background-color: rgba($color-value, 0.1);\n        }\n\n        &:active,\n        &:focus {\n          background-color: $color-value;\n          color: #fff !important;\n        }\n      }\n\n      // For Btn Relief\n      .btn-relief-#{$color-name} {\n        background-color: $color-value;\n        box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.2);\n        color: #fff;\n\n        &:hover {\n          color: #fff;\n        }\n\n        &:active,\n        &:focus {\n          outline: none;\n          transform: translateY(3px);\n        }\n      }\n\n      // Outline buttons\n      .btn-outline-#{$color_name} {\n        border: 1px solid $color_value;\n        background-color: transparent;\n        color: $color_value;\n\n        &:hover {\n          background-color: rgba($color: $color_value, $alpha: 0.08);\n          color: $color_value;\n        }\n        &:active {\n          color: #fff !important;\n        }\n      }\n\n      // Dropdowns\n      .btn-#{$color_name},\n      .btn-outline-#{$color_name},\n      .btn-flat-#{$color-name} {\n        & ~ .dropdown-menu {\n          .dropdown-item {\n            &.active {\n              background-color: $color_value;\n              color: #fff;\n              &:hover {\n                color: #fff;\n              }\n            }\n\n            &:not(.active):not(:active) {\n              &:hover {\n                color: $color_value;\n              }\n            }\n          }\n        }\n      }\n\n      // Bullet colors for email app\n      .bullet {\n        &.bullet-#{$color_name} {\n          background-color: $color_value;\n          &.bullet-bordered {\n            background-color: transparent;\n            border: 2px solid $color_value;\n          }\n        }\n      }\n\n      // For pagination\n      .pagination-#{$color-name} {\n        li,\n        .page-item {\n          &.active {\n            a,\n            .page-link {\n              background: $color-value !important;\n              color: #fff;\n\n              &:hover {\n                color: #fff !important;\n              }\n            }\n          }\n\n          a,\n          .page-link {\n            &:hover {\n              color: $color_value !important;\n            }\n          }\n\n          &.prev-item,\n          &.next-item {\n            .page-link:hover {\n              background: $color_value;\n              color: #fff;\n            }\n          }\n        }\n      }\n\n      // For Nav Pills\n      .nav-pill-#{$color-name} {\n        .nav-item {\n          .nav-link {\n            &.active {\n              color: #fff;\n              background-color: $color_value;\n            }\n          }\n        }\n      }\n\n      // Chips\n\n      .chip-#{$color-name} {\n        background-color: $color_value !important;\n        .chip-body {\n          color: #fff !important;\n        }\n      }\n\n      // Divider\n\n      .divider.divider-#{$color-name} {\n        .divider-text {\n          &:before,\n          &:after {\n            border-color: $color-value !important;\n          }\n        }\n      }\n\n      // Form Input Elements\n      // Checkbox & Radio\n      input {\n        &[type=\"checkbox\"].bg-#{$color_name},\n        &[type=\"radio\"].bg-#{$color_name} {\n          + .custom-control-label {\n            &:before {\n              background-color: $color_value !important;\n            }\n          }\n        }\n      }\n\n      input:focus ~ .bg-#{$color_name} {\n        box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem $color_value !important;\n      }\n\n      // Vuesax Custom Checkbox\n      .vx-checkbox-#{$color_name} {\n        input {\n          &:checked ~ .vx-checkbox {\n            border-color: $color_value !important;\n            .vx-checkbox--check {\n              background-color: $color_value !important;\n            }\n          }\n          &:active:checked + .vx-checkbox .vx-checkbox--check {\n            background-color: $color_value !important;\n          }\n        }\n      }\n\n      // Vertical Layout Menu Themes \n      .vertical-layout {\n        .main-menu.theme-#{$color_name} {\n          .navbar-header {\n            .navbar-nav {\n              .brand-text {\n                color: $color_value;\n              }\n            }\n          }\n          .navigation {\n            .nav-item {\n              &.active {\n                a {\n                  background: linear-gradient(\n                    118deg,\n                    rgba($color_value, 1),\n                    rgba($color_value, 0.7)\n                  );\n                  box-shadow: 0 0 10px 1px rgba($color_value, 0.7) !important;\n                }\n              }\n              .menu-content {\n                li.active {\n                  background: linear-gradient(\n                    118deg,\n                    rgba($color_value, 1),\n                    rgba($color_value, 0.7)\n                  );\n                  box-shadow: 0 0 10px 1px rgba($color_value, 0.7) !important;\n                }\n              }\n            }\n          }\n        }\n      }\n\n      // Horizontal Layout\n      .horizontal-layout.theme-#{$color_name}{\n        .header-navbar{\n          .brand-text{\n            color: $color_value !important;\n          }\n        }\n        .navbar-horizontal{\n          #main-menu-navigation{\n            .nav-item.active{\n              .nav-link{\n                background: linear-gradient(\n                  118deg,\n                  rgba($color_value, 1),\n                  rgba($color_value, 0.7)\n                );\n                box-shadow: 0 0 10px 1px rgba($color_value, 0.7) !important;;\n              }\n            }\n          }\n        }\n      }\n\n      // Bootstrap Custom Switches\n\n      .custom-switch-#{$color-name} {\n        .custom-control-input:checked ~ .custom-control-label::before {\n          background-color: $color_value !important;\n          color: #fff;\n          transition: all 0.2s ease-out;\n        }\n      }\n\n      // Color radio\n      .color-radio.color-radio-#{$color-name} {\n        border: 1px solid transparent;\n        &.selected {\n          border-color: $color_value;\n        }\n        .radio-content {\n          background-color: $color_value;\n        }\n      }\n\n      // Vuesax Custom Checkbox\n      .vx-radio-#{$color_name} {\n        input {\n          &:checked ~ .vx-radio {\n            .vx-radio--circle {\n              background: rgba($color_value, 1) !important;\n              box-shadow: 0 3px 12px 0 rgba($color_value, 0.4) !important;\n            }\n          }\n        }\n      }\n    } @else {\n      .#{$color_name}.#{$color_type} {\n        color: $color_value !important;\n      }\n\n      .bg-#{$color_name}.bg-#{$color_type} {\n        background-color: $color_value !important;\n      }\n\n      .btn-#{$color_name}.btn-#{$color_type} {\n        border-color: color-function($color_name, \"darken-2\") !important;\n        background-color: $color_value !important;\n\n        &:hover {\n          border-color: color-function($color_name, \"darken-2\") !important;\n          background-color: color-function($color_name, \"darken-3\") !important;\n        }\n\n        &:focus,\n        &:active {\n          border-color: color-function($color_name, \"darken-3\") !important;\n          background-color: color-function($color_name, \"darken-4\") !important;\n        }\n      }\n\n      .btn-outline-#{$color_name}.btn-outline-#{$color_type} {\n        border-color: $color_value !important;\n        color: $color_value !important;\n\n        &:hover {\n          background-color: $color_value !important;\n        }\n      }\n\n      input:focus ~ .bg-#{$color_name} {\n        box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem $color_value !important;\n      }\n\n      .border-#{$color_name}.border-#{$color_type} {\n        border: 1px solid $color_value !important;\n      }\n\n      .border-top-#{$color_name}.border-top-#{$color_type} {\n        border-top: 1px solid $color_value !important;\n      }\n\n      .border-bottom-#{$color_name}.border-bottom-#{$color_type} {\n        border-bottom: 1px solid $color_value !important;\n      }\n\n      .border-left-#{$color_name}.border-left-#{$color_type} {\n        border-left: 1px solid $color_value !important;\n      }\n\n      .border-right-#{$color_name}.border-right-#{$color_type} {\n        border-right: 1px solid $color_value !important;\n      }\n\n      .overlay-#{$color_name}.overlay-#{$color_type} {\n        @include bg-opacity($color_value, 0.6);\n      }\n    }\n  }\n}\n","@mixin bg-opacity($color, $opacity: 1) {\n    background: $color; /* The Fallback */\n    background: rgba($color, $opacity);\n}","// Overrides user components-variables\n@import \"~bootstrap/scss/_functions.scss\";\n@import \"../variables/variables\";\n@import \"~bootstrap/scss/_variables.scss\";\n\n// Google Color Palette defined: http://www.google.com/design/spec/style/color.html\n\n$white: (\n  \"base\": #ffffff\n);\n$black: (\n  \"base\": #000000\n);\n$dark: (\n  \"base\": map-get($theme-colors, \"dark\"),\n  \"gradient-bg\": #640064\n);\n$light: (\n  \"base\": map-get($theme-colors, \"light\"),\n  \"gradient-bg\": #640064\n);\n\n$primary: (\n  \"gradient-light\": lighten(saturate(adjust-hue((map-get($theme-colors, \"primary\")), 25), 11.9), 13.33),\n  \"light-badge\": lighten(map-get($theme-colors, \"primary\"), 25%),\n  \"lighten-5\": lighten(map-get($theme-colors, \"primary\"), 25%),\n  \"lighten-4\": lighten(map-get($theme-colors, \"primary\"), 20%),\n  \"lighten-3\": lighten(map-get($theme-colors, \"primary\"), 15%),\n  \"lighten-2\": lighten(map-get($theme-colors, \"primary\"), 10%),\n  \"lighten-1\": lighten(map-get($theme-colors, \"primary\"), 5%),\n  \"base\": map-get($theme-colors, \"primary\"),\n  \"darken-1\": darken(map-get($theme-colors, \"primary\"), 5%),\n  \"darken-2\": darken(map-get($theme-colors, \"primary\"), 10%),\n  \"darken-3\": darken(map-get($theme-colors, \"primary\"), 15%),\n  \"darken-4\": darken(map-get($theme-colors, \"primary\"), 20%),\n  \"accent-1\": #bdfdff,\n  \"accent-2\": #8afbff,\n  \"accent-3\": #57faff,\n  \"accent-4\": #3df9ff,\n  \"gradient-bg\": #640064\n);\n$secondary: (\n  \"gradient-light\": lighten(saturate(adjust-hue((map-get($theme-colors, \"secondary\")), 25), 11.9), 13.33),\n  \"light-badge\": lighten(map-get($theme-colors, \"secondary\"), 35%),\n  \"lighten-5\": lighten(map-get($theme-colors, \"secondary\"), 25%),\n  \"lighten-4\": lighten(map-get($theme-colors, \"secondary\"), 20%),\n  \"lighten-3\": lighten(map-get($theme-colors, \"secondary\"), 15%),\n  \"lighten-2\": lighten(map-get($theme-colors, \"secondary\"), 10%),\n  \"lighten-1\": lighten(map-get($theme-colors, \"secondary\"), 5%),\n  \"base\": map-get($theme-colors, \"secondary\"),\n  \"darken-1\": darken(map-get($theme-colors, \"secondary\"), 5%),\n  \"darken-2\": darken(map-get($theme-colors, \"secondary\"), 10%),\n  \"darken-3\": darken(map-get($theme-colors, \"secondary\"), 15%),\n  \"darken-4\": darken(map-get($theme-colors, \"secondary\"), 20%),\n  \"gradient-bg\": #640064\n);\n$success: (\n  \"gradient-light\": lighten(saturate(adjust-hue((map-get($theme-colors, \"success\")), 25), 11.9), 13.33),\n  \"light-badge\": lighten(map-get($theme-colors, \"success\"), 40%),\n  \"lighten-5\": lighten(map-get($theme-colors, \"success\"), 25%),\n  \"lighten-4\": lighten(map-get($theme-colors, \"success\"), 20%),\n  \"lighten-3\": lighten(map-get($theme-colors, \"success\"), 15%),\n  \"lighten-2\": lighten(map-get($theme-colors, \"success\"), 10%),\n  \"lighten-1\": lighten(map-get($theme-colors, \"success\"), 5%),\n  \"base\": map-get($theme-colors, \"success\"),\n  \"darken-1\": darken(map-get($theme-colors, \"success\"), 5%),\n  \"darken-2\": darken(map-get($theme-colors, \"success\"), 10%),\n  \"darken-3\": darken(map-get($theme-colors, \"success\"), 15%),\n  \"darken-4\": darken(map-get($theme-colors, \"success\"), 20%),\n  \"accent-1\": #e1fff1,\n  \"accent-2\": #aeffd9,\n  \"accent-3\": #7bffc1,\n  \"accent-4\": #62ffb5,\n  \"gradient-bg\": #0064fa\n);\n$info: (\n  \"gradient-light\": lighten(saturate(adjust-hue((map-get($theme-colors, \"info\")), 25), 11.9), 13.33),\n  \"light-badge\": lighten(map-get($theme-colors, \"info\"), 40%),\n  \"lighten-5\": lighten(map-get($theme-colors, \"info\"), 25%),\n  \"lighten-4\": lighten(map-get($theme-colors, \"info\"), 20%),\n  \"lighten-3\": lighten(map-get($theme-colors, \"info\"), 15%),\n  \"lighten-2\": lighten(map-get($theme-colors, \"info\"), 10%),\n  \"lighten-1\": lighten(map-get($theme-colors, \"info\"), 5%),\n  \"base\": map-get($theme-colors, \"info\"),\n  \"darken-1\": darken(map-get($theme-colors, \"info\"), 5%),\n  \"darken-2\": darken(map-get($theme-colors, \"info\"), 10%),\n  \"darken-3\": darken(map-get($theme-colors, \"info\"), 15%),\n  \"darken-4\": darken(map-get($theme-colors, \"info\"), 20%),\n  \"accent-1\": #feffff,\n  \"accent-2\": #cbf5ff,\n  \"accent-3\": #98ecff,\n  \"accent-4\": #7fe7ff,\n  \"gradient-bg\": #640064\n);\n$warning: (\n  \"gradient-light\": lighten(saturate(adjust-hue((map-get($theme-colors, \"warning\")), 25), 11.9), 13.33),\n  \"light-badge\": lighten(map-get($theme-colors, \"warning\"), 25%),\n  \"lighten-5\": lighten(map-get($theme-colors, \"warning\"), 25%),\n  \"lighten-4\": lighten(map-get($theme-colors, \"warning\"), 20%),\n  \"lighten-3\": lighten(map-get($theme-colors, \"warning\"), 15%),\n  \"lighten-2\": lighten(map-get($theme-colors, \"warning\"), 10%),\n  \"lighten-1\": lighten(map-get($theme-colors, \"warning\"), 5%),\n  \"base\": map-get($theme-colors, \"warning\"),\n  \"darken-1\": darken(map-get($theme-colors, \"warning\"), 5%),\n  \"darken-2\": darken(map-get($theme-colors, \"warning\"), 10%),\n  \"darken-3\": darken(map-get($theme-colors, \"warning\"), 15%),\n  \"darken-4\": darken(map-get($theme-colors, \"warning\"), 20%),\n  \"accent-1\": #fff5ef,\n  \"accent-2\": #ffe5d8,\n  \"accent-3\": #fff6f3,\n  \"accent-4\": #ffe3da,\n  \"gradient-bg\": #fafafa\n);\n$danger: (\n  \"gradient-light\": lighten(saturate(adjust-hue((map-get($theme-colors, \"danger\")), 25), 11.9), 13.33),\n  \"light-badge\": lighten(map-get($theme-colors, \"danger\"), 30%),\n  \"lighten-5\": lighten(map-get($theme-colors, \"danger\"), 25%),\n  \"lighten-4\": lighten(map-get($theme-colors, \"danger\"), 20%),\n  \"lighten-3\": lighten(map-get($theme-colors, \"danger\"), 15%),\n  \"lighten-2\": lighten(map-get($theme-colors, \"danger\"), 10%),\n  \"lighten-1\": lighten(map-get($theme-colors, \"danger\"), 5%),\n  \"base\": map-get($theme-colors, \"danger\"),\n  \"darken-1\": darken(map-get($theme-colors, \"danger\"), 5%),\n  \"darken-2\": darken(map-get($theme-colors, \"danger\"), 10%),\n  \"darken-3\": darken(map-get($theme-colors, \"danger\"), 15%),\n  \"darken-4\": darken(map-get($theme-colors, \"danger\"), 20%),\n  \"accent-1\": #ffeef1,\n  \"accent-2\": #ffd6db,\n  \"accent-3\": #ffecee,\n  \"accent-4\": #ffd3d7,\n  \"gradient-bg\": #640064\n);\n\n$colors: (\n  \"white\": $white,\n  \"black\": $black,\n  \"dark\": $dark,\n  \"light\": $light,\n  \"primary\": $primary,\n  \"secondary\": $secondary,\n  \"success\": $success,\n  \"info\": $info,\n  \"warning\": $warning,\n  \"danger\": $danger\n);","@font-face {\n  font-family: \"feather\";\n  src: url(\"../fonts/feather.eot?t=1501834582692\"); /* IE9*/\n  src: url(\"../fonts/feather.eot?t=1501834582692#iefix\")\n      format(\"embedded-opentype\"),\n    /* IE6-IE8 */ url(\"../fonts/feather.woff?t=1501834582692\") format(\"woff\"),\n    /* chrome, firefox */ url(\"../fonts/feather.ttf?t=1501834582692\")\n      format(\"truetype\"),\n    /* chrome, firefox, opera, Safari, Android, iOS 4.2+*/\n      url(\"../fonts/feather.svg?t=1501834582692#feather\") format(\"svg\"); /* iOS 4.1- */\n}\n\n.feather {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: \"feather\" !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-alert-octagon:before {\n  content: \"\\e81b\";\n}\n\n.icon-alert-circle:before {\n  content: \"\\e81c\";\n}\n\n.icon-activity:before {\n  content: \"\\e81d\";\n}\n\n.icon-alert-triangle:before {\n  content: \"\\e81e\";\n}\n\n.icon-align-center:before {\n  content: \"\\e81f\";\n}\n\n.icon-airplay:before {\n  content: \"\\e820\";\n}\n\n.icon-align-justify:before {\n  content: \"\\e821\";\n}\n\n.icon-align-left:before {\n  content: \"\\e822\";\n}\n\n.icon-align-right:before {\n  content: \"\\e823\";\n}\n\n.icon-arrow-down-left:before {\n  content: \"\\e824\";\n}\n\n.icon-arrow-down-right:before {\n  content: \"\\e825\";\n}\n\n.icon-anchor:before {\n  content: \"\\e826\";\n}\n\n.icon-aperture:before {\n  content: \"\\e827\";\n}\n\n.icon-arrow-left:before {\n  content: \"\\e828\";\n}\n\n.icon-arrow-right:before {\n  content: \"\\e829\";\n}\n\n.icon-arrow-down:before {\n  content: \"\\e82a\";\n}\n\n.icon-arrow-up-left:before {\n  content: \"\\e82b\";\n}\n\n.icon-arrow-up-right:before {\n  content: \"\\e82c\";\n}\n\n.icon-arrow-up:before {\n  content: \"\\e82d\";\n}\n\n.icon-award:before {\n  content: \"\\e82e\";\n}\n\n.icon-bar-chart:before {\n  content: \"\\e82f\";\n}\n\n.icon-at-sign:before {\n  content: \"\\e830\";\n}\n\n.icon-bar-chart-2:before {\n  content: \"\\e831\";\n}\n\n.icon-battery-charging:before {\n  content: \"\\e832\";\n}\n\n.icon-bell-off:before {\n  content: \"\\e833\";\n}\n\n.icon-battery:before {\n  content: \"\\e834\";\n}\n\n.icon-bluetooth:before {\n  content: \"\\e835\";\n}\n\n.icon-bell:before {\n  content: \"\\e836\";\n}\n\n.icon-book:before {\n  content: \"\\e837\";\n}\n\n.icon-briefcase:before {\n  content: \"\\e838\";\n}\n\n.icon-camera-off:before {\n  content: \"\\e839\";\n}\n\n.icon-calendar:before {\n  content: \"\\e83a\";\n}\n\n.icon-bookmark:before {\n  content: \"\\e83b\";\n}\n\n.icon-box:before {\n  content: \"\\e83c\";\n}\n\n.icon-camera:before {\n  content: \"\\e83d\";\n}\n\n.icon-check-circle:before {\n  content: \"\\e83e\";\n}\n\n.icon-check:before {\n  content: \"\\e83f\";\n}\n\n.icon-check-square:before {\n  content: \"\\e840\";\n}\n\n.icon-cast:before {\n  content: \"\\e841\";\n}\n\n.icon-chevron-down:before {\n  content: \"\\e842\";\n}\n\n.icon-chevron-left:before {\n  content: \"\\e843\";\n}\n\n.icon-chevron-right:before {\n  content: \"\\e844\";\n}\n\n.icon-chevron-up:before {\n  content: \"\\e845\";\n}\n\n.icon-chevrons-down:before {\n  content: \"\\e846\";\n}\n\n.icon-chevrons-right:before {\n  content: \"\\e847\";\n}\n\n.icon-chevrons-up:before {\n  content: \"\\e848\";\n}\n\n.icon-chevrons-left:before {\n  content: \"\\e849\";\n}\n\n.icon-circle:before {\n  content: \"\\e84a\";\n}\n\n.icon-clipboard:before {\n  content: \"\\e84b\";\n}\n\n.icon-chrome:before {\n  content: \"\\e84c\";\n}\n\n.icon-clock:before {\n  content: \"\\e84d\";\n}\n\n.icon-cloud-lightning:before {\n  content: \"\\e84e\";\n}\n\n.icon-cloud-drizzle:before {\n  content: \"\\e84f\";\n}\n\n.icon-cloud-rain:before {\n  content: \"\\e850\";\n}\n\n.icon-cloud-off:before {\n  content: \"\\e851\";\n}\n\n.icon-codepen:before {\n  content: \"\\e852\";\n}\n\n.icon-cloud-snow:before {\n  content: \"\\e853\";\n}\n\n.icon-compass:before {\n  content: \"\\e854\";\n}\n\n.icon-copy:before {\n  content: \"\\e855\";\n}\n\n.icon-corner-down-right:before {\n  content: \"\\e856\";\n}\n\n.icon-corner-down-left:before {\n  content: \"\\e857\";\n}\n\n.icon-corner-left-down:before {\n  content: \"\\e858\";\n}\n\n.icon-corner-left-up:before {\n  content: \"\\e859\";\n}\n\n.icon-corner-up-left:before {\n  content: \"\\e85a\";\n}\n\n.icon-corner-up-right:before {\n  content: \"\\e85b\";\n}\n\n.icon-corner-right-down:before {\n  content: \"\\e85c\";\n}\n\n.icon-corner-right-up:before {\n  content: \"\\e85d\";\n}\n\n.icon-cpu:before {\n  content: \"\\e85e\";\n}\n\n.icon-credit-card:before {\n  content: \"\\e85f\";\n}\n\n.icon-crosshair:before {\n  content: \"\\e860\";\n}\n\n.icon-disc:before {\n  content: \"\\e861\";\n}\n\n.icon-delete:before {\n  content: \"\\e862\";\n}\n\n.icon-download-cloud:before {\n  content: \"\\e863\";\n}\n\n.icon-download:before {\n  content: \"\\e864\";\n}\n\n.icon-droplet:before {\n  content: \"\\e865\";\n}\n\n.icon-edit-2:before {\n  content: \"\\e866\";\n}\n\n.icon-edit:before {\n  content: \"\\e867\";\n}\n\n.icon-edit-1:before {\n  content: \"\\e868\";\n}\n\n.icon-external-link:before {\n  content: \"\\e869\";\n}\n\n.icon-eye:before {\n  content: \"\\e86a\";\n}\n\n.icon-feather:before {\n  content: \"\\e86b\";\n}\n\n.icon-facebook:before {\n  content: \"\\e86c\";\n}\n\n.icon-file-minus:before {\n  content: \"\\e86d\";\n}\n\n.icon-eye-off:before {\n  content: \"\\e86e\";\n}\n\n.icon-fast-forward:before {\n  content: \"\\e86f\";\n}\n\n.icon-file-text:before {\n  content: \"\\e870\";\n}\n\n.icon-film:before {\n  content: \"\\e871\";\n}\n\n.icon-file:before {\n  content: \"\\e872\";\n}\n\n.icon-file-plus:before {\n  content: \"\\e873\";\n}\n\n.icon-folder:before {\n  content: \"\\e874\";\n}\n\n.icon-filter:before {\n  content: \"\\e875\";\n}\n\n.icon-flag:before {\n  content: \"\\e876\";\n}\n\n.icon-globe:before {\n  content: \"\\e877\";\n}\n\n.icon-grid:before {\n  content: \"\\e878\";\n}\n\n.icon-heart:before {\n  content: \"\\e879\";\n}\n\n.icon-home:before {\n  content: \"\\e87a\";\n}\n\n.icon-github:before {\n  content: \"\\e87b\";\n}\n\n.icon-image:before {\n  content: \"\\e87c\";\n}\n\n.icon-inbox:before {\n  content: \"\\e87d\";\n}\n\n.icon-layers:before {\n  content: \"\\e87e\";\n}\n\n.icon-info:before {\n  content: \"\\e87f\";\n}\n\n.icon-instagram:before {\n  content: \"\\e880\";\n}\n\n.icon-layout:before {\n  content: \"\\e881\";\n}\n\n.icon-link-2:before {\n  content: \"\\e882\";\n}\n\n.icon-life-buoy:before {\n  content: \"\\e883\";\n}\n\n.icon-link:before {\n  content: \"\\e884\";\n}\n\n.icon-log-in:before {\n  content: \"\\e885\";\n}\n\n.icon-list:before {\n  content: \"\\e886\";\n}\n\n.icon-lock:before {\n  content: \"\\e887\";\n}\n\n.icon-log-out:before {\n  content: \"\\e888\";\n}\n\n.icon-loader:before {\n  content: \"\\e889\";\n}\n\n.icon-mail:before {\n  content: \"\\e88a\";\n}\n\n.icon-maximize-2:before {\n  content: \"\\e88b\";\n}\n\n.icon-map:before {\n  content: \"\\e88c\";\n}\n\n.icon-map-pin:before {\n  content: \"\\e88e\";\n}\n\n.icon-menu:before {\n  content: \"\\e88f\";\n}\n\n.icon-message-circle:before {\n  content: \"\\e890\";\n}\n\n.icon-message-square:before {\n  content: \"\\e891\";\n}\n\n.icon-minimize-2:before {\n  content: \"\\e892\";\n}\n\n.icon-mic-off:before {\n  content: \"\\e893\";\n}\n\n.icon-minus-circle:before {\n  content: \"\\e894\";\n}\n\n.icon-mic:before {\n  content: \"\\e895\";\n}\n\n.icon-minus-square:before {\n  content: \"\\e896\";\n}\n\n.icon-minus:before {\n  content: \"\\e897\";\n}\n\n.icon-moon:before {\n  content: \"\\e898\";\n}\n\n.icon-monitor:before {\n  content: \"\\e899\";\n}\n\n.icon-more-vertical:before {\n  content: \"\\e89a\";\n}\n\n.icon-more-horizontal:before {\n  content: \"\\e89b\";\n}\n\n.icon-move:before {\n  content: \"\\e89c\";\n}\n\n.icon-music:before {\n  content: \"\\e89d\";\n}\n\n.icon-navigation-2:before {\n  content: \"\\e89e\";\n}\n\n.icon-navigation:before {\n  content: \"\\e89f\";\n}\n\n.icon-octagon:before {\n  content: \"\\e8a0\";\n}\n\n.icon-package:before {\n  content: \"\\e8a1\";\n}\n\n.icon-pause-circle:before {\n  content: \"\\e8a2\";\n}\n\n.icon-pause:before {\n  content: \"\\e8a3\";\n}\n\n.icon-percent:before {\n  content: \"\\e8a4\";\n}\n\n.icon-phone-call:before {\n  content: \"\\e8a5\";\n}\n\n.icon-phone-forwarded:before {\n  content: \"\\e8a6\";\n}\n\n.icon-phone-missed:before {\n  content: \"\\e8a7\";\n}\n\n.icon-phone-off:before {\n  content: \"\\e8a8\";\n}\n\n.icon-phone-incoming:before {\n  content: \"\\e8a9\";\n}\n\n.icon-phone:before {\n  content: \"\\e8aa\";\n}\n\n.icon-phone-outgoing:before {\n  content: \"\\e8ab\";\n}\n\n.icon-pie-chart:before {\n  content: \"\\e8ac\";\n}\n\n.icon-play-circle:before {\n  content: \"\\e8ad\";\n}\n\n.icon-play:before {\n  content: \"\\e8ae\";\n}\n\n.icon-plus-square:before {\n  content: \"\\e8af\";\n}\n\n.icon-plus-circle:before {\n  content: \"\\e8b0\";\n}\n\n.icon-plus:before {\n  content: \"\\e8b1\";\n}\n\n.icon-pocket:before {\n  content: \"\\e8b2\";\n}\n\n.icon-printer:before {\n  content: \"\\e8b3\";\n}\n\n.icon-power:before {\n  content: \"\\e8b4\";\n}\n\n.icon-radio:before {\n  content: \"\\e8b5\";\n}\n\n.icon-repeat:before {\n  content: \"\\e8b6\";\n}\n\n.icon-refresh-ccw:before {\n  content: \"\\e8b7\";\n}\n\n.icon-rewind:before {\n  content: \"\\e8b8\";\n}\n\n.icon-rotate-ccw:before {\n  content: \"\\e8b9\";\n}\n\n.icon-refresh-cw:before {\n  content: \"\\e8ba\";\n}\n\n.icon-rotate-cw:before {\n  content: \"\\e8bb\";\n}\n\n.icon-save:before {\n  content: \"\\e8bc\";\n}\n\n.icon-search:before {\n  content: \"\\e8bd\";\n}\n\n.icon-server:before {\n  content: \"\\e8be\";\n}\n\n.icon-scissors:before {\n  content: \"\\e8bf\";\n}\n\n.icon-share-2:before {\n  content: \"\\e8c0\";\n}\n\n.icon-share:before {\n  content: \"\\e8c1\";\n}\n\n.icon-shield:before {\n  content: \"\\e8c2\";\n}\n\n.icon-settings:before {\n  content: \"\\e8c3\";\n}\n\n.icon-skip-back:before {\n  content: \"\\e8c4\";\n}\n\n.icon-shuffle:before {\n  content: \"\\e8c5\";\n}\n\n.icon-sidebar:before {\n  content: \"\\e8c6\";\n}\n\n.icon-skip-forward:before {\n  content: \"\\e8c7\";\n}\n\n.icon-slack:before {\n  content: \"\\e8c8\";\n}\n\n.icon-slash:before {\n  content: \"\\e8c9\";\n}\n\n.icon-smartphone:before {\n  content: \"\\e8ca\";\n}\n\n.icon-square:before {\n  content: \"\\e8cb\";\n}\n\n.icon-speaker:before {\n  content: \"\\e8cc\";\n}\n\n.icon-star:before {\n  content: \"\\e8cd\";\n}\n\n.icon-stop-circle:before {\n  content: \"\\e8ce\";\n}\n\n.icon-sun:before {\n  content: \"\\e8cf\";\n}\n\n.icon-sunrise:before {\n  content: \"\\e8d0\";\n}\n\n.icon-tablet:before {\n  content: \"\\e8d1\";\n}\n\n.icon-tag:before {\n  content: \"\\e8d2\";\n}\n\n.icon-sunset:before {\n  content: \"\\e8d3\";\n}\n\n.icon-target:before {\n  content: \"\\e8d4\";\n}\n\n.icon-thermometer:before {\n  content: \"\\e8d5\";\n}\n\n.icon-thumbs-up:before {\n  content: \"\\e8d6\";\n}\n\n.icon-thumbs-down:before {\n  content: \"\\e8d7\";\n}\n\n.icon-toggle-left:before {\n  content: \"\\e8d8\";\n}\n\n.icon-toggle-right:before {\n  content: \"\\e8d9\";\n}\n\n.icon-trash-2:before {\n  content: \"\\e8da\";\n}\n\n.icon-trash:before {\n  content: \"\\e8db\";\n}\n\n.icon-trending-up:before {\n  content: \"\\e8dc\";\n}\n\n.icon-trending-down:before {\n  content: \"\\e8dd\";\n}\n\n.icon-triangle:before {\n  content: \"\\e8de\";\n}\n\n.icon-type:before {\n  content: \"\\e8df\";\n}\n\n.icon-twitter:before {\n  content: \"\\e8e0\";\n}\n\n.icon-upload:before {\n  content: \"\\e8e1\";\n}\n\n.icon-umbrella:before {\n  content: \"\\e8e2\";\n}\n\n.icon-upload-cloud:before {\n  content: \"\\e8e3\";\n}\n\n.icon-unlock:before {\n  content: \"\\e8e4\";\n}\n\n.icon-user-check:before {\n  content: \"\\e8e5\";\n}\n\n.icon-user-minus:before {\n  content: \"\\e8e6\";\n}\n\n.icon-user-plus:before {\n  content: \"\\e8e7\";\n}\n\n.icon-user-x:before {\n  content: \"\\e8e8\";\n}\n\n.icon-user:before {\n  content: \"\\e8e9\";\n}\n\n.icon-users:before {\n  content: \"\\e8ea\";\n}\n\n.icon-video-off:before {\n  content: \"\\e8eb\";\n}\n\n.icon-video:before {\n  content: \"\\e8ec\";\n}\n\n.icon-voicemail:before {\n  content: \"\\e8ed\";\n}\n\n.icon-volume-x:before {\n  content: \"\\e8ee\";\n}\n\n.icon-volume-2:before {\n  content: \"\\e8ef\";\n}\n\n.icon-volume-1:before {\n  content: \"\\e8f0\";\n}\n\n.icon-volume:before {\n  content: \"\\e8f1\";\n}\n\n.icon-watch:before {\n  content: \"\\e8f2\";\n}\n\n.icon-wifi:before {\n  content: \"\\e8f3\";\n}\n\n.icon-x-square:before {\n  content: \"\\e8f4\";\n}\n\n.icon-wind:before {\n  content: \"\\e8f5\";\n}\n\n.icon-x:before {\n  content: \"\\e8f6\";\n}\n\n.icon-x-circle:before {\n  content: \"\\e8f7\";\n}\n\n.icon-zap:before {\n  content: \"\\e8f8\";\n}\n\n.icon-zoom-in:before {\n  content: \"\\e8f9\";\n}\n\n.icon-zoom-out:before {\n  content: \"\\e8fa\";\n}\n\n.icon-command:before {\n  content: \"\\e8fb\";\n}\n\n.icon-cloud:before {\n  content: \"\\e8fc\";\n}\n\n.icon-hash:before {\n  content: \"\\e8fd\";\n}\n\n.icon-headphones:before {\n  content: \"\\e8fe\";\n}\n\n.icon-underline:before {\n  content: \"\\e8ff\";\n}\n\n.icon-italic:before {\n  content: \"\\e900\";\n}\n\n.icon-bold:before {\n  content: \"\\e901\";\n}\n\n.icon-crop:before {\n  content: \"\\e902\";\n}\n\n.icon-help-circle:before {\n  content: \"\\e903\";\n}\n\n.icon-paperclip:before {\n  content: \"\\e904\";\n}\n\n.icon-shopping-cart:before {\n  content: \"\\e905\";\n}\n\n.icon-tv:before {\n  content: \"\\e906\";\n}\n\n.icon-wifi-off:before {\n  content: \"\\e907\";\n}\n\n.icon-minimize:before {\n  content: \"\\e88d\";\n}\n\n.icon-maximize:before {\n  content: \"\\e908\";\n}\n\n.icon-gitlab:before {\n  content: \"\\e909\";\n}\n\n.icon-sliders:before {\n  content: \"\\e90a\";\n}\n\n.icon-star-on:before {\n  content: \"\\e90b\";\n}\n\n.icon-heart-on:before {\n  content: \"\\e90c\";\n}\n\n.icon-archive:before {\n  content: \"\\e90d\";\n}\n\n.icon-arrow-down-circle:before {\n  content: \"\\e90e\";\n}\n\n.icon-arrow-up-circle:before {\n  content: \"\\e90f\";\n}\n\n.icon-arrow-left-circle:before {\n  content: \"\\e910\";\n}\n\n.icon-arrow-right-circle:before {\n  content: \"\\e911\";\n}\n\n.icon-bar-chart-line-:before {\n  content: \"\\e912\";\n}\n\n.icon-bar-chart-line:before {\n  content: \"\\e913\";\n}\n\n.icon-book-open:before {\n  content: \"\\e914\";\n}\n\n.icon-code:before {\n  content: \"\\e915\";\n}\n\n.icon-database:before {\n  content: \"\\e916\";\n}\n\n.icon-dollar-sign:before {\n  content: \"\\e917\";\n}\n\n.icon-folder-plus:before {\n  content: \"\\e918\";\n}\n\n.icon-gift:before {\n  content: \"\\e919\";\n}\n\n.icon-folder-minus:before {\n  content: \"\\e91a\";\n}\n\n.icon-git-commit:before {\n  content: \"\\e91b\";\n}\n\n.icon-git-branch:before {\n  content: \"\\e91c\";\n}\n\n.icon-git-pull-request:before {\n  content: \"\\e91d\";\n}\n\n.icon-git-merge:before {\n  content: \"\\e91e\";\n}\n\n.icon-linkedin:before {\n  content: \"\\e91f\";\n}\n\n.icon-hard-drive:before {\n  content: \"\\e920\";\n}\n\n.icon-more-vertical-:before {\n  content: \"\\e921\";\n}\n\n.icon-more-horizontal-:before {\n  content: \"\\e922\";\n}\n\n.icon-rss:before {\n  content: \"\\e923\";\n}\n\n.icon-send:before {\n  content: \"\\e924\";\n}\n\n.icon-shield-off:before {\n  content: \"\\e925\";\n}\n\n.icon-shopping-bag:before {\n  content: \"\\e926\";\n}\n\n.icon-terminal:before {\n  content: \"\\e927\";\n}\n\n.icon-truck:before {\n  content: \"\\e928\";\n}\n\n.icon-zap-off:before {\n  content: \"\\e929\";\n}\n\n.icon-youtube:before {\n  content: \"\\e92a\";\n}\n","// ================================================================================================\n//  File Name: custom-rtl.scss\n//  Description: RTL support SCSS file.\n//  ----------------------------------------------------------------------------------------------\n//  Item Name: Vuexy  - Vuejs, HTML & Laravel admin Dashboard Template\n//  Author: PIXINVENT\n//  Author URL: http://www.themeforest.net/user/pixinvent\n// ================================================================================================\n\n// Variables\n// ------------------------------\n\n// Core variables and mixins\n@import \"~bootstrap/scss/_functions\";\n@import \"~bootstrap/scss/_mixins\";\n@import \"bootstrap-extended/mixins\";\n\n// Core variables and mixins overrides\n@import \"core/variables/variables\";\n@import \"~bootstrap/scss/_variables\";\n\n// Overrides user variable\n@import \"core/variables/components-variables\";\n\nhtml[dir=\"rtl\"] {\n  // dashboard sales card\n  .sales-card {\n    .img-left {\n      left: 0;\n      right: auto;\n    }\n    .img-right {\n      right: 0;\n    }\n  }\n\n  // breadcrumb\n  .breadcrum-right {\n    .dropdown-toggle {\n      svg {\n        right: 0;\n      }\n    }\n  }\n\n  //breadcrumb-header\n  .breadcrumb-wrapper {\n    .breadcrumb {\n      .breadcrumb-item {\n        &:before {\n          transform: rotate(180deg);\n        }\n      }\n    }\n  }\n\n  // Dropdown\n  .dropup-form {\n    .dropdown-menu {\n      min-width: 16rem;\n    }\n  }\n\n  // main menu icon\n  .main-menu {\n    ul.navigation-main {\n      .nav-item {\n        &:not(.open) {\n          svg.menu-toggle-icon {\n            transform: rotate(180deg);\n          }\n        }\n        &.open {\n          svg.menu-toggle-icon {\n            transform: rotate(90deg) !important;\n          }\n        }\n      }\n    }\n  }\n\n  // ag-grid\n  .ag-rtl {\n    direction: rtl;\n    .ag-header-select-all {\n      margin-right: 0 !important;\n      margin-left: 24px !important;\n    }\n    .ag-cell-value {\n      margin-left: 0 !important;\n      margin-right: 24px !important;\n    }\n  }\n\n  // Code\n  .component-code {\n    pre {\n      text-align: left;\n    }\n  }\n\n  // Recharts\n  .recharts-layer {\n    direction: ltr;\n  }\n\n  // context menu\n  .react-contexify {\n    z-index: 1031;\n  }\n\n  // Email\n  .email-application {\n    .content-right {\n      .app-fixed-search {\n        .sidebar-toggle {\n          margin-left: 0;\n        }\n      }\n      .email-detail-header,.app-action{\n        .dropdown{\n          .dropdown-menu{\n            transform: translate3d(0px, 22px, 0px) !important;\n          }\n        }\n      }\n    }\n  }\n\n  // carousel\n  .carousel {\n    .carousel-control-prev,\n    .carousel-control-next {\n      .carousel-control-prev-icon,\n      .carousel-control-next-icon {\n        transform: rotate(180deg);\n      }\n    }\n  }\n\n  // pagination\n  .pagination,\n  .vx-pagination {\n    .prev-item,\n    .previous,\n    .next-item,\n    .next {\n      a svg {\n        transform: rotate(180deg);\n      }\n    }\n    li:first-child,\n    li:last-child {\n      a span {\n        svg {\n          transform: rotate(180deg);\n        }\n      }\n    }\n  }\n\n  // swiper\n  .swiper-container {\n    .swiper-button-next,\n    .swiper-button-prev {\n      &:after {\n        transform: rotate(180deg);\n      }\n    }\n  }\n  .swiper-container-cube {\n    &.swiper-container-rtl {\n      .swiper-slide {\n        transform-origin: 100% 0 !important;\n      }\n    }\n  }\n\n  //slider\n  .rc-slider-tooltip {\n    right: 50%;\n    width: 30px;\n  }\n  .rc-slider-vertical {\n    .rc-slider-dot {\n      right: -1px;\n    }\n  }\n  // Horizontal\n  .horizontal-layout {\n    .horizontal-menu-wrapper {\n      #main-menu-navigation {\n        .nav-item {\n          .has-sub {\n            svg.has-sub-arrow {\n              transform: rotate(180deg);\n            }\n          }\n        }\n        .dropdown-menu {\n          right: 0 !important;\n          left: auto !important;\n          top: 100% !important;\n          .dropdown-menu {\n            left: auto !important;\n            right: 100% !important;\n            top: 0 !important;\n           \n          }\n        }\n      }\n    }\n  }\n\n  //  menu items alignment\n  .main-menu {\n    .navigation > li ul li > a {\n      display: flex;\n      align-items: center;\n    }\n  }\n\n  // Dropdown RTL Changes\n  .header-navbar .navbar-container ul.nav li.dropdown {\n    .dropdown-menu {\n      margin-top: 0;\n      &::before {\n        top: 1px;\n      }\n    }\n  }\n\n  .header-navbar {\n    .dropdown,\n    .dropup {\n      .dropdown-menu.dropdown-menu-right::before {\n        right: auto;\n        left: 0.5rem;\n      }\n    }\n  }\n\n  .dropdown,\n  .dropup {\n    .dropdown-menu {\n      right: auto !important;\n      top: 0 !important;\n      left: auto !important;\n\n      &.dropdown-menu-right {\n        left: auto !important;\n        right: 0 !important;\n\n        &::before {\n          right: 0.6rem;\n          left: auto;\n        }\n      }\n    }\n  }\n\n  // Input Group dropdown\n  .input-group {\n    .dropdown-menu.show {\n      top: 0 !important;\n      right: auto !important;\n      left: 0px !important;\n    }\n  }\n\n  // Context menu list css\n  .context-menu-list {\n    z-index: 1031 !important;\n  }\n\n  code[class*=\"language-\"],\n  pre[class*=\"language-\"] {\n    direction: ltr;\n  }\n\n  @media print {\n    code[class*=\"language-\"],\n    pre[class*=\"language-\"] {\n      text-shadow: none;\n    }\n  }\n\n  // Calendar\n  .app-calendar {\n    .calendar-navigation {\n      .btn {\n        svg {\n          transform: rotate(180deg);\n        }\n      }\n    }\n  }\n\n  // Tooltip\n  .bs-tooltip-left .arrow::before,\n  .bs-tooltip-auto[x-placement^=\"left\"] .arrow::before {\n    border-width: 0.4rem 0 0.4rem 0.4rem;\n    border-left-color: $tooltip-bg;\n  }\n\n  .bs-tooltip-left .arrow,\n  .bs-tooltip-auto[x-placement^=\"left\"] .arrow {\n    right: 0;\n    left: auto;\n  }\n\n  .bs-tooltip-right .arrow::before,\n  .bs-tooltip-auto[x-placement^=\"right\"] .arrow::before {\n    border-width: 0.4rem 0.4rem 0.4rem 0;\n    border-right-color: $tooltip-bg;\n  }\n\n  .bs-tooltip-right .arrow,\n  .bs-tooltip-auto[x-placement^=\"right\"] .arrow {\n    left: 0;\n    right: auto;\n  }\n\n  // Popover Style\n  .popover {\n    right: auto !important;\n  }\n\n  // Perfect scrollbar RTL fix\n  body .ps__rail-y {\n    right: auto !important;\n    left: 1px !important;\n  }\n}\n\n@media (max-width: 1200px) {\n  html[dir=\"rtl\"] {\n    .vertical-layout {\n      &.menu-collapsed {\n        .app-content {\n          margin-right: 0;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 575.98px) {\n  html[dir=\"rtl\"] {\n    .vertical-layout {\n      .navbar-container {\n        .header-navbar {\n          ul.nav {\n            .nav-item {\n              &.dropdown {\n                .dropdown-menu {\n                  left: 12px !important;\n                  &.dropdown-menu-media {\n                    left: 15px !important;\n                    right: -15px !important;\n                  }\n                }\n\n                &.dropdown-notification {\n                  .dropdown-menu {\n                    transform: translate3d(-12px, 62px, 0px) !important;\n                    &.dropdown-cart {\n                      transform: translate3d(-12px, 59px, 0px) !important;\n                    }\n                  }\n                }\n                &.dropdown-user {\n                  .dropdown-menu {\n                    transform: translate3d(20px, 60px, 0px) !important;\n                  }\n                }\n                &.dropdown-language {\n                  .dropdown-menu {\n                    right: 28px !important;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (min-width: 769px) {\n html[dir=\"rtl\"]{\n   .header-navbar {\n     .dropdown {\n       &.dropdown-notification {\n         .dropdown-menu {\n           transform: translate3d(324px, 62px, 0px) !important;\n           &.dropdowncart {\n             transform: translate3d(335px, 62px, 0px) !important;\n           }\n         }\n       }\n       &.dropdown-user {\n         .dropdown-menu {\n           transform: translate3d(20px, 60px, 0px) !important;\n         }\n       }\n       &.dropdown-language {\n         .dropdown-menu {\n           transform: translate3d(114px, 64px, 0px) !important;\n         }\n       }\n     }\n   }\n }\n}\n\n@media (max-width: 768px) {\n  html[dir=\"rtl\"]{\n    .app-content {\n      .header-navbar {\n        .dropdown {\n          &.dropdown-notification {\n            .dropdown-menu {\n              transform: translate3d(26px, 59px, 0px) !important;\n              &.dropdown-cart {\n                transform: translate3d(26px, 59px, 0px) !important;\n              }\n            }\n          }\n          &.dropdown-user {\n            .dropdown-menu {\n              left: 0 !important;\n              right: 28px !important;\n            }\n          }\n          &.dropdown-language {\n            .dropdown-menu {\n              transform: translate3d(26px, 64px, 0px) !important;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","@import \"./bootstrap.scss\";\n@import \"./components.scss\";\n@import \"./bootstrap-extended.scss\";\n@import \"./colors.scss\";\n@import \"./iconfont.scss\";\n@import \"./custom-rtl.scss\";\n* {\n    font-family: 'Montserrat', sans-serif;\n}\n\n\n.uploadFormGroup {\n    display:flex;\n    flex-direction:column;\n}\n\n.uploadFormGroup .uploadButton {\n    align-self: center;\n    align-items: center;\n}\n\n\n.image-crop-modal {\n    min-width: 80%;\n    min-height: 70%;\n}\n\n.image-crop-modal-body {\n    text-align: center;\n}\n\n\n.ag-root.ag-layout-normal {\n    /* height: 100%; */\n    height: fit-content;\n}\n\n.ag-grid-table {\n    height: 750px !important;    \n}\n\n\n.ag-paging-description span{\n    display: initial !important;\n}\n\n\n.ag-paging-page-summary-panel .ag-paging-number{\n    display: none;\n}\n\n.breadcrumb-item {\n    color: #7367f0;\n    text-decoration: none;\n    cursor: pointer;\n}\n\n.delete-modal {\n    min-width: fit-content;\n}\n.textarea-auto{\n    textarea{\n        min-height: 200px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
